import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  /** A DateTime representation in ISO format */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AccountType = {
  __typename?: 'AccountType';
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  is_deleted?: Maybe<Scalars['DateTime']['output']>;
  is_editable?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AccuralCycle = {
  __typename?: 'AccuralCycle';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type AccuralDetailLogs = {
  __typename?: 'AccuralDetailLogs';
  leave?: Maybe<LeaveType>;
  logs?: Maybe<AccuralLogs>;
  time_off?: Maybe<TimeOffType>;
};

export type AccuralHistory = {
  __typename?: 'AccuralHistory';
  accural_status?: Maybe<Scalars['String']['output']>;
  from_date?: Maybe<Scalars['Date']['output']>;
  leave_packeg_id?: Maybe<Scalars['ID']['output']>;
  packeg_name?: Maybe<Scalars['String']['output']>;
  to_date?: Maybe<Scalars['Date']['output']>;
  users?: Maybe<Array<Maybe<UserAccural>>>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type AccuralHistoryHeader = {
  __typename?: 'AccuralHistoryHeader';
  employee_name?: Maybe<Scalars['String']['output']>;
  leavetypes?: Maybe<Array<Maybe<LeaveType>>>;
};

export type AccuralHistoryLogs = {
  __typename?: 'AccuralHistoryLogs';
  accural_status?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<UserDetailAccural>>>;
  from_date?: Maybe<Scalars['Date']['output']>;
  header?: Maybe<AccuralHistoryHeader>;
  leave_packeg_id?: Maybe<Scalars['ID']['output']>;
  packeg_name?: Maybe<Scalars['String']['output']>;
  to_date?: Maybe<Scalars['Date']['output']>;
  total_employees?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type AccuralLedgerEntry = {
  __typename?: 'AccuralLedgerEntry';
  amount?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  transaction_type?: Maybe<Scalars['String']['output']>;
};

export type AccuralLogs = {
  __typename?: 'AccuralLogs';
  action_date?: Maybe<Scalars['Date']['output']>;
  carry_forword?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  pay_off?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<LeaveType>;
};

export type AccuralResult = {
  __typename?: 'AccuralResult';
  accrual_id?: Maybe<Scalars['ID']['output']>;
  cycle?: Maybe<AccuralCycle>;
  is_current?: Maybe<Scalars['Boolean']['output']>;
  leave_breakdown?: Maybe<Array<Maybe<LeaveBreakdown>>>;
  package_name?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<AccuralSummary>;
  usage_ledger?: Maybe<Array<Maybe<UsageLedgerEntry>>>;
};

export type AccuralSummary = {
  __typename?: 'AccuralSummary';
  paid_leave_days?: Maybe<Scalars['Int']['output']>;
  total_earned_pto_hrs?: Maybe<Scalars['Float']['output']>;
  total_worked_hrs?: Maybe<Scalars['Float']['output']>;
};

export type AccuralTimeOff = {
  __typename?: 'AccuralTimeOff';
  _id?: Maybe<Scalars['ID']['output']>;
  carry_forword?: Maybe<Scalars['Int']['output']>;
  countIn?: Maybe<Scalars['String']['output']>;
  leaveAssighment?: Maybe<Scalars['String']['output']>;
  policy_type?: Maybe<Scalars['String']['output']>;
  time_off_category?: Maybe<Scalars['String']['output']>;
  time_off_days?: Maybe<Scalars['String']['output']>;
  time_off_total_days?: Maybe<Scalars['String']['output']>;
  time_off_type?: Maybe<LeaveType>;
  total_unpaid_count?: Maybe<Scalars['String']['output']>;
  unpaid_count?: Maybe<Scalars['String']['output']>;
};

export type ActionFeature = {
  __typename?: 'ActionFeature';
  _id: Scalars['ID']['output'];
  module?: Maybe<ModulesEnum>;
  name?: Maybe<Scalars['String']['output']>;
  sub_module?: Maybe<SubModulesEnum>;
};

export type ActionFeatureFilterInput = {
  module?: InputMaybe<ModulesEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_module?: InputMaybe<SubModulesEnum>;
};

export type ActionFeatureInput = {
  module: ModulesEnum;
  name: Scalars['String']['input'];
  sub_module: SubModulesEnum;
};

export type ActionFeatureUpdateInput = {
  module?: InputMaybe<ModulesEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  sub_module?: InputMaybe<SubModulesEnum>;
};

export type ActiveEmployeesForPublicHolidayInput = {
  departments?: InputMaybe<Array<Scalars['ID']['input']>>;
  roles?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AddCaseWitnessInput = {
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name: Scalars['String']['input'];
  job_title?: InputMaybe<Scalars['String']['input']>;
};

export type AddConversationInput = {
  feedback_id: Scalars['ID']['input'];
  is_internal_note?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
};

export type AddInterviewLogInput = {
  User?: InputMaybe<Scalars['ID']['input']>;
  follow_up_required?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<InterviewFormatEnum>;
  interview_date: Scalars['DateTime']['input'];
  interview_type: InterviewTypeEnum;
  participant_name: Scalars['String']['input'];
  participant_role?: InputMaybe<Scalars['String']['input']>;
  summary: Scalars['String']['input'];
};

export enum AdminMode {
  External = 'external',
  HrmsQuiz = 'hrms_quiz'
}

export enum AdminModeEnum {
  External = 'external',
  HrmsQuiz = 'hrms_quiz'
}

export type AirTicket = {
  __typename?: 'AirTicket';
  air_ticket_class?: Maybe<Scalars['String']['output']>;
  air_tickets_frequency?: Maybe<Scalars['String']['output']>;
  destination_city?: Maybe<Scalars['String']['output']>;
  destination_country?: Maybe<Country>;
  no_of_air_tickets?: Maybe<Scalars['Int']['output']>;
  orignal_city?: Maybe<Scalars['String']['output']>;
  orignal_country?: Maybe<Country>;
};

export type Alert = {
  __typename?: 'Alert';
  _id?: Maybe<Scalars['ID']['output']>;
  alertType?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<Asset>;
  availStatus?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  maintenance?: Maybe<Maintenance>;
};

export type AlertConfiguration = {
  __typename?: 'AlertConfiguration';
  afterDueDate?: Maybe<Scalars['Boolean']['output']>;
  before3Days?: Maybe<Scalars['Boolean']['output']>;
  before7Days?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  leadTime?: Maybe<Scalars['Int']['output']>;
  onTheDay?: Maybe<Scalars['Boolean']['output']>;
  sendEmail?: Maybe<Scalars['Boolean']['output']>;
};

export type AlertConfigurationInput = {
  afterDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  before3Days?: InputMaybe<Scalars['Boolean']['input']>;
  before7Days?: InputMaybe<Scalars['Boolean']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  onTheDay?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AllowBusinessStatus {
  Active = 'active',
  All = 'all',
  Archive = 'archive',
  Inactive = 'inactive',
  Inprogress = 'inprogress',
  Rejected = 'rejected'
}

export enum AllowBusinessType {
  Franchiser = 'franchiser',
  FranchiserOem = 'franchiser_OEM',
  IndependentBusiness = 'independent_business'
}

export enum AllowMethodPhoneVerify {
  Call = 'call',
  Email = 'email',
  Sms = 'sms'
}

export type AllowPermissions = {
  __typename?: 'AllowPermissions';
  loggedInUserPermissions?: Maybe<Array<Maybe<Permission>>>;
  role?: Maybe<Role>;
};

export type Allowance = {
  __typename?: 'Allowance';
  _id: Scalars['ID']['output'];
  allowance_type: AllowanceType;
  amount: Scalars['Float']['output'];
  business_location?: Maybe<BusinessLocation>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_fixed: Scalars['Boolean']['output'];
  is_sample_data?: Maybe<Scalars['Boolean']['output']>;
  is_taxable?: Maybe<Scalars['Boolean']['output']>;
  pay_slip_name: Scalars['String']['output'];
};

export type AllowanceData = {
  __typename?: 'AllowanceData';
  allowance?: Maybe<Allowance>;
  amount: Scalars['Float']['output'];
  is_percentage: Scalars['Boolean']['output'];
  taxable: Scalars['Boolean']['output'];
};

export type AllowanceList = {
  allowance: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  is_percentage: Scalars['Boolean']['input'];
};

export enum AllowanceType {
  Bonus = 'bonus',
  Expense = 'expense',
  HolidayOvertime = 'holiday_overtime',
  MobileAllowance = 'mobile_allowance',
  Other = 'other',
  OverTimeAllowance = 'over_time_allowance',
  SiteAccomodation = 'site_accomodation',
  TransportAllowance = 'transport_allowance',
  UnusedLeaveEncashment = 'unused_leave_encashment'
}

export enum AllowanceTypeFilter {
  Active = 'active',
  All = 'all',
  Archive = 'archive',
  Bonus = 'bonus',
  Expense = 'expense',
  HolidayOvertime = 'holiday_overtime',
  MobileAllowance = 'mobile_allowance',
  Other = 'other',
  OverTimeAllowance = 'over_time_allowance',
  SiteAccomodation = 'site_accomodation',
  TransportAllowance = 'transport_allowance',
  UnusedLeaveEncashment = 'unused_leave_encashment'
}

export type AllowancesType = {
  __typename?: 'AllowancesType';
  allowance?: Maybe<Allowance>;
  amount?: Maybe<Scalars['Float']['output']>;
  is_taxable?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export enum AllowedSubscriptionStatus {
  Active = 'active',
  All = 'all',
  Archive = 'archive',
  Canceled = 'canceled',
  Inprogress = 'inprogress',
  Rejected = 'rejected'
}

export enum AnimationTypeEnum {
  AutoScroll = 'auto_scroll',
  None = 'none'
}

export type AppPasswordInput = {
  appId: Scalars['ID']['input'];
  password?: InputMaybe<EncryptedPasswordInput>;
};

export type AppraisalObjecive = {
  __typename?: 'AppraisalObjecive';
  AppraisalType?: Maybe<AppraisalType>;
  _id?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  weight_percent?: Maybe<Scalars['Int']['output']>;
};

export type AppraisalType = {
  __typename?: 'AppraisalType';
  _id: Scalars['ID']['output'];
  clockHistoryCount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_punctuality?: Maybe<Scalars['Boolean']['output']>;
  is_task?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  objective_count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  target_type?: Maybe<TargetEnum>;
  totalHours?: Maybe<Scalars['Float']['output']>;
  total_hours_logged?: Maybe<Scalars['Float']['output']>;
};

export type ApprovalWorkFlow = {
  __typename?: 'ApprovalWorkFlow';
  _id?: Maybe<Scalars['ID']['output']>;
  action_performed?: Maybe<Scalars['Boolean']['output']>;
  business?: Maybe<Business>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  escalation_user?: Maybe<EscalationUserType>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_sample_data?: Maybe<Scalars['Boolean']['output']>;
  overdue_days?: Maybe<Scalars['Int']['output']>;
  total_level?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
  work_flow_levels?: Maybe<Array<Maybe<WorkFlowLevels>>>;
  work_flow_type?: Maybe<Scalars['String']['output']>;
};

export type ApprovalWorkFlowResult = {
  __typename?: 'ApprovalWorkFlowResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<ApprovalWorkFlow>>>;
};

export type Asset = {
  __typename?: 'Asset';
  AssetBrand?: Maybe<AssetBrand>;
  AssetModel?: Maybe<AssetModel>;
  Role?: Maybe<Array<Maybe<Role>>>;
  Station?: Maybe<Station>;
  Vendor?: Maybe<Vendor>;
  _id?: Maybe<Scalars['ID']['output']>;
  actualQuantity?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  assetId?: Maybe<Scalars['String']['output']>;
  assetImage?: Maybe<Scalars['String']['output']>;
  assigned?: Maybe<User>;
  assignedSite?: Maybe<BusinessLocation>;
  assignedType?: Maybe<Scalars['String']['output']>;
  availStatus?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<AssetCategory>;
  checkIn_checkOut_date?: Maybe<Scalars['Date']['output']>;
  contractsAndLicenses?: Maybe<Array<Maybe<ContractLicense>>>;
  cost?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<User>;
  currentCost?: Maybe<Scalars['Float']['output']>;
  department?: Maybe<Department>;
  depreciatedCost?: Maybe<Scalars['Float']['output']>;
  depreciation?: Maybe<Array<Maybe<Depreciation>>>;
  depreciationSalvageValue?: Maybe<Scalars['Int']['output']>;
  depreciationTenure?: Maybe<Scalars['Int']['output']>;
  depreciationType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<DisposeDetail>;
  disposeAsset?: Maybe<DisposeObj>;
  documents?: Maybe<Array<Maybe<Documents>>>;
  employee?: Maybe<User>;
  fields?: Maybe<Array<Maybe<FieldData>>>;
  id?: Maybe<Scalars['ID']['output']>;
  initialCost?: Maybe<Scalars['Float']['output']>;
  insuranceLinks?: Maybe<Array<Maybe<InsuranceLinks>>>;
  invoice?: Maybe<InvoicesList>;
  invoice_price?: Maybe<Scalars['String']['output']>;
  isAutoAssetId?: Maybe<Scalars['Boolean']['output']>;
  isDepreciation?: Maybe<Scalars['Boolean']['output']>;
  isLinkedRelation?: Maybe<Scalars['String']['output']>;
  isMoved?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  leaseBegin?: Maybe<Scalars['Date']['output']>;
  leaseEnd?: Maybe<Scalars['Date']['output']>;
  linkingAssets?: Maybe<Array<Maybe<LinkingAssets>>>;
  linkingTransactWhole?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  logs?: Maybe<Array<Maybe<LogsAsset>>>;
  maintenance?: Maybe<Maintenance>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notificationEmail?: Maybe<Scalars['String']['output']>;
  other_assignee?: Maybe<Scalars['String']['output']>;
  other_detail?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<Scalars['Int']['output']>;
  purchasedDate?: Maybe<Scalars['Date']['output']>;
  purchasedFrom?: Maybe<LeasingCustomer>;
  purchasedType?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  reserveAsset?: Maybe<ReserveAssets>;
  role_employes?: Maybe<Array<Maybe<User>>>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  site?: Maybe<BusinessLocation>;
  status?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<AssetSubCategory>;
  type?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
  uploadReceipt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  warranty?: Maybe<Scalars['String']['output']>;
  warrantyExpiry?: Maybe<Scalars['Date']['output']>;
};

export type AssetBrand = {
  __typename?: 'AssetBrand';
  Business?: Maybe<Business>;
  _id: Scalars['ID']['output'];
  brand_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_linked?: Maybe<Scalars['Boolean']['output']>;
  updated_by?: Maybe<User>;
};

export type AssetBrandWithModel = {
  __typename?: 'AssetBrandWithModel';
  AssetModel?: Maybe<Array<Maybe<AssetModel>>>;
  Business?: Maybe<Business>;
  _id: Scalars['ID']['output'];
  brand_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  updated_by?: Maybe<User>;
};

export type AssetByBusinessResult = {
  __typename?: 'AssetByBusinessResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<Asset>>>;
};

export type AssetByEmployeeResult = {
  __typename?: 'AssetByEmployeeResult';
  config?: Maybe<DataTableConfig>;
  is_department_asset?: Maybe<Scalars['Boolean']['output']>;
  results?: Maybe<Array<Maybe<Asset>>>;
};

export type AssetCategories = {
  __typename?: 'AssetCategories';
  created_at?: Maybe<Scalars['Date']['output']>;
  detail?: Maybe<SubCategoryType>;
  id: Scalars['ID']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  linkedSubCategories?: Maybe<Scalars['Int']['output']>;
  linked_subCategories?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  subCategoryCount?: Maybe<Scalars['Int']['output']>;
  unlinkedSubCategories?: Maybe<Scalars['Int']['output']>;
  unlinked_sub_categories?: Maybe<Scalars['Int']['output']>;
};

export type AssetCategory = {
  __typename?: 'AssetCategory';
  _id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_linked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type AssetCountAndAlerts = {
  __typename?: 'AssetCountAndAlerts';
  assetAlert?: Maybe<AssetAlert>;
  assetCount?: Maybe<AssetCount>;
};

export type AssetCountResult = {
  __typename?: 'AssetCountResult';
  assigned: Scalars['Int']['output'];
  disposed: Scalars['Int']['output'];
  maintenance: Scalars['Int']['output'];
  reserved: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unassigned: Scalars['Int']['output'];
};

export type AssetInput = {
  AssetBrand?: InputMaybe<Scalars['ID']['input']>;
  AssetModel?: InputMaybe<Scalars['ID']['input']>;
  Role?: InputMaybe<Array<Scalars['ID']['input']>>;
  Station?: InputMaybe<Scalars['ID']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  assetId?: InputMaybe<Scalars['String']['input']>;
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assetImage?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  assignedEmployee?: InputMaybe<Scalars['ID']['input']>;
  assignedType?: InputMaybe<Scalars['String']['input']>;
  availStatus?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  checkIn_checkOut_date?: InputMaybe<Scalars['Date']['input']>;
  contractsAndLicenses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  depreciation?: InputMaybe<Array<InputMaybe<DepreciationInput>>>;
  depreciationSalvageValue?: InputMaybe<Scalars['Int']['input']>;
  depreciationTenure?: InputMaybe<Scalars['Int']['input']>;
  depreciationType?: InputMaybe<DepreciationEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Field>>>;
  initialCost?: InputMaybe<Scalars['Float']['input']>;
  insuranceLinks?: InputMaybe<Array<InputMaybe<InsuranceLinking>>>;
  isAutoAssetId?: InputMaybe<Scalars['Boolean']['input']>;
  isDepreciation?: InputMaybe<Scalars['Boolean']['input']>;
  isSeriallized?: InputMaybe<Scalars['Boolean']['input']>;
  leaseBegin?: InputMaybe<Scalars['Date']['input']>;
  leaseEnd?: InputMaybe<Scalars['Date']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manualAssetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  other_detail?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Payment>;
  paymentDetails?: InputMaybe<Scalars['Int']['input']>;
  purchasedDate?: InputMaybe<Scalars['Date']['input']>;
  purchasedFrom?: InputMaybe<Scalars['ID']['input']>;
  purchasedType?: InputMaybe<PurchaseType>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  role_employes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  serialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  site?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subCategory?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TypeAsset>;
  uploadReceipt?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  warranty?: InputMaybe<Scalars['String']['input']>;
  warrantyExpiry?: InputMaybe<Scalars['Date']['input']>;
};

export type AssetModel = {
  __typename?: 'AssetModel';
  AssetBrand?: Maybe<AssetBrand>;
  Business?: Maybe<Business>;
  _id: Scalars['ID']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_linked?: Maybe<Scalars['Boolean']['output']>;
  model_name?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<User>;
};

export type AssetMovement = {
  __typename?: 'AssetMovement';
  data?: Maybe<Array<Maybe<Movement>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type AssetSubCategory = {
  __typename?: 'AssetSubCategory';
  AssetCategory?: Maybe<AssetCategory>;
  actualCost?: Maybe<Scalars['Float']['output']>;
  assetCount?: Maybe<Scalars['Int']['output']>;
  currentValue?: Maybe<Scalars['Float']['output']>;
  depreciationValue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_linked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subCategoryUrl?: Maybe<Scalars['String']['output']>;
};

export type AssetUpdateInput = {
  AssetBrand?: InputMaybe<Scalars['ID']['input']>;
  AssetModel?: InputMaybe<Scalars['ID']['input']>;
  Role?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Station?: InputMaybe<Scalars['ID']['input']>;
  actualQuantity?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  assetIds?: InputMaybe<Scalars['String']['input']>;
  assetImage?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  assetImageUrl?: InputMaybe<Scalars['String']['input']>;
  assignedEmployee?: InputMaybe<Scalars['ID']['input']>;
  assignedType?: InputMaybe<Scalars['String']['input']>;
  availStatus?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  checkIn_checkOut_date?: InputMaybe<Scalars['Date']['input']>;
  contractsAndLicenses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  depreciation?: InputMaybe<Array<InputMaybe<DepreciationInput>>>;
  depreciationSalvageValue?: InputMaybe<Scalars['Int']['input']>;
  depreciationTenure?: InputMaybe<Scalars['Int']['input']>;
  depreciationType?: InputMaybe<DepreciationEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Field>>>;
  initialCost?: InputMaybe<Scalars['Float']['input']>;
  insuranceLinks?: InputMaybe<Array<InputMaybe<InsuranceLinking>>>;
  isAutoAssetId?: InputMaybe<Scalars['Boolean']['input']>;
  isDepreciation?: InputMaybe<Scalars['Boolean']['input']>;
  leaseBegin?: InputMaybe<Scalars['Date']['input']>;
  leaseEnd?: InputMaybe<Scalars['Date']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manualAssetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  other_detail?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Payment>;
  paymentDetails?: InputMaybe<Scalars['Int']['input']>;
  purchasedDate?: InputMaybe<Scalars['Date']['input']>;
  purchasedFrom?: InputMaybe<Scalars['ID']['input']>;
  purchasedType?: InputMaybe<PurchaseType>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  role_employes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  serialNumbers?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subCategory?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TypeAsset>;
  uploadReceipt?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  warranty?: InputMaybe<Scalars['String']['input']>;
  warrantyExpiry?: InputMaybe<Scalars['Date']['input']>;
};

export type AssetUpdateInputS = {
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assetImage?: InputMaybe<Array<Scalars['Upload']['input']>>;
  brand?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  serialNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seriallized?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Scalars['ID']['input']>;
  subCategory?: InputMaybe<Scalars['ID']['input']>;
};

export type AssignCategorySectionTypeReport = {
  __typename?: 'AssignCategorySectionTypeReport';
  QuizCategory?: Maybe<QuizCategory>;
  section_questions: Array<AssignQuestionSectionTypeReport>;
};

export type AssignQuestionSectionType = {
  __typename?: 'AssignQuestionSectionType';
  QuizCategorySection?: Maybe<QuizCategorySection>;
  question_answer?: Maybe<Array<Maybe<Question_AnswerType>>>;
};

export type AssignQuestionSectionTypeReport = {
  __typename?: 'AssignQuestionSectionTypeReport';
  QuizCategorySection?: Maybe<QuizCategorySection>;
  question_answer?: Maybe<Array<Maybe<Question_AnswerTypeReport>>>;
};

export enum Assign_To {
  All = 'all',
  EmployeeTenure = 'employee_tenure'
}

export type AssignedLeave = {
  __typename?: 'AssignedLeave';
  days?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
};

export type AssignedQuestion = {
  __typename?: 'AssignedQuestion';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_required?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  points?: Maybe<Scalars['Float']['output']>;
  question_text?: Maybe<Scalars['String']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
};

export type AssignedQuiz = {
  __typename?: 'AssignedQuiz';
  Department?: Maybe<Array<Maybe<Department>>>;
  Quiz?: Maybe<Quiz>;
  Role?: Maybe<Array<Maybe<Role>>>;
  User?: Maybe<User>;
  category_sections?: Maybe<Array<Maybe<AssignCategorySectionType>>>;
  created_by?: Maybe<User>;
  duration?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['Date']['output']>;
  evaluate_by?: Maybe<Array<Maybe<User>>>;
  grade?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_graded?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  percentage?: Maybe<Scalars['Float']['output']>;
  question_count?: Maybe<Scalars['Int']['output']>;
  quiz_end_time?: Maybe<Scalars['Date']['output']>;
  quiz_start_time?: Maybe<Scalars['Date']['output']>;
  start_time?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  user_score?: Maybe<Scalars['Float']['output']>;
};

export type AssignedQuizReport = {
  __typename?: 'AssignedQuizReport';
  Quiz?: Maybe<Quiz>;
  User?: Maybe<User>;
  category_sections?: Maybe<Array<Maybe<AssignCategorySectionTypeReport>>>;
  correct_questions?: Maybe<Scalars['Int']['output']>;
  created_by?: Maybe<User>;
  duration?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['Date']['output']>;
  evaluate_by?: Maybe<Array<Maybe<User>>>;
  grade?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_graded?: Maybe<Scalars['Boolean']['output']>;
  is_passed?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  min_passing_score?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  start_time?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_questions?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  user_score?: Maybe<Scalars['Float']['output']>;
};

export type AssignedUserQuiz = {
  __typename?: 'AssignedUserQuiz';
  Department?: Maybe<Array<Maybe<Department>>>;
  Quiz?: Maybe<Quiz>;
  Role?: Maybe<Array<Maybe<Role>>>;
  User?: Maybe<User>;
  category_sections?: Maybe<Array<Maybe<AssignCategorySectionType>>>;
  created_by?: Maybe<User>;
  duration?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['Date']['output']>;
  evaluate_by?: Maybe<Array<Maybe<User>>>;
  grade?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invalidated_at?: Maybe<Scalars['DateTime']['output']>;
  invalidation_reason?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_graded?: Maybe<Scalars['Boolean']['output']>;
  is_invalidated?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  question_count?: Maybe<Scalars['Int']['output']>;
  quiz_end_time?: Maybe<Scalars['Date']['output']>;
  quiz_start_time?: Maybe<Scalars['Date']['output']>;
  start_time?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  user_score?: Maybe<Scalars['Float']['output']>;
};

export type AssigneeFilteredByStatus = {
  __typename?: 'AssigneeFilteredByStatus';
  end_time?: Maybe<Scalars['Date']['output']>;
  start_time?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<AssigneeUserData>;
};

export type AssigneeUserData = {
  __typename?: 'AssigneeUserData';
  completed_date?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  _id?: Maybe<Scalars['ID']['output']>;
  children?: Maybe<Array<Maybe<Attachment>>>;
  file?: Maybe<Scalars['String']['output']>;
  isFile?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Attachment>;
  subscription?: Maybe<Subscription>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AttemptInput = {
  question_answer?: InputMaybe<Array<InputMaybe<QuestionAttemptInput>>>;
  selectedLanguage: LanguageCode;
};

export type Attendance = {
  __typename?: 'Attendance';
  BusinessLocation?: Maybe<BusinessLocation>;
  User?: Maybe<User>;
  _id: Scalars['ID']['output'];
  attendanceStatus?: Maybe<Scalars['String']['output']>;
  attendance_adjusted_by?: Maybe<User>;
  attendance_date: Scalars['DateTime']['output'];
  attendance_log_detail?: Maybe<Array<Maybe<AttendanceLogDetail>>>;
  clock_in_time?: Maybe<Scalars['DateTime']['output']>;
  clock_out_time?: Maybe<Scalars['DateTime']['output']>;
  epoch_time?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_attendance_maually_adjusted?: Maybe<Scalars['Boolean']['output']>;
  is_between_leave?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_hours_logged?: Maybe<Scalars['String']['output']>;
  total_minutes_logged?: Maybe<Scalars['String']['output']>;
};

export type AttendanceByGroup = {
  __typename?: 'AttendanceByGroup';
  EmployeesList?: Maybe<AttendanceGroupEmployee>;
  absent?: Maybe<Scalars['Int']['output']>;
  active?: Maybe<Scalars['Int']['output']>;
  break?: Maybe<Scalars['Int']['output']>;
  clockedOut?: Maybe<Scalars['Int']['output']>;
  exceedBreak?: Maybe<Scalars['Int']['output']>;
  holiday?: Maybe<Scalars['Int']['output']>;
  leave?: Maybe<Scalars['Int']['output']>;
  miss_punch_out?: Maybe<Scalars['Int']['output']>;
  shortBreak?: Maybe<Scalars['Int']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  upcoming_clock_in?: Maybe<Scalars['Int']['output']>;
  upcoming_clock_out?: Maybe<Scalars['Int']['output']>;
  weekend?: Maybe<Scalars['Int']['output']>;
};

export type AttendanceData = {
  __typename?: 'AttendanceData';
  CategoryColor?: Maybe<Scalars['String']['output']>;
  EmployeeId?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  EndTime?: Maybe<Scalars['DateTime']['output']>;
  ID?: Maybe<Scalars['String']['output']>;
  ImageType?: Maybe<Scalars['String']['output']>;
  IsAllDay?: Maybe<Scalars['Boolean']['output']>;
  IsBlock?: Maybe<Scalars['Boolean']['output']>;
  RecurrenceRule?: Maybe<Scalars['String']['output']>;
  RemainingLeaves?: Maybe<Scalars['String']['output']>;
  StartTime?: Maybe<Scalars['DateTime']['output']>;
  Subject?: Maybe<Scalars['String']['output']>;
  TotalLeave?: Maybe<Scalars['Float']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  TypeOfAbsence?: Maybe<Scalars['String']['output']>;
  leave_type?: Maybe<Scalars['String']['output']>;
};

export type AttendanceDataWithEmployees = {
  __typename?: 'AttendanceDataWithEmployees';
  data?: Maybe<Array<Maybe<AttendanceData>>>;
  employees?: Maybe<Array<Maybe<User>>>;
};

export type AttendanceEmployeeCount = {
  __typename?: 'AttendanceEmployeeCount';
  absent?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  leave?: Maybe<Scalars['Int']['output']>;
  present?: Maybe<Scalars['Int']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['String']['output']>;
};

export type AttendanceGroupEmployee = {
  __typename?: 'AttendanceGroupEmployee';
  absents?: Maybe<Array<Maybe<EmployeeListAttendance>>>;
  active?: Maybe<Array<Maybe<EmployeeListAttendance>>>;
  break?: Maybe<Array<Maybe<EmployeeListAttendance>>>;
  holiday?: Maybe<Array<Maybe<EmployeeListAttendance>>>;
  leaves?: Maybe<Array<Maybe<EmployeeListAttendance>>>;
  miss_punch_out?: Maybe<Array<Maybe<EmployeeListAttendance>>>;
  upcoming_clock_in?: Maybe<Array<Maybe<EmployeeListAttendance>>>;
  upcoming_clock_out?: Maybe<Array<Maybe<EmployeeListAttendance>>>;
  weekend?: Maybe<Array<Maybe<EmployeeListAttendance>>>;
};

export type AttendanceInput = {
  employee: Scalars['ID']['input'];
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum AttendancePolicyFilter {
  Active = 'active',
  All = 'all',
  Archive = 'archive'
}

export enum AttendancePolicyStatusFilter {
  Current = 'current',
  Previous = 'previous',
  Upcoming = 'upcoming'
}

export type AttendanceRecord = {
  __typename?: 'AttendanceRecord';
  api_response?: Maybe<Scalars['JSON']['output']>;
  date_time: Scalars['DateTime']['output'];
};

export type AttendanceRegulation = {
  __typename?: 'AttendanceRegulation';
  _id?: Maybe<Scalars['ID']['output']>;
  approval_description?: Maybe<Scalars['String']['output']>;
  approval_status?: Maybe<Scalars['String']['output']>;
  attendance_date?: Maybe<Scalars['DateTime']['output']>;
  behalf_of?: Maybe<Array<Maybe<User>>>;
  business?: Maybe<Business>;
  business_manager?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  logs?: Maybe<Array<Maybe<LogsAttendanceRegulation>>>;
  marked_at?: Maybe<Scalars['String']['output']>;
  reason_type?: Maybe<Scalars['String']['output']>;
  roster?: Maybe<Roster>;
  status?: Maybe<Scalars['String']['output']>;
  time_in?: Maybe<Scalars['String']['output']>;
  time_out?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
  work_flow?: Maybe<Array<Maybe<WorkFlow>>>;
};

export enum AttendancestatusEnum {
  Active = 'active',
  Inactive = 'inactive'
}

export enum Attrition {
  NonRegrettable = 'non_regrettable',
  Regrettable = 'regrettable'
}

export type AuditEntry = {
  __typename?: 'AuditEntry';
  _id?: Maybe<Scalars['ID']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  performed_by?: Maybe<User>;
  performed_by_role?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthTokens = {
  __typename?: 'AuthTokens';
  businesses?: Maybe<Array<Maybe<Business>>>;
  code_verifier?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  org_id?: Maybe<Scalars['String']['output']>;
  rocketChat?: Maybe<RocketChat>;
  state?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Tokens>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserAuthDetail>;
};

export type Authenticator = {
  __typename?: 'Authenticator';
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['String']['output']>;
  app_info?: Maybe<AuthenticatorAppInfo>;
  app_name?: Maybe<Scalars['String']['output']>;
  app_type?: Maybe<Scalars['String']['output']>;
  app_url?: Maybe<Scalars['String']['output']>;
  breadcrumbs?: Maybe<Array<Maybe<Authenticator>>>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hierarchy?: Maybe<Array<Maybe<Authenticator>>>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_totp?: Maybe<Scalars['Boolean']['output']>;
  parent_id?: Maybe<AuthenticatorGroup>;
  password_manager?: Maybe<PasswordManagerType>;
  path?: Maybe<Scalars['String']['output']>;
  share_with?: Maybe<Array<Maybe<ShareAuthenticatorApp>>>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type AuthenticatorGroup = {
  __typename?: 'AuthenticatorGroup';
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['String']['output']>;
  app_name?: Maybe<Scalars['String']['output']>;
  breadcrumbs?: Maybe<Array<Maybe<Authenticator>>>;
  children?: Maybe<Array<Maybe<Authenticator>>>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['Date']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  parent_id?: Maybe<AuthenticatorGroup>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type AuthenticatorListWithPagination = {
  __typename?: 'AuthenticatorListWithPagination';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Authenticator>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type AuthenticatorResult = {
  __typename?: 'AuthenticatorResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<Authenticator>>>;
};

export enum AuthenticatorSearchFieldEnum {
  AppName = 'app_name',
  AppUrl = 'app_url',
  Email = 'email',
  UserName = 'user_name'
}

export type BlackOutWindow = {
  __typename?: 'BlackOutWindow';
  date?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type BlackOutWindowInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Brand = {
  __typename?: 'Brand';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Manufacturer?: Maybe<Manufacturer>;
  _id?: Maybe<Scalars['ID']['output']>;
  brand_type?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_global?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Brand>;
  prefix?: Maybe<Scalars['String']['output']>;
};

export type BreakClockedHistory = {
  __typename?: 'BreakClockedHistory';
  User?: Maybe<User>;
  _id: Scalars['ID']['output'];
  breakId?: Maybe<Scalars['ID']['output']>;
  breakInstatus?: Maybe<Scalars['String']['output']>;
  breakType?: Maybe<Scalars['String']['output']>;
  breakTypeId?: Maybe<Scalars['String']['output']>;
  break_duration?: Maybe<Scalars['Int']['output']>;
  break_in_time?: Maybe<Scalars['String']['output']>;
  break_out_time?: Maybe<Scalars['String']['output']>;
  break_type?: Maybe<MasterDataValue>;
  message?: Maybe<Scalars['String']['output']>;
  minimum_break_percentage?: Maybe<Scalars['Int']['output']>;
  newWriteUp?: Maybe<NewWriteUp>;
  pending_writeups?: Maybe<Array<Maybe<WriteUp>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Break_ = {
  __typename?: 'Break_';
  duration: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Business = {
  __typename?: 'Business';
  Country?: Maybe<Country>;
  _id: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  business_email?: Maybe<Scalars['String']['output']>;
  business_identification_number?: Maybe<Scalars['String']['output']>;
  business_identification_type?: Maybe<Scalars['String']['output']>;
  business_keeping_unit?: Maybe<Scalars['String']['output']>;
  business_legal_name?: Maybe<Scalars['String']['output']>;
  business_package?: Maybe<BusinessPackage>;
  business_system_name?: Maybe<Scalars['String']['output']>;
  business_type?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency_format?: Maybe<Scalars['String']['output']>;
  currency_name?: Maybe<Scalars['String']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  date_format?: Maybe<Scalars['String']['output']>;
  is_24_hour_format?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  number_of_stores?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<User>;
  package?: Maybe<Scalars['ID']['output']>;
  pictures?: Maybe<Array<Maybe<ProfilePictures>>>;
  state?: Maybe<State>;
  status?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type BusinessAttendanceLogs = {
  __typename?: 'BusinessAttendanceLogs';
  Business?: Maybe<Business>;
  logs?: Maybe<Array<Maybe<UserAttendanceLogs>>>;
};

export type BusinessDomain = {
  __typename?: 'BusinessDomain';
  Business: Business;
  _id: Scalars['ID']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  domain: Scalars['String']['output'];
  domainId: Scalars['String']['output'];
  is_valid: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type BusinessEmail = {
  __typename?: 'BusinessEmail';
  Business: Business;
  BusinessDomain: BusinessDomain;
  _id: Scalars['ID']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  email: Scalars['String']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type BusinessEmailTemplate = {
  __typename?: 'BusinessEmailTemplate';
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['ID']['output']>;
  business_address?: Maybe<Scalars['String']['output']>;
  business_email?: Maybe<Scalars['String']['output']>;
  business_name?: Maybe<Scalars['String']['output']>;
  business_phone?: Maybe<Scalars['String']['output']>;
  copy_right?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  footer_logo?: Maybe<Scalars['String']['output']>;
  hbs_templates?: Maybe<Array<Maybe<HbsTemplate>>>;
  header_logo?: Maybe<Scalars['String']['output']>;
  html_template?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  module?: Maybe<ModulesEnum>;
  sub_module?: Maybe<SubModulesEnum>;
  subject?: Maybe<Scalars['String']['output']>;
  support_email?: Maybe<Scalars['String']['output']>;
  template_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type BusinessEmailTemplateInput = {
  business_address?: InputMaybe<Scalars['String']['input']>;
  business_name?: InputMaybe<Scalars['String']['input']>;
  business_phone?: InputMaybe<Scalars['String']['input']>;
  copy_right?: InputMaybe<Scalars['String']['input']>;
  footer_logo?: InputMaybe<Scalars['String']['input']>;
  hbs_templates?: InputMaybe<Array<InputMaybe<HbsTemplateCreateInput>>>;
  header_logo?: InputMaybe<Scalars['String']['input']>;
  module: ModulesEnum;
  sub_module: SubModulesEnum;
  subject?: InputMaybe<Scalars['String']['input']>;
  support_email?: InputMaybe<Scalars['String']['input']>;
  template_name: Scalars['String']['input'];
};

export type BusinessEmailTemplateUpdateInput = {
  _id: Scalars['ID']['input'];
  business_address?: InputMaybe<Scalars['String']['input']>;
  business_name?: InputMaybe<Scalars['String']['input']>;
  business_phone?: InputMaybe<Scalars['String']['input']>;
  copy_right?: InputMaybe<Scalars['String']['input']>;
  footer_logo?: InputMaybe<Scalars['String']['input']>;
  header_logo?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  support_email?: InputMaybe<Scalars['String']['input']>;
  template_name: Scalars['String']['input'];
};

export type BusinessLocation = {
  __typename?: 'BusinessLocation';
  Country: Country;
  State?: Maybe<Scalars['ID']['output']>;
  _id?: Maybe<Scalars['ID']['output']>;
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  business_id: Business;
  city?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  duty_roaster?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  franchiser_business?: Maybe<Business>;
  identification_number?: Maybe<Scalars['String']['output']>;
  identification_type?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_store_configure?: Maybe<Scalars['Boolean']['output']>;
  location_keeping_unit?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Package>;
  phone?: Maybe<Scalars['String']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Region>;
  sales_tax?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  store_legal_name?: Maybe<Scalars['String']['output']>;
  store_logo?: Maybe<Scalars['String']['output']>;
  store_name?: Maybe<Scalars['String']['output']>;
  store_nick_name?: Maybe<Scalars['String']['output']>;
  store_type?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type BusinessLocationInput = {
  Country: Scalars['ID']['input'];
  State: Scalars['ID']['input'];
  address_1: Scalars['String']['input'];
  address_2?: InputMaybe<Scalars['String']['input']>;
  business?: InputMaybe<Scalars['ID']['input']>;
  city: Scalars['ID']['input'];
  duty_roaster?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  franchisee_business?: InputMaybe<Scalars['ID']['input']>;
  identification_number: Scalars['String']['input'];
  identification_type?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
  region?: InputMaybe<Scalars['ID']['input']>;
  sales_tax: Scalars['String']['input'];
  status: BusinessLocationStatus;
  store_legal_name: Scalars['String']['input'];
  store_logo?: InputMaybe<Scalars['Upload']['input']>;
  store_name: Scalars['String']['input'];
  store_nick_name: Scalars['String']['input'];
  store_type: StoreTypeEnum;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  zip_code: Scalars['String']['input'];
};

export enum BusinessLocationStatus {
  Active = 'active',
  All = 'all',
  Approved = 'approved',
  Archive = 'archive',
  Inactive = 'inactive',
  Inprogress = 'inprogress',
  Rejected = 'rejected'
}

export type BusinessNavigation = {
  __typename?: 'BusinessNavigation';
  _id?: Maybe<Scalars['String']['output']>;
  accepted_by_user?: Maybe<User>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['Date']['output']>;
  deleted_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  navigation_users?: Maybe<Array<Maybe<BusinessNavigationUserList>>>;
  requested_by?: Maybe<Business>;
  requested_by_user?: Maybe<User>;
  requested_to?: Maybe<Business>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  updated_by?: Maybe<User>;
};

export type BusinessNavigationUserList = {
  __typename?: 'BusinessNavigationUserList';
  employee?: Maybe<User>;
  role?: Maybe<Array<Maybe<Role>>>;
};

export type BusinessPackage = {
  __typename?: 'BusinessPackage';
  _id?: Maybe<Scalars['ID']['output']>;
  business?: Maybe<Business>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  hr_module_only?: Maybe<Scalars['Boolean']['output']>;
  is_pakage_free: Scalars['Boolean']['output'];
  no_of_employee?: Maybe<Scalars['Int']['output']>;
  no_of_store?: Maybe<Scalars['Int']['output']>;
  no_of_transcation?: Maybe<Scalars['Int']['output']>;
  number_of_cashregisters?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<Package>;
  package_name: Scalars['String']['output'];
  package_price: Scalars['Float']['output'];
  package_type: Scalars['String']['output'];
  permissions: Array<Maybe<Permission>>;
  recurring: PackageRecurrignType;
  status?: Maybe<Scalars['String']['output']>;
  subscribe_at?: Maybe<Scalars['DateTime']['output']>;
  transcation_fee?: Maybe<Scalars['Float']['output']>;
  transcation_fee_calculation_type?: Maybe<PackageTranscationFeeType>;
  transcation_fee_ending_limit?: Maybe<Scalars['Float']['output']>;
  transcation_fee_starting_limit?: Maybe<Scalars['Float']['output']>;
};

export type BusinessUpdate = {
  __typename?: 'BusinessUpdate';
  is_country_change?: Maybe<Scalars['Boolean']['output']>;
  is_date_format_change?: Maybe<Scalars['Boolean']['output']>;
  is_time_format_change?: Maybe<Scalars['Boolean']['output']>;
  is_time_zone_change?: Maybe<Scalars['Boolean']['output']>;
};

export type BusinessWithOtp = {
  __typename?: 'BusinessWithOtp';
  Country?: Maybe<Country>;
  _id: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  business_email?: Maybe<Scalars['String']['output']>;
  business_identification_number?: Maybe<Scalars['String']['output']>;
  business_identification_type?: Maybe<Scalars['String']['output']>;
  business_keeping_unit?: Maybe<Scalars['String']['output']>;
  business_legal_name?: Maybe<Scalars['String']['output']>;
  business_package?: Maybe<BusinessPackage>;
  business_system_name?: Maybe<Scalars['String']['output']>;
  business_type?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  date_format?: Maybe<Scalars['String']['output']>;
  is_24_hour_format?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  number_of_stores?: Maybe<Scalars['String']['output']>;
  otp_code?: Maybe<Scalars['Int']['output']>;
  owner_id?: Maybe<User>;
  package?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<State>;
  status?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Discount?: Maybe<Array<Maybe<Discount>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  statistics?: Maybe<Scalars['Float']['output']>;
  stores?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum CanReAttempts {
  Auto = 'auto',
  Manual = 'manual',
  NoReattampt = 'no_reattampt'
}

export type Capacity = {
  __typename?: 'Capacity';
  _id?: Maybe<Scalars['ID']['output']>;
  is_global?: Maybe<Scalars['Boolean']['output']>;
  storage_prefix?: Maybe<Scalars['String']['output']>;
  storage_size?: Maybe<Scalars['String']['output']>;
};

export type Carrier = {
  __typename?: 'Carrier';
  _id?: Maybe<Scalars['ID']['output']>;
  carrier_name?: Maybe<Scalars['String']['output']>;
  carrier_prefix?: Maybe<Scalars['String']['output']>;
  is_global?: Maybe<Scalars['Boolean']['output']>;
};

export type CarryForwardLeave = {
  __typename?: 'CarryForwardLeave';
  days?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
};

export type CaseResolution = {
  __typename?: 'CaseResolution';
  complainant_notification_method?: Maybe<Scalars['String']['output']>;
  complainant_notified_date?: Maybe<Scalars['DateTime']['output']>;
  disciplinary_action?: Maybe<Scalars['String']['output']>;
  is_policy_updated_as_result?: Maybe<Scalars['Boolean']['output']>;
  is_referred_externally?: Maybe<Scalars['Boolean']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  referral_policy_details?: Maybe<Scalars['String']['output']>;
  resolution_notes?: Maybe<Scalars['String']['output']>;
  resolved_at?: Maybe<Scalars['DateTime']['output']>;
  resolved_by?: Maybe<User>;
};

export type CaseWitness = {
  __typename?: 'CaseWitness';
  Department?: Maybe<Array<Maybe<Department>>>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  email?: Maybe<Scalars['String']['output']>;
  form_completed_at?: Maybe<Scalars['DateTime']['output']>;
  form_sent_at?: Maybe<Scalars['DateTime']['output']>;
  form_status?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  what_they_witnessed?: Maybe<Scalars['String']['output']>;
};

export type CashDemonination = {
  __typename?: 'CashDemonination';
  CashRegisters?: Maybe<CashRegisters>;
  TillCountLogs?: Maybe<TillCount>;
  User?: Maybe<User>;
  qty?: Maybe<Scalars['Int']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['Float']['output']>;
};

export enum CashOutRateType {
  FixedRate = 'fixed_rate',
  RegularHourlyRate = 'regular_hourly_rate'
}

export type CashRegisters = {
  __typename?: 'CashRegisters';
  BusinessLocation?: Maybe<BusinessLocation>;
  _id?: Maybe<Scalars['ID']['output']>;
  closing_amount?: Maybe<Scalars['Int']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  opening_amount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<CashRegisterStatus>;
  total_cash?: Maybe<Scalars['Float']['output']>;
};

export type CashRegistersHistory = {
  __typename?: 'CashRegistersHistory';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  CashRegisters?: Maybe<CashRegisters>;
  Transaction?: Maybe<Transaction>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  previous_amount?: Maybe<Scalars['Float']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  transaction_amount?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  type_of_payment?: Maybe<Scalars['String']['output']>;
  updated_amount?: Maybe<Scalars['Float']['output']>;
};

export type CashRegistersHistoryListing = {
  __typename?: 'CashRegistersHistoryListing';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<CashRegistersHistory>>>;
};

export type Category = {
  __typename?: 'Category';
  _id?: Maybe<Scalars['ID']['output']>;
  category_name?: Maybe<Scalars['String']['output']>;
};

export type CategorySectionInput = {
  QuizCategory: Scalars['ID']['input'];
  section_questions: Array<QuestionSectionInput>;
};

export type CategorySectionType = {
  __typename?: 'CategorySectionType';
  QuizCategory?: Maybe<QuizCategory>;
  section_questions: Array<QuestionSectionType>;
};

export type ChartOfAccount = {
  __typename?: 'ChartOfAccount';
  _id?: Maybe<Scalars['ID']['output']>;
  account_balance?: Maybe<Scalars['Int']['output']>;
  account_code?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  account_type?: Maybe<AccountType>;
  as_of?: Maybe<Scalars['DateTime']['output']>;
  business?: Maybe<Business>;
  businessLocation?: Maybe<BusinessLocation>;
  description?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_editable?: Maybe<Scalars['Boolean']['output']>;
  is_sub_account?: Maybe<Scalars['Boolean']['output']>;
  is_system_generated?: Maybe<Scalars['Boolean']['output']>;
  opening_balance?: Maybe<Scalars['Int']['output']>;
  parent_account?: Maybe<ChartOfAccount>;
};

export type CheckInAssetInput = {
  action_performed?: InputMaybe<Scalars['Boolean']['input']>;
  assetId?: InputMaybe<Scalars['ID']['input']>;
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CheckerInput = {
  question_answer?: InputMaybe<Array<InputMaybe<CheckerMarkerInput>>>;
};

export type CheckerMarkerInput = {
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  points_earned?: InputMaybe<Scalars['Float']['input']>;
  question?: InputMaybe<Scalars['ID']['input']>;
};

export type CheckoutAssetInput = {
  Station?: InputMaybe<Scalars['ID']['input']>;
  asset?: InputMaybe<Array<InputMaybe<AssetIds>>>;
  assignedType?: InputMaybe<AssignedType>;
  checkoutDate?: InputMaybe<Scalars['String']['input']>;
  other_detail?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  role_employes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  roles?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ChildTax = {
  __typename?: 'ChildTax';
  _id: Scalars['ID']['output'];
  child_tax_amount?: Maybe<Scalars['String']['output']>;
  child_tax_is_percentage?: Maybe<Scalars['Boolean']['output']>;
  child_tax_name?: Maybe<Scalars['String']['output']>;
};

export type City = {
  __typename?: 'City';
  Country?: Maybe<Country>;
  State?: Maybe<State>;
  _id?: Maybe<Scalars['ID']['output']>;
  city_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  short_name?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ClockedHistory = {
  __typename?: 'ClockedHistory';
  BusinessLocation?: Maybe<Scalars['ID']['output']>;
  Payroll?: Maybe<Payroll>;
  PreviousUserHistory?: Maybe<UserHistory>;
  Schedule?: Maybe<Schedule>;
  User: User;
  UserAppDeviceLog?: Maybe<Array<Maybe<UserAppDeviceLog>>>;
  UserHistory?: Maybe<UserHistory>;
  _id: Scalars['ID']['output'];
  attendanceDate?: Maybe<Scalars['String']['output']>;
  attendanceStatus?: Maybe<Scalars['String']['output']>;
  attendance_adjusted_by?: Maybe<User>;
  attendance_date?: Maybe<Scalars['Date']['output']>;
  attendance_log_detail?: Maybe<Array<Maybe<AttendanceLogDetail>>>;
  breaks?: Maybe<Array<Maybe<BreakClockedHistory>>>;
  clock_in_time?: Maybe<Scalars['String']['output']>;
  clock_out_time?: Maybe<Scalars['String']['output']>;
  clockedInStatus?: Maybe<Scalars['String']['output']>;
  clockedOutStatus?: Maybe<Scalars['String']['output']>;
  is_attendance_maually_adjusted?: Maybe<Scalars['Boolean']['output']>;
  is_back_pay?: Maybe<Scalars['Boolean']['output']>;
  is_between_leave?: Maybe<Scalars['Boolean']['output']>;
  is_over_time_public_holiday?: Maybe<Scalars['Boolean']['output']>;
  is_over_time_weekend?: Maybe<Scalars['Boolean']['output']>;
  is_paid_public_holiday?: Maybe<Scalars['Boolean']['output']>;
  is_paid_weekend?: Maybe<Scalars['Boolean']['output']>;
  is_payroll_processed?: Maybe<Scalars['Boolean']['output']>;
  is_public_holiday?: Maybe<Scalars['Boolean']['output']>;
  is_public_holiday_off?: Maybe<Scalars['Boolean']['output']>;
  is_un_restricted?: Maybe<Scalars['Boolean']['output']>;
  is_update_pending?: Maybe<Scalars['Boolean']['output']>;
  is_weekend?: Maybe<Scalars['Boolean']['output']>;
  logged_seconds?: Maybe<Scalars['Int']['output']>;
  logs?: Maybe<Array<Maybe<LogType>>>;
  manually_logs?: Maybe<Array<Maybe<ManuallyLogs>>>;
  marked_at?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  newWriteUp?: Maybe<NewWriteUp>;
  normal_time_minutes_logged?: Maybe<Scalars['Int']['output']>;
  over_time_minutes_logged?: Maybe<Scalars['Int']['output']>;
  pay_period?: Maybe<Scalars['String']['output']>;
  pending_writeups?: Maybe<Array<Maybe<WriteUp>>>;
  pto_payout_minutes?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  salary_type?: Maybe<Scalars['String']['output']>;
  short_break_count?: Maybe<Scalars['Int']['output']>;
  short_break_detail?: Maybe<Array<Maybe<Short_Break_Detail>>>;
  short_break_duration?: Maybe<Scalars['Int']['output']>;
  short_break_exceeded_minutes?: Maybe<Scalars['Int']['output']>;
  short_break_remaining_minutes?: Maybe<Scalars['Int']['output']>;
  short_break_taken_minutes?: Maybe<Scalars['Int']['output']>;
  short_break_type?: Maybe<Scalars['String']['output']>;
  short_breaks?: Maybe<ShortBreak>;
  short_leave?: Maybe<Array<Maybe<ShortLeave>>>;
  status?: Maybe<Scalars['String']['output']>;
  total_hours_logged?: Maybe<Scalars['String']['output']>;
  total_minutes_logged?: Maybe<Scalars['String']['output']>;
  total_wages?: Maybe<Scalars['String']['output']>;
  total_working_hours_logged?: Maybe<Scalars['String']['output']>;
  total_working_minutes_logged?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  weekOverTime?: Maybe<Scalars['Int']['output']>;
  weeklyTotalLogTime?: Maybe<Scalars['Int']['output']>;
  write_up_type?: Maybe<Scalars['String']['output']>;
  writup_id?: Maybe<Scalars['ID']['output']>;
};

export type ClockedInStatus = {
  __typename?: 'ClockedInStatus';
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  attendanceStatus?: Maybe<Scalars['String']['output']>;
  clock_in_date?: Maybe<Scalars['DateTime']['output']>;
  clock_in_time?: Maybe<Scalars['String']['output']>;
  is_clockedIn: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type Color = {
  __typename?: 'Color';
  _id?: Maybe<Scalars['ID']['output']>;
  color_name?: Maybe<Scalars['String']['output']>;
  color_prefix?: Maybe<Scalars['String']['output']>;
  is_global?: Maybe<Scalars['Boolean']['output']>;
};

export type CommisionCampaignInput = {
  Business: Scalars['ID']['input'];
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Commission = {
  __typename?: 'Commission';
  Brand?: Maybe<Array<Maybe<SystemBrand>>>;
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Category?: Maybe<Array<Maybe<ServiceCategory>>>;
  CommissionCampaign?: Maybe<CommissionCampaign>;
  Department?: Maybe<Array<Maybe<Department>>>;
  DeviceModel?: Maybe<Array<Maybe<DeviceModel>>>;
  DeviceType?: Maybe<Array<Maybe<DeviceType>>>;
  Employee?: Maybe<Array<Maybe<User>>>;
  Product?: Maybe<Array<Maybe<Product>>>;
  ProductType?: Maybe<Array<Maybe<ProductCategoryType>>>;
  Role?: Maybe<Array<Maybe<Role>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  business_type?: Maybe<Scalars['String']['output']>;
  commission_amount: Scalars['Float']['output'];
  commission_duration?: Maybe<_Commission_Duration>;
  commission_name?: Maybe<Scalars['String']['output']>;
  commission_on?: Maybe<CommissionOn>;
  commission_store?: Maybe<_Commission_Store>;
  commission_type?: Maybe<_Commission_Type>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<Array<Maybe<User>>>;
  description?: Maybe<Scalars['String']['output']>;
  highest_sale_duration?: Maybe<_Sale_Duration>;
  is_active?: Maybe<Is_Active>;
  is_all_brands?: Maybe<Scalars['Boolean']['output']>;
  is_all_categories?: Maybe<Scalars['Boolean']['output']>;
  is_all_departments?: Maybe<Scalars['Boolean']['output']>;
  is_all_deviceModels?: Maybe<Scalars['Boolean']['output']>;
  is_all_deviceTypes?: Maybe<Scalars['Boolean']['output']>;
  is_all_employee?: Maybe<Scalars['Boolean']['output']>;
  is_all_productTypes?: Maybe<Scalars['Boolean']['output']>;
  is_all_products?: Maybe<Scalars['Boolean']['output']>;
  is_all_roles?: Maybe<Scalars['Boolean']['output']>;
  is_commission_on_sale?: Maybe<Scalars['Boolean']['output']>;
  is_commission_type_percentage?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['DateTime']['output']>;
  is_greater_then?: Maybe<Scalars['Boolean']['output']>;
  is_on_highest_sales?: Maybe<Scalars['Boolean']['output']>;
  on_gt_eq_sale_duration?: Maybe<_Sale_Duration>;
  on_gt_eq_sale_number?: Maybe<Scalars['Float']['output']>;
  pay_Type?: Maybe<Scalars['String']['output']>;
  pay_schedule?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  redeem_by?: Maybe<Array<Maybe<Customer>>>;
  salary_type?: Maybe<Scalars['String']['output']>;
  schedule_from?: Maybe<Scalars['DateTime']['output']>;
  schedule_to?: Maybe<Scalars['DateTime']['output']>;
  statistics?: Maybe<Scalars['Float']['output']>;
  status: _Status;
  stores?: Maybe<Array<Maybe<BusinessLocation>>>;
  till_date?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Array<Maybe<User>>>;
};

export type CommissionCampaign = {
  __typename?: 'CommissionCampaign';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Commission?: Maybe<Array<Maybe<Commission>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  statistics?: Maybe<Scalars['Float']['output']>;
  stores?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CommissionDetails = {
  __typename?: 'CommissionDetails';
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<Commission>>>;
};

export type CommissionInput = {
  Brand?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Business: Scalars['ID']['input'];
  BusinessLocation: Scalars['ID']['input'];
  Category?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  CommissionCampaign: Scalars['ID']['input'];
  Department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  DeviceModel?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  DeviceType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Employee?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Product?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ProductType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Role?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  business_type?: InputMaybe<AllowBusinessType>;
  commission_amount: Scalars['Float']['input'];
  commission_duration?: InputMaybe<_Commission_Duration>;
  commission_name: Scalars['String']['input'];
  commission_on: CommissionOn;
  commission_store?: InputMaybe<_Commission_Store>;
  commission_type?: InputMaybe<_Commission_Type>;
  description?: InputMaybe<Scalars['String']['input']>;
  highest_sale_duration?: InputMaybe<_Sale_Duration>;
  is_active?: InputMaybe<IsActive>;
  is_all_brands?: InputMaybe<Scalars['Boolean']['input']>;
  is_all_categories?: InputMaybe<Scalars['Boolean']['input']>;
  is_all_departments: Scalars['Boolean']['input'];
  is_all_deviceModels?: InputMaybe<Scalars['Boolean']['input']>;
  is_all_deviceTypes?: InputMaybe<Scalars['Boolean']['input']>;
  is_all_employee?: InputMaybe<Scalars['Boolean']['input']>;
  is_all_productTypes?: InputMaybe<Scalars['Boolean']['input']>;
  is_all_products?: InputMaybe<Scalars['Boolean']['input']>;
  is_all_roles?: InputMaybe<Scalars['Boolean']['input']>;
  is_commission_on_sale?: InputMaybe<Scalars['Boolean']['input']>;
  is_commission_type_percentage?: InputMaybe<Scalars['Boolean']['input']>;
  is_greater_then?: InputMaybe<Scalars['Boolean']['input']>;
  is_on_highest_sales?: InputMaybe<Scalars['Boolean']['input']>;
  life_time?: InputMaybe<Scalars['Boolean']['input']>;
  on_gt_eq_sale_duration?: InputMaybe<_Sale_Duration>;
  on_gt_eq_sale_number?: InputMaybe<Scalars['Float']['input']>;
  pay_schedule?: InputMaybe<Scalars['String']['input']>;
  pay_type?: InputMaybe<Scalars['String']['input']>;
  salary_type?: InputMaybe<Scalars['String']['input']>;
  schedule_from?: InputMaybe<Scalars['DateTime']['input']>;
  schedule_to?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<_Status>;
  stores?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  till_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum CommissionOn {
  Repairs = 'repairs',
  Sales = 'sales'
}

export type CommonDnsKeys = {
  __typename?: 'CommonDnsKeys';
  data?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type CommonValidReason = {
  __typename?: 'CommonValidReason';
  reason?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type ComplaintFilterInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  complainant_by: ComplainantBy;
  field?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<ComplaintSeverity>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ComplaintStatus>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComplaintInterviewLog = {
  __typename?: 'ComplaintInterviewLog';
  Business?: Maybe<Business>;
  HRComplaint?: Maybe<HrComplaint>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  follow_up_required?: Maybe<Scalars['Boolean']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  interview_date?: Maybe<Scalars['DateTime']['output']>;
  interview_type?: Maybe<Scalars['String']['output']>;
  participant_name?: Maybe<Scalars['String']['output']>;
  participant_role?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum ComplaintSeverity {
  Critical = 'critical',
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum ComplaintStatus {
  Closed = 'closed',
  Overdue = 'overdue',
  Resolved = 'resolved',
  Submitted = 'submitted',
  UnderReview = 'under_review'
}

export enum ComplaintUrgency {
  ImmediateDanger = 'immediate_danger',
  Ongoing = 'ongoing',
  RecordOnly = 'record_only',
  Serious = 'serious'
}

export type ComplianceAssignment = {
  __typename?: 'ComplianceAssignment';
  assignment_id?: Maybe<Scalars['ID']['output']>;
  cycle_id?: Maybe<Scalars['ID']['output']>;
  due_date?: Maybe<Scalars['Date']['output']>;
  escalation_triggered?: Maybe<Scalars['Boolean']['output']>;
  failure_counter?: Maybe<Scalars['Int']['output']>;
  matrix_section?: Maybe<MatrixSection>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  urgency_status?: Maybe<UrgencyStatus>;
};

export type ComplianceDashboardInput = {
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  designationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employeeName?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  lastReminderSentAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  outstandingCount?: InputMaybe<Scalars['Int']['input']>;
  overdueCount?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  trainingCategory?: InputMaybe<MatrixSection>;
  urgencyStatus?: InputMaybe<UrgencyStatus>;
};

export type ComplianceDashboardList = {
  __typename?: 'ComplianceDashboardList';
  config?: Maybe<UpdatedDataTableConfig>;
  headerStats?: Maybe<ComplianceHeaderStats>;
  results?: Maybe<Array<Maybe<EmployeeComplianceResult>>>;
};

export type ComplianceDashboardListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  designationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matrix_section?: InputMaybe<MatrixSection>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  urgencyStatus?: InputMaybe<Scalars['String']['input']>;
};

export type ComplianceDashboardResult = {
  __typename?: 'ComplianceDashboardResult';
  departmentBreakdown?: Maybe<Array<Maybe<DepartmentComplianceSummary>>>;
  employees?: Maybe<Array<Maybe<EmployeeComplianceResult>>>;
  headerStats?: Maybe<ComplianceHeaderStats>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ComplianceHeaderStats = {
  __typename?: 'ComplianceHeaderStats';
  employees_at_failure_threshold?: Maybe<Scalars['Int']['output']>;
  not_yet_emailed_count?: Maybe<Scalars['Int']['output']>;
  on_track_count?: Maybe<Scalars['Int']['output']>;
  overdue_count?: Maybe<Scalars['Int']['output']>;
  total_employees_pending?: Maybe<Scalars['Int']['output']>;
  total_trainings_outstanding?: Maybe<Scalars['Int']['output']>;
};

export type ComplianceMilestone = {
  __typename?: 'ComplianceMilestone';
  _id?: Maybe<Scalars['ID']['output']>;
  admin_mode?: Maybe<Scalars['String']['output']>;
  completion_date?: Maybe<Scalars['Date']['output']>;
  deadline_date?: Maybe<Scalars['Date']['output']>;
  milestone_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  urgency_status?: Maybe<UrgencyStatus>;
};

export type ComplianceOrientation = {
  __typename?: 'ComplianceOrientation';
  _id?: Maybe<Scalars['ID']['output']>;
  acknowledged_at?: Maybe<Scalars['Date']['output']>;
  delivery_method?: Maybe<Scalars['String']['output']>;
  orientation_date?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ComplianceSummaryEmailInput = {
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type ConfigListing = {
  __typename?: 'ConfigListing';
  _id?: Maybe<Scalars['ID']['output']>;
  actions?: Maybe<Array<Maybe<ConfigActionType>>>;
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  filters?: Maybe<Array<Maybe<ListingFiltersType>>>;
  no_of_records?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ConfigListingEnum {
  AccessoriesListing = 'AccessoriesListing',
  AccuralHistoryListing = 'AccuralHistoryListing',
  AlertListing = 'AlertListing',
  AllInvoiceListing = 'AllInvoiceListing',
  AllowanceListing = 'AllowanceListing',
  AppraisalReportsExtendedListing = 'AppraisalReportsExtendedListing',
  AppraisalReportsListing = 'AppraisalReportsListing',
  ApprovalWorkFlowListing = 'ApprovalWorkFlowListing',
  ApraisalEvaluationListing = 'ApraisalEvaluationListing',
  ApraisalReviewcyclereport = 'ApraisalReviewcyclereport',
  ArchivedDocumentListing = 'ArchivedDocumentListing',
  AssetCategoryListing = 'AssetCategoryListing',
  AssetListing = 'AssetListing',
  AssetReportListing = 'AssetReportListing',
  AssetsAccessoryByBusinessListing = 'AssetsAccessoryByBusinessListing',
  AssetsByBusinessListing = 'AssetsByBusinessListing',
  AssetsByEmployeeListing = 'AssetsByEmployeeListing',
  AttendanceApprovalsListing = 'AttendanceApprovalsListing',
  AttendancePolicyExtendedView = 'AttendancePolicyExtendedView',
  AttendancePolicyListing = 'AttendancePolicyListing',
  AttendancePolicyPreviousListing = 'AttendancePolicyPreviousListing',
  AttendancePolicyUpcomingListing = 'AttendancePolicyUpcomingListing',
  AttendanceRequestListing = 'AttendanceRequestListing',
  BusinessEmailTemplateListing = 'BusinessEmailTemplateListing',
  BusinessExpenseListing = 'BusinessExpenseListing',
  BusinessFranchiserListing = 'BusinessFranchiserListing',
  BusinessListing = 'BusinessListing',
  BusinessLocationListing = 'BusinessLocationListing',
  BusinessLocationThirdPartyListing = 'BusinessLocationThirdPartyListing',
  BusinessfranchiserOemListing = 'BusinessfranchiserOEMListing',
  CashRegisterListing = 'CashRegisterListing',
  CashRegistersHistoryListing = 'CashRegistersHistoryListing',
  CategoryDetailsListings = 'CategoryDetailsListings',
  ChartOfAccountListing = 'ChartOfAccountListing',
  ComissionListing = 'ComissionListing',
  CommentListing = 'CommentListing',
  CommissionCampaignListing = 'CommissionCampaignListing',
  CommissionListing = 'CommissionListing',
  ComplianceDashboardListing = 'ComplianceDashboardListing',
  ContractLicenseListing = 'ContractLicenseListing',
  ContributionsListing = 'ContributionsListing',
  DeductionListing = 'DeductionListing',
  DepartmentListing = 'DepartmentListing',
  DepartmentalTrainingMatrixListing = 'DepartmentalTrainingMatrixListing',
  DesignationListing = 'DesignationListing',
  DiscountItemListings = 'DiscountItemListings',
  DiscountListing = 'DiscountListing',
  DisposeAssetListing = 'DisposeAssetListing',
  DocumentUplaodListing = 'DocumentUplaodListing',
  DocumentsControlListing = 'DocumentsControlListing',
  EmailDeliveryRuleListing = 'EmailDeliveryRuleListing',
  EmployeeDocumentsListing = 'EmployeeDocumentsListing',
  EmployeeGarnishmentListing = 'EmployeeGarnishmentListing',
  EmployeeSeparationListing = 'EmployeeSeparationListing',
  EmployeeTimeLineHistoryListing = 'EmployeeTimeLineHistoryListing',
  EmployeeTrainingProfileListing = 'EmployeeTrainingProfileListing',
  EmployeesListing = 'EmployeesListing',
  ExpenseApprovalListing = 'ExpenseApprovalListing',
  ExpenseInvoiceCategoryListing = 'ExpenseInvoiceCategoryListing',
  ExpenseInvoiceDetailsListing = 'ExpenseInvoiceDetailsListing',
  ExpenseInvoiceListing = 'ExpenseInvoiceListing',
  ExpenseListing = 'ExpenseListing',
  ExpenseRequestListing = 'ExpenseRequestListing',
  ExtendedAttendanceListing = 'ExtendedAttendanceListing',
  ExternalVendorTrainingListing = 'ExternalVendorTrainingListing',
  FeedbackListing = 'FeedbackListing',
  GiftCardCategoryListing = 'GiftCardCategoryListing',
  GiftCardListing = 'GiftCardListing',
  GoalsListing = 'GoalsListing',
  GroupGoalsListing = 'GroupGoalsListing',
  GroupTimeSheetListing = 'GroupTimeSheetListing',
  HrComplaintListing = 'HRComplaintListing',
  InsuranceListing = 'InsuranceListing',
  InvoiceItemListings = 'InvoiceItemListings',
  LeavePolicyListing = 'LeavePolicyListing',
  LeaveTypeListing = 'LeaveTypeListing',
  LoanApprovalListing = 'LoanApprovalListing',
  LoanListing = 'LoanListing',
  LoanRequestListing = 'LoanRequestListing',
  LoanTransictionListing = 'LoanTransictionListing',
  MaintenanceListing = 'MaintenanceListing',
  MandatoryHrTrainingMatrixListing = 'MandatoryHRTrainingMatrixListing',
  MedicalInsuranceListing = 'MedicalInsuranceListing',
  MedicalInsurancePackageEmployee = 'MedicalInsurancePackageEmployee',
  MedicalInsurancePackageListing = 'MedicalInsurancePackageListing',
  MyApraisalEvaluationListing = 'MyApraisalEvaluationListing',
  MyFeedbackListing = 'MyFeedbackListing',
  MyQuizTrainingListing = 'MyQuizTrainingListing',
  MyRequestActivityListing = 'MyRequestActivityListing',
  ObjectiveAssignmentsListing = 'ObjectiveAssignmentsListing',
  OnboardingMilestoneTrainingMatrixListing = 'OnboardingMilestoneTrainingMatrixListing',
  OrientationTrackingListing = 'OrientationTrackingListing',
  PackageListing = 'PackageListing',
  PayrollRunListing = 'PayrollRunListing',
  PayrollScheduleListing = 'PayrollScheduleListing',
  PayrollStructureListing = 'PayrollStructureListing',
  PerformanceCycleListing = 'PerformanceCycleListing',
  PerformanceGoalsListing = 'PerformanceGoalsListing',
  PlaidTransactionListing = 'PlaidTransactionListing',
  PublicHolidayListing = 'PublicHolidayListing',
  QuickAccessoriesListing = 'QuickAccessoriesListing',
  QuickAssetListing = 'QuickAssetListing',
  QuickAssetReportListing = 'QuickAssetReportListing',
  QuizAssignedListing = 'QuizAssignedListing',
  QuizCatgoryListing = 'QuizCatgoryListing',
  QuizEvaluationListing = 'QuizEvaluationListing',
  QuizListing = 'QuizListing',
  QuizTrainingAssignmentListing = 'QuizTrainingAssignmentListing',
  QuizTrainingCategoryListing = 'QuizTrainingCategoryListing',
  QuizTrainingListing = 'QuizTrainingListing',
  QuizTrainingReplicaListing = 'QuizTrainingReplicaListing',
  RegionsListing = 'RegionsListing',
  ReserveAssetListing = 'ReserveAssetListing',
  RolesListing = 'RolesListing',
  SendRequestActivityListing = 'SendRequestActivityListing',
  ShiftsListing = 'ShiftsListing',
  SubCategoryItemListings = 'SubCategoryItemListings',
  SubscriptionListing = 'SubscriptionListing',
  SubscriptionLogListing = 'SubscriptionLogListing',
  TaskListing = 'TaskListing',
  TimeLineHistoryByEmployeeId = 'TimeLineHistoryByEmployeeId',
  TimeOffEmployeeListing = 'TimeOffEmployeeListing',
  TimeOffListing = 'TimeOffListing',
  TimeOffRequestListing = 'TimeOffRequestListing',
  TimeSheetListing = 'TimeSheetListing',
  TrainingCycleListing = 'TrainingCycleListing',
  TrainingFailureResetLogListing = 'TrainingFailureResetLogListing',
  TrainingMatrixListing = 'TrainingMatrixListing',
  TrainingMilestoneTrackingListing = 'TrainingMilestoneTrackingListing',
  UserQuizAssignedListing = 'UserQuizAssignedListing',
  WriteUpApprovalListing = 'WriteUpApprovalListing',
  WriteUpListing = 'WriteUpListing',
  WriteUpListingByEmployeeId = 'WriteUpListingByEmployeeId',
  AppraisalListing = 'appraisalListing',
  AppraisalObjectiveListing = 'appraisalObjectiveListing',
  AppraisalScaleListing = 'appraisalScaleListing',
  AssetModelListing = 'assetModelListing',
  AssteBrandListing = 'assteBrandListing',
  AssteLinkedBrandListing = 'assteLinkedBrandListing',
  AuthenticatorAppListing = 'authenticatorAppListing',
  FinalSettlementListing = 'finalSettlementListing',
  GetConnectedAppDeviceList = 'getConnectedAppDeviceList',
  PayrollBiWeeklyListing = 'payrollBiWeeklyListing',
  PayrollPerMonthListing = 'payrollPerMonthListing',
  PayrollTwiceMonthListing = 'payrollTwiceMonthListing',
  PayrollWeeklyListing = 'payrollWeeklyListing',
  RecruitmentListing = 'recruitmentListing',
  ShareWithMeAppListing = 'shareWithMeAppListing',
  TerminalAppDeviceListing = 'terminalAppDeviceListing',
  TerminalAppHistoryListing = 'terminalAppHistoryListing',
  UserAppDeviceExtendListing = 'userAppDeviceExtendListing',
  UserAppDeviceListing = 'userAppDeviceListing'
}

export type ConfigListingInput = {
  columns?: InputMaybe<Array<InputMaybe<ListingColumnsInput>>>;
  filters?: InputMaybe<Array<InputMaybe<ListingFiltersInput>>>;
  no_of_records?: InputMaybe<Scalars['Int']['input']>;
  table_config?: InputMaybe<TableConfig>;
  type?: InputMaybe<ConfigListingEnum>;
};

export type ConflictRecord = {
  __typename?: 'ConflictRecord';
  attendanceStatus?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  record_id?: Maybe<Scalars['ID']['output']>;
};

export type ConflictSchedule = {
  __typename?: 'ConflictSchedule';
  Business?: Maybe<Business>;
  conflicted_schedule?: Maybe<Schedule>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  employee_action?: Maybe<Scalars['String']['output']>;
  employee_id?: Maybe<User>;
  employee_name?: Maybe<Scalars['String']['output']>;
  is_attendance_exist?: Maybe<Scalars['Boolean']['output']>;
  is_conflict?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_leave?: Maybe<Scalars['Boolean']['output']>;
  is_overlap?: Maybe<Scalars['Boolean']['output']>;
  is_salary_detail_not_exist?: Maybe<Scalars['Boolean']['output']>;
  new_schedule?: Maybe<Schedule>;
};

export type ContractLicense = {
  __typename?: 'ContractLicense';
  contactPerson?: Maybe<Scalars['String']['output']>;
  contractLicenseTitle?: Maybe<Scalars['String']['output']>;
  contractNo?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  hyperlink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isForSoftware?: Maybe<Scalars['Boolean']['output']>;
  isNoEndDate?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  logs?: Maybe<Array<Maybe<ContractLogs>>>;
  noOfLicenses?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type ContractLicenseFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ContractLicenseResult = {
  __typename?: 'ContractLicenseResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<ContractLicense>>>;
};

export type Contribution = {
  __typename?: 'Contribution';
  _id?: Maybe<Scalars['ID']['output']>;
  business: Business;
  contribution_amount: Scalars['Float']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  is_calculate_amount_fixed: Scalars['Boolean']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name_pay_slip: Scalars['String']['output'];
};

export type ContributionData = {
  __typename?: 'ContributionData';
  amount: Scalars['Float']['output'];
  contribution?: Maybe<Contribution>;
  is_percentage: Scalars['Boolean']['output'];
};

export type ContributionInput = {
  business: Scalars['String']['input'];
  contribution_amount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  is_calculate_amount_fixed: Scalars['Boolean']['input'];
  name_pay_slip: Scalars['String']['input'];
};

export type ContributionList = {
  amount: Scalars['Float']['input'];
  contribution: Scalars['ID']['input'];
  is_percentage: Scalars['Boolean']['input'];
};

export type ContributionsType = {
  __typename?: 'ContributionsType';
  amount?: Maybe<Scalars['Float']['output']>;
  contribution?: Maybe<Contribution>;
  is_taxable?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  is_internal_note?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<User>;
};

export type Country = {
  __typename?: 'Country';
  _id?: Maybe<Scalars['ID']['output']>;
  identification_types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
};

export type CreateAssetCategoryInput = {
  name: Scalars['String']['input'];
};

export type CreateAssetCategoryOrSubCategoryInput = {
  AssetCategoryId?: InputMaybe<Scalars['ID']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  subCategoryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCategoryUrl?: InputMaybe<Scalars['Upload']['input']>;
};

export type CreateAssetInput = {
  AssetBrand?: InputMaybe<Scalars['ID']['input']>;
  AssetModel?: InputMaybe<Scalars['ID']['input']>;
  Role?: InputMaybe<Array<Scalars['ID']['input']>>;
  Station?: InputMaybe<Scalars['ID']['input']>;
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assetImage?: InputMaybe<Array<Scalars['Upload']['input']>>;
  assignedEmployee?: InputMaybe<Scalars['ID']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['ID']['input'];
  cost?: InputMaybe<Scalars['Float']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  depreciation?: InputMaybe<Array<InputMaybe<DepreciationInput>>>;
  depreciationSalvageValue?: InputMaybe<Scalars['Int']['input']>;
  depreciationTenure?: InputMaybe<Scalars['Int']['input']>;
  depreciationType?: InputMaybe<DepreciationEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  initialCost?: InputMaybe<Scalars['Float']['input']>;
  isAutoAssetId?: InputMaybe<Scalars['Boolean']['input']>;
  isDepreciation?: InputMaybe<Scalars['Boolean']['input']>;
  isSeriallized?: InputMaybe<Scalars['Boolean']['input']>;
  manualAssetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  other_detail?: InputMaybe<Scalars['String']['input']>;
  purchasedDate?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  role_employes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  serialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  site?: InputMaybe<Scalars['ID']['input']>;
  subCategory: Scalars['ID']['input'];
  type?: InputMaybe<AssetTypeEnum>;
};

export type CreateAssetSubCategoryInput = {
  AssetCategoryId: Scalars['ID']['input'];
  categoryUrl?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCategoriesInput = {
  name: Scalars['String']['input'];
  sections?: InputMaybe<Array<CreateCategorySectionInput>>;
};

export type CreateCategorySectionInput = {
  name: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};

export type CreateEmployeeDashboardViewInput = {
  card_size?: InputMaybe<Scalars['String']['input']>;
  card_width?: InputMaybe<Scalars['Float']['input']>;
  is_bold_emp_name?: InputMaybe<Scalars['Boolean']['input']>;
  is_bold_status_time?: InputMaybe<Scalars['Boolean']['input']>;
  is_system_default_screen?: InputMaybe<Scalars['Boolean']['input']>;
  name_format?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  profile_picture_size?: InputMaybe<Scalars['String']['input']>;
  status_display?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  view_type: EmployeeDashboardViewEnum;
  views: Array<EmployeeDashboardViewSectionInput>;
};

export type CreateExternalVendorTrainingInput = {
  Users: Array<Scalars['ID']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  completion_date: Scalars['Date']['input'];
  provider: Scalars['String']['input'];
  training_name: Scalars['String']['input'];
};

export type CreateFeedbackInput = {
  Department?: InputMaybe<Array<Scalars['ID']['input']>>;
  attached_files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  feedback: Scalars['String']['input'];
  feedback_type: Scalars['ID']['input'];
  is_anonymous: Scalars['Boolean']['input'];
};

export type CreateHrComplaintInput = {
  Department?: InputMaybe<Array<Scalars['ID']['input']>>;
  approximate_time?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  hr_additional_info?: InputMaybe<Scalars['String']['input']>;
  incident_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_exact_date_unknown?: InputMaybe<Scalars['Boolean']['input']>;
  is_hr_review_confirmed: Scalars['Boolean']['input'];
  is_hr_should_know_anything?: InputMaybe<Scalars['Boolean']['input']>;
  is_reported_previously?: InputMaybe<Scalars['Boolean']['input']>;
  is_supporting_documents?: InputMaybe<Scalars['Boolean']['input']>;
  is_truthful_confirmed: Scalars['Boolean']['input'];
  other_concern_description?: InputMaybe<Scalars['String']['input']>;
  persons_involved?: InputMaybe<Array<InputMaybe<PersonInvolvedInput>>>;
  preferred_contact_method: PreferredContactMethod;
  previous_description?: InputMaybe<Scalars['String']['input']>;
  situation_ongoing?: InputMaybe<WitnessesEvent>;
  supporting_files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  supporting_files_description?: InputMaybe<Scalars['String']['input']>;
  type_of_concern: Array<TypeOfConcern>;
  urgency: ComplaintUrgency;
  where_did_it_occur?: InputMaybe<Scalars['String']['input']>;
  witnesses?: InputMaybe<Array<WitnessComplaintInput>>;
  witnesses_events: WitnessesEvent;
};

export type CreateQuestionInput = {
  QuizCategory: Scalars['ID']['input'];
  QuizCategorySection: Scalars['ID']['input'];
  questions: Array<MultiQuestion>;
  selectedLanugages?: InputMaybe<Array<LanguageCode>>;
};

export type CreateQuizInput = {
  Department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Role?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  can_assign_traning?: InputMaybe<Scalars['Boolean']['input']>;
  can_re_attempts?: InputMaybe<CanReAttempts>;
  category_sections: Array<CategorySectionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['Date']['input']>;
  end_time?: InputMaybe<Scalars['Date']['input']>;
  evaluate_by?: InputMaybe<Array<Scalars['ID']['input']>>;
  evaluator_department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  evaluator_role?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  grade?: InputMaybe<Array<GradeInput>>;
  is_attempt_one_by_one?: InputMaybe<Scalars['Boolean']['input']>;
  is_random?: InputMaybe<Scalars['Boolean']['input']>;
  is_shuffling?: InputMaybe<Scalars['Boolean']['input']>;
  max_attempts?: InputMaybe<Scalars['Int']['input']>;
  passing_marks?: InputMaybe<Scalars['Float']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  selectedLanguages?: InputMaybe<Array<LanguageCode>>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  start_time?: InputMaybe<Scalars['Date']['input']>;
  title: Scalars['String']['input'];
};

export type CreateRefresherCycleInput = {
  assignTo: Array<Scalars['ID']['input']>;
  end_date: Scalars['Date']['input'];
  matrix_section: CycleMatrixSection;
  name: Scalars['String']['input'];
  start_date: Scalars['Date']['input'];
  targetDepartments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CreateTrainingInput = {
  Quiz?: InputMaybe<Scalars['ID']['input']>;
  QuizTrainingCategory: Scalars['ID']['input'];
  QuizTrainingSubCategory: Scalars['ID']['input'];
  attachments: Array<TrainingAttachmentInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<TrainingLinkInput>>>;
  selectedLanguages: Array<LanguageCode>;
  title: Scalars['String']['input'];
};

export type CreateUpdateEmployeeInput = {
  employeeAccount?: InputMaybe<EmployeeAccountInput>;
  employeeDocumentsList?: InputMaybe<EmployeeDocumentsInput>;
  employeeEmployeeTimeLine?: InputMaybe<EmployeeEmployeeTimeLineInput>;
  employeeInfo?: InputMaybe<EmployeeInfoInput>;
  employeeSalaryTaxDetails?: InputMaybe<EmployeeSalaryTaxDetails>;
  employeeSalaryTransferMethod?: InputMaybe<EmployeeSalaryTransferMethodInput>;
  employeeTimeOff?: InputMaybe<EmployeeTimeOffInput>;
  employeeTimeRuleAttendance?: InputMaybe<EmployeeTimeRuleAttendanceInput>;
  employmentContract?: InputMaybe<EmploymentContractInput>;
  joiningLatter?: InputMaybe<JoiningLatterInput>;
  section: EmployeeSections;
};

export type CurrendClockedInSchedule = {
  __typename?: 'CurrendClockedInSchedule';
  Schedule?: Maybe<Schedule>;
  clockedHistory?: Maybe<ClockedHistory>;
  short_break?: Maybe<ShortBreak>;
  taken_breaks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taken_short_breaks?: Maybe<Scalars['Int']['output']>;
  total_allowed_short_breaks?: Maybe<Scalars['Int']['output']>;
};

export type CurrentAccuralResult = {
  __typename?: 'CurrentAccuralResult';
  accrual_id?: Maybe<Scalars['ID']['output']>;
  cycle?: Maybe<AccuralCycle>;
  is_current?: Maybe<Scalars['Boolean']['output']>;
  package_name?: Maybe<Scalars['String']['output']>;
  pto_summary?: Maybe<PtoSummary>;
  remaining_leaves?: Maybe<Array<Maybe<RemainingLeave>>>;
};

export enum CustomFieldTypeEnum {
  Customer = 'customer'
}

export type CustomFieldTypeInput = {
  controlType?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<CustomFieldTypeOptionInput>>>;
  order?: InputMaybe<Scalars['Float']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFieldTypeOptionInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFieldTypeOptionType = {
  __typename?: 'CustomFieldTypeOptionType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Customer = {
  __typename?: 'Customer';
  _id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CycleInfo = {
  __typename?: 'CycleInfo';
  _id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum CycleMatrixSection {
  All = 'all',
  Departmental = 'departmental',
  MandatoryHrTraining = 'mandatory_hr_training'
}

export enum CycleStatus {
  Active = 'active',
  Completed = 'completed',
  Scheduled = 'scheduled'
}

export type Deduction = {
  __typename?: 'Deduction';
  _id?: Maybe<Scalars['ID']['output']>;
  business: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deduction_amount: Scalars['Float']['output'];
  deduction_tax_plan: Scalars['Boolean']['output'];
  is_calculate_amount_fixed: Scalars['Boolean']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_sample_data?: Maybe<Scalars['Boolean']['output']>;
  name_pay_slip: Scalars['String']['output'];
};

export type DeductionData = {
  __typename?: 'DeductionData';
  amount: Scalars['Float']['output'];
  deduction?: Maybe<Deduction>;
  is_percentage: Scalars['Boolean']['output'];
  taxable: Scalars['Boolean']['output'];
};

export type DeductionInput = {
  business: Scalars['String']['input'];
  deduction_amount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  is_calculate_amount_fixed: Scalars['Boolean']['input'];
  name_pay_slip: Scalars['String']['input'];
};

export type DeductionList = {
  amount: Scalars['Float']['input'];
  deduction: Scalars['ID']['input'];
  is_percentage: Scalars['Boolean']['input'];
};

export type DeductionsType = {
  __typename?: 'DeductionsType';
  amount?: Maybe<Scalars['Float']['output']>;
  deduction?: Maybe<Deduction>;
  is_taxable?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type DefaultEmailTemplate = {
  __typename?: 'DefaultEmailTemplate';
  ActionFeature?: Maybe<ActionFeature>;
  _id: Scalars['ID']['output'];
  body: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  module: ModulesEnum;
  name: Scalars['String']['output'];
  sub_module: SubModulesEnum;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  variables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DefaultTemplateInput = {
  ActionFeature: Scalars['ID']['input'];
  body: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  module: ModulesEnum;
  name: Scalars['String']['input'];
  sub_module: SubModulesEnum;
};

export type DefaultTemplateResult = {
  __typename?: 'DefaultTemplateResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<DefaultEmailTemplate>>>;
};

export type DelegantApproval = {
  __typename?: 'DelegantApproval';
  Business?: Maybe<Business>;
  approval_type?: Maybe<WorkFlowTypeEnum>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  delegate_approvers?: Maybe<Array<Maybe<User>>>;
  original_approver?: Maybe<User>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['DateTime']['output']>;
};

export type DeleteCycleResponse = {
  __typename?: 'DeleteCycleResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteExtraLeaveInput = {
  leave_type_id?: InputMaybe<Scalars['ID']['input']>;
  schedule_date?: InputMaybe<Scalars['String']['input']>;
  schedule_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum DeletedType {
  Node = 'node',
  Tree = 'tree'
}

export type Department = {
  __typename?: 'Department';
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['ID']['output']>;
  businessLocation?: Maybe<BusinessLocation>;
  department_name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  employee_count?: Maybe<Scalars['Int']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_sample_data?: Maybe<Scalars['Boolean']['output']>;
};

export type DepartmentComplianceSummary = {
  __typename?: 'DepartmentComplianceSummary';
  completion_percentage?: Maybe<Scalars['Int']['output']>;
  department_id?: Maybe<Scalars['ID']['output']>;
  department_name?: Maybe<Scalars['String']['output']>;
  employees_completed_all_trainings?: Maybe<Scalars['Int']['output']>;
  employees_with_pending_trainings?: Maybe<Scalars['Int']['output']>;
  overdue_trainings_count?: Maybe<Scalars['Int']['output']>;
  total_employees?: Maybe<Scalars['Int']['output']>;
};

export type DepartmentOvertime = {
  __typename?: 'DepartmentOvertime';
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  totalOvertimeMinutes?: Maybe<Scalars['Int']['output']>;
  totalOvertimeWages?: Maybe<Scalars['Float']['output']>;
};

export type DepartmentOvertimeResult = {
  __typename?: 'DepartmentOvertimeResult';
  perDepartment?: Maybe<Array<Maybe<DepartmentOvertime>>>;
  totalSummary?: Maybe<OvertimeTotalSummary>;
};

export type DepartmentRosterData = {
  __typename?: 'DepartmentRosterData';
  CategoryColor?: Maybe<Scalars['String']['output']>;
  EndTime?: Maybe<Scalars['DateTime']['output']>;
  ID?: Maybe<Scalars['String']['output']>;
  IsAllDay?: Maybe<Scalars['Boolean']['output']>;
  IsBlock?: Maybe<Scalars['Boolean']['output']>;
  RecurrenceRule?: Maybe<Scalars['String']['output']>;
  StartTime?: Maybe<Scalars['DateTime']['output']>;
  Subject?: Maybe<Scalars['String']['output']>;
  TaskId?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type Designation = {
  __typename?: 'Designation';
  _id?: Maybe<Scalars['ID']['output']>;
  business?: Maybe<Business>;
  businessLocation?: Maybe<BusinessLocation>;
  designation_name?: Maybe<Scalars['String']['output']>;
  employee_count?: Maybe<Scalars['Int']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_sample_data?: Maybe<Scalars['Boolean']['output']>;
};

export type DeviceModel = {
  __typename?: 'DeviceModel';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  _id?: Maybe<Scalars['ID']['output']>;
  brand?: Maybe<SystemBrand>;
  device_prefix?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum DeviceStatusEnum {
  Linked = 'linked',
  Unlinked = 'unlinked'
}

export type DeviceType = {
  __typename?: 'DeviceType';
  _id?: Maybe<Scalars['ID']['output']>;
  type_name?: Maybe<Scalars['String']['output']>;
  type_prefix?: Maybe<Scalars['String']['output']>;
};

export enum DisciplinaryActionEnum {
  Demotion = 'demotion',
  FinalWrittenWarning = 'final_written_warning',
  None = 'none',
  PerformanceImprovementPlan = 'performance_improvement_plan',
  PolicyUpdated = 'policy_updated',
  ReferredToLawEnforcement = 'referred_to_law_enforcement',
  SuspensionPaid = 'suspension_paid',
  SuspensionUnpaid = 'suspension_unpaid',
  TerminationInvoluntary = 'termination_involuntary',
  TerminationVoluntary = 'termination_voluntary',
  VerbalCounseling = 'verbal_counseling',
  WrittenWarningL1 = 'written_warning_l1',
  WrittenWarningL2 = 'written_warning_l2'
}

export type Discount = {
  __typename?: 'Discount';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Campaign?: Maybe<Campaign>;
  Product?: Maybe<Array<Maybe<Product>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  business_type?: Maybe<Scalars['String']['output']>;
  can_schedule: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customerTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customer_since?: Maybe<Scalars['DateTime']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  engagement?: Maybe<Scalars['Float']['output']>;
  isSendEmail?: Maybe<Scalars['Boolean']['output']>;
  is_active: Is_Active;
  is_customer_can_use_only_once?: Maybe<Scalars['Boolean']['output']>;
  is_customer_more_then_said_amount?: Maybe<Scalars['Boolean']['output']>;
  is_customer_since?: Maybe<Scalars['Boolean']['output']>;
  is_customer_spent_amount: Scalars['Boolean']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_discount_percentage?: Maybe<Scalars['Boolean']['output']>;
  is_entire_order?: Maybe<Scalars['Boolean']['output']>;
  /** it will depend */
  is_minimum_purchase?: Maybe<Scalars['Boolean']['output']>;
  is_minimum_purchase_amount?: Maybe<Scalars['Boolean']['output']>;
  is_new_customer_only?: Maybe<Scalars['Boolean']['output']>;
  is_single_store?: Maybe<Scalars['Boolean']['output']>;
  multi_stores?: Maybe<Array<Maybe<BusinessLocation>>>;
  new_customer_register_after_date?: Maybe<Scalars['DateTime']['output']>;
  number_of_usage_per_customer?: Maybe<Scalars['Float']['output']>;
  purchaseAmountQuantity?: Maybe<Scalars['Float']['output']>;
  reach?: Maybe<Scalars['Float']['output']>;
  redeem_by?: Maybe<Array<Maybe<Customer>>>;
  schedule_from?: Maybe<Scalars['DateTime']['output']>;
  schedule_to?: Maybe<Scalars['DateTime']['output']>;
  single_store?: Maybe<BusinessLocation>;
  spent_amount?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type DiscountDetail = {
  __typename?: 'DiscountDetail';
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<Discount>>>;
};

export type DiscountInput = {
  Business: Scalars['ID']['input'];
  BusinessLocation: Scalars['ID']['input'];
  Campaign: Scalars['ID']['input'];
  Product?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  business_type: Scalars['String']['input'];
  can_schedule: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  customerTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customer_since?: InputMaybe<Scalars['String']['input']>;
  discount_amount: Scalars['Float']['input'];
  isSendEmail: Scalars['Boolean']['input'];
  is_active: Is_Active;
  is_customer_can_use_only_once: Scalars['Boolean']['input'];
  is_customer_more_then_said_amount: Scalars['Boolean']['input'];
  is_customer_since: Scalars['Boolean']['input'];
  is_customer_spent_amount: Scalars['Boolean']['input'];
  is_discount_percentage: Scalars['Boolean']['input'];
  is_entire_order: Scalars['Boolean']['input'];
  is_minimum_purchase: Scalars['Boolean']['input'];
  is_minimum_purchase_amount: Scalars['Boolean']['input'];
  is_new_customer_only: Scalars['Boolean']['input'];
  is_single_store: Scalars['Boolean']['input'];
  multi_stores?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  number_of_usage_per_customer?: InputMaybe<Scalars['Float']['input']>;
  purchaseAmountQuantity?: InputMaybe<Scalars['Float']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  schedule_from?: InputMaybe<Scalars['String']['input']>;
  schedule_to?: InputMaybe<Scalars['String']['input']>;
  single_store?: InputMaybe<Scalars['ID']['input']>;
  spent_amount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DividePermission = {
  __typename?: 'DividePermission';
  POSPermissionResult?: Maybe<Array<Maybe<Permission>>>;
  adminPermissionResult?: Maybe<Array<Maybe<Permission>>>;
};

export type DnsKeysSecurityFlag = {
  __typename?: 'DnsKeysSecurityFlag';
  dkim1?: Maybe<CommonDnsKeys>;
  dkim2?: Maybe<CommonDnsKeys>;
  mail_cname?: Maybe<CommonDnsKeys>;
};

export type DnsKeysWithoutSecurityFlag = {
  __typename?: 'DnsKeysWithoutSecurityFlag';
  dkim?: Maybe<CommonDnsKeys>;
  mail_server?: Maybe<CommonDnsKeys>;
  subdomain_spf?: Maybe<CommonDnsKeys>;
};

export type DocumentControlAttachment = {
  __typename?: 'DocumentControlAttachment';
  _id?: Maybe<Scalars['ID']['output']>;
  activity_name?: Maybe<Scalars['String']['output']>;
  activity_type?: Maybe<Activity_Type>;
  assign_to?: Maybe<AssignToType>;
  attachment?: Maybe<Scalars['String']['output']>;
  bread_crum?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
  business?: Maybe<Business>;
  businessLocation?: Maybe<BusinessLocation>;
  children?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
  clock_in_time?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  details?: Maybe<DocumentControlAttachmentDetail>;
  document_type?: Maybe<Scalars['String']['output']>;
  employeeDocumentUpload?: Maybe<Array<Maybe<EmployeeDocumentUpload>>>;
  extension?: Maybe<Scalars['String']['output']>;
  google_drive_attachment?: Maybe<Scalars['String']['output']>;
  google_drive_id?: Maybe<Scalars['String']['output']>;
  group?: Maybe<DocumentControlAttachment>;
  grouped_activities?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
  isEmployeeUpload?: Maybe<Scalars['Boolean']['output']>;
  isFile?: Maybe<Scalars['Boolean']['output']>;
  is_activity_folder?: Maybe<Scalars['Boolean']['output']>;
  is_asset_main_folder?: Maybe<Scalars['Boolean']['output']>;
  is_default_document?: Maybe<Scalars['Boolean']['output']>;
  is_employee_folder?: Maybe<Scalars['Boolean']['output']>;
  is_employee_main_folder?: Maybe<Scalars['Boolean']['output']>;
  is_group?: Maybe<Scalars['Boolean']['output']>;
  is_hide_after_review?: Maybe<Scalars['Boolean']['output']>;
  is_owner?: Maybe<Scalars['Boolean']['output']>;
  is_sign_required?: Maybe<Scalars['Boolean']['output']>;
  is_submission_required?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  not_responded?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<DocumentControlAttachment>;
  receivedDocumentInMultipleAction?: Maybe<Scalars['String']['output']>;
  responded?: Maybe<Scalars['Int']['output']>;
  share_as?: Maybe<Scalars['String']['output']>;
  share_by?: Maybe<Scalars['String']['output']>;
  share_with?: Maybe<Array<Maybe<Share_With>>>;
  signatureDeliveryOption?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
  uploadfileref?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentControlAttachmentDetail = {
  __typename?: 'DocumentControlAttachmentDetail';
  files?: Maybe<Scalars['Int']['output']>;
  folder?: Maybe<Scalars['Int']['output']>;
};

export type DocumentControlAttachmenttWithData = {
  __typename?: 'DocumentControlAttachmenttWithData';
  Doucuments?: Maybe<DocumentControlAttachment>;
  detail?: Maybe<DocumentDetail>;
};

export type DocumentListType = {
  __typename?: 'DocumentListType';
  Role?: Maybe<Role>;
  _id?: Maybe<Scalars['String']['output']>;
  assinged_to?: Maybe<User>;
  documents_description?: Maybe<Scalars['String']['output']>;
  documents_expiry_date?: Maybe<Scalars['Date']['output']>;
  documents_name?: Maybe<Scalars['String']['output']>;
  documents_type?: Maybe<Scalars['String']['output']>;
  google_drive_id?: Maybe<Scalars['String']['output']>;
  is_documents_hide?: Maybe<Scalars['Boolean']['output']>;
  is_email_notify?: Maybe<Scalars['Boolean']['output']>;
  upload_documents?: Maybe<Scalars['String']['output']>;
};

export enum DocumentTypeEnums {
  Owner = 'owner',
  Shared = 'shared'
}

export type DomainAuthenticationInput = {
  automatic_security?: InputMaybe<Scalars['Boolean']['input']>;
  domain: Scalars['String']['input'];
};

export type EarnedAccrued = {
  __typename?: 'EarnedAccrued';
  days?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  minutes?: Maybe<Scalars['Float']['output']>;
};

export type EditAuthenticatorGroupInput = {
  group_type: Group_Type;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type EmailDeliveryRule = {
  __typename?: 'EmailDeliveryRule';
  Business: Business;
  BusinessEmail: BusinessEmail;
  _id?: Maybe<Scalars['ID']['output']>;
  configuration_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  module: ModulesEnum;
  sub_module: SubModulesEnum;
  type?: Maybe<SmtpType>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type EmailDeliveryRuleResult = {
  __typename?: 'EmailDeliveryRuleResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<EmailDeliveryRule>>>;
};

export type EmailScheduleInput = {
  body: Scalars['String']['input'];
  email_to_me?: InputMaybe<Scalars['Boolean']['input']>;
  employees: Array<InputMaybe<Scalars['ID']['input']>>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  include_comment?: InputMaybe<Scalars['Boolean']['input']>;
  include_total_hours?: InputMaybe<Scalars['Boolean']['input']>;
  is_html_format?: InputMaybe<Scalars['Boolean']['input']>;
  is_include_schedule?: InputMaybe<Scalars['Boolean']['input']>;
  send_option?: InputMaybe<SendEmailOption>;
  subject: Scalars['String']['input'];
  view?: InputMaybe<ViewSchedule>;
};

export type EmailTemplateBodySendingEmailInput = {
  body: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type EmailTemplateResult = {
  __typename?: 'EmailTemplateResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<BusinessEmailTemplate>>>;
};

export type EmailTemplateUnion = BusinessEmailTemplate | DefaultEmailTemplate;

export type EmployeeAdpResponse = {
  __typename?: 'EmployeeADPResponse';
  adpId?: Maybe<Scalars['ID']['output']>;
  employee_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type EmployeeAccountInput = {
  account_representive_code?: InputMaybe<Scalars['String']['input']>;
  account_status: Scalars['String']['input'];
  associated_customer?: InputMaybe<Scalars['String']['input']>;
  auth_pin: Scalars['String']['input'];
  badge_code?: InputMaybe<Scalars['String']['input']>;
  custom_user?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  send_order_email_to_parent?: InputMaybe<Scalars['String']['input']>;
  send_sales_order_email?: InputMaybe<Scalars['String']['input']>;
  users_password_manager?: InputMaybe<EmployeeEncryptionKeyInput>;
};

export type EmployeeAccuralResponse = {
  __typename?: 'EmployeeAccuralResponse';
  accruals?: Maybe<Array<Maybe<AccuralResult>>>;
  current_accrual?: Maybe<CurrentAccuralResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EmployeeAirTicketInput = {
  air_ticket_class: Scalars['String']['input'];
  air_tickets_frequency: Scalars['String']['input'];
  destination_city: Scalars['String']['input'];
  destination_country: Scalars['ID']['input'];
  no_of_air_tickets: Scalars['Int']['input'];
  orignal_city: Scalars['String']['input'];
  orignal_country: Scalars['ID']['input'];
};

export type EmployeeAllowances = {
  allowance: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type EmployeeBasicInfo = {
  __typename?: 'EmployeeBasicInfo';
  department?: Maybe<Array<Maybe<Department>>>;
  designation?: Maybe<Designation>;
  employee_id?: Maybe<Scalars['ID']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
};

export type EmployeeComplianceResult = {
  __typename?: 'EmployeeComplianceResult';
  assignments?: Maybe<Array<Maybe<ComplianceAssignment>>>;
  at_failure_threshold?: Maybe<Scalars['Boolean']['output']>;
  department?: Maybe<Array<Maybe<Department>>>;
  designation?: Maybe<Designation>;
  employee_id?: Maybe<Scalars['ID']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  last_activity_at?: Maybe<Scalars['Date']['output']>;
  last_email_sent_at?: Maybe<Scalars['Date']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_reminder_sent_at?: Maybe<Scalars['Date']['output']>;
  milestone?: Maybe<ComplianceMilestone>;
  orientation?: Maybe<ComplianceOrientation>;
  outstanding_count?: Maybe<Scalars['Int']['output']>;
  overdue_count?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeContributions = {
  amount: Scalars['Float']['input'];
  contribution: Scalars['ID']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type EmployeeDashboardView = {
  __typename?: 'EmployeeDashboardView';
  Business?: Maybe<Business>;
  card_size?: Maybe<Scalars['String']['output']>;
  card_width?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  deleted_by?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  is_bold_emp_name?: Maybe<Scalars['Boolean']['output']>;
  is_bold_status_time?: Maybe<Scalars['Boolean']['output']>;
  is_default_screen?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_system_default_screen?: Maybe<Scalars['Boolean']['output']>;
  name_format?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['JSON']['output']>;
  profile_picture_size?: Maybe<Scalars['String']['output']>;
  status_display?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
  view_type: EmployeeDashboardViewEnum;
  views: Array<EmployeeDashboardViewSection>;
};

export type EmployeeDashboardViewConfig = {
  __typename?: 'EmployeeDashboardViewConfig';
  array_list?: Maybe<Scalars['String']['output']>;
  classes?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['JSON']['output']>;
};

export type EmployeeDashboardViewConfigInput = {
  array_list?: InputMaybe<Scalars['String']['input']>;
  classes?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
};

export enum EmployeeDashboardViewEnum {
  Custom = 'custom',
  Default = 'default'
}

export type EmployeeDashboardViewSection = {
  __typename?: 'EmployeeDashboardViewSection';
  animation: AnimationTypeEnum;
  animation_speed?: Maybe<Scalars['Float']['output']>;
  arrays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  columns: Scalars['Int']['output'];
  configs?: Maybe<Array<Maybe<EmployeeDashboardViewConfig>>>;
  options?: Maybe<Scalars['JSON']['output']>;
  section_title: EmployeeDashboardViewSectionEnum;
  sort_order?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  upcoming_clock_reminder_time?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum EmployeeDashboardViewSectionEnum {
  Active = 'active',
  BreakAndShortBreak = 'break_and_short_break',
  Default = 'default',
  LeaveAndAbsentees = 'leave_and_absentees',
  PublicHolidaysAndWeekend = 'public_holidays_and_weekend',
  UpcomingClockIn = 'upcoming_clock_in',
  UpcomingClockOut = 'upcoming_clock_out'
}

export type EmployeeDashboardViewSectionInput = {
  animation: AnimationTypeEnum;
  animation_speed?: InputMaybe<Scalars['Float']['input']>;
  arrays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columns: Scalars['Int']['input'];
  configs?: InputMaybe<Array<InputMaybe<EmployeeDashboardViewConfigInput>>>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  section_title: EmployeeDashboardViewSectionEnum;
  sort_order?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  upcoming_clock_reminder_time?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type EmployeeDeductions = {
  amount: Scalars['Float']['input'];
  deduction: Scalars['ID']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type EmployeeDocument = {
  __typename?: 'EmployeeDocument';
  document_description?: Maybe<Scalars['String']['output']>;
  document_file_path?: Maybe<Scalars['String']['output']>;
};

export type EmployeeDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  document_description?: InputMaybe<Scalars['String']['input']>;
  document_file_path?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeDocumentsInput = {
  Role?: InputMaybe<Scalars['ID']['input']>;
  assinged_to?: InputMaybe<Scalars['ID']['input']>;
  documents_description?: InputMaybe<Scalars['String']['input']>;
  documents_expiry_date?: InputMaybe<Scalars['DateTime']['input']>;
  documents_name?: InputMaybe<Scalars['String']['input']>;
  documents_type: Scalars['String']['input'];
  google_drive_id?: InputMaybe<Scalars['String']['input']>;
  is_documents_hide?: InputMaybe<Scalars['Boolean']['input']>;
  is_email_notify?: InputMaybe<Scalars['Boolean']['input']>;
  upload_documents: Scalars['Upload']['input'];
};

export type EmployeeEmployeeTimeLineInput = {
  account_status?: InputMaybe<Scalars['String']['input']>;
  action_type: ActionTypeEnum;
  adjustment_start_from?: InputMaybe<Scalars['DateTime']['input']>;
  attendance_policy: Scalars['ID']['input'];
  basic_salary?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Array<Scalars['ID']['input']>>;
  employee_type: Scalars['String']['input'];
  is_email_notify?: InputMaybe<Scalars['Boolean']['input']>;
  is_excluding_pay_roll: Scalars['Boolean']['input'];
  is_use_new_salary?: InputMaybe<Scalars['Boolean']['input']>;
  line_manager?: InputMaybe<Scalars['ID']['input']>;
  new_salary_effect_from: Scalars['DateTime']['input'];
  over_time_rate?: InputMaybe<Scalars['Float']['input']>;
  pay_schedule: Scalars['ID']['input'];
  pay_type?: InputMaybe<Scalars['String']['input']>;
  public_day_hourly_salary?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Array<Scalars['ID']['input']>>;
  roles?: InputMaybe<Array<Scalars['ID']['input']>>;
  salary_type: Scalars['String']['input'];
  shift?: InputMaybe<Scalars['ID']['input']>;
  storeAccess?: InputMaybe<Array<InputMaybe<EmployeeStoreAccessInput>>>;
  total_week_hours?: InputMaybe<Scalars['Int']['input']>;
  weekend_day_salary?: InputMaybe<Scalars['String']['input']>;
  weekly_hourly_salary?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeGarnishment = {
  __typename?: 'EmployeeGarnishment';
  _id?: Maybe<Scalars['ID']['output']>;
  assignTo?: Maybe<User>;
  business?: Maybe<Business>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  document?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  fix_amount?: Maybe<Scalars['Float']['output']>;
  garnishment?: Maybe<Scalars['String']['output']>;
  garnishment_account?: Maybe<Scalars['String']['output']>;
  garnishment_creator?: Maybe<Scalars['String']['output']>;
  garnishment_type?: Maybe<Scalars['String']['output']>;
  google_drive_id?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type EmployeeInfoInput = {
  Country: Scalars['ID']['input'];
  address_1: Scalars['String']['input'];
  address_2?: InputMaybe<Scalars['String']['input']>;
  birth_date: Scalars['DateTime']['input'];
  city: Scalars['ID']['input'];
  default_image?: InputMaybe<Scalars['String']['input']>;
  employee_id?: InputMaybe<Scalars['String']['input']>;
  extra_no?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  home_no?: InputMaybe<Scalars['String']['input']>;
  is_phone_no_verified?: InputMaybe<Scalars['Boolean']['input']>;
  last_name: Scalars['String']['input'];
  license_no?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  marital_status?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  mobile_no_to_send_sms?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  passport_number?: InputMaybe<Scalars['String']['input']>;
  personal_email?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  preffered_name?: InputMaybe<Scalars['String']['input']>;
  ssn_no?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['ID']['input'];
  support_name?: InputMaybe<Scalars['String']['input']>;
  vehicle_no?: InputMaybe<Scalars['String']['input']>;
  vehicle_type?: InputMaybe<Scalars['String']['input']>;
  work_no?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

export type EmployeeList = {
  __typename?: 'EmployeeList';
  employeeList?: Maybe<Array<Maybe<User>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type EmployeeListAttendance = {
  __typename?: 'EmployeeListAttendance';
  BreakExceedTime?: Maybe<Scalars['Int']['output']>;
  activeTime?: Maybe<Scalars['Int']['output']>;
  breakTime?: Maybe<Scalars['Int']['output']>;
  clockHistoryId?: Maybe<Scalars['String']['output']>;
  clock_in_time?: Maybe<Scalars['DateTime']['output']>;
  clockedInStatus?: Maybe<Scalars['String']['output']>;
  isClockedOut?: Maybe<Scalars['Boolean']['output']>;
  schedule_end_time?: Maybe<Scalars['DateTime']['output']>;
  schedule_start_time?: Maybe<Scalars['DateTime']['output']>;
  short_break_current_time_exceed?: Maybe<Scalars['Int']['output']>;
  short_break_duration?: Maybe<Scalars['Int']['output']>;
  short_break_exceeded_minutes?: Maybe<Scalars['Int']['output']>;
  short_break_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type EmployeeListWithAssets = {
  __typename?: 'EmployeeListWithAssets';
  assetCount?: Maybe<Scalars['Int']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  joining_date?: Maybe<Scalars['String']['output']>;
  profile_pictures?: Maybe<Array<Maybe<Image>>>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type EmployeeMedicalInsuranceInput = {
  expiry_date_of_policy?: InputMaybe<Scalars['DateTime']['input']>;
  insurance_card: Scalars['String']['input'];
  insurance_class: Scalars['String']['input'];
  total_policy_amount_monthly?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeSalaryTaxDetails = {
  EmployeeGarnishment?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  additional_tax_override?: InputMaybe<Scalars['String']['input']>;
  additional_withholding_amount?: InputMaybe<Scalars['String']['input']>;
  adp?: InputMaybe<Scalars['String']['input']>;
  allowances?: InputMaybe<Array<InputMaybe<EmployeeAllowances>>>;
  basic_salary?: InputMaybe<Scalars['Float']['input']>;
  contributions?: InputMaybe<Array<InputMaybe<EmployeeContributions>>>;
  deductions?: InputMaybe<Array<InputMaybe<EmployeeDeductions>>>;
  employee_group: Scalars['ID']['input'];
  employee_home_address?: InputMaybe<Scalars['String']['input']>;
  employee_work_address?: InputMaybe<Scalars['String']['input']>;
  is_customzied_overtime?: InputMaybe<Scalars['Boolean']['input']>;
  is_excluding_pay_roll?: InputMaybe<Scalars['Boolean']['input']>;
  is_exempt_federal_tax?: InputMaybe<Scalars['Boolean']['input']>;
  is_exempt_from_withholding?: InputMaybe<Scalars['Boolean']['input']>;
  is_exempt_income_tax?: InputMaybe<Scalars['Boolean']['input']>;
  over_time_rate?: InputMaybe<Scalars['Float']['input']>;
  pay_schedule: Scalars['ID']['input'];
  pay_type?: InputMaybe<Scalars['String']['input']>;
  public_day_hourly_salary?: InputMaybe<Scalars['Float']['input']>;
  salary_template?: InputMaybe<Scalars['String']['input']>;
  salary_type: Scalars['String']['input'];
  sales_tax_allowances?: InputMaybe<Scalars['String']['input']>;
  starting_date?: InputMaybe<Scalars['DateTime']['input']>;
  tax_override?: InputMaybe<Scalars['String']['input']>;
  tax_override_amount?: InputMaybe<Scalars['String']['input']>;
  total_allowances?: InputMaybe<Scalars['String']['input']>;
  total_week_hours?: InputMaybe<Scalars['Int']['input']>;
  w4_form?: InputMaybe<Scalars['String']['input']>;
  weekend_day_salary?: InputMaybe<Scalars['Float']['input']>;
  weekly_hourly_salary?: InputMaybe<Scalars['Float']['input']>;
  withholding_status?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeSalaryTransferMethodInput = {
  account_number?: InputMaybe<Scalars['String']['input']>;
  account_title?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  branch_code?: InputMaybe<Scalars['String']['input']>;
  local_code?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  routing_number?: InputMaybe<Scalars['String']['input']>;
  salary_payment_method?: InputMaybe<Scalars['String']['input']>;
  swift_code?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeStoreAccessInput = {
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  cashRegister?: InputMaybe<Array<Scalars['ID']['input']>>;
  roles?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EmployeeTimeOffInput = {
  time_off?: InputMaybe<Array<InputMaybe<TimeOffEmployeeInput>>>;
};

export type EmployeeTimeRuleAttendanceInput = {
  is_attendance_rule_applied?: InputMaybe<Scalars['Boolean']['input']>;
  is_breaktime_exception?: InputMaybe<Scalars['Boolean']['input']>;
  is_earlyout?: InputMaybe<Scalars['Boolean']['input']>;
  is_enable_checkin_checkout_access?: InputMaybe<Scalars['Boolean']['input']>;
  is_hours_in_a_day?: InputMaybe<Scalars['Boolean']['input']>;
  is_late_arrival?: InputMaybe<Scalars['Boolean']['input']>;
  is_leave_restriction?: InputMaybe<Scalars['Boolean']['input']>;
  is_missing_attendance?: InputMaybe<Scalars['Boolean']['input']>;
  is_over_time_policy?: InputMaybe<Scalars['Boolean']['input']>;
  is_self_service_access?: InputMaybe<Scalars['Boolean']['input']>;
  is_send_email_notification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployeeTrainingProfile = {
  __typename?: 'EmployeeTrainingProfile';
  employee?: Maybe<EmployeeBasicInfo>;
  external_trainings?: Maybe<Array<Maybe<ExternalVendorTrainingProfileItem>>>;
  milestone?: Maybe<ComplianceMilestone>;
  orientation?: Maybe<ComplianceOrientation>;
  trainings?: Maybe<Array<Maybe<TrainingProfileItem>>>;
};

export type EmployeeTrainingProfileList = {
  __typename?: 'EmployeeTrainingProfileList';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<EmployeeTrainingProfileResult>>>;
};

export type EmployeeTrainingProfileListInput = {
  User?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  completion_date?: InputMaybe<Scalars['String']['input']>;
  compliance_status?: InputMaybe<Scalars['String']['input']>;
  counter_reset_active?: InputMaybe<Scalars['Boolean']['input']>;
  cycle_id?: InputMaybe<Scalars['ID']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matrix_section?: InputMaybe<MatrixSection>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TrainingAssignStatus>;
  urgency_status?: InputMaybe<Scalars['String']['input']>;
  was_counter_reset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployeeTrainingProfileResult = {
  __typename?: 'EmployeeTrainingProfileResult';
  Business?: Maybe<Scalars['ID']['output']>;
  User?: Maybe<User>;
  _id: Scalars['ID']['output'];
  completion_date?: Maybe<Scalars['String']['output']>;
  compliance_status?: Maybe<Scalars['String']['output']>;
  counter_reset_active?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  cycle_id?: Maybe<CycleInfo>;
  escalation_triggered?: Maybe<Scalars['Boolean']['output']>;
  failure_counter?: Maybe<Scalars['Int']['output']>;
  is_invalidated?: Maybe<Scalars['Boolean']['output']>;
  is_reattempt?: Maybe<Scalars['Boolean']['output']>;
  matrix_section?: Maybe<Scalars['String']['output']>;
  quiz_score_percentage?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  training_end_time?: Maybe<Scalars['Date']['output']>;
  training_start_time?: Maybe<Scalars['Date']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  urgency_status?: Maybe<Scalars['String']['output']>;
  was_counter_reset?: Maybe<Scalars['Boolean']['output']>;
};

export type EmployeeTrainingStats = {
  __typename?: 'EmployeeTrainingStats';
  completed?: Maybe<Scalars['Int']['output']>;
  outstanding?: Maybe<Scalars['Int']['output']>;
  overdue?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type EmployeesAssetInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeesByDepWithoutLimits = {
  department?: InputMaybe<Array<Scalars['ID']['input']>>;
  designation?: InputMaybe<Array<Scalars['ID']['input']>>;
  employee_type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pay_schedule?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EmployeesDepartments = {
  __typename?: 'EmployeesDepartments';
  department?: Maybe<Department>;
  employees?: Maybe<Scalars['Int']['output']>;
};

export type EmployeesDepartmentsList = {
  __typename?: 'EmployeesDepartmentsList';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<EmployeesDepartments>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type EmployeesSitesInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SearchUserTypeenum>;
};

export type EmployeesWithClockedHistoryInput = {
  department?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<AttendanceWithStatus>;
};

export type EmployessByDepartment = {
  department?: InputMaybe<Array<Scalars['ID']['input']>>;
  designation?: InputMaybe<Array<Scalars['ID']['input']>>;
  employee_type?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type EmploymentContractInput = {
  air_ticket?: InputMaybe<EmployeeAirTicketInput>;
  department?: InputMaybe<Array<Scalars['ID']['input']>>;
  designation?: InputMaybe<Scalars['ID']['input']>;
  eligibility_date?: InputMaybe<Scalars['DateTime']['input']>;
  employee_type: Scalars['String']['input'];
  hire_date: Scalars['DateTime']['input'];
  is_air_ticket?: InputMaybe<Scalars['Boolean']['input']>;
  is_gratuity?: InputMaybe<Scalars['Boolean']['input']>;
  is_medical_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  is_payroll_run_on_business?: InputMaybe<Scalars['Boolean']['input']>;
  is_store_wise: Scalars['Boolean']['input'];
  joining_date: Scalars['DateTime']['input'];
  leave_policy_id?: InputMaybe<Scalars['ID']['input']>;
  line_manager?: InputMaybe<Scalars['ID']['input']>;
  medical_insurance?: InputMaybe<EmployeeMedicalInsuranceInput>;
  probation_period?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Array<Scalars['ID']['input']>>;
  roles?: InputMaybe<Array<Scalars['ID']['input']>>;
  shift?: InputMaybe<Scalars['ID']['input']>;
  storeAccess?: InputMaybe<Array<InputMaybe<EmployeeStoreAccessInput>>>;
};

export type EmpoyeesAssetAssignedResult = {
  __typename?: 'EmpoyeesAssetAssignedResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<User>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type EmpoyeesAssetAssignedResults = {
  __typename?: 'EmpoyeesAssetAssignedResults';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<User>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type EmpoyeesPermissions = {
  __typename?: 'EmpoyeesPermissions';
  employees?: Maybe<Array<Maybe<User>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  permissions?: Maybe<Array<Maybe<Permissions>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type EmpoyeesSitesAssetAssignedResult = {
  __typename?: 'EmpoyeesSitesAssetAssignedResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BusinessLocation>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type Encryption = {
  __typename?: 'Encryption';
  encrypted_private_key?: Maybe<Scalars['String']['output']>;
  iv?: Maybe<Scalars['String']['output']>;
  salt?: Maybe<Scalars['String']['output']>;
};

export type EncryptionData = {
  encryption?: InputMaybe<EncryptionInput>;
  from_user?: InputMaybe<Scalars['ID']['input']>;
};

export type EncryptionInput = {
  encrypted_private_key?: InputMaybe<Scalars['String']['input']>;
  iv?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
};

export type EscalationUserInput = {
  escalationEmployee?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  escalationReminder?: InputMaybe<Scalars['String']['input']>;
  escalationRole?: InputMaybe<Scalars['ID']['input']>;
};

export type EscalationUserType = {
  __typename?: 'EscalationUserType';
  escalationEmployee?: Maybe<Array<Maybe<User>>>;
  escalationReminder?: Maybe<Scalars['String']['output']>;
  escalationRole?: Maybe<Role>;
};

export type Expense = {
  __typename?: 'Expense';
  _id?: Maybe<Scalars['ID']['output']>;
  approval_description?: Maybe<Scalars['String']['output']>;
  approval_status?: Maybe<Scalars['String']['output']>;
  behalf_of?: Maybe<Array<Maybe<User>>>;
  business?: Maybe<Business>;
  business_manager?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<User>;
  expense_date?: Maybe<Scalars['DateTime']['output']>;
  expense_total_amount?: Maybe<Scalars['Float']['output']>;
  expense_type?: Maybe<Scalars['String']['output']>;
  google_drive_id?: Maybe<Scalars['String']['output']>;
  is_business_expense?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_received?: Maybe<Scalars['Boolean']['output']>;
  logs?: Maybe<Array<Maybe<LogsExpense>>>;
  status?: Maybe<Scalars['String']['output']>;
  upload_document_info?: Maybe<UpdloadDocumentInf>;
  upload_files_workflow?: Maybe<Array<Maybe<UpoadFileWorkFlow>>>;
  work_flow?: Maybe<Array<Maybe<WorkFlow>>>;
};

export type ExpenseInvFilter = {
  expenseInvoice?: InputMaybe<Scalars['ID']['input']>;
};

export type ExpenseInvoiceCategoryInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ExpenseInvoiceInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum ExpenseType {
  Asset = 'asset',
  General = 'general',
  Transport = 'transport'
}

export type ExternalVendorTraining = {
  __typename?: 'ExternalVendorTraining';
  Business?: Maybe<Business>;
  User?: Maybe<User>;
  _id: Scalars['ID']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  completion_date?: Maybe<Scalars['Date']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<User>;
  provider?: Maybe<Scalars['String']['output']>;
  training_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  updated_by?: Maybe<User>;
};

export type ExternalVendorTrainingList = {
  __typename?: 'ExternalVendorTrainingList';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<ExternalVendorTraining>>>;
};

export type ExternalVendorTrainingListInput = {
  User?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ExternalVendorTrainingProfileItem = {
  __typename?: 'ExternalVendorTrainingProfileItem';
  _id?: Maybe<Scalars['ID']['output']>;
  completion_date?: Maybe<Scalars['Date']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  training_name?: Maybe<Scalars['String']['output']>;
};

export type Feedback = {
  __typename?: 'Feedback';
  Department?: Maybe<Array<Maybe<Department>>>;
  _id: Scalars['ID']['output'];
  attached_files?: Maybe<Array<Maybe<SupportingFileItem>>>;
  conversation?: Maybe<Array<Maybe<ConversationMessage>>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  feedback_type?: Maybe<MasterDataValue>;
  is_anonymous?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  reviewed_by?: Maybe<User>;
  status?: Maybe<FeedbackStatus>;
  submitted_by?: Maybe<User>;
  ticket_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FeedbackResult = {
  __typename?: 'FeedbackResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Feedback>>>;
};

export enum FeedbackStatus {
  Pending = 'pending',
  Resolved = 'resolved',
  Reviewed = 'reviewed'
}

export enum FeedbackType {
  ConcernOrComplaint = 'concern_or_complaint',
  GeneralFeedback = 'general_feedback',
  Other = 'other',
  Recognition = 'recognition',
  Suggestion = 'suggestion',
  WorkplaceSafety = 'workplace_safety'
}

export type File = {
  __typename?: 'File';
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
};

export type Filter = {
  __typename?: 'Filter';
  _id: Scalars['ID']['output'];
  business?: Maybe<Business>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<User>;
  filter: Scalars['String']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export enum FilterEnum {
  Day = 'day',
  Month = 'month',
  Week = 'week'
}

export enum FilterTypeEnum {
  EmployeeList = 'employee_list',
  Scheduler = 'scheduler',
  Timesheet = 'timesheet'
}

export type FinalSettlement = {
  __typename?: 'FinalSettlement';
  _id?: Maybe<Scalars['ID']['output']>;
  business?: Maybe<Business>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<User>;
  expense_amount?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  last_working_date?: Maybe<Scalars['DateTime']['output']>;
  leave_amount?: Maybe<Scalars['Float']['output']>;
  loan_amount?: Maybe<Scalars['Float']['output']>;
  separation_type?: Maybe<Scalars['String']['output']>;
  settlement_completed?: Maybe<Scalars['Boolean']['output']>;
};

export type FranchiseRequest = {
  __typename?: 'FranchiseRequest';
  Franchise?: Maybe<BusinessLocation>;
  FranchiseeBusiness?: Maybe<Business>;
  FranchiserBusiness?: Maybe<Business>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_by?: Maybe<User>;
  franchise_fee?: Maybe<Scalars['Float']['output']>;
  payment_pending?: Maybe<Scalars['Boolean']['output']>;
};

export type GetAllActiveEmployeesForShareDocumentInput = {
  documentId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetFeedbacksInput = {
  feedback_type?: InputMaybe<FeedbackType>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FeedbackStatus>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GiftCard = {
  __typename?: 'GiftCard';
  BusinessLocation: BusinessLocation;
  Customer: Customer;
  _id: Scalars['ID']['output'];
  amount?: Maybe<Scalars['Float']['output']>;
  card_no: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  gift_card_keeping_unit: Scalars['String']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_email_send?: Maybe<Scalars['Boolean']['output']>;
  is_used?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  qr_code?: Maybe<Scalars['String']['output']>;
  send_gift_card: Scalars['DateTime']['output'];
  subject: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type GiftCardCategory = {
  __typename?: 'GiftCardCategory';
  _id: Scalars['ID']['output'];
  business?: Maybe<Scalars['String']['output']>;
  category_name?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GradeInput = {
  grade?: InputMaybe<Scalars['String']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
};

export type GradeType = {
  __typename?: 'GradeType';
  grade?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

export type Gratuity = {
  __typename?: 'Gratuity';
  _id?: Maybe<Scalars['ID']['output']>;
  business?: Maybe<Business>;
  business_location?: Maybe<BusinessLocation>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  month_days?: Maybe<Scalars['String']['output']>;
  total_working_days?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GratuityInput = {
  business: Scalars['ID']['input'];
  business_location?: InputMaybe<Scalars['ID']['input']>;
  month_days?: InputMaybe<Scalars['String']['input']>;
  total_working_days?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GratuityType>;
};

export enum GratuityType {
  Automatic = 'automatic',
  Manuall = 'manuall'
}

export type HrComplaint = {
  __typename?: 'HRComplaint';
  Business?: Maybe<Business>;
  Department?: Maybe<Array<Maybe<Department>>>;
  User?: Maybe<User>;
  _id: Scalars['ID']['output'];
  approximate_time?: Maybe<Scalars['String']['output']>;
  assinged_status?: Maybe<Scalars['String']['output']>;
  audit_log?: Maybe<Array<Maybe<AuditEntry>>>;
  case_id?: Maybe<Scalars['String']['output']>;
  case_witnesses?: Maybe<Array<Maybe<CaseWitness>>>;
  closed_date?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  days_open?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hr_additional_info?: Maybe<Scalars['String']['output']>;
  incident_date?: Maybe<Scalars['DateTime']['output']>;
  internal_notes?: Maybe<Array<Maybe<HrInternalNote>>>;
  investigator?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_exact_date_unknown?: Maybe<Scalars['Boolean']['output']>;
  is_hr_review_confirmed?: Maybe<Scalars['Boolean']['output']>;
  is_hr_should_know_anything?: Maybe<Scalars['Boolean']['output']>;
  is_reported_previously?: Maybe<Scalars['Boolean']['output']>;
  is_supporting_documents?: Maybe<Scalars['Boolean']['output']>;
  is_truthful_confirmed?: Maybe<Scalars['Boolean']['output']>;
  other_concern_description?: Maybe<Scalars['String']['output']>;
  overdue_date?: Maybe<Scalars['DateTime']['output']>;
  persons_involved?: Maybe<Array<Maybe<PersonInvolved>>>;
  persons_involved_count?: Maybe<Scalars['Int']['output']>;
  preferred_contact_method?: Maybe<PreferredContactMethod>;
  previous_description?: Maybe<Scalars['String']['output']>;
  reminder?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<CaseResolution>;
  respondent_notified?: Maybe<Scalars['Boolean']['output']>;
  respondent_notified_at?: Maybe<Scalars['DateTime']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  situation_ongoing?: Maybe<WitnessesEvent>;
  status?: Maybe<Scalars['String']['output']>;
  submitted_by?: Maybe<User>;
  supporting_files?: Maybe<Array<Maybe<SupportingFileItem>>>;
  supporting_files_description?: Maybe<Scalars['String']['output']>;
  type_of_concern?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  urgency?: Maybe<ComplaintUrgency>;
  where_did_it_occur?: Maybe<Scalars['String']['output']>;
  witnesses?: Maybe<Array<Maybe<WitnessComplaint>>>;
  witnesses_events?: Maybe<WitnessesEvent>;
  work_flow_user?: Maybe<User>;
};

export type HrComplaintDashboard = {
  __typename?: 'HRComplaintDashboard';
  cases_by_status?: Maybe<Array<Maybe<StatusCount>>>;
  cases_needing_attention?: Maybe<Array<Maybe<HrComplaint>>>;
  critical_high_cases?: Maybe<Scalars['Int']['output']>;
  open_cases?: Maybe<Scalars['Int']['output']>;
  overdue_cases?: Maybe<Scalars['Int']['output']>;
  pending_witness_forms?: Maybe<Scalars['Int']['output']>;
  resolved_this_month?: Maybe<Scalars['Int']['output']>;
  workload_by_investigator?: Maybe<Array<Maybe<InvestigatorWorkload>>>;
};

export type HrComplaintPaginatedResult = {
  __typename?: 'HRComplaintPaginatedResult';
  config?: Maybe<UpdatedDataTableConfig>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<HrComplaint>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type HrInternalNote = {
  __typename?: 'HRInternalNote';
  _id?: Maybe<Scalars['ID']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
};

export type HbsTemplate = {
  __typename?: 'HbsTemplate';
  ActionFeature?: Maybe<ActionFeature>;
  _id?: Maybe<Scalars['ID']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  variables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HbsTemplateCreateInput = {
  ActionFeature: Scalars['ID']['input'];
  body: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HbsTemplateUpdateInput = {
  body: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HierarchicalDetail = {
  __typename?: 'HierarchicalDetail';
  Country?: Maybe<Country>;
  States?: Maybe<Array<Maybe<StateHierarchicy>>>;
};

export type HierarchyItem = {
  __typename?: 'HierarchyItem';
  _id: Scalars['ID']['output'];
  app_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ImportEmployeeInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  is_update_password: Scalars['Boolean']['input'];
  last_name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type ImportEmployeeType = {
  __typename?: 'ImportEmployeeType';
  InvalidDataUsers?: Maybe<Array<Maybe<User>>>;
  alreadyExistUsers?: Maybe<Array<Maybe<User>>>;
  newlyAddedUsers?: Maybe<Array<Maybe<User>>>;
};

export type ImportSchedule = {
  __typename?: 'ImportSchedule';
  conflicted_schedule?: Maybe<Schedule>;
  error?: Maybe<Scalars['Boolean']['output']>;
  insert_schedule?: Maybe<Array<Maybe<Schedule>>>;
  invalid_schedule?: Maybe<Array<Maybe<ClockedHistory>>>;
};

export type ImportTimesheetType = {
  __typename?: 'ImportTimesheetType';
  already_exists_timesheet?: Maybe<Array<Maybe<ClockedHistory>>>;
  insert_timesheet?: Maybe<Array<Maybe<ClockedHistory>>>;
  invalid_timesheet?: Maybe<Array<Maybe<ClockedHistory>>>;
  updated_timesheet?: Maybe<Array<Maybe<ClockedHistory>>>;
};

export type InputAdjustment = {
  adjustment_amount: Scalars['Float']['input'];
  adjustment_comment: Scalars['String']['input'];
  adjustment_date: Scalars['DateTime']['input'];
  adjustment_type?: InputMaybe<Scalars['String']['input']>;
  bank_account_number?: InputMaybe<Scalars['String']['input']>;
  bank_amount?: InputMaybe<Scalars['String']['input']>;
  check_number?: InputMaybe<Scalars['String']['input']>;
  employee_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_credit: Scalars['Boolean']['input'];
  transaction_reference?: InputMaybe<Scalars['String']['input']>;
};

export type InputAllowances = {
  allowance_type: AllowanceType;
  amount: Scalars['Float']['input'];
  business_location?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_fixed: Scalars['Boolean']['input'];
  pay_slip_name: Scalars['String']['input'];
};

export type InputAppraisalType = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumActive>;
  target_type: TargetEnum;
};

export type InputAttachment = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  subscription: Scalars['ID']['input'];
};

export type InputAttendance = {
  attendanceStatus?: InputMaybe<AttendanceWithStatus>;
  attendance_date: Scalars['DateTime']['input'];
  attendance_log_detail?: InputMaybe<Array<AttendanceLogDetailInput>>;
  breaks?: InputMaybe<Array<Breaks>>;
  clock_in_time?: InputMaybe<Scalars['DateTime']['input']>;
  clock_out_time?: InputMaybe<Scalars['DateTime']['input']>;
  clockedInStatus?: InputMaybe<AttendanceWithStatus>;
  clockedOutStatus?: InputMaybe<AttendanceWithStatus>;
  employee: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isAbsent?: InputMaybe<Scalars['Boolean']['input']>;
  is_between_leave?: InputMaybe<Scalars['Boolean']['input']>;
  is_break_adjustment: Scalars['Boolean']['input'];
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  marked_at?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  short_break?: InputMaybe<Scalars['Boolean']['input']>;
  write_up_reason?: InputMaybe<WriteUpReason>;
  writup_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputAttendanceList = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type InputAttendanceRequest = {
  attendance_date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  remarks: Scalars['String']['input'];
  time_in: Scalars['String']['input'];
  time_out: Scalars['String']['input'];
};

export type InputCreateAttachment = {
  file_upload?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  isFile?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  subscription: Scalars['ID']['input'];
};

export type InputCreateAttendance = {
  attendance_date: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  marked_at?: InputMaybe<Scalars['String']['input']>;
  reason_type: EnumReasonType;
  time_in?: InputMaybe<Scalars['String']['input']>;
  time_out?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputCreateExpenseRequest = {
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['Upload']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  expense_date: Scalars['DateTime']['input'];
  expense_total_amount: Scalars['Float']['input'];
  expense_type: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputCreateLogActivity = {
  activity_date: Scalars['DateTime']['input'];
  attachment_file?: InputMaybe<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subscription: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: TypeEnum;
};

export type InputCreateSetupAlert = {
  asset_email_details?: InputMaybe<SetupEmailInput>;
  is_asset_alert?: InputMaybe<Scalars['Boolean']['input']>;
  is_asset_email?: InputMaybe<Scalars['Boolean']['input']>;
  is_lease_email?: InputMaybe<Scalars['Boolean']['input']>;
  is_lease_expiration_alert?: InputMaybe<Scalars['Boolean']['input']>;
  is_maintenance_alert?: InputMaybe<Scalars['Boolean']['input']>;
  is_maintenance_email?: InputMaybe<Scalars['Boolean']['input']>;
  is_warranty_email?: InputMaybe<Scalars['Boolean']['input']>;
  is_warranty_expiration_alert?: InputMaybe<Scalars['Boolean']['input']>;
  lease_email_details?: InputMaybe<SetupEmailInput>;
  lease_lead_time?: InputMaybe<Scalars['Int']['input']>;
  maintenance_email_details?: InputMaybe<SetupEmailInput>;
  maintenance_lead_time?: InputMaybe<Scalars['Int']['input']>;
  maintenance_overdue_time?: InputMaybe<Scalars['Int']['input']>;
  warranty_email_details?: InputMaybe<SetupEmailInput>;
  warranty_lead_time?: InputMaybe<Scalars['Int']['input']>;
};

export type InputExpense = {
  business: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['Upload']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  expense_date: Scalars['DateTime']['input'];
  expense_total_amount: Scalars['Float']['input'];
  expense_type: Scalars['String']['input'];
  follow_workflow: Scalars['Boolean']['input'];
  google_drive_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_business_expense: Scalars['Boolean']['input'];
  is_received: Scalars['Boolean']['input'];
  remove_image?: InputMaybe<Scalars['Boolean']['input']>;
  status: ExpenseStatus;
};

export type InputFinalSettlement = {
  business: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  employee: Scalars['ID']['input'];
  expense_amount?: InputMaybe<Scalars['Float']['input']>;
  last_working_date: Scalars['DateTime']['input'];
  leave_amount?: InputMaybe<Scalars['Float']['input']>;
  loan_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type InputLeaveType = {
  accrual_no_of_hours?: InputMaybe<Scalars['Float']['input']>;
  accrual_on_day?: InputMaybe<Scalars['String']['input']>;
  accrual_on_month?: InputMaybe<MonthEnum>;
  accrual_one_time_day?: InputMaybe<Scalars['String']['input']>;
  accrual_one_time_month?: InputMaybe<MonthEnum>;
  accrual_type?: InputMaybe<YearlyMonthlyEnum>;
  assign_to?: InputMaybe<Assign_To>;
  blackOutWindow?: InputMaybe<Array<InputMaybe<BlackOutWindowInput>>>;
  business: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  consecutive_leaves?: InputMaybe<Scalars['String']['input']>;
  count_after_days?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  effective_after?: InputMaybe<Scalars['Float']['input']>;
  effective_after_type?: InputMaybe<EffectiveAfterTypeEnum>;
  fixed_pto_ratio?: InputMaybe<Scalars['Float']['input']>;
  from_date: Scalars['DateTime']['input'];
  half_day_Consideration?: InputMaybe<HalfDayConsideration>;
  half_leave_in_ful_leave?: InputMaybe<Scalars['Boolean']['input']>;
  is_accrual?: InputMaybe<Scalars['Boolean']['input']>;
  is_allow_partial_apply?: InputMaybe<Scalars['Boolean']['input']>;
  is_count_after?: InputMaybe<Scalars['Boolean']['input']>;
  is_pto: Scalars['Boolean']['input'];
  is_pto_against_overtime?: InputMaybe<Scalars['Boolean']['input']>;
  is_pto_against_public_holiday?: InputMaybe<Scalars['Boolean']['input']>;
  is_pto_against_weekend?: InputMaybe<Scalars['Boolean']['input']>;
  is_reset?: InputMaybe<Scalars['Boolean']['input']>;
  is_unit_hours: Scalars['Boolean']['input'];
  leave_duration?: InputMaybe<LeaveDuration>;
  maximum_duration?: InputMaybe<MaximumDurationEnum>;
  minimum_duration?: InputMaybe<Scalars['String']['input']>;
  month_selection?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  partial_apply_minimum?: InputMaybe<PartialApplyMinimumEnum>;
  per_day_hours?: InputMaybe<Scalars['String']['input']>;
  policy_type?: InputMaybe<PolicyTypeEnum>;
  pto_advance_notice_days?: InputMaybe<Scalars['Float']['input']>;
  pto_earning_threshold_hours?: InputMaybe<Scalars['Float']['input']>;
  pto_hours_against_threshold?: InputMaybe<Scalars['Float']['input']>;
  pto_minimum_consumable_hours?: InputMaybe<Scalars['Float']['input']>;
  pto_type?: InputMaybe<Scalars['String']['input']>;
  pto_value_in?: InputMaybe<PtoValueIn>;
  ranges?: InputMaybe<Array<InputMaybe<Range>>>;
  reset_carry_forward?: InputMaybe<CarryForwardEnum>;
  reset_carry_forward_count?: InputMaybe<Scalars['Float']['input']>;
  reset_carry_forward_type?: InputMaybe<CarryForwardTypeEnum>;
  reset_max_limit?: InputMaybe<Scalars['Float']['input']>;
  reset_on_day?: InputMaybe<Scalars['String']['input']>;
  reset_on_month?: InputMaybe<MonthEnum>;
  reset_one_time_day?: InputMaybe<Scalars['String']['input']>;
  reset_one_time_month?: InputMaybe<MonthEnum>;
  reset_type?: InputMaybe<YearlyMonthlyEnum>;
  to_date: Scalars['DateTime']['input'];
  type: LeaveTypesEnum;
  un_paid?: InputMaybe<Scalars['Boolean']['input']>;
  un_paid_days?: InputMaybe<Scalars['String']['input']>;
  working_days?: InputMaybe<Scalars['String']['input']>;
};

export type InputLoan = {
  business: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  employee: Scalars['ID']['input'];
  follow_workflow: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  installment_amount: Scalars['Float']['input'];
  is_fixed: Scalars['Boolean']['input'];
  loan_amount: Scalars['Float']['input'];
  loan_recovery_method: RecoveryMethod;
  loan_taken_date: Scalars['DateTime']['input'];
  loan_type: LoanType;
  no_of_installment?: InputMaybe<Scalars['Float']['input']>;
  payment_received_date?: InputMaybe<Scalars['DateTime']['input']>;
  payment_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  status: LoanPaymentStatus;
};

export type InputLoanRequest = {
  business: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  installment_amount: Scalars['Float']['input'];
  is_fixed: Scalars['Boolean']['input'];
  loan_amount: Scalars['Float']['input'];
  loan_recovery_method: RecoveryMethod;
  loan_taken_date: Scalars['DateTime']['input'];
  loan_type: LoanType;
  no_of_installment?: InputMaybe<Scalars['Float']['input']>;
  payment_received_date?: InputMaybe<Scalars['DateTime']['input']>;
  payment_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputPublicHolidays = {
  Department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Role?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Users?: InputMaybe<Array<Scalars['ID']['input']>>;
  business: Scalars['ID']['input'];
  from_date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  is_recursive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  to_date: Scalars['DateTime']['input'];
};

export type InputScheduleGraph = {
  department?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['ID']['input']>;
  start_date: Scalars['String']['input'];
};

export type InputTransaction = {
  business: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
  loan: Scalars['ID']['input'];
  loan_transaction_amount: Scalars['Float']['input'];
  loan_transaction_date: Scalars['DateTime']['input'];
};

export type InputUpdateAttachment = {
  _id: Scalars['ID']['input'];
  parent: Scalars['ID']['input'];
};

export type InputUpdateAttendance = {
  _id: Scalars['ID']['input'];
  attendance_date: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  marked_at?: InputMaybe<Scalars['String']['input']>;
  reason_type: Scalars['String']['input'];
  time_in?: InputMaybe<Scalars['String']['input']>;
  time_out?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateExpenseApproval = {
  action_performed?: InputMaybe<Scalars['Boolean']['input']>;
  approval_description?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['Upload']['input']>;
  employee_id: Scalars['ID']['input'];
  expense_id: Scalars['ID']['input'];
  status: ExpenseStatus;
};

export type InputUpdateExpenseRequest = {
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['Upload']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  expense_date: Scalars['DateTime']['input'];
  expense_total_amount: Scalars['Float']['input'];
  expense_type: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  remove_image?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUpdateLogActivity = {
  _id: Scalars['ID']['input'];
  activity_date: Scalars['DateTime']['input'];
  attachment_file?: InputMaybe<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subscription: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: TypeEnum;
};

export type InputUpdateSetupAlert = {
  _id: Scalars['ID']['input'];
  asset_email_details?: InputMaybe<SetupEmailInput>;
  is_asset_alert?: InputMaybe<Scalars['Boolean']['input']>;
  is_asset_email?: InputMaybe<Scalars['Boolean']['input']>;
  is_lease_email?: InputMaybe<Scalars['Boolean']['input']>;
  is_lease_expiration_alert?: InputMaybe<Scalars['Boolean']['input']>;
  is_maintenance_alert?: InputMaybe<Scalars['Boolean']['input']>;
  is_maintenance_email?: InputMaybe<Scalars['Boolean']['input']>;
  is_warranty_email?: InputMaybe<Scalars['Boolean']['input']>;
  is_warranty_expiration_alert?: InputMaybe<Scalars['Boolean']['input']>;
  lease_email_details?: InputMaybe<SetupEmailInput>;
  lease_lead_time?: InputMaybe<Scalars['Int']['input']>;
  maintenance_email_details?: InputMaybe<SetupEmailInput>;
  maintenance_lead_time?: InputMaybe<Scalars['Int']['input']>;
  maintenance_overdue_time?: InputMaybe<Scalars['Int']['input']>;
  warranty_email_details?: InputMaybe<SetupEmailInput>;
  warranty_lead_time?: InputMaybe<Scalars['Int']['input']>;
};

export type InputUpdateWriteUpApproval = {
  action_performed?: InputMaybe<Scalars['Boolean']['input']>;
  approval_description?: InputMaybe<Scalars['String']['input']>;
  status: WriteUpStatus;
  write_up_id: Scalars['ID']['input'];
};

export type InputemployeeGarnishmentList = {
  Page?: InputMaybe<Scalars['Int']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type Insurance = {
  __typename?: 'Insurance';
  active?: Maybe<Scalars['Boolean']['output']>;
  asset?: Maybe<Asset>;
  contactPerson?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Scalars['Float']['output']>;
  deductible?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insuranceCo?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  limits?: Maybe<Scalars['Float']['output']>;
  logs?: Maybe<Array<Maybe<InsuranceLogs>>>;
  phone?: Maybe<Scalars['String']['output']>;
  policyNo?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type InsuranceInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  asset?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  coverage?: InputMaybe<Scalars['Float']['input']>;
  deductible?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  insuranceCo?: InputMaybe<Scalars['String']['input']>;
  limits?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  policyNo?: InputMaybe<Scalars['String']['input']>;
  premium?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export enum InterviewFormatEnum {
  InPerson = 'in_person',
  Phone = 'phone',
  Video = 'video',
  Written = 'written'
}

export type InterviewLogPaginatedResult = {
  __typename?: 'InterviewLogPaginatedResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ComplaintInterviewLog>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export enum InterviewTypeEnum {
  Complainant = 'complainant',
  Investigator = 'investigator',
  Respondent = 'respondent',
  Witness = 'witness'
}

export type InvalidRecord = {
  __typename?: 'InvalidRecord';
  DAY?: Maybe<Scalars['String']['output']>;
  employee_id?: Maybe<Scalars['String']['output']>;
  employee_name?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  short_break_count?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type InvestigatorWorkload = {
  __typename?: 'InvestigatorWorkload';
  count?: Maybe<Scalars['Int']['output']>;
  investigator?: Maybe<User>;
};

export type InvoiceData = {
  __typename?: 'InvoiceData';
  assignToAsset?: Maybe<Scalars['Float']['output']>;
  billTo?: Maybe<GetShipToType>;
  company?: Maybe<Scalars['String']['output']>;
  courtesyCredit?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  detail?: Maybe<InvoiceDetail>;
  grandTotal?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceItems?: Maybe<Array<Maybe<InvoiceItemsType>>>;
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  invoice_image?: Maybe<Scalars['String']['output']>;
  invoice_image_name?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['Date']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  shipTo?: Maybe<GetShipToType>;
  shippingMethod?: Maybe<ShippingMethods>;
  subTotal?: Maybe<Scalars['Float']['output']>;
  taxes?: Maybe<Scalars['Float']['output']>;
  toPayOff?: Maybe<Scalars['Float']['output']>;
  totalInvoiceItems?: Maybe<Scalars['Float']['output']>;
  totalPaid?: Maybe<Scalars['Float']['output']>;
  totalProducts?: Maybe<Scalars['Float']['output']>;
  totalQty?: Maybe<Scalars['Int']['output']>;
  totalSerialNumber?: Maybe<Scalars['Float']['output']>;
  totalShippingCharges?: Maybe<Scalars['Float']['output']>;
  totalSku?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendors>;
};

export type InvoiceInput = {
  billTo?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  courtesyCredit?: InputMaybe<Scalars['Float']['input']>;
  grandTotal?: InputMaybe<Scalars['Float']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoiceItems?: InputMaybe<Array<InputMaybe<InvoiceItems>>>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  invoice_image?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderDate?: InputMaybe<Scalars['Date']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  shipTo?: InputMaybe<Scalars['String']['input']>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  subTotal?: InputMaybe<Scalars['Float']['input']>;
  taxes?: InputMaybe<Scalars['Float']['input']>;
  toPayOff?: InputMaybe<Scalars['Float']['input']>;
  totalPaid?: InputMaybe<Scalars['Float']['input']>;
  totalProducts?: InputMaybe<Scalars['Float']['input']>;
  totalQty?: InputMaybe<Scalars['Int']['input']>;
  totalSerialNumber?: InputMaybe<Scalars['Float']['input']>;
  totalShippingCharges?: InputMaybe<Scalars['Float']['input']>;
  totalSku?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vendor: Scalars['ID']['input'];
};

export type InvoiceItemInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  serial_number?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export enum LanguageCode {
  Ar = 'AR',
  En = 'EN',
  Fa = 'FA',
  Fr = 'FR',
  Hi = 'HI',
  Ne = 'NE',
  Nl = 'NL'
}

export type LanguageStatus = {
  __typename?: 'LanguageStatus';
  human_verified?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
};

export type Lease = {
  __typename?: 'Lease';
  asset?: Maybe<Asset>;
  id?: Maybe<Scalars['ID']['output']>;
  leaseBegin: Scalars['String']['output'];
  leaseEnd: Scalars['String']['output'];
  leasingCustomer?: Maybe<LeasingCustomer>;
};

export type LeaseInput = {
  assetId: Scalars['ID']['input'];
  leaseBegin: Scalars['String']['input'];
  leaseEnd: Scalars['String']['input'];
  leasingCustomerId: Scalars['ID']['input'];
};

export type LeaseListingResult = {
  __typename?: 'LeaseListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Lease>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type LeasingCustomer = {
  __typename?: 'LeasingCustomer';
  address?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type LeasingCustomerInput = {
  address: Scalars['String']['input'];
  company: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type LeaveAccural = {
  __typename?: 'LeaveAccural';
  Business?: Maybe<Business>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  accural_status?: Maybe<Scalars['String']['output']>;
  assign_from?: Maybe<Scalars['DateTime']['output']>;
  assign_to?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  from_date?: Maybe<Scalars['DateTime']['output']>;
  is_current?: Maybe<Scalars['Boolean']['output']>;
  leave_Packeg_id?: Maybe<LeavePolicy>;
  logs?: Maybe<Array<Maybe<LeaveAccuralLog>>>;
  next?: Maybe<LeaveAccural>;
  packeg_name?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<LeaveAccural>;
  pto_minutes?: Maybe<PtoMinutesType>;
  time_off?: Maybe<Array<Maybe<AccuralTimeOff>>>;
  to_date?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type LeaveAccuralLedgerInput = {
  accural_id: Scalars['ID']['input'];
  employee_id: Scalars['ID']['input'];
  from_date: Scalars['DateTime']['input'];
  leave_type_id: Scalars['ID']['input'];
  to_date: Scalars['DateTime']['input'];
};

export type LeaveAccuralLedgerResponse = {
  __typename?: 'LeaveAccuralLedgerResponse';
  carry_forword?: Maybe<Scalars['String']['output']>;
  count_in?: Maybe<Scalars['String']['output']>;
  ledger?: Maybe<Array<Maybe<AccuralLedgerEntry>>>;
  remaining_balance?: Maybe<Scalars['String']['output']>;
  total_assigned?: Maybe<Scalars['String']['output']>;
  usage_balance?: Maybe<Scalars['String']['output']>;
};

export type LeaveAccuralLog = {
  __typename?: 'LeaveAccuralLog';
  _id?: Maybe<Scalars['ID']['output']>;
  action_date?: Maybe<Scalars['DateTime']['output']>;
  carry_forword?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  pay_off?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<LeaveType>;
};

export type LeaveBreakdown = {
  __typename?: 'LeaveBreakdown';
  assigned?: Maybe<AssignedLeave>;
  carry_forward?: Maybe<CarryForwardLeave>;
  count_in?: Maybe<Scalars['String']['output']>;
  earned_accrued?: Maybe<EarnedAccrued>;
  leave_assignment?: Maybe<Scalars['String']['output']>;
  policy_type?: Maybe<Scalars['String']['output']>;
  remaining_balance?: Maybe<RemainingBalance>;
  time_off_type?: Maybe<LeaveType>;
  usage_balance?: Maybe<UsageBalance>;
};

export enum LeaveCountTypeEnum {
  Days = 'days',
  Hours = 'hours'
}

export type LeavePackageHistory = {
  __typename?: 'LeavePackageHistory';
  Business?: Maybe<Business>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  new_policy?: Maybe<LeavePolicySnapshot>;
  previous_policy?: Maybe<LeavePolicySnapshot>;
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<User>;
};

export type LeavePolicy = {
  __typename?: 'LeavePolicy';
  _id?: Maybe<Scalars['ID']['output']>;
  accrual_no_of_hours?: Maybe<Scalars['Float']['output']>;
  accrual_on_day?: Maybe<Scalars['String']['output']>;
  accrual_on_month?: Maybe<Scalars['String']['output']>;
  accrual_one_time_day?: Maybe<Scalars['String']['output']>;
  accrual_one_time_month?: Maybe<Scalars['String']['output']>;
  accrual_type?: Maybe<YearlyMonthlyEnum>;
  assign_to?: Maybe<Array<Maybe<User>>>;
  business?: Maybe<Business>;
  businessLocation?: Maybe<BusinessLocation>;
  carry_forward_limit?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  is_accrual?: Maybe<Scalars['Boolean']['output']>;
  is_carry_forward_percentage?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_hourly_employee_sandwich?: Maybe<Scalars['Boolean']['output']>;
  is_manual_deduction?: Maybe<Scalars['Boolean']['output']>;
  is_reset?: Maybe<Scalars['Boolean']['output']>;
  is_salary_employee_sandwich?: Maybe<Scalars['Boolean']['output']>;
  is_sample_data?: Maybe<Scalars['Boolean']['output']>;
  is_short_leave_sandwich?: Maybe<Scalars['Boolean']['output']>;
  is_user_input_value?: Maybe<Scalars['Boolean']['output']>;
  is_week_hour_limit?: Maybe<Scalars['Boolean']['output']>;
  leaves?: Maybe<Array<Maybe<LeavesType>>>;
  manual_deduction_value?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  policy_type?: Maybe<PolicyTypeEnum>;
  reset_accural_date?: Maybe<Scalars['String']['output']>;
  reset_carry_forward?: Maybe<CarryForwardEnum>;
  reset_carry_forward_count?: Maybe<Scalars['Float']['output']>;
  reset_carry_forward_type?: Maybe<CarryForwardTypeEnum>;
  reset_max_limit?: Maybe<Scalars['Float']['output']>;
  reset_on_day?: Maybe<Scalars['String']['output']>;
  reset_on_month?: Maybe<Scalars['String']['output']>;
  reset_one_time_day?: Maybe<Scalars['String']['output']>;
  reset_one_time_month?: Maybe<Scalars['String']['output']>;
  reset_type?: Maybe<YearlyMonthlyEnum>;
  sandwich?: Maybe<Scalars['Boolean']['output']>;
  sandwich_on_public_holiday?: Maybe<Scalars['Boolean']['output']>;
};

export type LeavePolicySnapshot = {
  __typename?: 'LeavePolicySnapshot';
  LeavePolicy?: Maybe<LeavePolicy>;
  pto_minutes?: Maybe<PtoMinutesType>;
  time_off?: Maybe<Array<Maybe<TimeOffType>>>;
};

export type LeaveType = {
  __typename?: 'LeaveType';
  _id?: Maybe<Scalars['ID']['output']>;
  accrual_no_of_hours?: Maybe<Scalars['Float']['output']>;
  accrual_on_day?: Maybe<Scalars['String']['output']>;
  accrual_on_month?: Maybe<Scalars['String']['output']>;
  accrual_one_time_day?: Maybe<Scalars['String']['output']>;
  accrual_one_time_month?: Maybe<Scalars['String']['output']>;
  accrual_type?: Maybe<Scalars['String']['output']>;
  assign_to?: Maybe<Assign_To>;
  blackOutWindow?: Maybe<Array<Maybe<BlackOutWindow>>>;
  business?: Maybe<Business>;
  code?: Maybe<Scalars['String']['output']>;
  consecutive_leaves?: Maybe<Scalars['String']['output']>;
  count_after_days?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  effective_after?: Maybe<Scalars['Float']['output']>;
  effective_after_type?: Maybe<Scalars['String']['output']>;
  fixed_pto_ratio?: Maybe<Scalars['Float']['output']>;
  from_date?: Maybe<Scalars['DateTime']['output']>;
  half_day_Consideration?: Maybe<HalfDayConsideration>;
  half_leave_in_ful_leave?: Maybe<Scalars['Boolean']['output']>;
  is_accrual?: Maybe<Scalars['Boolean']['output']>;
  is_allow_partial_apply?: Maybe<Scalars['Boolean']['output']>;
  is_count_after?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_not_count_as_leave?: Maybe<Scalars['Boolean']['output']>;
  is_pto?: Maybe<Scalars['Boolean']['output']>;
  is_pto_against_overtime?: Maybe<Scalars['Boolean']['output']>;
  is_pto_against_public_holiday?: Maybe<Scalars['Boolean']['output']>;
  is_pto_against_weekend?: Maybe<Scalars['Boolean']['output']>;
  is_reset?: Maybe<Scalars['Boolean']['output']>;
  is_sample_data?: Maybe<Scalars['Boolean']['output']>;
  is_unit_hours?: Maybe<Scalars['Boolean']['output']>;
  leave_duration?: Maybe<LeaveDuration>;
  maximum_duration?: Maybe<Scalars['String']['output']>;
  minimum_duration?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partial_apply_minimum?: Maybe<Scalars['String']['output']>;
  per_day_hours?: Maybe<Scalars['String']['output']>;
  policy_type?: Maybe<Scalars['String']['output']>;
  pto_advance_notice_days?: Maybe<Scalars['Int']['output']>;
  pto_earning_threshold_hours?: Maybe<Scalars['Float']['output']>;
  pto_hours_against_threshold?: Maybe<Scalars['Float']['output']>;
  pto_minimum_consumable_hours?: Maybe<Scalars['Int']['output']>;
  pto_type?: Maybe<Scalars['String']['output']>;
  pto_value_in?: Maybe<PtoValueIn>;
  ranges?: Maybe<Array<Maybe<RangeType>>>;
  reset_carry_forward?: Maybe<Scalars['String']['output']>;
  reset_carry_forward_count?: Maybe<Scalars['Float']['output']>;
  reset_carry_forward_type?: Maybe<Scalars['String']['output']>;
  reset_max_limit?: Maybe<Scalars['Float']['output']>;
  reset_on_day?: Maybe<Scalars['String']['output']>;
  reset_on_month?: Maybe<Scalars['String']['output']>;
  reset_one_time_day?: Maybe<Scalars['String']['output']>;
  reset_one_time_month?: Maybe<Scalars['String']['output']>;
  reset_type?: Maybe<Scalars['String']['output']>;
  to_date?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  un_paid?: Maybe<Scalars['Boolean']['output']>;
  un_paid_days?: Maybe<Scalars['String']['output']>;
  working_days?: Maybe<Scalars['String']['output']>;
};

export type LeavesForCalender = {
  __typename?: 'LeavesForCalender';
  date_type_leave?: Maybe<Array<Maybe<TypeLeave>>>;
  is_short_leave?: Maybe<Scalars['Boolean']['output']>;
};

export type LinkToken = {
  __typename?: 'LinkToken';
  expiration?: Maybe<Scalars['Date']['output']>;
  link_token?: Maybe<Scalars['String']['output']>;
  request_id?: Maybe<Scalars['String']['output']>;
};

export type ListFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type LoanDetail = {
  __typename?: 'LoanDetail';
  balance?: Maybe<Scalars['Int']['output']>;
  total_loan?: Maybe<Scalars['Int']['output']>;
};

export type LoanPayment = {
  __typename?: 'LoanPayment';
  _id?: Maybe<Scalars['ID']['output']>;
  approval_description?: Maybe<Scalars['String']['output']>;
  approval_status?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  behalf_of?: Maybe<Array<Maybe<User>>>;
  business?: Maybe<Business>;
  business_manager?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<User>;
  installment_amount?: Maybe<Scalars['Float']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_fixed?: Maybe<Scalars['Boolean']['output']>;
  loan_amount?: Maybe<Scalars['Float']['output']>;
  loan_recovery_method?: Maybe<Scalars['String']['output']>;
  loan_taken_date?: Maybe<Scalars['DateTime']['output']>;
  loan_type?: Maybe<Scalars['String']['output']>;
  logs?: Maybe<Array<Maybe<LogsLoanPayments>>>;
  no_of_installment?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<Scalars['Float']['output']>;
  payment_received_date?: Maybe<Scalars['DateTime']['output']>;
  payment_start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
  work_flow?: Maybe<Array<Maybe<WorkFlow>>>;
};

export enum LoanPaymentStatus {
  Accepted = 'accepted',
  All = 'all',
  Archive = 'archive',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type LoanTransaction = {
  __typename?: 'LoanTransaction';
  _id?: Maybe<Scalars['ID']['output']>;
  adjustment_amount?: Maybe<Scalars['Float']['output']>;
  adjustment_comment?: Maybe<Scalars['String']['output']>;
  adjustment_date?: Maybe<Scalars['DateTime']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  business?: Maybe<Business>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  is_adjustable?: Maybe<Scalars['Boolean']['output']>;
  is_cash?: Maybe<Scalars['Boolean']['output']>;
  is_credit?: Maybe<Scalars['Boolean']['output']>;
  loan?: Maybe<LoanPayment>;
  loan_amount?: Maybe<Scalars['Float']['output']>;
  loan_transaction_amount?: Maybe<Scalars['Float']['output']>;
  loan_transaction_date?: Maybe<Scalars['DateTime']['output']>;
  logs?: Maybe<Array<Maybe<TransactionLogs>>>;
  transaction?: Maybe<Scalars['String']['output']>;
};

export enum LoanType {
  Advanced = 'advanced',
  Loan = 'loan'
}

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  store_number?: Maybe<Scalars['String']['output']>;
};

export enum LoginAs {
  TerminalApp = 'terminalApp',
  UserApp = 'userApp'
}

export type MsAttendanceAllowedBusiness = {
  __typename?: 'MSAttendanceAllowedBusiness';
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type MsAttendanceLog = {
  __typename?: 'MSAttendanceLog';
  Business?: Maybe<Business>;
  api_response?: Maybe<Scalars['String']['output']>;
  attendance_date?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  date_time?: Maybe<Scalars['DateTime']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  personal_email?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Maintenance = {
  __typename?: 'Maintenance';
  asset?: Maybe<Asset>;
  cost?: Maybe<Scalars['Float']['output']>;
  dateCompleted?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  maintenanceBy?: Maybe<Scalars['String']['output']>;
  recurring?: Maybe<Scalars['Int']['output']>;
  recurringBy?: Maybe<RecurringBy>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MaintenanceInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  dateCompleted?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceBy?: InputMaybe<Scalars['String']['input']>;
  recurring?: InputMaybe<Scalars['Int']['input']>;
  recurringBy?: InputMaybe<RecurringBy>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_global?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type MappedPlaidCategories = {
  __typename?: 'MappedPlaidCategories';
  _id: Scalars['ID']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  mapped_category?: Maybe<Scalars['String']['output']>;
  plaid_categorie?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MarginTiers = {
  __typename?: 'MarginTiers';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  from_price?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  markup?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  to_price?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<User>;
};

export type MasterDataType = {
  __typename?: 'MasterDataType';
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  data_type_name?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type MasterDataValue = {
  __typename?: 'MasterDataValue';
  _id?: Maybe<Scalars['ID']['output']>;
  business?: Maybe<Business>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  data_type?: Maybe<MasterDataType>;
  data_value_name?: Maybe<Scalars['String']['output']>;
  data_value_type?: Maybe<MasterDataValue>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_system_generated?: Maybe<Scalars['Boolean']['output']>;
};

export enum MatrixSection {
  Departmental = 'departmental',
  MandatoryHrTraining = 'mandatory_hr_training',
  OnboardingMilestone = 'onboarding_milestone'
}

export type MedicalInsurance = {
  __typename?: 'MedicalInsurance';
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  medical_facilities_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type MedicalInsuranceConfig = {
  __typename?: 'MedicalInsuranceConfig';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<MedicalInsurance>>>;
};

export type MedicalInsurancePackage = {
  __typename?: 'MedicalInsurancePackage';
  MasterDataValue?: Maybe<Array<Maybe<MasterDataValue>>>;
  Medical_facilities_name?: Maybe<Array<Maybe<MedicalInsurance>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  assigned_to?: Maybe<Array<Maybe<User>>>;
  company?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  enrollment_end_date?: Maybe<Scalars['DateTime']['output']>;
  enrollment_end_days?: Maybe<Scalars['Int']['output']>;
  enrollment_start_date?: Maybe<Scalars['DateTime']['output']>;
  enrollment_start_days?: Maybe<Scalars['Int']['output']>;
  expire_days?: Maybe<Scalars['DateTime']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_open_enrollment_period?: Maybe<Scalars['Boolean']['output']>;
  is_post_hire_eligibility?: Maybe<Scalars['Boolean']['output']>;
  monthly_cost_to_employe?: Maybe<Scalars['Int']['output']>;
  monthly_cost_to_employer?: Maybe<Scalars['Int']['output']>;
  notifications?: Maybe<Scalars['Boolean']['output']>;
  notify_before_days?: Maybe<Scalars['Int']['output']>;
  package_name?: Maybe<Scalars['String']['output']>;
  package_price?: Maybe<Scalars['Float']['output']>;
  package_type?: Maybe<Scalars['String']['output']>;
  upload_document?: Maybe<Scalars['String']['output']>;
};

export type MedicalInsurancePackageConfig = {
  __typename?: 'MedicalInsurancePackageConfig';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<MedicalInsurancePackage>>>;
};

export type MedicalInsurancePackageConfigUpdate = {
  __typename?: 'MedicalInsurancePackageConfigUpdate';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<MedicalInsurancePackage>>>;
};

export type MedicalInsuranceType = {
  __typename?: 'MedicalInsuranceType';
  expiry_date_of_policy?: Maybe<Scalars['DateTime']['output']>;
  insurance_card?: Maybe<Scalars['String']['output']>;
  insurance_class?: Maybe<Scalars['String']['output']>;
  total_policy_amount_monthly?: Maybe<Scalars['String']['output']>;
};

export enum MilestoneStatusEnum {
  Complete = 'complete',
  Passed = 'passed',
  Pending = 'pending'
}

export type MilestoneTracking = {
  __typename?: 'MilestoneTracking';
  Business?: Maybe<Business>;
  QuizAssignment?: Maybe<Scalars['ID']['output']>;
  TrainingMatrix?: Maybe<Scalars['ID']['output']>;
  User?: Maybe<User>;
  _id: Scalars['ID']['output'];
  admin_mode?: Maybe<Scalars['String']['output']>;
  completion_date?: Maybe<Scalars['Date']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<User>;
  deadline_date?: Maybe<Scalars['Date']['output']>;
  evidence_doc?: Maybe<Scalars['String']['output']>;
  meeting_date?: Maybe<Scalars['Date']['output']>;
  milestone_type?: Maybe<Scalars['String']['output']>;
  outcome_notes?: Maybe<Scalars['String']['output']>;
  score_percentage?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  updated_by?: Maybe<User>;
};

export type MilestoneTrackingList = {
  __typename?: 'MilestoneTrackingList';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<MilestoneTracking>>>;
};

export type MilestoneTrackingListInput = {
  User?: InputMaybe<Scalars['ID']['input']>;
  admin_mode?: InputMaybe<AdminModeEnum>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  milestone_type?: InputMaybe<MilestoneTypeEnum>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MilestoneStatusEnum>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum MilestoneType {
  CompetencyAssessment = 'competency_assessment',
  PerformanceMeeting = 'performance_meeting'
}

export enum MilestoneTypeEnum {
  CompetencyAssessment = 'competency_assessment',
  PerformanceMeeting = 'performance_meeting'
}

export type MissPaunchOut = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MissPaunchOutListingResult = {
  __typename?: 'MissPaunchOutListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ClockedHistory>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type ModuleAndSubModuleInputIdsInput = {
  TemplateModule: Scalars['ID']['input'];
  TemplateSubModule: Scalars['ID']['input'];
};

export type ModuleFeature = {
  __typename?: 'ModuleFeature';
  feature_hierarchy?: Maybe<Array<Maybe<FeatureHierarchy>>>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  modules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  permission?: Maybe<Array<Maybe<Permission>>>;
};

export type ModulePermissions = {
  __typename?: 'ModulePermissions';
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  modules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
};

export type ModulesFeatures = {
  __typename?: 'ModulesFeatures';
  feature?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<PermissionObj>>>;
};

export type ModulesFeaturesPermissions = {
  __typename?: 'ModulesFeaturesPermissions';
  features?: Maybe<Array<Maybe<ModulesFeatures>>>;
  module?: Maybe<Scalars['String']['output']>;
};

export type MultiCustomFieldTypeInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  controlType?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<CustomFieldTypeOptionInput>>>;
  order?: InputMaybe<Scalars['Float']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MultiInvoiceItemInput = {
  items?: InputMaybe<Array<InputMaybe<InvoiceItemInput>>>;
};

export type MultiQuestion = {
  attachment?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  correct_answer: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  options: Array<InputMaybe<OptionInput>>;
  question_text: Scalars['String']['input'];
  question_type: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  MarkNotificationsAsCleared?: Maybe<Scalars['Boolean']['output']>;
  UpdateAllRoleAndPermissionOfUser?: Maybe<Scalars['Boolean']['output']>;
  UpdateNameOfEmployeesFolder?: Maybe<Scalars['Boolean']['output']>;
  acceptRejectBusinessRequest?: Maybe<Scalars['Boolean']['output']>;
  acknowledgeOrientation?: Maybe<OrientationTracking>;
  addCaseWitness?: Maybe<HrComplaint>;
  addContractLicense: ContractLicense;
  addCustomLocation?: Maybe<Scalars['Boolean']['output']>;
  addDelegantEmployee?: Maybe<DelegantApproval>;
  addDocumentToSign?: Maybe<Scalars['Boolean']['output']>;
  addEmployeeIntoBusinesses?: Maybe<BusinessNavigation>;
  addEmployeeToAattendancePolicy?: Maybe<Scalars['Boolean']['output']>;
  addFeedbackConversation?: Maybe<Feedback>;
  addGuarantorForPassword?: Maybe<Scalars['Boolean']['output']>;
  addHRNote?: Maybe<HrComplaint>;
  addInsurance: Insurance;
  addInterviewLog?: Maybe<ComplaintInterviewLog>;
  addLease: Lease;
  addLeasingCustomer: LeasingCustomer;
  addMaintenance: Maintenance;
  addManualShortBreaks?: Maybe<Scalars['Boolean']['output']>;
  addMarginTiers?: Maybe<MarginTiers>;
  addNewFolderDocumentControl?: Maybe<DocumentControlAttachment>;
  addNewHbsContentToBusinessEmailTemplate?: Maybe<BusinessEmailTemplate>;
  addNewPaymentMethodCustomer?: Maybe<Scalars['Boolean']['output']>;
  addOrRemoveEmployeeInRole?: Maybe<Scalars['Boolean']['output']>;
  addPasswordManagerAdmin?: Maybe<Scalars['Boolean']['output']>;
  addProfitCategory?: Maybe<ProfitCategory>;
  addReason?: Maybe<Reason>;
  addRepairPrice?: Maybe<RepairPrice>;
  addRosterComment?: Maybe<Scalars['Boolean']['output']>;
  addShippingMethods?: Maybe<ShippingMethods>;
  addShortBreak?: Maybe<ShortBreakClockedHistory>;
  addStoreToDutyRoster?: Maybe<RosterStores>;
  addUpdateTerminalDevice?: Maybe<AddTerminalAppType>;
  addUserRadius?: Maybe<BusinessRadius>;
  addVendor?: Maybe<Vendor>;
  addWeekendAndPublicHolidayOnTimeSheet?: Maybe<Scalars['Boolean']['output']>;
  adjustLeaveBalance?: Maybe<Scalars['Boolean']['output']>;
  allowAttendance?: Maybe<Scalars['Boolean']['output']>;
  archiveAccountType?: Maybe<Scalars['Boolean']['output']>;
  archiveAdvanceFilter?: Maybe<Scalars['Boolean']['output']>;
  archiveAllowance?: Maybe<Scalars['Boolean']['output']>;
  archiveAppraisalObjective?: Maybe<Scalars['Boolean']['output']>;
  archiveAppraisalScale?: Maybe<Scalars['Boolean']['output']>;
  archiveApprovalWorkFlow?: Maybe<Scalars['Boolean']['output']>;
  archiveAsset?: Maybe<Scalars['Boolean']['output']>;
  archiveAssetBrand?: Maybe<Scalars['Boolean']['output']>;
  archiveAssetCategory?: Maybe<Scalars['Boolean']['output']>;
  archiveAssetModel?: Maybe<Scalars['Boolean']['output']>;
  archiveAssetSubCategory?: Maybe<Scalars['Boolean']['output']>;
  archiveAttandencePolicy?: Maybe<Scalars['Boolean']['output']>;
  archiveAttendance?: Maybe<Scalars['Boolean']['output']>;
  archiveAttendanceRegulation?: Maybe<Scalars['Boolean']['output']>;
  archiveBusiness?: Maybe<Scalars['Boolean']['output']>;
  archiveBusinessEmailTemplate?: Maybe<Scalars['Boolean']['output']>;
  archiveBusinessLocation?: Maybe<Scalars['Boolean']['output']>;
  archiveCashRegister?: Maybe<Scalars['Boolean']['output']>;
  archiveContractLicense?: Maybe<Scalars['Boolean']['output']>;
  archiveDocumentControl?: Maybe<ArchivedIds>;
  archiveEmailDeliveryRule?: Maybe<Scalars['Boolean']['output']>;
  archiveEmployee?: Maybe<ArchivedEmployees>;
  archiveEmployeeDashboardView?: Maybe<Scalars['Boolean']['output']>;
  archiveEmployeeDocument?: Maybe<Scalars['Boolean']['output']>;
  archiveEmployeeGarnishment?: Maybe<Scalars['Boolean']['output']>;
  archiveEmployeeHistory?: Maybe<Scalars['Boolean']['output']>;
  archiveExpense?: Maybe<Scalars['Boolean']['output']>;
  archiveExpenseInvoice?: Maybe<Scalars['Boolean']['output']>;
  archiveExpenseInvoiceCategory?: Maybe<Scalars['Boolean']['output']>;
  archiveFilter?: Maybe<Scalars['Boolean']['output']>;
  archiveFinalSettlement?: Maybe<Scalars['Boolean']['output']>;
  archiveGiftCardCategory?: Maybe<Scalars['Boolean']['output']>;
  archiveGiftCardCategoryTemplate?: Maybe<Scalars['Boolean']['output']>;
  archiveGratuity?: Maybe<Scalars['Boolean']['output']>;
  archiveInsurance?: Maybe<Scalars['Boolean']['output']>;
  archiveInvoice?: Maybe<Scalars['Boolean']['output']>;
  archiveLeavePolicyById?: Maybe<Scalars['Boolean']['output']>;
  archiveLeaveTypeById?: Maybe<Scalars['Boolean']['output']>;
  archiveLoan?: Maybe<Scalars['Boolean']['output']>;
  archiveLoanTransaction?: Maybe<Scalars['Boolean']['output']>;
  archiveMaintenance?: Maybe<Scalars['Boolean']['output']>;
  archiveMedicalInsurance?: Maybe<Scalars['Boolean']['output']>;
  archiveMedicalInsurancePackage?: Maybe<Scalars['Boolean']['output']>;
  archiveObjectiveAssignment?: Maybe<Scalars['Boolean']['output']>;
  archivePackage?: Maybe<Scalars['Boolean']['output']>;
  archivePaymentMethod?: Maybe<Scalars['Boolean']['output']>;
  archivePayrollSchedule?: Maybe<Scalars['Boolean']['output']>;
  archivePayrollStructure?: Maybe<Scalars['Boolean']['output']>;
  archivePlaidCategories?: Maybe<Scalars['Boolean']['output']>;
  archivePublicHolidays?: Maybe<Scalars['Boolean']['output']>;
  archiveRole?: Maybe<Scalars['Boolean']['output']>;
  archiveRoster?: Maybe<Scalars['Boolean']['output']>;
  archiveRosterComment?: Maybe<Scalars['Boolean']['output']>;
  archiveShift?: Maybe<Scalars['Boolean']['output']>;
  archiveStoreFromDutyRoster?: Maybe<Scalars['Boolean']['output']>;
  archiveSubscriptionAttachment?: Maybe<Scalars['Boolean']['output']>;
  archiveSubscriptionLogActivity?: Maybe<Scalars['Boolean']['output']>;
  archiveTask?: Maybe<Scalars['Boolean']['output']>;
  archiveTemplate?: Maybe<Scalars['Boolean']['output']>;
  archiveUnArchiveCashRegistersHistory?: Maybe<Scalars['Boolean']['output']>;
  archiveUnarchiveQuiz?: Maybe<Scalars['Boolean']['output']>;
  archiveUnarchiveQuizCategory?: Maybe<Scalars['Boolean']['output']>;
  archiveUnarchiveQuizCategorySection?: Maybe<Scalars['Boolean']['output']>;
  archiveUnarchiveQuizQuestion?: Maybe<Scalars['Boolean']['output']>;
  archiveUnarchiveQuizTrainingCategory?: Maybe<Scalars['Boolean']['output']>;
  archiveUnarchiveQuizTrainingSubCategory?: Maybe<Scalars['Boolean']['output']>;
  archiveUnarchiveQuizTraning?: Maybe<Scalars['Boolean']['output']>;
  archiveUnarchiveQuizTraningReplica?: Maybe<Scalars['Boolean']['output']>;
  archiveUserAppDevice?: Maybe<Scalars['Boolean']['output']>;
  archivedTax?: Maybe<Scalars['Boolean']['output']>;
  assetAlertConfiguration: AlertConfiguration;
  assignAattendancePolicyToEmployee?: Maybe<Scalars['Boolean']['output']>;
  assignInvestigator?: Maybe<HrComplaint>;
  assignLeavePolicyToEmployee?: Maybe<LeavePolicy>;
  assignPackageToSubscription?: Maybe<Scalars['Boolean']['output']>;
  assignQuiz?: Maybe<Scalars['Boolean']['output']>;
  assignRoleToEmployee?: Maybe<Scalars['Boolean']['output']>;
  assignScheduleToEmployees?: Maybe<ConflictRoster>;
  assignUsersToQuizAndTraining?: Maybe<TraningRepecaCreateInputResult>;
  assigneeFilterByStatus: Array<Maybe<AssigneeFilteredByStatus>>;
  attemptQuizAssignment?: Maybe<Scalars['Boolean']['output']>;
  attendancePolicy?: Maybe<Scalars['Boolean']['output']>;
  authenticateNewDomain?: Maybe<SendGridResponseUnion>;
  backPayToEmployee?: Maybe<Scalars['Boolean']['output']>;
  campaignStatusChanged?: Maybe<Scalars['Boolean']['output']>;
  cancelBusinessPackage?: Maybe<Scalars['Boolean']['output']>;
  cancelScheduleConflicts?: Maybe<Scalars['Boolean']['output']>;
  changeBusinessOwnerPassword?: Maybe<Scalars['Boolean']['output']>;
  changeComplaintStatus?: Maybe<HrComplaint>;
  changeConfigColumnVisibility?: Maybe<Scalars['Boolean']['output']>;
  changeDocumentControlAttachmentFolder?: Maybe<Scalars['Boolean']['output']>;
  changeEmployeeAttendancePolicy?: Maybe<Scalars['Boolean']['output']>;
  changeEmployeeLeavePackage?: Maybe<LeavePolicy>;
  changeEmployeeLeavePolicy?: Maybe<LeavePolicy>;
  changeLocationOfDocumentDeletedParent?: Maybe<Scalars['Boolean']['output']>;
  changeOldDocuments?: Maybe<Scalars['Boolean']['output']>;
  changeRecruitmentStatus?: Maybe<Recruitment>;
  changeRoleParent?: Maybe<Role>;
  changeSharingStatusOrRemoveShare?: Maybe<Scalars['Boolean']['output']>;
  changeSubscriptionAttachmentFolder?: Maybe<Scalars['Boolean']['output']>;
  changeSubsriptionStatus?: Maybe<Scalars['Boolean']['output']>;
  changeTaskAction: TimeLogResponse;
  checkAuthenticatedUser?: Maybe<User>;
  checkInAssets?: Maybe<Scalars['Boolean']['output']>;
  checkerQuizAssignment?: Maybe<Scalars['Boolean']['output']>;
  checkoutAssets?: Maybe<Scalars['Boolean']['output']>;
  clearAllFilter?: Maybe<Scalars['Boolean']['output']>;
  clearDutyRoster?: Maybe<Scalars['Boolean']['output']>;
  clearTempTablePreset?: Maybe<Scalars['Boolean']['output']>;
  cloneRole?: Maybe<Scalars['Boolean']['output']>;
  commission_compaingStatusChanged?: Maybe<Scalars['Boolean']['output']>;
  commission_statusChanged?: Maybe<Scalars['Boolean']['output']>;
  connectSendgridAccount?: Maybe<SendgridConfig>;
  copyAuthenticatorApp?: Maybe<Scalars['Boolean']['output']>;
  copyDocumentControlAttachmentFolder?: Maybe<Scalars['Boolean']['output']>;
  copyRolePermissions?: Maybe<Scalars['Boolean']['output']>;
  copySchedule?: Maybe<Scalars['Boolean']['output']>;
  copyScheduleByDate?: Maybe<Array<Maybe<ConflictedSchedules>>>;
  copyScheduleDifferentDate?: Maybe<Array<Maybe<ConflictedSchedules>>>;
  copyScheduleEmployeeToEmployees?: Maybe<Array<Maybe<ConflictedSchedules>>>;
  copyScheduletoNextWeek?: Maybe<Scalars['Boolean']['output']>;
  copyScheduletoSelectDate?: Maybe<ConflictRoster>;
  createAccountType?: Maybe<AccountType>;
  createActionFeature?: Maybe<ActionFeature>;
  createActivityGroup?: Maybe<Scalars['Boolean']['output']>;
  createAdminDefaultPermissions?: Maybe<Array<Maybe<Permission>>>;
  createAdvanceFilter?: Maybe<Scalars['Boolean']['output']>;
  createAndMapPlaidCategories?: Maybe<MappedPlaidCategories>;
  createAppraisalObjective?: Maybe<AppraisalObjecive>;
  createAppraisalScale?: Maybe<AppraisalScale>;
  createAppraisalType?: Maybe<AppraisalType>;
  createApprovalWorkFlow?: Maybe<ApprovalWorkFlow>;
  createAsset?: Maybe<Scalars['Boolean']['output']>;
  createAssetBrand?: Maybe<AssetBrand>;
  createAssetCategory: AssetCategory;
  createAssetCategoryOrSubCategory?: Maybe<AssetCategory>;
  createAssetModel?: Maybe<Scalars['Boolean']['output']>;
  createAssetSubCategory: AssetSubCategory;
  createAttendanceRegulation?: Maybe<AttendanceRegulation>;
  createAuthenticatorAppThroughQR?: Maybe<Authenticator>;
  createAuthenticatorAppWithoutOTP?: Maybe<Authenticator>;
  createAuthenticatorGroup?: Maybe<AuthenticatorGroup>;
  createBusiness?: Maybe<Business>;
  createBusinessEmailTemplate?: Maybe<BusinessEmailTemplate>;
  createBusinessLocation?: Maybe<BusinessLocation>;
  createBusinessSampleData?: Maybe<Scalars['Boolean']['output']>;
  createCampaign?: Maybe<Campaign>;
  createCashRegister?: Maybe<CashRegisters>;
  createCashRegistersHistory?: Maybe<CashRegistersHistory>;
  createCategory?: Maybe<Scalars['Boolean']['output']>;
  createChartOfAccount?: Maybe<ChartOfAccount>;
  createChatTenantAndUsers?: Maybe<Scalars['Boolean']['output']>;
  createCity?: Maybe<City>;
  createComment?: Maybe<TaskComment>;
  createCommisionCampaign?: Maybe<CommissionCampaign>;
  createCommission?: Maybe<Commission>;
  createCommonNotificationPermissions?: Maybe<Scalars['Boolean']['output']>;
  createCompensationTimeOff?: Maybe<TimeOff>;
  createDeduction?: Maybe<Deduction>;
  createDefaultConfigListing?: Maybe<Scalars['Boolean']['output']>;
  createDefaultEmployeeAction?: Maybe<Scalars['Boolean']['output']>;
  createDefaultTemplate?: Maybe<Scalars['Boolean']['output']>;
  createDefualtMasterDataTypeAndValues?: Maybe<Scalars['Boolean']['output']>;
  createDepartment?: Maybe<Department>;
  createDesignation?: Maybe<Designation>;
  createDetailType?: Maybe<DetailType>;
  createDiscount?: Maybe<Discount>;
  createDocumentControlAttachment?: Maybe<DocumentControlAttachment>;
  createDutyRoster?: Maybe<ConflictRoster>;
  createDutyRosterForcefully?: Maybe<Scalars['Boolean']['output']>;
  createEmailDeliveryRule?: Maybe<EmailDeliveryRule>;
  createEmailOTP?: Maybe<EmailOtp>;
  createEmployeeDashboardView: EmployeeDashboardView;
  createEmployeeGarnishment?: Maybe<EmployeeGarnishment>;
  createEmployeeSeparation?: Maybe<EmployeeSeparation>;
  createEncryptionCopies?: Maybe<Scalars['Boolean']['output']>;
  createEvaluation?: Maybe<AppraisalEvaluation>;
  createExpenseInvoice?: Maybe<Scalars['Boolean']['output']>;
  createExpenseInvoiceAndCategory?: Maybe<CreatedExpenseInvoice>;
  createExpenseInvoiceCategory?: Maybe<Scalars['Boolean']['output']>;
  createExpenseRequest?: Maybe<Expense>;
  createExternalVendorTraining: Array<Maybe<ExternalVendorTraining>>;
  createFeedback?: Maybe<Feedback>;
  createFileUrl?: Maybe<Scalars['String']['output']>;
  createFilter?: Maybe<Filter>;
  createFinalSettlement?: Maybe<FinalSettlement>;
  createGiftCard?: Maybe<GiftCard>;
  createGoal?: Maybe<Goals>;
  createHRComplaint?: Maybe<HrComplaint>;
  createInvoice?: Maybe<Scalars['Boolean']['output']>;
  createInvoiceItem?: Maybe<Scalars['Boolean']['output']>;
  createLoanAdjustment?: Maybe<Scalars['Boolean']['output']>;
  createLoanRequest?: Maybe<LoanPayment>;
  createLoanTransaction?: Maybe<LoanTransaction>;
  createMasterDataType?: Maybe<MasterDataType>;
  createMasterDataTypeValue?: Maybe<MasterDataValue>;
  createMedicalInsurance?: Maybe<MasterDataValue>;
  createMultiInvoiceItem?: Maybe<Scalars['Boolean']['output']>;
  createNewEmail?: Maybe<BusinessEmail>;
  createNotificationPermissionForBusiness?: Maybe<Scalars['Boolean']['output']>;
  createObjectiveAssignment?: Maybe<ObjectiveAssignment>;
  createPOSDefaultPermissions?: Maybe<Array<Maybe<Permission>>>;
  createPackage?: Maybe<Package>;
  createPackageForSuperAdmin?: Maybe<Package>;
  createPerformanceCycle?: Maybe<PerformanceCycleType>;
  createPhoneOTP?: Maybe<PhoneOtp>;
  createQuickAsset?: Maybe<Array<Maybe<Asset>>>;
  createQuiz?: Maybe<Scalars['Boolean']['output']>;
  createQuizCategories?: Maybe<Scalars['Boolean']['output']>;
  createQuizQuestion?: Maybe<Array<Maybe<QuestionCreated>>>;
  createQuizTarainingCategories?: Maybe<Scalars['Boolean']['output']>;
  createQuizTraining?: Maybe<CreateResponseQuizTraining>;
  createReason?: Maybe<Reason>;
  createRefresherCycle?: Maybe<TrainingCycle>;
  createRegion?: Maybe<Region>;
  createReminderForNotification?: Maybe<Scalars['Boolean']['output']>;
  createRepliesinCommmentTask?: Maybe<TaskManagement>;
  createReport?: Maybe<Scalars['Boolean']['output']>;
  createRocketChatUserFromChat?: Maybe<Scalars['Boolean']['output']>;
  createRole?: Maybe<Role>;
  createRosterByScheduleTemplate?: Maybe<Array<Maybe<Roster>>>;
  createSampleData?: Maybe<Array<Maybe<SampleData>>>;
  createSampleDataModules?: Maybe<Scalars['Boolean']['output']>;
  createSchedule?: Maybe<Array<Maybe<ConflictedSchedules>>>;
  createSchedulesFromTimeSheet?: Maybe<Scalars['Int']['output']>;
  createServiceCategory?: Maybe<ServiceCategoryType>;
  createSetupAlert?: Maybe<SetupAlert>;
  createShipTo?: Maybe<Scalars['Boolean']['output']>;
  createState?: Maybe<State>;
  createStation?: Maybe<Station>;
  createSubscriptionAttachment?: Maybe<Array<Maybe<Attachment>>>;
  createSubscriptionLogActivity?: Maybe<SubscriptionLogActivity>;
  createTask?: Maybe<TaskManagement>;
  createTax?: Maybe<Tax>;
  createTimeOff?: Maybe<TimeOff>;
  createTimeZone?: Maybe<Array<Maybe<TimeZone>>>;
  createTrainingMatrix?: Maybe<TrainingMatrix>;
  createTrainingSettings?: Maybe<TrainingSettings>;
  createUpdateAllowance?: Maybe<Allowance>;
  createUpdateAttendance?: Maybe<Attendance>;
  createUpdateAttendanceRequest?: Maybe<Attendance>;
  createUpdateConfigListing?: Maybe<ConfigListing>;
  createUpdateContribution?: Maybe<Contribution>;
  createUpdateEmployee?: Maybe<User>;
  createUpdateExpense?: Maybe<Expense>;
  createUpdateGratuity?: Maybe<Gratuity>;
  createUpdateLeavePolicy?: Maybe<LeavePolicy>;
  createUpdateLeaveType?: Maybe<LeaveType>;
  createUpdateLoan?: Maybe<LoanPayment>;
  createUpdateMedicalInsurancePackage?: Maybe<MedicalInsurancePackage>;
  createUpdateMultiStoreCustomField?: Maybe<Scalars['Boolean']['output']>;
  createUpdateMultipleActionActivity?: Maybe<DocumentControlAttachment>;
  createUpdatePayrollSchedule?: Maybe<PayrollSchedule>;
  createUpdatePayrollStructure?: Maybe<PayrollStructure>;
  createUpdateProductattributes?: Maybe<Scalars['Boolean']['output']>;
  createUpdatePublicHolidays?: Maybe<PublicHoliday>;
  createUpdateRecruitmentEmployee?: Maybe<Recruitment>;
  createUpdateReserveAssetColor?: Maybe<Scalars['Boolean']['output']>;
  createUpdateSchedulerConfig?: Maybe<SchedulerConfig>;
  createUpdateShift?: Maybe<Shift>;
  createUpdateShortLeave?: Maybe<ClockedHistory>;
  createUpdateStoreCustomField?: Maybe<StoreCustomField>;
  createUpdateTablePreset?: Maybe<Scalars['Boolean']['output']>;
  createUpdateTimeOffRequest?: Maybe<TimeOff>;
  createUpdatepaidUnPaid?: Maybe<PaidUnPaids>;
  createUserAppDevice?: Maybe<Scalars['Boolean']['output']>;
  createWeekends?: Maybe<Scalars['Boolean']['output']>;
  createWriteUp?: Maybe<WriteUp>;
  createcommentOnTask?: Maybe<TaskManagement>;
  customGrade?: Maybe<Scalars['Boolean']['output']>;
  defaultServicesConfiguration: Scalars['Boolean']['output'];
  deleteAppraisalType?: Maybe<Scalars['Boolean']['output']>;
  deleteAuthenticatorApp?: Maybe<Scalars['Boolean']['output']>;
  deleteCaseWitness?: Maybe<HrComplaint>;
  deleteChartOfAccount?: Maybe<Scalars['Boolean']['output']>;
  deleteCommentInTask?: Maybe<Scalars['Boolean']['output']>;
  deleteCommission?: Maybe<Scalars['Boolean']['output']>;
  deleteCommonNotification?: Maybe<Scalars['Boolean']['output']>;
  deleteConfigListing?: Maybe<Scalars['Boolean']['output']>;
  deleteDepartment?: Maybe<Scalars['Boolean']['output']>;
  deleteDesignation?: Maybe<Scalars['Boolean']['output']>;
  deleteDiscount?: Maybe<Scalars['Boolean']['output']>;
  deleteDocFromAsset?: Maybe<Scalars['Boolean']['output']>;
  deleteEmployeeSeparation?: Maybe<Scalars['Boolean']['output']>;
  deleteExternalVendorTraining?: Maybe<Scalars['Boolean']['output']>;
  deleteFeedback?: Maybe<Scalars['Boolean']['output']>;
  deleteGoal?: Maybe<Scalars['Boolean']['output']>;
  deleteHRComplaint?: Maybe<Scalars['Boolean']['output']>;
  deleteHRNote?: Maybe<HrComplaint>;
  deleteInterviewLog?: Maybe<Scalars['Boolean']['output']>;
  deleteLoanAdjustment?: Maybe<Scalars['Boolean']['output']>;
  deleteMarginTiers?: Maybe<MarginTiers>;
  deleteMasterDataTypeValue?: Maybe<Scalars['Boolean']['output']>;
  deleteMultiSchedule?: Maybe<Scalars['Boolean']['output']>;
  deleteNewScheduleAndPreviewOldSchedule?: Maybe<Scalars['Boolean']['output']>;
  deleteNotification?: Maybe<Scalars['Boolean']['output']>;
  deleteNotificationsForBusinessAndUser?: Maybe<Scalars['Boolean']['output']>;
  deleteObjectiveAssignmentNestedData?: Maybe<Scalars['Boolean']['output']>;
  deletePerformanceCycle?: Maybe<Scalars['Boolean']['output']>;
  deletePermissions?: Maybe<Scalars['Boolean']['output']>;
  deleteProductattributes?: Maybe<Scalars['Boolean']['output']>;
  deleteProfitCategory?: Maybe<ProfitCategory>;
  deleteReason?: Maybe<Reason>;
  deleteRecruitment?: Maybe<Recruitment>;
  deleteRefresherCycle: DeleteCycleResponse;
  deleteRegion?: Maybe<Scalars['Boolean']['output']>;
  deleteRepairPrice?: Maybe<RepairPrice>;
  deleteRepliesinCommmentTask?: Maybe<Scalars['Boolean']['output']>;
  deleteRole?: Maybe<Scalars['Boolean']['output']>;
  deleteRosters?: Maybe<Scalars['Boolean']['output']>;
  deleteSchedule?: Maybe<Scalars['Boolean']['output']>;
  deleteShipTo?: Maybe<Scalars['Boolean']['output']>;
  deleteShippingMethods?: Maybe<ShippingMethods>;
  deleteShortLeave?: Maybe<Scalars['Boolean']['output']>;
  deleteStation?: Maybe<Scalars['Boolean']['output']>;
  deleteStoreCustomField?: Maybe<Scalars['Boolean']['output']>;
  deleteSubscriptionRequest?: Maybe<Scalars['Boolean']['output']>;
  deleteTablePreset?: Maybe<Scalars['Boolean']['output']>;
  deleteTimeOff?: Maybe<Scalars['Boolean']['output']>;
  deleteTrainingMatrixById?: Maybe<Scalars['Boolean']['output']>;
  deleteVendor?: Maybe<Vendor>;
  deleteWriteUp?: Maybe<Scalars['Boolean']['output']>;
  deletecontribution?: Maybe<Scalars['Boolean']['output']>;
  deletededuction?: Maybe<Scalars['Boolean']['output']>;
  deletepaidUnPaid?: Maybe<Scalars['Boolean']['output']>;
  detectContractFromAsset?: Maybe<Scalars['Boolean']['output']>;
  detectInsuranceFromAsset?: Maybe<Scalars['Boolean']['output']>;
  discountStatusChanged?: Maybe<Scalars['Boolean']['output']>;
  disposedAsset?: Maybe<Scalars['Boolean']['output']>;
  editAuthenticatorGroup?: Maybe<Scalars['Boolean']['output']>;
  editBusinessEmployee?: Maybe<BusinessNavigation>;
  editCaseWitness?: Maybe<HrComplaint>;
  editMedicalInsurance?: Maybe<MedicalInsurance>;
  emailScheduleToEmployee?: Maybe<Scalars['Boolean']['output']>;
  employeeClockedInStatus?: Maybe<ClockedInStatus>;
  employeeRecentFileView?: Maybe<Scalars['Boolean']['output']>;
  generateFolderAndSubfolderForBusiness?: Maybe<Scalars['Boolean']['output']>;
  generateUniqueAssetId?: Maybe<Scalars['String']['output']>;
  getBusinessOwnerData?: Maybe<User>;
  getEmployeesAttendanceList?: Maybe<Array<Maybe<AttendanceData>>>;
  getLoggedInUserDetail?: Maybe<AuthTokens>;
  goalStatusChanged?: Maybe<Scalars['Boolean']['output']>;
  importCityStateData?: Maybe<Scalars['Boolean']['output']>;
  importEmployeesScheduleforMSFromClockingTime?: Maybe<Scalars['Boolean']['output']>;
  importEmployeesforMS?: Maybe<Array<Maybe<User>>>;
  importProductAttributeMasterDataTypeValue?: Maybe<Scalars['Boolean']['output']>;
  importRepairPrice?: Maybe<Array<Maybe<RepairPrice>>>;
  importScheduleCsv?: Maybe<SchdualCsvResponse>;
  importSchedules?: Maybe<Scalars['Boolean']['output']>;
  importTimeSheet?: Maybe<ImportTimesheetType>;
  integrateRosterIntoSchedule?: Maybe<Scalars['Boolean']['output']>;
  linkBusinesses?: Maybe<BusinessNavigation>;
  linkContractsWithAsset?: Maybe<Scalars['Boolean']['output']>;
  linkInsuranceWithAsset?: Maybe<Scalars['Boolean']['output']>;
  linkParentOrChildAssetWithAsset?: Maybe<Scalars['Boolean']['output']>;
  loginToOtherBusiness?: Maybe<AuthTokens>;
  loginWithEmail?: Maybe<AuthTokens>;
  loginWithZitadelCode?: Maybe<AuthTokens>;
  logout?: Maybe<Scalars['Boolean']['output']>;
  makeScreenAsDefault?: Maybe<EmployeeDashboardView>;
  markAllAsRead?: Maybe<Scalars['Boolean']['output']>;
  markAllViewed?: Maybe<Scalars['Boolean']['output']>;
  markRespondentNotified?: Maybe<HrComplaint>;
  moveAccessoriesToAsset?: Maybe<Scalars['Boolean']['output']>;
  moveAsset?: Maybe<Scalars['Boolean']['output']>;
  moveAssetFromLocationToLocation?: Maybe<Scalars['Boolean']['output']>;
  overrideSeverity?: Maybe<HrComplaint>;
  payForPackageSubsctipiton?: Maybe<Scalars['Boolean']['output']>;
  payFranchiseSubscription?: Maybe<Scalars['Boolean']['output']>;
  payrollDetailManuallyAdjust?: Maybe<Scalars['Boolean']['output']>;
  permanentlyDeleteDocument?: Maybe<Scalars['Boolean']['output']>;
  quizTraningAssignTo?: Maybe<Scalars['Boolean']['output']>;
  reJoinEmployee?: Maybe<User>;
  reRunQuestionTranslation?: Maybe<Question>;
  recordExternalAssessment?: Maybe<MilestoneTracking>;
  recordPerformanceMeeting?: Maybe<MilestoneTracking>;
  recordResolution?: Maybe<HrComplaint>;
  refreshToken?: Maybe<AuthTokens>;
  regionStatusChanged?: Maybe<Scalars['Boolean']['output']>;
  registerBusiness?: Maybe<BusniessId>;
  removeCommisionCampaign?: Maybe<Scalars['Boolean']['output']>;
  removeDelegantEmployee?: Maybe<DelegantApproval>;
  removeEmployeeFromAattendancePolicy?: Maybe<Scalars['Boolean']['output']>;
  removeEmployeeFromBusiness?: Maybe<BusinessNavigation>;
  removeEmployeeFromLeavePolicy?: Maybe<Scalars['Boolean']['output']>;
  removeEmployeeRole?: Maybe<Scalars['Boolean']['output']>;
  removeGuarantors?: Maybe<Scalars['Boolean']['output']>;
  removeShareOfAuthenticatorApp?: Maybe<Scalars['Boolean']['output']>;
  removeTerminalDevice?: Maybe<Scalars['Boolean']['output']>;
  renameDocumentControlAttachment?: Maybe<DocumentControlAttachment>;
  renameSubscriptionAttachment?: Maybe<Attachment>;
  reserveAsset: Scalars['Boolean']['output'];
  resetEmployeeFailureCounter?: Maybe<ResetFailureCounterResponse>;
  resolveConflicts?: Maybe<Scalars['Boolean']['output']>;
  revertCancelSubscription?: Maybe<Scalars['Boolean']['output']>;
  s3UploadFile?: Maybe<Scalars['Boolean']['output']>;
  saveScheduleTemplate?: Maybe<Scalars['Boolean']['output']>;
  saveTillCount?: Maybe<TillCount>;
  scrapAsset?: Maybe<Scalars['Boolean']['output']>;
  scriptForAssetBrand?: Maybe<Scalars['Boolean']['output']>;
  scriptForAssetCategoryCounts?: Maybe<Scalars['Boolean']['output']>;
  scriptForAssignVendorsToQuickAsset?: Maybe<Scalars['Boolean']['output']>;
  seederForAuthenticator?: Maybe<Scalars['Boolean']['output']>;
  sendEmployeeEvaluationEmail?: Maybe<Scalars['Boolean']['output']>;
  sendForgotPasswordEmail?: Maybe<Scalars['Boolean']['output']>;
  sendManualReminder?: Maybe<Scalars['Boolean']['output']>;
  sendSchedulesByEmail?: Maybe<Scalars['Boolean']['output']>;
  sendTemplateToTestEmail?: Maybe<Scalars['Boolean']['output']>;
  sendTrainingAssignmentEmail?: Maybe<Scalars['Boolean']['output']>;
  sendWitnessForm?: Maybe<HrComplaint>;
  setDefaultCard?: Maybe<Scalars['Boolean']['output']>;
  setDoNotDisturbInNotifications?: Maybe<Scalars['Boolean']['output']>;
  setEmployeeAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  setEmployeeUnAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  setNumberOfRecord?: Maybe<Scalars['Boolean']['output']>;
  setProfilePictures?: Maybe<Scalars['Boolean']['output']>;
  setPtoOpeningBalance?: Maybe<Scalars['Boolean']['output']>;
  setSelfFeatureHierarchy?: Maybe<Scalars['Boolean']['output']>;
  shareAuthenticatorApp?: Maybe<Authenticator>;
  shareBulkAuthenticatorApps?: Maybe<Scalars['Boolean']['output']>;
  shareDocumentControlAttachment?: Maybe<Scalars['Boolean']['output']>;
  singleUpload?: Maybe<Scalars['String']['output']>;
  skipQuizQuestion?: Maybe<Scalars['Boolean']['output']>;
  startedQuiz?: Maybe<Scalars['Boolean']['output']>;
  submitDocumentByEmployee?: Maybe<DocumentControlAttachment>;
  subscribeMedicalInsurance?: Maybe<Scalars['Boolean']['output']>;
  subscribePackgeForSuperAdmin?: Maybe<BusinessPackage>;
  swapeEmployees?: Maybe<Scalars['Boolean']['output']>;
  swapeRole?: Maybe<Scalars['Boolean']['output']>;
  syncPayroll?: Maybe<Payroll>;
  syncWithChatServer?: Maybe<Scalars['Boolean']['output']>;
  testCompleteExpiredCycles?: Maybe<Scalars['Boolean']['output']>;
  testDailyHRSummaryCron?: Maybe<Scalars['Boolean']['output']>;
  testNewHireDOJCron?: Maybe<Scalars['Boolean']['output']>;
  testPerformanceMeetingCron?: Maybe<Scalars['Boolean']['output']>;
  testRefresherCron?: Maybe<Scalars['Boolean']['output']>;
  testReminderEmailCron?: Maybe<Scalars['Boolean']['output']>;
  trashAsset?: Maybe<Scalars['Boolean']['output']>;
  triggerComplianceSummaryEmail?: Maybe<Scalars['Boolean']['output']>;
  unAssignAsset?: Maybe<Scalars['Boolean']['output']>;
  unAssignQuiz?: Maybe<Scalars['Boolean']['output']>;
  unBlockEmployees?: Maybe<Scalars['Boolean']['output']>;
  unLinkAssetRelationFromAsset?: Maybe<Scalars['Boolean']['output']>;
  undoDisposedAsset?: Maybe<Scalars['Boolean']['output']>;
  undoReserveAsset?: Maybe<Scalars['Boolean']['output']>;
  unlinkBusiness?: Maybe<BusinessNavigation>;
  unlinkUserAppDevice?: Maybe<Scalars['Boolean']['output']>;
  updateAccountType?: Maybe<AccountType>;
  updateActionFeature?: Maybe<ActionFeature>;
  updateAlertConfiguration?: Maybe<AlertConfiguration>;
  updateAllRolesFeatureHierarchyBulk?: Maybe<Scalars['Boolean']['output']>;
  updateAppPasswordAndShares?: Maybe<Scalars['Boolean']['output']>;
  updateAppraisalObjective?: Maybe<AppraisalObjecive>;
  updateAppraisalScale?: Maybe<AppraisalScale>;
  updateAppraisalType?: Maybe<AppraisalType>;
  updateApprovalWorkFlow?: Maybe<ApprovalWorkFlow>;
  updateAsset?: Maybe<Asset>;
  updateAssetBrand?: Maybe<AssetBrand>;
  updateAssetCategory?: Maybe<AssetCategory>;
  updateAssetModel?: Maybe<AssetModel>;
  updateAssetSubCategory?: Maybe<AssetSubCategory>;
  updateAttendancePermission?: Maybe<Scalars['Boolean']['output']>;
  updateAttendancePolicy?: Maybe<Scalars['Boolean']['output']>;
  updateAttendancePolicyInPreviousData?: Maybe<Scalars['Boolean']['output']>;
  updateAttendanceRegulation?: Maybe<AttendanceRegulation>;
  updateAttendanceRegulationApproval?: Maybe<Scalars['Boolean']['output']>;
  updateAuthenticatorApp?: Maybe<Authenticator>;
  updateBusiness?: Maybe<Business>;
  updateBusinessEmailTemplate?: Maybe<BusinessEmailTemplate>;
  updateBusinessForMSAttendance?: Maybe<Array<Maybe<MsAttendanceAllowedBusiness>>>;
  updateBusinessLocation?: Maybe<BusinessLocation>;
  updateBusinessPackage?: Maybe<Scalars['Boolean']['output']>;
  updateCashDrawer?: Maybe<CashRegisters>;
  updateCashRegister?: Maybe<CashRegisters>;
  updateChartOfAccount?: Maybe<ChartOfAccount>;
  updateCommentInTask?: Maybe<Scalars['Boolean']['output']>;
  updateCommisionCampaign?: Maybe<Scalars['Boolean']['output']>;
  updateCommission?: Maybe<Commission>;
  updateContractLicense?: Maybe<ContractLicense>;
  updateDepartment?: Maybe<Department>;
  updateDesignation?: Maybe<Designation>;
  updateDiscount?: Maybe<Scalars['Boolean']['output']>;
  updateDocumentControlAttachmentAssigning?: Maybe<DocumentControlAttachment>;
  updateDocumentToSign?: Maybe<Scalars['Boolean']['output']>;
  updateDutyRoster?: Maybe<Scalars['Boolean']['output']>;
  updateEmail?: Maybe<BusinessEmail>;
  updateEmailDeliveryRule?: Maybe<EmailDeliveryRule>;
  updateEmployeeADPId?: Maybe<Array<Maybe<EmployeeAdpResponse>>>;
  updateEmployeeDashboardView: EmployeeDashboardView;
  updateEmployeeDocument?: Maybe<User>;
  updateEmployeeGarnishment?: Maybe<EmployeeGarnishment>;
  /**
   * Recalculates pay_schedule_salary for every salaried employee in the business.
   * Omit business_id to default to the caller's own business.
   * Safe to call against any size tenant — processes employees in batches internally.
   */
  updateEmployeePayScheduleSalary?: Maybe<Scalars['Boolean']['output']>;
  updateEmployeeSeparation?: Maybe<EmployeeSeparation>;
  updateEmployeeVeiwCount?: Maybe<Scalars['Boolean']['output']>;
  updateEmployeesPictures?: Maybe<Scalars['Boolean']['output']>;
  updateEvaluation?: Maybe<AppraisalEvaluation>;
  updateExistingZipCode?: Maybe<Scalars['Boolean']['output']>;
  updateExpenseApproval?: Maybe<Scalars['Boolean']['output']>;
  updateExpenseInvoice?: Maybe<Scalars['Boolean']['output']>;
  updateExpenseInvoiceCategory?: Maybe<ExpenseCategory>;
  updateExpenseRequest?: Maybe<Expense>;
  updateExternalVendorTraining?: Maybe<ExternalVendorTraining>;
  updateFeedback?: Maybe<Feedback>;
  updateFilter?: Maybe<Filter>;
  updateFinalSettlement?: Maybe<FinalSettlement>;
  updateGiftCard?: Maybe<Scalars['Boolean']['output']>;
  updateGiftCardCategory?: Maybe<Scalars['Boolean']['output']>;
  updateGoal?: Maybe<Scalars['Boolean']['output']>;
  updateHRComplaint?: Maybe<HrComplaint>;
  updateHbsContentOfBusinessEmailTemplate?: Maybe<BusinessEmailTemplate>;
  updateInLineField?: Maybe<Scalars['Boolean']['output']>;
  updateInsurance?: Maybe<Insurance>;
  updateInterviewLog?: Maybe<ComplaintInterviewLog>;
  updateInvoice?: Maybe<Scalars['Boolean']['output']>;
  updateInvoiceItem?: Maybe<Scalars['Boolean']['output']>;
  updateLease?: Maybe<Lease>;
  updateLeasingCustomer: LeasingCustomer;
  updateLiveLocation?: Maybe<Scalars['Boolean']['output']>;
  updateLoanApproval?: Maybe<Scalars['Boolean']['output']>;
  updateMaintenance?: Maybe<Maintenance>;
  updateMarginTiers?: Maybe<MarginTiers>;
  updateMasterDataTypeValue?: Maybe<MasterDataValue>;
  updateMultiSchedules?: Maybe<UpdateMultipleScheduleRes>;
  updateMultipleAssetSubCategory?: Maybe<Scalars['Boolean']['output']>;
  updateMultipleWritupApproval?: Maybe<Scalars['Boolean']['output']>;
  updateNotification?: Maybe<Scalars['Boolean']['output']>;
  updateNotificationPermissions?: Maybe<Scalars['Boolean']['output']>;
  updateObjectiveAssignment?: Maybe<ObjectiveAssignment>;
  updateOrientationDetails?: Maybe<OrientationTracking>;
  updateOwnPersonalInformation?: Maybe<Scalars['Boolean']['output']>;
  updatePackage?: Maybe<Package>;
  updatePayrollDetailStatus?: Maybe<PayrollDetail>;
  updatePayrollStatus?: Maybe<Payroll>;
  updatePerformanceCycle?: Maybe<Scalars['Boolean']['output']>;
  updatePerformanceCycleStatus?: Maybe<Scalars['Boolean']['output']>;
  updatePopupStatus?: Maybe<Scalars['Boolean']['output']>;
  updatePreviousAttendancePolicyAndImplementWeekends?: Maybe<Scalars['Boolean']['output']>;
  updateProfilePictureForModels?: Maybe<Scalars['Boolean']['output']>;
  updateProfit_category?: Maybe<ProfitCategory>;
  updateQuickAsset?: Maybe<Scalars['Boolean']['output']>;
  updateQuiz?: Maybe<Scalars['Boolean']['output']>;
  updateQuizCategories?: Maybe<Scalars['Boolean']['output']>;
  updateQuizQuestion?: Maybe<Scalars['Boolean']['output']>;
  updateQuizTraining?: Maybe<Scalars['Boolean']['output']>;
  updateQuizTrainingAssignmentStatus?: Maybe<Scalars['Boolean']['output']>;
  updateQuizTrainingCategories?: Maybe<Scalars['Boolean']['output']>;
  updateQuizTrainingReplica?: Maybe<Scalars['Boolean']['output']>;
  updateReason?: Maybe<Reason>;
  updateRecordsZipCodeWise?: Maybe<Scalars['Boolean']['output']>;
  updateRegion?: Maybe<Region>;
  updateRegisterBusiness?: Maybe<Business>;
  updateRepairPrice?: Maybe<RepairPrice>;
  updateRepliesinCommmentTask?: Maybe<Scalars['Boolean']['output']>;
  updateReserveAsset: Scalars['Boolean']['output'];
  updateRole?: Maybe<Role>;
  updateSampleData?: Maybe<Scalars['Boolean']['output']>;
  updateSchedule?: Maybe<Scalars['Boolean']['output']>;
  updateSchedulesBreaksByDateRange?: Maybe<Scalars['Boolean']['output']>;
  updateServiceCategory?: Maybe<ServiceCategoryType>;
  updateSetupAlert?: Maybe<SetupAlert>;
  updateShareOfAuthenticatorApp?: Maybe<Authenticator>;
  updateShipTo?: Maybe<Scalars['Boolean']['output']>;
  updateShippingMethods?: Maybe<ShippingMethods>;
  updateStation?: Maybe<Station>;
  updateStoreToDutyRoster?: Maybe<RosterStores>;
  updateSubscriptionLogActivity?: Maybe<SubscriptionLogActivity>;
  updateTask?: Maybe<TaskManagement>;
  updateTaskAssignTo?: Maybe<TaskManagement>;
  updateTaskSectionWise?: Maybe<TaskManagement>;
  updateTaskStatus?: Maybe<TaskManagement>;
  updateTax?: Maybe<Tax>;
  updateTimeOff?: Maybe<TimeOff>;
  updateTimeOffApproval?: Maybe<Scalars['Boolean']['output']>;
  updateTraineStatus?: Maybe<Scalars['Boolean']['output']>;
  updateTrainingAssigneeAttachmentStatus?: Maybe<QuizTrainingAssignementListResult>;
  updateTrainingAssigneeLinkStatus?: Maybe<QuizTrainingAssignementListResult>;
  updateTrainingMatrix?: Maybe<TrainingMatrix>;
  updateTrainingSettings?: Maybe<TrainingSettings>;
  updateTransactWholeFieldInAsset?: Maybe<Scalars['Boolean']['output']>;
  updateUserAppDevice?: Maybe<Scalars['Boolean']['output']>;
  updateUserAssignedRoles?: Maybe<Scalars['Boolean']['output']>;
  updateUserAttachmentStatus?: Maybe<MyQuizTrainingLists>;
  updateUserEmailStatus?: Maybe<Scalars['Boolean']['output']>;
  updateUserPassword?: Maybe<Scalars['Boolean']['output']>;
  updateUserPhoneStatus?: Maybe<Scalars['Boolean']['output']>;
  updateUserProfile?: Maybe<User>;
  updateUserSystemToken?: Maybe<User>;
  updateUsersEncryptionKeys?: Maybe<Scalars['Boolean']['output']>;
  updateVendor?: Maybe<Vendor>;
  updateWriteUp?: Maybe<WriteUp>;
  updateWriteUpApproval?: Maybe<Scalars['Boolean']['output']>;
  uploadAssetDocs?: Maybe<Scalars['Boolean']['output']>;
  uploadDocumentControlAttachment?: Maybe<DocumentControlAttachment>;
  uploadFileDocumentControlAttachment?: Maybe<DocumentControlAttachment>;
  uploadLocationImage: Scalars['Boolean']['output'];
  upsertOrgChartSettings?: Maybe<OrgChartSettings>;
  userBreakedIn?: Maybe<BreakClockedHistory>;
  userClockedIn?: Maybe<ClockedHistory>;
  userForgetPassword?: Maybe<Scalars['Boolean']['output']>;
  userPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  userPinCodeVerify?: Maybe<UserCLocked>;
  verifyEmailOTP?: Maybe<EmailOtp>;
  verifyPhoneOTP?: Maybe<PhoneOtp>;
  verifySSNAndSendOTP?: Maybe<Scalars['Boolean']['output']>;
  verifyTranslation?: Maybe<Scalars['Boolean']['output']>;
  workingTimeWagesCalculate?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationMarkNotificationsAsClearedArgs = {
  _ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationUpdateAllRoleAndPermissionOfUserArgs = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateNameOfEmployeesFolderArgs = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAcceptRejectBusinessRequestArgs = {
  input?: InputMaybe<ChangeRequestStatusInput>;
};


export type MutationAddCaseWitnessArgs = {
  complaint_id: Scalars['ID']['input'];
  input: WitnessComplaintInput;
};


export type MutationAddContractLicenseArgs = {
  input: ContractLicenseInput;
};


export type MutationAddCustomLocationArgs = {
  input: CustomLocationInput;
};


export type MutationAddDelegantEmployeeArgs = {
  input: DelegantApprovalMutationInput;
};


export type MutationAddDocumentToSignArgs = {
  input?: InputMaybe<AddDocument>;
};


export type MutationAddEmployeeIntoBusinessesArgs = {
  input?: InputMaybe<AddEmployeeIntoBusinessInput>;
};


export type MutationAddEmployeeToAattendancePolicyArgs = {
  employee_id: Scalars['ID']['input'];
  policy_id: Scalars['ID']['input'];
};


export type MutationAddFeedbackConversationArgs = {
  input: AddConversationInput;
};


export type MutationAddGuarantorForPasswordArgs = {
  employees: Array<Scalars['ID']['input']>;
};


export type MutationAddHrNoteArgs = {
  complaint_id: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};


export type MutationAddInsuranceArgs = {
  input: InsuranceInput;
};


export type MutationAddInterviewLogArgs = {
  complaint_id: Scalars['ID']['input'];
  input: AddInterviewLogInput;
};


export type MutationAddLeaseArgs = {
  input?: InputMaybe<LeaseInput>;
};


export type MutationAddLeasingCustomerArgs = {
  input: LeasingCustomerInput;
};


export type MutationAddMaintenanceArgs = {
  input?: InputMaybe<MaintenanceInput>;
};


export type MutationAddManualShortBreaksArgs = {
  input: AddManualShortBreaksInput;
};


export type MutationAddMarginTiersArgs = {
  input?: InputMaybe<InputTypeMarginTiers>;
};


export type MutationAddNewFolderDocumentControlArgs = {
  input: AddNewFolderDocumentControl;
};


export type MutationAddNewHbsContentToBusinessEmailTemplateArgs = {
  hbs_template: HbsTemplateCreateInput;
  template_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddNewPaymentMethodCustomerArgs = {
  input?: InputMaybe<PaymentMethod>;
};


export type MutationAddOrRemoveEmployeeInRoleArgs = {
  input: AddEmployee;
};


export type MutationAddPasswordManagerAdminArgs = {
  employee: Scalars['ID']['input'];
};


export type MutationAddProfitCategoryArgs = {
  input?: InputMaybe<InputProfitCategory>;
};


export type MutationAddReasonArgs = {
  input?: InputMaybe<InputReason>;
};


export type MutationAddRepairPriceArgs = {
  input?: InputMaybe<InputRepairPrice>;
};


export type MutationAddRosterCommentArgs = {
  input?: InputMaybe<RosterCommentInput>;
};


export type MutationAddShippingMethodsArgs = {
  input?: InputMaybe<InputBagShipping>;
};


export type MutationAddShortBreakArgs = {
  input?: InputMaybe<UserShortBreak>;
};


export type MutationAddStoreToDutyRosterArgs = {
  business: Scalars['ID']['input'];
  business_location: Scalars['ID']['input'];
  time_zone: Scalars['String']['input'];
};


export type MutationAddUpdateTerminalDeviceArgs = {
  input: AddTerminalAppInput;
};


export type MutationAddUserRadiusArgs = {
  radius?: InputMaybe<Scalars['Float']['input']>;
  time_interval?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationAddVendorArgs = {
  input?: InputMaybe<InputBagVendor>;
};


export type MutationAddWeekendAndPublicHolidayOnTimeSheetArgs = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationAdjustLeaveBalanceArgs = {
  input: AdjustLeaveBalanceInput;
};


export type MutationAllowAttendanceArgs = {
  _id: Scalars['ID']['input'];
  is_allow: Scalars['Boolean']['input'];
};


export type MutationArchiveAccountTypeArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationArchiveAdvanceFilterArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationArchiveAllowanceArgs = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationArchiveAppraisalObjectiveArgs = {
  _id: Array<Scalars['ID']['input']>;
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveAppraisalScaleArgs = {
  _id: Array<Scalars['ID']['input']>;
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveApprovalWorkFlowArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveAssetArgs = {
  _id?: InputMaybe<Array<Scalars['ID']['input']>>;
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveAssetBrandArgs = {
  _id?: InputMaybe<Array<Scalars['ID']['input']>>;
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveAssetCategoryArgs = {
  _id?: InputMaybe<Array<Scalars['ID']['input']>>;
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveAssetModelArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveAssetSubCategoryArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveAttandencePolicyArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveAttendanceArgs = {
  input: ArchiveInput;
};


export type MutationArchiveAttendanceRegulationArgs = {
  _id?: InputMaybe<Array<Scalars['ID']['input']>>;
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveBusinessArgs = {
  archive: Scalars['Boolean']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationArchiveBusinessEmailTemplateArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveBusinessLocationArgs = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationArchiveCashRegisterArgs = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationArchiveContractLicenseArgs = {
  _id?: InputMaybe<Array<Scalars['ID']['input']>>;
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveDocumentControlArgs = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  id: Array<Scalars['ID']['input']>;
};


export type MutationArchiveEmailDeliveryRuleArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveEmployeeArgs = {
  archive: Scalars['Boolean']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  proceed: Scalars['Boolean']['input'];
};


export type MutationArchiveEmployeeDashboardViewArgs = {
  archive: Scalars['Boolean']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationArchiveEmployeeDocumentArgs = {
  document_id: Scalars['ID']['input'];
  employee_id: Scalars['ID']['input'];
};


export type MutationArchiveEmployeeGarnishmentArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveEmployeeHistoryArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveExpenseArgs = {
  archive: Scalars['Boolean']['input'];
  archiveExpenseId?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationArchiveExpenseInvoiceArgs = {
  input?: InputMaybe<ArchiveInvoiceInput>;
};


export type MutationArchiveExpenseInvoiceCategoryArgs = {
  input?: InputMaybe<ArchiveInvoiceInput>;
};


export type MutationArchiveFilterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveFinalSettlementArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveGiftCardCategoryArgs = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationArchiveGiftCardCategoryTemplateArgs = {
  id: Scalars['ID']['input'];
  templateUrl: Scalars['String']['input'];
};


export type MutationArchiveGratuityArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationArchiveInsuranceArgs = {
  _id?: InputMaybe<Array<Scalars['ID']['input']>>;
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveInvoiceArgs = {
  input?: InputMaybe<ArchiveInvoiceInput>;
};


export type MutationArchiveLeavePolicyByIdArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveLeaveTypeByIdArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveLoanArgs = {
  archive: Scalars['Boolean']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationArchiveLoanTransactionArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveMaintenanceArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveMedicalInsuranceArgs = {
  input?: InputMaybe<ArchiveMedicalInsuranceInput>;
};


export type MutationArchiveMedicalInsurancePackageArgs = {
  input?: InputMaybe<ArchiveMedicalInsurancepackageInput>;
};


export type MutationArchiveObjectiveAssignmentArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationArchivePackageArgs = {
  archive: Scalars['Boolean']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationArchivePaymentMethodArgs = {
  card_id: Scalars['ID']['input'];
  customer_id: Scalars['ID']['input'];
};


export type MutationArchivePayrollScheduleArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationArchivePayrollStructureArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationArchivePlaidCategoriesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchivePublicHolidaysArgs = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationArchiveRoleArgs = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationArchiveRosterArgs = {
  input?: InputMaybe<ArchiveRosterByTypeInput>;
};


export type MutationArchiveRosterCommentArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationArchiveShiftArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationArchiveStoreFromDutyRosterArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationArchiveSubscriptionAttachmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationArchiveSubscriptionLogActivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveTaskArgs = {
  archive: Scalars['Boolean']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationArchiveTemplateArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationArchiveUnArchiveCashRegistersHistoryArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationArchiveUnarchiveQuizArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveUnarchiveQuizCategoryArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveUnarchiveQuizCategorySectionArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveUnarchiveQuizQuestionArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveUnarchiveQuizTrainingCategoryArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveUnarchiveQuizTrainingSubCategoryArgs = {
  input?: InputMaybe<DeleteSubCategoryInput>;
};


export type MutationArchiveUnarchiveQuizTraningArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveUnarchiveQuizTraningReplicaArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveUserAppDeviceArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchivedTaxArgs = {
  _id: Scalars['ID']['input'];
  archive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAssetAlertConfigurationArgs = {
  input: AlertConfigurationInput;
};


export type MutationAssignAattendancePolicyToEmployeeArgs = {
  employee_id: Array<InputMaybe<Scalars['ID']['input']>>;
  policy_id: Scalars['ID']['input'];
};


export type MutationAssignInvestigatorArgs = {
  complaint_id: Scalars['ID']['input'];
  investigator_id: Scalars['ID']['input'];
};


export type MutationAssignLeavePolicyToEmployeeArgs = {
  input: AssignLeavePolicyInput;
};


export type MutationAssignPackageToSubscriptionArgs = {
  package: Scalars['ID']['input'];
  subscription: Scalars['ID']['input'];
};


export type MutationAssignQuizArgs = {
  assignTo: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAssignRoleToEmployeeArgs = {
  input?: InputMaybe<AssignRoleInput>;
};


export type MutationAssignScheduleToEmployeesArgs = {
  input: AssignInput;
};


export type MutationAssignUsersToQuizAndTrainingArgs = {
  input: AssignUsersToQuizAndTrainingInput;
  trainingId: Scalars['ID']['input'];
};


export type MutationAssigneeFilterByStatusArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TrainingAssignStatus>;
};


export type MutationAttemptQuizAssignmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<AttemptInput>;
};


export type MutationAttendancePolicyArgs = {
  input?: InputMaybe<HrPolicyInput>;
};


export type MutationAuthenticateNewDomainArgs = {
  input: DomainAuthenticationInput;
};


export type MutationBackPayToEmployeeArgs = {
  input: BackPayInput;
};


export type MutationCampaignStatusChangedArgs = {
  campaign_id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCancelBusinessPackageArgs = {
  business: Scalars['ID']['input'];
};


export type MutationChangeBusinessOwnerPasswordArgs = {
  input?: InputMaybe<UpdateBusinessOwnerPasswordInput>;
};


export type MutationChangeComplaintStatusArgs = {
  complaint_id: Scalars['ID']['input'];
  status: ComplaintStatus;
};


export type MutationChangeConfigColumnVisibilityArgs = {
  column_id: Array<InputMaybe<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
};


export type MutationChangeDocumentControlAttachmentFolderArgs = {
  id: Scalars['ID']['input'];
  newParentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationChangeEmployeeAttendancePolicyArgs = {
  input: ChangePolicyInput_;
};


export type MutationChangeEmployeeLeavePackageArgs = {
  input: ChangeLeavePolicyInput;
};


export type MutationChangeEmployeeLeavePolicyArgs = {
  input: ChangePolicyInput;
};


export type MutationChangeLocationOfDocumentDeletedParentArgs = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  newParentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationChangeRecruitmentStatusArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<RecruitmentStatusEnum>;
};


export type MutationChangeRoleParentArgs = {
  _id: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};


export type MutationChangeSharingStatusOrRemoveShareArgs = {
  input?: InputMaybe<ChangeshareStatusInput>;
};


export type MutationChangeSubscriptionAttachmentFolderArgs = {
  id: Scalars['ID']['input'];
  newParentId: Scalars['ID']['input'];
};


export type MutationChangeSubsriptionStatusArgs = {
  id: Scalars['ID']['input'];
  status: AllowedSubscriptionStatus;
};


export type MutationChangeTaskActionArgs = {
  input: TimeLogInput;
};


export type MutationCheckAuthenticatedUserArgs = {
  business_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type MutationCheckInAssetsArgs = {
  input: CheckInAssetInput;
};


export type MutationCheckerQuizAssignmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<CheckerInput>;
};


export type MutationCheckoutAssetsArgs = {
  input: CheckoutAssetInput;
};


export type MutationClearDutyRosterArgs = {
  input: Array<InputMaybe<ArchiveRosterInput>>;
};


export type MutationCloneRoleArgs = {
  input: CloneRoleInput;
};


export type MutationCommission_CompaingStatusChangedArgs = {
  campaign_id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCommission_StatusChangedArgs = {
  campaign_id: Scalars['ID']['input'];
  commission_id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationConnectSendgridAccountArgs = {
  input: SendgridAccountInput;
};


export type MutationCopyAuthenticatorAppArgs = {
  input?: InputMaybe<CopyAuthenticatorAppInput>;
};


export type MutationCopyDocumentControlAttachmentFolderArgs = {
  id: Scalars['ID']['input'];
  newParentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCopyRolePermissionsArgs = {
  input?: InputMaybe<CopyPermissionInput>;
};


export type MutationCopyScheduleArgs = {
  input: CopyScheduleInput;
};


export type MutationCopyScheduleByDateArgs = {
  input: CopyScheduleByDateInput;
};


export type MutationCopyScheduleDifferentDateArgs = {
  input: CopyScheduleDifferentDateInput;
};


export type MutationCopyScheduleEmployeeToEmployeesArgs = {
  input: CopyScheduleEmpInput;
};


export type MutationCopyScheduletoNextWeekArgs = {
  input: NextWeekInput;
};


export type MutationCopyScheduletoSelectDateArgs = {
  input?: InputMaybe<CopyScheduleSelectedDate>;
};


export type MutationCreateAccountTypeArgs = {
  input: AccountTypeInput;
};


export type MutationCreateActionFeatureArgs = {
  input: ActionFeatureInput;
};


export type MutationCreateActivityGroupArgs = {
  input?: InputMaybe<CreateGroupInput>;
};


export type MutationCreateAdvanceFilterArgs = {
  input: InputCreateAdvanceFilter;
};


export type MutationCreateAndMapPlaidCategoriesArgs = {
  input?: InputMaybe<PlaidCategoriesInput>;
};


export type MutationCreateAppraisalObjectiveArgs = {
  input: CreateAppraisalObjecive;
};


export type MutationCreateAppraisalScaleArgs = {
  input: AddAppraisalScale;
};


export type MutationCreateAppraisalTypeArgs = {
  input: InputAppraisalType;
};


export type MutationCreateApprovalWorkFlowArgs = {
  input: WorkFlowInput;
};


export type MutationCreateAssetArgs = {
  input: AssetInput;
};


export type MutationCreateAssetBrandArgs = {
  brand_name: Scalars['String']['input'];
};


export type MutationCreateAssetCategoryArgs = {
  input: CreateAssetCategoryInput;
};


export type MutationCreateAssetCategoryOrSubCategoryArgs = {
  input?: InputMaybe<CreateAssetCategoryOrSubCategoryInput>;
};


export type MutationCreateAssetModelArgs = {
  AssetBrand: Scalars['ID']['input'];
  models?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateAssetSubCategoryArgs = {
  input: CreateAssetSubCategoryInput;
};


export type MutationCreateAttendanceRegulationArgs = {
  input: InputCreateAttendance;
};


export type MutationCreateAuthenticatorAppThroughQrArgs = {
  input?: InputMaybe<CreateAppInputOtp>;
};


export type MutationCreateAuthenticatorAppWithoutOtpArgs = {
  input?: InputMaybe<CreateAppInputWithoutOtp>;
};


export type MutationCreateAuthenticatorGroupArgs = {
  input?: InputMaybe<CreateAuthenticatorGroupInput>;
};


export type MutationCreateBusinessArgs = {
  input?: InputMaybe<CreateBusinessInput>;
};


export type MutationCreateBusinessEmailTemplateArgs = {
  input: BusinessEmailTemplateInput;
};


export type MutationCreateBusinessLocationArgs = {
  input: BusinessLocationInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCashRegisterArgs = {
  input?: InputMaybe<CashRegisterInput>;
};


export type MutationCreateCashRegistersHistoryArgs = {
  input: CashRegistersHistoryInput;
};


export type MutationCreateCategoryArgs = {
  input: CategoryInput;
};


export type MutationCreateChartOfAccountArgs = {
  input: ChartOfAccountsInput;
};


export type MutationCreateChatTenantAndUsersArgs = {
  businessId: Scalars['ID']['input'];
};


export type MutationCreateCityArgs = {
  input: CityInput;
};


export type MutationCreateCommentArgs = {
  input: CommentInput;
};


export type MutationCreateCommisionCampaignArgs = {
  input?: InputMaybe<CommisionCampaignInput>;
};


export type MutationCreateCommissionArgs = {
  input?: InputMaybe<CommissionInput>;
};


export type MutationCreateCompensationTimeOffArgs = {
  input?: InputMaybe<CreateCompasationLeaveInput>;
};


export type MutationCreateDeductionArgs = {
  input?: InputMaybe<DeductionInput>;
};


export type MutationCreateDefaultEmployeeActionArgs = {
  business: Scalars['ID']['input'];
};


export type MutationCreateDefaultTemplateArgs = {
  input: DefaultTemplateInput;
};


export type MutationCreateDepartmentArgs = {
  input: DepartmentInput;
};


export type MutationCreateDesignationArgs = {
  input: DesignationsInput;
};


export type MutationCreateDetailTypeArgs = {
  input?: InputMaybe<DetailTypeInput>;
};


export type MutationCreateDiscountArgs = {
  input: DiscountInput;
};


export type MutationCreateDocumentControlAttachmentArgs = {
  input: AddDocumentInput;
};


export type MutationCreateDutyRosterArgs = {
  input: RosterInput;
};


export type MutationCreateDutyRosterForcefullyArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateRosterForcefully>>>;
};


export type MutationCreateEmailDeliveryRuleArgs = {
  input?: InputMaybe<EmailDeliveryRuleInput>;
};


export type MutationCreateEmailOtpArgs = {
  input?: InputMaybe<EmailOtpInput>;
};


export type MutationCreateEmployeeDashboardViewArgs = {
  input: CreateEmployeeDashboardViewInput;
};


export type MutationCreateEmployeeGarnishmentArgs = {
  input?: InputMaybe<EmployeeGarnishmentInput>;
};


export type MutationCreateEmployeeSeparationArgs = {
  input?: InputMaybe<EmployeeSeparationInput>;
};


export type MutationCreateEncryptionCopiesArgs = {
  input?: InputMaybe<UserEncryptionCopiesInput>;
};


export type MutationCreateEvaluationArgs = {
  input?: InputMaybe<CreateEvaluationInput>;
};


export type MutationCreateExpenseInvoiceArgs = {
  input: CreateExpenseInvoice;
};


export type MutationCreateExpenseInvoiceAndCategoryArgs = {
  input: CreateExpenseInvoice;
};


export type MutationCreateExpenseInvoiceCategoryArgs = {
  input: CreateExpenseInvoiceCategory;
};


export type MutationCreateExpenseRequestArgs = {
  input: InputCreateExpenseRequest;
};


export type MutationCreateExternalVendorTrainingArgs = {
  input: CreateExternalVendorTrainingInput;
};


export type MutationCreateFeedbackArgs = {
  input: CreateFeedbackInput;
};


export type MutationCreateFileUrlArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationCreateFilterArgs = {
  input: SaveFilterInput;
};


export type MutationCreateFinalSettlementArgs = {
  input: InputFinalSettlement;
};


export type MutationCreateGiftCardArgs = {
  input: GiftCardInput;
};


export type MutationCreateGoalArgs = {
  input?: InputMaybe<GoalsInput>;
};


export type MutationCreateHrComplaintArgs = {
  input: CreateHrComplaintInput;
};


export type MutationCreateInvoiceArgs = {
  input: InvoiceInput;
};


export type MutationCreateInvoiceItemArgs = {
  input: InvoiceItemInput;
};


export type MutationCreateLoanAdjustmentArgs = {
  input: InputAdjustment;
};


export type MutationCreateLoanRequestArgs = {
  input: InputLoanRequest;
};


export type MutationCreateLoanTransactionArgs = {
  input: InputTransaction;
};


export type MutationCreateMasterDataTypeArgs = {
  input: DataTypeInput;
};


export type MutationCreateMasterDataTypeValueArgs = {
  input: DataTypeValueInput;
};


export type MutationCreateMedicalInsuranceArgs = {
  medical_insurance_name: Scalars['String']['input'];
};


export type MutationCreateMultiInvoiceItemArgs = {
  input?: InputMaybe<MultiInvoiceItemInput>;
};


export type MutationCreateNewEmailArgs = {
  BusinessDomain: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};


export type MutationCreateNotificationPermissionForBusinessArgs = {
  business_id: Scalars['ID']['input'];
};


export type MutationCreateObjectiveAssignmentArgs = {
  input?: InputMaybe<CreateInputObjectiveAssignment>;
};


export type MutationCreatePackageArgs = {
  input: PackageInput;
};


export type MutationCreatePerformanceCycleArgs = {
  input?: InputMaybe<PerformanceCycleInput>;
};


export type MutationCreatePhoneOtpArgs = {
  input?: InputMaybe<PhoneOtpInput>;
};


export type MutationCreateQuickAssetArgs = {
  input?: InputMaybe<CreateAssetInput>;
};


export type MutationCreateQuizArgs = {
  input: CreateQuizInput;
};


export type MutationCreateQuizCategoriesArgs = {
  input: CreateCategoriesInput;
};


export type MutationCreateQuizQuestionArgs = {
  input: CreateQuestionInput;
};


export type MutationCreateQuizTarainingCategoriesArgs = {
  input: TrainingCategoriesInput;
};


export type MutationCreateQuizTrainingArgs = {
  input: CreateTrainingInput;
};


export type MutationCreateReasonArgs = {
  input?: InputMaybe<ReasonInput>;
};


export type MutationCreateRefresherCycleArgs = {
  input?: InputMaybe<CreateRefresherCycleInput>;
};


export type MutationCreateRegionArgs = {
  input: CreateRegionInput;
};


export type MutationCreateReminderForNotificationArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationCreateRepliesinCommmentTaskArgs = {
  input: CreateRepliesCommentInput;
};


export type MutationCreateRocketChatUserFromChatArgs = {
  input?: InputMaybe<CreateRocketChatUserInput>;
};


export type MutationCreateRoleArgs = {
  input?: InputMaybe<RoleInput>;
};


export type MutationCreateRosterByScheduleTemplateArgs = {
  input: CreateRosterByTemplate;
};


export type MutationCreateSampleDataArgs = {
  business_id: Scalars['ID']['input'];
  input: Array<CreateSampleDataInput>;
};


export type MutationCreateScheduleArgs = {
  input: SchduleInput;
};


export type MutationCreateSchedulesFromTimeSheetArgs = {
  break_type?: InputMaybe<Scalars['ID']['input']>;
  file: Scalars['Upload']['input'];
};


export type MutationCreateServiceCategoryArgs = {
  category_name: Scalars['String']['input'];
};


export type MutationCreateSetupAlertArgs = {
  input?: InputMaybe<InputCreateSetupAlert>;
};


export type MutationCreateShipToArgs = {
  input: CreateShipTo;
};


export type MutationCreateStateArgs = {
  input: StateInput;
};


export type MutationCreateStationArgs = {
  input: StationInput;
};


export type MutationCreateSubscriptionAttachmentArgs = {
  input: InputCreateAttachment;
};


export type MutationCreateSubscriptionLogActivityArgs = {
  input: InputCreateLogActivity;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTaxArgs = {
  input: TaxInput;
};


export type MutationCreateTimeOffArgs = {
  input?: InputMaybe<CreateTimeOffInput>;
};


export type MutationCreateTrainingMatrixArgs = {
  input: TrainingMatrixInput;
};


export type MutationCreateUpdateAllowanceArgs = {
  input?: InputMaybe<InputAllowances>;
};


export type MutationCreateUpdateAttendanceArgs = {
  input: InputAttendance;
};


export type MutationCreateUpdateAttendanceRequestArgs = {
  input: AttendanceInput;
};


export type MutationCreateUpdateConfigListingArgs = {
  input?: InputMaybe<ConfigListingInput>;
};


export type MutationCreateUpdateContributionArgs = {
  input?: InputMaybe<ContributionInput>;
};


export type MutationCreateUpdateEmployeeArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  business_id: Scalars['ID']['input'];
  input: CreateUpdateEmployeeInput;
};


export type MutationCreateUpdateExpenseArgs = {
  input: InputExpense;
};


export type MutationCreateUpdateGratuityArgs = {
  input?: InputMaybe<GratuityInput>;
};


export type MutationCreateUpdateLeavePolicyArgs = {
  input: LeavePolicyInput;
};


export type MutationCreateUpdateLeaveTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: InputLeaveType;
};


export type MutationCreateUpdateLoanArgs = {
  input: InputLoan;
};


export type MutationCreateUpdateMedicalInsurancePackageArgs = {
  input?: InputMaybe<MedicalInsurancePackageInput>;
};


export type MutationCreateUpdateMultiStoreCustomFieldArgs = {
  customFieldType: CustomFieldTypeEnum;
  input?: InputMaybe<Array<InputMaybe<MultiCustomFieldTypeInput>>>;
  location_id: Scalars['ID']['input'];
};


export type MutationCreateUpdateMultipleActionActivityArgs = {
  input: AddDocumentInput;
};


export type MutationCreateUpdatePayrollScheduleArgs = {
  input?: InputMaybe<PayrollScheduleInput>;
};


export type MutationCreateUpdatePayrollStructureArgs = {
  input?: InputMaybe<PayrollStructureInput>;
};


export type MutationCreateUpdateProductattributesArgs = {
  input?: InputMaybe<ProductAttributeInput>;
};


export type MutationCreateUpdatePublicHolidaysArgs = {
  input?: InputMaybe<InputPublicHolidays>;
};


export type MutationCreateUpdateRecruitmentEmployeeArgs = {
  input?: InputMaybe<RecruitmentInput>;
};


export type MutationCreateUpdateReserveAssetColorArgs = {
  input: InputReserveAssetColor;
};


export type MutationCreateUpdateSchedulerConfigArgs = {
  input: SchedulerConfigInput;
};


export type MutationCreateUpdateShiftArgs = {
  input?: InputMaybe<ShiftInput>;
};


export type MutationCreateUpdateShortLeaveArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: ShortLeaveInput;
};


export type MutationCreateUpdateStoreCustomFieldArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  customFieldType: CustomFieldTypeEnum;
  input?: InputMaybe<CustomFieldTypeInput>;
  location_id: Scalars['ID']['input'];
};


export type MutationCreateUpdateTablePresetArgs = {
  input?: InputMaybe<CreateInputTablePreset>;
};


export type MutationCreateUpdateTimeOffRequestArgs = {
  input: CreateUpdateTimeOffRequestInput;
};


export type MutationCreateUpdatepaidUnPaidArgs = {
  input?: InputMaybe<PaidUnPaidInput>;
};


export type MutationCreateUserAppDeviceArgs = {
  input: InputUserAppDevice;
};


export type MutationCreateWeekendsArgs = {
  input: CreateWeekendsInput;
};


export type MutationCreateWriteUpArgs = {
  input?: InputMaybe<WriteUpInput>;
};


export type MutationCreatecommentOnTaskArgs = {
  input: CreateCommentInput;
};


export type MutationCustomGradeArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDefaultServicesConfigurationArgs = {
  input: ServiceConfigInput;
};


export type MutationDeleteAppraisalTypeArgs = {
  archive: Scalars['Boolean']['input'];
  id: Array<Scalars['ID']['input']>;
};


export type MutationDeleteAuthenticatorAppArgs = {
  Ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  deleteChildren?: InputMaybe<Scalars['Boolean']['input']>;
  group_type?: InputMaybe<Group_Type>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteCaseWitnessArgs = {
  complaint_id: Scalars['ID']['input'];
  witness_id: Scalars['ID']['input'];
};


export type MutationDeleteChartOfAccountArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteCommentInTaskArgs = {
  comment_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
};


export type MutationDeleteCommissionArgs = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteConfigListingArgs = {
  listName: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteDepartmentArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationDeleteDesignationArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationDeleteDiscountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocFromAssetArgs = {
  assetId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeSeparationArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationDeleteExternalVendorTrainingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeedbackArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteGoalArgs = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDeleteHrComplaintArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteHrNoteArgs = {
  complaint_id: Scalars['ID']['input'];
  note_id: Scalars['ID']['input'];
};


export type MutationDeleteInterviewLogArgs = {
  interview_id: Scalars['ID']['input'];
};


export type MutationDeleteLoanAdjustmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMarginTiersArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteMasterDataTypeValueArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteMultiScheduleArgs = {
  input?: InputMaybe<MultiScheduleDeleteInput>;
};


export type MutationDeleteNewScheduleAndPreviewOldScheduleArgs = {
  input?: InputMaybe<PreviewOldScheduleInput>;
};


export type MutationDeleteNotificationArgs = {
  _ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationDeleteNotificationsForBusinessAndUserArgs = {
  business_id: Scalars['ID']['input'];
  employeeId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationDeleteObjectiveAssignmentNestedDataArgs = {
  _id: Scalars['ID']['input'];
  objectiveId: Scalars['ID']['input'];
};


export type MutationDeletePerformanceCycleArgs = {
  archive: Scalars['Boolean']['input'];
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationDeletePermissionsArgs = {
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteProductattributesArgs = {
  id: Scalars['ID']['input'];
  type: ProductAttributeTypes;
};


export type MutationDeleteProfitCategoryArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteReasonArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteRecruitmentArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteRefresherCycleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRegionArgs = {
  archive: Scalars['Boolean']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDeleteRepairPriceArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteRepliesinCommmentTaskArgs = {
  comment_id: Scalars['ID']['input'];
  reply_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  input: ArchiveRoleData;
};


export type MutationDeleteRostersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteScheduleArgs = {
  ids: Array<Scalars['ID']['input']>;
  notify_by_email: Scalars['Boolean']['input'];
};


export type MutationDeleteShipToArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShippingMethodsArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationDeleteShortLeaveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStationArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationDeleteStoreCustomFieldArgs = {
  customFieldId: Scalars['ID']['input'];
  customFieldType: CustomFieldTypeEnum;
  location_id: Scalars['ID']['input'];
};


export type MutationDeleteSubscriptionRequestArgs = {
  archive: Scalars['Boolean']['input'];
  id: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDeleteTablePresetArgs = {
  input?: InputMaybe<DeleteInputTablePreset>;
};


export type MutationDeleteTimeOffArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDeleteTrainingMatrixByIdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVendorArgs = {
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
};


export type MutationDeleteWriteUpArgs = {
  archive: Scalars['Boolean']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDeletecontributionArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeletedeductionArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeletepaidUnPaidArgs = {
  _id: Scalars['ID']['input'];
  archive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDetectContractFromAssetArgs = {
  assetId: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  contractName: Scalars['String']['input'];
};


export type MutationDetectInsuranceFromAssetArgs = {
  assetId: Scalars['ID']['input'];
  insuranceId: Scalars['ID']['input'];
  insuranceName: Scalars['String']['input'];
};


export type MutationDiscountStatusChangedArgs = {
  campaign_id: Scalars['ID']['input'];
  discount_id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDisposedAssetArgs = {
  input?: InputMaybe<DisposedInput>;
};


export type MutationEditAuthenticatorGroupArgs = {
  input?: InputMaybe<EditAuthenticatorGroupInput>;
};


export type MutationEditBusinessEmployeeArgs = {
  input?: InputMaybe<EditBusinessEmployeeInput>;
};


export type MutationEditCaseWitnessArgs = {
  complaint_id: Scalars['ID']['input'];
  input: WitnessComplaintInput;
  witness_id: Scalars['ID']['input'];
};


export type MutationEditMedicalInsuranceArgs = {
  input?: InputMaybe<MedicalInsuranceInput>;
};


export type MutationEmailScheduleToEmployeeArgs = {
  input: EmailScheduleInput;
};


export type MutationEmployeeClockedInStatusArgs = {
  employeeId: Scalars['ID']['input'];
};


export type MutationEmployeeRecentFileViewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateFolderAndSubfolderForBusinessArgs = {
  business: Scalars['ID']['input'];
};


export type MutationGenerateUniqueAssetIdArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetBusinessOwnerDataArgs = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationGetEmployeesAttendanceListArgs = {
  input: InputAttendanceList;
};


export type MutationGetLoggedInUserDetailArgs = {
  app_type?: InputMaybe<Application_Type>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_token?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationGoalStatusChangedArgs = {
  goal_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportCityStateDataArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportEmployeesScheduleforMsFromClockingTimeArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportEmployeesforMsArgs = {
  ceoRoleId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  policy: Scalars['ID']['input'];
};


export type MutationImportProductAttributeMasterDataTypeValueArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportRepairPriceArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportScheduleCsvArgs = {
  file: Scalars['Upload']['input'];
  minimum_break_percentage?: InputMaybe<Scalars['Int']['input']>;
  schedule_From: Scalars['String']['input'];
  schedule_To: Scalars['String']['input'];
};


export type MutationImportSchedulesArgs = {
  break_type: Scalars['ID']['input'];
  create_timesheet: Scalars['Boolean']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationImportTimeSheetArgs = {
  break_type?: InputMaybe<Scalars['ID']['input']>;
  file: Scalars['Upload']['input'];
  is_create_schedule: Scalars['Boolean']['input'];
};


export type MutationIntegrateRosterIntoScheduleArgs = {
  end_date: Scalars['DateTime']['input'];
  start_date: Scalars['DateTime']['input'];
};


export type MutationLinkBusinessesArgs = {
  input?: InputMaybe<LinkBusinessesInput>;
};


export type MutationLinkContractsWithAssetArgs = {
  assetId: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  contractName: Scalars['String']['input'];
};


export type MutationLinkInsuranceWithAssetArgs = {
  assetId: Scalars['ID']['input'];
  insuranceId: Scalars['ID']['input'];
  insuranceName: Scalars['String']['input'];
};


export type MutationLinkParentOrChildAssetWithAssetArgs = {
  input: Array<InputMaybe<LinkingRelationAsset>>;
};


export type MutationLoginToOtherBusinessArgs = {
  input?: InputMaybe<LoginToOtherBusinessInput>;
};


export type MutationLoginWithEmailArgs = {
  app_type?: InputMaybe<Application_Type>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_token?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  password: Scalars['String']['input'];
};


export type MutationLoginWithZitadelCodeArgs = {
  input?: InputMaybe<LoginWithZetadelInput>;
};


export type MutationLogoutArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationMakeScreenAsDefaultArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkAllAsReadArgs = {
  input?: InputMaybe<MarkAsReadInput>;
};


export type MutationMarkRespondentNotifiedArgs = {
  complaint_id: Scalars['ID']['input'];
  is_notified: Scalars['Boolean']['input'];
};


export type MutationMoveAccessoriesToAssetArgs = {
  accessoryId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationMoveAssetArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<MoveAssetInput>;
};


export type MutationMoveAssetFromLocationToLocationArgs = {
  assetId: Scalars['ID']['input'];
  site?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationOverrideSeverityArgs = {
  complaint_id: Scalars['ID']['input'];
  severity: ComplaintSeverity;
};


export type MutationPayForPackageSubsctipitonArgs = {
  subscription: Scalars['ID']['input'];
};


export type MutationPayFranchiseSubscriptionArgs = {
  requestID: Scalars['ID']['input'];
};


export type MutationPayrollDetailManuallyAdjustArgs = {
  input: ManuallyAdjustmentInput;
};


export type MutationPermanentlyDeleteDocumentArgs = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationQuizTraningAssignToArgs = {
  id: Scalars['ID']['input'];
  input: QuizTrainingAssignToInput;
};


export type MutationReJoinEmployeeArgs = {
  input?: InputMaybe<ReJoinEmployeeInput>;
};


export type MutationReRunQuestionTranslationArgs = {
  question_id: Scalars['ID']['input'];
};


export type MutationRecordExternalAssessmentArgs = {
  input: RecordExternalAssessmentInput;
};


export type MutationRecordPerformanceMeetingArgs = {
  input: RecordPerformanceMeetingInput;
};


export type MutationRecordResolutionArgs = {
  complaint_id: Scalars['ID']['input'];
  input: RecordResolutionInput;
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegionStatusChangedArgs = {
  _id: Scalars['ID']['input'];
  status: RegionStatusChange;
};


export type MutationRegisterBusinessArgs = {
  input?: InputMaybe<BusinessRegistration>;
};


export type MutationRemoveCommisionCampaignArgs = {
  archive: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRemoveDelegantEmployeeArgs = {
  input: DelegantApprovalMutationInput;
};


export type MutationRemoveEmployeeFromAattendancePolicyArgs = {
  employee_id: Scalars['ID']['input'];
  policy_id: Scalars['ID']['input'];
};


export type MutationRemoveEmployeeFromBusinessArgs = {
  input?: InputMaybe<RemoveBusinessEmployeeInput>;
};


export type MutationRemoveEmployeeFromLeavePolicyArgs = {
  _id: Scalars['ID']['input'];
  employee_id: Scalars['ID']['input'];
};


export type MutationRemoveEmployeeRoleArgs = {
  input: RemoveEmployee;
};


export type MutationRemoveGuarantorsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationRemoveShareOfAuthenticatorAppArgs = {
  input?: InputMaybe<RemoveShareInput>;
};


export type MutationRemoveTerminalDeviceArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationRenameDocumentControlAttachmentArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenameSubscriptionAttachmentArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationReserveAssetArgs = {
  input: ReserveAssetInput;
};


export type MutationResetEmployeeFailureCounterArgs = {
  input: ResetFailureCounterInput;
};


export type MutationResolveConflictsArgs = {
  input: Array<ResolveConflictsInput>;
};


export type MutationRevertCancelSubscriptionArgs = {
  business: Scalars['ID']['input'];
};


export type MutationS3UploadFileArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationSaveScheduleTemplateArgs = {
  input: ScheduleTemplateInput;
};


export type MutationSaveTillCountArgs = {
  input: TillCountInput;
};


export type MutationScrapAssetArgs = {
  input?: InputMaybe<ScrapInput>;
};


export type MutationScriptForAssetBrandArgs = {
  business_id: Scalars['ID']['input'];
};


export type MutationScriptForAssetCategoryCountsArgs = {
  business_id: Scalars['ID']['input'];
};


export type MutationScriptForAssignVendorsToQuickAssetArgs = {
  business_id: Scalars['ID']['input'];
};


export type MutationSendEmployeeEvaluationEmailArgs = {
  input?: InputMaybe<Array<InputMaybe<EvaluationEmailInput>>>;
};


export type MutationSendForgotPasswordEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendManualReminderArgs = {
  input: SendManualReminderInput;
};


export type MutationSendSchedulesByEmailArgs = {
  input: EmailScheduleInput;
};


export type MutationSendTemplateToTestEmailArgs = {
  hbs_template: HbsTemplateCreateInput;
  to_email: Scalars['String']['input'];
};


export type MutationSendTrainingAssignmentEmailArgs = {
  input: SendTrainingAssignmentEmailInput;
};


export type MutationSendWitnessFormArgs = {
  complaint_id: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  witness_id: Scalars['ID']['input'];
};


export type MutationSetDefaultCardArgs = {
  card_id: Scalars['ID']['input'];
  customer_id: Scalars['ID']['input'];
};


export type MutationSetDoNotDisturbInNotificationsArgs = {
  DoNotDisturb?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetEmployeeAuthenticatedArgs = {
  allow_email?: InputMaybe<Scalars['Boolean']['input']>;
  allow_qr_code?: InputMaybe<Scalars['Boolean']['input']>;
  allow_sms?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationSetEmployeeUnAuthenticatedArgs = {
  emp_id: Scalars['ID']['input'];
};


export type MutationSetNumberOfRecordArgs = {
  input: SetNumberOfRecordInput;
};


export type MutationSetPtoOpeningBalanceArgs = {
  input: PtoOpeningBalanceInput;
};


export type MutationShareAuthenticatorAppArgs = {
  input?: InputMaybe<ShareAppInput>;
};


export type MutationShareBulkAuthenticatorAppsArgs = {
  input?: InputMaybe<ShareBulkAppInput>;
};


export type MutationShareDocumentControlAttachmentArgs = {
  input: EmailDocumentControlAttachment;
};


export type MutationSingleUploadArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationSkipQuizQuestionArgs = {
  id: Scalars['ID']['input'];
  question: Scalars['ID']['input'];
};


export type MutationStartedQuizArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitDocumentByEmployeeArgs = {
  input?: InputMaybe<SubmitDocumentEmployeeInput>;
};


export type MutationSubscribeMedicalInsuranceArgs = {
  input: SubscribeMedicalInsuranceInput;
};


export type MutationSwapeEmployeesArgs = {
  input: SwapeEmployeesData;
};


export type MutationSwapeRoleArgs = {
  input: RoleDataForSwap;
};


export type MutationSyncPayrollArgs = {
  input: SyncPayrollInput;
};


export type MutationSyncWithChatServerArgs = {
  input?: InputMaybe<CreateSyncWithChatServerInput>;
};


export type MutationTrashAssetArgs = {
  input?: InputMaybe<TrashInput>;
};


export type MutationTriggerComplianceSummaryEmailArgs = {
  input?: InputMaybe<ComplianceSummaryEmailInput>;
};


export type MutationUnAssignAssetArgs = {
  input?: InputMaybe<UnAssignAssetInput>;
};


export type MutationUnAssignQuizArgs = {
  id: Scalars['ID']['input'];
  unAssignTo: Array<Scalars['ID']['input']>;
};


export type MutationUnBlockEmployeesArgs = {
  input: UnBlockInput;
};


export type MutationUnLinkAssetRelationFromAssetArgs = {
  input?: InputMaybe<UnLinkingRelationAsset>;
};


export type MutationUndoDisposedAssetArgs = {
  assetId: Scalars['ID']['input'];
};


export type MutationUndoReserveAssetArgs = {
  assetId: Scalars['ID']['input'];
};


export type MutationUnlinkBusinessArgs = {
  input?: InputMaybe<UnlinkBusinessInput>;
};


export type MutationUnlinkUserAppDeviceArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationUpdateAccountTypeArgs = {
  input: UpdateAccountTypeInput;
};


export type MutationUpdateActionFeatureArgs = {
  _id: Scalars['ID']['input'];
  input?: InputMaybe<ActionFeatureUpdateInput>;
};


export type MutationUpdateAlertConfigurationArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<AlertConfigurationInput>;
};


export type MutationUpdateAppPasswordAndSharesArgs = {
  input?: InputMaybe<UpdatePasswordInput>;
};


export type MutationUpdateAppraisalObjectiveArgs = {
  input: UpdateAppraisalObjecive;
};


export type MutationUpdateAppraisalScaleArgs = {
  input?: InputMaybe<UpdateInputAppraisaleScale>;
};


export type MutationUpdateAppraisalTypeArgs = {
  input: UpdateAppraisalType;
};


export type MutationUpdateApprovalWorkFlowArgs = {
  input: UpdateWorkFlowInput;
};


export type MutationUpdateAssetArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<AssetUpdateInput>;
};


export type MutationUpdateAssetBrandArgs = {
  input?: InputMaybe<InputUpdateBrand>;
};


export type MutationUpdateAssetCategoryArgs = {
  input?: InputMaybe<UpdateAssetCategoryInput>;
};


export type MutationUpdateAssetModelArgs = {
  input?: InputMaybe<InputUpdateModel>;
};


export type MutationUpdateAssetSubCategoryArgs = {
  input?: InputMaybe<UpdateAssetSubCategoryInput>;
};


export type MutationUpdateAttendancePermissionArgs = {
  appType: Application_Type;
  deviceId: Scalars['String']['input'];
  isClockedInFromApp: Scalars['Boolean']['input'];
};


export type MutationUpdateAttendancePolicyArgs = {
  input?: InputMaybe<AttandencePolicyUpdate>;
};


export type MutationUpdateAttendancePolicyInPreviousDataArgs = {
  from_date: Scalars['String']['input'];
};


export type MutationUpdateAttendanceRegulationArgs = {
  input: InputUpdateAttendance;
};


export type MutationUpdateAttendanceRegulationApprovalArgs = {
  input: UpdateRequestLevel;
};


export type MutationUpdateAuthenticatorAppArgs = {
  input?: InputMaybe<UpdateAppInput>;
};


export type MutationUpdateBusinessArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateBusinessInput>;
};


export type MutationUpdateBusinessEmailTemplateArgs = {
  input: BusinessEmailTemplateUpdateInput;
};


export type MutationUpdateBusinessForMsAttendanceArgs = {
  business_id: Scalars['ID']['input'];
  is_allowed: Scalars['Boolean']['input'];
};


export type MutationUpdateBusinessLocationArgs = {
  id: Scalars['ID']['input'];
  input: BusinessLocationInput;
};


export type MutationUpdateBusinessPackageArgs = {
  inActiveEmployees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  inActiveStore?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  package: Scalars['ID']['input'];
  subscription: Scalars['ID']['input'];
};


export type MutationUpdateCashDrawerArgs = {
  input?: InputMaybe<CashDrawerInput>;
};


export type MutationUpdateCashRegisterArgs = {
  _id: Scalars['ID']['input'];
  input: CashRegisterInput;
};


export type MutationUpdateChartOfAccountArgs = {
  _id: Scalars['ID']['input'];
  input: ChartOfAccountsInput;
};


export type MutationUpdateCommentInTaskArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateCommisionCampaignArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<CommisionCampaignInput>;
};


export type MutationUpdateCommissionArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<CommissionInput>;
};


export type MutationUpdateContractLicenseArgs = {
  id: Scalars['ID']['input'];
  input: ContractLicenseInput;
};


export type MutationUpdateDepartmentArgs = {
  _id: Scalars['ID']['input'];
  input: DepartmentInput;
};


export type MutationUpdateDesignationArgs = {
  _id: Scalars['ID']['input'];
  input: DesignationsInput;
};


export type MutationUpdateDiscountArgs = {
  input: UpdateDiscountInput;
};


export type MutationUpdateDocumentControlAttachmentAssigningArgs = {
  input?: InputMaybe<UpdateDocumentInput>;
};


export type MutationUpdateDocumentToSignArgs = {
  input?: InputMaybe<UpdateDoucment>;
};


export type MutationUpdateDutyRosterArgs = {
  input?: InputMaybe<RosterInput>;
};


export type MutationUpdateEmailArgs = {
  email: Scalars['String']['input'];
  emailID: Scalars['ID']['input'];
};


export type MutationUpdateEmailDeliveryRuleArgs = {
  _id: Scalars['ID']['input'];
  input?: InputMaybe<EmailDeliveryRuleInput>;
};


export type MutationUpdateEmployeeAdpIdArgs = {
  input?: InputMaybe<Array<EmployeeAdpId>>;
};


export type MutationUpdateEmployeeDashboardViewArgs = {
  id: Scalars['ID']['input'];
  input: CreateEmployeeDashboardViewInput;
};


export type MutationUpdateEmployeeDocumentArgs = {
  input?: InputMaybe<EmployeeDocumentUpdateInput>;
};


export type MutationUpdateEmployeeGarnishmentArgs = {
  input?: InputMaybe<EmployeeGarnishmentUpdate>;
};


export type MutationUpdateEmployeePayScheduleSalaryArgs = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateEmployeeSeparationArgs = {
  id: Scalars['ID']['input'];
  input: EmployeeSeparationInput;
};


export type MutationUpdateEmployeeVeiwCountArgs = {
  employeeID?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateEmployeesPicturesArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUpdateEvaluationArgs = {
  input?: InputMaybe<UpdateEvaluationInput>;
};


export type MutationUpdateExpenseApprovalArgs = {
  input: InputUpdateExpenseApproval;
};


export type MutationUpdateExpenseInvoiceArgs = {
  input: UpdateExpenseInvoice;
};


export type MutationUpdateExpenseInvoiceCategoryArgs = {
  input: UpdateExpenseInvoiceCategory;
};


export type MutationUpdateExpenseRequestArgs = {
  input: InputUpdateExpenseRequest;
};


export type MutationUpdateExternalVendorTrainingArgs = {
  id: Scalars['ID']['input'];
  input: UpdateExternalVendorTrainingInput;
};


export type MutationUpdateFeedbackArgs = {
  input: UpdateFeedbackInput;
};


export type MutationUpdateFilterArgs = {
  id: Scalars['ID']['input'];
  input: SaveFilterInput;
};


export type MutationUpdateFinalSettlementArgs = {
  _id: Scalars['ID']['input'];
  input: InputFinalSettlement;
};


export type MutationUpdateGiftCardArgs = {
  id: Scalars['ID']['input'];
  input: GiftCardInput;
};


export type MutationUpdateGiftCardCategoryArgs = {
  input: UpdateCategoryInput;
};


export type MutationUpdateGoalArgs = {
  _id: Scalars['ID']['input'];
  input?: InputMaybe<GoalsInput>;
};


export type MutationUpdateHrComplaintArgs = {
  _id: Scalars['ID']['input'];
  input: CreateHrComplaintInput;
};


export type MutationUpdateHbsContentOfBusinessEmailTemplateArgs = {
  hbs_template: HbsTemplateUpdateInput;
  hbs_template_id: Scalars['ID']['input'];
  template_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateInLineFieldArgs = {
  input: InLineFealdInput;
};


export type MutationUpdateInsuranceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<InsuranceInput>;
};


export type MutationUpdateInterviewLogArgs = {
  input: AddInterviewLogInput;
  interview_id: Scalars['ID']['input'];
};


export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};


export type MutationUpdateInvoiceItemArgs = {
  input: UpdateInvoiceItemInput;
};


export type MutationUpdateLeaseArgs = {
  input: UpdateLeaseInput;
};


export type MutationUpdateLeasingCustomerArgs = {
  input: LeasingCustomerInput;
};


export type MutationUpdateLiveLocationArgs = {
  app_type: Application_Type;
  device_id: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateLoanApprovalArgs = {
  input: UpdateLoanRequest;
};


export type MutationUpdateMaintenanceArgs = {
  input: UpdateMaintenanceInput;
};


export type MutationUpdateMarginTiersArgs = {
  input?: InputMaybe<InputUpdateMarginTiers>;
};


export type MutationUpdateMasterDataTypeValueArgs = {
  input: UpdateDataTypeValueInput;
};


export type MutationUpdateMultiSchedulesArgs = {
  input: UpdateMultiSchduleInput;
};


export type MutationUpdateMultipleAssetSubCategoryArgs = {
  input?: InputMaybe<InputUpdateMultipleSubCateg>;
};


export type MutationUpdateMultipleWritupApprovalArgs = {
  action_performed?: InputMaybe<Scalars['Boolean']['input']>;
  approval_description?: InputMaybe<Scalars['String']['input']>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  status: WritupStatusEnumMult;
};


export type MutationUpdateNotificationArgs = {
  _id: Scalars['ID']['input'];
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateNotificationPermissionsArgs = {
  input?: InputMaybe<UpdatePermissions>;
};


export type MutationUpdateObjectiveAssignmentArgs = {
  input: UpdateInputObjectiveAssignment;
};


export type MutationUpdateOrientationDetailsArgs = {
  input: UpdateOrientationDetailsInput;
};


export type MutationUpdateOwnPersonalInformationArgs = {
  employee_id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateOwnPersonalInformationInput>;
};


export type MutationUpdatePackageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: PackageInput;
};


export type MutationUpdatePayrollDetailStatusArgs = {
  input: UpdatePayrollStatusInput;
};


export type MutationUpdatePayrollStatusArgs = {
  input: UpdatePayrollStatusInput;
};


export type MutationUpdatePerformanceCycleArgs = {
  input?: InputMaybe<UpdatePerformanceCycleInput>;
};


export type MutationUpdatePerformanceCycleStatusArgs = {
  input?: InputMaybe<UpdatePerformanceCycleStatusInput>;
};


export type MutationUpdatePreviousAttendancePolicyAndImplementWeekendsArgs = {
  input?: InputMaybe<UpdatePreviousInput>;
};


export type MutationUpdateProfilePictureForModelsArgs = {
  input?: InputMaybe<UpdateProfilePictureInput>;
};


export type MutationUpdateProfit_CategoryArgs = {
  input?: InputMaybe<InputUpdateProfitCategory>;
};


export type MutationUpdateQuickAssetArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateAssetInput>;
};


export type MutationUpdateQuizArgs = {
  id: Scalars['ID']['input'];
  input: UpdateQuizInput;
};


export type MutationUpdateQuizCategoriesArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCategoriesInput;
};


export type MutationUpdateQuizQuestionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpdateQuestionInput;
};


export type MutationUpdateQuizTrainingArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTrainingInput;
};


export type MutationUpdateQuizTrainingAssignmentStatusArgs = {
  input: UpdateQuizTrainingAssignmentStatusInput;
};


export type MutationUpdateQuizTrainingCategoriesArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTrainingCategoriesInput;
};


export type MutationUpdateQuizTrainingReplicaArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTraininReplicagInput;
};


export type MutationUpdateReasonArgs = {
  input?: InputMaybe<InputUpdateReason>;
};


export type MutationUpdateRegionArgs = {
  input: UpdateRegionInput;
};


export type MutationUpdateRegisterBusinessArgs = {
  input?: InputMaybe<UpdateRegisterBusinessInput>;
};


export type MutationUpdateRepairPriceArgs = {
  input?: InputMaybe<InputUpdateRepairPrice>;
};


export type MutationUpdateRepliesinCommmentTaskArgs = {
  input?: InputMaybe<UpdateRepliesCommentInput>;
};


export type MutationUpdateReserveAssetArgs = {
  input: ReserveUpdateAssetInput;
};


export type MutationUpdateRoleArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<RoleInput>;
};


export type MutationUpdateSampleDataArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  input: Array<UpdateSampleDataInput>;
};


export type MutationUpdateScheduleArgs = {
  input: UpdateSchduleInput;
};


export type MutationUpdateSchedulesBreaksByDateRangeArgs = {
  input?: InputMaybe<InputBreakUpdate>;
};


export type MutationUpdateServiceCategoryArgs = {
  _id: Scalars['ID']['input'];
  category_name: Scalars['String']['input'];
};


export type MutationUpdateSetupAlertArgs = {
  input?: InputMaybe<InputUpdateSetupAlert>;
};


export type MutationUpdateShareOfAuthenticatorAppArgs = {
  input?: InputMaybe<UpdateShareAppInput>;
};


export type MutationUpdateShipToArgs = {
  input: UpdateShipTo;
};


export type MutationUpdateShippingMethodsArgs = {
  input?: InputMaybe<InputUpdateShipping>;
};


export type MutationUpdateStationArgs = {
  _id: Scalars['ID']['input'];
  input: StationInput;
};


export type MutationUpdateStoreToDutyRosterArgs = {
  input: RosterStoreInput;
};


export type MutationUpdateSubscriptionLogActivityArgs = {
  input: InputUpdateLogActivity;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTaskAssignToArgs = {
  input: UpdateAssignToInput;
};


export type MutationUpdateTaskSectionWiseArgs = {
  input: UpdateTaskSectionWise;
};


export type MutationUpdateTaskStatusArgs = {
  _id: Scalars['ID']['input'];
  status: TaskStatusUpdateEmums;
};


export type MutationUpdateTaxArgs = {
  _id: Scalars['ID']['input'];
  input: TaxInput;
};


export type MutationUpdateTimeOffArgs = {
  input?: InputMaybe<TimeOffInput>;
};


export type MutationUpdateTimeOffApprovalArgs = {
  input: UpdateLeaveRequest;
};


export type MutationUpdateTraineStatusArgs = {
  id: Scalars['ID']['input'];
  input: QuizTrainingUpdateStatus;
};


export type MutationUpdateTrainingAssigneeAttachmentStatusArgs = {
  input: UpdateTrainingAttachementStatus;
  trainingAssignmentId: Scalars['ID']['input'];
};


export type MutationUpdateTrainingAssigneeLinkStatusArgs = {
  input: UpdateTrainingLinkStatus;
  trainingAssignmentId: Scalars['ID']['input'];
};


export type MutationUpdateTrainingMatrixArgs = {
  id: Scalars['ID']['input'];
  input: TrainingMatrixUpdateInput;
};


export type MutationUpdateTrainingSettingsArgs = {
  input: TrainingSettingsUpdateInput;
};


export type MutationUpdateTransactWholeFieldInAssetArgs = {
  assetId: Scalars['ID']['input'];
  transactionValue: Scalars['Boolean']['input'];
};


export type MutationUpdateUserAppDeviceArgs = {
  input?: InputMaybe<UpdateInputUserAppDevice>;
};


export type MutationUpdateUserAttachmentStatusArgs = {
  input: UpdateTrainingAttachementStatus;
  trainingId: Scalars['ID']['input'];
};


export type MutationUpdateUserEmailStatusArgs = {
  input?: InputMaybe<EmailVerifyOtpInput>;
};


export type MutationUpdateUserPasswordArgs = {
  input?: InputMaybe<UpdateUserPasswordInput>;
};


export type MutationUpdateUserPhoneStatusArgs = {
  employeeId: Scalars['ID']['input'];
  otp_code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationUpdateUserProfileArgs = {
  input?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateUserSystemTokenArgs = {
  _id: Scalars['ID']['input'];
  system_token: Scalars['String']['input'];
};


export type MutationUpdateUsersEncryptionKeysArgs = {
  input?: InputMaybe<UserEncryptionKeyInput>;
};


export type MutationUpdateVendorArgs = {
  input?: InputMaybe<InputUpdateVendor>;
};


export type MutationUpdateWriteUpArgs = {
  input?: InputMaybe<UpdateWriteUpInput>;
};


export type MutationUpdateWriteUpApprovalArgs = {
  input: InputUpdateWriteUpApproval;
};


export type MutationUploadAssetDocsArgs = {
  input?: InputMaybe<UploadAssetDocInput>;
};


export type MutationUploadDocumentControlAttachmentArgs = {
  input: FileUploadDocumentControl;
};


export type MutationUploadFileDocumentControlAttachmentArgs = {
  input: UploadFileDocumentControlAttachment;
};


export type MutationUploadLocationImageArgs = {
  file: Scalars['Upload']['input'];
  location_id: Scalars['String']['input'];
};


export type MutationUpsertOrgChartSettingsArgs = {
  input: OrgChartSettingsInput;
};


export type MutationUserBreakedInArgs = {
  breakClockedTime: Scalars['String']['input'];
  input?: InputMaybe<UserBreakIn>;
  oldBreakHistoryId?: InputMaybe<Scalars['ID']['input']>;
  writeups?: InputMaybe<Array<WriteUpInput>>;
};


export type MutationUserClockedInArgs = {
  app_type?: InputMaybe<Application_Type>;
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  clockedTime: Scalars['String']['input'];
  device_id?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  oldClockHistoryId?: InputMaybe<Scalars['ID']['input']>;
  userClockInPin: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  writeups?: InputMaybe<Array<WriteUpInput>>;
  zoneName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserForgetPasswordArgs = {
  email: Scalars['String']['input'];
  method?: InputMaybe<AllowMethodPhoneVerify>;
};


export type MutationUserPasswordResetArgs = {
  input?: InputMaybe<PasswordResetInput>;
};


export type MutationUserPinCodeVerifyArgs = {
  business_id: Scalars['ID']['input'];
  clockedTime: Scalars['String']['input'];
  pincode: Scalars['String']['input'];
  time_zone: Scalars['String']['input'];
};


export type MutationVerifyEmailOtpArgs = {
  input?: InputMaybe<EmailVerifyOtpInput>;
};


export type MutationVerifyPhoneOtpArgs = {
  input?: InputMaybe<PhoneVerifyOtpInput>;
};


export type MutationVerifySsnAndSendOtpArgs = {
  input?: InputMaybe<VerifySsnAndSendOtpInput>;
};


export type MutationVerifyTranslationArgs = {
  language: LanguageCode;
  master_question_id: Scalars['ID']['input'];
};


export type MutationWorkingTimeWagesCalculateArgs = {
  employees?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type MyQuizTrainingLists = {
  __typename?: 'MyQuizTrainingLists';
  Quiz?: Maybe<Quiz>;
  QuizTrainingCategory?: Maybe<QuizTrainingCategory>;
  QuizTrainingSubCategory?: Maybe<QuizTrainingSubCategory>;
  all_assignee?: Maybe<Array<Maybe<QuizTrainingUser>>>;
  assign_to_department?: Maybe<Array<Maybe<QuizTrainingDepartment>>>;
  assign_to_role?: Maybe<Array<Maybe<QuizTrainingRole>>>;
  attachments?: Maybe<Array<QuizTrainingAttachment>>;
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  global_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  links?: Maybe<Array<Maybe<QuizTrainingLink>>>;
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type MyQuizTraningListingResult = {
  __typename?: 'MyQuizTraningListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<MyQuizTrainingLists>>>;
};

export type NewWriteUp = {
  __typename?: 'NewWriteUp';
  write_up_type?: Maybe<Scalars['String']['output']>;
  writeup_category?: Maybe<Scalars['String']['output']>;
  writeup_date?: Maybe<Scalars['DateTime']['output']>;
  writeup_message?: Maybe<Scalars['String']['output']>;
};

export enum NotificationMethodEnum {
  Email = 'email',
  InPerson = 'in_person',
  Phone = 'phone',
  WrittenLetter = 'written_letter'
}

export type NotificationModuleAndPermission = {
  __typename?: 'NotificationModuleAndPermission';
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  is_checked?: Maybe<Scalars['Boolean']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_enabled?: Maybe<Scalars['Boolean']['output']>;
  module?: Maybe<Scalars['String']['output']>;
  permission_at?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Array<Maybe<Role>>>;
  slug?: Maybe<Scalars['String']['output']>;
  sub_feature?: Maybe<Scalars['String']['output']>;
  userID?: Maybe<Scalars['String']['output']>;
};

export type NotificationPath = {
  __typename?: 'NotificationPath';
  feature?: Maybe<Scalars['String']['output']>;
  module?: Maybe<Scalars['String']['output']>;
  navigationUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type OfferLetter = {
  __typename?: 'OfferLetter';
  offer_letter_description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  offer_letter_details?: Maybe<Scalars['String']['output']>;
  offer_letter_footer?: Maybe<Scalars['String']['output']>;
  professional_tax?: Maybe<Scalars['String']['output']>;
};

export type OfferLetterInput = {
  offer_letter_description?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offer_letter_details?: InputMaybe<Scalars['String']['input']>;
  offer_letter_footer?: InputMaybe<Scalars['String']['input']>;
  professional_tax?: InputMaybe<Scalars['String']['input']>;
};

export type OldInvoiceInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  invoiceItems?: InputMaybe<Array<InputMaybe<InvoiceItems>>>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<Scalars['Int']['input']>;
  subTotal?: InputMaybe<Scalars['Int']['input']>;
  taxes?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type OpeningBalanceInput = {
  employee_id: Scalars['Int']['input'];
  opening_balance_hours?: InputMaybe<Scalars['Int']['input']>;
  opening_balance_minutes?: InputMaybe<Scalars['Int']['input']>;
};

export type OptionImageAddInput = {
  files: Array<Scalars['Upload']['input']>;
  optionId: Scalars['ID']['input'];
};

export type OptionImageRemoveInput = {
  fileUrl: Scalars['String']['input'];
  optionId: Scalars['ID']['input'];
};

export type OptionInput = {
  images?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type OptionObject = {
  __typename?: 'OptionObject';
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type OptionTextUpdateInput = {
  optionId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type OrgChartSettings = {
  __typename?: 'OrgChartSettings';
  child_color?: Maybe<Scalars['String']['output']>;
  color_scheme?: Maybe<ColorSchemeEnum>;
  custom_destence?: Maybe<Scalars['Int']['output']>;
  defult_expand?: Maybe<Scalars['Int']['output']>;
  group_siblings?: Maybe<Scalars['Int']['output']>;
  hybrid_color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_allow_drag_drop?: Maybe<Scalars['Boolean']['output']>;
  is_enable_wheel?: Maybe<Scalars['Boolean']['output']>;
  is_expand_on_click?: Maybe<Scalars['Boolean']['output']>;
  is_multi_highlight?: Maybe<Scalars['Boolean']['output']>;
  is_searcheble?: Maybe<Scalars['Boolean']['output']>;
  is_show_avatars?: Maybe<Scalars['Boolean']['output']>;
  layer_color_count?: Maybe<Scalars['Int']['output']>;
  layer_colors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  node_color_mode?: Maybe<NodeColorModeEnum>;
  parent_color?: Maybe<Scalars['String']['output']>;
};

export type OrgChartSettingsInput = {
  child_color?: InputMaybe<Scalars['String']['input']>;
  color_scheme?: InputMaybe<ColorSchemeEnum>;
  custom_destence?: InputMaybe<Scalars['Int']['input']>;
  defult_expand?: InputMaybe<Scalars['Int']['input']>;
  group_siblings?: InputMaybe<Scalars['Int']['input']>;
  hybrid_color?: InputMaybe<Scalars['String']['input']>;
  is_allow_drag_drop?: InputMaybe<Scalars['Boolean']['input']>;
  is_enable_wheel?: InputMaybe<Scalars['Boolean']['input']>;
  is_expand_on_click?: InputMaybe<Scalars['Boolean']['input']>;
  is_multi_highlight?: InputMaybe<Scalars['Boolean']['input']>;
  is_searcheble?: InputMaybe<Scalars['Boolean']['input']>;
  is_show_avatars?: InputMaybe<Scalars['Boolean']['input']>;
  layer_color_count?: InputMaybe<Scalars['Int']['input']>;
  layer_colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  node_color_mode?: InputMaybe<NodeColorModeEnum>;
  parent_color?: InputMaybe<Scalars['String']['input']>;
};

export enum OrientationDeliveryMethod {
  InPerson = 'in_person',
  Virtual = 'virtual'
}

export type OrientationTracking = {
  __typename?: 'OrientationTracking';
  Business?: Maybe<Business>;
  User?: Maybe<User>;
  _id: Scalars['ID']['output'];
  acknowledged_at?: Maybe<Scalars['Date']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<User>;
  delivery_method?: Maybe<Scalars['String']['output']>;
  orientation_date?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  updated_by?: Maybe<User>;
};

export type OrientationTrackingList = {
  __typename?: 'OrientationTrackingList';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<OrientationTracking>>>;
};

export type OrientationTrackingListInput = {
  User?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  delivery_method?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type OutOfAccuralLeavesAndTypes = {
  __typename?: 'OutOfAccuralLeavesAndTypes';
  User?: Maybe<User>;
  countIn?: Maybe<Scalars['String']['output']>;
  leaveType?: Maybe<LeaveType>;
  schedules?: Maybe<Array<Maybe<Schedule>>>;
  total_leave_out_of_accrual?: Maybe<Scalars['Float']['output']>;
};

export type OvertimeTotalSummary = {
  __typename?: 'OvertimeTotalSummary';
  totalOvertimeMinutes?: Maybe<Scalars['Int']['output']>;
  totalOvertimeWages?: Maybe<Scalars['Float']['output']>;
};

export type PtoDayBreakdown = {
  __typename?: 'PTODayBreakdown';
  acctual_minutes?: Maybe<Scalars['Float']['output']>;
  applied_minutes?: Maybe<Scalars['Float']['output']>;
  schedule_date?: Maybe<Scalars['String']['output']>;
};

export type PacakgeAndBusinessPermission = {
  __typename?: 'PacakgeAndBusinessPermission';
  businessPermission?: Maybe<Array<Maybe<Permission>>>;
  package?: Maybe<Package>;
};

export type Package = {
  __typename?: 'Package';
  _id?: Maybe<Scalars['ID']['output']>;
  auto_renewal?: Maybe<Scalars['Boolean']['output']>;
  business?: Maybe<Business>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  hr_module_only?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_pakage_free?: Maybe<Scalars['Boolean']['output']>;
  is_public_package?: Maybe<Scalars['Boolean']['output']>;
  no_of_employee?: Maybe<Scalars['Int']['output']>;
  no_of_store?: Maybe<Scalars['Int']['output']>;
  no_of_transcation?: Maybe<Scalars['Int']['output']>;
  number_of_cashregisters?: Maybe<Scalars['Int']['output']>;
  package_name?: Maybe<Scalars['String']['output']>;
  package_price?: Maybe<Scalars['Float']['output']>;
  package_type?: Maybe<Scalars['String']['output']>;
  per_employee_fee?: Maybe<Scalars['Float']['output']>;
  per_store_fee?: Maybe<Scalars['Float']['output']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  policy?: Maybe<Policy>;
  purchase_from_ms?: Maybe<Scalars['Boolean']['output']>;
  recurring?: Maybe<PackageRecurrignType>;
  transcation_fee?: Maybe<Scalars['Float']['output']>;
  transcation_fee_calculation_type?: Maybe<PackageTranscationFeeType>;
  transcation_fee_ending_limit?: Maybe<Scalars['Float']['output']>;
  transcation_fee_starting_limit?: Maybe<Scalars['Float']['output']>;
};

export type PackageListingResult = {
  __typename?: 'PackageListingResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<Package>>>;
};

export type PackagePaymentLogs = {
  __typename?: 'PackagePaymentLogs';
  _id?: Maybe<Scalars['ID']['output']>;
  business?: Maybe<Business>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Subscription>;
};

export enum PackageRecurrignType {
  Monthly = 'monthly',
  Quarter = 'quarter',
  Yearly = 'yearly'
}

export enum PackageTranscationFeeType {
  Fixed = 'fixed',
  Percentage = 'percentage'
}

export enum PackageType {
  Archive = 'archive',
  Corporate = 'corporate',
  Franchise = 'franchise',
  Franchiser = 'franchiser',
  FranchiserOem = 'franchiser_OEM',
  IndependentBusiness = 'independent_business'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  nextPageCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginateAssetEmployees = {
  __typename?: 'PaginateAssetEmployees';
  EmployeeListWithAssets?: Maybe<Array<Maybe<EmployeeListWithAssets>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PaidOffMinutes = {
  __typename?: 'PaidOffMinutes';
  pto_accrual_minutes?: Maybe<Scalars['Int']['output']>;
  pto_payout_minutes?: Maybe<Scalars['Int']['output']>;
};

export type PaidTransactionFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum PartialApplyMinimumEnum {
  HalfDay = 'half_day',
  Hour_1 = 'hour_1',
  Hour_2 = 'hour_2',
  Hour_3 = 'hour_3',
  Hour_4 = 'hour_4',
  Hour_5 = 'hour_5',
  Hour_6 = 'hour_6',
  Hour_7 = 'hour_7',
  Min_15 = 'min_15',
  Min_30 = 'min_30'
}

export type PasswordManagerAdmins = {
  __typename?: 'PasswordManagerAdmins';
  encryptionCopy?: Maybe<UserEncryptionCopies>;
  is_encryption_copy_exist?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

export type PasswordResetInput = {
  confirmPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum PayHolidayPolicy {
  RunPayrollEarlier = 'run_payroll_earlier',
  RunPayrollLater = 'run_payroll_later'
}

export enum PayPeriod {
  BiWeekly = 'BiWeekly',
  PerMonth = 'per_month'
}

export enum PayoffMethodEnum {
  CarryForward = 'carry_forward',
  CarryForwardPayOff = 'carry_forward_pay_off',
  None = 'none',
  PayoffOnly = 'payoff_only'
}

export type Payroll = {
  __typename?: 'Payroll';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  _id?: Maybe<Scalars['ID']['output']>;
  despersed_date?: Maybe<Scalars['DateTime']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_dispersed?: Maybe<Scalars['Boolean']['output']>;
  no_of_days?: Maybe<Scalars['Int']['output']>;
  no_of_employee?: Maybe<Scalars['Int']['output']>;
  pay_period?: Maybe<Scalars['String']['output']>;
  payroll_detail?: Maybe<Array<Maybe<Payroll_Detail>>>;
  payroll_name?: Maybe<Scalars['String']['output']>;
  payroll_run_date?: Maybe<Scalars['DateTime']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

export type PayrollDetail = {
  __typename?: 'PayrollDetail';
  Payroll?: Maybe<Payroll>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  absents?: Maybe<Scalars['Int']['output']>;
  account_number?: Maybe<Scalars['String']['output']>;
  adjusted_amount?: Maybe<Scalars['Float']['output']>;
  adjusted_at?: Maybe<Scalars['DateTime']['output']>;
  adjusted_by?: Maybe<User>;
  adjustment_detail?: Maybe<Array<Maybe<Adjustment_Detail>>>;
  allowances?: Maybe<Array<Maybe<Allowances_Deductions>>>;
  back_pay_wages?: Maybe<Scalars['Float']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  basic_salary?: Maybe<Scalars['Float']['output']>;
  commissions?: Maybe<Array<Maybe<Allowances_Deductions>>>;
  contributions?: Maybe<Array<Maybe<Allowances_Deductions>>>;
  deductions?: Maybe<Array<Maybe<Allowances_Deductions>>>;
  description?: Maybe<Scalars['String']['output']>;
  employee_actions?: Maybe<Array<Maybe<Employee_Actions>>>;
  employee_garnishment?: Maybe<Array<Maybe<Allowances_Deductions>>>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  expenses?: Maybe<Array<Maybe<Allowances_Deductions>>>;
  gross_salary?: Maybe<Scalars['Float']['output']>;
  is_credit?: Maybe<Scalars['Boolean']['output']>;
  is_dispersed?: Maybe<Scalars['Boolean']['output']>;
  is_manually_adjust?: Maybe<Scalars['Boolean']['output']>;
  is_processed?: Maybe<Scalars['Boolean']['output']>;
  leaves?: Maybe<Scalars['Int']['output']>;
  loan_payments?: Maybe<Array<Maybe<Allowances_Deductions>>>;
  medical_insurance?: Maybe<Array<Maybe<Allowances_Deductions>>>;
  net_salary?: Maybe<Scalars['Float']['output']>;
  no_of_days?: Maybe<Scalars['Int']['output']>;
  over_time_paid_public_holidays?: Maybe<Scalars['Int']['output']>;
  over_time_public_holidays?: Maybe<Scalars['Int']['output']>;
  over_time_public_holidays_minutes_logged?: Maybe<Scalars['Int']['output']>;
  over_time_public_holidays_wages?: Maybe<Scalars['Float']['output']>;
  over_time_weekend_days?: Maybe<Scalars['Int']['output']>;
  over_time_weekend_minutes_logged?: Maybe<Scalars['Int']['output']>;
  over_time_weekend_wages?: Maybe<Scalars['Float']['output']>;
  paid_off_minutes?: Maybe<PaidOffMinutes>;
  paid_public_holidays?: Maybe<Scalars['Int']['output']>;
  paid_public_holidays_wages?: Maybe<Scalars['Float']['output']>;
  paid_short_leaves?: Maybe<Scalars['Int']['output']>;
  paid_short_leaves_wages?: Maybe<Scalars['Float']['output']>;
  paid_weekend_days?: Maybe<Scalars['Int']['output']>;
  paid_weekend_days_wages?: Maybe<Scalars['Float']['output']>;
  pay_date?: Maybe<Scalars['DateTime']['output']>;
  pto_wages?: Maybe<Scalars['Float']['output']>;
  sale_goals?: Maybe<Array<Maybe<Allowances_Deductions>>>;
  short_leaves?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taxes?: Maybe<Array<Maybe<Allowances_Deductions>>>;
  total_adjusted_amount?: Maybe<Scalars['Float']['output']>;
  un_paid_short_leaves?: Maybe<Scalars['Int']['output']>;
};

export enum PayrollPayPeriodEnum {
  BiWeekly = 'BiWeekly',
  PerMonth = 'PerMonth',
  TwiceMonth = 'TwiceMonth',
  Weekly = 'Weekly'
}

export type PayrollSchedule = {
  __typename?: 'PayrollSchedule';
  _id?: Maybe<Scalars['ID']['output']>;
  business?: Maybe<Business>;
  business_location?: Maybe<BusinessLocation>;
  day_of_month?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  first_day_of_payroll_run_date?: Maybe<Scalars['Int']['output']>;
  hourly_pay?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  last_payroll_run_date?: Maybe<Scalars['DateTime']['output']>;
  no_of_days?: Maybe<Scalars['String']['output']>;
  pay_day?: Maybe<Scalars['DateTime']['output']>;
  pay_holiday_policy?: Maybe<Scalars['String']['output']>;
  pay_period?: Maybe<Scalars['String']['output']>;
  schedule_name?: Maybe<Scalars['String']['output']>;
  secound_day_of_payroll_run_date?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PayrollScheduleInput = {
  business: Scalars['ID']['input'];
  business_location?: InputMaybe<Scalars['ID']['input']>;
  day_of_month?: InputMaybe<Scalars['Int']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  first_day_of_payroll_run_date?: InputMaybe<Scalars['Int']['input']>;
  hourly_pay: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  no_of_days?: InputMaybe<Scalars['String']['input']>;
  pay_day: Scalars['String']['input'];
  pay_holiday_policy: Scalars['String']['input'];
  pay_period: Scalars['String']['input'];
  schedule_name: Scalars['String']['input'];
  secound_day_of_payroll_run_date?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollScheduleListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  order_by?: InputMaybe<SortEnum>;
  page: Scalars['Int']['input'];
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type PayrollScheduleListingResult = {
  __typename?: 'PayrollScheduleListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<PayrollSchedule>>>;
};

export type PayrollStructure = {
  __typename?: 'PayrollStructure';
  _id?: Maybe<Scalars['ID']['output']>;
  allowances?: Maybe<Array<Maybe<AllowanceData>>>;
  contributions?: Maybe<Array<Maybe<ContributionData>>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deductions?: Maybe<Array<Maybe<DeductionData>>>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  structure_name?: Maybe<Scalars['String']['output']>;
};

export type PayrollStructureInput = {
  allowance_list?: InputMaybe<Array<InputMaybe<AllowanceList>>>;
  business_location?: InputMaybe<Scalars['ID']['input']>;
  contribution_list?: InputMaybe<Array<InputMaybe<ContributionList>>>;
  deduction_list?: InputMaybe<Array<InputMaybe<DeductionList>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  structure_name: Scalars['String']['input'];
};

export type PayrollStructureListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type PayrollStructureListingResult = {
  __typename?: 'PayrollStructureListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<PayrollStructure>>>;
};

export type Permission = {
  __typename?: 'Permission';
  feature?: Maybe<Scalars['String']['output']>;
  is_admin_essential_permission?: Maybe<Scalars['Boolean']['output']>;
  module?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Scalars['String']['output']>;
  permission_at?: Maybe<Scalars['String']['output']>;
};

export type PermissionRole = {
  __typename?: 'PermissionRole';
  _id?: Maybe<Scalars['ID']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  module?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
};

export type PersonInvolved = {
  __typename?: 'PersonInvolved';
  Department?: Maybe<Array<Maybe<Department>>>;
  User?: Maybe<User>;
  additional_context?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  is_internal_person?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  relationship_to_you?: Maybe<Scalars['String']['output']>;
};

export type PersonInvolvedInput = {
  Department?: InputMaybe<Array<Scalars['ID']['input']>>;
  User?: InputMaybe<Scalars['ID']['input']>;
  additional_context?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  is_internal_person?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  relationship_to_you?: InputMaybe<RelationshipToYou>;
};

export type PersonalDetails = {
  __typename?: 'PersonalDetails';
  Country?: Maybe<Country>;
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  birth_date?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<City>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  home_no?: Maybe<Scalars['String']['output']>;
  is_email_verify?: Maybe<Scalars['Boolean']['output']>;
  is_phone_verify?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  marital_status?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  mobile_no_to_send_sms?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type PersonalDetailsInput = {
  Country?: InputMaybe<Scalars['ID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  birth_date?: InputMaybe<Scalars['Date']['input']>;
  city?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  home_no?: InputMaybe<Scalars['String']['input']>;
  is_email_verify?: InputMaybe<Scalars['Boolean']['input']>;
  is_phone_verify?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  marital_status?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  mobile_no_to_send_sms?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['ID']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type PlaidSyncTransactions = {
  __typename?: 'PlaidSyncTransactions';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PlaidTransactionType = {
  __typename?: 'PlaidTransactionType';
  _id: Scalars['ID']['output'];
  account_id?: Maybe<Scalars['String']['output']>;
  account_owner?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  authorized_datetime?: Maybe<Scalars['Date']['output']>;
  category?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  date?: Maybe<Scalars['Date']['output']>;
  datetime?: Maybe<Scalars['Date']['output']>;
  iso_currency_code?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationData>;
  logo_url?: Maybe<Scalars['String']['output']>;
  mapped_category?: Maybe<Scalars['String']['output']>;
  merchant_entity_id?: Maybe<Scalars['String']['output']>;
  merchant_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pending?: Maybe<Scalars['Boolean']['output']>;
  transaction_code?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
  transaction_type?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type PlaidTransactionsResult = {
  __typename?: 'PlaidTransactionsResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<PlaidTransactionType>>>;
};

export type Policy = {
  __typename?: 'Policy';
  customer_max_storecredit?: Maybe<Scalars['Int']['output']>;
  customer_max_storecredit_transfer?: Maybe<Scalars['Int']['output']>;
  device_type?: Maybe<Scalars['String']['output']>;
  pay_later_invoice_max_limit?: Maybe<Scalars['Int']['output']>;
  payment_gateways?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sale_cash_max_limit?: Maybe<Scalars['Int']['output']>;
  sale_max_invoice_discount_fixed?: Maybe<Scalars['Int']['output']>;
  sale_max_invoice_discount_percentage?: Maybe<Scalars['Int']['output']>;
  sale_max_item_discount?: Maybe<Scalars['Int']['output']>;
  sale_max_tabs?: Maybe<Scalars['Int']['output']>;
  sale_paypal_invoice_min_limit?: Maybe<Scalars['Int']['output']>;
  sale_paypal_invoice_no_transaction?: Maybe<Scalars['Int']['output']>;
  sale_paypal_min_limit?: Maybe<Scalars['Int']['output']>;
  sale_paypal_no_transaction?: Maybe<Scalars['Int']['output']>;
  ticket_invoice_refund_max_percentage_discount?: Maybe<Scalars['Int']['output']>;
};

export enum PolicyTypeEnum {
  CarryForward = 'CarryForward',
  CarryForwardPayOff = 'CarryForwardPayOff',
  None = 'None',
  PayOff = 'PayOff'
}

export enum PreferredContactMethod {
  PersonalEmail = 'personal_email',
  Phone = 'phone',
  WorkEmail = 'work_email'
}

export type Previous = {
  __typename?: 'Previous';
  account_status?: Maybe<Scalars['String']['output']>;
  action_create_date?: Maybe<Scalars['DateTime']['output']>;
  action_type?: Maybe<Scalars['String']['output']>;
  basic_salary?: Maybe<Scalars['Float']['output']>;
  department?: Maybe<Array<Maybe<Department>>>;
  employee_type?: Maybe<Scalars['String']['output']>;
  hire_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_exclude_pay_roll?: Maybe<Scalars['String']['output']>;
  is_excluding_pay_roll?: Maybe<Scalars['Boolean']['output']>;
  is_use_new_salary?: Maybe<Scalars['Boolean']['output']>;
  joining_date?: Maybe<Scalars['DateTime']['output']>;
  line_manager?: Maybe<User>;
  new_salary_effect_from?: Maybe<Scalars['DateTime']['output']>;
  over_time_hours?: Maybe<Scalars['Int']['output']>;
  over_time_rate?: Maybe<Scalars['Float']['output']>;
  pay_schedule?: Maybe<PayrollSchedule>;
  pay_type?: Maybe<Scalars['String']['output']>;
  public_day_hourly_salary?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Array<Maybe<Region>>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  salary_type?: Maybe<Scalars['String']['output']>;
  shift?: Maybe<Shift>;
  starting_date?: Maybe<Scalars['DateTime']['output']>;
  storeAccess?: Maybe<Array<Maybe<StoreAccessType>>>;
  total_week_hours?: Maybe<Scalars['Int']['output']>;
  weekend_day_salary?: Maybe<Scalars['String']['output']>;
  weekly_hourly_salary?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  _id?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  product_name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

export enum ProductAttributeTypes {
  Brand = 'brand',
  Capacity = 'capacity',
  Carrier = 'carrier',
  Category = 'category',
  Color = 'color'
}

export type ProductAttributes = {
  __typename?: 'ProductAttributes';
  brand?: Maybe<Array<Maybe<SystemBrand>>>;
  capacity?: Maybe<Array<Maybe<Capacity>>>;
  carrier?: Maybe<Array<Maybe<Carrier>>>;
  category?: Maybe<Array<Maybe<Category>>>;
  color?: Maybe<Array<Maybe<Color>>>;
};

export type ProductCategoryType = {
  __typename?: 'ProductCategoryType';
  _id?: Maybe<Scalars['ID']['output']>;
  category_name?: Maybe<Scalars['String']['output']>;
  category_tax?: Maybe<Scalars['Float']['output']>;
  category_tax_key?: Maybe<Scalars['String']['output']>;
  category_type?: Maybe<Scalars['String']['output']>;
};

export type ProductType = {
  __typename?: 'ProductType';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  ProductCategory?: Maybe<ProductCategoryType>;
  approve_by?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_global?: Maybe<Scalars['Boolean']['output']>;
  is_sub_type?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ProfitCategory = {
  __typename?: 'ProfitCategory';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Category?: Maybe<ProductType>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  markup?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<User>;
};

export type PtoMinutesType = {
  __typename?: 'PtoMinutesType';
  carry_forword?: Maybe<Scalars['Int']['output']>;
  pto_availed_minutes?: Maybe<Scalars['Float']['output']>;
  pto_count_in?: Maybe<Scalars['String']['output']>;
  pto_earned_minutes?: Maybe<Scalars['Float']['output']>;
  pto_fixed_days?: Maybe<Scalars['Float']['output']>;
  pto_fixed_minutes?: Maybe<Scalars['Float']['output']>;
  pto_fixed_total_days?: Maybe<Scalars['Float']['output']>;
  pto_fixed_total_minutes?: Maybe<Scalars['Float']['output']>;
  pto_type?: Maybe<Scalars['String']['output']>;
};

export type PtoOpeningBalanceInput = {
  leave_policy: Scalars['ID']['input'];
  leave_type: Scalars['ID']['input'];
  opening_balance: Array<OpeningBalanceInput>;
};

export type PtoSummary = {
  __typename?: 'PtoSummary';
  carry_forward_minutes?: Maybe<Scalars['Float']['output']>;
  earned_hrs?: Maybe<Scalars['Float']['output']>;
  remaining_hrs?: Maybe<Scalars['Float']['output']>;
  used_hrs?: Maybe<Scalars['Float']['output']>;
};

export enum PtoValueIn {
  FixedHours = 'fixed_hours',
  WeekRatio = 'week_ratio'
}

export type PublicHoliday = {
  __typename?: 'PublicHoliday';
  Department?: Maybe<Array<Maybe<Department>>>;
  Role?: Maybe<Array<Maybe<Role>>>;
  User?: Maybe<Scalars['ID']['output']>;
  Users?: Maybe<Array<Maybe<User>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  business?: Maybe<Business>;
  conflicts?: Maybe<Array<Maybe<UserConflict>>>;
  date_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  from_date?: Maybe<Scalars['DateTime']['output']>;
  hasConflict: Scalars['Boolean']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_recursive?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  to_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PublicHolidayCalenderType = {
  __typename?: 'PublicHolidayCalenderType';
  _id?: Maybe<Scalars['ID']['output']>;
  date_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PublicHolidayInput = {
  business_id: Scalars['ID']['input'];
  date: Array<InputMaybe<Scalars['DateTime']['input']>>;
  employee_id: Scalars['ID']['input'];
};

export type PurchasesReport = {
  __typename?: 'PurchasesReport';
  total_amount?: Maybe<Scalars['Float']['output']>;
};

export type QrLogs = {
  __typename?: 'QRLogs';
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<User>;
  employee?: Maybe<User>;
  scanned_by?: Maybe<User>;
};

export type QrLogsInput = {
  employeeId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type QrLogsList = {
  __typename?: 'QRLogsList';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<QrLogs>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  CommissionById?: Maybe<Commission>;
  Commissions?: Maybe<Array<Maybe<Commission>>>;
  GetAssetMovementHistorybyID?: Maybe<AssetMovement>;
  addBusinessInDocumentShare?: Maybe<Scalars['Boolean']['output']>;
  businessLocationById?: Maybe<BusinessLocation>;
  businessPackageByBusinessId?: Maybe<BusinessPackage>;
  businessPermissions?: Maybe<Array<Maybe<Permission>>>;
  calculateUpdatePackageFee?: Maybe<Scalars['Float']['output']>;
  checkAbsentUsers?: Maybe<Scalars['Boolean']['output']>;
  checkAssetByAssetIdAndNumber?: Maybe<Scalars['Boolean']['output']>;
  checkEmployeeIsClockedIn?: Maybe<Scalars['Boolean']['output']>;
  checkQuizTrainingAssignmentStatusByIds?: Maybe<QuizTrainingAssignementListResult>;
  checkUnRestrictedPolicy?: Maybe<Scalars['Boolean']['output']>;
  commisionCampaignById?: Maybe<CommissionCampaign>;
  confirmEmployeeClockedHistory?: Maybe<ClockedHistory>;
  countries?: Maybe<Array<Maybe<Country>>>;
  customersByBusinessId?: Maybe<Array<Maybe<Customer>>>;
  customersByLocationId?: Maybe<Array<Maybe<Customer>>>;
  deleteInvoice?: Maybe<Scalars['Boolean']['output']>;
  deleteInvoiceItem?: Maybe<Scalars['Boolean']['output']>;
  employeeLoanAmount?: Maybe<EmployeeLoanAmountResult>;
  employeeSeparationList?: Maybe<EmployeeListingresult>;
  fetchQuizAssignmentById?: Maybe<AssignedQuiz>;
  filterQuizTrainingAssignement?: Maybe<Array<Maybe<FilterTrainingAssignementResult>>>;
  forgetBusinessUrl?: Maybe<Scalars['Boolean']['output']>;
  generateAssetId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  generateInvoiceId?: Maybe<Scalars['String']['output']>;
  getAccountTypeById?: Maybe<AccountType>;
  getActionFeatures?: Maybe<Array<Maybe<ActionFeature>>>;
  getActiveShifts?: Maybe<Array<Maybe<Shift>>>;
  getAdminDashboardData?: Maybe<GetAdminDashboardData>;
  getAdvanceFilterById?: Maybe<AdvanceFilter>;
  getAllAccessoriesWithSearch?: Maybe<AssetListingResult>;
  getAllAccountTypes?: Maybe<Array<Maybe<AccountType>>>;
  getAllActiveAndInActiveEmployees?: Maybe<Array<Maybe<User>>>;
  getAllActiveAppraisalType?: Maybe<Array<Maybe<AppraisalType>>>;
  getAllActiveBusiness?: Maybe<Array<Maybe<Business>>>;
  getAllActiveBusinessesLocationsByBusinessId?: Maybe<Array<Maybe<BusinessLocation>>>;
  getAllActiveEmployees?: Maybe<Array<Maybe<User>>>;
  getAllActiveEmployeesForShareDocument?: Maybe<Array<Maybe<User>>>;
  getAllActiveEmployeesWithSearch?: Maybe<Array<Maybe<User>>>;
  getAllActiveInActiveEmployeesByDepartment?: Maybe<Array<Maybe<User>>>;
  getAllActivityDocuments?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
  getAllAdvanceFilters?: Maybe<Array<Maybe<AdvanceFilter>>>;
  getAllAlerts?: Maybe<AlertListingResult>;
  getAllAllowances?: Maybe<Array<Maybe<Allowance>>>;
  getAllAppraisalObjective?: Maybe<AppraisalObjectiveResult>;
  getAllAppraisalScales?: Maybe<AppraisalScaleResult>;
  getAllAppraisalType?: Maybe<AppraisalResult>;
  getAllAssetBrand?: Maybe<Array<Maybe<AssetBrand>>>;
  getAllAssetBrandList?: Maybe<BrandList>;
  getAllAssetByCategoryId?: Maybe<Array<Maybe<Asset>>>;
  getAllAssetCategories: Array<AssetCategory>;
  getAllAssetCategoryAndSubCategory?: Maybe<CategoryListingResult>;
  getAllAssetModel?: Maybe<Array<Maybe<AssetModel>>>;
  getAllAssetSubCategories: Array<AssetSubCategory>;
  getAllAssetSubCategoryById?: Maybe<Array<Maybe<AssetSubCategory>>>;
  getAllAssetTypes?: Maybe<Array<Maybe<MasterDataValue>>>;
  getAllAssets?: Maybe<Array<Maybe<Asset>>>;
  getAllAssetsDispose?: Maybe<Array<Maybe<Asset>>>;
  getAllAssetsMaintenance?: Maybe<Array<Maybe<Asset>>>;
  getAllAssetsWithSearch?: Maybe<AssetsListingResult>;
  getAllAssigneeTasksWithSearch?: Maybe<Array<Maybe<TaskManagement>>>;
  getAllAttendance?: Maybe<AttendanceListingResult>;
  getAllBrands?: Maybe<BrandResult>;
  getAllBusinesseForFranchise?: Maybe<Array<Maybe<Business>>>;
  getAllCampaignsSearch?: Maybe<Array<Maybe<Campaign>>>;
  getAllCashRegistersHistory?: Maybe<CashRegistersHistoryListing>;
  getAllCategoryAndSubcategoryList?: Maybe<GetCategoriesList>;
  getAllCity?: Maybe<Array<Maybe<City>>>;
  getAllContractAndLicenseeWithSearch?: Maybe<ContractLicenseResult>;
  getAllContractsAndLicenses?: Maybe<Array<Maybe<ContractLicense>>>;
  getAllContractsAndLicensesLinkWithAssets?: Maybe<Asset>;
  getAllDepartmentAssetWithSearch?: Maybe<GetQuickAsset>;
  getAllDepartments?: Maybe<Array<Maybe<Department>>>;
  getAllDesignationList?: Maybe<AllDesignationListingresult>;
  getAllDeviceIssues?: Maybe<Array<Maybe<ProductType>>>;
  getAllDeviceModel?: Maybe<DeviceModelResult>;
  getAllDeviceModelByBrand?: Maybe<Array<Maybe<DeviceModel>>>;
  getAllDeviceType?: Maybe<Array<Maybe<DeviceType>>>;
  getAllDiscountTags?: Maybe<Array<Maybe<Tags>>>;
  getAllDiscounts?: Maybe<DiscountListingResult>;
  getAllDiscountsWithSearch?: Maybe<CampaignsListingResultNew>;
  getAllDisposeWithSearch?: Maybe<GetDisposeList>;
  getAllDocumentsLinkWithAssets?: Maybe<Asset>;
  getAllEmployeeActions?: Maybe<Array<Maybe<UserHistory>>>;
  getAllEmployeeTypes?: Maybe<Array<Maybe<MasterDataValue>>>;
  getAllEmployeeswithjoingDate?: Maybe<Array<Maybe<User>>>;
  getAllEvaluation?: Maybe<AppraisalEvaluationResult>;
  getAllExpenseInvoice?: Maybe<Array<Maybe<GetExpenseInvoice>>>;
  getAllExpenseInvoiceCategory?: Maybe<Array<Maybe<ExpenseCategory>>>;
  getAllExternalVendorTrainings?: Maybe<ExternalVendorTrainingList>;
  getAllFinalSettlement?: Maybe<Array<Maybe<FinalSettlement>>>;
  getAllGoalsList?: Maybe<AppraisalEvaluationResult>;
  getAllGratuityList?: Maybe<Array<Maybe<Gratuity>>>;
  getAllGroupList?: Maybe<Array<Maybe<AuthenticatorGroup>>>;
  getAllGuarantor?: Maybe<Array<Maybe<User>>>;
  getAllInsurance?: Maybe<Array<Maybe<Insurance>>>;
  getAllInsuranceLinkWithAssets?: Maybe<Asset>;
  getAllInsuranceWithSearch?: Maybe<InsuranceListingResult>;
  getAllInvoiceItem?: Maybe<GetInvoiceItemType>;
  getAllInvoices?: Maybe<GetInvoiceList>;
  getAllLeaseWithSearch?: Maybe<LeaseListingResult>;
  getAllLeasingCustomer?: Maybe<Array<Maybe<LeasingCustomer>>>;
  getAllLeavePoliciesWithConfig?: Maybe<LeavePolicyListingResult>;
  getAllLeavePoliciesWithSearch?: Maybe<ResultOfLeavePolicy>;
  getAllLeavesForCalender?: Maybe<Array<Maybe<TimeOff>>>;
  getAllLeavesType?: Maybe<Array<Maybe<LeaveType>>>;
  getAllLinkRelationalAsset?: Maybe<Asset>;
  getAllLinkedAssetBrandList?: Maybe<BrandList>;
  getAllMYAuthenticatorApps?: Maybe<AuthenticatorResult>;
  getAllMaintenanceLinkWithAssets?: Maybe<Array<Maybe<Maintenance>>>;
  getAllMaintenanceWithSearch?: Maybe<MaintenanceListingResult>;
  getAllMasterDataTypeValueById?: Maybe<MasterDataValue>;
  getAllMasterDataTypeValueByTypeId?: Maybe<Array<Maybe<MasterDataValue>>>;
  getAllMasterDataTypeValueWithSearch?: Maybe<DataTypeResult>;
  getAllMasterDataTypeWithSearch?: Maybe<Array<Maybe<MasterDataType>>>;
  getAllMedicalInsurance?: Maybe<Array<Maybe<MasterDataValue>>>;
  getAllMedicalInsurancePackageList?: Maybe<Array<Maybe<MedicalInsurancePackage>>>;
  getAllMilestoneTracking?: Maybe<MilestoneTrackingList>;
  getAllMoveLeavePolicy?: Maybe<Array<Maybe<LeavePolicy>>>;
  getAllMyRequestDocuments?: Maybe<AllDocumentListingResult>;
  getAllMyTasksWithSearch?: Maybe<AssigneeTaskListingResult>;
  getAllNavigationBusinessList?: Maybe<Array<Maybe<Business>>>;
  getAllNotifications?: Maybe<Array<Maybe<Notification>>>;
  getAllNotificationsWithFilters?: Maybe<NotificationListingResult>;
  getAllNotificationsWithPagination?: Maybe<NotificationListingResult>;
  getAllObjective?: Maybe<Array<Maybe<AppraisalObjecive>>>;
  getAllObjectiveAssignment?: Maybe<ObjectiveAssignmentResult>;
  getAllOrientationTracking?: Maybe<OrientationTrackingList>;
  getAllPackages?: Maybe<PackageListingResult>;
  getAllPayrollDetailList?: Maybe<Array<Maybe<PayrollDetail>>>;
  getAllPayrollSchedule?: Maybe<Array<Maybe<PayrollSchedule>>>;
  getAllPayrollScheduleList?: Maybe<PayrollScheduleListingResult>;
  getAllPayrollStructureList?: Maybe<Array<Maybe<PayrollStructure>>>;
  getAllPayrollStructureListWithSearch?: Maybe<PayrollStructureListingResult>;
  getAllPayrolleList?: Maybe<PayrollListResult>;
  getAllPermissionOfNotifications?: Maybe<Array<Maybe<NotificationModuleAndPermission>>>;
  getAllPlaidCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getAllProductCategories?: Maybe<Array<Maybe<ProductCategoryType>>>;
  getAllQuickAssets?: Maybe<GetQuickAsset>;
  getAllQuizCategory?: Maybe<AllCategoriesList>;
  getAllRegions?: Maybe<Array<Maybe<Region>>>;
  getAllRepairPriceWithSearch?: Maybe<Array<Maybe<RepairPrice>>>;
  getAllRequestedDocuments?: Maybe<AllDocumentListingResult>;
  getAllReserve?: Maybe<ReserveAssetResult>;
  getAllReserveWithSearch?: Maybe<AssetListingResult>;
  getAllRostersByRosterStoreId?: Maybe<Array<Maybe<Roster>>>;
  getAllSendRequestDocuments?: Maybe<AllDocumentListingResult>;
  getAllServiceCategory?: Maybe<Array<Maybe<ServiceCategoryType>>>;
  getAllSetupAlertList?: Maybe<SetupAlert>;
  getAllShareOfApp?: Maybe<Array<Maybe<ShareAuthenticatorApp>>>;
  getAllShareOfDocument?: Maybe<AllShareDocumentResults>;
  getAllShareWithMeApps?: Maybe<ShareMeListDataTable>;
  getAllShiftsList?: Maybe<ShiftListingResult>;
  getAllShipTo?: Maybe<Array<Maybe<GetShipToType>>>;
  getAllState?: Maybe<Array<Maybe<State>>>;
  getAllStations?: Maybe<Array<Maybe<Station>>>;
  getAllSubscriptionLogActivity?: Maybe<LogActivityListingResult>;
  getAllSystemBrands?: Maybe<SystembrandResult>;
  getAllTasksWithSearch?: Maybe<AllTasksListingResult>;
  getAllTax?: Maybe<Array<Maybe<Tax>>>;
  getAllTerminalDevices?: Maybe<Array<Maybe<AddTerminalAppType>>>;
  getAllTimeOffByBusiness?: Maybe<Array<Maybe<TimeOff>>>;
  getAllUsersForSharedRecords?: Maybe<Array<Maybe<User>>>;
  getAllowanceById?: Maybe<Allowance>;
  getAllowanceWithFilters?: Maybe<AllowanceResult>;
  getAppVersion?: Maybe<Scalars['Boolean']['output']>;
  getAppVersions?: Maybe<Scalars['Boolean']['output']>;
  getAppraisalObejctiveByPerformanceCycle?: Maybe<Array<Maybe<AppraisalObjecive>>>;
  getAppraisalObjectiveByAppraisalType?: Maybe<Array<Maybe<AppraisalObjecive>>>;
  getAppraisalObjectiveById?: Maybe<AppraisalObjecive>;
  getAppraisalObjectiveByType?: Maybe<Array<Maybe<AppraisalObjecive>>>;
  getAppraisalScaleById?: Maybe<AppraisalScale>;
  getAppraisalTypeById?: Maybe<AppraisalType>;
  getApprovalWorkFlowById?: Maybe<ApprovalWorkFlow>;
  getApprovalWorkFlowWithSearch?: Maybe<ApprovalWorkFlowResult>;
  getArchivedDocuments?: Maybe<TrashDocumentDataTableResult>;
  getAssetAlertConfigurationByBusiness?: Maybe<AlertConfiguration>;
  getAssetBrandById?: Maybe<AssetBrandWithModel>;
  getAssetCategoryById?: Maybe<AssetCategory>;
  getAssetCount?: Maybe<AssetCountResult>;
  getAssetModelByBrand?: Maybe<Array<Maybe<AssetModel>>>;
  getAssetModelById?: Maybe<AssetModel>;
  getAssetSubCategoryById?: Maybe<AssetSubCategory>;
  getAssets?: Maybe<Array<Maybe<Asset>>>;
  getAssetsByBussinessId?: Maybe<AssetByBusinessResult>;
  getAssetsByDepartmentId?: Maybe<Array<Maybe<Asset>>>;
  getAssetsByEmployeeId?: Maybe<AssetByEmployeeResult>;
  getAssetsById?: Maybe<Asset>;
  getAssetsOfUser?: Maybe<AsssignAssetResult>;
  getAssetsStatusesCount?: Maybe<AssetCountAndAlerts>;
  getAssetsWithEmployeeHerierchy?: Maybe<PaginateAssetEmployees>;
  getAssignByMeTaskWithSearch?: Maybe<TaskListingResult>;
  getAssignToMeTaskWithSearch?: Maybe<TaskListingResult>;
  getAttemptQuizById?: Maybe<AssignedQuiz>;
  getAttendanceById?: Maybe<ClockedHistory>;
  getAttendanceList?: Maybe<AttendanceListExtendedresult>;
  getAttendanceListByEmployeeId?: Maybe<EmployeeClockHistory>;
  getAttendanceListWithStatus?: Maybe<AttendanceDataWithEmployees>;
  getAttendancePolicyByPayType?: Maybe<Array<Maybe<AttandencePolicy>>>;
  getAttendancePolicyGroups?: Maybe<Array<Maybe<AttandencePolicy>>>;
  getAttendanceRegulationApprovalsWithSearch?: Maybe<AttendanceResult>;
  getAttendanceRegulationById?: Maybe<AttendanceRegulation>;
  getAttendanceRegulationOfUser?: Maybe<Array<Maybe<AttendanceRegulation>>>;
  getAttendanceRegulationWithSearch?: Maybe<AttendanceResult>;
  getAuthenticatorAppById?: Maybe<Authenticator>;
  getAuthentictorsEmployees?: Maybe<AuthenticorResult>;
  getBrandById?: Maybe<Brand>;
  getBusinessByID?: Maybe<Business>;
  getBusinessByIdentificationNumber?: Maybe<Business>;
  getBusinessBySystemName?: Maybe<Business>;
  getBusinessBySystemNameWithValidation?: Maybe<BusinessWithOtp>;
  getBusinessByUserID?: Maybe<Business>;
  getBusinessEmailTemplate?: Maybe<BusinessEmailTemplate>;
  getBusinessForMSAttendance?: Maybe<Array<Maybe<MsAttendanceAllowedBusiness>>>;
  getBusinessLocationsByBusinessId?: Maybe<Array<Maybe<BusinessLocation>>>;
  getBusinessPackageDetail?: Maybe<BusinessPackage>;
  getBusinessPackages?: Maybe<Array<Maybe<Package>>>;
  getBusinessSubscriptions?: Maybe<SubscriptionDataTableList>;
  getBusinessedByType?: Maybe<Array<Maybe<Business>>>;
  getBusinesses?: Maybe<Array<Maybe<Business>>>;
  getBusinessesByType?: Maybe<Array<Maybe<Business>>>;
  getBusinessesLocations?: Maybe<Array<Maybe<BusinessLocation>>>;
  getBusinessesLocationsByRegionId?: Maybe<Array<Maybe<BusinessLocation>>>;
  getBusinessesWithFilter?: Maybe<BuinsesslistingResult>;
  getCampaignsAndSearch?: Maybe<CampaignsListingResult>;
  getCashRegisterById?: Maybe<CashRegisters>;
  getCashRegisterByLocation?: Maybe<Array<Maybe<CashRegisters>>>;
  getCashRegisterWithFilters?: Maybe<CashRegisterlistingResult>;
  getCategoryGiftCardList?: Maybe<GiftCardCategoryList>;
  getChartOfAccountById?: Maybe<ChartOfAccount>;
  getChartOfAccountList?: Maybe<ChartOfAccountsListingresult>;
  getChartOfAccountsByAccountType?: Maybe<Array<Maybe<ChartOfAccount>>>;
  getCityByStateId?: Maybe<Array<Maybe<City>>>;
  getCommisionCampaigns?: Maybe<Array<Maybe<CommissionCampaign>>>;
  getCommisionCampaignswithCommissions?: Maybe<CommisionCampaignList>;
  getCommissionAndSearch?: Maybe<Array<Maybe<Commission>>>;
  getCompansationLeaveType?: Maybe<Array<Maybe<LeaveType>>>;
  getComplianceDashboard?: Maybe<ComplianceDashboardResult>;
  getComplianceDashboardDataTable?: Maybe<ComplianceDashboardList>;
  getComplianceDashboardStats?: Maybe<ComplianceHeaderStats>;
  getConflictSchedule?: Maybe<Array<Maybe<ConflictSchedule>>>;
  getContractAndLicenseById?: Maybe<ContractLicense>;
  getContribution?: Maybe<Array<Maybe<Contribution>>>;
  getCookie?: Maybe<Scalars['String']['output']>;
  getCountAlerts?: Maybe<CountAlert>;
  getCouponCode?: Maybe<CouponCode>;
  getCreateCategroyGiftCardById?: Maybe<GiftCardCategory>;
  getCurrentAccural?: Maybe<AccuralDate>;
  getCurrentDayRosterByEmployee?: Maybe<Schedule>;
  getCurrentDayScheduleByEmployee?: Maybe<Schedule>;
  getCurrentEmployeeAction?: Maybe<UserHistory>;
  getCurrentScheduleByEmployeeId?: Maybe<CurrendClockedInSchedule>;
  getCurretUserAllPermissions?: Maybe<Array<Maybe<Permission>>>;
  getCurretUserAllowedModules?: Maybe<Array<Maybe<Permission>>>;
  getCustomGradeScale?: Maybe<Array<Maybe<AppraisalScale>>>;
  getCustomersBysearch?: Maybe<Array<Maybe<Customer>>>;
  getCustomersTrasactions?: Maybe<Array<Maybe<Transaction>>>;
  getDataByFolder?: Maybe<Scalars['Boolean']['output']>;
  getDataWithZipcode?: Maybe<Array<Maybe<HierarchicalDetail>>>;
  getDeduction?: Maybe<Array<Maybe<Deduction>>>;
  getDefaultEmailTemplate?: Maybe<DefaultEmailTemplate>;
  getDefaultEmailTemplateListWithSearch?: Maybe<DefaultTemplateResult>;
  getDelegantApproval?: Maybe<DelegantApproval>;
  getDepartmentById?: Maybe<Department>;
  getDepartmentComplianceSummary?: Maybe<Array<Maybe<DepartmentComplianceSummary>>>;
  getDepartmentsByLocationID?: Maybe<Array<Maybe<Department>>>;
  getDepartmentsByRoleId?: Maybe<Array<Maybe<Department>>>;
  getDepartmentsList?: Maybe<DepartmentListingresult>;
  getDesignationById?: Maybe<Designation>;
  getDesignationList?: Maybe<DesignationListingresult>;
  getDetailTypeByAccountId?: Maybe<DetailType>;
  getDeviceInfoById?: Maybe<TerminalAppHistoryResult>;
  getDeviceModel?: Maybe<Array<Maybe<DeviceModel>>>;
  getDeviceModelById?: Maybe<DeviceModel>;
  getDiscountByCode?: Maybe<Discount>;
  getDiscountById?: Maybe<Discount>;
  getDocumentById?: Maybe<DocumentControlAttachment>;
  getDocumentControlAttachmentsById?: Maybe<DocumentControlAttachment>;
  getDocumentControlAttachmentsFolder?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
  getDocumentControlGroups?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
  getDocumentListBySenderId?: Maybe<Array<Maybe<UnSignedList>>>;
  getDocumentListBySubscriptionId?: Maybe<Array<Maybe<UnSignedList>>>;
  getDocumentTypes?: Maybe<Array<Maybe<MasterDataValue>>>;
  getDocumentsByEmployeeId?: Maybe<AllDocumentsDataTableResult>;
  getDocumentsWithFilter?: Maybe<AllDocumentsResult>;
  getDomain?: Maybe<BusinessDomain>;
  getEffectDiscountToCustomer?: Maybe<ProgressBarData>;
  getEmailDeliveryRuleById?: Maybe<EmailDeliveryRule>;
  getEmailDeliveryRuleWithSearch?: Maybe<EmailDeliveryRuleResult>;
  getEmailTemplateListWithSearch?: Maybe<EmailTemplateResult>;
  getEmployeeAttendance?: Maybe<AttendanceListingResult>;
  getEmployeeAttendanceByGroup?: Maybe<AttendanceByGroup>;
  getEmployeeBirthDaysForCalender?: Maybe<Array<Maybe<User>>>;
  getEmployeeByAssignRole?: Maybe<Array<Maybe<User>>>;
  getEmployeeByEmail?: Maybe<User>;
  getEmployeeByEmailLogin?: Maybe<User>;
  getEmployeeByID?: Maybe<User>;
  getEmployeeByRoleId?: Maybe<Array<Maybe<User>>>;
  getEmployeeByRoleIds?: Maybe<Array<Maybe<User>>>;
  getEmployeeCount?: Maybe<Array<Maybe<AttendanceEmployeeCount>>>;
  getEmployeeCustomPermissions?: Maybe<UserCustomPermissions>;
  getEmployeeDashboardViewById?: Maybe<EmployeeDashboardView>;
  getEmployeeEncryptionKeys?: Maybe<UserEncryptionKeys>;
  getEmployeeFirstSchedule?: Maybe<Schedule>;
  getEmployeeForMention?: Maybe<Array<Maybe<User>>>;
  getEmployeeGarnishmentById?: Maybe<EmployeeGarnishment>;
  getEmployeeGarnishmentList?: Maybe<EmployeeGarnishmentResult>;
  getEmployeeLastClockedInOrSeparation?: Maybe<ClockedInOrSepration>;
  getEmployeeLeaveAccuralsDetail?: Maybe<Array<Maybe<LeaveAccural>>>;
  getEmployeeLeaveByDateRange?: Maybe<Array<Maybe<EmployeeLeavebyDateRange>>>;
  getEmployeeListForSeparation?: Maybe<Array<Maybe<User>>>;
  getEmployeePaidUnpaidLeaves?: Maybe<EmployeePaidUnpaidLeaves>;
  getEmployeePendingRequests?: Maybe<PendingRequests>;
  getEmployeePermissionsByEmployeeId?: Maybe<Array<Maybe<PermissionRole>>>;
  getEmployeeReportingTeam?: Maybe<Array<Maybe<User>>>;
  getEmployeeRolePermissions?: Maybe<AllowPermissions>;
  getEmployeeSchedules?: Maybe<ScheduleListingResult>;
  getEmployeeSeparationById?: Maybe<EmployeeSeparation>;
  getEmployeeTimeLineHistory?: Maybe<HistoryListingResult>;
  getEmployeeTimeSheetList?: Maybe<Array<Maybe<EmployeesMonthlyTimeSheet>>>;
  getEmployeeTrainingAssignments?: Maybe<EmployeeTrainingProfileList>;
  getEmployeeTrainingProfile?: Maybe<EmployeeTrainingProfile>;
  getEmployeeTrainingStats?: Maybe<EmployeeTrainingStats>;
  getEmployeeTwoFAData?: Maybe<TwoFaOutput>;
  getEmployeeUnpaidWeekend?: Maybe<Array<Maybe<Weekend>>>;
  getEmployeeWeekend?: Maybe<Array<Maybe<Weekend>>>;
  getEmployeesAssetAssigned?: Maybe<EmpoyeesAssetAssignedResults>;
  getEmployeesAssetAssignedWithSearch?: Maybe<EmpoyeesAssetAssignedResult>;
  getEmployeesByDepartment?: Maybe<EmployeeListingResult>;
  getEmployeesByDepartmentWithoutLimits?: Maybe<Array<Maybe<User>>>;
  getEmployeesByDepartments?: Maybe<Array<Maybe<User>>>;
  getEmployeesByIdDutyRoster?: Maybe<RosterStores>;
  getEmployeesByLocationID?: Maybe<Array<Maybe<User>>>;
  getEmployeesByPayroleFilters?: Maybe<Array<Maybe<User>>>;
  getEmployeesByRole?: Maybe<Array<Maybe<User>>>;
  getEmployeesByRosterStore?: Maybe<RosterStores>;
  getEmployeesChatWithSearch?: Maybe<EmployeeListingResultNew>;
  getEmployeesDepartmentsByStore?: Maybe<EmployeesDepartmentsList>;
  getEmployeesForAssigningRole?: Maybe<Array<Maybe<User>>>;
  getEmployeesForAttendacePolicy?: Maybe<Array<Maybe<User>>>;
  getEmployeesForAttendancePolicy?: Maybe<Array<Maybe<User>>>;
  getEmployeesForFinalSettlement?: Maybe<Array<Maybe<EmployeeSeparation>>>;
  getEmployeesForLeavePolicy?: Maybe<Array<Maybe<User>>>;
  getEmployeesForLineManager?: Maybe<Array<Maybe<User>>>;
  getEmployeesScheduleExists?: Maybe<Array<Maybe<User>>>;
  getEmployeesUnderRole?: Maybe<Array<Maybe<User>>>;
  getEmployeesWithBirthday?: Maybe<Array<Maybe<User>>>;
  getEmployeesWithClockedHistory?: Maybe<EmployeeshClockedHistoryList>;
  getEmployeesWithPermisstionsByBusinessId?: Maybe<EmpoyeesPermissions>;
  getEmployeesWithRosters?: Maybe<EmployeesWithRostersList>;
  getEmployeesWithSchedule?: Maybe<ScheduleListingResultApp>;
  getEmployeesWithSearch?: Maybe<EmployeeListingResultNew>;
  getEncryptionCopyByUserId?: Maybe<Array<Maybe<UserEncryptionCopies>>>;
  getEvaluationById?: Maybe<AppraisalEvaluation>;
  getEvaluatorQuizAssignmentListWIthSearch?: Maybe<QuizEvaluatorResult>;
  getEvaluators?: Maybe<Array<Maybe<QuizEvaluatorList>>>;
  getExpenseApprovalsWithFilters?: Maybe<ExpnseResultUpdate>;
  getExpenseById?: Maybe<Expense>;
  getExpenseDetail?: Maybe<Scalars['Int']['output']>;
  getExpenseInvoiceAndCategoryListWithSearch?: Maybe<GetInvoiceExpenseAndCategoryList>;
  getExpenseInvoiceById?: Maybe<GetExpenseInvoice>;
  getExpenseInvoiceCategoryById?: Maybe<GetExpenseInvoiceCategory>;
  getExpenseInvoiceCategoryWithSearch?: Maybe<GetExpenseInvoiceCategoryList>;
  getExpenseInvoiceWithSearch?: Maybe<GetInvoiceExpenseList>;
  getExpenseRequestOfUser?: Maybe<Array<Maybe<Expense>>>;
  getExpenseRequestWithFilters?: Maybe<ExpnseResultUpdate>;
  getExpenseWithFilters?: Maybe<ExpnseResultUpdate>;
  getExternalVendorTrainingsById?: Maybe<ExternalVendorTraining>;
  getFeaturesByModuleAndSubModule?: Maybe<Array<Maybe<TemplateFeature>>>;
  getFeedbackById?: Maybe<Feedback>;
  getFeedbackTypes?: Maybe<Array<Maybe<MasterDataValue>>>;
  getFeedbacks?: Maybe<FeedbackResult>;
  getFileUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getFilterByID?: Maybe<Filter>;
  getFinalSettlementById?: Maybe<FinalSettlement>;
  getFinalSettlementByUserId?: Maybe<FinalSettlement>;
  getFinalSettlementWithFilters?: Maybe<FinalSettlementResult>;
  getFoldersWithSearch?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
  getFranchiseRequests?: Maybe<Array<Maybe<FranchiseRequest>>>;
  getGiftCardById?: Maybe<GiftCard>;
  getGiftCardBycardNo?: Maybe<GiftCard>;
  getGiftCardsWithSearch?: Maybe<GiftCardListingResult>;
  getGoalById?: Maybe<GetGoals>;
  getGoalList?: Maybe<GoalsListingresult>;
  getGoalsForExtendedView?: Maybe<Array<Maybe<AppraisalEvaluation>>>;
  getGratuityByID?: Maybe<Gratuity>;
  getGratuityPolicy?: Maybe<Gratuity>;
  getGroupGoalsList?: Maybe<GrounpEvaluationListResult>;
  getGroupedWagesDataForGraph?: Maybe<GrandTotalWagesGraph>;
  getHRComplaintById?: Maybe<HrComplaint>;
  getHRComplaintDashboard?: Maybe<HrComplaintDashboard>;
  getHRComplaints?: Maybe<HrComplaintPaginatedResult>;
  getHistoryById?: Maybe<UserHistory>;
  getInsuranceById?: Maybe<Insurance>;
  getInsurancewithemployeejoiningDate?: Maybe<Array<Maybe<MedicalInsurancePackage>>>;
  getInterviewLogs?: Maybe<InterviewLogPaginatedResult>;
  getInvoiceById?: Maybe<InvoicesList>;
  getInvoiceByItemId?: Maybe<InvoicesList>;
  getInvoiceItemById?: Maybe<InvoiceItemDetails>;
  getItemAsset?: Maybe<Array<Maybe<Asset>>>;
  getLeaseById?: Maybe<Lease>;
  getLeaveAccuralLedger?: Maybe<LeaveAccuralLedgerResponse>;
  getLeaveAfterLastWorkingDay?: Maybe<Array<Maybe<Schedule>>>;
  getLeavePolicyById?: Maybe<LeavePolicy>;
  getLeaveTypeById?: Maybe<LeaveType>;
  getLeaveTypeEmployeeById?: Maybe<ResultWrapper>;
  getLeavesTypeWithSearch?: Maybe<LeaveTypeListingResult>;
  getLinkToken?: Maybe<LinkToken>;
  getLinkedBusinesses?: Maybe<Array<Maybe<BusinessNavigation>>>;
  getLinkedBusinessesById?: Maybe<BusinessNavigation>;
  getLoanApprovalsWithFilters?: Maybe<LoanResult>;
  getLoanById?: Maybe<LoanPayment>;
  getLoanDetail?: Maybe<LoanDetail>;
  getLoanRequestOfUser?: Maybe<Array<Maybe<LoanPayment>>>;
  getLoanRequestWithFilters?: Maybe<LoanResult>;
  getLoanTransactionById?: Maybe<LoanTransaction>;
  getLoanTransactionsByLoanId?: Maybe<LoanTransactionResult>;
  getLoanWithFilters?: Maybe<LoanResult>;
  getLoggedInBusinessAllowedModule?: Maybe<Array<Maybe<Permission>>>;
  getLoggedInBusinessModulePermissions?: Maybe<ModulePermissions>;
  getLoggedInUserAllowModules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getLoggedInUserAllowModulesAndFeature?: Maybe<ModuleFeature>;
  getLoggedInUserAllowModulesAndFeatureWithName?: Maybe<ModuleFeature>;
  getLoggedInUserModulePermissions?: Maybe<ModulePermissions>;
  getLoginUserTasks?: Maybe<Array<Maybe<TaskManagement>>>;
  getLogsByTaskId?: Maybe<TaskTimeLogsById>;
  getMSAttendanceLogs?: Maybe<Array<Maybe<BusinessAttendanceLogs>>>;
  getMaapedPlaidCcategories?: Maybe<Array<Maybe<MappedPlaidCategories>>>;
  getMaintenanceById?: Maybe<Maintenance>;
  getManagerComplianceView?: Maybe<ComplianceDashboardResult>;
  getManagerEmployeeTrainingProfile?: Maybe<EmployeeTrainingProfile>;
  getMarginTiers?: Maybe<Array<Maybe<MarginTiers>>>;
  getMarkInvoiceItem?: Maybe<GetInvoiceItemList>;
  getMarkReason?: Maybe<Array<Maybe<Reason>>>;
  getMarkedAttendanceByDate?: Maybe<ClockedHistory>;
  getMasterDataValuesByDataValueName?: Maybe<Array<Maybe<MasterDataValue>>>;
  getMedicalInsuranceList?: Maybe<MedicalInsuranceConfig>;
  getMedicalInsurancePackageList?: Maybe<MedicalInsurancePackageConfigUpdate>;
  getMedicalInsurancePackageNewList?: Maybe<MedicalInsurancePackageConfig>;
  getMilestoneTrackingById?: Maybe<MilestoneTracking>;
  getMisPaunchOutEmployeeList?: Maybe<MissPaunchOutListingResult>;
  getModelsByBrandIds?: Maybe<Array<Maybe<SystemModel>>>;
  getModulesFeaturesAndPermissions?: Maybe<Modulefeatureandpermission>;
  getMostSoldProducts?: Maybe<Array<Maybe<Product>>>;
  getMyEvaluation?: Maybe<AppraisalEvaluationResult>;
  getMyFeedbacks?: Maybe<Array<Maybe<Feedback>>>;
  getMyHRComplaints?: Maybe<Array<Maybe<HrComplaint>>>;
  getMyMilestoneTracking?: Maybe<MilestoneTracking>;
  getMyOrientationTracking?: Maybe<OrientationTracking>;
  getMyQuizTraningListWithSearch?: Maybe<MyQuizTraningListingResult>;
  getMyTaskCalender?: Maybe<TaskCalenderResults>;
  getMyTaskWithSearch?: Maybe<TaskListingResult>;
  getNotificationById?: Maybe<Notification>;
  getObjectiveAssignmentById?: Maybe<ObjectiveAssignments>;
  getOrgChartSettings?: Maybe<OrgChartSettings>;
  getOrganizationRoleHierarchy?: Maybe<Array<Maybe<RoleWithUser>>>;
  getOrganizationRolesHierarchy?: Maybe<Array<Maybe<Role>>>;
  getOrganizationUsersWithRoleHierarchy?: Maybe<Array<Maybe<RolesData>>>;
  getOrientationTrackingById?: Maybe<OrientationTracking>;
  getPacakgesForCustomSubscriptionRequest?: Maybe<Array<Maybe<Package>>>;
  getPackageAndBusinessPermission?: Maybe<PacakgeAndBusinessPermission>;
  getPackageById?: Maybe<PackageById>;
  getPaidUnPaidByID?: Maybe<PaidUnPaids>;
  getPasswordManagerAdmin?: Maybe<User>;
  getPasswordManagerAdmins?: Maybe<Array<Maybe<PasswordManagerAdmins>>>;
  getPaymentMethod?: Maybe<CardsDetail>;
  getPayrollByID?: Maybe<Payroll>;
  getPayrollDetail?: Maybe<PayrollDetail>;
  getPayrollDetailByID?: Maybe<PayrollDetail>;
  getPayrollDetailByUserID?: Maybe<PayrollDetail>;
  getPayrollScheduleByID?: Maybe<PayrollSchedule>;
  getPayrollStructureByID?: Maybe<PayrollStructure>;
  getPendingRequestCount?: Maybe<PendingRequestsData>;
  getPerformanceCycleById?: Maybe<PerformanceCycleType>;
  getPerformanceCycleList?: Maybe<PerformanceCycleResult>;
  getPlaidSyncTransactions?: Maybe<PlaidSyncTransactions>;
  getPlaidTransactions?: Maybe<PlaidTransactionsResult>;
  getPreviuseAccuralHistoryLogs?: Maybe<AccuralHistoryLogs>;
  getProdcutsByFilteration?: Maybe<Array<Maybe<Product>>>;
  getProductAttributes?: Maybe<ProductAttributes>;
  getProductTypes?: Maybe<Array<Maybe<ProductType>>>;
  getProductsByLocation?: Maybe<Array<Maybe<Product>>>;
  getProfitCategory?: Maybe<Array<Maybe<ProfitCategory>>>;
  getPublicHolidayForCalender?: Maybe<Array<Maybe<PublicHoliday>>>;
  getPublicHolidayOrWeekend?: Maybe<Array<Maybe<Schedule>>>;
  getPublicHolidaysByID?: Maybe<PublicHoliday>;
  getPublicHolidaysWithFilters?: Maybe<PublicHolidaysResult>;
  getPublicPackagesForFranchisee?: Maybe<Array<Maybe<Package>>>;
  getQRLogs?: Maybe<QrLogsList>;
  getQuizAssignmentById?: Maybe<AssignedQuiz>;
  getQuizAssignmentListWIthSearch?: Maybe<QuizAssignedListResult>;
  getQuizById?: Maybe<Quiz>;
  getQuizByIdForManualReAttemped?: Maybe<Quiz>;
  getQuizCategoryById?: Maybe<QuizCategoryDetails>;
  getQuizCategoryListWIthSearch?: Maybe<QuizCategoryListResult>;
  getQuizCategorySectionById?: Maybe<QuizCategorySectionType>;
  getQuizListWIthSearch?: Maybe<QuizListResult>;
  getQuizQuestionById?: Maybe<Question>;
  getQuizQuestionByLanguage?: Maybe<Question>;
  getQuizQuestionListWIthSearch?: Maybe<QuestionList>;
  getQuizQuestions?: Maybe<Array<Maybe<QuizQuestiones>>>;
  getQuizReportById?: Maybe<AssignedQuizReport>;
  getQuizTrainingAssignementById?: Maybe<QuizTrainingAssignementListResult>;
  getQuizTrainingAssignmentListWIthSearch?: Maybe<QuizTrainingAssignmentListResult>;
  getQuizTrainingById?: Maybe<MyQuizTrainingLists>;
  getQuizTrainingCategoryById?: Maybe<QuizTrainingCategoryDetails>;
  getQuizTrainingCategoryListWIthSearch?: Maybe<QuizTrainingCategoryListResult>;
  getQuizTrainingReplicaById?: Maybe<QuizTrainingReplica>;
  getQuizTrainingReplicaListWIthSearch?: Maybe<QuizTrainingReplicaListResult>;
  getQuizTraningListWithSearch?: Maybe<QuizTraningListingResult>;
  getQuizesForTraining?: Maybe<QuizListResult>;
  getReasons?: Maybe<Array<Maybe<Reason>>>;
  getRecruitmentById?: Maybe<Recruitment>;
  getRecruitmentEmployeeByConfig?: Maybe<RecruitmentResult>;
  getRegionById?: Maybe<Region>;
  getRegionWithSearch?: Maybe<RegionListingResult>;
  getRemainingLeavesRequest?: Maybe<RemainingLeaves>;
  getRepairCategory?: Maybe<Array<Maybe<RepairCategory>>>;
  getRepairsServicesFilteration?: Maybe<Array<Maybe<ServicesPrice>>>;
  getReportObjectiveAssigment?: Maybe<ReportObjectiveAssignment1>;
  getReserveAssetColor?: Maybe<GetReserveAssetColor>;
  getResetPolicyDetail?: Maybe<Array<Maybe<ResultOutOfAccural>>>;
  getReviewReportForUser?: Maybe<Array<Maybe<GetReviewReport>>>;
  getReviewcyclereport?: Maybe<AppraisalEvaluationResult>;
  getRoasterMinutes?: Maybe<RosterMinutesAndDate>;
  getRoasterWithScheduledDahboard?: Maybe<DashboardRostersWithAttendance>;
  getRole?: Maybe<RolePermission>;
  getRoleByBusinessId?: Maybe<Array<Maybe<Role>>>;
  getRoleDetail?: Maybe<Role>;
  getRoles?: Maybe<Array<Maybe<Role>>>;
  getRolesByBusinessId?: Maybe<Array<Maybe<Role>>>;
  getRolesByDepartmentId?: Maybe<Array<Maybe<Role>>>;
  getRolesByEmployees?: Maybe<Array<Maybe<Role>>>;
  getRolesByStore?: Maybe<Array<Maybe<Role>>>;
  getRolesOrganizationHierarchy?: Maybe<Array<Maybe<UserWithRolesHierarchy>>>;
  getRolesWithFilter?: Maybe<RolelistingResult>;
  getRosterByEmployeeID?: Maybe<Array<Maybe<Roster>>>;
  getRosterByID?: Maybe<Roster>;
  getRosterByUserId?: Maybe<Array<Maybe<UserRoster>>>;
  getRosterData?: Maybe<Array<Maybe<RosterData>>>;
  getRosterDepartmentData?: Maybe<Array<Maybe<DepartmentRosterData>>>;
  getRosterStores?: Maybe<Array<Maybe<RosterStores>>>;
  getRosterTemplates?: Maybe<Array<Maybe<RosterTemplate>>>;
  getRosterTimeOff?: Maybe<TimeOffListingRosterResult>;
  getRosterWithSearch?: Maybe<RosterListingResult>;
  getRosters?: Maybe<EmployeesRosters>;
  getRostersByEmployeeId?: Maybe<Array<Maybe<Roster>>>;
  getSaleGoalWithAdvanceFilter?: Maybe<Array<Maybe<Goals>>>;
  getSampleData?: Maybe<Array<Maybe<SampleData>>>;
  getSavedFilters?: Maybe<Array<Maybe<Filter>>>;
  getScheduleAlertData?: Maybe<Array<Maybe<AlertData>>>;
  getScheduleById?: Maybe<Schedule>;
  getScheduleGraph?: Maybe<ScheduleGraphData>;
  getScheduleLogs?: Maybe<Array<Maybe<ScheduleLogs>>>;
  getScheduleMinutes?: Maybe<ScheduleMinutesAndDate>;
  getScheduleTotalCounts?: Maybe<ScheduleCountsType>;
  getScheduleWithSearch?: Maybe<ScheduleListingResult>;
  getSchedulerConfig?: Maybe<SchedulerConfig>;
  getSchedulesBreaksByDateRange?: Maybe<Array<Maybe<ScheduleBreaks>>>;
  getSearchContribution?: Maybe<ContributionlistingResult>;
  getSearchDeduction?: Maybe<DeductionlistingResult>;
  getSearchedDiscountTags?: Maybe<Array<Maybe<Tags>>>;
  getSearchpaidUnPaid?: Maybe<PaidUnPaidlistingResult>;
  getSectionsByCategory?: Maybe<Array<Maybe<QuizCategorySection>>>;
  getSendgridConfig?: Maybe<SendgridConfig>;
  getServices?: Maybe<Array<Maybe<Service>>>;
  getSharedAuthenticatorAppById?: Maybe<ShareAuthenticatorApp>;
  getShifBreaks?: Maybe<Array<Maybe<MasterDataValue>>>;
  getShiftByID?: Maybe<Shift>;
  getShipToById?: Maybe<GetShipToType>;
  getShippingMethods?: Maybe<Array<Maybe<ShippingMethods>>>;
  getShippingMethodsById?: Maybe<ShippingMethods>;
  getSingleTemplateModule?: Maybe<TemplateModule>;
  getSitesAssetAssigned?: Maybe<SitesAssetAssignedResults>;
  getSitesAssetAssignedWithSearch?: Maybe<SitesAssetAssignedResult>;
  getStateByCountryId?: Maybe<Array<Maybe<State>>>;
  getStationByDepartmentId?: Maybe<Array<Maybe<Station>>>;
  getStationtById?: Maybe<Station>;
  getStoreCustomFields?: Maybe<Array<Maybe<StoreCustomField>>>;
  getStoreDutyRoster?: Maybe<RosterStores>;
  getSubCategoriesByCategory?: Maybe<Array<Maybe<QuizTrainingSubCategorySection>>>;
  getSubordinateEvaluation?: Maybe<AppraisalEvaluationResult>;
  getSubscriptionAttachments?: Maybe<AttachmentListingResult>;
  getSubscriptionAttachmentsFolder?: Maybe<Array<Maybe<Attachment>>>;
  getSubscriptionById?: Maybe<Subscription>;
  getSubscriptionByRequestedBusinessId?: Maybe<Subscription>;
  getSubscriptionLogActivityById?: Maybe<SubscriptionLogActivity>;
  getSubscriptionPaymentLogs?: Maybe<Array<Maybe<PackagePaymentLogs>>>;
  getSystemBrandById?: Maybe<SystemBrand>;
  getTaskById?: Maybe<TaskManagement_>;
  getTaskByTaskName?: Maybe<TaskManagement>;
  getTaskCalender?: Maybe<TaskCalenderResults>;
  getTasksCount?: Maybe<TasksCountResult>;
  getTasksForCalender?: Maybe<Array<Maybe<TasksForCalenderType>>>;
  getTaxById?: Maybe<Tax>;
  getTaxWithSearch?: Maybe<TaxListingResult>;
  getTeamMembers?: Maybe<Array<Maybe<User>>>;
  getTechbarPublicPackagesForBusiness?: Maybe<Array<Maybe<Package>>>;
  getTemplateModules?: Maybe<Array<Maybe<TemplateModule>>>;
  getTemplatesByModuleSubModule?: Maybe<Array<Maybe<EmailTemplateUnion>>>;
  getTerminalAppHistory?: Maybe<TerminalAppHistoryResult>;
  getTillCountLogsWithSearch?: Maybe<TillCountListing>;
  getTimeOffApprovalsWithSearch?: Maybe<TimeOffListingresult>;
  getTimeOffById?: Maybe<TimeOff>;
  getTimeOffList?: Maybe<TimeOffListingresult>;
  getTimeOffPTOById?: Maybe<Array<Maybe<PtoDayBreakdown>>>;
  getTimeOffRequestList?: Maybe<TimeOffListingresult>;
  getTimeOffRequestUser?: Maybe<Array<Maybe<TimeOff>>>;
  getTimeSheetAttendanceGrandTotal?: Maybe<GrandTotalResult>;
  getTimeSheetAttendanceList?: Maybe<EmployeesClockHistory>;
  getTimeSheetAttendanceListByEmployee?: Maybe<EmployeeClockHistory>;
  getTimeSheetAttendanceListNew?: Maybe<EmployeesClockHistory>;
  getTimeSheetGrandTotal?: Maybe<GrandTotalResult>;
  getTimeSheetGraph?: Maybe<TimesheetGraph>;
  getTimeZone?: Maybe<Array<Maybe<TimeZone>>>;
  getTimesheetAnalytics?: Maybe<TimesheetAnalyticsResult>;
  getTimesheetStatusByDates?: Maybe<TimesheetStatus>;
  getTotalBusinessLocations?: Maybe<Scalars['Int']['output']>;
  getTotalCustomers?: Maybe<Scalars['Int']['output']>;
  getTotalEmployees?: Maybe<Scalars['Int']['output']>;
  getTotalEmployeesRostersWages?: Maybe<TotalEmployeesRostersWages>;
  getTotalPurchasesReport?: Maybe<Array<Maybe<PurchasesReport>>>;
  getTotalRevenue?: Maybe<Scalars['Float']['output']>;
  getTotalSalesByBusinessId?: Maybe<Array<Maybe<SalesReport1>>>;
  getTotalSalesReport?: Maybe<Array<Maybe<SalesReport>>>;
  getTotalSchedulers?: Maybe<Scalars['Int']['output']>;
  getTrainingAttemptHistory?: Maybe<TrainingAttemptHistoryList>;
  getTrainingCycles?: Maybe<TrainingCycleList>;
  getTrainingFailureResetLogs?: Maybe<TrainingFailureResetLogList>;
  getTrainingMatrixById?: Maybe<TrainingMatrix>;
  getTrainingMatrixList?: Maybe<TrainingMatrixResult>;
  getTrainingSettings?: Maybe<TrainingSettings>;
  getUserActivities?: Maybe<UserActivityListingResult>;
  getUserAppDeviceById?: Maybe<UserAppDevice>;
  getUserAppDeviceCount?: Maybe<UserAppDeviceCount>;
  getUserAppDeviceList?: Maybe<UserAppDeviceList>;
  getUserAppDevices?: Maybe<Array<Maybe<UserAppDevice>>>;
  getUserByRolePermissions?: Maybe<Array<Maybe<User>>>;
  getUserConnectedAppList?: Maybe<UserAppDeviceList>;
  getUserDashboardView?: Maybe<Array<Maybe<EmployeeDashboardView>>>;
  getUserMonthlyTimeSheetStatus?: Maybe<Array<Maybe<UserMonthlyAttendaceStatus>>>;
  getUserRolesByFeature?: Maybe<Array<Maybe<Role>>>;
  getUserTimeSheetStatus?: Maybe<CountStatusCount>;
  getUserWithSummary?: Maybe<UserData>;
  getUserdashboard?: Maybe<UserDashbaord>;
  getUsersForPublicHolidays?: Maybe<Array<Maybe<User>>>;
  getUsersQuizAssignmentListWIthSearch?: Maybe<QuizUserListResult>;
  getUsersWithPasswordPermission?: Maybe<Array<Maybe<User>>>;
  getValidateDiscountByCode?: Maybe<ValidDiscount>;
  getVendor?: Maybe<Array<Maybe<Vendor>>>;
  getVendorByID?: Maybe<Vendor>;
  getWriteUpApprovalsWithFilters?: Maybe<WriteUpResult>;
  getWriteUpById?: Maybe<WriteUp>;
  getWriteups?: Maybe<WriteUpListDataTable>;
  getWriteupsByEmployeeId?: Maybe<WriteUpList>;
  getZipCodeWithFilter?: Maybe<Array<Maybe<ZipCode>>>;
  getallActiveRoles?: Maybe<Array<Maybe<Role>>>;
  getattendancePolicyByID?: Maybe<AttandencePolicy>;
  getattendancePolicyWithFilter?: Maybe<Array<Maybe<AttandencePolicy>>>;
  getbusinessPermissionsbyBusinessID?: Maybe<BusinessPermissionsbytype>;
  getemployeeRecentFileView?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
  listYourDomainEmails?: Maybe<Array<Maybe<BusinessEmail>>>;
  previouseAccuralHistory?: Maybe<Array<Maybe<AccuralHistory>>>;
  previouseAccuralHistoryWithConfig?: Maybe<AccuralHistoryListingResult>;
  publicHoliday?: Maybe<SandwichLeaveType>;
  resetAccural?: Maybe<ResetAccuralPolicy>;
  searchAuthenticatorApps?: Maybe<SearchAuthenticatorResult>;
  searchBusinessLocation?: Maybe<BuinsessLocationlistingResult>;
  searchCommisionCampaigns?: Maybe<Array<Maybe<CommissionCampaign>>>;
  searchInCommission?: Maybe<Array<Maybe<Commission>>>;
  sendEmailGiftCard?: Maybe<Scalars['Boolean']['output']>;
  setAccessToken?: Maybe<Scalars['Boolean']['output']>;
  startCronjob?: Maybe<Scalars['Boolean']['output']>;
  subTest?: Maybe<Scalars['Int']['output']>;
  totalRepairDevices?: Maybe<RepairDevices>;
  userBusinessLocations?: Maybe<Array<Maybe<BusinessLocation>>>;
  validateAuthenticatedNewDomain?: Maybe<SendGridValidationResponse>;
  validateBusinessAddEmployeeRequest?: Maybe<Scalars['Float']['output']>;
  validateBusinessAddStoreRequest?: Maybe<Scalars['Float']['output']>;
  validateComissionCampaignName?: Maybe<Scalars['Boolean']['output']>;
  validateComissionName?: Maybe<Scalars['Boolean']['output']>;
  validateStoreAddEmployeeRequest?: Maybe<Scalars['Float']['output']>;
  verifyBusinessSystemName?: Maybe<Scalars['Boolean']['output']>;
  verifyEmployeeSchedule?: Maybe<Array<Maybe<User>>>;
};


export type QueryCommissionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommissionsArgs = {
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
};


export type QueryGetAssetMovementHistorybyIdArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBusinessLocationByIdArgs = {
  businessLocationId: Scalars['ID']['input'];
};


export type QueryBusinessPackageByBusinessIdArgs = {
  businessId: Scalars['ID']['input'];
};


export type QueryCalculateUpdatePackageFeeArgs = {
  package: Scalars['ID']['input'];
  subscription: Scalars['ID']['input'];
};


export type QueryCheckAbsentUsersArgs = {
  business?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCheckAssetByAssetIdAndNumberArgs = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckEmployeeIsClockedInArgs = {
  employee_id: Scalars['ID']['input'];
};


export type QueryCheckQuizTrainingAssignmentStatusByIdsArgs = {
  quizId: Scalars['ID']['input'];
  quizTrainingReplicaId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryCheckUnRestrictedPolicyArgs = {
  attendance_date: Scalars['DateTime']['input'];
  employee_id: Scalars['ID']['input'];
};


export type QueryCommisionCampaignByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConfirmEmployeeClockedHistoryArgs = {
  input: ConfirmClockedHistory;
};


export type QueryCustomersByBusinessIdArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryCustomersByLocationIdArgs = {
  business: Scalars['ID']['input'];
  businessLocation: Scalars['ID']['input'];
};


export type QueryDeleteInvoiceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDeleteInvoiceItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmployeeLoanAmountArgs = {
  employee: Scalars['ID']['input'];
};


export type QueryEmployeeSeparationListArgs = {
  input?: InputMaybe<EmployeeSeparationFilter>;
};


export type QueryFetchQuizAssignmentByIdArgs = {
  quizId: Scalars['ID']['input'];
  quizTrainingReplicaId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryFilterQuizTrainingAssignementArgs = {
  input?: InputMaybe<QuizTrainingAssignmentFilterInput>;
  trainingReplicaId: Scalars['ID']['input'];
};


export type QueryForgetBusinessUrlArgs = {
  input?: InputMaybe<ForgetBusinessInput>;
};


export type QueryGenerateAssetIdArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAccountTypeByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetActionFeaturesArgs = {
  input?: InputMaybe<ActionFeatureFilterInput>;
};


export type QueryGetAdminDashboardDataArgs = {
  input?: InputMaybe<InputadminDashboard>;
};


export type QueryGetAdvanceFilterByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetAllAccessoriesWithSearchArgs = {
  input?: InputMaybe<AccessoriesListFilter>;
};


export type QueryGetAllActiveAndInActiveEmployeesArgs = {
  business_id: Scalars['ID']['input'];
  feature?: InputMaybe<FeatureEnum>;
};


export type QueryGetAllActiveAppraisalTypeArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllActiveBusinessesLocationsByBusinessIdArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetAllActiveEmployeesArgs = {
  business_id: Scalars['ID']['input'];
  feature?: InputMaybe<FeatureEnum>;
};


export type QueryGetAllActiveEmployeesForShareDocumentArgs = {
  input: GetAllActiveEmployeesForShareDocumentInput;
};


export type QueryGetAllActiveEmployeesWithSearchArgs = {
  business_id: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllActiveInActiveEmployeesByDepartmentArgs = {
  filter?: InputMaybe<EmployeesByDepWithoutLimits>;
};


export type QueryGetAllAdvanceFiltersArgs = {
  type: Scalars['String']['input'];
};


export type QueryGetAllAlertsArgs = {
  input?: InputMaybe<AlertListFilter>;
};


export type QueryGetAllAppraisalObjectiveArgs = {
  input?: InputMaybe<InputAppraisalObjective>;
};


export type QueryGetAllAppraisalScalesArgs = {
  input?: InputMaybe<InputAppraisalScales>;
};


export type QueryGetAllAppraisalTypeArgs = {
  input?: InputMaybe<InputAllAppraisalType>;
};


export type QueryGetAllAssetBrandListArgs = {
  input?: InputMaybe<InputfilterAssetBrand>;
};


export type QueryGetAllAssetByCategoryIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAllAssetCategoryAndSubCategoryArgs = {
  input?: InputMaybe<CategoryListFilter>;
};


export type QueryGetAllAssetSubCategoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAllAssetTypesArgs = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAllAssetsWithSearchArgs = {
  input?: InputMaybe<AssetListFilter>;
};


export type QueryGetAllAssigneeTasksWithSearchArgs = {
  input: AllAssigneeTasksInput;
};


export type QueryGetAllAttendanceArgs = {
  input?: InputMaybe<AttendanceListFilters>;
};


export type QueryGetAllBrandsArgs = {
  input?: InputMaybe<ListFilter>;
};


export type QueryGetAllCampaignsSearchArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetAllCashRegistersHistoryArgs = {
  input: GetCashRegistersHistoryInput;
};


export type QueryGetAllCategoryAndSubcategoryListArgs = {
  input?: InputMaybe<CategoryListFilter>;
};


export type QueryGetAllCityArgs = {
  state_ids: Array<Scalars['ID']['input']>;
};


export type QueryGetAllContractAndLicenseeWithSearchArgs = {
  input?: InputMaybe<ContractLicenseFilter>;
};


export type QueryGetAllContractsAndLicensesLinkWithAssetsArgs = {
  assetId: Scalars['ID']['input'];
};


export type QueryGetAllDepartmentAssetWithSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllDepartmentsArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetAllDesignationListArgs = {
  input?: InputMaybe<DesignationtListFilter>;
};


export type QueryGetAllDeviceModelArgs = {
  input?: InputMaybe<InputFilter>;
};


export type QueryGetAllDeviceModelByBrandArgs = {
  brandId?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGetAllDiscountsArgs = {
  input?: InputMaybe<SearchDiscountInput>;
};


export type QueryGetAllDiscountsWithSearchArgs = {
  input?: InputMaybe<SearchDiscountNewInput>;
};


export type QueryGetAllDisposeWithSearchArgs = {
  input?: InputMaybe<DisposeListFilter>;
};


export type QueryGetAllDocumentsLinkWithAssetsArgs = {
  assetId: Scalars['ID']['input'];
};


export type QueryGetAllEmployeeActionsArgs = {
  input: EmployeeActionInput;
};


export type QueryGetAllEmployeeTypesArgs = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAllEmployeeswithjoingDateArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetAllEvaluationArgs = {
  input?: InputMaybe<InputAllEvaluation>;
};


export type QueryGetAllExpenseInvoiceArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllExpenseInvoiceCategoryArgs = {
  filter?: InputMaybe<ExpenseInvFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllExternalVendorTrainingsArgs = {
  input?: InputMaybe<ExternalVendorTrainingListInput>;
};


export type QueryGetAllFinalSettlementArgs = {
  business: Scalars['ID']['input'];
};


export type QueryGetAllGoalsListArgs = {
  input?: InputMaybe<InputAllEvaluation>;
};


export type QueryGetAllGroupListArgs = {
  input?: InputMaybe<GetGroupsInput>;
};


export type QueryGetAllInsuranceLinkWithAssetsArgs = {
  assetId: Scalars['ID']['input'];
};


export type QueryGetAllInsuranceWithSearchArgs = {
  input?: InputMaybe<InsuranceListFilter>;
};


export type QueryGetAllInvoiceItemArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllInvoicesArgs = {
  input?: InputMaybe<InvoicesInput>;
};


export type QueryGetAllLeaseWithSearchArgs = {
  input?: InputMaybe<LeaseListFilter>;
};


export type QueryGetAllLeavePoliciesWithConfigArgs = {
  input?: InputMaybe<LeavePolicyListingInput>;
};


export type QueryGetAllLeavePoliciesWithSearchArgs = {
  business?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllLinkRelationalAssetArgs = {
  assetId: Scalars['ID']['input'];
};


export type QueryGetAllLinkedAssetBrandListArgs = {
  input?: InputMaybe<InputfilterAssetBrand>;
};


export type QueryGetAllMyAuthenticatorAppsArgs = {
  input?: InputMaybe<GetAuthenticatorAppDataTableInput>;
};


export type QueryGetAllMaintenanceLinkWithAssetsArgs = {
  assetId: Scalars['ID']['input'];
};


export type QueryGetAllMaintenanceWithSearchArgs = {
  input?: InputMaybe<MaintenanceListFilter>;
};


export type QueryGetAllMasterDataTypeValueByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAllMasterDataTypeValueByTypeIdArgs = {
  input: DataValueInput;
};


export type QueryGetAllMasterDataTypeValueWithSearchArgs = {
  input: SearchDataTypeValueInput;
};


export type QueryGetAllMasterDataTypeWithSearchArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllMilestoneTrackingArgs = {
  input?: InputMaybe<MilestoneTrackingListInput>;
};


export type QueryGetAllMoveLeavePolicyArgs = {
  business?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllMyRequestDocumentsArgs = {
  input: InputDocumentsWithFilter;
};


export type QueryGetAllMyTasksWithSearchArgs = {
  input: AllMyTasksInput;
};


export type QueryGetAllNotificationsArgs = {
  input?: InputMaybe<NotificationsInput>;
};


export type QueryGetAllNotificationsWithFiltersArgs = {
  input?: InputMaybe<NotificationFilterInput>;
};


export type QueryGetAllNotificationsWithPaginationArgs = {
  input?: InputMaybe<NotificationsInput>;
};


export type QueryGetAllObjectiveAssignmentArgs = {
  input?: InputMaybe<InputAllobjectiveAssignment>;
};


export type QueryGetAllOrientationTrackingArgs = {
  input?: InputMaybe<OrientationTrackingListInput>;
};


export type QueryGetAllPackagesArgs = {
  input?: InputMaybe<PackageListFilter>;
};


export type QueryGetAllPayrollScheduleListArgs = {
  input?: InputMaybe<PayrollScheduleListInput>;
};


export type QueryGetAllPayrollStructureListWithSearchArgs = {
  input?: InputMaybe<PayrollStructureListInput>;
};


export type QueryGetAllPayrolleListArgs = {
  input?: InputMaybe<InputPayrollList>;
};


export type QueryGetAllQuickAssetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type: EnumAssetType;
};


export type QueryGetAllQuizCategoryArgs = {
  input?: InputMaybe<AllCategories>;
};


export type QueryGetAllRegionsArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetAllRepairPriceWithSearchArgs = {
  input?: InputMaybe<InputRepairPriceWithSearch>;
};


export type QueryGetAllRequestedDocumentsArgs = {
  input: InputDocumentsWithFilter;
};


export type QueryGetAllReserveArgs = {
  input?: InputMaybe<ReserveAssetFilter>;
};


export type QueryGetAllReserveWithSearchArgs = {
  input?: InputMaybe<ReserveListFilter>;
};


export type QueryGetAllRostersByRosterStoreIdArgs = {
  roster_store_id: Scalars['ID']['input'];
};


export type QueryGetAllSendRequestDocumentsArgs = {
  input: InputDocumentsWithFilter;
};


export type QueryGetAllShareOfAppArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAllShareOfDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryGetAllShareWithMeAppsArgs = {
  input?: InputMaybe<GetAuthenticatorAppInput>;
};


export type QueryGetAllShiftsListArgs = {
  input?: InputMaybe<ShiftListInput>;
};


export type QueryGetAllShipToArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllStationsArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetAllSubscriptionLogActivityArgs = {
  input?: InputMaybe<LogActivity>;
};


export type QueryGetAllSystemBrandsArgs = {
  Business: Scalars['ID']['input'];
  BusinessLocation: Scalars['ID']['input'];
  input?: InputMaybe<ListFilter>;
};


export type QueryGetAllTasksWithSearchArgs = {
  input: AllTasksInput;
};


export type QueryGetAllTaxArgs = {
  input?: InputMaybe<InputGetAllTaxes>;
};


export type QueryGetAllTimeOffByBusinessArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetAllUsersForSharedRecordsArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAllowanceByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAllowanceWithFiltersArgs = {
  input?: InputMaybe<AllowanceFilter>;
};


export type QueryGetAppVersionArgs = {
  input: AppVersionInput;
};


export type QueryGetAppVersionsArgs = {
  input: AppVersionInput;
};


export type QueryGetAppraisalObejctiveByPerformanceCycleArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetAppraisalObjectiveByAppraisalTypeArgs = {
  apprailsaTypeId: Scalars['ID']['input'];
};


export type QueryGetAppraisalObjectiveByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetAppraisalObjectiveByTypeArgs = {
  PerformanceCycleId: Scalars['ID']['input'];
};


export type QueryGetAppraisalScaleByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetAppraisalTypeByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetApprovalWorkFlowByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetApprovalWorkFlowWithSearchArgs = {
  input?: InputMaybe<WorkFlowListFilter>;
};


export type QueryGetArchivedDocumentsArgs = {
  input?: InputMaybe<ArchivedDocumentInput>;
};


export type QueryGetAssetBrandByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetAssetCategoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAssetCountArgs = {
  input?: InputMaybe<DashboardAssetCount>;
};


export type QueryGetAssetModelByBrandArgs = {
  assetBrand: Scalars['ID']['input'];
};


export type QueryGetAssetModelByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetAssetSubCategoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAssetsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGetAssetsByBussinessIdArgs = {
  input?: InputMaybe<InputAssetByBusiness>;
};


export type QueryGetAssetsByDepartmentIdArgs = {
  department_id: Scalars['ID']['input'];
  type: AssetTypeEnum;
};


export type QueryGetAssetsByEmployeeIdArgs = {
  input?: InputMaybe<InputAssetByEmployee>;
};


export type QueryGetAssetsByIdArgs = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAssetsWithEmployeeHerierchyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAssignByMeTaskWithSearchArgs = {
  input?: InputMaybe<TaskWithSearchInput>;
};


export type QueryGetAssignToMeTaskWithSearchArgs = {
  input?: InputMaybe<TaskWithSearchInput>;
};


export type QueryGetAttemptQuizByIdArgs = {
  id: Scalars['ID']['input'];
  selectedLanguage: LanguageCode;
};


export type QueryGetAttendanceByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetAttendanceListArgs = {
  input?: InputMaybe<AttendanceListFilter>;
};


export type QueryGetAttendanceListByEmployeeIdArgs = {
  input: InputTimeSheetEmployeeId;
};


export type QueryGetAttendanceListWithStatusArgs = {
  input?: InputMaybe<AttendanceListWithStatus>;
};


export type QueryGetAttendancePolicyByPayTypeArgs = {
  pay_type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAttendancePolicyGroupsArgs = {
  business_id: Scalars['ID']['input'];
  policy_status?: InputMaybe<PolicyStatusEnum>;
};


export type QueryGetAttendanceRegulationApprovalsWithSearchArgs = {
  input?: InputMaybe<AttendanceFilter>;
};


export type QueryGetAttendanceRegulationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAttendanceRegulationOfUserArgs = {
  input?: InputMaybe<InputAttendceRequest>;
};


export type QueryGetAttendanceRegulationWithSearchArgs = {
  input?: InputMaybe<AttendanceFilter>;
};


export type QueryGetAuthenticatorAppByIdArgs = {
  Id: Scalars['ID']['input'];
};


export type QueryGetBrandByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBusinessByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetBusinessByIdentificationNumberArgs = {
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBusinessBySystemNameArgs = {
  systemName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBusinessBySystemNameWithValidationArgs = {
  input: BusinessSystemInput;
};


export type QueryGetBusinessByUserIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetBusinessEmailTemplateArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetBusinessLocationsByBusinessIdArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetBusinessPackageDetailArgs = {
  business?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetBusinessPackagesArgs = {
  business: Scalars['ID']['input'];
  package_type?: InputMaybe<PackageType>;
};


export type QueryGetBusinessSubscriptionsArgs = {
  input?: InputMaybe<SubscriptionListFilter>;
};


export type QueryGetBusinessedByTypeArgs = {
  type?: InputMaybe<AllowBusinessType>;
};


export type QueryGetBusinessesByTypeArgs = {
  business_types: Array<Scalars['String']['input']>;
};


export type QueryGetBusinessesLocationsArgs = {
  business_ids: Array<Scalars['ID']['input']>;
};


export type QueryGetBusinessesLocationsByRegionIdArgs = {
  region_id: Scalars['ID']['input'];
};


export type QueryGetBusinessesWithFilterArgs = {
  input?: InputMaybe<BusinessListFilter>;
};


export type QueryGetCampaignsAndSearchArgs = {
  input?: InputMaybe<SearchCampaignInput>;
};


export type QueryGetCashRegisterByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCashRegisterByLocationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetCashRegisterWithFiltersArgs = {
  input?: InputMaybe<CashRegisterListFilter>;
};


export type QueryGetCategoryGiftCardListArgs = {
  input?: InputMaybe<GiftCardCategoryListFilter>;
};


export type QueryGetChartOfAccountByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetChartOfAccountListArgs = {
  input: ChartOfAccountsListFilter;
};


export type QueryGetChartOfAccountsByAccountTypeArgs = {
  account_type: Scalars['ID']['input'];
};


export type QueryGetCityByStateIdArgs = {
  state_id: Scalars['ID']['input'];
};


export type QueryGetCommisionCampaignsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCommisionCampaignswithCommissionsArgs = {
  input?: InputMaybe<CommissioinCampaignSearchInput>;
};


export type QueryGetCommissionAndSearchArgs = {
  input?: InputMaybe<SearchCommissionInput>;
};


export type QueryGetCompansationLeaveTypeArgs = {
  business: Scalars['ID']['input'];
};


export type QueryGetComplianceDashboardArgs = {
  input?: InputMaybe<ComplianceDashboardInput>;
};


export type QueryGetComplianceDashboardDataTableArgs = {
  input?: InputMaybe<ComplianceDashboardListInput>;
};


export type QueryGetConflictScheduleArgs = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetContractAndLicenseByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetContributionArgs = {
  input?: InputMaybe<GetContributionFilter>;
};


export type QueryGetCreateCategroyGiftCardByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCurrentAccuralArgs = {
  packageId: Scalars['ID']['input'];
};


export type QueryGetCurrentDayRosterByEmployeeArgs = {
  date: Scalars['Date']['input'];
  employeeId: Scalars['ID']['input'];
};


export type QueryGetCurrentDayScheduleByEmployeeArgs = {
  date: Scalars['Date']['input'];
  employeeId: Scalars['ID']['input'];
};


export type QueryGetCurrentEmployeeActionArgs = {
  employee_id: Scalars['ID']['input'];
};


export type QueryGetCurrentScheduleByEmployeeIdArgs = {
  badge_code?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetCustomersBysearchArgs = {
  input?: InputMaybe<CustomerInput>;
};


export type QueryGetCustomersTrasactionsArgs = {
  input?: InputMaybe<CustomerTransactionInput>;
};


export type QueryGetDataByFolderArgs = {
  folderName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDataWithZipcodeArgs = {
  business?: InputMaybe<Scalars['ID']['input']>;
  zipcode: Scalars['String']['input'];
};


export type QueryGetDeductionArgs = {
  input?: InputMaybe<GetDeductionFilter>;
};


export type QueryGetDefaultEmailTemplateArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetDefaultEmailTemplateListWithSearchArgs = {
  input?: InputMaybe<InputEmailTemplateList>;
};


export type QueryGetDelegantApprovalArgs = {
  approval_type: Scalars['String']['input'];
};


export type QueryGetDepartmentByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetDepartmentsByLocationIdArgs = {
  business_id: Scalars['ID']['input'];
  location_id: Scalars['ID']['input'];
};


export type QueryGetDepartmentsByRoleIdArgs = {
  role_id: Scalars['ID']['input'];
};


export type QueryGetDepartmentsListArgs = {
  input?: InputMaybe<DepartmentListFilter>;
};


export type QueryGetDesignationByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetDesignationListArgs = {
  input?: InputMaybe<DesignationtListFilter>;
};


export type QueryGetDetailTypeByAccountIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetDeviceInfoByIdArgs = {
  input?: InputMaybe<InputDeviceInfoById>;
};


export type QueryGetDeviceModelByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetDiscountByCodeArgs = {
  code: Scalars['ID']['input'];
};


export type QueryGetDiscountByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDocumentByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDocumentControlAttachmentsByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDocumentListBySenderIdArgs = {
  singerId: Scalars['ID']['input'];
  subId: Scalars['ID']['input'];
};


export type QueryGetDocumentListBySubscriptionIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDocumentsByEmployeeIdArgs = {
  input?: InputMaybe<InputEmployeeDocuments>;
};


export type QueryGetDocumentsWithFilterArgs = {
  input: InputWithFilter;
};


export type QueryGetDomainArgs = {
  domainId: Scalars['String']['input'];
};


export type QueryGetEffectDiscountToCustomerArgs = {
  input?: InputMaybe<ProgressBarInput>;
};


export type QueryGetEmailDeliveryRuleByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetEmailDeliveryRuleWithSearchArgs = {
  input?: InputMaybe<EmailDeliveryRuleList>;
};


export type QueryGetEmailTemplateListWithSearchArgs = {
  input?: InputMaybe<InputEmailTemplateList>;
};


export type QueryGetEmployeeAttendanceArgs = {
  input?: InputMaybe<AttendanceInput>;
};


export type QueryGetEmployeeAttendanceByGroupArgs = {
  input?: InputMaybe<GroupEmployeeInput>;
};


export type QueryGetEmployeeByAssignRoleArgs = {
  role: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEmployeeByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetEmployeeByEmailLoginArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetEmployeeByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetEmployeeByRoleIdArgs = {
  roles_id: Scalars['ID']['input'];
};


export type QueryGetEmployeeByRoleIdsArgs = {
  roles_ids: Array<Scalars['ID']['input']>;
};


export type QueryGetEmployeeCountArgs = {
  department_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  roles_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEmployeeCustomPermissionsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEmployeeDashboardViewByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEmployeeEncryptionKeysArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetEmployeeFirstScheduleArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryGetEmployeeForMentionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEmployeeGarnishmentByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetEmployeeGarnishmentListArgs = {
  input?: InputMaybe<InputemployeeGarnishmentList>;
};


export type QueryGetEmployeeLastClockedInOrSeparationArgs = {
  clockedHistory?: InputMaybe<Scalars['Boolean']['input']>;
  user_id: Scalars['ID']['input'];
};


export type QueryGetEmployeeLeaveAccuralsDetailArgs = {
  input: LeaveAccuralInput;
};


export type QueryGetEmployeeLeaveByDateRangeArgs = {
  input?: InputMaybe<EmployeeLeaveInput>;
};


export type QueryGetEmployeeListForSeparationArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEmployeePaidUnpaidLeavesArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetEmployeePendingRequestsArgs = {
  action_performed?: InputMaybe<Scalars['Boolean']['input']>;
  employeeID: Scalars['ID']['input'];
};


export type QueryGetEmployeePermissionsByEmployeeIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEmployeeReportingTeamArgs = {
  business_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type QueryGetEmployeeRolePermissionsArgs = {
  role?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetEmployeeSchedulesArgs = {
  input: GetScheduleByEmployeeIdInput;
};


export type QueryGetEmployeeSeparationByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetEmployeeTimeLineHistoryArgs = {
  input?: InputMaybe<HistoryListFilter>;
};


export type QueryGetEmployeeTimeSheetListArgs = {
  input?: InputMaybe<EmployeeTimeSheetInput>;
};


export type QueryGetEmployeeTrainingAssignmentsArgs = {
  input?: InputMaybe<EmployeeTrainingProfileListInput>;
};


export type QueryGetEmployeeTrainingProfileArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryGetEmployeeTrainingStatsArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryGetEmployeeTwoFaDataArgs = {
  input: TwoFaInput;
};


export type QueryGetEmployeeUnpaidWeekendArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetEmployeeWeekendArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetEmployeesAssetAssignedArgs = {
  input: EmployeesSitesInput;
};


export type QueryGetEmployeesAssetAssignedWithSearchArgs = {
  input: EmployeesAssetInput;
};


export type QueryGetEmployeesByDepartmentArgs = {
  filter?: InputMaybe<EmployessByDepartment>;
};


export type QueryGetEmployeesByDepartmentWithoutLimitsArgs = {
  filter?: InputMaybe<EmployeesByDepWithoutLimits>;
};


export type QueryGetEmployeesByDepartmentsArgs = {
  input?: InputMaybe<EmployeeFilterInput>;
};


export type QueryGetEmployeesByIdDutyRosterArgs = {
  input?: InputMaybe<SearchRosterInput>;
};


export type QueryGetEmployeesByLocationIdArgs = {
  business_id: Scalars['ID']['input'];
  location_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetEmployeesByPayroleFiltersArgs = {
  BusinessLocation: Array<InputMaybe<Scalars['ID']['input']>>;
  RoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  departmentsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  payType?: InputMaybe<Scalars['String']['input']>;
  payschedule?: InputMaybe<Scalars['String']['input']>;
  salarytype?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEmployeesByRoleArgs = {
  roles_id: Scalars['ID']['input'];
};


export type QueryGetEmployeesByRosterStoreArgs = {
  _id: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEmployeesChatWithSearchArgs = {
  input?: InputMaybe<EmployeeListFilter>;
};


export type QueryGetEmployeesDepartmentsByStoreArgs = {
  input: EmployeesDepartmentsFilter;
};


export type QueryGetEmployeesForAssigningRoleArgs = {
  roleId: Scalars['ID']['input'];
};


export type QueryGetEmployeesForAttendacePolicyArgs = {
  input?: InputMaybe<EmployeesForPolicy>;
};


export type QueryGetEmployeesForLeavePolicyArgs = {
  args?: InputMaybe<GetLeavePolicyArguments>;
};


export type QueryGetEmployeesScheduleExistsArgs = {
  input: EmployeesScheduleExists;
};


export type QueryGetEmployeesWithBirthdayArgs = {
  type: FilterEnum;
};


export type QueryGetEmployeesWithClockedHistoryArgs = {
  input?: InputMaybe<EmployeesWithClockedHistoryInput>;
};


export type QueryGetEmployeesWithPermisstionsByBusinessIdArgs = {
  input: EmployeesByBusiness;
};


export type QueryGetEmployeesWithRostersArgs = {
  input: GetRosterWithFilter;
};


export type QueryGetEmployeesWithScheduleArgs = {
  input?: InputMaybe<ScheduleListFilterApp>;
};


export type QueryGetEmployeesWithSearchArgs = {
  input?: InputMaybe<EmployeeListFilter>;
};


export type QueryGetEncryptionCopyByUserIdArgs = {
  input: GetEncryptionCopyInput;
};


export type QueryGetEvaluationByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetEvaluatorQuizAssignmentListWIthSearchArgs = {
  input?: InputMaybe<QuizAssignedListInput>;
};


export type QueryGetEvaluatorsArgs = {
  input?: InputMaybe<EvaluatorInputs>;
};


export type QueryGetExpenseApprovalsWithFiltersArgs = {
  input?: InputMaybe<ExpenseRequestFilter>;
};


export type QueryGetExpenseByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetExpenseDetailArgs = {
  employee: Scalars['ID']['input'];
};


export type QueryGetExpenseInvoiceAndCategoryListWithSearchArgs = {
  input?: InputMaybe<ExpenseInvoiceCategoryInput>;
};


export type QueryGetExpenseInvoiceByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetExpenseInvoiceCategoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetExpenseInvoiceCategoryWithSearchArgs = {
  input?: InputMaybe<ExpenseInvoiceCategoryInput>;
};


export type QueryGetExpenseInvoiceWithSearchArgs = {
  input?: InputMaybe<ExpenseInvoiceInput>;
};


export type QueryGetExpenseRequestOfUserArgs = {
  input?: InputMaybe<InputExpenseRequestUser>;
};


export type QueryGetExpenseRequestWithFiltersArgs = {
  input?: InputMaybe<ExpenseFilter>;
};


export type QueryGetExpenseWithFiltersArgs = {
  input?: InputMaybe<ExpenseFilter>;
};


export type QueryGetExternalVendorTrainingsByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetFeaturesByModuleAndSubModuleArgs = {
  input: ModuleAndSubModuleInputIdsInput;
};


export type QueryGetFeedbackByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetFeedbacksArgs = {
  input?: InputMaybe<FeedbackFilter>;
};


export type QueryGetFilterByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetFinalSettlementByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetFinalSettlementByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetFinalSettlementWithFiltersArgs = {
  input: FinalSettlementFilter;
};


export type QueryGetFoldersWithSearchArgs = {
  parent?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DocumentTypeEnums>;
};


export type QueryGetFranchiseRequestsArgs = {
  business: Scalars['ID']['input'];
};


export type QueryGetGiftCardByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetGiftCardBycardNoArgs = {
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  card_no: Scalars['String']['input'];
};


export type QueryGetGiftCardsWithSearchArgs = {
  input: GiftCardListFilter;
};


export type QueryGetGoalByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetGoalListArgs = {
  input?: InputMaybe<GoalsListFilter>;
};


export type QueryGetGoalsForExtendedViewArgs = {
  performanceCycleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryGetGratuityByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetGratuityPolicyArgs = {
  business: Scalars['ID']['input'];
};


export type QueryGetGroupGoalsListArgs = {
  input?: InputMaybe<InputAllEvaluation>;
};


export type QueryGetGroupedWagesDataForGraphArgs = {
  input: InputTimeSheet;
};


export type QueryGetHrComplaintByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetHrComplaintsArgs = {
  input?: InputMaybe<ComplaintFilterInput>;
};


export type QueryGetHistoryByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetInsuranceByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInsurancewithemployeejoiningDateArgs = {
  input?: InputMaybe<Joiningdateinput>;
};


export type QueryGetInterviewLogsArgs = {
  complaint_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetInvoiceByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetInvoiceByItemIdArgs = {
  itemId: Scalars['ID']['input'];
};


export type QueryGetInvoiceItemByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetItemAssetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetLeaseByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLeaveAccuralLedgerArgs = {
  input: LeaveAccuralLedgerInput;
};


export type QueryGetLeaveAfterLastWorkingDayArgs = {
  input?: InputMaybe<GetLeaveAfterLastWorkingDayInput>;
};


export type QueryGetLeavePolicyByIdArgs = {
  _id: Scalars['ID']['input'];
  employee?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLeaveTypeByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLeaveTypeEmployeeByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLeavesTypeWithSearchArgs = {
  input?: InputMaybe<LeaveTypeListFilter>;
};


export type QueryGetLinkedBusinessesArgs = {
  input?: InputMaybe<GetLinkedBusinessInput>;
};


export type QueryGetLinkedBusinessesByIdArgs = {
  business_navigation_id: Scalars['ID']['input'];
};


export type QueryGetLoanApprovalsWithFiltersArgs = {
  input?: InputMaybe<LoanRequestFilter>;
};


export type QueryGetLoanByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLoanDetailArgs = {
  employee: Scalars['ID']['input'];
};


export type QueryGetLoanRequestOfUserArgs = {
  input?: InputMaybe<InputLoanRequestUser>;
};


export type QueryGetLoanRequestWithFiltersArgs = {
  input?: InputMaybe<LoanFilter>;
};


export type QueryGetLoanTransactionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLoanTransactionsByLoanIdArgs = {
  input?: InputMaybe<LoanTransactionFilter>;
};


export type QueryGetLoanWithFiltersArgs = {
  input?: InputMaybe<LoanFilter>;
};


export type QueryGetLoggedInBusinessModulePermissionsArgs = {
  module: Scalars['String']['input'];
};


export type QueryGetLoggedInUserAllowModulesAndFeatureWithNameArgs = {
  module?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetLoggedInUserModulePermissionsArgs = {
  module: Scalars['String']['input'];
};


export type QueryGetLoginUserTasksArgs = {
  input?: InputMaybe<UserFilterTasks>;
};


export type QueryGetLogsByTaskIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMsAttendanceLogsArgs = {
  from_date: Scalars['String']['input'];
  to_date: Scalars['String']['input'];
};


export type QueryGetMaintenanceByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetManagerComplianceViewArgs = {
  input?: InputMaybe<ComplianceDashboardInput>;
};


export type QueryGetManagerEmployeeTrainingProfileArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryGetMarginTiersArgs = {
  input?: InputMaybe<InputMarginTiersSearch>;
};


export type QueryGetMarkInvoiceItemArgs = {
  input?: InputMaybe<GetMarkInvoiceItems>;
};


export type QueryGetMarkReasonArgs = {
  input?: InputMaybe<InputSearchMarkReason>;
};


export type QueryGetMarkedAttendanceByDateArgs = {
  attandance_data: Scalars['String']['input'];
  employee_id: Scalars['ID']['input'];
};


export type QueryGetMasterDataValuesByDataValueNameArgs = {
  data_type_name: Scalars['String']['input'];
};


export type QueryGetMedicalInsuranceListArgs = {
  input?: InputMaybe<MedicalInsuranceListFilter>;
};


export type QueryGetMedicalInsurancePackageListArgs = {
  input?: InputMaybe<MedicalInsuranceListFilter>;
};


export type QueryGetMedicalInsurancePackageNewListArgs = {
  input?: InputMaybe<MedicalInsuranceListFilter>;
};


export type QueryGetMilestoneTrackingByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetMisPaunchOutEmployeeListArgs = {
  input?: InputMaybe<MissPaunchOut>;
};


export type QueryGetModelsByBrandIdsArgs = {
  brandIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryGetMostSoldProductsArgs = {
  filter: SoldInput;
};


export type QueryGetMyEvaluationArgs = {
  input?: InputMaybe<InputAllEvaluation>;
};


export type QueryGetMyQuizTraningListWithSearchArgs = {
  input?: InputMaybe<QuizTraningListInput>;
};


export type QueryGetMyTaskCalenderArgs = {
  input?: InputMaybe<TaskCalenderInput>;
};


export type QueryGetMyTaskWithSearchArgs = {
  input?: InputMaybe<TaskWithSearchInput>;
};


export type QueryGetNotificationByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetObjectiveAssignmentByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetOrgChartSettingsArgs = {
  businessId: Scalars['ID']['input'];
};


export type QueryGetOrganizationRoleHierarchyArgs = {
  business: Scalars['ID']['input'];
};


export type QueryGetOrganizationRolesHierarchyArgs = {
  business: Scalars['ID']['input'];
};


export type QueryGetOrganizationUsersWithRoleHierarchyArgs = {
  business: Scalars['ID']['input'];
};


export type QueryGetOrientationTrackingByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetPacakgesForCustomSubscriptionRequestArgs = {
  subscription: Scalars['ID']['input'];
};


export type QueryGetPackageAndBusinessPermissionArgs = {
  business?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPackageByIdArgs = {
  package_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPaidUnPaidByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPasswordManagerAdminsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPaymentMethodArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetPayrollByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetPayrollDetailArgs = {
  payroll_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type QueryGetPayrollDetailByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPayrollDetailByUserIdArgs = {
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPayrollScheduleByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetPayrollStructureByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetPendingRequestCountArgs = {
  input: PendingRequestInput;
};


export type QueryGetPerformanceCycleByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPerformanceCycleListArgs = {
  input?: InputMaybe<InputPerformanceCycleType>;
};


export type QueryGetPlaidTransactionsArgs = {
  input?: InputMaybe<PaidTransactionFilter>;
};


export type QueryGetPreviuseAccuralHistoryLogsArgs = {
  leave_Packeg_id?: InputMaybe<Scalars['ID']['input']>;
  searchYear?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProdcutsByFilterationArgs = {
  BusinessLocation: Scalars['ID']['input'];
  brandIds: Array<InputMaybe<Scalars['ID']['input']>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deviceTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  modelIds: Array<InputMaybe<Scalars['ID']['input']>>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryGetProductTypesArgs = {
  input?: InputMaybe<InputOfTypes>;
};


export type QueryGetProductsByLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryGetProfitCategoryArgs = {
  input?: InputMaybe<InputProfitCategoryWithSearch>;
};


export type QueryGetPublicHolidayOrWeekendArgs = {
  input?: InputMaybe<PublicHolidayOrWeekendSchedule>;
};


export type QueryGetPublicHolidaysByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPublicHolidaysWithFiltersArgs = {
  input?: InputMaybe<PublicHolidaysFilter>;
};


export type QueryGetPublicPackagesForFranchiseeArgs = {
  business_id: Scalars['ID']['input'];
  store_type?: InputMaybe<StoreTypeEnum>;
};


export type QueryGetQrLogsArgs = {
  input: QrLogsInput;
};


export type QueryGetQuizAssignmentByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuizAssignmentListWIthSearchArgs = {
  input?: InputMaybe<QuizAssignedListInput>;
};


export type QueryGetQuizByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuizByIdForManualReAttempedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuizCategoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuizCategoryListWIthSearchArgs = {
  input?: InputMaybe<QuizCategoryListInput>;
};


export type QueryGetQuizCategorySectionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuizListWIthSearchArgs = {
  input?: InputMaybe<QuizListInput>;
};


export type QueryGetQuizQuestionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuizQuestionByLanguageArgs = {
  language: LanguageCode;
  master_question_id: Scalars['ID']['input'];
};


export type QueryGetQuizQuestionListWIthSearchArgs = {
  input?: InputMaybe<QuizQuestionListInput>;
};


export type QueryGetQuizQuestionsArgs = {
  input?: InputMaybe<QuizQuestionInputs>;
};


export type QueryGetQuizReportByIdArgs = {
  id: Scalars['ID']['input'];
  selectedLanguage: LanguageCode;
};


export type QueryGetQuizTrainingAssignementByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuizTrainingAssignmentListWIthSearchArgs = {
  input?: InputMaybe<QuizTraningAssignementUserListInput>;
};


export type QueryGetQuizTrainingByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuizTrainingCategoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuizTrainingCategoryListWIthSearchArgs = {
  input?: InputMaybe<QuizCategoryListInput>;
};


export type QueryGetQuizTrainingReplicaByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuizTrainingReplicaListWIthSearchArgs = {
  input?: InputMaybe<QuizTrainingReplicaListInput>;
};


export type QueryGetQuizTraningListWithSearchArgs = {
  input?: InputMaybe<QuizTraningListInput>;
};


export type QueryGetQuizesForTrainingArgs = {
  input?: InputMaybe<QuizListInput>;
};


export type QueryGetReasonsArgs = {
  reason_type?: InputMaybe<ReasonType>;
};


export type QueryGetRecruitmentByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRecruitmentEmployeeByConfigArgs = {
  input?: InputMaybe<InputRecruitment>;
};


export type QueryGetRegionByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetRegionWithSearchArgs = {
  input?: InputMaybe<RegionInput>;
};


export type QueryGetRepairsServicesFilterationArgs = {
  BusinessLocation: Scalars['ID']['input'];
  brandIds: Array<InputMaybe<Scalars['ID']['input']>>;
  modelIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryGetReportObjectiveAssigmentArgs = {
  input?: InputMaybe<InputGetReportObjective>;
};


export type QueryGetResetPolicyDetailArgs = {
  packageId: Scalars['ID']['input'];
};


export type QueryGetReviewcyclereportArgs = {
  input?: InputMaybe<InputReviewcyclereport>;
};


export type QueryGetRoasterMinutesArgs = {
  input?: InputMaybe<RoasterMinutesInput>;
};


export type QueryGetRoasterWithScheduledDahboardArgs = {
  input: DashboardEmplyeCountToday;
};


export type QueryGetRoleArgs = {
  roleID: Scalars['ID']['input'];
};


export type QueryGetRoleByBusinessIdArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetRoleDetailArgs = {
  roleID: Scalars['ID']['input'];
};


export type QueryGetRolesArgs = {
  roleFilter: RoleFilter;
};


export type QueryGetRolesByBusinessIdArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetRolesByDepartmentIdArgs = {
  department_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetRolesByEmployeesArgs = {
  search: Scalars['String']['input'];
};


export type QueryGetRolesByStoreArgs = {
  location_id: Scalars['ID']['input'];
};


export type QueryGetRolesOrganizationHierarchyArgs = {
  busniss: Scalars['ID']['input'];
};


export type QueryGetRolesWithFilterArgs = {
  input: RoleListingFilter;
};


export type QueryGetRosterByEmployeeIdArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryGetRosterByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetRosterByUserIdArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryGetRosterDataArgs = {
  employees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  rosterStore: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRosterDepartmentDataArgs = {
  rosterStore: Scalars['ID']['input'];
};


export type QueryGetRosterStoresArgs = {
  businessId: Scalars['ID']['input'];
};


export type QueryGetRosterTemplatesArgs = {
  roster_store_id: Scalars['ID']['input'];
};


export type QueryGetRosterTimeOffArgs = {
  input: TimeOffListInput;
};


export type QueryGetRosterWithSearchArgs = {
  input?: InputMaybe<RosterListFilter>;
};


export type QueryGetRostersArgs = {
  input: RostersInput;
};


export type QueryGetRostersByEmployeeIdArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryGetSaleGoalWithAdvanceFilterArgs = {
  input?: InputMaybe<SaleGoalAdvanceSearchInput>;
};


export type QueryGetSavedFiltersArgs = {
  type: FilterTypeEnum;
};


export type QueryGetScheduleAlertDataArgs = {
  input?: InputMaybe<RoasterMinutesInput>;
};


export type QueryGetScheduleByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetScheduleGraphArgs = {
  input?: InputMaybe<InputScheduleGraph>;
};


export type QueryGetScheduleLogsArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type QueryGetScheduleMinutesArgs = {
  input: ScheduleMinutesInput;
};


export type QueryGetScheduleTotalCountsArgs = {
  input?: InputMaybe<ScheduleCountFilter>;
};


export type QueryGetScheduleWithSearchArgs = {
  input?: InputMaybe<ScheduleListFilter>;
};


export type QueryGetSchedulerConfigArgs = {
  business: Scalars['ID']['input'];
};


export type QueryGetSchedulesBreaksByDateRangeArgs = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  start_date: Scalars['String']['input'];
};


export type QueryGetSearchContributionArgs = {
  input?: InputMaybe<ContributionListFilter>;
};


export type QueryGetSearchDeductionArgs = {
  input?: InputMaybe<DeductionListFilter>;
};


export type QueryGetSearchedDiscountTagsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSearchpaidUnPaidArgs = {
  input?: InputMaybe<PaidUnPaidListFilter>;
};


export type QueryGetSectionsByCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSharedAuthenticatorAppByIdArgs = {
  Id: Scalars['ID']['input'];
};


export type QueryGetShifBreaksArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetShiftByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetShipToByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetShippingMethodsArgs = {
  input?: InputMaybe<InputGetShippingWithSearch>;
};


export type QueryGetShippingMethodsByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetSingleTemplateModuleArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetSitesAssetAssignedArgs = {
  input: EmployeesSitesInput;
};


export type QueryGetSitesAssetAssignedWithSearchArgs = {
  input: SearchSitesInput;
};


export type QueryGetStateByCountryIdArgs = {
  country_id: Scalars['ID']['input'];
};


export type QueryGetStationByDepartmentIdArgs = {
  department: Scalars['ID']['input'];
};


export type QueryGetStationtByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetStoreCustomFieldsArgs = {
  customFieldType: CustomFieldTypeEnum;
  location_id: Scalars['ID']['input'];
};


export type QueryGetStoreDutyRosterArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetSubCategoriesByCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryGetSubordinateEvaluationArgs = {
  input?: InputMaybe<InputAllEvaluation>;
};


export type QueryGetSubscriptionAttachmentsArgs = {
  input?: InputMaybe<InputAttachment>;
};


export type QueryGetSubscriptionAttachmentsFolderArgs = {
  subscription: Scalars['ID']['input'];
};


export type QueryGetSubscriptionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSubscriptionByRequestedBusinessIdArgs = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSubscriptionLogActivityByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSubscriptionPaymentLogsArgs = {
  subscription: Scalars['ID']['input'];
};


export type QueryGetSystemBrandByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTaskByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTaskByTaskNameArgs = {
  task_name: Scalars['String']['input'];
};


export type QueryGetTaskCalenderArgs = {
  input?: InputMaybe<TaskCalenderInput>;
};


export type QueryGetTasksCountArgs = {
  input?: InputMaybe<TaskCountInput>;
};


export type QueryGetTaxByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTaxWithSearchArgs = {
  filter: TaxFilterInput;
};


export type QueryGetTeamMembersArgs = {
  businessLocaion?: InputMaybe<Scalars['ID']['input']>;
  employee_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetTechbarPublicPackagesForBusinessArgs = {
  business_type?: InputMaybe<AllowBusinessType>;
};


export type QueryGetTemplatesByModuleSubModuleArgs = {
  input?: InputMaybe<TemplateByModuleSubmoduleInput>;
};


export type QueryGetTerminalAppHistoryArgs = {
  input?: InputMaybe<InputTerminalAppHistory>;
};


export type QueryGetTillCountLogsWithSearchArgs = {
  input: GetTillCountInput;
};


export type QueryGetTimeOffApprovalsWithSearchArgs = {
  input?: InputMaybe<TimeOffListFilter>;
};


export type QueryGetTimeOffByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetTimeOffListArgs = {
  input?: InputMaybe<TimeOffListFilter>;
};


export type QueryGetTimeOffPtoByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTimeOffRequestListArgs = {
  input?: InputMaybe<TimeOffListFilter>;
};


export type QueryGetTimeOffRequestUserArgs = {
  input?: InputMaybe<InputTimeOffRequestUser>;
};


export type QueryGetTimeSheetAttendanceGrandTotalArgs = {
  input: InputTimeSheet;
};


export type QueryGetTimeSheetAttendanceListArgs = {
  input?: InputMaybe<InputEmployeeTimeSheet>;
};


export type QueryGetTimeSheetAttendanceListByEmployeeArgs = {
  input?: InputMaybe<InputTimeSheetEmployee>;
};


export type QueryGetTimeSheetAttendanceListNewArgs = {
  input?: InputMaybe<InputEmployeeTimeSheet>;
};


export type QueryGetTimeSheetGrandTotalArgs = {
  input: InputGrandTotal;
};


export type QueryGetTimeSheetGraphArgs = {
  input?: InputMaybe<GetTimeSheetGraph>;
};


export type QueryGetTimesheetAnalyticsArgs = {
  input: TimesheetStatusInput;
};


export type QueryGetTimesheetStatusByDatesArgs = {
  input: TimesheetStatusInput;
};


export type QueryGetTotalBusinessLocationsArgs = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetTotalCustomersArgs = {
  input?: InputMaybe<BusinessStoreInput>;
};


export type QueryGetTotalEmployeesArgs = {
  input?: InputMaybe<BusinessStoreInput>;
};


export type QueryGetTotalEmployeesRostersWagesArgs = {
  input: EmployeesRostertsInput;
};


export type QueryGetTotalPurchasesReportArgs = {
  filter: FilterInput;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  to_date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryGetTotalRevenueArgs = {
  input?: InputMaybe<BusinessStoreInput>;
};


export type QueryGetTotalSalesByBusinessIdArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetTotalSalesReportArgs = {
  filter: FilterInput;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  to_date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryGetTotalSchedulersArgs = {
  business: Scalars['ID']['input'];
};


export type QueryGetTrainingAttemptHistoryArgs = {
  input?: InputMaybe<TrainingAttemptHistoryListInput>;
};


export type QueryGetTrainingCyclesArgs = {
  input?: InputMaybe<TrainingCycleListInput>;
};


export type QueryGetTrainingFailureResetLogsArgs = {
  input?: InputMaybe<TrainingFailureResetLogListInput>;
};


export type QueryGetTrainingMatrixByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTrainingMatrixListArgs = {
  input?: InputMaybe<TrainingMatrixFilter>;
};


export type QueryGetUserActivitiesArgs = {
  input: EmployeeActivityFilter;
};


export type QueryGetUserAppDeviceByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUserAppDeviceListArgs = {
  input: QueryInputUserAppDevice;
};


export type QueryGetUserAppDevicesArgs = {
  app_type: AppTypes;
};


export type QueryGetUserByRolePermissionsArgs = {
  featureName: Scalars['String']['input'];
};


export type QueryGetUserConnectedAppListArgs = {
  input: QueryInputTerminalAppDevice;
};


export type QueryGetUserMonthlyTimeSheetStatusArgs = {
  input?: InputMaybe<InputUserMonthly>;
};


export type QueryGetUserRolesByFeatureArgs = {
  feature: FeatureEnum;
};


export type QueryGetUserTimeSheetStatusArgs = {
  input?: InputMaybe<InpuUserTimeSheetStatus>;
};


export type QueryGetUserWithSummaryArgs = {
  LoginAs?: InputMaybe<LoginAs>;
  appType?: InputMaybe<Application_Type>;
  clocked_time: Scalars['DateTime']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  time_zone: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
};


export type QueryGetUserdashboardArgs = {
  input?: InputMaybe<UserDashboardInput>;
};


export type QueryGetUsersForPublicHolidaysArgs = {
  input?: InputMaybe<ActiveEmployeesForPublicHolidayInput>;
};


export type QueryGetUsersQuizAssignmentListWIthSearchArgs = {
  input?: InputMaybe<QuizUserListInput>;
};


export type QueryGetUsersWithPasswordPermissionArgs = {
  business_id: Scalars['ID']['input'];
};


export type QueryGetValidateDiscountByCodeArgs = {
  input: ValidateDiscountInput;
};


export type QueryGetVendorArgs = {
  input?: InputMaybe<InputGetVendorWithSearch>;
};


export type QueryGetVendorByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetWriteUpApprovalsWithFiltersArgs = {
  input?: InputMaybe<WriteUpRequestFilter>;
};


export type QueryGetWriteUpByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWriteupsArgs = {
  input?: InputMaybe<WriteUpListFilter>;
};


export type QueryGetWriteupsByEmployeeIdArgs = {
  input?: InputMaybe<WriteUpByEmployee>;
};


export type QueryGetZipCodeWithFilterArgs = {
  input?: InputMaybe<ZipCodeFilterInput>;
};


export type QueryGetattendancePolicyByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetattendancePolicyWithFilterArgs = {
  input?: InputMaybe<AttandencePolicyListFilter>;
};


export type QueryGetbusinessPermissionsbyBusinessIdArgs = {
  business?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListYourDomainEmailsArgs = {
  BusinessDomain: Scalars['ID']['input'];
};


export type QueryPreviouseAccuralHistoryArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviouseAccuralHistoryWithConfigArgs = {
  input?: InputMaybe<AccuralHistoryListingInput>;
};


export type QueryPublicHolidayArgs = {
  input: PublicHolidayInput;
};


export type QueryResetAccuralArgs = {
  input?: InputMaybe<ResetAccuralInput>;
};


export type QuerySearchAuthenticatorAppsArgs = {
  input?: InputMaybe<SearchAuthenticatorInput>;
};


export type QuerySearchBusinessLocationArgs = {
  input?: InputMaybe<BusinessLocationListFilter>;
};


export type QuerySearchCommisionCampaignsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchInCommissionArgs = {
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  status?: InputMaybe<_Status>;
};


export type QuerySendEmailGiftCardArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySetAccessTokenArgs = {
  public_token: Array<Scalars['String']['input']>;
};


export type QueryTotalRepairDevicesArgs = {
  location_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryValidateAuthenticatedNewDomainArgs = {
  domainId: Scalars['String']['input'];
};


export type QueryValidateBusinessAddEmployeeRequestArgs = {
  business: Scalars['ID']['input'];
  employeeID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryValidateBusinessAddStoreRequestArgs = {
  business: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryValidateComissionCampaignNameArgs = {
  business_id: Scalars['ID']['input'];
  campaignName: Scalars['String']['input'];
};


export type QueryValidateComissionNameArgs = {
  BusinessLocation: Scalars['ID']['input'];
  commissionCampaignId: Scalars['ID']['input'];
  commission_name: Scalars['String']['input'];
};


export type QueryValidateStoreAddEmployeeRequestArgs = {
  business: Scalars['ID']['input'];
  businessLocation: Scalars['ID']['input'];
};


export type QueryVerifyBusinessSystemNameArgs = {
  business_system_name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVerifyEmployeeScheduleArgs = {
  input: EmployeeScheduleInput;
};

export type Question = {
  __typename?: 'Question';
  QuizCategory?: Maybe<QuizCategory>;
  QuizCategorySection?: Maybe<QuizCategorySection>;
  attachment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  correct_answer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  human_verified?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_required?: Maybe<Scalars['Boolean']['output']>;
  language_statuses?: Maybe<Array<Maybe<LanguageStatus>>>;
  master_question_id?: Maybe<Scalars['ID']['output']>;
  options?: Maybe<Array<Maybe<OptionObject>>>;
  question_text?: Maybe<Scalars['String']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
  quiz_count?: Maybe<Scalars['Int']['output']>;
};

export type QuestionAnswer = {
  __typename?: 'QuestionAnswer';
  QuizQuestion?: Maybe<AssignedQuestion>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  pointsEarned?: Maybe<Scalars['Float']['output']>;
  selectedAnswer?: Maybe<Scalars['String']['output']>;
};

export type QuestionAttemptInput = {
  question?: InputMaybe<Scalars['ID']['input']>;
  selected_answer?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuestionCreated = {
  __typename?: 'QuestionCreated';
  QuizCategory?: Maybe<Scalars['ID']['output']>;
  QuizCategorySection?: Maybe<Scalars['ID']['output']>;
  attachment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  correct_answer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_default_language?: Maybe<Scalars['Boolean']['output']>;
  is_required?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  master_question_id?: Maybe<Scalars['ID']['output']>;
  options?: Maybe<Array<Maybe<OptionObject>>>;
  question_text?: Maybe<Scalars['String']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
  quiz_count?: Maybe<Scalars['Int']['output']>;
};

export type QuestionList = {
  __typename?: 'QuestionList';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Question>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type QuestionListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionListResult = {
  __typename?: 'QuestionListResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Quiz>>>;
};

export type QuestionSection = {
  limit: Scalars['Int']['input'];
  question_section: Scalars['ID']['input'];
};

export type QuestionSectionInput = {
  QuizCategorySection: Scalars['ID']['input'];
  QuizQuestion?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_random: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
};

export type QuestionSectionType = {
  __typename?: 'QuestionSectionType';
  QuizCategorySection?: Maybe<QuizCategorySection>;
  QuizQuestion?: Maybe<Array<Maybe<Question>>>;
  is_random?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
};

export type QuestionWithOutCorrectAnswer = {
  __typename?: 'QuestionWithOutCorrectAnswer';
  QuizCategory?: Maybe<QuizCategory>;
  QuizCategorySection?: Maybe<QuizCategorySection>;
  attachment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_required?: Maybe<Scalars['Boolean']['output']>;
  master_question_id?: Maybe<Question>;
  options?: Maybe<Array<Maybe<OptionObject>>>;
  question_text?: Maybe<Scalars['String']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
  quiz_count?: Maybe<Scalars['Int']['output']>;
};

export type Question_AnswerTypeReport = {
  __typename?: 'Question_answerTypeReport';
  QuizQuestion?: Maybe<Question>;
  is_correct?: Maybe<Scalars['Boolean']['output']>;
  points_earned?: Maybe<Scalars['Float']['output']>;
  selected_answer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Quiz = {
  __typename?: 'Quiz';
  Department?: Maybe<Array<Maybe<Department>>>;
  Role?: Maybe<Array<Maybe<Role>>>;
  assignTo?: Maybe<Array<Maybe<User>>>;
  can_assign_traning?: Maybe<Scalars['Boolean']['output']>;
  can_re_attempts?: Maybe<Scalars['String']['output']>;
  candidates?: Maybe<Scalars['Int']['output']>;
  category_sections?: Maybe<Array<Maybe<CategorySectionType>>>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['Date']['output']>;
  evaluate_by?: Maybe<Array<Maybe<User>>>;
  evaluator_department?: Maybe<Array<Maybe<Department>>>;
  evaluator_role?: Maybe<Array<Maybe<Role>>>;
  grade?: Maybe<Array<Maybe<GradeType>>>;
  id?: Maybe<Scalars['ID']['output']>;
  is_attempt_one_by_one?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_random?: Maybe<Scalars['Boolean']['output']>;
  is_shuffling?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Array<Maybe<LanguageCode>>>;
  max_attempts?: Maybe<Scalars['Int']['output']>;
  passing_marks?: Maybe<Scalars['Float']['output']>;
  question_count?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type QuizCategory = {
  __typename?: 'QuizCategory';
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Scalars['Int']['output']>;
};

export type QuizCategoryDetails = {
  __typename?: 'QuizCategoryDetails';
  created_at?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Scalars['Int']['output']>;
  sections?: Maybe<Array<Maybe<QuizCategorySection>>>;
};

export type QuizCategorySection = {
  __typename?: 'QuizCategorySection';
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  question_count?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

export type QuizCategorySectionType = {
  __typename?: 'QuizCategorySectionType';
  QuizCategory?: Maybe<QuizCategory>;
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

export type QuizEvaluatorList = {
  __typename?: 'QuizEvaluatorList';
  Business?: Maybe<Scalars['ID']['output']>;
  _id?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
};

export type QuizQuestionInputs = {
  Category: Scalars['ID']['input'];
  Section: Scalars['ID']['input'];
  selectedLanguage: Array<InputMaybe<LanguageCode>>;
};

export type QuizQuestionListInput = {
  Category?: InputMaybe<Scalars['ID']['input']>;
  Section?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  selectedLanguage?: InputMaybe<Array<InputMaybe<LanguageCode>>>;
};

export type QuizQuestiones = {
  __typename?: 'QuizQuestiones';
  correct_answer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question_text?: Maybe<Scalars['String']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
};

export type QuizTraining = {
  __typename?: 'QuizTraining';
  _id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type QuizTrainingAssignementListResult = {
  __typename?: 'QuizTrainingAssignementListResult';
  Department?: Maybe<Array<Maybe<Department>>>;
  Quiz?: Maybe<Quiz>;
  QuizTrainingCategory?: Maybe<QuizTrainingCategory>;
  QuizTrainingReplica?: Maybe<QuizTrainingReplica>;
  QuizTrainingSubCategory?: Maybe<QuizTrainingSubCategory>;
  Role?: Maybe<Array<Maybe<Role>>>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  attachments?: Maybe<Array<QuizTrainingAttachment>>;
  content?: Maybe<Scalars['JSON']['output']>;
  created_by?: Maybe<User>;
  default_language?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['DateTime']['output']>;
  invalidated_at?: Maybe<Scalars['DateTime']['output']>;
  invalidation_reason?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_invalidated?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  links?: Maybe<Array<Maybe<QuizTrainingLink>>>;
  matrix_section?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  training_end_time?: Maybe<Scalars['DateTime']['output']>;
  training_start_time?: Maybe<Scalars['DateTime']['output']>;
};

export type QuizTrainingAssignmentFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TrainingAssignStatus>;
};

export type QuizTrainingAttachment = {
  __typename?: 'QuizTrainingAttachment';
  _id?: Maybe<Scalars['ID']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type QuizTrainingCategory = {
  __typename?: 'QuizTrainingCategory';
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type QuizTrainingCategoryDetails = {
  __typename?: 'QuizTrainingCategoryDetails';
  created_at?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sub_categories?: Maybe<Array<Maybe<QuizTrainingSubCategorySection>>>;
};

export type QuizTrainingDepartment = {
  __typename?: 'QuizTrainingDepartment';
  Department: Department;
  assigned_to_user?: Maybe<Array<QuizTrainingUserStatus>>;
  ended_at?: Maybe<Scalars['Date']['output']>;
  started_at?: Maybe<Scalars['Date']['output']>;
};

export type QuizTrainingEntry = {
  __typename?: 'QuizTrainingEntry';
  is_required?: Maybe<Scalars['Boolean']['output']>;
  training?: Maybe<QuizTraining>;
};

export type QuizTrainingEntryInput = {
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  training: Scalars['ID']['input'];
};

export type QuizTrainingLink = {
  __typename?: 'QuizTrainingLink';
  _id?: Maybe<Scalars['ID']['output']>;
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type QuizTrainingReplica = {
  __typename?: 'QuizTrainingReplica';
  Department?: Maybe<Array<Maybe<Department>>>;
  Quiz?: Maybe<Quiz>;
  QuizTrainingCategory?: Maybe<QuizTrainingCategory>;
  QuizTrainingSubCategory?: Maybe<QuizTrainingSubCategory>;
  Role?: Maybe<Array<Maybe<Role>>>;
  attachments?: Maybe<Array<QuizTrainingAttachment>>;
  candidates?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  created_by?: Maybe<User>;
  default_language?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['Date']['output']>;
  evaluate_by?: Maybe<Array<Maybe<User>>>;
  global_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  links?: Maybe<Array<Maybe<QuizTrainingLink>>>;
  started_date?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type QuizTrainingRole = {
  __typename?: 'QuizTrainingRole';
  Role: Role;
  assigned_to_user?: Maybe<Array<QuizTrainingUserStatus>>;
  ended_at?: Maybe<Scalars['Date']['output']>;
  started_at?: Maybe<Scalars['Date']['output']>;
};

export type QuizTrainingSubCategory = {
  __typename?: 'QuizTrainingSubCategory';
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type QuizTrainingSubCategorySection = {
  __typename?: 'QuizTrainingSubCategorySection';
  _id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type QuizTrainingUser = {
  __typename?: 'QuizTrainingUser';
  assigned_to_user?: Maybe<Array<Maybe<QuizTrainingUserStatus>>>;
  ended_at?: Maybe<Scalars['Date']['output']>;
  started_at?: Maybe<Scalars['Date']['output']>;
};

export type QuizTrainingUserStatus = {
  __typename?: 'QuizTrainingUserStatus';
  User: User;
  completed_date?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
};

export type QuizTraningAssignementUserListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_invalidated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuizTraningListingResult = {
  __typename?: 'QuizTraningListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<QuizTrainingListing>>>;
};

export type QuizUserListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_invalidated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuizUserListResult = {
  __typename?: 'QuizUserListResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<AssignedUserQuiz>>>;
};

export type Range = {
  end?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type RangeType = {
  __typename?: 'RangeType';
  end?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Reason = {
  __typename?: 'Reason';
  _id: Scalars['ID']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  reason_name?: Maybe<Scalars['String']['output']>;
  reason_type?: Maybe<Scalars['String']['output']>;
};

export type RecordExternalAssessmentInput = {
  _id: Scalars['ID']['input'];
  completion_date: Scalars['Date']['input'];
  evidence_doc?: InputMaybe<Scalars['Upload']['input']>;
  score: Scalars['Float']['input'];
};

export type RecordPerformanceMeetingInput = {
  _id: Scalars['ID']['input'];
  meeting_date: Scalars['Date']['input'];
  outcome_notes?: InputMaybe<Scalars['String']['input']>;
};

export type RecordResolutionInput = {
  complainant_notification_method: NotificationMethodEnum;
  complainant_notified_date?: InputMaybe<Scalars['DateTime']['input']>;
  disciplinary_action: DisciplinaryActionEnum;
  is_policy_updated_as_result?: InputMaybe<Scalars['Boolean']['input']>;
  is_referred_externally?: InputMaybe<Scalars['Boolean']['input']>;
  outcome: ResolutionOutcomeEnum;
  referral_policy_details?: InputMaybe<Scalars['String']['input']>;
  resolution_notes: Scalars['String']['input'];
};

export enum RecoveryMethod {
  Cash = 'cash',
  LumpSum = 'lump_sum',
  Salary = 'salary'
}

export type Recruitment = {
  __typename?: 'Recruitment';
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  offer_letter?: Maybe<OfferLetter>;
  personal_details?: Maybe<PersonalDetails>;
  status?: Maybe<Scalars['String']['output']>;
  term_and_salary?: Maybe<TermAndSalary>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type RecruitmentInput = {
  Business: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  offer_letter?: InputMaybe<OfferLetterInput>;
  personal_details?: InputMaybe<PersonalDetailsInput>;
  section: RecruitmentInputSections;
  status?: InputMaybe<RecruitmentStatusEnum>;
  term_and_salary?: InputMaybe<TermAndSalaryInput>;
};

export enum RecruitmentInputSections {
  OfferLetter = 'offer_letter',
  PersonalDetails = 'personal_details',
  TermAndSalary = 'term_and_salary'
}

export type Region = {
  __typename?: 'Region';
  BusinessLocation?: Maybe<Array<Maybe<BusinessLocation>>>;
  City?: Maybe<Array<Maybe<City>>>;
  Country?: Maybe<Country>;
  State?: Maybe<Array<Maybe<State>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  region_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum RelationshipToYou {
  Contractor = 'contractor',
  Coworker = 'coworker',
  DirectManager = 'direct_manager',
  Other = 'other',
  SkipLevelManager = 'skip_level_manager'
}

export type RemainingBalance = {
  __typename?: 'RemainingBalance';
  days?: Maybe<Scalars['Float']['output']>;
  exceeded_by_days?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  is_exceeded?: Maybe<Scalars['Boolean']['output']>;
};

export type RemainingLeave = {
  __typename?: 'RemainingLeave';
  assigned_days?: Maybe<Scalars['Float']['output']>;
  carry_forward_days?: Maybe<Scalars['Float']['output']>;
  count_in?: Maybe<Scalars['String']['output']>;
  policy_type?: Maybe<Scalars['String']['output']>;
  remaining?: Maybe<RemainingBalance>;
  time_off_type?: Maybe<Scalars['ID']['output']>;
  total_assigned_days?: Maybe<Scalars['Float']['output']>;
  used?: Maybe<UsedLeave>;
};

export type RemainingLeaves = {
  __typename?: 'RemainingLeaves';
  remainingLeaves?: Maybe<Scalars['String']['output']>;
};

export type RepairCategory = {
  __typename?: 'RepairCategory';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  _id?: Maybe<Scalars['ID']['output']>;
  category_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  is_global?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type RepairDevices = {
  __typename?: 'RepairDevices';
  devices?: Maybe<Scalars['Int']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

export type RepairPrice = {
  __typename?: 'RepairPrice';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  DeviceIssue?: Maybe<Array<Maybe<ProductType>>>;
  DeviceModel?: Maybe<DeviceModel>;
  Service?: Maybe<Service>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  minimum_price?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  repair_label?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<User>;
};

export type ResetFailureCounterInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  trainingAssignmentId: Scalars['ID']['input'];
};

export type ResetFailureCounterResponse = {
  __typename?: 'ResetFailureCounterResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export enum ResolutionOutcomeEnum {
  DuplicateMerged = 'duplicate_merged',
  Inconclusive = 'inconclusive',
  ReferredExternally = 'referred_externally',
  SubstantiatedActionTaken = 'substantiated_action_taken',
  SubstantiatedNoAction = 'substantiated_no_action',
  Unsubstantiated = 'unsubstantiated',
  WithdrawnByComplainant = 'withdrawn_by_complainant'
}

export type ResultWrapper = {
  __typename?: 'ResultWrapper';
  UserLeave?: Maybe<Array<Maybe<LeaveTypeEmployeeById>>>;
  is_hourly_employee_sandwich?: Maybe<Scalars['Boolean']['output']>;
  is_manual_deduction?: Maybe<Scalars['Boolean']['output']>;
  is_salary_employee_sandwich?: Maybe<Scalars['Boolean']['output']>;
  is_short_leave_sandwich?: Maybe<Scalars['Boolean']['output']>;
  is_week_hour_limit?: Maybe<Scalars['Boolean']['output']>;
  leaveTypeEmployee?: Maybe<Array<Maybe<LeaveTypeEmployeeById>>>;
  manual_deduction_value?: Maybe<Scalars['Float']['output']>;
  ptoMinutes?: Maybe<Pto_MinutesType>;
  publicHolidaySandwich?: Maybe<Scalars['Boolean']['output']>;
  salary_type?: Maybe<Scalars['String']['output']>;
  sandwich?: Maybe<Scalars['Boolean']['output']>;
  total_week_hours?: Maybe<Scalars['Float']['output']>;
  working_days?: Maybe<Scalars['Float']['output']>;
};

export type RoasterMinutesInput = {
  employee_id: Scalars['ID']['input'];
  leave_dates?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  leave_type?: InputMaybe<Scalars['ID']['input']>;
};

export type Role = {
  __typename?: 'Role';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  _id?: Maybe<Scalars['ID']['output']>;
  assigned_users?: Maybe<Array<Maybe<User>>>;
  children?: Maybe<Array<Maybe<Role>>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  employeeCount?: Maybe<Scalars['Int']['output']>;
  feature_hierarchy?: Maybe<Array<Maybe<FeatureHierarchy>>>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<Role>;
  path?: Maybe<Array<Maybe<Role>>>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  roleName?: Maybe<Scalars['String']['output']>;
  rolePolicy?: Maybe<RolePolicy>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type RoleModule = {
  __typename?: 'RoleModule';
  modules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  role?: Maybe<Role>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  permissions?: Maybe<DividePermission>;
  role?: Maybe<Role>;
};

export type RolePolicy = {
  __typename?: 'RolePolicy';
  sale_max_invoice_discount_fixed?: Maybe<Scalars['Float']['output']>;
  sale_max_invoice_discount_percentage?: Maybe<Scalars['Float']['output']>;
  sale_max_item_discount?: Maybe<Scalars['Float']['output']>;
  ticket_invoice_refund_max_percentage_discount?: Maybe<Scalars['Float']['output']>;
};

export type RolelistingResult = {
  __typename?: 'RolelistingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Role>>>;
};

export type Roster = {
  __typename?: 'Roster';
  EmployeeId?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  EndTime?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  IsAllDay?: Maybe<Scalars['Boolean']['output']>;
  IsBlock?: Maybe<Scalars['Boolean']['output']>;
  RecurrenceException?: Maybe<Scalars['String']['output']>;
  RecurrenceID?: Maybe<Scalars['String']['output']>;
  RecurrenceRule?: Maybe<Scalars['String']['output']>;
  StartTime?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  _id?: Maybe<Scalars['ID']['output']>;
  break_detail?: Maybe<Array<Maybe<BreakDetailType>>>;
  color?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Department>;
  designations?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  employees?: Maybe<Array<Maybe<User>>>;
  end_date?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  is_published?: Maybe<Scalars['Boolean']['output']>;
  meal_break?: Maybe<Scalars['Float']['output']>;
  onRepeat?: Maybe<Scalars['String']['output']>;
  overTime?: Maybe<Array<Maybe<OverTime>>>;
  recursion_date?: Maybe<Scalars['DateTime']['output']>;
  repeat?: Maybe<Repeat>;
  rest_break?: Maybe<Scalars['Float']['output']>;
  rosterStore?: Maybe<RosterStores>;
  short_break?: Maybe<Array<Maybe<ShortBreakType>>>;
  short_break_count?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  timeOff?: Maybe<_TimeOff>;
  totalMinuts?: Maybe<Scalars['Int']['output']>;
  total_overtime?: Maybe<Scalars['Int']['output']>;
  totalhours?: Maybe<Scalars['Int']['output']>;
};

export type RosterCommentInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  rosterStore?: InputMaybe<Scalars['ID']['input']>;
};

export type RosterData = {
  __typename?: 'RosterData';
  CategoryColor?: Maybe<Scalars['String']['output']>;
  Comment?: Maybe<Scalars['String']['output']>;
  EmployeeId?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  EndTime?: Maybe<Scalars['DateTime']['output']>;
  ID?: Maybe<Scalars['String']['output']>;
  IsAllDay?: Maybe<Scalars['Boolean']['output']>;
  IsBlock?: Maybe<Scalars['Boolean']['output']>;
  RecurrenceRule?: Maybe<Scalars['String']['output']>;
  RemainingLeaves?: Maybe<Scalars['Float']['output']>;
  StartTime?: Maybe<Scalars['DateTime']['output']>;
  Subject?: Maybe<Scalars['String']['output']>;
  TotalLeave?: Maybe<Scalars['Float']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  TypeOfAbsence?: Maybe<Scalars['String']['output']>;
  leave_type?: Maybe<Scalars['String']['output']>;
};

export type RosterInput = {
  break_detail?: InputMaybe<Array<BreakDetail>>;
  color?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  designations?: InputMaybe<Scalars['ID']['input']>;
  editType?: InputMaybe<Scalars['String']['input']>;
  employees: Array<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  end_time: Scalars['String']['input'];
  full_year?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  meal_break?: InputMaybe<Scalars['Float']['input']>;
  recurrence_rule?: InputMaybe<Scalars['String']['input']>;
  repeat: Repeat;
  rest_break?: InputMaybe<Scalars['Float']['input']>;
  rosterStore: Scalars['ID']['input'];
  short_break_count?: InputMaybe<Scalars['Int']['input']>;
  start_date: Scalars['DateTime']['input'];
  start_time: Scalars['String']['input'];
  updateScheduleId?: InputMaybe<Scalars['ID']['input']>;
  week_number?: InputMaybe<Scalars['Int']['input']>;
};

export type RosterMinutesAndDate = {
  __typename?: 'RosterMinutesAndDate';
  alertData?: Maybe<Array<Maybe<AlertData>>>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  out_of_accural_leave_days?: Maybe<Scalars['Int']['output']>;
  out_of_accural_leave_hours?: Maybe<Scalars['Int']['output']>;
  sandwichDate?: Maybe<Array<Maybe<SandWichDays>>>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  totalMinuts?: Maybe<Scalars['Int']['output']>;
  weekEndDays?: Maybe<Array<Maybe<Weekend>>>;
};

export type RosterStoreInput = {
  _id: Scalars['ID']['input'];
  backgroundComment?: InputMaybe<Scalars['String']['input']>;
  backgroundLeave?: InputMaybe<Scalars['String']['input']>;
  backgroundScheduler?: InputMaybe<Scalars['String']['input']>;
  default_schedular_view?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  number_of_record_employees?: InputMaybe<Scalars['Int']['input']>;
  start_day_of_week?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
};

export type RosterStores = {
  __typename?: 'RosterStores';
  _id?: Maybe<Scalars['ID']['output']>;
  backgroundComment?: Maybe<Scalars['String']['output']>;
  backgroundLeave?: Maybe<Scalars['String']['output']>;
  backgroundScheduler?: Maybe<Scalars['String']['output']>;
  business?: Maybe<Business>;
  business_location?: Maybe<BusinessLocation>;
  chunk_wise_short_break?: Maybe<ChunkWiseShortBreak>;
  default_schedular_view?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Array<Maybe<User>>>;
  number_of_record_employees?: Maybe<Scalars['Int']['output']>;
  overtimeColor?: Maybe<Scalars['String']['output']>;
  paidTomeOffColor?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Permissions>>>;
  ptoColor?: Maybe<Scalars['String']['output']>;
  publicHolidayColor?: Maybe<Scalars['String']['output']>;
  sandwichLeaveColor?: Maybe<Scalars['String']['output']>;
  shortLeavePaid?: Maybe<Scalars['String']['output']>;
  shortLeaveUnpaid?: Maybe<Scalars['String']['output']>;
  short_breaks?: Maybe<ChunkWiseShortBreak>;
  start_day_of_week?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unpaidTomeOffColor?: Maybe<Scalars['String']['output']>;
  weekendColor?: Maybe<Scalars['String']['output']>;
};

export type RosterSubscription = {
  __typename?: 'RosterSubscription';
  action: Scalars['String']['output'];
  roster_data?: Maybe<Roster>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type RosterTemplate = {
  __typename?: 'RosterTemplate';
  _id?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rosters?: Maybe<Array<Maybe<Roster>>>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
};

export type SalesReport = {
  __typename?: 'SalesReport';
  total_amount?: Maybe<Scalars['Float']['output']>;
};

export type SalesReport1 = {
  __typename?: 'SalesReport1';
  end_date?: Maybe<Scalars['DateTime']['output']>;
  from_date?: Maybe<Scalars['DateTime']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

export type SampleData = {
  __typename?: 'SampleData';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  _id?: Maybe<Scalars['ID']['output']>;
  is_selected?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SandwichLeaveType = {
  __typename?: 'SandwichLeaveType';
  sandwichDate?: Maybe<Array<Maybe<SandWichDays>>>;
};

export type Schedule = {
  __typename?: 'Schedule';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Payroll?: Maybe<Payroll>;
  PublicHoliday?: Maybe<PublicHoliday>;
  RosterStore?: Maybe<RosterStores>;
  TimeOff?: Maybe<TimeOff>;
  User?: Maybe<User>;
  UserHistory?: Maybe<UserHistory>;
  _id?: Maybe<Scalars['ID']['output']>;
  break_detail?: Maybe<Array<Maybe<ScheduleBreaks>>>;
  clockedHistory?: Maybe<ClockedHistory>;
  created_by?: Maybe<User>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Maybe<ScheduleEvents>>>;
  is_attendance_exist?: Maybe<Scalars['Boolean']['output']>;
  is_between_leave?: Maybe<Scalars['Boolean']['output']>;
  is_clocked_in?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_imported?: Maybe<Scalars['Boolean']['output']>;
  is_paid_leave?: Maybe<Scalars['Boolean']['output']>;
  is_payroll_processed?: Maybe<Scalars['Boolean']['output']>;
  is_pto?: Maybe<Scalars['Boolean']['output']>;
  is_public_holiday?: Maybe<Scalars['Boolean']['output']>;
  is_public_holiday_off?: Maybe<Scalars['Boolean']['output']>;
  is_sand_wich?: Maybe<Scalars['Boolean']['output']>;
  is_taken_short_break?: Maybe<Scalars['Boolean']['output']>;
  is_weekend?: Maybe<Scalars['Boolean']['output']>;
  is_weekend_off?: Maybe<Scalars['Boolean']['output']>;
  normal_time_minuts?: Maybe<Scalars['Int']['output']>;
  normal_time_percentage?: Maybe<Scalars['Float']['output']>;
  normal_time_wage?: Maybe<Scalars['Float']['output']>;
  over_time_percentage?: Maybe<Scalars['Float']['output']>;
  over_time_wage?: Maybe<Scalars['Float']['output']>;
  overtime_minuts?: Maybe<Scalars['Int']['output']>;
  paid_leave_percentage?: Maybe<Scalars['Int']['output']>;
  previous_schedule?: Maybe<Schedule>;
  previous_schedule_type?: Maybe<Scalars['String']['output']>;
  schedule_date?: Maybe<Scalars['String']['output']>;
  schedule_minuts?: Maybe<Scalars['Int']['output']>;
  short_break?: Maybe<MasterDataValue>;
  short_break_count?: Maybe<Scalars['Int']['output']>;
  short_break_duration?: Maybe<Scalars['Int']['output']>;
  short_break_type?: Maybe<Scalars['String']['output']>;
  short_leave_time_percentage?: Maybe<Scalars['Float']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  total_hours?: Maybe<Scalars['Int']['output']>;
  total_minuts?: Maybe<Scalars['Int']['output']>;
  total_wage?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type ScheduleMinutesAndDate = {
  __typename?: 'ScheduleMinutesAndDate';
  end_date?: Maybe<Scalars['DateTime']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  sandwichDate?: Maybe<Array<Maybe<SandWichDays>>>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  totalMinuts?: Maybe<Scalars['Int']['output']>;
  weekEndDays?: Maybe<Array<Maybe<Weekend>>>;
};

export type ScheduleMinutesInput = {
  employee_id: Scalars['ID']['input'];
  leave_dates?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  leave_type?: InputMaybe<Scalars['ID']['input']>;
};

export type SchedulerConfig = {
  __typename?: 'SchedulerConfig';
  backgroundScheduler?: Maybe<Scalars['String']['output']>;
  business?: Maybe<Business>;
  chunk_wise_short_break?: Maybe<ShortBreaks>;
  id?: Maybe<Scalars['ID']['output']>;
  is_include_unpaid_break?: Maybe<Scalars['Boolean']['output']>;
  number_of_record_employees?: Maybe<Scalars['Int']['output']>;
  overtimeColor?: Maybe<Scalars['String']['output']>;
  paidTomeOffColor?: Maybe<Scalars['String']['output']>;
  ptoColor?: Maybe<Scalars['String']['output']>;
  publicHolidayColor?: Maybe<Scalars['String']['output']>;
  sandwichLeaveColor?: Maybe<Scalars['String']['output']>;
  shortLeavePaid?: Maybe<Scalars['String']['output']>;
  shortLeaveUnpaid?: Maybe<Scalars['String']['output']>;
  short_breaks?: Maybe<ShortBreaks>;
  unpaidTomeOffColor?: Maybe<Scalars['String']['output']>;
  weekendColor?: Maybe<Scalars['String']['output']>;
};

export type SearchAuthenticatorInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
  searchColumns?: InputMaybe<Array<InputMaybe<SearchColumnEnum>>>;
};

export type SearchAuthenticatorItem = {
  __typename?: 'SearchAuthenticatorItem';
  _id: Scalars['ID']['output'];
  app_name?: Maybe<Scalars['String']['output']>;
  app_url?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hierarchy?: Maybe<Array<Maybe<HierarchyItem>>>;
  path?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type SearchAuthenticatorResult = {
  __typename?: 'SearchAuthenticatorResult';
  currentRecords?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<SearchAuthenticatorItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
  viewMore?: Maybe<Scalars['Boolean']['output']>;
};

export enum SearchColumnEnum {
  AppName = 'app_name',
  AppUrl = 'app_url',
  Email = 'email',
  Username = 'username'
}

export enum SendEmailOption {
  SendEmployeeTheFullSchedule = 'send_employee_the_full_schedule',
  SendEmployeeTheirOwnSchedule = 'send_employee_their_own_schedule'
}

export type SendGridResponseUnion = SendGridWithSecurity | SendGridWithoutSecurity;

export type SendGridValidationResponse = {
  __typename?: 'SendGridValidationResponse';
  domainId?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  validation_results?: Maybe<ValidationDnsKeys>;
};

export type SendGridWithSecurity = {
  __typename?: 'SendGridWithSecurity';
  dns?: Maybe<DnsKeysSecurityFlag>;
  domain?: Maybe<Scalars['String']['output']>;
  domainId?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type SendGridWithoutSecurity = {
  __typename?: 'SendGridWithoutSecurity';
  dns?: Maybe<DnsKeysWithoutSecurityFlag>;
  domain?: Maybe<Scalars['String']['output']>;
  domainId?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type SendManualReminderInput = {
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  employeeIds: Array<Scalars['ID']['input']>;
};

export type SendTrainingAssignmentEmailInput = {
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  employeeIds: Array<Scalars['ID']['input']>;
  isRefresher?: InputMaybe<Scalars['Boolean']['input']>;
  isTransfer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendgridAccountInput = {
  apikey: Scalars['String']['input'];
  port?: InputMaybe<Scalars['Int']['input']>;
};

export type SendgridConfig = {
  __typename?: 'SendgridConfig';
  Business: Business;
  _id: Scalars['ID']['output'];
  api_key: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  host: Scalars['String']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  port: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
  user_name: Scalars['String']['output'];
};

export type Separation = {
  __typename?: 'Separation';
  AdminID: Scalars['ID']['output'];
  EmployeeId: Scalars['ID']['output'];
  Message: Scalars['String']['output'];
};

export enum SeparationFilter {
  Resignation = 'Resignation',
  Retirement = 'Retirement',
  Termination = 'Termination',
  All = 'all',
  Archive = 'archive'
}

export enum Separation_Types {
  Resignation = 'Resignation',
  Retirement = 'Retirement',
  Termination = 'Termination'
}

export type Service = {
  __typename?: 'Service';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  RepairCategory?: Maybe<RepairCategory>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type ServiceCategory = {
  __typename?: 'ServiceCategory';
  _id?: Maybe<Scalars['ID']['output']>;
  category_name?: Maybe<Scalars['String']['output']>;
  category_prefix?: Maybe<Scalars['String']['output']>;
};

export type ServiceCategoryType = {
  __typename?: 'ServiceCategoryType';
  _id?: Maybe<Scalars['ID']['output']>;
  category_name?: Maybe<Scalars['String']['output']>;
};

export type ServiceConfigInput = {
  business: Scalars['ID']['input'];
  config: Scalars['Boolean']['input'];
  location: Scalars['ID']['input'];
};

export type ServicesPrice = {
  __typename?: 'ServicesPrice';
  Service?: Maybe<Product>;
  ServiceBrand?: Maybe<SystemBrand>;
  ServiceDeviceModel?: Maybe<DeviceModel>;
  ServiceItem?: Maybe<Product>;
  _id?: Maybe<Scalars['ID']['output']>;
  defaultServiceID?: Maybe<Scalars['ID']['output']>;
  service_max_price?: Maybe<Scalars['Float']['output']>;
  service_min_price?: Maybe<Scalars['Float']['output']>;
};

export type SetupAlert = {
  __typename?: 'SetupAlert';
  _id: Scalars['ID']['output'];
  asset_email_details?: Maybe<SetupEmail>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  is_asset_alert?: Maybe<Scalars['Boolean']['output']>;
  is_asset_email?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_lease_email?: Maybe<Scalars['Boolean']['output']>;
  is_lease_expiration_alert?: Maybe<Scalars['Boolean']['output']>;
  is_maintenance_alert?: Maybe<Scalars['Boolean']['output']>;
  is_maintenance_email?: Maybe<Scalars['Boolean']['output']>;
  is_warranty_email?: Maybe<Scalars['Boolean']['output']>;
  is_warranty_expiration_alert?: Maybe<Scalars['Boolean']['output']>;
  lease_email_details?: Maybe<SetupEmail>;
  lease_lead_time?: Maybe<Scalars['Int']['output']>;
  maintenance_email_details?: Maybe<SetupEmail>;
  maintenance_lead_time?: Maybe<Scalars['Int']['output']>;
  maintenance_overdue_time?: Maybe<Scalars['Int']['output']>;
  updated_by?: Maybe<User>;
  warranty_email_details?: Maybe<SetupEmail>;
  warranty_lead_time?: Maybe<Scalars['Int']['output']>;
};

export type SetupEmail = {
  __typename?: 'SetupEmail';
  email_body?: Maybe<Scalars['String']['output']>;
  email_frequency?: Maybe<Scalars['String']['output']>;
  email_subject?: Maybe<Scalars['String']['output']>;
  email_time?: Maybe<Scalars['String']['output']>;
  email_to?: Maybe<Scalars['String']['output']>;
  stop_email_after_days?: Maybe<Scalars['Int']['output']>;
};

export type SetupEmailInput = {
  email_body?: InputMaybe<Scalars['String']['input']>;
  email_frequency?: InputMaybe<Scalars['String']['input']>;
  email_subject?: InputMaybe<Scalars['String']['input']>;
  email_time?: InputMaybe<Scalars['String']['input']>;
  email_to?: InputMaybe<Scalars['String']['input']>;
  stop_email_after_days?: InputMaybe<Scalars['Int']['input']>;
};

export type ShareAppPermissions = {
  can_delete?: InputMaybe<Scalars['Boolean']['input']>;
  can_edit?: InputMaybe<Scalars['Boolean']['input']>;
  can_share_otp?: InputMaybe<Scalars['Boolean']['input']>;
  can_share_password?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShareAuthenticatorApp = {
  __typename?: 'ShareAuthenticatorApp';
  AuthenticatorApp?: Maybe<Authenticator>;
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['String']['output']>;
  app_info?: Maybe<AuthenticatorAppInfo>;
  app_name?: Maybe<Scalars['String']['output']>;
  app_url?: Maybe<Scalars['String']['output']>;
  breadcrumbs?: Maybe<Array<Maybe<ShareAuthenticatorApp>>>;
  created_at?: Maybe<Scalars['Date']['output']>;
  deleted_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_scheduled?: Maybe<Scalars['Boolean']['output']>;
  parent_id?: Maybe<AuthenticatorGroup>;
  password_manager?: Maybe<PasswordManagerType>;
  scheduled_for?: Maybe<Scalars['String']['output']>;
  share_as?: Maybe<Scalars['String']['output']>;
  share_permissions?: Maybe<Share_Permissions>;
  share_type?: Maybe<Scalars['String']['output']>;
  share_with?: Maybe<Array<Maybe<ShareAuthenticatorApp>>>;
  shared_by?: Maybe<User>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export enum ShareDocumentroles {
  Editor = 'Editor',
  Owner = 'Owner',
  Remove = 'Remove',
  Viewer = 'Viewer'
}

export type ShareMeListDataTable = {
  __typename?: 'ShareMeListDataTable';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<ShareAuthenticatorApp>>>;
};

export type ShareWithMeListWithPagination = {
  __typename?: 'ShareWithMeListWithPagination';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ShareAuthenticatorApp>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type Shift = {
  __typename?: 'Shift';
  _id?: Maybe<Scalars['ID']['output']>;
  break_detail?: Maybe<Array<Maybe<BreakDetailType>>>;
  break_hours?: Maybe<Scalars['String']['output']>;
  business?: Maybe<Business>;
  business_location?: Maybe<BusinessLocation>;
  employee?: Maybe<User>;
  employees?: Maybe<Array<Maybe<User>>>;
  employeesCount?: Maybe<Scalars['Int']['output']>;
  end_time: Scalars['String']['output'];
  is_custom?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_sample_data?: Maybe<Scalars['Boolean']['output']>;
  meal_break?: Maybe<Scalars['Int']['output']>;
  rest_break?: Maybe<Scalars['Int']['output']>;
  shift_name: Scalars['String']['output'];
  start_time: Scalars['String']['output'];
  working_hours?: Maybe<Scalars['String']['output']>;
};

export type ShiftInput = {
  break_detail?: InputMaybe<Array<InputMaybe<BreakDetail>>>;
  break_hours?: InputMaybe<Scalars['String']['input']>;
  business: Scalars['ID']['input'];
  business_location?: InputMaybe<Scalars['ID']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  end_time: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  is_custom: Scalars['Boolean']['input'];
  meal_break?: InputMaybe<Scalars['Int']['input']>;
  rest_break?: InputMaybe<Scalars['Int']['input']>;
  shift_name: Scalars['String']['input'];
  start_time: Scalars['String']['input'];
  working_hours?: InputMaybe<Scalars['String']['input']>;
};

export type ShiftListInput = {
  business?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_sample_data?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ShiftsList = {
  __typename?: 'ShiftsList';
  cursor?: Maybe<Scalars['ID']['output']>;
  list?: Maybe<Array<Maybe<Shift>>>;
};

export type ShippingMethods = {
  __typename?: 'ShippingMethods';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<User>;
};

export type SitesAssetAssignedResult = {
  __typename?: 'SitesAssetAssignedResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BusinessLocation>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type SitesAssetAssignedResults = {
  __typename?: 'SitesAssetAssignedResults';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<BusinessLocation>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type State = {
  __typename?: 'State';
  Country?: Maybe<Country>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  short_name?: Maybe<Scalars['String']['output']>;
  state_name?: Maybe<Scalars['String']['output']>;
};

export type StateHierarchicy = {
  __typename?: 'StateHierarchicy';
  State?: Maybe<State>;
  cities?: Maybe<Array<Maybe<City>>>;
};

export type Station = {
  __typename?: 'Station';
  Business?: Maybe<Business>;
  Department?: Maybe<Department>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  station_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum Status {
  Active = 'Active',
  All = 'All',
  Disabled = 'Disabled',
  Scheduled = 'Scheduled'
}

export type StatusCount = {
  __typename?: 'StatusCount';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum StatusEnum {
  Accepted = 'accepted',
  All = 'all',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type StoreAccessType = {
  __typename?: 'StoreAccessType';
  businessLocation?: Maybe<BusinessLocation>;
  cashRegister?: Maybe<Array<Maybe<CashRegisters>>>;
  roles?: Maybe<Array<Maybe<Role>>>;
};

export type StoreCustomField = {
  __typename?: 'StoreCustomField';
  _id?: Maybe<Scalars['ID']['output']>;
  controlType?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<CustomFieldTypeOptionType>>>;
  order?: Maybe<Scalars['Float']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum StoreTypeEnum {
  Corporate = 'corporate',
  ThirdPartyFranchisee = 'third_party_franchisee'
}

export type Subscription = {
  __typename?: 'Subscription';
  ClockedHistory?: Maybe<Scalars['Boolean']['output']>;
  TimeOff: Separation;
  _id?: Maybe<Scalars['ID']['output']>;
  attendanceRegulationRequestOrApproved?: Maybe<AttendanceRegulation>;
  attendanceRequestDeleted?: Maybe<AttendanceRegulation>;
  businessTimeZoneChange?: Maybe<BusinessUpdate>;
  businessUpdate?: Maybe<Business>;
  canUserClockInViaApp?: Maybe<Scalars['Boolean']['output']>;
  clockHistryPdfDownload?: Maybe<ClockHistryPdfDownloadType>;
  commentInTaskListen?: Maybe<TaskManagement>;
  createSubTaskListen?: Maybe<TaskManagement>;
  createTaskListen?: Maybe<TaskManagement>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleteDocument?: Maybe<DeleteDocumentSubscribe>;
  deleteRequest?: Maybe<DeletedRequestResponse>;
  downloadZip?: Maybe<DownloadZip>;
  email?: Maybe<Scalars['String']['output']>;
  employeeDashBoardUpdate?: Maybe<DashBoardChange>;
  employeesRosters?: Maybe<EmployeesWithRostersList>;
  expenseRequestOrApproved?: Maybe<Expense>;
  fileUploadProgress: UploadProgress;
  generatedNotification?: Maybe<Notification>;
  import_timesheets?: Maybe<Scalars['Float']['output']>;
  is_custom_package?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  leavePackage?: Maybe<Scalars['Boolean']['output']>;
  loanPaymentRequestOrApproved?: Maybe<LoanPayment>;
  numberIncremented?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<Package>;
  phone?: Maybe<Scalars['String']['output']>;
  request_from?: Maybe<Business>;
  request_to?: Maybe<Business>;
  roster: Scalars['Boolean']['output'];
  scheduleCsvProgress?: Maybe<ImportCsvSubsciption>;
  scheduleProgress?: Maybe<ScheduleProgressType>;
  sendDocumentToSharedEmployees?: Maybe<DocumentControlAttachment>;
  sendNotificationCount?: Maybe<NotificationCount>;
  sendRequestToAssignees?: Maybe<DocumentControlAttachment>;
  show_paynow?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<AllowedSubscriptionStatus>;
  subTaskStatusUpdated?: Maybe<TaskManagement>;
  taskStatusUpdated?: Maybe<TaskManagement>;
  timeOffRequestOrApproved?: Maybe<TimeOff>;
  unlinkedDevice?: Maybe<Scalars['Boolean']['output']>;
  updateAssignee?: Maybe<TaskManagement>;
  updateAttendance?: Maybe<UpdateAttendanceSocket>;
  updateTasksListen?: Maybe<TaskManagement>;
  uploadFile?: Maybe<Fileuploadsize>;
  userInactiveNotification?: Maybe<UserAccountStatus>;
  userInfoUpdate?: Maybe<EmailChanged>;
  user_request_from?: Maybe<User>;
  usersPermissionsChangedNotify?: Maybe<RoleChanged>;
};


export type SubscriptionClockedHistoryArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptionAttendanceRegulationRequestOrApprovedArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionAttendanceRequestDeletedArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionBusinessTimeZoneChangeArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptionBusinessUpdateArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptionCanUserClockInViaAppArgs = {
  employee_id: Scalars['ID']['input'];
};


export type SubscriptionClockHistryPdfDownloadArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionDeleteRequestArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionDownloadZipArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionEmployeeDashBoardUpdateArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptionEmployeesRostersArgs = {
  user_id: Scalars['ID']['input'];
};


export type SubscriptionExpenseRequestOrApprovedArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionFileUploadProgressArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionGeneratedNotificationArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionLeavePackageArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionLoanPaymentRequestOrApprovedArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionNumberIncrementedArgs = {
  businessId: Scalars['ID']['input'];
};


export type SubscriptionScheduleCsvProgressArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionScheduleProgressArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionSendDocumentToSharedEmployeesArgs = {
  employeeId: Scalars['ID']['input'];
};


export type SubscriptionSendNotificationCountArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionSendRequestToAssigneesArgs = {
  employeeId: Scalars['ID']['input'];
};


export type SubscriptionTimeOffRequestOrApprovedArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionUnlinkedDeviceArgs = {
  _id: Scalars['ID']['input'];
};


export type SubscriptionUpdateAttendanceArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionUploadFileArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionUserInactiveNotificationArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionUserInfoUpdateArgs = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionUsersPermissionsChangedNotifyArgs = {
  userId: Scalars['ID']['input'];
};

export type SubscriptionDataTableList = {
  __typename?: 'SubscriptionDataTableList';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<Subscription>>>;
};

export type SubscriptionList = {
  __typename?: 'SubscriptionList';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Subscription>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionLogActivity = {
  __typename?: 'SubscriptionLogActivity';
  _id?: Maybe<Scalars['ID']['output']>;
  activity_date?: Maybe<Scalars['DateTime']['output']>;
  attachment?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type SupportingFileItem = {
  __typename?: 'SupportingFileItem';
  file_name?: Maybe<Scalars['String']['output']>;
  file_url?: Maybe<Scalars['String']['output']>;
};

export type SystemBrand = {
  __typename?: 'SystemBrand';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  _id?: Maybe<Scalars['ID']['output']>;
  brand_name?: Maybe<Scalars['String']['output']>;
  brand_prefix?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  is_global?: Maybe<Scalars['Boolean']['output']>;
};

export type SystemModel = {
  __typename?: 'SystemModel';
  Brand?: Maybe<Brand>;
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Capacity?: Maybe<Array<Maybe<Capacity>>>;
  Carrier?: Maybe<Array<Maybe<Carrier>>>;
  Color?: Maybe<Array<Maybe<Color>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_global?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TableConfig = {
  activeFilters?: InputMaybe<Scalars['Boolean']['input']>;
  bodyTextFontsSize?: InputMaybe<Scalars['Int']['input']>;
  filterNames?: InputMaybe<Scalars['String']['input']>;
  fontFaimly?: InputMaybe<Scalars['String']['input']>;
  globalSearch?: InputMaybe<Scalars['String']['input']>;
  headerTextFontsSize?: InputMaybe<Scalars['Int']['input']>;
  oddRowsBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  rowShadingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  selectedTableLayout?: InputMaybe<Scalars['String']['input']>;
  showVerticalBorder?: InputMaybe<Scalars['Boolean']['input']>;
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type TableConfigListing = {
  __typename?: 'TableConfigListing';
  bodyTextFontsSize?: Maybe<Scalars['Int']['output']>;
  fontFaimly?: Maybe<Scalars['String']['output']>;
  globalSearch?: Maybe<Scalars['String']['output']>;
  headerTextFontsSize?: Maybe<Scalars['Int']['output']>;
  oddRowsBackgroundColor?: Maybe<Scalars['String']['output']>;
  rowShadingEnabled?: Maybe<Scalars['Boolean']['output']>;
  selectedTableLayout?: Maybe<Scalars['String']['output']>;
  showVerticalBorder?: Maybe<Scalars['Boolean']['output']>;
};

export type Tags = {
  __typename?: 'Tags';
  _id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum TargetEnum {
  Scale = 'scale',
  Score = 'score'
}

export type TaskComment = {
  __typename?: 'TaskComment';
  Business?: Maybe<Business>;
  TaskManagement?: Maybe<TaskManagement>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  comment_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<TaskComment>;
  path?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type TaskForUserDashbaord = {
  __typename?: 'TaskForUserDashbaord';
  data?: Maybe<StatusOfTasks>;
  date?: Maybe<Scalars['String']['output']>;
};

export type TaskManagement = {
  __typename?: 'TaskManagement';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<Business>;
  Department?: Maybe<Array<Maybe<Department>>>;
  ParentTask?: Maybe<TaskManagement>;
  Role?: Maybe<Role>;
  _id?: Maybe<Scalars['ID']['output']>;
  assignee?: Maybe<Array<Maybe<User>>>;
  attachments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attachments_count?: Maybe<Scalars['Int']['output']>;
  attachments_name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bread_cram?: Maybe<Array<Maybe<TaskManagement>>>;
  check_list?: Maybe<Array<Maybe<CheckListStep>>>;
  comment_count?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Array<Maybe<CommenType>>>;
  completed_date?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  editor_description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  formatted_time: Scalars['String']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_owner?: Maybe<Scalars['Boolean']['output']>;
  is_timing_active: Scalars['Boolean']['output'];
  is_timing_ended: Scalars['Boolean']['output'];
  no_sub_task?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priority?: Maybe<Scalars['String']['output']>;
  reporter?: Maybe<User>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_task?: Maybe<Array<Maybe<TaskManagement>>>;
  summary?: Maybe<Scalars['String']['output']>;
  task_name?: Maybe<Scalars['String']['output']>;
  time_logs: Array<TimeLog>;
  total_time_spent: Scalars['Float']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type TaskManagementWithData = {
  __typename?: 'TaskManagementWithData';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<Business>;
  Department?: Maybe<Array<Maybe<Department>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  assignee?: Maybe<Array<Maybe<User>>>;
  attachments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attachments_count?: Maybe<Scalars['Int']['output']>;
  attachments_name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  check_list?: Maybe<Array<Maybe<CheckListStep>>>;
  comment_count?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Array<Maybe<CommenType>>>;
  completed_date?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<CommentDetail>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  editor_description?: Maybe<Scalars['String']['output']>;
  formatted_time: Scalars['String']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_owner?: Maybe<Scalars['Boolean']['output']>;
  is_timing_active: Scalars['Boolean']['output'];
  is_timing_ended: Scalars['Boolean']['output'];
  no_sub_task?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priority?: Maybe<Scalars['String']['output']>;
  reporter?: Maybe<User>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  task_name?: Maybe<Scalars['String']['output']>;
  time_logs: Array<TimeLog>;
  total_time_spent: Scalars['Float']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type TaskManagement_ = {
  __typename?: 'TaskManagement_';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<Business>;
  Department?: Maybe<Array<Maybe<Department>>>;
  ParentTask?: Maybe<TaskManagement>;
  Role?: Maybe<Role>;
  _id?: Maybe<Scalars['ID']['output']>;
  assignee?: Maybe<Array<Maybe<User>>>;
  attachments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attachments_name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bread_cram?: Maybe<Array<Maybe<TaskManagement>>>;
  check_list?: Maybe<Array<Maybe<CheckListStep>>>;
  comments?: Maybe<Array<Maybe<CommenType>>>;
  completed_date?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  editor_description?: Maybe<Scalars['String']['output']>;
  formatted_time: Scalars['String']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_timing_active: Scalars['Boolean']['output'];
  is_timing_ended: Scalars['Boolean']['output'];
  logs?: Maybe<Array<Maybe<LogsTask>>>;
  no_sub_task?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priority?: Maybe<Scalars['String']['output']>;
  reporter?: Maybe<User>;
  status?: Maybe<Scalars['String']['output']>;
  sub_task?: Maybe<DataColumnResults>;
  summary?: Maybe<Scalars['String']['output']>;
  task_name?: Maybe<Scalars['String']['output']>;
  time_logs: Array<TimeLog>;
  total_time_spent: Scalars['Float']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type TaskResponse = {
  __typename?: 'TaskResponse';
  description?: Maybe<Scalars['String']['output']>;
  formatted_time: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_timing_active: Scalars['Boolean']['output'];
  is_timing_ended: Scalars['Boolean']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  time_logs: Array<TimeLog>;
  title: Scalars['String']['output'];
  total_time_spent: Scalars['Float']['output'];
};

export type TaskTimeLogsById = {
  __typename?: 'TaskTimeLogsById';
  _id?: Maybe<Scalars['ID']['output']>;
  formatted_time: Scalars['String']['output'];
  is_timing_active: Scalars['Boolean']['output'];
  is_timing_ended: Scalars['Boolean']['output'];
  onhold_formatted_time: Scalars['String']['output'];
  timeLogs?: Maybe<Array<Maybe<TimeLogResult>>>;
  time_logs: Array<TimeLog>;
  todo_formatted_time: Scalars['String']['output'];
  total_time_spent: Scalars['Float']['output'];
};

export type Tax = {
  __typename?: 'Tax';
  BusinessLocation?: Maybe<BusinessLocation>;
  _id?: Maybe<Scalars['ID']['output']>;
  applicable_on?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_tax_exemptible?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage_amount?: Maybe<Scalars['Int']['output']>;
};

export enum TaxTypeEnum {
  PurchaseTax = 'purchase_tax',
  SaleTax = 'sale_tax'
}

export type TemplateByModule = {
  __typename?: 'TemplateByModule';
  module?: Maybe<ModulesEnum>;
  templates?: Maybe<Array<Maybe<DefaultEmailTemplate>>>;
};

export type TemplateByModuleSubmoduleInput = {
  model: TemplateModelEnum;
  module?: InputMaybe<ModulesEnum>;
  sub_module?: InputMaybe<SubModulesEnum>;
};

export type TemplateFeature = {
  __typename?: 'TemplateFeature';
  TemplateModule?: Maybe<TemplateModule>;
  TemplateSubModule?: Maybe<TemplateSubModule>;
  _id: Scalars['ID']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  feature?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export enum TemplateModelEnum {
  BusinessEmailTemplate = 'BusinessEmailTemplate',
  DefaultEmailTemplate = 'DefaultEmailTemplate'
}

export type TemplateModule = {
  __typename?: 'TemplateModule';
  TemplateSubModule?: Maybe<Array<Maybe<TemplateSubModule>>>;
  _id: Scalars['ID']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  module?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type TemplateSubModule = {
  __typename?: 'TemplateSubModule';
  TemplateModule?: Maybe<TemplateModule>;
  _id: Scalars['ID']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  sub_module?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type TermAndSalary = {
  __typename?: 'TermAndSalary';
  Designation?: Maybe<Designation>;
  employee_type?: Maybe<Scalars['String']['output']>;
  joining_date?: Maybe<Scalars['DateTime']['output']>;
  probation_period?: Maybe<Scalars['String']['output']>;
  public_day_hourly_salary?: Maybe<Scalars['Int']['output']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  salary_offered?: Maybe<Scalars['Int']['output']>;
  salary_type?: Maybe<Scalars['String']['output']>;
  weekend_day_salary?: Maybe<Scalars['Int']['output']>;
  weekly_hourly_salary?: Maybe<Scalars['Int']['output']>;
};

export type TermAndSalaryInput = {
  Designation?: InputMaybe<Scalars['ID']['input']>;
  employee_type?: InputMaybe<Scalars['String']['input']>;
  joining_date?: InputMaybe<Scalars['DateTime']['input']>;
  probation_period?: InputMaybe<Scalars['String']['input']>;
  public_day_hourly_salary?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  salary_offered?: InputMaybe<Scalars['Int']['input']>;
  salary_type?: InputMaybe<Scalars['String']['input']>;
  weekend_day_salary?: InputMaybe<Scalars['Int']['input']>;
  weekly_hourly_salary?: InputMaybe<Scalars['Int']['input']>;
};

export type TerminalAppHistory = {
  __typename?: 'TerminalAppHistory';
  User?: Maybe<User>;
  UserAppDevice?: Maybe<UserAppDevice>;
  _id?: Maybe<Scalars['ID']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  action_date?: Maybe<Scalars['Date']['output']>;
  app_type?: Maybe<Scalars['String']['output']>;
  device_id?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type TerminalAppHistoryResult = {
  __typename?: 'TerminalAppHistoryResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<TerminalAppHistory>>>;
};

export type TillCount = {
  __typename?: 'TillCount';
  CashDemonination?: Maybe<Array<Maybe<CashDemonination>>>;
  CashRegisters?: Maybe<CashRegisters>;
  User?: Maybe<User>;
  closing_amount?: Maybe<Scalars['Float']['output']>;
  counted_amount?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<Scalars['DateTime']['output']>;
  deposited?: Maybe<Scalars['Float']['output']>;
  discrepancy?: Maybe<Scalars['Float']['output']>;
  expected_amount?: Maybe<Scalars['Float']['output']>;
  opening_amount?: Maybe<Scalars['Float']['output']>;
  remaining_amount?: Maybe<Scalars['Float']['output']>;
};

export type TillCountListing = {
  __typename?: 'TillCountListing';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<TillCount>>>;
};

export type TimeLog = {
  __typename?: 'TimeLog';
  id: Scalars['ID']['output'];
  status: TimeLogAction;
  timestamp: Scalars['Date']['output'];
};

export enum TimeLogAction {
  BackLog = 'backLog',
  Completed = 'completed',
  InProgress = 'inProgress',
  OnHold = 'onHold',
  Todo = 'todo'
}

export type TimeLogInput = {
  status: TimeLogAction;
  task_id: Scalars['ID']['input'];
};

export type TimeLogResponse = {
  __typename?: 'TimeLogResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type TimeLogResult = {
  __typename?: 'TimeLogResult';
  duration: Scalars['String']['output'];
  from: Scalars['String']['output'];
  fromTime?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  to?: Maybe<Scalars['String']['output']>;
  toTime?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type TimeOffListInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rosterStoreId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TimeOffStatusFilter>;
};

export type TimeOffListingRosterResult = {
  __typename?: 'TimeOffListingRosterResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TimeOff>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type TimeOffType = {
  __typename?: 'TimeOffType';
  countIn?: Maybe<Scalars['String']['output']>;
  time_off_category?: Maybe<Scalars['String']['output']>;
  time_off_days?: Maybe<Scalars['String']['output']>;
  time_off_total_days?: Maybe<Scalars['String']['output']>;
  time_off_type?: Maybe<LeaveType>;
};

export type TimeZone = {
  __typename?: 'TimeZone';
  offset?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TradeInDevice = {
  __typename?: 'TradeInDevice';
  Brand?: Maybe<Brand>;
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Capacity?: Maybe<Capacity>;
  Carrier?: Maybe<Carrier>;
  Color?: Maybe<Color>;
  Customer?: Maybe<Customer>;
  SystemModel?: Maybe<SystemModel>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deviceCheckIn?: Maybe<Scalars['ID']['output']>;
  device_color?: Maybe<Color>;
  imei_ssn?: Maybe<Scalars['String']['output']>;
  is_ID_verified?: Maybe<Scalars['Boolean']['output']>;
  is_account_removed?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_password_removed?: Maybe<Scalars['Boolean']['output']>;
  is_water_damage?: Maybe<Scalars['Boolean']['output']>;
  model_number?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  other_issue?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum TrainingAssignStatus {
  Assigned = 'assigned',
  Completed = 'completed',
  InProgress = 'in_progress',
  Overdue = 'overdue'
}

export type TrainingAttachmentInput = {
  file: Scalars['Upload']['input'];
  language: LanguageCode;
};

export type TrainingAttempt = {
  __typename?: 'TrainingAttempt';
  attempt_number?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  is_passed?: Maybe<Scalars['Boolean']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type TrainingAttemptHistoryList = {
  __typename?: 'TrainingAttemptHistoryList';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<TrainingAttemptHistoryResult>>>;
};

export type TrainingAttemptHistoryListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_passed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  trainingAssignmentId: Scalars['ID']['input'];
};

export type TrainingAttemptHistoryResult = {
  __typename?: 'TrainingAttemptHistoryResult';
  _id?: Maybe<Scalars['ID']['output']>;
  attempt_number?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  is_passed?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  user_score?: Maybe<Scalars['Float']['output']>;
};

export type TrainingCycle = {
  __typename?: 'TrainingCycle';
  _id?: Maybe<Scalars['ID']['output']>;
  assignTo?: Maybe<Array<Maybe<User>>>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  matrix_section?: Maybe<CycleMatrixSection>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetDepartments?: Maybe<Array<Maybe<Department>>>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
};

export type TrainingCycleList = {
  __typename?: 'TrainingCycleList';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<TrainingCycle>>>;
};

export type TrainingCycleListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matrix_section?: InputMaybe<CycleMatrixSection>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<CycleStatus>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrainingFailureResetLog = {
  __typename?: 'TrainingFailureResetLog';
  Business?: Maybe<Business>;
  QuizTrainingAssignment?: Maybe<QuizTrainingAssignementListResult>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  previous_failure_count?: Maybe<Scalars['Int']['output']>;
  reset_by?: Maybe<User>;
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<User>;
};

export type TrainingFailureResetLogList = {
  __typename?: 'TrainingFailureResetLogList';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<TrainingFailureResetLog>>>;
};

export type TrainingFailureResetLogListInput = {
  QuizTrainingAssignment?: InputMaybe<Scalars['ID']['input']>;
  User?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum TrainingGlobalStatus {
  Active = 'active',
  Completed = 'completed',
  Delivered = 'delivered',
  Overdue = 'overdue'
}

export type TrainingLinkInput = {
  language: LanguageCode;
  url: Scalars['String']['input'];
};

export type TrainingMatrix = {
  __typename?: 'TrainingMatrix';
  Business?: Maybe<Business>;
  Department?: Maybe<Department>;
  Designation?: Maybe<Designation>;
  QuizTraining?: Maybe<Array<Maybe<QuizTrainingEntry>>>;
  _id: Scalars['ID']['output'];
  admin_mode?: Maybe<AdminMode>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<User>;
  deadline_days?: Maybe<Scalars['Int']['output']>;
  evaluate_by?: Maybe<Array<Maybe<User>>>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  milestone_type?: Maybe<MilestoneType>;
  section: TrainingMatrixSection;
  updated_at?: Maybe<Scalars['Date']['output']>;
  updated_by?: Maybe<User>;
};

export type TrainingMatrixFilter = {
  Department?: InputMaybe<Scalars['ID']['input']>;
  Designation?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  config_type: TrainingMatrixListingEnum;
  field?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<TrainingMatrixSection>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrainingMatrixInput = {
  Department?: InputMaybe<Scalars['ID']['input']>;
  Designation?: InputMaybe<Scalars['ID']['input']>;
  QuizTraining?: InputMaybe<Array<InputMaybe<QuizTrainingEntryInput>>>;
  admin_mode?: InputMaybe<AdminMode>;
  deadline_days?: InputMaybe<Scalars['Int']['input']>;
  evaluate_by: Array<Scalars['ID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  milestone_type?: InputMaybe<MilestoneType>;
  section: TrainingMatrixSection;
};

export enum TrainingMatrixListingEnum {
  DepartmentalTrainingMatrixListing = 'DepartmentalTrainingMatrixListing',
  MandatoryHrTrainingMatrixListing = 'MandatoryHRTrainingMatrixListing',
  OnboardingMilestoneTrainingMatrixListing = 'OnboardingMilestoneTrainingMatrixListing'
}

export type TrainingMatrixResult = {
  __typename?: 'TrainingMatrixResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<TrainingMatrix>>>;
};

export enum TrainingMatrixSection {
  Departmental = 'departmental',
  MandatoryHrTraining = 'mandatory_hr_training',
  OnboardingMilestone = 'onboarding_milestone'
}

export type TrainingMatrixUpdateEntryInput = {
  is_required: Scalars['Boolean']['input'];
  training: Scalars['ID']['input'];
};

export type TrainingMatrixUpdateInput = {
  QuizTraining?: InputMaybe<Array<TrainingMatrixUpdateEntryInput>>;
  deadline_days?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrainingProfileItem = {
  __typename?: 'TrainingProfileItem';
  assignment_id?: Maybe<Scalars['ID']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  attempts?: Maybe<Array<Maybe<TrainingAttempt>>>;
  completion_date?: Maybe<Scalars['Date']['output']>;
  cycle_id?: Maybe<Scalars['ID']['output']>;
  due_date?: Maybe<Scalars['Date']['output']>;
  escalation_triggered?: Maybe<Scalars['Boolean']['output']>;
  failure_counter?: Maybe<Scalars['Int']['output']>;
  matrix_section?: Maybe<MatrixSection>;
  score_percentage?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  urgency_status?: Maybe<UrgencyStatus>;
};

export type TrainingSettings = {
  __typename?: 'TrainingSettings';
  Business?: Maybe<Business>;
  _id: Scalars['ID']['output'];
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<User>;
  departmental_failure_escalation_threshold?: Maybe<Scalars['Int']['output']>;
  departmental_min_passing_score?: Maybe<Scalars['Int']['output']>;
  departmental_reminder_frequency_days?: Maybe<Scalars['Int']['output']>;
  failure_escalation_threshold?: Maybe<Scalars['Int']['output']>;
  mandatory_failure_escalation_threshold?: Maybe<Scalars['Int']['output']>;
  mandatory_min_passing_score?: Maybe<Scalars['Int']['output']>;
  mandatory_reminder_frequency_days?: Maybe<Scalars['Int']['output']>;
  min_passing_score?: Maybe<Scalars['Int']['output']>;
  onboarding_failure_escalation_threshold?: Maybe<Scalars['Int']['output']>;
  onboarding_min_passing_score?: Maybe<Scalars['Int']['output']>;
  onboarding_reminder_frequency_days?: Maybe<Scalars['Int']['output']>;
  reminder_frequency_days?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  updated_by?: Maybe<User>;
};

export type TrainingSettingsUpdateInput = {
  departmental_failure_escalation_threshold?: InputMaybe<Scalars['Int']['input']>;
  departmental_min_passing_score?: InputMaybe<Scalars['Int']['input']>;
  departmental_reminder_frequency_days?: InputMaybe<Scalars['Int']['input']>;
  failure_escalation_threshold?: InputMaybe<Scalars['Int']['input']>;
  mandatory_failure_escalation_threshold?: InputMaybe<Scalars['Int']['input']>;
  mandatory_min_passing_score?: InputMaybe<Scalars['Int']['input']>;
  mandatory_reminder_frequency_days?: InputMaybe<Scalars['Int']['input']>;
  min_passing_score?: InputMaybe<Scalars['Int']['input']>;
  onboarding_failure_escalation_threshold?: InputMaybe<Scalars['Int']['input']>;
  onboarding_min_passing_score?: InputMaybe<Scalars['Int']['input']>;
  onboarding_reminder_frequency_days?: InputMaybe<Scalars['Int']['input']>;
  reminder_frequency_days?: InputMaybe<Scalars['Int']['input']>;
};

export type TraningRepecaCreateInputResult = {
  __typename?: 'TraningRepecaCreateInputResult';
  attachments?: Maybe<Array<QuizTrainingAttachment>>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  links?: Maybe<Array<Maybe<QuizTrainingLink>>>;
  started_date?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  Brand?: Maybe<Brand>;
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Customer?: Maybe<Customer>;
  RepairTransaction?: Maybe<Transaction>;
  Tax?: Maybe<Tax>;
  TradeInDevice?: Maybe<TradeInDevice>;
  _id?: Maybe<Scalars['ID']['output']>;
  additional_notes?: Maybe<Scalars['String']['output']>;
  arrival_date?: Maybe<Scalars['DateTime']['output']>;
  balance_not_paid_amount?: Maybe<Scalars['Float']['output']>;
  btnCaption?: Maybe<Scalars['String']['output']>;
  calculated_price?: Maybe<Scalars['Float']['output']>;
  cancel_at?: Maybe<Scalars['DateTime']['output']>;
  cancel_by?: Maybe<User>;
  cost?: Maybe<Scalars['Float']['output']>;
  coupon_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  custom_purchase_part?: Maybe<Scalars['String']['output']>;
  deadline_status?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  delivered_percentage?: Maybe<Scalars['Float']['output']>;
  delivery_address?: Maybe<Scalars['String']['output']>;
  desired_margin?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_value?: Maybe<Scalars['Float']['output']>;
  filterJson?: Maybe<Scalars['String']['output']>;
  filter_type?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  invoice_for_repair_room?: Maybe<Scalars['Boolean']['output']>;
  is_additional_cost?: Maybe<Scalars['Boolean']['output']>;
  is_amount_refund?: Maybe<Scalars['Boolean']['output']>;
  is_apply_sale_tax?: Maybe<Scalars['Boolean']['output']>;
  is_checkout?: Maybe<Scalars['Boolean']['output']>;
  is_coupon_apply?: Maybe<Scalars['Boolean']['output']>;
  is_devices_for_checkout?: Maybe<Scalars['Boolean']['output']>;
  is_discount_percentage?: Maybe<Scalars['Boolean']['output']>;
  is_extra_items?: Maybe<Scalars['Boolean']['output']>;
  is_missing_items?: Maybe<Scalars['Boolean']['output']>;
  is_overide_price?: Maybe<Scalars['Boolean']['output']>;
  is_partial_checkout?: Maybe<Scalars['Boolean']['output']>;
  is_partial_repair_done?: Maybe<Scalars['Boolean']['output']>;
  is_pay_to_customer?: Maybe<Scalars['Boolean']['output']>;
  is_private?: Maybe<Scalars['Boolean']['output']>;
  is_repair_done?: Maybe<Scalars['Boolean']['output']>;
  is_service_update?: Maybe<Scalars['Boolean']['output']>;
  is_tax_percentage?: Maybe<Scalars['Boolean']['output']>;
  is_tax_refund?: Maybe<Scalars['Boolean']['output']>;
  is_trade_in_issue?: Maybe<Scalars['Boolean']['output']>;
  net_term_amount?: Maybe<Scalars['Float']['output']>;
  order_actual_amount?: Maybe<Scalars['Float']['output']>;
  order_estimate_amount?: Maybe<Scalars['Float']['output']>;
  order_status?: Maybe<Scalars['String']['output']>;
  pay_to_customer?: Maybe<Scalars['Float']['output']>;
  received_additional_cost?: Maybe<Scalars['Float']['output']>;
  received_by?: Maybe<Scalars['String']['output']>;
  received_date?: Maybe<Scalars['DateTime']['output']>;
  received_note?: Maybe<Scalars['String']['output']>;
  ref_no?: Maybe<Scalars['String']['output']>;
  refund_amount?: Maybe<Scalars['Float']['output']>;
  refund_amount_to_customer?: Maybe<Scalars['Float']['output']>;
  remaining_Customer_credit?: Maybe<Scalars['Float']['output']>;
  remaining_amount?: Maybe<Scalars['Float']['output']>;
  repair_completion_date?: Maybe<Scalars['DateTime']['output']>;
  repair_room_color_pallet?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  route_url?: Maybe<Scalars['String']['output']>;
  schedule_pickup?: Maybe<Scalars['DateTime']['output']>;
  shipping_amount?: Maybe<Scalars['Float']['output']>;
  shipping_company_name?: Maybe<Scalars['String']['output']>;
  shipping_estimated_days?: Maybe<Scalars['String']['output']>;
  shipping_tracking_no?: Maybe<Scalars['String']['output']>;
  sub_total_amount?: Maybe<Scalars['Float']['output']>;
  supplier_order_number?: Maybe<Scalars['String']['output']>;
  supplier_rma_number?: Maybe<Scalars['String']['output']>;
  tax_amount?: Maybe<Scalars['Float']['output']>;
  tax_value?: Maybe<Scalars['Float']['output']>;
  technician?: Maybe<User>;
  ticket_type?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  total_part_count?: Maybe<Scalars['Int']['output']>;
  total_refund_amount?: Maybe<Scalars['Float']['output']>;
  total_tax_amount?: Maybe<Scalars['Float']['output']>;
  tradin_initial_value?: Maybe<Scalars['Int']['output']>;
  transaction_am_pm?: Maybe<Scalars['String']['output']>;
  transaction_date?: Maybe<Scalars['DateTime']['output']>;
  transaction_hours?: Maybe<Scalars['String']['output']>;
  transaction_keeping_unit?: Maybe<Scalars['String']['output']>;
  transaction_minutes?: Maybe<Scalars['String']['output']>;
  transaction_payment_status?: Maybe<Scalars['String']['output']>;
  transaction_status?: Maybe<Scalars['String']['output']>;
  transaction_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type TwoFaInput = {
  employee_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TwoFaOutput = {
  __typename?: 'TwoFAOutput';
  uri?: Maybe<Scalars['String']['output']>;
};

export enum TypeOfConcern {
  CoworkerMisconduct = 'coworker_misconduct',
  DiscriminationAge = 'discrimination_age',
  DiscriminationDisability = 'discrimination_disability',
  DiscriminationGenderSex = 'discrimination_gender_sex',
  DiscriminationNationalOrigin = 'discrimination_national_origin',
  DiscriminationRaceEthnicity = 'discrimination_race_ethnicity',
  DiscriminationReligion = 'discrimination_religion',
  HarassmentNonSexual = 'harassment_non_sexual',
  HarassmentSexual = 'harassment_sexual',
  ManagerSupervisorMisconduct = 'manager_supervisor_misconduct',
  Other = 'other',
  PolicyViolation = 'policy_violation',
  Retaliation = 'retaliation',
  SafetyConcern = 'safety_concern',
  SubstanceAbuse = 'substance_abuse',
  TheftOrFraud = 'theft_or_fraud',
  TimekeepingScheduleDispute = 'timekeeping_schedule_dispute',
  WagePayDispute = 'wage_pay_dispute',
  WorkplaceViolenceOrThreat = 'workplace_violence_or_threat'
}

export type UpdateAssetCategoryInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetInput = {
  AssetBrand?: InputMaybe<Scalars['ID']['input']>;
  AssetModel?: InputMaybe<Scalars['ID']['input']>;
  Role?: InputMaybe<Array<Scalars['ID']['input']>>;
  Station?: InputMaybe<Scalars['ID']['input']>;
  actualQuantity?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Scalars['String']['input']>;
  assetImage?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  assetImageUrl?: InputMaybe<Scalars['String']['input']>;
  assignedEmployee?: InputMaybe<Scalars['ID']['input']>;
  assignedType?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  depreciation?: InputMaybe<Array<InputMaybe<DepreciationInput>>>;
  depreciationSalvageValue?: InputMaybe<Scalars['Int']['input']>;
  depreciationTenure?: InputMaybe<Scalars['Int']['input']>;
  depreciationType?: InputMaybe<DepreciationEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  initialCost?: InputMaybe<Scalars['Float']['input']>;
  isAutoAssetId?: InputMaybe<Scalars['Boolean']['input']>;
  isDepreciation?: InputMaybe<Scalars['Boolean']['input']>;
  isSeriallized?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  other_detail?: InputMaybe<Scalars['String']['input']>;
  purchasedDate?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  role_employes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  serialNumbers?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['ID']['input']>;
  subCategory?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetSubCategoryInput = {
  AssetCategoryId?: InputMaybe<Scalars['ID']['input']>;
  categoryUrl?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoriesInput = {
  name: Scalars['String']['input'];
  sections?: InputMaybe<Array<UpdateCategoriesSectionInput>>;
};

export type UpdateCategoriesSectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};

export type UpdateDiscountInput = {
  Business: Scalars['ID']['input'];
  BusinessLocation: Scalars['ID']['input'];
  Campaign: Scalars['ID']['input'];
  Product?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  business_type: Scalars['String']['input'];
  can_schedule: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  customerTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customer_since?: InputMaybe<Scalars['String']['input']>;
  discount_amount: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  isSendEmail: Scalars['Boolean']['input'];
  is_active: Is_Active;
  is_customer_can_use_only_once: Scalars['Boolean']['input'];
  is_customer_more_then_said_amount: Scalars['Boolean']['input'];
  is_customer_since: Scalars['Boolean']['input'];
  is_customer_spent_amount: Scalars['Boolean']['input'];
  is_discount_percentage: Scalars['Boolean']['input'];
  is_entire_order: Scalars['Boolean']['input'];
  is_minimum_purchase: Scalars['Boolean']['input'];
  is_minimum_purchase_amount: Scalars['Boolean']['input'];
  is_new_customer_only: Scalars['Boolean']['input'];
  is_single_store: Scalars['Boolean']['input'];
  multi_stores?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  number_of_usage_per_customer?: InputMaybe<Scalars['Float']['input']>;
  purchaseAmountQuantity?: InputMaybe<Scalars['Float']['input']>;
  reach?: InputMaybe<Scalars['Int']['input']>;
  schedule_from?: InputMaybe<Scalars['String']['input']>;
  schedule_to?: InputMaybe<Scalars['String']['input']>;
  single_store?: InputMaybe<Scalars['ID']['input']>;
  spent_amount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateExternalVendorTrainingInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  completion_date?: InputMaybe<Scalars['Date']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  training_name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeedbackInput = {
  _id: Scalars['ID']['input'];
  status?: InputMaybe<FeedbackStatus>;
};

export type UpdateInvoiceInput = {
  billTo?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  courtesyCredit?: InputMaybe<Scalars['Float']['input']>;
  grandTotal?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoiceImageUrl?: InputMaybe<Scalars['String']['input']>;
  invoiceItems?: InputMaybe<Array<InputMaybe<UpdateInvoiceItemsInput>>>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  invoice_image?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderDate?: InputMaybe<Scalars['Date']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  shipTo?: InputMaybe<Scalars['String']['input']>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  subTotal?: InputMaybe<Scalars['Float']['input']>;
  taxes?: InputMaybe<Scalars['Float']['input']>;
  toPayOff?: InputMaybe<Scalars['Float']['input']>;
  totalPaid?: InputMaybe<Scalars['Float']['input']>;
  totalProducts?: InputMaybe<Scalars['Float']['input']>;
  totalQty?: InputMaybe<Scalars['Int']['input']>;
  totalSerialNumber?: InputMaybe<Scalars['Float']['input']>;
  totalShippingCharges?: InputMaybe<Scalars['Float']['input']>;
  totalSku?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInvoiceInputs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  invoiceItems?: InputMaybe<Array<InputMaybe<UpdateInvoiceItemsInput>>>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<Scalars['Int']['input']>;
  subTotal?: InputMaybe<Scalars['Int']['input']>;
  taxes?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInvoiceItemInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  serial_number?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMaintenanceInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  dateCompleted?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceBy?: InputMaybe<Scalars['String']['input']>;
  recurring?: InputMaybe<Scalars['Int']['input']>;
  recurringBy?: InputMaybe<RecurringBy>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrientationDetailsInput = {
  _id: Scalars['ID']['input'];
  delivery_method: OrientationDeliveryMethod;
  orientation_date: Scalars['Date']['input'];
};

export type UpdateOwnPersonalInformationInput = {
  Country?: InputMaybe<Scalars['ID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  birth_date?: InputMaybe<Scalars['DateTime']['input']>;
  city?: InputMaybe<Scalars['ID']['input']>;
  default_image?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  marital_status?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  personal_email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preffered_name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['ID']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePasswordInput = {
  appId: Scalars['ID']['input'];
  appShares?: InputMaybe<Array<InputMaybe<UsersSharedPasswordInput>>>;
};

export type UpdateQuestionInput = {
  QuizCategory: Scalars['ID']['input'];
  QuizCategorySection: Scalars['ID']['input'];
  addLanguages?: InputMaybe<Array<LanguageCode>>;
  add_attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  add_option_images?: InputMaybe<Array<InputMaybe<OptionImageAddInput>>>;
  add_options?: InputMaybe<Array<InputMaybe<OptionInput>>>;
  correct_answer?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  question_text: Scalars['String']['input'];
  question_type: Scalars['String']['input'];
  remove_attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  remove_option_images?: InputMaybe<Array<InputMaybe<OptionImageRemoveInput>>>;
  remove_options?: InputMaybe<Array<Scalars['ID']['input']>>;
  update_option_text?: InputMaybe<Array<InputMaybe<OptionTextUpdateInput>>>;
};

export type UpdateQuizInput = {
  Department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Role?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assignTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  can_assign_traning?: InputMaybe<Scalars['Boolean']['input']>;
  can_re_attempts?: InputMaybe<CanReAttempts>;
  category_sections: Array<CategorySectionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['Date']['input']>;
  end_time?: InputMaybe<Scalars['Date']['input']>;
  evaluate_by?: InputMaybe<Array<Scalars['ID']['input']>>;
  evaluator_department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  evaluator_role?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  grade?: InputMaybe<Array<GradeInput>>;
  is_attempt_one_by_one?: InputMaybe<Scalars['Boolean']['input']>;
  is_random?: InputMaybe<Scalars['Boolean']['input']>;
  is_shuffling?: InputMaybe<Scalars['Boolean']['input']>;
  max_attempts?: InputMaybe<Scalars['Int']['input']>;
  passing_marks?: InputMaybe<Scalars['Float']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  selectedLanguages?: InputMaybe<Array<LanguageCode>>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  start_time?: InputMaybe<Scalars['Date']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateQuizTrainingAssignmentStatusInput = {
  quizTrainingAssignmentId: Scalars['ID']['input'];
  status: TrainingAssignStatus;
};

export type UpdateShareAppInput = {
  authenticatorAppId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  is_opt_share: Scalars['Boolean']['input'];
  is_password_share: Scalars['Boolean']['input'];
  is_scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<EncryptedPasswordInput>;
  scheduled_for?: InputMaybe<Scalars['String']['input']>;
  share_as: ShareAsEnum;
  share_permissions: ShareAppPermissions;
};

export type UpdateSubCategoriesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateWorkFlowInput = {
  action_performed?: InputMaybe<Scalars['Boolean']['input']>;
  business: Scalars['ID']['input'];
  escalation_user?: InputMaybe<EscalationUserInput>;
  id: Scalars['ID']['input'];
  overdue_days?: InputMaybe<Scalars['Int']['input']>;
  work_flow_levels: Array<WorkFlowLevelInput>;
  work_flow_type: WorkFlowTypeEnum;
};

export type UpdatedDataTableConfig = {
  __typename?: 'UpdatedDataTableConfig';
  actions?: Maybe<Array<Maybe<ConfigActionType>>>;
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  filters?: Maybe<Array<Maybe<ListingFiltersType>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  no_of_records?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  table_config?: Maybe<TableConfigListing>;
  table_preset?: Maybe<Array<Maybe<ListingTablePreset>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type UploadProgress = {
  __typename?: 'UploadProgress';
  fileName: Scalars['String']['output'];
  module: Scalars['String']['output'];
  percentage: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export enum UrgencyStatus {
  NoDeadline = 'no_deadline',
  OnTrack = 'on_track',
  Overdue = 'overdue',
  Urgent = 'urgent'
}

export type UsageBalance = {
  __typename?: 'UsageBalance';
  days?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  short_leave_count?: Maybe<Scalars['Int']['output']>;
};

export type UsageLedgerEntry = {
  __typename?: 'UsageLedgerEntry';
  amount?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  is_credit?: Maybe<Scalars['Boolean']['output']>;
  transaction_type?: Maybe<Scalars['String']['output']>;
};

export type UsedLeave = {
  __typename?: 'UsedLeave';
  count?: Maybe<Scalars['Int']['output']>;
  days?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
};

export type User = {
  __typename?: 'User';
  Country?: Maybe<Country>;
  EmployeeGarnishment?: Maybe<Array<Maybe<EmployeeGarnishment>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  account_number?: Maybe<Scalars['String']['output']>;
  account_representive_code?: Maybe<Scalars['String']['output']>;
  account_status?: Maybe<Scalars['String']['output']>;
  account_title?: Maybe<Scalars['String']['output']>;
  action_create_date?: Maybe<Scalars['DateTime']['output']>;
  action_type?: Maybe<Scalars['String']['output']>;
  additional_tax_override?: Maybe<Scalars['String']['output']>;
  additional_withholding_amount?: Maybe<Scalars['String']['output']>;
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  adp?: Maybe<Scalars['String']['output']>;
  air_ticket?: Maybe<AirTicket>;
  allow_email?: Maybe<Scalars['Boolean']['output']>;
  allow_qr_code?: Maybe<Scalars['Boolean']['output']>;
  allow_sms?: Maybe<Scalars['Boolean']['output']>;
  allowances?: Maybe<Array<Maybe<AllowancesType>>>;
  altername?: Maybe<Scalars['String']['output']>;
  associated_customer?: Maybe<Scalars['String']['output']>;
  auth_pin?: Maybe<Scalars['String']['output']>;
  avatar_location?: Maybe<Scalars['String']['output']>;
  badge_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  basic_salary?: Maybe<Scalars['String']['output']>;
  birth_date?: Maybe<Scalars['DateTime']['output']>;
  branch_code?: Maybe<Scalars['String']['output']>;
  business_id?: Maybe<Business>;
  city?: Maybe<City>;
  commision?: Maybe<Scalars['Float']['output']>;
  contributions?: Maybe<Array<Maybe<ContributionsType>>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  custom_user?: Maybe<Scalars['String']['output']>;
  deductions?: Maybe<Array<Maybe<DeductionsType>>>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  department?: Maybe<Array<Maybe<Department>>>;
  designation?: Maybe<Designation>;
  documents_list?: Maybe<Array<Maybe<DocumentListType>>>;
  eligibility_date?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employee_action_date?: Maybe<Scalars['DateTime']['output']>;
  employee_group?: Maybe<AttandencePolicy>;
  employee_home_address?: Maybe<Scalars['String']['output']>;
  employee_id?: Maybe<Scalars['String']['output']>;
  employee_status?: Maybe<Scalars['String']['output']>;
  employee_type?: Maybe<Scalars['String']['output']>;
  employee_work_address?: Maybe<Scalars['String']['output']>;
  exempt_any_state_tax?: Maybe<Scalars['Boolean']['output']>;
  extra_no?: Maybe<Scalars['String']['output']>;
  final_settlement_completed?: Maybe<Scalars['Boolean']['output']>;
  final_settlement_date?: Maybe<Scalars['DateTime']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hire_date?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<Array<Maybe<UserHistory>>>;
  home_no?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['DateTime']['output']>;
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  is_air_ticket?: Maybe<Scalars['Boolean']['output']>;
  is_allow_attendance?: Maybe<Scalars['Boolean']['output']>;
  is_app_authenticator?: Maybe<Scalars['Boolean']['output']>;
  is_attendance_rule_applied?: Maybe<Scalars['Boolean']['output']>;
  is_breaked_in?: Maybe<Scalars['Boolean']['output']>;
  is_breaktime_exception?: Maybe<Scalars['Boolean']['output']>;
  is_business_owner_requested_new_password?: Maybe<Scalars['Boolean']['output']>;
  is_clocked_in?: Maybe<Scalars['Boolean']['output']>;
  is_company?: Maybe<Scalars['Boolean']['output']>;
  is_customzied_overtime?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_earlyout?: Maybe<Scalars['Boolean']['output']>;
  is_email_verify?: Maybe<Scalars['Boolean']['output']>;
  is_enable_checkin_checkout_access?: Maybe<Scalars['Boolean']['output']>;
  is_excluding_pay_roll?: Maybe<Scalars['Boolean']['output']>;
  is_exempt_federal_tax?: Maybe<Scalars['Boolean']['output']>;
  is_exempt_from_withholding?: Maybe<Scalars['Boolean']['output']>;
  is_exempt_income_tax?: Maybe<Scalars['Boolean']['output']>;
  is_generate_joining_letter?: Maybe<Scalars['Boolean']['output']>;
  is_gratuity?: Maybe<Scalars['Boolean']['output']>;
  is_hours_in_a_day?: Maybe<Scalars['Boolean']['output']>;
  is_late_arrival?: Maybe<Scalars['Boolean']['output']>;
  is_leave_restriction?: Maybe<Scalars['Boolean']['output']>;
  is_medical_insurance?: Maybe<Scalars['Boolean']['output']>;
  is_missing_attendance?: Maybe<Scalars['Boolean']['output']>;
  is_navigated_user?: Maybe<Scalars['Boolean']['output']>;
  is_over_time_policy?: Maybe<Scalars['Boolean']['output']>;
  is_password_set?: Maybe<Scalars['Boolean']['output']>;
  is_payroll_run_on_business?: Maybe<Scalars['Boolean']['output']>;
  is_phone_verify?: Maybe<Scalars['Boolean']['output']>;
  is_profile_completed?: Maybe<Scalars['Boolean']['output']>;
  is_profile_updated?: Maybe<Scalars['Boolean']['output']>;
  is_sample_data?: Maybe<Scalars['Boolean']['output']>;
  is_self_service_access?: Maybe<Scalars['Boolean']['output']>;
  is_send_email_notification?: Maybe<Scalars['Boolean']['output']>;
  is_store_wise?: Maybe<Scalars['Boolean']['output']>;
  is_super_admin?: Maybe<Scalars['Boolean']['output']>;
  is_writeup_pending?: Maybe<Scalars['Boolean']['output']>;
  joining_date?: Maybe<Scalars['DateTime']['output']>;
  joining_latter?: Maybe<Joining_Latter>;
  landline?: Maybe<Scalars['String']['output']>;
  last_day_worked?: Maybe<Scalars['String']['output']>;
  last_login_at?: Maybe<Scalars['String']['output']>;
  last_login_ip?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_working_date?: Maybe<Scalars['DateTime']['output']>;
  leave_policy?: Maybe<LeavePolicy>;
  length_of_service?: Maybe<Scalars['String']['output']>;
  license_no?: Maybe<Scalars['String']['output']>;
  line_manager?: Maybe<User>;
  local_code?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  marital_status?: Maybe<Scalars['String']['output']>;
  medical_insurance?: Maybe<MedicalInsuranceType>;
  middle_name?: Maybe<Scalars['String']['output']>;
  mobile_no?: Maybe<Scalars['String']['output']>;
  mobile_no_to_send_sms?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  new_salary_effect_from?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  numberOfdays?: Maybe<Scalars['Int']['output']>;
  over_time_rate?: Maybe<Scalars['Float']['output']>;
  passport_number?: Maybe<Scalars['String']['output']>;
  password_changed_at?: Maybe<Scalars['String']['output']>;
  pay_schedule?: Maybe<PayrollSchedule>;
  pay_schedule_salary?: Maybe<Scalars['Float']['output']>;
  pay_type?: Maybe<Scalars['String']['output']>;
  payout_frequency?: Maybe<Scalars['String']['output']>;
  payout_rate?: Maybe<Scalars['Float']['output']>;
  personal_email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone_country_code?: Maybe<Scalars['String']['output']>;
  preffered_name?: Maybe<Scalars['String']['output']>;
  previous_leave_policy?: Maybe<LeavePolicy>;
  probation_period?: Maybe<Scalars['String']['output']>;
  profile_pictures?: Maybe<Array<Maybe<ProfilePictures>>>;
  profile_score?: Maybe<Scalars['Float']['output']>;
  pto_minutes?: Maybe<PtoMinutesType>;
  public_day_hourly_salary?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Array<Maybe<Region>>>;
  rocket_chat_id?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  routing_number?: Maybe<Scalars['String']['output']>;
  salaryHour?: Maybe<Scalars['Float']['output']>;
  salary_payment_method?: Maybe<Scalars['String']['output']>;
  salary_template?: Maybe<Scalars['String']['output']>;
  salary_type?: Maybe<Scalars['String']['output']>;
  sales_tax_allowances?: Maybe<Scalars['String']['output']>;
  seasonal_employee?: Maybe<Scalars['String']['output']>;
  send_order_email_to_parent?: Maybe<Scalars['String']['output']>;
  send_sales_order_email?: Maybe<Scalars['String']['output']>;
  sepration_description?: Maybe<Scalars['String']['output']>;
  shift?: Maybe<Shift>;
  ssn?: Maybe<Scalars['String']['output']>;
  ssn_last_four_digit?: Maybe<Scalars['String']['output']>;
  starting_date?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<State>;
  status?: Maybe<Scalars['String']['output']>;
  storeAccess?: Maybe<Array<Maybe<StoreAccessType>>>;
  subscribed_insurances?: Maybe<Array<Maybe<MedicalInsurancePackage>>>;
  support_name?: Maybe<Scalars['String']['output']>;
  swift_code?: Maybe<Scalars['String']['output']>;
  tax_override?: Maybe<Scalars['String']['output']>;
  tax_override_amount?: Maybe<Scalars['String']['output']>;
  termination_date?: Maybe<Scalars['DateTime']['output']>;
  termination_reason?: Maybe<Scalars['String']['output']>;
  time_off?: Maybe<Array<Maybe<TimeOffType>>>;
  total_allowances?: Maybe<Scalars['String']['output']>;
  total_week_hours?: Maybe<Scalars['Int']['output']>;
  two_fa_secret?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
  user_keeping_unit?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  users_password_manager?: Maybe<UserEncryptionKeys>;
  vehicle_no?: Maybe<Scalars['String']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
  w4_form?: Maybe<Scalars['String']['output']>;
  weekend_day_salary?: Maybe<Scalars['String']['output']>;
  weekly_hourly_salary?: Maybe<Scalars['String']['output']>;
  withholding_status?: Maybe<Scalars['String']['output']>;
  work_email?: Maybe<Scalars['String']['output']>;
  work_no?: Maybe<Scalars['String']['output']>;
  writeup_date?: Maybe<Scalars['String']['output']>;
  writeup_message?: Maybe<Scalars['String']['output']>;
  writeup_type?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type UserAccural = {
  __typename?: 'UserAccural';
  User?: Maybe<User>;
  logs?: Maybe<Array<Maybe<AccuralLogs>>>;
  pto_minutes?: Maybe<PtoMinutesType>;
  time_off?: Maybe<Array<Maybe<TimeOffType>>>;
};

export type UserActivity = {
  __typename?: 'UserActivity';
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  access_type?: Maybe<Scalars['String']['output']>;
  application?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type UserAppDeviceLog = {
  __typename?: 'UserAppDeviceLog';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  User?: Maybe<User>;
  UserAppDevice?: Maybe<UserAppDevice>;
  _id?: Maybe<Scalars['ID']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  action_date?: Maybe<Scalars['DateTime']['output']>;
  app_type?: Maybe<Scalars['String']['output']>;
  break_type?: Maybe<MasterDataValue>;
  device_id?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
};

export type UserAttendanceLogs = {
  __typename?: 'UserAttendanceLogs';
  personal_email: Scalars['String']['output'];
  records: Array<MsAttendanceLog>;
};

export type UserConflict = {
  __typename?: 'UserConflict';
  records?: Maybe<Array<Maybe<ConflictRecord>>>;
  user_name?: Maybe<Scalars['String']['output']>;
};

export type UserDetailAccural = {
  __typename?: 'UserDetailAccural';
  User?: Maybe<User>;
  leave_type_details?: Maybe<Array<Maybe<AccuralDetailLogs>>>;
  logs?: Maybe<Array<Maybe<AccuralLogs>>>;
  pto_minutes?: Maybe<PtoMinutesType>;
  time_off?: Maybe<Array<Maybe<TimeOffType>>>;
};

export type UserEncryptionCopies = {
  __typename?: 'UserEncryptionCopies';
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  encryption?: Maybe<Encryption>;
  from_user?: Maybe<User>;
  is_owner?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UserEncryptionCopiesInput = {
  encryptionKeys?: InputMaybe<Array<EncryptionData>>;
  user: Scalars['ID']['input'];
};

export type UserEncryptionKeys = {
  __typename?: 'UserEncryptionKeys';
  encryptedPrivateKey?: Maybe<Scalars['String']['output']>;
  iv?: Maybe<Scalars['String']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
  salt?: Maybe<Scalars['String']['output']>;
};

export type UserHistory = {
  __typename?: 'UserHistory';
  account_status?: Maybe<Scalars['String']['output']>;
  action_create_date?: Maybe<Scalars['DateTime']['output']>;
  action_type?: Maybe<Scalars['String']['output']>;
  back_pay_effected?: Maybe<Array<Maybe<UserHistory>>>;
  basic_salary?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<User>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Array<Maybe<Department>>>;
  employee?: Maybe<User>;
  employee_group?: Maybe<AttandencePolicy>;
  employee_type?: Maybe<Scalars['String']['output']>;
  hire_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_exclude_pay_roll?: Maybe<Scalars['String']['output']>;
  is_excluding_pay_roll?: Maybe<Scalars['Boolean']['output']>;
  is_salary_update?: Maybe<Scalars['Boolean']['output']>;
  is_under_back_pay?: Maybe<Scalars['Boolean']['output']>;
  is_use_new_salary?: Maybe<Scalars['Boolean']['output']>;
  joining_date?: Maybe<Scalars['DateTime']['output']>;
  line_manager?: Maybe<User>;
  new_salary_effect_from?: Maybe<Scalars['DateTime']['output']>;
  new_salary_effect_to?: Maybe<Scalars['DateTime']['output']>;
  over_time_hours?: Maybe<Scalars['Int']['output']>;
  over_time_rate?: Maybe<Scalars['Float']['output']>;
  pay_schedule?: Maybe<PayrollSchedule>;
  pay_type?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Previous>;
  public_day_hourly_salary?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Array<Maybe<Region>>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  salary_type?: Maybe<Scalars['String']['output']>;
  shift?: Maybe<Shift>;
  starting_date?: Maybe<Scalars['DateTime']['output']>;
  storeAccess?: Maybe<Array<Maybe<StoreAccessType>>>;
  total_week_hours?: Maybe<Scalars['Int']['output']>;
  weekend_day_salary?: Maybe<Scalars['Float']['output']>;
  weekly_hourly_salary?: Maybe<Scalars['Float']['output']>;
};

export type UserRoster = {
  __typename?: 'UserRoster';
  RecurrenceRule?: Maybe<Scalars['String']['output']>;
  _id?: Maybe<Scalars['ID']['output']>;
  break_detail?: Maybe<Array<Maybe<BreakDetailType>>>;
  color?: Maybe<Scalars['String']['output']>;
  designations?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  employees?: Maybe<Array<Maybe<User>>>;
  end_date?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  is_published?: Maybe<Scalars['Boolean']['output']>;
  meal_break?: Maybe<Scalars['Float']['output']>;
  repeat?: Maybe<Repeat>;
  rest_break?: Maybe<Scalars['Float']['output']>;
  rosterStore?: Maybe<RosterStores>;
  start_date?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
};

export type UserWorkFlow = {
  __typename?: 'UserWorkFlow';
  _id?: Maybe<Scalars['ID']['output']>;
  logs?: Maybe<Array<Maybe<WorkFlows>>>;
  total_level?: Maybe<Scalars['Int']['output']>;
  work_flow_levels?: Maybe<Array<Maybe<Level>>>;
  work_flow_type?: Maybe<Scalars['String']['output']>;
};

export type ValidDiscount = {
  __typename?: 'ValidDiscount';
  coupon_amount?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Discount>;
  is_eligible: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type ValidationDnsKeys = {
  __typename?: 'ValidationDnsKeys';
  dkim1?: Maybe<CommonValidReason>;
  dkim2?: Maybe<CommonValidReason>;
  mail_cname?: Maybe<CommonValidReason>;
  spf?: Maybe<CommonValidReason>;
};

export type Vendor = {
  __typename?: 'Vendor';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<User>;
};

export enum ViewSchedule {
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export type WitnessComplaint = {
  __typename?: 'WitnessComplaint';
  Department?: Maybe<Array<Maybe<Department>>>;
  User?: Maybe<User>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  is_internal_person?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  what_they_witnessed?: Maybe<Scalars['String']['output']>;
};

export type WitnessComplaintInput = {
  Department?: InputMaybe<Array<Scalars['ID']['input']>>;
  User?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  is_internal_person?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  what_they_witnessed?: InputMaybe<Scalars['String']['input']>;
};

export enum WitnessesEvent {
  No = 'no',
  Unsure = 'unsure',
  Yes = 'yes'
}

export type WorkFlowInput = {
  business: Scalars['ID']['input'];
  escalation_user?: InputMaybe<EscalationUserInput>;
  overdue_days?: InputMaybe<Scalars['Int']['input']>;
  work_flow_levels: Array<WorkFlowLevelInput>;
  work_flow_type: WorkFlowTypeEnum;
};

export type WorkFlowLevelInput = {
  approval_level?: InputMaybe<Scalars['Int']['input']>;
  approval_to: ApprovalTo;
  employee?: InputMaybe<Scalars['ID']['input']>;
  level: Scalars['Int']['input'];
  move_to_next?: InputMaybe<Scalars['String']['input']>;
  reminder?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
};

export type WriteUp = {
  __typename?: 'WriteUp';
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['ID']['output']>;
  accept_assign_schedule?: Maybe<Scalars['Boolean']['output']>;
  approval_description?: Maybe<Scalars['String']['output']>;
  approval_status?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  behalf_of?: Maybe<Array<Maybe<User>>>;
  business_manager?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<User>;
  informed_hr?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_pending?: Maybe<Scalars['Boolean']['output']>;
  logs?: Maybe<Array<Maybe<LogsWriteUp>>>;
  status?: Maybe<Scalars['String']['output']>;
  work_flow?: Maybe<Array<Maybe<WorkFlow>>>;
  write_up_reason?: Maybe<Scalars['String']['output']>;
  write_up_source?: Maybe<Scalars['String']['output']>;
  write_up_type?: Maybe<Scalars['String']['output']>;
  writeup_date?: Maybe<Scalars['DateTime']['output']>;
  writeup_message?: Maybe<Scalars['String']['output']>;
};

export type WriteUpList = {
  __typename?: 'WriteUpList';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<WriteUp>>>;
};

export enum WriteUpReason {
  AssistingTeam = 'ASSISTING_TEAM',
  BreakExtension = 'BREAK_EXTENSION',
  CoveringColleague = 'COVERING_COLLEAGUE',
  ExtendedLunch = 'EXTENDED_LUNCH',
  FamilyEmergency = 'FAMILY_EMERGENCY',
  FamilyIssue = 'FAMILY_ISSUE',
  LostTrackOfTime = 'LOST_TRACK_OF_TIME',
  MedicalIssues = 'MEDICAL_ISSUES',
  Miscommunication = 'MISCOMMUNICATION',
  MissedClockout = 'MISSED_CLOCKOUT',
  Other = 'OTHER',
  Overslept = 'OVERSLEPT',
  PersonalAppointment = 'PERSONAL_APPOINTMENT',
  PersonalCall = 'PERSONAL_CALL',
  PreArrangedWork = 'PRE_ARRANGED_WORK',
  ReligiousObservance = 'RELIGIOUS_OBSERVANCE',
  SickLeave = 'SICK_LEAVE',
  SupervisorApproved = 'SUPERVISOR_APPROVED',
  SupervisorRequest = 'SUPERVISOR_REQUEST',
  TasksCompleted = 'TASKS_COMPLETED',
  TaskCompletion = 'TASK_COMPLETION',
  Transportation = 'TRANSPORTATION',
  TravelIssue = 'TRAVEL_ISSUE',
  Unplanned = 'UNPLANNED',
  UnplannedAbsence = 'UNPLANNED_ABSENCE'
}

export type ZipCode = {
  __typename?: 'ZipCode';
  City?: Maybe<City>;
  Country?: Maybe<Country>;
  State?: Maybe<State>;
  _id?: Maybe<Scalars['ID']['output']>;
  city_name?: Maybe<Scalars['String']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  state_name?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ZipCodeData = {
  __typename?: 'ZipCodeData';
  City?: Maybe<City>;
  Detail?: Maybe<HierarchicalDetail>;
  State?: Maybe<State>;
  _id?: Maybe<Scalars['ID']['output']>;
  city_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ZipCodeFilterInput = {
  city?: InputMaybe<Scalars['ID']['input']>;
  country: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['ID']['input']>;
};

export enum _Status {
  Active = 'Active',
  Inactive = 'Inactive',
  Scheduled = 'Scheduled'
}

export type _TimeOff = {
  __typename?: '_TimeOff';
  RecurrenceRule?: Maybe<Scalars['String']['output']>;
  category_color?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  from_date?: Maybe<Scalars['DateTime']['output']>;
  is_paid?: Maybe<Scalars['Boolean']['output']>;
  leave_type?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to_date?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<TimeOff>;
};

export enum _Commission_Duration {
  LifeTime = 'life_time',
  ScheduleToFrom = 'schedule_to_from',
  TillDate = 'till_date'
}

export enum _Commission_Store {
  MultiStore = 'multi_store',
  SelectedStore = 'selected_store',
  SingleStore = 'single_store'
}

export enum _Commission_Type {
  ComissionOnGreaterThanOrEqualTo = 'comission_on_greater_than_or_equal_to',
  CommissionOnHighestSales = 'commission_on_highest_sales',
  CommissionOnMinimumDiscount = 'commission_on_minimum_discount',
  CommissionOnSaleExceedingMinimumPriceOfProduct = 'commission_on_sale_exceeding_minimum_price_of_product',
  CommissionPerSale = 'commission_per_sale'
}

export enum _Sale_Duration {
  Day = 'day',
  Month = 'month',
  Week = 'week'
}

export enum _Schedule {
  Absent = 'Absent',
  OverTime = 'OverTime',
  Paid = 'Paid',
  UnPaid = 'UnPaid'
}

export enum _SearchStatus {
  Active = 'Active',
  All = 'All',
  Disabled = 'Disabled',
  Expired = 'Expired',
  Scheduled = 'Scheduled'
}

export enum _TaskStatusEmums {
  Closed = 'closed',
  DueDate = 'due_date',
  InProgress = 'inProgress'
}

export type AccessoriesListFilter = {
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AccessoriesTypeEnum>;
};

export enum AccessoriesTypeEnum {
  Accessory = 'accessory',
  QuickAccessory = 'quickAccessory'
}

export type AccountTypeInput = {
  is_editable: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type AccuralDate = {
  __typename?: 'accuralDate';
  from_date?: Maybe<Scalars['Date']['output']>;
  to_date?: Maybe<Scalars['Date']['output']>;
};

export type AccuralHistoryListingInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AccuralHistoryListingResult = {
  __typename?: 'accuralHistoryListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<AccuralHistory>>>;
};

export enum ActionFeatureEnum {
  AssetContractExpiryForAssetManager = 'asset_contract_expiry_for_asset_manager',
  AssetMaintenanceDueForAssetManager = 'asset_maintenance_due_for_asset_manager',
  AssetPastDueDateForAssetManager = 'asset_past_due_date_for_asset_manager',
  AssetWarrantyExpiryForAssetManager = 'asset_warranty_expiry_for_asset_manager',
  AttendanceBreakExceedForEmployee = 'attendance_break_exceed_for_employee',
  AttendanceBreakExceedForManager = 'attendance_break_exceed_for_manager',
  AttendanceMissedPunchoutForEmployee = 'attendance_missed_punchout_for_employee',
  AttendanceMissedPunchoutForManager = 'attendance_missed_punchout_for_manager',
  AuthenticationAccountCreationForEmployee = 'authentication_account_creation_for_employee',
  AuthenticationEmailChangeForEmployee = 'authentication_email_change_for_employee',
  AuthenticationEmailVerificationForEmployee = 'authentication_email_verification_for_employee',
  AuthenticationForgotPasswordForEmployee = 'authentication_forgot_password_for_employee',
  AuthenticationPasswordChangeForEmployee = 'authentication_password_change_for_employee',
  AuthenticationSsnUpdateForEmployee = 'authentication_ssn_update_for_employee',
  EmployeeSeparationInitiationForEmployee = 'employee_separation_initiation_for_employee',
  GiftCardDeliveryForBusinessOwner = 'gift_card_delivery_for_business_owner',
  LmsQuizCreationForChecker = 'lms_quiz_creation_for_checker',
  LmsQuizCreationForEmployee = 'lms_quiz_creation_for_employee',
  LmsQuizReminderForChecker = 'lms_quiz_reminder_for_checker',
  LmsQuizReminderForEmployee = 'lms_quiz_reminder_for_employee',
  LmsTrainingCompletionForEmployee = 'lms_training_completion_for_employee',
  LmsTrainingCreationForEmployee = 'lms_training_creation_for_employee',
  SalaryAdjustmentForEmployee = 'salary_adjustment_for_employee',
  SalaryBackpayForEmployee = 'salary_backpay_for_employee',
  ScheduleReportCreationForEmployee = 'schedule_report_creation_for_employee',
  ScheduleReportDeletionForEmployee = 'schedule_report_deletion_for_employee',
  ScheduleReportUpdationForEmployee = 'schedule_report_updation_for_employee',
  ScheduleReportViewForEmployee = 'schedule_report_view_for_employee',
  ScheduleReportViewForManager = 'schedule_report_view_for_manager',
  TimesheetMultiDayReportForEmployee = 'timesheet_multi_day_report_for_employee',
  TimesheetMultiDayReportForManager = 'timesheet_multi_day_report_for_manager',
  TimesheetSingleDayReportForEmployee = 'timesheet_single_day_report_for_employee',
  TimesheetSingleDayReportForManager = 'timesheet_single_day_report_for_manager'
}

export enum ActionTypeEnum {
  Decrement = 'Decrement',
  Increment = 'Increment',
  Other = 'Other',
  Promotion = 'Promotion',
  ReJoin = 'ReJoin',
  Transfer = 'Transfer',
  Adjustment = 'adjustment'
}

export enum ActivityFor {
  EmployeeAction = 'EmployeeAction',
  NewEmployee = 'NewEmployee'
}

export enum Activity_Type {
  Multiple = 'multiple',
  RequestDocument = 'request_document',
  ViewDocument = 'view_document'
}

export type AddAppraisalScale = {
  name?: InputMaybe<Scalars['String']['input']>;
  scale_group?: InputMaybe<Array<InputMaybe<ScaleGroupInput>>>;
  total_score?: InputMaybe<Scalars['Int']['input']>;
};

export type AddAttachmentInput = {
  _id: Scalars['ID']['input'];
  attachments: Array<Scalars['Upload']['input']>;
};

export type AddDocument = {
  docRef?: InputMaybe<Scalars['Upload']['input']>;
  subject_to?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['String']['input']>;
};

export type AddDocumentInput = {
  activity_type?: InputMaybe<Activity_Type>;
  assign_to?: InputMaybe<AssignToInput>;
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  business?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  document_type?: InputMaybe<DocumentType>;
  google_drive_attachment?: InputMaybe<Scalars['String']['input']>;
  google_drive_id?: InputMaybe<Scalars['String']['input']>;
  is_choose_folder_allow?: InputMaybe<Scalars['Boolean']['input']>;
  is_document_submission_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_group?: InputMaybe<Scalars['Boolean']['input']>;
  is_hide_after_review?: InputMaybe<Scalars['Boolean']['input']>;
  is_sign_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_submission_required?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  validity?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AddEmployee = {
  addEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  employeeIds: Array<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
};

export type AddEmployeeIntoBusinessInput = {
  business_navigation_id: Scalars['ID']['input'];
  user_list: Array<InputMaybe<User_List_Input>>;
};

export type AddManualShortBreaksInput = {
  clockedHistoryId: Scalars['ID']['input'];
  short_break_detail?: InputMaybe<Array<InputMaybe<ShortBreakDetail>>>;
};

export type AddNewFolderDocumentControl = {
  bread_crum?: InputMaybe<Array<Scalars['ID']['input']>>;
  department?: InputMaybe<Scalars['ID']['input']>;
  employee?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  share_as?: InputMaybe<ShareDocumentroles>;
  type?: InputMaybe<AssignToEnums>;
};

export type AddSubTaskInput = {
  _id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type AddTerminalAppInput = {
  Business: Scalars['ID']['input'];
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  User?: InputMaybe<Scalars['ID']['input']>;
  authentication_type?: InputMaybe<Scalars['String']['input']>;
  device_name: Scalars['String']['input'];
  device_version?: InputMaybe<Scalars['String']['input']>;
  ip_address: Scalars['String']['input'];
  is_authenticated?: InputMaybe<Scalars['Boolean']['input']>;
  linked_at?: InputMaybe<Scalars['String']['input']>;
  mac_address?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DeviceStatusEnum>;
};

export type AddTerminalAppType = {
  __typename?: 'addTerminalAppType';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  User?: Maybe<User>;
  authentication_type?: Maybe<Scalars['String']['output']>;
  device_name?: Maybe<Scalars['String']['output']>;
  device_version?: Maybe<Scalars['String']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  is_authenticated?: Maybe<Scalars['Boolean']['output']>;
  linked_at?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AdjustLeaveBalanceInput = {
  employee_id: Scalars['ID']['input'];
  opening_balance: Array<LeaveAdjustmentInput>;
};

export type Adjustment_Detail = {
  __typename?: 'adjustment_detail';
  adjusted_amount?: Maybe<Scalars['Float']['output']>;
  adjusted_at?: Maybe<Scalars['DateTime']['output']>;
  adjusted_by?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  is_credit?: Maybe<Scalars['Boolean']['output']>;
};

export type AdvanceFilter = {
  __typename?: 'advanceFilter';
  Business?: Maybe<Business>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  filter_name?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<Maybe<ListingFiltersType>>>;
  list_type?: Maybe<Scalars['String']['output']>;
};

export type AlertData = {
  __typename?: 'alertData';
  date?: Maybe<Scalars['String']['output']>;
  isLeaveApplied?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  schedule_not_found?: Maybe<Scalars['Boolean']['output']>;
};

export type AlertListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AlertListingResult = {
  __typename?: 'alertListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Alert>>>;
};

export type AllAssigneeTasksInput = {
  assign: AssignEnum;
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  priority?: InputMaybe<PriorityEmums>;
  search?: InputMaybe<Scalars['String']['input']>;
  status: TaskStatus;
  team_member?: InputMaybe<Scalars['ID']['input']>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AllCategories = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AllCategoriesList = {
  __typename?: 'allCategoriesList';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<QuizCategory>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type AllDesignationListingresult = {
  __typename?: 'allDesignationListingresult';
  result?: Maybe<Array<Maybe<Designation>>>;
};

export type AllDiscountInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AllDocumentListingResult = {
  __typename?: 'allDocumentListingResult';
  config?: Maybe<DataTableConfig>;
  countpendingRequest?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<DocumentControlAttachmenttWithData>>>;
};

export type AllDocumentsDataTableResult = {
  __typename?: 'allDocumentsDataTableResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
};

export type AllDocumentsResult = {
  __typename?: 'allDocumentsResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type AllMyTasksInput = {
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterTask>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<PriorityEmums>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskStatusUpdateEmums>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AllShareDocumentResults = {
  __typename?: 'allShareDocumentResults';
  departments?: Maybe<Array<Maybe<ShareFilteredResults>>>;
  employees?: Maybe<Array<Maybe<ShareFilteredResults>>>;
  roles?: Maybe<Array<Maybe<ShareFilteredResults>>>;
};

export type AllTasksInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  date?: InputMaybe<Scalars['Int']['input']>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
  team_member?: InputMaybe<Scalars['ID']['input']>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AllTasksListingResult = {
  __typename?: 'allTasksListingResult';
  config?: Maybe<DataTableConfig>;
  data?: Maybe<Array<Maybe<TaskManagementWithData>>>;
};

export type AllowanceFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AllowanceResult = {
  __typename?: 'allowanceResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Allowance>>>;
};

export type Allowances_Deductions = {
  __typename?: 'allowances_deductions';
  amount?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export enum AnimationSpeedEnum {
  Fast = 'fast',
  Medium = 'medium',
  Slow = 'slow'
}

export enum AppName {
  Terminal = 'terminal',
  User = 'user'
}

export enum AppType {
  Android = 'android',
  Ios = 'ios'
}

export enum AppTypes {
  TerminalApp = 'terminal_app',
  UserApp = 'user_app'
}

export type AppVersionInput = {
  app_name: AppName;
  app_type: AppType;
  app_version: Scalars['String']['input'];
};

export enum ApplicableEnum {
  Accessories = 'Accessories',
  Devices = 'Devices',
  Parts = 'Parts',
  Services = 'Services'
}

export enum Application_Type {
  TerminalApp = 'terminal_app',
  UserApp = 'user_app'
}

export type AppraisalEvaluation = {
  __typename?: 'appraisalEvaluation';
  ApraisalObjectiveAssignmnet?: Maybe<ObjectiveAssignment>;
  Business?: Maybe<Business>;
  PerformanceCycle?: Maybe<PerformanceCycleType>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  assignTo?: Maybe<User>;
  created_by?: Maybe<User>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  designation?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<EmployeeDetail>;
  end_date?: Maybe<Scalars['Date']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  listProjects?: Maybe<Scalars['String']['output']>;
  milestone?: Maybe<Scalars['String']['output']>;
  objectiveAssigned?: Maybe<Array<Maybe<Objective_Assigned>>>;
  performanceGoals?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  road_map?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_score?: Maybe<Scalars['Float']['output']>;
  trainingRequired?: Maybe<Scalars['Boolean']['output']>;
  updated_by?: Maybe<User>;
  weight_percent?: Maybe<Scalars['Float']['output']>;
};

export type AppraisalEvaluationResult = {
  __typename?: 'appraisalEvaluationResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<AppraisalEvaluation>>>;
};

export type AppraisalObjectiveResult = {
  __typename?: 'appraisalObjectiveResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<AppraisalObjecive>>>;
};

export type AppraisalResult = {
  __typename?: 'appraisalResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<AppraisalType>>>;
};

export type AppraisalScale = {
  __typename?: 'appraisalScale';
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_by?: Maybe<User>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  is_custom_grade?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scale_group?: Maybe<Array<Maybe<ScaleGroup>>>;
  total_score?: Maybe<Scalars['Int']['output']>;
  updated_by?: Maybe<User>;
};

export type AppraisalScaleResult = {
  __typename?: 'appraisalScaleResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<AppraisalScale>>>;
};

export type AppraisalSettingInput = {
  AppraisalScale?: InputMaybe<Scalars['ID']['input']>;
  AppraisalType?: InputMaybe<Scalars['ID']['input']>;
  assign_by?: InputMaybe<Scalars['ID']['input']>;
  objective?: InputMaybe<Scalars['Int']['input']>;
  weight_percent?: InputMaybe<Scalars['Float']['input']>;
};

export type AppraisalSettingType = {
  __typename?: 'appraisalSettingType';
  AppraisalScale?: Maybe<AppraisalScale>;
  AppraisalType?: Maybe<AppraisalType>;
  assign_by?: Maybe<User>;
  attendanceStatus?: Maybe<Array<Maybe<AttendanceStatusType>>>;
  objective?: Maybe<Scalars['Int']['output']>;
  task?: Maybe<Array<Maybe<TaskType>>>;
  weight_percent?: Maybe<Scalars['Float']['output']>;
};

export type AppraiserSettingInput = {
  AppraisalType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  User?: InputMaybe<Scalars['ID']['input']>;
  appraiser_type?: InputMaybe<Scalars['String']['input']>;
  weight_percent?: InputMaybe<Scalars['Float']['input']>;
};

export type AppraiserSettingType = {
  __typename?: 'appraiserSettingType';
  AppraisalType?: Maybe<Array<Maybe<AppraisalType>>>;
  User?: Maybe<User>;
  appraiser_type?: Maybe<Scalars['String']['output']>;
  weight_percent?: Maybe<Scalars['Float']['output']>;
};

export type Approval = {
  __typename?: 'approval';
  approvalAttendance?: Maybe<Scalars['Int']['output']>;
  approvalExpense?: Maybe<Scalars['Int']['output']>;
  approvalLeave?: Maybe<Scalars['Int']['output']>;
  approvalLoan?: Maybe<Scalars['Int']['output']>;
  approvalWriteUp?: Maybe<Scalars['Int']['output']>;
};

export enum ApprovalTo {
  ApprovalFromLineManager = 'approval_from_lineManager',
  ApprovalToEmployee = 'approval_to_employee'
}

export enum ArchiveEnum {
  Active = 'active',
  Inactive = 'inactive'
}

export type ArchiveInput = {
  archive: Scalars['Boolean']['input'];
  attendance_date: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

export type ArchiveInvoiceInput = {
  archive: Scalars['Boolean']['input'];
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ArchiveMedicalInsuranceInput = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  medical_insurance_id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ArchiveMedicalInsurancepackageInput = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  medical_insurance_package_id?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ArchiveRoleData = {
  deleteType: DeletedType;
  id: Scalars['ID']['input'];
};

export type ArchiveRosterByTypeInput = {
  _id: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ArchiveRosterInput = {
  deleteType?: InputMaybe<Scalars['String']['input']>;
  empid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  scheduleDate?: InputMaybe<Scalars['String']['input']>;
};

export type ArchivedDocumentInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ArchivedEmployees = {
  __typename?: 'archivedEmployees';
  archived?: Maybe<Array<Maybe<User>>>;
  clockedIn?: Maybe<Array<Maybe<User>>>;
};

export type ArchivedIds = {
  __typename?: 'archivedIds';
  DeletedParentDocument?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  archived?: Maybe<Scalars['Boolean']['output']>;
};

export type AssetAlert = {
  __typename?: 'assetAlert';
  completed?: Maybe<Scalars['Int']['output']>;
  contract?: Maybe<Scalars['Int']['output']>;
  disposed?: Maybe<Scalars['Int']['output']>;
  inProgress?: Maybe<Scalars['Int']['output']>;
  insurance?: Maybe<Scalars['Int']['output']>;
  leased?: Maybe<Scalars['Int']['output']>;
  maintenance?: Maybe<Scalars['Int']['output']>;
  onHold?: Maybe<Scalars['Int']['output']>;
  pastDue?: Maybe<Scalars['Int']['output']>;
  reserved?: Maybe<Scalars['Int']['output']>;
  scheduled?: Maybe<Scalars['Int']['output']>;
  scrap?: Maybe<Scalars['Int']['output']>;
  trashed?: Maybe<Scalars['Int']['output']>;
  warranty?: Maybe<Scalars['Int']['output']>;
};

export type AssetBranAndModel = {
  __typename?: 'assetBranAndModel';
  Business?: Maybe<Business>;
  _id?: Maybe<Scalars['ID']['output']>;
  asset_count?: Maybe<Scalars['Int']['output']>;
  brand_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<User>;
  deleted_by?: Maybe<User>;
  detail?: Maybe<AssetModelExtendView>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  model_counts?: Maybe<Scalars['Int']['output']>;
  updated_by?: Maybe<User>;
};

export type AssetCount = {
  __typename?: 'assetCount';
  allAssets?: Maybe<Scalars['Int']['output']>;
  assigned?: Maybe<Scalars['Int']['output']>;
  disposed?: Maybe<Scalars['Int']['output']>;
  maintenance?: Maybe<Scalars['Int']['output']>;
  reserved?: Maybe<Scalars['Int']['output']>;
  unAssigned?: Maybe<Scalars['Int']['output']>;
};

export type AssetIds = {
  id?: InputMaybe<Scalars['ID']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AssetListFilter = {
  assetColumns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  filterAsset?: InputMaybe<FilterAsset>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  is_report?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AssetTypeInputEnum>;
};

export type AssetListingResult = {
  __typename?: 'assetListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Asset>>>;
};

export type AssetModelExtendView = {
  __typename?: 'assetModelExtendView';
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<AssetModel>>>;
};

export enum AssetTypeEnum {
  Accessory = 'accessory',
  Asset = 'asset'
}

export enum AssetTypeInputEnum {
  Asset = 'asset',
  QuickAsset = 'quickAsset'
}

export type Assets = {
  __typename?: 'assets';
  allAssets?: Maybe<Scalars['Int']['output']>;
  assigned?: Maybe<Scalars['Int']['output']>;
  disposed?: Maybe<Scalars['Int']['output']>;
  maintenance?: Maybe<Scalars['Int']['output']>;
  reserved?: Maybe<Scalars['Int']['output']>;
  unAssigned?: Maybe<Scalars['Int']['output']>;
};

export type AssetsListingResult = {
  __typename?: 'assetsListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Asset>>>;
};

export type AssignCategorySectionType = {
  __typename?: 'assignCategorySectionType';
  QuizCategory?: Maybe<QuizCategory>;
  section_questions: Array<AssignQuestionSectionType>;
};

export enum AssignEnum {
  AssignToMe = 'assign_to_me',
  AssignedByMe = 'assigned_by_me',
  MyTasks = 'my_tasks'
}

export type AssignInput = {
  employee_id: Scalars['ID']['input'];
  employees: Array<Scalars['ID']['input']>;
  end_date: Scalars['DateTime']['input'];
  start_date: Scalars['DateTime']['input'];
};

export type AssignLeavePolicyInput = {
  _id: Scalars['ID']['input'];
  assign_to: Array<AssignToPolicyInput>;
};

export type AssignRoleInput = {
  employees: Array<Scalars['ID']['input']>;
  role: Scalars['ID']['input'];
};

export enum AssignToEnums {
  Department = 'Department',
  Employees = 'Employees',
  Roles = 'Roles'
}

export type AssignToInput = {
  assignee?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  roles?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<AssignToEnums>;
};

export type AssignToMeTaskResult = {
  __typename?: 'assignToMeTaskResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TaskManagement>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type AssignToPolicyInput = {
  employee: Scalars['ID']['input'];
  extra_taken: Scalars['Float']['input'];
  is_unpaid: Scalars['Boolean']['input'];
  pto_minutes?: InputMaybe<Pto_MinutesType_Input>;
  time_off: Array<TimeOffEmployeeInput>;
};

export type AssignToType = {
  __typename?: 'assignToType';
  assignee?: Maybe<Array<Maybe<User>>>;
  department?: Maybe<Department>;
  roles?: Maybe<Array<Maybe<Role>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AssignUsersToQuizAndTrainingInput = {
  Department?: InputMaybe<Array<Scalars['ID']['input']>>;
  Role?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignTo: Array<Scalars['ID']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  evaluate_by: Array<Scalars['ID']['input']>;
  quiz_extended_days?: InputMaybe<Scalars['Int']['input']>;
  started_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum AssignedType {
  Department = 'department',
  Employee = 'employee',
  Other = 'other',
  Site = 'site'
}

export type AssigneeTaskListingResult = {
  __typename?: 'assigneeTaskListingResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<TaskManagement>>>;
};

export type AssigneeTaskResult = {
  __typename?: 'assigneeTaskResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TaskManagement>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type AssinByMeTaskResult = {
  __typename?: 'assinByMeTaskResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TaskManagement>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type AsssignAssetResult = {
  __typename?: 'asssignAssetResult';
  accessories?: Maybe<Array<Maybe<Asset>>>;
  assets?: Maybe<Array<Maybe<Asset>>>;
};

export type AttachmentListingResult = {
  __typename?: 'attachmentListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Attachment>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type AttandencePolicy = {
  __typename?: 'attandencePolicy';
  AttendancePolicy?: Maybe<AttandencePolicy>;
  Business?: Maybe<Business>;
  How_are_leaves_deducted?: Maybe<Scalars['String']['output']>;
  RecurrenceRule?: Maybe<Scalars['String']['output']>;
  _id?: Maybe<Scalars['ID']['output']>;
  apply_penalty_employee_daily_salary?: Maybe<Scalars['Int']['output']>;
  attendance_after_days?: Maybe<Scalars['Int']['output']>;
  attendance_rule?: Maybe<Scalars['String']['output']>;
  attendance_rule_effective_from?: Maybe<Scalars['DateTime']['output']>;
  base?: Maybe<Scalars['String']['output']>;
  before_early_clockin?: Maybe<Scalars['Int']['output']>;
  block_employee_account_after?: Maybe<Scalars['Int']['output']>;
  block_employee_account_after_days?: Maybe<Scalars['Int']['output']>;
  block_employee_default_message?: Maybe<Scalars['String']['output']>;
  block_user?: Maybe<Scalars['Boolean']['output']>;
  block_user_acount_number_breaks?: Maybe<Scalars['Int']['output']>;
  break_deduct_salary_for_every_minuts?: Maybe<Scalars['Int']['output']>;
  break_deduct_salary_for_every_per_minuts?: Maybe<Scalars['Int']['output']>;
  break_grace_period?: Maybe<Scalars['Boolean']['output']>;
  break_modify_message?: Maybe<Scalars['String']['output']>;
  breaks?: Maybe<Scalars['String']['output']>;
  clock_out_grace_period?: Maybe<Scalars['Boolean']['output']>;
  deafult_message_earlyOut?: Maybe<Scalars['Boolean']['output']>;
  deafult_missing_attendance_message?: Maybe<Scalars['Boolean']['output']>;
  deduct_annually_minuts?: Maybe<Scalars['Int']['output']>;
  deduct_days?: Maybe<Scalars['Int']['output']>;
  deduct_days_of_leave_incidents?: Maybe<Scalars['Int']['output']>;
  deduct_leave?: Maybe<Scalars['Int']['output']>;
  deduct_salary_for_every?: Maybe<Scalars['Int']['output']>;
  deduct_salary_for_every_per_minuts?: Maybe<Scalars['Int']['output']>;
  deduction_based?: Maybe<Scalars['String']['output']>;
  default_message_early?: Maybe<Scalars['Boolean']['output']>;
  department?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  detail?: Maybe<EmployeeDetail>;
  earlyOut_deduct_based_on?: Maybe<Scalars['String']['output']>;
  earlyOut_deduct_salary_incidents?: Maybe<Scalars['Boolean']['output']>;
  earlyOut_maximum_early_time?: Maybe<Scalars['Int']['output']>;
  early_clockin?: Maybe<Scalars['Boolean']['output']>;
  employeeIds?: Maybe<Scalars['Int']['output']>;
  employee_type?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  employesCount?: Maybe<Scalars['Int']['output']>;
  employesId?: Maybe<Array<Maybe<User>>>;
  for_every_incidents_late_coming?: Maybe<Scalars['Int']['output']>;
  grace_period?: Maybe<Scalars['Int']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  hours_penalize_deduct_leave?: Maybe<Scalars['Boolean']['output']>;
  is_auto_clocked_in?: Maybe<Scalars['Boolean']['output']>;
  is_auto_miss_punch_writeup?: Maybe<Scalars['Boolean']['output']>;
  is_clocked_in_from_app?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_email_for_miss_punch?: Maybe<Scalars['Boolean']['output']>;
  is_email_to_employee?: Maybe<Scalars['Boolean']['output']>;
  is_email_to_line_manager?: Maybe<Scalars['Boolean']['output']>;
  is_exclude_grace_time_in_working_hours?: Maybe<Scalars['Boolean']['output']>;
  is_paid_for_extra_time?: Maybe<Scalars['Boolean']['output']>;
  is_paid_weekend?: Maybe<Scalars['Boolean']['output']>;
  is_un_restricted?: Maybe<Scalars['Boolean']['output']>;
  is_weekend_mode?: Maybe<Scalars['Boolean']['output']>;
  is_weekend_premium_after_limit?: Maybe<Scalars['Boolean']['output']>;
  is_weekend_premium_before_limit?: Maybe<Scalars['Boolean']['output']>;
  lateOut_maximum_late_time?: Maybe<Scalars['Int']['output']>;
  lateOut_message?: Maybe<Scalars['Boolean']['output']>;
  lateOut_message_late_time?: Maybe<Scalars['String']['output']>;
  late_clockin?: Maybe<Scalars['Boolean']['output']>;
  late_clockin_deduction?: Maybe<Scalars['String']['output']>;
  late_coming_incidents?: Maybe<Scalars['String']['output']>;
  maximum_absent_modify_message?: Maybe<Scalars['String']['output']>;
  maximum_emp_absent?: Maybe<Scalars['Boolean']['output']>;
  maximum_emp_message?: Maybe<Scalars['Boolean']['output']>;
  maximum_emp_time?: Maybe<Scalars['Int']['output']>;
  maximum_late_modify_message?: Maybe<Scalars['String']['output']>;
  maximum_late_time?: Maybe<Scalars['Boolean']['output']>;
  maximum_late_time_deduction_after_minutes?: Maybe<Scalars['Int']['output']>;
  maximum_late_time_message?: Maybe<Scalars['Boolean']['output']>;
  maximum_no_days?: Maybe<Scalars['Int']['output']>;
  messge_earlyOut?: Maybe<Scalars['String']['output']>;
  minuts_period_break_in_out?: Maybe<Scalars['Int']['output']>;
  missing_attendance_message?: Maybe<Scalars['String']['output']>;
  modify_message_early?: Maybe<Scalars['String']['output']>;
  over_time_hours?: Maybe<Scalars['Int']['output']>;
  over_time_rate?: Maybe<Scalars['Float']['output']>;
  overtime?: Maybe<Scalars['String']['output']>;
  overtime_by_employeeType?: Maybe<Scalars['String']['output']>;
  paunch_out_mnts?: Maybe<Scalars['Int']['output']>;
  pay_type?: Maybe<PayrollSchedule>;
  penalize_deduct_leave?: Maybe<Scalars['Boolean']['output']>;
  percentage_Base?: Maybe<Scalars['String']['output']>;
  percentage_base_no_of_days?: Maybe<Scalars['Int']['output']>;
  percentage_base_percentage_of_hourse?: Maybe<Scalars['Float']['output']>;
  plenty_base?: Maybe<Scalars['String']['output']>;
  repeat?: Maybe<Scalars['String']['output']>;
  send_absent_email_to_line_manager?: Maybe<Scalars['Boolean']['output']>;
  send_break_email_to_employee?: Maybe<Scalars['Boolean']['output']>;
  send_break_email_to_line_manager?: Maybe<Scalars['Boolean']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_hours?: Maybe<Scalars['Int']['output']>;
  wagebased?: Maybe<Scalars['Boolean']['output']>;
  wagebased_on?: Maybe<Scalars['String']['output']>;
  weekEndDays?: Maybe<Array<Maybe<WeekEndDaysRetun>>>;
  week_number?: Maybe<Scalars['Int']['output']>;
  working_days?: Maybe<Scalars['Int']['output']>;
};

export type AttandencePolicyListFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type AttandencePolicyUpdate = {
  Business?: InputMaybe<Scalars['String']['input']>;
  How_are_leaves_deducted?: InputMaybe<Scalars['String']['input']>;
  apply_penalty_employee_daily_salary?: InputMaybe<Scalars['Int']['input']>;
  attendance_after_days?: InputMaybe<Scalars['Int']['input']>;
  attendance_rule?: InputMaybe<Scalars['String']['input']>;
  base?: InputMaybe<Scalars['String']['input']>;
  before_early_clockin?: InputMaybe<Scalars['Int']['input']>;
  block_employee_account_after?: InputMaybe<Scalars['Int']['input']>;
  block_employee_account_after_days?: InputMaybe<Scalars['Int']['input']>;
  block_employee_default_message?: InputMaybe<Scalars['String']['input']>;
  block_user?: InputMaybe<Scalars['Boolean']['input']>;
  block_user_acount_number_breaks?: InputMaybe<Scalars['Int']['input']>;
  break_deduct_salary_for_every_minuts?: InputMaybe<Scalars['Int']['input']>;
  break_deduct_salary_for_every_per_minuts?: InputMaybe<Scalars['Int']['input']>;
  break_grace_period?: InputMaybe<Scalars['Boolean']['input']>;
  break_modify_message?: InputMaybe<Scalars['String']['input']>;
  breaks?: InputMaybe<Scalars['String']['input']>;
  clock_out_grace_period?: InputMaybe<Scalars['Boolean']['input']>;
  deafult_message_earlyOut?: InputMaybe<Scalars['Boolean']['input']>;
  deafult_missing_attendance_message?: InputMaybe<Scalars['Boolean']['input']>;
  deduct_annually_minuts?: InputMaybe<Scalars['Int']['input']>;
  deduct_days?: InputMaybe<Scalars['Int']['input']>;
  deduct_days_of_leave_incidents?: InputMaybe<Scalars['Int']['input']>;
  deduct_leave?: InputMaybe<Scalars['Boolean']['input']>;
  deduct_leave_time?: InputMaybe<Scalars['String']['input']>;
  deduct_salary_for_every?: InputMaybe<Scalars['Int']['input']>;
  deduct_salary_for_every_per_minuts?: InputMaybe<Scalars['Int']['input']>;
  deduction_based?: InputMaybe<Scalars['String']['input']>;
  default_message_early?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  earlyOut_deduct_based_on?: InputMaybe<Scalars['String']['input']>;
  earlyOut_deduct_salary_incidents?: InputMaybe<Scalars['Boolean']['input']>;
  earlyOut_maximum_early_time?: InputMaybe<Scalars['Int']['input']>;
  early_clockin?: InputMaybe<Scalars['Boolean']['input']>;
  employee_type?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employesId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  for_every_incidents_late_coming?: InputMaybe<Scalars['Int']['input']>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  grace_period?: InputMaybe<Scalars['Int']['input']>;
  group_name?: InputMaybe<Scalars['String']['input']>;
  hours_penalize_deduct_leave?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  is_auto_clocked_in?: InputMaybe<Scalars['Boolean']['input']>;
  is_auto_miss_punch_writeup?: InputMaybe<Scalars['Boolean']['input']>;
  is_clocked_in_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_email_to_employee?: InputMaybe<Scalars['Boolean']['input']>;
  is_email_to_line_manager?: InputMaybe<Scalars['Boolean']['input']>;
  is_exclude_grace_time_in_working_hours?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid_for_extra_time?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid_weekend?: InputMaybe<Scalars['Boolean']['input']>;
  is_un_restricted: Scalars['Boolean']['input'];
  is_weekend_mode: Scalars['Boolean']['input'];
  is_weekend_premium_after_limit?: InputMaybe<Scalars['Boolean']['input']>;
  is_weekend_premium_before_limit?: InputMaybe<Scalars['Boolean']['input']>;
  lateOut_maximum_late_time?: InputMaybe<Scalars['Int']['input']>;
  lateOut_message?: InputMaybe<Scalars['Boolean']['input']>;
  lateOut_message_late_time?: InputMaybe<Scalars['String']['input']>;
  late_clockin?: InputMaybe<Scalars['Boolean']['input']>;
  late_clockin_deduction?: InputMaybe<Scalars['String']['input']>;
  late_coming_incidents?: InputMaybe<Scalars['String']['input']>;
  maximum_absent_modify_message?: InputMaybe<Scalars['String']['input']>;
  maximum_emp_absent?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_emp_message?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_emp_time?: InputMaybe<Scalars['Int']['input']>;
  maximum_late_modify_message?: InputMaybe<Scalars['String']['input']>;
  maximum_late_time?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_late_time_deduction_after_minutes?: InputMaybe<Scalars['Int']['input']>;
  maximum_late_time_message?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_no_days?: InputMaybe<Scalars['Int']['input']>;
  messge_earlyOut?: InputMaybe<Scalars['String']['input']>;
  minuts_period_break_in_out?: InputMaybe<Scalars['Int']['input']>;
  missing_attendance_message?: InputMaybe<Scalars['String']['input']>;
  modify_message_early?: InputMaybe<Scalars['String']['input']>;
  over_time_hours?: InputMaybe<Scalars['Int']['input']>;
  over_time_rate?: InputMaybe<Scalars['Float']['input']>;
  overtime?: InputMaybe<Scalars['String']['input']>;
  overtime_by_employeeType?: InputMaybe<Scalars['String']['input']>;
  paunch_out_mnts?: InputMaybe<Scalars['Int']['input']>;
  pay_type: Scalars['ID']['input'];
  penalize_deduct_leave?: InputMaybe<Scalars['Boolean']['input']>;
  percentage_Base?: InputMaybe<Scalars['String']['input']>;
  percentage_base_no_of_days?: InputMaybe<Scalars['Int']['input']>;
  percentage_base_percentage_of_hourse?: InputMaybe<Scalars['Int']['input']>;
  plenty_base?: InputMaybe<Scalars['String']['input']>;
  send_absent_email_to_line_manager?: InputMaybe<Scalars['Boolean']['input']>;
  send_break_email_to_employee?: InputMaybe<Scalars['Boolean']['input']>;
  send_break_email_to_line_manager?: InputMaybe<Scalars['Boolean']['input']>;
  wagebased?: InputMaybe<Scalars['Boolean']['input']>;
  wagebased_on?: InputMaybe<Scalars['String']['input']>;
  weekEndDays?: InputMaybe<Array<InputMaybe<WeekEndDays>>>;
  working_days?: InputMaybe<Scalars['Int']['input']>;
};

export type AttendanceFilter = {
  attendance_date?: InputMaybe<Scalars['DateTime']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum AttendanceFilters {
  Absent = 'Absent',
  All = 'All',
  Archive = 'Archive',
  Block = 'Block',
  EarlyOut = 'EarlyOut',
  LateArrival = 'LateArrival',
  LateOut = 'LateOut',
  Present = 'Present',
  ShortTime = 'ShortTime',
  Leave = 'leave',
  PublicHoliday = 'publicHoliday'
}

export type AttendanceListExtendedresult = {
  __typename?: 'attendanceListExtendedresult';
  config?: Maybe<UpdatedDataTableConfig>;
  data?: Maybe<Array<Maybe<AttandencePolicy>>>;
};

export type AttendanceListFilter = {
  business?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status: AttendancePolicyStatusFilter;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AttendanceListFilters = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AttendanceFilters>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AttendanceListWithStatus = {
  employee?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<AttendanceWithStatus>;
  store_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AttendanceListingResult = {
  __typename?: 'attendanceListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Attendance>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type AttendanceListingresult = {
  __typename?: 'attendanceListingresult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<AttandencePolicy>>>;
};

export type AttendanceLogDetail = {
  __typename?: 'attendanceLogDetail';
  clock_in_time?: Maybe<Scalars['String']['output']>;
  clock_out_time?: Maybe<Scalars['String']['output']>;
  clockedInStatus?: Maybe<Scalars['String']['output']>;
  clockedOutStatus?: Maybe<Scalars['String']['output']>;
  is_un_restricted?: Maybe<Scalars['Boolean']['output']>;
  logged_hours?: Maybe<Scalars['String']['output']>;
  logged_minutes?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  wages?: Maybe<Scalars['Float']['output']>;
};

export type AttendanceLogDetailInput = {
  clock_in_time?: InputMaybe<Scalars['String']['input']>;
  clock_out_time?: InputMaybe<Scalars['String']['input']>;
  clockedInStatus?: InputMaybe<AttendanceWithStatus>;
  clockedOutStatus?: InputMaybe<AttendanceWithStatus>;
};

export type AttendanceResult = {
  __typename?: 'attendanceResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<AttendanceRegulation>>>;
};

export enum AttendanceStatus {
  EarlyClockin = 'EarlyClockin',
  LateArrival = 'LateArrival',
  Absent = 'absent',
  Accepted = 'accepted',
  EarlyClockedOut = 'earlyClockedOut',
  LateOut = 'lateOut',
  OnLeave = 'onLeave',
  Present = 'present',
  Rejected = 'rejected'
}

export type AttendanceStatusType = {
  __typename?: 'attendanceStatusType';
  Clockin?: Maybe<Scalars['Float']['output']>;
  EarlyBreak?: Maybe<Scalars['Float']['output']>;
  GraceLateBreak?: Maybe<Scalars['Float']['output']>;
  LateBreak?: Maybe<Scalars['Float']['output']>;
  LateOutBreak?: Maybe<Scalars['Float']['output']>;
  WritupEarlyOut?: Maybe<Scalars['Float']['output']>;
  WritupLateIn?: Maybe<Scalars['Float']['output']>;
  WritupLateOut?: Maybe<Scalars['Float']['output']>;
  WritupMisspunchout?: Maybe<Scalars['Float']['output']>;
  absent?: Maybe<Scalars['Int']['output']>;
  attendenceHours?: Maybe<Scalars['Float']['output']>;
  block?: Maybe<Scalars['Float']['output']>;
  breakIn?: Maybe<Scalars['Float']['output']>;
  breakOut?: Maybe<Scalars['Float']['output']>;
  clockHistoryCount?: Maybe<Scalars['Float']['output']>;
  earlyIn?: Maybe<Scalars['Int']['output']>;
  earlyOut?: Maybe<Scalars['Int']['output']>;
  late?: Maybe<Scalars['Int']['output']>;
  lateOut?: Maybe<Scalars['Int']['output']>;
  lateness?: Maybe<Scalars['Int']['output']>;
  leave?: Maybe<Scalars['Int']['output']>;
  onTime?: Maybe<Scalars['Int']['output']>;
  onTimeOut?: Maybe<Scalars['Int']['output']>;
  present?: Maybe<Scalars['Int']['output']>;
  totalHours?: Maybe<Scalars['Float']['output']>;
  total_hours_logged?: Maybe<Scalars['Float']['output']>;
};

export enum AttendanceWithStatus {
  Absent = 'Absent',
  All = 'All',
  Block = 'Block',
  EarlyArrival = 'EarlyArrival',
  EarlyOut = 'EarlyOut',
  LateArrival = 'LateArrival',
  LateOut = 'LateOut',
  MissPaunchOut = 'MissPaunchOut',
  OnTimeOut = 'OnTimeOut',
  Present = 'Present',
  ShortLeave = 'ShortLeave',
  ShortTime = 'ShortTime',
  Leave = 'leave',
  NotComing = 'notComing',
  OnTime = 'onTime',
  PaidLeave = 'paidLeave',
  PublicHoliday = 'publicHoliday',
  UnpaidLeave = 'unpaidLeave',
  Weekend = 'weekend'
}

export type AuthenticatorAppInfo = {
  __typename?: 'authenticatorAppInfo';
  label?: Maybe<Scalars['String']['output']>;
  qr_url?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
};

export type AuthenticorResult = {
  __typename?: 'authenticorResult';
  authentictorsEmployees?: Maybe<Array<Maybe<User>>>;
  unAuthentictorsEmployees?: Maybe<Array<Maybe<User>>>;
};

export type BackPayInput = {
  action_type: BackPayType;
  basic_salary?: InputMaybe<Scalars['Float']['input']>;
  employee: Scalars['ID']['input'];
  employee_group: Scalars['ID']['input'];
  employee_type: Scalars['String']['input'];
  from_date: Scalars['String']['input'];
  is_email_notify?: InputMaybe<Scalars['Boolean']['input']>;
  is_pay_now: Scalars['Boolean']['input'];
  is_update_timesheet: Scalars['Boolean']['input'];
  over_time_rate?: InputMaybe<Scalars['Float']['input']>;
  pay_schedule: Scalars['ID']['input'];
  public_day_hourly_salary?: InputMaybe<Scalars['Float']['input']>;
  salary_type: EmployeeType;
  to_date?: InputMaybe<Scalars['String']['input']>;
  total_week_hours?: InputMaybe<Scalars['Int']['input']>;
  weekend_day_salary?: InputMaybe<Scalars['Float']['input']>;
  weekly_hourly_salary?: InputMaybe<Scalars['Float']['input']>;
};

export enum BackPayType {
  Increment = 'increment'
}

export type Billing_Details = {
  __typename?: 'billing_details';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BrandList = {
  __typename?: 'brandList';
  config?: Maybe<UpdatedDataTableConfig>;
  data?: Maybe<Array<Maybe<AssetBranAndModel>>>;
};

export type BrandResult = {
  __typename?: 'brandResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Brand>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type BreakDetail = {
  break_duration: Scalars['Int']['input'];
  break_end_time?: InputMaybe<Scalars['String']['input']>;
  break_start_time?: InputMaybe<Scalars['String']['input']>;
  break_type: Scalars['ID']['input'];
  is_break_start_time: Scalars['Boolean']['input'];
};

export type BreakDetailType = {
  __typename?: 'breakDetailType';
  break_duration?: Maybe<Scalars['Int']['output']>;
  break_end_time?: Maybe<Scalars['String']['output']>;
  break_start_time?: Maybe<Scalars['String']['output']>;
  break_type?: Maybe<MasterDataValue>;
  is_break_start_time?: Maybe<Scalars['Boolean']['output']>;
};

export type BreakIn = {
  __typename?: 'breakIn';
  previous_state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type BreakLogs = {
  __typename?: 'breakLogs';
  break_id?: Maybe<MasterDataValue>;
  break_in?: Maybe<BreakIn>;
  break_name?: Maybe<Scalars['String']['output']>;
  break_out?: Maybe<BreakOut>;
};

export type BreakOut = {
  __typename?: 'breakOut';
  previous_state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type BreakTime = {
  __typename?: 'breakTime';
  breakName?: Maybe<Scalars['String']['output']>;
  breakType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

export type Break_Details = {
  __typename?: 'break_details';
  breakID?: Maybe<Scalars['String']['output']>;
  breakType?: Maybe<Scalars['String']['output']>;
  breakTypeID?: Maybe<Scalars['String']['output']>;
  break_in_time?: Maybe<Scalars['String']['output']>;
};

export type Breaks = {
  breakId: Scalars['ID']['input'];
  breakName: Scalars['String']['input'];
  breakType: Scalars['String']['input'];
  break_duration: Scalars['Int']['input'];
  break_in_time?: InputMaybe<Scalars['String']['input']>;
  break_out_time?: InputMaybe<Scalars['String']['input']>;
  minimum_break_percentage?: InputMaybe<Scalars['Int']['input']>;
};

export type BuinsessLocationlistingResult = {
  __typename?: 'buinsessLocationlistingResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<BusinessLocation>>>;
};

export type BuinsesslistingResult = {
  __typename?: 'buinsesslistingResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<Business>>>;
};

export type BulkSharePasswordInput = {
  employeeId: Scalars['ID']['input'];
  passwords?: InputMaybe<Array<InputMaybe<AppPasswordInput>>>;
};

export type BusinessListFilter = {
  businessType?: InputMaybe<AllowBusinessType>;
  business_id?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessLocationListFilter = {
  business_id: Scalars['ID']['input'];
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  store_type?: InputMaybe<StoreTypeEnum>;
};

export enum BusinessNavigationStatusEnum {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type BusinessPermissionsbytype = {
  __typename?: 'businessPermissionsbytype';
  adminPermission?: Maybe<Array<Maybe<ModulesFeaturesPermissions>>>;
  posPermissions?: Maybe<Array<Maybe<ModulesFeaturesPermissions>>>;
};

export type BusinessRadius = {
  __typename?: 'businessRadius';
  radius?: Maybe<Scalars['Float']['output']>;
};

export type BusinessRegistration = {
  address?: InputMaybe<Scalars['String']['input']>;
  business_identification_number?: InputMaybe<Scalars['String']['input']>;
  business_identification_type?: InputMaybe<Scalars['String']['input']>;
  business_legal_name: Scalars['String']['input'];
  business_logo?: InputMaybe<Scalars['Upload']['input']>;
  business_system_name: Scalars['String']['input'];
  business_type?: InputMaybe<Scalars['String']['input']>;
  card_holder_name?: InputMaybe<Scalars['String']['input']>;
  card_number?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['ID']['input']>;
  confirm_password?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['ID']['input'];
  currency_format?: InputMaybe<Scalars['String']['input']>;
  currency_name?: InputMaybe<Scalars['String']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  cvv?: InputMaybe<Scalars['String']['input']>;
  date_format?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiration_month?: InputMaybe<Scalars['String']['input']>;
  expiration_year?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  is_24_hour_format?: InputMaybe<Scalars['Boolean']['input']>;
  is_custom_package: Scalars['Boolean']['input'];
  is_email_verify?: InputMaybe<Scalars['Boolean']['input']>;
  is_phone_verify?: InputMaybe<Scalars['Boolean']['input']>;
  landline?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  number_of_customer?: InputMaybe<Scalars['Int']['input']>;
  number_of_employee?: InputMaybe<Scalars['Int']['input']>;
  number_of_product?: InputMaybe<Scalars['Int']['input']>;
  number_of_repair_tickets?: InputMaybe<Scalars['Int']['input']>;
  number_of_stores?: InputMaybe<Scalars['Int']['input']>;
  package?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  phone_country_code?: InputMaybe<Scalars['String']['input']>;
  request_for_franchise?: InputMaybe<Scalars['Boolean']['input']>;
  request_to?: InputMaybe<Scalars['ID']['input']>;
  sales_volume?: InputMaybe<Scalars['String']['input']>;
  sample_data?: InputMaybe<Array<InputMaybe<UpdateSampleDataInput>>>;
  save_card?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['ID']['input']>;
  time_zone: Scalars['String']['input'];
  types_of_products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  what_mostly_sell?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessStoreInput = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
  business_location_id?: InputMaybe<Scalars['ID']['input']>;
};

export type BusinessSystemInput = {
  device_id: Scalars['String']['input'];
  is_return_otp: Scalars['Boolean']['input'];
  system_name: Scalars['String']['input'];
  terminal_name: Scalars['String']['input'];
};

export enum BusinessType {
  Franchiser = 'franchiser',
  FranchiserOem = 'franchiser_OEM',
  IndependentBusiness = 'independent_business'
}

export type BusniessId = {
  __typename?: 'busniessId';
  _id?: Maybe<Scalars['ID']['output']>;
};

export type CampaignInput = {
  business: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignsListingResult = {
  __typename?: 'campaignsListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Campaign>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type CampaignsListingResultNew = {
  __typename?: 'campaignsListingResultNew';
  config?: Maybe<DataTableConfig>;
  data?: Maybe<Array<Maybe<CompaignData>>>;
};

export type Card = {
  __typename?: 'card';
  brand?: Maybe<Scalars['String']['output']>;
  checks?: Maybe<Checks>;
  country?: Maybe<Scalars['String']['output']>;
  exp_month?: Maybe<Scalars['Int']['output']>;
  exp_year?: Maybe<Scalars['Int']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type CardsDetail = {
  __typename?: 'cardsDetail';
  cards?: Maybe<Array<Maybe<GetPaymentMethod>>>;
  default?: Maybe<Scalars['String']['output']>;
};

export enum CarryForwardEnum {
  CarryForward = 'CarryForward'
}

export enum CarryForwardTypeEnum {
  Percentage = 'Percentage',
  Unit = 'Unit'
}

export type CashDemoninationInput = {
  qty?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['Float']['input']>;
};

export type CashDrawerInput = {
  BusinessLocation: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  cashRegister: Scalars['ID']['input'];
  clockin_pin: Scalars['Int']['input'];
  drawerType: OpenCashDrawerType;
  remarks: Scalars['String']['input'];
};

export enum CashFilter {
  Active = 'active',
  All = 'all',
  Archive = 'archive'
}

export type CashRegisterInput = {
  BusinessLocation: Scalars['ID']['input'];
  closed_at?: InputMaybe<Scalars['String']['input']>;
  closing_amount?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  opening_amount?: InputMaybe<Scalars['Float']['input']>;
  status: CashRegisterStatus;
};

export type CashRegisterListFilter = {
  businessLocation: Scalars['ID']['input'];
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export enum CashRegisterStatus {
  Close = 'close',
  Open = 'open'
}

export enum CashRegisterTypeEnum {
  Deposit = 'Deposit',
  Withdraw = 'Withdraw'
}

export type CashRegisterlistingResult = {
  __typename?: 'cashRegisterlistingResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<CashRegisters>>>;
};

export type CashRegistersHistoryInput = {
  BusinessLocation: Scalars['ID']['input'];
  businessLocation: Scalars['ID']['input'];
  cashRegisters: Scalars['ID']['input'];
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  payment_type: PaymentTypeEnum;
  previous_amount?: InputMaybe<Scalars['Float']['input']>;
  transaction_amount: Scalars['Float']['input'];
  type: CashRegisterTypeEnum;
  updated_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type CategoryData = {
  __typename?: 'categoryData';
  _id?: Maybe<Scalars['ID']['output']>;
  assigned_asset_count?: Maybe<Scalars['Int']['output']>;
  detail?: Maybe<SubCategoryDetail>;
  dispose_asset_count?: Maybe<Scalars['Int']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  maintenance_asset_count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reserved_asset_count?: Maybe<Scalars['Int']['output']>;
  scrap_asset_count?: Maybe<Scalars['Int']['output']>;
  subCategory?: Maybe<Array<Maybe<AssetSubCategory>>>;
  subCategoryCount?: Maybe<Scalars['Int']['output']>;
  totalActualCost?: Maybe<Scalars['Float']['output']>;
  totalCurrentValue?: Maybe<Scalars['Float']['output']>;
  totalDepreciationValue?: Maybe<Scalars['Float']['output']>;
  trashed_asset_count?: Maybe<Scalars['Int']['output']>;
  unassigned_asset_count?: Maybe<Scalars['Int']['output']>;
};

export type CategoryInput = {
  business: Scalars['String']['input'];
  category_name: Scalars['String']['input'];
  template?: InputMaybe<Scalars['Upload']['input']>;
};

export type CategoryList = {
  __typename?: 'categoryList';
  categoryName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<Array<Maybe<AssetSubCategory>>>;
  totalActualCost?: Maybe<Scalars['Float']['output']>;
  totalCurrentValue?: Maybe<Scalars['Float']['output']>;
  totalDepreciationValue?: Maybe<Scalars['Float']['output']>;
  totalSubCategory?: Maybe<Scalars['Int']['output']>;
};

export type CategoryListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CategoryListingResult = {
  __typename?: 'categoryListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  data?: Maybe<Array<Maybe<CategoryData>>>;
};

export type ChangeLeavePolicyInput = {
  assign_to: MovePolicyInput;
  current_policy: Scalars['ID']['input'];
  new_policy: Scalars['ID']['input'];
};

export type ChangePasswordEncryptionKeys = {
  encryptedPrivateKey?: InputMaybe<Scalars['String']['input']>;
  iv?: InputMaybe<Scalars['String']['input']>;
  salt?: InputMaybe<Scalars['String']['input']>;
};

export type ChangePolicyInput = {
  assign_to: AssignToPolicyInput;
  current_policy: Scalars['ID']['input'];
  new_policy: Scalars['ID']['input'];
};

export type ChangePolicyInput_ = {
  current_policy: Scalars['ID']['input'];
  employee_id: Scalars['ID']['input'];
  new_policy: Scalars['ID']['input'];
};

export type ChangeRequestStatusInput = {
  business_navigation_id: Scalars['ID']['input'];
  status: BusinessNavigationStatusEnum;
};

export type ChangeshareStatusInput = {
  action?: InputMaybe<ShareDocumentroles>;
  department?: InputMaybe<Scalars['ID']['input']>;
  documentId: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['ID']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
};

export type ChartOfAccountsInput = {
  account_balance: Scalars['Int']['input'];
  account_code?: InputMaybe<Scalars['String']['input']>;
  account_name: Scalars['String']['input'];
  account_type: Scalars['ID']['input'];
  as_of?: InputMaybe<Scalars['DateTime']['input']>;
  business?: InputMaybe<Scalars['ID']['input']>;
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_editable: Scalars['Boolean']['input'];
  is_sub_account: Scalars['Boolean']['input'];
  is_system_generated: Scalars['Boolean']['input'];
  opening_balance: Scalars['Int']['input'];
  parent_account?: InputMaybe<Scalars['ID']['input']>;
};

export type ChartOfAccountsListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ChartOfAccountsListingresult = {
  __typename?: 'chartOfAccountsListingresult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<ChartOfAccount>>>;
};

export type CheckListInput = {
  is_completed: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type CheckListStep = {
  __typename?: 'checkListStep';
  _id?: Maybe<Scalars['ID']['output']>;
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Checks = {
  __typename?: 'checks';
  cvc_check?: Maybe<Scalars['String']['output']>;
};

export type ChildTaxInput = {
  child_tax_amount: Scalars['String']['input'];
  child_tax_is_percentage: Scalars['Boolean']['input'];
  child_tax_name: Scalars['String']['input'];
};

export type ChunkWiseShortBreak = {
  __typename?: 'chunkWiseShortBreak';
  short_break_duration?: Maybe<Scalars['Int']['output']>;
  short_break_name?: Maybe<Scalars['String']['output']>;
  short_break_type?: Maybe<Scalars['Int']['output']>;
};

export type CityInput = {
  State: Scalars['ID']['input'];
  city_name: Scalars['String']['input'];
  short_name?: InputMaybe<Scalars['String']['input']>;
};

export type ClockHistoryEmployee = {
  __typename?: 'clockHistoryEmployee';
  ClockedHistory?: Maybe<Array<Maybe<ClockedHistory>>>;
  countStatus?: Maybe<CountStatusGroupedEmployee>;
};

export type ClockHistoryGroupData = {
  __typename?: 'clockHistoryGroupData';
  EarlyClockin?: Maybe<Scalars['Int']['output']>;
  OntimeOut?: Maybe<Scalars['Int']['output']>;
  absent?: Maybe<Scalars['Int']['output']>;
  block?: Maybe<Scalars['Int']['output']>;
  detail?: Maybe<ClockHistoryGroupDetail>;
  earlyClockedOut?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lateOut?: Maybe<Scalars['Int']['output']>;
  lateness?: Maybe<Scalars['Int']['output']>;
  missPaunchOut?: Maybe<Scalars['Int']['output']>;
  onLeave?: Maybe<Scalars['Int']['output']>;
  onTIme?: Maybe<Scalars['Int']['output']>;
  publicHoliday?: Maybe<Scalars['Int']['output']>;
  shortLeave?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalLogedMinuts?: Maybe<Scalars['String']['output']>;
  totalScheduleHours?: Maybe<Scalars['String']['output']>;
  totalWages?: Maybe<Scalars['String']['output']>;
  totalWorkingLogedMinuts?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  weekend?: Maybe<Scalars['Int']['output']>;
};

export type ClockHistoryGroupDetail = {
  __typename?: 'clockHistoryGroupDetail';
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<ClockedHistory>>>;
};

export type ClockHistoryWithStatus = {
  __typename?: 'clockHistoryWithStatus';
  groupClockHistory?: Maybe<Array<Maybe<GroupClockHistory>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type ClockHistryPdfDownloadType = {
  __typename?: 'clockHistryPdfDownloadType';
  donwloadProgress?: Maybe<Scalars['Int']['output']>;
  processingProgress?: Maybe<Scalars['Int']['output']>;
};

export type ClockIn = {
  __typename?: 'clockIn';
  previous_state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export enum ClockInEnum {
  EarlyArrival = 'EarlyArrival',
  LateArrival = 'LateArrival',
  OnTime = 'onTime'
}

export type ClockInOUtStatus = {
  __typename?: 'clockInOUtStatus';
  previous_state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ClockOut = {
  __typename?: 'clockOut';
  previous_state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export enum ClockOutEnum {
  EarlyOut = 'EarlyOut',
  LateOut = 'LateOut',
  MissePunchout = 'MissePunchout',
  OnTimeOut = 'OnTimeOut'
}

export type ClockStatus = {
  __typename?: 'clockStatus';
  EarlyOut?: Maybe<Scalars['Int']['output']>;
  LateOut?: Maybe<Scalars['Int']['output']>;
  Lateness?: Maybe<Scalars['Int']['output']>;
  early_clock_in?: Maybe<Scalars['Int']['output']>;
  miss_punch_out?: Maybe<Scalars['Int']['output']>;
  on_time_clock_in?: Maybe<Scalars['Int']['output']>;
};

export type ClockedInOrSepration = {
  __typename?: 'clockedInOrSepration';
  firstClockedInDate?: Maybe<Scalars['DateTime']['output']>;
  lastClockedInDate?: Maybe<Scalars['DateTime']['output']>;
  last_working_date?: Maybe<Scalars['DateTime']['output']>;
  resignation_date?: Maybe<Scalars['DateTime']['output']>;
  seprationDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum ClockedInStatusEnum {
  EarlyIn = 'EarlyIn',
  Lateness = 'Lateness',
  OnTime = 'onTime'
}

export type CloneRoleInput = {
  name: Scalars['String']['input'];
  role: Scalars['ID']['input'];
};

export enum ColorSchemeEnum {
  Custom = 'custom',
  Default = 'default'
}

export enum ColumnTypeEnum {
  Array = 'array',
  Date = 'date',
  Dropdown = 'dropdown',
  NestedSearch = 'nested_search',
  Number = 'number',
  String = 'string'
}

export type Column_Dropdown_Value = {
  __typename?: 'column_dropdown_value';
  _id?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ColumnsInput = {
  _ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  field: Scalars['String']['input'];
  query?: InputMaybe<QueryInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  type: ColumnTypeEnum;
};

export type CommenType = {
  __typename?: 'commenType';
  _id?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  comment_by?: Maybe<User>;
  comment_date?: Maybe<Scalars['DateTime']['output']>;
  optional_id?: Maybe<Scalars['String']['output']>;
  replies?: Maybe<Array<Maybe<ReplyType>>>;
};

export type CommentDetail = {
  __typename?: 'commentDetail';
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<CommenType>>>;
};

export type CommentInput = {
  TaskManagement: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
};

export type CommisionCampaignList = {
  __typename?: 'commisionCampaignList';
  config?: Maybe<DataTableConfig>;
  data?: Maybe<Array<Maybe<CommissionCompaignData>>>;
};

export type CommissioinCampaignSearchInput = {
  Business?: InputMaybe<Scalars['ID']['input']>;
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionCompaignData = {
  __typename?: 'commissionCompaignData';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Commission?: Maybe<Array<Maybe<Commission>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  detail?: Maybe<CommissionDetails>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  statistics?: Maybe<Scalars['Float']['output']>;
  stores?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CompaignData = {
  __typename?: 'compaignData';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  Discount?: Maybe<Array<Maybe<Discount>>>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  detail?: Maybe<DiscountDetail>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  statistics?: Maybe<Scalars['Float']['output']>;
  stores?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum ComplainantBy {
  My = 'my',
  Other = 'other'
}

export type CompletetSubTaskInput = {
  is_completed: Scalars['Boolean']['input'];
  sub_task_id: Scalars['ID']['input'];
};

export enum ConditionEnum {
  And = 'and',
  None = 'none',
  Or = 'or'
}

export enum ConditionalEnum {
  After = 'after',
  Before = 'before',
  Contain = 'contain',
  DoesNotContain = 'does_not_contain',
  Equal = 'equal',
  GreaterThenEqual = 'greater_then_equal',
  LessThenEqual = 'less_then_equal',
  NotEqual = 'not_equal'
}

export type ConfigActionType = {
  __typename?: 'configActionType';
  is_visible?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ConfirmClockedHistory = {
  date: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
};

export type ConflictRoster = {
  __typename?: 'conflictRoster';
  conflictSchedule?: Maybe<Array<Maybe<ConflictScheduleList>>>;
  isLeaveConflict?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConflictScheduleList = {
  __typename?: 'conflictScheduleList';
  clockIn?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  existingScheduleId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  newRosterId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ConflictScheduleList_ = {
  __typename?: 'conflictScheduleList_';
  clockIn?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  existingScheduleId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  newRosterId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ConflictedSchedules = {
  __typename?: 'conflictedSchedules';
  conflicted_schedule?: Maybe<Schedule>;
  employee_action?: Maybe<Scalars['ID']['output']>;
  employee_id?: Maybe<Scalars['ID']['output']>;
  employee_name?: Maybe<Scalars['String']['output']>;
  is_attendance_exist?: Maybe<Scalars['Boolean']['output']>;
  is_conflict?: Maybe<Scalars['Boolean']['output']>;
  is_leave?: Maybe<Scalars['Boolean']['output']>;
  is_overlap?: Maybe<Scalars['Boolean']['output']>;
  is_salary_detail_not_exist?: Maybe<Scalars['Boolean']['output']>;
  new_schedule?: Maybe<Schedule>;
};

export type ContractLicenseInput = {
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  contractLicenseTitle?: InputMaybe<Scalars['String']['input']>;
  contractNo?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  hyperlink?: InputMaybe<Scalars['String']['input']>;
  isForSoftware?: InputMaybe<Scalars['Boolean']['input']>;
  isNoEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  noOfLicenses?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type ContractLogs = {
  __typename?: 'contractLogs';
  action?: Maybe<Scalars['String']['output']>;
  assigned?: Maybe<Asset>;
  created_by?: Maybe<User>;
  date?: Maybe<Scalars['Date']['output']>;
};

export type ContributionListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ContributionlistingResult = {
  __typename?: 'contributionlistingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Contribution>>>;
};

export type CopyAuthenticatorAppInput = {
  appIds: Array<Scalars['ID']['input']>;
  group_type: Group_Type;
  move_to_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CopyPermissionInput = {
  copy_from: Scalars['ID']['input'];
  copy_to: Array<Scalars['ID']['input']>;
};

export type CopyScheduleByDateInput = {
  schedule_date?: InputMaybe<Scalars['String']['input']>;
  schedules: Array<Scalars['ID']['input']>;
  week_number?: InputMaybe<Array<InputMaybe<WeekAndYearInput>>>;
};

export type CopyScheduleDifferentDateInput = {
  employee_id: Scalars['ID']['input'];
  schedule_date: Scalars['DateTime']['input'];
  schedule_id: Scalars['ID']['input'];
};

export type CopyScheduleEmpInput = {
  employee_id: Scalars['ID']['input'];
  employees: Array<Scalars['ID']['input']>;
  end_date: Scalars['DateTime']['input'];
  start_date: Scalars['DateTime']['input'];
};

export type CopyScheduleInput = {
  _id: Scalars['ID']['input'];
  employees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end_date: Scalars['DateTime']['input'];
  includes_comments?: InputMaybe<Scalars['Boolean']['input']>;
  no_of_weeks: Scalars['Int']['input'];
  start_date: Scalars['DateTime']['input'];
};

export type CopyScheduleSelectedDate = {
  dateType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  scheduleList?: InputMaybe<Array<InputMaybe<SelectedScheduleInput>>>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CopyScheduleSelectedDatesInput = {
  dateType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  scheduleList?: InputMaybe<Array<InputMaybe<SelectedScheduleInput>>>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CountAlert = {
  __typename?: 'countAlert';
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CountStatus = {
  __typename?: 'countStatus';
  EarlyClockin?: Maybe<Scalars['Int']['output']>;
  absent?: Maybe<Scalars['Int']['output']>;
  block?: Maybe<Scalars['Int']['output']>;
  earlyClockedOut?: Maybe<Scalars['Int']['output']>;
  lateOut?: Maybe<Scalars['Int']['output']>;
  lateness?: Maybe<Scalars['Int']['output']>;
  missPaunchOut?: Maybe<Scalars['Int']['output']>;
  onLeave?: Maybe<Scalars['Int']['output']>;
  present?: Maybe<Scalars['Int']['output']>;
  shortLeave?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CountStatusCount = {
  __typename?: 'countStatusCount';
  absent?: Maybe<Scalars['Int']['output']>;
  block?: Maybe<Scalars['Int']['output']>;
  earlyIn?: Maybe<Scalars['Int']['output']>;
  earlyOut?: Maybe<Scalars['Int']['output']>;
  lateOut?: Maybe<Scalars['Int']['output']>;
  lateness?: Maybe<Scalars['Int']['output']>;
  missPunchOut?: Maybe<Scalars['Int']['output']>;
  notComing?: Maybe<Scalars['Int']['output']>;
  onLeave?: Maybe<Scalars['Int']['output']>;
  onTimeIn?: Maybe<Scalars['Int']['output']>;
  onTimeOut?: Maybe<Scalars['Int']['output']>;
  present?: Maybe<Scalars['Int']['output']>;
  publicHoliday?: Maybe<Scalars['Int']['output']>;
  shortLeave?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['String']['output']>;
  weekend?: Maybe<Scalars['Int']['output']>;
};

export type CountStatusGroupedEmployee = {
  __typename?: 'countStatusGroupedEmployee';
  EarlyClockin?: Maybe<Scalars['Int']['output']>;
  OntimeOut?: Maybe<Scalars['Int']['output']>;
  absent?: Maybe<Scalars['Int']['output']>;
  block?: Maybe<Scalars['Int']['output']>;
  earlyClockedOut?: Maybe<Scalars['Int']['output']>;
  lateOut?: Maybe<Scalars['Int']['output']>;
  lateness?: Maybe<Scalars['Int']['output']>;
  missPaunchOut?: Maybe<Scalars['Int']['output']>;
  onLeave?: Maybe<Scalars['Int']['output']>;
  onTIme?: Maybe<Scalars['Int']['output']>;
  publicHoliday?: Maybe<Scalars['Int']['output']>;
  shortLeave?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalLogedMinuts?: Maybe<Scalars['String']['output']>;
  totalScheduleHours?: Maybe<Scalars['Int']['output']>;
  totalWorkingLogedMinuts?: Maybe<Scalars['String']['output']>;
  weekend?: Maybe<Scalars['Int']['output']>;
};

export type CouponCode = {
  __typename?: 'couponCode';
  code: Scalars['String']['output'];
};

export type CreateAppInputOtp = {
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  qrData: Scalars['String']['input'];
};

export type CreateAppInputWithoutOtp = {
  app_name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  password: PasswordManagerInput;
  url: Scalars['String']['input'];
};

export type CreateAppraisalObjecive = {
  AppraisalType: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight_percent?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAuthenticatorGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  group_name: Scalars['String']['input'];
  group_type: Group_Type;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateBusinessInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  business_identification_number?: InputMaybe<Scalars['String']['input']>;
  business_identification_type?: InputMaybe<Scalars['String']['input']>;
  business_legal_name: Scalars['String']['input'];
  business_logo?: InputMaybe<Scalars['Upload']['input']>;
  business_system_name: Scalars['String']['input'];
  business_type: AllowBusinessType;
  city?: InputMaybe<Scalars['ID']['input']>;
  country: Scalars['ID']['input'];
  currency_format?: InputMaybe<Scalars['String']['input']>;
  currency_name?: InputMaybe<Scalars['String']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  date_format?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  is_24_hour_format?: InputMaybe<Scalars['Boolean']['input']>;
  is_email_verify?: InputMaybe<Scalars['Boolean']['input']>;
  is_phone_verify?: InputMaybe<Scalars['Boolean']['input']>;
  landline?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  package?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_country_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['ID']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCampaignInput = {
  Business: Scalars['ID']['input'];
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  mention_users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  optional_id?: InputMaybe<Scalars['String']['input']>;
  task_id: Scalars['ID']['input'];
};

export type CreateCompasationLeaveInput = {
  countIn?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  date_type_leave?: InputMaybe<Array<InputMaybe<TypeLeaveInput>>>;
  document?: InputMaybe<Scalars['Upload']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  is_compansation_leave?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_short_leave?: InputMaybe<Scalars['Boolean']['input']>;
  leave_request?: InputMaybe<Array<InputMaybe<LeaveInput>>>;
  reason_for_leave?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  total_leave_out_of_accural?: InputMaybe<Scalars['Float']['input']>;
  total_leaves?: InputMaybe<Scalars['Float']['input']>;
  total_unpaid_leaves?: InputMaybe<Scalars['Float']['input']>;
  type_of_absence?: InputMaybe<Scalars['ID']['input']>;
  unpaid_count?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateEvaluationInput = {
  PerformanceCycle?: InputMaybe<Scalars['ID']['input']>;
  User?: InputMaybe<Scalars['ID']['input']>;
  listProjects?: InputMaybe<Scalars['String']['input']>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  performanceCycles?: InputMaybe<Array<InputMaybe<InputPerformance_Cycles>>>;
  performanceGoals?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  roadMap?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trainingRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateExpenseInvoice = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invoice?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExpenseInvoiceCategory = {
  expenseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateGroupInput = {
  activity?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  activityFor?: InputMaybe<ActivityFor>;
  department?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupAssignee?: InputMaybe<GroupAssignees>;
  groupType?: InputMaybe<GroupType>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateInputObjectiveAssignment = {
  User?: InputMaybe<Scalars['ID']['input']>;
  objectiveAssigned?: InputMaybe<Array<InputMaybe<InputobjectiveAssigned>>>;
  status?: InputMaybe<EnumObjectiveAssignmentStatus>;
};

export type CreateInputTablePreset = {
  activeFilters?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ListingColumnsInput>>>;
  config?: InputMaybe<TableConfig>;
  filters?: InputMaybe<Array<InputMaybe<ListingFiltersInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  loadingCall?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortingConfig?: InputMaybe<SortingConfigInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRegionInput = {
  Business?: InputMaybe<Scalars['ID']['input']>;
  BusinessLocation?: InputMaybe<Array<Scalars['ID']['input']>>;
  City?: InputMaybe<Array<Scalars['ID']['input']>>;
  Country: Scalars['ID']['input'];
  State?: InputMaybe<Array<Scalars['ID']['input']>>;
  region_name: Scalars['String']['input'];
};

export type CreateRepliesCommentInput = {
  comment_id: Scalars['ID']['input'];
  reply: Scalars['String']['input'];
  task_id: Scalars['ID']['input'];
};

export type CreateResponseQuizTraining = {
  __typename?: 'createResponseQuizTraining';
  Quiz?: Maybe<Quiz>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateRocketChatUserInput = {
  chat_user_name?: InputMaybe<Scalars['String']['input']>;
  rocket_chat_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRosterByTemplate = {
  end_date: Scalars['DateTime']['input'];
  start_date: Scalars['DateTime']['input'];
  template_id: Scalars['ID']['input'];
};

export type CreateRosterForcefully = {
  date?: InputMaybe<Scalars['String']['input']>;
  existingScheduleId?: InputMaybe<Scalars['ID']['input']>;
  newRosterId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSampleDataInput = {
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  is_selected: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateSchedule = {
  __typename?: 'createSchedule';
  conflictSchedule?: Maybe<Array<Maybe<Schedule>>>;
  errorList?: Maybe<Array<Maybe<OverLapedSchedules>>>;
  message?: Maybe<Scalars['String']['output']>;
  overLapedSchedules?: Maybe<Array<Maybe<OverLapedSchedules>>>;
};

export type CreateShipTo = {
  location: Scalars['String']['input'];
};

export type CreateSyncWithChatServerInput = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTaskInput = {
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  ParentTask?: InputMaybe<Scalars['ID']['input']>;
  assignee?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  check_list?: InputMaybe<Array<CheckListInput>>;
  department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  editor_description?: InputMaybe<Scalars['String']['input']>;
  google_drive_id?: InputMaybe<Scalars['String']['input']>;
  priority: PriorityEmums;
  role?: InputMaybe<Scalars['ID']['input']>;
  summary: Scalars['String']['input'];
};

export type CreateTimeOffInput = {
  accept_reject_leave?: InputMaybe<Array<InputMaybe<LeaveInput>>>;
  countIn?: InputMaybe<Scalars['String']['input']>;
  date_type_leave?: InputMaybe<Array<InputMaybe<TypeLeaveInput>>>;
  document?: InputMaybe<Scalars['Upload']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  is_between_leave?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_pto?: InputMaybe<Scalars['Boolean']['input']>;
  is_sandwich?: InputMaybe<Scalars['Boolean']['input']>;
  is_short_leave?: InputMaybe<Scalars['Boolean']['input']>;
  leave?: InputMaybe<Array<InputMaybe<TypeLeaveInput>>>;
  leave_request?: InputMaybe<Array<InputMaybe<LeaveInput>>>;
  reason_for_leave?: InputMaybe<Scalars['String']['input']>;
  remaining_days?: InputMaybe<Scalars['Float']['input']>;
  remaining_unpaid_days?: InputMaybe<Scalars['Float']['input']>;
  sandwich?: InputMaybe<Array<InputMaybe<Sandwich>>>;
  scheduleData?: InputMaybe<Array<InputMaybe<ScheduleData>>>;
  status?: InputMaybe<TimeOffStatus>;
  total_leave_out_of_accural?: InputMaybe<Scalars['Float']['input']>;
  total_leaves?: InputMaybe<Scalars['Float']['input']>;
  total_unpaid_leaves?: InputMaybe<Scalars['Float']['input']>;
  type_of_absence?: InputMaybe<Scalars['ID']['input']>;
  type_of_absence_id?: InputMaybe<Scalars['String']['input']>;
  unpaid_count?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateUpdateTimeOffRequestInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  accept_reject_leave?: InputMaybe<Array<InputMaybe<LeaveInput>>>;
  countIn?: InputMaybe<Scalars['String']['input']>;
  date_type_leave?: InputMaybe<Array<InputMaybe<TypeLeaveInput>>>;
  document?: InputMaybe<Scalars['Upload']['input']>;
  is_between_leave?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_pto?: InputMaybe<Scalars['Boolean']['input']>;
  is_sandwich?: InputMaybe<Scalars['Boolean']['input']>;
  is_short_leave?: InputMaybe<Scalars['Boolean']['input']>;
  leave_request?: InputMaybe<Array<InputMaybe<LeaveInput>>>;
  reason_for_leave?: InputMaybe<Scalars['String']['input']>;
  remaining_days?: InputMaybe<Scalars['Float']['input']>;
  remaining_unpaid_days?: InputMaybe<Scalars['Float']['input']>;
  sandwich?: InputMaybe<Array<InputMaybe<Sandwich>>>;
  total_leave_out_of_accural?: InputMaybe<Scalars['Float']['input']>;
  total_leaves?: InputMaybe<Scalars['Float']['input']>;
  total_unpaid_leaves?: InputMaybe<Scalars['Float']['input']>;
  type_of_absence: Scalars['ID']['input'];
  type_of_absence_id?: InputMaybe<Scalars['String']['input']>;
  unpaid_count?: InputMaybe<Scalars['Float']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateWeekendsInput = {
  from_date: Scalars['DateTime']['input'];
};

export type CreatedExpenseInvoice = {
  __typename?: 'createdExpenseInvoice';
  category?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CreatedExpenseInvoiceCategory = {
  __typename?: 'createdExpenseInvoiceCategory';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomLocationInput = {
  city_name: Scalars['String']['input'];
  country_id: Scalars['ID']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  state_id: Scalars['ID']['input'];
  zip_code: Scalars['String']['input'];
};

export type CustomerInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerTransactionInput = {
  customer: Scalars['ID']['input'];
};

export type DailyClockHistoryList = {
  __typename?: 'dailyClockHistoryList';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ClockedHistory>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type DailyReport = {
  __typename?: 'dailyReport';
  date?: Maybe<Scalars['String']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  totalMinutes?: Maybe<Scalars['Int']['output']>;
  totalWages?: Maybe<Scalars['String']['output']>;
};

export type Daily_Wages = {
  __typename?: 'daily_wages';
  schedule_date?: Maybe<Scalars['String']['output']>;
  total_wage?: Maybe<Scalars['Float']['output']>;
};

export type Daily_Wages_Timesheet = {
  __typename?: 'daily_wages_timesheet';
  attendance_date?: Maybe<Scalars['String']['output']>;
  total_wages?: Maybe<Scalars['Float']['output']>;
};

export type DashBoardChange = {
  __typename?: 'dashBoardChange';
  is_updated?: Maybe<Scalars['Boolean']['output']>;
};

export type DashboardAssetCount = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardEmplyeCountToday = {
  department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employees?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['DateTime']['input'];
  role?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate: Scalars['DateTime']['input'];
};

export type DashboardRostersWithAttendance = {
  __typename?: 'dashboardRostersWithAttendance';
  absent?: Maybe<Scalars['Int']['output']>;
  absentPercentage?: Maybe<Scalars['Int']['output']>;
  employees?: Maybe<Array<Maybe<User>>>;
  leave?: Maybe<Scalars['Int']['output']>;
  leavePercentage?: Maybe<Scalars['Int']['output']>;
  present?: Maybe<Scalars['Int']['output']>;
  presentPercentage?: Maybe<Scalars['Int']['output']>;
  scheduledEmployees?: Maybe<Scalars['Int']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  unrestrictedUsers?: Maybe<Scalars['Int']['output']>;
};

export type DataColumnResults = {
  __typename?: 'dataColumnResults';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<TaskManagement>>>;
};

export type DataTableConfig = {
  __typename?: 'dataTableConfig';
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  filters?: Maybe<Array<Maybe<ListingFiltersType>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  no_of_records?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  table_config?: Maybe<TableConfigListing>;
  table_preset?: Maybe<Array<Maybe<ListingTablePreset>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DataTypeInput = {
  data_type_name: Scalars['String']['input'];
};

export type DataTypeResult = {
  __typename?: 'dataTypeResult';
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<MasterDataValue>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type DataTypeValueInput = {
  business?: InputMaybe<Scalars['ID']['input']>;
  data_type: Scalars['ID']['input'];
  data_value_name: Scalars['String']['input'];
  data_value_type?: InputMaybe<Scalars['ID']['input']>;
  is_system_generated: Scalars['Boolean']['input'];
};

export type DataValueInput = {
  business: Scalars['ID']['input'];
  data_type_id: Scalars['ID']['input'];
};

export type DateObj = {
  __typename?: 'dateObj';
  from_date?: Maybe<Scalars['DateTime']['output']>;
  to_date?: Maybe<Scalars['DateTime']['output']>;
};

export type DateOfSandwich = {
  __typename?: 'dateOfSandwich';
  date?: Maybe<Scalars['DateTime']['output']>;
  day?: Maybe<Scalars['String']['output']>;
};

export enum DeductionFilter {
  Active = 'active',
  All = 'all',
  Archive = 'archive'
}

export type DeductionListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeductionlistingResult = {
  __typename?: 'deductionlistingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Deduction>>>;
};

export type DelegantApprovalMutationInput = {
  approval_type: WorkFlowTypeEnum;
  employee_id: Scalars['ID']['input'];
};

export type DeleteAppraisalType = {
  __typename?: 'deleteAppraisalType';
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteAttachmentInput = {
  _id: Scalars['ID']['input'];
  attachmentURl: Scalars['String']['input'];
};

export type DeleteDocumentSubscribe = {
  __typename?: 'deleteDocumentSubscribe';
  current?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
};

export type DeleteInputTablePreset = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteSubCategoryInput = {
  categoryId: Scalars['ID']['input'];
  subCategoryId: Scalars['ID']['input'];
};

export type DeleteSubTaskInput = {
  _id: Scalars['ID']['input'];
  sub_task_id: Scalars['ID']['input'];
};

export type DeletedRequestResponse = {
  __typename?: 'deletedRequestResponse';
  _id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<RequestEnums>;
};

export type DepartmentEmployeeCount = {
  __typename?: 'departmentEmployeeCount';
  department?: Maybe<Department>;
  employee_count?: Maybe<Scalars['Int']['output']>;
};

export enum DepartmentFilter {
  Active = 'active',
  All = 'all',
  Archive = 'archive'
}

export type DepartmentInput = {
  Business: Scalars['ID']['input'];
  department_name: Scalars['String']['input'];
};

export type DepartmentListFilter = {
  business?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DepartmentListingresult = {
  __typename?: 'departmentListingresult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Department>>>;
};

export type Depreciation = {
  __typename?: 'depreciation';
  dailyDepreciation?: Maybe<Scalars['Float']['output']>;
  depreciationAmount?: Maybe<Scalars['Int']['output']>;
  depreciationMonths?: Maybe<Scalars['Int']['output']>;
  endAmount?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  startAmount?: Maybe<Scalars['Int']['output']>;
  totalDepreciated?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export enum DepreciationEnum {
  Instant = 'instant',
  Periodic = 'periodic'
}

export type DepreciationInput = {
  dailyDepreciation?: InputMaybe<Scalars['Float']['input']>;
  depreciationAmount?: InputMaybe<Scalars['Int']['input']>;
  depreciationMonths?: InputMaybe<Scalars['Int']['input']>;
  endAmount?: InputMaybe<Scalars['Int']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  startAmount?: InputMaybe<Scalars['Int']['input']>;
  totalDepreciated?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type DesigationEmployeeCount = {
  __typename?: 'desigationEmployeeCount';
  designation?: Maybe<Designation>;
  employee_count?: Maybe<Scalars['Int']['output']>;
};

export type DesignationListingresult = {
  __typename?: 'designationListingresult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Designation>>>;
};

export type DesignationsInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  business: Scalars['ID']['input'];
  designation_name: Scalars['String']['input'];
};

export enum DesignationtFilter {
  Active = 'active',
  All = 'all',
  Archive = 'archive'
}

export type DesignationtListFilter = {
  business?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DesignationtFilter>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DesignationtListFilterNew = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type DetailReport = {
  __typename?: 'detailReport';
  Objective?: Maybe<AppraisalObjecive>;
  _id?: Maybe<Scalars['ID']['output']>;
  appraisal_type?: Maybe<AppraisalType>;
  appraiser?: Maybe<Array<Maybe<User>>>;
  department?: Maybe<Department>;
  name?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type DetailType = {
  __typename?: 'detailType';
  _id?: Maybe<Scalars['ID']['output']>;
  accunt_type?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DetailTypeInput = {
  accunt_type?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Detail_Result = {
  __typename?: 'detail_result';
  AppraisalObjective?: Maybe<AppraisalObjecive>;
  AppraisalType?: Maybe<AppraisalType>;
  _id?: Maybe<Scalars['ID']['output']>;
  appraisal?: Maybe<User>;
  appraiser?: Maybe<User>;
  appraisers?: Maybe<Array<Maybe<User>>>;
  score?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
  weight_percent?: Maybe<Scalars['Float']['output']>;
};

export type DetailextendedView = {
  __typename?: 'detailextendedView';
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<Detail_Result>>>;
};

export type DeviceModelResult = {
  __typename?: 'deviceModelResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<DeviceModel>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export enum DeviceStatus {
  Linked = 'linked',
  Unlinked = 'unlinked'
}

export type DiscountListingResult = {
  __typename?: 'discountListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Discount>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type DisposeDetail = {
  __typename?: 'disposeDetail';
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<LogsAsset>>>;
};

export enum DisposeFilter {
  All = 'all',
  Disposed = 'disposed',
  Scrap = 'scrap',
  Trashed = 'trashed'
}

export type DisposeListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  disposeColumns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DisposeObj = {
  __typename?: 'disposeObj';
  disposeDate?: Maybe<Scalars['Date']['output']>;
  disposeTo?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type DisposedInput = {
  assetId: Scalars['String']['input'];
  disposeDate?: InputMaybe<Scalars['Date']['input']>;
  disposeTo?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentDetail = {
  __typename?: 'documentDetail';
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<UplaodDocument>>>;
};

export enum DocumentType {
  All = 'All',
  Company = 'Company',
  Individual = 'Individual'
}

export enum DocumentTypeEnum {
  All = 'All',
  Company = 'Company',
  Individual = 'Individual'
}

export type Documents = {
  __typename?: 'documents';
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  upload_by?: Maybe<User>;
};

export type DownloadZip = {
  __typename?: 'downloadZip';
  percent?: Maybe<Scalars['Int']['output']>;
};

export type EditBusinessEmployeeInput = {
  business_navigation_id: Scalars['ID']['input'];
  employee: Scalars['ID']['input'];
  role?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export enum EffectiveAfterTypeEnum {
  Day = 'Day',
  Month = 'Month',
  Year = 'Year'
}

export type EmailChanged = {
  __typename?: 'emailChanged';
  is_email_changed?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailDeliveryRuleInput = {
  BusinessEmail: Scalars['ID']['input'];
  configuration_name: Scalars['String']['input'];
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  module: ModulesEnum;
  sub_module: SubModulesEnum;
  type?: InputMaybe<SmtpType>;
};

export type EmailDeliveryRuleList = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailDocumentControlAttachment = {
  department?: InputMaybe<Scalars['ID']['input']>;
  documentId: Scalars['ID']['input'];
  employee: Array<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  share_as?: InputMaybe<ShareDocumentroles>;
  type?: InputMaybe<AssignToEnums>;
};

export type EmailOtp = {
  __typename?: 'emailOtp';
  _id?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  otp_code: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type EmailOtpInput = {
  email: Scalars['String']['input'];
  is2FactorAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EmailVerifyOtpInput = {
  email: Scalars['String']['input'];
  otp_code: Scalars['String']['input'];
};

export type EmloyeeSharePermission = {
  __typename?: 'emloyeeSharePermission';
  detail?: Maybe<Share_With>;
  employee?: Maybe<User>;
  share_as?: Maybe<Scalars['String']['output']>;
};

export type EmployeeAdpId = {
  adpId: Scalars['ID']['input'];
  employee_id: Scalars['ID']['input'];
};

export type EmployeeActionInput = {
  employee_id: Scalars['ID']['input'];
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeActivityFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type EmployeeBirthDaysForCalenderType = {
  __typename?: 'employeeBirthDaysForCalenderType';
  birth_date?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Array<Maybe<Department>>>;
  employee_type?: Maybe<Scalars['String']['output']>;
  joining_date?: Maybe<Scalars['DateTime']['output']>;
};

export type EmployeeClockHistory = {
  __typename?: 'employeeClockHistory';
  groupData?: Maybe<Array<Maybe<ClockHistoryEmployee>>>;
};

export type EmployeeDetail = {
  __typename?: 'employeeDetail';
  actions?: Maybe<Array<Maybe<ConfigActionType>>>;
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<User>>>;
};

export type EmployeeDocumentUpdateInput = {
  Role?: InputMaybe<Scalars['ID']['input']>;
  _id: Scalars['ID']['input'];
  assinged_to?: InputMaybe<Scalars['ID']['input']>;
  documents_description?: InputMaybe<Scalars['String']['input']>;
  documents_expiry_date?: InputMaybe<Scalars['String']['input']>;
  documents_name?: InputMaybe<Scalars['String']['input']>;
  documents_type?: InputMaybe<Scalars['String']['input']>;
  is_email_notify?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployeeDocumentUpload = {
  __typename?: 'employeeDocumentUpload';
  _id?: Maybe<Scalars['ID']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<User>;
  fileRef?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  view?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeEncryptionKeyInput = {
  encryptedPrivateKey: Scalars['String']['input'];
  iv: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
  salt: Scalars['String']['input'];
};

export type EmployeeFilterInput = {
  departments?: InputMaybe<Array<Scalars['ID']['input']>>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  roles?: InputMaybe<Array<Scalars['ID']['input']>>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeGarnishmentInput = {
  assignTo?: InputMaybe<Scalars['ID']['input']>;
  document?: InputMaybe<Scalars['Upload']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  fix_amount?: InputMaybe<Scalars['Float']['input']>;
  garnishment: EnumGarnishment;
  garnishment_account: Scalars['String']['input'];
  garnishment_creator: Scalars['String']['input'];
  garnishment_type: GarnishmentTypeEnums;
  google_drive_id?: InputMaybe<Scalars['String']['input']>;
  start_date: Scalars['DateTime']['input'];
};

export type EmployeeGarnishmentResult = {
  __typename?: 'employeeGarnishmentResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<EmployeeGarnishment>>>;
};

export type EmployeeGarnishmentUpdate = {
  _id: Scalars['ID']['input'];
  assignTo?: InputMaybe<Scalars['ID']['input']>;
  document?: InputMaybe<Scalars['Upload']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  fix_amount?: InputMaybe<Scalars['Float']['input']>;
  garnishment?: InputMaybe<EnumGarnishment>;
  garnishment_account?: InputMaybe<Scalars['String']['input']>;
  garnishment_creator?: InputMaybe<Scalars['String']['input']>;
  garnishment_type?: InputMaybe<GarnishmentTypeEnums>;
  google_drive_id?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeLeaveInput = {
  employeeId: Scalars['ID']['input'];
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
};

export type EmployeeLeavebyDateRange = {
  __typename?: 'employeeLeavebyDateRange';
  from_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  reason_for_leave?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  to_date?: Maybe<Scalars['DateTime']['output']>;
  total_leaves?: Maybe<Scalars['Float']['output']>;
};

export type EmployeeListFilter = {
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type EmployeeListingResult = {
  __typename?: 'employeeListingResult';
  config?: Maybe<DataTableConfig>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<User>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeListingResultNew = {
  __typename?: 'employeeListingResultNew';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<User>>>;
};

export type EmployeeListingresult = {
  __typename?: 'employeeListingresult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<EmployeeSeparation>>>;
};

export type EmployeeLoanAmountResult = {
  __typename?: 'employeeLoanAmountResult';
  paidAmount?: Maybe<Scalars['Int']['output']>;
  remainingAmount?: Maybe<Scalars['Int']['output']>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
};

export type EmployeePaidUnpaidLeaves = {
  __typename?: 'employeePaidUnpaidLeaves';
  paidLeave?: Maybe<Scalars['Int']['output']>;
  unPaidLeave?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeRosters = {
  __typename?: 'employeeRosters';
  date?: Maybe<Scalars['DateTime']['output']>;
  roster?: Maybe<Roster>;
  short_breaks?: Maybe<Shortbreak>;
  wages?: Maybe<Scalars['Float']['output']>;
};

export type EmployeeScheduleInput = {
  end_date: Scalars['DateTime']['input'];
  feature: FeatureEnum;
  start_date: Scalars['DateTime']['input'];
};

export enum EmployeeSections {
  Accounts = 'accounts',
  Contract = 'contract',
  Documents = 'documents',
  EmployeeTimeLine = 'employee_time_line',
  JoiningLatter = 'joining_latter',
  Leave = 'leave',
  ProfileInfo = 'profile_info',
  SalaryTaxDetails = 'salary_tax_details',
  TimeRuleAttendance = 'time_rule_attendance',
  TransferMethod = 'transfer_method'
}

export type EmployeeSeparation = {
  __typename?: 'employeeSeparation';
  _id?: Maybe<Scalars['ID']['output']>;
  attrition?: Maybe<Attrition>;
  business?: Maybe<Business>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  documents?: Maybe<Array<Maybe<EmployeeDocument>>>;
  employee?: Maybe<User>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_notifiy?: Maybe<Scalars['Boolean']['output']>;
  last_working_date?: Maybe<Scalars['DateTime']['output']>;
  payroll_hold?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reason_description?: Maybe<Scalars['String']['output']>;
  resignation_date?: Maybe<Scalars['DateTime']['output']>;
  separation_type?: Maybe<Separation_Types>;
  settlement_completed?: Maybe<Scalars['Boolean']['output']>;
  to_employees?: Maybe<Array<Maybe<User>>>;
};

export type EmployeeSeparationFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type EmployeeSeparationInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  attrition: Attrition;
  business: Scalars['ID']['input'];
  documents?: InputMaybe<Array<InputMaybe<EmployeeDocumentInput>>>;
  employee: Scalars['ID']['input'];
  is_notifiy?: InputMaybe<Scalars['Boolean']['input']>;
  last_working_date: Scalars['DateTime']['input'];
  payroll_hold?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_description?: InputMaybe<Scalars['String']['input']>;
  resignation_date: Scalars['DateTime']['input'];
  separation_type: Separation_Types;
  to_employees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export enum EmployeeStatus {
  Inactive = 'Inactive',
  Active = 'active'
}

export type EmployeeTimeSheetInput = {
  business: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeTimeSheetType = {
  __typename?: 'employeeTimeSheetType';
  Absent?: Maybe<Scalars['Int']['output']>;
  EarlyOut?: Maybe<Scalars['Int']['output']>;
  Lateness?: Maybe<Scalars['Int']['output']>;
  Leave?: Maybe<Scalars['Int']['output']>;
  Present?: Maybe<Scalars['Int']['output']>;
  _id?: Maybe<Scalars['String']['output']>;
};

export enum EmployeeType {
  Hourly = 'Hourly',
  Salary = 'Salary'
}

export enum EmployeeTypeEnum {
  Promotion = 'Promotion',
  Transfer = 'Transfer',
  Increment = 'increment'
}

export type Employee_Actions = {
  __typename?: 'employee_actions';
  UserHistory?: Maybe<UserHistory>;
  absents?: Maybe<Scalars['Int']['output']>;
  no_of_days?: Maybe<Scalars['Int']['output']>;
  paid_leaves?: Maybe<Scalars['Int']['output']>;
  paid_short_leaves?: Maybe<Scalars['Int']['output']>;
  un_paid_leaves?: Maybe<Scalars['Int']['output']>;
  un_paid_short_leaves?: Maybe<Scalars['Int']['output']>;
};

export type Employee_Groups = {
  __typename?: 'employee_groups';
  _id?: Maybe<Scalars['String']['output']>;
  is_un_restricted?: Maybe<Scalars['Boolean']['output']>;
};

export type EmployeesByBusiness = {
  business_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rosterStore: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeesClockHistory = {
  __typename?: 'employeesClockHistory';
  config?: Maybe<UpdatedDataTableConfig>;
  dailyClockHistoryList?: Maybe<Array<Maybe<ClockedHistory>>>;
  groupData?: Maybe<Array<Maybe<ClockHistoryGroupData>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EmployeesDepartmentsFilter = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  store_id?: InputMaybe<Scalars['ID']['input']>;
};

export type EmployeesForPolicy = {
  department?: InputMaybe<Array<Scalars['ID']['input']>>;
  designation?: InputMaybe<Array<Scalars['ID']['input']>>;
  role?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EmployeesMonthlyTimeSheet = {
  __typename?: 'employeesMonthlyTimeSheet';
  dateList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  employeesTimeSheet?: Maybe<Array<Maybe<EmployeeTimeSheetType>>>;
  totalAbsent?: Maybe<Scalars['Int']['output']>;
  totalEarlyOut?: Maybe<Scalars['Int']['output']>;
  totalLateness?: Maybe<Scalars['Int']['output']>;
  totalLeave?: Maybe<Scalars['Int']['output']>;
  totalPresent?: Maybe<Scalars['Int']['output']>;
};

export type EmployeesRosters = {
  __typename?: 'employeesRosters';
  employees?: Maybe<Array<Maybe<User>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  permissions?: Maybe<Array<Maybe<Permissions>>>;
  rosterStore?: Maybe<RosterStores>;
  rosters?: Maybe<Array<Maybe<Roster>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type EmployeesRostersInput = {
  endDate: Scalars['DateTime']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type EmployeesRostertsInput = {
  currentView?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['DateTime']['input'];
  payrollType?: InputMaybe<PayrollType>;
  role?: InputMaybe<Scalars['ID']['input']>;
  scheduled?: InputMaybe<ScheduledFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  timeOff?: InputMaybe<_Schedule>;
};

export type EmployeesScheduleExists = {
  endDate: Scalars['DateTime']['input'];
  feature?: InputMaybe<FeatureEnum>;
  startDate: Scalars['DateTime']['input'];
};

export type EmployeesWithClockedHistory = {
  __typename?: 'employeesWithClockedHistory';
  clockedHistory?: Maybe<Array<Maybe<ClockedHistory>>>;
  user?: Maybe<User>;
};

export type EmployeesWithRosters = {
  __typename?: 'employeesWithRosters';
  user?: Maybe<User>;
  userRosters?: Maybe<Array<Maybe<EmployeeRosters>>>;
};

export type EmployeesWithRostersList = {
  __typename?: 'employeesWithRostersList';
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  is_canceled?: Maybe<Scalars['Boolean']['output']>;
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  userRostersList?: Maybe<Array<Maybe<EmployeesWithRosters>>>;
};

export type EmployeeshClockedHistoryList = {
  __typename?: 'employeeshClockedHistoryList';
  clockedHistoryList?: Maybe<Array<Maybe<EmployeesWithClockedHistory>>>;
  current_time?: Maybe<Scalars['DateTime']['output']>;
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  is_salary_view?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type EncryptedPasswordInput = {
  encryptedAESKey?: InputMaybe<Scalars['String']['input']>;
  encryptedPassword?: InputMaybe<Scalars['String']['input']>;
  iv?: InputMaybe<Scalars['String']['input']>;
};

export type EncryptedPasswordType = {
  __typename?: 'encryptedPasswordType';
  encryptedAESKey?: Maybe<Scalars['String']['output']>;
  encryptedPassword?: Maybe<Scalars['String']['output']>;
  iv?: Maybe<Scalars['String']['output']>;
};

export enum Enrollment {
  EligibleToJoinBetween = 'eligible_to_join_between',
  GeneralEnrollment = 'general_enrollment'
}

export type EntitlementInput = {
  accural_from_day: Scalars['String']['input'];
  accural_from_month: Scalars['String']['input'];
  pto_policy?: InputMaybe<PolicyTypeEnum>;
  pto_schedule: PtoScheduleEnum;
  reset_to_day: Scalars['String']['input'];
  reset_to_month: Scalars['String']['input'];
};

export type EntitlementType = {
  __typename?: 'entitlementType';
  accural_from_day?: Maybe<Scalars['String']['output']>;
  accural_from_month?: Maybe<Scalars['String']['output']>;
  pto_policy?: Maybe<Scalars['String']['output']>;
  pto_schedule?: Maybe<Scalars['String']['output']>;
  reset_to_day?: Maybe<Scalars['String']['output']>;
  reset_to_month?: Maybe<Scalars['String']['output']>;
};

export enum EnumActive {
  Active = 'active',
  Inactive = 'inactive'
}

export enum EnumAssetType {
  Accessory = 'accessory',
  Asset = 'asset'
}

export enum EnumEventType {
  Birthday = 'birthday',
  PublicHoliday = 'publicHoliday',
  Task = 'task',
  TimeOff = 'timeOff'
}

export enum EnumGarnishment {
  Monthly = 'monthly',
  Yearly = 'yearly'
}

export enum EnumObjectiveAssignmentStatus {
  Assigned = 'assigned',
  Unassigned = 'unassigned'
}

export enum EnumReasonMark {
  All = 'All',
  Damage = 'Damage',
  Defective = 'Defective',
  Missing = 'Missing',
  Stolen = 'Stolen'
}

export enum EnumReasonType {
  FamilyEmergency = 'FAMILY_EMERGENCY',
  Miscommunication = 'MISCOMMUNICATION',
  SickLeave = 'SICK_LEAVE',
  SupervisorApproved = 'SUPERVISOR_APPROVED',
  TravelIssue = 'TRAVEL_ISSUE',
  UnplannedAbsence = 'UNPLANNED_ABSENCE',
  ForgotCheckIn = 'forgot_check_in',
  ForgotCheckOut = 'forgot_check_out',
  LateComming = 'late_comming',
  Lateness = 'lateness',
  Other = 'other',
  SystemError = 'system_error'
}

export type ErrorMessage = {
  __typename?: 'errorMessage';
  date?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type EvaluationEmailInput = {
  performanceCycleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type EvaluatorInputs = {
  department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ExpenseCategory = {
  __typename?: 'expenseCategory';
  created_at?: Maybe<Scalars['Date']['output']>;
  expenseInvoice?: Maybe<GetExpenseInvoice>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice?: Maybe<Array<Maybe<InvoicesList>>>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ExpenseFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  expense_date?: InputMaybe<Scalars['DateTime']['input']>;
  expense_type?: InputMaybe<Scalars['String']['input']>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_business_expense: Scalars['Boolean']['input'];
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ExpenseRequestFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  expense_status?: InputMaybe<ExpenseStatus>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum ExpenseStatus {
  Accepted = 'accepted',
  All = 'all',
  Archive = 'archive',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type ExpnseResult = {
  __typename?: 'expnseResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<Expense>>>;
};

export type ExpnseResultUpdate = {
  __typename?: 'expnseResultUpdate';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Expense>>>;
};

export enum FeatureEnum {
  CalendarBirthdayEvent = 'calendar_birthday_event',
  CalendarLeaveEvent = 'calendar_leave_event',
  CalendarPublicholidayEvent = 'calendar_publicholiday_event',
  CalendarTaskEvent = 'calendar_task_event',
  ComplianceDashboard = 'compliance_dashboard',
  DocumentControl = 'document_control',
  ExternalVendorTrainingTab = 'external_vendor_training_tab',
  ManageEmployee = 'manage_employee',
  QuizList = 'quiz_list',
  RefresherCycleTab = 'refresher_cycle_tab',
  Schedule = 'schedule',
  Task = 'task',
  Timesheet = 'timesheet',
  Training = 'training',
  TrainingFailureResetTab = 'training_failure_reset_tab',
  TrainingMatrixTab = 'training_matrix_tab',
  TrainingMilestoneTab = 'training_milestone_tab',
  TrainingOrientationTab = 'training_orientation_tab',
  TrainingSettingsTab = 'training_settings_tab',
  Writeup = 'writeup'
}

export type FeatureHierarchy = {
  __typename?: 'featureHierarchy';
  feature?: Maybe<Scalars['String']['output']>;
  is_all?: Maybe<Scalars['Boolean']['output']>;
  is_only_me?: Maybe<Scalars['Boolean']['output']>;
  is_peer?: Maybe<Scalars['Boolean']['output']>;
  is_under_them?: Maybe<Scalars['Boolean']['output']>;
};

export type FeatureHierarchyInput = {
  feature: FeatureEnum;
  is_all: Scalars['Boolean']['input'];
  is_only_me?: InputMaybe<Scalars['Boolean']['input']>;
  is_peer: Scalars['Boolean']['input'];
  is_under_them: Scalars['Boolean']['input'];
};

export type FeedbackFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  submitted_by: SubmittedBy;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type Field = {
  assetName?: InputMaybe<Scalars['String']['input']>;
  labelName?: InputMaybe<Scalars['String']['input']>;
};

export type FieldData = {
  __typename?: 'fieldData';
  assetName?: Maybe<Scalars['String']['output']>;
  labelName?: Maybe<Scalars['String']['output']>;
};

export type FileUploadDocumentControl = {
  attachment: Scalars['Upload']['input'];
  expiry?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Fileuploadsize = {
  __typename?: 'fileuploadsize';
  percent?: Maybe<Scalars['Int']['output']>;
};

export enum FilterAlerts {
  All = 'all',
  LeaseExpiry = 'leaseExpiry',
  MaintenanceDue = 'maintenanceDue',
  MaintenanceRecur = 'maintenanceRecur',
  Warranty = 'warranty'
}

export enum FilterAsset {
  All = 'all',
  Archive = 'archive',
  Assigned = 'assigned',
  Disposed = 'disposed',
  Leased = 'leased',
  Maintenance = 'maintenance',
  Unassigned = 'unassigned'
}

export enum FilterEmployee {
  Active = 'active',
  All = 'all',
  Archive = 'archive',
  Inactive = 'inactive'
}

export type FilterHistory = {
  action_type?: InputMaybe<ActionTypeEnum>;
  employee_type?: InputMaybe<EmployeeTypeEnum>;
  pay_type?: InputMaybe<PayTypeEnum>;
  status?: InputMaybe<StatusEnum>;
};

export type FilterInput = {
  businessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  purchasesReportType?: InputMaybe<PurchasesReportType>;
  salesReportType?: InputMaybe<SalesReportType>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FilterInvoice = {
  grandTotal?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export enum FilterLeaves {
  All = 'All',
  OnDuty = 'OnDuty',
  Paid = 'Paid',
  Unpaid = 'Unpaid',
  Active = 'active',
  Archive = 'archive'
}

export enum FilterMaintenance {
  All = 'all',
  Archive = 'archive',
  Completed = 'completed',
  InProgress = 'inProgress',
  OnHold = 'onHold',
  Scheduled = 'scheduled'
}

export enum FilterRoster {
  Active = 'active',
  All = 'all',
  Archive = 'archive'
}

export enum FilterSchedule {
  Active = 'active',
  All = 'all',
  Archive = 'archive'
}

export enum FilterTask {
  All = 'all',
  AssignToMe = 'assign_to_me',
  AssignedByMe = 'assigned_by_me',
  MyTasks = 'my_tasks'
}

export type FilterTrainingAssignementResult = {
  __typename?: 'filterTrainingAssignementResult';
  _id?: Maybe<Scalars['ID']['output']>;
  attachments?: Maybe<Array<QuizTrainingAttachment>>;
  email?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['DateTime']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  training_end_time?: Maybe<Scalars['DateTime']['output']>;
  training_start_time?: Maybe<Scalars['DateTime']['output']>;
};

export type FiltersQueryInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
  first_condition?: InputMaybe<Scalars['String']['input']>;
  first_value?: InputMaybe<Scalars['String']['input']>;
  second_condition?: InputMaybe<Scalars['String']['input']>;
  second_value?: InputMaybe<Scalars['String']['input']>;
};

export type FiltersQueryType = {
  __typename?: 'filtersQueryType';
  condition?: Maybe<Scalars['String']['output']>;
  first_condition?: Maybe<Scalars['String']['output']>;
  first_value?: Maybe<Scalars['String']['output']>;
  second_condition?: Maybe<Scalars['String']['output']>;
  second_value?: Maybe<Scalars['String']['output']>;
};

export type FinalSettlementFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type FinalSettlementResult = {
  __typename?: 'finalSettlementResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<FinalSettlement>>>;
};

export enum ForUserDashbaord {
  Task = 'task',
  Timesheet = 'timesheet'
}

export type ForgetBusinessInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<AllowMethodPhoneVerify>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum GarnishmentTypeEnums {
  UnpaidChildSupport = 'UNPAID_CHILD_SUPPORT',
  UnpaidLoans = 'UNPAID_LOANS',
  UnpaidTaxes = 'UNPAID_TAXES'
}

export type GeneratedAssetIds = {
  __typename?: 'generatedAssetIds';
  generatedAssetId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GetAdminDashboardData = {
  __typename?: 'getAdminDashboardData';
  approvals?: Maybe<Approval>;
  assets?: Maybe<Assets>;
  presentAbsentLeave?: Maybe<PresentAbsentLeave>;
  taskManagementCount?: Maybe<TaskManagementCount>;
  total_employees?: Maybe<Array<Maybe<TotalEmployees>>>;
};

export type GetAuthenticatorAppDataTableInput = {
  app_id?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  search_field?: InputMaybe<AuthenticatorSearchFieldEnum>;
  shared_with?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAuthenticatorAppInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetCashRegistersHistoryInput = {
  businessLocation: Scalars['ID']['input'];
  cashRegister: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GetCategoriesList = {
  __typename?: 'getCategoriesList';
  config?: Maybe<UpdatedDataTableConfig>;
  data?: Maybe<Array<Maybe<AssetCategories>>>;
};

export type GetContributionFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetDeductionFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetDisposeList = {
  __typename?: 'getDisposeList';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Asset>>>;
};

export type GetEncryptionCopyInput = {
  from_user?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  user: Scalars['ID']['input'];
};

export type GetExpenseInvoice = {
  __typename?: 'getExpenseInvoice';
  category?: Maybe<Array<Maybe<ExpenseCategory>>>;
  category_count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  detail?: Maybe<InvoiceDetails>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice?: Maybe<Array<Maybe<InvoicesList>>>;
  invoice_count?: Maybe<Scalars['Int']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type GetExpenseInvoiceAndCategory = {
  __typename?: 'getExpenseInvoiceAndCategory';
  category_count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  detail?: Maybe<InvoiceCategoryDetails>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice_count?: Maybe<Scalars['Int']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type GetExpenseInvoiceCategory = {
  __typename?: 'getExpenseInvoiceCategory';
  category?: Maybe<ExpenseCategory>;
  created_at?: Maybe<Scalars['Date']['output']>;
  expenseInvoice?: Maybe<ExpenseCategory>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice?: Maybe<Array<Maybe<InvoicesList>>>;
  invoice_number?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type GetExpenseInvoiceCategoryList = {
  __typename?: 'getExpenseInvoiceCategoryList';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<GetExpenseInvoiceCategory>>>;
};

export type GetExpenseInvoiceList = {
  __typename?: 'getExpenseInvoiceList';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<GetExpenseInvoice>>>;
};

export type GetGoals = {
  __typename?: 'getGoals';
  _id?: Maybe<Scalars['ID']['output']>;
  business?: Maybe<Business>;
  business_type?: Maybe<BusinessType>;
  count_no_by_goal_period?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Array<Maybe<Department>>>;
  employees?: Maybe<Array<Maybe<User>>>;
  goal_name?: Maybe<Scalars['String']['output']>;
  goal_period?: Maybe<GoalPeriod>;
  goal_type?: Maybe<GoalType>;
  is_all_department?: Maybe<Scalars['Boolean']['output']>;
  is_all_employee?: Maybe<Scalars['Boolean']['output']>;
  is_amount?: Maybe<Scalars['Boolean']['output']>;
  is_percentage?: Maybe<Scalars['Boolean']['output']>;
  recurring?: Maybe<Scalars['Boolean']['output']>;
  sales_target_incentive?: Maybe<Scalars['Int']['output']>;
  sales_target_value?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  store?: Maybe<BusinessLocation>;
  target_by_departments?: Maybe<Array<Maybe<TargetByDepartments>>>;
  target_by_employees?: Maybe<Array<Maybe<TargetByEmployees>>>;
  target_by_products?: Maybe<Array<Maybe<TargetByProducts>>>;
};

export type GetGroupsInput = {
  Ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  group_type: Group_Type;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetInvoiceExpenseAndCategoryList = {
  __typename?: 'getInvoiceExpenseAndCategoryList';
  config?: Maybe<UpdatedDataTableConfig>;
  data?: Maybe<Array<Maybe<GetExpenseInvoiceAndCategory>>>;
};

export type GetInvoiceExpenseList = {
  __typename?: 'getInvoiceExpenseList';
  config?: Maybe<DataTableConfig>;
  data?: Maybe<Array<Maybe<GetExpenseInvoice>>>;
};

export type GetInvoiceItemList = {
  __typename?: 'getInvoiceItemList';
  data?: Maybe<Array<Maybe<InvoiceItem>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type GetInvoiceItemType = {
  __typename?: 'getInvoiceItemType';
  data?: Maybe<Array<Maybe<InvoiceItemDetails>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type GetInvoiceList = {
  __typename?: 'getInvoiceList';
  config?: Maybe<UpdatedDataTableConfig>;
  data?: Maybe<Array<Maybe<InvoiceData>>>;
};

export type GetLeaveAfterLastWorkingDayInput = {
  last_working_date: Scalars['DateTime']['input'];
  userId: Scalars['ID']['input'];
};

export type GetLeavePolicyArguments = {
  department?: InputMaybe<Scalars['ID']['input']>;
  designation?: InputMaybe<Scalars['ID']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
};

export type GetLinkedBusinessInput = {
  status?: InputMaybe<Scalars['String']['input']>;
  type: LinkedBusinessTypeEnum;
};

export type GetMarkInvoiceItems = {
  archive?: InputMaybe<ArchiveEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetPaymentMethod = {
  __typename?: 'getPaymentMethod';
  billing_details?: Maybe<Billing_Details>;
  card?: Maybe<Card>;
  customer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type GetQuickAsset = {
  __typename?: 'getQuickAsset';
  data?: Maybe<Array<Maybe<Asset>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type GetReserveAssetColor = {
  __typename?: 'getReserveAssetColor';
  employeeColor?: Maybe<Scalars['String']['output']>;
  siteColor?: Maybe<Scalars['String']['output']>;
};

export type GetReviewReport = {
  __typename?: 'getReviewReport';
  cycleId?: Maybe<Scalars['String']['output']>;
  cycle_name?: Maybe<Scalars['String']['output']>;
  employeID?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GetRosterWithFilter = {
  department?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type GetScheduleByEmployeeIdInput = {
  employee: Scalars['ID']['input'];
  from_date: Scalars['Date']['input'];
  to_date: Scalars['Date']['input'];
};

export type GetScheduleGraphData = {
  __typename?: 'getScheduleGraphData';
  normalTime?: Maybe<Scalars['Float']['output']>;
  paidBreakMinuts?: Maybe<Scalars['Float']['output']>;
  paidLeaves?: Maybe<Scalars['Float']['output']>;
  scheduleEmployees?: Maybe<Scalars['Int']['output']>;
  scheduleMinuts?: Maybe<Scalars['Float']['output']>;
  unpaidLeaves?: Maybe<Scalars['Float']['output']>;
  unpaidbreakMinuts?: Maybe<Scalars['Float']['output']>;
  wages?: Maybe<Array<Maybe<Wages>>>;
};

export type GetShipToType = {
  __typename?: 'getShipToType';
  created_at?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type GetTillCountInput = {
  businessLocation: Scalars['ID']['input'];
  cashRegister: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTimeSheetGraph = {
  department?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['ID']['input']>;
  start_date: Scalars['String']['input'];
};

export type GiftCardCategoryList = {
  __typename?: 'giftCardCategoryList';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<GiftCardCategory>>>;
};

export type GiftCardCategoryListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GiftCardInput = {
  BusinessLocation: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  business?: InputMaybe<Scalars['ID']['input']>;
  business_type?: InputMaybe<BusinessType>;
  from: Scalars['ID']['input'];
  gift_card_url?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  send_gift_card: Scalars['DateTime']['input'];
  subject: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type GiftCardListFilter = {
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  headerFilter?: InputMaybe<HeaderFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GiftCardListingResult = {
  __typename?: 'giftCardListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<GiftCard>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export enum GoalPeriod {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export enum GoalType {
  DepartmentGoal = 'department_goal',
  EmployeeGoal = 'employee_goal'
}

export type Goals = {
  __typename?: 'goals';
  _id?: Maybe<Scalars['ID']['output']>;
  business?: Maybe<Scalars['ID']['output']>;
  business_type?: Maybe<BusinessType>;
  count_no_by_goal_period?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  employees?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  goal_name?: Maybe<Scalars['String']['output']>;
  goal_period?: Maybe<GoalPeriod>;
  goal_type?: Maybe<GoalType>;
  is_all_department?: Maybe<Scalars['Boolean']['output']>;
  is_all_employee?: Maybe<Scalars['Boolean']['output']>;
  is_amount?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_percentage?: Maybe<Scalars['Boolean']['output']>;
  recurring?: Maybe<Scalars['Boolean']['output']>;
  sales_target_incentive?: Maybe<Scalars['Int']['output']>;
  sales_target_value?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  store?: Maybe<Scalars['ID']['output']>;
  target_by_departments?: Maybe<Array<Maybe<TargetByDepartments>>>;
  target_by_employees?: Maybe<Array<Maybe<TargetByEmployees>>>;
  target_by_products?: Maybe<Array<Maybe<TargetByProducts>>>;
};

export type GoalsInput = {
  business?: InputMaybe<Scalars['ID']['input']>;
  business_type?: InputMaybe<BusinessType>;
  count_no_by_goal_period?: InputMaybe<Scalars['Int']['input']>;
  department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  goal_name?: InputMaybe<Scalars['String']['input']>;
  goal_period?: InputMaybe<GoalPeriod>;
  goal_type?: InputMaybe<GoalType>;
  is_all_department?: InputMaybe<Scalars['Boolean']['input']>;
  is_all_employee?: InputMaybe<Scalars['Boolean']['input']>;
  is_amount?: InputMaybe<Scalars['Boolean']['input']>;
  is_percentage?: InputMaybe<Scalars['Boolean']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  sales_target_incentive?: InputMaybe<Scalars['Int']['input']>;
  sales_target_value?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  target_by_departments?: InputMaybe<Array<InputMaybe<TargetByDepartmentsInput>>>;
  target_by_employees?: InputMaybe<Array<InputMaybe<TargetByEmployeesInput>>>;
  target_by_products?: InputMaybe<Array<InputMaybe<TargetByProductsInput>>>;
};

export type GoalsListFilter = {
  business?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type GoalsListingresult = {
  __typename?: 'goalsListingresult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<Goals>>>;
};

export type GrandTotalResult = {
  __typename?: 'grandTotalResult';
  absent?: Maybe<Scalars['Int']['output']>;
  block?: Maybe<Scalars['Int']['output']>;
  departmentWiseOT?: Maybe<DepartmentOvertimeResult>;
  earlyIn?: Maybe<Scalars['Int']['output']>;
  earlyOut?: Maybe<Scalars['Int']['output']>;
  lateOut?: Maybe<Scalars['Int']['output']>;
  lateness?: Maybe<Scalars['Int']['output']>;
  missPunchOut?: Maybe<Scalars['Int']['output']>;
  notComing?: Maybe<Scalars['Int']['output']>;
  onLeave?: Maybe<Scalars['Int']['output']>;
  onTimeIn?: Maybe<Scalars['Int']['output']>;
  onTimeOut?: Maybe<Scalars['Int']['output']>;
  paidLeave?: Maybe<Scalars['Int']['output']>;
  present?: Maybe<Scalars['Int']['output']>;
  publicHoliday?: Maybe<Scalars['Int']['output']>;
  restrected?: Maybe<Scalars['Int']['output']>;
  scheduleTime?: Maybe<Scalars['String']['output']>;
  shortLeave?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  unpaidLeave?: Maybe<Scalars['Int']['output']>;
  unrestrected?: Maybe<Scalars['Int']['output']>;
  unrestrictedWorkingTime?: Maybe<Scalars['String']['output']>;
  wages?: Maybe<Scalars['Float']['output']>;
  weekend?: Maybe<Scalars['Int']['output']>;
  workingTime?: Maybe<Scalars['String']['output']>;
};

export type GrandTotalWagesGraph = {
  __typename?: 'grandTotalWagesGraph';
  grand_total?: Maybe<Scalars['Float']['output']>;
  wages_by_date?: Maybe<Array<Maybe<WagesByDate>>>;
};

export type GraphOfTimeSheet = {
  __typename?: 'graphOfTimeSheet';
  clockStatus?: Maybe<Array<Maybe<ClockStatus>>>;
  presentAbsentLeave?: Maybe<PresentAbsentLeave>;
  scheduleEmployeeAndHours?: Maybe<ScheduleEmployeeAndHours>;
  totalWagesAndScheduleHours?: Maybe<Array<Maybe<TotalWagesAndScheduleHours>>>;
};

export type GrounpEvaluationListResult = {
  __typename?: 'grounpEvaluationListResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<GroupGoalsListType>>>;
};

export enum GroupAssignees {
  Automatic = 'Automatic',
  None = 'None'
}

export type GroupClockHistory = {
  __typename?: 'groupClockHistory';
  ClockedHistory?: Maybe<Array<Maybe<ClockedHistory>>>;
  countStatus?: Maybe<CountStatusGroupedEmployee>;
};

export type GroupEmployeeInput = {
  absents?: InputMaybe<Scalars['Boolean']['input']>;
  activeStatus?: InputMaybe<Array<InputMaybe<ClockedInStatusEnum>>>;
  break?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  leave?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  screen_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  short_break?: InputMaybe<Scalars['Boolean']['input']>;
  sort_by?: InputMaybe<Sort_By_Enum>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupGoalsListType = {
  __typename?: 'groupGoalsListType';
  _id?: Maybe<Scalars['ID']['output']>;
  detail?: Maybe<EmployeeDetail>;
  employees_count?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum GroupType {
  Decrement = 'Decrement',
  Department = 'Department',
  Employee = 'Employee',
  Increment = 'Increment',
  Role = 'Role'
}

export enum Group_Type {
  MyApp = 'my_app',
  SharedApp = 'shared_app'
}

export enum HalfDayConsideration {
  Schedule = 'Schedule',
  WeekHourLimit = 'weekHourLimit'
}

export enum HeaderFilter {
  All = 'all',
  NotUsed = 'not_used',
  Used = 'used'
}

export type HistoryListFilter = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type HistoryListingResult = {
  __typename?: 'historyListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<UserHistory>>>;
};

export type HistoryTimes = {
  __typename?: 'historyTimes';
  previous_time?: Maybe<Scalars['String']['output']>;
  updated_time?: Maybe<Scalars['String']['output']>;
};

export type HrPolicyInput = {
  Business?: InputMaybe<Scalars['String']['input']>;
  How_are_leaves_deducted?: InputMaybe<Scalars['String']['input']>;
  apply_penalty_employee_daily_salary?: InputMaybe<Scalars['Int']['input']>;
  attendance_after_days?: InputMaybe<Scalars['Int']['input']>;
  attendance_rule?: InputMaybe<Scalars['String']['input']>;
  base?: InputMaybe<Scalars['String']['input']>;
  before_early_clockin?: InputMaybe<Scalars['Int']['input']>;
  block_employee_account_after?: InputMaybe<Scalars['Int']['input']>;
  block_employee_account_after_days?: InputMaybe<Scalars['Int']['input']>;
  block_employee_default_message?: InputMaybe<Scalars['String']['input']>;
  block_user?: InputMaybe<Scalars['Boolean']['input']>;
  block_user_acount_number_breaks?: InputMaybe<Scalars['Int']['input']>;
  break_deduct_salary_for_every_minuts?: InputMaybe<Scalars['Int']['input']>;
  break_deduct_salary_for_every_per_minuts?: InputMaybe<Scalars['Int']['input']>;
  break_grace_period?: InputMaybe<Scalars['Boolean']['input']>;
  break_modify_message?: InputMaybe<Scalars['String']['input']>;
  breaks?: InputMaybe<Scalars['String']['input']>;
  clock_out_grace_period?: InputMaybe<Scalars['Boolean']['input']>;
  deafult_message_earlyOut?: InputMaybe<Scalars['Boolean']['input']>;
  deafult_missing_attendance_message?: InputMaybe<Scalars['Boolean']['input']>;
  deduct_annually_minuts?: InputMaybe<Scalars['Int']['input']>;
  deduct_days?: InputMaybe<Scalars['Int']['input']>;
  deduct_days_of_leave_incidents?: InputMaybe<Scalars['Int']['input']>;
  deduct_leave?: InputMaybe<Scalars['Boolean']['input']>;
  deduct_leave_time?: InputMaybe<Scalars['String']['input']>;
  deduct_salary_for_every?: InputMaybe<Scalars['Int']['input']>;
  deduct_salary_for_every_per_minuts?: InputMaybe<Scalars['Int']['input']>;
  deduction_based?: InputMaybe<Scalars['String']['input']>;
  default_message_early?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  earlyOut_deduct_based_on?: InputMaybe<Scalars['String']['input']>;
  earlyOut_deduct_salary_incidents?: InputMaybe<Scalars['Boolean']['input']>;
  earlyOut_maximum_early_time?: InputMaybe<Scalars['Int']['input']>;
  early_clockin?: InputMaybe<Scalars['Boolean']['input']>;
  employee_type?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  employesId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  for_every_incidents_late_coming?: InputMaybe<Scalars['Int']['input']>;
  grace_period?: InputMaybe<Scalars['Int']['input']>;
  group_name?: InputMaybe<Scalars['String']['input']>;
  hours_penalize_deduct_leave?: InputMaybe<Scalars['Boolean']['input']>;
  is_auto_clocked_in?: InputMaybe<Scalars['Boolean']['input']>;
  is_auto_miss_punch_writeup?: InputMaybe<Scalars['Boolean']['input']>;
  is_clocked_in_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_email_to_employee?: InputMaybe<Scalars['Boolean']['input']>;
  is_email_to_line_manager?: InputMaybe<Scalars['Boolean']['input']>;
  is_exclude_grace_time_in_working_hours?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid_for_extra_time?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid_weekend?: InputMaybe<Scalars['Boolean']['input']>;
  is_un_restricted: Scalars['Boolean']['input'];
  is_weekend_mode?: InputMaybe<Scalars['Boolean']['input']>;
  is_weekend_premium_after_limit?: InputMaybe<Scalars['Boolean']['input']>;
  is_weekend_premium_before_limit?: InputMaybe<Scalars['Boolean']['input']>;
  lateOut_maximum_late_time?: InputMaybe<Scalars['Int']['input']>;
  lateOut_message?: InputMaybe<Scalars['Boolean']['input']>;
  lateOut_message_late_time?: InputMaybe<Scalars['String']['input']>;
  late_clockin?: InputMaybe<Scalars['Boolean']['input']>;
  late_clockin_deduction?: InputMaybe<Scalars['String']['input']>;
  late_coming_incidents?: InputMaybe<Scalars['String']['input']>;
  maximum_absent_modify_message?: InputMaybe<Scalars['String']['input']>;
  maximum_emp_absent?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_emp_message?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_emp_time?: InputMaybe<Scalars['Int']['input']>;
  maximum_late_modify_message?: InputMaybe<Scalars['String']['input']>;
  maximum_late_time?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_late_time_deduction_after_minutes?: InputMaybe<Scalars['Int']['input']>;
  maximum_late_time_message?: InputMaybe<Scalars['Boolean']['input']>;
  maximum_no_days?: InputMaybe<Scalars['Int']['input']>;
  messge_earlyOut?: InputMaybe<Scalars['String']['input']>;
  minuts_period_break_in_out?: InputMaybe<Scalars['Int']['input']>;
  missing_attendance_message?: InputMaybe<Scalars['String']['input']>;
  modify_message_early?: InputMaybe<Scalars['String']['input']>;
  over_time_hours?: InputMaybe<Scalars['Int']['input']>;
  over_time_rate?: InputMaybe<Scalars['Float']['input']>;
  overtime?: InputMaybe<Scalars['String']['input']>;
  overtime_by_employeeType?: InputMaybe<Scalars['String']['input']>;
  paunch_out_mnts?: InputMaybe<Scalars['Int']['input']>;
  pay_type: Scalars['ID']['input'];
  penalize_deduct_leave?: InputMaybe<Scalars['Boolean']['input']>;
  percentage_Base?: InputMaybe<Scalars['String']['input']>;
  percentage_base_no_of_days?: InputMaybe<Scalars['Int']['input']>;
  percentage_base_percentage_of_hourse?: InputMaybe<Scalars['Int']['input']>;
  plenty_base?: InputMaybe<Scalars['String']['input']>;
  send_absent_email_to_line_manager?: InputMaybe<Scalars['Boolean']['input']>;
  send_break_email_to_employee?: InputMaybe<Scalars['Boolean']['input']>;
  send_break_email_to_line_manager?: InputMaybe<Scalars['Boolean']['input']>;
  wagebased?: InputMaybe<Scalars['Boolean']['input']>;
  wagebased_on?: InputMaybe<Scalars['String']['input']>;
  weekEndDays?: InputMaybe<Array<InputMaybe<WeekEndDays>>>;
  working_days?: InputMaybe<Scalars['Int']['input']>;
};

export type Image = {
  __typename?: 'image';
  _id?: Maybe<Scalars['ID']['output']>;
  dimension?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type ImportCsvSubsciption = {
  __typename?: 'importCsvSubsciption';
  currentEmployee?: Maybe<Scalars['Int']['output']>;
  doneEmployees?: Maybe<Scalars['Int']['output']>;
  employee_name?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
};

export type InLineFealdInput = {
  config_type: ConfigListingEnum;
  entity_id: Scalars['ID']['input'];
  field: Scalars['String']['input'];
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_unique?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum InformedBy {
  Email = 'Email',
  Phone = 'Phone',
  Sms = 'SMS',
  Whatsapp = 'Whatsapp'
}

export type InpuUserTimeSheetStatus = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type InputAllAppraisalType = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputAllEvaluation = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  performance_cycle_Id?: InputMaybe<Scalars['String']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputAllobjectiveAssignment = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  performanceCycle?: InputMaybe<Scalars['ID']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputAppraisalObjective = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputAppraisalScales = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputAssetByBusiness = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type InputAssetByEmployee = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputAttendceRequest = {
  attendance_date?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type InputBagShipping = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputBagVendor = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputBreakUpdate = {
  breaks?: InputMaybe<Array<InputMaybe<MultipleBreakPayload>>>;
  employee_id: Array<Scalars['ID']['input']>;
  end_date: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
};

export type InputCreateAdvanceFilter = {
  filter_name?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<ListingFiltersInput>>>;
  list_type?: InputMaybe<Scalars['String']['input']>;
};

export type InputDeviceInfoById = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['ID']['input'];
};

export type InputDocumentsWithFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  department?: InputMaybe<Scalars['ID']['input']>;
  document_type?: InputMaybe<DocumentType>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  order_by?: InputMaybe<SortEnum>;
  page: Scalars['Int']['input'];
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputEmailTemplateList = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type InputEmployeeDocuments = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  order_by?: InputMaybe<SortEnum>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type InputEmployeeTimeSheet = {
  clockedInStatus?: InputMaybe<Array<InputMaybe<ClockInEnum>>>;
  clockedOutStatus?: InputMaybe<Array<InputMaybe<ClockOutEnum>>>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  currentView?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['DateTime']['input'];
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  over_time?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  payrollType?: InputMaybe<PayrollType>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  rosterStore?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<AttendanceWithStatus>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
  timeOff?: InputMaybe<_Schedule>;
};

export type InputExpenseRequestUser = {
  expense_date?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type InputFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type InputGetAllTaxes = {
  archive?: InputMaybe<ArchiveEnum>;
};

export type InputGetReportObjective = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputGetShippingWithSearch = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<ArchiveEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputGetVendorWithSearch = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<ArchiveEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputGrandTotal = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type InputLoanRequestUser = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  request_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InputMarginTiersSearch = {
  Business?: InputMaybe<Scalars['ID']['input']>;
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<ArchiveEnum>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputOfTypes = {
  type: Scalars['Boolean']['input'];
};

export type InputPayrollList = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_dispersed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pay_period: PayrollPayPeriodEnum;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputPerformanceCycleType = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputPerformance_Cycles = {
  ApraisalObjectiveAssignmnet?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  measurement?: InputMaybe<Scalars['Float']['input']>;
  objectiveAssigned?: InputMaybe<Scalars['ID']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  target?: InputMaybe<Scalars['Float']['input']>;
  weight_percent?: InputMaybe<Scalars['Float']['input']>;
};

export type InputProfitCategory = {
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  Category: Scalars['ID']['input'];
  markup?: InputMaybe<Scalars['Float']['input']>;
};

export type InputProfitCategoryWithSearch = {
  Category?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<ArchiveEnum>;
  id?: InputMaybe<Scalars['ID']['input']>;
  markup?: InputMaybe<Scalars['Float']['input']>;
};

export type InputReason = {
  reason_name: Scalars['String']['input'];
  reason_type: ReasonTypeEnum;
};

export type InputReasonMark = {
  type: EnumReasonMark;
};

export type InputRecruitment = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputRepairPrice = {
  DeviceIssue: Array<Scalars['ID']['input']>;
  DeviceModel: Scalars['ID']['input'];
  Service: Scalars['ID']['input'];
  created_by?: InputMaybe<Scalars['ID']['input']>;
  minimum_price: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  repair_label: Scalars['String']['input'];
};

export type InputRepairPriceWithSearch = {
  archive?: InputMaybe<ArchiveEnum>;
  repair_label?: InputMaybe<Scalars['String']['input']>;
};

export type InputReserveAssetColor = {
  employeeColor: Scalars['String']['input'];
  siteColor: Scalars['String']['input'];
};

export type InputReviewcyclereport = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputSearchMarkReason = {
  archive?: InputMaybe<ArchiveEnum>;
};

export type InputTerminalAppHistory = {
  appType?: InputMaybe<Application_Type>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type InputTimeOffRequestUser = {
  from_timeOff_date?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  to_timeOff_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InputTimeSheet = {
  clockedInStatus?: InputMaybe<Array<InputMaybe<ClockInEnum>>>;
  clockedOutStatus?: InputMaybe<Array<InputMaybe<ClockOutEnum>>>;
  currentView?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  over_time?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  payrollType?: InputMaybe<PayrollType>;
  role?: InputMaybe<Scalars['ID']['input']>;
  rosterStore?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<AttendanceWithStatus>;
  timeOff?: InputMaybe<_Schedule>;
};

export type InputTimeSheetEmployee = {
  employee?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type InputTimeSheetEmployeeId = {
  employee: Scalars['ID']['input'];
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  status: AttendanceWithStatus;
};

export type InputTypeMarginTiers = {
  from_price?: InputMaybe<Scalars['Float']['input']>;
  markup?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  to_price?: InputMaybe<Scalars['Float']['input']>;
};

export type InputUpdateBrand = {
  _id: Scalars['ID']['input'];
  brand_name?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateMarginTiers = {
  Business?: InputMaybe<Scalars['ID']['input']>;
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  from_price?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  markup?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  to_price?: InputMaybe<Scalars['Float']['input']>;
};

export type InputUpdateModel = {
  AssetBrand?: InputMaybe<Scalars['ID']['input']>;
  _id: Scalars['ID']['input'];
  model_name?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateMultipleSubCateg = {
  AssetCategory?: InputMaybe<Scalars['ID']['input']>;
  subCatgeoryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCatgeoryObj?: InputMaybe<Array<InputMaybe<SubCatgoryObjs>>>;
};

export type InputUpdateProfitCategory = {
  Business?: InputMaybe<Scalars['ID']['input']>;
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  Category?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  markup?: InputMaybe<Scalars['Float']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type InputUpdateReason = {
  id: Scalars['ID']['input'];
  reason_name?: InputMaybe<Scalars['String']['input']>;
  reason_type?: InputMaybe<ReasonTypeEnum>;
};

export type InputUpdateRepairPrice = {
  Business?: InputMaybe<Scalars['ID']['input']>;
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  DeviceIssue?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  DeviceModel?: InputMaybe<Scalars['ID']['input']>;
  Service?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  minimum_price?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  repair_label?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Scalars['ID']['input']>;
};

export type InputUpdateShipping = {
  _id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateVendor = {
  _id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputUserAppDevice = {
  Business: Scalars['ID']['input'];
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  app_type: AppTypes;
  device_id: Scalars['String']['input'];
  device_manufacturer?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  device_name?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  operating_system?: InputMaybe<Scalars['String']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  sim_network?: InputMaybe<Scalars['String']['input']>;
  sim_number?: InputMaybe<Scalars['String']['input']>;
};

export type InputUserMonthly = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type InputWithFilter = {
  department?: InputMaybe<Scalars['ID']['input']>;
  document_type?: InputMaybe<DocumentTypeEnum>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type: DocumentTypeEnums;
};

export type InputadminDashboard = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  start_date: Scalars['String']['input'];
};

export type Inputcolumn_Dropdown_Value = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InputfilterAssetBrand = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputobjectiveAssigned = {
  AppraisalObjective?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['Float']['input']>;
  weight_percent?: InputMaybe<Scalars['Float']['input']>;
};

export type InsuranceLinking = {
  insurance?: InputMaybe<Scalars['ID']['input']>;
};

export type InsuranceLinks = {
  __typename?: 'insuranceLinks';
  insurance?: Maybe<Insurance>;
};

export type InsuranceListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InsuranceListingResult = {
  __typename?: 'insuranceListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Insurance>>>;
};

export type InsuranceLogs = {
  __typename?: 'insuranceLogs';
  action?: Maybe<Scalars['String']['output']>;
  assigned?: Maybe<Asset>;
  created_by?: Maybe<User>;
  date?: Maybe<Scalars['Date']['output']>;
};

export type InvoiceCategoryDetails = {
  __typename?: 'invoiceCategoryDetails';
  actions?: Maybe<Array<Maybe<ConfigActionType>>>;
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<ExpenseCategory>>>;
};

export type InvoiceDetail = {
  __typename?: 'invoiceDetail';
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<InvoiceItemsType>>>;
};

export type InvoiceDetails = {
  __typename?: 'invoiceDetails';
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<InvoiceItemsTypes>>>;
};

export type InvoiceItem = {
  __typename?: 'invoiceItem';
  _id?: Maybe<Scalars['ID']['output']>;
  assetIds?: Maybe<Asset>;
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceObjectId?: Maybe<Scalars['ID']['output']>;
  is_expense?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  serial_number?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type InvoiceItemDetails = {
  __typename?: 'invoiceItemDetails';
  _id?: Maybe<Scalars['ID']['output']>;
  assetIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  expenseId?: Maybe<Scalars['ID']['output']>;
  expenseInvCategoryId?: Maybe<Scalars['ID']['output']>;
  is_expense?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type InvoiceItems = {
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  color?: InputMaybe<Scalars['String']['input']>;
  expenseId?: InputMaybe<Scalars['ID']['input']>;
  expenseInvCategoryId?: InputMaybe<Scalars['ID']['input']>;
  is_expense?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newCreatedAssetsList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceItemsType = {
  __typename?: 'invoiceItemsType';
  assetIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  expenseId?: Maybe<GetExpenseInvoice>;
  expenseInvCategoryId?: Maybe<ExpenseCategory>;
  id?: Maybe<Scalars['ID']['output']>;
  is_expense?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  serial_number?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type InvoiceItemsTypes = {
  __typename?: 'invoiceItemsTypes';
  category?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoice_name?: Maybe<Scalars['String']['output']>;
  invoice_number?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
};

export type InvoicesInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  filterInvoice?: InputMaybe<FilterInvoice>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InvoicesList = {
  __typename?: 'invoicesList';
  assignToAsset?: Maybe<Scalars['Float']['output']>;
  billTo?: Maybe<GetShipToType>;
  company?: Maybe<Scalars['String']['output']>;
  courtesyCredit?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  grandTotal?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceItems?: Maybe<Array<Maybe<InvoiceItemsType>>>;
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  invoice_image?: Maybe<Scalars['String']['output']>;
  invoice_image_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['Date']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  shipTo?: Maybe<GetShipToType>;
  shippingMethod?: Maybe<ShippingMethods>;
  subTotal?: Maybe<Scalars['Float']['output']>;
  taxes?: Maybe<Scalars['Float']['output']>;
  toPayOff?: Maybe<Scalars['Float']['output']>;
  totalInvoiceItems?: Maybe<Scalars['Float']['output']>;
  totalPaid?: Maybe<Scalars['Float']['output']>;
  totalProducts?: Maybe<Scalars['Float']['output']>;
  totalQty?: Maybe<Scalars['Int']['output']>;
  totalSerialNumber?: Maybe<Scalars['Float']['output']>;
  totalShippingCharges?: Maybe<Scalars['Float']['output']>;
  totalSku?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendors>;
};

export enum IsActive {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export enum Is_Active {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export type JoiningLatterInput = {
  Joining_formalities?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
};

export type Joining_Latter = {
  __typename?: 'joining_latter';
  Joining_formalities?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
};

export type Joiningdateinput = {
  joining_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LeaseListFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type LeaveAccuralDetail = {
  __typename?: 'leaveAccuralDetail';
  employee_id: Scalars['ID']['output'];
  from_date: Scalars['DateTime']['output'];
  to_date: Scalars['DateTime']['output'];
};

export type LeaveAccuralInput = {
  employee_id: Scalars['ID']['input'];
  from_date: Scalars['DateTime']['input'];
  to_date: Scalars['DateTime']['input'];
};

export type LeaveAccuralLogs = {
  __typename?: 'leaveAccuralLogs';
  action_date?: Maybe<Scalars['DateTime']['output']>;
  carry_forword?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  pay_off?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<LeaveType>;
};

export type LeaveAdjustmentInput = {
  leave_type: Scalars['ID']['input'];
  opening_balance_days?: InputMaybe<Scalars['Int']['input']>;
  opening_balance_hours?: InputMaybe<Scalars['Int']['input']>;
  opening_balance_minutes?: InputMaybe<Scalars['Int']['input']>;
};

export enum LeaveDuration {
  FullDay = 'FullDay',
  HalfDay = 'HalfDay'
}

export enum LeaveEntitlement {
  Monthly = 'Monthly',
  Yearly = 'Yearly'
}

export type LeaveInput = {
  end_time?: InputMaybe<Scalars['String']['input']>;
  from_date: Scalars['DateTime']['input'];
  is_out_of_accural_leave?: InputMaybe<Scalars['Boolean']['input']>;
  is_sandwich?: InputMaybe<Scalars['Boolean']['input']>;
  leave_date?: InputMaybe<Scalars['DateTime']['input']>;
  leave_minutes?: InputMaybe<Scalars['Int']['input']>;
  leave_type?: InputMaybe<Scalars['String']['input']>;
  no_of_days?: InputMaybe<Scalars['Float']['input']>;
  out_of_accural_leave_days?: InputMaybe<Scalars['Float']['input']>;
  out_of_accural_leave_hours?: InputMaybe<Scalars['Float']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  to_date: Scalars['DateTime']['input'];
  totalMinuts?: InputMaybe<Scalars['Float']['input']>;
};

export type LeaveInputType = {
  __typename?: 'leaveInputType';
  end_time?: Maybe<Scalars['String']['output']>;
  from_date: Scalars['DateTime']['output'];
  is_out_of_accural_leave?: Maybe<Scalars['Boolean']['output']>;
  is_sandwich?: Maybe<Scalars['Boolean']['output']>;
  leave_date?: Maybe<Scalars['DateTime']['output']>;
  leave_type?: Maybe<Scalars['String']['output']>;
  no_of_days?: Maybe<Scalars['Float']['output']>;
  out_of_accural_leave_days?: Maybe<Scalars['Float']['output']>;
  out_of_accural_leave_hours?: Maybe<Scalars['Float']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  to_date: Scalars['DateTime']['output'];
  totalMinuts?: Maybe<Scalars['Float']['output']>;
};

export type LeavePolicyInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  accrual_no_of_hours?: InputMaybe<Scalars['Float']['input']>;
  accrual_on_day?: InputMaybe<Scalars['String']['input']>;
  accrual_on_month?: InputMaybe<MonthEnum>;
  accrual_one_time_day?: InputMaybe<Scalars['String']['input']>;
  accrual_one_time_month?: InputMaybe<MonthEnum>;
  accrual_type?: InputMaybe<YearlyMonthlyEnum>;
  assign_to?: InputMaybe<Array<AssignToPolicyInput>>;
  business?: InputMaybe<Scalars['ID']['input']>;
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  carry_forward_limit?: InputMaybe<Scalars['Float']['input']>;
  is_accrual?: InputMaybe<Scalars['Boolean']['input']>;
  is_carry_forward_percentage?: InputMaybe<Scalars['Boolean']['input']>;
  is_hourly_employee_sandwich?: InputMaybe<Scalars['Boolean']['input']>;
  is_manual_deduction?: InputMaybe<Scalars['Boolean']['input']>;
  is_reset?: InputMaybe<Scalars['Boolean']['input']>;
  is_salary_employee_sandwich?: InputMaybe<Scalars['Boolean']['input']>;
  is_short_leave_sandwich?: InputMaybe<Scalars['Boolean']['input']>;
  is_user_input_value?: InputMaybe<Scalars['Boolean']['input']>;
  is_week_hour_limit?: InputMaybe<Scalars['Boolean']['input']>;
  leaves: Array<LeavesInput>;
  manual_deduction_value?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  policy_type?: InputMaybe<PolicyTypeEnum>;
  reset_accural_date?: InputMaybe<Scalars['String']['input']>;
  reset_carry_forward?: InputMaybe<CarryForwardEnum>;
  reset_carry_forward_count?: InputMaybe<Scalars['Float']['input']>;
  reset_carry_forward_type?: InputMaybe<CarryForwardTypeEnum>;
  reset_max_limit?: InputMaybe<Scalars['Float']['input']>;
  reset_on_day?: InputMaybe<Scalars['String']['input']>;
  reset_on_month?: InputMaybe<MonthEnum>;
  reset_one_time_day?: InputMaybe<Scalars['String']['input']>;
  reset_one_time_month?: InputMaybe<MonthEnum>;
  reset_type?: InputMaybe<YearlyMonthlyEnum>;
  sandwich?: InputMaybe<Scalars['Boolean']['input']>;
  sandwich_on_public_holiday?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LeavePolicyListingInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type LeavePolicyListingResult = {
  __typename?: 'leavePolicyListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<LeavePolicy>>>;
};

export type LeaveTypeEmployeeById = {
  __typename?: 'leaveTypeEmployeeById';
  _id?: Maybe<Scalars['String']['output']>;
  carry_forword?: Maybe<Scalars['Int']['output']>;
  countIn?: Maybe<Scalars['String']['output']>;
  time_off_days?: Maybe<Scalars['String']['output']>;
  time_off_type?: Maybe<LeaveType>;
  unpaid_count?: Maybe<Scalars['String']['output']>;
  working_days?: Maybe<Scalars['String']['output']>;
};

export type LeaveTypeListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  filterLeavesType?: InputMaybe<FilterLeaves>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type LeaveTypeListingResult = {
  __typename?: 'leaveTypeListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<LeaveType>>>;
};

export enum LeaveTypesEnum {
  OnDuty = 'OnDuty',
  Paid = 'Paid',
  Unpaid = 'Unpaid'
}

export type LeavesInput = {
  carry_forward_limit?: InputMaybe<Scalars['Float']['input']>;
  cash_out_rate_type?: InputMaybe<CashOutRateType>;
  count?: InputMaybe<Scalars['Int']['input']>;
  countIn?: InputMaybe<LeaveCountTypeEnum>;
  fixed_rate?: InputMaybe<Scalars['Float']['input']>;
  leaveAssighment?: InputMaybe<LeaveEntitlement>;
  policy_type?: InputMaybe<PolicyTypeEnum>;
  type: Scalars['ID']['input'];
  unpaid_count?: InputMaybe<Scalars['Int']['input']>;
};

export type LeavesType = {
  __typename?: 'leavesType';
  carry_forward_limit?: Maybe<Scalars['Float']['output']>;
  cash_out_rate_type?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  countIn?: Maybe<Scalars['String']['output']>;
  fixed_rate?: Maybe<Scalars['Float']['output']>;
  leaveAssighment?: Maybe<Scalars['String']['output']>;
  policy_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<LeaveType>;
};

export type LeavesWithType = {
  __typename?: 'leavesWithType';
  id?: Maybe<Scalars['String']['output']>;
  leaveName?: Maybe<Scalars['String']['output']>;
  totalLeaves?: Maybe<Scalars['Int']['output']>;
};

export type Level = {
  __typename?: 'level';
  approval_level?: Maybe<Scalars['Int']['output']>;
  approval_to?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<User>;
  level?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Role>;
};

export type LinearFlowItem = {
  __typename?: 'linearFlowItem';
  User?: Maybe<Scalars['ID']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  objectiveStatus?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LinkBusinessesInput = {
  requested_to: Scalars['ID']['input'];
};

export enum LinkedBusinessTypeEnum {
  LinkedBusiness = 'linked_business',
  LinkedWithMe = 'linked_with_me'
}

export type LinkingAssets = {
  __typename?: 'linkingAssets';
  asset?: Maybe<Asset>;
  relation?: Maybe<Scalars['String']['output']>;
};

export type LinkingRelationAsset = {
  accessoryId?: InputMaybe<Scalars['ID']['input']>;
  assetId?: InputMaybe<Scalars['ID']['input']>;
  assetTag: Scalars['String']['input'];
  linkingTransactWhole: Scalars['Boolean']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  relation: RelationAsset;
  relationAssetId: Scalars['ID']['input'];
};

export type ListingColumnsInput = {
  column_data?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  column_dropdown_value?: InputMaybe<Array<InputMaybe<Inputcolumn_Dropdown_Value>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  filters_data?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header?: InputMaybe<Scalars['String']['input']>;
  is_amount?: InputMaybe<Scalars['Boolean']['input']>;
  is_editable?: InputMaybe<Scalars['Boolean']['input']>;
  is_groupable?: InputMaybe<Scalars['Boolean']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_search_able?: InputMaybe<Scalars['Boolean']['input']>;
  is_sortable?: InputMaybe<Scalars['Boolean']['input']>;
  is_unique?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  min_width?: InputMaybe<Scalars['Float']['input']>;
  pinned?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<FiltersQueryInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  show_total?: InputMaybe<Scalars['Boolean']['input']>;
  sum?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  validateFn?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type ListingColumnsType = {
  __typename?: 'listingColumnsType';
  _id?: Maybe<Scalars['ID']['output']>;
  average?: Maybe<Scalars['Float']['output']>;
  column_data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  column_dropdown_value?: Maybe<Array<Maybe<Column_Dropdown_Value>>>;
  count?: Maybe<Scalars['Int']['output']>;
  count_empty?: Maybe<Scalars['Int']['output']>;
  distinct_count?: Maybe<Scalars['Int']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  filterValue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  header?: Maybe<Scalars['String']['output']>;
  is_amount?: Maybe<Scalars['Boolean']['output']>;
  is_editable?: Maybe<Scalars['Boolean']['output']>;
  is_groupable?: Maybe<Scalars['Boolean']['output']>;
  is_required?: Maybe<Scalars['Boolean']['output']>;
  is_search_able?: Maybe<Scalars['Boolean']['output']>;
  is_sortable?: Maybe<Scalars['Boolean']['output']>;
  is_unique?: Maybe<Scalars['Boolean']['output']>;
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  max_count?: Maybe<Scalars['Float']['output']>;
  min_count?: Maybe<Scalars['Float']['output']>;
  pinned?: Maybe<Scalars['String']['output']>;
  query?: Maybe<QueryType>;
  search?: Maybe<Scalars['String']['output']>;
  show_total?: Maybe<Scalars['Boolean']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  validateFn?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type ListingFiltersInput = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<FiltersQueryInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListingFiltersType = {
  __typename?: 'listingFiltersType';
  _ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  field?: Maybe<Scalars['String']['output']>;
  query?: Maybe<FiltersQueryType>;
  search?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ListingTablePreset = {
  __typename?: 'listingTablePreset';
  activeFilters?: Maybe<Scalars['Boolean']['output']>;
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  config?: Maybe<TableConfigListing>;
  filters?: Maybe<Array<Maybe<ListingFiltersType>>>;
  id?: Maybe<Scalars['ID']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  is_temp?: Maybe<Scalars['Boolean']['output']>;
  loadingCall?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LoanFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  request_date?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type LoanRequestFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type LoanResult = {
  __typename?: 'loanResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<LoanPayment>>>;
};

export type LoanTransactionFilter = {
  field?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  loan_id: Scalars['ID']['input'];
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type LoanTransactionResult = {
  __typename?: 'loanTransactionResult';
  config?: Maybe<DataTableConfig>;
  employee?: Maybe<User>;
  remaining_amount?: Maybe<Scalars['Float']['output']>;
  results?: Maybe<Array<Maybe<LoanTransaction>>>;
  total_loan_amount?: Maybe<Scalars['Float']['output']>;
  total_pay_amount?: Maybe<Scalars['Float']['output']>;
};

export type LocationData = {
  __typename?: 'locationData';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Int']['output']>;
  lon?: Maybe<Scalars['Int']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  store_number?: Maybe<Scalars['String']['output']>;
};

export type LogActivity = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  subscription: Scalars['ID']['input'];
};

export type LogActivityListingResult = {
  __typename?: 'logActivityListingResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<SubscriptionLogActivity>>>;
};

export type LogInput = {
  break_id?: InputMaybe<Scalars['ID']['input']>;
  log_date?: InputMaybe<Scalars['DateTime']['input']>;
  log_status?: InputMaybe<LogTypes>;
  total_minutes?: InputMaybe<Scalars['Int']['input']>;
};

export type LogType = {
  __typename?: 'logType';
  break_id?: Maybe<MasterDataValue>;
  log_date?: Maybe<Scalars['DateTime']['output']>;
  log_status?: Maybe<Scalars['String']['output']>;
  total_minutes?: Maybe<Scalars['Int']['output']>;
};

export enum LogTypes {
  BreakEarlyOut = 'break_early_out',
  BreakGraceLateOut = 'break_grace_late_out',
  BreakLateOut = 'break_late_out',
  EarlyClockOut = 'early_clock_out',
  GraceEarlyClockIn = 'grace_early_clock_in',
  GraceEarlyClockOut = 'grace_early_clock_out',
  GraceLateClockIn = 'grace_late_clock_in',
  GraceLateClockOut = 'grace_late_clock_out',
  LateClockIn = 'late_clock_in',
  LateClockOut = 'late_clock_out'
}

export type LoginToOtherBusinessInput = {
  app_type?: InputMaybe<Scalars['String']['input']>;
  business_id: Scalars['ID']['input'];
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_token?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
};

export type LoginWithZetadelInput = {
  app_type?: InputMaybe<Application_Type>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_verifier?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_token?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type Logs = {
  __typename?: 'logs';
  from?: Maybe<Scalars['String']['output']>;
  log_type?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type LogsAsset = {
  __typename?: 'logsAsset';
  action?: Maybe<Scalars['String']['output']>;
  assetId?: Maybe<Scalars['String']['output']>;
  assigned?: Maybe<User>;
  assignedDepartment?: Maybe<Department>;
  assignedSite?: Maybe<BusinessLocation>;
  changedFrom?: Maybe<Scalars['String']['output']>;
  changedTo?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  date?: Maybe<Scalars['Date']['output']>;
  oldAssigneId?: Maybe<User>;
  quantity?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LogsAttendanceRegulation = {
  __typename?: 'logsAttendanceRegulation';
  action?: Maybe<Scalars['String']['output']>;
  changed_from?: Maybe<Scalars['String']['output']>;
  changed_to?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  date?: Maybe<Scalars['Date']['output']>;
};

export type LogsExpense = {
  __typename?: 'logsExpense';
  action?: Maybe<Scalars['String']['output']>;
  changed_from?: Maybe<Scalars['String']['output']>;
  changed_to?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  date?: Maybe<Scalars['Date']['output']>;
};

export type LogsLoanPayments = {
  __typename?: 'logsLoanPayments';
  action?: Maybe<Scalars['String']['output']>;
  changed_from?: Maybe<Scalars['String']['output']>;
  changed_to?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  date?: Maybe<Scalars['Date']['output']>;
};

export type LogsTask = {
  __typename?: 'logsTask';
  action?: Maybe<Scalars['String']['output']>;
  assigned?: Maybe<User>;
  changed_from?: Maybe<Scalars['String']['output']>;
  changed_to?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  date?: Maybe<Scalars['Date']['output']>;
  task_id?: Maybe<Scalars['String']['output']>;
};

export type LogsTimeOff = {
  __typename?: 'logsTimeOff';
  action?: Maybe<Scalars['String']['output']>;
  changed_from?: Maybe<Scalars['String']['output']>;
  changed_to?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  date?: Maybe<Scalars['Date']['output']>;
};

export type LogsWriteUp = {
  __typename?: 'logsWriteUp';
  action?: Maybe<Scalars['String']['output']>;
  changed_from?: Maybe<Scalars['String']['output']>;
  changed_to?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<User>;
  date?: Maybe<Scalars['Date']['output']>;
};

export type MaintenanceListFilter = {
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maintenanceColumns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type MaintenanceListingResult = {
  __typename?: 'maintenanceListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Maintenance>>>;
};

export type ManuallyAdjustmentInput = {
  adjusted_amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  is_credit: Scalars['Boolean']['input'];
  payroll_detail_ids: Array<Scalars['ID']['input']>;
  payroll_id: Scalars['ID']['input'];
};

export type ManuallyLogs = {
  __typename?: 'manuallyLogs';
  breaks?: Maybe<Array<Maybe<BreakLogs>>>;
  clock_in?: Maybe<ClockIn>;
  clock_in_status?: Maybe<ClockInOUtStatus>;
  clock_out?: Maybe<ClockOut>;
  clock_out_status?: Maybe<ClockInOUtStatus>;
  history_times?: Maybe<HistoryTimes>;
  log_date?: Maybe<Scalars['DateTime']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  short_leave?: Maybe<ShortLeaveLog>;
  updated_by?: Maybe<User>;
};

export type MarkAsReadInput = {
  feature?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  module?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum MaximumDuration {
  HalfDay = 'halfDay',
  Partialy = 'partialy'
}

export enum MaximumDurationEnum {
  HalfDay = 'halfDay',
  Partialy = 'partialy'
}

export type MedicalInsuranceInput = {
  medical_facilities_name: Scalars['String']['input'];
  medical_insurance_id?: InputMaybe<Scalars['ID']['input']>;
};

export type MedicalInsuranceListFilter = {
  business?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type MedicalInsurancePackageInput = {
  assigned_to?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  company?: InputMaybe<Scalars['String']['input']>;
  enrollment_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  enrollment_end_days?: InputMaybe<Scalars['Int']['input']>;
  enrollment_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  enrollment_start_days?: InputMaybe<Scalars['Int']['input']>;
  expire_days?: InputMaybe<Scalars['Int']['input']>;
  is_open_enrollment_period?: InputMaybe<Scalars['Boolean']['input']>;
  is_post_hire_eligibility?: InputMaybe<Scalars['Boolean']['input']>;
  medical_facilities_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  medical_package_id?: InputMaybe<Scalars['ID']['input']>;
  monthly_cost_to_employe?: InputMaybe<Scalars['Float']['input']>;
  monthly_cost_to_employer?: InputMaybe<Scalars['Float']['input']>;
  notifications?: InputMaybe<Scalars['Boolean']['input']>;
  notify_before_days?: InputMaybe<Scalars['Int']['input']>;
  package_name?: InputMaybe<Scalars['String']['input']>;
  package_price?: InputMaybe<Scalars['Float']['input']>;
  package_type?: InputMaybe<Scalars['String']['input']>;
  upload_document?: InputMaybe<Scalars['Upload']['input']>;
};

export type Modulefeatureandpermission = {
  __typename?: 'modulefeatureandpermission';
  POSPermissionResult?: Maybe<Array<Maybe<ModulesFeaturesPermissions>>>;
  adminPermissionResult?: Maybe<Array<Maybe<ModulesFeaturesPermissions>>>;
};

export enum ModulesEnum {
  AssetAlerts = 'asset_alerts',
  AttendancePolicies = 'attendance_policies',
  Authentications = 'authentications',
  Documents = 'documents',
  EmployeeSeparations = 'employee_separations',
  GiftCards = 'gift_cards',
  LearningManagementSystems = 'learning_management_systems',
  SalaryAdjustments = 'salary_adjustments',
  Schedules = 'schedules',
  TimesheetReports = 'timesheet_reports'
}

export enum MonthEnum {
  Apr = 'Apr',
  Aug = 'Aug',
  Dec = 'Dec',
  Feb = 'Feb',
  Jan = 'Jan',
  Jul = 'Jul',
  Jun = 'Jun',
  Mar = 'Mar',
  May = 'May',
  Nov = 'Nov',
  Oct = 'Oct',
  Sep = 'Sep',
  April = 'april',
  January = 'january'
}

export type MoveAssetInput = {
  department?: InputMaybe<Scalars['ID']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  role: Array<Scalars['ID']['input']>;
  role_employes: Array<InputMaybe<Scalars['ID']['input']>>;
  site?: InputMaybe<Scalars['ID']['input']>;
  station?: InputMaybe<Scalars['ID']['input']>;
};

export type MovePolicyInput = {
  employee: Scalars['ID']['input'];
  is_unpaid: Scalars['Boolean']['input'];
  pto_minutes?: InputMaybe<Pto_MinutesType_Input>;
  time_off: Array<TimeOffEmployeeInput>;
};

export type Movement = {
  __typename?: 'movement';
  from?: Maybe<MovementFrom>;
  moved_at?: Maybe<Scalars['Date']['output']>;
  moved_by?: Maybe<User>;
  remarks?: Maybe<Scalars['String']['output']>;
  to?: Maybe<MovementFrom>;
};

export type MovementFrom = {
  __typename?: 'movementFrom';
  Role?: Maybe<Array<Maybe<Role>>>;
  Station?: Maybe<Station>;
  department?: Maybe<Department>;
  role_employes?: Maybe<Array<Maybe<User>>>;
  site?: Maybe<BusinessLocation>;
};

export type MultiScheduleDeleteInput = {
  employeesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_all?: InputMaybe<Scalars['Boolean']['input']>;
  is_delete_clockhistry?: InputMaybe<Scalars['Boolean']['input']>;
  is_delete_timeoff?: InputMaybe<Scalars['Boolean']['input']>;
  notifyByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  start_date: Scalars['DateTime']['input'];
};

export type MultipleBreakPayload = {
  break_id: Scalars['ID']['input'];
  minimum_break_percentage: Scalars['Int']['input'];
};

export type MyTaskResult = {
  __typename?: 'myTaskResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<TaskManagement>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type NextWeekInput = {
  _id: Scalars['ID']['input'];
  employees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end_date: Scalars['DateTime']['input'];
  includes_comments?: InputMaybe<Scalars['Boolean']['input']>;
  no_of_weeks: Scalars['Int']['input'];
  start_date: Scalars['DateTime']['input'];
};

export enum NodeColorModeEnum {
  Layer = 'layer',
  ParentChild = 'parentChild'
}

export type Notification = {
  __typename?: 'notification';
  _id?: Maybe<Scalars['ID']['output']>;
  action_type?: Maybe<Scalars['String']['output']>;
  business_id?: Maybe<Business>;
  created_at?: Maybe<Scalars['Date']['output']>;
  data_object?: Maybe<Scalars['JSON']['output']>;
  defaultSystemNotification?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  for_user?: Maybe<User>;
  has_action?: Maybe<Scalars['Boolean']['output']>;
  is_read?: Maybe<Scalars['Boolean']['output']>;
  is_reminder_sent?: Maybe<Scalars['Boolean']['output']>;
  is_veiwed?: Maybe<Scalars['Boolean']['output']>;
  path?: Maybe<NotificationPath>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<User>;
};

export type NotificationCount = {
  __typename?: 'notificationCount';
  notificationCount?: Maybe<Scalars['Int']['output']>;
};

export type NotificationFilterInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  feature?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_deleted: Scalars['Boolean']['input'];
  is_read?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  module?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationListingResult = {
  __typename?: 'notificationListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  notificationCount?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Notification>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type NotificationsInput = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type Objective = {
  __typename?: 'objective';
  AppraisalObjective?: Maybe<AppraisalObjecive>;
  _id?: Maybe<Scalars['ID']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
  weight_percent?: Maybe<Scalars['Float']['output']>;
};

export type ObjectiveAssignedInput = {
  AppraisalType?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  objective?: InputMaybe<Array<InputMaybe<InputobjectiveAssigned>>>;
  total_weight?: InputMaybe<Scalars['Int']['input']>;
};

export type ObjectiveAssignment = {
  __typename?: 'objectiveAssignment';
  Business?: Maybe<Business>;
  PerformanceCycle?: Maybe<PerformanceCycleType>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_by?: Maybe<User>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<User>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  linearFlow?: Maybe<Array<Maybe<LinearFlowItem>>>;
  objective?: Maybe<Scalars['Int']['output']>;
  objectiveAssigned?: Maybe<Array<Maybe<Objective_Assigned>>>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<User>;
};

export type ObjectiveAssignmentResult = {
  __typename?: 'objectiveAssignmentResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<ObjectiveAssignment>>>;
};

export type ObjectiveAssignments = {
  __typename?: 'objectiveAssignments';
  Business?: Maybe<Business>;
  PerformanceCycle?: Maybe<PerformanceCycleType>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  linearFlow?: Maybe<Array<Maybe<LinearFlowItem>>>;
  objectiveAssigned?: Maybe<Array<Maybe<Objective_Assigned>>>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ObjectiveAssignmnet = {
  objective?: InputMaybe<Array<InputMaybe<InputPerformance_Cycles>>>;
  objectiveAssigned?: InputMaybe<Scalars['ID']['input']>;
  total_score?: InputMaybe<Scalars['Float']['input']>;
  total_target?: InputMaybe<Scalars['Float']['input']>;
  total_weight?: InputMaybe<Scalars['Float']['input']>;
};

export type Objective_Assigned = {
  __typename?: 'objective_Assigned';
  AppraisalType?: Maybe<AppraisalType>;
  _id?: Maybe<Scalars['ID']['output']>;
  attendanceStatus?: Maybe<Array<Maybe<AttendanceStatusType>>>;
  objective?: Maybe<Array<Maybe<Objective>>>;
  task?: Maybe<Array<Maybe<TaskType>>>;
  total?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Int']['output']>;
  total_target?: Maybe<Scalars['Int']['output']>;
  total_weight?: Maybe<Scalars['Int']['output']>;
};

export type OldAndNewSchedule = {
  __typename?: 'oldAndNewSchedule';
  scheduleListOldAndNew?: Maybe<Array<Maybe<ScheduleListOldAndNew>>>;
};

export enum OneTimeDateEnum {
  BirthDate = 'BirthDate',
  JoiningDate = 'JoiningDate',
  PolicyDate = 'PolicyDate'
}

export enum OneTimeMonthEnum {
  PolicyMonth = 'PolicyMonth'
}

export enum OpenCashDrawerType {
  Deposit = 'deposit',
  Withdraw = 'withdraw'
}

export type OverLapedSchedules = {
  __typename?: 'overLapedSchedules';
  employeeId?: Maybe<Scalars['String']['output']>;
  employee_name?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  schedule_date?: Maybe<Scalars['String']['output']>;
};

export type OverTime = {
  __typename?: 'overTime';
  overtimeDate?: Maybe<Scalars['String']['output']>;
  overtimeDuration?: Maybe<Scalars['Int']['output']>;
};

export type PackageById = {
  __typename?: 'packageById';
  package?: Maybe<Package>;
  permissions?: Maybe<DividePermission>;
};

export type PackageInput = {
  auto_renewal?: InputMaybe<Scalars['Boolean']['input']>;
  business: Scalars['ID']['input'];
  hr_module_only?: InputMaybe<Scalars['Boolean']['input']>;
  is_pakage_free?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_package?: InputMaybe<Scalars['Boolean']['input']>;
  no_of_employee: Scalars['Int']['input'];
  no_of_store?: InputMaybe<Scalars['Int']['input']>;
  no_of_transcation?: InputMaybe<Scalars['Int']['input']>;
  number_of_cashregisters?: InputMaybe<Scalars['Int']['input']>;
  package_name: Scalars['String']['input'];
  package_price?: InputMaybe<Scalars['Float']['input']>;
  package_type: PackageType;
  per_employee_fee?: InputMaybe<Scalars['Float']['input']>;
  per_store_fee?: InputMaybe<Scalars['Float']['input']>;
  permissions: Array<InputMaybe<PermissionInput>>;
  policy?: InputMaybe<PolicyInput>;
  purchase_from_ms?: InputMaybe<Scalars['Boolean']['input']>;
  recurring: PackageRecurrignType;
  transcation_fee?: InputMaybe<Scalars['Float']['input']>;
  transcation_fee_calculation_type?: InputMaybe<PackageTranscationFeeType>;
  transcation_fee_ending_limit?: InputMaybe<Scalars['Float']['input']>;
  transcation_fee_starting_limit?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  package_type?: InputMaybe<PackageType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PaidUnPaidInput = {
  business: Scalars['ID']['input'];
  hours_earn_per_year: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  include_weekends: Scalars['Boolean']['input'];
  is_paid_leave: Scalars['Boolean']['input'];
  policy_name: Scalars['String']['input'];
};

export type PaidUnPaidListFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type PaidUnPaidlistingResult = {
  __typename?: 'paidUnPaidlistingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<PaidUnPaids>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type PaidUnPaids = {
  __typename?: 'paidUnPaids';
  _id?: Maybe<Scalars['ID']['output']>;
  business?: Maybe<Business>;
  hours_earn_per_year?: Maybe<Scalars['Int']['output']>;
  include_weekends?: Maybe<Scalars['Boolean']['output']>;
  is_paid_leave?: Maybe<Scalars['Boolean']['output']>;
  policy_name?: Maybe<Scalars['String']['output']>;
};

export type PasswordManagerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<EncryptedPasswordInput>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordManagerType = {
  __typename?: 'passwordManagerType';
  email?: Maybe<Scalars['String']['output']>;
  password?: Maybe<EncryptedPasswordType>;
  user_name?: Maybe<Scalars['String']['output']>;
};

export enum PayPeriodEnum {
  MonthlyPeriod = 'MonthlyPeriod'
}

export enum PayTypeEnum {
  BiWeekly = 'BiWeekly',
  PerMonth = 'PerMonth',
  Weekly = 'Weekly'
}

export enum Payment {
  Paid = 'paid',
  UnPaid = 'unPaid'
}

export type PaymentMethod = {
  card_holder_name?: InputMaybe<Scalars['String']['input']>;
  card_number?: InputMaybe<Scalars['String']['input']>;
  cvv?: InputMaybe<Scalars['String']['input']>;
  expiration_month?: InputMaybe<Scalars['String']['input']>;
  expiration_year?: InputMaybe<Scalars['String']['input']>;
  save_card?: InputMaybe<Scalars['Boolean']['input']>;
  subscription_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum PaymentTypeEnum {
  AdditionalCost = 'additional_cost',
  ExtraItem = 'extra_item',
  OrderPayment = 'order_payment'
}

export type PayrollListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  is_dispersed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pay_period: PayrollPayPeriodEnum;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollListResult = {
  __typename?: 'payrollListResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Payroll>>>;
};

export type PayrollResult = {
  __typename?: 'payrollResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<Payroll>>>;
};

export enum PayrollStatus {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  InProgress = 'InProgress',
  OnHold = 'OnHold',
  Paid = 'Paid',
  Pending = 'Pending'
}

export enum PayrollType {
  Hourly = 'Hourly',
  Salary = 'Salary'
}

export type Payroll_Detail = {
  __typename?: 'payroll_detail';
  User?: Maybe<User>;
  is_manually_adjust?: Maybe<Scalars['Boolean']['output']>;
  salary_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_adjusted_amount?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

export type PendingRequestInput = {
  employee_id: Scalars['ID']['input'];
  leve_type_id: Scalars['ID']['input'];
};

export type PendingRequests = {
  __typename?: 'pendingRequests';
  assetListing?: Maybe<Array<Maybe<Asset>>>;
  clockedHistory?: Maybe<Array<Maybe<ClockedHistory>>>;
  documentListing?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
  pending_attendance_requests?: Maybe<Array<Maybe<AttendanceRegulation>>>;
  pending_expenses_requests?: Maybe<Array<Maybe<Expense>>>;
  pending_leaves_requests?: Maybe<Array<Maybe<TimeOff>>>;
  pending_loan_requests?: Maybe<Array<Maybe<LoanPayment>>>;
  pending_writeup_requests?: Maybe<Array<Maybe<WriteUp>>>;
  tasklisting?: Maybe<Array<Maybe<TaskManagement_>>>;
  workFlowListing?: Maybe<Array<Maybe<UserWorkFlow>>>;
};

export type PendingRequestsData = {
  __typename?: 'pendingRequestsData';
  pending_request_minutes?: Maybe<Scalars['Int']['output']>;
};

export type PerformanceCycleInput = {
  Department?: InputMaybe<Scalars['ID']['input']>;
  Role?: InputMaybe<Scalars['ID']['input']>;
  appraisal_setting?: InputMaybe<Array<InputMaybe<AppraisalSettingInput>>>;
  appraiser_setting?: InputMaybe<Array<InputMaybe<AppraiserSettingInput>>>;
  assigning_start_date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end_date: Scalars['Date']['input'];
  is_all?: InputMaybe<Scalars['Boolean']['input']>;
  is_linear_flow?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  start_date: Scalars['Date']['input'];
};

export type PerformanceCycleResult = {
  __typename?: 'performanceCycleResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<PerformanceCycleType>>>;
};

export type PerformanceCycleType = {
  __typename?: 'performanceCycleType';
  Department?: Maybe<Department>;
  Role?: Maybe<Role>;
  _id?: Maybe<Scalars['ID']['output']>;
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  appraisal_setting?: Maybe<Array<Maybe<AppraisalSettingType>>>;
  appraiser_setting?: Maybe<Array<Maybe<AppraiserSettingType>>>;
  assigning_start_date?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Array<Maybe<User>>>;
  end_date?: Maybe<Scalars['Date']['output']>;
  is_all?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_linear_flow?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Performance_Cycles = {
  __typename?: 'performance_cycles';
  ApraisalObjectiveAssignmnet?: Maybe<ObjectiveAssignment>;
  measurement?: Maybe<Scalars['Float']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
  weight_percent?: Maybe<Scalars['Float']['output']>;
};

export enum PermissionAtEnum {
  Administration = 'administration',
  Pos = 'pos'
}

export type PermissionInput = {
  feature?: InputMaybe<Scalars['String']['input']>;
  is_admin_essential_permission?: InputMaybe<Scalars['Boolean']['input']>;
  module?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  permission_at?: InputMaybe<Scalars['String']['input']>;
};

export type PermissionObj = {
  __typename?: 'permissionObj';
  permission?: Maybe<Scalars['String']['output']>;
};

export type Permissions = {
  __typename?: 'permissions';
  can_update_schedule?: Maybe<Scalars['Boolean']['output']>;
  can_view_schedule?: Maybe<Scalars['Boolean']['output']>;
  employee?: Maybe<User>;
};

export type PhoneOtp = {
  __typename?: 'phoneOtp';
  _id?: Maybe<Scalars['String']['output']>;
  otp_code?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type PhoneOtpInput = {
  method?: InputMaybe<AllowMethodPhoneVerify>;
  phone: Scalars['String']['input'];
};

export type PhoneVerifyOtpInput = {
  otp_code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type PlaidCategoriesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  mapped_category?: InputMaybe<Scalars['String']['input']>;
  plaid_categorie?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PolicyInput = {
  customer_max_storecredit?: InputMaybe<Scalars['Int']['input']>;
  customer_max_storecredit_transfer?: InputMaybe<Scalars['Int']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  max_tabs?: InputMaybe<Scalars['Int']['input']>;
  pay_later_invoice_max_limit?: InputMaybe<Scalars['Int']['input']>;
  payment_gateways?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sale_cash_max_limit?: InputMaybe<Scalars['Int']['input']>;
  sale_max_invoice_discount_fixed?: InputMaybe<Scalars['Int']['input']>;
  sale_max_invoice_discount_percentage?: InputMaybe<Scalars['Int']['input']>;
  sale_max_item_discount?: InputMaybe<Scalars['Int']['input']>;
  sale_paypal_invoice_min_limit?: InputMaybe<Scalars['Int']['input']>;
  sale_paypal_invoice_no_transaction?: InputMaybe<Scalars['Int']['input']>;
  sale_paypal_min_limit?: InputMaybe<Scalars['Int']['input']>;
  sale_paypal_no_transaction?: InputMaybe<Scalars['Int']['input']>;
  ticket_invoice_refund_max_percentage_discount?: InputMaybe<Scalars['Int']['input']>;
  useDefaultServices?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PolicyStatusEnum {
  Current = 'current',
  Previous = 'previous',
  Upcoming = 'upcoming'
}

export type PolicyWithRosterInput = {
  department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  designations?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  full_year?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  recurrence_rule?: InputMaybe<Scalars['String']['input']>;
  repeat: Repeat;
  rosterStore: Scalars['ID']['input'];
  start_date: Scalars['DateTime']['input'];
  total_hours: Scalars['Int']['input'];
  week_number?: InputMaybe<Scalars['Int']['input']>;
};

export type PresentAbsentLeave = {
  __typename?: 'presentAbsentLeave';
  absent?: Maybe<Scalars['Int']['output']>;
  block?: Maybe<Scalars['Int']['output']>;
  leave?: Maybe<Scalars['Int']['output']>;
  present?: Maybe<Scalars['Int']['output']>;
  restricted?: Maybe<Scalars['Int']['output']>;
  unrestricted?: Maybe<Scalars['Int']['output']>;
};

export type PreviewOldScheduleInput = {
  new_schedule_id: Scalars['ID']['input'];
  old_schedule_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum PriorityEmums {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export type ProductAttributeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  type: ProductAttributeTypes;
};

export enum ProductTypeEnum {
  Accessory = 'Accessory',
  Computer = 'Computer',
  Connector = 'Connector',
  DeviceIssue = 'DeviceIssue',
  Mobile = 'Mobile',
  Supply = 'Supply',
  Tool = 'Tool'
}

export type ProfilePictures = {
  __typename?: 'profilePictures';
  dimension?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type ProgressBarData = {
  __typename?: 'progressBarData';
  Total_customer?: Maybe<Scalars['Int']['output']>;
  effect_customer?: Maybe<Scalars['Int']['output']>;
};

export type ProgressBarInput = {
  business: Scalars['ID']['input'];
  businessLocations?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customer_since?: InputMaybe<Scalars['String']['input']>;
  is_customer_more_then_said_amount?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_since: Scalars['Boolean']['input'];
  is_customer_spent_amount?: InputMaybe<Scalars['Boolean']['input']>;
  spent_amount?: InputMaybe<Scalars['Float']['input']>;
};

export enum PtoScheduleEnum {
  Monthly = 'Monthly',
  Onetime = 'Onetime',
  Yearly = 'Yearly'
}

export type Pto_MinutesType = {
  __typename?: 'pto_minutesType';
  carry_forword?: Maybe<Scalars['Int']['output']>;
  pto_availed_minutes?: Maybe<Scalars['Float']['output']>;
  pto_earned_minutes?: Maybe<Scalars['Float']['output']>;
};

export type Pto_MinutesType_Input = {
  pto_availed_minutes?: InputMaybe<Scalars['Float']['input']>;
  pto_count_in?: InputMaybe<Scalars['String']['input']>;
  pto_earned_minutes?: InputMaybe<Scalars['Float']['input']>;
  pto_fixed_days?: InputMaybe<Scalars['Float']['input']>;
  pto_fixed_minutes?: InputMaybe<Scalars['Float']['input']>;
  pto_fixed_total_days?: InputMaybe<Scalars['Float']['input']>;
  pto_fixed_total_minutes?: InputMaybe<Scalars['Float']['input']>;
  pto_type?: InputMaybe<Scalars['String']['input']>;
};

export type PublicHolidayOrWeekendSchedule = {
  end_date: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
};

export type PublicHolidaysFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type PublicHolidaysResult = {
  __typename?: 'publicHolidaysResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<PublicHoliday>>>;
};

export enum PurchaseType {
  Card = 'card',
  Cash = 'cash',
  Employee = 'employee',
  Leased = 'leased',
  Netbanking = 'netbanking',
  Upi = 'upi'
}

export enum PurchasesReportType {
  All = 'all',
  Monthly = 'monthly',
  Quarter = 'quarter',
  Today = 'today',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

export type QueryInput = {
  condition?: InputMaybe<ConditionEnum>;
  first_condition?: InputMaybe<ConditionalEnum>;
  first_value?: InputMaybe<Scalars['String']['input']>;
  second_condition?: InputMaybe<ConditionalEnum>;
  second_value?: InputMaybe<Scalars['String']['input']>;
};

export type QueryInputTerminalAppDevice = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryInputUserAppDevice = {
  app_type: AppTypes;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryType = {
  __typename?: 'queryType';
  condition?: Maybe<Scalars['String']['output']>;
  first_condition?: Maybe<Scalars['String']['output']>;
  first_value?: Maybe<Scalars['String']['output']>;
  second_condition?: Maybe<Scalars['String']['output']>;
  second_value?: Maybe<Scalars['String']['output']>;
};

export type Question_AnswerType = {
  __typename?: 'question_answerType';
  QuizQuestion?: Maybe<QuestionWithOutCorrectAnswer>;
};

export type QuickAssetType = {
  __typename?: 'quickAssetType';
  AssetBrand?: Maybe<AssetBrand>;
  AssetModel?: Maybe<AssetModel>;
  assetId?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<SubData>;
  id?: Maybe<Scalars['ID']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<SubData>;
  type?: Maybe<Scalars['String']['output']>;
};

export type QuizAssignedListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  quiz_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuizAssignedListResult = {
  __typename?: 'quizAssignedListResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<AssignedQuiz>>>;
  stats?: Maybe<StatsType>;
};

export type QuizCategoryListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuizCategoryListResult = {
  __typename?: 'quizCategoryListResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<QuizCategoryDetails>>>;
};

export type QuizEvaluatorResult = {
  __typename?: 'quizEvaluatorResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Quiz>>>;
  stats?: Maybe<StatsType>;
};

export type QuizListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuizListResult = {
  __typename?: 'quizListResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Quiz>>>;
};

export type QuizTrainingAssignToInput = {
  assign_to?: InputMaybe<Array<Scalars['ID']['input']>>;
  department?: InputMaybe<Scalars['ID']['input']>;
  due_date: Scalars['DateTime']['input'];
  role?: InputMaybe<Scalars['ID']['input']>;
  started_date: Scalars['DateTime']['input'];
};

export type QuizTrainingAssignmentListResult = {
  __typename?: 'quizTrainingAssignmentListResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<QuizTrainingAssignementListResult>>>;
  stats?: Maybe<StatsType>;
};

export type QuizTrainingCategoryListResult = {
  __typename?: 'quizTrainingCategoryListResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<QuizTrainingCategoryDetails>>>;
};

export type QuizTrainingListing = {
  __typename?: 'quizTrainingListing';
  Quiz?: Maybe<Quiz>;
  all_assignee?: Maybe<Array<Maybe<QuizTrainingUser>>>;
  assign_to_department?: Maybe<Array<Maybe<QuizTrainingDepartment>>>;
  assign_to_role?: Maybe<Array<Maybe<QuizTrainingRole>>>;
  attachments?: Maybe<Array<QuizTrainingAttachment>>;
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  global_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Array<Maybe<LanguageCode>>>;
  links?: Maybe<Array<Maybe<QuizTrainingLink>>>;
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type QuizTrainingReplicaListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  trainingId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuizTrainingReplicaListResult = {
  __typename?: 'quizTrainingReplicaListResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<QuizTrainingReplica>>>;
  stats?: Maybe<StatsType>;
};

export type QuizTrainingUpdateStatus = {
  assign_to?: InputMaybe<Scalars['ID']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<TrainingAssignStatus>;
};

export type QuizTraningListInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ReJoinEmployeeInput = {
  basic_salary?: InputMaybe<Scalars['Float']['input']>;
  employee_group?: InputMaybe<Scalars['ID']['input']>;
  employee_type?: InputMaybe<Scalars['ID']['input']>;
  hire_date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  joining_date?: InputMaybe<Scalars['DateTime']['input']>;
  line_manager?: InputMaybe<Scalars['ID']['input']>;
  over_time_rate?: InputMaybe<Scalars['Float']['input']>;
  pay_schedule?: InputMaybe<Scalars['ID']['input']>;
  public_day_hourly_salary?: InputMaybe<Scalars['Float']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  salary_type?: InputMaybe<Scalars['String']['input']>;
  total_week_hours?: InputMaybe<Scalars['Float']['input']>;
  weekend_day_salary?: InputMaybe<Scalars['Float']['input']>;
  weekly_hourly_salary?: InputMaybe<Scalars['Float']['input']>;
};

export type ReasonInput = {
  reason_name: Scalars['String']['input'];
  reason_type: ReasonType;
};

export enum ReasonType {
  Resignation = 'Resignation',
  Retirement = 'Retirement',
  Termination = 'Termination'
}

export enum ReasonTypeEnum {
  Damage = 'Damage',
  Defective = 'Defective',
  Missing = 'Missing',
  Stolen = 'Stolen'
}

export type RecruitmentResult = {
  __typename?: 'recruitmentResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Recruitment>>>;
};

export enum RecruitmentStatusEnum {
  Hired = 'hired',
  Hold = 'hold',
  Rejected = 'rejected',
  Shortlisted = 'shortlisted'
}

export enum RecurringBy {
  Monthly = 'monthly',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

export type RegionInput = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RegionStatus>;
};

export type RegionListingResult = {
  __typename?: 'regionListingResult';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<Region>>>;
};

export enum RegionStatus {
  Active = 'active',
  All = 'all',
  Archive = 'archive'
}

export enum RegionStatusChange {
  Active = 'active',
  Inactive = 'inactive'
}

export enum RelationAsset {
  Child = 'child',
  Parent = 'parent'
}

export type RemoveBusinessEmployeeInput = {
  business_navigation_id: Scalars['ID']['input'];
  employee: Scalars['ID']['input'];
};

export type RemoveEmployee = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveShareInput = {
  authenticatorAppId: Scalars['ID']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum Repeat {
  Daily = 'DAILY',
  Never = 'Never',
  Weekly = 'WEEKLY'
}

export enum RepeatOnEnum {
  Fri = 'Fri',
  Mon = 'Mon',
  Sat = 'Sat',
  Sun = 'Sun',
  Thu = 'Thu',
  Tue = 'Tue',
  Wed = 'Wed'
}

export type RepeatOnInput = {
  repeatOn?: InputMaybe<RepeatOnEnum>;
};

export type ReplyType = {
  __typename?: 'replyType';
  _id?: Maybe<Scalars['ID']['output']>;
  reply?: Maybe<Scalars['String']['output']>;
  reply_by?: Maybe<User>;
  reply_date?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportObjectiveAssignment = {
  __typename?: 'reportObjectiveAssignment';
  _id?: Maybe<ReportObjectiveAssignmentData>;
  detail?: Maybe<Array<Maybe<DetailReport>>>;
};

export type ReportObjectiveAssignment1 = {
  __typename?: 'reportObjectiveAssignment1';
  config?: Maybe<DataTableConfig>;
  results?: Maybe<Array<Maybe<ReportObjectiveAssignment_>>>;
};

export type ReportObjectiveAssignmentData = {
  __typename?: 'reportObjectiveAssignmentData';
  department?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  performanceCycleName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ReportObjectiveAssignment_ = {
  __typename?: 'reportObjectiveAssignment_';
  Business?: Maybe<Business>;
  PerformanceCycle?: Maybe<PerformanceCycleType>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  detail?: Maybe<DetailextendedView>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum RequestEnums {
  AttendanceRegulation = 'attendanceRegulation',
  Expense = 'expense',
  LaonPayment = 'laonPayment',
  Leave = 'leave'
}

export type ReserveAssetFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ReserveAssetInput = {
  assetId: Scalars['String']['input'];
  assignedId?: InputMaybe<Scalars['ID']['input']>;
  assignedType?: InputMaybe<AssignedType>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  other_detail?: InputMaybe<Scalars['String']['input']>;
  reserveFrom?: InputMaybe<Scalars['Date']['input']>;
  reserveTo?: InputMaybe<Scalars['Date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type ReserveAssetResult = {
  __typename?: 'reserveAssetResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ResevedAsset>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type ReserveAssets = {
  __typename?: 'reserveAssets';
  assignedType?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Department>;
  employee?: Maybe<User>;
  other_assignee?: Maybe<Scalars['String']['output']>;
  other_detail?: Maybe<Scalars['String']['output']>;
  reserveFrom?: Maybe<Scalars['Date']['output']>;
  reserveTo?: Maybe<Scalars['Date']['output']>;
  site?: Maybe<BusinessLocation>;
};

export type ReserveListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ReserveUpdateAssetInput = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  assignedId?: InputMaybe<Scalars['ID']['input']>;
  assignedType?: InputMaybe<AssignedType>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  other_detail?: InputMaybe<Scalars['String']['input']>;
  previousAsset?: InputMaybe<Scalars['ID']['input']>;
  reserveFrom?: InputMaybe<Scalars['Date']['input']>;
  reserveTo?: InputMaybe<Scalars['Date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type ResetAccuralInput = {
  deleteExtraLeaveInput?: InputMaybe<Array<InputMaybe<DeleteExtraLeaveInput>>>;
  leaves: Array<LeavesInput>;
  packageId?: InputMaybe<Scalars['ID']['input']>;
};

export type ResetAccuralPolicy = {
  __typename?: 'resetAccuralPolicy';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResevedAsset = {
  __typename?: 'resevedAsset';
  assetId?: Maybe<Scalars['String']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  assignedId?: Maybe<Scalars['ID']['output']>;
  assignedType?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAllDay?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['Date']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type ResolveConflictsInput = {
  employee_action: Scalars['ID']['input'];
  employee_id: Scalars['ID']['input'];
  new_schedle_id: Scalars['ID']['input'];
  old_schedle_id: Scalars['ID']['input'];
  schedule_date: Scalars['String']['input'];
};

export type ResultOfLeavePolicy = {
  __typename?: 'resultOfLeavePolicy';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<LeavePolicy>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type ResultOutOfAccural = {
  __typename?: 'resultOutOfAccural';
  _id?: Maybe<User>;
  data?: Maybe<Array<Maybe<OutOfAccuralLeavesAndTypes>>>;
};

export type RocketChat = {
  __typename?: 'rocketChat';
  authToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type RoleChanged = {
  __typename?: 'roleChanged';
  is_navigated_business_change?: Maybe<Scalars['Boolean']['output']>;
  is_password_changed?: Maybe<Scalars['Boolean']['output']>;
  is_role_changed?: Maybe<Scalars['Boolean']['output']>;
};

export type RoleDataForSwap = {
  firstRole: Scalars['ID']['input'];
  secondRole: Scalars['ID']['input'];
};

export type RoleFilter = {
  business_id: Scalars['ID']['input'];
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  location_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
};

export type RoleInput = {
  business: Scalars['ID']['input'];
  feature_hierarchy?: InputMaybe<Array<FeatureHierarchyInput>>;
  location?: InputMaybe<Scalars['ID']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  permissions: Array<InputMaybe<PermissionInput>>;
  roleName: Scalars['String']['input'];
  rolePolicy?: InputMaybe<RolePolicyInput>;
};

export type RoleListingFilter = {
  business_id: Scalars['ID']['input'];
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location_id?: InputMaybe<Scalars['ID']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RolePolicyInput = {
  sale_max_invoice_discount_fixed?: InputMaybe<Scalars['Float']['input']>;
  sale_max_invoice_discount_percentage?: InputMaybe<Scalars['Float']['input']>;
  sale_max_item_discount?: InputMaybe<Scalars['Float']['input']>;
  ticket_invoice_refund_max_percentage_discount?: InputMaybe<Scalars['Float']['input']>;
};

export type RoleWithUser = {
  __typename?: 'roleWithUser';
  id?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  positionName?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type RolesData = {
  __typename?: 'rolesData';
  childs?: Maybe<Array<Maybe<RolesData>>>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RolesWithUsers = {
  __typename?: 'rolesWithUsers';
  role?: Maybe<Role>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type RosterListFilter = {
  filterRoster?: InputMaybe<FilterRoster>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RosterListingResult = {
  __typename?: 'rosterListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Roster>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type RostersInput = {
  currentView?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  employees?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  payrollType?: InputMaybe<PayrollType>;
  role?: InputMaybe<Scalars['ID']['input']>;
  rosterStore?: InputMaybe<Scalars['ID']['input']>;
  scheduled?: InputMaybe<ScheduledFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  timeOff?: InputMaybe<_Schedule>;
};

export enum SalaryType {
  Hourly = 'Hourly',
  Salary = 'Salary'
}

export type SaleGoalAdvanceSearchInput = {
  Business?: InputMaybe<Scalars['ID']['input']>;
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum SalesReportType {
  All = 'all',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Today = 'today',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

export type SandWichDays = {
  __typename?: 'sandWichDays';
  date_of_sandwich?: Maybe<Array<Maybe<DateOfSandwich>>>;
  deduction_type?: Maybe<Scalars['String']['output']>;
  deduction_value?: Maybe<Scalars['Float']['output']>;
  difference_in_days?: Maybe<Scalars['Int']['output']>;
  difference_in_hours?: Maybe<Scalars['Float']['output']>;
};

export type Sandwich = {
  date_of_sandwich?: InputMaybe<Array<InputMaybe<Sandwichdate>>>;
  deduction_type?: InputMaybe<Scalars['String']['input']>;
  deduction_value?: InputMaybe<Scalars['Float']['input']>;
  difference_in_days?: InputMaybe<Scalars['Int']['input']>;
  difference_in_hours?: InputMaybe<Scalars['Float']['input']>;
};

export type SandwichUpdateAproval = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Sandwichdate = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  day?: InputMaybe<Scalars['String']['input']>;
};

export type SaveFilterInput = {
  filter: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: FilterTypeEnum;
};

export type ScaleGroup = {
  __typename?: 'scaleGroup';
  maximum_value?: Maybe<Scalars['Int']['output']>;
  minimum_value?: Maybe<Scalars['Int']['output']>;
  scroe_name?: Maybe<Scalars['String']['output']>;
};

export type ScaleGroupInput = {
  maximum_value?: InputMaybe<Scalars['Int']['input']>;
  minimum_value?: InputMaybe<Scalars['Int']['input']>;
  scroe_name?: InputMaybe<Scalars['String']['input']>;
};

export type SchdualCsvResponse = {
  __typename?: 'schdualCsvResponse';
  InvalidRecord?: Maybe<Array<Maybe<InvalidRecord>>>;
  complectSechduals?: Maybe<Array<Maybe<ConflictedSchedules>>>;
};

export type SchduleInput = {
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  User: Array<Scalars['ID']['input']>;
  break_detail?: InputMaybe<Array<ScheduleBreaksInput>>;
  end_time: Scalars['String']['input'];
  is_full_year: Scalars['Boolean']['input'];
  notifyByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  schedule_date: Scalars['String']['input'];
  short_break?: InputMaybe<Scalars['ID']['input']>;
  short_break_count?: InputMaybe<Scalars['Int']['input']>;
  short_break_duration: Scalars['Int']['input'];
  short_break_type: ShortBreakType;
  start_time: Scalars['String']['input'];
  week_days: Array<Scalars['String']['input']>;
  week_number: Scalars['Int']['input'];
};

export type ScheduleBreaks = {
  __typename?: 'scheduleBreaks';
  break_duration?: Maybe<Scalars['Int']['output']>;
  break_in_time?: Maybe<Scalars['String']['output']>;
  break_out_time?: Maybe<Scalars['String']['output']>;
  break_type?: Maybe<MasterDataValue>;
  minimum_break_percentage?: Maybe<Scalars['Int']['output']>;
};

export type ScheduleBreaksInput = {
  break_duration: Scalars['Int']['input'];
  break_type: Scalars['ID']['input'];
  minimum_break_percentage?: InputMaybe<Scalars['Int']['input']>;
};

export type ScheduleCountFilter = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  filterSchedule?: InputMaybe<FilterSchedule>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start_date: Scalars['String']['input'];
};

export type ScheduleCountsType = {
  __typename?: 'scheduleCountsType';
  estimateWage?: Maybe<Scalars['Float']['output']>;
  onleave?: Maybe<Scalars['Float']['output']>;
  overTimeCost?: Maybe<Scalars['Float']['output']>;
  overTimeHours?: Maybe<Scalars['Float']['output']>;
  ptoCost?: Maybe<Scalars['Float']['output']>;
  ptoHours?: Maybe<Scalars['Float']['output']>;
  scheduleHours?: Maybe<Scalars['Float']['output']>;
  scheduleShift?: Maybe<Scalars['Float']['output']>;
  shortleaves?: Maybe<Scalars['Float']['output']>;
  totalUserCount?: Maybe<Scalars['Float']['output']>;
};

export type ScheduleData = {
  create_schedule: Scalars['Boolean']['input'];
  date: Scalars['String']['input'];
  delete_clock_histry: Scalars['Boolean']['input'];
  end_time?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleDataInput = {
  employee_id: Scalars['ID']['input'];
  schedule_id: Array<Scalars['ID']['input']>;
};

export type ScheduleEmployeeAndHours = {
  __typename?: 'scheduleEmployeeAndHours';
  schduleEmploye?: Maybe<Scalars['Float']['output']>;
  schduleHours?: Maybe<Scalars['Float']['output']>;
};

export type ScheduleEvents = {
  __typename?: 'scheduleEvents';
  TimeOff?: Maybe<TimeOff>;
  end_time?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['Int']['output']>;
  leave_type?: Maybe<Scalars['String']['output']>;
  minutes?: Maybe<Scalars['Int']['output']>;
  star_time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ScheduleFilter {
  Active = 'active',
  All = 'all',
  Archive = 'archive'
}

export type ScheduleGraphData = {
  __typename?: 'scheduleGraphData';
  daily_wages?: Maybe<Array<Maybe<Daily_Wages>>>;
  total_normal_time_minutes?: Maybe<Scalars['Int']['output']>;
  total_normal_time_wage?: Maybe<Scalars['Float']['output']>;
  total_over_time_minutes?: Maybe<Scalars['Int']['output']>;
  total_over_time_wage?: Maybe<Scalars['Float']['output']>;
  total_paid_breaks_minutes?: Maybe<Scalars['Int']['output']>;
  total_paid_leave_count?: Maybe<Scalars['Int']['output']>;
  total_schedules_hours?: Maybe<Scalars['Float']['output']>;
  total_schedules_minutes?: Maybe<Scalars['Int']['output']>;
  total_unpaid_breaks_minutes?: Maybe<Scalars['Int']['output']>;
  total_unpaid_leave_count?: Maybe<Scalars['Int']['output']>;
  total_users?: Maybe<Scalars['Int']['output']>;
  total_wages?: Maybe<Scalars['Float']['output']>;
  total_weekend_off_days?: Maybe<Scalars['Int']['output']>;
};

export type ScheduleListFilter = {
  department?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  filterSchedule?: InputMaybe<FilterSchedule>;
  is_monthly_view: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  salary_type?: InputMaybe<SalaryType>;
  search?: InputMaybe<Scalars['String']['input']>;
  start_date: Scalars['String']['input'];
  type?: InputMaybe<ScheduleType>;
};

export type ScheduleListFilterApp = {
  department?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  filterSchedule?: InputMaybe<FilterSchedule>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start_date: Scalars['String']['input'];
};

export type ScheduleListOldAndNew = {
  __typename?: 'scheduleListOldAndNew';
  clockIn?: Maybe<Scalars['Boolean']['output']>;
  existingDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  existingScheduleId?: Maybe<Scalars['ID']['output']>;
  newRosterId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type ScheduleListingResult = {
  __typename?: 'scheduleListingResult';
  RosterStore?: Maybe<RosterStores>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  is_conflict_schedule?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Array<Maybe<ScheduleResult>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
  wagesPermission?: Maybe<Scalars['Boolean']['output']>;
};

export type ScheduleListingResultApp = {
  __typename?: 'scheduleListingResultApp';
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  is_salary_view?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Array<Maybe<ScheduleResultApp>>>;
};

export type ScheduleLogs = {
  __typename?: 'scheduleLogs';
  Schedule?: Maybe<Schedule>;
  User?: Maybe<User>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  logs?: Maybe<Array<Maybe<Logs>>>;
};

export type ScheduleProgressType = {
  __typename?: 'scheduleProgressType';
  data?: Maybe<Array<Maybe<ConflictedSchedules>>>;
  processingCurrChunkSize?: Maybe<Scalars['Int']['output']>;
  processingProgress?: Maybe<Scalars['Int']['output']>;
  successProgress?: Maybe<Scalars['Int']['output']>;
  successProgressCurrChunkSize?: Maybe<Scalars['Int']['output']>;
  totalChunkSize?: Maybe<Scalars['Int']['output']>;
};

export type ScheduleResult = {
  __typename?: 'scheduleResult';
  RosterStore?: Maybe<RosterStores>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['String']['output']>;
  estimated_wage?: Maybe<Scalars['Float']['output']>;
  schedules?: Maybe<Array<Maybe<Schedule>>>;
  total_normal_time?: Maybe<Scalars['Int']['output']>;
  total_normal_time_wage?: Maybe<Scalars['Float']['output']>;
  total_over_time?: Maybe<Scalars['Int']['output']>;
  total_over_time_wage?: Maybe<Scalars['Float']['output']>;
  total_schedules_hours?: Maybe<Scalars['Int']['output']>;
  total_schedules_minutes?: Maybe<Scalars['Int']['output']>;
};

export type ScheduleResultApp = {
  __typename?: 'scheduleResultApp';
  RosterStore?: Maybe<RosterStores>;
  _id?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Designation>;
  estimated_wage?: Maybe<Scalars['Float']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  profile_pictures?: Maybe<Array<Maybe<ProfilePictures>>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  schedules?: Maybe<Array<Maybe<Schedule>>>;
  total_normal_time?: Maybe<Scalars['Int']['output']>;
  total_normal_time_wage?: Maybe<Scalars['Float']['output']>;
  total_over_time?: Maybe<Scalars['Int']['output']>;
  total_over_time_wage?: Maybe<Scalars['Float']['output']>;
  total_schedules_hours?: Maybe<Scalars['Int']['output']>;
  total_schedules_minutes?: Maybe<Scalars['Int']['output']>;
};

export type ScheduleTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  end_date: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  rosters: Array<Scalars['ID']['input']>;
  start_date: Scalars['DateTime']['input'];
};

export enum ScheduleType {
  Holiday = 'holiday',
  Leave = 'leave',
  Mandatory = 'mandatory',
  NoSchedule = 'noSchedule',
  NotMandatory = 'notMandatory',
  OverTime = 'overTime',
  Pto = 'pto',
  Schadule = 'schadule',
  Weekend = 'weekend'
}

export enum ScheduledFilter {
  All = 'all',
  Scheduled = 'scheduled',
  Unscheduled = 'unscheduled'
}

export type SchedulerConfigInput = {
  backgroundScheduler: Scalars['String']['input'];
  business: Scalars['ID']['input'];
  chunk_wise_short_break?: InputMaybe<ShortBreaksInput>;
  is_include_unpaid_break?: InputMaybe<Scalars['Boolean']['input']>;
  number_of_record_employees: Scalars['Int']['input'];
  overtimeColor: Scalars['String']['input'];
  paidTomeOffColor: Scalars['String']['input'];
  ptoColor?: InputMaybe<Scalars['String']['input']>;
  publicHolidayColor?: InputMaybe<Scalars['String']['input']>;
  sandwichLeaveColor?: InputMaybe<Scalars['String']['input']>;
  shortLeavePaid: Scalars['String']['input'];
  shortLeaveUnpaid: Scalars['String']['input'];
  short_breaks?: InputMaybe<ShortBreaksInput>;
  unpaidTomeOffColor: Scalars['String']['input'];
  weekendColor?: InputMaybe<Scalars['String']['input']>;
};

export type ScrapInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  assetId: Scalars['String']['input'];
  scrapDate?: InputMaybe<Scalars['Date']['input']>;
  scrapDealer?: InputMaybe<Scalars['String']['input']>;
};

export type SearchCampaignInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SearchCommissionInput = {
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<_SearchStatus>;
};

export type SearchDataTypeValueInput = {
  business: Scalars['ID']['input'];
  data_type: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SearchDiscountInput = {
  Business?: InputMaybe<Scalars['ID']['input']>;
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
};

export type SearchDiscountNewInput = {
  Business?: InputMaybe<Scalars['ID']['input']>;
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SearchRosterInput = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  store_id?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchSitesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum SearchStatus_ {
  Active = 'Active',
  All = 'All',
  Disabled = 'Disabled',
  Expired = 'Expired',
  Scheduled = 'Scheduled'
}

export type SearchTagsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum SearchUserTypeenum {
  Assets = 'assets',
  EmployeeSeparation = 'employeeSeparation',
  LoanAndPayment = 'loanAndPayment',
  Subscription = 'subscription',
  Timeoff = 'timeoff'
}

export type SectionValueInput = {
  addAttachment?: InputMaybe<Array<Scalars['Upload']['input']>>;
  addComment?: InputMaybe<Scalars['String']['input']>;
  addSubTask?: InputMaybe<Scalars['String']['input']>;
  assignTo?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  completeSubTask?: InputMaybe<CompletetSubTaskInput>;
  deleteAttachment?: InputMaybe<Scalars['String']['input']>;
  deleteSubTask?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  markAsDone?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<PriorityEmums>;
  status?: InputMaybe<_TaskStatusEmums>;
  summary?: InputMaybe<Scalars['String']['input']>;
  updateComment?: InputMaybe<UpdateCommentInput>;
};

export type SelectedScheduleInput = {
  empid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  scheduleDate?: InputMaybe<Scalars['String']['input']>;
};

export type SetNumberOfRecordInput = {
  business?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
};

export type ShareAppInput = {
  id: Scalars['ID']['input'];
  is_opt_share: Scalars['Boolean']['input'];
  is_password_share: Scalars['Boolean']['input'];
  is_scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled_for?: InputMaybe<Scalars['String']['input']>;
  share_as: ShareAsEnum;
  share_permissions: ShareAppPermissions;
  share_with?: InputMaybe<Array<InputMaybe<SharePasswordInput>>>;
};

export enum ShareAsEnum {
  Editor = 'Editor',
  Viewer = 'Viewer'
}

export type ShareBulkAppInput = {
  ids: Array<Scalars['ID']['input']>;
  is_opt_share: Scalars['Boolean']['input'];
  is_password_share: Scalars['Boolean']['input'];
  is_scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled_for?: InputMaybe<Scalars['String']['input']>;
  share_as: ShareAsEnum;
  share_permissions: ShareAppPermissions;
  share_with?: InputMaybe<Array<InputMaybe<BulkSharePasswordInput>>>;
};

export type ShareFilteredResults = {
  __typename?: 'shareFilteredResults';
  department?: Maybe<Department>;
  employees?: Maybe<Array<Maybe<EmloyeeSharePermission>>>;
  role?: Maybe<Role>;
  share_as?: Maybe<Scalars['String']['output']>;
};

export type SharePasswordInput = {
  employeeId: Scalars['ID']['input'];
  password?: InputMaybe<EncryptedPasswordInput>;
};

export type Share_Permissions = {
  __typename?: 'share_permissions';
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_edit?: Maybe<Scalars['Boolean']['output']>;
  can_share_otp?: Maybe<Scalars['Boolean']['output']>;
  can_share_password?: Maybe<Scalars['Boolean']['output']>;
};

export type Share_With = {
  __typename?: 'share_with';
  Document?: Maybe<DocumentControlAttachment>;
  _id?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Department>;
  employee?: Maybe<User>;
  role?: Maybe<Role>;
  share_as?: Maybe<Scalars['String']['output']>;
  shared_by?: Maybe<User>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ShiftFilter {
  Active = 'active',
  All = 'all',
  Archive = 'archive'
}

export type ShiftListingResult = {
  __typename?: 'shiftListingResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<Shift>>>;
};

export type ShortBreak = {
  __typename?: 'shortBreak';
  short_break_duration?: Maybe<Scalars['Int']['output']>;
  short_break_name?: Maybe<Scalars['String']['output']>;
};

export type ShortBreakClockedHistory = {
  __typename?: 'shortBreakClockedHistory';
  break_duration?: Maybe<Scalars['Int']['output']>;
  break_end_time?: Maybe<Scalars['String']['output']>;
  break_out_time?: Maybe<Scalars['String']['output']>;
  break_start_time?: Maybe<Scalars['String']['output']>;
  shift_time?: Maybe<Scalars['String']['output']>;
};

export type ShortBreakDetail = {
  break_duration?: InputMaybe<Scalars['Int']['input']>;
  break_end_time?: InputMaybe<Scalars['String']['input']>;
  break_start_time?: InputMaybe<Scalars['String']['input']>;
};

export type ShortBreakInput = {
  allowed_limit: Scalars['Int']['input'];
  break_duration: Scalars['Int']['input'];
  break_name: Scalars['String']['input'];
};

export enum ShortBreakType {
  Chunk = 'chunk',
  Frequency = 'frequency'
}

export type ShortBreaks = {
  __typename?: 'shortBreaks';
  short_break_duration?: Maybe<Scalars['Int']['output']>;
  short_break_name?: Maybe<Scalars['String']['output']>;
  short_break_type?: Maybe<Scalars['String']['output']>;
};

export type ShortBreaksInput = {
  short_break_duration?: InputMaybe<Scalars['Int']['input']>;
  short_break_name?: InputMaybe<Scalars['String']['input']>;
  short_break_type: ShortBreakType;
};

export type ShortBreaksRosterInput = {
  short_break_count?: InputMaybe<Scalars['Int']['input']>;
  short_break_duration?: InputMaybe<Scalars['Int']['input']>;
  short_break_name?: InputMaybe<Scalars['String']['input']>;
};

export type ShortLeave = {
  __typename?: 'shortLeave';
  TimeOff?: Maybe<Scalars['ID']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['String']['output']>;
  is_paid?: Maybe<Scalars['Float']['output']>;
  leave_type?: Maybe<Scalars['String']['output']>;
  minutes?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  short_leave_time_percentage?: Maybe<Scalars['Float']['output']>;
  star_time?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ShortLeaveInput = {
  employee: Scalars['ID']['input'];
  end_time: Scalars['String']['input'];
  leave_date: Scalars['DateTime']['input'];
  remarks: Scalars['String']['input'];
  start_time: Scalars['String']['input'];
};

export type ShortLeaveLog = {
  __typename?: 'shortLeaveLog';
  duration?: Maybe<Scalars['Int']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  previous_state?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
};

export type Short_Break_Detail = {
  __typename?: 'short_break_detail';
  break_duration?: Maybe<Scalars['Int']['output']>;
  break_end_time?: Maybe<Scalars['String']['output']>;
  break_out_time?: Maybe<Scalars['String']['output']>;
  break_start_time?: Maybe<Scalars['String']['output']>;
};

export type Shortbreak = {
  __typename?: 'shortbreak';
  short_break_count?: Maybe<Scalars['Int']['output']>;
  short_break_duration?: Maybe<Scalars['Int']['output']>;
  short_break_name?: Maybe<Scalars['String']['output']>;
};

export enum SmtpType {
  AmazonSes = 'amazon_ses',
  Brevo = 'brevo',
  Mailgun = 'mailgun',
  Postmark = 'postmark',
  Sendgrid = 'sendgrid'
}

export type SoldInput = {
  soldProductsType?: InputMaybe<SoldProductsType>;
};

export enum SoldProductsType {
  WithOutPrice = 'with_out_price',
  WithPrice = 'with_price'
}

export enum SortEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export enum Sort_By_Enum {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortingConfigInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  order_by?: InputMaybe<Scalars['String']['input']>;
};

export type StateInput = {
  Country: Scalars['ID']['input'];
  short_name?: InputMaybe<Scalars['String']['input']>;
  state_name: Scalars['String']['input'];
};

export type StationInput = {
  Department: Scalars['ID']['input'];
  station_name: Scalars['String']['input'];
};

export type StatsType = {
  __typename?: 'statsType';
  duration?: Maybe<Scalars['String']['output']>;
  highest_score?: Maybe<Scalars['Int']['output']>;
  total_attempt?: Maybe<Scalars['Int']['output']>;
  total_completed?: Maybe<Scalars['Int']['output']>;
  total_condidate?: Maybe<Scalars['Int']['output']>;
  total_fail?: Maybe<Scalars['Int']['output']>;
  total_inprogress?: Maybe<Scalars['Int']['output']>;
  total_not_attempt?: Maybe<Scalars['Int']['output']>;
  total_pass?: Maybe<Scalars['Int']['output']>;
  total_to_be_attempt?: Maybe<Scalars['Int']['output']>;
  total_to_be_check?: Maybe<Scalars['Int']['output']>;
};

export enum StatusEnum {
  Active = 'active',
  Inactive = 'inactive'
}

export enum StatusFilter {
  Accepted = 'accepted',
  All = 'all',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type StatusOfTasks = {
  __typename?: 'statusOfTasks';
  completed?: Maybe<Scalars['Int']['output']>;
  inProgress?: Maybe<Scalars['Int']['output']>;
  overdue?: Maybe<Scalars['Int']['output']>;
};

export type SubCate = {
  __typename?: 'subCate';
  Business?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SubCategory = {
  __typename?: 'subCategory';
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type SubCategoryDetail = {
  __typename?: 'subCategoryDetail';
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<AssetSubCategory>>>;
};

export type SubCategoryInput = {
  name: Scalars['String']['input'];
};

export type SubCategoryType = {
  __typename?: 'subCategoryType';
  actions?: Maybe<Array<Maybe<ConfigActionType>>>;
  columns?: Maybe<Array<Maybe<ListingColumnsType>>>;
  result?: Maybe<Array<Maybe<SubCategory>>>;
};

export type SubCatgoryObjs = {
  _id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SubData = {
  __typename?: 'subData';
  name?: Maybe<Scalars['String']['output']>;
};

export enum SubModulesEnum {
  AssetContractExpiry = 'asset_contract_expiry',
  AssetMaintenanceDue = 'asset_maintenance_due',
  AssetPastDueDate = 'asset_past_due_date',
  AssetWarrantyExpiry = 'asset_warranty_expiry',
  AttendanceBreakExceed = 'attendance_break_exceed',
  AttendanceMissedPunchout = 'attendance_missed_punchout',
  AuthenticationAccountCreation = 'authentication_account_creation',
  AuthenticationEmailChange = 'authentication_email_change',
  AuthenticationEmailVerification = 'authentication_email_verification',
  AuthenticationForgotPassword = 'authentication_forgot_password',
  AuthenticationPasswordChange = 'authentication_password_change',
  AuthenticationSsnUpdate = 'authentication_ssn_update',
  DocumentsExpiryAlert = 'documents_expiry_alert',
  EmployeeSeparationInitiation = 'employee_separation_initiation',
  GiftCardDelivery = 'gift_card_delivery',
  LmsQuizCreation = 'lms_quiz_creation',
  LmsQuizReminder = 'lms_quiz_reminder',
  LmsTrainingCompletion = 'lms_training_completion',
  LmsTrainingCreation = 'lms_training_creation',
  SalaryAdjustment = 'salary_adjustment',
  SalaryBackpay = 'salary_backpay',
  ScheduleReportCreation = 'schedule_report_creation',
  ScheduleReportDeletion = 'schedule_report_deletion',
  ScheduleReportUpdation = 'schedule_report_updation',
  ScheduleReportView = 'schedule_report_view',
  TimesheetMultiDayReport = 'timesheet_multi_day_report',
  TimesheetSingleDayReport = 'timesheet_single_day_report'
}

export type SubTaskInput = {
  _id: Scalars['ID']['input'];
  is_completed: Scalars['Boolean']['input'];
  sub_task_id: Scalars['ID']['input'];
};

export type SubmitDocumentEmployeeInput = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  google_drive_attachment?: InputMaybe<Scalars['String']['input']>;
  google_drive_id?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
};

export enum SubmittedBy {
  My = 'my',
  Other = 'other'
}

export type SubscribeMedicalInsuranceInput = {
  employee_id: Scalars['ID']['input'];
  medical_insurance_id: Scalars['ID']['input'];
};

export type SubscriptionListFilter = {
  business_id: Scalars['ID']['input'];
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type SwapeEmployeesData = {
  firstRoleId: Scalars['ID']['input'];
  firstUserId: Scalars['ID']['input'];
  secondRoleId: Scalars['ID']['input'];
  secondUserId: Scalars['ID']['input'];
};

export type SyncPayrollInput = {
  employee?: InputMaybe<Array<Scalars['ID']['input']>>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  pay_type?: InputMaybe<PayTypeEnum>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SystembrandResult = {
  __typename?: 'systembrandResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Brand>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type TagsListingResult = {
  __typename?: 'tagsListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Tags>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type TargetByDepartments = {
  __typename?: 'targetByDepartments';
  department_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  target?: Maybe<Scalars['String']['output']>;
};

export type TargetByDepartmentsInput = {
  department_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
};

export type TargetByEmployees = {
  __typename?: 'targetByEmployees';
  designation?: Maybe<Scalars['String']['output']>;
  employee_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  target?: Maybe<Scalars['String']['output']>;
};

export type TargetByEmployeesInput = {
  designation?: InputMaybe<Scalars['String']['input']>;
  employee_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
};

export type TargetByProducts = {
  __typename?: 'targetByProducts';
  amount?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['String']['output']>;
  product_category?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type TargetByProductsInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['String']['input']>;
  product_category?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaskCalender = {
  __typename?: 'taskCalender';
  result?: Maybe<TaskCalenderResults>;
};

export type TaskCalenderInput = {
  department?: InputMaybe<Scalars['String']['input']>;
  employeeSearch?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<EnumEventType>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type TaskCalenderResults = {
  __typename?: 'taskCalenderResults';
  birthdays?: Maybe<Array<Maybe<User>>>;
  employees?: Maybe<Array<Maybe<User>>>;
  leaves?: Maybe<Array<Maybe<TimeOff>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  publicHolidays?: Maybe<Array<Maybe<PublicHoliday>>>;
  results?: Maybe<Array<Maybe<TaskManagement>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type TaskCountInput = {
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  team_member?: InputMaybe<Scalars['ID']['input']>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaskListingResult = {
  __typename?: 'taskListingResult';
  assign_by_me?: Maybe<Array<Maybe<TaskManagement>>>;
  assign_to_me?: Maybe<Array<Maybe<TaskManagement>>>;
  closed_tasks?: Maybe<Array<Maybe<TaskManagement>>>;
  my_tasks?: Maybe<Array<Maybe<TaskManagement>>>;
};

export type TaskManagementCount = {
  __typename?: 'taskManagementCount';
  completed?: Maybe<Scalars['Int']['output']>;
  inProgress?: Maybe<Scalars['Int']['output']>;
  onHold?: Maybe<Scalars['Int']['output']>;
  todo?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum TaskSections {
  AddAttachment = 'add_attachment',
  AddSubTask = 'add_sub_task',
  AssignTo = 'assign_to',
  Comment = 'comment',
  CompleteSubTask = 'complete_sub_task',
  DeleteAttachment = 'delete_attachment',
  DeleteSubTask = 'delete_sub_task',
  Description = 'description',
  DueDate = 'due_date',
  MarkAsDone = 'mark_as_done',
  Priority = 'priority',
  Status = 'status',
  Summary = 'summary',
  UpdateComment = 'update_comment'
}

export enum TaskStatus {
  All = 'all',
  Closed = 'closed',
  DueDate = 'due_date',
  InProgress = 'inProgress'
}

export enum TaskStatusEmums {
  Closed = 'closed',
  InProgress = 'inProgress'
}

export enum TaskStatusUpdateEmums {
  BackLog = 'backLog',
  Completed = 'completed',
  InProgress = 'inProgress',
  OnHold = 'onHold',
  Todo = 'todo'
}

export type TaskType = {
  __typename?: 'taskType';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type TaskWithSearchInput = {
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<PriorityEmums>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskStatusUpdateEmums>;
  team_member?: InputMaybe<Scalars['ID']['input']>;
};

export type TasksCountResult = {
  __typename?: 'tasksCountResult';
  assign_by_me?: Maybe<Scalars['Int']['output']>;
  assign_to_me?: Maybe<Scalars['Int']['output']>;
  my_tasks?: Maybe<Scalars['Int']['output']>;
};

export type TasksForCalenderType = {
  __typename?: 'tasksForCalenderType';
  due_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum TaxFilter {
  Active = 'active',
  All = 'all',
  Archive = 'archive'
}

export type TaxFilterInput = {
  BusinessLocation: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaxFilter>;
};

export type TaxInput = {
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  applicable_on?: InputMaybe<Array<InputMaybe<ApplicableEnum>>>;
  is_tax_exemptible?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  percentage_amount: Scalars['Int']['input'];
};

export type TaxListingResult = {
  __typename?: 'taxListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<Tax>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type TillCountInput = {
  BusinessLocation?: InputMaybe<Scalars['ID']['input']>;
  cashDemonination?: InputMaybe<Array<InputMaybe<CashDemoninationInput>>>;
  cashRegister?: InputMaybe<Scalars['ID']['input']>;
  counted_amount?: InputMaybe<Scalars['Float']['input']>;
  deposited?: InputMaybe<Scalars['Float']['input']>;
  discrepancy?: InputMaybe<Scalars['Float']['input']>;
  expected_amount?: InputMaybe<Scalars['Float']['input']>;
  remaining_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type TimeOff = {
  __typename?: 'timeOff';
  _id?: Maybe<Scalars['ID']['output']>;
  accept_reject_leave?: Maybe<Array<Maybe<LeaveInputType>>>;
  acctual_minutes?: Maybe<Scalars['Int']['output']>;
  applied_minutes?: Maybe<Scalars['Int']['output']>;
  approval_description?: Maybe<Scalars['String']['output']>;
  approval_status?: Maybe<Scalars['String']['output']>;
  behalf_of?: Maybe<Array<Maybe<User>>>;
  business_manager?: Maybe<User>;
  countIn?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  date_type_leave?: Maybe<Array<Maybe<TypeLeave>>>;
  differenceInDays?: Maybe<Scalars['Int']['output']>;
  document_url?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<User>;
  is_between_leave?: Maybe<Scalars['Boolean']['output']>;
  is_compansation_leave?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_pto?: Maybe<Scalars['Boolean']['output']>;
  is_sandwich?: Maybe<Scalars['Boolean']['output']>;
  is_short_leave?: Maybe<Scalars['Boolean']['output']>;
  leave_request?: Maybe<Array<Maybe<LeaveInputType>>>;
  leave_request_dates?: Maybe<Array<Maybe<DateObj>>>;
  logs?: Maybe<Array<Maybe<LogsTimeOff>>>;
  no_request?: Maybe<Scalars['Float']['output']>;
  reason_for_leave?: Maybe<Scalars['String']['output']>;
  remaining_days?: Maybe<Scalars['Float']['output']>;
  remaining_unpaid_days?: Maybe<Scalars['Float']['output']>;
  request_id?: Maybe<Scalars['String']['output']>;
  sandwich?: Maybe<Array<Maybe<SandWichDays>>>;
  schedule_not_founds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<TimeOffStatus>;
  total_leave_out_of_accural?: Maybe<Scalars['Float']['output']>;
  total_leaves?: Maybe<Scalars['Float']['output']>;
  total_request_leaves?: Maybe<Scalars['Float']['output']>;
  total_unpaid_leaves?: Maybe<Scalars['Float']['output']>;
  type_of_absence?: Maybe<LeaveType>;
  unpaid_count?: Maybe<Scalars['Float']['output']>;
  upload_document_info?: Maybe<UpdloadDocumentInf>;
  work_flow?: Maybe<Array<Maybe<WorkFlow>>>;
};

export type TimeOffEmployeeInput = {
  is_pto?: InputMaybe<Scalars['Boolean']['input']>;
  time_off_days: Scalars['String']['input'];
  time_off_total_days?: InputMaybe<Scalars['String']['input']>;
  time_off_type: Scalars['ID']['input'];
};

export enum TimeOffEnum {
  Paid = 'Paid',
  Unpaid = 'Unpaid'
}

export type TimeOffInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  date_type_leave: Array<TypeLeaveInput>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  out_of_accural_leave_days?: InputMaybe<Scalars['Int']['input']>;
  out_of_accural_leave_hours?: InputMaybe<Scalars['Int']['input']>;
  reason_for_leave?: InputMaybe<Scalars['String']['input']>;
  remaining_days?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  total_leaves?: InputMaybe<Scalars['Float']['input']>;
  type_of_absence?: InputMaybe<Scalars['String']['input']>;
  type_of_absence_id?: InputMaybe<Scalars['String']['input']>;
};

export type TimeOffListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  from_timeOff_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
  to_timeOff_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimeOffListingresult = {
  __typename?: 'timeOffListingresult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<TimeOff>>>;
};

export enum TimeOffStatus {
  Approved = 'approved',
  Canceled = 'canceled',
  Partially = 'partially',
  Pending = 'pending',
  Rejected = 'rejected',
  Revision = 'revision'
}

export enum TimeOffStatusFilter {
  All = 'all',
  Approved = 'approved',
  Archive = 'archive',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type TimesheetAnalytics = {
  __typename?: 'timesheetAnalytics';
  absent?: Maybe<Scalars['Int']['output']>;
  attendanceDate?: Maybe<Scalars['String']['output']>;
  leave?: Maybe<Scalars['Int']['output']>;
  present?: Maybe<Scalars['Int']['output']>;
  publicHoliday?: Maybe<Scalars['Int']['output']>;
  weekend?: Maybe<Scalars['Int']['output']>;
};

export type TimesheetAnalyticsResult = {
  __typename?: 'timesheetAnalyticsResult';
  is_employee?: Maybe<Scalars['Boolean']['output']>;
  timesheet_analytics?: Maybe<Array<Maybe<TimesheetAnalytics>>>;
};

export type TimesheetGraph = {
  __typename?: 'timesheetGraph';
  daily_wages?: Maybe<Array<Maybe<Daily_Wages_Timesheet>>>;
  total_absent?: Maybe<Scalars['Int']['output']>;
  total_early_clocked_in?: Maybe<Scalars['Int']['output']>;
  total_early_out?: Maybe<Scalars['Int']['output']>;
  total_employees?: Maybe<Scalars['Int']['output']>;
  total_late_out?: Maybe<Scalars['Int']['output']>;
  total_lateness?: Maybe<Scalars['Int']['output']>;
  total_leaves?: Maybe<Scalars['Int']['output']>;
  total_miss_punch_out?: Maybe<Scalars['Int']['output']>;
  total_on_time_cloked_in?: Maybe<Scalars['Int']['output']>;
  total_on_time_out?: Maybe<Scalars['Int']['output']>;
  total_public_holidays?: Maybe<Scalars['Int']['output']>;
  total_restricted_employees?: Maybe<Scalars['Int']['output']>;
  total_schedules_minutes?: Maybe<Scalars['Int']['output']>;
  total_short_leaves?: Maybe<Scalars['Int']['output']>;
  total_wages?: Maybe<Scalars['Float']['output']>;
  total_weekends?: Maybe<Scalars['Int']['output']>;
};

export type TimesheetStatus = {
  __typename?: 'timesheetStatus';
  absent?: Maybe<Scalars['Int']['output']>;
  absent_users?: Maybe<Scalars['Int']['output']>;
  early_in?: Maybe<Scalars['Int']['output']>;
  early_out?: Maybe<Scalars['Int']['output']>;
  is_employee?: Maybe<Scalars['Boolean']['output']>;
  late_out?: Maybe<Scalars['Int']['output']>;
  lateness?: Maybe<Scalars['Int']['output']>;
  leave_users?: Maybe<Scalars['Int']['output']>;
  miss_punch_out?: Maybe<Scalars['Int']['output']>;
  on_time_in?: Maybe<Scalars['Int']['output']>;
  on_time_out?: Maybe<Scalars['Int']['output']>;
  paid_leavs?: Maybe<Scalars['Int']['output']>;
  present?: Maybe<Scalars['Int']['output']>;
  present_users?: Maybe<Scalars['Int']['output']>;
  publicHoliday?: Maybe<Scalars['Int']['output']>;
  restricted_employees?: Maybe<Scalars['Int']['output']>;
  short_leavs?: Maybe<Scalars['Int']['output']>;
  total_leaves?: Maybe<Scalars['Int']['output']>;
  total_users?: Maybe<Scalars['Int']['output']>;
  unpaid_leaves?: Maybe<Scalars['Int']['output']>;
  unrestricted_employees?: Maybe<Scalars['Int']['output']>;
  weekend?: Maybe<Scalars['Int']['output']>;
};

export type TimesheetStatusInput = {
  end_date: Scalars['String']['input'];
  is_employee: Scalars['Boolean']['input'];
  start_date: Scalars['String']['input'];
};

export type Token = {
  __typename?: 'token';
  expires?: Maybe<Scalars['DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type Tokens = {
  __typename?: 'tokens';
  access?: Maybe<Token>;
  refresh?: Maybe<Token>;
};

export type TotalEmployees = {
  __typename?: 'totalEmployees';
  _id?: Maybe<Scalars['String']['output']>;
  employee_group?: Maybe<Employee_Groups>;
};

export type TotalEmployeesRostersWages = {
  __typename?: 'totalEmployeesRostersWages';
  breaksTime?: Maybe<Array<Maybe<BreakTime>>>;
  dailyReport?: Maybe<Array<Maybe<DailyReport>>>;
  dateList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  leavesWithType?: Maybe<Array<Maybe<LeavesWithType>>>;
  totaTimeOffMinutes?: Maybe<Scalars['Int']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  totalMinutes?: Maybe<Scalars['Int']['output']>;
  totalOverTime?: Maybe<Scalars['Int']['output']>;
  totalRosters?: Maybe<Scalars['Int']['output']>;
  totalTimeOff?: Maybe<Scalars['Int']['output']>;
  totalWages?: Maybe<Scalars['String']['output']>;
  unRestrictedEmployees?: Maybe<Scalars['Int']['output']>;
  weeklyData?: Maybe<Array<Maybe<WeeklyData>>>;
};

export type TotalWagesAndScheduleHours = {
  __typename?: 'totalWagesAndScheduleHours';
  _id?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  totalScheduleMinutes?: Maybe<Scalars['Float']['output']>;
  totalWages?: Maybe<Scalars['Float']['output']>;
};

export type TrainingCategoriesInput = {
  name: Scalars['String']['input'];
  subCategories?: InputMaybe<Array<SubCategoryInput>>;
};

export type TransactionLogs = {
  __typename?: 'transactionLogs';
  adjustment_amount?: Maybe<Scalars['Float']['output']>;
  adjustment_comment?: Maybe<Scalars['String']['output']>;
  adjustment_date?: Maybe<Scalars['DateTime']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  created_by?: Maybe<User>;
  is_credit?: Maybe<Scalars['Boolean']['output']>;
};

export type TrashDocumentDataTableResult = {
  __typename?: 'trashDocumentDataTableResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<DocumentControlAttachment>>>;
};

export type TrashInput = {
  assetId: Scalars['String']['input'];
  expense?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  trashDate?: InputMaybe<Scalars['Date']['input']>;
};

export enum TypeAsset {
  Accessories = 'accessories',
  Accessory = 'accessory',
  Asset = 'asset'
}

export enum TypeEnum {
  Call = 'Call',
  Email = 'Email',
  Sms = 'SMS'
}

export type TypeLeave = {
  __typename?: 'typeLeave';
  end_time?: Maybe<Scalars['String']['output']>;
  is_paid?: Maybe<Scalars['Boolean']['output']>;
  leave_date?: Maybe<Scalars['DateTime']['output']>;
  leave_type?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
};

export type TypeLeaveInput = {
  end_time?: InputMaybe<Scalars['String']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  leave_date?: InputMaybe<Scalars['DateTime']['input']>;
  leave_type?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
};

export type UnAssignAssetInput = {
  asset_Id: Scalars['ID']['input'];
  item_id: Scalars['ID']['input'];
};

export type UnBlockInput = {
  ids: Array<Scalars['ID']['input']>;
  isEmployees: Scalars['Boolean']['input'];
  status: EmployeeStatus;
};

export type UnLinkingRelationAsset = {
  assetId: Scalars['ID']['input'];
  assetTag: Scalars['String']['input'];
  relationAssetId: Scalars['ID']['input'];
};

export type UnSignedList = {
  __typename?: 'unSignedList';
  _id?: Maybe<Scalars['ID']['output']>;
  docRef?: Maybe<Scalars['String']['output']>;
  request_to?: Maybe<Scalars['String']['output']>;
  requested_time?: Maybe<Scalars['DateTime']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  signed_time?: Maybe<Scalars['DateTime']['output']>;
  subject_to?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  user_request_from?: Maybe<Scalars['String']['output']>;
};

export type UnlinkBusinessInput = {
  business_navigation_id: Scalars['ID']['input'];
};

export type UpdateAccountTypeInput = {
  _id: Scalars['ID']['input'];
  is_editable: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type UpdateAppInput = {
  app_name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  password?: InputMaybe<PasswordManagerInput>;
  qrData?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type UpdateAppraisalObjecive = {
  AppraisalType?: InputMaybe<Scalars['ID']['input']>;
  _id: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight_percent?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAppraisalType = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumActive>;
  target_type: TargetEnum;
};

export type UpdateAssignToInput = {
  _id: Scalars['ID']['input'];
  action_performed?: InputMaybe<Scalars['Boolean']['input']>;
  assignee: Scalars['ID']['input'];
};

export type UpdateAttendanceSocket = {
  __typename?: 'updateAttendanceSocket';
  action?: Maybe<Scalars['String']['output']>;
  clockedHistory?: Maybe<ClockedHistory>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

export type UpdateBusinessInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  business_identification_number?: InputMaybe<Scalars['String']['input']>;
  business_identification_type?: InputMaybe<Scalars['String']['input']>;
  business_legal_name: Scalars['String']['input'];
  business_logo?: InputMaybe<Scalars['Upload']['input']>;
  business_system_name: Scalars['String']['input'];
  business_type: AllowBusinessType;
  city?: InputMaybe<Scalars['ID']['input']>;
  country: Scalars['ID']['input'];
  currency_format?: InputMaybe<Scalars['String']['input']>;
  currency_name?: InputMaybe<Scalars['String']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  date_format?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  is_24_hour_format?: InputMaybe<Scalars['Boolean']['input']>;
  is_email_verify?: InputMaybe<Scalars['Boolean']['input']>;
  is_phone_verify?: InputMaybe<Scalars['Boolean']['input']>;
  landline?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  owner_id?: InputMaybe<Scalars['String']['input']>;
  package?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_country_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['ID']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessOwnerPasswordInput = {
  encryptedPassword?: InputMaybe<ChangePasswordEncryptionKeys>;
  newPassword: Scalars['String']['input'];
};

export type UpdateCategoryInput = {
  business: Scalars['String']['input'];
  category_id?: InputMaybe<Scalars['ID']['input']>;
  category_name?: InputMaybe<Scalars['String']['input']>;
  templateFile?: InputMaybe<Scalars['Upload']['input']>;
};

export type UpdateCommentInput = {
  comment: Scalars['String']['input'];
  comment_id: Scalars['ID']['input'];
  mention_users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  optional_id?: InputMaybe<Scalars['String']['input']>;
  task_id: Scalars['ID']['input'];
};

export type UpdateDataTypeValueInput = {
  _id: Scalars['ID']['input'];
  business?: InputMaybe<Scalars['ID']['input']>;
  data_value_name: Scalars['String']['input'];
  data_value_type?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDescriptionInput = {
  _id: Scalars['ID']['input'];
  description: Scalars['String']['input'];
};

export type UpdateDocumentInput = {
  assign_to?: InputMaybe<AssignToInput>;
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  document_type?: InputMaybe<DocumentType>;
  id: Scalars['ID']['input'];
  is_document_submission_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_hide_after_review?: InputMaybe<Scalars['Boolean']['input']>;
  is_sign_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_submission_required?: InputMaybe<Scalars['Boolean']['input']>;
  validity?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateDoucment = {
  docRef?: InputMaybe<Scalars['Upload']['input']>;
  doc_id?: InputMaybe<Scalars['String']['input']>;
  xfdf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateDueDateInput = {
  _id: Scalars['ID']['input'];
  due_date: Scalars['DateTime']['input'];
};

export type UpdateEvaluationInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  listProjects?: InputMaybe<Scalars['String']['input']>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  objectiveAssigned?: InputMaybe<Array<InputMaybe<ObjectiveAssignmnet>>>;
  performanceGoals?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  road_map?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_remark?: InputMaybe<Scalars['Float']['input']>;
  total_score?: InputMaybe<Scalars['Float']['input']>;
  total_target?: InputMaybe<Scalars['Float']['input']>;
  total_weight?: InputMaybe<Scalars['Float']['input']>;
  trainingRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateExpenseInvoice = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateExpenseInvoiceCategory = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInputAppraisaleScale = {
  _id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  scale_group?: InputMaybe<Array<InputMaybe<ScaleGroupInput>>>;
  total_score?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateInputObjectiveAssignment = {
  _id: Scalars['ID']['input'];
  objectiveAssigned?: InputMaybe<Array<InputMaybe<ObjectiveAssignedInput>>>;
};

export type UpdateInputUserAppDevice = {
  app_type: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  is_approved: Scalars['Boolean']['input'];
};

export type UpdateInvoiceItemsInput = {
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  color?: InputMaybe<Scalars['String']['input']>;
  expenseId?: InputMaybe<Scalars['ID']['input']>;
  expenseInvCategoryId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_expense?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newCreatedAssetsList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLeaseInput = {
  assetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  leaseBegin?: InputMaybe<Scalars['String']['input']>;
  leaseEnd?: InputMaybe<Scalars['String']['input']>;
  leasingCustomerId: Scalars['ID']['input'];
};

export type UpdateLeavePolicyInput = {
  _id: Scalars['ID']['input'];
  assign_to: Array<Scalars['ID']['input']>;
  business?: InputMaybe<Scalars['ID']['input']>;
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
  leaves: Array<LeavesInput>;
  name: Scalars['String']['input'];
};

export type UpdateLeaveRequest = {
  accept_reject_leave?: InputMaybe<Array<InputMaybe<LeaveInput>>>;
  action_performed?: InputMaybe<Scalars['Boolean']['input']>;
  approval_description?: InputMaybe<Scalars['String']['input']>;
  date_type_leave?: InputMaybe<Array<InputMaybe<TypeLeaveInput>>>;
  employee_id: Scalars['ID']['input'];
  is_adjusted?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_sandwich?: InputMaybe<Scalars['Boolean']['input']>;
  leave_request?: InputMaybe<Array<InputMaybe<LeaveInput>>>;
  reason_for_leave?: InputMaybe<Scalars['String']['input']>;
  remaining_days?: InputMaybe<Scalars['Float']['input']>;
  remaining_unpaid_days?: InputMaybe<Scalars['Float']['input']>;
  sandwich?: InputMaybe<Array<InputMaybe<SandwichUpdateAproval>>>;
  status?: InputMaybe<TimeOffStatus>;
  time_off_id: Scalars['ID']['input'];
  total_leave_out_of_accural?: InputMaybe<Scalars['Float']['input']>;
  total_leaves?: InputMaybe<Scalars['Float']['input']>;
  total_unpaid_leaves?: InputMaybe<Scalars['Float']['input']>;
  type_of_absence: Scalars['ID']['input'];
  type_of_absence_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLoanRequest = {
  action_performed?: InputMaybe<Scalars['Boolean']['input']>;
  approval_description?: InputMaybe<Scalars['String']['input']>;
  employee_id: Scalars['ID']['input'];
  loan_id: Scalars['ID']['input'];
  status: LoanPaymentStatus;
};

export type UpdateMultiSchduleInput = {
  break_detail?: InputMaybe<Array<ScheduleBreaksInput>>;
  employeesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  is_all?: InputMaybe<Scalars['Boolean']['input']>;
  notifyByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  short_break?: InputMaybe<Scalars['ID']['input']>;
  short_break_count?: InputMaybe<Scalars['Int']['input']>;
  short_break_duration: Scalars['Int']['input'];
  short_break_type: ShortBreakType;
  start_date: Scalars['DateTime']['input'];
  start_time: Scalars['String']['input'];
};

export type UpdateMultipleScheduleRes = {
  __typename?: 'updateMultipleScheduleRes';
  data?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Array<Maybe<ErrorMessage>>>;
};

export type UpdatePayrollStatusInput = {
  _id: Scalars['ID']['input'];
  status: PayrollStatus;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdatePerformanceCycleInput = {
  Department?: InputMaybe<Scalars['ID']['input']>;
  Role?: InputMaybe<Scalars['ID']['input']>;
  appraisal_setting?: InputMaybe<Array<InputMaybe<AppraisalSettingInput>>>;
  appraiser_setting?: InputMaybe<Array<InputMaybe<AppraiserSettingInput>>>;
  assigning_start_date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end_date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  is_all?: InputMaybe<Scalars['Boolean']['input']>;
  is_linear_flow?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  start_date: Scalars['Date']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePerformanceCycleStatusInput = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  status: Scalars['String']['input'];
};

export type UpdatePermissions = {
  permissions?: InputMaybe<Array<UserPermissionInput>>;
};

export type UpdatePreviousDataInput = {
  from_date: Scalars['String']['input'];
};

export type UpdatePreviousInput = {
  business_id?: InputMaybe<Scalars['ID']['input']>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  is_paid_weekend?: InputMaybe<Scalars['Boolean']['input']>;
  is_weekend_mode?: InputMaybe<Scalars['Boolean']['input']>;
  pay_type?: InputMaybe<Scalars['ID']['input']>;
  weekEndDays?: InputMaybe<Array<InputMaybe<WeekEndDays>>>;
  working_days?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePriorityInput = {
  _id: Scalars['ID']['input'];
  priority: PriorityEmums;
};

export type UpdateProfilePictureInput = {
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  type?: InputMaybe<UpdateProfileTypeEnum>;
};

export enum UpdateProfileTypeEnum {
  Asset = 'asset',
  Business = 'business',
  Employee = 'employee'
}

export type UpdateRegionInput = {
  Business?: InputMaybe<Scalars['ID']['input']>;
  BusinessLocation?: InputMaybe<Array<Scalars['ID']['input']>>;
  City?: InputMaybe<Array<Scalars['ID']['input']>>;
  Country: Scalars['ID']['input'];
  State?: InputMaybe<Array<Scalars['ID']['input']>>;
  _id: Scalars['ID']['input'];
  region_name: Scalars['String']['input'];
};

export type UpdateRegisterBusinessInput = {
  business_identification_number?: InputMaybe<Scalars['String']['input']>;
  business_identification_type?: InputMaybe<Scalars['String']['input']>;
  business_legal_name: Scalars['String']['input'];
  business_logo?: InputMaybe<Scalars['Upload']['input']>;
  card_holder_name: Scalars['String']['input'];
  card_number: Scalars['String']['input'];
  confirm_password?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['ID']['input'];
  currency_format?: InputMaybe<Scalars['String']['input']>;
  currency_name?: InputMaybe<Scalars['String']['input']>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  cvv: Scalars['String']['input'];
  date_format?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  estimated_monthly_sale?: InputMaybe<Scalars['Float']['input']>;
  expiration_month: Scalars['String']['input'];
  expiration_year: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  is_24_hour_format?: InputMaybe<Scalars['Boolean']['input']>;
  landline?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  number_of_stores?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  phone_country_code: Scalars['String']['input'];
  save_card: Scalars['Boolean']['input'];
  what_mostly_sell?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateRepliesCommentInput = {
  comment_id: Scalars['ID']['input'];
  reply: Scalars['String']['input'];
  reply_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
};

export type UpdateRequestLevel = {
  action_performed?: InputMaybe<Scalars['Boolean']['input']>;
  approval_description?: InputMaybe<Scalars['String']['input']>;
  attendance_date: Scalars['DateTime']['input'];
  attendance_id: Scalars['ID']['input'];
  employee_id: Scalars['ID']['input'];
  reason_type: Scalars['String']['input'];
  status: AttendanceStatus;
  time_in?: InputMaybe<Scalars['String']['input']>;
  time_out?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSampleDataInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  is_selected: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateSchduleInput = {
  _id: Scalars['ID']['input'];
  break_detail?: InputMaybe<Array<ScheduleBreaksInput>>;
  end_time: Scalars['String']['input'];
  notifyByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  short_break?: InputMaybe<Scalars['ID']['input']>;
  short_break_count?: InputMaybe<Scalars['Int']['input']>;
  short_break_duration: Scalars['Int']['input'];
  short_break_type: ShortBreakType;
  start_time: Scalars['String']['input'];
};

export type UpdateShipTo = {
  id: Scalars['ID']['input'];
  location: Scalars['String']['input'];
};

export type UpdateSummaryInput = {
  _id: Scalars['ID']['input'];
  summary: Scalars['String']['input'];
};

export type UpdateTaskInput = {
  _id: Scalars['ID']['input'];
  assignee?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  check_list?: InputMaybe<Array<CheckListInput>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  editor_description?: InputMaybe<Scalars['String']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<PriorityEmums>;
  removeFileUrl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Scalars['ID']['input']>;
  status: TaskStatusUpdateEmums;
  summary: Scalars['String']['input'];
};

export type UpdateTaskSectionWise = {
  _id: Scalars['ID']['input'];
  section: TaskSections;
  sectionValue: SectionValueInput;
};

export type UpdateTraininReplicagInput = {
  add_attachments: Array<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  remove_attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrainingAttachementStatus = {
  attachmentId: Scalars['ID']['input'];
  is_completed: Scalars['Boolean']['input'];
};

export type UpdateTrainingCategoriesInput = {
  name: Scalars['String']['input'];
  subCategories?: InputMaybe<Array<UpdateSubCategoriesInput>>;
};

export type UpdateTrainingInput = {
  Quiz?: InputMaybe<Scalars['ID']['input']>;
  QuizTrainingCategory: Scalars['ID']['input'];
  QuizTrainingSubCategory: Scalars['ID']['input'];
  add_attachments?: InputMaybe<Array<TrainingAttachmentInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<TrainingLinkInput>>>;
  remove_attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedLanguages: Array<LanguageCode>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrainingLinkStatus = {
  is_completed: Scalars['Boolean']['input'];
  linkId: Scalars['ID']['input'];
};

export type UpdateUserInput = {
  _id: Scalars['ID']['input'];
  business_id: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  old_password?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserPasswordInput = {
  confirmPassword: Scalars['String']['input'];
  encryptedPassword?: InputMaybe<ChangePasswordEncryptionKeys>;
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type UpdateWriteUpInput = {
  _id: Scalars['ID']['input'];
  accept_assign_schedule?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<InformedBy>;
  employee: Scalars['ID']['input'];
  informed_hr?: InputMaybe<Scalars['Boolean']['input']>;
  write_up_type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdloadDocumentInf = {
  __typename?: 'updloadDocumentInf';
  extension?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type UplaodDocument = {
  __typename?: 'uplaodDocument';
  date?: Maybe<Scalars['DateTime']['output']>;
  employee?: Maybe<User>;
  fileRef?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadAssetDocInput = {
  assetDoc?: InputMaybe<Scalars['Upload']['input']>;
  assetId: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type UploadFileDocumentControlAttachment = {
  attachment: Array<Scalars['Upload']['input']>;
  google_drive_attachment?: InputMaybe<Scalars['String']['input']>;
  google_drive_id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
};

export type UpoadFileWorkFlow = {
  __typename?: 'upoadFileWorkFlow';
  file_name?: Maybe<Scalars['String']['output']>;
  file_url?: Maybe<Scalars['String']['output']>;
  uploaded_by?: Maybe<User>;
};

export type UserAccountStatus = {
  __typename?: 'userAccountStatus';
  account_status?: Maybe<Scalars['Boolean']['output']>;
};

export type UserActivityListingResult = {
  __typename?: 'userActivityListingResult';
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<UserActivity>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type UserAppDevice = {
  __typename?: 'userAppDevice';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  User?: Maybe<User>;
  _id?: Maybe<Scalars['ID']['output']>;
  app_type?: Maybe<Scalars['String']['output']>;
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  approved_by?: Maybe<User>;
  device_id?: Maybe<Scalars['String']['output']>;
  device_manufacturer?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  device_name?: Maybe<Scalars['String']['output']>;
  installed_date?: Maybe<Scalars['DateTime']['output']>;
  is_allow_attendance?: Maybe<Scalars['Boolean']['output']>;
  last_active_date?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  operating_system?: Maybe<Scalars['String']['output']>;
  os_version?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  removed_at?: Maybe<Scalars['DateTime']['output']>;
  removed_by?: Maybe<User>;
  sim_network?: Maybe<Scalars['String']['output']>;
  sim_number?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  terminal_id?: Maybe<Scalars['String']['output']>;
  terminal_name?: Maybe<Scalars['String']['output']>;
};

export type UserAppDeviceCount = {
  __typename?: 'userAppDeviceCount';
  allowAttendanceCount?: Maybe<Scalars['Int']['output']>;
  linked_device_count?: Maybe<Scalars['Int']['output']>;
  notAllowAttendanceCount?: Maybe<Scalars['Int']['output']>;
  terminal_app_device_count?: Maybe<Scalars['Int']['output']>;
  unlinked_device_count?: Maybe<Scalars['Int']['output']>;
  user_app_device_count?: Maybe<Scalars['Int']['output']>;
};

export type UserAppDeviceList = {
  __typename?: 'userAppDeviceList';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<UserAppDevice>>>;
};

export type UserAuthDetail = {
  __typename?: 'userAuthDetail';
  avatar_location?: Maybe<Scalars['String']['output']>;
  business_city_name?: Maybe<Scalars['String']['output']>;
  business_country_name?: Maybe<Scalars['String']['output']>;
  business_id?: Maybe<Business>;
  business_is_super_admin?: Maybe<Scalars['Boolean']['output']>;
  business_state_name?: Maybe<Scalars['String']['output']>;
  business_status: Scalars['String']['output'];
  business_type: Scalars['String']['output'];
  chat_user_name?: Maybe<Scalars['String']['output']>;
  currency_format?: Maybe<Scalars['String']['output']>;
  currency_name?: Maybe<Scalars['String']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  date_format?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Array<Maybe<Department>>>;
  designation?: Maybe<Designation>;
  do_not_disturb?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_domain?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isDeviceExists?: Maybe<Scalars['Boolean']['output']>;
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  is_navigated_user?: Maybe<Scalars['Boolean']['output']>;
  is_popup_closed?: Maybe<Scalars['Boolean']['output']>;
  is_sample_data?: Maybe<Scalars['Boolean']['output']>;
  is_un_restricted?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_working_date?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profile_pictures?: Maybe<Array<Maybe<ProfilePictures>>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  time_zone?: Maybe<Scalars['String']['output']>;
  two_fa_secret?: Maybe<Scalars['String']['output']>;
  user_is_super_admin?: Maybe<Scalars['Boolean']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

export type UserBreakIn = {
  app_type?: InputMaybe<Application_Type>;
  breakId?: InputMaybe<Scalars['String']['input']>;
  breakType?: InputMaybe<Scalars['String']['input']>;
  clockedHistoryId?: InputMaybe<Scalars['ID']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  minimum_break_percentage?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserCLocked = {
  __typename?: 'userCLocked';
  Schedule?: Maybe<Schedule>;
  User?: Maybe<User>;
  UserClockInPin: Scalars['String']['output'];
  break_details?: Maybe<Break_Details>;
  clockedHistory?: Maybe<ClockedHistory>;
  clocked_in_time?: Maybe<Scalars['String']['output']>;
  isOnShortBreak?: Maybe<Scalars['Boolean']['output']>;
  is_un_restricted?: Maybe<Scalars['Boolean']['output']>;
  oldClockHistoryId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Tokens>;
};

export type UserCustomPermissions = {
  __typename?: 'userCustomPermissions';
  can_update_payroll?: Maybe<Scalars['Boolean']['output']>;
  can_update_schedule?: Maybe<Scalars['Boolean']['output']>;
  can_view_payroll?: Maybe<Scalars['Boolean']['output']>;
  can_view_schedule?: Maybe<Scalars['Boolean']['output']>;
};

export type UserDashbaord = {
  __typename?: 'userDashbaord';
  task?: Maybe<Array<Maybe<TaskForUserDashbaord>>>;
  wagesAndHours?: Maybe<Array<Maybe<UserDashboardWagesAndHours>>>;
};

export type UserDashboardInput = {
  task_end_date?: InputMaybe<Scalars['String']['input']>;
  task_start_date?: InputMaybe<Scalars['String']['input']>;
  timesheet_end_date?: InputMaybe<Scalars['String']['input']>;
  timesheet_start_date?: InputMaybe<Scalars['String']['input']>;
};

export type UserDashboardWagesAndHours = {
  __typename?: 'userDashboardWagesAndHours';
  _id?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  totalWages?: Maybe<Scalars['Float']['output']>;
};

export type UserData = {
  __typename?: 'userData';
  Schedule?: Maybe<Schedule>;
  User?: Maybe<User>;
  UserClockInPin?: Maybe<Scalars['String']['output']>;
  approval_requests?: Maybe<Scalars['Int']['output']>;
  attendanceStatus?: Maybe<Scalars['String']['output']>;
  break_details?: Maybe<Break_Details>;
  clockedHistory?: Maybe<ClockedHistory>;
  clocked_in_time?: Maybe<Scalars['String']['output']>;
  isOnShortBreak?: Maybe<Scalars['Boolean']['output']>;
  isScheduleViewAsAdmin?: Maybe<Scalars['Boolean']['output']>;
  isTimesheetViewAsAdmin?: Maybe<Scalars['Boolean']['output']>;
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  is_clocked_in_from_app?: Maybe<Scalars['Boolean']['output']>;
  is_un_restricted?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Scalars['Int']['output']>;
  oldClockHistoryId?: Maybe<Scalars['String']['output']>;
  onTime?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  short_break?: Maybe<ShortBreak>;
  short_break_count?: Maybe<Scalars['Int']['output']>;
  short_break_detail?: Maybe<Array<Maybe<Short_Break_Detail>>>;
  status?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Scalars['Int']['output']>;
};

export type UserEncryptionKeyInput = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKey: Scalars['String']['input'];
  iv: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
  salt: Scalars['String']['input'];
};

export type UserFilterTasks = {
  date: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type UserMonthlyAttendaceStatus = {
  __typename?: 'userMonthlyAttendaceStatus';
  absent?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  onLeave?: Maybe<Scalars['Int']['output']>;
  present?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  week?: Maybe<Scalars['String']['output']>;
};

export type UserPermissionInput = {
  id: Scalars['ID']['input'];
  is_enabled: Scalars['Boolean']['input'];
};

export type UserShortBreak = {
  app_type: Application_Type;
  break_end_time?: InputMaybe<Scalars['String']['input']>;
  clockedHistoryId?: InputMaybe<Scalars['ID']['input']>;
  device_id: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  shift_time?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserWithRolesHierarchy = {
  __typename?: 'userWithRolesHierarchy';
  Business?: Maybe<Business>;
  BusinessLocation?: Maybe<BusinessLocation>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<Role>;
  parentId?: Maybe<Scalars['ID']['output']>;
  path?: Maybe<Array<Maybe<Role>>>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  positionName?: Maybe<Scalars['String']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
  rolePolicy?: Maybe<RolePolicy>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type User_List_Input = {
  employee?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type Userdata = {
  __typename?: 'userdata';
  _id?: Maybe<Scalars['ID']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
};

export type UsersSharedPasswordInput = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<EncryptedPasswordInput>;
};

export type ValidateDiscountInput = {
  couponCode: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};

export type Vendors = {
  __typename?: 'vendors';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum VerificationMethodEnum {
  Email = 'email',
  Phone = 'phone'
}

export type VerifySsnAndSendOtpInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  method: VerificationMethodEnum;
  phone?: InputMaybe<Scalars['String']['input']>;
  ssn_no: Scalars['String']['input'];
};

export type Wages = {
  __typename?: 'wages';
  _id?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  totalWages?: Maybe<Scalars['Float']['output']>;
  total_calculated_daily_salary?: Maybe<Scalars['Float']['output']>;
};

export type WagesByDate = {
  __typename?: 'wagesByDate';
  date?: Maybe<Scalars['String']['output']>;
  total_wages?: Maybe<Scalars['Float']['output']>;
};

export type WeekAndYearInput = {
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type WeekEndDays = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WeekEndDaysRetun = {
  __typename?: 'weekEndDaysRetun';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
};

export type Weekend = {
  __typename?: 'weekend';
  _id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
};

export type WeeklyData = {
  __typename?: 'weeklyData';
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  totalOverTime?: Maybe<Scalars['Int']['output']>;
  totalRostersTime?: Maybe<Scalars['Int']['output']>;
  totalWages?: Maybe<Scalars['String']['output']>;
  weekNumber?: Maybe<Scalars['Int']['output']>;
};

export type WorkFlow = {
  __typename?: 'workFlow';
  action_date?: Maybe<Scalars['Date']['output']>;
  approval_description?: Maybe<Scalars['String']['output']>;
  approved_by?: Maybe<User>;
  delegated_user?: Maybe<Array<Maybe<User>>>;
  deleted_date?: Maybe<Scalars['Date']['output']>;
  employee?: Maybe<User>;
  status?: Maybe<Scalars['String']['output']>;
};

export type WorkFlowLevels = {
  __typename?: 'workFlowLevels';
  approval_level?: Maybe<Scalars['Int']['output']>;
  approval_to?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<User>;
  level?: Maybe<Scalars['Int']['output']>;
  move_to_next?: Maybe<Scalars['String']['output']>;
  reminder?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
};

export type WorkFlowListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum WorkFlowTypeEnum {
  AttendenceRegulation = 'AttendenceRegulation',
  Complaint = 'Complaint',
  Expense = 'Expense',
  Leave = 'Leave',
  Loan = 'Loan',
  WriteUp = 'WriteUp'
}

export type WorkFlows = {
  __typename?: 'workFlows';
  current_workflow_levels?: Maybe<Array<Maybe<Level>>>;
  previous_workflow_levels?: Maybe<Array<Maybe<Level>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<User>;
};

export type WriteUpByEmployee = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  employee: Scalars['ID']['input'];
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
};

export type WriteUpInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  accept_assign_schedule?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<InformedBy>;
  employee?: InputMaybe<Scalars['ID']['input']>;
  informed_hr?: InputMaybe<Scalars['Boolean']['input']>;
  write_up_reason: WriteUpReason;
  write_up_source?: InputMaybe<Application_Type>;
  write_up_type?: InputMaybe<Scalars['String']['input']>;
  writeup_date?: InputMaybe<Scalars['DateTime']['input']>;
  writeup_message?: InputMaybe<Scalars['String']['input']>;
};

export type WriteUpListDataTable = {
  __typename?: 'writeUpListDataTable';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<WriteUp>>>;
};

export type WriteUpListFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preset_filters_cleared?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  table_view_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<WriteUpStatus>;
};

export type WriteUpRequestFilter = {
  columns?: InputMaybe<Array<InputMaybe<ColumnsInput>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  exported_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  is_call_from_app?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  is_exported?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<SortEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WriteUpResult = {
  __typename?: 'writeUpResult';
  config?: Maybe<UpdatedDataTableConfig>;
  results?: Maybe<Array<Maybe<WriteUp>>>;
};

export enum WriteUpStatus {
  Accepted = 'accepted',
  All = 'all',
  Archive = 'archive',
  Pending = 'pending',
  Rejected = 'rejected'
}

export enum WriteUpTypeFilters {
  All = 'All',
  EarlyOut = 'EarlyOut',
  Late = 'Late',
  LateOut = 'LateOut',
  MissPunchOut = 'MissPunchOut'
}

export enum WritupStatusEnumMult {
  Accepted = 'accepted',
  Rejected = 'rejected'
}

export enum XpenseStatusEnum {
  Accept = 'accept',
  All = 'all',
  Reject = 'reject'
}

export enum YearlyMonthlyEnum {
  Monthly = 'Monthly',
  Onetime = 'Onetime',
  Yearly = 'Yearly'
}

export type GetAllAccessoriesWithSearchQueryVariables = Exact<{
  input?: InputMaybe<AccessoriesListFilter>;
}>;


export type GetAllAccessoriesWithSearchQuery = { __typename?: 'Query', getAllAccessoriesWithSearch?: { __typename?: 'assetListingResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Asset', id?: string | null, is_deleted?: boolean | null, assetId?: string | null, name?: string | null, type?: string | null, status?: string | null, quantity?: number | null, actualQuantity?: number | null, location?: string | null, availStatus?: string | null, assetImage?: string | null, category?: { __typename?: 'AssetCategory', id?: string | null, name: string } | null, subCategory?: { __typename?: 'AssetSubCategory', id: string, name?: string | null } | null, AssetBrand?: { __typename?: 'AssetBrand', _id: string, brand_name?: string | null } | null, AssetModel?: { __typename?: 'AssetModel', _id: string, model_name?: string | null } | null, Vendor?: { __typename?: 'Vendor', _id?: string | null, name?: string | null } | null, invoice?: { __typename?: 'invoicesList', id?: string | null, invoiceId?: string | null, orderNumber?: string | null } | null, linkingAssets?: Array<{ __typename?: 'linkingAssets', relation?: string | null, asset?: { __typename?: 'Asset', id?: string | null } | null } | null> | null } | null> | null } | null };

export type MoveAccessoriesToAssetMutationVariables = Exact<{
  accessoryId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MoveAccessoriesToAssetMutation = { __typename?: 'Mutation', moveAccessoriesToAsset?: boolean | null };

export type ArchiveAccessoryMutationVariables = Exact<{
  id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveAccessoryMutation = { __typename?: 'Mutation', archiveAsset?: boolean | null };

export type CreateAdvanceFilterMutationVariables = Exact<{
  input: InputCreateAdvanceFilter;
}>;


export type CreateAdvanceFilterMutation = { __typename?: 'Mutation', createAdvanceFilter?: boolean | null };

export type GetAllAdvanceFiltersQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetAllAdvanceFiltersQuery = { __typename?: 'Query', getAllAdvanceFilters?: Array<{ __typename?: 'advanceFilter', _id?: string | null, filter_name?: string | null, list_type?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, filters?: Array<{ __typename?: 'listingFiltersType', _ids?: Array<string | null> | null, field?: string | null, search?: string | null, type?: string | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_condition?: string | null, first_value?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null } | null> | null };

export type GetAdvanceFilterByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAdvanceFilterByIdQuery = { __typename?: 'Query', getAdvanceFilterById?: { __typename?: 'advanceFilter', _id?: string | null, filter_name?: string | null, list_type?: string | null, filters?: Array<{ __typename?: 'listingFiltersType', _ids?: Array<string | null> | null, field?: string | null, search?: string | null, type?: string | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_condition?: string | null, first_value?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, is_search_able?: boolean | null, is_amount?: boolean | null, is_visible?: boolean | null, is_sortable?: boolean | null, search?: string | null, type?: string | null, filterValue?: Array<string | null> | null, column_data?: Array<string | null> | null, query?: { __typename?: 'queryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type ArchiveAdvanceFilterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveAdvanceFilterMutation = { __typename?: 'Mutation', archiveAdvanceFilter?: boolean | null };

export type CreateUpdateTablePresetMutationVariables = Exact<{
  input?: InputMaybe<CreateInputTablePreset>;
}>;


export type CreateUpdateTablePresetMutation = { __typename?: 'Mutation', createUpdateTablePreset?: boolean | null };

export type DeleteTablePresetMutationVariables = Exact<{
  input?: InputMaybe<DeleteInputTablePreset>;
}>;


export type DeleteTablePresetMutation = { __typename?: 'Mutation', deleteTablePreset?: boolean | null };

export type ClearTempTablePresetMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearTempTablePresetMutation = { __typename?: 'Mutation', clearTempTablePreset?: boolean | null };

export type GetAllAlertsQueryVariables = Exact<{
  input?: InputMaybe<AlertListFilter>;
}>;


export type GetAllAlertsQuery = { __typename?: 'Query', getAllAlerts?: { __typename?: 'alertListingResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Alert', _id?: string | null, is_deleted?: boolean | null, alertType?: string | null, availStatus?: string | null, endDate?: any | null, asset?: { __typename?: 'Asset', type?: string | null, assetId?: string | null, name?: string | null, availStatus?: string | null, id?: string | null } | null } | null> | null } | null };

export type GetAllAssetBrandListQueryVariables = Exact<{
  input?: InputMaybe<InputfilterAssetBrand>;
}>;


export type GetAllAssetBrandListQuery = { __typename?: 'Query', getAllAssetBrandList?: { __typename?: 'brandList', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'assetBranAndModel', _id?: string | null, brand_name?: string | null, asset_count?: number | null, model_counts?: number | null, is_deleted?: boolean | null, created_at?: any | null, detail?: { __typename?: 'assetModelExtendView', actions?: Array<string | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null } | null> | null, result?: Array<{ __typename?: 'AssetModel', _id: string, model_name?: string | null, is_deleted?: boolean | null, created_at?: any | null } | null> | null } | null } | null> | null } | null };

export type GetAllLinkedAssetBrandListQueryVariables = Exact<{
  input?: InputMaybe<InputfilterAssetBrand>;
}>;


export type GetAllLinkedAssetBrandListQuery = { __typename?: 'Query', getAllLinkedAssetBrandList?: { __typename?: 'brandList', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'assetBranAndModel', _id?: string | null, brand_name?: string | null, model_counts?: number | null, asset_count?: number | null, created_at?: any | null, detail?: { __typename?: 'assetModelExtendView', actions?: Array<string | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null } | null> | null, result?: Array<{ __typename?: 'AssetModel', _id: string, model_name?: string | null, is_deleted?: boolean | null, created_at?: any | null } | null> | null } | null } | null> | null } | null };

export type GetAssetBrandByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAssetBrandByIdQuery = { __typename?: 'Query', getAssetBrandById?: { __typename?: 'AssetBrandWithModel', _id: string, brand_name?: string | null, AssetModel?: Array<{ __typename?: 'AssetModel', _id: string, model_name?: string | null } | null> | null } | null };

export type GetAllAssetBrandQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssetBrandQuery = { __typename?: 'Query', getAllAssetBrand?: Array<{ __typename?: 'AssetBrand', _id: string, brand_name?: string | null } | null> | null };

export type GetAllAssetModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssetModelQuery = { __typename?: 'Query', getAllAssetModel?: Array<{ __typename?: 'AssetModel', _id: string, model_name?: string | null, is_deleted?: boolean | null } | null> | null };

export type GetAssetModelByBrandQueryVariables = Exact<{
  assetBrand: Scalars['ID']['input'];
}>;


export type GetAssetModelByBrandQuery = { __typename?: 'Query', getAssetModelByBrand?: Array<{ __typename?: 'AssetModel', _id: string, model_name?: string | null, is_deleted?: boolean | null } | null> | null };

export type CreateAssetBrandMutationVariables = Exact<{
  brandName: Scalars['String']['input'];
}>;


export type CreateAssetBrandMutation = { __typename?: 'Mutation', createAssetBrand?: { __typename?: 'AssetBrand', _id: string, brand_name?: string | null } | null };

export type UpdateAssetBrandMutationVariables = Exact<{
  input?: InputMaybe<InputUpdateBrand>;
}>;


export type UpdateAssetBrandMutation = { __typename?: 'Mutation', updateAssetBrand?: { __typename?: 'AssetBrand', _id: string, brand_name?: string | null, is_deleted?: boolean | null } | null };

export type ArchiveAssetBrandMutationVariables = Exact<{
  archive: Scalars['Boolean']['input'];
  id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ArchiveAssetBrandMutation = { __typename?: 'Mutation', archiveAssetBrand?: boolean | null };

export type CreateAssetModelMutationVariables = Exact<{
  assetBrand: Scalars['ID']['input'];
  models?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateAssetModelMutation = { __typename?: 'Mutation', createAssetModel?: boolean | null };

export type UpdateAssetModelMutationVariables = Exact<{
  input?: InputMaybe<InputUpdateModel>;
}>;


export type UpdateAssetModelMutation = { __typename?: 'Mutation', updateAssetModel?: { __typename?: 'AssetModel', _id: string, model_name?: string | null } | null };

export type ArchiveAssetModelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveAssetModelMutation = { __typename?: 'Mutation', archiveAssetModel?: boolean | null };

export type GetAllAssetCategoryAndSubCategoryQueryVariables = Exact<{
  input?: InputMaybe<CategoryListFilter>;
}>;


export type GetAllAssetCategoryAndSubCategoryQuery = { __typename?: 'Query', getAllAssetCategoryAndSubCategory?: { __typename?: 'categoryListingResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'categoryData', _id?: string | null, name?: string | null, subCategoryCount?: number | null, assigned_asset_count?: number | null, unassigned_asset_count?: number | null, maintenance_asset_count?: number | null, reserved_asset_count?: number | null, dispose_asset_count?: number | null, scrap_asset_count?: number | null, trashed_asset_count?: number | null, totalActualCost?: number | null, totalCurrentValue?: number | null, totalDepreciationValue?: number | null, is_deleted?: boolean | null, subCategory?: Array<{ __typename?: 'AssetSubCategory', id: string, name?: string | null } | null> | null, detail?: { __typename?: 'subCategoryDetail', columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null } | null> | null, result?: Array<{ __typename?: 'AssetSubCategory', name?: string | null, is_deleted?: boolean | null } | null> | null } | null } | null> | null } | null };

export type GetAllCategoryAndSubcategoryListQueryVariables = Exact<{
  input?: InputMaybe<CategoryListFilter>;
}>;


export type GetAllCategoryAndSubcategoryListQuery = { __typename?: 'Query', getAllCategoryAndSubcategoryList?: { __typename?: 'getCategoriesList', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'AssetCategories', name: string, id: string, subCategoryCount?: number | null, linked_subCategories?: number | null, unlinked_sub_categories?: number | null, created_at?: any | null, is_deleted?: boolean | null, detail?: { __typename?: 'subCategoryType', columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null } | null> | null, result?: Array<{ __typename?: 'subCategory', name: string, id: string, is_deleted?: boolean | null, created_at?: any | null } | null> | null } | null } | null> | null } | null };

export type GetAllAssetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssetCategoriesQuery = { __typename?: 'Query', getAllAssetCategories: Array<{ __typename?: 'AssetCategory', _id?: string | null, id?: string | null, name: string }> };

export type GetAllAssetSubCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssetSubCategoriesQuery = { __typename?: 'Query', getAllAssetSubCategories: Array<{ __typename?: 'AssetSubCategory', id: string, name?: string | null, is_deleted?: boolean | null }> };

export type GetAllAssetSubCategoryByIdQueryVariables = Exact<{
  getAllAssetSubCategoryByIdId: Scalars['ID']['input'];
}>;


export type GetAllAssetSubCategoryByIdQuery = { __typename?: 'Query', getAllAssetSubCategoryById?: Array<{ __typename?: 'AssetSubCategory', id: string, name?: string | null, is_deleted?: boolean | null } | null> | null };

export type GetAssetCategoryByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAssetCategoryByIdQuery = { __typename?: 'Query', getAssetCategoryById?: { __typename?: 'AssetCategory', _id?: string | null, id?: string | null, name: string } | null };

export type CreateAssetCategoryOrSubCategoryMutationVariables = Exact<{
  input?: InputMaybe<CreateAssetCategoryOrSubCategoryInput>;
}>;


export type CreateAssetCategoryOrSubCategoryMutation = { __typename?: 'Mutation', createAssetCategoryOrSubCategory?: { __typename?: 'AssetCategory', _id?: string | null, id?: string | null, name: string } | null };

export type UpdateAssetCategoryMutationVariables = Exact<{
  input?: InputMaybe<UpdateAssetCategoryInput>;
}>;


export type UpdateAssetCategoryMutation = { __typename?: 'Mutation', updateAssetCategory?: { __typename?: 'AssetCategory', _id?: string | null, id?: string | null, name: string } | null };

export type ArchiveAssetCategoryMutationVariables = Exact<{
  archive: Scalars['Boolean']['input'];
  id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ArchiveAssetCategoryMutation = { __typename?: 'Mutation', archiveAssetCategory?: boolean | null };

export type UpdateAssetSubCategoryMutationVariables = Exact<{
  input?: InputMaybe<UpdateAssetSubCategoryInput>;
}>;


export type UpdateAssetSubCategoryMutation = { __typename?: 'Mutation', updateAssetSubCategory?: { __typename?: 'AssetSubCategory', id: string, name?: string | null, is_deleted?: boolean | null } | null };

export type ArchiveAssetSubCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveAssetSubCategoryMutation = { __typename?: 'Mutation', archiveAssetSubCategory?: boolean | null };

export type UpdateMultipleAssetSubCategoryMutationVariables = Exact<{
  input?: InputMaybe<InputUpdateMultipleSubCateg>;
}>;


export type UpdateMultipleAssetSubCategoryMutation = { __typename?: 'Mutation', updateMultipleAssetSubCategory?: boolean | null };

export type GetStationByDepartmentIdQueryVariables = Exact<{
  department: Scalars['ID']['input'];
}>;


export type GetStationByDepartmentIdQuery = { __typename?: 'Query', getStationByDepartmentId?: Array<{ __typename?: 'Station', _id?: string | null, station_name?: string | null } | null> | null };

export type GetAllQuickAssetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type: EnumAssetType;
}>;


export type GetAllQuickAssetsQuery = { __typename?: 'Query', getAllQuickAssets?: { __typename?: 'getQuickAsset', totalPages?: number | null, totalResults?: number | null, data?: Array<{ __typename?: 'Asset', id?: string | null, assetId?: string | null, name?: string | null, type?: string | null, actualQuantity?: number | null, category?: { __typename?: 'AssetCategory', name: string } | null, subCategory?: { __typename?: 'AssetSubCategory', name?: string | null } | null, AssetBrand?: { __typename?: 'AssetBrand', _id: string, brand_name?: string | null } | null, AssetModel?: { __typename?: 'AssetModel', _id: string, model_name?: string | null } | null } | null> | null } | null };

export type GetAllUnlinkedQuickAssetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type: EnumAssetType;
}>;


export type GetAllUnlinkedQuickAssetsQuery = { __typename?: 'Query', getAllQuickAssets?: { __typename?: 'getQuickAsset', totalResults?: number | null, totalPages?: number | null, data?: Array<{ __typename?: 'Asset', id?: string | null, name?: string | null, type?: string | null, assetId?: string | null, category?: { __typename?: 'AssetCategory', name: string } | null, subCategory?: { __typename?: 'AssetSubCategory', name?: string | null } | null, AssetBrand?: { __typename?: 'AssetBrand', _id: string, brand_name?: string | null } | null, AssetModel?: { __typename?: 'AssetModel', _id: string, model_name?: string | null } | null } | null> | null } | null };

export type GetAllAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssetsQuery = { __typename?: 'Query', getAllAssets?: Array<{ __typename?: 'Asset', isLinkedRelation?: string | null, id?: string | null, assetId?: string | null, name?: string | null, serialNumber?: string | null } | null> | null };

export type GetAllAssetsWithSearchQueryVariables = Exact<{
  input?: InputMaybe<AssetListFilter>;
}>;


export type GetAllAssetsWithSearchQuery = { __typename?: 'Query', getAllAssetsWithSearch?: { __typename?: 'assetsListingResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Asset', other_detail?: string | null, type?: string | null, assetId?: string | null, assignedType?: string | null, description?: string | null, unitPrice?: number | null, assetImage?: string | null, isLinkedRelation?: string | null, availStatus?: string | null, checkIn_checkOut_date?: any | null, cost?: number | null, is_deleted?: boolean | null, id?: string | null, location?: string | null, name?: string | null, quantity?: number | null, serialNumber?: string | null, status?: string | null, warranty?: string | null, warrantyExpiry?: any | null, created_at?: any | null, Station?: { __typename?: 'Station', _id?: string | null, station_name?: string | null } | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, invoice?: { __typename?: 'invoicesList', invoice_image?: string | null, invoiceId?: string | null, grandTotal?: number | null, id?: string | null, invoice_image_name?: string | null, invoiceItems?: Array<{ __typename?: 'invoiceItemsType', assetIds?: Array<string | null> | null, price?: string | null } | null> | null } | null, Vendor?: { __typename?: 'Vendor', _id?: string | null, name?: string | null } | null, reserveAsset?: { __typename?: 'reserveAssets', assignedType?: string | null, reserveFrom?: any | null, reserveTo?: any | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null } | null, logs?: Array<{ __typename?: 'logsAsset', action?: string | null, changedFrom?: string | null, changedTo?: string | null, date?: any | null, status?: string | null, assigned?: { __typename?: 'User', id?: string | null, full_name?: string | null, last_name?: string | null } | null, assignedDepartment?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, created_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null } | null } | null> | null, assigned?: { __typename?: 'User', id?: string | null, first_name?: string | null, full_name?: string | null } | null, assignedSite?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, category?: { __typename?: 'AssetCategory', id?: string | null, is_deleted?: boolean | null, name: string } | null, subCategory?: { __typename?: 'AssetSubCategory', id: string, is_deleted?: boolean | null, name?: string | null } | null, fields?: Array<{ __typename?: 'fieldData', assetName?: string | null, labelName?: string | null } | null> | null, AssetBrand?: { __typename?: 'AssetBrand', _id: string, brand_name?: string | null } | null, AssetModel?: { __typename?: 'AssetModel', _id: string, model_name?: string | null } | null, purchasedFrom?: { __typename?: 'LeasingCustomer', address?: string | null, company?: string | null, email?: string | null, fullName?: string | null, id?: string | null, notes?: string | null, phone?: string | null } | null } | null> | null } | null };

export type GetAssetsByIdQueryVariables = Exact<{
  getAssetsByIdId: Scalars['ID']['input'];
}>;


export type GetAssetsByIdQuery = { __typename?: 'Query', getAssetsById?: { __typename?: 'Asset', id?: string | null, assetId?: string | null, name?: string | null, type?: string | null, assetImage?: string | null, status?: string | null, availStatus?: string | null, cost?: number | null, is_deleted?: boolean | null, description?: string | null, serialNumber?: string | null, quantity?: number | null, location?: string | null, created_at?: any | null, purchasedDate?: any | null, warrantyExpiry?: any | null, warranty?: string | null, leaseBegin?: any | null, leaseEnd?: any | null, initialCost?: number | null, depreciationType?: string | null, isDepreciation?: boolean | null, depreciationTenure?: number | null, depreciationSalvageValue?: number | null, isAutoAssetId?: boolean | null, assignedType?: string | null, other_detail?: string | null, category?: { __typename?: 'AssetCategory', id?: string | null, name: string } | null, subCategory?: { __typename?: 'AssetSubCategory', id: string, name?: string | null } | null, AssetBrand?: { __typename?: 'AssetBrand', _id: string, brand_name?: string | null } | null, AssetModel?: { __typename?: 'AssetModel', _id: string, model_name?: string | null } | null, assigned?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null } | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, Station?: { __typename?: 'Station', _id?: string | null, station_name?: string | null } | null, purchasedFrom?: { __typename?: 'LeasingCustomer', id?: string | null, address?: string | null, company?: string | null, email?: string | null, fullName?: string | null, notes?: string | null, phone?: string | null } | null, invoice?: { __typename?: 'invoicesList', id?: string | null, invoiceId?: string | null, invoiceItems?: Array<{ __typename?: 'invoiceItemsType', id?: string | null, sku?: string | null, name?: string | null, quantity?: string | null, price?: string | null, total?: number | null, serial_number?: string | null } | null> | null } | null, depreciation?: Array<{ __typename?: 'depreciation', year?: number | null, startAmount?: number | null, percentage?: number | null, depreciationAmount?: number | null, depreciationMonths?: number | null, endAmount?: number | null, dailyDepreciation?: number | null, totalDepreciated?: number | null } | null> | null, reserveAsset?: { __typename?: 'reserveAssets', assignedType?: string | null, reserveFrom?: any | null, reserveTo?: any | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null } | null, logs?: Array<{ __typename?: 'logsAsset', action?: string | null, date?: any | null, changedFrom?: string | null, changedTo?: string | null, status?: string | null, created_by?: { __typename?: 'User', full_name?: string | null } | null, assigned?: { __typename?: 'User', full_name?: string | null } | null, assignedDepartment?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null } | null> | null, contractsAndLicenses?: Array<{ __typename?: 'ContractLicense', id: string } | null> | null, insuranceLinks?: Array<{ __typename?: 'insuranceLinks', insurance?: { __typename?: 'Insurance', id?: string | null } | null } | null> | null, fields?: Array<{ __typename?: 'fieldData', assetName?: string | null, labelName?: string | null } | null> | null, created_by?: { __typename?: 'User', full_name?: string | null } | null } | null };

export type GetQuickAssetByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetQuickAssetByIdQuery = { __typename?: 'Query', getAssetsById?: { __typename?: 'Asset', id?: string | null, type?: string | null, name?: string | null, quantity?: number | null, actualQuantity?: number | null, isAutoAssetId?: boolean | null, description?: string | null, other_detail?: string | null, assetImage?: string | null, assetId?: string | null, serialNumber?: string | null, assignedType?: string | null, category?: { __typename?: 'AssetCategory', id?: string | null, name: string } | null, subCategory?: { __typename?: 'AssetSubCategory', id: string, name?: string | null } | null, AssetBrand?: { __typename?: 'AssetBrand', _id: string, brand_name?: string | null } | null, AssetModel?: { __typename?: 'AssetModel', _id: string, model_name?: string | null } | null, assigned?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, Station?: { __typename?: 'Station', _id?: string | null, station_name?: string | null } | null } | null };

export type GetAssetMovementHistorybyIdQueryVariables = Exact<{
  getAssetMovementHistorybyIdId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAssetMovementHistorybyIdQuery = { __typename?: 'Query', GetAssetMovementHistorybyID?: { __typename?: 'AssetMovement', limit?: number | null, page?: number | null, totalCount?: number | null, totalPages?: number | null, data?: Array<{ __typename?: 'movement', moved_at?: any | null, remarks?: string | null, moved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, from?: { __typename?: 'movementFrom', department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, Station?: { __typename?: 'Station', _id?: string | null, station_name?: string | null } | null, role_employes?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null } | null, to?: { __typename?: 'movementFrom', department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, Station?: { __typename?: 'Station', _id?: string | null, station_name?: string | null } | null, role_employes?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null } | null } | null> | null } | null };

export type GetLinkedAssetsQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetLinkedAssetsQuery = { __typename?: 'Query', getAllLinkRelationalAsset?: { __typename?: 'Asset', id?: string | null, linkingAssets?: Array<{ __typename?: 'linkingAssets', relation?: string | null, asset?: { __typename?: 'Asset', id?: string | null, name?: string | null, assetId?: string | null } | null } | null> | null } | null };

export type GetAllLeasingCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLeasingCustomerQuery = { __typename?: 'Query', getAllLeasingCustomer?: Array<{ __typename?: 'LeasingCustomer', id?: string | null, fullName?: string | null, company?: string | null, address?: string | null, phone?: string | null, email?: string | null, notes?: string | null } | null> | null };

export type GenerateAssetIdQueryVariables = Exact<{
  quantity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateAssetIdQuery = { __typename?: 'Query', generateAssetId?: Array<string | null> | null };

export type CreateQuickAssetMutationVariables = Exact<{
  input?: InputMaybe<CreateAssetInput>;
}>;


export type CreateQuickAssetMutation = { __typename?: 'Mutation', createQuickAsset?: Array<{ __typename?: 'Asset', id?: string | null, assetId?: string | null, type?: string | null, AssetBrand?: { __typename?: 'AssetBrand', _id: string, brand_name?: string | null } | null, AssetModel?: { __typename?: 'AssetModel', _id: string, model_name?: string | null } | null } | null> | null };

export type UpdateQuickAssetMutationVariables = Exact<{
  updateQuickAssetId: Scalars['ID']['input'];
  input?: InputMaybe<UpdateAssetInput>;
}>;


export type UpdateQuickAssetMutation = { __typename?: 'Mutation', updateQuickAsset?: boolean | null };

export type CreateAssetMutationVariables = Exact<{
  input: AssetInput;
}>;


export type CreateAssetMutation = { __typename?: 'Mutation', createAsset?: boolean | null };

export type UpdateAssetMutationVariables = Exact<{
  updateAssetId: Scalars['ID']['input'];
  input?: InputMaybe<AssetUpdateInput>;
}>;


export type UpdateAssetMutation = { __typename?: 'Mutation', updateAsset?: { __typename?: 'Asset', assetId?: string | null } | null };

export type ArchiveAssetMutationVariables = Exact<{
  archive: Scalars['Boolean']['input'];
  id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ArchiveAssetMutation = { __typename?: 'Mutation', archiveAsset?: boolean | null };

export type GenerateUniqueAssetIdMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateUniqueAssetIdMutation = { __typename?: 'Mutation', generateUniqueAssetId?: string | null };

export type LinkAssetAsChildOrParentMutationVariables = Exact<{
  input: Array<InputMaybe<LinkingRelationAsset>> | InputMaybe<LinkingRelationAsset>;
}>;


export type LinkAssetAsChildOrParentMutation = { __typename?: 'Mutation', linkParentOrChildAssetWithAsset?: boolean | null };

export type UnLinkAssetRelationFromAssetMutationVariables = Exact<{
  input?: InputMaybe<UnLinkingRelationAsset>;
}>;


export type UnLinkAssetRelationFromAssetMutation = { __typename?: 'Mutation', unLinkAssetRelationFromAsset?: boolean | null };

export type CheckoutAssetsMutationVariables = Exact<{
  input: CheckoutAssetInput;
}>;


export type CheckoutAssetsMutation = { __typename?: 'Mutation', checkoutAssets?: boolean | null };

export type CheckInAssetsMutationVariables = Exact<{
  input: CheckInAssetInput;
}>;


export type CheckInAssetsMutation = { __typename?: 'Mutation', checkInAssets?: boolean | null };

export type MoveAssetFromLocationToLocationMutationVariables = Exact<{
  assetId: Scalars['ID']['input'];
  site?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MoveAssetFromLocationToLocationMutation = { __typename?: 'Mutation', moveAssetFromLocationToLocation?: boolean | null };

export type AddLeasingCustomerMutationVariables = Exact<{
  input: LeasingCustomerInput;
}>;


export type AddLeasingCustomerMutation = { __typename?: 'Mutation', addLeasingCustomer: { __typename?: 'LeasingCustomer', id?: string | null, fullName?: string | null } };

export type UpdateLeasingCustomerMutationVariables = Exact<{
  input: LeasingCustomerInput;
}>;


export type UpdateLeasingCustomerMutation = { __typename?: 'Mutation', updateLeasingCustomer: { __typename?: 'LeasingCustomer', id?: string | null, fullName?: string | null, company?: string | null, address?: string | null, phone?: string | null, email?: string | null, notes?: string | null } };

export type SetTransactAsWholeMutationVariables = Exact<{
  assetId: Scalars['ID']['input'];
  transactionValue: Scalars['Boolean']['input'];
}>;


export type SetTransactAsWholeMutation = { __typename?: 'Mutation', updateTransactWholeFieldInAsset?: boolean | null };

export type GetPlaidTransactionsQueryVariables = Exact<{
  input?: InputMaybe<PaidTransactionFilter>;
}>;


export type GetPlaidTransactionsQuery = { __typename?: 'Query', getPlaidTransactions?: { __typename?: 'PlaidTransactionsResult', config?: { __typename?: 'dataTableConfig', actions?: Array<string | null> | null, limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'PlaidTransactionType', _id: string, mapped_category?: string | null, account_id?: string | null, account_owner?: string | null, amount?: number | null, authorized_datetime?: any | null, category?: Array<string | null> | null, datetime?: any | null, merchant_entity_id?: string | null, merchant_name?: string | null, name?: string | null, pending?: boolean | null, transaction_code?: string | null, transaction_id?: string | null, transaction_type?: string | null, website?: string | null, iso_currency_code?: string | null, logo_url?: string | null, location?: { __typename?: 'locationData', city?: string | null } | null } | null> | null } | null };

export type SyncPlaidTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SyncPlaidTransactionsQuery = { __typename?: 'Query', getPlaidSyncTransactions?: { __typename?: 'PlaidSyncTransactions', success?: boolean | null } | null };

export type GetAllPlaidCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPlaidCategoriesQuery = { __typename?: 'Query', getAllPlaidCategories?: Array<string | null> | null };

export type GetMappedPlaidCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMappedPlaidCategoriesQuery = { __typename?: 'Query', getMaapedPlaidCcategories?: Array<{ __typename?: 'MappedPlaidCategories', is_deleted?: boolean | null, _id: string, mapped_category?: string | null, plaid_categorie?: Array<string | null> | null } | null> | null };

export type CreateAndMapPlaidCategoriesMutationVariables = Exact<{
  input?: InputMaybe<PlaidCategoriesInput>;
}>;


export type CreateAndMapPlaidCategoriesMutation = { __typename?: 'Mutation', createAndMapPlaidCategories?: { __typename?: 'MappedPlaidCategories', is_deleted?: boolean | null, mapped_category?: string | null, plaid_categorie?: Array<string | null> | null } | null };

export type ArchivePlaidCategoriesMutationVariables = Exact<{
  archivePlaidCategoriesId: Scalars['ID']['input'];
}>;


export type ArchivePlaidCategoriesMutation = { __typename?: 'Mutation', archivePlaidCategories?: boolean | null };

export type GetAllContractAndLicenseeWithSearchQueryVariables = Exact<{
  input?: InputMaybe<ContractLicenseFilter>;
}>;


export type GetAllContractAndLicenseeWithSearchQuery = { __typename?: 'Query', getAllContractAndLicenseeWithSearch?: { __typename?: 'ContractLicenseResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'ContractLicense', id: string, contractLicenseTitle?: string | null, description?: string | null, hyperlink?: string | null, contractNo?: string | null, vendor?: string | null, cost?: number | null, startDate?: any | null, endDate?: any | null, contactPerson?: string | null, phone?: string | null, noOfLicenses?: number | null, isForSoftware?: boolean | null, isNoEndDate?: boolean | null, is_deleted?: boolean | null, status?: string | null, logs?: Array<{ __typename?: 'contractLogs', date?: any | null, action?: string | null, created_by?: { __typename?: 'User', full_name?: string | null } | null, assigned?: { __typename?: 'Asset', assetId?: string | null, name?: string | null } | null } | null> | null } | null> | null } | null };

export type GetContractAndLicenseByIdQueryVariables = Exact<{
  getContractAndLicenseByIdId: Scalars['ID']['input'];
}>;


export type GetContractAndLicenseByIdQuery = { __typename?: 'Query', getContractAndLicenseById?: { __typename?: 'ContractLicense', contractLicenseTitle?: string | null, description?: string | null, hyperlink?: string | null, contractNo?: string | null, vendor?: string | null, cost?: number | null, startDate?: any | null, endDate?: any | null, contactPerson?: string | null, phone?: string | null, isForSoftware?: boolean | null } | null };

export type GetAllContractsAndLicensesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllContractsAndLicensesQuery = { __typename?: 'Query', getAllContractsAndLicenses?: Array<{ __typename?: 'ContractLicense', id: string, contractLicenseTitle?: string | null, vendor?: string | null, startDate?: any | null, endDate?: any | null, contactPerson?: string | null } | null> | null };

export type GetAllContractsAndLicensesLinkWithAssetsQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetAllContractsAndLicensesLinkWithAssetsQuery = { __typename?: 'Query', getAllContractsAndLicensesLinkWithAssets?: { __typename?: 'Asset', id?: string | null, contractsAndLicenses?: Array<{ __typename?: 'ContractLicense', id: string, contractLicenseTitle?: string | null, vendor?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, is_deleted?: boolean | null, contactPerson?: string | null, contractNo?: string | null } | null> | null } | null };

export type AddContractLicenseMutationVariables = Exact<{
  input: ContractLicenseInput;
}>;


export type AddContractLicenseMutation = { __typename?: 'Mutation', addContractLicense: { __typename?: 'ContractLicense', id: string } };

export type UpdateContractLicenseMutationVariables = Exact<{
  updateContractLicenseId: Scalars['ID']['input'];
  input: ContractLicenseInput;
}>;


export type UpdateContractLicenseMutation = { __typename?: 'Mutation', updateContractLicense?: { __typename?: 'ContractLicense', id: string } | null };

export type ArchiveContractLicenseMutationVariables = Exact<{
  archive: Scalars['Boolean']['input'];
  id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ArchiveContractLicenseMutation = { __typename?: 'Mutation', archiveContractLicense?: boolean | null };

export type LinkContractsWithAssetMutationVariables = Exact<{
  assetId: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  contractName: Scalars['String']['input'];
}>;


export type LinkContractsWithAssetMutation = { __typename?: 'Mutation', linkContractsWithAsset?: boolean | null };

export type DetectContractFromAssetMutationVariables = Exact<{
  assetId: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  contractName: Scalars['String']['input'];
}>;


export type DetectContractFromAssetMutation = { __typename?: 'Mutation', detectContractFromAsset?: boolean | null };

export type GetAllAssetsForDisposeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssetsForDisposeQuery = { __typename?: 'Query', getAllAssets?: Array<{ __typename?: 'Asset', id?: string | null, assetId?: string | null, name?: string | null } | null> | null };

export type GetAllDisposeWithSearchQueryVariables = Exact<{
  input?: InputMaybe<DisposeListFilter>;
}>;


export type GetAllDisposeWithSearchQuery = { __typename?: 'Query', getAllDisposeWithSearch?: { __typename?: 'getDisposeList', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Asset', id?: string | null, is_deleted?: boolean | null, assetId?: string | null, name?: string | null, availStatus?: string | null, location?: string | null, disposeAsset?: { __typename?: 'disposeObj', disposeDate?: any | null } | null, detail?: { __typename?: 'disposeDetail', columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null, search?: string | null, is_search_able?: boolean | null, is_visible?: boolean | null, is_sortable?: boolean | null, filterValue?: Array<string | null> | null, column_data?: Array<string | null> | null, query?: { __typename?: 'queryType', first_condition?: string | null, second_condition?: string | null, first_value?: string | null, second_value?: string | null, condition?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, result?: Array<{ __typename?: 'logsAsset', action?: string | null, changedFrom?: string | null, changedTo?: string | null, date?: any | null, assigned?: { __typename?: 'User', full_name?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type DisposedAssetMutationVariables = Exact<{
  input?: InputMaybe<DisposedInput>;
}>;


export type DisposedAssetMutation = { __typename?: 'Mutation', disposedAsset?: boolean | null };

export type UndoDisposedAssetMutationVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type UndoDisposedAssetMutation = { __typename?: 'Mutation', undoDisposedAsset?: boolean | null };

export type TrashAssetMutationVariables = Exact<{
  input?: InputMaybe<TrashInput>;
}>;


export type TrashAssetMutation = { __typename?: 'Mutation', trashAsset?: boolean | null };

export type ScrapAssetMutationVariables = Exact<{
  input?: InputMaybe<ScrapInput>;
}>;


export type ScrapAssetMutation = { __typename?: 'Mutation', scrapAsset?: boolean | null };

export type GetAllDocumentsLinkWithAssetsQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetAllDocumentsLinkWithAssetsQuery = { __typename?: 'Query', getAllDocumentsLinkWithAssets?: { __typename?: 'Asset', created_at?: any | null, documents?: Array<{ __typename?: 'documents', id?: string | null, fileName?: string | null, fileType?: string | null, fileUrl?: string | null, description?: string | null, upload_by?: { __typename?: 'User', full_name?: string | null } | null } | null> | null } | null };

export type UploadAssetDocsMutationVariables = Exact<{
  input?: InputMaybe<UploadAssetDocInput>;
}>;


export type UploadAssetDocsMutation = { __typename?: 'Mutation', uploadAssetDocs?: boolean | null };

export type DeleteDocFromAssetMutationVariables = Exact<{
  assetId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
}>;


export type DeleteDocFromAssetMutation = { __typename?: 'Mutation', deleteDocFromAsset?: boolean | null };

export type GetExpenseInvoiceAndCategoryListWithSearchQueryVariables = Exact<{
  input?: InputMaybe<ExpenseInvoiceCategoryInput>;
}>;


export type GetExpenseInvoiceAndCategoryListWithSearchQuery = { __typename?: 'Query', getExpenseInvoiceAndCategoryListWithSearch?: { __typename?: 'getInvoiceExpenseAndCategoryList', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'getExpenseInvoiceAndCategory', id?: string | null, name?: string | null, is_deleted?: boolean | null, category_count?: number | null, invoice_count?: number | null, created_at?: any | null, detail?: { __typename?: 'invoiceCategoryDetails', actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_amount?: boolean | null, filterValue?: Array<string | null> | null, column_data?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, result?: Array<{ __typename?: 'expenseCategory', id?: string | null, name?: string | null, is_deleted?: boolean | null, created_at?: any | null } | null> | null } | null } | null> | null } | null };

export type GetExpenseInvoiceWithSearchQueryVariables = Exact<{
  input?: InputMaybe<ExpenseInvoiceInput>;
}>;


export type GetExpenseInvoiceWithSearchQuery = { __typename?: 'Query', getExpenseInvoiceWithSearch?: { __typename?: 'getInvoiceExpenseList', config?: { __typename?: 'dataTableConfig', actions?: Array<string | null> | null, limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'getExpenseInvoice', id?: string | null, name?: string | null, is_deleted?: boolean | null, category_count?: number | null, invoice_count?: number | null, created_at?: any | null, detail?: { __typename?: 'invoiceDetails', columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_amount?: boolean | null, filterValue?: Array<string | null> | null, column_data?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, result?: Array<{ __typename?: 'invoiceItemsTypes', id?: string | null, name?: string | null, category?: string | null, categoryId?: string | null, invoiceId?: string | null, invoice_name?: string | null, invoice_number?: string | null, price?: string | null, quantity?: string | null } | null> | null } | null } | null> | null } | null };

export type GetExpenseInvoiceByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExpenseInvoiceByIdQuery = { __typename?: 'Query', getExpenseInvoiceById?: { __typename?: 'getExpenseInvoice', id?: string | null, name?: string | null, is_deleted?: boolean | null, category?: Array<{ __typename?: 'expenseCategory', id?: string | null, name?: string | null } | null> | null } | null };

export type GetAllExpenseInvoiceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllExpenseInvoiceQuery = { __typename?: 'Query', getAllExpenseInvoice?: Array<{ __typename?: 'getExpenseInvoice', id?: string | null, name?: string | null, category?: Array<{ __typename?: 'expenseCategory', id?: string | null, name?: string | null } | null> | null } | null> | null };

export type GetAllExpenseInvoiceCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllExpenseInvoiceCategoryQuery = { __typename?: 'Query', getAllExpenseInvoiceCategory?: Array<{ __typename?: 'expenseCategory', id?: string | null, name?: string | null, is_deleted?: boolean | null } | null> | null };

export type CreateExpenseInvoiceCategoryMutationVariables = Exact<{
  input: CreateExpenseInvoiceCategory;
}>;


export type CreateExpenseInvoiceCategoryMutation = { __typename?: 'Mutation', createExpenseInvoiceCategory?: boolean | null };

export type CreateExpenseInvoiceMutationVariables = Exact<{
  input: CreateExpenseInvoice;
}>;


export type CreateExpenseInvoiceMutation = { __typename?: 'Mutation', createExpenseInvoice?: boolean | null };

export type UpdateExpenseInvoiceMutationVariables = Exact<{
  input: UpdateExpenseInvoice;
}>;


export type UpdateExpenseInvoiceMutation = { __typename?: 'Mutation', updateExpenseInvoice?: boolean | null };

export type CreateExpenseInvoiceAndCategoryMutationVariables = Exact<{
  input: CreateExpenseInvoice;
}>;


export type CreateExpenseInvoiceAndCategoryMutation = { __typename?: 'Mutation', createExpenseInvoiceAndCategory?: { __typename?: 'createdExpenseInvoice', id?: string | null, name?: string | null, category?: Array<string | null> | null } | null };

export type UpdateExpenseInvoiceCategoryMutationVariables = Exact<{
  input: UpdateExpenseInvoiceCategory;
}>;


export type UpdateExpenseInvoiceCategoryMutation = { __typename?: 'Mutation', updateExpenseInvoiceCategory?: { __typename?: 'expenseCategory', id?: string | null, name?: string | null } | null };

export type ArchiveExpenseInvoiceMutationVariables = Exact<{
  input?: InputMaybe<ArchiveInvoiceInput>;
}>;


export type ArchiveExpenseInvoiceMutation = { __typename?: 'Mutation', archiveExpenseInvoice?: boolean | null };

export type ArchiveExpenseInvoiceCategoryMutationVariables = Exact<{
  input?: InputMaybe<ArchiveInvoiceInput>;
}>;


export type ArchiveExpenseInvoiceCategoryMutation = { __typename?: 'Mutation', archiveExpenseInvoiceCategory?: boolean | null };

export type GetInsuranceByIdQueryVariables = Exact<{
  getInsuranceByIdId: Scalars['ID']['input'];
}>;


export type GetInsuranceByIdQuery = { __typename?: 'Query', getInsuranceById?: { __typename?: 'Insurance', active?: boolean | null, contactPerson?: string | null, coverage?: number | null, deductible?: number | null, description?: string | null, email?: string | null, endDate?: any | null, insuranceCo?: string | null, limits?: number | null, phone?: string | null, policyNo?: string | null, premium?: number | null, startDate?: any | null } | null };

export type GetAllInsuranceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInsuranceQuery = { __typename?: 'Query', getAllInsurance?: Array<{ __typename?: 'Insurance', id?: string | null, insuranceCo?: string | null, active?: boolean | null, endDate?: any | null, startDate?: any | null } | null> | null };

export type GetAllInsuranceWithSearchQueryVariables = Exact<{
  input?: InputMaybe<InsuranceListFilter>;
}>;


export type GetAllInsuranceWithSearchQuery = { __typename?: 'Query', getAllInsuranceWithSearch?: { __typename?: 'insuranceListingResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Insurance', active?: boolean | null, status?: string | null, contactPerson?: string | null, coverage?: number | null, deductible?: number | null, description?: string | null, email?: string | null, endDate?: any | null, id?: string | null, insuranceCo?: string | null, is_deleted?: boolean | null, limits?: number | null, phone?: string | null, policyNo?: string | null, premium?: number | null, startDate?: any | null, logs?: Array<{ __typename?: 'insuranceLogs', date?: any | null, action?: string | null, created_by?: { __typename?: 'User', full_name?: string | null } | null, assigned?: { __typename?: 'Asset', assetId?: string | null, name?: string | null } | null } | null> | null, asset?: { __typename?: 'Asset', id?: string | null, name?: string | null, assetId?: string | null } | null } | null> | null } | null };

export type GetAllInsuranceLinkWithAssetsQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetAllInsuranceLinkWithAssetsQuery = { __typename?: 'Query', getAllInsuranceLinkWithAssets?: { __typename?: 'Asset', name?: string | null, id?: string | null, insuranceLinks?: Array<{ __typename?: 'insuranceLinks', insurance?: { __typename?: 'Insurance', startDate?: any | null, endDate?: any | null, insuranceCo?: string | null, is_deleted?: boolean | null, description?: string | null, id?: string | null, active?: boolean | null, contactPerson?: string | null, coverage?: number | null, deductible?: number | null, limits?: number | null, phone?: string | null, policyNo?: string | null, premium?: number | null, email?: string | null } | null } | null> | null } | null };

export type AddInsuranceMutationVariables = Exact<{
  input: InsuranceInput;
}>;


export type AddInsuranceMutation = { __typename?: 'Mutation', addInsurance: { __typename?: 'Insurance', id?: string | null, active?: boolean | null } };

export type UpdateInsuranceMutationVariables = Exact<{
  updateInsuranceId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<InsuranceInput>;
}>;


export type UpdateInsuranceMutation = { __typename?: 'Mutation', updateInsurance?: { __typename?: 'Insurance', id?: string | null } | null };

export type ArchiveInsuranceMutationVariables = Exact<{
  archive: Scalars['Boolean']['input'];
  id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ArchiveInsuranceMutation = { __typename?: 'Mutation', archiveInsurance?: boolean | null };

export type LinkInsuranceWithAssetMutationVariables = Exact<{
  assetId: Scalars['ID']['input'];
  insuranceId: Scalars['ID']['input'];
  insuranceName: Scalars['String']['input'];
}>;


export type LinkInsuranceWithAssetMutation = { __typename?: 'Mutation', linkInsuranceWithAsset?: boolean | null };

export type DetectInsuranceFromAssetMutationVariables = Exact<{
  assetId: Scalars['ID']['input'];
  insuranceId: Scalars['ID']['input'];
  insuranceName: Scalars['String']['input'];
}>;


export type DetectInsuranceFromAssetMutation = { __typename?: 'Mutation', detectInsuranceFromAsset?: boolean | null };

export type GetAllInvoicesQueryVariables = Exact<{
  input?: InputMaybe<InvoicesInput>;
}>;


export type GetAllInvoicesQuery = { __typename?: 'Query', getAllInvoices?: { __typename?: 'getInvoiceList', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'InvoiceData', invoice_image?: string | null, invoiceId?: string | null, name?: string | null, orderDate?: any | null, orderNumber?: string | null, id?: string | null, company?: string | null, type?: string | null, taxes?: number | null, totalShippingCharges?: number | null, totalInvoiceItems?: number | null, grandTotal?: number | null, is_deleted?: boolean | null, subTotal?: number | null, invoice_image_name?: string | null, vendor?: { __typename?: 'vendors', id?: string | null, name?: string | null } | null, shippingMethod?: { __typename?: 'ShippingMethods', _id?: string | null, name?: string | null } | null, billTo?: { __typename?: 'getShipToType', location?: string | null, id?: string | null } | null, shipTo?: { __typename?: 'getShipToType', location?: string | null, id?: string | null } | null, invoiceItems?: Array<{ __typename?: 'invoiceItemsType', is_expense?: boolean | null, assetIds?: Array<string | null> | null } | null> | null, detail?: { __typename?: 'invoiceDetail', columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, result?: Array<{ __typename?: 'invoiceItemsType', product?: string | null, serial_number?: string | null, sku?: string | null, quantity?: string | null, price?: string | null, type?: string | null, total?: number | null } | null> | null } | null } | null> | null } | null };

export type GetInvoiceByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetInvoiceByIdQuery = { __typename?: 'Query', getInvoiceById?: { __typename?: 'invoicesList', id?: string | null, invoiceId?: string | null, name?: string | null, orderDate?: any | null, orderNumber?: string | null, company?: string | null, paymentMethod?: string | null, taxes?: number | null, totalShippingCharges?: number | null, courtesyCredit?: number | null, totalPaid?: number | null, toPayOff?: number | null, subTotal?: number | null, grandTotal?: number | null, invoice_image_name?: string | null, invoiceImageUrl?: string | null, vendor?: { __typename?: 'vendors', id?: string | null, name?: string | null } | null, shippingMethod?: { __typename?: 'ShippingMethods', _id?: string | null, name?: string | null } | null, shipTo?: { __typename?: 'getShipToType', id?: string | null, location?: string | null } | null, billTo?: { __typename?: 'getShipToType', id?: string | null, location?: string | null } | null, invoiceItems?: Array<{ __typename?: 'invoiceItemsType', id?: string | null, sku?: string | null, serial_number?: string | null, product?: string | null, quantity?: string | null, price?: string | null, total?: number | null, color?: string | null, type?: string | null, is_expense?: boolean | null, assetIds?: Array<string | null> | null, expenseId?: { __typename?: 'getExpenseInvoice', id?: string | null } | null, expenseInvCategoryId?: { __typename?: 'expenseCategory', id?: string | null } | null } | null> | null } | null };

export type GenerateInvoiceIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateInvoiceIdQuery = { __typename?: 'Query', generateInvoiceId?: string | null };

export type GetVendorQueryVariables = Exact<{
  input?: InputMaybe<InputGetVendorWithSearch>;
}>;


export type GetVendorQuery = { __typename?: 'Query', getVendor?: Array<{ __typename?: 'Vendor', _id?: string | null, name?: string | null, is_deleted?: boolean | null } | null> | null };

export type GetShippingMethodsQueryVariables = Exact<{
  input?: InputMaybe<InputGetShippingWithSearch>;
}>;


export type GetShippingMethodsQuery = { __typename?: 'Query', getShippingMethods?: Array<{ __typename?: 'ShippingMethods', _id?: string | null, name?: string | null, is_deleted?: boolean | null } | null> | null };

export type GetAllShipToQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllShipToQuery = { __typename?: 'Query', getAllShipTo?: Array<{ __typename?: 'getShipToType', id?: string | null, location?: string | null, is_deleted?: boolean | null } | null> | null };

export type GetInvoiceItemLinkedAssetsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetInvoiceItemLinkedAssetsQuery = { __typename?: 'Query', getItemAsset?: Array<{ __typename?: 'Asset', id?: string | null, assetId?: string | null, name?: string | null, type?: string | null, category?: { __typename?: 'AssetCategory', name: string } | null, subCategory?: { __typename?: 'AssetSubCategory', name?: string | null } | null, AssetBrand?: { __typename?: 'AssetBrand', brand_name?: string | null } | null, AssetModel?: { __typename?: 'AssetModel', model_name?: string | null } | null } | null> | null };

export type CreateInvoiceMutationVariables = Exact<{
  input: InvoiceInput;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice?: boolean | null };

export type UpdateInvoiceMutationVariables = Exact<{
  input: UpdateInvoiceInput;
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoice?: boolean | null };

export type ArchiveInvoiceMutationVariables = Exact<{
  input?: InputMaybe<ArchiveInvoiceInput>;
}>;


export type ArchiveInvoiceMutation = { __typename?: 'Mutation', archiveInvoice?: boolean | null };

export type AddVendorMutationVariables = Exact<{
  input?: InputMaybe<InputBagVendor>;
}>;


export type AddVendorMutation = { __typename?: 'Mutation', addVendor?: { __typename?: 'Vendor', _id?: string | null, name?: string | null } | null };

export type AddShippingMethodsMutationVariables = Exact<{
  input?: InputMaybe<InputBagShipping>;
}>;


export type AddShippingMethodsMutation = { __typename?: 'Mutation', addShippingMethods?: { __typename?: 'ShippingMethods', _id?: string | null, name?: string | null } | null };

export type CreateShipToMutationVariables = Exact<{
  input: CreateShipTo;
}>;


export type CreateShipToMutation = { __typename?: 'Mutation', createShipTo?: boolean | null };

export type GetMaintenanceByIdQueryVariables = Exact<{
  getMaintenanceByIdId: Scalars['ID']['input'];
}>;


export type GetMaintenanceByIdQuery = { __typename?: 'Query', getMaintenanceById?: { __typename?: 'Maintenance', cost?: number | null, id?: string | null, dateCompleted?: any | null, dueDate?: any | null, maintenanceBy?: string | null, status?: string | null, title?: string | null, recurring?: number | null, recurringBy?: RecurringBy | null, isRecurring?: boolean | null, asset?: { __typename?: 'Asset', assetId?: string | null, name?: string | null, id?: string | null } | null } | null };

export type GetAllMaintenanceWithSearchQueryVariables = Exact<{
  input?: InputMaybe<MaintenanceListFilter>;
}>;


export type GetAllMaintenanceWithSearchQuery = { __typename?: 'Query', getAllMaintenanceWithSearch?: { __typename?: 'maintenanceListingResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Maintenance', is_deleted?: boolean | null, id?: string | null, cost?: number | null, dateCompleted?: any | null, dueDate?: any | null, maintenanceBy?: string | null, status?: string | null, title?: string | null, asset?: { __typename?: 'Asset', assetId?: string | null, id?: string | null, name?: string | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null } | null } | null> | null } | null };

export type GetAssetsForMaintenanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetsForMaintenanceQuery = { __typename?: 'Query', getAllAssetsMaintenance?: Array<{ __typename?: 'Asset', assetId?: string | null, name?: string | null, id?: string | null } | null> | null };

export type GetAllMaintenanceLinkWithAssetsQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetAllMaintenanceLinkWithAssetsQuery = { __typename?: 'Query', getAllMaintenanceLinkWithAssets?: Array<{ __typename?: 'Maintenance', cost?: number | null, dateCompleted?: any | null, dueDate?: any | null, id?: string | null, maintenanceBy?: string | null, status?: string | null, title?: string | null, asset?: { __typename?: 'Asset', id?: string | null, name?: string | null, assetId?: string | null, availStatus?: string | null, status?: string | null } | null } | null> | null };

export type GetAssetForMaintenanceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAssetForMaintenanceQuery = { __typename?: 'Query', getAssetsById?: { __typename?: 'Asset', id?: string | null, name?: string | null, assetId?: string | null } | null };

export type AddMaintenanceMutationVariables = Exact<{
  input?: InputMaybe<MaintenanceInput>;
}>;


export type AddMaintenanceMutation = { __typename?: 'Mutation', addMaintenance: { __typename?: 'Maintenance', cost?: number | null } };

export type UpdateMaintenanceMutationVariables = Exact<{
  input: UpdateMaintenanceInput;
}>;


export type UpdateMaintenanceMutation = { __typename?: 'Mutation', updateMaintenance?: { __typename?: 'Maintenance', cost?: number | null } | null };

export type ArchiveMaintenanceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveMaintenanceMutation = { __typename?: 'Mutation', archiveMaintenance?: boolean | null };

export type GetAllReportsWithSearchQueryVariables = Exact<{
  input?: InputMaybe<AssetListFilter>;
}>;


export type GetAllReportsWithSearchQuery = { __typename?: 'Query', getAllAssetsWithSearch?: { __typename?: 'assetsListingResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Asset', id?: string | null, assetId?: string | null, name?: string | null, assignedType?: string | null, type?: string | null, status?: string | null, availStatus?: string | null, cost?: number | null, is_deleted?: boolean | null, description?: string | null, serialNumber?: string | null, quantity?: number | null, location?: string | null, created_at?: any | null, other_detail?: string | null, category?: { __typename?: 'AssetCategory', id?: string | null, name: string, is_deleted?: boolean | null } | null, subCategory?: { __typename?: 'AssetSubCategory', id: string, name?: string | null, is_deleted?: boolean | null } | null, AssetBrand?: { __typename?: 'AssetBrand', _id: string, brand_name?: string | null } | null, AssetModel?: { __typename?: 'AssetModel', _id: string, model_name?: string | null } | null, assigned?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null } | null, assignedSite?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null } | null> | null } | null };

export type GetAssetsForReservationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetsForReservationQuery = { __typename?: 'Query', getAllAssets?: Array<{ __typename?: 'Asset', id?: string | null, assetId?: string | null, name?: string | null } | null> | null };

export type GetAllReserveWithSearchQueryVariables = Exact<{
  input?: InputMaybe<ReserveListFilter>;
}>;


export type GetAllReserveWithSearchQuery = { __typename?: 'Query', getAllReserveWithSearch?: { __typename?: 'assetListingResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Asset', id?: string | null, is_deleted?: boolean | null, assetId?: string | null, other_detail?: string | null, reserveAsset?: { __typename?: 'reserveAssets', assignedType?: string | null, reserveFrom?: any | null, reserveTo?: any | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null, status?: string | null, account_status?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null } | null> | null } | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null } | null } | null> | null } | null };

export type GetReservedAssetByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetReservedAssetByIdQuery = { __typename?: 'Query', getAssetsById?: { __typename?: 'Asset', id?: string | null, assetId?: string | null, name?: string | null, reserveAsset?: { __typename?: 'reserveAssets', assignedType?: string | null, other_detail?: string | null, reserveFrom?: any | null, reserveTo?: any | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null } | null } | null };

export type ReserveAssetMutationVariables = Exact<{
  input: ReserveAssetInput;
}>;


export type ReserveAssetMutation = { __typename?: 'Mutation', reserveAsset: boolean };

export type UpdateReserveAssetMutationVariables = Exact<{
  input: ReserveUpdateAssetInput;
}>;


export type UpdateReserveAssetMutation = { __typename?: 'Mutation', updateReserveAsset: boolean };

export type UndoReserveAssetMutationVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type UndoReserveAssetMutation = { __typename?: 'Mutation', undoReserveAsset?: boolean | null };

export type GetAllStationsQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
}>;


export type GetAllStationsQuery = { __typename?: 'Query', getAllStations?: Array<{ __typename?: 'Station', _id?: string | null, station_name?: string | null, is_deleted?: boolean | null, Department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null } | null> | null };

export type GetStationsByDepartmentQueryVariables = Exact<{
  department: Scalars['ID']['input'];
}>;


export type GetStationsByDepartmentQuery = { __typename?: 'Query', getStationByDepartmentId?: Array<{ __typename?: 'Station', _id?: string | null, station_name?: string | null, is_deleted?: boolean | null } | null> | null };

export type CreateStationMutationVariables = Exact<{
  input: StationInput;
}>;


export type CreateStationMutation = { __typename?: 'Mutation', createStation?: { __typename?: 'Station', _id?: string | null, station_name?: string | null } | null };

export type UpdateStationMutationVariables = Exact<{
  input: StationInput;
  id: Scalars['ID']['input'];
}>;


export type UpdateStationMutation = { __typename?: 'Mutation', updateStation?: { __typename?: 'Station', _id?: string | null, station_name?: string | null } | null };

export type DeleteStationMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type DeleteStationMutation = { __typename?: 'Mutation', deleteStation?: boolean | null };

export type GetStationByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStationByIdQuery = { __typename?: 'Query', getStationtById?: { __typename?: 'Station', _id?: string | null, station_name?: string | null, Department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null } | null };

export type GetEmployeeTwoFaDataQueryVariables = Exact<{
  input: TwoFaInput;
}>;


export type GetEmployeeTwoFaDataQuery = { __typename?: 'Query', getEmployeeTwoFAData?: { __typename?: 'TwoFAOutput', uri?: string | null } | null };

export type GetAllMyAuthenticatorAppsQueryVariables = Exact<{
  input?: InputMaybe<GetAuthenticatorAppDataTableInput>;
}>;


export type GetAllMyAuthenticatorAppsQuery = { __typename?: 'Query', getAllMYAuthenticatorApps?: { __typename?: 'AuthenticatorResult', config?: { __typename?: 'dataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Authenticator', _id?: string | null, app_name?: string | null, description?: string | null, app_url?: string | null, type?: string | null, app_type?: string | null, is_deleted?: boolean | null, created_at?: any | null, is_totp?: boolean | null, app_info?: { __typename?: 'authenticatorAppInfo', secret?: string | null, qr_url?: string | null, label?: string | null } | null, password_manager?: { __typename?: 'passwordManagerType', user_name?: string | null, email?: string | null, password?: { __typename?: 'encryptedPasswordType', encryptedAESKey?: string | null, encryptedPassword?: string | null, iv?: string | null } | null } | null, share_with?: Array<{ __typename?: 'ShareAuthenticatorApp', _id?: string | null, app_name?: string | null, share_type?: string | null } | null> | null } | null> | null } | null };

export type GetAllShareWithMeAppsQueryVariables = Exact<{
  input?: InputMaybe<GetAuthenticatorAppInput>;
}>;


export type GetAllShareWithMeAppsQuery = { __typename?: 'Query', getAllShareWithMeApps?: { __typename?: 'ShareMeListDataTable', config?: { __typename?: 'dataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'ShareAuthenticatorApp', _id?: string | null, app_name?: string | null, description?: string | null, app_url?: string | null, type?: string | null, is_deleted?: boolean | null, created_at?: any | null, app_info?: { __typename?: 'authenticatorAppInfo', secret?: string | null, qr_url?: string | null, label?: string | null } | null, password_manager?: { __typename?: 'passwordManagerType', user_name?: string | null, email?: string | null, password?: { __typename?: 'encryptedPasswordType', encryptedAESKey?: string | null, encryptedPassword?: string | null, iv?: string | null } | null } | null } | null> | null } | null };

export type GetAuthenticatorAppByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAuthenticatorAppByIdQuery = { __typename?: 'Query', getAuthenticatorAppById?: { __typename?: 'Authenticator', app_url?: string | null, app_name?: string | null, created_at?: any | null, _id?: string | null, share_with?: Array<{ __typename?: 'ShareAuthenticatorApp', _id?: string | null, app_url?: string | null, app_name?: string | null, share_type?: string | null, employee?: { __typename?: 'User', full_name?: string | null, employee_id?: string | null, id?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null } | null, password_manager?: { __typename?: 'passwordManagerType', user_name?: string | null, email?: string | null, password?: { __typename?: 'encryptedPasswordType', encryptedAESKey?: string | null, encryptedPassword?: string | null, iv?: string | null } | null } | null, shared_by?: { __typename?: 'User', full_name?: string | null, id?: string | null, employee_id?: string | null } | null } | null> | null } | null };

export type GetAllShareOfAppQueryVariables = Exact<{
  getAllShareOfAppId: Scalars['ID']['input'];
}>;


export type GetAllShareOfAppQuery = { __typename?: 'Query', getAllShareOfApp?: Array<{ __typename?: 'ShareAuthenticatorApp', app_name?: string | null, app_url?: string | null, _id?: string | null, share_type?: string | null, is_scheduled?: boolean | null, created_at?: any | null, share_as?: string | null, scheduled_for?: string | null, employee?: { __typename?: 'User', id?: string | null, employee_id?: string | null, full_name?: string | null, email?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null } | null, share_permissions?: { __typename?: 'share_permissions', can_share_password?: boolean | null, can_share_otp?: boolean | null, can_edit?: boolean | null } | null, shared_by?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null };

export type GetSharedAuthenticatorAppByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSharedAuthenticatorAppByIdQuery = { __typename?: 'Query', getSharedAuthenticatorAppById?: { __typename?: 'ShareAuthenticatorApp', share_type?: string | null, share_as?: string | null, scheduled_for?: string | null, is_scheduled?: boolean | null, app_name?: string | null, description?: string | null, app_url?: string | null, _id?: string | null, created_at?: any | null, AuthenticatorApp?: { __typename?: 'Authenticator', _id?: string | null } | null, shared_by?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null, share_permissions?: { __typename?: 'share_permissions', can_share_password?: boolean | null, can_share_otp?: boolean | null, can_edit?: boolean | null } | null, app_info?: { __typename?: 'authenticatorAppInfo', secret?: string | null, qr_url?: string | null, label?: string | null } | null, employee?: { __typename?: 'User', id?: string | null, employee_id?: string | null, full_name?: string | null, email?: string | null } | null, share_with?: Array<{ __typename?: 'ShareAuthenticatorApp', _id?: string | null, app_name?: string | null, share_type?: string | null } | null> | null } | null };

export type GetQrLogsQueryVariables = Exact<{
  input: QrLogsInput;
}>;


export type GetQrLogsQuery = { __typename?: 'Query', getQRLogs?: { __typename?: 'QRLogsList', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, results?: Array<{ __typename?: 'QRLogs', created_at?: any | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, scanned_by?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null } | null> | null } | null };

export type GetEmployeeEncryptionKeysQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetEmployeeEncryptionKeysQuery = { __typename?: 'Query', getEmployeeEncryptionKeys?: { __typename?: 'UserEncryptionKeys', salt?: string | null, publicKey?: string | null, iv?: string | null, encryptedPrivateKey?: string | null } | null };

export type GetPasswordManagerAdminsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPasswordManagerAdminsQuery = { __typename?: 'Query', getPasswordManagerAdmins?: Array<{ __typename?: 'PasswordManagerAdmins', is_encryption_copy_exist?: boolean | null, user?: { __typename?: 'User', id?: string | null, full_name?: string | null, users_password_manager?: { __typename?: 'UserEncryptionKeys', encryptedPrivateKey?: string | null, iv?: string | null, publicKey?: string | null, salt?: string | null } | null } | null, encryptionCopy?: { __typename?: 'UserEncryptionCopies', encryption?: { __typename?: 'Encryption', encrypted_private_key?: string | null, iv?: string | null, salt?: string | null } | null } | null } | null> | null };

export type GetEncryptionCopyByUserIdQueryVariables = Exact<{
  input: GetEncryptionCopyInput;
}>;


export type GetEncryptionCopyByUserIdQuery = { __typename?: 'Query', getEncryptionCopyByUserId?: Array<{ __typename?: 'UserEncryptionCopies', _id?: string | null, is_owner?: boolean | null, from_user?: { __typename?: 'User', users_password_manager?: { __typename?: 'UserEncryptionKeys', encryptedPrivateKey?: string | null, iv?: string | null, publicKey?: string | null, salt?: string | null } | null } | null, encryption?: { __typename?: 'Encryption', encrypted_private_key?: string | null, iv?: string | null, salt?: string | null } | null, user?: { __typename?: 'User', _id?: string | null, full_name?: string | null, users_password_manager?: { __typename?: 'UserEncryptionKeys', publicKey?: string | null, iv?: string | null, salt?: string | null, encryptedPrivateKey?: string | null } | null } | null } | null> | null };

export type GetAllUsersForSharedRecordsQueryVariables = Exact<{
  appId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAllUsersForSharedRecordsQuery = { __typename?: 'Query', getAllUsersForSharedRecords?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, users_password_manager?: { __typename?: 'UserEncryptionKeys', encryptedPrivateKey?: string | null, iv?: string | null, publicKey?: string | null, salt?: string | null } | null } | null> | null };

export type GetAllGroupListQueryVariables = Exact<{
  input?: InputMaybe<GetGroupsInput>;
}>;


export type GetAllGroupListQuery = { __typename?: 'Query', getAllGroupList?: Array<{ __typename?: 'AuthenticatorGroup', app_name?: string | null, _id?: string | null, type?: string | null } | null> | null };

export type SearchAuthenticatorAppsQueryVariables = Exact<{
  input?: InputMaybe<SearchAuthenticatorInput>;
}>;


export type SearchAuthenticatorAppsQuery = { __typename?: 'Query', searchAuthenticatorApps?: { __typename?: 'SearchAuthenticatorResult', currentRecords?: number | null, viewMore?: boolean | null, total?: number | null, results?: Array<{ __typename?: 'SearchAuthenticatorItem', app_name?: string | null, _id: string, app_url?: string | null, email?: string | null, path?: string | null, type: string, username?: string | null, hierarchy?: Array<{ __typename?: 'HierarchyItem', app_name?: string | null, type?: string | null, _id: string } | null> | null } | null> | null } | null };

export type GetAuthenticatorPasswordManagerAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthenticatorPasswordManagerAdminQuery = { __typename?: 'Query', getPasswordManagerAdmin?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null };

export type GetAuthenticatorAllGuarantorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthenticatorAllGuarantorQuery = { __typename?: 'Query', getAllGuarantor?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, email?: string | null } | null> | null };

export type GetAuthenticatorUsersWithPasswordPermissionQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
}>;


export type GetAuthenticatorUsersWithPasswordPermissionQuery = { __typename?: 'Query', getUsersWithPasswordPermission?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, email?: string | null, users_password_manager?: { __typename?: 'UserEncryptionKeys', encryptedPrivateKey?: string | null, iv?: string | null, publicKey?: string | null, salt?: string | null } | null } | null> | null };

export type ShareAuthenticatorAppMutationVariables = Exact<{
  input?: InputMaybe<ShareAppInput>;
}>;


export type ShareAuthenticatorAppMutation = { __typename?: 'Mutation', shareAuthenticatorApp?: { __typename?: 'Authenticator', _id?: string | null, app_name?: string | null } | null };

export type UpdateAuthenticatorAppMutationVariables = Exact<{
  input?: InputMaybe<UpdateAppInput>;
}>;


export type UpdateAuthenticatorAppMutation = { __typename?: 'Mutation', updateAuthenticatorApp?: { __typename?: 'Authenticator', app_name?: string | null } | null };

export type CreateAuthenticatorAppWithoutOtpMutationVariables = Exact<{
  input?: InputMaybe<CreateAppInputWithoutOtp>;
}>;


export type CreateAuthenticatorAppWithoutOtpMutation = { __typename?: 'Mutation', createAuthenticatorAppWithoutOTP?: { __typename?: 'Authenticator', app_name?: string | null } | null };

export type RemoveShareOfAuthenticatorAppMutationVariables = Exact<{
  input?: InputMaybe<RemoveShareInput>;
}>;


export type RemoveShareOfAuthenticatorAppMutation = { __typename?: 'Mutation', removeShareOfAuthenticatorApp?: boolean | null };

export type UpdateShareOfAuthenticatorAppMutationVariables = Exact<{
  input?: InputMaybe<UpdateShareAppInput>;
}>;


export type UpdateShareOfAuthenticatorAppMutation = { __typename?: 'Mutation', updateShareOfAuthenticatorApp?: { __typename?: 'Authenticator', app_name?: string | null, _id?: string | null } | null };

export type EditAuthenticatorGroupMutationVariables = Exact<{
  input: EditAuthenticatorGroupInput;
}>;


export type EditAuthenticatorGroupMutation = { __typename?: 'Mutation', editAuthenticatorGroup?: boolean | null };

export type CreateAuthenticatorGroupMutationVariables = Exact<{
  input?: InputMaybe<CreateAuthenticatorGroupInput>;
}>;


export type CreateAuthenticatorGroupMutation = { __typename?: 'Mutation', createAuthenticatorGroup?: { __typename?: 'AuthenticatorGroup', breadcrumbs?: Array<{ __typename?: 'Authenticator', _id?: string | null, app_name?: string | null } | null> | null } | null };

export type DeleteAuthenticatorAppMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  groupType?: InputMaybe<Group_Type>;
  deleteChildren?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteAuthenticatorAppMutation = { __typename?: 'Mutation', deleteAuthenticatorApp?: boolean | null };

export type CopyAuthenticatorAppMutationVariables = Exact<{
  input?: InputMaybe<CopyAuthenticatorAppInput>;
}>;


export type CopyAuthenticatorAppMutation = { __typename?: 'Mutation', copyAuthenticatorApp?: boolean | null };

export type ShareBulkAuthenticatorAppsMutationVariables = Exact<{
  input?: InputMaybe<ShareBulkAppInput>;
}>;


export type ShareBulkAuthenticatorAppsMutation = { __typename?: 'Mutation', shareBulkAuthenticatorApps?: boolean | null };

export type UpdateUsersEncryptionKeysMutationVariables = Exact<{
  input?: InputMaybe<UserEncryptionKeyInput>;
}>;


export type UpdateUsersEncryptionKeysMutation = { __typename?: 'Mutation', updateUsersEncryptionKeys?: boolean | null };

export type CreateEncryptionCopiesMutationVariables = Exact<{
  input?: InputMaybe<UserEncryptionCopiesInput>;
}>;


export type CreateEncryptionCopiesMutation = { __typename?: 'Mutation', createEncryptionCopies?: boolean | null };

export type UpdateAppPasswordAndSharesMutationVariables = Exact<{
  input?: InputMaybe<UpdatePasswordInput>;
}>;


export type UpdateAppPasswordAndSharesMutation = { __typename?: 'Mutation', updateAppPasswordAndShares?: boolean | null };

export type SendForgotPasswordEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendForgotPasswordEmailMutation = { __typename?: 'Mutation', sendForgotPasswordEmail?: boolean | null };

export type UpdateUserPasswordMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserPasswordInput>;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPassword?: boolean | null };

export type AddPasswordManagerAdminMutationVariables = Exact<{
  employee: Scalars['ID']['input'];
}>;


export type AddPasswordManagerAdminMutation = { __typename?: 'Mutation', addPasswordManagerAdmin?: boolean | null };

export type AddGuarantorForPasswordMutationVariables = Exact<{
  employees: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddGuarantorForPasswordMutation = { __typename?: 'Mutation', addGuarantorForPassword?: boolean | null };

export type ChangeBusinessOwnerPasswordMutationVariables = Exact<{
  input?: InputMaybe<UpdateBusinessOwnerPasswordInput>;
}>;


export type ChangeBusinessOwnerPasswordMutation = { __typename?: 'Mutation', changeBusinessOwnerPassword?: boolean | null };

export type RemoveGuarantorsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type RemoveGuarantorsMutation = { __typename?: 'Mutation', removeGuarantors?: boolean | null };

export type LoginWithEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  deviceToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoginWithEmailMutation = { __typename?: 'Mutation', loginWithEmail?: { __typename?: 'AuthTokens', tokens?: { __typename?: 'tokens', access?: { __typename?: 'token', token?: string | null, expires?: any | null } | null, refresh?: { __typename?: 'token', token?: string | null, expires?: any | null } | null } | null, user?: { __typename?: 'userAuthDetail', is_navigated_user?: boolean | null, date_format?: string | null, currency_format?: string | null, currency_name?: string | null, currency_symbol?: string | null, do_not_disturb?: boolean | null, two_fa_secret?: string | null, is_un_restricted?: boolean | null, last_working_date?: string | null, is_sample_data?: boolean | null, isOwner?: boolean | null, id?: string | null, business_status: string, business_type: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, logo?: string | null, avatar_location?: string | null, user_is_super_admin?: boolean | null, is_popup_closed?: boolean | null, business_is_super_admin?: boolean | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, business_id?: { __typename?: 'Business', zip_code?: string | null, is_24_hour_format?: boolean | null, _id: string, logo?: string | null, business_legal_name?: string | null, business_type?: string | null, time_zone?: string | null, Country?: { __typename?: 'Country', name?: string | null, _id?: string | null } | null, state?: { __typename?: 'State', _id?: string | null, state_name?: string | null } | null, city?: { __typename?: 'City', _id?: string | null, city_name?: string | null } | null, business_package?: { __typename?: 'BusinessPackage', hr_module_only?: boolean | null } | null } | null } | null, rocketChat?: { __typename?: 'rocketChat', userId?: string | null, authToken?: string | null, refreshToken?: string | null } | null, businesses?: Array<{ __typename?: 'Business', business_type?: string | null, _id: string, business_email?: string | null, business_legal_name?: string | null, address?: string | null, logo?: string | null, number_of_stores?: string | null, date_format?: string | null, time_zone?: string | null, status?: string | null, pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, Country?: { __typename?: 'Country', _id?: string | null, name?: string | null, short_name?: string | null } | null, city?: { __typename?: 'City', _id?: string | null, city_name?: string | null } | null } | null> | null } | null };

export type LogoutMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: boolean | null };

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: { __typename?: 'AuthTokens', tokens?: { __typename?: 'tokens', access?: { __typename?: 'token', token?: string | null } | null, refresh?: { __typename?: 'token', token?: string | null, expires?: any | null } | null } | null, user?: { __typename?: 'userAuthDetail', id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, avatar_location?: string | null, business_id?: { __typename?: 'Business', _id: string } | null } | null } | null };

export type UserForgetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  method?: InputMaybe<AllowMethodPhoneVerify>;
}>;


export type UserForgetPasswordMutation = { __typename?: 'Mutation', userForgetPassword?: boolean | null };

export type UserPasswordResetMutationVariables = Exact<{
  input?: InputMaybe<PasswordResetInput>;
}>;


export type UserPasswordResetMutation = { __typename?: 'Mutation', userPasswordReset?: boolean | null };

export type UpdateUserSystemTokenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  systemToken: Scalars['String']['input'];
}>;


export type UpdateUserSystemTokenMutation = { __typename?: 'Mutation', updateUserSystemToken?: { __typename?: 'User', id?: string | null } | null };

export type UpdateUserEmailStatusMutationVariables = Exact<{
  input?: InputMaybe<EmailVerifyOtpInput>;
}>;


export type UpdateUserEmailStatusMutation = { __typename?: 'Mutation', updateUserEmailStatus?: boolean | null };

export type UpdateUserPhoneStatusMutationVariables = Exact<{
  phone: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type UpdateUserPhoneStatusMutation = { __typename?: 'Mutation', updateUserPhoneStatus?: boolean | null };

export type UsersPermissionsChangedNotifySubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UsersPermissionsChangedNotifySubscription = { __typename?: 'Subscription', usersPermissionsChangedNotify?: { __typename?: 'roleChanged', is_role_changed?: boolean | null, is_password_changed?: boolean | null, is_navigated_business_change?: boolean | null } | null };

export type BusinessTimeZoneChangeSubscriptionVariables = Exact<{
  businessId: Scalars['ID']['input'];
}>;


export type BusinessTimeZoneChangeSubscription = { __typename?: 'Subscription', businessTimeZoneChange?: { __typename?: 'BusinessUpdate', is_country_change?: boolean | null, is_time_format_change?: boolean | null, is_time_zone_change?: boolean | null, is_date_format_change?: boolean | null } | null };

export type UserInactiveNotificationSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserInactiveNotificationSubscription = { __typename?: 'Subscription', userInactiveNotification?: { __typename?: 'userAccountStatus', account_status?: boolean | null } | null };

export type GetBusinessByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBusinessByIdQuery = { __typename?: 'Query', getBusinessByID?: { __typename?: 'Business', _id: string, business_keeping_unit?: string | null, business_system_name?: string | null, number_of_stores?: string | null, business_legal_name?: string | null, business_identification_type?: string | null, business_identification_number?: string | null, business_type?: string | null, package?: string | null, date_format?: string | null, currency_format?: string | null, currency_name?: string | null, currency_symbol?: string | null, is_24_hour_format?: boolean | null, time_zone?: string | null, address?: string | null, zip_code?: string | null, logo?: string | null, status?: string | null, created_at?: any | null, city?: { __typename?: 'City', _id?: string | null, city_name?: string | null } | null, state?: { __typename?: 'State', _id?: string | null, state_name?: string | null } | null, Country?: { __typename?: 'Country', _id?: string | null, name?: string | null, short_name?: string | null, is_active?: boolean | null, identification_types?: Array<string | null> | null } | null, owner_id?: { __typename?: 'User', id?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, phone_country_code?: string | null, landline?: string | null, isOwner?: boolean | null, is_email_verify?: boolean | null, is_phone_verify?: boolean | null, auth_pin?: string | null } | null, business_package?: { __typename?: 'BusinessPackage', _id?: string | null, package_name: string, package_price: number, recurring: PackageRecurrignType, subscribe_at?: any | null, expires_at?: any | null, hr_module_only?: boolean | null } | null } | null };

export type GetBusinessesWithFilterQueryVariables = Exact<{
  input?: InputMaybe<BusinessListFilter>;
}>;


export type GetBusinessesWithFilterQuery = { __typename?: 'Query', getBusinessesWithFilter?: { __typename?: 'buinsesslistingResult', config?: { __typename?: 'dataTableConfig', actions?: Array<string | null> | null, limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null, is_search_able?: boolean | null, is_visible?: boolean | null, is_sortable?: boolean | null, search?: string | null, filterValue?: Array<string | null> | null, column_data?: Array<string | null> | null, query?: { __typename?: 'queryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', search?: string | null, field?: string | null, type?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Business', _id: string, business_legal_name?: string | null, business_keeping_unit?: string | null, number_of_stores?: string | null, status?: string | null, is_deleted?: boolean | null, business_email?: string | null, address?: string | null, currency_format?: string | null, currency_name?: string | null, currency_symbol?: string | null, owner_id?: { __typename?: 'User', id?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null } | null, city?: { __typename?: 'City', _id?: string | null, city_name?: string | null } | null, Country?: { __typename?: 'Country', _id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetTotalBusinessLocationsQueryVariables = Exact<{
  businessId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetTotalBusinessLocationsQuery = { __typename?: 'Query', getTotalBusinessLocations?: number | null };

export type GetTotalCustomersQueryVariables = Exact<{
  input?: InputMaybe<BusinessStoreInput>;
}>;


export type GetTotalCustomersQuery = { __typename?: 'Query', getTotalCustomers?: number | null };

export type GetTotalEmployeesQueryVariables = Exact<{
  input?: InputMaybe<BusinessStoreInput>;
}>;


export type GetTotalEmployeesQuery = { __typename?: 'Query', getTotalEmployees?: number | null };

export type CustomersByBusinessIdQueryVariables = Exact<{
  business: Scalars['ID']['input'];
}>;


export type CustomersByBusinessIdQuery = { __typename?: 'Query', customersByBusinessId?: Array<{ __typename?: 'Customer', _id?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, full_name?: string | null } | null> | null };

export type GetUsersWithPasswordPermissionQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
}>;


export type GetUsersWithPasswordPermissionQuery = { __typename?: 'Query', getUsersWithPasswordPermission?: Array<{ __typename?: 'User', id?: string | null, email?: string | null, employee_id?: string | null, first_name?: string | null, last_name?: string | null, middle_name?: string | null, full_name?: string | null, phone?: string | null, phone_country_code?: string | null, isOwner?: boolean | null, status?: string | null, logo?: string | null, avatar_location?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null, users_password_manager?: { __typename?: 'UserEncryptionKeys', publicKey?: string | null } | null } | null> | null };

export type GetLinkedBusinessesQueryVariables = Exact<{
  input?: InputMaybe<GetLinkedBusinessInput>;
}>;


export type GetLinkedBusinessesQuery = { __typename?: 'Query', getLinkedBusinesses?: Array<{ __typename?: 'BusinessNavigation', _id?: string | null, status?: string | null, created_at?: any | null, updated_at?: any | null, is_deleted?: boolean | null, requested_by?: { __typename?: 'Business', _id: string, logo?: string | null, business_legal_name?: string | null, business_system_name?: string | null } | null, requested_to?: { __typename?: 'Business', _id: string, logo?: string | null, business_legal_name?: string | null, business_system_name?: string | null } | null, requested_by_user?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, requested_to_user?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, navigation_users?: Array<{ __typename?: 'BusinessNavigationUserList', employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null, employee_id?: string | null } | null, role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null } | null> | null } | null> | null };

export type GetLinkedBusinessesByIdQueryVariables = Exact<{
  businessNavigationId: Scalars['ID']['input'];
}>;


export type GetLinkedBusinessesByIdQuery = { __typename?: 'Query', getLinkedBusinessesById?: { __typename?: 'BusinessNavigation', _id?: string | null, status?: string | null, requested_by?: { __typename?: 'Business', business_legal_name?: string | null } | null, requested_to?: { __typename?: 'Business', business_legal_name?: string | null } | null, navigation_users?: Array<{ __typename?: 'BusinessNavigationUserList', employee?: { __typename?: 'User', id?: string | null, full_name?: string | null, employee_id?: string | null } | null, role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null } | null> | null } | null };

export type GetAllNavigationBusinessListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllNavigationBusinessListQuery = { __typename?: 'Query', getAllNavigationBusinessList?: Array<{ __typename?: 'Business', _id: string, business_legal_name?: string | null, business_email?: string | null, logo?: string | null, Country?: { __typename?: 'Country', name?: string | null, _id?: string | null } | null } | null> | null };

export type GetAllActiveBusinessQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActiveBusinessQuery = { __typename?: 'Query', getAllActiveBusiness?: Array<{ __typename?: 'Business', _id: string, business_legal_name?: string | null, business_system_name?: string | null, logo?: string | null, status?: string | null } | null> | null };

export type UpdateBusinessMutationVariables = Exact<{
  updateBusinessId: Scalars['ID']['input'];
  input?: InputMaybe<UpdateBusinessInput>;
}>;


export type UpdateBusinessMutation = { __typename?: 'Mutation', updateBusiness?: { __typename?: 'Business', _id: string, business_legal_name?: string | null, logo?: string | null } | null };

export type ArchiveBusinessMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveBusinessMutation = { __typename?: 'Mutation', archiveBusiness?: boolean | null };

export type LinkBusinessesMutationVariables = Exact<{
  input?: InputMaybe<LinkBusinessesInput>;
}>;


export type LinkBusinessesMutation = { __typename?: 'Mutation', linkBusinesses?: { __typename?: 'BusinessNavigation', status?: string | null, requested_by?: { __typename?: 'Business', business_legal_name?: string | null } | null, requested_to?: { __typename?: 'Business', business_legal_name?: string | null } | null } | null };

export type UnlinkBusinessMutationVariables = Exact<{
  input?: InputMaybe<UnlinkBusinessInput>;
}>;


export type UnlinkBusinessMutation = { __typename?: 'Mutation', unlinkBusiness?: { __typename?: 'BusinessNavigation', _id?: string | null, deleted_at?: any | null } | null };

export type AcceptRejectBusinessRequestMutationVariables = Exact<{
  input?: InputMaybe<ChangeRequestStatusInput>;
}>;


export type AcceptRejectBusinessRequestMutation = { __typename?: 'Mutation', acceptRejectBusinessRequest?: boolean | null };

export type AddEmployeeIntoBusinessesMutationVariables = Exact<{
  input?: InputMaybe<AddEmployeeIntoBusinessInput>;
}>;


export type AddEmployeeIntoBusinessesMutation = { __typename?: 'Mutation', addEmployeeIntoBusinesses?: { __typename?: 'BusinessNavigation', _id?: string | null, is_deleted?: boolean | null } | null };

export type EditBusinessEmployeeMutationVariables = Exact<{
  input?: InputMaybe<EditBusinessEmployeeInput>;
}>;


export type EditBusinessEmployeeMutation = { __typename?: 'Mutation', editBusinessEmployee?: { __typename?: 'BusinessNavigation', _id?: string | null, created_at?: any | null } | null };

export type RemoveEmployeeFromBusinessMutationVariables = Exact<{
  input?: InputMaybe<RemoveBusinessEmployeeInput>;
}>;


export type RemoveEmployeeFromBusinessMutation = { __typename?: 'Mutation', removeEmployeeFromBusiness?: { __typename?: 'BusinessNavigation', _id?: string | null } | null };

export type GetAllGuarantorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGuarantorQuery = { __typename?: 'Query', getAllGuarantor?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, employee_id?: string | null, full_name?: string | null, logo?: string | null } | null> | null };

export type GetPasswordManagerAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPasswordManagerAdminQuery = { __typename?: 'Query', getPasswordManagerAdmin?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null };

export type GetLoggedInUserDetailMutationVariables = Exact<{ [key: string]: never; }>;


export type GetLoggedInUserDetailMutation = { __typename?: 'Mutation', getLoggedInUserDetail?: { __typename?: 'AuthTokens', user?: { __typename?: 'userAuthDetail', is_navigated_user?: boolean | null, two_fa_secret?: string | null, last_working_date?: string | null, is_sample_data?: boolean | null, isOwner?: boolean | null, id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, logo?: string | null, avatar_location?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, business_id?: { __typename?: 'Business', zip_code?: string | null, is_24_hour_format?: boolean | null, date_format?: string | null, time_zone?: string | null, currency_format?: string | null, currency_name?: string | null, _id: string, logo?: string | null, business_legal_name?: string | null, business_type?: string | null, Country?: { __typename?: 'Country', name?: string | null, _id?: string | null } | null, state?: { __typename?: 'State', _id?: string | null, state_name?: string | null } | null, city?: { __typename?: 'City', _id?: string | null, city_name?: string | null } | null, business_package?: { __typename?: 'BusinessPackage', hr_module_only?: boolean | null } | null } | null } | null } | null };

export type VerifyBusinessSystemNameQueryVariables = Exact<{
  business_system_name?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifyBusinessSystemNameQuery = { __typename?: 'Query', verifyBusinessSystemName?: boolean | null };

export type GetBusinessByIdentificationNumberQueryVariables = Exact<{
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBusinessByIdentificationNumberQuery = { __typename?: 'Query', getBusinessByIdentificationNumber?: { __typename?: 'Business', _id: string, business_keeping_unit?: string | null, business_system_name?: string | null, business_legal_name?: string | null, business_identification_type?: string | null, business_identification_number?: string | null, business_type?: string | null, address?: string | null, zip_code?: string | null, logo?: string | null, status?: string | null, owner_id?: { __typename?: 'User', id?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, phone_country_code?: string | null, is_email_verify?: boolean | null, is_phone_verify?: boolean | null } | null, Country?: { __typename?: 'Country', _id?: string | null, name?: string | null, short_name?: string | null, identification_types?: Array<string | null> | null } | null } | null };

export type GetBusinessPackagesQueryVariables = Exact<{
  business: Scalars['ID']['input'];
  packageType?: InputMaybe<PackageType>;
}>;


export type GetBusinessPackagesQuery = { __typename?: 'Query', getBusinessPackages?: Array<{ __typename?: 'Package', _id?: string | null, package_name?: string | null, package_type?: string | null } | null> | null };

export type CreateBusinessMutationVariables = Exact<{
  input?: InputMaybe<CreateBusinessInput>;
}>;


export type CreateBusinessMutation = { __typename?: 'Mutation', createBusiness?: { __typename?: 'Business', _id: string } | null };

export type RegisterBusinessMutationVariables = Exact<{
  input?: InputMaybe<BusinessRegistration>;
}>;


export type RegisterBusinessMutation = { __typename?: 'Mutation', registerBusiness?: { __typename?: 'busniessId', _id?: string | null } | null };

export type GetSampleDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSampleDataQuery = { __typename?: 'Query', getSampleData?: Array<{ __typename?: 'SampleData', _id?: string | null, is_selected?: boolean | null, name?: string | null } | null> | null };

export type UpdateSampleDataMutationVariables = Exact<{
  input: Array<UpdateSampleDataInput> | UpdateSampleDataInput;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateSampleDataMutation = { __typename?: 'Mutation', updateSampleData?: boolean | null };

export type GetBusinessedByTypeCommissionQueryVariables = Exact<{
  type?: InputMaybe<AllowBusinessType>;
}>;


export type GetBusinessedByTypeCommissionQuery = { __typename?: 'Query', getBusinessedByType?: Array<{ __typename?: 'Business', _id: string, business_system_name?: string | null } | null> | null };

export type GetBusinessLocationsByBusinessIdCommissionQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
}>;


export type GetBusinessLocationsByBusinessIdCommissionQuery = { __typename?: 'Query', getBusinessLocationsByBusinessId?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null> | null };

export type GetCommisionCampaignswithCommissionsQueryVariables = Exact<{
  input?: InputMaybe<CommissioinCampaignSearchInput>;
}>;


export type GetCommisionCampaignswithCommissionsQuery = { __typename?: 'Query', getCommisionCampaignswithCommissions?: { __typename?: 'commisionCampaignList', config?: { __typename?: 'dataTableConfig', totalResults?: number | null, totalPages?: number | null, actions?: Array<string | null> | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', field?: string | null, header?: string | null, is_visible?: boolean | null, is_search_able?: boolean | null, is_sortable?: boolean | null, is_amount?: boolean | null, type?: string | null, column_data?: Array<string | null> | null } | null> | null } | null, data?: Array<{ __typename?: 'commissionCompaignData', _id?: string | null, name?: string | null, start_date?: any | null, end_date?: any | null, is_active?: boolean | null, is_deleted?: boolean | null, statistics?: number | null, stores?: number | null, summary?: number | null, created_at?: any | null, Business?: { __typename?: 'Business', _id: string, business_system_name?: string | null } | null, BusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, Commission?: Array<{ __typename?: 'Commission', _id?: string | null, commission_name?: string | null, commission_amount: number, commission_type?: _Commission_Type | null, commission_duration?: _Commission_Duration | null, is_commission_type_percentage?: boolean | null, is_active?: Is_Active | null, status: _Status, reach?: number | null, statistics?: number | null, till_date?: any | null, schedule_from?: any | null, schedule_to?: any | null } | null> | null, detail?: { __typename?: 'CommissionDetails', actions?: Array<string | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', field?: string | null, header?: string | null, is_visible?: boolean | null, is_search_able?: boolean | null, is_sortable?: boolean | null, is_amount?: boolean | null, type?: string | null } | null> | null, result?: Array<{ __typename?: 'Commission', _id?: string | null, commission_name?: string | null, commission_amount: number, commission_type?: _Commission_Type | null, commission_duration?: _Commission_Duration | null, is_commission_type_percentage?: boolean | null, is_active?: Is_Active | null, status: _Status, reach?: number | null, statistics?: number | null, till_date?: any | null, schedule_from?: any | null, schedule_to?: any | null } | null> | null } | null } | null> | null } | null };

export type GetCommisionCampaignsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCommisionCampaignsQuery = { __typename?: 'Query', getCommisionCampaigns?: Array<{ __typename?: 'CommissionCampaign', _id?: string | null, name?: string | null, is_active?: boolean | null, is_deleted?: boolean | null } | null> | null };

export type CommissionByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CommissionByIdQuery = { __typename?: 'Query', CommissionById?: { __typename?: 'Commission', _id?: string | null, business_type?: string | null, commission_name?: string | null, commission_amount: number, commission_duration?: _Commission_Duration | null, commission_on?: CommissionOn | null, commission_store?: _Commission_Store | null, commission_type?: _Commission_Type | null, description?: string | null, highest_sale_duration?: _Sale_Duration | null, is_active?: Is_Active | null, is_all_brands?: boolean | null, is_all_categories?: boolean | null, is_all_departments?: boolean | null, is_all_deviceModels?: boolean | null, is_all_deviceTypes?: boolean | null, is_all_employee?: boolean | null, is_all_productTypes?: boolean | null, is_all_products?: boolean | null, is_all_roles?: boolean | null, is_commission_on_sale?: boolean | null, is_commission_type_percentage?: boolean | null, is_greater_then?: boolean | null, is_on_highest_sales?: boolean | null, on_gt_eq_sale_duration?: _Sale_Duration | null, on_gt_eq_sale_number?: number | null, pay_Type?: string | null, pay_schedule?: string | null, salary_type?: string | null, schedule_from?: any | null, schedule_to?: any | null, status: _Status, till_date?: any | null, Business?: { __typename?: 'Business', _id: string, business_system_name?: string | null } | null, BusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, CommissionCampaign?: { __typename?: 'CommissionCampaign', _id?: string | null, name?: string | null } | null, Brand?: Array<{ __typename?: 'SystemBrand', _id?: string | null, brand_name?: string | null } | null> | null, Category?: Array<{ __typename?: 'ServiceCategory', _id?: string | null, category_name?: string | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, DeviceModel?: Array<{ __typename?: 'DeviceModel', _id?: string | null, name?: string | null } | null> | null, DeviceType?: Array<{ __typename?: 'DeviceType', _id?: string | null, type_name?: string | null } | null> | null, Employee?: Array<{ __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null> | null, Product?: Array<{ __typename?: 'Product', _id?: string | null, product_name?: string | null } | null> | null, ProductType?: Array<{ __typename?: 'ProductCategoryType', _id?: string | null, category_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, stores?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null> | null } | null };

export type SearchBusinessLocationCommissionQueryVariables = Exact<{
  input?: InputMaybe<BusinessLocationListFilter>;
}>;


export type SearchBusinessLocationCommissionQuery = { __typename?: 'Query', searchBusinessLocation?: { __typename?: 'buinsessLocationlistingResult', results?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null> | null } | null };

export type GetAllSystemBrandsCommissionQueryVariables = Exact<{
  Business: Scalars['ID']['input'];
  BusinessLocation: Scalars['ID']['input'];
  input?: InputMaybe<ListFilter>;
}>;


export type GetAllSystemBrandsCommissionQuery = { __typename?: 'Query', getAllSystemBrands?: { __typename?: 'systembrandResult', results?: Array<{ __typename?: 'Brand', _id?: string | null, name?: string | null } | null> | null } | null };

export type GetEmployeesByPayroleFiltersQueryVariables = Exact<{
  BusinessLocation: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  departmentsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  payType?: InputMaybe<Scalars['String']['input']>;
  payschedule?: InputMaybe<Scalars['String']['input']>;
  RoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  salarytype?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEmployeesByPayroleFiltersQuery = { __typename?: 'Query', getEmployeesByPayroleFilters?: Array<{ __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null> | null };

export type GetModelsByBrandIdsQueryVariables = Exact<{
  brandIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type GetModelsByBrandIdsQuery = { __typename?: 'Query', getModelsByBrandIds?: Array<{ __typename?: 'SystemModel', _id?: string | null, name?: string | null } | null> | null };

export type GetProdcutsByFilterationQueryVariables = Exact<{
  brandIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  BusinessLocation: Scalars['ID']['input'];
  modelIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  deviceTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type GetProdcutsByFilterationQuery = { __typename?: 'Query', getProdcutsByFilteration?: Array<{ __typename?: 'Product', _id?: string | null, product_name?: string | null } | null> | null };

export type GetAllProductCategoriesCommissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProductCategoriesCommissionQuery = { __typename?: 'Query', getAllProductCategories?: Array<{ __typename?: 'ProductCategoryType', _id?: string | null, category_name?: string | null } | null> | null };

export type GetAllDeviceTypeCommissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDeviceTypeCommissionQuery = { __typename?: 'Query', getAllDeviceType?: Array<{ __typename?: 'DeviceType', _id?: string | null, type_name?: string | null } | null> | null };

export type GetAllServiceCategoryCommissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllServiceCategoryCommissionQuery = { __typename?: 'Query', getAllServiceCategory?: Array<{ __typename?: 'ServiceCategoryType', _id?: string | null, category_name?: string | null } | null> | null };

export type CreateCommisionCampaignMutationVariables = Exact<{
  input?: InputMaybe<CommisionCampaignInput>;
}>;


export type CreateCommisionCampaignMutation = { __typename?: 'Mutation', createCommisionCampaign?: { __typename?: 'CommissionCampaign', _id?: string | null, name?: string | null } | null };

export type CreateCommissionMutationVariables = Exact<{
  input?: InputMaybe<CommissionInput>;
}>;


export type CreateCommissionMutation = { __typename?: 'Mutation', createCommission?: { __typename?: 'Commission', _id?: string | null, commission_name?: string | null } | null };

export type UpdateCommissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<CommissionInput>;
}>;


export type UpdateCommissionMutation = { __typename?: 'Mutation', updateCommission?: { __typename?: 'Commission', _id?: string | null, commission_name?: string | null } | null };

export type RemoveCommisionCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type RemoveCommisionCampaignMutation = { __typename?: 'Mutation', removeCommisionCampaign?: boolean | null };

export type DeleteCommissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  delete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteCommissionMutation = { __typename?: 'Mutation', deleteCommission?: boolean | null };

export type CommissionCompaingStatusChangedMutationVariables = Exact<{
  campaign_id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CommissionCompaingStatusChangedMutation = { __typename?: 'Mutation', commission_compaingStatusChanged?: boolean | null };

export type CommissionStatusChangedMutationVariables = Exact<{
  campaign_id: Scalars['ID']['input'];
  commission_id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CommissionStatusChangedMutation = { __typename?: 'Mutation', commission_statusChanged?: boolean | null };

export type GetAllDiscountsQueryVariables = Exact<{
  input?: InputMaybe<SearchDiscountInput>;
}>;


export type GetAllDiscountsQuery = { __typename?: 'Query', getAllDiscounts?: { __typename?: 'discountListingResult', page?: number | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null, results?: Array<{ __typename?: 'Discount', _id?: string | null, code?: string | null, tags?: Array<string | null> | null, is_single_store?: boolean | null, is_minimum_purchase?: boolean | null, is_discount_percentage?: boolean | null, discount_amount?: number | null, is_minimum_purchase_amount?: boolean | null, purchaseAmountQuantity?: number | null, is_entire_order?: boolean | null, is_customer_since?: boolean | null, customer_since?: any | null, is_new_customer_only?: boolean | null, new_customer_register_after_date?: any | null, is_customer_spent_amount: boolean, is_customer_more_then_said_amount?: boolean | null, spent_amount?: number | null, customerTags?: Array<string | null> | null, is_customer_can_use_only_once?: boolean | null, number_of_usage_per_customer?: number | null, can_schedule: boolean, schedule_from?: any | null, schedule_to?: any | null, created_at?: any | null, updated_at?: any | null, is_active: Is_Active, reach?: number | null, status?: string | null, engagement?: number | null, isSendEmail?: boolean | null, is_deleted?: boolean | null, Campaign?: { __typename?: 'Campaign', _id?: string | null, name?: string | null, is_active?: boolean | null, start_date?: any | null, end_date?: any | null } | null, single_store?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null, multi_stores?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_nick_name?: string | null, store_name?: string | null } | null> | null, Product?: Array<{ __typename?: 'Product', _id?: string | null, product_name?: string | null, total_amount?: number | null, quantity?: number | null } | null> | null, redeem_by?: Array<{ __typename?: 'Customer', _id?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null> | null, BusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null, Business?: { __typename?: 'Business', _id: string, business_keeping_unit?: string | null, business_system_name?: string | null, business_type?: string | null, number_of_stores?: string | null } | null } | null> | null } | null };

export type GetAllDiscountsWithSearchQueryVariables = Exact<{
  input?: InputMaybe<SearchDiscountNewInput>;
}>;


export type GetAllDiscountsWithSearchQuery = { __typename?: 'Query', getAllDiscountsWithSearch?: { __typename?: 'campaignsListingResultNew', config?: { __typename?: 'dataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<string | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null, search?: string | null, is_search_able?: boolean | null, is_visible?: boolean | null, filterValue?: Array<string | null> | null, is_sortable?: boolean | null, column_data?: Array<string | null> | null, query?: { __typename?: 'queryType', first_condition?: string | null, second_condition?: string | null, first_value?: string | null, second_value?: string | null, condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', search?: string | null, field?: string | null, type?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'compaignData', name?: string | null, is_active?: boolean | null, start_date?: any | null, end_date?: any | null, summary?: number | null, statistics?: number | null, stores?: number | null, created_at?: any | null, _id?: string | null, detail?: { __typename?: 'DiscountDetail', actions?: Array<string | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null } | null> | null, result?: Array<{ __typename?: 'Discount', discount_amount?: number | null, code?: string | null, schedule_from?: any | null, schedule_to?: any | null, _id?: string | null } | null> | null } | null } | null> | null } | null };

export type GetDiscountByIdQueryVariables = Exact<{
  DiscountId: Scalars['ID']['input'];
}>;


export type GetDiscountByIdQuery = { __typename?: 'Query', getDiscountById?: { __typename?: 'Discount', _id?: string | null, code?: string | null, business_type?: string | null, tags?: Array<string | null> | null, is_single_store?: boolean | null, is_minimum_purchase?: boolean | null, is_discount_percentage?: boolean | null, discount_amount?: number | null, is_minimum_purchase_amount?: boolean | null, purchaseAmountQuantity?: number | null, is_entire_order?: boolean | null, is_customer_since?: boolean | null, customer_since?: any | null, is_new_customer_only?: boolean | null, new_customer_register_after_date?: any | null, is_customer_spent_amount: boolean, is_customer_more_then_said_amount?: boolean | null, spent_amount?: number | null, customerTags?: Array<string | null> | null, is_customer_can_use_only_once?: boolean | null, number_of_usage_per_customer?: number | null, can_schedule: boolean, schedule_from?: any | null, schedule_to?: any | null, created_at?: any | null, updated_at?: any | null, is_active: Is_Active, reach?: number | null, status?: string | null, engagement?: number | null, isSendEmail?: boolean | null, is_deleted?: boolean | null, Campaign?: { __typename?: 'Campaign', _id?: string | null, name?: string | null, is_active?: boolean | null, start_date?: any | null, end_date?: any | null } | null, single_store?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null, multi_stores?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_nick_name?: string | null, store_name?: string | null } | null> | null, Product?: Array<{ __typename?: 'Product', _id?: string | null, product_name?: string | null, total_amount?: number | null, quantity?: number | null } | null> | null, redeem_by?: Array<{ __typename?: 'Customer', _id?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null> | null, BusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null, Business?: { __typename?: 'Business', _id: string, business_keeping_unit?: string | null, business_system_name?: string | null, business_type?: string | null, number_of_stores?: string | null } | null } | null };

export type GetDiscountByCodeQueryVariables = Exact<{
  code: Scalars['ID']['input'];
}>;


export type GetDiscountByCodeQuery = { __typename?: 'Query', getDiscountByCode?: { __typename?: 'Discount', _id?: string | null, code?: string | null, business_type?: string | null, tags?: Array<string | null> | null, is_single_store?: boolean | null, is_minimum_purchase?: boolean | null, is_discount_percentage?: boolean | null, discount_amount?: number | null, is_minimum_purchase_amount?: boolean | null, purchaseAmountQuantity?: number | null, is_entire_order?: boolean | null, is_customer_since?: boolean | null, customer_since?: any | null, is_new_customer_only?: boolean | null, new_customer_register_after_date?: any | null, is_customer_spent_amount: boolean, is_customer_more_then_said_amount?: boolean | null, spent_amount?: number | null, customerTags?: Array<string | null> | null, is_customer_can_use_only_once?: boolean | null, number_of_usage_per_customer?: number | null, can_schedule: boolean, schedule_from?: any | null, schedule_to?: any | null, created_at?: any | null, updated_at?: any | null, is_active: Is_Active, reach?: number | null, status?: string | null, engagement?: number | null, isSendEmail?: boolean | null, is_deleted?: boolean | null, Campaign?: { __typename?: 'Campaign', _id?: string | null, name?: string | null, is_active?: boolean | null, start_date?: any | null, end_date?: any | null } | null, single_store?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null, multi_stores?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_nick_name?: string | null, store_name?: string | null } | null> | null, Product?: Array<{ __typename?: 'Product', _id?: string | null, product_name?: string | null, total_amount?: number | null, quantity?: number | null } | null> | null, redeem_by?: Array<{ __typename?: 'Customer', _id?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null> | null, BusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null, Business?: { __typename?: 'Business', _id: string, business_keeping_unit?: string | null, business_system_name?: string | null, business_type?: string | null, number_of_stores?: string | null } | null } | null };

export type GetValidateDiscountByCodeQueryVariables = Exact<{
  input: ValidateDiscountInput;
}>;


export type GetValidateDiscountByCodeQuery = { __typename?: 'Query', getValidateDiscountByCode?: { __typename?: 'ValidDiscount', discount?: { __typename?: 'Discount', _id?: string | null, code?: string | null, business_type?: string | null, tags?: Array<string | null> | null, is_single_store?: boolean | null, is_minimum_purchase?: boolean | null, is_discount_percentage?: boolean | null, discount_amount?: number | null, is_minimum_purchase_amount?: boolean | null, purchaseAmountQuantity?: number | null, is_entire_order?: boolean | null, is_customer_since?: boolean | null, customer_since?: any | null, is_new_customer_only?: boolean | null, new_customer_register_after_date?: any | null, is_customer_spent_amount: boolean, is_customer_more_then_said_amount?: boolean | null, spent_amount?: number | null, customerTags?: Array<string | null> | null, is_customer_can_use_only_once?: boolean | null, number_of_usage_per_customer?: number | null, can_schedule: boolean, schedule_from?: any | null, schedule_to?: any | null, created_at?: any | null, updated_at?: any | null, is_active: Is_Active, reach?: number | null, status?: string | null, engagement?: number | null, isSendEmail?: boolean | null, is_deleted?: boolean | null, Campaign?: { __typename?: 'Campaign', _id?: string | null, name?: string | null } | null, single_store?: { __typename?: 'BusinessLocation', _id?: string | null } | null, multi_stores?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null> | null, Product?: Array<{ __typename?: 'Product', _id?: string | null, product_name?: string | null, total_amount?: number | null, quantity?: number | null } | null> | null, redeem_by?: Array<{ __typename?: 'Customer', _id?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null> | null, BusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null, Business?: { __typename?: 'Business', _id: string, business_keeping_unit?: string | null, business_system_name?: string | null } | null } | null } | null };

export type GetCouponCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCouponCodeQuery = { __typename?: 'Query', getCouponCode?: { __typename?: 'couponCode', code: string } | null };

export type GetAllCampaignsSearchQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
}>;


export type GetAllCampaignsSearchQuery = { __typename?: 'Query', getAllCampaignsSearch?: Array<{ __typename?: 'Campaign', _id?: string | null, name?: string | null, is_active?: boolean | null, start_date?: any | null, end_date?: any | null } | null> | null };

export type GetCampaignsAndSearchQueryVariables = Exact<{
  input?: InputMaybe<SearchCampaignInput>;
}>;


export type GetCampaignsAndSearchQuery = { __typename?: 'Query', getCampaignsAndSearch?: { __typename?: 'campaignsListingResult', page?: number | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null, results?: Array<{ __typename?: 'Campaign', _id?: string | null, name?: string | null, is_active?: boolean | null, start_date?: any | null, end_date?: any | null } | null> | null } | null };

export type GetAllDiscountTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDiscountTagsQuery = { __typename?: 'Query', getAllDiscountTags?: Array<{ __typename?: 'Tags', _id?: string | null, name?: string | null, slug?: string | null, type?: string | null } | null> | null };

export type GetSearchedDiscountTagsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSearchedDiscountTagsQuery = { __typename?: 'Query', getSearchedDiscountTags?: Array<{ __typename?: 'Tags', _id?: string | null, name?: string | null, slug?: string | null, type?: string | null } | null> | null };

export type GetEffectDiscountToCustomerQueryVariables = Exact<{
  input?: InputMaybe<ProgressBarInput>;
}>;


export type GetEffectDiscountToCustomerQuery = { __typename?: 'Query', getEffectDiscountToCustomer?: { __typename?: 'progressBarData', Total_customer?: number | null, effect_customer?: number | null } | null };

export type CreateDiscountMutationVariables = Exact<{
  input: DiscountInput;
}>;


export type CreateDiscountMutation = { __typename?: 'Mutation', createDiscount?: { __typename?: 'Discount', _id?: string | null, code?: string | null, business_type?: string | null, tags?: Array<string | null> | null, is_single_store?: boolean | null, is_minimum_purchase?: boolean | null, is_discount_percentage?: boolean | null, discount_amount?: number | null, is_minimum_purchase_amount?: boolean | null, purchaseAmountQuantity?: number | null, is_entire_order?: boolean | null, is_customer_since?: boolean | null, customer_since?: any | null, is_new_customer_only?: boolean | null, new_customer_register_after_date?: any | null, is_customer_spent_amount: boolean, is_customer_more_then_said_amount?: boolean | null, spent_amount?: number | null, customerTags?: Array<string | null> | null, is_customer_can_use_only_once?: boolean | null, number_of_usage_per_customer?: number | null, can_schedule: boolean, schedule_from?: any | null, schedule_to?: any | null, created_at?: any | null, updated_at?: any | null, is_active: Is_Active, reach?: number | null, status?: string | null, engagement?: number | null, isSendEmail?: boolean | null, is_deleted?: boolean | null, Campaign?: { __typename?: 'Campaign', _id?: string | null, name?: string | null } | null, single_store?: { __typename?: 'BusinessLocation', _id?: string | null } | null, multi_stores?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null> | null, Product?: Array<{ __typename?: 'Product', _id?: string | null, product_name?: string | null, total_amount?: number | null, quantity?: number | null } | null> | null, redeem_by?: Array<{ __typename?: 'Customer', _id?: string | null, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null> | null, BusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null } | null, Business?: { __typename?: 'Business', _id: string, business_keeping_unit?: string | null, business_system_name?: string | null } | null } | null };

export type UpdateDiscountMutationVariables = Exact<{
  input: UpdateDiscountInput;
}>;


export type UpdateDiscountMutation = { __typename?: 'Mutation', updateDiscount?: boolean | null };

export type DeleteDiscountMutationVariables = Exact<{
  deleteDiscountId: Scalars['ID']['input'];
}>;


export type DeleteDiscountMutation = { __typename?: 'Mutation', deleteDiscount?: boolean | null };

export type DiscountStatusChangedMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  discountId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DiscountStatusChangedMutation = { __typename?: 'Mutation', discountStatusChanged?: boolean | null };

export type CampaignStatusChangedMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CampaignStatusChangedMutation = { __typename?: 'Mutation', campaignStatusChanged?: boolean | null };

export type GetProductsByLocationQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type GetProductsByLocationQuery = { __typename?: 'Query', getProductsByLocation?: Array<{ __typename?: 'Product', _id?: string | null, product_name?: string | null, description?: string | null } | null> | null };

export type GetBusinessedByTypeQueryVariables = Exact<{
  type?: InputMaybe<AllowBusinessType>;
}>;


export type GetBusinessedByTypeQuery = { __typename?: 'Query', getBusinessedByType?: Array<{ __typename?: 'Business', _id: string, business_type?: string | null, business_system_name?: string | null } | null> | null };

export type CreateCampaignMutationVariables = Exact<{
  input: CreateCampaignInput;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', createCampaign?: { __typename?: 'Campaign', _id?: string | null, name?: string | null, start_date?: any | null, end_date?: any | null, is_active?: boolean | null, BusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null } | null, Business?: { __typename?: 'Business', _id: string, status?: string | null } | null } | null };

export type GetAllActivityDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActivityDocumentsQuery = { __typename?: 'Query', getAllActivityDocuments?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, attachment?: string | null, validity?: any | null, name?: string | null, assign_to?: { __typename?: 'assignToType', type?: string | null, assignee?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null } | null } | null> | null };

export type GetDocumentControlGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentControlGroupsQuery = { __typename?: 'Query', getDocumentControlGroups?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, isFile?: boolean | null, updated_at?: any | null, attachment?: string | null, document_type?: string | null, validity?: any | null, assign_to?: { __typename?: 'assignToType', type?: string | null, assignee?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null } | null } | null> | null };

export type CreateActivityGroupMutationVariables = Exact<{
  input?: InputMaybe<CreateGroupInput>;
}>;


export type CreateActivityGroupMutation = { __typename?: 'Mutation', createActivityGroup?: boolean | null };

export type CreateUpdateMultipleActionActivityMutationVariables = Exact<{
  input: AddDocumentInput;
}>;


export type CreateUpdateMultipleActionActivityMutation = { __typename?: 'Mutation', createUpdateMultipleActionActivity?: { __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, activity_type?: Activity_Type | null, attachment?: string | null } | null };

export type GetAllActiveEmployeesForActivityQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
}>;


export type GetAllActiveEmployeesForActivityQuery = { __typename?: 'Query', getAllActiveEmployees?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, last_working_date?: any | null } | null> | null };

export type GetAllDepartmentsQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
}>;


export type GetAllDepartmentsQuery = { __typename?: 'Query', getAllDepartments?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null };

export type GetEmployeesByDepartmentWithoutLimitsQueryVariables = Exact<{
  filter?: InputMaybe<EmployeesByDepWithoutLimits>;
}>;


export type GetEmployeesByDepartmentWithoutLimitsQuery = { __typename?: 'Query', getEmployeesByDepartmentWithoutLimits?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, last_working_date?: any | null } | null> | null };

export type GetEmployeeByRoleIdsQueryVariables = Exact<{
  roles_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetEmployeeByRoleIdsQuery = { __typename?: 'Query', getEmployeeByRoleIds?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, last_working_date?: any | null } | null> | null };

export type GetRolesByBusinessIdQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
}>;


export type GetRolesByBusinessIdQuery = { __typename?: 'Query', getRolesByBusinessId?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null };

export type GetDocumentsWithFilterQueryVariables = Exact<{
  input: InputWithFilter;
}>;


export type GetDocumentsWithFilterQuery = { __typename?: 'Query', getDocumentsWithFilter?: { __typename?: 'allDocumentsResult', page?: number | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null, results?: Array<{ __typename?: 'DocumentControlAttachment', is_owner?: boolean | null, share_as?: string | null, share_by?: string | null, google_drive_attachment?: string | null, type?: string | null, is_default_document?: boolean | null, is_employee_main_folder?: boolean | null, is_employee_folder?: boolean | null, is_asset_main_folder?: boolean | null, created_at?: any | null, isEmployeeUpload?: boolean | null, _id?: string | null, activity_type?: Activity_Type | null, name?: string | null, isFile?: boolean | null, updated_at?: any | null, extension?: string | null, size?: number | null, attachment?: string | null, document_type?: string | null, validity?: any | null, details?: { __typename?: 'DocumentControlAttachmentDetail', files?: number | null, folder?: number | null } | null, share_with?: Array<{ __typename?: 'share_with', _id?: string | null, date?: any | null, share_as?: string | null, type?: string | null, shared_by?: { __typename?: 'User', full_name?: string | null } | null, department?: { __typename?: 'Department', department_name?: string | null, _id?: string | null } | null, role?: { __typename?: 'Role', roleName?: string | null, _id?: string | null } | null, employee?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null } | null> | null, bread_crum?: Array<{ __typename?: 'DocumentControlAttachment', name?: string | null, _id?: string | null } | null> | null, created_by?: { __typename?: 'User', full_name?: string | null } | null, children?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, isFile?: boolean | null, updated_at?: any | null, size?: number | null, children?: Array<{ __typename?: 'DocumentControlAttachment', size?: number | null, name?: string | null, _id?: string | null } | null> | null } | null> | null, parent?: { __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, isFile?: boolean | null, updated_at?: any | null, parent?: { __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null } | null } | null, assign_to?: { __typename?: 'assignToType', type?: string | null, assignee?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null } | null } | null> | null } | null };

export type GetDocumentControlAttachmentsFolderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentControlAttachmentsFolderQuery = { __typename?: 'Query', getDocumentControlAttachmentsFolder?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, isFile?: boolean | null, assign_to?: { __typename?: 'assignToType', type?: string | null, assignee?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null } | null, children?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, isFile?: boolean | null } | null> | null } | null> | null };

export type GetFoldersWithSearchQueryVariables = Exact<{
  type?: InputMaybe<DocumentTypeEnums>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFoldersWithSearchQuery = { __typename?: 'Query', getFoldersWithSearch?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, isFile?: boolean | null, updated_at?: any | null, share_as?: string | null, extension?: string | null, is_owner?: boolean | null, attachment?: string | null, document_type?: string | null, validity?: any | null, type?: string | null, share_with?: Array<{ __typename?: 'share_with', _id?: string | null, type?: string | null, employee?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null } | null> | null, children?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, isFile?: boolean | null, updated_at?: any | null } | null> | null, parent?: { __typename?: 'DocumentControlAttachment', isFile?: boolean | null, _id?: string | null, name?: string | null } | null, assign_to?: { __typename?: 'assignToType', type?: string | null, assignee?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null } | null } | null> | null };

export type GetDocumentControlAttachmentsByIdQueryVariables = Exact<{
  getDocumentControlAttachmentsByIdId: Scalars['ID']['input'];
}>;


export type GetDocumentControlAttachmentsByIdQuery = { __typename?: 'Query', getDocumentControlAttachmentsById?: { __typename?: 'DocumentControlAttachment', created_at?: any | null, is_owner?: boolean | null, google_drive_id?: string | null, activity_type?: Activity_Type | null, google_drive_attachment?: string | null, updated_at?: any | null, is_employee_main_folder?: boolean | null, is_default_document?: boolean | null, is_asset_main_folder?: boolean | null, is_employee_folder?: boolean | null, extension?: string | null, type?: string | null, share_as?: string | null, size?: number | null, _id?: string | null, deleted_at?: any | null, attachment?: string | null, name?: string | null, validity?: any | null, is_sign_required?: boolean | null, is_hide_after_review?: boolean | null, isFile?: boolean | null, document_type?: string | null, details?: { __typename?: 'DocumentControlAttachmentDetail', files?: number | null, folder?: number | null } | null, created_by?: { __typename?: 'User', full_name?: string | null } | null, share_with?: Array<{ __typename?: 'share_with', _id?: string | null, date?: any | null, share_as?: string | null, type?: string | null, shared_by?: { __typename?: 'User', full_name?: string | null } | null, department?: { __typename?: 'Department', department_name?: string | null } | null, role?: { __typename?: 'Role', roleName?: string | null } | null, employee?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null } | null> | null, deleted_by?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null, parent?: { __typename?: 'DocumentControlAttachment', name?: string | null, _id?: string | null, children?: Array<{ __typename?: 'DocumentControlAttachment', name?: string | null, _id?: string | null, size?: number | null, children?: Array<{ __typename?: 'DocumentControlAttachment', name?: string | null, _id?: string | null, size?: number | null } | null> | null } | null> | null } | null, children?: Array<{ __typename?: 'DocumentControlAttachment', name?: string | null, size?: number | null, _id?: string | null, children?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, size?: number | null } | null> | null } | null> | null, assign_to?: { __typename?: 'assignToType', type?: string | null, assignee?: Array<{ __typename?: 'User', id?: string | null, first_name?: string | null, full_name?: string | null } | null> | null, department?: { __typename?: 'Department', department_name?: string | null, _id?: string | null } | null, roles?: Array<{ __typename?: 'Role', roleName?: string | null, _id?: string | null } | null> | null } | null } | null };

export type GetemployeeRecentFileViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetemployeeRecentFileViewQuery = { __typename?: 'Query', getemployeeRecentFileView?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, attachment?: string | null, name?: string | null, extension?: string | null, document_type?: string | null, isFile?: boolean | null } | null> | null };

export type AddNewFolderDocumentControlMutationVariables = Exact<{
  input: AddNewFolderDocumentControl;
}>;


export type AddNewFolderDocumentControlMutation = { __typename?: 'Mutation', addNewFolderDocumentControl?: { __typename?: 'DocumentControlAttachment', _id?: string | null } | null };

export type CreateDocumentControlAttachmentMutationVariables = Exact<{
  input: AddDocumentInput;
}>;


export type CreateDocumentControlAttachmentMutation = { __typename?: 'Mutation', createDocumentControlAttachment?: { __typename?: 'DocumentControlAttachment', _id?: string | null, document_type?: string | null } | null };

export type RenameDocumentControlAttachmentMutationVariables = Exact<{
  renameDocumentControlAttachmentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameDocumentControlAttachmentMutation = { __typename?: 'Mutation', renameDocumentControlAttachment?: { __typename?: 'DocumentControlAttachment', _id?: string | null } | null };

export type ChangeLocationOfDocumentDeletedParentMutationVariables = Exact<{
  changeLocationOfDocumentDeletedParentId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  newParentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ChangeLocationOfDocumentDeletedParentMutation = { __typename?: 'Mutation', changeLocationOfDocumentDeletedParent?: boolean | null };

export type ChangeDocumentControlAttachmentFolderMutationVariables = Exact<{
  changeDocumentControlAttachmentFolderId: Scalars['ID']['input'];
  newParentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ChangeDocumentControlAttachmentFolderMutation = { __typename?: 'Mutation', changeDocumentControlAttachmentFolder?: boolean | null };

export type UploadDocumentControlAttachmentMutationVariables = Exact<{
  input: FileUploadDocumentControl;
}>;


export type UploadDocumentControlAttachmentMutation = { __typename?: 'Mutation', uploadDocumentControlAttachment?: { __typename?: 'DocumentControlAttachment', _id?: string | null } | null };

export type UploadFileDocumentControlAttachmentMutationVariables = Exact<{
  input: UploadFileDocumentControlAttachment;
}>;


export type UploadFileDocumentControlAttachmentMutation = { __typename?: 'Mutation', uploadFileDocumentControlAttachment?: { __typename?: 'DocumentControlAttachment', _id?: string | null, google_drive_id?: string | null, extension?: string | null } | null };

export type CopyDocumentControlAttachmentFolderMutationVariables = Exact<{
  copyDocumentControlAttachmentFolderId: Scalars['ID']['input'];
  newParentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CopyDocumentControlAttachmentFolderMutation = { __typename?: 'Mutation', copyDocumentControlAttachmentFolder?: boolean | null };

export type EmployeeRecentFileViewMutationVariables = Exact<{
  employeeRecentFileViewId: Scalars['ID']['input'];
}>;


export type EmployeeRecentFileViewMutation = { __typename?: 'Mutation', employeeRecentFileView?: boolean | null };

export type DownloadZipSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type DownloadZipSubscription = { __typename?: 'Subscription', downloadZip?: { __typename?: 'downloadZip', percent?: number | null } | null };

export type DeleteDocumentSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type DeleteDocumentSubscription = { __typename?: 'Subscription', deleteDocument?: { __typename?: 'deleteDocumentSubscribe', current?: string | null, parent?: string | null } | null };

export type UploadFileSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UploadFileSubscription = { __typename?: 'Subscription', uploadFile?: { __typename?: 'fileuploadsize', percent?: number | null } | null };

export type GetAllRequestedDocumentsQueryVariables = Exact<{
  input: InputDocumentsWithFilter;
}>;


export type GetAllRequestedDocumentsQuery = { __typename?: 'Query', getAllRequestedDocuments?: { __typename?: 'allDocumentListingResult', config?: { __typename?: 'dataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<string | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null, search?: string | null, is_search_able?: boolean | null, is_visible?: boolean | null, filterValue?: Array<string | null> | null, column_data?: Array<string | null> | null, query?: { __typename?: 'queryType', first_condition?: string | null, second_condition?: string | null, first_value?: string | null, second_value?: string | null, condition?: string | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'DocumentControlAttachmenttWithData', Doucuments?: { __typename?: 'DocumentControlAttachment', is_group?: boolean | null, activity_name?: string | null, name?: string | null, attachment?: string | null, responded?: number | null, not_responded?: number | null, validity?: any | null, _id?: string | null, employeeDocumentUpload?: Array<{ __typename?: 'employeeDocumentUpload', date?: string | null, fileRef?: string | null, status?: boolean | null, view?: number | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, assign_to?: { __typename?: 'assignToType', assignee?: Array<{ __typename?: 'User', full_name?: string | null, id?: string | null } | null> | null } | null } | null, detail?: { __typename?: 'documentDetail', columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, header?: string | null, field?: string | null } | null> | null, result?: Array<{ __typename?: 'uplaodDocument', fileRef?: string | null, status?: boolean | null, employee?: { __typename?: 'User', full_name?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type GetAllSendRequestDocumentsQueryVariables = Exact<{
  input: InputDocumentsWithFilter;
}>;


export type GetAllSendRequestDocumentsQuery = { __typename?: 'Query', getAllSendRequestDocuments?: { __typename?: 'allDocumentListingResult', countpendingRequest?: number | null, config?: { __typename?: 'dataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'DocumentControlAttachmenttWithData', Doucuments?: { __typename?: 'DocumentControlAttachment', activity_name?: string | null, signatureDeliveryOption?: string | null, receivedDocumentInMultipleAction?: string | null, status?: string | null, extension?: string | null, is_group?: boolean | null, message?: string | null, activity_type?: Activity_Type | null, name?: string | null, document_type?: string | null, _id?: string | null, attachment?: string | null, validity?: any | null, size?: number | null, created_at?: any | null, grouped_activities?: Array<{ __typename?: 'DocumentControlAttachment', signatureDeliveryOption?: string | null, receivedDocumentInMultipleAction?: string | null, status?: string | null, extension?: string | null, is_group?: boolean | null, message?: string | null, activity_type?: Activity_Type | null, name?: string | null, activity_name?: string | null, document_type?: string | null, _id?: string | null, attachment?: string | null, validity?: any | null, size?: number | null, created_at?: any | null, assign_to?: { __typename?: 'assignToType', assignee?: Array<{ __typename?: 'User', full_name?: string | null, id?: string | null } | null> | null } | null, employeeDocumentUpload?: Array<{ __typename?: 'employeeDocumentUpload', _id?: string | null, date?: string | null, fileRef?: string | null, status?: boolean | null, view?: number | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null, bread_crum?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, children?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null } | null> | null } | null> | null, created_by?: { __typename?: 'User', full_name?: string | null } | null } | null> | null, assign_to?: { __typename?: 'assignToType', assignee?: Array<{ __typename?: 'User', full_name?: string | null, id?: string | null } | null> | null } | null, employeeDocumentUpload?: Array<{ __typename?: 'employeeDocumentUpload', _id?: string | null, date?: string | null, fileRef?: string | null, status?: boolean | null, view?: number | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null, bread_crum?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, children?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null } | null> | null } | null> | null, created_by?: { __typename?: 'User', full_name?: string | null } | null } | null, detail?: { __typename?: 'documentDetail', result?: Array<{ __typename?: 'uplaodDocument', date?: any | null, fileRef?: string | null, status?: boolean | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type SubmitDocumentByEmployeeMutationVariables = Exact<{
  input?: InputMaybe<SubmitDocumentEmployeeInput>;
}>;


export type SubmitDocumentByEmployeeMutation = { __typename?: 'Mutation', submitDocumentByEmployee?: { __typename?: 'DocumentControlAttachment', _id?: string | null, attachment?: string | null, type?: string | null } | null };

export type UpdateEmployeeVeiwCountMutationVariables = Exact<{
  updateEmployeeVeiwCountId: Scalars['ID']['input'];
  employeeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateEmployeeVeiwCountMutation = { __typename?: 'Mutation', updateEmployeeVeiwCount?: boolean | null };

export type UpdateDocumentControlAttachmentAssigningMutationVariables = Exact<{
  input?: InputMaybe<UpdateDocumentInput>;
}>;


export type UpdateDocumentControlAttachmentAssigningMutation = { __typename?: 'Mutation', updateDocumentControlAttachmentAssigning?: { __typename?: 'DocumentControlAttachment', _id?: string | null } | null };

export type GetAllShareOfDocumentQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type GetAllShareOfDocumentQuery = { __typename?: 'Query', getAllShareOfDocument?: { __typename?: 'allShareDocumentResults', departments?: Array<{ __typename?: 'shareFilteredResults', share_as?: string | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, employees?: Array<{ __typename?: 'emloyeeSharePermission', share_as?: string | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, detail?: { __typename?: 'share_with', _id?: string | null } | null } | null> | null } | null> | null, roles?: Array<{ __typename?: 'shareFilteredResults', share_as?: string | null, role?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null, employees?: Array<{ __typename?: 'emloyeeSharePermission', share_as?: string | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, detail?: { __typename?: 'share_with', _id?: string | null } | null } | null> | null } | null> | null, employees?: Array<{ __typename?: 'shareFilteredResults', employees?: Array<{ __typename?: 'emloyeeSharePermission', share_as?: string | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, detail?: { __typename?: 'share_with', _id?: string | null } | null } | null> | null } | null> | null } | null };

export type ShareDocumentControlAttachmentMutationVariables = Exact<{
  input: EmailDocumentControlAttachment;
}>;


export type ShareDocumentControlAttachmentMutation = { __typename?: 'Mutation', shareDocumentControlAttachment?: boolean | null };

export type ChangeSharingStatusOrRemoveShareMutationVariables = Exact<{
  input?: InputMaybe<ChangeshareStatusInput>;
}>;


export type ChangeSharingStatusOrRemoveShareMutation = { __typename?: 'Mutation', changeSharingStatusOrRemoveShare?: boolean | null };

export type GetArchivedDocumentsQueryVariables = Exact<{
  input?: InputMaybe<ArchivedDocumentInput>;
}>;


export type GetArchivedDocumentsQuery = { __typename?: 'Query', getArchivedDocuments?: { __typename?: 'trashDocumentDataTableResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'DocumentControlAttachment', deleted_at?: any | null, type?: string | null, activity_type?: Activity_Type | null, created_at?: any | null, is_owner?: boolean | null, updated_at?: any | null, extension?: string | null, size?: number | null, _id?: string | null, attachment?: string | null, name?: string | null, validity?: any | null, is_sign_required?: boolean | null, is_hide_after_review?: boolean | null, isFile?: boolean | null, document_type?: string | null, deleted_by?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null, details?: { __typename?: 'DocumentControlAttachmentDetail', files?: number | null, folder?: number | null } | null, created_by?: { __typename?: 'User', full_name?: string | null } | null, share_with?: Array<{ __typename?: 'share_with', date?: any | null, employee?: { __typename?: 'User', employee_id?: string | null, id?: string | null, full_name?: string | null } | null } | null> | null, parent?: { __typename?: 'DocumentControlAttachment', name?: string | null, _id?: string | null, children?: Array<{ __typename?: 'DocumentControlAttachment', name?: string | null, _id?: string | null, size?: number | null, children?: Array<{ __typename?: 'DocumentControlAttachment', name?: string | null, _id?: string | null, size?: number | null } | null> | null } | null> | null } | null, children?: Array<{ __typename?: 'DocumentControlAttachment', name?: string | null, size?: number | null, _id?: string | null, children?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, size?: number | null } | null> | null } | null> | null, assign_to?: { __typename?: 'assignToType', type?: string | null, assignee?: Array<{ __typename?: 'User', id?: string | null, first_name?: string | null, full_name?: string | null } | null> | null, department?: { __typename?: 'Department', department_name?: string | null, _id?: string | null } | null, roles?: Array<{ __typename?: 'Role', roleName?: string | null, _id?: string | null } | null> | null } | null } | null> | null } | null };

export type ArchiveDocumentControlMutationVariables = Exact<{
  archiveDocumentControlId: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchiveDocumentControlMutation = { __typename?: 'Mutation', archiveDocumentControl?: { __typename?: 'archivedIds', DeletedParentDocument?: Array<string | null> | null, archived?: boolean | null } | null };

export type PermanentlyDeleteDocumentMutationVariables = Exact<{
  permanentlyDeleteDocumentId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PermanentlyDeleteDocumentMutation = { __typename?: 'Mutation', permanentlyDeleteDocument?: boolean | null };

export type SearchBusinessLocationQueryVariables = Exact<{
  input?: InputMaybe<BusinessLocationListFilter>;
}>;


export type SearchBusinessLocationQuery = { __typename?: 'Query', searchBusinessLocation?: { __typename?: 'buinsessLocationlistingResult', results?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null, created_at?: any | null, email?: string | null, phone?: string | null, status?: string | null, location_keeping_unit?: string | null, is_deleted?: boolean | null, franchiser_business?: { __typename?: 'Business', _id: string, business_system_name?: string | null } | null } | null> | null, config?: { __typename?: 'dataTableConfig', actions?: Array<string | null> | null, limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null } | null } | null };

export type BusinessLocationByIdQueryVariables = Exact<{
  businessLocationId: Scalars['ID']['input'];
}>;


export type BusinessLocationByIdQuery = { __typename?: 'Query', businessLocationById?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null, store_legal_name?: string | null, address_1?: string | null, address_2?: string | null, State?: string | null, city?: string | null, zip_code?: string | null, location_keeping_unit?: string | null, sales_tax?: number | null, email?: string | null, phone?: string | null, store_type?: string | null, identification_type?: string | null, identification_number?: string | null, time_zone?: string | null, store_logo?: string | null, logo?: string | null, duty_roaster?: boolean | null, status?: string | null, Country: { __typename?: 'Country', _id?: string | null, name?: string | null, short_name?: string | null }, package?: { __typename?: 'Package', _id?: string | null, package_name?: string | null, package_type?: string | null } | null, business_id: { __typename?: 'Business', _id: string, business_system_name?: string | null, business_type?: string | null }, franchiser_business?: { __typename?: 'Business', _id: string, business_system_name?: string | null } | null, region?: { __typename?: 'Region', _id?: string | null, region_name?: string | null } | null } | null };

export type GetTimeZoneQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeZoneQuery = { __typename?: 'Query', getTimeZone?: Array<{ __typename?: 'TimeZone', value?: string | null, offset?: string | null, text?: string | null } | null> | null };

export type GetAllBusinesseForFranchiseQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBusinesseForFranchiseQuery = { __typename?: 'Query', getAllBusinesseForFranchise?: Array<{ __typename?: 'Business', _id: string, business_legal_name?: string | null, business_system_name?: string | null } | null> | null };

export type ValidateBusinessAddStoreRequestQueryVariables = Exact<{
  business: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ValidateBusinessAddStoreRequestQuery = { __typename?: 'Query', validateBusinessAddStoreRequest?: number | null };

export type CreateBusinessLocationMutationVariables = Exact<{
  input: BusinessLocationInput;
}>;


export type CreateBusinessLocationMutation = { __typename?: 'Mutation', createBusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null } | null };

export type UpdateBusinessLocationMutationVariables = Exact<{
  updateBusinessLocationId: Scalars['ID']['input'];
  input: BusinessLocationInput;
}>;


export type UpdateBusinessLocationMutation = { __typename?: 'Mutation', updateBusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null } | null };

export type ArchiveBusinessLocationMutationVariables = Exact<{
  archiveBusinessLocationId?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchiveBusinessLocationMutation = { __typename?: 'Mutation', archiveBusinessLocation?: boolean | null };

export type RegionGetAllStateQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionGetAllStateQuery = { __typename?: 'Query', getAllState?: Array<{ __typename?: 'State', _id?: string | null, state_name?: string | null, short_name?: string | null } | null> | null };

export type RegionGetAllCityQueryVariables = Exact<{
  stateIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RegionGetAllCityQuery = { __typename?: 'Query', getAllCity?: Array<{ __typename?: 'City', _id?: string | null, city_name?: string | null, short_name?: string | null } | null> | null };

export type GetRegionWithSearchQueryVariables = Exact<{
  input?: InputMaybe<RegionInput>;
}>;


export type GetRegionWithSearchQuery = { __typename?: 'Query', getRegionWithSearch?: { __typename?: 'regionListingResult', config?: { __typename?: 'dataTableConfig', actions?: Array<string | null> | null, limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, is_visible?: boolean | null, type?: string | null } | null> | null } | null, results?: Array<{ __typename?: 'Region', _id?: string | null, region_name?: string | null, status?: string | null, is_deleted?: boolean | null, Country?: { __typename?: 'Country', _id?: string | null, name?: string | null } | null, State?: Array<{ __typename?: 'State', _id?: string | null, state_name?: string | null } | null> | null, City?: Array<{ __typename?: 'City', _id?: string | null, city_name?: string | null } | null> | null } | null> | null } | null };

export type GetRegionByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRegionByIdQuery = { __typename?: 'Query', getRegionById?: { __typename?: 'Region', _id?: string | null, region_name?: string | null, Country?: { __typename?: 'Country', _id?: string | null, name?: string | null } | null, State?: Array<{ __typename?: 'State', _id?: string | null, state_name?: string | null, short_name?: string | null } | null> | null, City?: Array<{ __typename?: 'City', _id?: string | null, city_name?: string | null, short_name?: string | null } | null> | null, BusinessLocation?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null, location_keeping_unit?: string | null } | null> | null } | null };

export type GetAllRegionsQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
}>;


export type GetAllRegionsQuery = { __typename?: 'Query', getAllRegions?: Array<{ __typename?: 'Region', _id?: string | null, region_name?: string | null } | null> | null };

export type RegionGetBusinessesByTypeQueryVariables = Exact<{
  businessTypes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RegionGetBusinessesByTypeQuery = { __typename?: 'Query', getBusinessesByType?: Array<{ __typename?: 'Business', _id: string, business_keeping_unit?: string | null, business_system_name?: string | null, business_type?: string | null } | null> | null };

export type RegionGetBusinessesLocationsQueryVariables = Exact<{
  businessIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RegionGetBusinessesLocationsQuery = { __typename?: 'Query', getBusinessesLocations?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null, location_keeping_unit?: string | null } | null> | null };

export type CreateRegionMutationVariables = Exact<{
  input: CreateRegionInput;
}>;


export type CreateRegionMutation = { __typename?: 'Mutation', createRegion?: { __typename?: 'Region', _id?: string | null } | null };

export type UpdateRegionMutationVariables = Exact<{
  input: UpdateRegionInput;
}>;


export type UpdateRegionMutation = { __typename?: 'Mutation', updateRegion?: { __typename?: 'Region', _id?: string | null } | null };

export type DeleteRegionMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  archive: Scalars['Boolean']['input'];
}>;


export type DeleteRegionMutation = { __typename?: 'Mutation', deleteRegion?: boolean | null };

export type SaleGoalGetListQueryVariables = Exact<{
  input?: InputMaybe<GoalsListFilter>;
}>;


export type SaleGoalGetListQuery = { __typename?: 'Query', getGoalList?: { __typename?: 'goalsListingresult', config?: { __typename?: 'dataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null } | null, results?: Array<{ __typename?: 'goals', _id?: string | null, goal_name?: string | null, goal_period?: GoalPeriod | null, goal_type?: GoalType | null, sales_target_value?: number | null, sales_target_incentive?: number | null, start_date?: any | null, status?: boolean | null, is_deleted?: boolean | null } | null> | null } | null };

export type SaleGoalGetByIdQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type SaleGoalGetByIdQuery = { __typename?: 'Query', getGoalById?: { __typename?: 'getGoals', _id?: string | null, goal_name?: string | null, business_type?: BusinessType | null, goal_period?: GoalPeriod | null, start_date?: any | null, count_no_by_goal_period?: number | null, sales_target_value?: number | null, sales_target_incentive?: number | null, is_percentage?: boolean | null, is_amount?: boolean | null, is_all_employee?: boolean | null, is_all_department?: boolean | null, goal_type?: GoalType | null, business?: { __typename?: 'Business', _id: string } | null, store?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, employees?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, target_by_products?: Array<{ __typename?: 'targetByProducts', product_category?: string | null, percentage?: string | null, amount?: string | null, status?: boolean | null } | null> | null, target_by_employees?: Array<{ __typename?: 'targetByEmployees', employee_name?: string | null, designation?: string | null, target?: string | null, status?: boolean | null } | null> | null, target_by_departments?: Array<{ __typename?: 'targetByDepartments', department_name?: string | null, target?: string | null, status?: boolean | null } | null> | null } | null };

export type SaleGoalGetBusinessesQueryVariables = Exact<{
  type?: InputMaybe<AllowBusinessType>;
}>;


export type SaleGoalGetBusinessesQuery = { __typename?: 'Query', getBusinessedByType?: Array<{ __typename?: 'Business', _id: string, business_system_name?: string | null } | null> | null };

export type SaleGoalGetStoresQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
}>;


export type SaleGoalGetStoresQuery = { __typename?: 'Query', getBusinessLocationsByBusinessId?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null> | null };

export type SaleGoalGetDepartmentsQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
  location_id: Scalars['ID']['input'];
}>;


export type SaleGoalGetDepartmentsQuery = { __typename?: 'Query', getDepartmentsByLocationID?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null };

export type SaleGoalGetEmployeesQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
  location_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaleGoalGetEmployeesQuery = { __typename?: 'Query', getEmployeesByLocationID?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null };

export type SaleGoalCreateMutationVariables = Exact<{
  input?: InputMaybe<GoalsInput>;
}>;


export type SaleGoalCreateMutation = { __typename?: 'Mutation', createGoal?: { __typename?: 'goals', _id?: string | null } | null };

export type SaleGoalUpdateMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input?: InputMaybe<GoalsInput>;
}>;


export type SaleGoalUpdateMutation = { __typename?: 'Mutation', updateGoal?: boolean | null };

export type SaleGoalDeleteMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaleGoalDeleteMutation = { __typename?: 'Mutation', deleteGoal?: boolean | null };

export type SaleGoalStatusChangeMutationVariables = Exact<{
  goal_id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaleGoalStatusChangeMutation = { __typename?: 'Mutation', goalStatusChanged?: boolean | null };

export type GetAttendanceRegulationApprovalsWithSearchQueryVariables = Exact<{
  input?: InputMaybe<AttendanceFilter>;
}>;


export type GetAttendanceRegulationApprovalsWithSearchQuery = { __typename?: 'Query', getAttendanceRegulationApprovalsWithSearch?: { __typename?: 'attendanceResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'AttendanceRegulation', _id?: string | null, attendance_date?: any | null, status?: string | null, is_deleted?: boolean | null, reason_type?: string | null, time_in?: string | null, time_out?: string | null, description?: string | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null } | null };

export type UpdateAttendanceRegulationApprovalMutationVariables = Exact<{
  input: UpdateRequestLevel;
}>;


export type UpdateAttendanceRegulationApprovalMutation = { __typename?: 'Mutation', updateAttendanceRegulationApproval?: boolean | null };

export type GetAttendanceRegulationByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAttendanceRegulationByIdQuery = { __typename?: 'Query', getAttendanceRegulationById?: { __typename?: 'AttendanceRegulation', _id?: string | null, attendance_date?: any | null, time_in?: string | null, time_out?: string | null, reason_type?: string | null, description?: string | null, status?: string | null, approval_description?: string | null, created_at?: any | null, updated_at?: any | null, approval_status?: string | null, business_manager?: { __typename?: 'User', _id?: string | null, full_name?: string | null, status?: string | null, id?: string | null } | null, behalf_of?: Array<{ __typename?: 'User', full_name?: string | null, _id?: string | null } | null> | null, employee?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, id?: string | null, _id?: string | null } | null, business?: { __typename?: 'Business', _id: string } | null, work_flow?: Array<{ __typename?: 'workFlow', approval_description?: string | null, status?: string | null, approved_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, _id?: string | null } | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null, id?: string | null } | null } | null> | null } | null };

export type GetDelegantApprovalQueryVariables = Exact<{
  approvalType: Scalars['String']['input'];
}>;


export type GetDelegantApprovalQuery = { __typename?: 'Query', getDelegantApproval?: { __typename?: 'DelegantApproval', approval_type?: WorkFlowTypeEnum | null, delegate_approvers?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null, original_approver?: { __typename?: 'User', full_name?: string | null } | null } | null };

export type AddDelegantEmployeeMutationVariables = Exact<{
  input: DelegantApprovalMutationInput;
}>;


export type AddDelegantEmployeeMutation = { __typename?: 'Mutation', addDelegantEmployee?: { __typename?: 'DelegantApproval', approval_type?: WorkFlowTypeEnum | null, delegate_approvers?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null, original_approver?: { __typename?: 'User', full_name?: string | null } | null } | null };

export type RemoveDelegantEmployeeMutationVariables = Exact<{
  input: DelegantApprovalMutationInput;
}>;


export type RemoveDelegantEmployeeMutation = { __typename?: 'Mutation', removeDelegantEmployee?: { __typename?: 'DelegantApproval', approval_type?: WorkFlowTypeEnum | null, original_approver?: { __typename?: 'User', full_name?: string | null } | null } | null };

export type GetExpenseApprovalsWithFiltersQueryVariables = Exact<{
  input?: InputMaybe<ExpenseRequestFilter>;
}>;


export type GetExpenseApprovalsWithFiltersQuery = { __typename?: 'Query', getExpenseApprovalsWithFilters?: { __typename?: 'expnseResultUpdate', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Expense', _id?: string | null, expense_type?: string | null, expense_total_amount?: number | null, expense_date?: any | null, description?: string | null, approval_description?: string | null, approval_status?: string | null, status?: string | null, is_deleted?: boolean | null, document_url?: string | null, created_at?: any | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, behalf_of?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null } | null> | null } | null };

export type UpdateExpenseApprovalMutationVariables = Exact<{
  input: InputUpdateExpenseApproval;
}>;


export type UpdateExpenseApprovalMutation = { __typename?: 'Mutation', updateExpenseApproval?: boolean | null };

export type GetTimeOffApprovalsWithSearchQueryVariables = Exact<{
  input?: InputMaybe<TimeOffListFilter>;
}>;


export type GetTimeOffApprovalsWithSearchQuery = { __typename?: 'Query', getTimeOffApprovalsWithSearch?: { __typename?: 'timeOffListingresult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'timeOff', is_short_leave?: boolean | null, _id?: string | null, is_deleted?: boolean | null, approval_status?: string | null, is_pto?: boolean | null, reason_for_leave?: string | null, total_leaves?: number | null, no_request?: number | null, created_at?: any | null, total_request_leaves?: number | null, total_unpaid_leaves?: number | null, remaining_unpaid_days?: number | null, request_id?: string | null, countIn?: string | null, remaining_days?: number | null, status?: TimeOffStatus | null, behalf_of?: Array<{ __typename?: 'User', full_name?: string | null, _id?: string | null } | null> | null, employee?: { __typename?: 'User', id?: string | null, email?: string | null, first_name?: string | null, middle_name?: string | null, last_name?: string | null, full_name?: string | null } | null, leave_request_dates?: Array<{ __typename?: 'dateObj', from_date?: any | null, to_date?: any | null } | null> | null, type_of_absence?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null, is_pto?: boolean | null, type?: string | null } | null } | null> | null } | null };

export type GetTimeOffByIdQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetTimeOffByIdQuery = { __typename?: 'Query', getTimeOffById?: { __typename?: 'timeOff', _id?: string | null, is_compansation_leave?: boolean | null, approval_status?: string | null, is_sandwich?: boolean | null, is_short_leave?: boolean | null, document_url?: string | null, reason_for_leave?: string | null, countIn?: string | null, total_leaves?: number | null, total_leave_out_of_accural?: number | null, total_unpaid_leaves?: number | null, remaining_unpaid_days?: number | null, remaining_days?: number | null, status?: TimeOffStatus | null, behalf_of?: Array<{ __typename?: 'User', full_name?: string | null, _id?: string | null } | null> | null, upload_document_info?: { __typename?: 'updloadDocumentInf', size?: string | null, extension?: string | null, name?: string | null } | null, sandwich?: Array<{ __typename?: 'sandWichDays', difference_in_days?: number | null, difference_in_hours?: number | null, date_of_sandwich?: Array<{ __typename?: 'dateOfSandwich', date?: any | null, day?: string | null } | null> | null } | null> | null, employee?: { __typename?: 'User', id?: string | null, _id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, time_off?: Array<{ __typename?: 'TimeOffType', time_off_category?: string | null, time_off_days?: string | null, time_off_type?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null } | null } | null> | null, pto_minutes?: { __typename?: 'PtoMinutesType', pto_earned_minutes?: number | null, pto_availed_minutes?: number | null } | null } | null, accept_reject_leave?: Array<{ __typename?: 'leaveInputType', leave_date?: any | null, start_time?: string | null, end_time?: string | null, leave_type?: string | null, from_date: any, to_date: any, no_of_days?: number | null, status?: string | null } | null> | null, work_flow?: Array<{ __typename?: 'workFlow', approval_description?: string | null, status?: string | null, action_date?: any | null, deleted_date?: any | null, approved_by?: { __typename?: 'User', id?: string | null, _id?: string | null, full_name?: string | null } | null, delegated_user?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null, employee?: { __typename?: 'User', full_name?: string | null, first_name?: string | null, last_name?: string | null, _id?: string | null } | null } | null> | null, type_of_absence?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null, count_after_days?: number | null, is_count_after?: boolean | null, is_not_count_as_leave?: boolean | null, is_pto?: boolean | null, maximum_duration?: string | null, half_leave_in_ful_leave?: boolean | null, un_paid_days?: string | null, type?: string | null, leave_duration?: LeaveDuration | null } | null, date_type_leave?: Array<{ __typename?: 'typeLeave', leave_date?: any | null, leave_type?: string | null } | null> | null, leave_request?: Array<{ __typename?: 'leaveInputType', totalMinuts?: number | null, start_time?: string | null, end_time?: string | null, leave_type?: string | null, is_sandwich?: boolean | null, from_date: any, to_date: any, no_of_days?: number | null, status?: string | null, out_of_accural_leave_days?: number | null, out_of_accural_leave_hours?: number | null } | null> | null } | null };

export type UpdateTimeOffApprovalMutationVariables = Exact<{
  input: UpdateLeaveRequest;
}>;


export type UpdateTimeOffApprovalMutation = { __typename?: 'Mutation', updateTimeOffApproval?: boolean | null };

export type DeleteTimeOffMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteTimeOffMutation = { __typename?: 'Mutation', deleteTimeOff?: boolean | null };

export type GetLoanApprovalsWithFiltersQueryVariables = Exact<{
  input?: InputMaybe<LoanRequestFilter>;
}>;


export type GetLoanApprovalsWithFiltersQuery = { __typename?: 'Query', getLoanApprovalsWithFilters?: { __typename?: 'loanResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'LoanPayment', _id?: string | null, loan_type?: string | null, loan_amount?: number | null, loan_taken_date?: any | null, no_of_installment?: number | null, installment_amount?: number | null, loan_recovery_method?: string | null, payment?: number | null, payment_start_date?: any | null, balance?: number | null, description?: string | null, approval_description?: string | null, approval_status?: string | null, status?: string | null, is_deleted?: boolean | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, updated_by?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null } | null };

export type UpdateLoanApprovalMutationVariables = Exact<{
  input: UpdateLoanRequest;
}>;


export type UpdateLoanApprovalMutation = { __typename?: 'Mutation', updateLoanApproval?: boolean | null };

export type GetAllAppraisalObjectiveQueryVariables = Exact<{
  input?: InputMaybe<InputAppraisalObjective>;
}>;


export type GetAllAppraisalObjectiveQuery = { __typename?: 'Query', getAllAppraisalObjective?: { __typename?: 'appraisalObjectiveResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'AppraisalObjecive', _id?: string | null, name?: string | null, description?: string | null, is_deleted?: boolean | null, AppraisalType?: { __typename?: 'AppraisalType', _id: string, name?: string | null } | null } | null> | null } | null };

export type GetAppraisalObjectiveByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAppraisalObjectiveByIdQuery = { __typename?: 'Query', getAppraisalObjectiveById?: { __typename?: 'AppraisalObjecive', _id?: string | null, name?: string | null, description?: string | null, weight_percent?: number | null, is_deleted?: boolean | null, AppraisalType?: { __typename?: 'AppraisalType', _id: string, name?: string | null, status?: string | null } | null } | null };

export type CreateAppraisalObjectiveMutationVariables = Exact<{
  input: CreateAppraisalObjecive;
}>;


export type CreateAppraisalObjectiveMutation = { __typename?: 'Mutation', createAppraisalObjective?: { __typename?: 'AppraisalObjecive', _id?: string | null, name?: string | null } | null };

export type UpdateAppraisalObjectiveMutationVariables = Exact<{
  input: UpdateAppraisalObjecive;
}>;


export type UpdateAppraisalObjectiveMutation = { __typename?: 'Mutation', updateAppraisalObjective?: { __typename?: 'AppraisalObjecive', _id?: string | null, name?: string | null } | null };

export type ArchiveAppraisalObjectiveMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveAppraisalObjectiveMutation = { __typename?: 'Mutation', archiveAppraisalObjective?: boolean | null };

export type GetAllActiveAppraisalTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActiveAppraisalTypeQuery = { __typename?: 'Query', getAllActiveAppraisalType?: Array<{ __typename?: 'AppraisalType', _id: string, name?: string | null, target_type?: TargetEnum | null } | null> | null };

export type GetAllAppraisalTypeQueryVariables = Exact<{
  input?: InputMaybe<InputAllAppraisalType>;
}>;


export type GetAllAppraisalTypeQuery = { __typename?: 'Query', getAllAppraisalType?: { __typename?: 'appraisalResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'AppraisalType', _id: string, name?: string | null, description?: string | null, target_type?: TargetEnum | null, status?: string | null, is_deleted?: boolean | null } | null> | null } | null };

export type GetAppraisalTypeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAppraisalTypeByIdQuery = { __typename?: 'Query', getAppraisalTypeById?: { __typename?: 'AppraisalType', _id: string, name?: string | null, description?: string | null, target_type?: TargetEnum | null, status?: string | null, is_deleted?: boolean | null } | null };

export type CreateAppraisalTypeMutationVariables = Exact<{
  input: InputAppraisalType;
}>;


export type CreateAppraisalTypeMutation = { __typename?: 'Mutation', createAppraisalType?: { __typename?: 'AppraisalType', _id: string, name?: string | null, target_type?: TargetEnum | null, description?: string | null, status?: string | null } | null };

export type UpdateAppraisalTypeMutationVariables = Exact<{
  input: UpdateAppraisalType;
}>;


export type UpdateAppraisalTypeMutation = { __typename?: 'Mutation', updateAppraisalType?: { __typename?: 'AppraisalType', _id: string, status?: string | null, description?: string | null, is_deleted?: boolean | null, target_type?: TargetEnum | null } | null };

export type DeleteAppraisalTypeMutationVariables = Exact<{
  deleteAppraisalTypeId: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type DeleteAppraisalTypeMutation = { __typename?: 'Mutation', deleteAppraisalType?: boolean | null };

export type GetAllEvaluationQueryVariables = Exact<{
  input?: InputMaybe<InputAllEvaluation>;
}>;


export type GetAllEvaluationQuery = { __typename?: 'Query', getAllEvaluation?: { __typename?: 'appraisalEvaluationResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'appraisalEvaluation', _id?: string | null, remark?: string | null, total_score?: number | null, status?: string | null, is_deleted?: boolean | null, User?: { __typename?: 'User', id?: string | null, full_name?: string | null, designation?: { __typename?: 'Designation', designation_name?: string | null } | null } | null, PerformanceCycle?: { __typename?: 'performanceCycleType', _id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetMyEvaluationQueryVariables = Exact<{
  input?: InputMaybe<InputAllEvaluation>;
}>;


export type GetMyEvaluationQuery = { __typename?: 'Query', getMyEvaluation?: { __typename?: 'appraisalEvaluationResult', config?: { __typename?: 'UpdatedDataTableConfig', page?: number | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'appraisalEvaluation', _id?: string | null, remark?: string | null, total_score?: number | null, status?: string | null, is_deleted?: boolean | null, User?: { __typename?: 'User', full_name?: string | null, designation?: { __typename?: 'Designation', designation_name?: string | null } | null } | null, PerformanceCycle?: { __typename?: 'performanceCycleType', name?: string | null, _id?: string | null } | null } | null> | null } | null };

export type GetEvaluationByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEvaluationByIdQuery = { __typename?: 'Query', getEvaluationById?: { __typename?: 'appraisalEvaluation', _id?: string | null, remark?: string | null, milestone?: string | null, listProjects?: string | null, road_map?: string | null, trainingRequired?: boolean | null, performanceGoals?: string | null, total_score?: number | null, status?: string | null, PerformanceCycle?: { __typename?: 'performanceCycleType', name?: string | null, status?: string | null, appraisal_setting?: Array<{ __typename?: 'appraisalSettingType', weight_percent?: number | null, AppraisalType?: { __typename?: 'AppraisalType', _id: string } | null } | null> | null } | null, objectiveAssigned?: Array<{ __typename?: 'objective_Assigned', _id?: string | null, total_weight?: number | null, AppraisalType?: { __typename?: 'AppraisalType', _id: string, name?: string | null, is_task?: boolean | null, is_punctuality?: boolean | null, totalHours?: number | null, total_hours_logged?: number | null, clockHistoryCount?: number | null } | null, objective?: Array<{ __typename?: 'objective', _id?: string | null, score?: number | null, target?: number | null, remark?: string | null, weight_percent?: number | null, AppraisalObjective?: { __typename?: 'AppraisalObjecive', _id?: string | null, name?: string | null } | null } | null> | null } | null> | null, User?: { __typename?: 'User', id?: string | null, full_name?: string | null, employee_id?: string | null, joining_date?: any | null, designation?: { __typename?: 'Designation', designation_name?: string | null } | null, department?: Array<{ __typename?: 'Department', department_name?: string | null } | null> | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null } | null> | null } | null, created_by?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null } | null };

export type UpdateEvaluationMutationVariables = Exact<{
  input?: InputMaybe<UpdateEvaluationInput>;
}>;


export type UpdateEvaluationMutation = { __typename?: 'Mutation', updateEvaluation?: { __typename?: 'appraisalEvaluation', remark?: string | null } | null };

export type UpdateObjectiveAssignmentMutationVariables = Exact<{
  input: UpdateInputObjectiveAssignment;
}>;


export type UpdateObjectiveAssignmentMutation = { __typename?: 'Mutation', updateObjectiveAssignment?: { __typename?: 'objectiveAssignment', _id?: string | null } | null };

export type GetAllGoalsListQueryVariables = Exact<{
  input?: InputMaybe<InputAllEvaluation>;
}>;


export type GetAllGoalsListQuery = { __typename?: 'Query', getAllGoalsList?: { __typename?: 'appraisalEvaluationResult', config?: { __typename?: 'UpdatedDataTableConfig', page?: number | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'appraisalEvaluation', _id?: string | null, start_date?: any | null, end_date?: any | null, status?: string | null, User?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, PerformanceCycle?: { __typename?: 'performanceCycleType', _id?: string | null, name?: string | null, start_date?: any | null, end_date?: any | null, status?: string | null } | null } | null> | null } | null };

export type GetGroupGoalsListQueryVariables = Exact<{
  input?: InputMaybe<InputAllEvaluation>;
}>;


export type GetGroupGoalsListQuery = { __typename?: 'Query', getGroupGoalsList?: { __typename?: 'grounpEvaluationListResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null, search?: string | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_search_able?: boolean | null, is_visible?: boolean | null, filterValue?: Array<string | null> | null, is_sortable?: boolean | null, column_data?: Array<string | null> | null, query?: { __typename?: 'queryType', first_condition?: string | null, second_condition?: string | null, first_value?: string | null, second_value?: string | null, condition?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', search?: string | null, field?: string | null, type?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', activeFilters?: boolean | null, id?: string | null, is_default?: boolean | null, is_temp?: boolean | null, loadingCall?: boolean | null, name?: string | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', width?: number | null, type?: string | null, search?: string | null, _id?: string | null, column_data?: Array<string | null> | null, field?: string | null, filterValue?: Array<string | null> | null, header?: string | null, is_amount?: boolean | null, is_groupable?: boolean | null, is_unique?: boolean | null, is_required?: boolean | null, is_editable?: boolean | null, validateFn?: string | null, is_search_able?: boolean | null, is_sortable?: boolean | null, is_visible?: boolean | null, pinned?: string | null, query?: { __typename?: 'queryType', condition?: string | null, first_condition?: string | null, first_value?: string | null, second_condition?: string | null, second_value?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null, rowShadingEnabled?: boolean | null } | null, filters?: Array<{ __typename?: 'listingFiltersType', _ids?: Array<string | null> | null, field?: string | null, search?: string | null, type?: string | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_condition?: string | null, first_value?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null } | null> | null } | null, results?: Array<{ __typename?: 'groupGoalsListType', _id?: string | null, end_date?: any | null, start_date?: any | null, name?: string | null, status?: string | null, employees_count?: number | null, detail?: { __typename?: 'employeeDetail', actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, is_amount?: boolean | null } | null> | null, result?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, employee_id?: string | null } | null> | null } | null } | null> | null } | null };

export type GetReportObjectiveAssigmentQueryVariables = Exact<{
  input?: InputMaybe<InputGetReportObjective>;
}>;


export type GetReportObjectiveAssigmentQuery = { __typename?: 'Query', getReportObjectiveAssigment?: { __typename?: 'reportObjectiveAssignment1', results?: Array<{ __typename?: 'reportObjectiveAssignment_', _id?: string | null, start_date?: any | null, end_date?: any | null, PerformanceCycle?: { __typename?: 'performanceCycleType', name?: string | null } | null, User?: { __typename?: 'User', full_name?: string | null, department?: Array<{ __typename?: 'Department', department_name?: string | null } | null> | null } | null, detail?: { __typename?: 'detailextendedView', columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, header?: string | null, field?: string | null } | null> | null, result?: Array<{ __typename?: 'detail_result', _id?: string | null, score?: number | null, target?: number | null, weight_percent?: number | null, AppraisalType?: { __typename?: 'AppraisalType', name?: string | null } | null, appraisers?: Array<{ __typename?: 'User', full_name?: string | null, designation?: { __typename?: 'Designation', designation_name?: string | null } | null } | null> | null, appraisal?: { __typename?: 'User', full_name?: string | null } | null, AppraisalObjective?: { __typename?: 'AppraisalObjecive', description?: string | null, name?: string | null } | null } | null> | null } | null } | null> | null, config?: { __typename?: 'dataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null, search?: string | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_search_able?: boolean | null, is_visible?: boolean | null, filterValue?: Array<string | null> | null, is_sortable?: boolean | null, column_data?: Array<string | null> | null, query?: { __typename?: 'queryType', first_condition?: string | null, second_condition?: string | null, first_value?: string | null, second_value?: string | null, condition?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', search?: string | null, field?: string | null, type?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', activeFilters?: boolean | null, id?: string | null, is_default?: boolean | null, is_temp?: boolean | null, loadingCall?: boolean | null, name?: string | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', width?: number | null, type?: string | null, search?: string | null, _id?: string | null, column_data?: Array<string | null> | null, field?: string | null, filterValue?: Array<string | null> | null, header?: string | null, is_amount?: boolean | null, is_groupable?: boolean | null, is_unique?: boolean | null, is_required?: boolean | null, is_editable?: boolean | null, validateFn?: string | null, is_search_able?: boolean | null, is_sortable?: boolean | null, is_visible?: boolean | null, pinned?: string | null, query?: { __typename?: 'queryType', condition?: string | null, first_condition?: string | null, first_value?: string | null, second_condition?: string | null, second_value?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null, rowShadingEnabled?: boolean | null } | null, filters?: Array<{ __typename?: 'listingFiltersType', _ids?: Array<string | null> | null, field?: string | null, search?: string | null, type?: string | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_condition?: string | null, first_value?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null } | null> | null } | null } | null };

export type GetReviewcyclereportQueryVariables = Exact<{
  input?: InputMaybe<InputReviewcyclereport>;
}>;


export type GetReviewcyclereportQuery = { __typename?: 'Query', getReviewcyclereport?: { __typename?: 'appraisalEvaluationResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null, search?: string | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_search_able?: boolean | null, is_visible?: boolean | null, filterValue?: Array<string | null> | null, is_sortable?: boolean | null, column_data?: Array<string | null> | null, query?: { __typename?: 'queryType', first_condition?: string | null, second_condition?: string | null, first_value?: string | null, second_value?: string | null, condition?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', search?: string | null, field?: string | null, type?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', activeFilters?: boolean | null, id?: string | null, is_default?: boolean | null, is_temp?: boolean | null, loadingCall?: boolean | null, name?: string | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', width?: number | null, type?: string | null, search?: string | null, _id?: string | null, column_data?: Array<string | null> | null, field?: string | null, filterValue?: Array<string | null> | null, header?: string | null, is_amount?: boolean | null, is_groupable?: boolean | null, is_unique?: boolean | null, is_required?: boolean | null, is_editable?: boolean | null, validateFn?: string | null, is_search_able?: boolean | null, is_sortable?: boolean | null, is_visible?: boolean | null, pinned?: string | null, query?: { __typename?: 'queryType', condition?: string | null, first_condition?: string | null, first_value?: string | null, second_condition?: string | null, second_value?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null, rowShadingEnabled?: boolean | null } | null, filters?: Array<{ __typename?: 'listingFiltersType', _ids?: Array<string | null> | null, field?: string | null, search?: string | null, type?: string | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_condition?: string | null, first_value?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null } | null> | null } | null, results?: Array<{ __typename?: 'appraisalEvaluation', _id?: string | null, start_date?: any | null, end_date?: any | null, total_score?: number | null, status?: string | null, User?: { __typename?: 'User', employee_id?: string | null, full_name?: string | null } | null, PerformanceCycle?: { __typename?: 'performanceCycleType', _id?: string | null, name?: string | null, start_date?: any | null, end_date?: any | null } | null } | null> | null } | null };

export type GetPerformanceCycleListQueryVariables = Exact<{
  input?: InputMaybe<InputPerformanceCycleType>;
}>;


export type GetPerformanceCycleListQuery = { __typename?: 'Query', getPerformanceCycleList?: { __typename?: 'performanceCycleResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'performanceCycleType', _id?: string | null, end_date?: any | null, is_all?: boolean | null, is_deleted?: boolean | null, is_linear_flow?: boolean | null, name?: string | null, start_date?: any | null, status?: string | null, description?: string | null, actions?: Array<string | null> | null, employees?: Array<{ __typename?: 'User', full_name?: string | null, email?: string | null, id?: string | null } | null> | null, appraisal_setting?: Array<{ __typename?: 'appraisalSettingType', weight_percent?: number | null, objective?: number | null, AppraisalScale?: { __typename?: 'appraisalScale', _id?: string | null, created_by?: { __typename?: 'User', full_name?: string | null, id?: string | null, email?: string | null } | null } | null, AppraisalType?: { __typename?: 'AppraisalType', _id: string, is_task?: boolean | null, is_punctuality?: boolean | null, is_deleted?: boolean | null, name?: string | null, status?: string | null, target_type?: TargetEnum | null, totalHours?: number | null, description?: string | null, clockHistoryCount?: number | null } | null, assign_by?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, task?: Array<{ __typename?: 'taskType', count?: number | null, status?: string | null } | null> | null } | null> | null, appraiser_setting?: Array<{ __typename?: 'appraiserSettingType', appraiser_type?: string | null, weight_percent?: number | null, AppraisalType?: Array<{ __typename?: 'AppraisalType', _id: string, description?: string | null, is_deleted?: boolean | null, is_punctuality?: boolean | null, is_task?: boolean | null, name?: string | null, status?: string | null, target_type?: TargetEnum | null, totalHours?: number | null, clockHistoryCount?: number | null } | null> | null, User?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null } | null> | null } | null };

export type GetPerformanceCycleByIdQueryVariables = Exact<{
  getPerformanceCycleByIdId: Scalars['ID']['input'];
}>;


export type GetPerformanceCycleByIdQuery = { __typename?: 'Query', getPerformanceCycleById?: { __typename?: 'performanceCycleType', status?: string | null, start_date?: any | null, assigning_start_date?: any | null, name?: string | null, is_linear_flow?: boolean | null, is_deleted?: boolean | null, is_all?: boolean | null, end_date?: any | null, description?: string | null, _id?: string | null, appraisal_setting?: Array<{ __typename?: 'appraisalSettingType', weight_percent?: number | null, objective?: number | null, assign_by?: { __typename?: 'User', first_name?: string | null, full_name?: string | null, id?: string | null, last_name?: string | null } | null, AppraisalType?: { __typename?: 'AppraisalType', _id: string, name?: string | null, target_type?: TargetEnum | null } | null, AppraisalScale?: { __typename?: 'appraisalScale', _id?: string | null, name?: string | null } | null } | null> | null, employees?: Array<{ __typename?: 'User', id?: string | null, first_name?: string | null, full_name?: string | null, last_name?: string | null } | null> | null, Department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, Role?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null, appraiser_setting?: Array<{ __typename?: 'appraiserSettingType', weight_percent?: number | null, appraiser_type?: string | null, User?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null } | null, AppraisalType?: Array<{ __typename?: 'AppraisalType', _id: string, name?: string | null } | null> | null } | null> | null } | null };

export type GetAppraisalObejctiveByPerformanceCycleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAppraisalObejctiveByPerformanceCycleQuery = { __typename?: 'Query', getAppraisalObejctiveByPerformanceCycle?: Array<{ __typename?: 'AppraisalObjecive', _id?: string | null, name?: string | null, weight_percent?: number | null, AppraisalType?: { __typename?: 'AppraisalType', _id: string, name?: string | null } | null } | null> | null };

export type CreatePerformanceCycleMutationVariables = Exact<{
  input?: InputMaybe<PerformanceCycleInput>;
}>;


export type CreatePerformanceCycleMutation = { __typename?: 'Mutation', createPerformanceCycle?: { __typename?: 'performanceCycleType', _id?: string | null } | null };

export type UpdatePerformanceCycleMutationVariables = Exact<{
  input?: InputMaybe<UpdatePerformanceCycleInput>;
}>;


export type UpdatePerformanceCycleMutation = { __typename?: 'Mutation', updatePerformanceCycle?: boolean | null };

export type UpdatePerformanceCycleStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdatePerformanceCycleStatusInput>;
}>;


export type UpdatePerformanceCycleStatusMutation = { __typename?: 'Mutation', updatePerformanceCycleStatus?: boolean | null };

export type ArchivePerformanceCycleMutationVariables = Exact<{
  archive: Scalars['Boolean']['input'];
  deletePerformanceCycleId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ArchivePerformanceCycleMutation = { __typename?: 'Mutation', deletePerformanceCycle?: boolean | null };

export type GetCustomGradeScaleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomGradeScaleQuery = { __typename?: 'Query', getCustomGradeScale?: Array<{ __typename?: 'appraisalScale', name?: string | null, _id?: string | null, is_deleted?: boolean | null } | null> | null };

export type GetObjectiveAssignmentByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetObjectiveAssignmentByIdQuery = { __typename?: 'Query', getObjectiveAssignmentById?: { __typename?: 'objectiveAssignments', _id?: string | null, PerformanceCycle?: { __typename?: 'performanceCycleType', appraisal_setting?: Array<{ __typename?: 'appraisalSettingType', objective?: number | null, weight_percent?: number | null, AppraisalType?: { __typename?: 'AppraisalType', _id: string, name?: string | null, is_task?: boolean | null, is_punctuality?: boolean | null, totalHours?: number | null } | null } | null> | null } | null, objectiveAssigned?: Array<{ __typename?: 'objective_Assigned', _id?: string | null, AppraisalType?: { __typename?: 'AppraisalType', _id: string, name?: string | null, is_task?: boolean | null, is_punctuality?: boolean | null, totalHours?: number | null } | null, objective?: Array<{ __typename?: 'objective', _id?: string | null, remark?: string | null, target?: number | null, weight_percent?: number | null, AppraisalObjective?: { __typename?: 'AppraisalObjecive', _id?: string | null, name?: string | null } | null } | null> | null } | null> | null } | null };

export type GetAllObjectiveAssignmentQueryVariables = Exact<{
  input?: InputMaybe<InputAllobjectiveAssignment>;
}>;


export type GetAllObjectiveAssignmentQuery = { __typename?: 'Query', getAllObjectiveAssignment?: { __typename?: 'objectiveAssignmentResult', results?: Array<{ __typename?: 'objectiveAssignment', _id?: string | null, start_date?: any | null, end_date?: any | null, status?: string | null, User?: { __typename?: 'User', id?: string | null, full_name?: string | null, designation?: { __typename?: 'Designation', designation_name?: string | null, _id?: string | null } | null } | null, PerformanceCycle?: { __typename?: 'performanceCycleType', name?: string | null, _id?: string | null } | null, linearFlow?: Array<{ __typename?: 'linearFlowItem', level?: number | null, User?: string | null, objectiveStatus?: string | null, status?: string | null } | null> | null, objectiveAssigned?: Array<{ __typename?: 'objective_Assigned', total_weight?: number | null, total_target?: number | null, total_score?: number | null, total?: number | null, AppraisalType?: { __typename?: 'AppraisalType', totalHours?: number | null, target_type?: TargetEnum | null, status?: string | null, name?: string | null, is_task?: boolean | null, is_punctuality?: boolean | null, is_deleted?: boolean | null, description?: string | null, clockHistoryCount?: number | null, _id: string } | null, task?: Array<{ __typename?: 'taskType', status?: string | null, count?: number | null } | null> | null, objective?: Array<{ __typename?: 'objective', _id?: string | null, remark?: string | null, score?: number | null, target?: number | null, weight_percent?: number | null, AppraisalObjective?: { __typename?: 'AppraisalObjecive', weight_percent?: number | null, name?: string | null, is_deleted?: boolean | null, description?: string | null, _id?: string | null, AppraisalType?: { __typename?: 'AppraisalType', totalHours?: number | null, target_type?: TargetEnum | null, status?: string | null, name?: string | null, is_task?: boolean | null, is_punctuality?: boolean | null, is_deleted?: boolean | null, description?: string | null, clockHistoryCount?: number | null, _id: string } | null } | null } | null> | null } | null> | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type GetGoalsForExtendedViewQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  performanceCycleId: Scalars['ID']['input'];
}>;


export type GetGoalsForExtendedViewQuery = { __typename?: 'Query', getGoalsForExtendedView?: Array<{ __typename?: 'appraisalEvaluation', _id?: string | null, weight_percent?: number | null, remark?: string | null, milestone?: string | null, listProjects?: string | null, road_map?: string | null, trainingRequired?: boolean | null, performanceGoals?: string | null, total_score?: number | null, created_by?: { __typename?: 'User', full_name?: string | null, id?: string | null, _id?: string | null } | null, objectiveAssigned?: Array<{ __typename?: 'objective_Assigned', _id?: string | null, AppraisalType?: { __typename?: 'AppraisalType', _id: string, name?: string | null, is_task?: boolean | null, is_punctuality?: boolean | null, clockHistoryCount?: number | null, totalHours?: number | null } | null, objective?: Array<{ __typename?: 'objective', _id?: string | null, score?: number | null, target?: number | null, remark?: string | null, weight_percent?: number | null, AppraisalObjective?: { __typename?: 'AppraisalObjecive', _id?: string | null, name?: string | null } | null } | null> | null } | null> | null, User?: { __typename?: 'User', id?: string | null, logo?: string | null, full_name?: string | null, employee_id?: string | null, joining_date?: any | null, department?: Array<{ __typename?: 'Department', department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', designation_name?: string | null } | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null } | null> | null } | null, assignTo?: { __typename?: 'User', id?: string | null, full_name?: string | null, employee_id?: string | null, joining_date?: any | null, department?: Array<{ __typename?: 'Department', department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', designation_name?: string | null } | null } | null, PerformanceCycle?: { __typename?: 'performanceCycleType', name?: string | null, appraisal_setting?: Array<{ __typename?: 'appraisalSettingType', weight_percent?: number | null, AppraisalType?: { __typename?: 'AppraisalType', _id: string, name?: string | null } | null } | null> | null } | null } | null> | null };

export type SendEmployeeEvaluationEmailMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<EvaluationEmailInput>> | InputMaybe<EvaluationEmailInput>>;
}>;


export type SendEmployeeEvaluationEmailMutation = { __typename?: 'Mutation', sendEmployeeEvaluationEmail?: boolean | null };

export type GetAllActiveAndInActiveEmployeesQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
  feature?: InputMaybe<FeatureEnum>;
}>;


export type GetAllActiveAndInActiveEmployeesQuery = { __typename?: 'Query', getAllActiveAndInActiveEmployees?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, email?: string | null, employee_id?: string | null } | null> | null };

export type GetUserByRolePermissionsQueryVariables = Exact<{
  featureName: Scalars['String']['input'];
}>;


export type GetUserByRolePermissionsQuery = { __typename?: 'Query', getUserByRolePermissions?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null };

export type GetAllAppraisalScalesQueryVariables = Exact<{
  input?: InputMaybe<InputAppraisalScales>;
}>;


export type GetAllAppraisalScalesQuery = { __typename?: 'Query', getAllAppraisalScales?: { __typename?: 'appraisalScaleResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'appraisalScale', _id?: string | null, name?: string | null, total_score?: number | null, is_custom_grade?: boolean | null, is_deleted?: boolean | null, scale_group?: Array<{ __typename?: 'scaleGroup', maximum_value?: number | null, minimum_value?: number | null, scroe_name?: string | null } | null> | null } | null> | null } | null };

export type GetAppraisalScaleByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAppraisalScaleByIdQuery = { __typename?: 'Query', getAppraisalScaleById?: { __typename?: 'appraisalScale', _id?: string | null, name?: string | null, is_custom_grade?: boolean | null, total_score?: number | null, scale_group?: Array<{ __typename?: 'scaleGroup', maximum_value?: number | null, minimum_value?: number | null, scroe_name?: string | null } | null> | null } | null };

export type CreateAppraisalScaleMutationVariables = Exact<{
  input: AddAppraisalScale;
}>;


export type CreateAppraisalScaleMutation = { __typename?: 'Mutation', createAppraisalScale?: { __typename?: 'appraisalScale', _id?: string | null, name?: string | null, is_deleted?: boolean | null, is_custom_grade?: boolean | null, total_score?: number | null } | null };

export type UpdateAppraisalScaleMutationVariables = Exact<{
  input?: InputMaybe<UpdateInputAppraisaleScale>;
}>;


export type UpdateAppraisalScaleMutation = { __typename?: 'Mutation', updateAppraisalScale?: { __typename?: 'appraisalScale', _id?: string | null, is_deleted?: boolean | null, name?: string | null } | null };

export type ArchiveAppraisalScaleMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveAppraisalScaleMutation = { __typename?: 'Mutation', archiveAppraisalScale?: boolean | null };

export type GetUserConnectedAppListQueryVariables = Exact<{
  input: QueryInputTerminalAppDevice;
}>;


export type GetUserConnectedAppListQuery = { __typename?: 'Query', getUserConnectedAppList?: { __typename?: 'userAppDeviceList', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'userAppDevice', _id?: string | null, is_allow_attendance?: boolean | null, latitude?: string | null, longitude?: string | null, User?: { __typename?: 'User', full_name?: string | null, email?: string | null, employee_id?: string | null, _id?: string | null } | null } | null> | null } | null };

export type GetUserAppDeviceListQueryVariables = Exact<{
  input: QueryInputUserAppDevice;
}>;


export type GetUserAppDeviceListQuery = { __typename?: 'Query', getUserAppDeviceList?: { __typename?: 'userAppDeviceList', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'userAppDevice', _id?: string | null, terminal_name?: string | null, device_model?: string | null, device_name?: string | null, device_manufacturer?: string | null, device_id?: string | null, longitude?: string | null, latitude?: string | null, app_type?: string | null, is_allow_attendance?: boolean | null, User?: { __typename?: 'User', full_name?: string | null, email?: string | null, _id?: string | null } | null } | null> | null } | null };

export type GetUserAppDevicesQueryVariables = Exact<{
  appType: AppTypes;
}>;


export type GetUserAppDevicesQuery = { __typename?: 'Query', getUserAppDevices?: Array<{ __typename?: 'userAppDevice', _id?: string | null, device_model?: string | null, device_manufacturer?: string | null, device_name?: string | null, longitude?: string | null, latitude?: string | null, User?: { __typename?: 'User', id?: string | null, full_name?: string | null, email?: string | null, logo?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null } | null> | null } | null } | null> | null };

export type GetUserAppDeviceCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAppDeviceCountQuery = { __typename?: 'Query', getUserAppDeviceCount?: { __typename?: 'userAppDeviceCount', allowAttendanceCount?: number | null, linked_device_count?: number | null, notAllowAttendanceCount?: number | null, terminal_app_device_count?: number | null, unlinked_device_count?: number | null, user_app_device_count?: number | null } | null };

export type GetAuthentictorsEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthentictorsEmployeesQuery = { __typename?: 'Query', getAuthentictorsEmployees?: { __typename?: 'authenticorResult', authentictorsEmployees?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, logo?: string | null, employee_id?: string | null, allow_sms?: boolean | null, allow_qr_code?: boolean | null, allow_email?: boolean | null } | null> | null, unAuthentictorsEmployees?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, logo?: string | null, employee_id?: string | null } | null> | null } | null };

export type GetTerminalAppHistoryQueryVariables = Exact<{
  input?: InputMaybe<InputTerminalAppHistory>;
}>;


export type GetTerminalAppHistoryQuery = { __typename?: 'Query', getTerminalAppHistory?: { __typename?: 'TerminalAppHistoryResult', results?: Array<{ __typename?: 'TerminalAppHistory', device_id?: string | null, is_deleted?: boolean | null, latitude?: number | null, longitude?: number | null, time?: string | null, action_date?: any | null, action?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, id?: string | null, employee_id?: string | null } | null, UserAppDevice?: { __typename?: 'userAppDevice', status?: string | null } | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, totalResults?: number | null, totalPages?: number | null, page?: number | null, limit?: number | null, filters?: Array<{ __typename?: 'listingFiltersType', search?: string | null, field?: string | null, type?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null } | null } | null };

export type GetDeviceInfoByIdQueryVariables = Exact<{
  input?: InputMaybe<InputDeviceInfoById>;
}>;


export type GetDeviceInfoByIdQuery = { __typename?: 'Query', getDeviceInfoById?: { __typename?: 'TerminalAppHistoryResult', results?: Array<{ __typename?: 'TerminalAppHistory', _id?: string | null, action?: string | null, action_date?: any | null, app_type?: string | null, device_id?: string | null, is_deleted?: boolean | null, latitude?: number | null, longitude?: number | null, User?: { __typename?: 'User', full_name?: string | null } | null, UserAppDevice?: { __typename?: 'userAppDevice', device_id?: string | null, device_manufacturer?: string | null, device_model?: string | null, device_name?: string | null, latitude?: string | null, longitude?: string | null } | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, totalResults?: number | null, totalPages?: number | null, page?: number | null, limit?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, is_search_able?: boolean | null, type?: string | null, search?: string | null, is_visible?: boolean | null, query?: { __typename?: 'queryType', first_condition?: string | null, second_condition?: string | null, first_value?: string | null, second_value?: string | null, condition?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null } | null } | null };

export type AllowAttendanceMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  isAllow: Scalars['Boolean']['input'];
}>;


export type AllowAttendanceMutation = { __typename?: 'Mutation', allowAttendance?: boolean | null };

export type UnlinkUserAppDeviceMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type UnlinkUserAppDeviceMutation = { __typename?: 'Mutation', unlinkUserAppDevice?: boolean | null };

export type SetEmployeeAuthenticatedMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  allowEmail?: InputMaybe<Scalars['Boolean']['input']>;
  allowSms?: InputMaybe<Scalars['Boolean']['input']>;
  allowQrCode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetEmployeeAuthenticatedMutation = { __typename?: 'Mutation', setEmployeeAuthenticated?: boolean | null };

export type SetEmployeeUnAuthenticatedMutationVariables = Exact<{
  empId: Scalars['ID']['input'];
}>;


export type SetEmployeeUnAuthenticatedMutation = { __typename?: 'Mutation', setEmployeeUnAuthenticated?: boolean | null };

export type AddUserRadiusMutationVariables = Exact<{
  radius?: InputMaybe<Scalars['Float']['input']>;
  timeInterval?: InputMaybe<Scalars['Float']['input']>;
}>;


export type AddUserRadiusMutation = { __typename?: 'Mutation', addUserRadius?: { __typename?: 'businessRadius', radius?: number | null } | null };

export type GetZipCodeWithFilterQueryVariables = Exact<{
  input?: InputMaybe<ZipCodeFilterInput>;
}>;


export type GetZipCodeWithFilterQuery = { __typename?: 'Query', getZipCodeWithFilter?: Array<{ __typename?: 'ZipCode', _id?: string | null, zipcode?: string | null, city_name?: string | null, state_name?: string | null, country_name?: string | null, City?: { __typename?: 'City', _id?: string | null } | null, State?: { __typename?: 'State', _id?: string | null } | null, Country?: { __typename?: 'Country', _id?: string | null } | null } | null> | null };

export type GetAllEmployeesQueryVariables = Exact<{
  input?: InputMaybe<EmployeeListFilter>;
}>;


export type GetAllEmployeesQuery = { __typename?: 'Query', getEmployeesWithSearch?: { __typename?: 'employeeListingResultNew', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'User', id?: string | null, logo?: string | null, is_deleted?: boolean | null, employee_id?: string | null, full_name?: string | null, email?: string | null, basic_salary?: string | null, pay_schedule_salary?: number | null, over_time_rate?: number | null, phone?: string | null, gender?: string | null, birth_date?: any | null, employee_type?: string | null, salary_payment_method?: string | null, salary_type?: string | null, account_status?: string | null, joining_date?: any | null, auth_pin?: string | null, user_keeping_unit?: string | null, pay_type?: string | null, total_week_hours?: number | null, new_salary_effect_from?: any | null, final_settlement_completed?: boolean | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, state?: { __typename?: 'State', _id?: string | null, state_name?: string | null } | null, Country?: { __typename?: 'Country', _id?: string | null, name?: string | null } | null, city?: { __typename?: 'City', _id?: string | null, city_name?: string | null } | null, pay_schedule?: { __typename?: 'PayrollSchedule', pay_period?: string | null } | null, shift?: { __typename?: 'Shift', _id?: string | null, shift_name: string } | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null, line_manager?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, employee_group?: { __typename?: 'attandencePolicy', _id?: string | null, group_name?: string | null, pay_type?: { __typename?: 'PayrollSchedule', _id?: string | null, schedule_name?: string | null } | null } | null } | null> | null } | null };

export type GetEmployeeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEmployeeByIdQuery = { __typename?: 'Query', getEmployeeByID?: { __typename?: 'User', id?: string | null, email?: string | null, final_settlement_completed?: boolean | null, is_generate_joining_letter?: boolean | null, last_working_date?: any | null, sepration_description?: string | null, final_settlement_date?: any | null, probation_period?: string | null, is_customzied_overtime?: boolean | null, ssn_last_four_digit?: string | null, employee_id?: string | null, first_name?: string | null, over_time_rate?: number | null, middle_name?: string | null, last_name?: string | null, full_name?: string | null, phone?: string | null, phone_country_code?: string | null, landline?: string | null, avatar_location?: string | null, home_no?: string | null, mobile_no_to_send_sms?: string | null, status?: string | null, badge_code?: string | null, is_password_set?: boolean | null, is_business_owner_requested_new_password?: boolean | null, vehicle_type?: string | null, vehicle_no?: string | null, license_no?: string | null, address_1?: string | null, address_2?: string | null, zipcode?: string | null, user_keeping_unit?: string | null, salaryHour?: number | null, is_deleted?: boolean | null, created_at?: any | null, is_clocked_in?: boolean | null, isOwner?: boolean | null, is_email_verify?: boolean | null, is_phone_verify?: boolean | null, preffered_name?: string | null, gender?: string | null, birth_date?: any | null, marital_status?: string | null, mobile_no?: string | null, work_no?: string | null, extra_no?: string | null, personal_email?: string | null, nationality?: string | null, passport_number?: string | null, logo?: string | null, user_name?: string | null, work_email?: string | null, auth_pin?: string | null, account_status?: string | null, send_sales_order_email?: string | null, account_representive_code?: string | null, send_order_email_to_parent?: string | null, custom_user?: string | null, associated_customer?: string | null, hire_date?: any | null, joining_date?: any | null, employee_type?: string | null, account_title?: string | null, note?: string | null, adp?: string | null, swift_code?: string | null, branch_code?: string | null, local_code?: string | null, is_medical_insurance?: boolean | null, is_store_wise?: boolean | null, is_payroll_run_on_business?: boolean | null, is_air_ticket?: boolean | null, is_gratuity?: boolean | null, eligibility_date?: any | null, salary_type?: string | null, pay_type?: string | null, basic_salary?: string | null, starting_date?: any | null, is_excluding_pay_roll?: boolean | null, salary_template?: string | null, weekly_hourly_salary?: string | null, weekend_day_salary?: string | null, public_day_hourly_salary?: string | null, employee_home_address?: string | null, employee_work_address?: string | null, sales_tax_allowances?: string | null, is_exempt_income_tax?: boolean | null, tax_override?: string | null, total_week_hours?: number | null, tax_override_amount?: string | null, w4_form?: string | null, withholding_status?: string | null, total_allowances?: string | null, additional_tax_override?: string | null, additional_withholding_amount?: string | null, is_exempt_from_withholding?: boolean | null, is_exempt_federal_tax?: boolean | null, salary_payment_method?: string | null, account_number?: string | null, bank_name?: string | null, routing_number?: string | null, is_attendance_rule_applied?: boolean | null, is_missing_attendance?: boolean | null, is_late_arrival?: boolean | null, is_leave_restriction?: boolean | null, is_hours_in_a_day?: boolean | null, is_over_time_policy?: boolean | null, is_earlyout?: boolean | null, is_enable_checkin_checkout_access?: boolean | null, is_breaktime_exception?: boolean | null, is_send_email_notification?: boolean | null, password_changed_at?: string | null, is_self_service_access?: boolean | null, last_login_at?: string | null, last_login_ip?: string | null, is_company?: boolean | null, is_profile_updated?: boolean | null, is_profile_completed?: boolean | null, profile_score?: number | null, exempt_any_state_tax?: boolean | null, seasonal_employee?: string | null, payout_frequency?: string | null, payout_rate?: number | null, termination_reason?: string | null, termination_date?: any | null, last_day_worked?: string | null, employee_status?: string | null, ssn?: string | null, commision?: number | null, length_of_service?: string | null, altername?: string | null, deleted_at?: any | null, updated_at?: any | null, leave_policy?: { __typename?: 'LeavePolicy', _id?: string | null, name: string, is_deleted?: boolean | null } | null, joining_latter?: { __typename?: 'joining_latter', date?: any | null, description?: string | null, footer?: string | null, Joining_formalities?: string | null } | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, business_id?: { __typename?: 'Business', business_system_name?: string | null, business_legal_name?: string | null, logo?: string | null } | null, time_off?: Array<{ __typename?: 'TimeOffType', time_off_category?: string | null, time_off_days?: string | null, time_off_type?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null, code?: string | null, type?: string | null } | null } | null> | null, medical_insurance?: { __typename?: 'MedicalInsuranceType', insurance_card?: string | null, insurance_class?: string | null, expiry_date_of_policy?: any | null, total_policy_amount_monthly?: string | null } | null, air_ticket?: { __typename?: 'AirTicket', no_of_air_tickets?: number | null, air_tickets_frequency?: string | null, destination_city?: string | null, air_ticket_class?: string | null, orignal_city?: string | null, orignal_country?: { __typename?: 'Country', _id?: string | null, name?: string | null } | null, destination_country?: { __typename?: 'Country', _id?: string | null, name?: string | null } | null } | null, city?: { __typename?: 'City', _id?: string | null, city_name?: string | null } | null, state?: { __typename?: 'State', _id?: string | null, state_name?: string | null } | null, employee_group?: { __typename?: 'attandencePolicy', _id?: string | null, is_un_restricted?: boolean | null, group_name?: string | null, pay_type?: { __typename?: 'PayrollSchedule', _id?: string | null, schedule_name?: string | null } | null, AttendancePolicy?: { __typename?: 'attandencePolicy', group_name?: string | null, is_un_restricted?: boolean | null } | null } | null, pay_schedule?: { __typename?: 'PayrollSchedule', _id?: string | null, schedule_name?: string | null, pay_period?: string | null } | null, allowances?: Array<{ __typename?: 'AllowancesType', amount?: number | null, percentage?: number | null, allowance?: { __typename?: 'Allowance', _id: string, pay_slip_name: string, amount: number } | null } | null> | null, contributions?: Array<{ __typename?: 'ContributionsType', amount?: number | null, percentage?: number | null, contribution?: { __typename?: 'Contribution', _id?: string | null, name_pay_slip: string, contribution_amount: number } | null } | null> | null, deductions?: Array<{ __typename?: 'DeductionsType', amount?: number | null, percentage?: number | null, deduction?: { __typename?: 'Deduction', _id?: string | null, name_pay_slip: string, deduction_amount: number } | null } | null> | null, EmployeeGarnishment?: Array<{ __typename?: 'EmployeeGarnishment', _id?: string | null, fix_amount?: number | null, garnishment_account?: string | null, garnishment_type?: string | null } | null> | null, Country?: { __typename?: 'Country', _id?: string | null, name?: string | null } | null, shift?: { __typename?: 'Shift', _id?: string | null, is_custom?: boolean | null, shift_name: string, start_time: string, end_time: string, meal_break?: number | null, rest_break?: number | null, break_hours?: string | null, working_hours?: string | null, is_deleted?: boolean | null } | null, line_manager?: { __typename?: 'User', id?: string | null, email?: string | null, first_name?: string | null, middle_name?: string | null, last_name?: string | null, full_name?: string | null } | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null, documents_list?: Array<{ __typename?: 'DocumentListType', _id?: string | null, upload_documents?: string | null, documents_type?: string | null, documents_name?: string | null, documents_description?: string | null, documents_expiry_date?: any | null, is_documents_hide?: boolean | null, is_email_notify?: boolean | null, Role?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null, assinged_to?: { __typename?: 'User', _id?: string | null, full_name?: string | null, id?: string | null } | null } | null> | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null, is_deleted?: boolean | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null, is_deleted?: boolean | null, businessLocation?: { __typename?: 'BusinessLocation', _id?: string | null, store_nick_name?: string | null } | null } | null> | null, region?: Array<{ __typename?: 'Region', _id?: string | null, region_name?: string | null } | null> | null, storeAccess?: Array<{ __typename?: 'StoreAccessType', businessLocation?: { __typename?: 'BusinessLocation', _id?: string | null, store_nick_name?: string | null } | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, cashRegister?: Array<{ __typename?: 'CashRegisters', _id?: string | null, name?: string | null } | null> | null } | null> | null } | null };

export type GetAllShiftsListQueryVariables = Exact<{
  input: ShiftListInput;
}>;


export type GetAllShiftsListQuery = { __typename?: 'Query', getAllShiftsList?: { __typename?: 'shiftListingResult', results?: Array<{ __typename?: 'Shift', _id?: string | null, shift_name: string, start_time: string, end_time: string, meal_break?: number | null, rest_break?: number | null, break_hours?: string | null, working_hours?: string | null, is_deleted?: boolean | null, is_custom?: boolean | null, break_detail?: Array<{ __typename?: 'breakDetailType', break_duration?: number | null, break_start_time?: string | null, break_end_time?: string | null, is_break_start_time?: boolean | null, break_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null } | null } | null> | null, employees?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type GetAllPayrollScheduleListQueryVariables = Exact<{
  input?: InputMaybe<PayrollScheduleListInput>;
}>;


export type GetAllPayrollScheduleListQuery = { __typename?: 'Query', getAllPayrollScheduleList?: { __typename?: 'PayrollScheduleListingResult', results?: Array<{ __typename?: 'PayrollSchedule', _id?: string | null, is_deleted?: boolean | null, schedule_name?: string | null, pay_period?: string | null, start_date?: any | null, end_date?: any | null, pay_day?: any | null, first_day_of_payroll_run_date?: number | null, day_of_month?: number | null, secound_day_of_payroll_run_date?: number | null, pay_holiday_policy?: string | null, last_payroll_run_date?: any | null, no_of_days?: string | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type GetAllAllowancesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAllowancesQuery = { __typename?: 'Query', getAllAllowances?: Array<{ __typename?: 'Allowance', _id: string, allowance_type: AllowanceType, pay_slip_name: string, is_fixed: boolean, is_taxable?: boolean | null, amount: number } | null> | null };

export type GetDeductionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDeductionQuery = { __typename?: 'Query', getDeduction?: Array<{ __typename?: 'Deduction', _id?: string | null, name_pay_slip: string, is_calculate_amount_fixed: boolean, deduction_amount: number, is_deleted?: boolean | null } | null> | null };

export type GetContributionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContributionQuery = { __typename?: 'Query', getContribution?: Array<{ __typename?: 'Contribution', _id?: string | null, name_pay_slip: string, is_calculate_amount_fixed: boolean, contribution_amount: number, is_deleted?: boolean | null, created_at?: any | null } | null> | null };

export type GetRolesQueryVariables = Exact<{
  roleFilter: RoleFilter;
}>;


export type GetRolesQuery = { __typename?: 'Query', getRoles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null, employeeCount?: number | null } | null> | null };

export type GetDepartmentsByLocationIdQueryVariables = Exact<{
  location_id: Scalars['ID']['input'];
  business_id: Scalars['ID']['input'];
}>;


export type GetDepartmentsByLocationIdQuery = { __typename?: 'Query', getDepartmentsByLocationID?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null, Business?: { __typename?: 'Business', _id: string } | null, businessLocation?: { __typename?: 'BusinessLocation', _id?: string | null } | null } | null> | null };

export type GetAllLeavesTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLeavesTypeQuery = { __typename?: 'Query', getAllLeavesType?: Array<{ __typename?: 'LeaveType', _id?: string | null, name?: string | null, code?: string | null, pto_type?: string | null, type?: string | null, is_pto?: boolean | null, minimum_duration?: string | null, maximum_duration?: string | null, un_paid_days?: string | null, per_day_hours?: string | null } | null> | null };

export type GetDocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentTypesQuery = { __typename?: 'Query', getDocumentTypes?: Array<{ __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, is_system_generated?: boolean | null } | null> | null };

export type GetDocumentsByEmployeeIdQueryVariables = Exact<{
  input?: InputMaybe<InputEmployeeDocuments>;
}>;


export type GetDocumentsByEmployeeIdQuery = { __typename?: 'Query', getDocumentsByEmployeeId?: { __typename?: 'allDocumentsDataTableResult', results?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, type?: string | null, share_as?: string | null, attachment?: string | null, is_sign_required?: boolean | null, is_hide_after_review?: boolean | null, is_submission_required?: boolean | null, validity?: any | null, employeeDocumentUpload?: Array<{ __typename?: 'employeeDocumentUpload', fileRef?: string | null, status?: boolean | null, view?: number | null, date?: string | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null } | null> | null, config?: { __typename?: 'dataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null } | null } | null };

export type GetDataWithZipcodeQueryVariables = Exact<{
  zipcode: Scalars['String']['input'];
  business?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetDataWithZipcodeQuery = { __typename?: 'Query', getDataWithZipcode?: Array<{ __typename?: 'HierarchicalDetail', Country?: { __typename?: 'Country', _id?: string | null, name?: string | null } | null, States?: Array<{ __typename?: 'StateHierarchicy', State?: { __typename?: 'State', _id?: string | null, state_name?: string | null } | null, cities?: Array<{ __typename?: 'City', _id?: string | null, city_name?: string | null } | null> | null } | null> | null } | null> | null };

export type GetEmployeeTimeLineHistoryQueryVariables = Exact<{
  input?: InputMaybe<HistoryListFilter>;
}>;


export type GetEmployeeTimeLineHistoryQuery = { __typename?: 'Query', getEmployeeTimeLineHistory?: { __typename?: 'historyListingResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'UserHistory', id?: string | null, action_type?: string | null, created_date?: any | null, basic_salary?: number | null, employee_type?: string | null, hire_date?: any | null, joining_date?: any | null, salary_type?: string | null, over_time_rate?: number | null, total_week_hours?: number | null, account_status?: string | null, starting_date?: any | null, weekly_hourly_salary?: number | null, weekend_day_salary?: number | null, public_day_hourly_salary?: number | null, new_salary_effect_from?: any | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, shift?: { __typename?: 'Shift', _id?: string | null, shift_name: string } | null, line_manager?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null } | null };

export type GetAllEmployeeActionsQueryVariables = Exact<{
  input: EmployeeActionInput;
}>;


export type GetAllEmployeeActionsQuery = { __typename?: 'Query', getAllEmployeeActions?: Array<{ __typename?: 'UserHistory', action_type?: string | null, basic_salary?: number | null, created_date?: any | null, employee_type?: string | null, hire_date?: any | null, id?: string | null, total_week_hours?: number | null, pay_type?: string | null, public_day_hourly_salary?: number | null, account_status?: string | null, is_salary_update?: boolean | null, is_use_new_salary?: boolean | null, joining_date?: any | null, new_salary_effect_from?: any | null, new_salary_effect_to?: any | null, over_time_rate?: number | null, salary_type?: string | null, weekend_day_salary?: number | null, weekly_hourly_salary?: number | null, starting_date?: any | null, pay_schedule?: { __typename?: 'PayrollSchedule', _id?: string | null, schedule_name?: string | null } | null, employee_group?: { __typename?: 'attandencePolicy', _id?: string | null, pay_type?: { __typename?: 'PayrollSchedule', _id?: string | null, schedule_name?: string | null } | null } | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null };

export type GetBusinessLocationsByBusinessIdQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
}>;


export type GetBusinessLocationsByBusinessIdQuery = { __typename?: 'Query', getBusinessLocationsByBusinessId?: Array<{ __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null, location_keeping_unit?: string | null, address_1?: string | null, address_2?: string | null, State?: string | null, city?: string | null, is_deleted?: boolean | null, status?: string | null } | null> | null };

export type GetActiveEmployeesForDropdownByBusinessIdQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
}>;


export type GetActiveEmployeesForDropdownByBusinessIdQuery = { __typename?: 'Query', getAllActiveEmployees?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null };

export type CreateUpdateEmployeeMutationVariables = Exact<{
  businessId: Scalars['ID']['input'];
  input: CreateUpdateEmployeeInput;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateUpdateEmployeeMutation = { __typename?: 'Mutation', createUpdateEmployee?: { __typename?: 'User', id?: string | null, email?: string | null, employee_id?: string | null, first_name?: string | null, middle_name?: string | null, last_name?: string | null, full_name?: string | null, phone?: string | null, status?: string | null, account_status?: string | null, hire_date?: any | null, joining_date?: any | null, employee_type?: string | null, salary_type?: string | null, basic_salary?: string | null, salary_payment_method?: string | null, is_deleted?: boolean | null, created_at?: any | null, updated_at?: any | null } | null };

export type ArchiveEmployeeMutationVariables = Exact<{
  archive: Scalars['Boolean']['input'];
  proceed: Scalars['Boolean']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ArchiveEmployeeMutation = { __typename?: 'Mutation', archiveEmployee?: { __typename?: 'archivedEmployees', archived?: Array<{ __typename?: 'User', account_number?: string | null } | null> | null, clockedIn?: Array<{ __typename?: 'User', full_name?: string | null, id?: string | null } | null> | null } | null };

export type ArchiveEmployeeHistoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveEmployeeHistoryMutation = { __typename?: 'Mutation', archiveEmployeeHistory?: boolean | null };

export type ArchiveEmployeeDocumentMutationVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
}>;


export type ArchiveEmployeeDocumentMutation = { __typename?: 'Mutation', archiveEmployeeDocument?: boolean | null };

export type UpdateEmployeeDocumentMutationVariables = Exact<{
  input?: InputMaybe<EmployeeDocumentUpdateInput>;
}>;


export type UpdateEmployeeDocumentMutation = { __typename?: 'Mutation', updateEmployeeDocument?: { __typename?: 'User', id?: string | null, documents_list?: Array<{ __typename?: 'DocumentListType', _id?: string | null, documents_name?: string | null, documents_type?: string | null, documents_description?: string | null, documents_expiry_date?: any | null, upload_documents?: string | null, is_documents_hide?: boolean | null, is_email_notify?: boolean | null, Role?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null, assinged_to?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename?: 'User', id?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null } | null };

export type UpdateProfilePictureForModelsMutationVariables = Exact<{
  input?: InputMaybe<UpdateProfilePictureInput>;
}>;


export type UpdateProfilePictureForModelsMutation = { __typename?: 'Mutation', updateProfilePictureForModels?: boolean | null };

export type ReJoinEmployeeMutationVariables = Exact<{
  input?: InputMaybe<ReJoinEmployeeInput>;
}>;


export type ReJoinEmployeeMutation = { __typename?: 'Mutation', reJoinEmployee?: { __typename?: 'User', _id?: string | null } | null };

export type GetWriteupsByEmployeeIdQueryVariables = Exact<{
  input?: InputMaybe<WriteUpByEmployee>;
}>;


export type GetWriteupsByEmployeeIdQuery = { __typename?: 'Query', getWriteupsByEmployeeId?: { __typename?: 'WriteUpList', results?: Array<{ __typename?: 'WriteUp', _id?: string | null, write_up_type?: string | null, write_up_reason?: string | null, status?: string | null, created_at?: any | null, writeup_date?: any | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null, config?: { __typename?: 'dataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<string | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type UpdateMultipleWritupApprovalMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  status: WritupStatusEnumMult;
}>;


export type UpdateMultipleWritupApprovalMutation = { __typename?: 'Mutation', updateMultipleWritupApproval?: boolean | null };

export type GetAssetsByEmployeeIdQueryVariables = Exact<{
  input?: InputMaybe<InputAssetByEmployee>;
}>;


export type GetAssetsByEmployeeIdQuery = { __typename?: 'Query', getAssetsByEmployeeId?: { __typename?: 'AssetByEmployeeResult', results?: Array<{ __typename?: 'Asset', _id?: string | null, assetId?: string | null, name?: string | null, type?: string | null, availStatus?: string | null, quantity?: number | null, site?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null } | null, assigned?: { __typename?: 'User', _id?: string | null, id?: string | null, employee_id?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null } | null> | null, config?: { __typename?: 'dataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<string | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type GetAllMyRequestDocumentsQueryVariables = Exact<{
  input: InputDocumentsWithFilter;
}>;


export type GetAllMyRequestDocumentsQuery = { __typename?: 'Query', getAllMyRequestDocuments?: { __typename?: 'allDocumentListingResult', countpendingRequest?: number | null, data?: Array<{ __typename?: 'DocumentControlAttachmenttWithData', Doucuments?: { __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, activity_name?: string | null, status?: string | null, activity_type?: Activity_Type | null, message?: string | null, attachment?: string | null, created_at?: any | null, validity?: any | null, extension?: string | null, uploadfileref?: string | null, created_by?: { __typename?: 'User', full_name?: string | null } | null } | null } | null> | null, config?: { __typename?: 'dataTableConfig', type?: string | null, limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null } | null } | null };

export type GetAllDesignationListQueryVariables = Exact<{
  input?: InputMaybe<DesignationtListFilter>;
}>;


export type GetAllDesignationListQuery = { __typename?: 'Query', getAllDesignationList?: { __typename?: 'allDesignationListingresult', result?: Array<{ __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null> | null } | null };

export type GetEmployeesForLineManagerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeesForLineManagerQuery = { __typename?: 'Query', getEmployeesForLineManager?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null, joining_date?: any | null, last_working_date?: any | null, employee_group?: { __typename?: 'attandencePolicy', is_un_restricted?: boolean | null } | null } | null> | null };

export type GetAllLeavePoliciesWithSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllLeavePoliciesWithSearchQuery = { __typename?: 'Query', getAllLeavePoliciesWithSearch?: { __typename?: 'resultOfLeavePolicy', results?: Array<{ __typename?: 'LeavePolicy', _id?: string | null, name: string, reset_type?: YearlyMonthlyEnum | null, is_deleted?: boolean | null, leaves?: Array<{ __typename?: 'leavesType', count?: number | null, countIn?: string | null, leaveAssighment?: string | null, type?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null, is_pto?: boolean | null } | null } | null> | null, assign_to?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null } | null> | null } | null };

export type GetCurrentEmployeeActionQueryVariables = Exact<{
  employee_id: Scalars['ID']['input'];
}>;


export type GetCurrentEmployeeActionQuery = { __typename?: 'Query', getCurrentEmployeeAction?: { __typename?: 'UserHistory', id?: string | null, action_type?: string | null, salary_type?: string | null, account_status?: string | null, employee_type?: string | null, basic_salary?: number | null, weekly_hourly_salary?: number | null, weekend_day_salary?: number | null, public_day_hourly_salary?: number | null, over_time_rate?: number | null, total_week_hours?: number | null, is_excluding_pay_roll?: boolean | null, line_manager?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, pay_schedule?: { __typename?: 'PayrollSchedule', _id?: string | null, schedule_name?: string | null, pay_period?: string | null, day_of_month?: number | null, last_payroll_run_date?: any | null } | null, employee_group?: { __typename?: 'attandencePolicy', _id?: string | null, group_name?: string | null } | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null } | null };

export type GetAttendancePolicyByPayTypeQueryVariables = Exact<{
  pay_type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAttendancePolicyByPayTypeQuery = { __typename?: 'Query', getAttendancePolicyByPayType?: Array<{ __typename?: 'attandencePolicy', _id?: string | null, group_name?: string | null } | null> | null };

export type GetAllActiveEmployeesWithSearchQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllActiveEmployeesWithSearchQuery = { __typename?: 'Query', getAllActiveEmployeesWithSearch?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null };

export type GetAllActiveEmployeesForShareDocumentQueryVariables = Exact<{
  input: GetAllActiveEmployeesForShareDocumentInput;
}>;


export type GetAllActiveEmployeesForShareDocumentQuery = { __typename?: 'Query', getAllActiveEmployeesForShareDocument?: Array<{ __typename?: 'User', id?: string | null, email?: string | null, full_name?: string | null } | null> | null };

export type GetAllActiveEmployeesQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
  feature?: InputMaybe<FeatureEnum>;
}>;


export type GetAllActiveEmployeesQuery = { __typename?: 'Query', getAllActiveEmployees?: Array<{ __typename?: 'User', id?: string | null, email?: string | null, employee_id?: string | null, salary_type?: string | null, first_name?: string | null, joining_date?: any | null, hire_date?: any | null, last_working_date?: any | null, final_settlement_completed?: boolean | null, last_day_worked?: string | null, account_status?: string | null, middle_name?: string | null, last_name?: string | null, full_name?: string | null, phone?: string | null, isOwner?: boolean | null, adp?: string | null, phone_country_code?: string | null, landline?: string | null, logo?: string | null, avatar_location?: string | null, status?: string | null, employee_group?: { __typename?: 'attandencePolicy', before_early_clockin?: number | null, paunch_out_mnts?: number | null, is_un_restricted?: boolean | null, is_auto_clocked_in?: boolean | null, _id?: string | null, group_name?: string | null } | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, business_id?: { __typename?: 'Business', business_system_name?: string | null } | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null, users_password_manager?: { __typename?: 'UserEncryptionKeys', publicKey?: string | null } | null } | null> | null };

export type GetExpenseWithFiltersQueryVariables = Exact<{
  input?: InputMaybe<ExpenseFilter>;
}>;


export type GetExpenseWithFiltersQuery = { __typename?: 'Query', getExpenseWithFilters?: { __typename?: 'expnseResultUpdate', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Expense', _id?: string | null, expense_type?: string | null, expense_total_amount?: number | null, expense_date?: any | null, description?: string | null, status?: string | null, is_received?: boolean | null, is_business_expense?: boolean | null, is_deleted?: boolean | null, created_at?: any | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, work_flow?: Array<{ __typename?: 'workFlow', approval_description?: string | null, status?: string | null, approved_by?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null> | null } | null> | null } | null };

export type GetExpenseByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExpenseByIdQuery = { __typename?: 'Query', getExpenseById?: { __typename?: 'Expense', _id?: string | null, expense_type?: string | null, expense_total_amount?: number | null, expense_date?: any | null, description?: string | null, status?: string | null, is_received?: boolean | null, is_business_expense?: boolean | null, is_deleted?: boolean | null, document_url?: string | null, approval_status?: string | null, approval_description?: string | null, google_drive_id?: string | null, employee?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, middle_name?: string | null } | null, business_manager?: { __typename?: 'User', _id?: string | null, full_name?: string | null, status?: string | null } | null, behalf_of?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null, work_flow?: Array<{ __typename?: 'workFlow', approval_description?: string | null, status?: string | null, approved_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, _id?: string | null } | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null, id?: string | null } | null } | null> | null, upload_document_info?: { __typename?: 'updloadDocumentInf', name?: string | null, extension?: string | null } | null } | null };

export type CreateUpdateExpenseMutationVariables = Exact<{
  input: InputExpense;
}>;


export type CreateUpdateExpenseMutation = { __typename?: 'Mutation', createUpdateExpense?: { __typename?: 'Expense', _id?: string | null, expense_type?: string | null, expense_total_amount?: number | null, status?: string | null } | null };

export type ArchiveExpenseMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveExpenseMutation = { __typename?: 'Mutation', archiveExpense?: boolean | null };

export type GetHrComplaintByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetHrComplaintByIdQuery = { __typename?: 'Query', getHRComplaintById?: { __typename?: 'HRComplaint', _id: string, case_id?: string | null, preferred_contact_method?: PreferredContactMethod | null, type_of_concern?: Array<string | null> | null, other_concern_description?: string | null, urgency?: ComplaintUrgency | null, incident_date?: any | null, is_exact_date_unknown?: boolean | null, approximate_time?: string | null, situation_ongoing?: WitnessesEvent | null, where_did_it_occur?: string | null, is_reported_previously?: boolean | null, previous_description?: string | null, description?: string | null, is_supporting_documents?: boolean | null, supporting_files_description?: string | null, persons_involved_count?: number | null, witnesses_events?: WitnessesEvent | null, is_hr_should_know_anything?: boolean | null, hr_additional_info?: string | null, is_truthful_confirmed?: boolean | null, is_hr_review_confirmed?: boolean | null, status?: string | null, assinged_status?: string | null, severity?: string | null, days_open?: number | null, reminder?: string | null, overdue_date?: any | null, closed_date?: any | null, is_deleted?: boolean | null, created_at?: any | null, updated_at?: any | null, respondent_notified?: boolean | null, respondent_notified_at?: any | null, Business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, supporting_files?: Array<{ __typename?: 'SupportingFileItem', file_url?: string | null, file_name?: string | null } | null> | null, persons_involved?: Array<{ __typename?: 'PersonInvolved', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, relationship_to_you?: string | null, additional_context?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, witnesses?: Array<{ __typename?: 'WitnessComplaint', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, what_they_witnessed?: string | null, User?: { __typename?: 'User', full_name?: string | null, _id?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, submitted_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, investigator?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, work_flow_user?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, case_witnesses?: Array<{ __typename?: 'CaseWitness', _id?: string | null, full_name?: string | null, email?: string | null, phone?: string | null, form_status?: string | null, form_sent_at?: any | null, form_completed_at?: any | null, created_at?: any | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, resolution?: { __typename?: 'CaseResolution', outcome?: string | null, disciplinary_action?: string | null, complainant_notification_method?: string | null, complainant_notified_date?: any | null, is_referred_externally?: boolean | null, is_policy_updated_as_result?: boolean | null, resolution_notes?: string | null, referral_policy_details?: string | null, resolved_at?: any | null, resolved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null, audit_log?: Array<{ __typename?: 'AuditEntry', _id?: string | null, timestamp?: any | null, action?: string | null, description?: string | null, performed_by_role?: string | null, performed_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, internal_notes?: Array<{ __typename?: 'HRInternalNote', _id?: string | null, content?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null } | null };

export type AssignInvestigatorMutationVariables = Exact<{
  complaintId: Scalars['ID']['input'];
  investigatorId: Scalars['ID']['input'];
}>;


export type AssignInvestigatorMutation = { __typename?: 'Mutation', assignInvestigator?: { __typename?: 'HRComplaint', _id: string, case_id?: string | null, preferred_contact_method?: PreferredContactMethod | null, type_of_concern?: Array<string | null> | null, other_concern_description?: string | null, urgency?: ComplaintUrgency | null, incident_date?: any | null, is_exact_date_unknown?: boolean | null, approximate_time?: string | null, situation_ongoing?: WitnessesEvent | null, where_did_it_occur?: string | null, is_reported_previously?: boolean | null, previous_description?: string | null, description?: string | null, is_supporting_documents?: boolean | null, supporting_files_description?: string | null, persons_involved_count?: number | null, witnesses_events?: WitnessesEvent | null, is_hr_should_know_anything?: boolean | null, hr_additional_info?: string | null, is_truthful_confirmed?: boolean | null, is_hr_review_confirmed?: boolean | null, status?: string | null, assinged_status?: string | null, severity?: string | null, days_open?: number | null, reminder?: string | null, overdue_date?: any | null, closed_date?: any | null, is_deleted?: boolean | null, created_at?: any | null, updated_at?: any | null, respondent_notified?: boolean | null, respondent_notified_at?: any | null, Business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, User?: { __typename?: 'User', id?: string | null, employee_id?: string | null, first_name?: string | null, email?: string | null, phone?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, supporting_files?: Array<{ __typename?: 'SupportingFileItem', file_url?: string | null, file_name?: string | null } | null> | null, persons_involved?: Array<{ __typename?: 'PersonInvolved', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, relationship_to_you?: string | null, additional_context?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, witnesses?: Array<{ __typename?: 'WitnessComplaint', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, what_they_witnessed?: string | null, User?: { __typename?: 'User', full_name?: string | null, _id?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, submitted_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, investigator?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, work_flow_user?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, case_witnesses?: Array<{ __typename?: 'CaseWitness', _id?: string | null, full_name?: string | null, email?: string | null, phone?: string | null, form_status?: string | null, form_sent_at?: any | null, form_completed_at?: any | null, created_at?: any | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, resolution?: { __typename?: 'CaseResolution', outcome?: string | null, disciplinary_action?: string | null, complainant_notification_method?: string | null, complainant_notified_date?: any | null, is_referred_externally?: boolean | null, is_policy_updated_as_result?: boolean | null, resolution_notes?: string | null, referral_policy_details?: string | null, resolved_at?: any | null, resolved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null, audit_log?: Array<{ __typename?: 'AuditEntry', _id?: string | null, timestamp?: any | null, action?: string | null, description?: string | null, performed_by_role?: string | null, performed_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, internal_notes?: Array<{ __typename?: 'HRInternalNote', _id?: string | null, content?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null } | null };

export type GetHrComplaintsQueryVariables = Exact<{
  input?: InputMaybe<ComplaintFilterInput>;
}>;


export type GetHrComplaintsQuery = { __typename?: 'Query', getHRComplaints?: { __typename?: 'HRComplaintPaginatedResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', is_visible?: string | null, name?: string | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, is_search_able?: boolean | null, is_amount?: boolean | null, is_sortable?: boolean | null, is_visible?: boolean | null, search?: string | null, type?: string | null, filterValue?: Array<string | null> | null, column_data?: Array<string | null> | null, query?: { __typename?: 'queryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', search?: string | null, field?: string | null, type?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'HRComplaint', assinged_status?: string | null, created_at?: any | null, severity?: string | null, status?: string | null, _id: string, case_id?: string | null, preferred_contact_method?: PreferredContactMethod | null, type_of_concern?: Array<string | null> | null, other_concern_description?: string | null, urgency?: ComplaintUrgency | null, incident_date?: any | null, is_exact_date_unknown?: boolean | null, approximate_time?: string | null, situation_ongoing?: WitnessesEvent | null, where_did_it_occur?: string | null, is_reported_previously?: boolean | null, previous_description?: string | null, description?: string | null, is_supporting_documents?: boolean | null, supporting_files_description?: string | null, persons_involved_count?: number | null, witnesses_events?: WitnessesEvent | null, days_open?: number | null, investigator?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null, Business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, supporting_files?: Array<{ __typename?: 'SupportingFileItem', file_url?: string | null, file_name?: string | null } | null> | null, persons_involved?: Array<{ __typename?: 'PersonInvolved', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, relationship_to_you?: string | null, additional_context?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, witnesses?: Array<{ __typename?: 'WitnessComplaint', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, what_they_witnessed?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type MarkRespondentNotifiedMutationVariables = Exact<{
  complaintId: Scalars['ID']['input'];
  isNotified: Scalars['Boolean']['input'];
}>;


export type MarkRespondentNotifiedMutation = { __typename?: 'Mutation', markRespondentNotified?: { __typename?: 'HRComplaint', _id: string, case_id?: string | null, preferred_contact_method?: PreferredContactMethod | null, type_of_concern?: Array<string | null> | null, other_concern_description?: string | null, urgency?: ComplaintUrgency | null, incident_date?: any | null, is_exact_date_unknown?: boolean | null, approximate_time?: string | null, situation_ongoing?: WitnessesEvent | null, where_did_it_occur?: string | null, is_reported_previously?: boolean | null, previous_description?: string | null, description?: string | null, is_supporting_documents?: boolean | null, supporting_files_description?: string | null, persons_involved_count?: number | null, witnesses_events?: WitnessesEvent | null, is_hr_should_know_anything?: boolean | null, hr_additional_info?: string | null, is_truthful_confirmed?: boolean | null, is_hr_review_confirmed?: boolean | null, status?: string | null, assinged_status?: string | null, severity?: string | null, days_open?: number | null, reminder?: string | null, overdue_date?: any | null, closed_date?: any | null, is_deleted?: boolean | null, created_at?: any | null, updated_at?: any | null, respondent_notified?: boolean | null, respondent_notified_at?: any | null, Business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, User?: { __typename?: 'User', id?: string | null, employee_id?: string | null, first_name?: string | null, email?: string | null, phone?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, supporting_files?: Array<{ __typename?: 'SupportingFileItem', file_url?: string | null, file_name?: string | null } | null> | null, persons_involved?: Array<{ __typename?: 'PersonInvolved', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, relationship_to_you?: string | null, additional_context?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, witnesses?: Array<{ __typename?: 'WitnessComplaint', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, what_they_witnessed?: string | null, User?: { __typename?: 'User', full_name?: string | null, _id?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, submitted_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, investigator?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, work_flow_user?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, case_witnesses?: Array<{ __typename?: 'CaseWitness', _id?: string | null, full_name?: string | null, email?: string | null, phone?: string | null, form_status?: string | null, form_sent_at?: any | null, form_completed_at?: any | null, created_at?: any | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, resolution?: { __typename?: 'CaseResolution', outcome?: string | null, disciplinary_action?: string | null, complainant_notification_method?: string | null, complainant_notified_date?: any | null, is_referred_externally?: boolean | null, is_policy_updated_as_result?: boolean | null, resolution_notes?: string | null, referral_policy_details?: string | null, resolved_at?: any | null, resolved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null, audit_log?: Array<{ __typename?: 'AuditEntry', _id?: string | null, timestamp?: any | null, action?: string | null, description?: string | null, performed_by_role?: string | null, performed_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, internal_notes?: Array<{ __typename?: 'HRInternalNote', _id?: string | null, content?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null } | null };

export type AddCaseWitnessMutationVariables = Exact<{
  complaintId: Scalars['ID']['input'];
  input: WitnessComplaintInput;
}>;


export type AddCaseWitnessMutation = { __typename?: 'Mutation', addCaseWitness?: { __typename?: 'HRComplaint', _id: string, case_id?: string | null, preferred_contact_method?: PreferredContactMethod | null, type_of_concern?: Array<string | null> | null, other_concern_description?: string | null, urgency?: ComplaintUrgency | null, incident_date?: any | null, is_exact_date_unknown?: boolean | null, approximate_time?: string | null, situation_ongoing?: WitnessesEvent | null, where_did_it_occur?: string | null, is_reported_previously?: boolean | null, previous_description?: string | null, description?: string | null, is_supporting_documents?: boolean | null, supporting_files_description?: string | null, persons_involved_count?: number | null, witnesses_events?: WitnessesEvent | null, is_hr_should_know_anything?: boolean | null, hr_additional_info?: string | null, is_truthful_confirmed?: boolean | null, is_hr_review_confirmed?: boolean | null, status?: string | null, assinged_status?: string | null, severity?: string | null, days_open?: number | null, reminder?: string | null, overdue_date?: any | null, closed_date?: any | null, is_deleted?: boolean | null, created_at?: any | null, updated_at?: any | null, respondent_notified?: boolean | null, respondent_notified_at?: any | null, Business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, User?: { __typename?: 'User', id?: string | null, employee_id?: string | null, first_name?: string | null, email?: string | null, phone?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, supporting_files?: Array<{ __typename?: 'SupportingFileItem', file_url?: string | null, file_name?: string | null } | null> | null, persons_involved?: Array<{ __typename?: 'PersonInvolved', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, relationship_to_you?: string | null, additional_context?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, witnesses?: Array<{ __typename?: 'WitnessComplaint', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, what_they_witnessed?: string | null, User?: { __typename?: 'User', full_name?: string | null, _id?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, submitted_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, investigator?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, work_flow_user?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, case_witnesses?: Array<{ __typename?: 'CaseWitness', _id?: string | null, full_name?: string | null, email?: string | null, phone?: string | null, form_status?: string | null, form_sent_at?: any | null, form_completed_at?: any | null, created_at?: any | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, resolution?: { __typename?: 'CaseResolution', outcome?: string | null, disciplinary_action?: string | null, complainant_notification_method?: string | null, complainant_notified_date?: any | null, is_referred_externally?: boolean | null, is_policy_updated_as_result?: boolean | null, resolution_notes?: string | null, referral_policy_details?: string | null, resolved_at?: any | null, resolved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null, audit_log?: Array<{ __typename?: 'AuditEntry', _id?: string | null, timestamp?: any | null, action?: string | null, description?: string | null, performed_by_role?: string | null, performed_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, internal_notes?: Array<{ __typename?: 'HRInternalNote', _id?: string | null, content?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null } | null };

export type SendWitnessFormMutationVariables = Exact<{
  complaintId: Scalars['ID']['input'];
  witnessId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
}>;


export type SendWitnessFormMutation = { __typename?: 'Mutation', sendWitnessForm?: { __typename?: 'HRComplaint', _id: string, case_id?: string | null, preferred_contact_method?: PreferredContactMethod | null, type_of_concern?: Array<string | null> | null, other_concern_description?: string | null, urgency?: ComplaintUrgency | null, incident_date?: any | null, is_exact_date_unknown?: boolean | null, approximate_time?: string | null, situation_ongoing?: WitnessesEvent | null, where_did_it_occur?: string | null, is_reported_previously?: boolean | null, previous_description?: string | null, description?: string | null, is_supporting_documents?: boolean | null, supporting_files_description?: string | null, persons_involved_count?: number | null, witnesses_events?: WitnessesEvent | null, is_hr_should_know_anything?: boolean | null, hr_additional_info?: string | null, is_truthful_confirmed?: boolean | null, is_hr_review_confirmed?: boolean | null, status?: string | null, assinged_status?: string | null, severity?: string | null, days_open?: number | null, reminder?: string | null, overdue_date?: any | null, closed_date?: any | null, is_deleted?: boolean | null, created_at?: any | null, updated_at?: any | null, respondent_notified?: boolean | null, respondent_notified_at?: any | null, Business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, User?: { __typename?: 'User', id?: string | null, employee_id?: string | null, first_name?: string | null, email?: string | null, phone?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, supporting_files?: Array<{ __typename?: 'SupportingFileItem', file_url?: string | null, file_name?: string | null } | null> | null, persons_involved?: Array<{ __typename?: 'PersonInvolved', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, relationship_to_you?: string | null, additional_context?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, witnesses?: Array<{ __typename?: 'WitnessComplaint', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, what_they_witnessed?: string | null, User?: { __typename?: 'User', full_name?: string | null, _id?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, submitted_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, investigator?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, work_flow_user?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, case_witnesses?: Array<{ __typename?: 'CaseWitness', _id?: string | null, full_name?: string | null, email?: string | null, phone?: string | null, form_status?: string | null, form_sent_at?: any | null, form_completed_at?: any | null, created_at?: any | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, resolution?: { __typename?: 'CaseResolution', outcome?: string | null, disciplinary_action?: string | null, complainant_notification_method?: string | null, complainant_notified_date?: any | null, is_referred_externally?: boolean | null, is_policy_updated_as_result?: boolean | null, resolution_notes?: string | null, referral_policy_details?: string | null, resolved_at?: any | null, resolved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null, audit_log?: Array<{ __typename?: 'AuditEntry', _id?: string | null, timestamp?: any | null, action?: string | null, description?: string | null, performed_by_role?: string | null, performed_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, internal_notes?: Array<{ __typename?: 'HRInternalNote', _id?: string | null, content?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null } | null };

export type AddInterviewLogMutationVariables = Exact<{
  complaintId: Scalars['ID']['input'];
  input: AddInterviewLogInput;
}>;


export type AddInterviewLogMutation = { __typename?: 'Mutation', addInterviewLog?: { __typename?: 'ComplaintInterviewLog', _id?: string | null, created_at?: any | null, updated_at?: any | null, interview_date?: any | null, interview_type?: string | null, participant_name?: string | null, participant_role?: string | null, format?: string | null, follow_up_required?: boolean | null, summary?: string | null, Business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, User?: { __typename?: 'User', id?: string | null, employee_id?: string | null, first_name?: string | null, email?: string | null, phone?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, HRComplaint?: { __typename?: 'HRComplaint', _id: string, case_id?: string | null, preferred_contact_method?: PreferredContactMethod | null, type_of_concern?: Array<string | null> | null, other_concern_description?: string | null, urgency?: ComplaintUrgency | null, incident_date?: any | null, is_exact_date_unknown?: boolean | null, approximate_time?: string | null, situation_ongoing?: WitnessesEvent | null, where_did_it_occur?: string | null, is_reported_previously?: boolean | null, previous_description?: string | null, description?: string | null, is_supporting_documents?: boolean | null, supporting_files_description?: string | null, persons_involved_count?: number | null, witnesses_events?: WitnessesEvent | null, is_hr_should_know_anything?: boolean | null, hr_additional_info?: string | null, is_truthful_confirmed?: boolean | null, is_hr_review_confirmed?: boolean | null, status?: string | null, assinged_status?: string | null, severity?: string | null, days_open?: number | null, reminder?: string | null, overdue_date?: any | null, closed_date?: any | null, is_deleted?: boolean | null, created_at?: any | null, updated_at?: any | null, respondent_notified?: boolean | null, respondent_notified_at?: any | null, Business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, User?: { __typename?: 'User', id?: string | null, employee_id?: string | null, first_name?: string | null, email?: string | null, phone?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, supporting_files?: Array<{ __typename?: 'SupportingFileItem', file_url?: string | null, file_name?: string | null } | null> | null, persons_involved?: Array<{ __typename?: 'PersonInvolved', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, relationship_to_you?: string | null, additional_context?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, witnesses?: Array<{ __typename?: 'WitnessComplaint', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, what_they_witnessed?: string | null, User?: { __typename?: 'User', full_name?: string | null, _id?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, submitted_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, investigator?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, work_flow_user?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, case_witnesses?: Array<{ __typename?: 'CaseWitness', _id?: string | null, full_name?: string | null, email?: string | null, phone?: string | null, form_status?: string | null, form_sent_at?: any | null, form_completed_at?: any | null, created_at?: any | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, resolution?: { __typename?: 'CaseResolution', outcome?: string | null, disciplinary_action?: string | null, complainant_notification_method?: string | null, complainant_notified_date?: any | null, is_referred_externally?: boolean | null, is_policy_updated_as_result?: boolean | null, resolution_notes?: string | null, referral_policy_details?: string | null, resolved_at?: any | null, resolved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null, audit_log?: Array<{ __typename?: 'AuditEntry', _id?: string | null, timestamp?: any | null, action?: string | null, description?: string | null, performed_by_role?: string | null, performed_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, internal_notes?: Array<{ __typename?: 'HRInternalNote', _id?: string | null, content?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null };

export type RecordResolutionMutationVariables = Exact<{
  complaintId: Scalars['ID']['input'];
  input: RecordResolutionInput;
}>;


export type RecordResolutionMutation = { __typename?: 'Mutation', recordResolution?: { __typename?: 'HRComplaint', _id: string, case_id?: string | null, preferred_contact_method?: PreferredContactMethod | null, type_of_concern?: Array<string | null> | null, other_concern_description?: string | null, urgency?: ComplaintUrgency | null, incident_date?: any | null, is_exact_date_unknown?: boolean | null, approximate_time?: string | null, situation_ongoing?: WitnessesEvent | null, where_did_it_occur?: string | null, is_reported_previously?: boolean | null, previous_description?: string | null, description?: string | null, is_supporting_documents?: boolean | null, supporting_files_description?: string | null, persons_involved_count?: number | null, witnesses_events?: WitnessesEvent | null, is_hr_should_know_anything?: boolean | null, hr_additional_info?: string | null, is_truthful_confirmed?: boolean | null, is_hr_review_confirmed?: boolean | null, status?: string | null, assinged_status?: string | null, severity?: string | null, days_open?: number | null, reminder?: string | null, overdue_date?: any | null, closed_date?: any | null, is_deleted?: boolean | null, created_at?: any | null, updated_at?: any | null, respondent_notified?: boolean | null, respondent_notified_at?: any | null, Business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, User?: { __typename?: 'User', id?: string | null, employee_id?: string | null, first_name?: string | null, email?: string | null, phone?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, supporting_files?: Array<{ __typename?: 'SupportingFileItem', file_url?: string | null, file_name?: string | null } | null> | null, persons_involved?: Array<{ __typename?: 'PersonInvolved', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, relationship_to_you?: string | null, additional_context?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, witnesses?: Array<{ __typename?: 'WitnessComplaint', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, what_they_witnessed?: string | null, User?: { __typename?: 'User', full_name?: string | null, _id?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, submitted_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, investigator?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, work_flow_user?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, case_witnesses?: Array<{ __typename?: 'CaseWitness', _id?: string | null, full_name?: string | null, email?: string | null, phone?: string | null, form_status?: string | null, form_sent_at?: any | null, form_completed_at?: any | null, created_at?: any | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, resolution?: { __typename?: 'CaseResolution', outcome?: string | null, disciplinary_action?: string | null, complainant_notification_method?: string | null, complainant_notified_date?: any | null, is_referred_externally?: boolean | null, is_policy_updated_as_result?: boolean | null, resolution_notes?: string | null, referral_policy_details?: string | null, resolved_at?: any | null, resolved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null, audit_log?: Array<{ __typename?: 'AuditEntry', _id?: string | null, timestamp?: any | null, action?: string | null, description?: string | null, performed_by_role?: string | null, performed_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, internal_notes?: Array<{ __typename?: 'HRInternalNote', _id?: string | null, content?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null } | null };

export type AddHrNoteMutationVariables = Exact<{
  complaintId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type AddHrNoteMutation = { __typename?: 'Mutation', addHRNote?: { __typename?: 'HRComplaint', _id: string, case_id?: string | null, preferred_contact_method?: PreferredContactMethod | null, type_of_concern?: Array<string | null> | null, other_concern_description?: string | null, urgency?: ComplaintUrgency | null, incident_date?: any | null, is_exact_date_unknown?: boolean | null, approximate_time?: string | null, situation_ongoing?: WitnessesEvent | null, where_did_it_occur?: string | null, is_reported_previously?: boolean | null, previous_description?: string | null, description?: string | null, is_supporting_documents?: boolean | null, supporting_files_description?: string | null, persons_involved_count?: number | null, witnesses_events?: WitnessesEvent | null, is_hr_should_know_anything?: boolean | null, hr_additional_info?: string | null, is_truthful_confirmed?: boolean | null, is_hr_review_confirmed?: boolean | null, status?: string | null, assinged_status?: string | null, severity?: string | null, days_open?: number | null, reminder?: string | null, overdue_date?: any | null, closed_date?: any | null, is_deleted?: boolean | null, created_at?: any | null, updated_at?: any | null, respondent_notified?: boolean | null, respondent_notified_at?: any | null, Business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, User?: { __typename?: 'User', id?: string | null, employee_id?: string | null, first_name?: string | null, email?: string | null, phone?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, supporting_files?: Array<{ __typename?: 'SupportingFileItem', file_url?: string | null, file_name?: string | null } | null> | null, persons_involved?: Array<{ __typename?: 'PersonInvolved', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, relationship_to_you?: string | null, additional_context?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, witnesses?: Array<{ __typename?: 'WitnessComplaint', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, what_they_witnessed?: string | null, User?: { __typename?: 'User', full_name?: string | null, _id?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, submitted_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, investigator?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, work_flow_user?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, case_witnesses?: Array<{ __typename?: 'CaseWitness', _id?: string | null, full_name?: string | null, email?: string | null, phone?: string | null, form_status?: string | null, form_sent_at?: any | null, form_completed_at?: any | null, created_at?: any | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, resolution?: { __typename?: 'CaseResolution', outcome?: string | null, disciplinary_action?: string | null, complainant_notification_method?: string | null, complainant_notified_date?: any | null, is_referred_externally?: boolean | null, is_policy_updated_as_result?: boolean | null, resolution_notes?: string | null, referral_policy_details?: string | null, resolved_at?: any | null, resolved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null, audit_log?: Array<{ __typename?: 'AuditEntry', _id?: string | null, timestamp?: any | null, action?: string | null, description?: string | null, performed_by_role?: string | null, performed_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, internal_notes?: Array<{ __typename?: 'HRInternalNote', _id?: string | null, content?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null } | null };

export type CreateHrComplaintMutationVariables = Exact<{
  input: CreateHrComplaintInput;
}>;


export type CreateHrComplaintMutation = { __typename?: 'Mutation', createHRComplaint?: { __typename?: 'HRComplaint', _id: string } | null };

export type GetHrComplaintDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHrComplaintDashboardQuery = { __typename?: 'Query', getHRComplaintDashboard?: { __typename?: 'HRComplaintDashboard', open_cases?: number | null, overdue_cases?: number | null, critical_high_cases?: number | null, pending_witness_forms?: number | null, resolved_this_month?: number | null, cases_by_status?: Array<{ __typename?: 'StatusCount', status?: string | null, count?: number | null } | null> | null, workload_by_investigator?: Array<{ __typename?: 'InvestigatorWorkload', count?: number | null, investigator?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null } | null } | null> | null, cases_needing_attention?: Array<{ __typename?: 'HRComplaint', _id: string, case_id?: string | null, preferred_contact_method?: PreferredContactMethod | null, type_of_concern?: Array<string | null> | null, other_concern_description?: string | null, urgency?: ComplaintUrgency | null, incident_date?: any | null, is_exact_date_unknown?: boolean | null, approximate_time?: string | null, situation_ongoing?: WitnessesEvent | null, where_did_it_occur?: string | null, is_reported_previously?: boolean | null, previous_description?: string | null, description?: string | null, is_supporting_documents?: boolean | null, supporting_files_description?: string | null, persons_involved_count?: number | null, witnesses_events?: WitnessesEvent | null, is_hr_should_know_anything?: boolean | null, hr_additional_info?: string | null, is_truthful_confirmed?: boolean | null, is_hr_review_confirmed?: boolean | null, status?: string | null, assinged_status?: string | null, severity?: string | null, days_open?: number | null, reminder?: string | null, overdue_date?: any | null, closed_date?: any | null, is_deleted?: boolean | null, created_at?: any | null, updated_at?: any | null, respondent_notified?: boolean | null, respondent_notified_at?: any | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, supporting_files?: Array<{ __typename?: 'SupportingFileItem', file_url?: string | null, file_name?: string | null } | null> | null, persons_involved?: Array<{ __typename?: 'PersonInvolved', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, relationship_to_you?: string | null, additional_context?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, witnesses?: Array<{ __typename?: 'WitnessComplaint', is_internal_person?: boolean | null, full_name?: string | null, email?: string | null, phone?: string | null, what_they_witnessed?: string | null, User?: { __typename?: 'User', full_name?: string | null, _id?: string | null } | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, submitted_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, investigator?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, work_flow_user?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, case_witnesses?: Array<{ __typename?: 'CaseWitness', _id?: string | null, full_name?: string | null, email?: string | null, phone?: string | null, form_status?: string | null, form_sent_at?: any | null, form_completed_at?: any | null, created_at?: any | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, resolution?: { __typename?: 'CaseResolution', outcome?: string | null, disciplinary_action?: string | null, complainant_notification_method?: string | null, complainant_notified_date?: any | null, is_referred_externally?: boolean | null, is_policy_updated_as_result?: boolean | null, resolution_notes?: string | null, referral_policy_details?: string | null, resolved_at?: any | null, resolved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null, audit_log?: Array<{ __typename?: 'AuditEntry', _id?: string | null, timestamp?: any | null, action?: string | null, description?: string | null, performed_by_role?: string | null, performed_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null, internal_notes?: Array<{ __typename?: 'HRInternalNote', _id?: string | null, content?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null } | null> | null } | null> | null } | null };

export type OverrideSeverityMutationVariables = Exact<{
  complaintId: Scalars['ID']['input'];
  severity: ComplaintSeverity;
}>;


export type OverrideSeverityMutation = { __typename?: 'Mutation', overrideSeverity?: { __typename?: 'HRComplaint', _id: string } | null };

export type DeleteHrComplaintMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteHrComplaintMutation = { __typename?: 'Mutation', deleteHRComplaint?: boolean | null };

export type UpdateHrComplaintMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CreateHrComplaintInput;
}>;


export type UpdateHrComplaintMutation = { __typename?: 'Mutation', updateHRComplaint?: { __typename?: 'HRComplaint', _id: string } | null };

export type ChangeComplaintStatusMutationVariables = Exact<{
  complaintId: Scalars['ID']['input'];
  status: ComplaintStatus;
}>;


export type ChangeComplaintStatusMutation = { __typename?: 'Mutation', changeComplaintStatus?: { __typename?: 'HRComplaint', _id: string } | null };

export type GetFeedbackTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeedbackTypesQuery = { __typename?: 'Query', getFeedbackTypes?: Array<{ __typename?: 'MasterDataValue', data_value_name?: string | null, _id?: string | null, is_deleted?: boolean | null, is_system_generated?: boolean | null } | null> | null };

export type CreateFeedbackMutationVariables = Exact<{
  input: CreateFeedbackInput;
}>;


export type CreateFeedbackMutation = { __typename?: 'Mutation', createFeedback?: { __typename?: 'Feedback', _id: string } | null };

export type AddFeedbackConversationMutationVariables = Exact<{
  input: AddConversationInput;
}>;


export type AddFeedbackConversationMutation = { __typename?: 'Mutation', addFeedbackConversation?: { __typename?: 'Feedback', _id: string, conversation?: Array<{ __typename?: 'ConversationMessage', _id?: string | null } | null> | null } | null };

export type GetFeedbacksQueryVariables = Exact<{
  input?: InputMaybe<FeedbackFilter>;
}>;


export type GetFeedbacksQuery = { __typename?: 'Query', getFeedbacks?: { __typename?: 'FeedbackResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, is_search_able?: boolean | null, is_visible?: boolean | null, search?: string | null, type?: string | null, filterValue?: Array<string | null> | null, column_data?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', search?: string | null, field?: string | null, type?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', is_visible?: string | null, name?: string | null } | null> | null } | null, results?: Array<{ __typename?: 'Feedback', _id: string, created_at?: any | null, feedback?: string | null, is_anonymous?: boolean | null, is_deleted?: boolean | null, status?: FeedbackStatus | null, ticket_id?: string | null, updated_at?: any | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, feedback_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null } | null, reviewed_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, id?: string | null } | null, submitted_by?: { __typename?: 'User', full_name?: string | null, last_name?: string | null, first_name?: string | null, email?: string | null } | null } | null> | null } | null };

export type GetFeedbackByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFeedbackByIdQuery = { __typename?: 'Query', getFeedbackById?: { __typename?: 'Feedback', _id: string, created_at?: any | null, feedback?: string | null, is_anonymous?: boolean | null, is_deleted?: boolean | null, status?: FeedbackStatus | null, ticket_id?: string | null, updated_at?: any | null, Department?: Array<{ __typename?: 'Department', department_name?: string | null, _id?: string | null } | null> | null, attached_files?: Array<{ __typename?: 'SupportingFileItem', file_name?: string | null, file_url?: string | null } | null> | null, conversation?: Array<{ __typename?: 'ConversationMessage', _id?: string | null, created_at?: any | null, is_internal_note?: boolean | null, message?: string | null, sender?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null> | null, feedback_type?: { __typename?: 'MasterDataValue', data_type?: { __typename?: 'MasterDataType', data_type_name?: string | null } | null } | null, reviewed_by?: { __typename?: 'User', full_name?: string | null } | null, submitted_by?: { __typename?: 'User', full_name?: string | null } | null } | null };

export type LmsTableConfigFieldsFragment = { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null };

export type LmsColumnFieldsFragment = { __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null };

export type LmsFilterFieldsFragment = { __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null };

export type LmsTablePresetFieldsFragment = { __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null };

export type LmsConfigFieldsFragment = { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null };

export type LmsLegacyDataTableConfigFieldsFragment = { __typename?: 'dataTableConfig', actions?: Array<string | null> | null, limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null };

export type LmsUserFieldsFragment = { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null };

export type LmsCategoryFieldsFragment = { __typename?: 'QuizCategoryDetails', id?: string | null, name?: string | null, is_deleted?: boolean | null, created_at?: any | null, questions?: number | null, sections?: Array<{ __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null, question_count?: number | null, is_deleted?: boolean | null } | null> | null };

export type LmsQuestionFieldsFragment = { __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null };

export type LmsQuizFieldsFragment = { __typename?: 'Quiz', id?: string | null, title?: string | null, description?: string | null, duration?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, passing_marks?: number | null, max_attempts?: number | null, question_count?: number | null, remarks?: string | null, language?: Array<LanguageCode | null> | null, is_random?: boolean | null, is_shuffling?: boolean | null, is_attempt_one_by_one?: boolean | null, can_assign_traning?: boolean | null, can_re_attempts?: string | null, candidates?: number | null, is_deleted?: boolean | null, created_at?: string | null, updated_at?: string | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, evaluator_department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, evaluator_role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, grade?: Array<{ __typename?: 'GradeType', grade?: string | null, percent?: number | null } | null> | null, category_sections?: Array<{ __typename?: 'CategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'QuestionSectionType', is_random?: boolean | null, limit?: number | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, QuizQuestion?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null }> } | null> | null };

export type LmsTrainingFieldsFragment = { __typename?: 'quizTrainingListing', id: string, title: string, description?: string | null, global_status?: string | null, created_at?: any | null, updated_at?: any | null, language?: Array<LanguageCode | null> | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null, all_assignee?: Array<{ __typename?: 'QuizTrainingUser', started_at?: any | null, ended_at?: any | null, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } } | null> | null } | null> | null, assign_to_department?: Array<{ __typename?: 'QuizTrainingDepartment', started_at?: any | null, ended_at?: any | null, Department: { __typename?: 'Department', _id?: string | null, department_name?: string | null }, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } }> | null } | null> | null, assign_to_role?: Array<{ __typename?: 'QuizTrainingRole', started_at?: any | null, ended_at?: any | null, Role: { __typename?: 'Role', _id?: string | null, roleName?: string | null }, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } }> | null } | null> | null };

export type LmsTrainingDetailFieldsFragment = { __typename?: 'MyQuizTrainingLists', id: string, title: string, description?: string | null, global_status?: string | null, status?: string | null, created_at?: any | null, updated_at?: any | null, language?: Array<string | null> | null, QuizTrainingCategory?: { __typename?: 'QuizTrainingCategory', id: string, name: string } | null, QuizTrainingSubCategory?: { __typename?: 'QuizTrainingSubCategory', id: string, name: string } | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null, all_assignee?: Array<{ __typename?: 'QuizTrainingUser', started_at?: any | null, ended_at?: any | null, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } } | null> | null } | null> | null, assign_to_department?: Array<{ __typename?: 'QuizTrainingDepartment', started_at?: any | null, ended_at?: any | null, Department: { __typename?: 'Department', _id?: string | null, department_name?: string | null }, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } }> | null } | null> | null, assign_to_role?: Array<{ __typename?: 'QuizTrainingRole', started_at?: any | null, ended_at?: any | null, Role: { __typename?: 'Role', _id?: string | null, roleName?: string | null }, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } }> | null } | null> | null };

export type LmsTrainingReplicaFieldsFragment = { __typename?: 'QuizTrainingReplica', id: string, title?: string | null, description?: string | null, global_status?: string | null, started_date?: any | null, due_date?: any | null, candidates?: number | null, default_language?: string | null, languages?: Array<string | null> | null, content?: any | null, is_deleted?: boolean | null, QuizTrainingCategory?: { __typename?: 'QuizTrainingCategory', id: string, name: string } | null, QuizTrainingSubCategory?: { __typename?: 'QuizTrainingSubCategory', id: string, name: string } | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null };

export type LmsAssignedQuizFieldsFragment = { __typename?: 'AssignedQuiz', id: string, title?: string | null, duration?: string | null, grade?: string | null, status?: string | null, is_active?: boolean | null, is_deleted?: boolean | null, is_graded?: boolean | null, percentage?: number | null, question_count?: number | null, quiz_start_time?: any | null, quiz_end_time?: any | null, start_time?: any | null, end_time?: any | null, total_score?: number | null, user_score?: number | null, language?: Array<string | null> | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, description?: string | null, duration?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, passing_marks?: number | null, max_attempts?: number | null, question_count?: number | null, remarks?: string | null, language?: Array<LanguageCode | null> | null, is_random?: boolean | null, is_shuffling?: boolean | null, is_attempt_one_by_one?: boolean | null, can_assign_traning?: boolean | null, can_re_attempts?: string | null, candidates?: number | null, is_deleted?: boolean | null, created_at?: string | null, updated_at?: string | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, evaluator_department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, evaluator_role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, grade?: Array<{ __typename?: 'GradeType', grade?: string | null, percent?: number | null } | null> | null, category_sections?: Array<{ __typename?: 'CategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'QuestionSectionType', is_random?: boolean | null, limit?: number | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, QuizQuestion?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null }> } | null> | null } | null, category_sections?: Array<{ __typename?: 'assignCategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'AssignQuestionSectionType', QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, question_answer?: Array<{ __typename?: 'question_answerType', QuizQuestion?: { __typename?: 'QuestionWithOutCorrectAnswer', id: string, question_text?: string | null, question_type?: string | null, description?: string | null, is_required?: boolean | null, attachment?: Array<string | null> | null, options?: Array<{ __typename?: 'OptionObject', id: string, images?: Array<string | null> | null, text?: string | null } | null> | null } | null } | null> | null }> } | null> | null };

export type LmsAssignedQuizReportFieldsFragment = { __typename?: 'AssignedQuizReport', id: string, title?: string | null, duration?: string | null, grade?: string | null, status?: string | null, is_active?: boolean | null, is_deleted?: boolean | null, is_graded?: boolean | null, percentage?: number | null, total_questions?: number | null, correct_questions?: number | null, start_time?: any | null, end_time?: any | null, total_score?: number | null, user_score?: number | null, language?: Array<string | null> | null, is_passed?: boolean | null, min_passing_score?: number | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, description?: string | null, duration?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, passing_marks?: number | null, max_attempts?: number | null, question_count?: number | null, remarks?: string | null, language?: Array<LanguageCode | null> | null, is_random?: boolean | null, is_shuffling?: boolean | null, is_attempt_one_by_one?: boolean | null, can_assign_traning?: boolean | null, can_re_attempts?: string | null, candidates?: number | null, is_deleted?: boolean | null, created_at?: string | null, updated_at?: string | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, evaluator_department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, evaluator_role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, grade?: Array<{ __typename?: 'GradeType', grade?: string | null, percent?: number | null } | null> | null, category_sections?: Array<{ __typename?: 'CategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'QuestionSectionType', is_random?: boolean | null, limit?: number | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, QuizQuestion?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null }> } | null> | null } | null, category_sections?: Array<{ __typename?: 'AssignCategorySectionTypeReport', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'AssignQuestionSectionTypeReport', QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, question_answer?: Array<{ __typename?: 'Question_answerTypeReport', selected_answer?: Array<string | null> | null, is_correct?: boolean | null, points_earned?: number | null, QuizQuestion?: { __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null } | null> | null }> } | null> | null };

export type LmsGetQuizCategoryListQueryVariables = Exact<{
  input?: InputMaybe<QuizCategoryListInput>;
}>;


export type LmsGetQuizCategoryListQuery = { __typename?: 'Query', getQuizCategoryListWIthSearch?: { __typename?: 'quizCategoryListResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'QuizCategoryDetails', id?: string | null, name?: string | null, is_deleted?: boolean | null, created_at?: any | null, questions?: number | null, sections?: Array<{ __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null, question_count?: number | null, is_deleted?: boolean | null } | null> | null } | null> | null } | null };

export type LmsGetQuizCategoryByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetQuizCategoryByIdQuery = { __typename?: 'Query', getQuizCategoryById?: { __typename?: 'QuizCategoryDetails', id?: string | null, name?: string | null, is_deleted?: boolean | null, created_at?: any | null, questions?: number | null, sections?: Array<{ __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null, question_count?: number | null, is_deleted?: boolean | null } | null> | null } | null };

export type LmsCreateQuizCategoryMutationVariables = Exact<{
  input: CreateCategoriesInput;
}>;


export type LmsCreateQuizCategoryMutation = { __typename?: 'Mutation', createQuizCategories?: boolean | null };

export type LmsUpdateQuizCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCategoriesInput;
}>;


export type LmsUpdateQuizCategoryMutation = { __typename?: 'Mutation', updateQuizCategories?: boolean | null };

export type LmsArchiveQuizCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type LmsArchiveQuizCategoryMutation = { __typename?: 'Mutation', archiveUnarchiveQuizCategory?: boolean | null };

export type LmsArchiveQuizCategorySectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type LmsArchiveQuizCategorySectionMutation = { __typename?: 'Mutation', archiveUnarchiveQuizCategorySection?: boolean | null };

export type LmsGetQuestionsQueryVariables = Exact<{
  input?: InputMaybe<QuizQuestionListInput>;
}>;


export type LmsGetQuestionsQuery = { __typename?: 'Query', getQuizQuestionListWIthSearch?: { __typename?: 'QuestionList', page?: number | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null, results?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null } | null };

export type LmsGetQuestionByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetQuestionByIdQuery = { __typename?: 'Query', getQuizQuestionById?: { __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null };

export type LmsGetQuestionByLanguageQueryVariables = Exact<{
  masterQuestionId: Scalars['ID']['input'];
  language: LanguageCode;
}>;


export type LmsGetQuestionByLanguageQuery = { __typename?: 'Query', getQuizQuestionByLanguage?: { __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null };

export type LmsGetQuestionsForSectionQueryVariables = Exact<{
  input?: InputMaybe<QuizQuestionInputs>;
}>;


export type LmsGetQuestionsForSectionQuery = { __typename?: 'Query', getQuizQuestions?: Array<{ __typename?: 'QuizQuestiones', id: string, question_text?: string | null, question_type?: string | null, description?: string | null, correct_answer?: Array<string | null> | null } | null> | null };

export type LmsCreateQuestionMutationVariables = Exact<{
  input: CreateQuestionInput;
}>;


export type LmsCreateQuestionMutation = { __typename?: 'Mutation', createQuizQuestion?: Array<{ __typename?: 'QuestionCreated', id?: string | null, master_question_id?: string | null, question_text?: string | null, question_type?: string | null } | null> | null };

export type LmsUpdateQuestionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpdateQuestionInput;
}>;


export type LmsUpdateQuestionMutation = { __typename?: 'Mutation', updateQuizQuestion?: boolean | null };

export type LmsArchiveQuestionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type LmsArchiveQuestionMutation = { __typename?: 'Mutation', archiveUnarchiveQuizQuestion?: boolean | null };

export type LmsVerifyQuestionTranslationMutationVariables = Exact<{
  masterQuestionId: Scalars['ID']['input'];
  language: LanguageCode;
}>;


export type LmsVerifyQuestionTranslationMutation = { __typename?: 'Mutation', verifyTranslation?: boolean | null };

export type LmsReRunQuestionTranslationMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
}>;


export type LmsReRunQuestionTranslationMutation = { __typename?: 'Mutation', reRunQuestionTranslation?: { __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null };

export type LmsGetQuizListQueryVariables = Exact<{
  input?: InputMaybe<QuizListInput>;
}>;


export type LmsGetQuizListQuery = { __typename?: 'Query', getQuizListWIthSearch?: { __typename?: 'quizListResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Quiz', id?: string | null, title?: string | null, description?: string | null, duration?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, passing_marks?: number | null, max_attempts?: number | null, question_count?: number | null, remarks?: string | null, language?: Array<LanguageCode | null> | null, is_random?: boolean | null, is_shuffling?: boolean | null, is_attempt_one_by_one?: boolean | null, can_assign_traning?: boolean | null, can_re_attempts?: string | null, candidates?: number | null, is_deleted?: boolean | null, created_at?: string | null, updated_at?: string | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, evaluator_department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, evaluator_role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, grade?: Array<{ __typename?: 'GradeType', grade?: string | null, percent?: number | null } | null> | null, category_sections?: Array<{ __typename?: 'CategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'QuestionSectionType', is_random?: boolean | null, limit?: number | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, QuizQuestion?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null }> } | null> | null } | null> | null } | null };

export type LmsGetQuizesForTrainingQueryVariables = Exact<{
  input?: InputMaybe<QuizListInput>;
}>;


export type LmsGetQuizesForTrainingQuery = { __typename?: 'Query', getQuizesForTraining?: { __typename?: 'quizListResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null> | null } | null };

export type LmsGetQuizByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetQuizByIdQuery = { __typename?: 'Query', getQuizById?: { __typename?: 'Quiz', id?: string | null, title?: string | null, description?: string | null, duration?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, passing_marks?: number | null, max_attempts?: number | null, question_count?: number | null, remarks?: string | null, language?: Array<LanguageCode | null> | null, is_random?: boolean | null, is_shuffling?: boolean | null, is_attempt_one_by_one?: boolean | null, can_assign_traning?: boolean | null, can_re_attempts?: string | null, candidates?: number | null, is_deleted?: boolean | null, created_at?: string | null, updated_at?: string | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, evaluator_department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, evaluator_role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, grade?: Array<{ __typename?: 'GradeType', grade?: string | null, percent?: number | null } | null> | null, category_sections?: Array<{ __typename?: 'CategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'QuestionSectionType', is_random?: boolean | null, limit?: number | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, QuizQuestion?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null }> } | null> | null } | null };

export type LmsGetQuizByIdForManualReAttemptedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetQuizByIdForManualReAttemptedQuery = { __typename?: 'Query', getQuizByIdForManualReAttemped?: { __typename?: 'Quiz', id?: string | null, title?: string | null, description?: string | null, duration?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, passing_marks?: number | null, max_attempts?: number | null, question_count?: number | null, remarks?: string | null, language?: Array<LanguageCode | null> | null, is_random?: boolean | null, is_shuffling?: boolean | null, is_attempt_one_by_one?: boolean | null, can_assign_traning?: boolean | null, can_re_attempts?: string | null, candidates?: number | null, is_deleted?: boolean | null, created_at?: string | null, updated_at?: string | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, evaluator_department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, evaluator_role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, grade?: Array<{ __typename?: 'GradeType', grade?: string | null, percent?: number | null } | null> | null, category_sections?: Array<{ __typename?: 'CategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'QuestionSectionType', is_random?: boolean | null, limit?: number | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, QuizQuestion?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null }> } | null> | null } | null };

export type LmsCreateQuizMutationVariables = Exact<{
  input: CreateQuizInput;
}>;


export type LmsCreateQuizMutation = { __typename?: 'Mutation', createQuiz?: boolean | null };

export type LmsUpdateQuizMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateQuizInput;
}>;


export type LmsUpdateQuizMutation = { __typename?: 'Mutation', updateQuiz?: boolean | null };

export type LmsArchiveQuizMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type LmsArchiveQuizMutation = { __typename?: 'Mutation', archiveUnarchiveQuiz?: boolean | null };

export type LmsGetUserQuizAssignmentsQueryVariables = Exact<{
  input?: InputMaybe<QuizUserListInput>;
}>;


export type LmsGetUserQuizAssignmentsQuery = { __typename?: 'Query', getUsersQuizAssignmentListWIthSearch?: { __typename?: 'QuizUserListResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'AssignedUserQuiz', id: string, title?: string | null, duration?: string | null, grade?: string | null, status?: string | null, percentage?: number | null, question_count?: number | null, total_score?: number | null, user_score?: number | null, quiz_start_time?: any | null, quiz_end_time?: any | null, start_time?: any | null, end_time?: any | null, invalidated_at?: any | null, invalidation_reason?: string | null, is_invalidated?: boolean | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null } | null> | null } | null };

export type LmsGetQuizAssignmentByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetQuizAssignmentByIdQuery = { __typename?: 'Query', getQuizAssignmentById?: { __typename?: 'AssignedQuiz', id: string, title?: string | null, duration?: string | null, grade?: string | null, status?: string | null, is_active?: boolean | null, is_deleted?: boolean | null, is_graded?: boolean | null, percentage?: number | null, question_count?: number | null, quiz_start_time?: any | null, quiz_end_time?: any | null, start_time?: any | null, end_time?: any | null, total_score?: number | null, user_score?: number | null, language?: Array<string | null> | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, description?: string | null, duration?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, passing_marks?: number | null, max_attempts?: number | null, question_count?: number | null, remarks?: string | null, language?: Array<LanguageCode | null> | null, is_random?: boolean | null, is_shuffling?: boolean | null, is_attempt_one_by_one?: boolean | null, can_assign_traning?: boolean | null, can_re_attempts?: string | null, candidates?: number | null, is_deleted?: boolean | null, created_at?: string | null, updated_at?: string | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, evaluator_department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, evaluator_role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, grade?: Array<{ __typename?: 'GradeType', grade?: string | null, percent?: number | null } | null> | null, category_sections?: Array<{ __typename?: 'CategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'QuestionSectionType', is_random?: boolean | null, limit?: number | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, QuizQuestion?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null }> } | null> | null } | null, category_sections?: Array<{ __typename?: 'assignCategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'AssignQuestionSectionType', QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, question_answer?: Array<{ __typename?: 'question_answerType', QuizQuestion?: { __typename?: 'QuestionWithOutCorrectAnswer', id: string, question_text?: string | null, question_type?: string | null, description?: string | null, is_required?: boolean | null, attachment?: Array<string | null> | null, options?: Array<{ __typename?: 'OptionObject', id: string, images?: Array<string | null> | null, text?: string | null } | null> | null } | null } | null> | null }> } | null> | null } | null };

export type LmsFetchQuizAssignmentByIdQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  quizId: Scalars['ID']['input'];
  quizTrainingReplicaId: Scalars['ID']['input'];
}>;


export type LmsFetchQuizAssignmentByIdQuery = { __typename?: 'Query', fetchQuizAssignmentById?: { __typename?: 'AssignedQuiz', id: string, title?: string | null, quiz_end_time?: any | null } | null };

export type LmsGetAttemptQuizByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  selectedLanguage: LanguageCode;
}>;


export type LmsGetAttemptQuizByIdQuery = { __typename?: 'Query', getAttemptQuizById?: { __typename?: 'AssignedQuiz', id: string, title?: string | null, duration?: string | null, grade?: string | null, status?: string | null, is_active?: boolean | null, is_deleted?: boolean | null, is_graded?: boolean | null, percentage?: number | null, question_count?: number | null, quiz_start_time?: any | null, quiz_end_time?: any | null, start_time?: any | null, end_time?: any | null, total_score?: number | null, user_score?: number | null, language?: Array<string | null> | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, description?: string | null, duration?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, passing_marks?: number | null, max_attempts?: number | null, question_count?: number | null, remarks?: string | null, language?: Array<LanguageCode | null> | null, is_random?: boolean | null, is_shuffling?: boolean | null, is_attempt_one_by_one?: boolean | null, can_assign_traning?: boolean | null, can_re_attempts?: string | null, candidates?: number | null, is_deleted?: boolean | null, created_at?: string | null, updated_at?: string | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, evaluator_department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, evaluator_role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, grade?: Array<{ __typename?: 'GradeType', grade?: string | null, percent?: number | null } | null> | null, category_sections?: Array<{ __typename?: 'CategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'QuestionSectionType', is_random?: boolean | null, limit?: number | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, QuizQuestion?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null }> } | null> | null } | null, category_sections?: Array<{ __typename?: 'assignCategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'AssignQuestionSectionType', QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, question_answer?: Array<{ __typename?: 'question_answerType', QuizQuestion?: { __typename?: 'QuestionWithOutCorrectAnswer', id: string, question_text?: string | null, question_type?: string | null, description?: string | null, is_required?: boolean | null, attachment?: Array<string | null> | null, options?: Array<{ __typename?: 'OptionObject', id: string, images?: Array<string | null> | null, text?: string | null } | null> | null } | null } | null> | null }> } | null> | null } | null };

export type LmsGetQuizReportByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  selectedLanguage: LanguageCode;
}>;


export type LmsGetQuizReportByIdQuery = { __typename?: 'Query', getQuizReportById?: { __typename?: 'AssignedQuizReport', id: string, title?: string | null, duration?: string | null, grade?: string | null, status?: string | null, is_active?: boolean | null, is_deleted?: boolean | null, is_graded?: boolean | null, percentage?: number | null, total_questions?: number | null, correct_questions?: number | null, start_time?: any | null, end_time?: any | null, total_score?: number | null, user_score?: number | null, language?: Array<string | null> | null, is_passed?: boolean | null, min_passing_score?: number | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, description?: string | null, duration?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, passing_marks?: number | null, max_attempts?: number | null, question_count?: number | null, remarks?: string | null, language?: Array<LanguageCode | null> | null, is_random?: boolean | null, is_shuffling?: boolean | null, is_attempt_one_by_one?: boolean | null, can_assign_traning?: boolean | null, can_re_attempts?: string | null, candidates?: number | null, is_deleted?: boolean | null, created_at?: string | null, updated_at?: string | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, evaluator_department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, evaluator_role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, grade?: Array<{ __typename?: 'GradeType', grade?: string | null, percent?: number | null } | null> | null, category_sections?: Array<{ __typename?: 'CategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'QuestionSectionType', is_random?: boolean | null, limit?: number | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, QuizQuestion?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null }> } | null> | null } | null, category_sections?: Array<{ __typename?: 'AssignCategorySectionTypeReport', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'AssignQuestionSectionTypeReport', QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, question_answer?: Array<{ __typename?: 'Question_answerTypeReport', selected_answer?: Array<string | null> | null, is_correct?: boolean | null, points_earned?: number | null, QuizQuestion?: { __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null } | null> | null }> } | null> | null } | null };

export type LmsStartQuizMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsStartQuizMutation = { __typename?: 'Mutation', startedQuiz?: boolean | null };

export type LmsAttemptQuizMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<AttemptInput>;
}>;


export type LmsAttemptQuizMutation = { __typename?: 'Mutation', attemptQuizAssignment?: boolean | null };

export type LmsCheckQuizMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<CheckerInput>;
}>;


export type LmsCheckQuizMutation = { __typename?: 'Mutation', checkerQuizAssignment?: boolean | null };

export type LmsGetQuizAssignmentListQueryVariables = Exact<{
  input?: InputMaybe<QuizAssignedListInput>;
}>;


export type LmsGetQuizAssignmentListQuery = { __typename?: 'Query', getQuizAssignmentListWIthSearch?: { __typename?: 'quizAssignedListResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'AssignedQuiz', id: string, title?: string | null, duration?: string | null, grade?: string | null, status?: string | null, is_active?: boolean | null, is_deleted?: boolean | null, is_graded?: boolean | null, percentage?: number | null, question_count?: number | null, quiz_start_time?: any | null, quiz_end_time?: any | null, start_time?: any | null, end_time?: any | null, total_score?: number | null, user_score?: number | null, language?: Array<string | null> | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, created_by?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, description?: string | null, duration?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, passing_marks?: number | null, max_attempts?: number | null, question_count?: number | null, remarks?: string | null, language?: Array<LanguageCode | null> | null, is_random?: boolean | null, is_shuffling?: boolean | null, is_attempt_one_by_one?: boolean | null, can_assign_traning?: boolean | null, can_re_attempts?: string | null, candidates?: number | null, is_deleted?: boolean | null, created_at?: string | null, updated_at?: string | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, evaluator_department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, evaluator_role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, grade?: Array<{ __typename?: 'GradeType', grade?: string | null, percent?: number | null } | null> | null, category_sections?: Array<{ __typename?: 'CategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'QuestionSectionType', is_random?: boolean | null, limit?: number | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, QuizQuestion?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null }> } | null> | null } | null, category_sections?: Array<{ __typename?: 'assignCategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'AssignQuestionSectionType', QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, question_answer?: Array<{ __typename?: 'question_answerType', QuizQuestion?: { __typename?: 'QuestionWithOutCorrectAnswer', id: string, question_text?: string | null, question_type?: string | null, description?: string | null, is_required?: boolean | null, attachment?: Array<string | null> | null, options?: Array<{ __typename?: 'OptionObject', id: string, images?: Array<string | null> | null, text?: string | null } | null> | null } | null } | null> | null }> } | null> | null } | null> | null, stats?: { __typename?: 'statsType', duration?: string | null, highest_score?: number | null, total_attempt?: number | null, total_completed?: number | null, total_condidate?: number | null, total_fail?: number | null, total_inprogress?: number | null, total_not_attempt?: number | null, total_pass?: number | null, total_to_be_attempt?: number | null, total_to_be_check?: number | null } | null } | null };

export type LmsGetEvaluatorAssignmentsQueryVariables = Exact<{
  input?: InputMaybe<QuizAssignedListInput>;
}>;


export type LmsGetEvaluatorAssignmentsQuery = { __typename?: 'Query', getEvaluatorQuizAssignmentListWIthSearch?: { __typename?: 'quizEvaluatorResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Quiz', id?: string | null, title?: string | null, description?: string | null, duration?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, passing_marks?: number | null, max_attempts?: number | null, question_count?: number | null, remarks?: string | null, language?: Array<LanguageCode | null> | null, is_random?: boolean | null, is_shuffling?: boolean | null, is_attempt_one_by_one?: boolean | null, can_assign_traning?: boolean | null, can_re_attempts?: string | null, candidates?: number | null, is_deleted?: boolean | null, created_at?: string | null, updated_at?: string | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, evaluator_department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, evaluator_role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, grade?: Array<{ __typename?: 'GradeType', grade?: string | null, percent?: number | null } | null> | null, category_sections?: Array<{ __typename?: 'CategorySectionType', QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, section_questions: Array<{ __typename?: 'QuestionSectionType', is_random?: boolean | null, limit?: number | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, QuizQuestion?: Array<{ __typename?: 'Question', id: string, master_question_id?: string | null, question_text?: string | null, question_type?: string | null, description?: string | null, duration?: string | null, correct_answer?: Array<string | null> | null, attachment?: Array<string | null> | null, is_required?: boolean | null, quiz_count?: number | null, human_verified?: boolean | null, language_statuses?: Array<{ __typename?: 'LanguageStatus', language?: string | null, human_verified?: boolean | null } | null> | null, QuizCategory?: { __typename?: 'QuizCategory', id?: string | null, name?: string | null } | null, QuizCategorySection?: { __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null } | null, options?: Array<{ __typename?: 'OptionObject', id: string, text?: string | null, images?: Array<string | null> | null } | null> | null } | null> | null }> } | null> | null } | null> | null } | null };

export type LmsGetTrainingListQueryVariables = Exact<{
  input?: InputMaybe<QuizTraningListInput>;
}>;


export type LmsGetTrainingListQuery = { __typename?: 'Query', getQuizTraningListWithSearch?: { __typename?: 'QuizTraningListingResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'quizTrainingListing', id: string, title: string, description?: string | null, global_status?: string | null, created_at?: any | null, updated_at?: any | null, language?: Array<LanguageCode | null> | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null, all_assignee?: Array<{ __typename?: 'QuizTrainingUser', started_at?: any | null, ended_at?: any | null, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } } | null> | null } | null> | null, assign_to_department?: Array<{ __typename?: 'QuizTrainingDepartment', started_at?: any | null, ended_at?: any | null, Department: { __typename?: 'Department', _id?: string | null, department_name?: string | null }, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } }> | null } | null> | null, assign_to_role?: Array<{ __typename?: 'QuizTrainingRole', started_at?: any | null, ended_at?: any | null, Role: { __typename?: 'Role', _id?: string | null, roleName?: string | null }, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } }> | null } | null> | null } | null> | null } | null };

export type LmsGetMyTrainingListQueryVariables = Exact<{
  input?: InputMaybe<QuizTraningListInput>;
}>;


export type LmsGetMyTrainingListQuery = { __typename?: 'Query', getMyQuizTraningListWithSearch?: { __typename?: 'MyQuizTraningListingResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'MyQuizTrainingLists', id: string, title: string, description?: string | null, global_status?: string | null, status?: string | null, created_at?: any | null, updated_at?: any | null, language?: Array<string | null> | null, QuizTrainingCategory?: { __typename?: 'QuizTrainingCategory', id: string, name: string } | null, QuizTrainingSubCategory?: { __typename?: 'QuizTrainingSubCategory', id: string, name: string } | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null, all_assignee?: Array<{ __typename?: 'QuizTrainingUser', started_at?: any | null, ended_at?: any | null, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } } | null> | null } | null> | null, assign_to_department?: Array<{ __typename?: 'QuizTrainingDepartment', started_at?: any | null, ended_at?: any | null, Department: { __typename?: 'Department', _id?: string | null, department_name?: string | null }, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } }> | null } | null> | null, assign_to_role?: Array<{ __typename?: 'QuizTrainingRole', started_at?: any | null, ended_at?: any | null, Role: { __typename?: 'Role', _id?: string | null, roleName?: string | null }, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } }> | null } | null> | null } | null> | null } | null };

export type LmsGetTrainingByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetTrainingByIdQuery = { __typename?: 'Query', getQuizTrainingById?: { __typename?: 'MyQuizTrainingLists', id: string, title: string, description?: string | null, global_status?: string | null, status?: string | null, created_at?: any | null, updated_at?: any | null, language?: Array<string | null> | null, QuizTrainingCategory?: { __typename?: 'QuizTrainingCategory', id: string, name: string } | null, QuizTrainingSubCategory?: { __typename?: 'QuizTrainingSubCategory', id: string, name: string } | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null, all_assignee?: Array<{ __typename?: 'QuizTrainingUser', started_at?: any | null, ended_at?: any | null, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } } | null> | null } | null> | null, assign_to_department?: Array<{ __typename?: 'QuizTrainingDepartment', started_at?: any | null, ended_at?: any | null, Department: { __typename?: 'Department', _id?: string | null, department_name?: string | null }, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } }> | null } | null> | null, assign_to_role?: Array<{ __typename?: 'QuizTrainingRole', started_at?: any | null, ended_at?: any | null, Role: { __typename?: 'Role', _id?: string | null, roleName?: string | null }, assigned_to_user?: Array<{ __typename?: 'QuizTrainingUserStatus', status: string, completed_date?: any | null, User: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } }> | null } | null> | null } | null };

export type LmsCreateTrainingMutationVariables = Exact<{
  input: CreateTrainingInput;
}>;


export type LmsCreateTrainingMutation = { __typename?: 'Mutation', createQuizTraining?: { __typename?: 'createResponseQuizTraining', id?: string | null, title?: string | null } | null };

export type LmsUpdateTrainingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTrainingInput;
}>;


export type LmsUpdateTrainingMutation = { __typename?: 'Mutation', updateQuizTraining?: boolean | null };

export type LmsArchiveTrainingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type LmsArchiveTrainingMutation = { __typename?: 'Mutation', archiveUnarchiveQuizTraning?: boolean | null };

export type LmsAssignTrainingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: QuizTrainingAssignToInput;
}>;


export type LmsAssignTrainingMutation = { __typename?: 'Mutation', quizTraningAssignTo?: boolean | null };

export type LmsAssignUsersToTrainingMutationVariables = Exact<{
  trainingId: Scalars['ID']['input'];
  input: AssignUsersToQuizAndTrainingInput;
}>;


export type LmsAssignUsersToTrainingMutation = { __typename?: 'Mutation', assignUsersToQuizAndTraining?: { __typename?: 'TraningRepecaCreateInputResult', id: string, title: string } | null };

export type LmsGetEvaluatorsQueryVariables = Exact<{
  input?: InputMaybe<EvaluatorInputs>;
}>;


export type LmsGetEvaluatorsQuery = { __typename?: 'Query', getEvaluators?: Array<{ __typename?: 'QuizEvaluatorList', Business?: string | null, _id?: string | null, email?: string | null, full_name?: string | null } | null> | null };

export type LmsGetTrainingReplicaListQueryVariables = Exact<{
  input?: InputMaybe<QuizTrainingReplicaListInput>;
}>;


export type LmsGetTrainingReplicaListQuery = { __typename?: 'Query', getQuizTrainingReplicaListWIthSearch?: { __typename?: 'quizTrainingReplicaListResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, stats?: { __typename?: 'statsType', total_completed?: number | null, total_condidate?: number | null, total_inprogress?: number | null, total_to_be_attempt?: number | null, total_not_attempt?: number | null, total_pass?: number | null, total_fail?: number | null } | null, results?: Array<{ __typename?: 'QuizTrainingReplica', id: string, title?: string | null, description?: string | null, global_status?: string | null, started_date?: any | null, due_date?: any | null, candidates?: number | null, default_language?: string | null, languages?: Array<string | null> | null, content?: any | null, is_deleted?: boolean | null, QuizTrainingCategory?: { __typename?: 'QuizTrainingCategory', id: string, name: string } | null, QuizTrainingSubCategory?: { __typename?: 'QuizTrainingSubCategory', id: string, name: string } | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null } | null> | null } | null };

export type LmsGetTrainingReplicaByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetTrainingReplicaByIdQuery = { __typename?: 'Query', getQuizTrainingReplicaById?: { __typename?: 'QuizTrainingReplica', id: string, title?: string | null, description?: string | null, global_status?: string | null, started_date?: any | null, due_date?: any | null, candidates?: number | null, default_language?: string | null, languages?: Array<string | null> | null, content?: any | null, is_deleted?: boolean | null, QuizTrainingCategory?: { __typename?: 'QuizTrainingCategory', id: string, name: string } | null, QuizTrainingSubCategory?: { __typename?: 'QuizTrainingSubCategory', id: string, name: string } | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null } | null };

export type LmsUpdateTrainingReplicaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTraininReplicagInput;
}>;


export type LmsUpdateTrainingReplicaMutation = { __typename?: 'Mutation', updateQuizTrainingReplica?: boolean | null };

export type LmsFilterTrainingAssignmentsQueryVariables = Exact<{
  trainingReplicaId: Scalars['ID']['input'];
  input?: InputMaybe<QuizTrainingAssignmentFilterInput>;
}>;


export type LmsFilterTrainingAssignmentsQuery = { __typename?: 'Query', filterQuizTrainingAssignement?: Array<{ __typename?: 'filterTrainingAssignementResult', _id?: string | null, full_name?: string | null, email?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, training_start_time?: any | null, training_end_time?: any | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null } | null> | null };

export type LmsGetTrainingAssignmentsQueryVariables = Exact<{
  input?: InputMaybe<QuizTraningAssignementUserListInput>;
}>;


export type LmsGetTrainingAssignmentsQuery = { __typename?: 'Query', getQuizTrainingAssignmentListWIthSearch?: { __typename?: 'quizTrainingAssignmentListResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'QuizTrainingAssignementListResult', _id?: string | null, title?: string | null, description?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, training_start_time?: any | null, training_end_time?: any | null, content?: any | null, languages?: Array<string | null> | null, matrix_section?: string | null, invalidated_at?: any | null, invalidation_reason?: string | null, is_invalidated?: boolean | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, QuizTrainingReplica?: { __typename?: 'QuizTrainingReplica', id: string, title?: string | null, description?: string | null, global_status?: string | null, started_date?: any | null, due_date?: any | null, candidates?: number | null, default_language?: string | null, languages?: Array<string | null> | null, content?: any | null, is_deleted?: boolean | null, QuizTrainingCategory?: { __typename?: 'QuizTrainingCategory', id: string, name: string } | null, QuizTrainingSubCategory?: { __typename?: 'QuizTrainingSubCategory', id: string, name: string } | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null } | null, QuizTrainingCategory?: { __typename?: 'QuizTrainingCategory', id: string, name: string } | null, QuizTrainingSubCategory?: { __typename?: 'QuizTrainingSubCategory', id: string, name: string } | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null } | null> | null } | null };

export type LmsGetTrainingAssignmentByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetTrainingAssignmentByIdQuery = { __typename?: 'Query', getQuizTrainingAssignementById?: { __typename?: 'QuizTrainingAssignementListResult', _id?: string | null, title?: string | null, description?: string | null, status?: string | null, start_time?: any | null, end_time?: any | null, training_start_time?: any | null, training_end_time?: any | null, content?: any | null, languages?: Array<string | null> | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, QuizTrainingReplica?: { __typename?: 'QuizTrainingReplica', id: string, title?: string | null, description?: string | null, global_status?: string | null, started_date?: any | null, due_date?: any | null, candidates?: number | null, default_language?: string | null, languages?: Array<string | null> | null, content?: any | null, is_deleted?: boolean | null, QuizTrainingCategory?: { __typename?: 'QuizTrainingCategory', id: string, name: string } | null, QuizTrainingSubCategory?: { __typename?: 'QuizTrainingSubCategory', id: string, name: string } | null, Quiz?: { __typename?: 'Quiz', id?: string | null, title?: string | null, status?: string | null } | null, evaluate_by?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null, dimension?: number | null } | null> | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null } | null, QuizTrainingCategory?: { __typename?: 'QuizTrainingCategory', id: string, name: string } | null, QuizTrainingSubCategory?: { __typename?: 'QuizTrainingSubCategory', id: string, name: string } | null, attachments?: Array<{ __typename?: 'QuizTrainingAttachment', _id?: string | null, file?: string | null, file_name?: string | null, language?: string | null, size?: string | null, type?: string | null, is_completed?: boolean | null }> | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null } | null };

export type LmsUpdateTrainingAssignmentStatusMutationVariables = Exact<{
  input: UpdateQuizTrainingAssignmentStatusInput;
}>;


export type LmsUpdateTrainingAssignmentStatusMutation = { __typename?: 'Mutation', updateQuizTrainingAssignmentStatus?: boolean | null };

export type LmsUpdateUserAttachmentStatusMutationVariables = Exact<{
  trainingId: Scalars['ID']['input'];
  input: UpdateTrainingAttachementStatus;
}>;


export type LmsUpdateUserAttachmentStatusMutation = { __typename?: 'Mutation', updateUserAttachmentStatus?: { __typename?: 'MyQuizTrainingLists', id: string, title: string } | null };

export type LmsUpdateTrainingAssigneeAttachmentStatusMutationVariables = Exact<{
  trainingAssignmentId: Scalars['ID']['input'];
  input: UpdateTrainingAttachementStatus;
}>;


export type LmsUpdateTrainingAssigneeAttachmentStatusMutation = { __typename?: 'Mutation', updateTrainingAssigneeAttachmentStatus?: { __typename?: 'QuizTrainingAssignementListResult', _id?: string | null, status?: string | null } | null };

export type LmsUpdateTrainingAssigneeLinkStatusMutationVariables = Exact<{
  trainingAssignmentId: Scalars['ID']['input'];
  input: UpdateTrainingLinkStatus;
}>;


export type LmsUpdateTrainingAssigneeLinkStatusMutation = { __typename?: 'Mutation', updateTrainingAssigneeLinkStatus?: { __typename?: 'QuizTrainingAssignementListResult', _id?: string | null, status?: string | null, title?: string | null, links?: Array<{ __typename?: 'QuizTrainingLink', _id?: string | null, url?: string | null, language?: string | null, is_completed?: boolean | null } | null> | null } | null };

export type LmsUpdateTraineeStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: QuizTrainingUpdateStatus;
}>;


export type LmsUpdateTraineeStatusMutation = { __typename?: 'Mutation', updateTraineStatus?: boolean | null };

export type LmsAssigneeFilterByStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status?: InputMaybe<TrainingAssignStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type LmsAssigneeFilterByStatusMutation = { __typename?: 'Mutation', assigneeFilterByStatus: Array<{ __typename?: 'AssigneeFilteredByStatus', title?: string | null, type?: string | null, start_time?: any | null, end_time?: any | null, user?: { __typename?: 'AssigneeUserData', full_name?: string | null, email?: string | null, status?: string | null, completed_date?: any | null } | null } | null> };

export type LmsGetTrainingSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type LmsGetTrainingSettingsQuery = { __typename?: 'Query', getTrainingSettings?: { __typename?: 'TrainingSettings', _id: string, min_passing_score?: number | null, failure_escalation_threshold?: number | null, reminder_frequency_days?: number | null, mandatory_min_passing_score?: number | null, mandatory_failure_escalation_threshold?: number | null, mandatory_reminder_frequency_days?: number | null, departmental_min_passing_score?: number | null, departmental_failure_escalation_threshold?: number | null, departmental_reminder_frequency_days?: number | null, onboarding_min_passing_score?: number | null, onboarding_failure_escalation_threshold?: number | null, onboarding_reminder_frequency_days?: number | null, created_at?: any | null, updated_at?: any | null } | null };

export type LmsCreateTrainingSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type LmsCreateTrainingSettingsMutation = { __typename?: 'Mutation', createTrainingSettings?: { __typename?: 'TrainingSettings', _id: string, min_passing_score?: number | null, failure_escalation_threshold?: number | null, reminder_frequency_days?: number | null, mandatory_min_passing_score?: number | null, mandatory_failure_escalation_threshold?: number | null, mandatory_reminder_frequency_days?: number | null, departmental_min_passing_score?: number | null, departmental_failure_escalation_threshold?: number | null, departmental_reminder_frequency_days?: number | null, onboarding_min_passing_score?: number | null, onboarding_failure_escalation_threshold?: number | null, onboarding_reminder_frequency_days?: number | null } | null };

export type LmsUpdateTrainingSettingsMutationVariables = Exact<{
  input: TrainingSettingsUpdateInput;
}>;


export type LmsUpdateTrainingSettingsMutation = { __typename?: 'Mutation', updateTrainingSettings?: { __typename?: 'TrainingSettings', _id: string, min_passing_score?: number | null, failure_escalation_threshold?: number | null, reminder_frequency_days?: number | null, mandatory_min_passing_score?: number | null, mandatory_failure_escalation_threshold?: number | null, mandatory_reminder_frequency_days?: number | null, departmental_min_passing_score?: number | null, departmental_failure_escalation_threshold?: number | null, departmental_reminder_frequency_days?: number | null, onboarding_min_passing_score?: number | null, onboarding_failure_escalation_threshold?: number | null, onboarding_reminder_frequency_days?: number | null } | null };

export type LmsGetAllExternalVendorTrainingsQueryVariables = Exact<{
  input?: InputMaybe<ExternalVendorTrainingListInput>;
}>;


export type LmsGetAllExternalVendorTrainingsQuery = { __typename?: 'Query', getAllExternalVendorTrainings?: { __typename?: 'ExternalVendorTrainingList', results?: Array<{ __typename?: 'ExternalVendorTraining', _id: string, training_name?: string | null, provider?: string | null, comments?: string | null, completion_date?: any | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type LmsGetExternalVendorTrainingsByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetExternalVendorTrainingsByIdQuery = { __typename?: 'Query', getExternalVendorTrainingsById?: { __typename?: 'ExternalVendorTraining', _id: string, training_name?: string | null, provider?: string | null, completion_date?: any | null, comments?: string | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null };

export type LmsCreateExternalVendorTrainingMutationVariables = Exact<{
  input: CreateExternalVendorTrainingInput;
}>;


export type LmsCreateExternalVendorTrainingMutation = { __typename?: 'Mutation', createExternalVendorTraining: Array<{ __typename?: 'ExternalVendorTraining', _id: string, training_name?: string | null, provider?: string | null, completion_date?: any | null } | null> };

export type LmsUpdateExternalVendorTrainingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateExternalVendorTrainingInput;
}>;


export type LmsUpdateExternalVendorTrainingMutation = { __typename?: 'Mutation', updateExternalVendorTraining?: { __typename?: 'ExternalVendorTraining', _id: string, training_name?: string | null, provider?: string | null, completion_date?: any | null } | null };

export type LmsDeleteExternalVendorTrainingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsDeleteExternalVendorTrainingMutation = { __typename?: 'Mutation', deleteExternalVendorTraining?: boolean | null };

export type LmsGetAllOrientationTrackingQueryVariables = Exact<{
  input?: InputMaybe<OrientationTrackingListInput>;
}>;


export type LmsGetAllOrientationTrackingQuery = { __typename?: 'Query', getAllOrientationTracking?: { __typename?: 'OrientationTrackingList', results?: Array<{ __typename?: 'OrientationTracking', _id: string, delivery_method?: string | null, orientation_date?: any | null, acknowledged_at?: any | null, status?: string | null, created_at?: any | null, updated_at?: any | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, employee_id?: string | null, email?: string | null } | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type LmsGetOrientationTrackingByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetOrientationTrackingByIdQuery = { __typename?: 'Query', getOrientationTrackingById?: { __typename?: 'OrientationTracking', _id: string, delivery_method?: string | null, orientation_date?: any | null, acknowledged_at?: any | null, status?: string | null, created_at?: any | null, updated_at?: any | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null } | null } | null };

export type LmsGetMyOrientationTrackingQueryVariables = Exact<{ [key: string]: never; }>;


export type LmsGetMyOrientationTrackingQuery = { __typename?: 'Query', getMyOrientationTracking?: { __typename?: 'OrientationTracking', _id: string, delivery_method?: string | null, orientation_date?: any | null, acknowledged_at?: any | null, status?: string | null, created_at?: any | null, updated_at?: any | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, employee_id?: string | null, email?: string | null } | null } | null };

export type LmsUpdateOrientationDetailsMutationVariables = Exact<{
  input: UpdateOrientationDetailsInput;
}>;


export type LmsUpdateOrientationDetailsMutation = { __typename?: 'Mutation', updateOrientationDetails?: { __typename?: 'OrientationTracking', _id: string, delivery_method?: string | null, orientation_date?: any | null, acknowledged_at?: any | null, status?: string | null } | null };

export type LmsAcknowledgeOrientationMutationVariables = Exact<{ [key: string]: never; }>;


export type LmsAcknowledgeOrientationMutation = { __typename?: 'Mutation', acknowledgeOrientation?: { __typename?: 'OrientationTracking', _id: string, delivery_method?: string | null, orientation_date?: any | null, acknowledged_at?: any | null, status?: string | null } | null };

export type LmsGetTrainingCyclesQueryVariables = Exact<{
  input?: InputMaybe<TrainingCycleListInput>;
}>;


export type LmsGetTrainingCyclesQuery = { __typename?: 'Query', getTrainingCycles?: { __typename?: 'TrainingCycleList', results?: Array<{ __typename?: 'TrainingCycle', _id?: string | null, name?: string | null, matrix_section?: CycleMatrixSection | null, status?: string | null, type?: string | null, start_date?: any | null, end_date?: any | null, is_active?: boolean | null, created_at?: any | null, updated_at?: any | null, assignTo?: Array<{ __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null } | null> | null, targetDepartments?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type LmsCreateRefresherCycleMutationVariables = Exact<{
  input?: InputMaybe<CreateRefresherCycleInput>;
}>;


export type LmsCreateRefresherCycleMutation = { __typename?: 'Mutation', createRefresherCycle?: { __typename?: 'TrainingCycle', _id?: string | null, name?: string | null, matrix_section?: CycleMatrixSection | null, status?: string | null, type?: string | null, start_date?: any | null, end_date?: any | null, is_active?: boolean | null } | null };

export type LmsDeleteRefresherCycleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsDeleteRefresherCycleMutation = { __typename?: 'Mutation', deleteRefresherCycle: { __typename?: 'DeleteCycleResponse', success: boolean, message: string } };

export type LmsGetAllMilestoneTrackingQueryVariables = Exact<{
  input?: InputMaybe<MilestoneTrackingListInput>;
}>;


export type LmsGetAllMilestoneTrackingQuery = { __typename?: 'Query', getAllMilestoneTracking?: { __typename?: 'MilestoneTrackingList', results?: Array<{ __typename?: 'MilestoneTracking', _id: string, milestone_type?: string | null, admin_mode?: string | null, score_percentage?: number | null, evidence_doc?: string | null, meeting_date?: any | null, outcome_notes?: string | null, completion_date?: any | null, deadline_date?: any | null, status?: string | null, created_at?: any | null, updated_at?: any | null, User?: { __typename?: 'User', _id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type LmsGetMilestoneTrackingByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetMilestoneTrackingByIdQuery = { __typename?: 'Query', getMilestoneTrackingById?: { __typename?: 'MilestoneTracking', _id: string, milestone_type?: string | null, admin_mode?: string | null, score_percentage?: number | null, evidence_doc?: string | null, meeting_date?: any | null, outcome_notes?: string | null, completion_date?: any | null, deadline_date?: any | null, status?: string | null, User?: { __typename?: 'User', _id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null } | null };

export type LmsRecordExternalAssessmentMutationVariables = Exact<{
  input: RecordExternalAssessmentInput;
}>;


export type LmsRecordExternalAssessmentMutation = { __typename?: 'Mutation', recordExternalAssessment?: { __typename?: 'MilestoneTracking', _id: string, milestone_type?: string | null, score_percentage?: number | null, evidence_doc?: string | null, completion_date?: any | null, status?: string | null } | null };

export type LmsRecordPerformanceMeetingMutationVariables = Exact<{
  input: RecordPerformanceMeetingInput;
}>;


export type LmsRecordPerformanceMeetingMutation = { __typename?: 'Mutation', recordPerformanceMeeting?: { __typename?: 'MilestoneTracking', _id: string, milestone_type?: string | null, meeting_date?: any | null, outcome_notes?: string | null, status?: string | null } | null };

export type LmsGetTrainingMatrixListQueryVariables = Exact<{
  input?: InputMaybe<TrainingMatrixFilter>;
}>;


export type LmsGetTrainingMatrixListQuery = { __typename?: 'Query', getTrainingMatrixList?: { __typename?: 'TrainingMatrixResult', results?: Array<{ __typename?: 'TrainingMatrix', _id: string, section: TrainingMatrixSection, milestone_type?: MilestoneType | null, admin_mode?: AdminMode | null, deadline_days?: number | null, is_active?: boolean | null, created_at?: any | null, updated_at?: any | null, Department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, Designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null, QuizTraining?: Array<{ __typename?: 'QuizTrainingEntry', is_required?: boolean | null, training?: { __typename?: 'QuizTraining', _id?: string | null, title?: string | null } | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, email?: string | null } | null> | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type LmsGetTrainingMatrixByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetTrainingMatrixByIdQuery = { __typename?: 'Query', getTrainingMatrixById?: { __typename?: 'TrainingMatrix', _id: string, section: TrainingMatrixSection, milestone_type?: MilestoneType | null, admin_mode?: AdminMode | null, deadline_days?: number | null, is_active?: boolean | null, Department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null, Designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null, QuizTraining?: Array<{ __typename?: 'QuizTrainingEntry', is_required?: boolean | null, training?: { __typename?: 'QuizTraining', _id?: string | null, title?: string | null } | null } | null> | null, evaluate_by?: Array<{ __typename?: 'User', id?: string | null, _id?: string | null, full_name?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null } | null> | null } | null };

export type LmsCreateTrainingMatrixMutationVariables = Exact<{
  input: TrainingMatrixInput;
}>;


export type LmsCreateTrainingMatrixMutation = { __typename?: 'Mutation', createTrainingMatrix?: { __typename?: 'TrainingMatrix', _id: string } | null };

export type LmsUpdateTrainingMatrixMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TrainingMatrixUpdateInput;
}>;


export type LmsUpdateTrainingMatrixMutation = { __typename?: 'Mutation', updateTrainingMatrix?: { __typename?: 'TrainingMatrix', _id: string, deadline_days?: number | null, is_active?: boolean | null } | null };

export type LmsDeleteTrainingMatrixByIdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsDeleteTrainingMatrixByIdMutation = { __typename?: 'Mutation', deleteTrainingMatrixById?: boolean | null };

export type LmsGetComplianceDashboardQueryVariables = Exact<{
  input?: InputMaybe<ComplianceDashboardInput>;
}>;


export type LmsGetComplianceDashboardQuery = { __typename?: 'Query', getComplianceDashboard?: { __typename?: 'ComplianceDashboardResult', totalCount?: number | null, headerStats?: { __typename?: 'ComplianceHeaderStats', total_employees_pending?: number | null, total_trainings_outstanding?: number | null, overdue_count?: number | null, on_track_count?: number | null, not_yet_emailed_count?: number | null, employees_at_failure_threshold?: number | null } | null, employees?: Array<{ __typename?: 'EmployeeComplianceResult', employee_id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, outstanding_count?: number | null, overdue_count?: number | null, at_failure_threshold?: boolean | null, last_email_sent_at?: any | null, last_reminder_sent_at?: any | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null } | null> | null, departmentBreakdown?: Array<{ __typename?: 'DepartmentComplianceSummary', completion_percentage?: number | null, department_id?: string | null, department_name?: string | null, total_employees?: number | null, employees_completed_all_trainings?: number | null, employees_with_pending_trainings?: number | null, overdue_trainings_count?: number | null } | null> | null } | null };

export type LmsGetComplianceDashboardDataTableQueryVariables = Exact<{
  input?: InputMaybe<ComplianceDashboardListInput>;
}>;


export type LmsGetComplianceDashboardDataTableQuery = { __typename?: 'Query', getComplianceDashboardDataTable?: { __typename?: 'ComplianceDashboardList', results?: Array<{ __typename?: 'EmployeeComplianceResult', employee_id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, outstanding_count?: number | null, overdue_count?: number | null, at_failure_threshold?: boolean | null, last_email_sent_at?: any | null, last_reminder_sent_at?: any | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, headerStats?: { __typename?: 'ComplianceHeaderStats', total_employees_pending?: number | null, total_trainings_outstanding?: number | null, overdue_count?: number | null, on_track_count?: number | null, not_yet_emailed_count?: number | null, employees_at_failure_threshold?: number | null } | null } | null };

export type LmsGetComplianceDashboardStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type LmsGetComplianceDashboardStatsQuery = { __typename?: 'Query', getComplianceDashboardStats?: { __typename?: 'ComplianceHeaderStats', total_employees_pending?: number | null, total_trainings_outstanding?: number | null, overdue_count?: number | null, on_track_count?: number | null, not_yet_emailed_count?: number | null, employees_at_failure_threshold?: number | null } | null };

export type LmsGetDepartmentComplianceSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type LmsGetDepartmentComplianceSummaryQuery = { __typename?: 'Query', getDepartmentComplianceSummary?: Array<{ __typename?: 'DepartmentComplianceSummary', completion_percentage?: number | null, department_id?: string | null, department_name?: string | null, total_employees?: number | null, employees_completed_all_trainings?: number | null, employees_with_pending_trainings?: number | null, overdue_trainings_count?: number | null } | null> | null };

export type LmsGetEmployeeTrainingProfileQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
}>;


export type LmsGetEmployeeTrainingProfileQuery = { __typename?: 'Query', getEmployeeTrainingProfile?: { __typename?: 'EmployeeTrainingProfile', employee?: { __typename?: 'EmployeeBasicInfo', full_name?: string | null, employee_id?: string | null, first_name?: string | null, last_name?: string | null, department?: Array<{ __typename?: 'Department', department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', designation_name?: string | null } | null } | null, orientation?: { __typename?: 'ComplianceOrientation', _id?: string | null, status?: string | null, orientation_date?: any | null, acknowledged_at?: any | null, delivery_method?: string | null } | null, milestone?: { __typename?: 'ComplianceMilestone', _id?: string | null, status?: string | null, milestone_type?: string | null, admin_mode?: string | null, deadline_date?: any | null, completion_date?: any | null, urgency_status?: UrgencyStatus | null } | null, trainings?: Array<{ __typename?: 'TrainingProfileItem', title?: string | null, matrix_section?: MatrixSection | null, status?: string | null, score_percentage?: number | null, attempt_count?: number | null, due_date?: any | null, urgency_status?: UrgencyStatus | null, failure_counter?: number | null, completion_date?: any | null, cycle_id?: string | null, assignment_id?: string | null, escalation_triggered?: boolean | null, attempts?: Array<{ __typename?: 'TrainingAttempt', attempt_number?: number | null, score?: number | null, is_passed?: boolean | null } | null> | null } | null> | null, external_trainings?: Array<{ __typename?: 'ExternalVendorTrainingProfileItem', _id?: string | null, training_name?: string | null, completion_date?: any | null, created_at?: any | null, provider?: string | null } | null> | null } | null };

export type LmsGetEmployeeTrainingStatsQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
}>;


export type LmsGetEmployeeTrainingStatsQuery = { __typename?: 'Query', getEmployeeTrainingStats?: { __typename?: 'EmployeeTrainingStats', total?: number | null, completed?: number | null, outstanding?: number | null, overdue?: number | null } | null };

export type LmsGetEmployeeTrainingProfileAssignmentsQueryVariables = Exact<{
  input?: InputMaybe<EmployeeTrainingProfileListInput>;
}>;


export type LmsGetEmployeeTrainingProfileAssignmentsQuery = { __typename?: 'Query', getEmployeeTrainingAssignments?: { __typename?: 'EmployeeTrainingProfileList', results?: Array<{ __typename?: 'EmployeeTrainingProfileResult', _id: string, title?: string | null, matrix_section?: string | null, status?: string | null, compliance_status?: string | null, quiz_score_percentage?: number | null, training_start_time?: any | null, training_end_time?: any | null, failure_counter?: number | null, escalation_triggered?: boolean | null, is_reattempt?: boolean | null, urgency_status?: string | null, completion_date?: string | null, counter_reset_active?: boolean | null, was_counter_reset?: boolean | null, cycle_id?: { __typename?: 'CycleInfo', _id?: string | null, name?: string | null } | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type LmsGetTrainingAttemptHistoryQueryVariables = Exact<{
  input?: InputMaybe<TrainingAttemptHistoryListInput>;
}>;


export type LmsGetTrainingAttemptHistoryQuery = { __typename?: 'Query', getTrainingAttemptHistory?: { __typename?: 'TrainingAttemptHistoryList', results?: Array<{ __typename?: 'TrainingAttemptHistoryResult', _id?: string | null, title?: string | null, attempt_number?: number | null, percentage?: number | null, is_passed?: boolean | null, created_at?: string | null, end_time?: string | null, total_score?: number | null, user_score?: number | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type LmsGetTrainingFailureResetLogsQueryVariables = Exact<{
  input?: InputMaybe<TrainingFailureResetLogListInput>;
}>;


export type LmsGetTrainingFailureResetLogsQuery = { __typename?: 'Query', getTrainingFailureResetLogs?: { __typename?: 'TrainingFailureResetLogList', results?: Array<{ __typename?: 'TrainingFailureResetLog', _id?: string | null, note?: string | null, previous_failure_count?: number | null, created_at?: string | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null, reset_by?: { __typename?: 'User', _id?: string | null, id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null, QuizTrainingAssignment?: { __typename?: 'QuizTrainingAssignementListResult', _id?: string | null, title?: string | null, status?: string | null, matrix_section?: string | null } | null } | null> | null, config?: { __typename?: 'dataTableConfig', actions?: Array<string | null> | null, limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type LmsResetEmployeeFailureCounterMutationVariables = Exact<{
  input: ResetFailureCounterInput;
}>;


export type LmsResetEmployeeFailureCounterMutation = { __typename?: 'Mutation', resetEmployeeFailureCounter?: { __typename?: 'ResetFailureCounterResponse', message?: string | null } | null };

export type LmsTriggerComplianceSummaryEmailMutationVariables = Exact<{
  input?: InputMaybe<ComplianceSummaryEmailInput>;
}>;


export type LmsTriggerComplianceSummaryEmailMutation = { __typename?: 'Mutation', triggerComplianceSummaryEmail?: boolean | null };

export type LmsSendManualReminderMutationVariables = Exact<{
  input: SendManualReminderInput;
}>;


export type LmsSendManualReminderMutation = { __typename?: 'Mutation', sendManualReminder?: boolean | null };

export type LmsSendTrainingAssignmentEmailMutationVariables = Exact<{
  input: SendTrainingAssignmentEmailInput;
}>;


export type LmsSendTrainingAssignmentEmailMutation = { __typename?: 'Mutation', sendTrainingAssignmentEmail?: boolean | null };

export type LmsTrainingCategoryFieldsFragment = { __typename?: 'QuizTrainingCategoryDetails', id?: string | null, name?: string | null, is_deleted?: boolean | null, created_at?: any | null, sub_categories?: Array<{ __typename?: 'QuizTrainingSubCategorySection', _id?: string | null, name?: string | null, is_deleted?: boolean | null } | null> | null };

export type LmsTrainingCategoryListFieldsFragment = { __typename?: 'QuizTrainingCategoryDetails', id?: string | null, name?: string | null, is_deleted?: boolean | null, created_at?: any | null, sub_categories?: Array<{ __typename?: 'QuizTrainingSubCategorySection', name?: string | null, is_deleted?: boolean | null } | null> | null };

export type LmsGetTrainingCategoryListQueryVariables = Exact<{
  input?: InputMaybe<QuizCategoryListInput>;
}>;


export type LmsGetTrainingCategoryListQuery = { __typename?: 'Query', getQuizTrainingCategoryListWIthSearch?: { __typename?: 'quizTrainingCategoryListResult', config?: { __typename?: 'UpdatedDataTableConfig', limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'QuizTrainingCategoryDetails', id?: string | null, name?: string | null, is_deleted?: boolean | null, created_at?: any | null, sub_categories?: Array<{ __typename?: 'QuizTrainingSubCategorySection', name?: string | null, is_deleted?: boolean | null } | null> | null } | null> | null } | null };

export type LmsGetTrainingCategoryByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetTrainingCategoryByIdQuery = { __typename?: 'Query', getQuizTrainingCategoryById?: { __typename?: 'QuizTrainingCategoryDetails', id?: string | null, name?: string | null, is_deleted?: boolean | null, created_at?: any | null, sub_categories?: Array<{ __typename?: 'QuizTrainingSubCategorySection', _id?: string | null, name?: string | null, is_deleted?: boolean | null } | null> | null } | null };

export type LmsCreateTrainingCategoryMutationVariables = Exact<{
  input: TrainingCategoriesInput;
}>;


export type LmsCreateTrainingCategoryMutation = { __typename?: 'Mutation', createQuizTarainingCategories?: boolean | null };

export type LmsUpdateTrainingCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTrainingCategoriesInput;
}>;


export type LmsUpdateTrainingCategoryMutation = { __typename?: 'Mutation', updateQuizTrainingCategories?: boolean | null };

export type LmsArchiveTrainingCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type LmsArchiveTrainingCategoryMutation = { __typename?: 'Mutation', archiveUnarchiveQuizTrainingCategory?: boolean | null };

export type LmsArchiveTrainingSubCategoryMutationVariables = Exact<{
  input?: InputMaybe<DeleteSubCategoryInput>;
}>;


export type LmsArchiveTrainingSubCategoryMutation = { __typename?: 'Mutation', archiveUnarchiveQuizTrainingSubCategory?: boolean | null };

export type LmsGetSubCategoriesByCategoryQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type LmsGetSubCategoriesByCategoryQuery = { __typename?: 'Query', getSubCategoriesByCategory?: Array<{ __typename?: 'QuizTrainingSubCategorySection', _id?: string | null, name?: string | null, is_deleted?: boolean | null } | null> | null };

export type LmsGetSectionsByCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LmsGetSectionsByCategoryQuery = { __typename?: 'Query', getSectionsByCategory?: Array<{ __typename?: 'QuizCategorySection', id?: string | null, name?: string | null, score?: number | null, question_count?: number | null, is_deleted?: boolean | null } | null> | null };

export type LmsFileUploadProgressSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type LmsFileUploadProgressSubscription = { __typename?: 'Subscription', fileUploadProgress: { __typename?: 'UploadProgress', fileName: string, module: string, percentage: number, status: string } };

export type GetLoanWithFiltersQueryVariables = Exact<{
  input?: InputMaybe<LoanFilter>;
}>;


export type GetLoanWithFiltersQuery = { __typename?: 'Query', getLoanWithFilters?: { __typename?: 'loanResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'LoanPayment', _id?: string | null, loan_type?: string | null, loan_amount?: number | null, no_of_installment?: number | null, installment_amount?: number | null, loan_recovery_method?: string | null, loan_taken_date?: any | null, payment_start_date?: any | null, payment_received_date?: any | null, description?: string | null, status?: string | null, payment?: number | null, balance?: number | null, is_deleted?: boolean | null, is_fixed?: boolean | null, approval_status?: string | null, behalf_of?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null, employee?: { __typename?: 'User', id?: string | null, _id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, joining_date?: any | null, last_working_date?: any | null, salary_type?: string | null } | null } | null> | null } | null };

export type GetLoanByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLoanByIdQuery = { __typename?: 'Query', getLoanById?: { __typename?: 'LoanPayment', _id?: string | null, loan_type?: string | null, loan_amount?: number | null, no_of_installment?: number | null, installment_amount?: number | null, loan_recovery_method?: string | null, loan_taken_date?: any | null, payment_start_date?: any | null, payment_received_date?: any | null, description?: string | null, status?: string | null, payment?: number | null, balance?: number | null, is_deleted?: boolean | null, is_fixed?: boolean | null, approval_description?: string | null, approval_status?: string | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, joining_date?: any | null, last_working_date?: any | null } | null, business_manager?: { __typename?: 'User', _id?: string | null, full_name?: string | null, status?: string | null } | null, behalf_of?: Array<{ __typename?: 'User', full_name?: string | null, _id?: string | null } | null> | null, work_flow?: Array<{ __typename?: 'workFlow', approval_description?: string | null, status?: string | null, approved_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, _id?: string | null } | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null, id?: string | null } | null } | null> | null } | null };

export type GetLoanTransactionsQueryVariables = Exact<{
  input?: InputMaybe<LoanTransactionFilter>;
}>;


export type GetLoanTransactionsQuery = { __typename?: 'Query', getLoanTransactionsByLoanId?: { __typename?: 'loanTransactionResult', config?: { __typename?: 'dataTableConfig', type?: string | null, page?: number | null, limit?: number | null, totalResults?: number | null, totalPages?: number | null, actions?: Array<string | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', field?: string | null, header?: string | null, is_visible?: boolean | null, is_search_able?: boolean | null, is_sortable?: boolean | null, is_amount?: boolean | null, type?: string | null, column_data?: Array<string | null> | null } | null> | null } | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null } | null, results?: Array<{ __typename?: 'LoanTransaction', _id?: string | null, transaction?: string | null, loan_amount?: number | null, loan_transaction_amount?: number | null, loan_transaction_date?: any | null, balance?: number | null, comment?: string | null, is_credit?: boolean | null, is_adjustable?: boolean | null, adjustment_amount?: number | null, adjustment_comment?: string | null, adjustment_date?: any | null, logs?: Array<{ __typename?: 'transactionLogs', adjustment_amount?: number | null, adjustment_comment?: string | null, adjustment_date?: any | null, balance?: number | null, is_credit?: boolean | null } | null> | null, loan?: { __typename?: 'LoanPayment', _id?: string | null, loan_type?: string | null, loan_amount?: number | null, payment_start_date?: any | null, balance?: number | null } | null } | null> | null } | null };

export type EmployeeLoanAmountQueryVariables = Exact<{
  employee: Scalars['ID']['input'];
}>;


export type EmployeeLoanAmountQuery = { __typename?: 'Query', employeeLoanAmount?: { __typename?: 'employeeLoanAmountResult', paidAmount?: number | null, remainingAmount?: number | null, totalAmount?: number | null } | null };

export type CreateUpdateLoanMutationVariables = Exact<{
  input: InputLoan;
}>;


export type CreateUpdateLoanMutation = { __typename?: 'Mutation', createUpdateLoan?: { __typename?: 'LoanPayment', _id?: string | null, loan_type?: string | null, loan_amount?: number | null, status?: string | null } | null };

export type ArchiveLoanMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveLoanMutation = { __typename?: 'Mutation', archiveLoan?: boolean | null };

export type ArchiveLoanTransactionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveLoanTransactionMutation = { __typename?: 'Mutation', archiveLoanTransaction?: boolean | null };

export type CreateLoanTransactionMutationVariables = Exact<{
  input: InputTransaction;
}>;


export type CreateLoanTransactionMutation = { __typename?: 'Mutation', createLoanTransaction?: { __typename?: 'LoanTransaction', _id?: string | null, loan_transaction_amount?: number | null, balance?: number | null } | null };

export type CreateLoanAdjustmentMutationVariables = Exact<{
  input: InputAdjustment;
}>;


export type CreateLoanAdjustmentMutation = { __typename?: 'Mutation', createLoanAdjustment?: boolean | null };

export type GetPayrollDetailByUserIdQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPayrollDetailByUserIdQuery = { __typename?: 'Query', getPayrollDetailByUserID?: { __typename?: 'PayrollDetail', _id?: string | null, absents?: number | null, account_number?: string | null, gross_salary?: number | null, basic_salary?: number | null, end_date?: any | null, leaves?: number | null, net_salary?: number | null, no_of_days?: number | null, pay_date?: any | null, start_date?: any | null, status?: string | null, pto_wages?: number | null, back_pay_wages?: number | null, User?: { __typename?: 'User', full_name?: string | null, salary_payment_method?: string | null, employee_type?: string | null } | null, Payroll?: { __typename?: 'Payroll', payroll_name?: string | null, pay_period?: string | null } | null, allowances?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, contributions?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, deductions?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, loan_payments?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, expenses?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, commissions?: Array<{ __typename?: 'allowances_deductions', name?: string | null, amount?: number | null, percentage?: number | null } | null> | null, taxes?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, medical_insurance?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, sale_goals?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null } | null };

export type GetAllPayrolleListQueryVariables = Exact<{
  input?: InputMaybe<InputPayrollList>;
}>;


export type GetAllPayrolleListQuery = { __typename?: 'Query', getAllPayrolleList?: { __typename?: 'payrollListResult', results?: Array<{ __typename?: 'Payroll', _id?: string | null, payroll_name?: string | null, pay_period?: string | null, start_date?: any | null, end_date?: any | null, no_of_days?: number | null, total_amount?: number | null, payroll_run_date?: any | null, despersed_date?: any | null, status?: string | null, is_deleted?: boolean | null, is_dispersed?: boolean | null, no_of_employee?: number | null, Business?: { __typename?: 'Business', _id: string, business_keeping_unit?: string | null, business_system_name?: string | null, business_legal_name?: string | null } | null, BusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, email?: string | null, store_legal_name?: string | null } | null, payroll_detail?: Array<{ __typename?: 'payroll_detail', salary_type?: string | null, total_amount?: number | null, status?: string | null, is_manually_adjust?: boolean | null, total_adjusted_amount?: number | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, full_name?: string | null, user_name?: string | null } | null } | null> | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', page?: number | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null, search?: string | null, is_search_able?: boolean | null, is_visible?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, width?: number | null, pinned?: string | null, is_groupable?: boolean | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, is_sortable?: boolean | null, is_amount?: boolean | null, validateFn?: string | null, is_required?: boolean | null, show_total?: boolean | null, sum?: number | null, average?: number | null, min_count?: number | null, max_count?: number | null, count?: number | null, count_empty?: number | null, distinct_count?: number | null, query?: { __typename?: 'queryType', first_condition?: string | null, second_condition?: string | null, first_value?: string | null, second_value?: string | null, condition?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', search?: string | null, field?: string | null, type?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', name?: string | null, activeFilters?: boolean | null, id?: string | null, is_default?: boolean | null, is_temp?: boolean | null, loadingCall?: boolean | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, type?: string | null, search?: string | null, is_search_able?: boolean | null, is_visible?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, width?: number | null, pinned?: string | null, is_groupable?: boolean | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, is_sortable?: boolean | null, is_amount?: boolean | null, validateFn?: string | null, is_required?: boolean | null, show_total?: boolean | null, sum?: number | null, average?: number | null, min_count?: number | null, max_count?: number | null, count?: number | null, count_empty?: number | null, distinct_count?: number | null, query?: { __typename?: 'queryType', first_condition?: string | null, second_condition?: string | null, first_value?: string | null, second_value?: string | null, condition?: string | null } | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', search?: string | null, field?: string | null, type?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', first_condition?: string | null, first_value?: string | null, condition?: string | null, second_condition?: string | null, second_value?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', fontFaimly?: string | null, bodyTextFontsSize?: number | null, headerTextFontsSize?: number | null, showVerticalBorder?: boolean | null, selectedTableLayout?: string | null, globalSearch?: string | null, rowShadingEnabled?: boolean | null, oddRowsBackgroundColor?: string | null } | null } | null> | null, table_config?: { __typename?: 'TableConfigListing', fontFaimly?: string | null, bodyTextFontsSize?: number | null, headerTextFontsSize?: number | null, showVerticalBorder?: boolean | null, selectedTableLayout?: string | null, globalSearch?: string | null, rowShadingEnabled?: boolean | null, oddRowsBackgroundColor?: string | null } | null } | null } | null };

export type GetPayrollByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPayrollByIdQuery = { __typename?: 'Query', getPayrollByID?: { __typename?: 'Payroll', _id?: string | null, payroll_run_date?: any | null, payroll_name?: string | null, status?: string | null, total_amount?: number | null, end_date?: any | null, no_of_days?: number | null, pay_period?: string | null, start_date?: any | null, payroll_detail?: Array<{ __typename?: 'payroll_detail', total_amount?: number | null, status?: string | null, salary_type?: string | null, User?: { __typename?: 'User', id?: string | null, full_name?: string | null, employee_type?: string | null, account_status?: string | null } | null } | null> | null } | null };

export type GetPayrollDetailQueryVariables = Exact<{
  payrollId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetPayrollDetailQuery = { __typename?: 'Query', getPayrollDetail?: { __typename?: 'PayrollDetail', _id?: string | null, absents?: number | null, gross_salary?: number | null, basic_salary?: number | null, end_date?: any | null, is_dispersed?: boolean | null, leaves?: number | null, net_salary?: number | null, no_of_days?: number | null, pay_date?: any | null, start_date?: any | null, status?: string | null, pto_wages?: number | null, back_pay_wages?: number | null, User?: { __typename?: 'User', full_name?: string | null, salary_payment_method?: string | null, employee_type?: string | null } | null, Payroll?: { __typename?: 'Payroll', payroll_name?: string | null, pay_period?: string | null } | null, adjustment_detail?: Array<{ __typename?: 'adjustment_detail', is_credit?: boolean | null, description?: string | null, adjusted_amount?: number | null, adjusted_at?: any | null, adjusted_by?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null, allowances?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, contributions?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, deductions?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, loan_payments?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, expenses?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, commissions?: Array<{ __typename?: 'allowances_deductions', name?: string | null, amount?: number | null, percentage?: number | null } | null> | null, taxes?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null, medical_insurance?: Array<{ __typename?: 'allowances_deductions', amount?: number | null, name?: string | null, percentage?: number | null } | null> | null } | null };

export type UpdatePayrollStatusMutationVariables = Exact<{
  input: UpdatePayrollStatusInput;
}>;


export type UpdatePayrollStatusMutation = { __typename?: 'Mutation', updatePayrollStatus?: { __typename?: 'Payroll', _id?: string | null } | null };

export type PayrollDetailManuallyAdjustMutationVariables = Exact<{
  input: ManuallyAdjustmentInput;
}>;


export type PayrollDetailManuallyAdjustMutation = { __typename?: 'Mutation', payrollDetailManuallyAdjust?: boolean | null };

export type SyncPayrollMutationVariables = Exact<{
  input: SyncPayrollInput;
}>;


export type SyncPayrollMutation = { __typename?: 'Mutation', syncPayroll?: { __typename?: 'Payroll', _id?: string | null, payroll_name?: string | null, status?: string | null } | null };

export type CreateUpdatePayrollScheduleMutationVariables = Exact<{
  input?: InputMaybe<PayrollScheduleInput>;
}>;


export type CreateUpdatePayrollScheduleMutation = { __typename?: 'Mutation', createUpdatePayrollSchedule?: { __typename?: 'PayrollSchedule', _id?: string | null, schedule_name?: string | null, pay_period?: string | null } | null };

export type ArchivePayrollScheduleMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchivePayrollScheduleMutation = { __typename?: 'Mutation', archivePayrollSchedule?: boolean | null };

export type CreateUpdateAllowanceMutationVariables = Exact<{
  input?: InputMaybe<InputAllowances>;
}>;


export type CreateUpdateAllowanceMutation = { __typename?: 'Mutation', createUpdateAllowance?: { __typename?: 'Allowance', _id: string, pay_slip_name: string, allowance_type: AllowanceType, is_fixed: boolean, amount: number } | null };

export type ArchiveAllowanceMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchiveAllowanceMutation = { __typename?: 'Mutation', archiveAllowance?: boolean | null };

export type GetAllowanceWithFiltersQueryVariables = Exact<{
  input?: InputMaybe<AllowanceFilter>;
}>;


export type GetAllowanceWithFiltersQuery = { __typename?: 'Query', getAllowanceWithFilters?: { __typename?: 'allowanceResult', results?: Array<{ __typename?: 'Allowance', _id: string, pay_slip_name: string, allowance_type: AllowanceType, is_fixed: boolean, amount: number, is_deleted?: boolean | null, created_at?: any | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type GetSearchContributionQueryVariables = Exact<{
  input?: InputMaybe<ContributionListFilter>;
}>;


export type GetSearchContributionQuery = { __typename?: 'Query', getSearchContribution?: { __typename?: 'contributionlistingResult', results?: Array<{ __typename?: 'Contribution', _id?: string | null, name_pay_slip: string, is_calculate_amount_fixed: boolean, contribution_amount: number, is_deleted?: boolean | null, created_at?: any | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type CreateUpdateContributionMutationVariables = Exact<{
  input?: InputMaybe<ContributionInput>;
}>;


export type CreateUpdateContributionMutation = { __typename?: 'Mutation', createUpdateContribution?: { __typename?: 'Contribution', _id?: string | null, name_pay_slip: string, is_calculate_amount_fixed: boolean, contribution_amount: number } | null };

export type DeleteContributionMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteContributionMutation = { __typename?: 'Mutation', deletecontribution?: boolean | null };

export type GetSearchDeductionQueryVariables = Exact<{
  input?: InputMaybe<DeductionListFilter>;
}>;


export type GetSearchDeductionQuery = { __typename?: 'Query', getSearchDeduction?: { __typename?: 'deductionlistingResult', results?: Array<{ __typename?: 'Deduction', _id?: string | null, name_pay_slip: string, is_calculate_amount_fixed: boolean, deduction_amount: number, is_deleted?: boolean | null, created_at?: any | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type CreateDeductionMutationVariables = Exact<{
  input?: InputMaybe<DeductionInput>;
}>;


export type CreateDeductionMutation = { __typename?: 'Mutation', createDeduction?: { __typename?: 'Deduction', _id?: string | null, name_pay_slip: string, is_calculate_amount_fixed: boolean, deduction_amount: number } | null };

export type DeleteDeductionMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDeductionMutation = { __typename?: 'Mutation', deletededuction?: boolean | null };

export type GetAllPayrollStructureListWithSearchQueryVariables = Exact<{
  input?: InputMaybe<PayrollStructureListInput>;
}>;


export type GetAllPayrollStructureListWithSearchQuery = { __typename?: 'Query', getAllPayrollStructureListWithSearch?: { __typename?: 'PayrollStructureListingResult', results?: Array<{ __typename?: 'PayrollStructure', _id?: string | null, structure_name?: string | null, is_deleted?: boolean | null, created_at?: any | null, allowances?: Array<{ __typename?: 'AllowanceData', amount: number, is_percentage: boolean, allowance?: { __typename?: 'Allowance', _id: string, pay_slip_name: string, allowance_type: AllowanceType } | null } | null> | null, contributions?: Array<{ __typename?: 'ContributionData', amount: number, is_percentage: boolean, contribution?: { __typename?: 'Contribution', _id?: string | null, name_pay_slip: string } | null } | null> | null, deductions?: Array<{ __typename?: 'DeductionData', amount: number, is_percentage: boolean, deduction?: { __typename?: 'Deduction', _id?: string | null, name_pay_slip: string } | null } | null> | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type GetPayrollStructureByIdQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetPayrollStructureByIdQuery = { __typename?: 'Query', getPayrollStructureByID?: { __typename?: 'PayrollStructure', _id?: string | null, structure_name?: string | null, allowances?: Array<{ __typename?: 'AllowanceData', amount: number, is_percentage: boolean, allowance?: { __typename?: 'Allowance', _id: string, pay_slip_name: string, allowance_type: AllowanceType } | null } | null> | null, contributions?: Array<{ __typename?: 'ContributionData', amount: number, is_percentage: boolean, contribution?: { __typename?: 'Contribution', _id?: string | null, name_pay_slip: string } | null } | null> | null, deductions?: Array<{ __typename?: 'DeductionData', amount: number, is_percentage: boolean, deduction?: { __typename?: 'Deduction', _id?: string | null, name_pay_slip: string } | null } | null> | null } | null };

export type CreateUpdatePayrollStructureMutationVariables = Exact<{
  input?: InputMaybe<PayrollStructureInput>;
}>;


export type CreateUpdatePayrollStructureMutation = { __typename?: 'Mutation', createUpdatePayrollStructure?: { __typename?: 'PayrollStructure', _id?: string | null, structure_name?: string | null } | null };

export type ArchivePayrollStructureMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchivePayrollStructureMutation = { __typename?: 'Mutation', archivePayrollStructure?: boolean | null };

export type GetRecruitmentEmployeeByConfigQueryVariables = Exact<{
  input?: InputMaybe<InputRecruitment>;
}>;


export type GetRecruitmentEmployeeByConfigQuery = { __typename?: 'Query', getRecruitmentEmployeeByConfig?: { __typename?: 'recruitmentResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Recruitment', _id?: string | null, status?: string | null, created_at?: any | null, updated_at?: any | null, deleted_at?: any | null, is_deleted?: boolean | null, personal_details?: { __typename?: 'PersonalDetails', first_name?: string | null, middle_name?: string | null, last_name?: string | null, full_name?: string | null, gender?: string | null, marital_status?: string | null, birth_date?: any | null, home_no?: string | null, phone?: string | null, email?: string | null, is_email_verify?: boolean | null, is_phone_verify?: boolean | null, mobile_no_to_send_sms?: string | null, address_1?: string | null, address_2?: string | null, zipcode?: string | null, nationality?: string | null, city?: { __typename?: 'City', _id?: string | null, city_name?: string | null } | null, state?: { __typename?: 'State', _id?: string | null, state_name?: string | null } | null, Country?: { __typename?: 'Country', _id?: string | null, name?: string | null } | null } | null, term_and_salary?: { __typename?: 'TermAndSalary', salary_type?: string | null, salary_offered?: number | null, joining_date?: any | null, employee_type?: string | null, probation_period?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, Designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null } | null, offer_letter?: { __typename?: 'OfferLetter', offer_letter_details?: string | null, offer_letter_description?: Array<string | null> | null, professional_tax?: string | null, offer_letter_footer?: string | null } | null, Business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, created_by?: { __typename?: 'User', id?: string | null, _id?: string | null, full_name?: string | null } | null, updated_by?: { __typename?: 'User', id?: string | null, _id?: string | null, full_name?: string | null } | null, deleted_by?: { __typename?: 'User', id?: string | null, _id?: string | null, full_name?: string | null } | null } | null> | null } | null };

export type GetRecruitmentByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRecruitmentByIdQuery = { __typename?: 'Query', getRecruitmentById?: { __typename?: 'Recruitment', _id?: string | null, status?: string | null, is_deleted?: boolean | null, personal_details?: { __typename?: 'PersonalDetails', first_name?: string | null, middle_name?: string | null, last_name?: string | null, email?: string | null, gender?: string | null, marital_status?: string | null, birth_date?: any | null, phone?: string | null, home_no?: string | null, zipcode?: string | null, address_1?: string | null, is_phone_verify?: boolean | null, Country?: { __typename?: 'Country', _id?: string | null, name?: string | null } | null, state?: { __typename?: 'State', _id?: string | null, state_name?: string | null } | null, city?: { __typename?: 'City', _id?: string | null, city_name?: string | null } | null } | null, term_and_salary?: { __typename?: 'TermAndSalary', salary_type?: string | null, salary_offered?: number | null, weekly_hourly_salary?: number | null, weekend_day_salary?: number | null, public_day_hourly_salary?: number | null, joining_date?: any | null, employee_type?: string | null, probation_period?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, Designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null } | null, offer_letter?: { __typename?: 'OfferLetter', offer_letter_description?: Array<string | null> | null, offer_letter_details?: string | null, offer_letter_footer?: string | null } | null } | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', _id?: string | null, name?: string | null } | null> | null };

export type GetStateByCountryIdQueryVariables = Exact<{
  country_id: Scalars['ID']['input'];
}>;


export type GetStateByCountryIdQuery = { __typename?: 'Query', getStateByCountryId?: Array<{ __typename?: 'State', _id?: string | null, state_name?: string | null } | null> | null };

export type GetCityByStateIdQueryVariables = Exact<{
  state_id: Scalars['ID']['input'];
}>;


export type GetCityByStateIdQuery = { __typename?: 'Query', getCityByStateId?: Array<{ __typename?: 'City', _id?: string | null, city_name?: string | null } | null> | null };

export type GetRolesForRecruitmentQueryVariables = Exact<{
  roleFilter: RoleFilter;
}>;


export type GetRolesForRecruitmentQuery = { __typename?: 'Query', getRoles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null };

export type GetAllDesignationListForRecruitmentQueryVariables = Exact<{
  input?: InputMaybe<DesignationtListFilter>;
}>;


export type GetAllDesignationListForRecruitmentQuery = { __typename?: 'Query', getAllDesignationList?: { __typename?: 'allDesignationListingresult', result?: Array<{ __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null> | null } | null };

export type CreateUpdateRecruitmentEmployeeMutationVariables = Exact<{
  input?: InputMaybe<RecruitmentInput>;
}>;


export type CreateUpdateRecruitmentEmployeeMutation = { __typename?: 'Mutation', createUpdateRecruitmentEmployee?: { __typename?: 'Recruitment', _id?: string | null, status?: string | null, personal_details?: { __typename?: 'PersonalDetails', first_name?: string | null, last_name?: string | null, email?: string | null, full_name?: string | null } | null, term_and_salary?: { __typename?: 'TermAndSalary', Designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null } | null, offer_letter?: { __typename?: 'OfferLetter', offer_letter_description?: Array<string | null> | null, offer_letter_details?: string | null, offer_letter_footer?: string | null } | null } | null };

export type ChangeRecruitmentStatusMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<RecruitmentStatusEnum>;
}>;


export type ChangeRecruitmentStatusMutation = { __typename?: 'Mutation', changeRecruitmentStatus?: { __typename?: 'Recruitment', _id?: string | null, status?: string | null } | null };

export type DeleteRecruitmentMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteRecruitmentMutation = { __typename?: 'Mutation', deleteRecruitment?: { __typename?: 'Recruitment', _id?: string | null, is_deleted?: boolean | null } | null };

export type GetAttendanceRegulationWithSearchQueryVariables = Exact<{
  input?: InputMaybe<AttendanceFilter>;
}>;


export type GetAttendanceRegulationWithSearchQuery = { __typename?: 'Query', getAttendanceRegulationWithSearch?: { __typename?: 'attendanceResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'AttendanceRegulation', _id?: string | null, is_deleted?: boolean | null, description?: string | null, reason_type?: string | null, attendance_date?: any | null, time_in?: string | null, time_out?: string | null, status?: string | null, created_at?: any | null, work_flow?: Array<{ __typename?: 'workFlow', approval_description?: string | null, status?: string | null, approved_by?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null, id?: string | null } | null } | null> | null, behalf_of?: Array<{ __typename?: 'User', full_name?: string | null, _id?: string | null } | null> | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null } | null };

export type CreateAttendanceRegulationMutationVariables = Exact<{
  input: InputCreateAttendance;
}>;


export type CreateAttendanceRegulationMutation = { __typename?: 'Mutation', createAttendanceRegulation?: { __typename?: 'AttendanceRegulation', _id?: string | null } | null };

export type UpdateAttendanceRegulationMutationVariables = Exact<{
  input: InputUpdateAttendance;
}>;


export type UpdateAttendanceRegulationMutation = { __typename?: 'Mutation', updateAttendanceRegulation?: { __typename?: 'AttendanceRegulation', _id?: string | null } | null };

export type ArchiveAttendanceRegulationMutationVariables = Exact<{
  _id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveAttendanceRegulationMutation = { __typename?: 'Mutation', archiveAttendanceRegulation?: boolean | null };

export type GetMasterDataValuesByDataValueNameQueryVariables = Exact<{
  data_type_name: Scalars['String']['input'];
}>;


export type GetMasterDataValuesByDataValueNameQuery = { __typename?: 'Query', getMasterDataValuesByDataValueName?: Array<{ __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null } | null> | null };

export type CreateExpenseRequestMutationVariables = Exact<{
  input: InputCreateExpenseRequest;
}>;


export type CreateExpenseRequestMutation = { __typename?: 'Mutation', createExpenseRequest?: { __typename?: 'Expense', _id?: string | null } | null };

export type UpdateExpenseRequestMutationVariables = Exact<{
  input: InputUpdateExpenseRequest;
}>;


export type UpdateExpenseRequestMutation = { __typename?: 'Mutation', updateExpenseRequest?: { __typename?: 'Expense', _id?: string | null } | null };

export type GetExpenseRequestWithFiltersQueryVariables = Exact<{
  input?: InputMaybe<ExpenseFilter>;
}>;


export type GetExpenseRequestWithFiltersQuery = { __typename?: 'Query', getExpenseRequestWithFilters?: { __typename?: 'expnseResultUpdate', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Expense', _id?: string | null, status?: string | null, is_deleted?: boolean | null, document_url?: string | null, expense_type?: string | null, expense_total_amount?: number | null, expense_date?: any | null, description?: string | null, created_at?: any | null, work_flow?: Array<{ __typename?: 'workFlow', approval_description?: string | null, status?: string | null, employee?: { __typename?: 'User', logo?: string | null, id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null } | null } | null> | null, employee?: { __typename?: 'User', full_name?: string | null, id?: string | null, middle_name?: string | null, last_name?: string | null, email?: string | null } | null } | null> | null } | null };

export type GetTimeOffRequestListQueryVariables = Exact<{
  input?: InputMaybe<TimeOffListFilter>;
}>;


export type GetTimeOffRequestListQuery = { __typename?: 'Query', getTimeOffRequestList?: { __typename?: 'timeOffListingresult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'timeOff', is_short_leave?: boolean | null, document_url?: string | null, _id?: string | null, is_deleted?: boolean | null, status?: TimeOffStatus | null, reason_for_leave?: string | null, total_leaves?: number | null, created_at?: any | null, total_request_leaves?: number | null, total_unpaid_leaves?: number | null, remaining_unpaid_days?: number | null, request_id?: string | null, countIn?: string | null, no_request?: number | null, leave_request_dates?: Array<{ __typename?: 'dateObj', from_date?: any | null, to_date?: any | null } | null> | null, upload_document_info?: { __typename?: 'updloadDocumentInf', size?: string | null, extension?: string | null, name?: string | null } | null, work_flow?: Array<{ __typename?: 'workFlow', approval_description?: string | null, status?: string | null, employee?: { __typename?: 'User', logo?: string | null, id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null } | null } | null> | null, employee?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null, type_of_absence?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null, is_pto?: boolean | null } | null, leave_request?: Array<{ __typename?: 'leaveInputType', end_time?: string | null, from_date: any, leave_date?: any | null, leave_type?: string | null, start_time?: string | null, to_date: any, no_of_days?: number | null, status?: string | null } | null> | null } | null> | null } | null };

export type CreateUpdateTimeOffRequestMutationVariables = Exact<{
  input: CreateUpdateTimeOffRequestInput;
}>;


export type CreateUpdateTimeOffRequestMutation = { __typename?: 'Mutation', createUpdateTimeOffRequest?: { __typename?: 'timeOff', _id?: string | null, status?: TimeOffStatus | null } | null };

export type GetRoasterMinutesQueryVariables = Exact<{
  input?: InputMaybe<RoasterMinutesInput>;
}>;


export type GetRoasterMinutesQuery = { __typename?: 'Query', getRoasterMinutes?: { __typename?: 'RosterMinutesAndDate', totalMinuts?: number | null, start_time?: string | null, end_time?: string | null, start_date?: any | null, end_date?: any | null, out_of_accural_leave_days?: number | null, out_of_accural_leave_hours?: number | null, alertData?: Array<{ __typename?: 'alertData', date?: string | null, message?: string | null, isLeaveApplied?: boolean | null, schedule_not_found?: boolean | null } | null> | null, weekEndDays?: Array<{ __typename?: 'weekend', _id?: string | null, id?: number | null, name?: string | null, selected?: boolean | null } | null> | null, sandwichDate?: Array<{ __typename?: 'sandWichDays', difference_in_days?: number | null, difference_in_hours?: number | null, deduction_type?: string | null, deduction_value?: number | null, date_of_sandwich?: Array<{ __typename?: 'dateOfSandwich', date?: any | null, day?: string | null } | null> | null } | null> | null } | null };

export type GetLeaveTypeEmployeeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLeaveTypeEmployeeByIdQuery = { __typename?: 'Query', getLeaveTypeEmployeeById?: { __typename?: 'ResultWrapper', working_days?: number | null, total_week_hours?: number | null, sandwich?: boolean | null, manual_deduction_value?: number | null, is_week_hour_limit?: boolean | null, is_manual_deduction?: boolean | null, is_hourly_employee_sandwich?: boolean | null, publicHolidaySandwich?: boolean | null, salary_type?: string | null, leaveTypeEmployee?: Array<{ __typename?: 'leaveTypeEmployeeById', _id?: string | null, countIn?: string | null, time_off_days?: string | null, unpaid_count?: string | null, carry_forword?: number | null, working_days?: string | null, time_off_type?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null, is_pto?: boolean | null, pto_type?: string | null, half_leave_in_ful_leave?: boolean | null, type?: string | null, leave_duration?: LeaveDuration | null, maximum_duration?: string | null, minimum_duration?: string | null, per_day_hours?: string | null, consecutive_leaves?: string | null, count_after_days?: number | null, half_day_Consideration?: HalfDayConsideration | null, un_paid_days?: string | null, working_days?: string | null, un_paid?: boolean | null, pto_minimum_consumable_hours?: number | null, pto_advance_notice_days?: number | null, is_allow_partial_apply?: boolean | null, partial_apply_minimum?: string | null, blackOutWindow?: Array<{ __typename?: 'BlackOutWindow', date?: any | null, reason?: string | null } | null> | null } | null } | null> | null, ptoMinutes?: { __typename?: 'pto_minutesType', pto_earned_minutes?: number | null, pto_availed_minutes?: number | null, carry_forword?: number | null } | null } | null };

export type AdjustLeaveBalanceMutationVariables = Exact<{
  input: AdjustLeaveBalanceInput;
}>;


export type AdjustLeaveBalanceMutation = { __typename?: 'Mutation', adjustLeaveBalance?: boolean | null };

export type GetPendingRequestCountQueryVariables = Exact<{
  input: PendingRequestInput;
}>;


export type GetPendingRequestCountQuery = { __typename?: 'Query', getPendingRequestCount?: { __typename?: 'pendingRequestsData', pending_request_minutes?: number | null } | null };

export type SetPtoOpeningBalanceMutationVariables = Exact<{
  input: PtoOpeningBalanceInput;
}>;


export type SetPtoOpeningBalanceMutation = { __typename?: 'Mutation', setPtoOpeningBalance?: boolean | null };

export type CreateLoanRequestMutationVariables = Exact<{
  input: InputLoanRequest;
}>;


export type CreateLoanRequestMutation = { __typename?: 'Mutation', createLoanRequest?: { __typename?: 'LoanPayment', _id?: string | null } | null };

export type GetLoanRequestWithFiltersQueryVariables = Exact<{
  input?: InputMaybe<LoanFilter>;
}>;


export type GetLoanRequestWithFiltersQuery = { __typename?: 'Query', getLoanRequestWithFilters?: { __typename?: 'loanResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'LoanPayment', _id?: string | null, loan_type?: string | null, loan_amount?: number | null, no_of_installment?: number | null, installment_amount?: number | null, loan_recovery_method?: string | null, loan_taken_date?: any | null, payment_start_date?: any | null, payment_received_date?: any | null, description?: string | null, status?: string | null, payment?: number | null, balance?: number | null, is_deleted?: boolean | null, is_fixed?: boolean | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, joining_date?: any | null, last_working_date?: any | null, salary_type?: string | null } | null } | null> | null } | null };

export type GetRolesWithFilterQueryVariables = Exact<{
  input: RoleListingFilter;
}>;


export type GetRolesWithFilterQuery = { __typename?: 'Query', getRolesWithFilter?: { __typename?: 'RolelistingResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null, employeeCount?: number | null, is_deleted?: boolean | null, created_at?: any | null, assigned_users?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null, parent?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null, BusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null } | null, permissions?: Array<{ __typename?: 'Permission', feature?: string | null, module?: string | null, permission?: string | null, permission_at?: string | null } | null> | null } | null> | null } | null };

export type GetallActiveRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetallActiveRolesQuery = { __typename?: 'Query', getallActiveRoles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null, is_deleted?: boolean | null } | null> | null };

export type GetRoleDetailQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
  getEmployeeByAssignRoleRole2: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRoleDetailQuery = { __typename?: 'Query', getRoleDetail?: { __typename?: 'Role', _id?: string | null, roleName?: string | null, parent?: { __typename?: 'Role', _id?: string | null } | null, BusinessLocation?: { __typename?: 'BusinessLocation', _id?: string | null } | null, permissions?: Array<{ __typename?: 'Permission', feature?: string | null, module?: string | null, permission?: string | null, permission_at?: string | null } | null> | null } | null, getEmployeeByAssignRole?: Array<{ __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, joining_date?: any | null } | null> | null };

export type GetModulesFeaturesAndPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetModulesFeaturesAndPermissionsQuery = { __typename?: 'Query', getModulesFeaturesAndPermissions?: { __typename?: 'modulefeatureandpermission', POSPermissionResult?: Array<{ __typename?: 'ModulesFeaturesPermissions', module?: string | null, features?: Array<{ __typename?: 'ModulesFeatures', feature?: string | null, permissions?: Array<{ __typename?: 'permissionObj', permission?: string | null } | null> | null } | null> | null } | null> | null, adminPermissionResult?: Array<{ __typename?: 'ModulesFeaturesPermissions', module?: string | null, features?: Array<{ __typename?: 'ModulesFeatures', feature?: string | null, permissions?: Array<{ __typename?: 'permissionObj', permission?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<RoleInput>;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null };

export type ArchiveRoleMutationVariables = Exact<{
  role?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchiveRoleMutation = { __typename?: 'Mutation', archiveRole?: boolean | null };

export type AssignRoleToEmployeeMutationVariables = Exact<{
  input?: InputMaybe<AssignRoleInput>;
}>;


export type AssignRoleToEmployeeMutation = { __typename?: 'Mutation', assignRoleToEmployee?: boolean | null };

export type CloneRoleMutationVariables = Exact<{
  input: CloneRoleInput;
}>;


export type CloneRoleMutation = { __typename?: 'Mutation', cloneRole?: boolean | null };

export type AddOrRemoveEmployeeInRoleMutationVariables = Exact<{
  input: AddEmployee;
}>;


export type AddOrRemoveEmployeeInRoleMutation = { __typename?: 'Mutation', addOrRemoveEmployeeInRole?: boolean | null };

export type CopyRolePermissionsMutationVariables = Exact<{
  input?: InputMaybe<CopyPermissionInput>;
}>;


export type CopyRolePermissionsMutation = { __typename?: 'Mutation', copyRolePermissions?: boolean | null };

export type CreateRoleMutationVariables = Exact<{
  input?: InputMaybe<RoleInput>;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole?: { __typename?: 'Role', _id?: string | null } | null };

export type GetAllActiveEmployeesSchedulerQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
}>;


export type GetAllActiveEmployeesSchedulerQuery = { __typename?: 'Query', getAllActiveEmployees?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, last_working_date?: any | null, employee_group?: { __typename?: 'attandencePolicy', is_un_restricted?: boolean | null } | null } | null> | null };

export type GetScheduleWithSearchQueryVariables = Exact<{
  input?: InputMaybe<ScheduleListFilter>;
}>;


export type GetScheduleWithSearchQuery = { __typename?: 'Query', getScheduleWithSearch?: { __typename?: 'scheduleListingResult', limit?: number | null, page?: number | null, totalResults?: number | null, totalPages?: number | null, is_conflict_schedule?: boolean | null, RosterStore?: { __typename?: 'RosterStores', backgroundLeave?: string | null, backgroundScheduler?: string | null, default_schedular_view?: string | null, overtimeColor?: string | null, paidTomeOffColor?: string | null, ptoColor?: string | null, sandwichLeaveColor?: string | null, unpaidTomeOffColor?: string | null, publicHolidayColor?: string | null, weekendColor?: string | null, shortLeaveUnpaid?: string | null, shortLeavePaid?: string | null } | null, result?: Array<{ __typename?: 'scheduleResult', _id?: string | null, total_schedules_hours?: number | null, total_schedules_minutes?: number | null, estimated_wage?: number | null, total_normal_time?: number | null, total_normal_time_wage?: number | null, total_over_time?: number | null, total_over_time_wage?: number | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, employee_id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null, email?: string | null, phone?: string | null, last_working_date?: any | null, joining_date?: any | null, salary_type?: string | null, account_status?: string | null, final_settlement_completed?: boolean | null, is_clocked_in?: boolean | null, last_day_worked?: string | null, employee_group?: { __typename?: 'attandencePolicy', _id?: string | null, week_number?: number | null, is_un_restricted?: boolean | null, is_auto_clocked_in?: boolean | null, weekEndDays?: Array<{ __typename?: 'weekEndDaysRetun', id?: number | null, name?: string | null, selected?: boolean | null } | null> | null } | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null } | null, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, is_payroll_processed?: boolean | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null, type?: string | null, is_pto?: boolean | null, is_sand_wich?: boolean | null, is_paid_leave?: boolean | null, is_clocked_in?: boolean | null, is_weekend?: boolean | null, is_weekend_off?: boolean | null, is_public_holiday?: boolean | null, is_public_holiday_off?: boolean | null, is_attendance_exist?: boolean | null, paid_leave_percentage?: number | null, total_hours?: number | null, total_minuts?: number | null, schedule_minuts?: number | null, overtime_minuts?: number | null, over_time_percentage?: number | null, normal_time_percentage?: number | null, short_leave_time_percentage?: number | null, short_break_count?: number | null, short_break_duration?: number | null, short_break_type?: string | null, is_taken_short_break?: boolean | null, PublicHoliday?: { __typename?: 'PublicHoliday', _id?: string | null, name?: string | null } | null, TimeOff?: { __typename?: 'timeOff', countIn?: string | null, type_of_absence?: { __typename?: 'LeaveType', name?: string | null } | null } | null, events?: Array<{ __typename?: 'scheduleEvents', type?: string | null, hours?: number | null, end_time?: string | null, leave_type?: string | null, minutes?: number | null, star_time?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type GetEmployeeSchedulesQueryVariables = Exact<{
  input: GetScheduleByEmployeeIdInput;
}>;


export type GetEmployeeSchedulesQuery = { __typename?: 'Query', getEmployeeSchedules?: { __typename?: 'scheduleListingResult', limit?: number | null, page?: number | null, totalResults?: number | null, totalPages?: number | null, RosterStore?: { __typename?: 'RosterStores', backgroundLeave?: string | null, backgroundScheduler?: string | null, default_schedular_view?: string | null, overtimeColor?: string | null, paidTomeOffColor?: string | null, ptoColor?: string | null, sandwichLeaveColor?: string | null, unpaidTomeOffColor?: string | null, publicHolidayColor?: string | null, weekendColor?: string | null, shortLeaveUnpaid?: string | null, shortLeavePaid?: string | null } | null, result?: Array<{ __typename?: 'scheduleResult', _id?: string | null, total_schedules_hours?: number | null, total_schedules_minutes?: number | null, estimated_wage?: number | null, total_normal_time?: number | null, total_normal_time_wage?: number | null, total_over_time?: number | null, total_over_time_wage?: number | null, User?: { __typename?: 'User', _id?: string | null, id?: string | null, employee_id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null, email?: string | null, phone?: string | null, last_working_date?: any | null, joining_date?: any | null, salary_type?: string | null, account_status?: string | null, final_settlement_completed?: boolean | null, is_clocked_in?: boolean | null, employee_group?: { __typename?: 'attandencePolicy', _id?: string | null, week_number?: number | null, is_un_restricted?: boolean | null, is_auto_clocked_in?: boolean | null, weekEndDays?: Array<{ __typename?: 'weekEndDaysRetun', id?: number | null, name?: string | null, selected?: boolean | null } | null> | null } | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null } | null, schedules?: Array<{ __typename?: 'Schedule', _id?: string | null, is_payroll_processed?: boolean | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null, type?: string | null, is_pto?: boolean | null, is_sand_wich?: boolean | null, is_paid_leave?: boolean | null, is_clocked_in?: boolean | null, is_weekend?: boolean | null, is_weekend_off?: boolean | null, is_public_holiday?: boolean | null, is_public_holiday_off?: boolean | null, is_attendance_exist?: boolean | null, paid_leave_percentage?: number | null, total_hours?: number | null, total_minuts?: number | null, schedule_minuts?: number | null, overtime_minuts?: number | null, over_time_percentage?: number | null, normal_time_percentage?: number | null, short_leave_time_percentage?: number | null, TimeOff?: { __typename?: 'timeOff', type_of_absence?: { __typename?: 'LeaveType', name?: string | null } | null } | null, events?: Array<{ __typename?: 'scheduleEvents', type?: string | null, hours?: number | null, end_time?: string | null, leave_type?: string | null, minutes?: number | null, star_time?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type CreateScheduleMutationVariables = Exact<{
  input: SchduleInput;
}>;


export type CreateScheduleMutation = { __typename?: 'Mutation', createSchedule?: Array<{ __typename?: 'conflictedSchedules', is_overlap?: boolean | null, is_conflict?: boolean | null, employee_id?: string | null, employee_name?: string | null, employee_action?: string | null, conflicted_schedule?: { __typename?: 'Schedule', _id?: string | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null, type?: string | null, is_pto?: boolean | null, is_sand_wich?: boolean | null, is_attendance_exist?: boolean | null } | null, new_schedule?: { __typename?: 'Schedule', _id?: string | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null, type?: string | null, is_pto?: boolean | null } | null } | null> | null };

export type DeleteScheduleMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  notifyByEmail: Scalars['Boolean']['input'];
}>;


export type DeleteScheduleMutation = { __typename?: 'Mutation', deleteSchedule?: boolean | null };

export type DeleteMultiScheduleMutationVariables = Exact<{
  input?: InputMaybe<MultiScheduleDeleteInput>;
}>;


export type DeleteMultiScheduleMutation = { __typename?: 'Mutation', deleteMultiSchedule?: boolean | null };

export type UpdateScheduleMutationVariables = Exact<{
  input: UpdateSchduleInput;
}>;


export type UpdateScheduleMutation = { __typename?: 'Mutation', updateSchedule?: boolean | null };

export type CopyScheduleByDateMutationVariables = Exact<{
  input: CopyScheduleByDateInput;
}>;


export type CopyScheduleByDateMutation = { __typename?: 'Mutation', copyScheduleByDate?: Array<{ __typename?: 'conflictedSchedules', is_overlap?: boolean | null, is_conflict?: boolean | null, is_leave?: boolean | null, is_salary_detail_not_exist?: boolean | null, employee_id?: string | null, employee_name?: string | null, employee_action?: string | null, conflicted_schedule?: { __typename?: 'Schedule', _id?: string | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null, is_attendance_exist?: boolean | null, type?: string | null } | null, new_schedule?: { __typename?: 'Schedule', _id?: string | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null } | null } | null> | null };

export type CopyScheduleDifferentDateMutationVariables = Exact<{
  input: CopyScheduleDifferentDateInput;
}>;


export type CopyScheduleDifferentDateMutation = { __typename?: 'Mutation', copyScheduleDifferentDate?: Array<{ __typename?: 'conflictedSchedules', is_overlap?: boolean | null, is_conflict?: boolean | null, is_leave?: boolean | null, is_salary_detail_not_exist?: boolean | null, employee_id?: string | null, employee_name?: string | null, employee_action?: string | null, conflicted_schedule?: { __typename?: 'Schedule', _id?: string | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null, is_attendance_exist?: boolean | null, is_pto?: boolean | null, type?: string | null } | null, new_schedule?: { __typename?: 'Schedule', _id?: string | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null } | null } | null> | null };

export type CopyScheduleEmployeeToEmployeesMutationVariables = Exact<{
  input: CopyScheduleEmpInput;
}>;


export type CopyScheduleEmployeeToEmployeesMutation = { __typename?: 'Mutation', copyScheduleEmployeeToEmployees?: Array<{ __typename?: 'conflictedSchedules', is_overlap?: boolean | null, is_conflict?: boolean | null, is_leave?: boolean | null, is_salary_detail_not_exist?: boolean | null, employee_id?: string | null, employee_name?: string | null, employee_action?: string | null, conflicted_schedule?: { __typename?: 'Schedule', _id?: string | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null, is_attendance_exist?: boolean | null, is_pto?: boolean | null, type?: string | null } | null, new_schedule?: { __typename?: 'Schedule', _id?: string | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null } | null } | null> | null };

export type SendSchedulesByEmailMutationVariables = Exact<{
  input: EmailScheduleInput;
}>;


export type SendSchedulesByEmailMutation = { __typename?: 'Mutation', sendSchedulesByEmail?: boolean | null };

export type ResolveConflictsMutationVariables = Exact<{
  input: Array<ResolveConflictsInput> | ResolveConflictsInput;
}>;


export type ResolveConflictsMutation = { __typename?: 'Mutation', resolveConflicts?: boolean | null };

export type GetConflictScheduleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConflictScheduleQuery = { __typename?: 'Query', getConflictSchedule?: Array<{ __typename?: 'ConflictSchedule', is_overlap?: boolean | null, is_conflict?: boolean | null, employee_name?: string | null, employee_action?: string | null, created_at?: any | null, employee_id?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, created_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, conflicted_schedule?: { __typename?: 'Schedule', _id?: string | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null, type?: string | null, is_pto?: boolean | null, is_sand_wich?: boolean | null, is_attendance_exist?: boolean | null } | null, new_schedule?: { __typename?: 'Schedule', _id?: string | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null, type?: string | null, is_pto?: boolean | null } | null } | null> | null };

export type CancelScheduleConflictsMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelScheduleConflictsMutation = { __typename?: 'Mutation', cancelScheduleConflicts?: boolean | null };

export type GetScheduleByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScheduleByIdQuery = { __typename?: 'Query', getScheduleById?: { __typename?: 'Schedule', _id?: string | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null, type?: string | null, is_pto?: boolean | null, is_sand_wich?: boolean | null, is_paid_leave?: boolean | null, is_clocked_in?: boolean | null, is_attendance_exist?: boolean | null, total_hours?: number | null, total_minuts?: number | null, overtime_minuts?: number | null, over_time_percentage?: number | null, normal_time_percentage?: number | null, short_leave_time_percentage?: number | null, User?: { __typename?: 'User', id?: string | null, full_name?: string | null, is_clocked_in?: boolean | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null } | null, TimeOff?: { __typename?: 'timeOff', _id?: string | null, is_pto?: boolean | null, total_leaves?: number | null, type_of_absence?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null, type?: string | null, leave_duration?: LeaveDuration | null } | null } | null, events?: Array<{ __typename?: 'scheduleEvents', type?: string | null, star_time?: string | null, end_time?: string | null, leave_type?: string | null, hours?: number | null, minutes?: number | null, TimeOff?: { __typename?: 'timeOff', _id?: string | null, type_of_absence?: { __typename?: 'LeaveType', name?: string | null } | null } | null } | null> | null } | null };

export type GetScheduleTotalCountsQueryVariables = Exact<{
  input?: InputMaybe<ScheduleCountFilter>;
}>;


export type GetScheduleTotalCountsQuery = { __typename?: 'Query', getScheduleTotalCounts?: { __typename?: 'scheduleCountsType', estimateWage?: number | null, onleave?: number | null, overTimeCost?: number | null, overTimeHours?: number | null, ptoCost?: number | null, ptoHours?: number | null, scheduleHours?: number | null, scheduleShift?: number | null, shortleaves?: number | null, totalUserCount?: number | null } | null };

export type GetAllDepartmentsSchedulerQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
}>;


export type GetAllDepartmentsSchedulerQuery = { __typename?: 'Query', getAllDepartments?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null };

export type GetRolesByDepartmentIdQueryVariables = Exact<{
  departmentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetRolesByDepartmentIdQuery = { __typename?: 'Query', getRolesByDepartmentId?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null };

export type CreateUpdateSchedulerConfigMutationVariables = Exact<{
  input: SchedulerConfigInput;
}>;


export type CreateUpdateSchedulerConfigMutation = { __typename?: 'Mutation', createUpdateSchedulerConfig?: { __typename?: 'SchedulerConfig', business?: { __typename?: 'Business', _id: string } | null } | null };

export type GetSchedulerConfigQueryVariables = Exact<{
  business: Scalars['ID']['input'];
}>;


export type GetSchedulerConfigQuery = { __typename?: 'Query', getSchedulerConfig?: { __typename?: 'SchedulerConfig', backgroundScheduler?: string | null, number_of_record_employees?: number | null, paidTomeOffColor?: string | null, unpaidTomeOffColor?: string | null, overtimeColor?: string | null, ptoColor?: string | null, sandwichLeaveColor?: string | null, publicHolidayColor?: string | null, shortLeavePaid?: string | null, shortLeaveUnpaid?: string | null, weekendColor?: string | null, is_include_unpaid_break?: boolean | null, business?: { __typename?: 'Business', _id: string, business_system_name?: string | null, business_type?: string | null, number_of_stores?: string | null } | null, short_breaks?: { __typename?: 'shortBreaks', short_break_name?: string | null, short_break_duration?: number | null, short_break_type?: string | null } | null, chunk_wise_short_break?: { __typename?: 'shortBreaks', short_break_name?: string | null, short_break_duration?: number | null, short_break_type?: string | null } | null } | null };

export type GetEmployeesByDepartmentsQueryVariables = Exact<{
  input?: InputMaybe<EmployeeFilterInput>;
}>;


export type GetEmployeesByDepartmentsQuery = { __typename?: 'Query', getEmployeesByDepartments?: Array<{ __typename?: 'User', id?: string | null, email?: string | null, employee_id?: string | null, salary_type?: string | null, first_name?: string | null, joining_date?: any | null, hire_date?: any | null, last_working_date?: any | null, final_settlement_completed?: boolean | null, last_day_worked?: string | null, account_status?: string | null, middle_name?: string | null, last_name?: string | null, full_name?: string | null, phone?: string | null, isOwner?: boolean | null, phone_country_code?: string | null, landline?: string | null, logo?: string | null, avatar_location?: string | null, status?: string | null, employee_group?: { __typename?: 'attandencePolicy', before_early_clockin?: number | null, paunch_out_mnts?: number | null, is_un_restricted?: boolean | null, is_auto_clocked_in?: boolean | null, _id?: string | null, group_name?: string | null } | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, business_id?: { __typename?: 'Business', business_system_name?: string | null } | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null, users_password_manager?: { __typename?: 'UserEncryptionKeys', publicKey?: string | null } | null } | null> | null };

export type GetShifBreaksQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
}>;


export type GetShifBreaksQuery = { __typename?: 'Query', getShifBreaks?: Array<{ __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_value_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null } | null } | null> | null };

export type UpdateSchedulesBreaksByDateRangeMutationVariables = Exact<{
  input?: InputMaybe<InputBreakUpdate>;
}>;


export type UpdateSchedulesBreaksByDateRangeMutation = { __typename?: 'Mutation', updateSchedulesBreaksByDateRange?: boolean | null };

export type ImportScheduleCsvMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  scheduleFrom: Scalars['String']['input'];
  scheduleTo: Scalars['String']['input'];
  minimum_break_percentage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ImportScheduleCsvMutation = { __typename?: 'Mutation', importScheduleCsv?: { __typename?: 'schdualCsvResponse', complectSechduals?: Array<{ __typename?: 'conflictedSchedules', is_overlap?: boolean | null, is_conflict?: boolean | null, employee_id?: string | null, employee_name?: string | null, employee_action?: string | null, conflicted_schedule?: { __typename?: 'Schedule', _id?: string | null, start_date?: any | null, schedule_date?: string | null, start_time?: string | null, end_time?: string | null, type?: string | null, is_pto?: boolean | null, is_sand_wich?: boolean | null, is_attendance_exist?: boolean | null } | null, new_schedule?: { __typename?: 'Schedule', _id?: string | null, end_time?: string | null, type?: string | null, is_pto?: boolean | null, schedule_date?: string | null, start_time?: string | null } | null } | null> | null, InvalidRecord?: Array<{ __typename?: 'InvalidRecord', employee_id?: string | null, employee_name?: string | null, DAY?: string | null, reason?: string | null } | null> | null } | null };

export type ScheduleCsvProgressSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ScheduleCsvProgressSubscription = { __typename?: 'Subscription', scheduleCsvProgress?: { __typename?: 'importCsvSubsciption', totalEmployees?: number | null, doneEmployees?: number | null, currentEmployee?: number | null, message?: string | null, error?: string | null } | null };

export type SetNumberOfRecordMutationVariables = Exact<{
  input: SetNumberOfRecordInput;
}>;


export type SetNumberOfRecordMutation = { __typename?: 'Mutation', setNumberOfRecord?: boolean | null };

export type GetScheduleAlertDataQueryVariables = Exact<{
  input?: InputMaybe<RoasterMinutesInput>;
}>;


export type GetScheduleAlertDataQuery = { __typename?: 'Query', getScheduleAlertData?: Array<{ __typename?: 'alertData', date?: string | null, message?: string | null, schedule_not_found?: boolean | null, isLeaveApplied?: boolean | null } | null> | null };

export type UpdateMultiSchedulesMutationVariables = Exact<{
  input: UpdateMultiSchduleInput;
}>;


export type UpdateMultiSchedulesMutation = { __typename?: 'Mutation', updateMultiSchedules?: { __typename?: 'updateMultipleScheduleRes', data?: boolean | null, errorMessage?: Array<{ __typename?: 'errorMessage', date?: string | null, message?: string | null } | null> | null } | null };

export type CreateTimeOffMutationVariables = Exact<{
  input?: InputMaybe<CreateTimeOffInput>;
}>;


export type CreateTimeOffMutation = { __typename?: 'Mutation', createTimeOff?: { __typename?: 'timeOff', _id?: string | null } | null };

export type PublicHolidayQueryVariables = Exact<{
  input: PublicHolidayInput;
}>;


export type PublicHolidayQuery = { __typename?: 'Query', publicHoliday?: { __typename?: 'SandwichLeaveType', sandwichDate?: Array<{ __typename?: 'sandWichDays', difference_in_days?: number | null, date_of_sandwich?: Array<{ __typename?: 'dateOfSandwich', date?: any | null, day?: string | null } | null> | null } | null> | null } | null };

export type VerifyEmployeeScheduleQueryVariables = Exact<{
  input: EmployeeScheduleInput;
}>;


export type VerifyEmployeeScheduleQuery = { __typename?: 'Query', verifyEmployeeSchedule?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, salary_type?: string | null, employee_group?: { __typename?: 'attandencePolicy', _id?: string | null, is_un_restricted?: boolean | null } | null } | null> | null };

export type GetApprovalWorkFlowWithSearchQueryVariables = Exact<{
  input?: InputMaybe<WorkFlowListFilter>;
}>;


export type GetApprovalWorkFlowWithSearchQuery = { __typename?: 'Query', getApprovalWorkFlowWithSearch?: { __typename?: 'ApprovalWorkFlowResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'ApprovalWorkFlow', _id?: string | null, work_flow_type?: string | null, total_level?: number | null, is_deleted?: boolean | null, created_at?: any | null } | null> | null } | null };

export type GetApprovalWorkFlowByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetApprovalWorkFlowByIdQuery = { __typename?: 'Query', getApprovalWorkFlowById?: { __typename?: 'ApprovalWorkFlow', _id?: string | null, work_flow_type?: string | null, total_level?: number | null, overdue_days?: number | null, work_flow_levels?: Array<{ __typename?: 'workFlowLevels', level?: number | null, approval_to?: string | null, approval_level?: number | null, reminder?: string | null, move_to_next?: string | null, role?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null, escalation_user?: { __typename?: 'EscalationUserType', escalationReminder?: string | null, escalationRole?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null, escalationEmployee?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null } | null } | null };

export type CreateApprovalWorkFlowMutationVariables = Exact<{
  input: WorkFlowInput;
}>;


export type CreateApprovalWorkFlowMutation = { __typename?: 'Mutation', createApprovalWorkFlow?: { __typename?: 'ApprovalWorkFlow', _id?: string | null, work_flow_type?: string | null } | null };

export type UpdateApprovalWorkFlowMutationVariables = Exact<{
  input: UpdateWorkFlowInput;
}>;


export type UpdateApprovalWorkFlowMutation = { __typename?: 'Mutation', updateApprovalWorkFlow?: { __typename?: 'ApprovalWorkFlow', _id?: string | null, work_flow_type?: string | null } | null };

export type ArchiveApprovalWorkFlowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveApprovalWorkFlowMutation = { __typename?: 'Mutation', archiveApprovalWorkFlow?: boolean | null };

export type GetAttendanceListQueryVariables = Exact<{
  input?: InputMaybe<AttendanceListFilter>;
}>;


export type GetAttendanceListQuery = { __typename?: 'Query', getAttendanceList?: { __typename?: 'attendanceListExtendedresult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'attandencePolicy', _id?: string | null, is_deleted?: boolean | null, employeeIds?: number | null, group_name?: string | null, description?: string | null, department?: Array<string | null> | null, designation?: Array<string | null> | null, employee_type?: Array<string | null> | null, attendance_rule?: string | null, is_un_restricted?: boolean | null, deduct_days?: number | null, attendance_after_days?: number | null, block_employee_account_after?: number | null, missing_attendance_message?: string | null, send_absent_email_to_line_manager?: boolean | null, penalize_deduct_leave?: boolean | null, early_clockin?: boolean | null, before_early_clockin?: number | null, default_message_early?: boolean | null, modify_message_early?: string | null, late_clockin?: boolean | null, grace_period?: number | null, late_clockin_deduction?: string | null, base?: string | null, plenty_base?: string | null, deduct_salary_for_every?: number | null, deduct_salary_for_every_per_minuts?: number | null, apply_penalty_employee_daily_salary?: number | null, maximum_no_days?: number | null, late_coming_incidents?: string | null, for_every_incidents_late_coming?: number | null, deduct_days_of_leave_incidents?: number | null, How_are_leaves_deducted?: string | null, maximum_late_time?: boolean | null, maximum_late_time_deduction_after_minutes?: number | null, block_employee_default_message?: string | null, maximum_late_modify_message?: string | null, deduct_leave?: number | null, deduct_annually_minuts?: number | null, employesCount?: number | null, earlyOut_deduct_salary_incidents?: boolean | null, earlyOut_maximum_early_time?: number | null, messge_earlyOut?: string | null, earlyOut_deduct_based_on?: string | null, hours_penalize_deduct_leave?: boolean | null, wagebased?: boolean | null, wagebased_on?: string | null, percentage_base_no_of_days?: number | null, percentage_base_percentage_of_hourse?: number | null, overtime?: string | null, overtime_by_employeeType?: string | null, breaks?: string | null, minuts_period_break_in_out?: number | null, deduction_based?: string | null, break_deduct_salary_for_every_minuts?: number | null, break_deduct_salary_for_every_per_minuts?: number | null, block_user_acount_number_breaks?: number | null, break_modify_message?: string | null, percentage_Base?: string | null, start_date?: any | null, status?: string | null, Business?: { __typename?: 'Business', _id: string } | null, pay_type?: { __typename?: 'PayrollSchedule', _id?: string | null, schedule_name?: string | null } | null, employesId?: Array<{ __typename?: 'User', id?: string | null, final_settlement_completed?: boolean | null, is_deleted?: boolean | null, employee_id?: string | null, full_name?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null, is_deleted?: boolean | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null, is_deleted?: boolean | null } | null> | null } | null> | null, detail?: { __typename?: 'employeeDetail', actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, is_amount?: boolean | null } | null> | null, result?: Array<{ __typename?: 'User', final_settlement_completed?: boolean | null, is_deleted?: boolean | null, _id?: string | null, full_name?: string | null, employee_id?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, employee_group?: { __typename?: 'attandencePolicy', _id?: string | null, group_name?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type ArchiveAttandencePolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveAttandencePolicyMutation = { __typename?: 'Mutation', archiveAttandencePolicy?: boolean | null };

export type CreateAttendancePolicyMutationVariables = Exact<{
  input?: InputMaybe<HrPolicyInput>;
}>;


export type CreateAttendancePolicyMutation = { __typename?: 'Mutation', attendancePolicy?: boolean | null };

export type UpdateAttendancePolicyMutationVariables = Exact<{
  input?: InputMaybe<AttandencePolicyUpdate>;
}>;


export type UpdateAttendancePolicyMutation = { __typename?: 'Mutation', updateAttendancePolicy?: boolean | null };

export type ChangeEmployeeAttendancePolicyMutationVariables = Exact<{
  input: ChangePolicyInput_;
}>;


export type ChangeEmployeeAttendancePolicyMutation = { __typename?: 'Mutation', changeEmployeeAttendancePolicy?: boolean | null };

export type CheckEmployeeIsClockedInQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
}>;


export type CheckEmployeeIsClockedInQuery = { __typename?: 'Query', checkEmployeeIsClockedIn?: boolean | null };

export type GetAttendancePolicyGroupsQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
  policyStatus?: InputMaybe<PolicyStatusEnum>;
}>;


export type GetAttendancePolicyGroupsQuery = { __typename?: 'Query', getAttendancePolicyGroups?: Array<{ __typename?: 'attandencePolicy', _id?: string | null, group_name?: string | null, description?: string | null, is_un_restricted?: boolean | null } | null> | null };

export type GetattendancePolicyByIdQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetattendancePolicyByIdQuery = { __typename?: 'Query', getattendancePolicyByID?: { __typename?: 'attandencePolicy', _id?: string | null, group_name?: string | null, description?: string | null, is_un_restricted?: boolean | null, is_auto_clocked_in?: boolean | null, is_clocked_in_from_app?: boolean | null, attendance_rule?: string | null, block_employee_account_after?: number | null, block_employee_account_after_days?: number | null, deafult_missing_attendance_message?: boolean | null, missing_attendance_message?: string | null, send_absent_email_to_line_manager?: boolean | null, penalize_deduct_leave?: boolean | null, early_clockin?: boolean | null, before_early_clockin?: number | null, default_message_early?: boolean | null, modify_message_early?: string | null, late_clockin?: boolean | null, grace_period?: number | null, maximum_late_time?: boolean | null, maximum_late_time_deduction_after_minutes?: number | null, maximum_late_time_message?: boolean | null, maximum_late_modify_message?: string | null, maximum_emp_absent?: boolean | null, maximum_emp_time?: number | null, maximum_emp_message?: boolean | null, maximum_absent_modify_message?: string | null, is_email_to_employee?: boolean | null, earlyOut_deduct_salary_incidents?: boolean | null, clock_out_grace_period?: boolean | null, earlyOut_maximum_early_time?: number | null, lateOut_maximum_late_time?: number | null, paunch_out_mnts?: number | null, is_auto_miss_punch_writeup?: boolean | null, is_email_to_line_manager?: boolean | null, deafult_message_earlyOut?: boolean | null, messge_earlyOut?: string | null, lateOut_message?: boolean | null, lateOut_message_late_time?: string | null, is_exclude_grace_time_in_working_hours?: boolean | null, is_paid_for_extra_time?: boolean | null, over_time_hours?: number | null, over_time_rate?: number | null, is_weekend_mode?: boolean | null, is_paid_weekend?: boolean | null, working_days?: number | null, is_weekend_premium_before_limit?: boolean | null, is_weekend_premium_after_limit?: boolean | null, breaks?: string | null, minuts_period_break_in_out?: number | null, block_user_acount_number_breaks?: number | null, send_break_email_to_line_manager?: boolean | null, send_break_email_to_employee?: boolean | null, block_user?: boolean | null, break_modify_message?: string | null, weekEndDays?: Array<{ __typename?: 'weekEndDaysRetun', id?: number | null, name?: string | null, selected?: boolean | null } | null> | null, pay_type?: { __typename?: 'PayrollSchedule', _id?: string | null, schedule_name?: string | null } | null } | null };

export type CreateDepartmentMutationVariables = Exact<{
  input: DepartmentInput;
}>;


export type CreateDepartmentMutation = { __typename?: 'Mutation', createDepartment?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null };

export type UpdateDepartmentMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: DepartmentInput;
}>;


export type UpdateDepartmentMutation = { __typename?: 'Mutation', updateDepartment?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null };

export type DeleteDepartmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type DeleteDepartmentMutation = { __typename?: 'Mutation', deleteDepartment?: boolean | null };

export type GetDepartmentByIdQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetDepartmentByIdQuery = { __typename?: 'Query', getDepartmentById?: { __typename?: 'Department', _id?: string | null, department_name?: string | null, Business?: { __typename?: 'Business', _id: string } | null, businessLocation?: { __typename?: 'BusinessLocation', _id?: string | null } | null } | null };

export type GetDepartmentsListQueryVariables = Exact<{
  input: DepartmentListFilter;
}>;


export type GetDepartmentsListQuery = { __typename?: 'Query', getDepartmentsList?: { __typename?: 'departmentListingresult', results?: Array<{ __typename?: 'Department', is_deleted?: boolean | null, _id?: string | null, department_name?: string | null, employee_count?: number | null, Business?: { __typename?: 'Business', _id: string } | null, businessLocation?: { __typename?: 'BusinessLocation', _id?: string | null } | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type CreateDesignationMutationVariables = Exact<{
  input: DesignationsInput;
}>;


export type CreateDesignationMutation = { __typename?: 'Mutation', createDesignation?: { __typename?: 'Designation', _id?: string | null } | null };

export type UpdateDesignationMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: DesignationsInput;
}>;


export type UpdateDesignationMutation = { __typename?: 'Mutation', updateDesignation?: { __typename?: 'Designation', _id?: string | null } | null };

export type DeleteDesignationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type DeleteDesignationMutation = { __typename?: 'Mutation', deleteDesignation?: boolean | null };

export type GetDesignationByIdQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetDesignationByIdQuery = { __typename?: 'Query', getDesignationById?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null, business?: { __typename?: 'Business', _id: string } | null, businessLocation?: { __typename?: 'BusinessLocation', _id?: string | null } | null } | null };

export type GetDesignationListQueryVariables = Exact<{
  input: DesignationtListFilter;
}>;


export type GetDesignationListQuery = { __typename?: 'Query', getDesignationList?: { __typename?: 'designationListingresult', results?: Array<{ __typename?: 'Designation', is_deleted?: boolean | null, _id?: string | null, designation_name?: string | null, employee_count?: number | null, business?: { __typename?: 'Business', _id: string } | null, businessLocation?: { __typename?: 'BusinessLocation', _id?: string | null } | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type GetEmployeeListForSeparationQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEmployeeListForSeparationQuery = { __typename?: 'Query', getEmployeeListForSeparation?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, employee_id?: string | null, is_deleted?: boolean | null, isOwner?: boolean | null, joining_date?: any | null } | null> | null };

export type EmployeeSeparationListQueryVariables = Exact<{
  input?: InputMaybe<EmployeeSeparationFilter>;
}>;


export type EmployeeSeparationListQuery = { __typename?: 'Query', employeeSeparationList?: { __typename?: 'employeeListingresult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'employeeSeparation', _id?: string | null, resignation_date?: any | null, last_working_date?: any | null, settlement_completed?: boolean | null, is_deleted?: boolean | null, reason?: string | null, separation_type?: Separation_Types | null, reason_description?: string | null, attrition?: Attrition | null, payroll_hold?: boolean | null, is_notifiy?: boolean | null, created_at?: any | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, employee_id?: string | null } | null, business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null } | null> | null } | null };

export type GetEmployeeSeparationByIdQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetEmployeeSeparationByIdQuery = { __typename?: 'Query', getEmployeeSeparationById?: { __typename?: 'employeeSeparation', _id?: string | null, resignation_date?: any | null, last_working_date?: any | null, reason?: string | null, reason_description?: string | null, separation_type?: Separation_Types | null, attrition?: Attrition | null, payroll_hold?: boolean | null, is_notifiy?: boolean | null, settlement_completed?: boolean | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, employee_id?: string | null } | null, to_employees?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null, business?: { __typename?: 'Business', _id: string, business_legal_name?: string | null } | null, documents?: Array<{ __typename?: 'EmployeeDocument', document_description?: string | null, document_file_path?: string | null } | null> | null } | null };

export type GetEmployeePendingRequestsQueryVariables = Exact<{
  employeeID: Scalars['ID']['input'];
  action_performed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEmployeePendingRequestsQuery = { __typename?: 'Query', getEmployeePendingRequests?: { __typename?: 'pendingRequests', clockedHistory?: Array<{ __typename?: 'ClockedHistory', _id: string, attendanceDate?: string | null, attendanceStatus?: string | null, clock_in_time?: string | null, clock_out_time?: string | null, User: { __typename?: 'User', full_name?: string | null } } | null> | null, pending_loan_requests?: Array<{ __typename?: 'LoanPayment', _id?: string | null, loan_type?: string | null, loan_amount?: number | null, installment_amount?: number | null, balance?: number | null, status?: string | null, logs?: Array<{ __typename?: 'logsLoanPayments', changed_from?: string | null, changed_to?: string | null, date?: any | null, created_by?: { __typename?: 'User', full_name?: string | null } | null } | null> | null } | null> | null, pending_expenses_requests?: Array<{ __typename?: 'Expense', _id?: string | null, expense_type?: string | null, expense_total_amount?: number | null, status?: string | null, logs?: Array<{ __typename?: 'logsExpense', changed_from?: string | null, changed_to?: string | null, date?: any | null, created_by?: { __typename?: 'User', full_name?: string | null } | null } | null> | null } | null> | null, pending_attendance_requests?: Array<{ __typename?: 'AttendanceRegulation', _id?: string | null, reason_type?: string | null, description?: string | null, status?: string | null, attendance_date?: any | null, time_in?: string | null, time_out?: string | null, logs?: Array<{ __typename?: 'logsAttendanceRegulation', changed_from?: string | null, changed_to?: string | null, date?: any | null, created_by?: { __typename?: 'User', full_name?: string | null } | null } | null> | null } | null> | null, pending_leaves_requests?: Array<{ __typename?: 'timeOff', _id?: string | null, reason_for_leave?: string | null, status?: TimeOffStatus | null, total_leaves?: number | null, total_unpaid_leaves?: number | null, remaining_unpaid_days?: number | null, remaining_days?: number | null, logs?: Array<{ __typename?: 'logsTimeOff', changed_from?: string | null, changed_to?: string | null, date?: any | null, created_by?: { __typename?: 'User', full_name?: string | null } | null } | null> | null, type_of_absence?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null } | null, date_type_leave?: Array<{ __typename?: 'typeLeave', leave_date?: any | null, leave_type?: string | null } | null> | null } | null> | null, pending_writeup_requests?: Array<{ __typename?: 'WriteUp', _id?: string | null, write_up_type?: string | null, status?: string | null, writeup_date?: any | null, accept_assign_schedule?: boolean | null, informed_hr?: boolean | null, logs?: Array<{ __typename?: 'logsWriteUp', changed_from?: string | null, changed_to?: string | null, date?: any | null, created_by?: { __typename?: 'User', full_name?: string | null } | null } | null> | null } | null> | null, tasklisting?: Array<{ __typename?: 'TaskManagement_', _id?: string | null, task_name?: string | null, status?: string | null, no_sub_task?: number | null, summary?: string | null, logs?: Array<{ __typename?: 'logsTask', changed_from?: string | null, changed_to?: string | null, date?: any | null, created_by?: { __typename?: 'User', full_name?: string | null } | null } | null> | null, assignee?: Array<{ __typename?: 'User', _id?: string | null } | null> | null } | null> | null, documentListing?: Array<{ __typename?: 'DocumentControlAttachment', _id?: string | null, name?: string | null, activity_type?: Activity_Type | null, message?: string | null, status?: string | null } | null> | null, assetListing?: Array<{ __typename?: 'Asset', _id?: string | null, id?: string | null, name?: string | null, quantity?: number | null, type?: string | null, logs?: Array<{ __typename?: 'logsAsset', changedFrom?: string | null, changedTo?: string | null, date?: any | null, created_by?: { __typename?: 'User', full_name?: string | null } | null } | null> | null, assigned?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null> | null, workFlowListing?: Array<{ __typename?: 'UserWorkFlow', _id?: string | null, work_flow_type?: string | null, total_level?: number | null, logs?: Array<{ __typename?: 'workFlows', updated_at?: any | null, updated_by?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, previous_workflow_levels?: Array<{ __typename?: 'level', level?: number | null, approval_to?: string | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, role?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null } | null> | null, current_workflow_levels?: Array<{ __typename?: 'level', level?: number | null, approval_to?: string | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, role?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null } | null> | null } | null> | null, work_flow_levels?: Array<{ __typename?: 'level', level?: number | null, approval_to?: string | null, approval_level?: number | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, role?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null } | null> | null } | null> | null } | null };

export type GetEmployeeLastClockedInOrSeparationQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
  clockedHistory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEmployeeLastClockedInOrSeparationQuery = { __typename?: 'Query', getEmployeeLastClockedInOrSeparation?: { __typename?: 'clockedInOrSepration', firstClockedInDate?: any | null, lastClockedInDate?: any | null, last_working_date?: any | null, resignation_date?: any | null, seprationDate?: any | null } | null };

export type GetLeaveAfterLastWorkingDayQueryVariables = Exact<{
  input?: InputMaybe<GetLeaveAfterLastWorkingDayInput>;
}>;


export type GetLeaveAfterLastWorkingDayQuery = { __typename?: 'Query', getLeaveAfterLastWorkingDay?: Array<{ __typename?: 'Schedule', _id?: string | null, start_date?: any | null, end_date?: any | null } | null> | null };

export type CreateEmployeeSeparationMutationVariables = Exact<{
  input?: InputMaybe<EmployeeSeparationInput>;
}>;


export type CreateEmployeeSeparationMutation = { __typename?: 'Mutation', createEmployeeSeparation?: { __typename?: 'employeeSeparation', _id?: string | null } | null };

export type UpdateEmployeeSeparationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: EmployeeSeparationInput;
}>;


export type UpdateEmployeeSeparationMutation = { __typename?: 'Mutation', updateEmployeeSeparation?: { __typename?: 'employeeSeparation', _id?: string | null } | null };

export type DeleteEmployeeSeparationMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type DeleteEmployeeSeparationMutation = { __typename?: 'Mutation', deleteEmployeeSeparation?: boolean | null };

export type GetEmployeesForFinalSettlementQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeesForFinalSettlementQuery = { __typename?: 'Query', getEmployeesForFinalSettlement?: Array<{ __typename?: 'employeeSeparation', _id?: string | null, last_working_date?: any | null, employee?: { __typename?: 'User', full_name?: string | null, id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null } | null } | null> | null };

export type GetLoanDetailQueryVariables = Exact<{
  employee: Scalars['ID']['input'];
}>;


export type GetLoanDetailQuery = { __typename?: 'Query', getLoanDetail?: { __typename?: 'LoanDetail', total_loan?: number | null, balance?: number | null } | null };

export type GetExpenseDetailQueryVariables = Exact<{
  employee: Scalars['ID']['input'];
}>;


export type GetExpenseDetailQuery = { __typename?: 'Query', getExpenseDetail?: number | null };

export type GetFinalSettlementWithFiltersQueryVariables = Exact<{
  input: FinalSettlementFilter;
}>;


export type GetFinalSettlementWithFiltersQuery = { __typename?: 'Query', getFinalSettlementWithFilters?: { __typename?: 'finalSettlementResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'FinalSettlement', _id?: string | null, is_deleted?: boolean | null, separation_type?: string | null, description?: string | null, settlement_completed?: boolean | null, last_working_date?: any | null, expense_amount?: number | null, employee?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null, created_by?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null> | null } | null };

export type GetFinalSettlementByUserIdQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetFinalSettlementByUserIdQuery = { __typename?: 'Query', getFinalSettlementByUserId?: { __typename?: 'FinalSettlement', _id?: string | null, last_working_date?: any | null, description?: string | null, loan_amount?: number | null, leave_amount?: number | null, expense_amount?: number | null, created_at?: any | null, is_deleted?: boolean | null, employee?: { __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null } | null };

export type GetFinalSettlementByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFinalSettlementByIdQuery = { __typename?: 'Query', getFinalSettlementById?: { __typename?: 'FinalSettlement', _id?: string | null, last_working_date?: any | null, description?: string | null, loan_amount?: number | null, leave_amount?: number | null, expense_amount?: number | null, created_at?: any | null, is_deleted?: boolean | null, employee?: { __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null } | null };

export type CreateFinalSettlementMutationVariables = Exact<{
  input: InputFinalSettlement;
}>;


export type CreateFinalSettlementMutation = { __typename?: 'Mutation', createFinalSettlement?: { __typename?: 'FinalSettlement', _id?: string | null } | null };

export type UpdateFinalSettlementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: InputFinalSettlement;
}>;


export type UpdateFinalSettlementMutation = { __typename?: 'Mutation', updateFinalSettlement?: { __typename?: 'FinalSettlement', _id?: string | null } | null };

export type ArchiveFinalSettlementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveFinalSettlementMutation = { __typename?: 'Mutation', archiveFinalSettlement?: boolean | null };

export type GetEmployeeGarnishmentListQueryVariables = Exact<{
  input?: InputMaybe<InputemployeeGarnishmentList>;
}>;


export type GetEmployeeGarnishmentListQuery = { __typename?: 'Query', getEmployeeGarnishmentList?: { __typename?: 'employeeGarnishmentResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'EmployeeGarnishment', _id?: string | null, garnishment_type?: string | null, fix_amount?: number | null, garnishment_creator?: string | null, start_date?: any | null, is_deleted?: boolean | null, garnishment_account?: string | null, end_date?: any | null, document?: string | null, garnishment?: string | null, assignTo?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null> | null } | null };

export type GetEmployeeGarnishmentByIdQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetEmployeeGarnishmentByIdQuery = { __typename?: 'Query', getEmployeeGarnishmentById?: { __typename?: 'EmployeeGarnishment', _id?: string | null, garnishment_type?: string | null, garnishment_creator?: string | null, fix_amount?: number | null, garnishment_account?: string | null, garnishment?: string | null, start_date?: any | null, end_date?: any | null, document?: string | null, assignTo?: { __typename?: 'User', id?: string | null, full_name?: string | null } | null } | null };

export type CreateEmployeeGarnishmentMutationVariables = Exact<{
  input: EmployeeGarnishmentInput;
}>;


export type CreateEmployeeGarnishmentMutation = { __typename?: 'Mutation', createEmployeeGarnishment?: { __typename?: 'EmployeeGarnishment', _id?: string | null, garnishment_type?: string | null } | null };

export type UpdateEmployeeGarnishmentMutationVariables = Exact<{
  input?: InputMaybe<EmployeeGarnishmentUpdate>;
}>;


export type UpdateEmployeeGarnishmentMutation = { __typename?: 'Mutation', updateEmployeeGarnishment?: { __typename?: 'EmployeeGarnishment', _id?: string | null, garnishment_type?: string | null } | null };

export type ArchiveEmployeeGarnishmentMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveEmployeeGarnishmentMutation = { __typename?: 'Mutation', archiveEmployeeGarnishment?: boolean | null };

export type GetGratuityPolicyQueryVariables = Exact<{
  business: Scalars['ID']['input'];
}>;


export type GetGratuityPolicyQuery = { __typename?: 'Query', getGratuityPolicy?: { __typename?: 'Gratuity', _id?: string | null, month_days?: string | null, total_working_days?: string | null, type?: string | null, is_deleted?: boolean | null } | null };

export type CreateUpdateGratuityMutationVariables = Exact<{
  input?: InputMaybe<GratuityInput>;
}>;


export type CreateUpdateGratuityMutation = { __typename?: 'Mutation', createUpdateGratuity?: { __typename?: 'Gratuity', _id?: string | null } | null };

export type CreateUpdateLeavePolicyMutationVariables = Exact<{
  input: LeavePolicyInput;
}>;


export type CreateUpdateLeavePolicyMutation = { __typename?: 'Mutation', createUpdateLeavePolicy?: { __typename?: 'LeavePolicy', _id?: string | null, name: string } | null };

export type ArchiveLeavePolicyByIdMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveLeavePolicyByIdMutation = { __typename?: 'Mutation', archiveLeavePolicyById?: boolean | null };

export type RemoveEmployeeFromLeavePolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
}>;


export type RemoveEmployeeFromLeavePolicyMutation = { __typename?: 'Mutation', removeEmployeeFromLeavePolicy?: boolean | null };

export type ChangeEmployeeLeavePolicyMutationVariables = Exact<{
  input: ChangePolicyInput;
}>;


export type ChangeEmployeeLeavePolicyMutation = { __typename?: 'Mutation', changeEmployeeLeavePolicy?: { __typename?: 'LeavePolicy', _id?: string | null } | null };

export type AssignLeavePolicyToEmployeeMutationVariables = Exact<{
  input: AssignLeavePolicyInput;
}>;


export type AssignLeavePolicyToEmployeeMutation = { __typename?: 'Mutation', assignLeavePolicyToEmployee?: { __typename?: 'LeavePolicy', _id?: string | null } | null };

export type GetLeavePolicyByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  employee?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLeavePolicyByIdQuery = { __typename?: 'Query', getLeavePolicyById?: { __typename?: 'LeavePolicy', _id?: string | null, name: string, is_deleted?: boolean | null, sandwich?: boolean | null, sandwich_on_public_holiday?: boolean | null, is_accrual?: boolean | null, accrual_type?: YearlyMonthlyEnum | null, accrual_on_day?: string | null, accrual_on_month?: string | null, accrual_no_of_hours?: number | null, accrual_one_time_day?: string | null, is_reset?: boolean | null, reset_type?: YearlyMonthlyEnum | null, reset_on_day?: string | null, reset_on_month?: string | null, reset_carry_forward_count?: number | null, reset_max_limit?: number | null, is_manual_deduction?: boolean | null, is_week_hour_limit?: boolean | null, manual_deduction_value?: number | null, is_hourly_employee_sandwich?: boolean | null, leaves?: Array<{ __typename?: 'leavesType', count?: number | null, countIn?: string | null, policy_type?: string | null, carry_forward_limit?: number | null, leaveAssighment?: string | null, type?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null, is_pto?: boolean | null, un_paid_days?: string | null, pto_type?: string | null } | null } | null> | null, assign_to?: Array<{ __typename?: 'User', employee_id?: string | null, id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, pto_minutes?: { __typename?: 'PtoMinutesType', pto_earned_minutes?: number | null, pto_availed_minutes?: number | null, pto_fixed_total_minutes?: number | null } | null, time_off?: Array<{ __typename?: 'TimeOffType', time_off_days?: string | null, time_off_total_days?: string | null, countIn?: string | null, time_off_type?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null, is_pto?: boolean | null, pto_type?: string | null } | null } | null> | null } | null> | null } | null };

export type GetEmployeesForLeavePolicyQueryVariables = Exact<{
  args?: InputMaybe<GetLeavePolicyArguments>;
}>;


export type GetEmployeesForLeavePolicyQuery = { __typename?: 'Query', getEmployeesForLeavePolicy?: Array<{ __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, joining_date?: any | null, employee_group?: { __typename?: 'attandencePolicy', is_un_restricted?: boolean | null } | null, time_off?: Array<{ __typename?: 'TimeOffType', time_off_days?: string | null, time_off_total_days?: string | null, time_off_type?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null, is_pto?: boolean | null } | null } | null> | null } | null> | null };

export type ChangeEmployeeLeavePackageMutationVariables = Exact<{
  input: ChangeLeavePolicyInput;
}>;


export type ChangeEmployeeLeavePackageMutation = { __typename?: 'Mutation', changeEmployeeLeavePackage?: { __typename?: 'LeavePolicy', _id?: string | null, name: string } | null };

export type CreateUpdateLeaveTypeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: InputLeaveType;
}>;


export type CreateUpdateLeaveTypeMutation = { __typename?: 'Mutation', createUpdateLeaveType?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null } | null };

export type ArchiveLeaveTypeByIdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveLeaveTypeByIdMutation = { __typename?: 'Mutation', archiveLeaveTypeById?: boolean | null };

export type GetLeavesTypeWithSearchQueryVariables = Exact<{
  input?: InputMaybe<LeaveTypeListFilter>;
}>;


export type GetLeavesTypeWithSearchQuery = { __typename?: 'Query', getLeavesTypeWithSearch?: { __typename?: 'leaveTypeListingResult', results?: Array<{ __typename?: 'LeaveType', _id?: string | null, name?: string | null, code?: string | null, type?: string | null, is_pto?: boolean | null, is_deleted?: boolean | null, description?: string | null } | null> | null, config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null } | null };

export type GetLeaveTypeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLeaveTypeByIdQuery = { __typename?: 'Query', getLeaveTypeById?: { __typename?: 'LeaveType', _id?: string | null, name?: string | null, code?: string | null, type?: string | null, description?: string | null, leave_duration?: LeaveDuration | null, minimum_duration?: string | null, maximum_duration?: string | null, per_day_hours?: string | null, working_days?: string | null, un_paid?: boolean | null, un_paid_days?: string | null, half_leave_in_ful_leave?: boolean | null, half_day_Consideration?: HalfDayConsideration | null, consecutive_leaves?: string | null, is_pto?: boolean | null, pto_type?: string | null, assign_to?: Assign_To | null, pto_earning_threshold_hours?: number | null, pto_hours_against_threshold?: number | null, pto_minimum_consumable_hours?: number | null, pto_advance_notice_days?: number | null, is_pto_against_overtime?: boolean | null, is_pto_against_weekend?: boolean | null, is_pto_against_public_holiday?: boolean | null, fixed_pto_ratio?: number | null, pto_value_in?: PtoValueIn | null, is_allow_partial_apply?: boolean | null, partial_apply_minimum?: string | null, is_reset?: boolean | null, reset_carry_forward_count?: number | null, policy_type?: string | null, blackOutWindow?: Array<{ __typename?: 'BlackOutWindow', date?: any | null, reason?: string | null } | null> | null, ranges?: Array<{ __typename?: 'RangeType', start?: number | null, end?: number | null, value?: number | null } | null> | null } | null };

export type GetMedicalInsurancePackageListQueryVariables = Exact<{
  input?: InputMaybe<MedicalInsuranceListFilter>;
}>;


export type GetMedicalInsurancePackageListQuery = { __typename?: 'Query', getMedicalInsurancePackageList?: { __typename?: 'MedicalInsurancePackageConfigUpdate', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'MedicalInsurancePackage', _id?: string | null, package_name?: string | null, company?: string | null, package_type?: string | null, package_price?: number | null, is_deleted?: boolean | null, enrollment_start_date?: any | null, enrollment_start_days?: number | null, enrollment_end_days?: number | null, enrollment_end_date?: any | null, monthly_cost_to_employe?: number | null, monthly_cost_to_employer?: number | null, notify_before_days?: number | null, MasterDataValue?: Array<{ __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null } | null> | null, assigned_to?: Array<{ __typename?: 'User', _id?: string | null } | null> | null } | null> | null } | null };

export type CreateUpdateMedicalInsurancePackageMutationVariables = Exact<{
  input?: InputMaybe<MedicalInsurancePackageInput>;
}>;


export type CreateUpdateMedicalInsurancePackageMutation = { __typename?: 'Mutation', createUpdateMedicalInsurancePackage?: { __typename?: 'MedicalInsurancePackage', _id?: string | null, package_name?: string | null } | null };

export type ArchiveMedicalInsurancePackageMutationVariables = Exact<{
  input?: InputMaybe<ArchiveMedicalInsurancepackageInput>;
}>;


export type ArchiveMedicalInsurancePackageMutation = { __typename?: 'Mutation', archiveMedicalInsurancePackage?: boolean | null };

export type GetPublicHolidaysWithFiltersQueryVariables = Exact<{
  input?: InputMaybe<PublicHolidaysFilter>;
}>;


export type GetPublicHolidaysWithFiltersQuery = { __typename?: 'Query', getPublicHolidaysWithFilters?: { __typename?: 'publicHolidaysResult', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'PublicHoliday', _id?: string | null, name?: string | null, from_date?: any | null, to_date?: any | null, is_recursive?: boolean | null, is_deleted?: boolean | null } | null> | null } | null };

export type GetPublicHolidaysByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPublicHolidaysByIdQuery = { __typename?: 'Query', getPublicHolidaysByID?: { __typename?: 'PublicHoliday', _id?: string | null, name?: string | null, from_date?: any | null, to_date?: any | null, is_recursive?: boolean | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null } | null };

export type CreateUpdatePublicHolidaysMutationVariables = Exact<{
  input?: InputMaybe<InputPublicHolidays>;
}>;


export type CreateUpdatePublicHolidaysMutation = { __typename?: 'Mutation', createUpdatePublicHolidays?: { __typename?: 'PublicHoliday', _id?: string | null, name?: string | null } | null };

export type ArchivePublicHolidaysMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchivePublicHolidaysMutation = { __typename?: 'Mutation', archivePublicHolidays?: boolean | null };

export type CreateUpdateShiftMutationVariables = Exact<{
  input?: InputMaybe<ShiftInput>;
}>;


export type CreateUpdateShiftMutation = { __typename?: 'Mutation', createUpdateShift?: { __typename?: 'Shift', _id?: string | null, shift_name: string } | null };

export type ArchiveShiftMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']['input']>;
  archive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArchiveShiftMutation = { __typename?: 'Mutation', archiveShift?: boolean | null };

export type GetWriteupsQueryVariables = Exact<{
  input?: InputMaybe<WriteUpListFilter>;
}>;


export type GetWriteupsQuery = { __typename?: 'Query', getWriteups?: { __typename?: 'writeUpListDataTable', config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'WriteUp', _id?: string | null, write_up_type?: string | null, write_up_reason?: string | null, description?: string | null, approval_description?: string | null, approval_status?: string | null, status?: string | null, informed_hr?: boolean | null, email?: string | null, writeup_date?: any | null, writeup_message?: string | null, created_at?: any | null, is_deleted?: boolean | null, is_pending?: boolean | null, write_up_source?: string | null, attachments?: Array<string | null> | null, employee?: { __typename?: 'User', _id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null, business_manager?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, work_flow?: Array<{ __typename?: 'workFlow', approval_description?: string | null, status?: string | null, approved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null> | null } | null> | null } | null };

export type GetWriteUpByIdQueryVariables = Exact<{
  getWriteUpByIdId: Scalars['ID']['input'];
}>;


export type GetWriteUpByIdQuery = { __typename?: 'Query', getWriteUpById?: { __typename?: 'WriteUp', _id?: string | null, write_up_type?: string | null, write_up_reason?: string | null, description?: string | null, approval_description?: string | null, approval_status?: string | null, status?: string | null, informed_hr?: boolean | null, email?: string | null, writeup_date?: any | null, writeup_message?: string | null, created_at?: any | null, is_deleted?: boolean | null, attachments?: Array<string | null> | null, employee?: { __typename?: 'User', _id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null, business_manager?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, work_flow?: Array<{ __typename?: 'workFlow', approval_description?: string | null, status?: string | null, approved_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, employee?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null> | null } | null };

export type DeleteWriteUpMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  archive: Scalars['Boolean']['input'];
}>;


export type DeleteWriteUpMutation = { __typename?: 'Mutation', deleteWriteUp?: boolean | null };

export type UpdateWriteUpApprovalMutationVariables = Exact<{
  input: InputUpdateWriteUpApproval;
}>;


export type UpdateWriteUpApprovalMutation = { __typename?: 'Mutation', updateWriteUpApproval?: boolean | null };

export type CreateMasterDataTypeMutationVariables = Exact<{
  input: DataTypeInput;
}>;


export type CreateMasterDataTypeMutation = { __typename?: 'Mutation', createMasterDataType?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', id?: string | null } | null } | null };

export type CreateMasterDataTypeValueMutationVariables = Exact<{
  input: DataTypeValueInput;
}>;


export type CreateMasterDataTypeValueMutation = { __typename?: 'Mutation', createMasterDataTypeValue?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, is_system_generated?: boolean | null, created_at?: any | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null, data_value_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null } | null, created_by?: { __typename?: 'User', id?: string | null } | null } | null };

export type UpdateMasterDataTypeValueMutationVariables = Exact<{
  input: UpdateDataTypeValueInput;
}>;


export type UpdateMasterDataTypeValueMutation = { __typename?: 'Mutation', updateMasterDataTypeValue?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, is_system_generated?: boolean | null, created_at?: any | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null, data_value_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null } | null, created_by?: { __typename?: 'User', id?: string | null } | null } | null };

export type GetAllMasterDataTypeValueByIdQueryVariables = Exact<{
  getAllMasterDataTypeValueByIdId: Scalars['ID']['input'];
}>;


export type GetAllMasterDataTypeValueByIdQuery = { __typename?: 'Query', getAllMasterDataTypeValueById?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, is_system_generated?: boolean | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null } | null, business?: { __typename?: 'Business', _id: string } | null, data_value_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null } | null } | null };

export type DeleteMasterDataTypeValueMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMasterDataTypeValueMutation = { __typename?: 'Mutation', deleteMasterDataTypeValue?: boolean | null };

export type GetAllMasterDataTypeWithSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllMasterDataTypeWithSearchQuery = { __typename?: 'Query', getAllMasterDataTypeWithSearch?: Array<{ __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null, created_at?: any | null, created_by?: { __typename?: 'User', id?: string | null } | null } | null> | null };

export type GetAllMasterDataTypeValueWithSearchQueryVariables = Exact<{
  input: SearchDataTypeValueInput;
}>;


export type GetAllMasterDataTypeValueWithSearchQuery = { __typename?: 'Query', getAllMasterDataTypeValueWithSearch?: { __typename?: 'dataTypeResult', page?: number | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null, results?: Array<{ __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, is_system_generated?: boolean | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null } | null, business?: { __typename?: 'Business', _id: string } | null, data_value_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null } | null } | null> | null } | null };

export type GetAllMasterDataTypeValueByTypeIdQueryVariables = Exact<{
  input: DataValueInput;
}>;


export type GetAllMasterDataTypeValueByTypeIdQuery = { __typename?: 'Query', getAllMasterDataTypeValueByTypeId?: Array<{ __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null, data_value_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, is_system_generated?: boolean | null, created_at?: any | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null, data_value_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null } | null } | null, created_by?: { __typename?: 'User', id?: string | null } | null, business?: { __typename?: 'Business', _id: string } | null } | null } | null> | null };

export type GetAllNotificationsWithFiltersQueryVariables = Exact<{
  input?: InputMaybe<NotificationFilterInput>;
}>;


export type GetAllNotificationsWithFiltersQuery = { __typename?: 'Query', getAllNotificationsWithFilters?: { __typename?: 'notificationListingResult', page?: number | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null, notificationCount?: number | null, results?: Array<{ __typename?: 'notification', is_reminder_sent?: boolean | null, has_action?: boolean | null, action_type?: string | null, defaultSystemNotification?: boolean | null, data_object?: any | null, _id?: string | null, title?: string | null, description?: string | null, is_read?: boolean | null, created_at?: any | null, path?: { __typename?: 'NotificationPath', slug?: string | null, feature?: string | null, module?: string | null, navigationUrl?: string | null } | null, user_id?: { __typename?: 'User', full_name?: string | null, id?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null } | null, for_user?: { __typename?: 'User', full_name?: string | null, id?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null } | null } | null> | null } | null };

export type GetAllPermissionOfNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPermissionOfNotificationsQuery = { __typename?: 'Query', getAllPermissionOfNotifications?: Array<{ __typename?: 'NotificationModuleAndPermission', _id?: string | null, feature?: string | null, is_checked?: boolean | null, is_default?: boolean | null, is_deleted?: boolean | null, is_enabled?: boolean | null, module?: string | null, permission_at?: string | null, slug?: string | null, sub_feature?: string | null, userID?: string | null, created_at?: any | null, role?: Array<{ __typename?: 'Role', roleName?: string | null } | null> | null } | null> | null };

export type MarkAllAsReadMutationVariables = Exact<{
  input?: InputMaybe<MarkAsReadInput>;
}>;


export type MarkAllAsReadMutation = { __typename?: 'Mutation', markAllAsRead?: boolean | null };

export type UpdateNotificationPermissionsMutationVariables = Exact<{
  input?: InputMaybe<UpdatePermissions>;
}>;


export type UpdateNotificationPermissionsMutation = { __typename?: 'Mutation', updateNotificationPermissions?: boolean | null };

export type MarkNotificationsAsClearedMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type MarkNotificationsAsClearedMutation = { __typename?: 'Mutation', MarkNotificationsAsCleared?: boolean | null };

export type DeleteNotificationMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type DeleteNotificationMutation = { __typename?: 'Mutation', deleteNotification?: boolean | null };

export type SetDoNotDisturbInNotificationsMutationVariables = Exact<{
  doNotDisturb?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetDoNotDisturbInNotificationsMutation = { __typename?: 'Mutation', setDoNotDisturbInNotifications?: boolean | null };

export type MarkAllViewedMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllViewedMutation = { __typename?: 'Mutation', markAllViewed?: boolean | null };

export type CreateReminderForNotificationMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type CreateReminderForNotificationMutation = { __typename?: 'Mutation', createReminderForNotification?: boolean | null };

export type GeneratedNotificationSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GeneratedNotificationSubscription = { __typename?: 'Subscription', generatedNotification?: { __typename?: 'notification', _id?: string | null, created_at?: any | null, data_object?: any | null, description?: string | null, is_read?: boolean | null, title?: string | null, for_user?: { __typename?: 'User', id?: string | null, full_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null } | null, path?: { __typename?: 'NotificationPath', feature?: string | null, module?: string | null, navigationUrl?: string | null } | null, user_id?: { __typename?: 'User', id?: string | null, full_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null } | null } | null };

export type SendNotificationCountSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type SendNotificationCountSubscription = { __typename?: 'Subscription', sendNotificationCount?: { __typename?: 'notificationCount', notificationCount?: number | null } | null };

export type UserPinCodeVerifyMutationVariables = Exact<{
  pincode: Scalars['String']['input'];
  businessId: Scalars['ID']['input'];
  clockedTime: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
}>;


export type UserPinCodeVerifyMutation = { __typename?: 'Mutation', userPinCodeVerify?: { __typename?: 'userCLocked', oldClockHistoryId?: string | null, clocked_in_time?: string | null, status?: string | null, UserClockInPin: string, clockedHistory?: { __typename?: 'ClockedHistory', breaks?: Array<{ __typename?: 'BreakClockedHistory', _id: string, break_duration?: number | null, breakInstatus?: string | null, break_in_time?: string | null, break_out_time?: string | null, title?: string | null, message?: string | null, break_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, is_system_generated?: boolean | null, data_value_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null } | null } | null } | null> | null } | null, break_details?: { __typename?: 'break_details', break_in_time?: string | null, breakID?: string | null, breakType?: string | null, breakTypeID?: string | null } | null, User?: { __typename?: 'User', id?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, middle_name?: string | null, writeup_type?: string | null, writeup_date?: string | null, storeAccess?: Array<{ __typename?: 'StoreAccessType', businessLocation?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null, location_keeping_unit?: string | null, logo?: string | null } | null } | null> | null, employee_group?: { __typename?: 'attandencePolicy', _id?: string | null, is_clocked_in_from_app?: boolean | null } | null } | null, tokens?: { __typename?: 'tokens', access?: { __typename?: 'token', token?: string | null, expires?: any | null } | null, refresh?: { __typename?: 'token', token?: string | null, expires?: any | null } | null } | null } | null };

export type UserClockedInMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  userClockInPin: Scalars['ID']['input'];
  clockedTime: Scalars['String']['input'];
  zoneName?: InputMaybe<Scalars['String']['input']>;
  oldClockHistoryId?: InputMaybe<Scalars['ID']['input']>;
  businessLocation?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserClockedInMutation = { __typename?: 'Mutation', userClockedIn?: { __typename?: 'ClockedHistory', _id: string, message?: string | null, clock_in_time?: string | null, write_up_type?: string | null, attendanceStatus?: string | null, breaks?: Array<{ __typename?: 'BreakClockedHistory', _id: string, break_duration?: number | null, breakInstatus?: string | null } | null> | null } | null };

export type CreateUpdateConfigListingMutationVariables = Exact<{
  input?: InputMaybe<ConfigListingInput>;
}>;


export type CreateUpdateConfigListingMutation = { __typename?: 'Mutation', createUpdateConfigListing?: { __typename?: 'ConfigListing', actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null } | null };

export type ColumnDefinitionWithoutSummaryFieldsFragment = { __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null };

export type ColumnDefinitionWithSummaryFieldsFragment = { __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null };

export type FilterFieldsFragment = { __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null };

export type TablePresetFieldsFragment = { __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null };

export type SharedConfigFieldsFragment = { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null };

export type ConfigWithoutSummaryFieldsFragment = { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null };

export type ConfigWithSummaryFieldsFragment = { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null };

export type GetPaymentMethodQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPaymentMethodQuery = { __typename?: 'Query', getPaymentMethod?: { __typename?: 'cardsDetail', default?: string | null, cards?: Array<{ __typename?: 'getPaymentMethod', id?: string | null, customer?: string | null, billing_details?: { __typename?: 'billing_details', email?: string | null, name?: string | null } | null, card?: { __typename?: 'card', brand?: string | null, country?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null } | null> | null } | null };

export type AddNewPaymentMethodCustomerMutationVariables = Exact<{
  input?: InputMaybe<PaymentMethod>;
}>;


export type AddNewPaymentMethodCustomerMutation = { __typename?: 'Mutation', addNewPaymentMethodCustomer?: boolean | null };

export type ArchivePaymentMethodMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type ArchivePaymentMethodMutation = { __typename?: 'Mutation', archivePaymentMethod?: boolean | null };

export type GetAllSubscriptionLogActivityQueryVariables = Exact<{
  input?: InputMaybe<LogActivity>;
}>;


export type GetAllSubscriptionLogActivityQuery = { __typename?: 'Query', getAllSubscriptionLogActivity?: { __typename?: 'logActivityListingResult', results?: Array<{ __typename?: 'SubscriptionLogActivity', _id?: string | null, type?: string | null, title?: string | null, description?: string | null, activity_date?: any | null, file_name?: string | null, attachment?: string | null } | null> | null, config?: { __typename?: 'dataTableConfig', page?: number | null, limit?: number | null, totalPages?: number | null, totalResults?: number | null } | null } | null };

export type GetSubscriptionLogActivityByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSubscriptionLogActivityByIdQuery = { __typename?: 'Query', getSubscriptionLogActivityById?: { __typename?: 'SubscriptionLogActivity', _id?: string | null, type?: string | null, title?: string | null, description?: string | null, activity_date?: any | null } | null };

export type CreateSubscriptionLogActivityMutationVariables = Exact<{
  input: InputCreateLogActivity;
}>;


export type CreateSubscriptionLogActivityMutation = { __typename?: 'Mutation', createSubscriptionLogActivity?: { __typename?: 'SubscriptionLogActivity', _id?: string | null } | null };

export type UpdateSubscriptionLogActivityMutationVariables = Exact<{
  input: InputUpdateLogActivity;
}>;


export type UpdateSubscriptionLogActivityMutation = { __typename?: 'Mutation', updateSubscriptionLogActivity?: { __typename?: 'SubscriptionLogActivity', _id?: string | null } | null };

export type ArchiveSubscriptionLogActivityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveSubscriptionLogActivityMutation = { __typename?: 'Mutation', archiveSubscriptionLogActivity?: boolean | null };

export type GetSubscriptionByRequestedBusinessIdQueryVariables = Exact<{
  business_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSubscriptionByRequestedBusinessIdQuery = { __typename?: 'Query', getSubscriptionByRequestedBusinessId?: { __typename?: 'Subscription', _id?: string | null, show_paynow?: boolean | null, is_custom_package?: boolean | null, status?: AllowedSubscriptionStatus | null, created_at?: any | null, user_request_from?: { __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, email?: string | null, phone?: string | null } | null, request_from?: { __typename?: 'Business', _id: string, business_system_name?: string | null, address?: string | null, zip_code?: string | null, Country?: { __typename?: 'Country', name?: string | null } | null } | null, request_to?: { __typename?: 'Business', _id: string, business_system_name?: string | null } | null, package?: { __typename?: 'Package', _id?: string | null, package_name?: string | null, package_price?: number | null, recurring?: PackageRecurrignType | null } | null } | null };

export type GetSubscriptionByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSubscriptionByIdQuery = { __typename?: 'Query', getSubscriptionById?: { __typename?: 'Subscription', _id?: string | null, show_paynow?: boolean | null, is_custom_package?: boolean | null, status?: AllowedSubscriptionStatus | null, created_at?: any | null, user_request_from?: { __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, email?: string | null, phone?: string | null } | null, request_from?: { __typename?: 'Business', _id: string, business_system_name?: string | null, address?: string | null, zip_code?: string | null, Country?: { __typename?: 'Country', name?: string | null } | null } | null, request_to?: { __typename?: 'Business', _id: string, business_system_name?: string | null } | null, package?: { __typename?: 'Package', _id?: string | null, package_name?: string | null, package_type?: string | null, package_price?: number | null, recurring?: PackageRecurrignType | null, is_pakage_free?: boolean | null, transcation_fee_calculation_type?: PackageTranscationFeeType | null, transcation_fee?: number | null, no_of_store?: number | null, no_of_employee?: number | null, number_of_cashregisters?: number | null } | null } | null };

export type GetPacakgesForCustomSubscriptionRequestQueryVariables = Exact<{
  subscription: Scalars['ID']['input'];
}>;


export type GetPacakgesForCustomSubscriptionRequestQuery = { __typename?: 'Query', getPacakgesForCustomSubscriptionRequest?: Array<{ __typename?: 'Package', _id?: string | null, package_name?: string | null, package_type?: string | null, package_price?: number | null, recurring?: PackageRecurrignType | null, is_pakage_free?: boolean | null, transcation_fee_calculation_type?: PackageTranscationFeeType | null, transcation_fee?: number | null, no_of_store?: number | null, no_of_employee?: number | null, number_of_cashregisters?: number | null, created_at?: any | null } | null> | null };

export type GetSubscriptionPaymentLogsQueryVariables = Exact<{
  subscription: Scalars['ID']['input'];
}>;


export type GetSubscriptionPaymentLogsQuery = { __typename?: 'Query', getSubscriptionPaymentLogs?: Array<{ __typename?: 'PackagePaymentLogs', remarks?: string | null, createdAt?: any | null } | null> | null };

export type BusinessPackageByBusinessIdQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
}>;


export type BusinessPackageByBusinessIdQuery = { __typename?: 'Query', businessPackageByBusinessId?: { __typename?: 'BusinessPackage', _id?: string | null, package_name: string, package_type: string, package_price: number, recurring: PackageRecurrignType, is_pakage_free: boolean, transcation_fee_calculation_type?: PackageTranscationFeeType | null, transcation_fee?: number | null, no_of_store?: number | null, no_of_employee?: number | null, number_of_cashregisters?: number | null, subscribe_at?: any | null, hr_module_only?: boolean | null, expires_at?: any | null } | null };

export type CalculateUpdatePackageFeeQueryVariables = Exact<{
  package: Scalars['ID']['input'];
  subscription: Scalars['ID']['input'];
}>;


export type CalculateUpdatePackageFeeQuery = { __typename?: 'Query', calculateUpdatePackageFee?: number | null };

export type GetFranchiseRequestsQueryVariables = Exact<{
  business: Scalars['ID']['input'];
}>;


export type GetFranchiseRequestsQuery = { __typename?: 'Query', getFranchiseRequests?: Array<{ __typename?: 'FranchiseRequest', _id?: string | null, franchise_fee?: number | null, payment_pending?: boolean | null, Franchise?: { __typename?: 'BusinessLocation', _id?: string | null, store_nick_name?: string | null } | null, FranchiseeBusiness?: { __typename?: 'Business', _id: string, business_system_name?: string | null } | null, FranchiserBusiness?: { __typename?: 'Business', _id: string, business_system_name?: string | null } | null } | null> | null };

export type ChangeSubsriptionStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: AllowedSubscriptionStatus;
}>;


export type ChangeSubsriptionStatusMutation = { __typename?: 'Mutation', changeSubsriptionStatus?: boolean | null };

export type AssignPackageToSubscriptionMutationVariables = Exact<{
  subscription: Scalars['ID']['input'];
  package: Scalars['ID']['input'];
}>;


export type AssignPackageToSubscriptionMutation = { __typename?: 'Mutation', assignPackageToSubscription?: boolean | null };

export type PayForPackageSubsctipitonMutationVariables = Exact<{
  subscription: Scalars['ID']['input'];
}>;


export type PayForPackageSubsctipitonMutation = { __typename?: 'Mutation', payForPackageSubsctipiton?: boolean | null };

export type UpdateBusinessPackageMutationVariables = Exact<{
  package: Scalars['ID']['input'];
  subscription: Scalars['ID']['input'];
  inActiveEmployees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  inActiveStore?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type UpdateBusinessPackageMutation = { __typename?: 'Mutation', updateBusinessPackage?: boolean | null };

export type CancelBusinessPackageMutationVariables = Exact<{
  business: Scalars['ID']['input'];
}>;


export type CancelBusinessPackageMutation = { __typename?: 'Mutation', cancelBusinessPackage?: boolean | null };

export type PayFranchiseSubscriptionMutationVariables = Exact<{
  requestId: Scalars['ID']['input'];
}>;


export type PayFranchiseSubscriptionMutation = { __typename?: 'Mutation', payFranchiseSubscription?: boolean | null };

export type SetDefaultCardMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type SetDefaultCardMutation = { __typename?: 'Mutation', setDefaultCard?: boolean | null };

export type GetBusinessSubscriptionsQueryVariables = Exact<{
  input?: InputMaybe<SubscriptionListFilter>;
}>;


export type GetBusinessSubscriptionsQuery = { __typename?: 'Query', getBusinessSubscriptions?: { __typename?: 'SubscriptionDataTableList', results?: Array<{ __typename?: 'Subscription', _id?: string | null, is_deleted?: boolean | null, email?: string | null, phone?: string | null, created_at?: any | null, status?: AllowedSubscriptionStatus | null, user_request_from?: { __typename?: 'User', id?: string | null, full_name?: string | null, business_id?: { __typename?: 'Business', _id: string, business_type?: string | null } | null } | null, package?: { __typename?: 'Package', _id?: string | null, package_name?: string | null } | null } | null> | null, config?: { __typename?: 'dataTableConfig', actions?: Array<string | null> | null, limit?: number | null, no_of_records?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, type?: string | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null } | null } | null };

export type DeleteSubscriptionRequestMutationVariables = Exact<{
  deleteSubscriptionRequestId: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  archive: Scalars['Boolean']['input'];
}>;


export type DeleteSubscriptionRequestMutation = { __typename?: 'Mutation', deleteSubscriptionRequest?: boolean | null };

export type GetAllTasksWithSearchQueryVariables = Exact<{
  input: AllTasksInput;
}>;


export type GetAllTasksWithSearchQuery = { __typename?: 'Query', getAllTasksWithSearch?: { __typename?: 'allTasksListingResult', config?: { __typename?: 'dataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<string | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, data?: Array<{ __typename?: 'TaskManagementWithData', _id?: string | null, summary?: string | null, description?: string | null, editor_description?: string | null, attachments?: Array<string | null> | null, attachments_name?: Array<string | null> | null, formatted_time: string, total_time_spent: number, is_timing_active: boolean, is_timing_ended: boolean, created_at?: any | null, due_date?: any | null, completed_date?: any | null, task_name?: string | null, no_sub_task?: number | null, is_owner?: boolean | null, comment_count?: number | null, attachments_count?: number | null, priority?: string | null, status?: string | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, assignee?: Array<{ __typename?: 'User', full_name?: string | null, id?: string | null } | null> | null, reporter?: { __typename?: 'User', full_name?: string | null, id?: string | null } | null, comments?: Array<{ __typename?: 'commenType', _id?: string | null, comment?: string | null, comment_date?: any | null, comment_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, logo?: string | null } | null, replies?: Array<{ __typename?: 'replyType', _id?: string | null, reply?: string | null, reply_date?: any | null, reply_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, logo?: string | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type GetTasksCountQueryVariables = Exact<{
  input?: InputMaybe<TaskCountInput>;
}>;


export type GetTasksCountQuery = { __typename?: 'Query', getTasksCount?: { __typename?: 'tasksCountResult', assign_by_me?: number | null, assign_to_me?: number | null, my_tasks?: number | null } | null };

export type GetTeamMembersQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  businessLocaion?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetTeamMembersQuery = { __typename?: 'Query', getTeamMembers?: Array<{ __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null } | null> | null };

export type ArchiveTaskMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveTaskMutation = { __typename?: 'Mutation', archiveTask?: boolean | null };

export type GetAllMyTasksWithSearchQueryVariables = Exact<{
  input: AllMyTasksInput;
}>;


export type GetAllMyTasksWithSearchQuery = { __typename?: 'Query', getAllMyTasksWithSearch?: { __typename?: 'assigneeTaskListingResult', config?: { __typename?: 'dataTableConfig', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, no_of_records?: number | null, type?: string | null, actions?: Array<string | null> | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, results?: Array<{ __typename?: 'TaskManagement', _id?: string | null, is_deleted?: boolean | null, editor_description?: string | null, summary?: string | null, description?: string | null, attachments?: Array<string | null> | null, attachments_name?: Array<string | null> | null, due_date?: any | null, formatted_time: string, total_time_spent: number, is_timing_active: boolean, is_timing_ended: boolean, created_at?: any | null, completed_date?: any | null, priority?: string | null, status?: string | null, task_name?: string | null, no_sub_task?: number | null, is_owner?: boolean | null, comment_count?: number | null, attachments_count?: number | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, check_list?: Array<{ __typename?: 'checkListStep', _id?: string | null, is_completed?: boolean | null, title?: string | null } | null> | null, comments?: Array<{ __typename?: 'commenType', _id?: string | null, comment?: string | null, comment_date?: any | null, comment_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, logo?: string | null } | null, replies?: Array<{ __typename?: 'replyType', _id?: string | null, reply?: string | null, reply_date?: any | null, reply_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, logo?: string | null } | null } | null> | null } | null> | null, assignee?: Array<{ __typename?: 'User', first_name?: string | null, full_name?: string | null, id?: string | null } | null> | null, reporter?: { __typename?: 'User', first_name?: string | null, full_name?: string | null, id?: string | null } | null } | null> | null } | null };

export type GetAllAssigneeTasksWithSearchQueryVariables = Exact<{
  input: AllAssigneeTasksInput;
}>;


export type GetAllAssigneeTasksWithSearchQuery = { __typename?: 'Query', getAllAssigneeTasksWithSearch?: Array<{ __typename?: 'TaskManagement', _id?: string | null, summary?: string | null, description?: string | null, attachments?: Array<string | null> | null, due_date?: any | null, is_deleted?: boolean | null, priority?: string | null, status?: string | null, completed_date?: any | null, check_list?: Array<{ __typename?: 'checkListStep', _id?: string | null, is_completed?: boolean | null, title?: string | null } | null> | null, comments?: Array<{ __typename?: 'commenType', comment?: string | null, comment_date?: any | null, comment_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, logo?: string | null } | null } | null> | null, assignee?: Array<{ __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null } | null> | null, reporter?: { __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null } | null } | null> | null };

export type GetTaskCalenderQueryVariables = Exact<{
  input?: InputMaybe<TaskCalenderInput>;
}>;


export type GetTaskCalenderQuery = { __typename?: 'Query', getTaskCalender?: { __typename?: 'taskCalenderResults', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, employees?: Array<{ __typename?: 'User', _id?: string | null, employee_id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, birth_date?: any | null, email?: string | null, salary_type?: string | null, phone?: string | null, joining_date?: any | null, employee_type?: string | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null } | null> | null, results?: Array<{ __typename?: 'TaskManagement', _id?: string | null, task_name?: string | null, summary?: string | null, description?: string | null, due_date?: any | null, start_date?: any | null, end_date?: any | null, status?: string | null, comment_count?: number | null, created_at?: any | null, updated_at?: any | null, reporter?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, assignee?: Array<{ __typename?: 'User', _id?: string | null, employee_id?: string | null, full_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null } | null> | null, sub_task?: Array<{ __typename?: 'TaskManagement', _id?: string | null, task_name?: string | null, summary?: string | null, description?: string | null, due_date?: any | null, start_date?: any | null, end_date?: any | null, priority?: string | null, status?: string | null, comment_count?: number | null, created_at?: any | null, updated_at?: any | null, no_sub_task?: number | null, assignee?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null, employee_id?: string | null } | null> | null, ParentTask?: { __typename?: 'TaskManagement', _id?: string | null, task_name?: string | null } | null } | null> | null } | null> | null } | null };

export type GetMyTaskCalenderQueryVariables = Exact<{
  input?: InputMaybe<TaskCalenderInput>;
}>;


export type GetMyTaskCalenderQuery = { __typename?: 'Query', getMyTaskCalender?: { __typename?: 'taskCalenderResults', limit?: number | null, page?: number | null, totalPages?: number | null, totalResults?: number | null, employees?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null } | null> | null, results?: Array<{ __typename?: 'TaskManagement', _id?: string | null, task_name?: string | null, summary?: string | null, description?: string | null, due_date?: any | null, start_date?: any | null, end_date?: any | null, status?: string | null, comment_count?: number | null, created_at?: any | null, updated_at?: any | null, reporter?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null, assignee?: Array<{ __typename?: 'User', _id?: string | null, employee_id?: string | null, full_name?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null } | null> | null, sub_task?: Array<{ __typename?: 'TaskManagement', _id?: string | null, task_name?: string | null, summary?: string | null, description?: string | null, due_date?: any | null, start_date?: any | null, end_date?: any | null, priority?: string | null, status?: string | null, comment_count?: number | null, created_at?: any | null, updated_at?: any | null, no_sub_task?: number | null, assignee?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null, employee_id?: string | null } | null> | null, ParentTask?: { __typename?: 'TaskManagement', _id?: string | null, task_name?: string | null } | null } | null> | null } | null> | null } | null };

export type CreatecommentOnTaskMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreatecommentOnTaskMutation = { __typename?: 'Mutation', createcommentOnTask?: { __typename?: 'TaskManagement', _id?: string | null } | null };

export type UpdateCommentInTaskMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type UpdateCommentInTaskMutation = { __typename?: 'Mutation', updateCommentInTask?: boolean | null };

export type DeleteCommentInTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
}>;


export type DeleteCommentInTaskMutation = { __typename?: 'Mutation', deleteCommentInTask?: boolean | null };

export type CreateRepliesinCommmentTaskMutationVariables = Exact<{
  input: CreateRepliesCommentInput;
}>;


export type CreateRepliesinCommmentTaskMutation = { __typename?: 'Mutation', createRepliesinCommmentTask?: { __typename?: 'TaskManagement', _id?: string | null } | null };

export type DeleteRepliesinCommmentTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
  replyId: Scalars['ID']['input'];
}>;


export type DeleteRepliesinCommmentTaskMutation = { __typename?: 'Mutation', deleteRepliesinCommmentTask?: boolean | null };

export type UpdateRepliesinCommmentTaskMutationVariables = Exact<{
  input?: InputMaybe<UpdateRepliesCommentInput>;
}>;


export type UpdateRepliesinCommmentTaskMutation = { __typename?: 'Mutation', updateRepliesinCommmentTask?: boolean | null };

export type GetTaskByIdQueryVariables = Exact<{
  getTaskByIdId: Scalars['ID']['input'];
}>;


export type GetTaskByIdQuery = { __typename?: 'Query', getTaskById?: { __typename?: 'TaskManagement_', _id?: string | null, summary?: string | null, description?: string | null, editor_description?: string | null, is_timing_active: boolean, is_timing_ended: boolean, status?: string | null, total_time_spent: number, priority?: string | null, due_date?: any | null, completed_date?: any | null, is_deleted?: boolean | null, attachments?: Array<string | null> | null, attachments_name?: Array<string | null> | null, time_logs: Array<{ __typename?: 'TimeLog', status: TimeLogAction, timestamp: any }>, bread_cram?: Array<{ __typename?: 'TaskManagement', _id?: string | null, task_name?: string | null, assignee?: Array<{ __typename?: 'User', full_name?: string | null, id?: string | null } | null> | null, reporter?: { __typename?: 'User', _id?: string | null, full_name?: string | null, logo?: string | null } | null } | null> | null, Department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, Role?: { __typename?: 'Role', _id?: string | null, roleName?: string | null } | null, assignee?: Array<{ __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null } | null> | null, reporter?: { __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null } | null, check_list?: Array<{ __typename?: 'checkListStep', _id?: string | null, is_completed?: boolean | null, title?: string | null } | null> | null, comments?: Array<{ __typename?: 'commenType', _id?: string | null, comment?: string | null, comment_date?: any | null, comment_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, logo?: string | null } | null, replies?: Array<{ __typename?: 'replyType', _id?: string | null, reply?: string | null, reply_date?: any | null, reply_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, logo?: string | null } | null } | null> | null } | null> | null, sub_task?: { __typename?: 'dataColumnResults', config?: { __typename?: 'dataTableConfig', columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null } | null> | null } | null, results?: Array<{ __typename?: 'TaskManagement', _id?: string | null, task_name?: string | null, description?: string | null, summary?: string | null, status?: string | null, attachments_name?: Array<string | null> | null, assignee?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null } | null> | null, reporter?: { __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null } | null } | null> | null } | null } | null };

export type GetLogsByTaskIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLogsByTaskIdQuery = { __typename?: 'Query', getLogsByTaskId?: { __typename?: 'TaskTimeLogsById', _id?: string | null, is_timing_active: boolean, is_timing_ended: boolean, formatted_time: string, total_time_spent: number, todo_formatted_time: string, onhold_formatted_time: string, time_logs: Array<{ __typename?: 'TimeLog', status: TimeLogAction, timestamp: any }>, timeLogs?: Array<{ __typename?: 'TimeLogResult', from: string, to?: string | null, fromTime?: string | null, toTime?: string | null, duration: string, status: string, userName: string } | null> | null } | null };

export type GetEmployeeForMentionQueryVariables = Exact<{
  getEmployeeForMentionId: Scalars['ID']['input'];
}>;


export type GetEmployeeForMentionQuery = { __typename?: 'Query', getEmployeeForMention?: Array<{ __typename?: 'User', full_name?: string | null, id?: string | null, logo?: string | null } | null> | null };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask?: { __typename?: 'TaskManagement', _id?: string | null, summary?: string | null, description?: string | null, attachments?: Array<string | null> | null, completed_date?: any | null, due_date?: any | null, is_deleted?: boolean | null, priority?: string | null, status?: string | null, check_list?: Array<{ __typename?: 'checkListStep', _id?: string | null, is_completed?: boolean | null, title?: string | null } | null> | null, comments?: Array<{ __typename?: 'commenType', comment?: string | null, comment_date?: any | null, comment_by?: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, logo?: string | null } | null } | null> | null, assignee?: Array<{ __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null } | null> | null, reporter?: { __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null } | null } | null };

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask?: { __typename?: 'TaskManagement', _id?: string | null } | null };

export type UpdateTaskStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: TaskStatusUpdateEmums;
}>;


export type UpdateTaskStatusMutation = { __typename?: 'Mutation', updateTaskStatus?: { __typename?: 'TaskManagement', BusinessLocation?: { __typename?: 'Business', business_keeping_unit?: string | null } | null } | null };

export type UpdateTaskAssignToMutationVariables = Exact<{
  input: UpdateAssignToInput;
}>;


export type UpdateTaskAssignToMutation = { __typename?: 'Mutation', updateTaskAssignTo?: { __typename?: 'TaskManagement', _id?: string | null } | null };

export type UpdateTaskSectionWiseMutationVariables = Exact<{
  input: UpdateTaskSectionWise;
}>;


export type UpdateTaskSectionWiseMutation = { __typename?: 'Mutation', updateTaskSectionWise?: { __typename?: 'TaskManagement', _id?: string | null } | null };

export type UpdateTasksListenSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateTasksListenSubscription = { __typename?: 'Subscription', updateTasksListen?: { __typename?: 'TaskManagement', _id?: string | null } | null };

export type TaskStatusUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TaskStatusUpdatedSubscription = { __typename?: 'Subscription', taskStatusUpdated?: { __typename?: 'TaskManagement', _id?: string | null } | null };

export type UpdateAssigneeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdateAssigneeSubscription = { __typename?: 'Subscription', updateAssignee?: { __typename?: 'TaskManagement', _id?: string | null } | null };

export type CommentInTaskListenSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CommentInTaskListenSubscription = { __typename?: 'Subscription', commentInTaskListen?: { __typename?: 'TaskManagement', _id?: string | null } | null };

export type CreateSubTaskListenSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CreateSubTaskListenSubscription = { __typename?: 'Subscription', createSubTaskListen?: { __typename?: 'TaskManagement', _id?: string | null } | null };

export type GetSavedFiltersQueryVariables = Exact<{
  type: FilterTypeEnum;
}>;


export type GetSavedFiltersQuery = { __typename?: 'Query', getSavedFilters?: Array<{ __typename?: 'Filter', _id: string, name?: string | null, filter: string, type: string, created_at?: any | null, updated_at?: any | null, is_deleted?: boolean | null } | null> | null };

export type GetCurrentDayScheduleByEmployeeQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type GetCurrentDayScheduleByEmployeeQuery = { __typename?: 'Query', getCurrentDayScheduleByEmployee?: { __typename?: 'Schedule', total_hours?: number | null, total_minuts?: number | null, end_time?: string | null, start_date?: any | null, end_date?: any | null, start_time?: string | null, _id?: string | null, is_between_leave?: boolean | null, schedule_minuts?: number | null, clockedHistory?: { __typename?: 'ClockedHistory', is_between_leave?: boolean | null, attendance_log_detail?: Array<{ __typename?: 'attendanceLogDetail', clock_in_time?: string | null, clock_out_time?: string | null, clockedInStatus?: string | null, clockedOutStatus?: string | null } | null> | null, short_leave?: Array<{ __typename?: 'shortLeave', duration?: number | null, star_time?: string | null, end_time?: string | null } | null> | null } | null, break_detail?: Array<{ __typename?: 'scheduleBreaks', break_duration?: number | null, minimum_break_percentage?: number | null, break_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_value_type?: { __typename?: 'MasterDataValue', data_value_name?: string | null } | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null } | null } | null> | null } | null };

export type GetFilterByIdQueryVariables = Exact<{
  getFilterByIdId: Scalars['ID']['input'];
}>;


export type GetFilterByIdQuery = { __typename?: 'Query', getFilterByID?: { __typename?: 'Filter', _id: string, name?: string | null, filter: string, type: string, is_deleted?: boolean | null } | null };

export type ConfigQueryVariables = Exact<{
  input?: InputMaybe<InputEmployeeTimeSheet>;
}>;


export type ConfigQuery = { __typename?: 'Query', getTimeSheetAttendanceList?: { __typename?: 'employeesClockHistory', type?: string | null, config?: { __typename?: 'UpdatedDataTableConfig', type?: string | null, page?: number | null, limit?: number | null, no_of_records?: number | null, totalPages?: number | null, totalResults?: number | null, columns?: Array<{ __typename?: 'listingColumnsType', min_count?: number | null, max_count?: number | null, average?: number | null, sum?: number | null, count?: number | null, distinct_count?: number | null, count_empty?: number | null, _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, actions?: Array<{ __typename?: 'configActionType', name?: string | null, is_visible?: string | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, table_preset?: Array<{ __typename?: 'listingTablePreset', id?: string | null, type?: string | null, name?: string | null, is_default?: boolean | null, is_temp?: boolean | null, activeFilters?: boolean | null, loadingCall?: boolean | null, columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, type?: string | null, field?: string | null, header?: string | null, search?: string | null, is_visible?: boolean | null, is_sortable?: boolean | null, is_search_able?: boolean | null, is_required?: boolean | null, is_amount?: boolean | null, show_total?: boolean | null, is_groupable?: boolean | null, is_editable?: boolean | null, is_unique?: boolean | null, pinned?: string | null, width?: number | null, validateFn?: string | null, column_data?: Array<string | null> | null, filterValue?: Array<string | null> | null, column_dropdown_value?: Array<{ __typename?: 'column_dropdown_value', _id?: string | null, value?: string | null } | null> | null, query?: { __typename?: 'queryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, filters?: Array<{ __typename?: 'listingFiltersType', type?: string | null, field?: string | null, search?: string | null, _ids?: Array<string | null> | null, query?: { __typename?: 'filtersQueryType', condition?: string | null, first_value?: string | null, first_condition?: string | null, second_value?: string | null, second_condition?: string | null } | null } | null> | null, config?: { __typename?: 'TableConfigListing', bodyTextFontsSize?: number | null, fontFaimly?: string | null, globalSearch?: string | null, headerTextFontsSize?: number | null, oddRowsBackgroundColor?: string | null, rowShadingEnabled?: boolean | null, selectedTableLayout?: string | null, showVerticalBorder?: boolean | null } | null } | null> | null } | null, dailyClockHistoryList?: Array<{ __typename?: 'ClockedHistory', BusinessLocation?: string | null, clock_out_time?: string | null, clock_in_time?: string | null, attendance_date?: any | null, clockedInStatus?: string | null, clockedOutStatus?: string | null, is_un_restricted?: boolean | null, _id: string, attendanceDate?: string | null, attendanceStatus?: string | null, writup_id?: string | null, write_up_type?: string | null, weeklyTotalLogTime?: number | null, weekOverTime?: number | null, user_name?: string | null, total_working_minutes_logged?: string | null, total_working_hours_logged?: string | null, total_wages?: string | null, total_minutes_logged?: string | null, total_hours_logged?: string | null, status?: string | null, short_break_type?: string | null, short_break_taken_minutes?: number | null, short_break_remaining_minutes?: number | null, short_break_exceeded_minutes?: number | null, short_break_duration?: number | null, short_break_count?: number | null, salary_type?: string | null, remarks?: string | null, pay_period?: string | null, over_time_minutes_logged?: number | null, normal_time_minutes_logged?: number | null, message?: string | null, marked_at?: string | null, is_attendance_maually_adjusted?: boolean | null, Payroll?: { __typename?: 'Payroll', _id?: string | null, end_date?: any | null, is_deleted?: boolean | null, is_dispersed?: boolean | null, no_of_days?: number | null, no_of_employee?: number | null, Business?: { __typename?: 'Business', Country?: { __typename?: 'Country', _id?: string | null } | null } | null } | null, PreviousUserHistory?: { __typename?: 'UserHistory', account_status?: string | null, action_type?: string | null, action_create_date?: any | null } | null, Schedule?: { __typename?: 'Schedule', _id?: string | null, created_date?: any | null, deleted_at?: any | null, end_date?: any | null, start_time?: string | null, end_time?: string | null, events?: Array<{ __typename?: 'scheduleEvents', end_time?: string | null, leave_type?: string | null, hours?: number | null, minutes?: number | null, star_time?: string | null, type?: string | null, TimeOff?: { __typename?: 'timeOff', _id?: string | null } | null } | null> | null } | null, User: { __typename?: 'User', _id?: string | null, full_name?: string | null, email?: string | null, employee_id?: string | null, salary_type?: string | null, final_settlement_completed?: boolean | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null, designation?: { __typename?: 'Designation', _id?: string | null, designation_name?: string | null } | null, roles?: Array<{ __typename?: 'Role', _id?: string | null, roleName?: string | null } | null> | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null }, UserAppDeviceLog?: Array<{ __typename?: 'UserAppDeviceLog', longitude?: string | null, latitude?: string | null, is_deleted?: boolean | null, device_id?: string | null, app_type?: string | null, action_date?: any | null, action?: string | null, _id?: string | null, break_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_type?: { __typename?: 'MasterDataType', data_type_name?: string | null } | null } | null, UserAppDevice?: { __typename?: 'userAppDevice', _id?: string | null, app_type?: string | null, device_name?: string | null, device_model?: string | null, terminal_name?: string | null, device_manufacturer?: string | null } | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null> | null, attendance_adjusted_by?: { __typename?: 'User', _id?: string | null } | null, attendance_log_detail?: Array<{ __typename?: 'attendanceLogDetail', is_un_restricted?: boolean | null, clock_in_time?: string | null, clock_out_time?: string | null, status?: string | null, logged_minutes?: string | null, logged_hours?: string | null, wages?: number | null } | null> | null, breaks?: Array<{ __typename?: 'BreakClockedHistory', _id: string, breakId?: string | null, breakInstatus?: string | null, break_in_time?: string | null, break_out_time?: string | null, breakType?: string | null, breakTypeId?: string | null, break_duration?: number | null, message?: string | null, minimum_break_percentage?: number | null, title?: string | null, User?: { __typename?: 'User', _id?: string | null } | null, break_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_value_type?: { __typename?: 'MasterDataValue', data_value_name?: string | null } | null } | null, newWriteUp?: { __typename?: 'NewWriteUp', writeup_message?: string | null, write_up_type?: string | null, writeup_date?: any | null, writeup_category?: string | null } | null } | null> | null, short_leave?: Array<{ __typename?: 'shortLeave', is_paid?: number | null, leave_type?: string | null, minutes?: string | null, remarks?: string | null, short_leave_time_percentage?: number | null, star_time?: string | null, start_time?: string | null, type?: string | null, hours?: string | null, end_time?: string | null, duration?: number | null, TimeOff?: string | null } | null> | null, short_breaks?: { __typename?: 'shortBreak', short_break_duration?: number | null, short_break_name?: string | null } | null, short_break_detail?: Array<{ __typename?: 'short_break_detail', break_start_time?: string | null, break_end_time?: string | null, break_duration?: number | null, break_out_time?: string | null } | null> | null, pending_writeups?: Array<{ __typename?: 'WriteUp', email?: string | null, is_deleted?: boolean | null } | null> | null, newWriteUp?: { __typename?: 'NewWriteUp', writeup_message?: string | null, write_up_type?: string | null, writeup_date?: any | null, writeup_category?: string | null } | null, manually_logs?: Array<{ __typename?: 'manuallyLogs', log_date?: any | null, remarks?: string | null, breaks?: Array<{ __typename?: 'breakLogs', break_name?: string | null, break_id?: { __typename?: 'MasterDataValue', _id?: string | null } | null, break_in?: { __typename?: 'breakIn', time?: string | null, status?: string | null, previous_state?: string | null } | null, break_out?: { __typename?: 'breakOut', time?: string | null, status?: string | null, previous_state?: string | null } | null } | null> | null, clock_in?: { __typename?: 'clockIn', time?: string | null, status?: string | null, previous_state?: string | null } | null, clock_in_status?: { __typename?: 'clockInOUtStatus', status?: string | null, previous_state?: string | null } | null, clock_out?: { __typename?: 'clockOut', time?: string | null, status?: string | null, previous_state?: string | null } | null, clock_out_status?: { __typename?: 'clockInOUtStatus', status?: string | null, previous_state?: string | null } | null, history_times?: { __typename?: 'historyTimes', previous_time?: string | null, updated_time?: string | null } | null, short_leave?: { __typename?: 'shortLeaveLog', duration?: number | null, start_time?: string | null, end_time?: string | null, previous_state?: string | null } | null, updated_by?: { __typename?: 'User', full_name?: string | null, _id?: string | null } | null } | null> | null } | null> | null, groupData?: Array<{ __typename?: 'clockHistoryGroupData', EarlyClockin?: number | null, OntimeOut?: number | null, absent?: number | null, block?: number | null, earlyClockedOut?: number | null, id?: string | null, lateOut?: number | null, lateness?: number | null, missPaunchOut?: number | null, onLeave?: number | null, onTIme?: number | null, totalScheduleHours?: string | null, totalLogedMinuts?: string | null, totalWorkingLogedMinuts?: string | null, totalWages?: string | null, publicHoliday?: number | null, shortLeave?: number | null, totalCount?: number | null, weekend?: number | null, user?: { __typename?: 'User', id?: string | null, full_name?: string | null, email?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null } | null> | null } | null, detail?: { __typename?: 'clockHistoryGroupDetail', columns?: Array<{ __typename?: 'listingColumnsType', _id?: string | null, field?: string | null, header?: string | null, is_amount?: boolean | null, type?: string | null, is_visible?: boolean | null } | null> | null, result?: Array<{ __typename?: 'ClockedHistory', BusinessLocation?: string | null, _id: string, attendanceDate?: string | null, attendanceStatus?: string | null, attendance_date?: any | null, writup_id?: string | null, write_up_type?: string | null, weeklyTotalLogTime?: number | null, weekOverTime?: number | null, user_name?: string | null, total_working_minutes_logged?: string | null, total_working_hours_logged?: string | null, total_wages?: string | null, total_minutes_logged?: string | null, total_hours_logged?: string | null, status?: string | null, short_break_type?: string | null, short_break_taken_minutes?: number | null, short_break_remaining_minutes?: number | null, short_break_exceeded_minutes?: number | null, short_break_duration?: number | null, short_break_count?: number | null, salary_type?: string | null, remarks?: string | null, pay_period?: string | null, over_time_minutes_logged?: number | null, normal_time_minutes_logged?: number | null, message?: string | null, marked_at?: string | null, logged_seconds?: number | null, is_weekend?: boolean | null, is_update_pending?: boolean | null, is_un_restricted?: boolean | null, is_public_holiday_off?: boolean | null, is_public_holiday?: boolean | null, is_payroll_processed?: boolean | null, is_paid_weekend?: boolean | null, is_paid_public_holiday?: boolean | null, is_over_time_weekend?: boolean | null, is_over_time_public_holiday?: boolean | null, is_back_pay?: boolean | null, is_attendance_maually_adjusted?: boolean | null, clockedOutStatus?: string | null, clockedInStatus?: string | null, clock_out_time?: string | null, clock_in_time?: string | null, Payroll?: { __typename?: 'Payroll', _id?: string | null } | null, PreviousUserHistory?: { __typename?: 'UserHistory', account_status?: string | null } | null, Schedule?: { __typename?: 'Schedule', _id?: string | null, end_time?: string | null, end_date?: any | null, deleted_at?: any | null, created_date?: any | null, is_attendance_exist?: boolean | null, events?: Array<{ __typename?: 'scheduleEvents', end_time?: string | null, hours?: number | null, leave_type?: string | null, minutes?: number | null, star_time?: string | null, type?: string | null, TimeOff?: { __typename?: 'timeOff', _id?: string | null, created_at?: any | null } | null } | null> | null } | null, UserAppDeviceLog?: Array<{ __typename?: 'UserAppDeviceLog', longitude?: string | null, latitude?: string | null, is_deleted?: boolean | null, device_id?: string | null, app_type?: string | null, action_date?: any | null, action?: string | null, _id?: string | null, break_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_type?: { __typename?: 'MasterDataType', data_type_name?: string | null } | null } | null, UserAppDevice?: { __typename?: 'userAppDevice', _id?: string | null, app_type?: string | null, device_name?: string | null, terminal_name?: string | null, device_model?: string | null, device_manufacturer?: string | null } | null, User?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null> | null, User: { __typename?: 'User', _id?: string | null, full_name?: string | null, email?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null } | null> | null }, attendance_adjusted_by?: { __typename?: 'User', _id?: string | null } | null, attendance_log_detail?: Array<{ __typename?: 'attendanceLogDetail', is_un_restricted?: boolean | null, clock_in_time?: string | null, clock_out_time?: string | null, status?: string | null, logged_minutes?: string | null, logged_hours?: string | null, wages?: number | null } | null> | null, breaks?: Array<{ __typename?: 'BreakClockedHistory', _id: string, breakType?: string | null, breakInstatus?: string | null, breakId?: string | null, breakTypeId?: string | null, break_duration?: number | null, break_in_time?: string | null, break_out_time?: string | null, message?: string | null, title?: string | null, break_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_value_type?: { __typename?: 'MasterDataValue', data_value_name?: string | null } | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null } | null } | null> | null, short_leave?: Array<{ __typename?: 'shortLeave', is_paid?: number | null, leave_type?: string | null, minutes?: string | null, remarks?: string | null, short_leave_time_percentage?: number | null, star_time?: string | null, start_time?: string | null, type?: string | null, hours?: string | null, end_time?: string | null, duration?: number | null, TimeOff?: string | null } | null> | null, short_breaks?: { __typename?: 'shortBreak', short_break_duration?: number | null, short_break_name?: string | null } | null, short_break_detail?: Array<{ __typename?: 'short_break_detail', break_start_time?: string | null, break_end_time?: string | null, break_duration?: number | null, break_out_time?: string | null } | null> | null, newWriteUp?: { __typename?: 'NewWriteUp', writeup_category?: string | null, write_up_type?: string | null, writeup_date?: any | null, writeup_message?: string | null } | null, manually_logs?: Array<{ __typename?: 'manuallyLogs', log_date?: any | null, remarks?: string | null, clock_in?: { __typename?: 'clockIn', time?: string | null, status?: string | null, previous_state?: string | null } | null, breaks?: Array<{ __typename?: 'breakLogs', break_name?: string | null, break_in?: { __typename?: 'breakIn', time?: string | null, status?: string | null, previous_state?: string | null } | null, break_out?: { __typename?: 'breakOut', time?: string | null, status?: string | null, previous_state?: string | null } | null } | null> | null, clock_in_status?: { __typename?: 'clockInOUtStatus', status?: string | null, previous_state?: string | null } | null, clock_out?: { __typename?: 'clockOut', time?: string | null, status?: string | null, previous_state?: string | null } | null, clock_out_status?: { __typename?: 'clockInOUtStatus', status?: string | null, previous_state?: string | null } | null, history_times?: { __typename?: 'historyTimes', previous_time?: string | null, updated_time?: string | null } | null, short_leave?: { __typename?: 'shortLeaveLog', duration?: number | null, start_time?: string | null, end_time?: string | null, previous_state?: string | null } | null, updated_by?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null> | null, logs?: Array<{ __typename?: 'logType', total_minutes?: number | null, log_status?: string | null, log_date?: any | null } | null> | null } | null> | null } | null } | null> | null } | null };

export type GetEmployeeTimeSheetListQueryVariables = Exact<{
  input?: InputMaybe<EmployeeTimeSheetInput>;
}>;


export type GetEmployeeTimeSheetListQuery = { __typename?: 'Query', getEmployeeTimeSheetList?: Array<{ __typename?: 'employeesMonthlyTimeSheet', totalAbsent?: number | null, totalEarlyOut?: number | null, totalLateness?: number | null, totalLeave?: number | null, totalPresent?: number | null, dateList?: Array<string | null> | null, employeesTimeSheet?: Array<{ __typename?: 'employeeTimeSheetType', _id?: string | null, Absent?: number | null, EarlyOut?: number | null, Lateness?: number | null, Leave?: number | null, Present?: number | null } | null> | null } | null> | null };

export type GetTimeSheetAttendanceListByEmployeeQueryVariables = Exact<{
  input?: InputMaybe<InputTimeSheetEmployee>;
}>;


export type GetTimeSheetAttendanceListByEmployeeQuery = { __typename?: 'Query', getTimeSheetAttendanceListByEmployee?: { __typename?: 'employeeClockHistory', groupData?: Array<{ __typename?: 'clockHistoryEmployee', countStatus?: { __typename?: 'countStatusGroupedEmployee', EarlyClockin?: number | null, lateness?: number | null, earlyClockedOut?: number | null, lateOut?: number | null, onTIme?: number | null, OntimeOut?: number | null, totalScheduleHours?: number | null, totalLogedMinuts?: string | null } | null, ClockedHistory?: Array<{ __typename?: 'ClockedHistory', total_hours_logged?: string | null, total_wages?: string | null, _id: string, clock_in_time?: string | null, clock_out_time?: string | null, attendance_date?: any | null, status?: string | null, attendanceStatus?: string | null, write_up_type?: string | null, message?: string | null, User: { __typename?: 'User', id?: string | null, is_breaked_in?: boolean | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null, email?: string | null, employee_id?: string | null, salary_type?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null }, breaks?: Array<{ __typename?: 'BreakClockedHistory', _id: string, break_in_time?: string | null, break_out_time?: string | null, breakInstatus?: string | null, breakType?: string | null, title?: string | null, breakTypeId?: string | null, break_duration?: number | null, breakId?: string | null, break_type?: { __typename?: 'MasterDataValue', data_value_name?: string | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null } | null } | null> | null, logs?: Array<{ __typename?: 'logType', log_status?: string | null, total_minutes?: number | null, log_date?: any | null, break_id?: { __typename?: 'MasterDataValue', data_value_name?: string | null } | null } | null> | null, Schedule?: { __typename?: 'Schedule', break_detail?: Array<{ __typename?: 'scheduleBreaks', break_duration?: number | null, break_type?: { __typename?: 'MasterDataValue', data_value_name?: string | null, _id?: string | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null } | null } | null> | null } | null } | null> | null } | null> | null } | null };

export type GetMisPaunchOutEmployeeListQueryVariables = Exact<{
  input?: InputMaybe<MissPaunchOut>;
}>;


export type GetMisPaunchOutEmployeeListQuery = { __typename?: 'Query', getMisPaunchOutEmployeeList?: { __typename?: 'MissPaunchOutListingResult', page?: number | null, limit?: number | null, totalResults?: number | null, totalPages?: number | null, results?: Array<{ __typename?: 'ClockedHistory', _id: string, clock_in_time?: string | null, clock_out_time?: string | null, attendance_date?: any | null, status?: string | null, attendanceStatus?: string | null, logs?: Array<{ __typename?: 'logType', log_status?: string | null, log_date?: any | null } | null> | null, User: { __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, logo?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', path?: string | null } | null> | null }, breaks?: Array<{ __typename?: 'BreakClockedHistory', breakInstatus?: string | null, breakType?: string | null, break_duration?: number | null, break_type?: { __typename?: 'MasterDataValue', data_value_name?: string | null } | null } | null> | null } | null> | null } | null };

export type GetCurrentDayRosterByEmployeeQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type GetCurrentDayRosterByEmployeeQuery = { __typename?: 'Query', getCurrentDayRosterByEmployee?: { __typename?: 'Schedule', total_hours?: number | null, total_minuts?: number | null, end_time?: string | null, start_date?: any | null, end_date?: any | null, start_time?: string | null, _id?: string | null, schedule_minuts?: number | null, break_detail?: Array<{ __typename?: 'scheduleBreaks', break_duration?: number | null, break_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_value_type?: { __typename?: 'MasterDataValue', data_value_name?: string | null } | null, data_type?: { __typename?: 'MasterDataType', _id?: string | null, data_type_name?: string | null } | null } | null } | null> | null } | null };

export type GetTimeSheetGrandTotalQueryVariables = Exact<{
  input: InputGrandTotal;
}>;


export type GetTimeSheetGrandTotalQuery = { __typename?: 'Query', getTimeSheetGrandTotal?: { __typename?: 'grandTotalResult', absent?: number | null, earlyIn?: number | null, earlyOut?: number | null, lateOut?: number | null, lateness?: number | null, missPunchOut?: number | null, onLeave?: number | null, onTimeIn?: number | null, onTimeOut?: number | null, present?: number | null, scheduleTime?: string | null, shortLeave?: number | null, wages?: number | null, workingTime?: string | null, block?: number | null } | null };

export type GetTimeSheetAttendanceGrandTotalQueryVariables = Exact<{
  input: InputTimeSheet;
}>;


export type GetTimeSheetAttendanceGrandTotalQuery = { __typename?: 'Query', getTimeSheetAttendanceGrandTotal?: { __typename?: 'grandTotalResult', absent?: number | null, workingTime?: string | null, weekend?: number | null, wages?: number | null, unrestrictedWorkingTime?: string | null, unrestrected?: number | null, unpaidLeave?: number | null, totalCount?: number | null, shortLeave?: number | null, scheduleTime?: string | null, restrected?: number | null, publicHoliday?: number | null, present?: number | null, paidLeave?: number | null, onTimeOut?: number | null, onTimeIn?: number | null, onLeave?: number | null, missPunchOut?: number | null, lateness?: number | null, lateOut?: number | null, earlyOut?: number | null, earlyIn?: number | null, block?: number | null, departmentWiseOT?: { __typename?: 'DepartmentOvertimeResult', perDepartment?: Array<{ __typename?: 'DepartmentOvertime', totalOvertimeMinutes?: number | null, totalOvertimeWages?: number | null, department?: { __typename?: 'Department', _id?: string | null, department_name?: string | null } | null } | null> | null, totalSummary?: { __typename?: 'OvertimeTotalSummary', totalOvertimeMinutes?: number | null, totalOvertimeWages?: number | null } | null } | null } | null };

export type GetGroupedWagesDataForGraphQueryVariables = Exact<{
  input: InputTimeSheet;
}>;


export type GetGroupedWagesDataForGraphQuery = { __typename?: 'Query', getGroupedWagesDataForGraph?: { __typename?: 'grandTotalWagesGraph', grand_total?: number | null, wages_by_date?: Array<{ __typename?: 'wagesByDate', date?: string | null, total_wages?: number | null } | null> | null } | null };

export type GetUserDashboardViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDashboardViewQuery = { __typename?: 'Query', getUserDashboardView?: Array<{ __typename?: 'EmployeeDashboardView', id: string, is_bold_emp_name?: boolean | null, card_size?: string | null, is_bold_status_time?: boolean | null, created_at?: string | null, card_width?: number | null, created_by?: string | null, deleted_at?: string | null, deleted_by?: string | null, is_default_screen?: boolean | null, is_deleted?: boolean | null, name_format?: string | null, options?: any | null, profile_picture_size?: string | null, status_display?: string | null, is_system_default_screen?: boolean | null, title: string, updated_at?: string | null, updated_by?: string | null, view_type: EmployeeDashboardViewEnum, Business?: { __typename?: 'Business', _id: string } | null, views: Array<{ __typename?: 'EmployeeDashboardViewSection', animation: AnimationTypeEnum, width?: number | null, animation_speed?: number | null, arrays?: Array<string | null> | null, columns: number, options?: any | null, section_title: EmployeeDashboardViewSectionEnum, sort_order?: string | null, text: string, upcoming_clock_reminder_time?: string | null, configs?: Array<{ __typename?: 'EmployeeDashboardViewConfig', array_list?: string | null, classes?: string | null, options?: any | null } | null> | null }> } | null> | null };

export type GetRosterStoresQueryVariables = Exact<{
  businessId: Scalars['ID']['input'];
}>;


export type GetRosterStoresQuery = { __typename?: 'Query', getRosterStores?: Array<{ __typename?: 'RosterStores', _id?: string | null, time_zone?: string | null, type?: string | null, business_location?: { __typename?: 'BusinessLocation', _id?: string | null, store_name?: string | null, store_nick_name?: string | null, address_1?: string | null, address_2?: string | null } | null, business?: { __typename?: 'Business', _id: string, business_keeping_unit?: string | null, business_system_name?: string | null, address?: string | null, business_legal_name?: string | null } | null } | null> | null };

export type GetAttendanceByIdQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetAttendanceByIdQuery = { __typename?: 'Query', getAttendanceById?: { __typename?: 'ClockedHistory', attendanceStatus?: string | null, attendance_date?: any | null, clockedOutStatus?: string | null, clockedInStatus?: string | null, clock_in_time?: string | null, clock_out_time?: string | null, remarks?: string | null, message?: string | null, writup_id?: string | null, status?: string | null, is_un_restricted?: boolean | null, is_between_leave?: boolean | null, _id: string, short_breaks?: { __typename?: 'shortBreak', short_break_duration?: number | null, short_break_name?: string | null } | null, short_break_detail?: Array<{ __typename?: 'short_break_detail', break_duration?: number | null, break_end_time?: string | null, break_out_time?: string | null, break_start_time?: string | null } | null> | null, breaks?: Array<{ __typename?: 'BreakClockedHistory', _id: string, breakId?: string | null, breakType?: string | null, break_duration?: number | null, break_in_time?: string | null, break_out_time?: string | null, minimum_break_percentage?: number | null, breakInstatus?: string | null, break_type?: { __typename?: 'MasterDataValue', _id?: string | null, data_value_name?: string | null, data_value_type?: { __typename?: 'MasterDataValue', data_value_name?: string | null } | null } | null } | null> | null, User: { __typename?: 'User', id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, joining_date?: any | null, is_deleted?: boolean | null, account_status?: string | null }, short_leave?: Array<{ __typename?: 'shortLeave', duration?: number | null, star_time?: string | null, end_time?: string | null } | null> | null, attendance_log_detail?: Array<{ __typename?: 'attendanceLogDetail', clock_in_time?: string | null, clock_out_time?: string | null, clockedInStatus?: string | null, clockedOutStatus?: string | null } | null> | null } | null };

export type GetEmployeePaidUnpaidLeavesQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetEmployeePaidUnpaidLeavesQuery = { __typename?: 'Query', getEmployeePaidUnpaidLeaves?: { __typename?: 'employeePaidUnpaidLeaves', paidLeave?: number | null, unPaidLeave?: number | null } | null };

export type GetEmployeesForBackPayQueryVariables = Exact<{
  business_id: Scalars['ID']['input'];
}>;


export type GetEmployeesForBackPayQuery = { __typename?: 'Query', getAllActiveEmployees?: Array<{ __typename?: 'User', id?: string | null, full_name?: string | null, joining_date?: any | null, salary_type?: string | null, basic_salary?: string | null, weekly_hourly_salary?: string | null, public_day_hourly_salary?: string | null, weekend_day_salary?: string | null, employee_type?: string | null, pay_schedule?: { __typename?: 'PayrollSchedule', _id?: string | null, schedule_name?: string | null } | null, employee_group?: { __typename?: 'attandencePolicy', _id?: string | null, group_name?: string | null } | null } | null> | null };

export type CreateFilterMutationVariables = Exact<{
  input: SaveFilterInput;
}>;


export type CreateFilterMutation = { __typename?: 'Mutation', createFilter?: { __typename?: 'Filter', _id: string, name?: string | null, filter: string, type: string } | null };

export type UpdateFilterMutationVariables = Exact<{
  updateFilterId: Scalars['ID']['input'];
  input: SaveFilterInput;
}>;


export type UpdateFilterMutation = { __typename?: 'Mutation', updateFilter?: { __typename?: 'Filter', _id: string, name?: string | null, filter: string, type: string, is_deleted?: boolean | null } | null };

export type ArchiveFilterMutationVariables = Exact<{
  archiveFilterId: Scalars['ID']['input'];
}>;


export type ArchiveFilterMutation = { __typename?: 'Mutation', archiveFilter?: boolean | null };

export type AddManualShortBreaksMutationVariables = Exact<{
  input: AddManualShortBreaksInput;
}>;


export type AddManualShortBreaksMutation = { __typename?: 'Mutation', addManualShortBreaks?: boolean | null };

export type CreateEmployeeDashboardViewMutationVariables = Exact<{
  input: CreateEmployeeDashboardViewInput;
}>;


export type CreateEmployeeDashboardViewMutation = { __typename?: 'Mutation', createEmployeeDashboardView: { __typename?: 'EmployeeDashboardView', is_bold_emp_name?: boolean | null, card_size?: string | null, is_bold_status_time?: boolean | null, created_at?: string | null, card_width?: number | null, created_by?: string | null, deleted_at?: string | null, deleted_by?: string | null, id: string, is_default_screen?: boolean | null, is_deleted?: boolean | null, name_format?: string | null, options?: any | null, profile_picture_size?: string | null, status_display?: string | null, is_system_default_screen?: boolean | null, title: string, updated_at?: string | null, updated_by?: string | null, view_type: EmployeeDashboardViewEnum, Business?: { __typename?: 'Business', _id: string } | null, views: Array<{ __typename?: 'EmployeeDashboardViewSection', animation: AnimationTypeEnum, width?: number | null, animation_speed?: number | null, arrays?: Array<string | null> | null, columns: number, options?: any | null, section_title: EmployeeDashboardViewSectionEnum, sort_order?: string | null, text: string, upcoming_clock_reminder_time?: string | null, configs?: Array<{ __typename?: 'EmployeeDashboardViewConfig', array_list?: string | null, classes?: string | null, options?: any | null } | null> | null }> } };

export type UpdateEmployeeDashboardViewMutationVariables = Exact<{
  input: CreateEmployeeDashboardViewInput;
  updateEmployeeDashboardViewId: Scalars['ID']['input'];
}>;


export type UpdateEmployeeDashboardViewMutation = { __typename?: 'Mutation', updateEmployeeDashboardView: { __typename?: 'EmployeeDashboardView', is_bold_emp_name?: boolean | null, card_size?: string | null, is_bold_status_time?: boolean | null, created_at?: string | null, card_width?: number | null, created_by?: string | null, deleted_at?: string | null, deleted_by?: string | null, id: string, is_default_screen?: boolean | null, is_deleted?: boolean | null, name_format?: string | null, options?: any | null, profile_picture_size?: string | null, status_display?: string | null, is_system_default_screen?: boolean | null, title: string, updated_at?: string | null, updated_by?: string | null, view_type: EmployeeDashboardViewEnum, Business?: { __typename?: 'Business', _id: string } | null, views: Array<{ __typename?: 'EmployeeDashboardViewSection', animation: AnimationTypeEnum, width?: number | null, animation_speed?: number | null, arrays?: Array<string | null> | null, columns: number, options?: any | null, section_title: EmployeeDashboardViewSectionEnum, sort_order?: string | null, text: string, upcoming_clock_reminder_time?: string | null, configs?: Array<{ __typename?: 'EmployeeDashboardViewConfig', array_list?: string | null, classes?: string | null, options?: any | null } | null> | null }> } };

export type ArchiveEmployeeDashboardViewMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  archive: Scalars['Boolean']['input'];
}>;


export type ArchiveEmployeeDashboardViewMutation = { __typename?: 'Mutation', archiveEmployeeDashboardView?: boolean | null };

export type MakeScreenAsDefaultMutationVariables = Exact<{
  makeScreenAsDefaultId: Scalars['ID']['input'];
}>;


export type MakeScreenAsDefaultMutation = { __typename?: 'Mutation', makeScreenAsDefault?: { __typename?: 'EmployeeDashboardView', id: string, is_deleted?: boolean | null, title: string, view_type: EmployeeDashboardViewEnum, is_default_screen?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, views: Array<{ __typename?: 'EmployeeDashboardViewSection', animation: AnimationTypeEnum, animation_speed?: number | null, columns: number, section_title: EmployeeDashboardViewSectionEnum, text: string }> } | null };

export type CreateUpdateShortLeaveMutationVariables = Exact<{
  input: ShortLeaveInput;
}>;


export type CreateUpdateShortLeaveMutation = { __typename?: 'Mutation', createUpdateShortLeave?: { __typename?: 'ClockedHistory', _id: string } | null };

export type CreateUpdateAttendanceMutationVariables = Exact<{
  input: InputAttendance;
}>;


export type CreateUpdateAttendanceMutation = { __typename?: 'Mutation', createUpdateAttendance?: { __typename?: 'Attendance', _id: string, clock_in_time?: any | null, clock_out_time?: any | null, status?: string | null, attendance_date: any, attendanceStatus?: string | null, total_minutes_logged?: string | null, total_hours_logged?: string | null, remarks?: string | null } | null };

export type BackPayToEmployeeMutationVariables = Exact<{
  input: BackPayInput;
}>;


export type BackPayToEmployeeMutation = { __typename?: 'Mutation', backPayToEmployee?: boolean | null };

export type ArchiveAttendanceMutationVariables = Exact<{
  input: ArchiveInput;
}>;


export type ArchiveAttendanceMutation = { __typename?: 'Mutation', archiveAttendance?: boolean | null };

export type ClockedHistorySubscriptionVariables = Exact<{
  businessId: Scalars['ID']['input'];
}>;


export type ClockedHistorySubscription = { __typename?: 'Subscription', ClockedHistory?: boolean | null };

export type EmployeeDashBoardUpdateSubscriptionVariables = Exact<{
  businessId: Scalars['ID']['input'];
}>;


export type EmployeeDashBoardUpdateSubscription = { __typename?: 'Subscription', employeeDashBoardUpdate?: { __typename?: 'dashBoardChange', is_updated?: boolean | null } | null };

export type UpdateAttendanceSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UpdateAttendanceSubscription = { __typename?: 'Subscription', updateAttendance?: { __typename?: 'updateAttendanceSocket', clockedHistory?: { __typename?: 'ClockedHistory', clockedInStatus?: string | null, clockedOutStatus?: string | null, is_un_restricted?: boolean | null, is_payroll_processed?: boolean | null, short_break_count?: number | null, short_break_duration?: number | null, short_break_exceeded_minutes?: number | null, short_break_remaining_minutes?: number | null, short_break_type?: string | null, short_break_taken_minutes?: number | null, total_hours_logged?: string | null, total_working_hours_logged?: string | null, is_attendance_maually_adjusted?: boolean | null, total_wages?: string | null, attendance_date?: any | null, _id: string, clock_in_time?: string | null, clock_out_time?: string | null, status?: string | null, attendanceStatus?: string | null, message?: string | null, BusinessLocation?: string | null, attendance_log_detail?: Array<{ __typename?: 'attendanceLogDetail', clock_in_time?: string | null, clock_out_time?: string | null, is_un_restricted?: boolean | null, logged_hours?: string | null, logged_minutes?: string | null, status?: string | null, wages?: number | null } | null> | null, short_break_detail?: Array<{ __typename?: 'short_break_detail', break_duration?: number | null, break_end_time?: string | null, break_out_time?: string | null, break_start_time?: string | null } | null> | null, manually_logs?: Array<{ __typename?: 'manuallyLogs', log_date?: any | null, remarks?: string | null, breaks?: Array<{ __typename?: 'breakLogs', break_name?: string | null, break_in?: { __typename?: 'breakIn', status?: string | null, previous_state?: string | null, time?: string | null } | null, break_out?: { __typename?: 'breakOut', status?: string | null, previous_state?: string | null, time?: string | null } | null } | null> | null, clock_in?: { __typename?: 'clockIn', time?: string | null, previous_state?: string | null, status?: string | null } | null, clock_out?: { __typename?: 'clockOut', status?: string | null, previous_state?: string | null, time?: string | null } | null, updated_by?: { __typename?: 'User', full_name?: string | null } | null } | null> | null, attendance_adjusted_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, full_name?: string | null } | null, breaks?: Array<{ __typename?: 'BreakClockedHistory', _id: string, break_in_time?: string | null, break_out_time?: string | null, breakInstatus?: string | null, breakType?: string | null, title?: string | null, breakTypeId?: string | null, break_duration?: number | null, breakId?: string | null, break_type?: { __typename?: 'MasterDataValue', data_value_name?: string | null } | null } | null> | null, User: { __typename?: 'User', id?: string | null, _id?: string | null, is_breaked_in?: boolean | null, first_name?: string | null, last_name?: string | null, is_deleted?: boolean | null, final_settlement_completed?: boolean | null, full_name?: string | null, phone?: string | null, logo?: string | null, email?: string | null, employee_id?: string | null, salary_type?: string | null, profile_pictures?: Array<{ __typename?: 'profilePictures', dimension?: number | null, path?: string | null } | null> | null, department?: Array<{ __typename?: 'Department', _id?: string | null, department_name?: string | null } | null> | null }, short_leave?: Array<{ __typename?: 'shortLeave', duration?: number | null, TimeOff?: string | null, end_time?: string | null, hours?: string | null, leave_type?: string | null, minutes?: string | null, remarks?: string | null, short_leave_time_percentage?: number | null, star_time?: string | null, start_time?: string | null, type?: string | null } | null> | null, short_breaks?: { __typename?: 'shortBreak', short_break_duration?: number | null, short_break_name?: string | null } | null, Schedule?: { __typename?: 'Schedule', _id?: string | null, start_time?: string | null, end_time?: string | null, total_minuts?: number | null, total_hours?: number | null, TimeOff?: { __typename?: 'timeOff', type_of_absence?: { __typename?: 'LeaveType', name?: string | null, type?: string | null } | null } | null, break_detail?: Array<{ __typename?: 'scheduleBreaks', break_duration?: number | null, break_type?: { __typename?: 'MasterDataValue', data_value_name?: string | null, _id?: string | null } | null } | null> | null } | null, logs?: Array<{ __typename?: 'logType', log_status?: string | null, total_minutes?: number | null, log_date?: any | null, break_id?: { __typename?: 'MasterDataValue', data_value_name?: string | null } | null } | null> | null } | null, user?: { __typename?: 'User', _id?: string | null, full_name?: string | null } | null } | null };

export const LmsTableConfigFieldsFragmentDoc = gql`
    fragment LmsTableConfigFields on TableConfigListing {
  bodyTextFontsSize
  fontFaimly
  globalSearch
  headerTextFontsSize
  oddRowsBackgroundColor
  rowShadingEnabled
  selectedTableLayout
  showVerticalBorder
}
    `;
export const LmsColumnFieldsFragmentDoc = gql`
    fragment LmsColumnFields on listingColumnsType {
  _id
  type
  field
  header
  search
  is_visible
  is_sortable
  is_search_able
  is_required
  is_amount
  show_total
  is_groupable
  is_editable
  is_unique
  pinned
  width
  validateFn
  column_data
  filterValue
  min_count
  max_count
  average
  sum
  count
  distinct_count
  count_empty
  column_dropdown_value {
    _id
    value
  }
  query {
    condition
    first_value
    first_condition
    second_value
    second_condition
  }
}
    `;
export const LmsFilterFieldsFragmentDoc = gql`
    fragment LmsFilterFields on listingFiltersType {
  type
  field
  search
  _ids
  query {
    condition
    first_value
    first_condition
    second_value
    second_condition
  }
}
    `;
export const LmsTablePresetFieldsFragmentDoc = gql`
    fragment LmsTablePresetFields on listingTablePreset {
  id
  type
  name
  is_default
  is_temp
  activeFilters
  loadingCall
  columns {
    ...LmsColumnFields
  }
  filters {
    ...LmsFilterFields
  }
  config {
    ...LmsTableConfigFields
  }
}
    ${LmsColumnFieldsFragmentDoc}
${LmsFilterFieldsFragmentDoc}
${LmsTableConfigFieldsFragmentDoc}`;
export const LmsConfigFieldsFragmentDoc = gql`
    fragment LmsConfigFields on UpdatedDataTableConfig {
  actions {
    name
    is_visible
  }
  limit
  no_of_records
  page
  totalPages
  totalResults
  type
  table_config {
    ...LmsTableConfigFields
  }
  columns {
    ...LmsColumnFields
  }
  filters {
    ...LmsFilterFields
  }
  table_preset {
    ...LmsTablePresetFields
  }
}
    ${LmsTableConfigFieldsFragmentDoc}
${LmsColumnFieldsFragmentDoc}
${LmsFilterFieldsFragmentDoc}
${LmsTablePresetFieldsFragmentDoc}`;
export const LmsLegacyDataTableConfigFieldsFragmentDoc = gql`
    fragment LmsLegacyDataTableConfigFields on dataTableConfig {
  actions
  limit
  no_of_records
  page
  totalPages
  totalResults
  type
  table_config {
    ...LmsTableConfigFields
  }
  columns {
    ...LmsColumnFields
  }
  filters {
    ...LmsFilterFields
  }
  table_preset {
    ...LmsTablePresetFields
  }
}
    ${LmsTableConfigFieldsFragmentDoc}
${LmsColumnFieldsFragmentDoc}
${LmsFilterFieldsFragmentDoc}
${LmsTablePresetFieldsFragmentDoc}`;
export const LmsCategoryFieldsFragmentDoc = gql`
    fragment LmsCategoryFields on QuizCategoryDetails {
  id
  name
  is_deleted
  created_at
  questions
  sections {
    id
    name
    score
    question_count
    is_deleted
  }
}
    `;
export const LmsUserFieldsFragmentDoc = gql`
    fragment LmsUserFields on User {
  _id
  id
  full_name
  email
  first_name
  last_name
  profile_pictures {
    path
    dimension
  }
}
    `;
export const LmsTrainingFieldsFragmentDoc = gql`
    fragment LmsTrainingFields on quizTrainingListing {
  id
  title
  description
  global_status
  created_at
  updated_at
  language
  Quiz {
    id
    title
    status
  }
  attachments {
    _id
    file
    file_name
    language
    size
    type
    is_completed
  }
  links {
    _id
    url
    language
    is_completed
  }
  all_assignee {
    started_at
    ended_at
    assigned_to_user {
      status
      completed_date
      User {
        ...LmsUserFields
      }
    }
  }
  assign_to_department {
    started_at
    ended_at
    Department {
      _id
      department_name
    }
    assigned_to_user {
      status
      completed_date
      User {
        ...LmsUserFields
      }
    }
  }
  assign_to_role {
    started_at
    ended_at
    Role {
      _id
      roleName
    }
    assigned_to_user {
      status
      completed_date
      User {
        ...LmsUserFields
      }
    }
  }
}
    ${LmsUserFieldsFragmentDoc}`;
export const LmsTrainingDetailFieldsFragmentDoc = gql`
    fragment LmsTrainingDetailFields on MyQuizTrainingLists {
  id
  title
  description
  global_status
  status
  created_at
  updated_at
  language
  QuizTrainingCategory {
    id
    name
  }
  QuizTrainingSubCategory {
    id
    name
  }
  Quiz {
    id
    title
    status
  }
  attachments {
    _id
    file
    file_name
    language
    size
    type
    is_completed
  }
  links {
    _id
    url
    language
    is_completed
  }
  all_assignee {
    started_at
    ended_at
    assigned_to_user {
      status
      completed_date
      User {
        ...LmsUserFields
      }
    }
  }
  assign_to_department {
    started_at
    ended_at
    Department {
      _id
      department_name
    }
    assigned_to_user {
      status
      completed_date
      User {
        ...LmsUserFields
      }
    }
  }
  assign_to_role {
    started_at
    ended_at
    Role {
      _id
      roleName
    }
    assigned_to_user {
      status
      completed_date
      User {
        ...LmsUserFields
      }
    }
  }
}
    ${LmsUserFieldsFragmentDoc}`;
export const LmsTrainingReplicaFieldsFragmentDoc = gql`
    fragment LmsTrainingReplicaFields on QuizTrainingReplica {
  id
  title
  description
  global_status
  started_date
  due_date
  candidates
  default_language
  languages
  content
  is_deleted
  QuizTrainingCategory {
    id
    name
  }
  QuizTrainingSubCategory {
    id
    name
  }
  Quiz {
    id
    title
    status
  }
  evaluate_by {
    ...LmsUserFields
  }
  Department {
    _id
    department_name
  }
  Role {
    _id
    roleName
  }
  attachments {
    _id
    file
    file_name
    language
    size
    type
    is_completed
  }
  links {
    _id
    url
    language
    is_completed
  }
}
    ${LmsUserFieldsFragmentDoc}`;
export const LmsQuestionFieldsFragmentDoc = gql`
    fragment LmsQuestionFields on Question {
  id
  master_question_id
  question_text
  question_type
  description
  duration
  correct_answer
  attachment
  is_required
  quiz_count
  human_verified
  language_statuses {
    language
    human_verified
  }
  QuizCategory {
    id
    name
  }
  QuizCategorySection {
    id
    name
    score
  }
  options {
    id
    text
    images
  }
}
    `;
export const LmsQuizFieldsFragmentDoc = gql`
    fragment LmsQuizFields on Quiz {
  id
  title
  description
  duration
  status
  start_time
  end_time
  passing_marks
  max_attempts
  question_count
  remarks
  language
  is_random
  is_shuffling
  is_attempt_one_by_one
  can_assign_traning
  can_re_attempts
  candidates
  is_deleted
  created_at
  updated_at
  assignTo {
    ...LmsUserFields
  }
  evaluate_by {
    ...LmsUserFields
  }
  Department {
    _id
    department_name
  }
  Role {
    _id
    roleName
  }
  evaluator_department {
    _id
    department_name
  }
  evaluator_role {
    _id
    roleName
  }
  grade {
    grade
    percent
  }
  category_sections {
    QuizCategory {
      id
      name
    }
    section_questions {
      is_random
      limit
      QuizCategorySection {
        id
        name
        score
      }
      QuizQuestion {
        ...LmsQuestionFields
      }
    }
  }
}
    ${LmsUserFieldsFragmentDoc}
${LmsQuestionFieldsFragmentDoc}`;
export const LmsAssignedQuizFieldsFragmentDoc = gql`
    fragment LmsAssignedQuizFields on AssignedQuiz {
  id
  title
  duration
  grade
  status
  is_active
  is_deleted
  is_graded
  percentage
  question_count
  quiz_start_time
  quiz_end_time
  start_time
  end_time
  total_score
  user_score
  language
  User {
    ...LmsUserFields
  }
  created_by {
    ...LmsUserFields
  }
  evaluate_by {
    ...LmsUserFields
  }
  Quiz {
    ...LmsQuizFields
  }
  category_sections {
    QuizCategory {
      id
      name
    }
    section_questions {
      QuizCategorySection {
        id
        name
        score
      }
      question_answer {
        QuizQuestion {
          id
          question_text
          question_type
          description
          options {
            id
            images
            text
          }
          is_required
          attachment
        }
      }
    }
  }
}
    ${LmsUserFieldsFragmentDoc}
${LmsQuizFieldsFragmentDoc}`;
export const LmsAssignedQuizReportFieldsFragmentDoc = gql`
    fragment LmsAssignedQuizReportFields on AssignedQuizReport {
  id
  title
  duration
  grade
  status
  is_active
  is_deleted
  is_graded
  percentage
  total_questions
  correct_questions
  start_time
  end_time
  total_score
  user_score
  language
  is_passed
  min_passing_score
  User {
    ...LmsUserFields
  }
  created_by {
    ...LmsUserFields
  }
  evaluate_by {
    ...LmsUserFields
  }
  Quiz {
    ...LmsQuizFields
  }
  category_sections {
    QuizCategory {
      id
      name
    }
    section_questions {
      QuizCategorySection {
        id
        name
        score
      }
      question_answer {
        selected_answer
        is_correct
        points_earned
        QuizQuestion {
          ...LmsQuestionFields
        }
      }
    }
  }
}
    ${LmsUserFieldsFragmentDoc}
${LmsQuizFieldsFragmentDoc}
${LmsQuestionFieldsFragmentDoc}`;
export const LmsTrainingCategoryFieldsFragmentDoc = gql`
    fragment LmsTrainingCategoryFields on QuizTrainingCategoryDetails {
  id
  name
  is_deleted
  created_at
  sub_categories {
    _id
    name
    is_deleted
  }
}
    `;
export const LmsTrainingCategoryListFieldsFragmentDoc = gql`
    fragment LmsTrainingCategoryListFields on QuizTrainingCategoryDetails {
  id
  name
  is_deleted
  created_at
  sub_categories {
    name
    is_deleted
  }
}
    `;
export const FilterFieldsFragmentDoc = gql`
    fragment FilterFields on listingFiltersType {
  type
  field
  search
  _ids
  query {
    condition
    first_value
    first_condition
    second_value
    second_condition
  }
}
    `;
export const ColumnDefinitionWithoutSummaryFieldsFragmentDoc = gql`
    fragment ColumnDefinitionWithoutSummaryFields on listingColumnsType {
  _id
  type
  field
  header
  search
  is_visible
  is_sortable
  is_search_able
  is_required
  is_amount
  show_total
  is_groupable
  is_editable
  is_unique
  pinned
  width
  validateFn
  column_data
  filterValue
  column_dropdown_value {
    _id
    value
  }
  query {
    condition
    first_value
    first_condition
    second_value
    second_condition
  }
}
    `;
export const TablePresetFieldsFragmentDoc = gql`
    fragment TablePresetFields on listingTablePreset {
  id
  type
  name
  is_default
  is_temp
  activeFilters
  loadingCall
  columns {
    ...ColumnDefinitionWithoutSummaryFields
  }
  filters {
    ...FilterFields
  }
  config {
    bodyTextFontsSize
    fontFaimly
    globalSearch
    headerTextFontsSize
    oddRowsBackgroundColor
    rowShadingEnabled
    selectedTableLayout
    showVerticalBorder
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}`;
export const SharedConfigFieldsFragmentDoc = gql`
    fragment SharedConfigFields on UpdatedDataTableConfig {
  type
  page
  limit
  no_of_records
  totalPages
  totalResults
  actions {
    name
    is_visible
  }
  filters {
    ...FilterFields
  }
  table_preset {
    ...TablePresetFields
  }
}
    ${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;
export const ConfigWithoutSummaryFieldsFragmentDoc = gql`
    fragment ConfigWithoutSummaryFields on UpdatedDataTableConfig {
  ...SharedConfigFields
  columns {
    ...ColumnDefinitionWithoutSummaryFields
  }
}
    ${SharedConfigFieldsFragmentDoc}
${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}`;
export const ColumnDefinitionWithSummaryFieldsFragmentDoc = gql`
    fragment ColumnDefinitionWithSummaryFields on listingColumnsType {
  ...ColumnDefinitionWithoutSummaryFields
  min_count
  max_count
  average
  sum
  count
  distinct_count
  count_empty
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}`;
export const ConfigWithSummaryFieldsFragmentDoc = gql`
    fragment ConfigWithSummaryFields on UpdatedDataTableConfig {
  ...SharedConfigFields
  columns {
    ...ColumnDefinitionWithSummaryFields
  }
}
    ${SharedConfigFieldsFragmentDoc}
${ColumnDefinitionWithSummaryFieldsFragmentDoc}`;
export const GetAllAccessoriesWithSearchDocument = gql`
    query GetAllAccessoriesWithSearch($input: accessoriesListFilter) {
  getAllAccessoriesWithSearch(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      id
      is_deleted
      assetId
      name
      type
      status
      quantity
      actualQuantity
      location
      availStatus
      assetImage
      category {
        id
        name
      }
      subCategory {
        id
        name
      }
      AssetBrand {
        _id
        brand_name
      }
      AssetModel {
        _id
        model_name
      }
      Vendor {
        _id
        name
      }
      invoice {
        id
        invoiceId
        orderNumber
      }
      linkingAssets {
        relation
        asset {
          id
        }
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAccessoriesWithSearchGQL extends Apollo.Query<GetAllAccessoriesWithSearchQuery, GetAllAccessoriesWithSearchQueryVariables> {
    override document = GetAllAccessoriesWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveAccessoriesToAssetDocument = gql`
    mutation MoveAccessoriesToAsset($accessoryId: ID, $quantity: Int) {
  moveAccessoriesToAsset(accessoryId: $accessoryId, quantity: $quantity)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveAccessoriesToAssetGQL extends Apollo.Mutation<MoveAccessoriesToAssetMutation, MoveAccessoriesToAssetMutationVariables> {
    override document = MoveAccessoriesToAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAccessoryDocument = gql`
    mutation ArchiveAccessory($id: [ID!], $archive: Boolean!) {
  archiveAsset(_id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAccessoryGQL extends Apollo.Mutation<ArchiveAccessoryMutation, ArchiveAccessoryMutationVariables> {
    override document = ArchiveAccessoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAdvanceFilterDocument = gql`
    mutation CreateAdvanceFilter($input: inputCreateAdvanceFilter!) {
  createAdvanceFilter(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAdvanceFilterGQL extends Apollo.Mutation<CreateAdvanceFilterMutation, CreateAdvanceFilterMutationVariables> {
    override document = CreateAdvanceFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAdvanceFiltersDocument = gql`
    query GetAllAdvanceFilters($type: String!) {
  getAllAdvanceFilters(type: $type) {
    _id
    filter_name
    list_type
    User {
      _id
      full_name
    }
    filters {
      _ids
      field
      search
      type
      query {
        condition
        first_condition
        first_value
        second_condition
        second_value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAdvanceFiltersGQL extends Apollo.Query<GetAllAdvanceFiltersQuery, GetAllAdvanceFiltersQueryVariables> {
    override document = GetAllAdvanceFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAdvanceFilterByIdDocument = gql`
    query GetAdvanceFilterById($id: ID!) {
  getAdvanceFilterById(_id: $id) {
    _id
    filter_name
    list_type
    filters {
      _ids
      field
      search
      type
      query {
        condition
        first_condition
        first_value
        second_condition
        second_value
      }
    }
    columns {
      _id
      field
      query {
        first_condition
        first_value
        condition
        second_condition
        second_value
      }
      header
      is_search_able
      is_amount
      is_visible
      is_sortable
      search
      type
      filterValue
      column_data
      column_dropdown_value {
        _id
        value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAdvanceFilterByIdGQL extends Apollo.Query<GetAdvanceFilterByIdQuery, GetAdvanceFilterByIdQueryVariables> {
    override document = GetAdvanceFilterByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAdvanceFilterDocument = gql`
    mutation ArchiveAdvanceFilter($id: ID!) {
  archiveAdvanceFilter(_id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAdvanceFilterGQL extends Apollo.Mutation<ArchiveAdvanceFilterMutation, ArchiveAdvanceFilterMutationVariables> {
    override document = ArchiveAdvanceFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateTablePresetDocument = gql`
    mutation CreateUpdateTablePreset($input: createInputTablePreset) {
  createUpdateTablePreset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateTablePresetGQL extends Apollo.Mutation<CreateUpdateTablePresetMutation, CreateUpdateTablePresetMutationVariables> {
    override document = CreateUpdateTablePresetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTablePresetDocument = gql`
    mutation DeleteTablePreset($input: deleteInputTablePreset) {
  deleteTablePreset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTablePresetGQL extends Apollo.Mutation<DeleteTablePresetMutation, DeleteTablePresetMutationVariables> {
    override document = DeleteTablePresetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClearTempTablePresetDocument = gql`
    mutation ClearTempTablePreset {
  clearTempTablePreset
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClearTempTablePresetGQL extends Apollo.Mutation<ClearTempTablePresetMutation, ClearTempTablePresetMutationVariables> {
    override document = ClearTempTablePresetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAlertsDocument = gql`
    query GetAllAlerts($input: alertListFilter) {
  getAllAlerts(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      is_deleted
      alertType
      availStatus
      asset {
        type
        assetId
        name
        availStatus
        id
      }
      endDate
      is_deleted
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAlertsGQL extends Apollo.Query<GetAllAlertsQuery, GetAllAlertsQueryVariables> {
    override document = GetAllAlertsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAssetBrandListDocument = gql`
    query GetAllAssetBrandList($input: inputfilterAssetBrand) {
  getAllAssetBrandList(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    data {
      _id
      brand_name
      asset_count
      model_counts
      is_deleted
      created_at
      detail {
        actions
        columns {
          _id
          field
          header
          type
        }
        result {
          _id
          model_name
          is_deleted
          created_at
        }
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAssetBrandListGQL extends Apollo.Query<GetAllAssetBrandListQuery, GetAllAssetBrandListQueryVariables> {
    override document = GetAllAssetBrandListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllLinkedAssetBrandListDocument = gql`
    query GetAllLinkedAssetBrandList($input: inputfilterAssetBrand) {
  getAllLinkedAssetBrandList(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    data {
      _id
      brand_name
      model_counts
      asset_count
      created_at
      detail {
        columns {
          _id
          field
          header
          type
        }
        actions
        result {
          _id
          model_name
          is_deleted
          created_at
        }
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllLinkedAssetBrandListGQL extends Apollo.Query<GetAllLinkedAssetBrandListQuery, GetAllLinkedAssetBrandListQueryVariables> {
    override document = GetAllLinkedAssetBrandListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetBrandByIdDocument = gql`
    query GetAssetBrandById($id: ID!) {
  getAssetBrandById(_id: $id) {
    _id
    brand_name
    AssetModel {
      _id
      model_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetBrandByIdGQL extends Apollo.Query<GetAssetBrandByIdQuery, GetAssetBrandByIdQueryVariables> {
    override document = GetAssetBrandByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAssetBrandDocument = gql`
    query GetAllAssetBrand {
  getAllAssetBrand {
    _id
    brand_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAssetBrandGQL extends Apollo.Query<GetAllAssetBrandQuery, GetAllAssetBrandQueryVariables> {
    override document = GetAllAssetBrandDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAssetModelDocument = gql`
    query GetAllAssetModel {
  getAllAssetModel {
    _id
    model_name
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAssetModelGQL extends Apollo.Query<GetAllAssetModelQuery, GetAllAssetModelQueryVariables> {
    override document = GetAllAssetModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetModelByBrandDocument = gql`
    query GetAssetModelByBrand($assetBrand: ID!) {
  getAssetModelByBrand(assetBrand: $assetBrand) {
    _id
    model_name
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetModelByBrandGQL extends Apollo.Query<GetAssetModelByBrandQuery, GetAssetModelByBrandQueryVariables> {
    override document = GetAssetModelByBrandDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAssetBrandDocument = gql`
    mutation CreateAssetBrand($brandName: String!) {
  createAssetBrand(brand_name: $brandName) {
    _id
    brand_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAssetBrandGQL extends Apollo.Mutation<CreateAssetBrandMutation, CreateAssetBrandMutationVariables> {
    override document = CreateAssetBrandDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssetBrandDocument = gql`
    mutation UpdateAssetBrand($input: inputUpdateBrand) {
  updateAssetBrand(input: $input) {
    _id
    brand_name
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssetBrandGQL extends Apollo.Mutation<UpdateAssetBrandMutation, UpdateAssetBrandMutationVariables> {
    override document = UpdateAssetBrandDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAssetBrandDocument = gql`
    mutation ArchiveAssetBrand($archive: Boolean!, $id: [ID!]) {
  archiveAssetBrand(archive: $archive, _id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAssetBrandGQL extends Apollo.Mutation<ArchiveAssetBrandMutation, ArchiveAssetBrandMutationVariables> {
    override document = ArchiveAssetBrandDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAssetModelDocument = gql`
    mutation CreateAssetModel($assetBrand: ID!, $models: [String!]) {
  createAssetModel(AssetBrand: $assetBrand, models: $models)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAssetModelGQL extends Apollo.Mutation<CreateAssetModelMutation, CreateAssetModelMutationVariables> {
    override document = CreateAssetModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssetModelDocument = gql`
    mutation UpdateAssetModel($input: inputUpdateModel) {
  updateAssetModel(input: $input) {
    _id
    model_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssetModelGQL extends Apollo.Mutation<UpdateAssetModelMutation, UpdateAssetModelMutationVariables> {
    override document = UpdateAssetModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAssetModelDocument = gql`
    mutation ArchiveAssetModel($id: ID!, $archive: Boolean!) {
  archiveAssetModel(_id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAssetModelGQL extends Apollo.Mutation<ArchiveAssetModelMutation, ArchiveAssetModelMutationVariables> {
    override document = ArchiveAssetModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAssetCategoryAndSubCategoryDocument = gql`
    query GetAllAssetCategoryAndSubCategory($input: categoryListFilter) {
  getAllAssetCategoryAndSubCategory(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    data {
      _id
      name
      subCategoryCount
      assigned_asset_count
      unassigned_asset_count
      maintenance_asset_count
      reserved_asset_count
      dispose_asset_count
      scrap_asset_count
      trashed_asset_count
      totalActualCost
      totalCurrentValue
      totalDepreciationValue
      is_deleted
      subCategory {
        id
        name
      }
      detail {
        columns {
          _id
          field
          header
          type
        }
        result {
          name
          is_deleted
        }
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAssetCategoryAndSubCategoryGQL extends Apollo.Query<GetAllAssetCategoryAndSubCategoryQuery, GetAllAssetCategoryAndSubCategoryQueryVariables> {
    override document = GetAllAssetCategoryAndSubCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllCategoryAndSubcategoryListDocument = gql`
    query GetAllCategoryAndSubcategoryList($input: categoryListFilter) {
  getAllCategoryAndSubcategoryList(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    data {
      name
      id
      subCategoryCount
      linked_subCategories
      unlinked_sub_categories
      created_at
      is_deleted
      detail {
        columns {
          _id
          field
          header
          type
        }
        result {
          name
          id
          is_deleted
          created_at
        }
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllCategoryAndSubcategoryListGQL extends Apollo.Query<GetAllCategoryAndSubcategoryListQuery, GetAllCategoryAndSubcategoryListQueryVariables> {
    override document = GetAllCategoryAndSubcategoryListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAssetCategoriesDocument = gql`
    query GetAllAssetCategories {
  getAllAssetCategories {
    _id
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAssetCategoriesGQL extends Apollo.Query<GetAllAssetCategoriesQuery, GetAllAssetCategoriesQueryVariables> {
    override document = GetAllAssetCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAssetSubCategoriesDocument = gql`
    query GetAllAssetSubCategories {
  getAllAssetSubCategories {
    id
    name
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAssetSubCategoriesGQL extends Apollo.Query<GetAllAssetSubCategoriesQuery, GetAllAssetSubCategoriesQueryVariables> {
    override document = GetAllAssetSubCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAssetSubCategoryByIdDocument = gql`
    query GetAllAssetSubCategoryById($getAllAssetSubCategoryByIdId: ID!) {
  getAllAssetSubCategoryById(id: $getAllAssetSubCategoryByIdId) {
    id
    name
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAssetSubCategoryByIdGQL extends Apollo.Query<GetAllAssetSubCategoryByIdQuery, GetAllAssetSubCategoryByIdQueryVariables> {
    override document = GetAllAssetSubCategoryByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetCategoryByIdDocument = gql`
    query GetAssetCategoryById($id: ID!) {
  getAssetCategoryById(id: $id) {
    _id
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetCategoryByIdGQL extends Apollo.Query<GetAssetCategoryByIdQuery, GetAssetCategoryByIdQueryVariables> {
    override document = GetAssetCategoryByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAssetCategoryOrSubCategoryDocument = gql`
    mutation CreateAssetCategoryOrSubCategory($input: CreateAssetCategoryOrSubCategoryInput) {
  createAssetCategoryOrSubCategory(input: $input) {
    _id
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAssetCategoryOrSubCategoryGQL extends Apollo.Mutation<CreateAssetCategoryOrSubCategoryMutation, CreateAssetCategoryOrSubCategoryMutationVariables> {
    override document = CreateAssetCategoryOrSubCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssetCategoryDocument = gql`
    mutation UpdateAssetCategory($input: UpdateAssetCategoryInput) {
  updateAssetCategory(input: $input) {
    _id
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssetCategoryGQL extends Apollo.Mutation<UpdateAssetCategoryMutation, UpdateAssetCategoryMutationVariables> {
    override document = UpdateAssetCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAssetCategoryDocument = gql`
    mutation ArchiveAssetCategory($archive: Boolean!, $id: [ID!]) {
  archiveAssetCategory(archive: $archive, _id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAssetCategoryGQL extends Apollo.Mutation<ArchiveAssetCategoryMutation, ArchiveAssetCategoryMutationVariables> {
    override document = ArchiveAssetCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssetSubCategoryDocument = gql`
    mutation UpdateAssetSubCategory($input: UpdateAssetSubCategoryInput) {
  updateAssetSubCategory(input: $input) {
    id
    name
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssetSubCategoryGQL extends Apollo.Mutation<UpdateAssetSubCategoryMutation, UpdateAssetSubCategoryMutationVariables> {
    override document = UpdateAssetSubCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAssetSubCategoryDocument = gql`
    mutation ArchiveAssetSubCategory($id: ID!, $archive: Boolean!) {
  archiveAssetSubCategory(_id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAssetSubCategoryGQL extends Apollo.Mutation<ArchiveAssetSubCategoryMutation, ArchiveAssetSubCategoryMutationVariables> {
    override document = ArchiveAssetSubCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMultipleAssetSubCategoryDocument = gql`
    mutation UpdateMultipleAssetSubCategory($input: inputUpdateMultipleSubCateg) {
  updateMultipleAssetSubCategory(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMultipleAssetSubCategoryGQL extends Apollo.Mutation<UpdateMultipleAssetSubCategoryMutation, UpdateMultipleAssetSubCategoryMutationVariables> {
    override document = UpdateMultipleAssetSubCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStationByDepartmentIdDocument = gql`
    query GetStationByDepartmentId($department: ID!) {
  getStationByDepartmentId(department: $department) {
    _id
    station_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStationByDepartmentIdGQL extends Apollo.Query<GetStationByDepartmentIdQuery, GetStationByDepartmentIdQueryVariables> {
    override document = GetStationByDepartmentIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllQuickAssetsDocument = gql`
    query GetAllQuickAssets($limit: Int, $page: Int, $search: String, $type: enumAssetType!) {
  getAllQuickAssets(limit: $limit, page: $page, search: $search, type: $type) {
    totalPages
    totalResults
    data {
      id
      assetId
      name
      type
      actualQuantity
      category {
        name
      }
      subCategory {
        name
      }
      AssetBrand {
        _id
        brand_name
      }
      AssetModel {
        _id
        model_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllQuickAssetsGQL extends Apollo.Query<GetAllQuickAssetsQuery, GetAllQuickAssetsQueryVariables> {
    override document = GetAllQuickAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllUnlinkedQuickAssetsDocument = gql`
    query GetAllUnlinkedQuickAssets($limit: Int, $page: Int, $search: String, $type: enumAssetType!) {
  getAllQuickAssets(limit: $limit, page: $page, search: $search, type: $type) {
    data {
      id
      category {
        name
      }
      subCategory {
        name
      }
      name
      type
      AssetBrand {
        _id
        brand_name
      }
      AssetModel {
        _id
        model_name
      }
      assetId
    }
    totalResults
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllUnlinkedQuickAssetsGQL extends Apollo.Query<GetAllUnlinkedQuickAssetsQuery, GetAllUnlinkedQuickAssetsQueryVariables> {
    override document = GetAllUnlinkedQuickAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAssetsDocument = gql`
    query GetAllAssets {
  getAllAssets {
    isLinkedRelation
    id
    assetId
    name
    serialNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAssetsGQL extends Apollo.Query<GetAllAssetsQuery, GetAllAssetsQueryVariables> {
    override document = GetAllAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAssetsWithSearchDocument = gql`
    query GetAllAssetsWithSearch($input: assetListFilter) {
  getAllAssetsWithSearch(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      other_detail
      Station {
        _id
        station_name
      }
      department {
        _id
        department_name
      }
      type
      assetId
      assignedType
      invoice {
        invoice_image
        invoiceId
        grandTotal
        id
        invoice_image_name
        invoiceItems {
          assetIds
          price
        }
      }
      description
      unitPrice
      assetImage
      isLinkedRelation
      Vendor {
        _id
        name
      }
      reserveAsset {
        assignedType
        reserveFrom
        reserveTo
        site {
          _id
          store_name
        }
        employee {
          id
          full_name
        }
        department {
          _id
          department_name
        }
      }
      logs {
        action
        assigned {
          id
          full_name
          last_name
        }
        assignedDepartment {
          _id
          department_name
        }
        changedFrom
        changedTo
        created_by {
          id
          full_name
          first_name
          last_name
        }
        date
        status
      }
      assigned {
        id
        first_name
        full_name
      }
      assignedSite {
        _id
        store_name
      }
      site {
        _id
        store_name
      }
      availStatus
      category {
        id
        is_deleted
        name
      }
      subCategory {
        id
        is_deleted
        name
      }
      checkIn_checkOut_date
      cost
      is_deleted
      fields {
        assetName
        labelName
      }
      id
      location
      AssetBrand {
        _id
        brand_name
      }
      AssetModel {
        _id
        model_name
      }
      name
      purchasedFrom {
        address
        company
        email
        fullName
        id
        notes
        phone
      }
      quantity
      serialNumber
      status
      warranty
      warrantyExpiry
      created_at
      is_deleted
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAssetsWithSearchGQL extends Apollo.Query<GetAllAssetsWithSearchQuery, GetAllAssetsWithSearchQueryVariables> {
    override document = GetAllAssetsWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetsByIdDocument = gql`
    query GetAssetsById($getAssetsByIdId: ID!) {
  getAssetsById(id: $getAssetsByIdId) {
    id
    assetId
    name
    type
    assetImage
    status
    availStatus
    cost
    is_deleted
    description
    serialNumber
    quantity
    location
    created_at
    purchasedDate
    warrantyExpiry
    warranty
    leaseBegin
    leaseEnd
    initialCost
    depreciationType
    isDepreciation
    depreciationTenure
    depreciationSalvageValue
    isAutoAssetId
    assignedType
    other_detail
    category {
      id
      name
    }
    subCategory {
      id
      name
    }
    AssetBrand {
      _id
      brand_name
    }
    AssetModel {
      _id
      model_name
    }
    assigned {
      id
      full_name
      first_name
      last_name
    }
    site {
      _id
      store_name
    }
    department {
      _id
      department_name
    }
    Station {
      _id
      station_name
    }
    purchasedFrom {
      id
      address
      company
      email
      fullName
      notes
      phone
    }
    invoice {
      id
      invoiceId
      invoiceItems {
        id
        sku
        name
        quantity
        price
        total
        serial_number
      }
    }
    depreciation {
      year
      startAmount
      percentage
      depreciationAmount
      depreciationMonths
      endAmount
      dailyDepreciation
      totalDepreciated
    }
    reserveAsset {
      assignedType
      reserveFrom
      reserveTo
      site {
        _id
        store_name
      }
      employee {
        id
        full_name
      }
      department {
        _id
        department_name
      }
    }
    logs {
      action
      date
      changedFrom
      changedTo
      status
      created_by {
        full_name
      }
      assigned {
        full_name
      }
      assignedDepartment {
        _id
        department_name
      }
    }
    contractsAndLicenses {
      id
    }
    insuranceLinks {
      insurance {
        id
      }
    }
    fields {
      assetName
      labelName
    }
    created_by {
      full_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetsByIdGQL extends Apollo.Query<GetAssetsByIdQuery, GetAssetsByIdQueryVariables> {
    override document = GetAssetsByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetQuickAssetByIdDocument = gql`
    query getQuickAssetById($id: ID!) {
  getAssetsById(id: $id) {
    id
    type
    name
    quantity
    actualQuantity
    isAutoAssetId
    description
    other_detail
    assetImage
    assetId
    serialNumber
    category {
      id
      name
    }
    subCategory {
      id
      name
    }
    AssetBrand {
      _id
      brand_name
    }
    AssetModel {
      _id
      model_name
    }
    assignedType
    assigned {
      id
      full_name
    }
    site {
      _id
      store_name
    }
    department {
      _id
      department_name
    }
    Station {
      _id
      station_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQuickAssetByIdGQL extends Apollo.Query<GetQuickAssetByIdQuery, GetQuickAssetByIdQueryVariables> {
    override document = GetQuickAssetByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetMovementHistorybyIdDocument = gql`
    query GetAssetMovementHistorybyId($getAssetMovementHistorybyIdId: ID!, $limit: Int, $page: Int) {
  GetAssetMovementHistorybyID(
    id: $getAssetMovementHistorybyIdId
    limit: $limit
    page: $page
  ) {
    data {
      moved_at
      moved_by {
        _id
        full_name
      }
      remarks
      from {
        department {
          _id
          department_name
        }
        Station {
          _id
          station_name
        }
        role_employes {
          _id
          full_name
        }
        site {
          _id
          store_name
          store_nick_name
        }
      }
      to {
        department {
          _id
          department_name
        }
        Station {
          _id
          station_name
        }
        role_employes {
          _id
          full_name
        }
        site {
          _id
          store_name
          store_nick_name
        }
      }
    }
    limit
    page
    totalCount
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetMovementHistorybyIdGQL extends Apollo.Query<GetAssetMovementHistorybyIdQuery, GetAssetMovementHistorybyIdQueryVariables> {
    override document = GetAssetMovementHistorybyIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLinkedAssetsDocument = gql`
    query GetLinkedAssets($assetId: ID!) {
  getAllLinkRelationalAsset(assetId: $assetId) {
    id
    linkingAssets {
      relation
      asset {
        id
        name
        assetId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLinkedAssetsGQL extends Apollo.Query<GetLinkedAssetsQuery, GetLinkedAssetsQueryVariables> {
    override document = GetLinkedAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllLeasingCustomerDocument = gql`
    query GetAllLeasingCustomer {
  getAllLeasingCustomer {
    id
    fullName
    company
    address
    phone
    email
    notes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllLeasingCustomerGQL extends Apollo.Query<GetAllLeasingCustomerQuery, GetAllLeasingCustomerQueryVariables> {
    override document = GetAllLeasingCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateAssetIdDocument = gql`
    query GenerateAssetId($quantity: Int, $name: String) {
  generateAssetId(quantity: $quantity, name: $name)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAssetIdGQL extends Apollo.Query<GenerateAssetIdQuery, GenerateAssetIdQueryVariables> {
    override document = GenerateAssetIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateQuickAssetDocument = gql`
    mutation CreateQuickAsset($input: CreateAssetInput) {
  createQuickAsset(input: $input) {
    id
    assetId
    type
    AssetBrand {
      _id
      brand_name
    }
    AssetModel {
      _id
      model_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateQuickAssetGQL extends Apollo.Mutation<CreateQuickAssetMutation, CreateQuickAssetMutationVariables> {
    override document = CreateQuickAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateQuickAssetDocument = gql`
    mutation UpdateQuickAsset($updateQuickAssetId: ID!, $input: UpdateAssetInput) {
  updateQuickAsset(id: $updateQuickAssetId, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateQuickAssetGQL extends Apollo.Mutation<UpdateQuickAssetMutation, UpdateQuickAssetMutationVariables> {
    override document = UpdateQuickAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAssetDocument = gql`
    mutation CreateAsset($input: AssetInput!) {
  createAsset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAssetGQL extends Apollo.Mutation<CreateAssetMutation, CreateAssetMutationVariables> {
    override document = CreateAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssetDocument = gql`
    mutation UpdateAsset($updateAssetId: ID!, $input: AssetUpdateInput) {
  updateAsset(id: $updateAssetId, input: $input) {
    assetId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssetGQL extends Apollo.Mutation<UpdateAssetMutation, UpdateAssetMutationVariables> {
    override document = UpdateAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAssetDocument = gql`
    mutation ArchiveAsset($archive: Boolean!, $id: [ID!]) {
  archiveAsset(archive: $archive, _id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAssetGQL extends Apollo.Mutation<ArchiveAssetMutation, ArchiveAssetMutationVariables> {
    override document = ArchiveAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateUniqueAssetIdDocument = gql`
    mutation GenerateUniqueAssetId($name: String) {
  generateUniqueAssetId(name: $name)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateUniqueAssetIdGQL extends Apollo.Mutation<GenerateUniqueAssetIdMutation, GenerateUniqueAssetIdMutationVariables> {
    override document = GenerateUniqueAssetIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LinkAssetAsChildOrParentDocument = gql`
    mutation LinkAssetAsChildOrParent($input: [linkingRelationAsset]!) {
  linkParentOrChildAssetWithAsset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LinkAssetAsChildOrParentGQL extends Apollo.Mutation<LinkAssetAsChildOrParentMutation, LinkAssetAsChildOrParentMutationVariables> {
    override document = LinkAssetAsChildOrParentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnLinkAssetRelationFromAssetDocument = gql`
    mutation UnLinkAssetRelationFromAsset($input: unLinkingRelationAsset) {
  unLinkAssetRelationFromAsset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnLinkAssetRelationFromAssetGQL extends Apollo.Mutation<UnLinkAssetRelationFromAssetMutation, UnLinkAssetRelationFromAssetMutationVariables> {
    override document = UnLinkAssetRelationFromAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckoutAssetsDocument = gql`
    mutation CheckoutAssets($input: CheckoutAssetInput!) {
  checkoutAssets(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckoutAssetsGQL extends Apollo.Mutation<CheckoutAssetsMutation, CheckoutAssetsMutationVariables> {
    override document = CheckoutAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckInAssetsDocument = gql`
    mutation CheckInAssets($input: CheckInAssetInput!) {
  checkInAssets(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckInAssetsGQL extends Apollo.Mutation<CheckInAssetsMutation, CheckInAssetsMutationVariables> {
    override document = CheckInAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveAssetFromLocationToLocationDocument = gql`
    mutation MoveAssetFromLocationToLocation($assetId: ID!, $site: ID) {
  moveAssetFromLocationToLocation(assetId: $assetId, site: $site)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveAssetFromLocationToLocationGQL extends Apollo.Mutation<MoveAssetFromLocationToLocationMutation, MoveAssetFromLocationToLocationMutationVariables> {
    override document = MoveAssetFromLocationToLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddLeasingCustomerDocument = gql`
    mutation AddLeasingCustomer($input: LeasingCustomerInput!) {
  addLeasingCustomer(input: $input) {
    id
    fullName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddLeasingCustomerGQL extends Apollo.Mutation<AddLeasingCustomerMutation, AddLeasingCustomerMutationVariables> {
    override document = AddLeasingCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLeasingCustomerDocument = gql`
    mutation UpdateLeasingCustomer($input: LeasingCustomerInput!) {
  updateLeasingCustomer(input: $input) {
    id
    fullName
    company
    address
    phone
    email
    notes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLeasingCustomerGQL extends Apollo.Mutation<UpdateLeasingCustomerMutation, UpdateLeasingCustomerMutationVariables> {
    override document = UpdateLeasingCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetTransactAsWholeDocument = gql`
    mutation SetTransactAsWhole($assetId: ID!, $transactionValue: Boolean!) {
  updateTransactWholeFieldInAsset(
    assetId: $assetId
    transactionValue: $transactionValue
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetTransactAsWholeGQL extends Apollo.Mutation<SetTransactAsWholeMutation, SetTransactAsWholeMutationVariables> {
    override document = SetTransactAsWholeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlaidTransactionsDocument = gql`
    query GetPlaidTransactions($input: PaidTransactionFilter) {
  getPlaidTransactions(input: $input) {
    config {
      actions
      columns {
        ...ColumnDefinitionWithSummaryFields
      }
      filters {
        ...FilterFields
      }
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
      table_preset {
        ...TablePresetFields
      }
    }
    results {
      _id
      mapped_category
      account_id
      account_owner
      amount
      authorized_datetime
      category
      datetime
      merchant_entity_id
      merchant_name
      name
      pending
      transaction_code
      transaction_id
      transaction_type
      website
      iso_currency_code
      logo_url
      location {
        city
      }
    }
  }
}
    ${ColumnDefinitionWithSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlaidTransactionsGQL extends Apollo.Query<GetPlaidTransactionsQuery, GetPlaidTransactionsQueryVariables> {
    override document = GetPlaidTransactionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SyncPlaidTransactionsDocument = gql`
    query SyncPlaidTransactions {
  getPlaidSyncTransactions {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SyncPlaidTransactionsGQL extends Apollo.Query<SyncPlaidTransactionsQuery, SyncPlaidTransactionsQueryVariables> {
    override document = SyncPlaidTransactionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllPlaidCategoriesDocument = gql`
    query GetAllPlaidCategories {
  getAllPlaidCategories
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllPlaidCategoriesGQL extends Apollo.Query<GetAllPlaidCategoriesQuery, GetAllPlaidCategoriesQueryVariables> {
    override document = GetAllPlaidCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMappedPlaidCategoriesDocument = gql`
    query GetMappedPlaidCategories {
  getMaapedPlaidCcategories {
    is_deleted
    _id
    mapped_category
    plaid_categorie
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMappedPlaidCategoriesGQL extends Apollo.Query<GetMappedPlaidCategoriesQuery, GetMappedPlaidCategoriesQueryVariables> {
    override document = GetMappedPlaidCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAndMapPlaidCategoriesDocument = gql`
    mutation CreateAndMapPlaidCategories($input: plaidCategoriesInput) {
  createAndMapPlaidCategories(input: $input) {
    is_deleted
    mapped_category
    plaid_categorie
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAndMapPlaidCategoriesGQL extends Apollo.Mutation<CreateAndMapPlaidCategoriesMutation, CreateAndMapPlaidCategoriesMutationVariables> {
    override document = CreateAndMapPlaidCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchivePlaidCategoriesDocument = gql`
    mutation ArchivePlaidCategories($archivePlaidCategoriesId: ID!) {
  archivePlaidCategories(id: $archivePlaidCategoriesId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchivePlaidCategoriesGQL extends Apollo.Mutation<ArchivePlaidCategoriesMutation, ArchivePlaidCategoriesMutationVariables> {
    override document = ArchivePlaidCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllContractAndLicenseeWithSearchDocument = gql`
    query GetAllContractAndLicenseeWithSearch($input: ContractLicenseFilter) {
  getAllContractAndLicenseeWithSearch(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      id
      contractLicenseTitle
      description
      hyperlink
      contractNo
      vendor
      cost
      startDate
      endDate
      contactPerson
      phone
      noOfLicenses
      isForSoftware
      isNoEndDate
      is_deleted
      status
      logs {
        date
        action
        created_by {
          full_name
        }
        assigned {
          assetId
          name
        }
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllContractAndLicenseeWithSearchGQL extends Apollo.Query<GetAllContractAndLicenseeWithSearchQuery, GetAllContractAndLicenseeWithSearchQueryVariables> {
    override document = GetAllContractAndLicenseeWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContractAndLicenseByIdDocument = gql`
    query GetContractAndLicenseById($getContractAndLicenseByIdId: ID!) {
  getContractAndLicenseById(id: $getContractAndLicenseByIdId) {
    contractLicenseTitle
    description
    hyperlink
    contractNo
    vendor
    cost
    startDate
    endDate
    contactPerson
    phone
    isForSoftware
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContractAndLicenseByIdGQL extends Apollo.Query<GetContractAndLicenseByIdQuery, GetContractAndLicenseByIdQueryVariables> {
    override document = GetContractAndLicenseByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllContractsAndLicensesDocument = gql`
    query GetAllContractsAndLicenses {
  getAllContractsAndLicenses {
    id
    contractLicenseTitle
    vendor
    startDate
    endDate
    contactPerson
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllContractsAndLicensesGQL extends Apollo.Query<GetAllContractsAndLicensesQuery, GetAllContractsAndLicensesQueryVariables> {
    override document = GetAllContractsAndLicensesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllContractsAndLicensesLinkWithAssetsDocument = gql`
    query GetAllContractsAndLicensesLinkWithAssets($assetId: ID!) {
  getAllContractsAndLicensesLinkWithAssets(assetId: $assetId) {
    id
    contractsAndLicenses {
      id
      contractLicenseTitle
      vendor
      startDate
      endDate
      description
      is_deleted
      contactPerson
      contractNo
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllContractsAndLicensesLinkWithAssetsGQL extends Apollo.Query<GetAllContractsAndLicensesLinkWithAssetsQuery, GetAllContractsAndLicensesLinkWithAssetsQueryVariables> {
    override document = GetAllContractsAndLicensesLinkWithAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddContractLicenseDocument = gql`
    mutation AddContractLicense($input: contractLicenseInput!) {
  addContractLicense(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddContractLicenseGQL extends Apollo.Mutation<AddContractLicenseMutation, AddContractLicenseMutationVariables> {
    override document = AddContractLicenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContractLicenseDocument = gql`
    mutation UpdateContractLicense($updateContractLicenseId: ID!, $input: contractLicenseInput!) {
  updateContractLicense(id: $updateContractLicenseId, input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContractLicenseGQL extends Apollo.Mutation<UpdateContractLicenseMutation, UpdateContractLicenseMutationVariables> {
    override document = UpdateContractLicenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveContractLicenseDocument = gql`
    mutation ArchiveContractLicense($archive: Boolean!, $id: [ID!]) {
  archiveContractLicense(archive: $archive, _id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveContractLicenseGQL extends Apollo.Mutation<ArchiveContractLicenseMutation, ArchiveContractLicenseMutationVariables> {
    override document = ArchiveContractLicenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LinkContractsWithAssetDocument = gql`
    mutation LinkContractsWithAsset($assetId: ID!, $contractId: ID!, $contractName: String!) {
  linkContractsWithAsset(
    assetId: $assetId
    contractId: $contractId
    contractName: $contractName
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LinkContractsWithAssetGQL extends Apollo.Mutation<LinkContractsWithAssetMutation, LinkContractsWithAssetMutationVariables> {
    override document = LinkContractsWithAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DetectContractFromAssetDocument = gql`
    mutation DetectContractFromAsset($assetId: ID!, $contractId: ID!, $contractName: String!) {
  detectContractFromAsset(
    assetId: $assetId
    contractId: $contractId
    contractName: $contractName
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DetectContractFromAssetGQL extends Apollo.Mutation<DetectContractFromAssetMutation, DetectContractFromAssetMutationVariables> {
    override document = DetectContractFromAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAssetsForDisposeDocument = gql`
    query GetAllAssetsForDispose {
  getAllAssets {
    id
    assetId
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAssetsForDisposeGQL extends Apollo.Query<GetAllAssetsForDisposeQuery, GetAllAssetsForDisposeQueryVariables> {
    override document = GetAllAssetsForDisposeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDisposeWithSearchDocument = gql`
    query GetAllDisposeWithSearch($input: disposeListFilter) {
  getAllDisposeWithSearch(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      id
      is_deleted
      assetId
      name
      availStatus
      location
      disposeAsset {
        disposeDate
      }
      detail {
        columns {
          _id
          field
          header
          type
          search
          is_search_able
          query {
            first_condition
            second_condition
            first_value
            second_value
            condition
          }
          is_visible
          is_sortable
          filterValue
          column_data
          column_dropdown_value {
            _id
            value
          }
        }
        result {
          assigned {
            full_name
          }
          action
          changedFrom
          changedTo
          date
        }
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDisposeWithSearchGQL extends Apollo.Query<GetAllDisposeWithSearchQuery, GetAllDisposeWithSearchQueryVariables> {
    override document = GetAllDisposeWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisposedAssetDocument = gql`
    mutation DisposedAsset($input: disposedInput) {
  disposedAsset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisposedAssetGQL extends Apollo.Mutation<DisposedAssetMutation, DisposedAssetMutationVariables> {
    override document = DisposedAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UndoDisposedAssetDocument = gql`
    mutation UndoDisposedAsset($assetId: ID!) {
  undoDisposedAsset(assetId: $assetId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UndoDisposedAssetGQL extends Apollo.Mutation<UndoDisposedAssetMutation, UndoDisposedAssetMutationVariables> {
    override document = UndoDisposedAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashAssetDocument = gql`
    mutation TrashAsset($input: trashInput) {
  trashAsset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashAssetGQL extends Apollo.Mutation<TrashAssetMutation, TrashAssetMutationVariables> {
    override document = TrashAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScrapAssetDocument = gql`
    mutation ScrapAsset($input: scrapInput) {
  scrapAsset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScrapAssetGQL extends Apollo.Mutation<ScrapAssetMutation, ScrapAssetMutationVariables> {
    override document = ScrapAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDocumentsLinkWithAssetsDocument = gql`
    query GetAllDocumentsLinkWithAssets($assetId: ID!) {
  getAllDocumentsLinkWithAssets(assetId: $assetId) {
    created_at
    documents {
      id
      fileName
      fileType
      fileUrl
      description
      upload_by {
        full_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDocumentsLinkWithAssetsGQL extends Apollo.Query<GetAllDocumentsLinkWithAssetsQuery, GetAllDocumentsLinkWithAssetsQueryVariables> {
    override document = GetAllDocumentsLinkWithAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadAssetDocsDocument = gql`
    mutation UploadAssetDocs($input: uploadAssetDocInput) {
  uploadAssetDocs(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadAssetDocsGQL extends Apollo.Mutation<UploadAssetDocsMutation, UploadAssetDocsMutationVariables> {
    override document = UploadAssetDocsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDocFromAssetDocument = gql`
    mutation DeleteDocFromAsset($assetId: ID!, $documentId: ID!) {
  deleteDocFromAsset(assetId: $assetId, documentId: $documentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDocFromAssetGQL extends Apollo.Mutation<DeleteDocFromAssetMutation, DeleteDocFromAssetMutationVariables> {
    override document = DeleteDocFromAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExpenseInvoiceAndCategoryListWithSearchDocument = gql`
    query GetExpenseInvoiceAndCategoryListWithSearch($input: ExpenseInvoiceCategoryInput) {
  getExpenseInvoiceAndCategoryListWithSearch(input: $input) {
    config {
      actions {
        name
        is_visible
      }
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
      table_preset {
        ...TablePresetFields
      }
    }
    data {
      id
      name
      is_deleted
      category_count
      invoice_count
      created_at
      detail {
        actions {
          name
          is_visible
        }
        columns {
          _id
          field
          header
          type
          is_visible
          is_sortable
          is_amount
          filterValue
          column_data
          column_dropdown_value {
            _id
            value
          }
        }
        result {
          id
          name
          is_deleted
          created_at
        }
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExpenseInvoiceAndCategoryListWithSearchGQL extends Apollo.Query<GetExpenseInvoiceAndCategoryListWithSearchQuery, GetExpenseInvoiceAndCategoryListWithSearchQueryVariables> {
    override document = GetExpenseInvoiceAndCategoryListWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExpenseInvoiceWithSearchDocument = gql`
    query GetExpenseInvoiceWithSearch($input: ExpenseInvoiceInput) {
  getExpenseInvoiceWithSearch(input: $input) {
    config {
      actions
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
      table_preset {
        ...TablePresetFields
      }
    }
    data {
      id
      name
      is_deleted
      category_count
      invoice_count
      created_at
      detail {
        columns {
          _id
          field
          header
          type
          is_visible
          is_sortable
          is_amount
          filterValue
          column_data
          column_dropdown_value {
            _id
            value
          }
        }
        result {
          id
          name
          category
          categoryId
          invoiceId
          invoice_name
          invoice_number
          price
          quantity
        }
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExpenseInvoiceWithSearchGQL extends Apollo.Query<GetExpenseInvoiceWithSearchQuery, GetExpenseInvoiceWithSearchQueryVariables> {
    override document = GetExpenseInvoiceWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExpenseInvoiceByIdDocument = gql`
    query GetExpenseInvoiceById($id: ID!) {
  getExpenseInvoiceById(id: $id) {
    id
    name
    is_deleted
    category {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExpenseInvoiceByIdGQL extends Apollo.Query<GetExpenseInvoiceByIdQuery, GetExpenseInvoiceByIdQueryVariables> {
    override document = GetExpenseInvoiceByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllExpenseInvoiceDocument = gql`
    query GetAllExpenseInvoice {
  getAllExpenseInvoice {
    id
    name
    category {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllExpenseInvoiceGQL extends Apollo.Query<GetAllExpenseInvoiceQuery, GetAllExpenseInvoiceQueryVariables> {
    override document = GetAllExpenseInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllExpenseInvoiceCategoryDocument = gql`
    query GetAllExpenseInvoiceCategory {
  getAllExpenseInvoiceCategory {
    id
    name
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllExpenseInvoiceCategoryGQL extends Apollo.Query<GetAllExpenseInvoiceCategoryQuery, GetAllExpenseInvoiceCategoryQueryVariables> {
    override document = GetAllExpenseInvoiceCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExpenseInvoiceCategoryDocument = gql`
    mutation CreateExpenseInvoiceCategory($input: createExpenseInvoiceCategory!) {
  createExpenseInvoiceCategory(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExpenseInvoiceCategoryGQL extends Apollo.Mutation<CreateExpenseInvoiceCategoryMutation, CreateExpenseInvoiceCategoryMutationVariables> {
    override document = CreateExpenseInvoiceCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExpenseInvoiceDocument = gql`
    mutation CreateExpenseInvoice($input: createExpenseInvoice!) {
  createExpenseInvoice(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExpenseInvoiceGQL extends Apollo.Mutation<CreateExpenseInvoiceMutation, CreateExpenseInvoiceMutationVariables> {
    override document = CreateExpenseInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateExpenseInvoiceDocument = gql`
    mutation UpdateExpenseInvoice($input: updateExpenseInvoice!) {
  updateExpenseInvoice(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExpenseInvoiceGQL extends Apollo.Mutation<UpdateExpenseInvoiceMutation, UpdateExpenseInvoiceMutationVariables> {
    override document = UpdateExpenseInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExpenseInvoiceAndCategoryDocument = gql`
    mutation CreateExpenseInvoiceAndCategory($input: createExpenseInvoice!) {
  createExpenseInvoiceAndCategory(input: $input) {
    id
    name
    category
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExpenseInvoiceAndCategoryGQL extends Apollo.Mutation<CreateExpenseInvoiceAndCategoryMutation, CreateExpenseInvoiceAndCategoryMutationVariables> {
    override document = CreateExpenseInvoiceAndCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateExpenseInvoiceCategoryDocument = gql`
    mutation UpdateExpenseInvoiceCategory($input: updateExpenseInvoiceCategory!) {
  updateExpenseInvoiceCategory(input: $input) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExpenseInvoiceCategoryGQL extends Apollo.Mutation<UpdateExpenseInvoiceCategoryMutation, UpdateExpenseInvoiceCategoryMutationVariables> {
    override document = UpdateExpenseInvoiceCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveExpenseInvoiceDocument = gql`
    mutation ArchiveExpenseInvoice($input: archiveInvoiceInput) {
  archiveExpenseInvoice(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveExpenseInvoiceGQL extends Apollo.Mutation<ArchiveExpenseInvoiceMutation, ArchiveExpenseInvoiceMutationVariables> {
    override document = ArchiveExpenseInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveExpenseInvoiceCategoryDocument = gql`
    mutation ArchiveExpenseInvoiceCategory($input: archiveInvoiceInput) {
  archiveExpenseInvoiceCategory(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveExpenseInvoiceCategoryGQL extends Apollo.Mutation<ArchiveExpenseInvoiceCategoryMutation, ArchiveExpenseInvoiceCategoryMutationVariables> {
    override document = ArchiveExpenseInvoiceCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInsuranceByIdDocument = gql`
    query GetInsuranceById($getInsuranceByIdId: ID!) {
  getInsuranceById(id: $getInsuranceByIdId) {
    active
    contactPerson
    coverage
    deductible
    description
    email
    endDate
    insuranceCo
    limits
    phone
    policyNo
    premium
    startDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInsuranceByIdGQL extends Apollo.Query<GetInsuranceByIdQuery, GetInsuranceByIdQueryVariables> {
    override document = GetInsuranceByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllInsuranceDocument = gql`
    query GetAllInsurance {
  getAllInsurance {
    id
    insuranceCo
    active
    endDate
    startDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllInsuranceGQL extends Apollo.Query<GetAllInsuranceQuery, GetAllInsuranceQueryVariables> {
    override document = GetAllInsuranceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllInsuranceWithSearchDocument = gql`
    query GetAllInsuranceWithSearch($input: insuranceListFilter) {
  getAllInsuranceWithSearch(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      active
      status
      logs {
        date
        action
        created_by {
          full_name
        }
        assigned {
          assetId
          name
        }
      }
      asset {
        id
        name
        assetId
      }
      contactPerson
      coverage
      deductible
      description
      email
      endDate
      id
      insuranceCo
      is_deleted
      limits
      phone
      policyNo
      premium
      startDate
      is_deleted
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllInsuranceWithSearchGQL extends Apollo.Query<GetAllInsuranceWithSearchQuery, GetAllInsuranceWithSearchQueryVariables> {
    override document = GetAllInsuranceWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllInsuranceLinkWithAssetsDocument = gql`
    query GetAllInsuranceLinkWithAssets($assetId: ID!) {
  getAllInsuranceLinkWithAssets(assetId: $assetId) {
    name
    id
    insuranceLinks {
      insurance {
        startDate
        endDate
        insuranceCo
        is_deleted
        description
        id
        active
        contactPerson
        coverage
        deductible
        limits
        phone
        policyNo
        premium
        email
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllInsuranceLinkWithAssetsGQL extends Apollo.Query<GetAllInsuranceLinkWithAssetsQuery, GetAllInsuranceLinkWithAssetsQueryVariables> {
    override document = GetAllInsuranceLinkWithAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddInsuranceDocument = gql`
    mutation AddInsurance($input: InsuranceInput!) {
  addInsurance(input: $input) {
    id
    active
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddInsuranceGQL extends Apollo.Mutation<AddInsuranceMutation, AddInsuranceMutationVariables> {
    override document = AddInsuranceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInsuranceDocument = gql`
    mutation UpdateInsurance($updateInsuranceId: ID, $input: InsuranceInput) {
  updateInsurance(id: $updateInsuranceId, input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInsuranceGQL extends Apollo.Mutation<UpdateInsuranceMutation, UpdateInsuranceMutationVariables> {
    override document = UpdateInsuranceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveInsuranceDocument = gql`
    mutation ArchiveInsurance($archive: Boolean!, $id: [ID!]) {
  archiveInsurance(archive: $archive, _id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveInsuranceGQL extends Apollo.Mutation<ArchiveInsuranceMutation, ArchiveInsuranceMutationVariables> {
    override document = ArchiveInsuranceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LinkInsuranceWithAssetDocument = gql`
    mutation LinkInsuranceWithAsset($assetId: ID!, $insuranceId: ID!, $insuranceName: String!) {
  linkInsuranceWithAsset(
    assetId: $assetId
    insuranceId: $insuranceId
    insuranceName: $insuranceName
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LinkInsuranceWithAssetGQL extends Apollo.Mutation<LinkInsuranceWithAssetMutation, LinkInsuranceWithAssetMutationVariables> {
    override document = LinkInsuranceWithAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DetectInsuranceFromAssetDocument = gql`
    mutation DetectInsuranceFromAsset($assetId: ID!, $insuranceId: ID!, $insuranceName: String!) {
  detectInsuranceFromAsset(
    assetId: $assetId
    insuranceId: $insuranceId
    insuranceName: $insuranceName
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DetectInsuranceFromAssetGQL extends Apollo.Mutation<DetectInsuranceFromAssetMutation, DetectInsuranceFromAssetMutationVariables> {
    override document = DetectInsuranceFromAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllInvoicesDocument = gql`
    query GetAllInvoices($input: invoicesInput) {
  getAllInvoices(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    data {
      invoice_image
      invoiceId
      name
      orderDate
      orderNumber
      id
      vendor {
        id
        name
      }
      shippingMethod {
        _id
        name
      }
      company
      billTo {
        location
        id
      }
      shipTo {
        location
        id
      }
      type
      taxes
      totalShippingCharges
      totalInvoiceItems
      grandTotal
      id
      is_deleted
      subTotal
      invoice_image_name
      invoiceItems {
        is_expense
        assetIds
      }
      detail {
        columns {
          ...ColumnDefinitionWithoutSummaryFields
        }
        result {
          product
          serial_number
          sku
          quantity
          price
          type
          total
        }
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}
${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllInvoicesGQL extends Apollo.Query<GetAllInvoicesQuery, GetAllInvoicesQueryVariables> {
    override document = GetAllInvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInvoiceByIdDocument = gql`
    query GetInvoiceById($id: ID) {
  getInvoiceById(id: $id) {
    id
    invoiceId
    name
    orderDate
    orderNumber
    company
    paymentMethod
    taxes
    totalShippingCharges
    courtesyCredit
    totalPaid
    toPayOff
    subTotal
    grandTotal
    invoiceImageUrl: invoice_image
    invoice_image_name
    vendor {
      id
      name
    }
    shippingMethod {
      _id
      name
    }
    shipTo {
      id
      location
    }
    billTo {
      id
      location
    }
    invoiceItems {
      id
      sku
      serial_number
      product
      quantity
      price
      total
      color
      type
      is_expense
      expenseId {
        id
      }
      expenseInvCategoryId {
        id
      }
      assetIds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvoiceByIdGQL extends Apollo.Query<GetInvoiceByIdQuery, GetInvoiceByIdQueryVariables> {
    override document = GetInvoiceByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateInvoiceIdDocument = gql`
    query GenerateInvoiceId {
  generateInvoiceId
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateInvoiceIdGQL extends Apollo.Query<GenerateInvoiceIdQuery, GenerateInvoiceIdQueryVariables> {
    override document = GenerateInvoiceIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVendorDocument = gql`
    query GetVendor($input: inputGetVendorWithSearch) {
  getVendor(input: $input) {
    _id
    name
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVendorGQL extends Apollo.Query<GetVendorQuery, GetVendorQueryVariables> {
    override document = GetVendorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetShippingMethodsDocument = gql`
    query GetShippingMethods($input: inputGetShippingWithSearch) {
  getShippingMethods(input: $input) {
    _id
    name
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetShippingMethodsGQL extends Apollo.Query<GetShippingMethodsQuery, GetShippingMethodsQueryVariables> {
    override document = GetShippingMethodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllShipToDocument = gql`
    query GetAllShipTo($search: String) {
  getAllShipTo(search: $search) {
    id
    location
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllShipToGQL extends Apollo.Query<GetAllShipToQuery, GetAllShipToQueryVariables> {
    override document = GetAllShipToDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInvoiceItemLinkedAssetsDocument = gql`
    query GetInvoiceItemLinkedAssets($id: ID) {
  getItemAsset(id: $id) {
    id
    assetId
    name
    type
    category {
      name
    }
    subCategory {
      name
    }
    AssetBrand {
      brand_name
    }
    AssetModel {
      model_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvoiceItemLinkedAssetsGQL extends Apollo.Query<GetInvoiceItemLinkedAssetsQuery, GetInvoiceItemLinkedAssetsQueryVariables> {
    override document = GetInvoiceItemLinkedAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($input: InvoiceInput!) {
  createInvoice(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInvoiceGQL extends Apollo.Mutation<CreateInvoiceMutation, CreateInvoiceMutationVariables> {
    override document = CreateInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($input: UpdateInvoiceInput!) {
  updateInvoice(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInvoiceGQL extends Apollo.Mutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables> {
    override document = UpdateInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveInvoiceDocument = gql`
    mutation ArchiveInvoice($input: archiveInvoiceInput) {
  archiveInvoice(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveInvoiceGQL extends Apollo.Mutation<ArchiveInvoiceMutation, ArchiveInvoiceMutationVariables> {
    override document = ArchiveInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddVendorDocument = gql`
    mutation AddVendor($input: inputBagVendor) {
  addVendor(input: $input) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddVendorGQL extends Apollo.Mutation<AddVendorMutation, AddVendorMutationVariables> {
    override document = AddVendorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddShippingMethodsDocument = gql`
    mutation AddShippingMethods($input: inputBagShipping) {
  addShippingMethods(input: $input) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddShippingMethodsGQL extends Apollo.Mutation<AddShippingMethodsMutation, AddShippingMethodsMutationVariables> {
    override document = AddShippingMethodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateShipToDocument = gql`
    mutation CreateShipTo($input: createShipTo!) {
  createShipTo(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateShipToGQL extends Apollo.Mutation<CreateShipToMutation, CreateShipToMutationVariables> {
    override document = CreateShipToDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMaintenanceByIdDocument = gql`
    query GetMaintenanceById($getMaintenanceByIdId: ID!) {
  getMaintenanceById(id: $getMaintenanceByIdId) {
    asset {
      assetId
      name
      id
    }
    cost
    id
    dateCompleted
    dueDate
    maintenanceBy
    status
    title
    recurring
    recurringBy
    isRecurring
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaintenanceByIdGQL extends Apollo.Query<GetMaintenanceByIdQuery, GetMaintenanceByIdQueryVariables> {
    override document = GetMaintenanceByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllMaintenanceWithSearchDocument = gql`
    query GetAllMaintenanceWithSearch($input: maintenanceListFilter) {
  getAllMaintenanceWithSearch(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      is_deleted
      id
      asset {
        site {
          _id
          store_name
        }
        assetId
        id
        name
      }
      cost
      dateCompleted
      dueDate
      maintenanceBy
      status
      title
      is_deleted
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllMaintenanceWithSearchGQL extends Apollo.Query<GetAllMaintenanceWithSearchQuery, GetAllMaintenanceWithSearchQueryVariables> {
    override document = GetAllMaintenanceWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetsForMaintenanceDocument = gql`
    query GetAssetsForMaintenance {
  getAllAssetsMaintenance {
    assetId
    name
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetsForMaintenanceGQL extends Apollo.Query<GetAssetsForMaintenanceQuery, GetAssetsForMaintenanceQueryVariables> {
    override document = GetAssetsForMaintenanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllMaintenanceLinkWithAssetsDocument = gql`
    query GetAllMaintenanceLinkWithAssets($assetId: ID!) {
  getAllMaintenanceLinkWithAssets(assetId: $assetId) {
    asset {
      id
      name
      assetId
      availStatus
      status
    }
    cost
    dateCompleted
    dueDate
    id
    maintenanceBy
    status
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllMaintenanceLinkWithAssetsGQL extends Apollo.Query<GetAllMaintenanceLinkWithAssetsQuery, GetAllMaintenanceLinkWithAssetsQueryVariables> {
    override document = GetAllMaintenanceLinkWithAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetForMaintenanceDocument = gql`
    query GetAssetForMaintenance($id: ID!) {
  getAssetsById(id: $id) {
    id
    name
    assetId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetForMaintenanceGQL extends Apollo.Query<GetAssetForMaintenanceQuery, GetAssetForMaintenanceQueryVariables> {
    override document = GetAssetForMaintenanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddMaintenanceDocument = gql`
    mutation AddMaintenance($input: MaintenanceInput) {
  addMaintenance(input: $input) {
    cost
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddMaintenanceGQL extends Apollo.Mutation<AddMaintenanceMutation, AddMaintenanceMutationVariables> {
    override document = AddMaintenanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMaintenanceDocument = gql`
    mutation UpdateMaintenance($input: UpdateMaintenanceInput!) {
  updateMaintenance(input: $input) {
    cost
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMaintenanceGQL extends Apollo.Mutation<UpdateMaintenanceMutation, UpdateMaintenanceMutationVariables> {
    override document = UpdateMaintenanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveMaintenanceDocument = gql`
    mutation ArchiveMaintenance($id: ID!, $archive: Boolean!) {
  archiveMaintenance(_id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveMaintenanceGQL extends Apollo.Mutation<ArchiveMaintenanceMutation, ArchiveMaintenanceMutationVariables> {
    override document = ArchiveMaintenanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllReportsWithSearchDocument = gql`
    query GetAllReportsWithSearch($input: assetListFilter) {
  getAllAssetsWithSearch(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      id
      assetId
      name
      assignedType
      type
      status
      availStatus
      cost
      is_deleted
      description
      serialNumber
      quantity
      location
      created_at
      category {
        id
        name
        is_deleted
      }
      subCategory {
        id
        name
        is_deleted
      }
      AssetBrand {
        _id
        brand_name
      }
      AssetModel {
        _id
        model_name
      }
      assigned {
        id
        full_name
        first_name
      }
      assignedSite {
        _id
        store_name
      }
      site {
        _id
        store_name
      }
      department {
        _id
        department_name
      }
      other_detail
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllReportsWithSearchGQL extends Apollo.Query<GetAllReportsWithSearchQuery, GetAllReportsWithSearchQueryVariables> {
    override document = GetAllReportsWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetsForReservationDocument = gql`
    query GetAssetsForReservation {
  getAllAssets {
    id
    assetId
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetsForReservationGQL extends Apollo.Query<GetAssetsForReservationQuery, GetAssetsForReservationQueryVariables> {
    override document = GetAssetsForReservationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllReserveWithSearchDocument = gql`
    query GetAllReserveWithSearch($input: reserveListFilter) {
  getAllReserveWithSearch(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      id
      is_deleted
      assetId
      other_detail
      reserveAsset {
        assignedType
        employee {
          id
          full_name
          profile_pictures {
            path
          }
          status
          account_status
        }
        site {
          _id
          store_name
        }
        department {
          _id
          department_name
        }
        reserveFrom
        reserveTo
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllReserveWithSearchGQL extends Apollo.Query<GetAllReserveWithSearchQuery, GetAllReserveWithSearchQueryVariables> {
    override document = GetAllReserveWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReservedAssetByIdDocument = gql`
    query GetReservedAssetById($id: ID!) {
  getAssetsById(id: $id) {
    id
    assetId
    name
    reserveAsset {
      assignedType
      other_detail
      reserveFrom
      reserveTo
      employee {
        id
        full_name
      }
      site {
        _id
        store_name
      }
      department {
        _id
        department_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReservedAssetByIdGQL extends Apollo.Query<GetReservedAssetByIdQuery, GetReservedAssetByIdQueryVariables> {
    override document = GetReservedAssetByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReserveAssetDocument = gql`
    mutation ReserveAsset($input: reserveAssetInput!) {
  reserveAsset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReserveAssetGQL extends Apollo.Mutation<ReserveAssetMutation, ReserveAssetMutationVariables> {
    override document = ReserveAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateReserveAssetDocument = gql`
    mutation UpdateReserveAsset($input: reserveUpdateAssetInput!) {
  updateReserveAsset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateReserveAssetGQL extends Apollo.Mutation<UpdateReserveAssetMutation, UpdateReserveAssetMutationVariables> {
    override document = UpdateReserveAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UndoReserveAssetDocument = gql`
    mutation UndoReserveAsset($assetId: ID!) {
  undoReserveAsset(assetId: $assetId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UndoReserveAssetGQL extends Apollo.Mutation<UndoReserveAssetMutation, UndoReserveAssetMutationVariables> {
    override document = UndoReserveAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllStationsDocument = gql`
    query GetAllStations($business_id: ID!) {
  getAllStations(business_id: $business_id) {
    _id
    station_name
    is_deleted
    Department {
      _id
      department_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllStationsGQL extends Apollo.Query<GetAllStationsQuery, GetAllStationsQueryVariables> {
    override document = GetAllStationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStationsByDepartmentDocument = gql`
    query GetStationsByDepartment($department: ID!) {
  getStationByDepartmentId(department: $department) {
    _id
    station_name
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStationsByDepartmentGQL extends Apollo.Query<GetStationsByDepartmentQuery, GetStationsByDepartmentQueryVariables> {
    override document = GetStationsByDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateStationDocument = gql`
    mutation CreateStation($input: stationInput!) {
  createStation(input: $input) {
    _id
    station_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStationGQL extends Apollo.Mutation<CreateStationMutation, CreateStationMutationVariables> {
    override document = CreateStationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStationDocument = gql`
    mutation UpdateStation($input: stationInput!, $id: ID!) {
  updateStation(input: $input, _id: $id) {
    _id
    station_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStationGQL extends Apollo.Mutation<UpdateStationMutation, UpdateStationMutationVariables> {
    override document = UpdateStationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStationDocument = gql`
    mutation DeleteStation($_id: ID!, $archive: Boolean!) {
  deleteStation(_id: $_id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStationGQL extends Apollo.Mutation<DeleteStationMutation, DeleteStationMutationVariables> {
    override document = DeleteStationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStationByIdDocument = gql`
    query GetStationById($id: ID!) {
  getStationtById(_id: $id) {
    _id
    station_name
    Department {
      _id
      department_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStationByIdGQL extends Apollo.Query<GetStationByIdQuery, GetStationByIdQueryVariables> {
    override document = GetStationByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeTwoFaDataDocument = gql`
    query GetEmployeeTwoFAData($input: TwoFAInput!) {
  getEmployeeTwoFAData(input: $input) {
    uri
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeTwoFaDataGQL extends Apollo.Query<GetEmployeeTwoFaDataQuery, GetEmployeeTwoFaDataQueryVariables> {
    override document = GetEmployeeTwoFaDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllMyAuthenticatorAppsDocument = gql`
    query GetAllMYAuthenticatorApps($input: getAuthenticatorAppDataTableInput) {
  getAllMYAuthenticatorApps(input: $input) {
    config {
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      table_preset {
        ...TablePresetFields
      }
    }
    results {
      _id
      app_name
      description
      app_url
      type
      app_type
      is_deleted
      created_at
      app_info {
        secret
        qr_url
        label
      }
      is_totp
      password_manager {
        user_name
        password {
          encryptedAESKey
          encryptedPassword
          iv
        }
        email
      }
      share_with {
        _id
        app_name
        share_type
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllMyAuthenticatorAppsGQL extends Apollo.Query<GetAllMyAuthenticatorAppsQuery, GetAllMyAuthenticatorAppsQueryVariables> {
    override document = GetAllMyAuthenticatorAppsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllShareWithMeAppsDocument = gql`
    query GetAllShareWithMeApps($input: getAuthenticatorAppInput) {
  getAllShareWithMeApps(input: $input) {
    config {
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      table_preset {
        ...TablePresetFields
      }
    }
    results {
      _id
      app_name
      description
      app_url
      type
      is_deleted
      created_at
      app_info {
        secret
        qr_url
        label
      }
      password_manager {
        user_name
        password {
          encryptedAESKey
          encryptedPassword
          iv
        }
        email
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllShareWithMeAppsGQL extends Apollo.Query<GetAllShareWithMeAppsQuery, GetAllShareWithMeAppsQueryVariables> {
    override document = GetAllShareWithMeAppsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAuthenticatorAppByIdDocument = gql`
    query GetAuthenticatorAppById($id: ID!) {
  getAuthenticatorAppById(Id: $id) {
    app_url
    app_name
    created_at
    _id
    share_with {
      _id
      app_url
      app_name
      employee {
        full_name
        employee_id
        id
        roles {
          _id
          roleName
        }
      }
      password_manager {
        user_name
        password {
          encryptedAESKey
          encryptedPassword
          iv
        }
        email
      }
      share_type
      shared_by {
        full_name
        id
        employee_id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAuthenticatorAppByIdGQL extends Apollo.Query<GetAuthenticatorAppByIdQuery, GetAuthenticatorAppByIdQueryVariables> {
    override document = GetAuthenticatorAppByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllShareOfAppDocument = gql`
    query GetAllShareOfApp($getAllShareOfAppId: ID!) {
  getAllShareOfApp(id: $getAllShareOfAppId) {
    app_name
    app_url
    _id
    employee {
      id
      employee_id
      full_name
      email
      roles {
        _id
        roleName
      }
    }
    share_type
    is_scheduled
    created_at
    share_permissions {
      can_share_password
      can_share_otp
      can_edit
    }
    share_as
    scheduled_for
    shared_by {
      id
      full_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllShareOfAppGQL extends Apollo.Query<GetAllShareOfAppQuery, GetAllShareOfAppQueryVariables> {
    override document = GetAllShareOfAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSharedAuthenticatorAppByIdDocument = gql`
    query GetSharedAuthenticatorAppById($id: ID!) {
  getSharedAuthenticatorAppById(Id: $id) {
    AuthenticatorApp {
      _id
    }
    shared_by {
      full_name
      id
    }
    share_type
    share_as
    scheduled_for
    share_permissions {
      can_share_password
      can_share_otp
      can_edit
    }
    is_scheduled
    app_name
    description
    app_url
    app_info {
      secret
      qr_url
      label
    }
    _id
    employee {
      id
      employee_id
      full_name
      email
    }
    share_with {
      _id
      app_name
      share_type
    }
    created_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSharedAuthenticatorAppByIdGQL extends Apollo.Query<GetSharedAuthenticatorAppByIdQuery, GetSharedAuthenticatorAppByIdQueryVariables> {
    override document = GetSharedAuthenticatorAppByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetQrLogsDocument = gql`
    query GetQRLogs($input: QRLogsInput!) {
  getQRLogs(input: $input) {
    limit
    page
    totalPages
    totalResults
    results {
      employee {
        id
        full_name
      }
      scanned_by {
        full_name
        id
      }
      created_at
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQrLogsGQL extends Apollo.Query<GetQrLogsQuery, GetQrLogsQueryVariables> {
    override document = GetQrLogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeEncryptionKeysDocument = gql`
    query GetEmployeeEncryptionKeys($employeeId: ID) {
  getEmployeeEncryptionKeys(employeeId: $employeeId) {
    salt
    publicKey
    iv
    encryptedPrivateKey
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeEncryptionKeysGQL extends Apollo.Query<GetEmployeeEncryptionKeysQuery, GetEmployeeEncryptionKeysQueryVariables> {
    override document = GetEmployeeEncryptionKeysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPasswordManagerAdminsDocument = gql`
    query GetPasswordManagerAdmins($userId: ID) {
  getPasswordManagerAdmins(userId: $userId) {
    is_encryption_copy_exist
    user {
      id
      full_name
      users_password_manager {
        encryptedPrivateKey
        iv
        publicKey
        salt
      }
    }
    encryptionCopy {
      encryption {
        encrypted_private_key
        iv
        salt
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPasswordManagerAdminsGQL extends Apollo.Query<GetPasswordManagerAdminsQuery, GetPasswordManagerAdminsQueryVariables> {
    override document = GetPasswordManagerAdminsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEncryptionCopyByUserIdDocument = gql`
    query GetEncryptionCopyByUserId($input: getEncryptionCopyInput!) {
  getEncryptionCopyByUserId(input: $input) {
    _id
    is_owner
    from_user {
      users_password_manager {
        encryptedPrivateKey
        iv
        publicKey
        salt
      }
    }
    encryption {
      encrypted_private_key
      iv
      salt
    }
    user {
      users_password_manager {
        publicKey
        iv
        salt
        encryptedPrivateKey
      }
      _id
      full_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEncryptionCopyByUserIdGQL extends Apollo.Query<GetEncryptionCopyByUserIdQuery, GetEncryptionCopyByUserIdQueryVariables> {
    override document = GetEncryptionCopyByUserIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllUsersForSharedRecordsDocument = gql`
    query GetAllUsersForSharedRecords($appId: ID) {
  getAllUsersForSharedRecords(appId: $appId) {
    id
    full_name
    users_password_manager {
      encryptedPrivateKey
      iv
      publicKey
      salt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllUsersForSharedRecordsGQL extends Apollo.Query<GetAllUsersForSharedRecordsQuery, GetAllUsersForSharedRecordsQueryVariables> {
    override document = GetAllUsersForSharedRecordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllGroupListDocument = gql`
    query GetAllGroupList($input: getGroupsInput) {
  getAllGroupList(input: $input) {
    app_name
    _id
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllGroupListGQL extends Apollo.Query<GetAllGroupListQuery, GetAllGroupListQueryVariables> {
    override document = GetAllGroupListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAuthenticatorAppsDocument = gql`
    query SearchAuthenticatorApps($input: SearchAuthenticatorInput) {
  searchAuthenticatorApps(input: $input) {
    results {
      app_name
      _id
      app_url
      email
      hierarchy {
        app_name
        type
        _id
      }
      path
      type
      username
    }
    currentRecords
    viewMore
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAuthenticatorAppsGQL extends Apollo.Query<SearchAuthenticatorAppsQuery, SearchAuthenticatorAppsQueryVariables> {
    override document = SearchAuthenticatorAppsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAuthenticatorPasswordManagerAdminDocument = gql`
    query GetAuthenticatorPasswordManagerAdmin {
  getPasswordManagerAdmin {
    full_name
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAuthenticatorPasswordManagerAdminGQL extends Apollo.Query<GetAuthenticatorPasswordManagerAdminQuery, GetAuthenticatorPasswordManagerAdminQueryVariables> {
    override document = GetAuthenticatorPasswordManagerAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAuthenticatorAllGuarantorDocument = gql`
    query GetAuthenticatorAllGuarantor {
  getAllGuarantor {
    id
    full_name
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAuthenticatorAllGuarantorGQL extends Apollo.Query<GetAuthenticatorAllGuarantorQuery, GetAuthenticatorAllGuarantorQueryVariables> {
    override document = GetAuthenticatorAllGuarantorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAuthenticatorUsersWithPasswordPermissionDocument = gql`
    query GetAuthenticatorUsersWithPasswordPermission($business_id: ID!) {
  getUsersWithPasswordPermission(business_id: $business_id) {
    id
    full_name
    email
    users_password_manager {
      encryptedPrivateKey
      iv
      publicKey
      salt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAuthenticatorUsersWithPasswordPermissionGQL extends Apollo.Query<GetAuthenticatorUsersWithPasswordPermissionQuery, GetAuthenticatorUsersWithPasswordPermissionQueryVariables> {
    override document = GetAuthenticatorUsersWithPasswordPermissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShareAuthenticatorAppDocument = gql`
    mutation ShareAuthenticatorApp($input: shareAppInput) {
  shareAuthenticatorApp(input: $input) {
    _id
    app_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShareAuthenticatorAppGQL extends Apollo.Mutation<ShareAuthenticatorAppMutation, ShareAuthenticatorAppMutationVariables> {
    override document = ShareAuthenticatorAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAuthenticatorAppDocument = gql`
    mutation UpdateAuthenticatorApp($input: updateAppInput) {
  updateAuthenticatorApp(input: $input) {
    app_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAuthenticatorAppGQL extends Apollo.Mutation<UpdateAuthenticatorAppMutation, UpdateAuthenticatorAppMutationVariables> {
    override document = UpdateAuthenticatorAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAuthenticatorAppWithoutOtpDocument = gql`
    mutation CreateAuthenticatorAppWithoutOTP($input: createAppInputWithoutOTP) {
  createAuthenticatorAppWithoutOTP(input: $input) {
    app_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAuthenticatorAppWithoutOtpGQL extends Apollo.Mutation<CreateAuthenticatorAppWithoutOtpMutation, CreateAuthenticatorAppWithoutOtpMutationVariables> {
    override document = CreateAuthenticatorAppWithoutOtpDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveShareOfAuthenticatorAppDocument = gql`
    mutation RemoveShareOfAuthenticatorApp($input: removeShareInput) {
  removeShareOfAuthenticatorApp(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveShareOfAuthenticatorAppGQL extends Apollo.Mutation<RemoveShareOfAuthenticatorAppMutation, RemoveShareOfAuthenticatorAppMutationVariables> {
    override document = RemoveShareOfAuthenticatorAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateShareOfAuthenticatorAppDocument = gql`
    mutation UpdateShareOfAuthenticatorApp($input: UpdateShareAppInput) {
  updateShareOfAuthenticatorApp(input: $input) {
    app_name
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateShareOfAuthenticatorAppGQL extends Apollo.Mutation<UpdateShareOfAuthenticatorAppMutation, UpdateShareOfAuthenticatorAppMutationVariables> {
    override document = UpdateShareOfAuthenticatorAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditAuthenticatorGroupDocument = gql`
    mutation EditAuthenticatorGroup($input: EditAuthenticatorGroupInput!) {
  editAuthenticatorGroup(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditAuthenticatorGroupGQL extends Apollo.Mutation<EditAuthenticatorGroupMutation, EditAuthenticatorGroupMutationVariables> {
    override document = EditAuthenticatorGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAuthenticatorGroupDocument = gql`
    mutation CreateAuthenticatorGroup($input: createAuthenticatorGroupInput) {
  createAuthenticatorGroup(input: $input) {
    breadcrumbs {
      _id
      app_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAuthenticatorGroupGQL extends Apollo.Mutation<CreateAuthenticatorGroupMutation, CreateAuthenticatorGroupMutationVariables> {
    override document = CreateAuthenticatorGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAuthenticatorAppDocument = gql`
    mutation DeleteAuthenticatorApp($ids: [ID!], $groupType: group_type, $deleteChildren: Boolean, $is_deleted: Boolean) {
  deleteAuthenticatorApp(
    Ids: $ids
    group_type: $groupType
    deleteChildren: $deleteChildren
    is_deleted: $is_deleted
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAuthenticatorAppGQL extends Apollo.Mutation<DeleteAuthenticatorAppMutation, DeleteAuthenticatorAppMutationVariables> {
    override document = DeleteAuthenticatorAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopyAuthenticatorAppDocument = gql`
    mutation CopyAuthenticatorApp($input: copyAuthenticatorAppInput) {
  copyAuthenticatorApp(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopyAuthenticatorAppGQL extends Apollo.Mutation<CopyAuthenticatorAppMutation, CopyAuthenticatorAppMutationVariables> {
    override document = CopyAuthenticatorAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShareBulkAuthenticatorAppsDocument = gql`
    mutation ShareBulkAuthenticatorApps($input: shareBulkAppInput) {
  shareBulkAuthenticatorApps(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShareBulkAuthenticatorAppsGQL extends Apollo.Mutation<ShareBulkAuthenticatorAppsMutation, ShareBulkAuthenticatorAppsMutationVariables> {
    override document = ShareBulkAuthenticatorAppsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUsersEncryptionKeysDocument = gql`
    mutation UpdateUsersEncryptionKeys($input: userEncryptionKeyInput) {
  updateUsersEncryptionKeys(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUsersEncryptionKeysGQL extends Apollo.Mutation<UpdateUsersEncryptionKeysMutation, UpdateUsersEncryptionKeysMutationVariables> {
    override document = UpdateUsersEncryptionKeysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEncryptionCopiesDocument = gql`
    mutation CreateEncryptionCopies($input: UserEncryptionCopiesInput) {
  createEncryptionCopies(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEncryptionCopiesGQL extends Apollo.Mutation<CreateEncryptionCopiesMutation, CreateEncryptionCopiesMutationVariables> {
    override document = CreateEncryptionCopiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAppPasswordAndSharesDocument = gql`
    mutation UpdateAppPasswordAndShares($input: UpdatePasswordInput) {
  updateAppPasswordAndShares(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAppPasswordAndSharesGQL extends Apollo.Mutation<UpdateAppPasswordAndSharesMutation, UpdateAppPasswordAndSharesMutationVariables> {
    override document = UpdateAppPasswordAndSharesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendForgotPasswordEmailDocument = gql`
    mutation SendForgotPasswordEmail($email: String!) {
  sendForgotPasswordEmail(email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendForgotPasswordEmailGQL extends Apollo.Mutation<SendForgotPasswordEmailMutation, SendForgotPasswordEmailMutationVariables> {
    override document = SendForgotPasswordEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserPasswordDocument = gql`
    mutation UpdateUserPassword($input: updateUserPasswordInput) {
  updateUserPassword(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserPasswordGQL extends Apollo.Mutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables> {
    override document = UpdateUserPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddPasswordManagerAdminDocument = gql`
    mutation AddPasswordManagerAdmin($employee: ID!) {
  addPasswordManagerAdmin(employee: $employee)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddPasswordManagerAdminGQL extends Apollo.Mutation<AddPasswordManagerAdminMutation, AddPasswordManagerAdminMutationVariables> {
    override document = AddPasswordManagerAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddGuarantorForPasswordDocument = gql`
    mutation AddGuarantorForPassword($employees: [ID!]!) {
  addGuarantorForPassword(employees: $employees)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddGuarantorForPasswordGQL extends Apollo.Mutation<AddGuarantorForPasswordMutation, AddGuarantorForPasswordMutationVariables> {
    override document = AddGuarantorForPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeBusinessOwnerPasswordDocument = gql`
    mutation ChangeBusinessOwnerPassword($input: updateBusinessOwnerPasswordInput) {
  changeBusinessOwnerPassword(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeBusinessOwnerPasswordGQL extends Apollo.Mutation<ChangeBusinessOwnerPasswordMutation, ChangeBusinessOwnerPasswordMutationVariables> {
    override document = ChangeBusinessOwnerPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveGuarantorsDocument = gql`
    mutation RemoveGuarantors($ids: [ID]!) {
  removeGuarantors(ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveGuarantorsGQL extends Apollo.Mutation<RemoveGuarantorsMutation, RemoveGuarantorsMutationVariables> {
    override document = RemoveGuarantorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginWithEmailDocument = gql`
    mutation LoginWithEmail($email: String!, $password: String!, $deviceToken: String) {
  loginWithEmail(email: $email, password: $password, device_token: $deviceToken) {
    tokens {
      access {
        token
        expires
      }
      refresh {
        token
        expires
      }
    }
    user {
      is_navigated_user
      date_format
      currency_format
      currency_name
      currency_symbol
      do_not_disturb
      two_fa_secret
      is_un_restricted
      last_working_date
      is_sample_data
      department {
        _id
        department_name
      }
      isOwner
      id
      profile_pictures {
        dimension
        path
      }
      business_id {
        zip_code
        is_24_hour_format
        Country {
          name
          _id
        }
        state {
          _id
          state_name
        }
        city {
          _id
          city_name
        }
        _id
        logo
        business_legal_name
        business_type
        time_zone
        business_package {
          hr_module_only
        }
      }
      business_status
      business_type
      first_name
      last_name
      email
      phone
      logo
      avatar_location
      user_is_super_admin
      is_popup_closed
      business_is_super_admin
    }
    rocketChat {
      userId
      authToken
      refreshToken
    }
    businesses {
      pictures {
        dimension
        path
      }
      business_type
      _id
      business_email
      business_legal_name
      address
      logo
      number_of_stores
      date_format
      time_zone
      Country {
        _id
        name
        short_name
      }
      status
      city {
        _id
        city_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginWithEmailGQL extends Apollo.Mutation<LoginWithEmailMutation, LoginWithEmailMutationVariables> {
    override document = LoginWithEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LogoutDocument = gql`
    mutation Logout($refreshToken: String!) {
  logout(refreshToken: $refreshToken)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LogoutGQL extends Apollo.Mutation<LogoutMutation, LogoutMutationVariables> {
    override document = LogoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    tokens {
      access {
        token
      }
      refresh {
        token
        expires
      }
    }
    user {
      id
      first_name
      last_name
      email
      avatar_location
      business_id {
        _id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshTokenGQL extends Apollo.Mutation<RefreshTokenMutation, RefreshTokenMutationVariables> {
    override document = RefreshTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserForgetPasswordDocument = gql`
    mutation UserForgetPassword($email: String!, $method: AllowMethodPhoneVerify) {
  userForgetPassword(email: $email, method: $method)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserForgetPasswordGQL extends Apollo.Mutation<UserForgetPasswordMutation, UserForgetPasswordMutationVariables> {
    override document = UserForgetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPasswordResetDocument = gql`
    mutation UserPasswordReset($input: PasswordResetInput) {
  userPasswordReset(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPasswordResetGQL extends Apollo.Mutation<UserPasswordResetMutation, UserPasswordResetMutationVariables> {
    override document = UserPasswordResetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserSystemTokenDocument = gql`
    mutation UpdateUserSystemToken($id: ID!, $systemToken: String!) {
  updateUserSystemToken(_id: $id, system_token: $systemToken) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserSystemTokenGQL extends Apollo.Mutation<UpdateUserSystemTokenMutation, UpdateUserSystemTokenMutationVariables> {
    override document = UpdateUserSystemTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserEmailStatusDocument = gql`
    mutation UpdateUserEmailStatus($input: emailVerifyOtpInput) {
  updateUserEmailStatus(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserEmailStatusGQL extends Apollo.Mutation<UpdateUserEmailStatusMutation, UpdateUserEmailStatusMutationVariables> {
    override document = UpdateUserEmailStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserPhoneStatusDocument = gql`
    mutation UpdateUserPhoneStatus($phone: String!, $otpCode: String!, $employeeId: ID!) {
  updateUserPhoneStatus(
    phone: $phone
    otp_code: $otpCode
    employeeId: $employeeId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserPhoneStatusGQL extends Apollo.Mutation<UpdateUserPhoneStatusMutation, UpdateUserPhoneStatusMutationVariables> {
    override document = UpdateUserPhoneStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersPermissionsChangedNotifyDocument = gql`
    subscription UsersPermissionsChangedNotify($userId: ID!) {
  usersPermissionsChangedNotify(userId: $userId) {
    is_role_changed
    is_password_changed
    is_navigated_business_change
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersPermissionsChangedNotifyGQL extends Apollo.Subscription<UsersPermissionsChangedNotifySubscription, UsersPermissionsChangedNotifySubscriptionVariables> {
    override document = UsersPermissionsChangedNotifyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BusinessTimeZoneChangeDocument = gql`
    subscription BusinessTimeZoneChange($businessId: ID!) {
  businessTimeZoneChange(businessId: $businessId) {
    is_country_change
    is_time_format_change
    is_time_zone_change
    is_date_format_change
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BusinessTimeZoneChangeGQL extends Apollo.Subscription<BusinessTimeZoneChangeSubscription, BusinessTimeZoneChangeSubscriptionVariables> {
    override document = BusinessTimeZoneChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserInactiveNotificationDocument = gql`
    subscription UserInactiveNotification($userId: ID!) {
  userInactiveNotification(userId: $userId) {
    account_status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserInactiveNotificationGQL extends Apollo.Subscription<UserInactiveNotificationSubscription, UserInactiveNotificationSubscriptionVariables> {
    override document = UserInactiveNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessByIdDocument = gql`
    query GetBusinessByID($id: ID!) {
  getBusinessByID(_id: $id) {
    _id
    business_keeping_unit
    business_system_name
    number_of_stores
    business_legal_name
    business_identification_type
    business_identification_number
    business_type
    package
    date_format
    currency_format
    currency_name
    currency_symbol
    is_24_hour_format
    time_zone
    address
    zip_code
    logo
    status
    created_at
    city {
      _id
      city_name
    }
    state {
      _id
      state_name
    }
    Country {
      _id
      name
      short_name
      is_active
      identification_types
    }
    owner_id {
      id
      email
      first_name
      last_name
      phone
      phone_country_code
      landline
      isOwner
      is_email_verify
      is_phone_verify
      auth_pin
    }
    business_package {
      _id
      package_name
      package_price
      recurring
      subscribe_at
      expires_at
      hr_module_only
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessByIdGQL extends Apollo.Query<GetBusinessByIdQuery, GetBusinessByIdQueryVariables> {
    override document = GetBusinessByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessesWithFilterDocument = gql`
    query GetBusinessesWithFilter($input: businessListFilter) {
  getBusinessesWithFilter(input: $input) {
    config {
      actions
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
      columns {
        _id
        field
        header
        type
        is_search_able
        is_visible
        is_sortable
        search
        filterValue
        column_data
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
        column_dropdown_value {
          _id
          value
        }
      }
      filters {
        search
        field
        type
        _ids
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
      }
    }
    results {
      _id
      business_legal_name
      business_keeping_unit
      number_of_stores
      status
      is_deleted
      business_email
      address
      currency_format
      currency_name
      currency_symbol
      owner_id {
        id
        email
        first_name
        last_name
        phone
      }
      city {
        _id
        city_name
      }
      Country {
        _id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessesWithFilterGQL extends Apollo.Query<GetBusinessesWithFilterQuery, GetBusinessesWithFilterQueryVariables> {
    override document = GetBusinessesWithFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTotalBusinessLocationsDocument = gql`
    query GetTotalBusinessLocations($businessId: ID) {
  getTotalBusinessLocations(business_id: $businessId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTotalBusinessLocationsGQL extends Apollo.Query<GetTotalBusinessLocationsQuery, GetTotalBusinessLocationsQueryVariables> {
    override document = GetTotalBusinessLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTotalCustomersDocument = gql`
    query GetTotalCustomers($input: businessStoreInput) {
  getTotalCustomers(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTotalCustomersGQL extends Apollo.Query<GetTotalCustomersQuery, GetTotalCustomersQueryVariables> {
    override document = GetTotalCustomersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTotalEmployeesDocument = gql`
    query GetTotalEmployees($input: businessStoreInput) {
  getTotalEmployees(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTotalEmployeesGQL extends Apollo.Query<GetTotalEmployeesQuery, GetTotalEmployeesQueryVariables> {
    override document = GetTotalEmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomersByBusinessIdDocument = gql`
    query CustomersByBusinessId($business: ID!) {
  customersByBusinessId(business_id: $business) {
    _id
    first_name
    last_name
    phone
    email
    full_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomersByBusinessIdGQL extends Apollo.Query<CustomersByBusinessIdQuery, CustomersByBusinessIdQueryVariables> {
    override document = CustomersByBusinessIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersWithPasswordPermissionDocument = gql`
    query GetUsersWithPasswordPermission($businessId: ID!) {
  getUsersWithPasswordPermission(business_id: $businessId) {
    id
    email
    employee_id
    first_name
    last_name
    middle_name
    full_name
    phone
    phone_country_code
    isOwner
    status
    logo
    avatar_location
    profile_pictures {
      dimension
      path
    }
    department {
      _id
      department_name
    }
    designation {
      _id
      designation_name
    }
    users_password_manager {
      publicKey
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersWithPasswordPermissionGQL extends Apollo.Query<GetUsersWithPasswordPermissionQuery, GetUsersWithPasswordPermissionQueryVariables> {
    override document = GetUsersWithPasswordPermissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLinkedBusinessesDocument = gql`
    query GetLinkedBusinesses($input: getLinkedBusinessInput) {
  getLinkedBusinesses(input: $input) {
    _id
    status
    created_at
    updated_at
    is_deleted
    requested_by {
      _id
      logo
      business_legal_name
      business_system_name
    }
    requested_to {
      _id
      logo
      business_legal_name
      business_system_name
    }
    requested_by_user {
      _id
      full_name
    }
    requested_to_user: accepted_by_user {
      _id
      full_name
    }
    navigation_users {
      employee {
        _id
        full_name
        employee_id
      }
      role {
        _id
        roleName
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLinkedBusinessesGQL extends Apollo.Query<GetLinkedBusinessesQuery, GetLinkedBusinessesQueryVariables> {
    override document = GetLinkedBusinessesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLinkedBusinessesByIdDocument = gql`
    query GetLinkedBusinessesById($businessNavigationId: ID!) {
  getLinkedBusinessesById(business_navigation_id: $businessNavigationId) {
    _id
    status
    requested_by {
      business_legal_name
    }
    requested_to {
      business_legal_name
    }
    navigation_users {
      employee {
        id
        full_name
        employee_id
      }
      role {
        _id
        roleName
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLinkedBusinessesByIdGQL extends Apollo.Query<GetLinkedBusinessesByIdQuery, GetLinkedBusinessesByIdQueryVariables> {
    override document = GetLinkedBusinessesByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllNavigationBusinessListDocument = gql`
    query GetAllNavigationBusinessList {
  getAllNavigationBusinessList {
    _id
    business_legal_name
    business_email
    logo
    Country {
      name
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllNavigationBusinessListGQL extends Apollo.Query<GetAllNavigationBusinessListQuery, GetAllNavigationBusinessListQueryVariables> {
    override document = GetAllNavigationBusinessListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllActiveBusinessDocument = gql`
    query GetAllActiveBusiness {
  getAllActiveBusiness {
    _id
    business_legal_name
    business_system_name
    logo
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllActiveBusinessGQL extends Apollo.Query<GetAllActiveBusinessQuery, GetAllActiveBusinessQueryVariables> {
    override document = GetAllActiveBusinessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBusinessDocument = gql`
    mutation UpdateBusiness($updateBusinessId: ID!, $input: updateBusinessInput) {
  updateBusiness(id: $updateBusinessId, input: $input) {
    _id
    business_legal_name
    logo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBusinessGQL extends Apollo.Mutation<UpdateBusinessMutation, UpdateBusinessMutationVariables> {
    override document = UpdateBusinessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveBusinessDocument = gql`
    mutation ArchiveBusiness($ids: [ID]!, $archive: Boolean!) {
  archiveBusiness(ids: $ids, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveBusinessGQL extends Apollo.Mutation<ArchiveBusinessMutation, ArchiveBusinessMutationVariables> {
    override document = ArchiveBusinessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LinkBusinessesDocument = gql`
    mutation LinkBusinesses($input: linkBusinessesInput) {
  linkBusinesses(input: $input) {
    status
    requested_by {
      business_legal_name
    }
    requested_to {
      business_legal_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LinkBusinessesGQL extends Apollo.Mutation<LinkBusinessesMutation, LinkBusinessesMutationVariables> {
    override document = LinkBusinessesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnlinkBusinessDocument = gql`
    mutation UnlinkBusiness($input: unlinkBusinessInput) {
  unlinkBusiness(input: $input) {
    _id
    deleted_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnlinkBusinessGQL extends Apollo.Mutation<UnlinkBusinessMutation, UnlinkBusinessMutationVariables> {
    override document = UnlinkBusinessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptRejectBusinessRequestDocument = gql`
    mutation AcceptRejectBusinessRequest($input: changeRequestStatusInput) {
  acceptRejectBusinessRequest(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptRejectBusinessRequestGQL extends Apollo.Mutation<AcceptRejectBusinessRequestMutation, AcceptRejectBusinessRequestMutationVariables> {
    override document = AcceptRejectBusinessRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddEmployeeIntoBusinessesDocument = gql`
    mutation AddEmployeeIntoBusinesses($input: addEmployeeIntoBusinessInput) {
  addEmployeeIntoBusinesses(input: $input) {
    _id
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddEmployeeIntoBusinessesGQL extends Apollo.Mutation<AddEmployeeIntoBusinessesMutation, AddEmployeeIntoBusinessesMutationVariables> {
    override document = AddEmployeeIntoBusinessesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditBusinessEmployeeDocument = gql`
    mutation EditBusinessEmployee($input: editBusinessEmployeeInput) {
  editBusinessEmployee(input: $input) {
    _id
    created_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditBusinessEmployeeGQL extends Apollo.Mutation<EditBusinessEmployeeMutation, EditBusinessEmployeeMutationVariables> {
    override document = EditBusinessEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEmployeeFromBusinessDocument = gql`
    mutation RemoveEmployeeFromBusiness($input: removeBusinessEmployeeInput) {
  removeEmployeeFromBusiness(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEmployeeFromBusinessGQL extends Apollo.Mutation<RemoveEmployeeFromBusinessMutation, RemoveEmployeeFromBusinessMutationVariables> {
    override document = RemoveEmployeeFromBusinessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllGuarantorDocument = gql`
    query GetAllGuarantor {
  getAllGuarantor {
    _id
    id
    employee_id
    full_name
    logo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllGuarantorGQL extends Apollo.Query<GetAllGuarantorQuery, GetAllGuarantorQueryVariables> {
    override document = GetAllGuarantorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPasswordManagerAdminDocument = gql`
    query GetPasswordManagerAdmin {
  getPasswordManagerAdmin {
    id
    full_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPasswordManagerAdminGQL extends Apollo.Query<GetPasswordManagerAdminQuery, GetPasswordManagerAdminQueryVariables> {
    override document = GetPasswordManagerAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLoggedInUserDetailDocument = gql`
    mutation GetLoggedInUserDetail {
  getLoggedInUserDetail {
    user {
      is_navigated_user
      two_fa_secret
      last_working_date
      is_sample_data
      isOwner
      id
      profile_pictures {
        dimension
        path
      }
      business_id {
        zip_code
        is_24_hour_format
        date_format
        time_zone
        currency_format
        currency_name
        Country {
          name
          _id
        }
        state {
          _id
          state_name
        }
        city {
          _id
          city_name
        }
        _id
        logo
        business_legal_name
        business_type
        time_zone
        business_package {
          hr_module_only
        }
      }
      first_name
      last_name
      email
      phone
      logo
      avatar_location
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLoggedInUserDetailGQL extends Apollo.Mutation<GetLoggedInUserDetailMutation, GetLoggedInUserDetailMutationVariables> {
    override document = GetLoggedInUserDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VerifyBusinessSystemNameDocument = gql`
    query VerifyBusinessSystemName($business_system_name: String) {
  verifyBusinessSystemName(business_system_name: $business_system_name)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VerifyBusinessSystemNameGQL extends Apollo.Query<VerifyBusinessSystemNameQuery, VerifyBusinessSystemNameQueryVariables> {
    override document = VerifyBusinessSystemNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessByIdentificationNumberDocument = gql`
    query GetBusinessByIdentificationNumber($identificationNumber: String) {
  getBusinessByIdentificationNumber(identificationNumber: $identificationNumber) {
    _id
    business_keeping_unit
    business_system_name
    business_legal_name
    business_identification_type
    business_identification_number
    business_type
    address
    zip_code
    logo
    status
    owner_id {
      id
      email
      first_name
      last_name
      phone
      phone_country_code
      is_email_verify
      is_phone_verify
    }
    Country {
      _id
      name
      short_name
      identification_types
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessByIdentificationNumberGQL extends Apollo.Query<GetBusinessByIdentificationNumberQuery, GetBusinessByIdentificationNumberQueryVariables> {
    override document = GetBusinessByIdentificationNumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessPackagesDocument = gql`
    query GetBusinessPackages($business: ID!, $packageType: PackageType) {
  getBusinessPackages(business: $business, package_type: $packageType) {
    _id
    package_name
    package_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessPackagesGQL extends Apollo.Query<GetBusinessPackagesQuery, GetBusinessPackagesQueryVariables> {
    override document = GetBusinessPackagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBusinessDocument = gql`
    mutation CreateBusiness($input: createBusinessInput) {
  createBusiness(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBusinessGQL extends Apollo.Mutation<CreateBusinessMutation, CreateBusinessMutationVariables> {
    override document = CreateBusinessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterBusinessDocument = gql`
    mutation RegisterBusiness($input: businessRegistration) {
  registerBusiness(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterBusinessGQL extends Apollo.Mutation<RegisterBusinessMutation, RegisterBusinessMutationVariables> {
    override document = RegisterBusinessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSampleDataDocument = gql`
    query GetSampleData {
  getSampleData {
    _id
    is_selected
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSampleDataGQL extends Apollo.Query<GetSampleDataQuery, GetSampleDataQueryVariables> {
    override document = GetSampleDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSampleDataDocument = gql`
    mutation UpdateSampleData($input: [updateSampleDataInput!]!, $id: ID) {
  updateSampleData(input: $input, _id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSampleDataGQL extends Apollo.Mutation<UpdateSampleDataMutation, UpdateSampleDataMutationVariables> {
    override document = UpdateSampleDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessedByTypeCommissionDocument = gql`
    query GetBusinessedByTypeCommission($type: AllowBusinessType) {
  getBusinessedByType(type: $type) {
    _id
    business_system_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessedByTypeCommissionGQL extends Apollo.Query<GetBusinessedByTypeCommissionQuery, GetBusinessedByTypeCommissionQueryVariables> {
    override document = GetBusinessedByTypeCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessLocationsByBusinessIdCommissionDocument = gql`
    query GetBusinessLocationsByBusinessIdCommission($business_id: ID!) {
  getBusinessLocationsByBusinessId(business_id: $business_id) {
    _id
    store_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessLocationsByBusinessIdCommissionGQL extends Apollo.Query<GetBusinessLocationsByBusinessIdCommissionQuery, GetBusinessLocationsByBusinessIdCommissionQueryVariables> {
    override document = GetBusinessLocationsByBusinessIdCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCommisionCampaignswithCommissionsDocument = gql`
    query GetCommisionCampaignswithCommissions($input: commissioinCampaignSearchInput) {
  getCommisionCampaignswithCommissions(input: $input) {
    config {
      totalResults
      totalPages
      actions
      columns {
        field
        header
        is_visible
        is_search_able
        is_sortable
        is_amount
        type
        column_data
      }
      type
    }
    data {
      _id
      name
      start_date
      end_date
      is_active
      is_deleted
      statistics
      stores
      summary
      created_at
      Business {
        _id
        business_system_name
      }
      BusinessLocation {
        _id
        store_name
      }
      Commission {
        _id
        commission_name
        commission_amount
        commission_type
        commission_duration
        is_commission_type_percentage
        is_active
        status
        reach
        statistics
        till_date
        schedule_from
        schedule_to
      }
      detail {
        actions
        columns {
          field
          header
          is_visible
          is_search_able
          is_sortable
          is_amount
          type
        }
        result {
          _id
          commission_name
          commission_amount
          commission_type
          commission_duration
          is_commission_type_percentage
          is_active
          status
          reach
          statistics
          till_date
          schedule_from
          schedule_to
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCommisionCampaignswithCommissionsGQL extends Apollo.Query<GetCommisionCampaignswithCommissionsQuery, GetCommisionCampaignswithCommissionsQueryVariables> {
    override document = GetCommisionCampaignswithCommissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCommisionCampaignsDocument = gql`
    query GetCommisionCampaigns($id: ID!) {
  getCommisionCampaigns(id: $id) {
    _id
    name
    is_active
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCommisionCampaignsGQL extends Apollo.Query<GetCommisionCampaignsQuery, GetCommisionCampaignsQueryVariables> {
    override document = GetCommisionCampaignsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommissionByIdDocument = gql`
    query CommissionById($id: ID!) {
  CommissionById(id: $id) {
    _id
    business_type
    commission_name
    commission_amount
    commission_duration
    commission_on
    commission_store
    commission_type
    description
    highest_sale_duration
    is_active
    is_all_brands
    is_all_categories
    is_all_departments
    is_all_deviceModels
    is_all_deviceTypes
    is_all_employee
    is_all_productTypes
    is_all_products
    is_all_roles
    is_commission_on_sale
    is_commission_type_percentage
    is_greater_then
    is_on_highest_sales
    on_gt_eq_sale_duration
    on_gt_eq_sale_number
    pay_Type
    pay_schedule
    salary_type
    schedule_from
    schedule_to
    status
    till_date
    Business {
      _id
      business_system_name
    }
    BusinessLocation {
      _id
      store_name
    }
    CommissionCampaign {
      _id
      name
    }
    Brand {
      _id
      brand_name
    }
    Category {
      _id
      category_name
    }
    Department {
      _id
      department_name
    }
    DeviceModel {
      _id
      name
    }
    DeviceType {
      _id
      type_name
    }
    Employee {
      id
      first_name
      last_name
      full_name
    }
    Product {
      _id
      product_name
    }
    ProductType {
      _id
      category_name
    }
    Role {
      _id
      roleName
    }
    stores {
      _id
      store_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommissionByIdGQL extends Apollo.Query<CommissionByIdQuery, CommissionByIdQueryVariables> {
    override document = CommissionByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchBusinessLocationCommissionDocument = gql`
    query SearchBusinessLocationCommission($input: businessLocationListFilter) {
  searchBusinessLocation(input: $input) {
    results {
      _id
      store_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchBusinessLocationCommissionGQL extends Apollo.Query<SearchBusinessLocationCommissionQuery, SearchBusinessLocationCommissionQueryVariables> {
    override document = SearchBusinessLocationCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllSystemBrandsCommissionDocument = gql`
    query GetAllSystemBrandsCommission($Business: ID!, $BusinessLocation: ID!, $input: ListFilter) {
  getAllSystemBrands(
    Business: $Business
    BusinessLocation: $BusinessLocation
    input: $input
  ) {
    results {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllSystemBrandsCommissionGQL extends Apollo.Query<GetAllSystemBrandsCommissionQuery, GetAllSystemBrandsCommissionQueryVariables> {
    override document = GetAllSystemBrandsCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeesByPayroleFiltersDocument = gql`
    query GetEmployeesByPayroleFilters($BusinessLocation: [ID]!, $departmentsIds: [ID], $payType: String, $payschedule: String, $RoleIds: [ID], $salarytype: String) {
  getEmployeesByPayroleFilters(
    BusinessLocation: $BusinessLocation
    departmentsIds: $departmentsIds
    payType: $payType
    payschedule: $payschedule
    RoleIds: $RoleIds
    salarytype: $salarytype
  ) {
    id
    first_name
    last_name
    full_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeesByPayroleFiltersGQL extends Apollo.Query<GetEmployeesByPayroleFiltersQuery, GetEmployeesByPayroleFiltersQueryVariables> {
    override document = GetEmployeesByPayroleFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetModelsByBrandIdsDocument = gql`
    query GetModelsByBrandIds($brandIds: [ID]!) {
  getModelsByBrandIds(brandIds: $brandIds) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetModelsByBrandIdsGQL extends Apollo.Query<GetModelsByBrandIdsQuery, GetModelsByBrandIdsQueryVariables> {
    override document = GetModelsByBrandIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProdcutsByFilterationDocument = gql`
    query GetProdcutsByFilteration($brandIds: [ID]!, $BusinessLocation: ID!, $modelIds: [ID]!, $productTypeIds: [ID], $deviceTypeIds: [ID], $categoryIds: [ID]) {
  getProdcutsByFilteration(
    brandIds: $brandIds
    BusinessLocation: $BusinessLocation
    modelIds: $modelIds
    productTypeIds: $productTypeIds
    deviceTypeIds: $deviceTypeIds
    categoryIds: $categoryIds
  ) {
    _id
    product_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProdcutsByFilterationGQL extends Apollo.Query<GetProdcutsByFilterationQuery, GetProdcutsByFilterationQueryVariables> {
    override document = GetProdcutsByFilterationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllProductCategoriesCommissionDocument = gql`
    query GetAllProductCategoriesCommission {
  getAllProductCategories {
    _id
    category_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllProductCategoriesCommissionGQL extends Apollo.Query<GetAllProductCategoriesCommissionQuery, GetAllProductCategoriesCommissionQueryVariables> {
    override document = GetAllProductCategoriesCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDeviceTypeCommissionDocument = gql`
    query GetAllDeviceTypeCommission {
  getAllDeviceType {
    _id
    type_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDeviceTypeCommissionGQL extends Apollo.Query<GetAllDeviceTypeCommissionQuery, GetAllDeviceTypeCommissionQueryVariables> {
    override document = GetAllDeviceTypeCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllServiceCategoryCommissionDocument = gql`
    query GetAllServiceCategoryCommission {
  getAllServiceCategory {
    _id
    category_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllServiceCategoryCommissionGQL extends Apollo.Query<GetAllServiceCategoryCommissionQuery, GetAllServiceCategoryCommissionQueryVariables> {
    override document = GetAllServiceCategoryCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommisionCampaignDocument = gql`
    mutation CreateCommisionCampaign($input: CommisionCampaignInput) {
  createCommisionCampaign(input: $input) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommisionCampaignGQL extends Apollo.Mutation<CreateCommisionCampaignMutation, CreateCommisionCampaignMutationVariables> {
    override document = CreateCommisionCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommissionDocument = gql`
    mutation CreateCommission($input: CommissionInput) {
  createCommission(input: $input) {
    _id
    commission_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommissionGQL extends Apollo.Mutation<CreateCommissionMutation, CreateCommissionMutationVariables> {
    override document = CreateCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommissionDocument = gql`
    mutation UpdateCommission($id: ID!, $input: CommissionInput) {
  updateCommission(id: $id, input: $input) {
    _id
    commission_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommissionGQL extends Apollo.Mutation<UpdateCommissionMutation, UpdateCommissionMutationVariables> {
    override document = UpdateCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCommisionCampaignDocument = gql`
    mutation RemoveCommisionCampaign($id: ID!, $archive: Boolean!) {
  removeCommisionCampaign(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCommisionCampaignGQL extends Apollo.Mutation<RemoveCommisionCampaignMutation, RemoveCommisionCampaignMutationVariables> {
    override document = RemoveCommisionCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommissionDocument = gql`
    mutation DeleteCommission($id: ID!, $delete: Boolean) {
  deleteCommission(id: $id, delete: $delete)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommissionGQL extends Apollo.Mutation<DeleteCommissionMutation, DeleteCommissionMutationVariables> {
    override document = DeleteCommissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommissionCompaingStatusChangedDocument = gql`
    mutation CommissionCompaingStatusChanged($campaign_id: ID!, $status: Boolean) {
  commission_compaingStatusChanged(campaign_id: $campaign_id, status: $status)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommissionCompaingStatusChangedGQL extends Apollo.Mutation<CommissionCompaingStatusChangedMutation, CommissionCompaingStatusChangedMutationVariables> {
    override document = CommissionCompaingStatusChangedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommissionStatusChangedDocument = gql`
    mutation CommissionStatusChanged($campaign_id: ID!, $commission_id: ID!, $status: Boolean) {
  commission_statusChanged(
    campaign_id: $campaign_id
    commission_id: $commission_id
    status: $status
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommissionStatusChangedGQL extends Apollo.Mutation<CommissionStatusChangedMutation, CommissionStatusChangedMutationVariables> {
    override document = CommissionStatusChangedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDiscountsDocument = gql`
    query GetAllDiscounts($input: searchDiscountInput) {
  getAllDiscounts(input: $input) {
    results {
      _id
      code
      Campaign {
        _id
        name
        is_active
        start_date
        end_date
      }
      tags
      is_single_store
      single_store {
        _id
        store_name
        store_nick_name
      }
      multi_stores {
        _id
        store_nick_name
        store_name
      }
      is_minimum_purchase
      is_discount_percentage
      discount_amount
      is_minimum_purchase_amount
      purchaseAmountQuantity
      is_entire_order
      Product {
        _id
        product_name
        total_amount
        quantity
      }
      is_customer_since
      customer_since
      is_new_customer_only
      new_customer_register_after_date
      is_customer_spent_amount
      is_customer_more_then_said_amount
      spent_amount
      customerTags
      is_customer_can_use_only_once
      number_of_usage_per_customer
      can_schedule
      schedule_from
      schedule_to
      created_at
      updated_at
      is_active
      redeem_by {
        _id
        first_name
        last_name
        phone
        email
      }
      reach
      status
      engagement
      BusinessLocation {
        _id
        store_name
        store_nick_name
      }
      Business {
        _id
        business_keeping_unit
        business_system_name
        business_type
        number_of_stores
      }
      isSendEmail
      is_deleted
    }
    page
    limit
    totalPages
    totalResults
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDiscountsGQL extends Apollo.Query<GetAllDiscountsQuery, GetAllDiscountsQueryVariables> {
    override document = GetAllDiscountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDiscountsWithSearchDocument = gql`
    query GetAllDiscountsWithSearch($input: searchDiscountNewInput) {
  getAllDiscountsWithSearch(input: $input) {
    config {
      limit
      page
      totalPages
      totalResults
      no_of_records
      type
      actions
      columns {
        _id
        field
        header
        type
        search
        is_search_able
        query {
          first_condition
          second_condition
          first_value
          second_value
          condition
        }
        is_visible
        filterValue
        is_sortable
        column_data
      }
      filters {
        search
        field
        type
        _ids
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
      }
    }
    data {
      name
      is_active
      start_date
      end_date
      summary
      statistics
      stores
      created_at
      _id
      detail {
        actions
        columns {
          _id
          field
          header
          type
        }
        result {
          discount_amount
          code
          schedule_from
          schedule_to
          _id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDiscountsWithSearchGQL extends Apollo.Query<GetAllDiscountsWithSearchQuery, GetAllDiscountsWithSearchQueryVariables> {
    override document = GetAllDiscountsWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiscountByIdDocument = gql`
    query GetDiscountById($DiscountId: ID!) {
  getDiscountById(id: $DiscountId) {
    _id
    code
    business_type
    Campaign {
      _id
      name
      is_active
      start_date
      end_date
    }
    tags
    is_single_store
    single_store {
      _id
      store_name
      store_nick_name
    }
    multi_stores {
      _id
      store_nick_name
      store_name
    }
    is_minimum_purchase
    is_discount_percentage
    discount_amount
    is_minimum_purchase_amount
    purchaseAmountQuantity
    is_entire_order
    Product {
      _id
      product_name
      total_amount
      quantity
    }
    is_customer_since
    customer_since
    is_new_customer_only
    new_customer_register_after_date
    is_customer_spent_amount
    is_customer_more_then_said_amount
    spent_amount
    customerTags
    is_customer_can_use_only_once
    number_of_usage_per_customer
    can_schedule
    schedule_from
    schedule_to
    created_at
    updated_at
    is_active
    redeem_by {
      _id
      first_name
      last_name
      phone
      email
    }
    reach
    status
    engagement
    BusinessLocation {
      _id
      store_name
      store_nick_name
    }
    Business {
      _id
      business_keeping_unit
      business_system_name
      business_type
      number_of_stores
    }
    isSendEmail
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDiscountByIdGQL extends Apollo.Query<GetDiscountByIdQuery, GetDiscountByIdQueryVariables> {
    override document = GetDiscountByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiscountByCodeDocument = gql`
    query GetDiscountByCode($code: ID!) {
  getDiscountByCode(code: $code) {
    _id
    code
    business_type
    Campaign {
      _id
      name
      is_active
      start_date
      end_date
    }
    tags
    is_single_store
    single_store {
      _id
      store_name
      store_nick_name
    }
    multi_stores {
      _id
      store_nick_name
      store_name
    }
    is_minimum_purchase
    is_discount_percentage
    discount_amount
    is_minimum_purchase_amount
    purchaseAmountQuantity
    is_entire_order
    Product {
      _id
      product_name
      total_amount
      quantity
    }
    is_customer_since
    customer_since
    is_new_customer_only
    new_customer_register_after_date
    is_customer_spent_amount
    is_customer_more_then_said_amount
    spent_amount
    customerTags
    is_customer_can_use_only_once
    number_of_usage_per_customer
    can_schedule
    schedule_from
    schedule_to
    created_at
    updated_at
    is_active
    redeem_by {
      _id
      first_name
      last_name
      phone
      email
    }
    reach
    status
    engagement
    BusinessLocation {
      _id
      store_name
      store_nick_name
    }
    Business {
      _id
      business_keeping_unit
      business_system_name
      business_type
      number_of_stores
    }
    isSendEmail
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDiscountByCodeGQL extends Apollo.Query<GetDiscountByCodeQuery, GetDiscountByCodeQueryVariables> {
    override document = GetDiscountByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetValidateDiscountByCodeDocument = gql`
    query GetValidateDiscountByCode($input: validateDiscountInput!) {
  getValidateDiscountByCode(input: $input) {
    discount {
      _id
      code
      business_type
      Campaign {
        _id
        name
      }
      tags
      is_single_store
      single_store {
        _id
      }
      multi_stores {
        _id
        store_name
        store_nick_name
      }
      is_minimum_purchase
      is_discount_percentage
      discount_amount
      is_minimum_purchase_amount
      purchaseAmountQuantity
      is_entire_order
      Product {
        _id
        product_name
        total_amount
        quantity
      }
      is_customer_since
      customer_since
      is_new_customer_only
      new_customer_register_after_date
      is_customer_spent_amount
      is_customer_more_then_said_amount
      spent_amount
      customerTags
      is_customer_can_use_only_once
      number_of_usage_per_customer
      can_schedule
      schedule_from
      schedule_to
      created_at
      updated_at
      is_active
      redeem_by {
        _id
        first_name
        last_name
        phone
        email
      }
      reach
      status
      engagement
      BusinessLocation {
        _id
        store_name
        store_nick_name
      }
      Business {
        _id
        business_keeping_unit
        business_system_name
      }
      isSendEmail
      is_deleted
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetValidateDiscountByCodeGQL extends Apollo.Query<GetValidateDiscountByCodeQuery, GetValidateDiscountByCodeQueryVariables> {
    override document = GetValidateDiscountByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCouponCodeDocument = gql`
    query GetCouponCode {
  getCouponCode {
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCouponCodeGQL extends Apollo.Query<GetCouponCodeQuery, GetCouponCodeQueryVariables> {
    override document = GetCouponCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllCampaignsSearchDocument = gql`
    query GetAllCampaignsSearch($businessId: ID!) {
  getAllCampaignsSearch(business_id: $businessId) {
    _id
    name
    is_active
    start_date
    end_date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllCampaignsSearchGQL extends Apollo.Query<GetAllCampaignsSearchQuery, GetAllCampaignsSearchQueryVariables> {
    override document = GetAllCampaignsSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignsAndSearchDocument = gql`
    query GetCampaignsAndSearch($input: searchCampaignInput) {
  getCampaignsAndSearch(input: $input) {
    results {
      _id
      name
      is_active
      start_date
      end_date
    }
    page
    limit
    totalPages
    totalResults
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignsAndSearchGQL extends Apollo.Query<GetCampaignsAndSearchQuery, GetCampaignsAndSearchQueryVariables> {
    override document = GetCampaignsAndSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDiscountTagsDocument = gql`
    query GetAllDiscountTags {
  getAllDiscountTags {
    _id
    name
    slug
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDiscountTagsGQL extends Apollo.Query<GetAllDiscountTagsQuery, GetAllDiscountTagsQueryVariables> {
    override document = GetAllDiscountTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSearchedDiscountTagsDocument = gql`
    query GetSearchedDiscountTags($search: String) {
  getSearchedDiscountTags(search: $search) {
    _id
    name
    slug
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSearchedDiscountTagsGQL extends Apollo.Query<GetSearchedDiscountTagsQuery, GetSearchedDiscountTagsQueryVariables> {
    override document = GetSearchedDiscountTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEffectDiscountToCustomerDocument = gql`
    query GetEffectDiscountToCustomer($input: progressBarInput) {
  getEffectDiscountToCustomer(input: $input) {
    Total_customer
    effect_customer
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEffectDiscountToCustomerGQL extends Apollo.Query<GetEffectDiscountToCustomerQuery, GetEffectDiscountToCustomerQueryVariables> {
    override document = GetEffectDiscountToCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDiscountDocument = gql`
    mutation CreateDiscount($input: DiscountInput!) {
  createDiscount(input: $input) {
    _id
    code
    business_type
    Campaign {
      _id
      name
    }
    tags
    is_single_store
    single_store {
      _id
    }
    multi_stores {
      _id
      store_name
      store_nick_name
    }
    is_minimum_purchase
    is_discount_percentage
    discount_amount
    is_minimum_purchase_amount
    purchaseAmountQuantity
    is_entire_order
    Product {
      _id
      product_name
      total_amount
      quantity
    }
    is_customer_since
    customer_since
    is_new_customer_only
    new_customer_register_after_date
    is_customer_spent_amount
    is_customer_more_then_said_amount
    spent_amount
    customerTags
    is_customer_can_use_only_once
    number_of_usage_per_customer
    can_schedule
    schedule_from
    schedule_to
    created_at
    updated_at
    is_active
    redeem_by {
      _id
      first_name
      last_name
      phone
      email
    }
    reach
    status
    engagement
    BusinessLocation {
      _id
      store_name
      store_nick_name
    }
    Business {
      _id
      business_keeping_unit
      business_system_name
    }
    isSendEmail
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDiscountGQL extends Apollo.Mutation<CreateDiscountMutation, CreateDiscountMutationVariables> {
    override document = CreateDiscountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDiscountDocument = gql`
    mutation UpdateDiscount($input: UpdateDiscountInput!) {
  updateDiscount(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDiscountGQL extends Apollo.Mutation<UpdateDiscountMutation, UpdateDiscountMutationVariables> {
    override document = UpdateDiscountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDiscountDocument = gql`
    mutation DeleteDiscount($deleteDiscountId: ID!) {
  deleteDiscount(id: $deleteDiscountId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDiscountGQL extends Apollo.Mutation<DeleteDiscountMutation, DeleteDiscountMutationVariables> {
    override document = DeleteDiscountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DiscountStatusChangedDocument = gql`
    mutation DiscountStatusChanged($campaignId: ID!, $discountId: ID!, $status: Boolean) {
  discountStatusChanged(
    campaign_id: $campaignId
    discount_id: $discountId
    status: $status
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DiscountStatusChangedGQL extends Apollo.Mutation<DiscountStatusChangedMutation, DiscountStatusChangedMutationVariables> {
    override document = DiscountStatusChangedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CampaignStatusChangedDocument = gql`
    mutation CampaignStatusChanged($campaignId: ID!, $status: Boolean) {
  campaignStatusChanged(campaign_id: $campaignId, status: $status)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CampaignStatusChangedGQL extends Apollo.Mutation<CampaignStatusChangedMutation, CampaignStatusChangedMutationVariables> {
    override document = CampaignStatusChangedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductsByLocationDocument = gql`
    query GetProductsByLocation($locationId: ID!) {
  getProductsByLocation(locationId: $locationId) {
    _id
    product_name
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductsByLocationGQL extends Apollo.Query<GetProductsByLocationQuery, GetProductsByLocationQueryVariables> {
    override document = GetProductsByLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessedByTypeDocument = gql`
    query GetBusinessedByType($type: AllowBusinessType) {
  getBusinessedByType(type: $type) {
    _id
    business_type
    business_system_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessedByTypeGQL extends Apollo.Query<GetBusinessedByTypeQuery, GetBusinessedByTypeQueryVariables> {
    override document = GetBusinessedByTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCampaignDocument = gql`
    mutation CreateCampaign($input: createCampaignInput!) {
  createCampaign(input: $input) {
    _id
    name
    start_date
    end_date
    is_active
    BusinessLocation {
      _id
    }
    Business {
      _id
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCampaignGQL extends Apollo.Mutation<CreateCampaignMutation, CreateCampaignMutationVariables> {
    override document = CreateCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllActivityDocumentsDocument = gql`
    query GetAllActivityDocuments {
  getAllActivityDocuments {
    _id
    attachment
    validity
    name
    assign_to {
      assignee {
        id
        full_name
      }
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllActivityDocumentsGQL extends Apollo.Query<GetAllActivityDocumentsQuery, GetAllActivityDocumentsQueryVariables> {
    override document = GetAllActivityDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentControlGroupsDocument = gql`
    query GetDocumentControlGroups {
  getDocumentControlGroups {
    _id
    name
    isFile
    updated_at
    assign_to {
      assignee {
        id
        full_name
      }
      department {
        _id
        department_name
      }
      type
      roles {
        _id
        roleName
      }
    }
    attachment
    document_type
    validity
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentControlGroupsGQL extends Apollo.Query<GetDocumentControlGroupsQuery, GetDocumentControlGroupsQueryVariables> {
    override document = GetDocumentControlGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateActivityGroupDocument = gql`
    mutation CreateActivityGroup($input: createGroupInput) {
  createActivityGroup(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateActivityGroupGQL extends Apollo.Mutation<CreateActivityGroupMutation, CreateActivityGroupMutationVariables> {
    override document = CreateActivityGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateMultipleActionActivityDocument = gql`
    mutation CreateUpdateMultipleActionActivity($input: addDocumentInput!) {
  createUpdateMultipleActionActivity(input: $input) {
    _id
    name
    activity_type
    attachment
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateMultipleActionActivityGQL extends Apollo.Mutation<CreateUpdateMultipleActionActivityMutation, CreateUpdateMultipleActionActivityMutationVariables> {
    override document = CreateUpdateMultipleActionActivityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllActiveEmployeesForActivityDocument = gql`
    query GetAllActiveEmployeesForActivity($business_id: ID!) {
  getAllActiveEmployees(business_id: $business_id) {
    id
    full_name
    last_working_date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllActiveEmployeesForActivityGQL extends Apollo.Query<GetAllActiveEmployeesForActivityQuery, GetAllActiveEmployeesForActivityQueryVariables> {
    override document = GetAllActiveEmployeesForActivityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDepartmentsDocument = gql`
    query GetAllDepartments($business_id: ID!) {
  getAllDepartments(business_id: $business_id) {
    _id
    department_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDepartmentsGQL extends Apollo.Query<GetAllDepartmentsQuery, GetAllDepartmentsQueryVariables> {
    override document = GetAllDepartmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeesByDepartmentWithoutLimitsDocument = gql`
    query GetEmployeesByDepartmentWithoutLimits($filter: EmployeesByDepWithoutLimits) {
  getEmployeesByDepartmentWithoutLimits(filter: $filter) {
    id
    full_name
    last_working_date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeesByDepartmentWithoutLimitsGQL extends Apollo.Query<GetEmployeesByDepartmentWithoutLimitsQuery, GetEmployeesByDepartmentWithoutLimitsQueryVariables> {
    override document = GetEmployeesByDepartmentWithoutLimitsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeByRoleIdsDocument = gql`
    query GetEmployeeByRoleIds($roles_ids: [ID!]!) {
  getEmployeeByRoleIds(roles_ids: $roles_ids) {
    id
    full_name
    last_working_date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeByRoleIdsGQL extends Apollo.Query<GetEmployeeByRoleIdsQuery, GetEmployeeByRoleIdsQueryVariables> {
    override document = GetEmployeeByRoleIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRolesByBusinessIdDocument = gql`
    query GetRolesByBusinessId($business_id: ID!) {
  getRolesByBusinessId(business_id: $business_id) {
    _id
    roleName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRolesByBusinessIdGQL extends Apollo.Query<GetRolesByBusinessIdQuery, GetRolesByBusinessIdQueryVariables> {
    override document = GetRolesByBusinessIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentsWithFilterDocument = gql`
    query GetDocumentsWithFilter($input: inputWithFilter!) {
  getDocumentsWithFilter(input: $input) {
    results {
      details {
        files
        folder
      }
      is_owner
      share_as
      share_by
      google_drive_attachment
      type
      is_default_document
      is_employee_main_folder
      is_employee_folder
      is_asset_main_folder
      share_with {
        _id
        date
        share_as
        type
        shared_by {
          full_name
        }
        department {
          department_name
          _id
        }
        role {
          roleName
          _id
        }
        employee {
          full_name
          id
        }
      }
      bread_crum {
        name
        _id
      }
      created_at
      created_by {
        full_name
      }
      isEmployeeUpload
      _id
      activity_type
      name
      isFile
      updated_at
      children {
        _id
        name
        isFile
        updated_at
        size
        children {
          size
          name
          _id
        }
      }
      parent {
        _id
        name
        isFile
        updated_at
        parent {
          _id
          name
        }
      }
      assign_to {
        assignee {
          id
          full_name
        }
        department {
          _id
          department_name
        }
        type
        roles {
          _id
          roleName
        }
      }
      extension
      size
      attachment
      document_type
      validity
    }
    page
    limit
    totalPages
    totalResults
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentsWithFilterGQL extends Apollo.Query<GetDocumentsWithFilterQuery, GetDocumentsWithFilterQueryVariables> {
    override document = GetDocumentsWithFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentControlAttachmentsFolderDocument = gql`
    query GetDocumentControlAttachmentsFolder {
  getDocumentControlAttachmentsFolder {
    _id
    name
    assign_to {
      type
      assignee {
        id
        full_name
      }
    }
    children {
      _id
      name
      isFile
    }
    isFile
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentControlAttachmentsFolderGQL extends Apollo.Query<GetDocumentControlAttachmentsFolderQuery, GetDocumentControlAttachmentsFolderQueryVariables> {
    override document = GetDocumentControlAttachmentsFolderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFoldersWithSearchDocument = gql`
    query GetFoldersWithSearch($type: DocumentTypeEnums, $parent: ID, $search: String) {
  getFoldersWithSearch(type: $type, parent: $parent, search: $search) {
    _id
    name
    isFile
    updated_at
    share_as
    extension
    is_owner
    share_with {
      _id
      type
      employee {
        full_name
        id
      }
    }
    children {
      _id
      name
      isFile
      updated_at
    }
    parent {
      isFile
      _id
      name
    }
    assign_to {
      assignee {
        id
        full_name
      }
      department {
        _id
        department_name
      }
      type
      roles {
        _id
        roleName
      }
    }
    attachment
    document_type
    validity
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFoldersWithSearchGQL extends Apollo.Query<GetFoldersWithSearchQuery, GetFoldersWithSearchQueryVariables> {
    override document = GetFoldersWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentControlAttachmentsByIdDocument = gql`
    query GetDocumentControlAttachmentsById($getDocumentControlAttachmentsByIdId: ID!) {
  getDocumentControlAttachmentsById(id: $getDocumentControlAttachmentsByIdId) {
    details {
      files
      folder
    }
    created_at
    is_owner
    google_drive_id
    activity_type
    google_drive_attachment
    updated_at
    is_employee_main_folder
    is_default_document
    is_asset_main_folder
    is_employee_folder
    extension
    type
    share_as
    size
    created_by {
      full_name
    }
    share_with {
      _id
      date
      share_as
      type
      shared_by {
        full_name
      }
      department {
        department_name
      }
      role {
        roleName
      }
      employee {
        full_name
        id
      }
    }
    _id
    deleted_at
    deleted_by {
      full_name
      id
    }
    attachment
    name
    validity
    is_sign_required
    is_hide_after_review
    isFile
    parent {
      name
      _id
      children {
        name
        _id
        size
        children {
          name
          _id
          size
        }
      }
    }
    children {
      name
      size
      _id
      children {
        _id
        name
        size
      }
    }
    assign_to {
      assignee {
        id
        first_name
        full_name
      }
      department {
        department_name
        _id
      }
      roles {
        roleName
        _id
      }
      type
    }
    document_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentControlAttachmentsByIdGQL extends Apollo.Query<GetDocumentControlAttachmentsByIdQuery, GetDocumentControlAttachmentsByIdQueryVariables> {
    override document = GetDocumentControlAttachmentsByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetemployeeRecentFileViewDocument = gql`
    query GetemployeeRecentFileView {
  getemployeeRecentFileView {
    _id
    attachment
    name
    extension
    document_type
    isFile
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetemployeeRecentFileViewGQL extends Apollo.Query<GetemployeeRecentFileViewQuery, GetemployeeRecentFileViewQueryVariables> {
    override document = GetemployeeRecentFileViewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddNewFolderDocumentControlDocument = gql`
    mutation AddNewFolderDocumentControl($input: addNewFolderDocumentControl!) {
  addNewFolderDocumentControl(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNewFolderDocumentControlGQL extends Apollo.Mutation<AddNewFolderDocumentControlMutation, AddNewFolderDocumentControlMutationVariables> {
    override document = AddNewFolderDocumentControlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDocumentControlAttachmentDocument = gql`
    mutation CreateDocumentControlAttachment($input: addDocumentInput!) {
  createDocumentControlAttachment(input: $input) {
    _id
    document_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDocumentControlAttachmentGQL extends Apollo.Mutation<CreateDocumentControlAttachmentMutation, CreateDocumentControlAttachmentMutationVariables> {
    override document = CreateDocumentControlAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RenameDocumentControlAttachmentDocument = gql`
    mutation RenameDocumentControlAttachment($renameDocumentControlAttachmentId: ID!, $name: String!) {
  renameDocumentControlAttachment(
    id: $renameDocumentControlAttachmentId
    name: $name
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RenameDocumentControlAttachmentGQL extends Apollo.Mutation<RenameDocumentControlAttachmentMutation, RenameDocumentControlAttachmentMutationVariables> {
    override document = RenameDocumentControlAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeLocationOfDocumentDeletedParentDocument = gql`
    mutation ChangeLocationOfDocumentDeletedParent($changeLocationOfDocumentDeletedParentId: [ID!], $newParentId: ID) {
  changeLocationOfDocumentDeletedParent(
    id: $changeLocationOfDocumentDeletedParentId
    newParentId: $newParentId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeLocationOfDocumentDeletedParentGQL extends Apollo.Mutation<ChangeLocationOfDocumentDeletedParentMutation, ChangeLocationOfDocumentDeletedParentMutationVariables> {
    override document = ChangeLocationOfDocumentDeletedParentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeDocumentControlAttachmentFolderDocument = gql`
    mutation ChangeDocumentControlAttachmentFolder($changeDocumentControlAttachmentFolderId: ID!, $newParentId: ID) {
  changeDocumentControlAttachmentFolder(
    id: $changeDocumentControlAttachmentFolderId
    newParentId: $newParentId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeDocumentControlAttachmentFolderGQL extends Apollo.Mutation<ChangeDocumentControlAttachmentFolderMutation, ChangeDocumentControlAttachmentFolderMutationVariables> {
    override document = ChangeDocumentControlAttachmentFolderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadDocumentControlAttachmentDocument = gql`
    mutation UploadDocumentControlAttachment($input: fileUploadDocumentControl!) {
  uploadDocumentControlAttachment(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadDocumentControlAttachmentGQL extends Apollo.Mutation<UploadDocumentControlAttachmentMutation, UploadDocumentControlAttachmentMutationVariables> {
    override document = UploadDocumentControlAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadFileDocumentControlAttachmentDocument = gql`
    mutation UploadFileDocumentControlAttachment($input: uploadFileDocumentControlAttachment!) {
  uploadFileDocumentControlAttachment(input: $input) {
    _id
    google_drive_id
    extension
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadFileDocumentControlAttachmentGQL extends Apollo.Mutation<UploadFileDocumentControlAttachmentMutation, UploadFileDocumentControlAttachmentMutationVariables> {
    override document = UploadFileDocumentControlAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopyDocumentControlAttachmentFolderDocument = gql`
    mutation CopyDocumentControlAttachmentFolder($copyDocumentControlAttachmentFolderId: ID!, $newParentId: ID) {
  copyDocumentControlAttachmentFolder(
    id: $copyDocumentControlAttachmentFolderId
    newParentId: $newParentId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopyDocumentControlAttachmentFolderGQL extends Apollo.Mutation<CopyDocumentControlAttachmentFolderMutation, CopyDocumentControlAttachmentFolderMutationVariables> {
    override document = CopyDocumentControlAttachmentFolderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmployeeRecentFileViewDocument = gql`
    mutation EmployeeRecentFileView($employeeRecentFileViewId: ID!) {
  employeeRecentFileView(id: $employeeRecentFileViewId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EmployeeRecentFileViewGQL extends Apollo.Mutation<EmployeeRecentFileViewMutation, EmployeeRecentFileViewMutationVariables> {
    override document = EmployeeRecentFileViewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadZipDocument = gql`
    subscription DownloadZip($userId: ID!) {
  downloadZip(userId: $userId) {
    percent
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadZipGQL extends Apollo.Subscription<DownloadZipSubscription, DownloadZipSubscriptionVariables> {
    override document = DownloadZipDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDocumentDocument = gql`
    subscription DeleteDocument {
  deleteDocument {
    current
    parent
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDocumentGQL extends Apollo.Subscription<DeleteDocumentSubscription, DeleteDocumentSubscriptionVariables> {
    override document = DeleteDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadFileDocument = gql`
    subscription UploadFile($userId: ID!) {
  uploadFile(userId: $userId) {
    percent
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadFileGQL extends Apollo.Subscription<UploadFileSubscription, UploadFileSubscriptionVariables> {
    override document = UploadFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllRequestedDocumentsDocument = gql`
    query GetAllRequestedDocuments($input: inputDocumentsWithFilter!) {
  getAllRequestedDocuments(input: $input) {
    config {
      limit
      page
      totalPages
      totalResults
      no_of_records
      type
      actions
      columns {
        _id
        field
        header
        type
        search
        is_search_able
        query {
          first_condition
          second_condition
          first_value
          second_value
          condition
        }
        is_visible
        filterValue
        column_data
      }
    }
    data {
      Doucuments {
        is_group
        activity_name
        employeeDocumentUpload {
          date
          employee {
            id
            full_name
            department {
              _id
              department_name
            }
          }
          fileRef
          status
          view
        }
        name
        attachment
        assign_to {
          assignee {
            full_name
            id
          }
        }
        responded
        not_responded
        validity
        _id
      }
      detail {
        columns {
          _id
          header
          field
        }
        result {
          fileRef
          status
          employee {
            full_name
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllRequestedDocumentsGQL extends Apollo.Query<GetAllRequestedDocumentsQuery, GetAllRequestedDocumentsQueryVariables> {
    override document = GetAllRequestedDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllSendRequestDocumentsDocument = gql`
    query GetAllSendRequestDocuments($input: inputDocumentsWithFilter!) {
  getAllSendRequestDocuments(input: $input) {
    countpendingRequest
    config {
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      table_preset {
        ...TablePresetFields
      }
    }
    data {
      Doucuments {
        activity_name
        signatureDeliveryOption
        receivedDocumentInMultipleAction
        grouped_activities {
          signatureDeliveryOption
          receivedDocumentInMultipleAction
          status
          extension
          is_group
          message
          activity_type
          name
          activity_name
          document_type
          assign_to {
            assignee {
              full_name
              id
            }
          }
          _id
          attachment
          validity
          employeeDocumentUpload {
            _id
            date
            employee {
              id
              full_name
            }
            fileRef
            status
            view
          }
          bread_crum {
            _id
            name
            children {
              _id
              name
            }
          }
          size
          created_at
          created_by {
            full_name
          }
        }
        status
        extension
        is_group
        message
        activity_type
        name
        document_type
        assign_to {
          assignee {
            full_name
            id
          }
        }
        _id
        attachment
        validity
        employeeDocumentUpload {
          _id
          date
          employee {
            id
            full_name
          }
          fileRef
          status
          view
        }
        bread_crum {
          _id
          name
          children {
            _id
            name
          }
        }
        size
        created_at
        created_by {
          full_name
        }
      }
      detail {
        result {
          date
          employee {
            id
            full_name
          }
          fileRef
          status
        }
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllSendRequestDocumentsGQL extends Apollo.Query<GetAllSendRequestDocumentsQuery, GetAllSendRequestDocumentsQueryVariables> {
    override document = GetAllSendRequestDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitDocumentByEmployeeDocument = gql`
    mutation SubmitDocumentByEmployee($input: submitDocumentEmployeeInput) {
  submitDocumentByEmployee(input: $input) {
    _id
    attachment
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitDocumentByEmployeeGQL extends Apollo.Mutation<SubmitDocumentByEmployeeMutation, SubmitDocumentByEmployeeMutationVariables> {
    override document = SubmitDocumentByEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEmployeeVeiwCountDocument = gql`
    mutation UpdateEmployeeVeiwCount($updateEmployeeVeiwCountId: ID!, $employeeId: ID) {
  updateEmployeeVeiwCount(id: $updateEmployeeVeiwCountId, employeeID: $employeeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEmployeeVeiwCountGQL extends Apollo.Mutation<UpdateEmployeeVeiwCountMutation, UpdateEmployeeVeiwCountMutationVariables> {
    override document = UpdateEmployeeVeiwCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDocumentControlAttachmentAssigningDocument = gql`
    mutation UpdateDocumentControlAttachmentAssigning($input: updateDocumentInput) {
  updateDocumentControlAttachmentAssigning(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDocumentControlAttachmentAssigningGQL extends Apollo.Mutation<UpdateDocumentControlAttachmentAssigningMutation, UpdateDocumentControlAttachmentAssigningMutationVariables> {
    override document = UpdateDocumentControlAttachmentAssigningDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllShareOfDocumentDocument = gql`
    query GetAllShareOfDocument($documentId: ID!) {
  getAllShareOfDocument(documentId: $documentId) {
    departments {
      department {
        _id
        department_name
      }
      share_as
      employees {
        employee {
          id
          full_name
        }
        share_as
        detail {
          _id
        }
      }
    }
    roles {
      role {
        _id
        roleName
      }
      share_as
      employees {
        employee {
          id
          full_name
        }
        share_as
        detail {
          _id
        }
      }
    }
    employees {
      employees {
        employee {
          id
          full_name
        }
        share_as
        detail {
          _id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllShareOfDocumentGQL extends Apollo.Query<GetAllShareOfDocumentQuery, GetAllShareOfDocumentQueryVariables> {
    override document = GetAllShareOfDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShareDocumentControlAttachmentDocument = gql`
    mutation ShareDocumentControlAttachment($input: emailDocumentControlAttachment!) {
  shareDocumentControlAttachment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShareDocumentControlAttachmentGQL extends Apollo.Mutation<ShareDocumentControlAttachmentMutation, ShareDocumentControlAttachmentMutationVariables> {
    override document = ShareDocumentControlAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeSharingStatusOrRemoveShareDocument = gql`
    mutation ChangeSharingStatusOrRemoveShare($input: changeshareStatusInput) {
  changeSharingStatusOrRemoveShare(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeSharingStatusOrRemoveShareGQL extends Apollo.Mutation<ChangeSharingStatusOrRemoveShareMutation, ChangeSharingStatusOrRemoveShareMutationVariables> {
    override document = ChangeSharingStatusOrRemoveShareDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetArchivedDocumentsDocument = gql`
    query GetArchivedDocuments($input: archivedDocumentInput) {
  getArchivedDocuments(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      deleted_at
      type
      activity_type
      deleted_by {
        full_name
        id
      }
      details {
        files
        folder
      }
      created_at
      is_owner
      updated_at
      extension
      size
      created_by {
        full_name
      }
      share_with {
        date
        employee {
          employee_id
          id
          full_name
        }
      }
      _id
      attachment
      name
      validity
      is_sign_required
      is_hide_after_review
      isFile
      parent {
        name
        _id
        children {
          name
          _id
          size
          children {
            name
            _id
            size
          }
        }
      }
      children {
        name
        size
        _id
        children {
          _id
          name
          size
        }
      }
      assign_to {
        assignee {
          id
          first_name
          full_name
        }
        department {
          department_name
          _id
        }
        roles {
          roleName
          _id
        }
        type
      }
      document_type
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetArchivedDocumentsGQL extends Apollo.Query<GetArchivedDocumentsQuery, GetArchivedDocumentsQueryVariables> {
    override document = GetArchivedDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveDocumentControlDocument = gql`
    mutation ArchiveDocumentControl($archiveDocumentControlId: [ID!]!, $archive: Boolean) {
  archiveDocumentControl(id: $archiveDocumentControlId, archive: $archive) {
    DeletedParentDocument
    archived
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveDocumentControlGQL extends Apollo.Mutation<ArchiveDocumentControlMutation, ArchiveDocumentControlMutationVariables> {
    override document = ArchiveDocumentControlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PermanentlyDeleteDocumentDocument = gql`
    mutation PermanentlyDeleteDocument($permanentlyDeleteDocumentId: [ID!]) {
  permanentlyDeleteDocument(id: $permanentlyDeleteDocumentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PermanentlyDeleteDocumentGQL extends Apollo.Mutation<PermanentlyDeleteDocumentMutation, PermanentlyDeleteDocumentMutationVariables> {
    override document = PermanentlyDeleteDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchBusinessLocationDocument = gql`
    query SearchBusinessLocation($input: businessLocationListFilter) {
  searchBusinessLocation(input: $input) {
    results {
      _id
      store_name
      store_nick_name
      created_at
      email
      phone
      status
      location_keeping_unit
      is_deleted
      franchiser_business {
        _id
        business_system_name
      }
    }
    config {
      actions
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchBusinessLocationGQL extends Apollo.Query<SearchBusinessLocationQuery, SearchBusinessLocationQueryVariables> {
    override document = SearchBusinessLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BusinessLocationByIdDocument = gql`
    query BusinessLocationById($businessLocationId: ID!) {
  businessLocationById(businessLocationId: $businessLocationId) {
    _id
    store_name
    store_nick_name
    store_legal_name
    address_1
    address_2
    State
    city
    zip_code
    location_keeping_unit
    sales_tax
    email
    phone
    store_type
    identification_type
    identification_number
    time_zone
    store_logo
    logo
    duty_roaster
    status
    Country {
      _id
      name
      short_name
    }
    package {
      _id
      package_name
      package_type
    }
    business_id {
      _id
      business_system_name
      business_type
    }
    franchiser_business {
      _id
      business_system_name
    }
    region {
      _id
      region_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BusinessLocationByIdGQL extends Apollo.Query<BusinessLocationByIdQuery, BusinessLocationByIdQueryVariables> {
    override document = BusinessLocationByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTimeZoneDocument = gql`
    query GetTimeZone {
  getTimeZone {
    value
    offset
    text
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTimeZoneGQL extends Apollo.Query<GetTimeZoneQuery, GetTimeZoneQueryVariables> {
    override document = GetTimeZoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllBusinesseForFranchiseDocument = gql`
    query GetAllBusinesseForFranchise {
  getAllBusinesseForFranchise {
    _id
    business_legal_name
    business_system_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllBusinesseForFranchiseGQL extends Apollo.Query<GetAllBusinesseForFranchiseQuery, GetAllBusinesseForFranchiseQueryVariables> {
    override document = GetAllBusinesseForFranchiseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateBusinessAddStoreRequestDocument = gql`
    query ValidateBusinessAddStoreRequest($business: ID!, $locationId: ID) {
  validateBusinessAddStoreRequest(business: $business, locationId: $locationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateBusinessAddStoreRequestGQL extends Apollo.Query<ValidateBusinessAddStoreRequestQuery, ValidateBusinessAddStoreRequestQueryVariables> {
    override document = ValidateBusinessAddStoreRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBusinessLocationDocument = gql`
    mutation CreateBusinessLocation($input: BusinessLocationInput!) {
  createBusinessLocation(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBusinessLocationGQL extends Apollo.Mutation<CreateBusinessLocationMutation, CreateBusinessLocationMutationVariables> {
    override document = CreateBusinessLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBusinessLocationDocument = gql`
    mutation UpdateBusinessLocation($updateBusinessLocationId: ID!, $input: BusinessLocationInput!) {
  updateBusinessLocation(id: $updateBusinessLocationId, input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBusinessLocationGQL extends Apollo.Mutation<UpdateBusinessLocationMutation, UpdateBusinessLocationMutationVariables> {
    override document = UpdateBusinessLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveBusinessLocationDocument = gql`
    mutation ArchiveBusinessLocation($archiveBusinessLocationId: ID, $archive: Boolean) {
  archiveBusinessLocation(id: $archiveBusinessLocationId, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveBusinessLocationGQL extends Apollo.Mutation<ArchiveBusinessLocationMutation, ArchiveBusinessLocationMutationVariables> {
    override document = ArchiveBusinessLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegionGetAllStateDocument = gql`
    query RegionGetAllState {
  getAllState {
    _id
    state_name
    short_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegionGetAllStateGQL extends Apollo.Query<RegionGetAllStateQuery, RegionGetAllStateQueryVariables> {
    override document = RegionGetAllStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegionGetAllCityDocument = gql`
    query RegionGetAllCity($stateIds: [ID!]!) {
  getAllCity(state_ids: $stateIds) {
    _id
    city_name
    short_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegionGetAllCityGQL extends Apollo.Query<RegionGetAllCityQuery, RegionGetAllCityQueryVariables> {
    override document = RegionGetAllCityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRegionWithSearchDocument = gql`
    query GetRegionWithSearch($input: regionInput) {
  getRegionWithSearch(input: $input) {
    config {
      actions
      columns {
        _id
        field
        header
        is_visible
        type
      }
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
    }
    results {
      _id
      region_name
      status
      is_deleted
      Country {
        _id
        name
      }
      State {
        _id
        state_name
      }
      City {
        _id
        city_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRegionWithSearchGQL extends Apollo.Query<GetRegionWithSearchQuery, GetRegionWithSearchQueryVariables> {
    override document = GetRegionWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRegionByIdDocument = gql`
    query GetRegionById($id: ID!) {
  getRegionById(_id: $id) {
    _id
    region_name
    Country {
      _id
      name
    }
    State {
      _id
      state_name
      short_name
    }
    City {
      _id
      city_name
      short_name
    }
    BusinessLocation {
      _id
      store_name
      store_nick_name
      location_keeping_unit
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRegionByIdGQL extends Apollo.Query<GetRegionByIdQuery, GetRegionByIdQueryVariables> {
    override document = GetRegionByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllRegionsDocument = gql`
    query GetAllRegions($businessId: ID!) {
  getAllRegions(business_id: $businessId) {
    _id
    region_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllRegionsGQL extends Apollo.Query<GetAllRegionsQuery, GetAllRegionsQueryVariables> {
    override document = GetAllRegionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegionGetBusinessesByTypeDocument = gql`
    query RegionGetBusinessesByType($businessTypes: [String!]!) {
  getBusinessesByType(business_types: $businessTypes) {
    _id
    business_keeping_unit
    business_system_name
    business_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegionGetBusinessesByTypeGQL extends Apollo.Query<RegionGetBusinessesByTypeQuery, RegionGetBusinessesByTypeQueryVariables> {
    override document = RegionGetBusinessesByTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegionGetBusinessesLocationsDocument = gql`
    query RegionGetBusinessesLocations($businessIds: [ID!]!) {
  getBusinessesLocations(business_ids: $businessIds) {
    _id
    store_name
    store_nick_name
    location_keeping_unit
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegionGetBusinessesLocationsGQL extends Apollo.Query<RegionGetBusinessesLocationsQuery, RegionGetBusinessesLocationsQueryVariables> {
    override document = RegionGetBusinessesLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRegionDocument = gql`
    mutation CreateRegion($input: createRegionInput!) {
  createRegion(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRegionGQL extends Apollo.Mutation<CreateRegionMutation, CreateRegionMutationVariables> {
    override document = CreateRegionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRegionDocument = gql`
    mutation UpdateRegion($input: updateRegionInput!) {
  updateRegion(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRegionGQL extends Apollo.Mutation<UpdateRegionMutation, UpdateRegionMutationVariables> {
    override document = UpdateRegionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRegionDocument = gql`
    mutation DeleteRegion($ids: [ID]!, $archive: Boolean!) {
  deleteRegion(ids: $ids, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRegionGQL extends Apollo.Mutation<DeleteRegionMutation, DeleteRegionMutationVariables> {
    override document = DeleteRegionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaleGoalGetListDocument = gql`
    query SaleGoalGetList($input: goalsListFilter) {
  getGoalList(input: $input) {
    config {
      limit
      page
      totalPages
      totalResults
    }
    results {
      _id
      goal_name
      goal_period
      goal_type
      sales_target_value
      sales_target_incentive
      start_date
      status
      is_deleted
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaleGoalGetListGQL extends Apollo.Query<SaleGoalGetListQuery, SaleGoalGetListQueryVariables> {
    override document = SaleGoalGetListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaleGoalGetByIdDocument = gql`
    query SaleGoalGetById($_id: ID!) {
  getGoalById(_id: $_id) {
    _id
    goal_name
    business_type
    business {
      _id
    }
    store {
      _id
      store_name
    }
    goal_period
    start_date
    count_no_by_goal_period
    sales_target_value
    sales_target_incentive
    is_percentage
    is_amount
    is_all_employee
    is_all_department
    goal_type
    employees {
      _id
      full_name
    }
    department {
      _id
      department_name
    }
    target_by_products {
      product_category
      percentage
      amount
      status
    }
    target_by_employees {
      employee_name
      designation
      target
      status
    }
    target_by_departments {
      department_name
      target
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaleGoalGetByIdGQL extends Apollo.Query<SaleGoalGetByIdQuery, SaleGoalGetByIdQueryVariables> {
    override document = SaleGoalGetByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaleGoalGetBusinessesDocument = gql`
    query SaleGoalGetBusinesses($type: AllowBusinessType) {
  getBusinessedByType(type: $type) {
    _id
    business_system_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaleGoalGetBusinessesGQL extends Apollo.Query<SaleGoalGetBusinessesQuery, SaleGoalGetBusinessesQueryVariables> {
    override document = SaleGoalGetBusinessesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaleGoalGetStoresDocument = gql`
    query SaleGoalGetStores($business_id: ID!) {
  getBusinessLocationsByBusinessId(business_id: $business_id) {
    _id
    store_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaleGoalGetStoresGQL extends Apollo.Query<SaleGoalGetStoresQuery, SaleGoalGetStoresQueryVariables> {
    override document = SaleGoalGetStoresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaleGoalGetDepartmentsDocument = gql`
    query SaleGoalGetDepartments($business_id: ID!, $location_id: ID!) {
  getDepartmentsByLocationID(business_id: $business_id, location_id: $location_id) {
    _id
    department_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaleGoalGetDepartmentsGQL extends Apollo.Query<SaleGoalGetDepartmentsQuery, SaleGoalGetDepartmentsQueryVariables> {
    override document = SaleGoalGetDepartmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaleGoalGetEmployeesDocument = gql`
    query SaleGoalGetEmployees($business_id: ID!, $location_id: ID) {
  getEmployeesByLocationID(business_id: $business_id, location_id: $location_id) {
    _id
    full_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaleGoalGetEmployeesGQL extends Apollo.Query<SaleGoalGetEmployeesQuery, SaleGoalGetEmployeesQueryVariables> {
    override document = SaleGoalGetEmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaleGoalCreateDocument = gql`
    mutation SaleGoalCreate($input: goalsInput) {
  createGoal(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaleGoalCreateGQL extends Apollo.Mutation<SaleGoalCreateMutation, SaleGoalCreateMutationVariables> {
    override document = SaleGoalCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaleGoalUpdateDocument = gql`
    mutation SaleGoalUpdate($_id: ID!, $input: goalsInput) {
  updateGoal(_id: $_id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaleGoalUpdateGQL extends Apollo.Mutation<SaleGoalUpdateMutation, SaleGoalUpdateMutationVariables> {
    override document = SaleGoalUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaleGoalDeleteDocument = gql`
    mutation SaleGoalDelete($ids: [ID]!, $archive: Boolean) {
  deleteGoal(ids: $ids, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaleGoalDeleteGQL extends Apollo.Mutation<SaleGoalDeleteMutation, SaleGoalDeleteMutationVariables> {
    override document = SaleGoalDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaleGoalStatusChangeDocument = gql`
    mutation SaleGoalStatusChange($goal_id: ID!, $status: Boolean) {
  goalStatusChanged(goal_id: $goal_id, status: $status)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaleGoalStatusChangeGQL extends Apollo.Mutation<SaleGoalStatusChangeMutation, SaleGoalStatusChangeMutationVariables> {
    override document = SaleGoalStatusChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAttendanceRegulationApprovalsWithSearchDocument = gql`
    query GetAttendanceRegulationApprovalsWithSearch($input: attendanceFilter) {
  getAttendanceRegulationApprovalsWithSearch(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      attendance_date
      status
      is_deleted
      reason_type
      time_in
      time_out
      description
      employee {
        id
        full_name
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAttendanceRegulationApprovalsWithSearchGQL extends Apollo.Query<GetAttendanceRegulationApprovalsWithSearchQuery, GetAttendanceRegulationApprovalsWithSearchQueryVariables> {
    override document = GetAttendanceRegulationApprovalsWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAttendanceRegulationApprovalDocument = gql`
    mutation UpdateAttendanceRegulationApproval($input: updateRequestLevel!) {
  updateAttendanceRegulationApproval(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAttendanceRegulationApprovalGQL extends Apollo.Mutation<UpdateAttendanceRegulationApprovalMutation, UpdateAttendanceRegulationApprovalMutationVariables> {
    override document = UpdateAttendanceRegulationApprovalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAttendanceRegulationByIdDocument = gql`
    query GetAttendanceRegulationById($id: ID!) {
  getAttendanceRegulationById(id: $id) {
    _id
    attendance_date
    time_in
    time_out
    reason_type
    description
    status
    approval_description
    business_manager {
      _id
      full_name
      status
      id
    }
    created_at
    updated_at
    approval_status
    behalf_of {
      full_name
      _id
    }
    employee {
      first_name
      last_name
      id
      _id
    }
    business {
      _id
    }
    work_flow {
      approved_by {
        id
        full_name
        _id
      }
      approval_description
      status
      employee {
        _id
        full_name
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAttendanceRegulationByIdGQL extends Apollo.Query<GetAttendanceRegulationByIdQuery, GetAttendanceRegulationByIdQueryVariables> {
    override document = GetAttendanceRegulationByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDelegantApprovalDocument = gql`
    query GetDelegantApproval($approvalType: String!) {
  getDelegantApproval(approval_type: $approvalType) {
    approval_type
    delegate_approvers {
      _id
      full_name
    }
    original_approver {
      full_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDelegantApprovalGQL extends Apollo.Query<GetDelegantApprovalQuery, GetDelegantApprovalQueryVariables> {
    override document = GetDelegantApprovalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddDelegantEmployeeDocument = gql`
    mutation AddDelegantEmployee($input: delegantApprovalMutationInput!) {
  addDelegantEmployee(input: $input) {
    approval_type
    delegate_approvers {
      _id
      full_name
    }
    original_approver {
      full_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddDelegantEmployeeGQL extends Apollo.Mutation<AddDelegantEmployeeMutation, AddDelegantEmployeeMutationVariables> {
    override document = AddDelegantEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveDelegantEmployeeDocument = gql`
    mutation RemoveDelegantEmployee($input: delegantApprovalMutationInput!) {
  removeDelegantEmployee(input: $input) {
    approval_type
    original_approver {
      full_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDelegantEmployeeGQL extends Apollo.Mutation<RemoveDelegantEmployeeMutation, RemoveDelegantEmployeeMutationVariables> {
    override document = RemoveDelegantEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExpenseApprovalsWithFiltersDocument = gql`
    query GetExpenseApprovalsWithFilters($input: expenseRequestFilter) {
  getExpenseApprovalsWithFilters(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      _id
      expense_type
      expense_total_amount
      expense_date
      description
      approval_description
      approval_status
      status
      is_deleted
      document_url
      employee {
        id
        full_name
      }
      behalf_of {
        id
        full_name
      }
      created_at
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExpenseApprovalsWithFiltersGQL extends Apollo.Query<GetExpenseApprovalsWithFiltersQuery, GetExpenseApprovalsWithFiltersQueryVariables> {
    override document = GetExpenseApprovalsWithFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateExpenseApprovalDocument = gql`
    mutation UpdateExpenseApproval($input: InputUpdateExpenseApproval!) {
  updateExpenseApproval(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExpenseApprovalGQL extends Apollo.Mutation<UpdateExpenseApprovalMutation, UpdateExpenseApprovalMutationVariables> {
    override document = UpdateExpenseApprovalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTimeOffApprovalsWithSearchDocument = gql`
    query GetTimeOffApprovalsWithSearch($input: timeOffListFilter) {
  getTimeOffApprovalsWithSearch(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      is_short_leave
      _id
      is_deleted
      approval_status
      behalf_of {
        full_name
        _id
      }
      is_pto
      employee {
        id
        email
        first_name
        middle_name
        last_name
        full_name
      }
      leave_request_dates {
        from_date
        to_date
      }
      reason_for_leave
      total_leaves
      no_request
      created_at
      total_request_leaves
      total_unpaid_leaves
      remaining_unpaid_days
      request_id
      countIn
      remaining_days
      status
      type_of_absence {
        _id
        name
        is_pto
        type
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTimeOffApprovalsWithSearchGQL extends Apollo.Query<GetTimeOffApprovalsWithSearchQuery, GetTimeOffApprovalsWithSearchQueryVariables> {
    override document = GetTimeOffApprovalsWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTimeOffByIdDocument = gql`
    query GetTimeOffById($_id: ID!) {
  getTimeOffById(_id: $_id) {
    _id
    is_compansation_leave
    approval_status
    behalf_of {
      full_name
      _id
    }
    is_sandwich
    is_short_leave
    upload_document_info {
      size
      extension
      name
    }
    document_url
    sandwich {
      date_of_sandwich {
        date
        day
      }
      difference_in_days
      difference_in_hours
    }
    employee {
      id
      _id
      full_name
      first_name
      last_name
      time_off {
        time_off_category
        time_off_days
        time_off_type {
          _id
          name
        }
      }
      pto_minutes {
        pto_earned_minutes
        pto_availed_minutes
      }
    }
    accept_reject_leave {
      leave_date
      start_time
      end_time
      leave_type
      from_date
      to_date
      no_of_days
      status
    }
    reason_for_leave
    work_flow {
      approved_by {
        id
        _id
        full_name
      }
      approval_description
      status
      action_date
      deleted_date
      delegated_user {
        _id
        full_name
      }
      employee {
        full_name
        first_name
        last_name
        _id
      }
    }
    type_of_absence {
      _id
      name
      count_after_days
      is_count_after
      is_not_count_as_leave
      is_pto
      maximum_duration
      half_leave_in_ful_leave
      un_paid_days
      type
      leave_duration
    }
    countIn
    reason_for_leave
    total_leaves
    total_leave_out_of_accural
    total_unpaid_leaves
    remaining_unpaid_days
    remaining_days
    date_type_leave {
      leave_date
      leave_type
    }
    leave_request {
      totalMinuts
      start_time
      end_time
      leave_type
      is_sandwich
      from_date
      to_date
      no_of_days
      status
      out_of_accural_leave_days
      out_of_accural_leave_hours
    }
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTimeOffByIdGQL extends Apollo.Query<GetTimeOffByIdQuery, GetTimeOffByIdQueryVariables> {
    override document = GetTimeOffByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTimeOffApprovalDocument = gql`
    mutation UpdateTimeOffApproval($input: updateLeaveRequest!) {
  updateTimeOffApproval(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTimeOffApprovalGQL extends Apollo.Mutation<UpdateTimeOffApprovalMutation, UpdateTimeOffApprovalMutationVariables> {
    override document = UpdateTimeOffApprovalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTimeOffDocument = gql`
    mutation DeleteTimeOff($ids: [ID]!) {
  deleteTimeOff(ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTimeOffGQL extends Apollo.Mutation<DeleteTimeOffMutation, DeleteTimeOffMutationVariables> {
    override document = DeleteTimeOffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLoanApprovalsWithFiltersDocument = gql`
    query GetLoanApprovalsWithFilters($input: loanRequestFilter) {
  getLoanApprovalsWithFilters(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      _id
      loan_type
      loan_amount
      loan_taken_date
      no_of_installment
      installment_amount
      loan_recovery_method
      payment
      payment_start_date
      balance
      description
      approval_description
      approval_status
      status
      is_deleted
      employee {
        id
        full_name
      }
      updated_by {
        id
        full_name
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLoanApprovalsWithFiltersGQL extends Apollo.Query<GetLoanApprovalsWithFiltersQuery, GetLoanApprovalsWithFiltersQueryVariables> {
    override document = GetLoanApprovalsWithFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLoanApprovalDocument = gql`
    mutation UpdateLoanApproval($input: updateLoanRequest!) {
  updateLoanApproval(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLoanApprovalGQL extends Apollo.Mutation<UpdateLoanApprovalMutation, UpdateLoanApprovalMutationVariables> {
    override document = UpdateLoanApprovalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAppraisalObjectiveDocument = gql`
    query GetAllAppraisalObjective($input: inputAppraisalObjective) {
  getAllAppraisalObjective(input: $input) {
    config {
      actions {
        name
        is_visible
      }
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
    }
    results {
      _id
      name
      description
      is_deleted
      AppraisalType {
        _id
        name
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAppraisalObjectiveGQL extends Apollo.Query<GetAllAppraisalObjectiveQuery, GetAllAppraisalObjectiveQueryVariables> {
    override document = GetAllAppraisalObjectiveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAppraisalObjectiveByIdDocument = gql`
    query GetAppraisalObjectiveById($id: ID!) {
  getAppraisalObjectiveById(_id: $id) {
    _id
    name
    description
    weight_percent
    is_deleted
    AppraisalType {
      _id
      name
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAppraisalObjectiveByIdGQL extends Apollo.Query<GetAppraisalObjectiveByIdQuery, GetAppraisalObjectiveByIdQueryVariables> {
    override document = GetAppraisalObjectiveByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAppraisalObjectiveDocument = gql`
    mutation CreateAppraisalObjective($input: createAppraisalObjecive!) {
  createAppraisalObjective(input: $input) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAppraisalObjectiveGQL extends Apollo.Mutation<CreateAppraisalObjectiveMutation, CreateAppraisalObjectiveMutationVariables> {
    override document = CreateAppraisalObjectiveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAppraisalObjectiveDocument = gql`
    mutation UpdateAppraisalObjective($input: updateAppraisalObjecive!) {
  updateAppraisalObjective(input: $input) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAppraisalObjectiveGQL extends Apollo.Mutation<UpdateAppraisalObjectiveMutation, UpdateAppraisalObjectiveMutationVariables> {
    override document = UpdateAppraisalObjectiveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAppraisalObjectiveDocument = gql`
    mutation ArchiveAppraisalObjective($id: [ID!]!, $archive: Boolean!) {
  archiveAppraisalObjective(_id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAppraisalObjectiveGQL extends Apollo.Mutation<ArchiveAppraisalObjectiveMutation, ArchiveAppraisalObjectiveMutationVariables> {
    override document = ArchiveAppraisalObjectiveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllActiveAppraisalTypeDocument = gql`
    query GetAllActiveAppraisalType {
  getAllActiveAppraisalType {
    _id
    name
    target_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllActiveAppraisalTypeGQL extends Apollo.Query<GetAllActiveAppraisalTypeQuery, GetAllActiveAppraisalTypeQueryVariables> {
    override document = GetAllActiveAppraisalTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAppraisalTypeDocument = gql`
    query GetAllAppraisalType($input: inputAllAppraisalType) {
  getAllAppraisalType(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      name
      description
      target_type
      status
      is_deleted
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAppraisalTypeGQL extends Apollo.Query<GetAllAppraisalTypeQuery, GetAllAppraisalTypeQueryVariables> {
    override document = GetAllAppraisalTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAppraisalTypeByIdDocument = gql`
    query GetAppraisalTypeById($id: ID!) {
  getAppraisalTypeById(_id: $id) {
    _id
    name
    description
    target_type
    status
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAppraisalTypeByIdGQL extends Apollo.Query<GetAppraisalTypeByIdQuery, GetAppraisalTypeByIdQueryVariables> {
    override document = GetAppraisalTypeByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAppraisalTypeDocument = gql`
    mutation CreateAppraisalType($input: InputAppraisalType!) {
  createAppraisalType(input: $input) {
    _id
    name
    target_type
    description
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAppraisalTypeGQL extends Apollo.Mutation<CreateAppraisalTypeMutation, CreateAppraisalTypeMutationVariables> {
    override document = CreateAppraisalTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAppraisalTypeDocument = gql`
    mutation UpdateAppraisalType($input: updateAppraisalType!) {
  updateAppraisalType(input: $input) {
    _id
    status
    description
    is_deleted
    target_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAppraisalTypeGQL extends Apollo.Mutation<UpdateAppraisalTypeMutation, UpdateAppraisalTypeMutationVariables> {
    override document = UpdateAppraisalTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAppraisalTypeDocument = gql`
    mutation DeleteAppraisalType($deleteAppraisalTypeId: [ID!]!, $archive: Boolean!) {
  deleteAppraisalType(id: $deleteAppraisalTypeId, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAppraisalTypeGQL extends Apollo.Mutation<DeleteAppraisalTypeMutation, DeleteAppraisalTypeMutationVariables> {
    override document = DeleteAppraisalTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllEvaluationDocument = gql`
    query GetAllEvaluation($input: inputAllEvaluation) {
  getAllEvaluation(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      _id
      remark
      total_score
      status
      is_deleted
      User {
        id
        full_name
        designation {
          designation_name
        }
      }
      PerformanceCycle {
        _id
        name
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllEvaluationGQL extends Apollo.Query<GetAllEvaluationQuery, GetAllEvaluationQueryVariables> {
    override document = GetAllEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMyEvaluationDocument = gql`
    query GetMyEvaluation($input: inputAllEvaluation) {
  getMyEvaluation(input: $input) {
    config {
      actions {
        name
        is_visible
      }
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      page
      limit
      totalPages
      totalResults
      no_of_records
      type
    }
    results {
      _id
      remark
      total_score
      status
      is_deleted
      User {
        full_name
        designation {
          designation_name
        }
      }
      PerformanceCycle {
        name
        _id
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMyEvaluationGQL extends Apollo.Query<GetMyEvaluationQuery, GetMyEvaluationQueryVariables> {
    override document = GetMyEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEvaluationByIdDocument = gql`
    query GetEvaluationById($id: ID!) {
  getEvaluationById(_id: $id) {
    _id
    remark
    milestone
    listProjects
    road_map
    trainingRequired
    performanceGoals
    total_score
    status
    PerformanceCycle {
      name
      status
      appraisal_setting {
        weight_percent
        AppraisalType {
          _id
        }
      }
    }
    objectiveAssigned {
      _id
      total_weight
      AppraisalType {
        _id
        name
        is_task
        is_punctuality
        totalHours
        total_hours_logged
        clockHistoryCount
      }
      objective {
        _id
        score
        target
        remark
        weight_percent
        AppraisalObjective {
          _id
          name
        }
      }
    }
    User {
      id
      full_name
      employee_id
      joining_date
      designation {
        designation_name
      }
      department {
        department_name
      }
      profile_pictures {
        path
      }
    }
    created_by {
      full_name
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEvaluationByIdGQL extends Apollo.Query<GetEvaluationByIdQuery, GetEvaluationByIdQueryVariables> {
    override document = GetEvaluationByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEvaluationDocument = gql`
    mutation UpdateEvaluation($input: updateEvaluationInput) {
  updateEvaluation(input: $input) {
    remark
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEvaluationGQL extends Apollo.Mutation<UpdateEvaluationMutation, UpdateEvaluationMutationVariables> {
    override document = UpdateEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateObjectiveAssignmentDocument = gql`
    mutation UpdateObjectiveAssignment($input: updateInputObjectiveAssignment!) {
  updateObjectiveAssignment(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateObjectiveAssignmentGQL extends Apollo.Mutation<UpdateObjectiveAssignmentMutation, UpdateObjectiveAssignmentMutationVariables> {
    override document = UpdateObjectiveAssignmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllGoalsListDocument = gql`
    query GetAllGoalsList($input: inputAllEvaluation) {
  getAllGoalsList(input: $input) {
    config {
      actions {
        name
        is_visible
      }
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      page
      limit
      totalPages
      totalResults
      no_of_records
      type
    }
    results {
      _id
      start_date
      end_date
      status
      User {
        id
        full_name
      }
      PerformanceCycle {
        _id
        name
        start_date
        end_date
        status
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllGoalsListGQL extends Apollo.Query<GetAllGoalsListQuery, GetAllGoalsListQueryVariables> {
    override document = GetAllGoalsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGroupGoalsListDocument = gql`
    query GetGroupGoalsList($input: inputAllEvaluation) {
  getGroupGoalsList(input: $input) {
    config {
      limit
      page
      totalPages
      totalResults
      no_of_records
      type
      actions {
        name
        is_visible
      }
      columns {
        _id
        field
        header
        type
        search
        is_unique
        pinned
        width
        is_groupable
        is_editable
        is_search_able
        query {
          first_condition
          second_condition
          first_value
          second_value
          condition
        }
        is_visible
        filterValue
        is_sortable
        column_data
        column_dropdown_value {
          _id
          value
        }
      }
      filters {
        search
        field
        type
        _ids
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
      }
      table_preset {
        activeFilters
        columns {
          width
          type
          search
          query {
            condition
            first_condition
            first_value
            second_condition
            second_value
          }
          _id
          column_data
          column_dropdown_value {
            _id
            value
          }
          field
          filterValue
          header
          is_amount
          is_groupable
          is_unique
          is_required
          is_editable
          validateFn
          is_search_able
          is_sortable
          is_visible
          pinned
        }
        config {
          bodyTextFontsSize
          fontFaimly
          globalSearch
          headerTextFontsSize
          selectedTableLayout
          showVerticalBorder
          rowShadingEnabled
        }
        filters {
          _ids
          field
          query {
            condition
            first_condition
            first_value
            second_condition
            second_value
          }
          search
          type
        }
        id
        is_default
        is_temp
        loadingCall
        name
        type
      }
    }
    results {
      _id
      end_date
      start_date
      name
      status
      employees_count
      detail {
        actions {
          name
          is_visible
        }
        columns {
          _id
          field
          header
          is_amount
        }
        result {
          id
          full_name
          employee_id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGroupGoalsListGQL extends Apollo.Query<GetGroupGoalsListQuery, GetGroupGoalsListQueryVariables> {
    override document = GetGroupGoalsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReportObjectiveAssigmentDocument = gql`
    query GetReportObjectiveAssigment($input: inputGetReportObjective) {
  getReportObjectiveAssigment(input: $input) {
    results {
      _id
      start_date
      end_date
      PerformanceCycle {
        name
      }
      User {
        full_name
        department {
          department_name
        }
      }
      detail {
        columns {
          _id
          header
          field
        }
        result {
          _id
          score
          target
          weight_percent
          AppraisalType {
            name
          }
          appraisers {
            full_name
            designation {
              designation_name
            }
          }
          appraisal {
            full_name
          }
          AppraisalObjective {
            description
            name
          }
        }
      }
    }
    config {
      limit
      page
      totalPages
      totalResults
      no_of_records
      type
      columns {
        _id
        field
        header
        type
        search
        is_unique
        pinned
        width
        is_groupable
        is_editable
        is_search_able
        query {
          first_condition
          second_condition
          first_value
          second_value
          condition
        }
        is_visible
        filterValue
        is_sortable
        column_data
        column_dropdown_value {
          _id
          value
        }
      }
      filters {
        search
        field
        type
        _ids
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
      }
      table_preset {
        activeFilters
        columns {
          width
          type
          search
          query {
            condition
            first_condition
            first_value
            second_condition
            second_value
          }
          _id
          column_data
          column_dropdown_value {
            _id
            value
          }
          field
          filterValue
          header
          is_amount
          is_groupable
          is_unique
          is_required
          is_editable
          validateFn
          is_search_able
          is_sortable
          is_visible
          pinned
        }
        config {
          bodyTextFontsSize
          fontFaimly
          globalSearch
          headerTextFontsSize
          selectedTableLayout
          showVerticalBorder
          rowShadingEnabled
        }
        filters {
          _ids
          field
          query {
            condition
            first_condition
            first_value
            second_condition
            second_value
          }
          search
          type
        }
        id
        is_default
        is_temp
        loadingCall
        name
        type
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReportObjectiveAssigmentGQL extends Apollo.Query<GetReportObjectiveAssigmentQuery, GetReportObjectiveAssigmentQueryVariables> {
    override document = GetReportObjectiveAssigmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReviewcyclereportDocument = gql`
    query GetReviewcyclereport($input: inputReviewcyclereport) {
  getReviewcyclereport(input: $input) {
    config {
      limit
      page
      totalPages
      totalResults
      no_of_records
      type
      actions {
        name
        is_visible
      }
      columns {
        _id
        field
        header
        type
        search
        is_unique
        pinned
        width
        is_groupable
        is_editable
        is_search_able
        query {
          first_condition
          second_condition
          first_value
          second_value
          condition
        }
        is_visible
        filterValue
        is_sortable
        column_data
        column_dropdown_value {
          _id
          value
        }
      }
      filters {
        search
        field
        type
        _ids
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
      }
      table_preset {
        activeFilters
        columns {
          width
          type
          search
          query {
            condition
            first_condition
            first_value
            second_condition
            second_value
          }
          _id
          column_data
          column_dropdown_value {
            _id
            value
          }
          field
          filterValue
          header
          is_amount
          is_groupable
          is_unique
          is_required
          is_editable
          validateFn
          is_search_able
          is_sortable
          is_visible
          pinned
        }
        config {
          bodyTextFontsSize
          fontFaimly
          globalSearch
          headerTextFontsSize
          selectedTableLayout
          showVerticalBorder
          rowShadingEnabled
        }
        filters {
          _ids
          field
          query {
            condition
            first_condition
            first_value
            second_condition
            second_value
          }
          search
          type
        }
        id
        is_default
        is_temp
        loadingCall
        name
        type
      }
    }
    results {
      _id
      start_date
      end_date
      total_score
      status
      User {
        employee_id
        full_name
      }
      PerformanceCycle {
        _id
        name
        start_date
        end_date
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReviewcyclereportGQL extends Apollo.Query<GetReviewcyclereportQuery, GetReviewcyclereportQueryVariables> {
    override document = GetReviewcyclereportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPerformanceCycleListDocument = gql`
    query GetPerformanceCycleList($input: inputPerformanceCycleType) {
  getPerformanceCycleList(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      end_date
      is_all
      is_deleted
      is_linear_flow
      name
      start_date
      status
      description
      actions
      employees {
        full_name
        email
        id
      }
      appraisal_setting {
        AppraisalScale {
          _id
          created_by {
            full_name
            id
            email
          }
        }
        AppraisalType {
          _id
          is_task
          is_punctuality
          is_deleted
          name
          status
          target_type
          totalHours
          description
          clockHistoryCount
        }
        assign_by {
          id
          full_name
        }
        weight_percent
        objective
        task {
          count
          status
        }
      }
      appraiser_setting {
        appraiser_type
        weight_percent
        AppraisalType {
          _id
          description
          is_deleted
          is_punctuality
          is_task
          name
          status
          target_type
          totalHours
          clockHistoryCount
        }
        User {
          id
          full_name
        }
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPerformanceCycleListGQL extends Apollo.Query<GetPerformanceCycleListQuery, GetPerformanceCycleListQueryVariables> {
    override document = GetPerformanceCycleListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPerformanceCycleByIdDocument = gql`
    query GetPerformanceCycleById($getPerformanceCycleByIdId: ID!) {
  getPerformanceCycleById(id: $getPerformanceCycleByIdId) {
    status
    start_date
    assigning_start_date
    name
    is_linear_flow
    is_deleted
    is_all
    end_date
    description
    _id
    appraisal_setting {
      weight_percent
      objective
      assign_by {
        first_name
        full_name
        id
        last_name
      }
      AppraisalType {
        _id
        name
        target_type
      }
      AppraisalScale {
        _id
        name
      }
    }
    employees {
      id
      first_name
      full_name
      last_name
    }
    Department {
      _id
      department_name
    }
    Role {
      _id
      roleName
    }
    appraiser_setting {
      weight_percent
      appraiser_type
      User {
        id
        full_name
        first_name
        last_name
      }
      AppraisalType {
        _id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPerformanceCycleByIdGQL extends Apollo.Query<GetPerformanceCycleByIdQuery, GetPerformanceCycleByIdQueryVariables> {
    override document = GetPerformanceCycleByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAppraisalObejctiveByPerformanceCycleDocument = gql`
    query GetAppraisalObejctiveByPerformanceCycle($id: ID!) {
  getAppraisalObejctiveByPerformanceCycle(_id: $id) {
    _id
    name
    weight_percent
    AppraisalType {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAppraisalObejctiveByPerformanceCycleGQL extends Apollo.Query<GetAppraisalObejctiveByPerformanceCycleQuery, GetAppraisalObejctiveByPerformanceCycleQueryVariables> {
    override document = GetAppraisalObejctiveByPerformanceCycleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePerformanceCycleDocument = gql`
    mutation CreatePerformanceCycle($input: performanceCycleInput) {
  createPerformanceCycle(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePerformanceCycleGQL extends Apollo.Mutation<CreatePerformanceCycleMutation, CreatePerformanceCycleMutationVariables> {
    override document = CreatePerformanceCycleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePerformanceCycleDocument = gql`
    mutation UpdatePerformanceCycle($input: updatePerformanceCycleInput) {
  updatePerformanceCycle(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePerformanceCycleGQL extends Apollo.Mutation<UpdatePerformanceCycleMutation, UpdatePerformanceCycleMutationVariables> {
    override document = UpdatePerformanceCycleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePerformanceCycleStatusDocument = gql`
    mutation UpdatePerformanceCycleStatus($input: updatePerformanceCycleStatusInput) {
  updatePerformanceCycleStatus(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePerformanceCycleStatusGQL extends Apollo.Mutation<UpdatePerformanceCycleStatusMutation, UpdatePerformanceCycleStatusMutationVariables> {
    override document = UpdatePerformanceCycleStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchivePerformanceCycleDocument = gql`
    mutation ArchivePerformanceCycle($archive: Boolean!, $deletePerformanceCycleId: [ID!]) {
  deletePerformanceCycle(archive: $archive, id: $deletePerformanceCycleId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchivePerformanceCycleGQL extends Apollo.Mutation<ArchivePerformanceCycleMutation, ArchivePerformanceCycleMutationVariables> {
    override document = ArchivePerformanceCycleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomGradeScaleDocument = gql`
    query GetCustomGradeScale {
  getCustomGradeScale {
    name
    _id
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomGradeScaleGQL extends Apollo.Query<GetCustomGradeScaleQuery, GetCustomGradeScaleQueryVariables> {
    override document = GetCustomGradeScaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetObjectiveAssignmentByIdDocument = gql`
    query GetObjectiveAssignmentById($id: ID!) {
  getObjectiveAssignmentById(_id: $id) {
    _id
    PerformanceCycle {
      appraisal_setting {
        objective
        weight_percent
        AppraisalType {
          _id
          name
          is_task
          is_punctuality
          totalHours
        }
      }
    }
    objectiveAssigned {
      _id
      AppraisalType {
        _id
        name
        is_task
        is_punctuality
        totalHours
      }
      objective {
        _id
        remark
        target
        weight_percent
        AppraisalObjective {
          _id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetObjectiveAssignmentByIdGQL extends Apollo.Query<GetObjectiveAssignmentByIdQuery, GetObjectiveAssignmentByIdQueryVariables> {
    override document = GetObjectiveAssignmentByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllObjectiveAssignmentDocument = gql`
    query GetAllObjectiveAssignment($input: inputAllobjectiveAssignment) {
  getAllObjectiveAssignment(input: $input) {
    results {
      _id
      start_date
      end_date
      User {
        id
        full_name
        designation {
          designation_name
          _id
        }
      }
      PerformanceCycle {
        name
        _id
      }
      status
      linearFlow {
        level
        User
        objectiveStatus
        status
      }
      objectiveAssigned {
        AppraisalType {
          totalHours
          target_type
          status
          name
          is_task
          is_punctuality
          is_deleted
          description
          clockHistoryCount
          _id
        }
        total_weight
        total_target
        total_score
        total
        task {
          status
          count
        }
        objective {
          AppraisalObjective {
            weight_percent
            name
            is_deleted
            description
            _id
            AppraisalType {
              totalHours
              target_type
              status
              name
              is_task
              is_punctuality
              is_deleted
              description
              clockHistoryCount
              _id
            }
          }
          _id
          remark
          score
          target
          weight_percent
        }
      }
    }
    config {
      ...ConfigWithoutSummaryFields
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllObjectiveAssignmentGQL extends Apollo.Query<GetAllObjectiveAssignmentQuery, GetAllObjectiveAssignmentQueryVariables> {
    override document = GetAllObjectiveAssignmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGoalsForExtendedViewDocument = gql`
    query GetGoalsForExtendedView($userId: ID!, $performanceCycleId: ID!) {
  getGoalsForExtendedView(
    userId: $userId
    performanceCycleId: $performanceCycleId
  ) {
    _id
    weight_percent
    created_by {
      full_name
      id
      _id
    }
    objectiveAssigned {
      _id
      AppraisalType {
        _id
        name
        is_task
        is_punctuality
        clockHistoryCount
        totalHours
      }
      objective {
        _id
        score
        target
        remark
        weight_percent
        AppraisalObjective {
          _id
          name
        }
      }
    }
    User {
      id
      logo
      full_name
      department {
        department_name
      }
      designation {
        designation_name
      }
      employee_id
      joining_date
      profile_pictures {
        path
      }
    }
    assignTo {
      id
      full_name
      department {
        department_name
      }
      designation {
        designation_name
      }
      employee_id
      joining_date
    }
    remark
    milestone
    listProjects
    road_map
    trainingRequired
    performanceGoals
    total_score
    PerformanceCycle {
      name
      appraisal_setting {
        weight_percent
        AppraisalType {
          _id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGoalsForExtendedViewGQL extends Apollo.Query<GetGoalsForExtendedViewQuery, GetGoalsForExtendedViewQueryVariables> {
    override document = GetGoalsForExtendedViewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendEmployeeEvaluationEmailDocument = gql`
    mutation SendEmployeeEvaluationEmail($input: [evaluationEmailInput]) {
  sendEmployeeEvaluationEmail(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendEmployeeEvaluationEmailGQL extends Apollo.Mutation<SendEmployeeEvaluationEmailMutation, SendEmployeeEvaluationEmailMutationVariables> {
    override document = SendEmployeeEvaluationEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllActiveAndInActiveEmployeesDocument = gql`
    query GetAllActiveAndInActiveEmployees($businessId: ID!, $feature: featureEnum) {
  getAllActiveAndInActiveEmployees(business_id: $businessId, feature: $feature) {
    id
    full_name
    email
    employee_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllActiveAndInActiveEmployeesGQL extends Apollo.Query<GetAllActiveAndInActiveEmployeesQuery, GetAllActiveAndInActiveEmployeesQueryVariables> {
    override document = GetAllActiveAndInActiveEmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserByRolePermissionsDocument = gql`
    query GetUserByRolePermissions($featureName: String!) {
  getUserByRolePermissions(featureName: $featureName) {
    id
    full_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserByRolePermissionsGQL extends Apollo.Query<GetUserByRolePermissionsQuery, GetUserByRolePermissionsQueryVariables> {
    override document = GetUserByRolePermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAppraisalScalesDocument = gql`
    query GetAllAppraisalScales($input: inputAppraisalScales) {
  getAllAppraisalScales(input: $input) {
    config {
      actions {
        name
        is_visible
      }
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
    }
    results {
      _id
      name
      total_score
      is_custom_grade
      is_deleted
      scale_group {
        maximum_value
        minimum_value
        scroe_name
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAppraisalScalesGQL extends Apollo.Query<GetAllAppraisalScalesQuery, GetAllAppraisalScalesQueryVariables> {
    override document = GetAllAppraisalScalesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAppraisalScaleByIdDocument = gql`
    query GetAppraisalScaleById($id: ID!) {
  getAppraisalScaleById(_id: $id) {
    _id
    name
    is_custom_grade
    total_score
    scale_group {
      maximum_value
      minimum_value
      scroe_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAppraisalScaleByIdGQL extends Apollo.Query<GetAppraisalScaleByIdQuery, GetAppraisalScaleByIdQueryVariables> {
    override document = GetAppraisalScaleByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAppraisalScaleDocument = gql`
    mutation CreateAppraisalScale($input: addAppraisalScale!) {
  createAppraisalScale(input: $input) {
    _id
    name
    is_deleted
    is_custom_grade
    total_score
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAppraisalScaleGQL extends Apollo.Mutation<CreateAppraisalScaleMutation, CreateAppraisalScaleMutationVariables> {
    override document = CreateAppraisalScaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAppraisalScaleDocument = gql`
    mutation UpdateAppraisalScale($input: updateInputAppraisaleScale) {
  updateAppraisalScale(input: $input) {
    _id
    is_deleted
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAppraisalScaleGQL extends Apollo.Mutation<UpdateAppraisalScaleMutation, UpdateAppraisalScaleMutationVariables> {
    override document = UpdateAppraisalScaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAppraisalScaleDocument = gql`
    mutation ArchiveAppraisalScale($id: [ID!]!, $archive: Boolean!) {
  archiveAppraisalScale(_id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAppraisalScaleGQL extends Apollo.Mutation<ArchiveAppraisalScaleMutation, ArchiveAppraisalScaleMutationVariables> {
    override document = ArchiveAppraisalScaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserConnectedAppListDocument = gql`
    query GetUserConnectedAppList($input: queryInputTerminalAppDevice!) {
  getUserConnectedAppList(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      is_allow_attendance
      latitude
      longitude
      User {
        full_name
        email
        employee_id
        _id
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserConnectedAppListGQL extends Apollo.Query<GetUserConnectedAppListQuery, GetUserConnectedAppListQueryVariables> {
    override document = GetUserConnectedAppListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserAppDeviceListDocument = gql`
    query GetUserAppDeviceList($input: queryInputUserAppDevice!) {
  getUserAppDeviceList(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      terminal_name
      device_model
      device_name
      device_manufacturer
      device_id
      longitude
      latitude
      app_type
      is_allow_attendance
      User {
        full_name
        email
        _id
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserAppDeviceListGQL extends Apollo.Query<GetUserAppDeviceListQuery, GetUserAppDeviceListQueryVariables> {
    override document = GetUserAppDeviceListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserAppDevicesDocument = gql`
    query GetUserAppDevices($appType: appTypes!) {
  getUserAppDevices(app_type: $appType) {
    _id
    device_model
    device_manufacturer
    device_name
    longitude
    latitude
    User {
      id
      full_name
      email
      logo
      profile_pictures {
        path
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserAppDevicesGQL extends Apollo.Query<GetUserAppDevicesQuery, GetUserAppDevicesQueryVariables> {
    override document = GetUserAppDevicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserAppDeviceCountDocument = gql`
    query GetUserAppDeviceCount {
  getUserAppDeviceCount {
    allowAttendanceCount
    linked_device_count
    notAllowAttendanceCount
    terminal_app_device_count
    unlinked_device_count
    user_app_device_count
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserAppDeviceCountGQL extends Apollo.Query<GetUserAppDeviceCountQuery, GetUserAppDeviceCountQueryVariables> {
    override document = GetUserAppDeviceCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAuthentictorsEmployeesDocument = gql`
    query GetAuthentictorsEmployees {
  getAuthentictorsEmployees {
    authentictorsEmployees {
      id
      full_name
      logo
      employee_id
      allow_sms
      allow_qr_code
      allow_email
    }
    unAuthentictorsEmployees {
      id
      full_name
      logo
      employee_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAuthentictorsEmployeesGQL extends Apollo.Query<GetAuthentictorsEmployeesQuery, GetAuthentictorsEmployeesQueryVariables> {
    override document = GetAuthentictorsEmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTerminalAppHistoryDocument = gql`
    query GetTerminalAppHistory($input: inputTerminalAppHistory) {
  getTerminalAppHistory(input: $input) {
    results {
      device_id
      is_deleted
      latitude
      longitude
      User {
        _id
        full_name
        id
        employee_id
      }
      time
      UserAppDevice {
        status
      }
      is_deleted
      action_date
      action
    }
    config {
      type
      totalResults
      totalPages
      page
      limit
      filters {
        search
        field
        type
        _ids
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
      }
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      actions {
        name
        is_visible
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTerminalAppHistoryGQL extends Apollo.Query<GetTerminalAppHistoryQuery, GetTerminalAppHistoryQueryVariables> {
    override document = GetTerminalAppHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceInfoByIdDocument = gql`
    query GetDeviceInfoById($input: inputDeviceInfoById) {
  getDeviceInfoById(input: $input) {
    results {
      _id
      action
      action_date
      app_type
      device_id
      is_deleted
      latitude
      longitude
      User {
        full_name
      }
      UserAppDevice {
        device_id
        device_manufacturer
        device_model
        device_name
        latitude
        longitude
      }
    }
    config {
      type
      totalResults
      totalPages
      page
      limit
      columns {
        _id
        field
        header
        is_search_able
        query {
          first_condition
          second_condition
          first_value
          second_value
          condition
        }
        type
        search
        is_visible
        column_dropdown_value {
          _id
          value
        }
      }
      filters {
        ...FilterFields
      }
      actions {
        name
        is_visible
      }
    }
  }
}
    ${FilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceInfoByIdGQL extends Apollo.Query<GetDeviceInfoByIdQuery, GetDeviceInfoByIdQueryVariables> {
    override document = GetDeviceInfoByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllowAttendanceDocument = gql`
    mutation AllowAttendance($_id: ID!, $isAllow: Boolean!) {
  allowAttendance(_id: $_id, is_allow: $isAllow)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllowAttendanceGQL extends Apollo.Mutation<AllowAttendanceMutation, AllowAttendanceMutationVariables> {
    override document = AllowAttendanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnlinkUserAppDeviceDocument = gql`
    mutation UnlinkUserAppDevice($_id: ID!) {
  unlinkUserAppDevice(_id: $_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnlinkUserAppDeviceGQL extends Apollo.Mutation<UnlinkUserAppDeviceMutation, UnlinkUserAppDeviceMutationVariables> {
    override document = UnlinkUserAppDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetEmployeeAuthenticatedDocument = gql`
    mutation SetEmployeeAuthenticated($ids: [ID!], $allowEmail: Boolean, $allowSms: Boolean, $allowQrCode: Boolean) {
  setEmployeeAuthenticated(
    ids: $ids
    allow_email: $allowEmail
    allow_sms: $allowSms
    allow_qr_code: $allowQrCode
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetEmployeeAuthenticatedGQL extends Apollo.Mutation<SetEmployeeAuthenticatedMutation, SetEmployeeAuthenticatedMutationVariables> {
    override document = SetEmployeeAuthenticatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetEmployeeUnAuthenticatedDocument = gql`
    mutation SetEmployeeUnAuthenticated($empId: ID!) {
  setEmployeeUnAuthenticated(emp_id: $empId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetEmployeeUnAuthenticatedGQL extends Apollo.Mutation<SetEmployeeUnAuthenticatedMutation, SetEmployeeUnAuthenticatedMutationVariables> {
    override document = SetEmployeeUnAuthenticatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddUserRadiusDocument = gql`
    mutation AddUserRadius($radius: Float, $timeInterval: Float) {
  addUserRadius(radius: $radius, time_interval: $timeInterval) {
    radius
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUserRadiusGQL extends Apollo.Mutation<AddUserRadiusMutation, AddUserRadiusMutationVariables> {
    override document = AddUserRadiusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetZipCodeWithFilterDocument = gql`
    query GetZipCodeWithFilter($input: ZipCodeFilterInput) {
  getZipCodeWithFilter(input: $input) {
    _id
    zipcode
    city_name
    state_name
    country_name
    City {
      _id
    }
    State {
      _id
    }
    Country {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetZipCodeWithFilterGQL extends Apollo.Query<GetZipCodeWithFilterQuery, GetZipCodeWithFilterQueryVariables> {
    override document = GetZipCodeWithFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllEmployeesDocument = gql`
    query GetAllEmployees($input: employeeListFilter) {
  getEmployeesWithSearch(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      id
      logo
      profile_pictures {
        dimension
        path
      }
      is_deleted
      employee_id
      full_name
      email
      basic_salary
      pay_schedule_salary
      over_time_rate
      phone
      gender
      birth_date
      employee_type
      salary_payment_method
      salary_type
      account_status
      joining_date
      auth_pin
      user_keeping_unit
      pay_type
      total_week_hours
      new_salary_effect_from
      final_settlement_completed
      state {
        _id
        state_name
      }
      Country {
        _id
        name
      }
      city {
        _id
        city_name
      }
      pay_schedule {
        pay_period
      }
      shift {
        _id
        shift_name
      }
      designation {
        _id
        designation_name
      }
      line_manager {
        _id
        full_name
      }
      department {
        _id
        department_name
      }
      roles {
        _id
        roleName
      }
      employee_group {
        _id
        group_name
        pay_type {
          _id
          schedule_name
        }
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllEmployeesGQL extends Apollo.Query<GetAllEmployeesQuery, GetAllEmployeesQueryVariables> {
    override document = GetAllEmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeByIdDocument = gql`
    query GetEmployeeById($id: ID!) {
  getEmployeeByID(_id: $id) {
    leave_policy {
      _id
      name
      is_deleted
    }
    id
    email
    final_settlement_completed
    is_generate_joining_letter
    last_working_date
    sepration_description
    final_settlement_date
    probation_period
    joining_latter {
      date
      description
      footer
      Joining_formalities
    }
    is_customzied_overtime
    ssn_last_four_digit
    profile_pictures {
      dimension
      path
    }
    employee_id
    first_name
    over_time_rate
    middle_name
    last_name
    full_name
    phone
    phone_country_code
    landline
    avatar_location
    home_no
    mobile_no_to_send_sms
    status
    badge_code
    is_password_set
    is_business_owner_requested_new_password
    vehicle_type
    vehicle_no
    license_no
    business_id {
      business_system_name
      business_legal_name
      logo
    }
    time_off {
      time_off_type {
        _id
        name
        code
        type
      }
      time_off_category
      time_off_days
    }
    medical_insurance {
      insurance_card
      insurance_class
      expiry_date_of_policy
      total_policy_amount_monthly
    }
    air_ticket {
      no_of_air_tickets
      air_tickets_frequency
      destination_city
      air_ticket_class
      orignal_city
      orignal_country {
        _id
        name
      }
      destination_country {
        _id
        name
      }
    }
    address_1
    address_2
    city {
      _id
      city_name
    }
    state {
      _id
      state_name
    }
    zipcode
    user_keeping_unit
    salaryHour
    is_deleted
    created_at
    is_clocked_in
    isOwner
    is_email_verify
    is_phone_verify
    preffered_name
    gender
    birth_date
    marital_status
    mobile_no
    work_no
    extra_no
    personal_email
    nationality
    passport_number
    logo
    user_name
    work_email
    auth_pin
    account_status
    send_sales_order_email
    account_representive_code
    send_order_email_to_parent
    custom_user
    associated_customer
    badge_code
    hire_date
    joining_date
    employee_type
    account_title
    note
    adp
    swift_code
    branch_code
    local_code
    employee_group {
      _id
      is_un_restricted
      pay_type {
        _id
        schedule_name
      }
      group_name
      AttendancePolicy {
        group_name
        is_un_restricted
      }
    }
    is_medical_insurance
    is_store_wise
    is_payroll_run_on_business
    is_air_ticket
    is_gratuity
    eligibility_date
    salary_type
    pay_type
    basic_salary
    pay_schedule {
      _id
      schedule_name
      pay_period
    }
    starting_date
    is_excluding_pay_roll
    salary_template
    weekly_hourly_salary
    weekend_day_salary
    public_day_hourly_salary
    employee_home_address
    employee_work_address
    sales_tax_allowances
    is_exempt_income_tax
    tax_override
    total_week_hours
    tax_override_amount
    w4_form
    withholding_status
    total_allowances
    additional_tax_override
    additional_withholding_amount
    is_exempt_from_withholding
    is_exempt_federal_tax
    salary_payment_method
    account_number
    bank_name
    routing_number
    is_attendance_rule_applied
    is_missing_attendance
    is_late_arrival
    is_leave_restriction
    is_hours_in_a_day
    is_over_time_policy
    is_earlyout
    is_enable_checkin_checkout_access
    is_breaktime_exception
    is_send_email_notification
    password_changed_at
    is_self_service_access
    last_login_at
    last_login_ip
    is_company
    is_profile_updated
    is_profile_completed
    profile_score
    exempt_any_state_tax
    seasonal_employee
    payout_frequency
    payout_rate
    termination_reason
    termination_date
    last_day_worked
    employee_status
    ssn
    commision
    length_of_service
    altername
    deleted_at
    updated_at
    allowances {
      allowance {
        _id
        pay_slip_name
        amount
      }
      amount
      percentage
    }
    contributions {
      contribution {
        _id
        name_pay_slip
        contribution_amount
      }
      amount
      percentage
    }
    deductions {
      deduction {
        _id
        name_pay_slip
        deduction_amount
      }
      amount
      percentage
    }
    EmployeeGarnishment {
      _id
      fix_amount
      garnishment_account
      garnishment_type
    }
    Country {
      _id
      name
    }
    shift {
      _id
      is_custom
      shift_name
      start_time
      end_time
      meal_break
      rest_break
      break_hours
      working_hours
      is_deleted
    }
    line_manager {
      id
      email
      first_name
      middle_name
      last_name
      full_name
    }
    designation {
      _id
      designation_name
    }
    documents_list {
      _id
      upload_documents
      documents_type
      documents_name
      documents_description
      documents_expiry_date
      is_documents_hide
      is_email_notify
      Role {
        _id
        roleName
      }
      assinged_to {
        _id
        full_name
        id
      }
    }
    roles {
      _id
      roleName
      is_deleted
    }
    department {
      _id
      department_name
      is_deleted
      businessLocation {
        _id
        store_nick_name
      }
    }
    region {
      _id
      region_name
    }
    storeAccess {
      businessLocation {
        _id
        store_nick_name
      }
      roles {
        _id
        roleName
      }
      cashRegister {
        _id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeByIdGQL extends Apollo.Query<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables> {
    override document = GetEmployeeByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllShiftsListDocument = gql`
    query GetAllShiftsList($input: ShiftListInput!) {
  getAllShiftsList(input: $input) {
    results {
      _id
      shift_name
      start_time
      end_time
      meal_break
      rest_break
      break_hours
      working_hours
      break_detail {
        break_duration
        break_start_time
        break_end_time
        is_break_start_time
        break_type {
          _id
          data_value_name
        }
      }
      is_deleted
      is_custom
      employees {
        _id
        full_name
      }
    }
    config {
      limit
      page
      totalPages
      totalResults
      no_of_records
      type
      actions {
        name
        is_visible
      }
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      table_preset {
        ...TablePresetFields
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllShiftsListGQL extends Apollo.Query<GetAllShiftsListQuery, GetAllShiftsListQueryVariables> {
    override document = GetAllShiftsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllPayrollScheduleListDocument = gql`
    query GetAllPayrollScheduleList($input: PayrollScheduleListInput) {
  getAllPayrollScheduleList(input: $input) {
    results {
      _id
      is_deleted
      schedule_name
      pay_period
      start_date
      end_date
      pay_day
      first_day_of_payroll_run_date
      day_of_month
      secound_day_of_payroll_run_date
      pay_holiday_policy
      last_payroll_run_date
      no_of_days
    }
    config {
      limit
      page
      totalPages
      totalResults
      no_of_records
      type
      actions {
        name
        is_visible
      }
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      table_preset {
        ...TablePresetFields
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllPayrollScheduleListGQL extends Apollo.Query<GetAllPayrollScheduleListQuery, GetAllPayrollScheduleListQueryVariables> {
    override document = GetAllPayrollScheduleListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAllowancesDocument = gql`
    query GetAllAllowances {
  getAllAllowances {
    _id
    allowance_type
    pay_slip_name
    is_fixed
    is_taxable
    amount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAllowancesGQL extends Apollo.Query<GetAllAllowancesQuery, GetAllAllowancesQueryVariables> {
    override document = GetAllAllowancesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeductionDocument = gql`
    query GetDeduction {
  getDeduction {
    _id
    name_pay_slip
    is_calculate_amount_fixed
    deduction_amount
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeductionGQL extends Apollo.Query<GetDeductionQuery, GetDeductionQueryVariables> {
    override document = GetDeductionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContributionDocument = gql`
    query GetContribution {
  getContribution {
    _id
    name_pay_slip
    is_calculate_amount_fixed
    contribution_amount
    is_deleted
    created_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContributionGQL extends Apollo.Query<GetContributionQuery, GetContributionQueryVariables> {
    override document = GetContributionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRolesDocument = gql`
    query GetRoles($roleFilter: roleFilter!) {
  getRoles(roleFilter: $roleFilter) {
    _id
    roleName
    employeeCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRolesGQL extends Apollo.Query<GetRolesQuery, GetRolesQueryVariables> {
    override document = GetRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDepartmentsByLocationIdDocument = gql`
    query GetDepartmentsByLocationId($location_id: ID!, $business_id: ID!) {
  getDepartmentsByLocationID(location_id: $location_id, business_id: $business_id) {
    _id
    department_name
    Business {
      _id
    }
    businessLocation {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDepartmentsByLocationIdGQL extends Apollo.Query<GetDepartmentsByLocationIdQuery, GetDepartmentsByLocationIdQueryVariables> {
    override document = GetDepartmentsByLocationIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllLeavesTypeDocument = gql`
    query GetAllLeavesType {
  getAllLeavesType {
    _id
    name
    code
    pto_type
    type
    is_pto
    minimum_duration
    maximum_duration
    un_paid_days
    per_day_hours
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllLeavesTypeGQL extends Apollo.Query<GetAllLeavesTypeQuery, GetAllLeavesTypeQueryVariables> {
    override document = GetAllLeavesTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentTypesDocument = gql`
    query GetDocumentTypes {
  getDocumentTypes {
    _id
    data_value_name
    is_system_generated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentTypesGQL extends Apollo.Query<GetDocumentTypesQuery, GetDocumentTypesQueryVariables> {
    override document = GetDocumentTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentsByEmployeeIdDocument = gql`
    query GetDocumentsByEmployeeId($input: inputEmployeeDocuments) {
  getDocumentsByEmployeeId(input: $input) {
    results {
      _id
      name
      type
      share_as
      attachment
      is_sign_required
      is_hide_after_review
      is_submission_required
      validity
      employeeDocumentUpload {
        fileRef
        status
        view
        date
        employee {
          id
          full_name
        }
      }
    }
    config {
      limit
      page
      totalPages
      totalResults
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentsByEmployeeIdGQL extends Apollo.Query<GetDocumentsByEmployeeIdQuery, GetDocumentsByEmployeeIdQueryVariables> {
    override document = GetDocumentsByEmployeeIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDataWithZipcodeDocument = gql`
    query GetDataWithZipcode($zipcode: String!, $business: ID) {
  getDataWithZipcode(zipcode: $zipcode, business: $business) {
    Country {
      _id
      name
    }
    States {
      State {
        _id
        state_name
      }
      cities {
        _id
        city_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDataWithZipcodeGQL extends Apollo.Query<GetDataWithZipcodeQuery, GetDataWithZipcodeQueryVariables> {
    override document = GetDataWithZipcodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeTimeLineHistoryDocument = gql`
    query GetEmployeeTimeLineHistory($input: historyListFilter) {
  getEmployeeTimeLineHistory(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      id
      action_type
      created_date
      basic_salary
      employee_type
      hire_date
      joining_date
      salary_type
      over_time_rate
      total_week_hours
      account_status
      starting_date
      weekly_hourly_salary
      weekend_day_salary
      public_day_hourly_salary
      new_salary_effect_from
      created_by {
        _id
        full_name
      }
      employee {
        id
        full_name
      }
      shift {
        _id
        shift_name
      }
      line_manager {
        id
        full_name
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeTimeLineHistoryGQL extends Apollo.Query<GetEmployeeTimeLineHistoryQuery, GetEmployeeTimeLineHistoryQueryVariables> {
    override document = GetEmployeeTimeLineHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllEmployeeActionsDocument = gql`
    query GetAllEmployeeActions($input: employeeActionInput!) {
  getAllEmployeeActions(input: $input) {
    action_type
    basic_salary
    created_date
    employee_type
    hire_date
    id
    total_week_hours
    pay_type
    public_day_hourly_salary
    account_status
    is_salary_update
    is_use_new_salary
    joining_date
    new_salary_effect_from
    new_salary_effect_to
    over_time_rate
    salary_type
    weekend_day_salary
    weekly_hourly_salary
    starting_date
    pay_schedule {
      _id
      schedule_name
    }
    employee_group {
      _id
      pay_type {
        _id
        schedule_name
      }
    }
    employee {
      id
      full_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllEmployeeActionsGQL extends Apollo.Query<GetAllEmployeeActionsQuery, GetAllEmployeeActionsQueryVariables> {
    override document = GetAllEmployeeActionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessLocationsByBusinessIdDocument = gql`
    query GetBusinessLocationsByBusinessId($businessId: ID!) {
  getBusinessLocationsByBusinessId(business_id: $businessId) {
    _id
    store_name
    store_nick_name
    location_keeping_unit
    address_1
    address_2
    State
    city
    is_deleted
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessLocationsByBusinessIdGQL extends Apollo.Query<GetBusinessLocationsByBusinessIdQuery, GetBusinessLocationsByBusinessIdQueryVariables> {
    override document = GetBusinessLocationsByBusinessIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActiveEmployeesForDropdownByBusinessIdDocument = gql`
    query GetActiveEmployeesForDropdownByBusinessId($business_id: ID!) {
  getAllActiveEmployees(business_id: $business_id) {
    id
    full_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActiveEmployeesForDropdownByBusinessIdGQL extends Apollo.Query<GetActiveEmployeesForDropdownByBusinessIdQuery, GetActiveEmployeesForDropdownByBusinessIdQueryVariables> {
    override document = GetActiveEmployeesForDropdownByBusinessIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateEmployeeDocument = gql`
    mutation CreateUpdateEmployee($businessId: ID!, $input: CreateUpdateEmployeeInput!, $id: ID) {
  createUpdateEmployee(business_id: $businessId, input: $input, _id: $id) {
    id
    email
    employee_id
    first_name
    middle_name
    last_name
    full_name
    phone
    status
    account_status
    hire_date
    joining_date
    employee_type
    salary_type
    basic_salary
    salary_payment_method
    is_deleted
    created_at
    updated_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateEmployeeGQL extends Apollo.Mutation<CreateUpdateEmployeeMutation, CreateUpdateEmployeeMutationVariables> {
    override document = CreateUpdateEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveEmployeeDocument = gql`
    mutation ArchiveEmployee($archive: Boolean!, $proceed: Boolean!, $ids: [ID!]) {
  archiveEmployee(archive: $archive, proceed: $proceed, ids: $ids) {
    archived {
      account_number
    }
    clockedIn {
      full_name
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveEmployeeGQL extends Apollo.Mutation<ArchiveEmployeeMutation, ArchiveEmployeeMutationVariables> {
    override document = ArchiveEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveEmployeeHistoryDocument = gql`
    mutation ArchiveEmployeeHistory($id: ID!, $archive: Boolean!) {
  archiveEmployeeHistory(_id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveEmployeeHistoryGQL extends Apollo.Mutation<ArchiveEmployeeHistoryMutation, ArchiveEmployeeHistoryMutationVariables> {
    override document = ArchiveEmployeeHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveEmployeeDocumentDocument = gql`
    mutation ArchiveEmployeeDocument($employeeId: ID!, $documentId: ID!) {
  archiveEmployeeDocument(employee_id: $employeeId, document_id: $documentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveEmployeeDocumentGQL extends Apollo.Mutation<ArchiveEmployeeDocumentMutation, ArchiveEmployeeDocumentMutationVariables> {
    override document = ArchiveEmployeeDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEmployeeDocumentDocument = gql`
    mutation UpdateEmployeeDocument($input: employeeDocumentUpdateInput) {
  updateEmployeeDocument(input: $input) {
    id
    documents_list {
      _id
      documents_name
      documents_type
      documents_description
      documents_expiry_date
      upload_documents
      is_documents_hide
      is_email_notify
      Role {
        _id
        roleName
      }
      assinged_to {
        id
        full_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEmployeeDocumentGQL extends Apollo.Mutation<UpdateEmployeeDocumentMutation, UpdateEmployeeDocumentMutationVariables> {
    override document = UpdateEmployeeDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($input: updateUserInput) {
  updateUserProfile(input: $input) {
    id
    email
    first_name
    last_name
    full_name
    logo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserProfileGQL extends Apollo.Mutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables> {
    override document = UpdateUserProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProfilePictureForModelsDocument = gql`
    mutation UpdateProfilePictureForModels($input: updateProfilePictureInput) {
  updateProfilePictureForModels(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProfilePictureForModelsGQL extends Apollo.Mutation<UpdateProfilePictureForModelsMutation, UpdateProfilePictureForModelsMutationVariables> {
    override document = UpdateProfilePictureForModelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReJoinEmployeeDocument = gql`
    mutation ReJoinEmployee($input: reJoinEmployeeInput) {
  reJoinEmployee(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReJoinEmployeeGQL extends Apollo.Mutation<ReJoinEmployeeMutation, ReJoinEmployeeMutationVariables> {
    override document = ReJoinEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWriteupsByEmployeeIdDocument = gql`
    query GetWriteupsByEmployeeId($input: writeUpByEmployee) {
  getWriteupsByEmployeeId(input: $input) {
    results {
      _id
      write_up_type
      write_up_reason
      status
      created_at
      writeup_date
      employee {
        id
        full_name
      }
    }
    config {
      limit
      page
      totalPages
      totalResults
      no_of_records
      type
      actions
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      table_preset {
        ...TablePresetFields
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWriteupsByEmployeeIdGQL extends Apollo.Query<GetWriteupsByEmployeeIdQuery, GetWriteupsByEmployeeIdQueryVariables> {
    override document = GetWriteupsByEmployeeIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMultipleWritupApprovalDocument = gql`
    mutation UpdateMultipleWritupApproval($ids: [ID]!, $status: writupStatusEnumMult!) {
  updateMultipleWritupApproval(ids: $ids, status: $status)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMultipleWritupApprovalGQL extends Apollo.Mutation<UpdateMultipleWritupApprovalMutation, UpdateMultipleWritupApprovalMutationVariables> {
    override document = UpdateMultipleWritupApprovalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetsByEmployeeIdDocument = gql`
    query GetAssetsByEmployeeId($input: inputAssetByEmployee) {
  getAssetsByEmployeeId(input: $input) {
    results {
      _id
      assetId
      name
      type
      availStatus
      quantity
      site {
        _id
        store_name
      }
      assigned {
        _id
        id
        employee_id
        email
        first_name
        last_name
        full_name
      }
    }
    config {
      limit
      page
      totalPages
      totalResults
      no_of_records
      type
      actions
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      table_preset {
        ...TablePresetFields
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetsByEmployeeIdGQL extends Apollo.Query<GetAssetsByEmployeeIdQuery, GetAssetsByEmployeeIdQueryVariables> {
    override document = GetAssetsByEmployeeIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllMyRequestDocumentsDocument = gql`
    query GetAllMyRequestDocuments($input: inputDocumentsWithFilter!) {
  getAllMyRequestDocuments(input: $input) {
    countpendingRequest
    data {
      Doucuments {
        _id
        name
        activity_name
        status
        activity_type
        message
        attachment
        created_at
        validity
        extension
        uploadfileref
        created_by {
          full_name
        }
      }
    }
    config {
      type
      limit
      page
      totalPages
      totalResults
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllMyRequestDocumentsGQL extends Apollo.Query<GetAllMyRequestDocumentsQuery, GetAllMyRequestDocumentsQueryVariables> {
    override document = GetAllMyRequestDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDesignationListDocument = gql`
    query GetAllDesignationList($input: designationtListFilter) {
  getAllDesignationList(input: $input) {
    result {
      _id
      designation_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDesignationListGQL extends Apollo.Query<GetAllDesignationListQuery, GetAllDesignationListQueryVariables> {
    override document = GetAllDesignationListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeesForLineManagerDocument = gql`
    query GetEmployeesForLineManager {
  getEmployeesForLineManager {
    _id
    full_name
    joining_date
    last_working_date
    employee_group {
      is_un_restricted
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeesForLineManagerGQL extends Apollo.Query<GetEmployeesForLineManagerQuery, GetEmployeesForLineManagerQueryVariables> {
    override document = GetEmployeesForLineManagerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllLeavePoliciesWithSearchDocument = gql`
    query GetAllLeavePoliciesWithSearch($search: String, $limit: Int, $page: Int) {
  getAllLeavePoliciesWithSearch(search: $search, limit: $limit, page: $page) {
    results {
      _id
      name
      reset_type
      is_deleted
      leaves {
        count
        countIn
        leaveAssighment
        type {
          _id
          name
          is_pto
        }
      }
      assign_to {
        id
        full_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllLeavePoliciesWithSearchGQL extends Apollo.Query<GetAllLeavePoliciesWithSearchQuery, GetAllLeavePoliciesWithSearchQueryVariables> {
    override document = GetAllLeavePoliciesWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentEmployeeActionDocument = gql`
    query GetCurrentEmployeeAction($employee_id: ID!) {
  getCurrentEmployeeAction(employee_id: $employee_id) {
    id
    action_type
    salary_type
    account_status
    employee_type
    basic_salary
    weekly_hourly_salary
    weekend_day_salary
    public_day_hourly_salary
    over_time_rate
    total_week_hours
    is_excluding_pay_roll
    line_manager {
      id
      full_name
    }
    pay_schedule {
      _id
      schedule_name
      pay_period
      day_of_month
      last_payroll_run_date
    }
    employee_group {
      _id
      group_name
    }
    roles {
      _id
      roleName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentEmployeeActionGQL extends Apollo.Query<GetCurrentEmployeeActionQuery, GetCurrentEmployeeActionQueryVariables> {
    override document = GetCurrentEmployeeActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAttendancePolicyByPayTypeDocument = gql`
    query GetAttendancePolicyByPayType($pay_type: String) {
  getAttendancePolicyByPayType(pay_type: $pay_type) {
    _id
    group_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAttendancePolicyByPayTypeGQL extends Apollo.Query<GetAttendancePolicyByPayTypeQuery, GetAttendancePolicyByPayTypeQueryVariables> {
    override document = GetAttendancePolicyByPayTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllActiveEmployeesWithSearchDocument = gql`
    query GetAllActiveEmployeesWithSearch($business_id: ID!, $search: String) {
  getAllActiveEmployeesWithSearch(business_id: $business_id, search: $search) {
    id
    full_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllActiveEmployeesWithSearchGQL extends Apollo.Query<GetAllActiveEmployeesWithSearchQuery, GetAllActiveEmployeesWithSearchQueryVariables> {
    override document = GetAllActiveEmployeesWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllActiveEmployeesForShareDocumentDocument = gql`
    query GetAllActiveEmployeesForShareDocument($input: GetAllActiveEmployeesForShareDocumentInput!) {
  getAllActiveEmployeesForShareDocument(input: $input) {
    id
    email
    full_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllActiveEmployeesForShareDocumentGQL extends Apollo.Query<GetAllActiveEmployeesForShareDocumentQuery, GetAllActiveEmployeesForShareDocumentQueryVariables> {
    override document = GetAllActiveEmployeesForShareDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllActiveEmployeesDocument = gql`
    query GetAllActiveEmployees($businessId: ID!, $feature: featureEnum) {
  getAllActiveEmployees(business_id: $businessId, feature: $feature) {
    id
    email
    employee_id
    salary_type
    first_name
    joining_date
    hire_date
    last_working_date
    final_settlement_completed
    last_day_worked
    account_status
    employee_group {
      before_early_clockin
      paunch_out_mnts
      is_un_restricted
      is_auto_clocked_in
    }
    middle_name
    last_name
    profile_pictures {
      dimension
      path
    }
    full_name
    employee_group {
      _id
      group_name
    }
    phone
    isOwner
    adp
    phone_country_code
    landline
    logo
    avatar_location
    status
    business_id {
      business_system_name
    }
    department {
      _id
      department_name
    }
    designation {
      _id
      designation_name
    }
    users_password_manager {
      publicKey
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllActiveEmployeesGQL extends Apollo.Query<GetAllActiveEmployeesQuery, GetAllActiveEmployeesQueryVariables> {
    override document = GetAllActiveEmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExpenseWithFiltersDocument = gql`
    query GetExpenseWithFilters($input: expenseFilter) {
  getExpenseWithFilters(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      _id
      expense_type
      expense_total_amount
      expense_date
      description
      status
      is_received
      is_business_expense
      is_deleted
      created_at
      employee {
        id
        full_name
      }
      work_flow {
        approved_by {
          id
          full_name
        }
        approval_description
        employee {
          _id
          full_name
        }
        status
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExpenseWithFiltersGQL extends Apollo.Query<GetExpenseWithFiltersQuery, GetExpenseWithFiltersQueryVariables> {
    override document = GetExpenseWithFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExpenseByIdDocument = gql`
    query GetExpenseById($id: ID!) {
  getExpenseById(id: $id) {
    _id
    expense_type
    expense_total_amount
    expense_date
    description
    status
    is_received
    is_business_expense
    is_deleted
    document_url
    employee {
      _id
      id
      full_name
    }
    _id
    approval_status
    approval_description
    business_manager {
      _id
      full_name
      status
    }
    behalf_of {
      _id
      full_name
    }
    work_flow {
      approval_description
      status
      approved_by {
        id
        full_name
        _id
      }
      employee {
        _id
        full_name
        id
      }
    }
    employee {
      _id
      first_name
      last_name
      full_name
      middle_name
    }
    upload_document_info {
      name
      extension
    }
    expense_type
    expense_total_amount
    expense_date
    description
    status
    is_received
    document_url
    google_drive_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExpenseByIdGQL extends Apollo.Query<GetExpenseByIdQuery, GetExpenseByIdQueryVariables> {
    override document = GetExpenseByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateExpenseDocument = gql`
    mutation CreateUpdateExpense($input: InputExpense!) {
  createUpdateExpense(input: $input) {
    _id
    expense_type
    expense_total_amount
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateExpenseGQL extends Apollo.Mutation<CreateUpdateExpenseMutation, CreateUpdateExpenseMutationVariables> {
    override document = CreateUpdateExpenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveExpenseDocument = gql`
    mutation ArchiveExpense($ids: [ID!], $archive: Boolean!) {
  archiveExpense(archiveExpenseId: $ids, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveExpenseGQL extends Apollo.Mutation<ArchiveExpenseMutation, ArchiveExpenseMutationVariables> {
    override document = ArchiveExpenseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetHrComplaintByIdDocument = gql`
    query GetHRComplaintById($id: ID!) {
  getHRComplaintById(_id: $id) {
    _id
    case_id
    Business {
      _id
      business_legal_name
    }
    User {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    Department {
      _id
      department_name
    }
    preferred_contact_method
    type_of_concern
    other_concern_description
    urgency
    incident_date
    is_exact_date_unknown
    approximate_time
    situation_ongoing
    where_did_it_occur
    is_reported_previously
    previous_description
    description
    is_supporting_documents
    supporting_files {
      file_url
      file_name
    }
    supporting_files_description
    persons_involved {
      is_internal_person
      full_name
      email
      phone
      User {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      Department {
        _id
        department_name
      }
      relationship_to_you
      additional_context
    }
    persons_involved_count
    witnesses_events
    witnesses {
      is_internal_person
      full_name
      email
      phone
      User {
        full_name
        _id
      }
      Department {
        _id
        department_name
      }
      what_they_witnessed
    }
    is_hr_should_know_anything
    hr_additional_info
    is_truthful_confirmed
    is_hr_review_confirmed
    status
    assinged_status
    severity
    days_open
    submitted_by {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    investigator {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    work_flow_user {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    reminder
    overdue_date
    closed_date
    is_deleted
    created_at
    updated_at
    respondent_notified
    respondent_notified_at
    case_witnesses {
      _id
      full_name
      Department {
        _id
        department_name
      }
      User {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      email
      phone
      form_status
      form_sent_at
      form_completed_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      created_at
    }
    resolution {
      outcome
      disciplinary_action
      complainant_notification_method
      complainant_notified_date
      is_referred_externally
      is_policy_updated_as_result
      resolution_notes
      referral_policy_details
      resolved_at
      resolved_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
    audit_log {
      _id
      timestamp
      action
      description
      performed_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      performed_by_role
    }
    internal_notes {
      _id
      content
      created_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetHrComplaintByIdGQL extends Apollo.Query<GetHrComplaintByIdQuery, GetHrComplaintByIdQueryVariables> {
    override document = GetHrComplaintByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignInvestigatorDocument = gql`
    mutation AssignInvestigator($complaintId: ID!, $investigatorId: ID!) {
  assignInvestigator(complaint_id: $complaintId, investigator_id: $investigatorId) {
    _id
    case_id
    Business {
      _id
      business_legal_name
    }
    User {
      id
      employee_id
      first_name
      email
      phone
      roles {
        _id
        roleName
      }
      department {
        _id
        department_name
      }
    }
    Department {
      _id
      department_name
    }
    preferred_contact_method
    type_of_concern
    other_concern_description
    urgency
    incident_date
    is_exact_date_unknown
    approximate_time
    situation_ongoing
    where_did_it_occur
    is_reported_previously
    previous_description
    description
    is_supporting_documents
    supporting_files {
      file_url
      file_name
    }
    supporting_files_description
    persons_involved {
      is_internal_person
      full_name
      email
      phone
      User {
        _id
        full_name
      }
      Department {
        _id
        department_name
      }
      relationship_to_you
      additional_context
    }
    persons_involved_count
    witnesses_events
    witnesses {
      is_internal_person
      full_name
      email
      phone
      User {
        full_name
        _id
      }
      Department {
        _id
        department_name
      }
      what_they_witnessed
    }
    is_hr_should_know_anything
    hr_additional_info
    is_truthful_confirmed
    is_hr_review_confirmed
    status
    assinged_status
    severity
    days_open
    submitted_by {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    investigator {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    work_flow_user {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    reminder
    overdue_date
    closed_date
    is_deleted
    created_at
    updated_at
    respondent_notified
    respondent_notified_at
    case_witnesses {
      _id
      full_name
      Department {
        _id
        department_name
      }
      User {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      email
      phone
      form_status
      form_sent_at
      form_completed_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      created_at
    }
    resolution {
      outcome
      disciplinary_action
      complainant_notification_method
      complainant_notified_date
      is_referred_externally
      is_policy_updated_as_result
      resolution_notes
      referral_policy_details
      resolved_at
      resolved_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
    audit_log {
      _id
      timestamp
      action
      description
      performed_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      performed_by_role
    }
    internal_notes {
      _id
      content
      created_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignInvestigatorGQL extends Apollo.Mutation<AssignInvestigatorMutation, AssignInvestigatorMutationVariables> {
    override document = AssignInvestigatorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetHrComplaintsDocument = gql`
    query GetHRComplaints($input: ComplaintFilterInput) {
  getHRComplaints(input: $input) {
    config {
      actions {
        is_visible
        name
      }
      table_preset {
        ...TablePresetFields
      }
      columns {
        _id
        field
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
        header
        is_search_able
        is_amount
        is_sortable
        is_visible
        search
        type
        filterValue
        column_data
        column_dropdown_value {
          _id
          value
        }
      }
      filters {
        search
        field
        type
        _ids
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
      }
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
    }
    results {
      assinged_status
      created_at
      severity
      status
      investigator {
        full_name
        id
      }
      _id
      case_id
      Business {
        _id
        business_legal_name
      }
      User {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      Department {
        _id
        department_name
      }
      preferred_contact_method
      type_of_concern
      other_concern_description
      urgency
      incident_date
      is_exact_date_unknown
      approximate_time
      situation_ongoing
      where_did_it_occur
      is_reported_previously
      previous_description
      description
      is_supporting_documents
      supporting_files {
        file_url
        file_name
      }
      supporting_files_description
      persons_involved {
        is_internal_person
        full_name
        email
        phone
        User {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
        Department {
          _id
          department_name
        }
        relationship_to_you
        additional_context
      }
      persons_involved_count
      witnesses_events
      days_open
      witnesses {
        is_internal_person
        full_name
        email
        phone
        User {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
        Department {
          _id
          department_name
        }
        what_they_witnessed
      }
    }
  }
}
    ${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetHrComplaintsGQL extends Apollo.Query<GetHrComplaintsQuery, GetHrComplaintsQueryVariables> {
    override document = GetHrComplaintsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkRespondentNotifiedDocument = gql`
    mutation MarkRespondentNotified($complaintId: ID!, $isNotified: Boolean!) {
  markRespondentNotified(complaint_id: $complaintId, is_notified: $isNotified) {
    _id
    case_id
    Business {
      _id
      business_legal_name
    }
    User {
      id
      employee_id
      first_name
      email
      phone
      roles {
        _id
        roleName
      }
      department {
        _id
        department_name
      }
    }
    Department {
      _id
      department_name
    }
    preferred_contact_method
    type_of_concern
    other_concern_description
    urgency
    incident_date
    is_exact_date_unknown
    approximate_time
    situation_ongoing
    where_did_it_occur
    is_reported_previously
    previous_description
    description
    is_supporting_documents
    supporting_files {
      file_url
      file_name
    }
    supporting_files_description
    persons_involved {
      is_internal_person
      full_name
      email
      phone
      User {
        _id
        full_name
      }
      Department {
        _id
        department_name
      }
      relationship_to_you
      additional_context
    }
    persons_involved_count
    witnesses_events
    witnesses {
      is_internal_person
      full_name
      email
      phone
      User {
        full_name
        _id
      }
      Department {
        _id
        department_name
      }
      what_they_witnessed
    }
    is_hr_should_know_anything
    hr_additional_info
    is_truthful_confirmed
    is_hr_review_confirmed
    status
    assinged_status
    severity
    days_open
    submitted_by {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    investigator {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    work_flow_user {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    reminder
    overdue_date
    closed_date
    is_deleted
    created_at
    updated_at
    respondent_notified
    respondent_notified_at
    case_witnesses {
      _id
      full_name
      Department {
        _id
        department_name
      }
      User {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      email
      phone
      form_status
      form_sent_at
      form_completed_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      created_at
    }
    resolution {
      outcome
      disciplinary_action
      complainant_notification_method
      complainant_notified_date
      is_referred_externally
      is_policy_updated_as_result
      resolution_notes
      referral_policy_details
      resolved_at
      resolved_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
    audit_log {
      _id
      timestamp
      action
      description
      performed_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      performed_by_role
    }
    internal_notes {
      _id
      content
      created_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkRespondentNotifiedGQL extends Apollo.Mutation<MarkRespondentNotifiedMutation, MarkRespondentNotifiedMutationVariables> {
    override document = MarkRespondentNotifiedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCaseWitnessDocument = gql`
    mutation AddCaseWitness($complaintId: ID!, $input: WitnessComplaintInput!) {
  addCaseWitness(complaint_id: $complaintId, input: $input) {
    _id
    case_id
    Business {
      _id
      business_legal_name
    }
    User {
      id
      employee_id
      first_name
      email
      phone
      roles {
        _id
        roleName
      }
      department {
        _id
        department_name
      }
    }
    Department {
      _id
      department_name
    }
    preferred_contact_method
    type_of_concern
    other_concern_description
    urgency
    incident_date
    is_exact_date_unknown
    approximate_time
    situation_ongoing
    where_did_it_occur
    is_reported_previously
    previous_description
    description
    is_supporting_documents
    supporting_files {
      file_url
      file_name
    }
    supporting_files_description
    persons_involved {
      is_internal_person
      full_name
      email
      phone
      User {
        _id
        full_name
      }
      Department {
        _id
        department_name
      }
      relationship_to_you
      additional_context
    }
    persons_involved_count
    witnesses_events
    witnesses {
      is_internal_person
      full_name
      email
      phone
      User {
        full_name
        _id
      }
      Department {
        _id
        department_name
      }
      what_they_witnessed
    }
    is_hr_should_know_anything
    hr_additional_info
    is_truthful_confirmed
    is_hr_review_confirmed
    status
    assinged_status
    severity
    days_open
    submitted_by {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    investigator {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    work_flow_user {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    reminder
    overdue_date
    closed_date
    is_deleted
    created_at
    updated_at
    respondent_notified
    respondent_notified_at
    case_witnesses {
      _id
      full_name
      Department {
        _id
        department_name
      }
      User {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      email
      phone
      form_status
      form_sent_at
      form_completed_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      created_at
    }
    resolution {
      outcome
      disciplinary_action
      complainant_notification_method
      complainant_notified_date
      is_referred_externally
      is_policy_updated_as_result
      resolution_notes
      referral_policy_details
      resolved_at
      resolved_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
    audit_log {
      _id
      timestamp
      action
      description
      performed_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      performed_by_role
    }
    internal_notes {
      _id
      content
      created_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCaseWitnessGQL extends Apollo.Mutation<AddCaseWitnessMutation, AddCaseWitnessMutationVariables> {
    override document = AddCaseWitnessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendWitnessFormDocument = gql`
    mutation SendWitnessForm($complaintId: ID!, $witnessId: ID!, $description: String!) {
  sendWitnessForm(
    complaint_id: $complaintId
    witness_id: $witnessId
    description: $description
  ) {
    _id
    case_id
    Business {
      _id
      business_legal_name
    }
    User {
      id
      employee_id
      first_name
      email
      phone
      roles {
        _id
        roleName
      }
      department {
        _id
        department_name
      }
    }
    Department {
      _id
      department_name
    }
    preferred_contact_method
    type_of_concern
    other_concern_description
    urgency
    incident_date
    is_exact_date_unknown
    approximate_time
    situation_ongoing
    where_did_it_occur
    is_reported_previously
    previous_description
    description
    is_supporting_documents
    supporting_files {
      file_url
      file_name
    }
    supporting_files_description
    persons_involved {
      is_internal_person
      full_name
      email
      phone
      User {
        _id
        full_name
      }
      Department {
        _id
        department_name
      }
      relationship_to_you
      additional_context
    }
    persons_involved_count
    witnesses_events
    witnesses {
      is_internal_person
      full_name
      email
      phone
      User {
        full_name
        _id
      }
      Department {
        _id
        department_name
      }
      what_they_witnessed
    }
    is_hr_should_know_anything
    hr_additional_info
    is_truthful_confirmed
    is_hr_review_confirmed
    status
    assinged_status
    severity
    days_open
    submitted_by {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    investigator {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    work_flow_user {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    reminder
    overdue_date
    closed_date
    is_deleted
    created_at
    updated_at
    respondent_notified
    respondent_notified_at
    case_witnesses {
      _id
      full_name
      Department {
        _id
        department_name
      }
      User {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      email
      phone
      form_status
      form_sent_at
      form_completed_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      created_at
    }
    resolution {
      outcome
      disciplinary_action
      complainant_notification_method
      complainant_notified_date
      is_referred_externally
      is_policy_updated_as_result
      resolution_notes
      referral_policy_details
      resolved_at
      resolved_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
    audit_log {
      _id
      timestamp
      action
      description
      performed_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      performed_by_role
    }
    internal_notes {
      _id
      content
      created_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendWitnessFormGQL extends Apollo.Mutation<SendWitnessFormMutation, SendWitnessFormMutationVariables> {
    override document = SendWitnessFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddInterviewLogDocument = gql`
    mutation AddInterviewLog($complaintId: ID!, $input: AddInterviewLogInput!) {
  addInterviewLog(complaint_id: $complaintId, input: $input) {
    _id
    Business {
      _id
      business_legal_name
    }
    User {
      id
      employee_id
      first_name
      email
      phone
      roles {
        _id
        roleName
      }
      department {
        _id
        department_name
      }
    }
    created_at
    updated_at
    HRComplaint {
      _id
      case_id
      Business {
        _id
        business_legal_name
      }
      User {
        id
        employee_id
        first_name
        email
        phone
        roles {
          _id
          roleName
        }
        department {
          _id
          department_name
        }
      }
      Department {
        _id
        department_name
      }
      preferred_contact_method
      type_of_concern
      other_concern_description
      urgency
      incident_date
      is_exact_date_unknown
      approximate_time
      situation_ongoing
      where_did_it_occur
      is_reported_previously
      previous_description
      description
      is_supporting_documents
      supporting_files {
        file_url
        file_name
      }
      supporting_files_description
      persons_involved {
        is_internal_person
        full_name
        email
        phone
        User {
          _id
          full_name
        }
        Department {
          _id
          department_name
        }
        relationship_to_you
        additional_context
      }
      persons_involved_count
      witnesses_events
      witnesses {
        is_internal_person
        full_name
        email
        phone
        User {
          full_name
          _id
        }
        Department {
          _id
          department_name
        }
        what_they_witnessed
      }
      is_hr_should_know_anything
      hr_additional_info
      is_truthful_confirmed
      is_hr_review_confirmed
      status
      assinged_status
      severity
      days_open
      submitted_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      investigator {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      work_flow_user {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      reminder
      overdue_date
      closed_date
      is_deleted
      created_at
      updated_at
      respondent_notified
      respondent_notified_at
      case_witnesses {
        _id
        full_name
        Department {
          _id
          department_name
        }
        User {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
        email
        phone
        form_status
        form_sent_at
        form_completed_at
        created_by {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
        created_at
      }
      resolution {
        outcome
        disciplinary_action
        complainant_notification_method
        complainant_notified_date
        is_referred_externally
        is_policy_updated_as_result
        resolution_notes
        referral_policy_details
        resolved_at
        resolved_by {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
      }
      audit_log {
        _id
        timestamp
        action
        description
        performed_by {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
        performed_by_role
      }
      internal_notes {
        _id
        content
        created_at
        created_by {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
      }
    }
    interview_date
    interview_type
    participant_name
    participant_role
    format
    follow_up_required
    summary
    created_by {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddInterviewLogGQL extends Apollo.Mutation<AddInterviewLogMutation, AddInterviewLogMutationVariables> {
    override document = AddInterviewLogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RecordResolutionDocument = gql`
    mutation RecordResolution($complaintId: ID!, $input: RecordResolutionInput!) {
  recordResolution(complaint_id: $complaintId, input: $input) {
    _id
    case_id
    Business {
      _id
      business_legal_name
    }
    User {
      id
      employee_id
      first_name
      email
      phone
      roles {
        _id
        roleName
      }
      department {
        _id
        department_name
      }
    }
    preferred_contact_method
    type_of_concern
    other_concern_description
    urgency
    incident_date
    is_exact_date_unknown
    approximate_time
    situation_ongoing
    where_did_it_occur
    is_reported_previously
    previous_description
    description
    is_supporting_documents
    supporting_files {
      file_url
      file_name
    }
    supporting_files_description
    persons_involved {
      is_internal_person
      full_name
      email
      phone
      User {
        _id
        full_name
      }
      Department {
        _id
        department_name
      }
      relationship_to_you
      additional_context
    }
    persons_involved_count
    witnesses_events
    witnesses {
      is_internal_person
      full_name
      email
      phone
      User {
        full_name
        _id
      }
      Department {
        _id
        department_name
      }
      what_they_witnessed
    }
    is_hr_should_know_anything
    hr_additional_info
    is_truthful_confirmed
    is_hr_review_confirmed
    status
    assinged_status
    severity
    days_open
    submitted_by {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    investigator {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    work_flow_user {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    reminder
    overdue_date
    closed_date
    is_deleted
    created_at
    updated_at
    respondent_notified
    respondent_notified_at
    case_witnesses {
      _id
      full_name
      Department {
        _id
        department_name
      }
      User {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      email
      phone
      form_status
      form_sent_at
      form_completed_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      created_at
    }
    resolution {
      outcome
      disciplinary_action
      complainant_notification_method
      complainant_notified_date
      is_referred_externally
      is_policy_updated_as_result
      resolution_notes
      referral_policy_details
      resolved_at
      resolved_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
    audit_log {
      _id
      timestamp
      action
      description
      performed_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      performed_by_role
    }
    internal_notes {
      _id
      content
      created_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RecordResolutionGQL extends Apollo.Mutation<RecordResolutionMutation, RecordResolutionMutationVariables> {
    override document = RecordResolutionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddHrNoteDocument = gql`
    mutation AddHRNote($complaintId: ID!, $content: String!) {
  addHRNote(complaint_id: $complaintId, content: $content) {
    _id
    case_id
    Business {
      _id
      business_legal_name
    }
    User {
      id
      employee_id
      first_name
      email
      phone
      roles {
        _id
        roleName
      }
      department {
        _id
        department_name
      }
    }
    Department {
      _id
      department_name
    }
    preferred_contact_method
    type_of_concern
    other_concern_description
    urgency
    incident_date
    is_exact_date_unknown
    approximate_time
    situation_ongoing
    where_did_it_occur
    is_reported_previously
    previous_description
    description
    is_supporting_documents
    supporting_files {
      file_url
      file_name
    }
    supporting_files_description
    persons_involved {
      is_internal_person
      full_name
      email
      phone
      User {
        _id
        full_name
      }
      Department {
        _id
        department_name
      }
      relationship_to_you
      additional_context
    }
    persons_involved_count
    witnesses_events
    witnesses {
      is_internal_person
      full_name
      email
      phone
      User {
        full_name
        _id
      }
      Department {
        _id
        department_name
      }
      what_they_witnessed
    }
    is_hr_should_know_anything
    hr_additional_info
    is_truthful_confirmed
    is_hr_review_confirmed
    status
    assinged_status
    severity
    days_open
    submitted_by {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    investigator {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    work_flow_user {
      _id
      full_name
      department {
        _id
        department_name
      }
    }
    reminder
    overdue_date
    closed_date
    is_deleted
    created_at
    updated_at
    respondent_notified
    respondent_notified_at
    case_witnesses {
      _id
      full_name
      Department {
        _id
        department_name
      }
      User {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      email
      phone
      form_status
      form_sent_at
      form_completed_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      created_at
    }
    resolution {
      outcome
      disciplinary_action
      complainant_notification_method
      complainant_notified_date
      is_referred_externally
      is_policy_updated_as_result
      resolution_notes
      referral_policy_details
      resolved_at
      resolved_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
    audit_log {
      _id
      timestamp
      action
      description
      performed_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      performed_by_role
    }
    internal_notes {
      _id
      content
      created_at
      created_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddHrNoteGQL extends Apollo.Mutation<AddHrNoteMutation, AddHrNoteMutationVariables> {
    override document = AddHrNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateHrComplaintDocument = gql`
    mutation CreateHRComplaint($input: CreateHRComplaintInput!) {
  createHRComplaint(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateHrComplaintGQL extends Apollo.Mutation<CreateHrComplaintMutation, CreateHrComplaintMutationVariables> {
    override document = CreateHrComplaintDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetHrComplaintDashboardDocument = gql`
    query GetHRComplaintDashboard {
  getHRComplaintDashboard {
    open_cases
    overdue_cases
    critical_high_cases
    pending_witness_forms
    resolved_this_month
    cases_by_status {
      status
      count
    }
    workload_by_investigator {
      investigator {
        _id
        full_name
        department {
          _id
          department_name
        }
        roles {
          _id
          roleName
        }
      }
      count
    }
    cases_needing_attention {
      _id
      case_id
      User {
        _id
        full_name
        department {
          _id
          department_name
        }
        roles {
          _id
          roleName
        }
      }
      Department {
        _id
        department_name
      }
      preferred_contact_method
      type_of_concern
      other_concern_description
      urgency
      incident_date
      is_exact_date_unknown
      approximate_time
      situation_ongoing
      where_did_it_occur
      is_reported_previously
      previous_description
      description
      is_supporting_documents
      supporting_files {
        file_url
        file_name
      }
      supporting_files_description
      persons_involved {
        is_internal_person
        full_name
        email
        phone
        User {
          _id
          full_name
        }
        Department {
          _id
          department_name
        }
        relationship_to_you
        additional_context
      }
      persons_involved_count
      witnesses_events
      witnesses {
        is_internal_person
        full_name
        email
        phone
        User {
          full_name
          _id
        }
        Department {
          _id
          department_name
        }
        what_they_witnessed
      }
      is_hr_should_know_anything
      hr_additional_info
      is_truthful_confirmed
      is_hr_review_confirmed
      status
      assinged_status
      severity
      days_open
      submitted_by {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      investigator {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      work_flow_user {
        _id
        full_name
        department {
          _id
          department_name
        }
      }
      reminder
      overdue_date
      closed_date
      is_deleted
      created_at
      updated_at
      respondent_notified
      respondent_notified_at
      case_witnesses {
        _id
        full_name
        Department {
          _id
          department_name
        }
        User {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
        email
        phone
        form_status
        form_sent_at
        form_completed_at
        created_by {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
        created_at
      }
      resolution {
        outcome
        disciplinary_action
        complainant_notification_method
        complainant_notified_date
        is_referred_externally
        is_policy_updated_as_result
        resolution_notes
        referral_policy_details
        resolved_at
        resolved_by {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
      }
      audit_log {
        _id
        timestamp
        action
        description
        performed_by {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
        performed_by_role
      }
      internal_notes {
        _id
        content
        created_at
        created_by {
          _id
          full_name
          department {
            _id
            department_name
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetHrComplaintDashboardGQL extends Apollo.Query<GetHrComplaintDashboardQuery, GetHrComplaintDashboardQueryVariables> {
    override document = GetHrComplaintDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverrideSeverityDocument = gql`
    mutation OverrideSeverity($complaintId: ID!, $severity: ComplaintSeverity!) {
  overrideSeverity(complaint_id: $complaintId, severity: $severity) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverrideSeverityGQL extends Apollo.Mutation<OverrideSeverityMutation, OverrideSeverityMutationVariables> {
    override document = OverrideSeverityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteHrComplaintDocument = gql`
    mutation DeleteHRComplaint($id: ID!) {
  deleteHRComplaint(_id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteHrComplaintGQL extends Apollo.Mutation<DeleteHrComplaintMutation, DeleteHrComplaintMutationVariables> {
    override document = DeleteHrComplaintDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateHrComplaintDocument = gql`
    mutation UpdateHRComplaint($id: ID!, $input: CreateHRComplaintInput!) {
  updateHRComplaint(_id: $id, input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateHrComplaintGQL extends Apollo.Mutation<UpdateHrComplaintMutation, UpdateHrComplaintMutationVariables> {
    override document = UpdateHrComplaintDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeComplaintStatusDocument = gql`
    mutation ChangeComplaintStatus($complaintId: ID!, $status: ComplaintStatus!) {
  changeComplaintStatus(complaint_id: $complaintId, status: $status) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeComplaintStatusGQL extends Apollo.Mutation<ChangeComplaintStatusMutation, ChangeComplaintStatusMutationVariables> {
    override document = ChangeComplaintStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFeedbackTypesDocument = gql`
    query GetFeedbackTypes {
  getFeedbackTypes {
    data_value_name
    _id
    is_deleted
    is_system_generated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFeedbackTypesGQL extends Apollo.Query<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables> {
    override document = GetFeedbackTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFeedbackDocument = gql`
    mutation CreateFeedback($input: CreateFeedbackInput!) {
  createFeedback(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFeedbackGQL extends Apollo.Mutation<CreateFeedbackMutation, CreateFeedbackMutationVariables> {
    override document = CreateFeedbackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddFeedbackConversationDocument = gql`
    mutation AddFeedbackConversation($input: AddConversationInput!) {
  addFeedbackConversation(input: $input) {
    _id
    conversation {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddFeedbackConversationGQL extends Apollo.Mutation<AddFeedbackConversationMutation, AddFeedbackConversationMutationVariables> {
    override document = AddFeedbackConversationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFeedbacksDocument = gql`
    query GetFeedbacks($input: feedbackFilter) {
  getFeedbacks(input: $input) {
    config {
      columns {
        _id
        field
        column_dropdown_value {
          _id
          value
        }
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
        header
        is_search_able
        is_visible
        search
        type
        filterValue
        column_data
      }
      filters {
        search
        field
        type
        _ids
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
      }
      table_preset {
        ...TablePresetFields
      }
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
      actions {
        is_visible
        name
      }
    }
    results {
      Department {
        _id
        department_name
      }
      _id
      created_at
      feedback
      feedback_type {
        _id
        data_value_name
      }
      is_anonymous
      is_deleted
      reviewed_by {
        first_name
        last_name
        id
      }
      status
      submitted_by {
        full_name
        last_name
        first_name
        email
      }
      ticket_id
      updated_at
    }
  }
}
    ${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFeedbacksGQL extends Apollo.Query<GetFeedbacksQuery, GetFeedbacksQueryVariables> {
    override document = GetFeedbacksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFeedbackByIdDocument = gql`
    query GetFeedbackById($id: ID!) {
  getFeedbackById(_id: $id) {
    Department {
      department_name
      _id
    }
    _id
    attached_files {
      file_name
      file_url
    }
    conversation {
      _id
      created_at
      is_internal_note
      message
      sender {
        _id
        full_name
      }
    }
    created_at
    feedback
    feedback_type {
      data_type {
        data_type_name
      }
    }
    is_anonymous
    is_deleted
    status
    reviewed_by {
      full_name
    }
    submitted_by {
      full_name
    }
    ticket_id
    updated_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFeedbackByIdGQL extends Apollo.Query<GetFeedbackByIdQuery, GetFeedbackByIdQueryVariables> {
    override document = GetFeedbackByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuizCategoryListDocument = gql`
    query LmsGetQuizCategoryList($input: quizCategoryListInput) {
  getQuizCategoryListWIthSearch(input: $input) {
    config {
      ...LmsConfigFields
    }
    results {
      ...LmsCategoryFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}
${LmsCategoryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuizCategoryListGQL extends Apollo.Query<LmsGetQuizCategoryListQuery, LmsGetQuizCategoryListQueryVariables> {
    override document = LmsGetQuizCategoryListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuizCategoryByIdDocument = gql`
    query LmsGetQuizCategoryById($id: ID!) {
  getQuizCategoryById(id: $id) {
    ...LmsCategoryFields
  }
}
    ${LmsCategoryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuizCategoryByIdGQL extends Apollo.Query<LmsGetQuizCategoryByIdQuery, LmsGetQuizCategoryByIdQueryVariables> {
    override document = LmsGetQuizCategoryByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsCreateQuizCategoryDocument = gql`
    mutation LmsCreateQuizCategory($input: CreateCategoriesInput!) {
  createQuizCategories(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsCreateQuizCategoryGQL extends Apollo.Mutation<LmsCreateQuizCategoryMutation, LmsCreateQuizCategoryMutationVariables> {
    override document = LmsCreateQuizCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateQuizCategoryDocument = gql`
    mutation LmsUpdateQuizCategory($id: ID!, $input: UpdateCategoriesInput!) {
  updateQuizCategories(id: $id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateQuizCategoryGQL extends Apollo.Mutation<LmsUpdateQuizCategoryMutation, LmsUpdateQuizCategoryMutationVariables> {
    override document = LmsUpdateQuizCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsArchiveQuizCategoryDocument = gql`
    mutation LmsArchiveQuizCategory($id: ID!, $archive: Boolean!) {
  archiveUnarchiveQuizCategory(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsArchiveQuizCategoryGQL extends Apollo.Mutation<LmsArchiveQuizCategoryMutation, LmsArchiveQuizCategoryMutationVariables> {
    override document = LmsArchiveQuizCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsArchiveQuizCategorySectionDocument = gql`
    mutation LmsArchiveQuizCategorySection($id: ID!, $archive: Boolean!) {
  archiveUnarchiveQuizCategorySection(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsArchiveQuizCategorySectionGQL extends Apollo.Mutation<LmsArchiveQuizCategorySectionMutation, LmsArchiveQuizCategorySectionMutationVariables> {
    override document = LmsArchiveQuizCategorySectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuestionsDocument = gql`
    query LmsGetQuestions($input: QuizQuestionListInput) {
  getQuizQuestionListWIthSearch(input: $input) {
    page
    limit
    totalPages
    totalResults
    results {
      ...LmsQuestionFields
    }
  }
}
    ${LmsQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuestionsGQL extends Apollo.Query<LmsGetQuestionsQuery, LmsGetQuestionsQueryVariables> {
    override document = LmsGetQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuestionByIdDocument = gql`
    query LmsGetQuestionById($id: ID!) {
  getQuizQuestionById(id: $id) {
    ...LmsQuestionFields
  }
}
    ${LmsQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuestionByIdGQL extends Apollo.Query<LmsGetQuestionByIdQuery, LmsGetQuestionByIdQueryVariables> {
    override document = LmsGetQuestionByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuestionByLanguageDocument = gql`
    query LmsGetQuestionByLanguage($masterQuestionId: ID!, $language: LanguageCode!) {
  getQuizQuestionByLanguage(
    master_question_id: $masterQuestionId
    language: $language
  ) {
    ...LmsQuestionFields
  }
}
    ${LmsQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuestionByLanguageGQL extends Apollo.Query<LmsGetQuestionByLanguageQuery, LmsGetQuestionByLanguageQueryVariables> {
    override document = LmsGetQuestionByLanguageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuestionsForSectionDocument = gql`
    query LmsGetQuestionsForSection($input: QuizQuestionInputs) {
  getQuizQuestions(input: $input) {
    id
    question_text
    question_type
    description
    correct_answer
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuestionsForSectionGQL extends Apollo.Query<LmsGetQuestionsForSectionQuery, LmsGetQuestionsForSectionQueryVariables> {
    override document = LmsGetQuestionsForSectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsCreateQuestionDocument = gql`
    mutation LmsCreateQuestion($input: CreateQuestionInput!) {
  createQuizQuestion(input: $input) {
    id
    master_question_id
    question_text
    question_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsCreateQuestionGQL extends Apollo.Mutation<LmsCreateQuestionMutation, LmsCreateQuestionMutationVariables> {
    override document = LmsCreateQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateQuestionDocument = gql`
    mutation LmsUpdateQuestion($id: ID, $input: UpdateQuestionInput!) {
  updateQuizQuestion(id: $id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateQuestionGQL extends Apollo.Mutation<LmsUpdateQuestionMutation, LmsUpdateQuestionMutationVariables> {
    override document = LmsUpdateQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsArchiveQuestionDocument = gql`
    mutation LmsArchiveQuestion($id: ID!, $archive: Boolean!) {
  archiveUnarchiveQuizQuestion(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsArchiveQuestionGQL extends Apollo.Mutation<LmsArchiveQuestionMutation, LmsArchiveQuestionMutationVariables> {
    override document = LmsArchiveQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsVerifyQuestionTranslationDocument = gql`
    mutation LmsVerifyQuestionTranslation($masterQuestionId: ID!, $language: LanguageCode!) {
  verifyTranslation(master_question_id: $masterQuestionId, language: $language)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsVerifyQuestionTranslationGQL extends Apollo.Mutation<LmsVerifyQuestionTranslationMutation, LmsVerifyQuestionTranslationMutationVariables> {
    override document = LmsVerifyQuestionTranslationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsReRunQuestionTranslationDocument = gql`
    mutation LmsReRunQuestionTranslation($questionId: ID!) {
  reRunQuestionTranslation(question_id: $questionId) {
    ...LmsQuestionFields
  }
}
    ${LmsQuestionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsReRunQuestionTranslationGQL extends Apollo.Mutation<LmsReRunQuestionTranslationMutation, LmsReRunQuestionTranslationMutationVariables> {
    override document = LmsReRunQuestionTranslationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuizListDocument = gql`
    query LmsGetQuizList($input: quizListInput) {
  getQuizListWIthSearch(input: $input) {
    config {
      ...LmsConfigFields
    }
    results {
      ...LmsQuizFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}
${LmsQuizFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuizListGQL extends Apollo.Query<LmsGetQuizListQuery, LmsGetQuizListQueryVariables> {
    override document = LmsGetQuizListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuizesForTrainingDocument = gql`
    query LmsGetQuizesForTraining($input: quizListInput) {
  getQuizesForTraining(input: $input) {
    config {
      ...LmsConfigFields
    }
    results {
      id
      title
      status
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuizesForTrainingGQL extends Apollo.Query<LmsGetQuizesForTrainingQuery, LmsGetQuizesForTrainingQueryVariables> {
    override document = LmsGetQuizesForTrainingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuizByIdDocument = gql`
    query LmsGetQuizById($id: ID!) {
  getQuizById(id: $id) {
    ...LmsQuizFields
  }
}
    ${LmsQuizFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuizByIdGQL extends Apollo.Query<LmsGetQuizByIdQuery, LmsGetQuizByIdQueryVariables> {
    override document = LmsGetQuizByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuizByIdForManualReAttemptedDocument = gql`
    query LmsGetQuizByIdForManualReAttempted($id: ID!) {
  getQuizByIdForManualReAttemped(id: $id) {
    ...LmsQuizFields
  }
}
    ${LmsQuizFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuizByIdForManualReAttemptedGQL extends Apollo.Query<LmsGetQuizByIdForManualReAttemptedQuery, LmsGetQuizByIdForManualReAttemptedQueryVariables> {
    override document = LmsGetQuizByIdForManualReAttemptedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsCreateQuizDocument = gql`
    mutation LmsCreateQuiz($input: CreateQuizInput!) {
  createQuiz(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsCreateQuizGQL extends Apollo.Mutation<LmsCreateQuizMutation, LmsCreateQuizMutationVariables> {
    override document = LmsCreateQuizDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateQuizDocument = gql`
    mutation LmsUpdateQuiz($id: ID!, $input: UpdateQuizInput!) {
  updateQuiz(id: $id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateQuizGQL extends Apollo.Mutation<LmsUpdateQuizMutation, LmsUpdateQuizMutationVariables> {
    override document = LmsUpdateQuizDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsArchiveQuizDocument = gql`
    mutation LmsArchiveQuiz($id: ID!, $archive: Boolean!) {
  archiveUnarchiveQuiz(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsArchiveQuizGQL extends Apollo.Mutation<LmsArchiveQuizMutation, LmsArchiveQuizMutationVariables> {
    override document = LmsArchiveQuizDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetUserQuizAssignmentsDocument = gql`
    query LmsGetUserQuizAssignments($input: QuizUserListInput) {
  getUsersQuizAssignmentListWIthSearch(input: $input) {
    config {
      ...LmsConfigFields
    }
    results {
      id
      title
      duration
      grade
      status
      percentage
      question_count
      total_score
      user_score
      quiz_start_time
      quiz_end_time
      start_time
      end_time
      invalidated_at
      invalidation_reason
      is_invalidated
      Quiz {
        id
        title
        status
      }
      User {
        ...LmsUserFields
      }
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}
${LmsUserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetUserQuizAssignmentsGQL extends Apollo.Query<LmsGetUserQuizAssignmentsQuery, LmsGetUserQuizAssignmentsQueryVariables> {
    override document = LmsGetUserQuizAssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuizAssignmentByIdDocument = gql`
    query LmsGetQuizAssignmentById($id: ID!) {
  getQuizAssignmentById(id: $id) {
    ...LmsAssignedQuizFields
  }
}
    ${LmsAssignedQuizFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuizAssignmentByIdGQL extends Apollo.Query<LmsGetQuizAssignmentByIdQuery, LmsGetQuizAssignmentByIdQueryVariables> {
    override document = LmsGetQuizAssignmentByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsFetchQuizAssignmentByIdDocument = gql`
    query LmsFetchQuizAssignmentById($userId: ID!, $quizId: ID!, $quizTrainingReplicaId: ID!) {
  fetchQuizAssignmentById(
    userId: $userId
    quizId: $quizId
    quizTrainingReplicaId: $quizTrainingReplicaId
  ) {
    id
    title
    quiz_end_time
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsFetchQuizAssignmentByIdGQL extends Apollo.Query<LmsFetchQuizAssignmentByIdQuery, LmsFetchQuizAssignmentByIdQueryVariables> {
    override document = LmsFetchQuizAssignmentByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetAttemptQuizByIdDocument = gql`
    query LmsGetAttemptQuizById($id: ID!, $selectedLanguage: LanguageCode!) {
  getAttemptQuizById(id: $id, selectedLanguage: $selectedLanguage) {
    ...LmsAssignedQuizFields
  }
}
    ${LmsAssignedQuizFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetAttemptQuizByIdGQL extends Apollo.Query<LmsGetAttemptQuizByIdQuery, LmsGetAttemptQuizByIdQueryVariables> {
    override document = LmsGetAttemptQuizByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuizReportByIdDocument = gql`
    query LmsGetQuizReportById($id: ID!, $selectedLanguage: LanguageCode!) {
  getQuizReportById(id: $id, selectedLanguage: $selectedLanguage) {
    ...LmsAssignedQuizReportFields
  }
}
    ${LmsAssignedQuizReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuizReportByIdGQL extends Apollo.Query<LmsGetQuizReportByIdQuery, LmsGetQuizReportByIdQueryVariables> {
    override document = LmsGetQuizReportByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsStartQuizDocument = gql`
    mutation LmsStartQuiz($id: ID!) {
  startedQuiz(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsStartQuizGQL extends Apollo.Mutation<LmsStartQuizMutation, LmsStartQuizMutationVariables> {
    override document = LmsStartQuizDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsAttemptQuizDocument = gql`
    mutation LmsAttemptQuiz($id: ID, $input: AttemptInput) {
  attemptQuizAssignment(id: $id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsAttemptQuizGQL extends Apollo.Mutation<LmsAttemptQuizMutation, LmsAttemptQuizMutationVariables> {
    override document = LmsAttemptQuizDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsCheckQuizDocument = gql`
    mutation LmsCheckQuiz($id: ID!, $input: CheckerInput) {
  checkerQuizAssignment(id: $id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsCheckQuizGQL extends Apollo.Mutation<LmsCheckQuizMutation, LmsCheckQuizMutationVariables> {
    override document = LmsCheckQuizDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetQuizAssignmentListDocument = gql`
    query LmsGetQuizAssignmentList($input: quizAssignedListInput) {
  getQuizAssignmentListWIthSearch(input: $input) {
    config {
      ...LmsConfigFields
    }
    results {
      ...LmsAssignedQuizFields
    }
    stats {
      duration
      highest_score
      total_attempt
      total_completed
      total_condidate
      total_fail
      total_inprogress
      total_not_attempt
      total_pass
      total_to_be_attempt
      total_to_be_check
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}
${LmsAssignedQuizFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetQuizAssignmentListGQL extends Apollo.Query<LmsGetQuizAssignmentListQuery, LmsGetQuizAssignmentListQueryVariables> {
    override document = LmsGetQuizAssignmentListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetEvaluatorAssignmentsDocument = gql`
    query LmsGetEvaluatorAssignments($input: quizAssignedListInput) {
  getEvaluatorQuizAssignmentListWIthSearch(input: $input) {
    config {
      ...LmsConfigFields
    }
    results {
      ...LmsQuizFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}
${LmsQuizFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetEvaluatorAssignmentsGQL extends Apollo.Query<LmsGetEvaluatorAssignmentsQuery, LmsGetEvaluatorAssignmentsQueryVariables> {
    override document = LmsGetEvaluatorAssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingListDocument = gql`
    query LmsGetTrainingList($input: quizTraningListInput) {
  getQuizTraningListWithSearch(input: $input) {
    config {
      ...LmsConfigFields
    }
    results {
      ...LmsTrainingFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}
${LmsTrainingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingListGQL extends Apollo.Query<LmsGetTrainingListQuery, LmsGetTrainingListQueryVariables> {
    override document = LmsGetTrainingListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetMyTrainingListDocument = gql`
    query LmsGetMyTrainingList($input: quizTraningListInput) {
  getMyQuizTraningListWithSearch(input: $input) {
    config {
      ...LmsConfigFields
    }
    results {
      ...LmsTrainingDetailFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}
${LmsTrainingDetailFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetMyTrainingListGQL extends Apollo.Query<LmsGetMyTrainingListQuery, LmsGetMyTrainingListQueryVariables> {
    override document = LmsGetMyTrainingListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingByIdDocument = gql`
    query LmsGetTrainingById($id: ID!) {
  getQuizTrainingById(id: $id) {
    ...LmsTrainingDetailFields
  }
}
    ${LmsTrainingDetailFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingByIdGQL extends Apollo.Query<LmsGetTrainingByIdQuery, LmsGetTrainingByIdQueryVariables> {
    override document = LmsGetTrainingByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsCreateTrainingDocument = gql`
    mutation LmsCreateTraining($input: CreateTrainingInput!) {
  createQuizTraining(input: $input) {
    id
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsCreateTrainingGQL extends Apollo.Mutation<LmsCreateTrainingMutation, LmsCreateTrainingMutationVariables> {
    override document = LmsCreateTrainingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateTrainingDocument = gql`
    mutation LmsUpdateTraining($id: ID!, $input: updateTrainingInput!) {
  updateQuizTraining(id: $id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateTrainingGQL extends Apollo.Mutation<LmsUpdateTrainingMutation, LmsUpdateTrainingMutationVariables> {
    override document = LmsUpdateTrainingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsArchiveTrainingDocument = gql`
    mutation LmsArchiveTraining($id: ID!, $archive: Boolean!) {
  archiveUnarchiveQuizTraning(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsArchiveTrainingGQL extends Apollo.Mutation<LmsArchiveTrainingMutation, LmsArchiveTrainingMutationVariables> {
    override document = LmsArchiveTrainingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsAssignTrainingDocument = gql`
    mutation LmsAssignTraining($id: ID!, $input: quizTrainingAssignToInput!) {
  quizTraningAssignTo(id: $id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsAssignTrainingGQL extends Apollo.Mutation<LmsAssignTrainingMutation, LmsAssignTrainingMutationVariables> {
    override document = LmsAssignTrainingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsAssignUsersToTrainingDocument = gql`
    mutation LmsAssignUsersToTraining($trainingId: ID!, $input: assignUsersToQuizAndTrainingInput!) {
  assignUsersToQuizAndTraining(trainingId: $trainingId, input: $input) {
    id
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsAssignUsersToTrainingGQL extends Apollo.Mutation<LmsAssignUsersToTrainingMutation, LmsAssignUsersToTrainingMutationVariables> {
    override document = LmsAssignUsersToTrainingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetEvaluatorsDocument = gql`
    query LmsGetEvaluators($input: evaluatorInputs) {
  getEvaluators(input: $input) {
    Business
    _id
    email
    full_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetEvaluatorsGQL extends Apollo.Query<LmsGetEvaluatorsQuery, LmsGetEvaluatorsQueryVariables> {
    override document = LmsGetEvaluatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingReplicaListDocument = gql`
    query LmsGetTrainingReplicaList($input: quizTrainingReplicaListInput) {
  getQuizTrainingReplicaListWIthSearch(input: $input) {
    config {
      ...LmsConfigFields
    }
    stats {
      total_completed
      total_condidate
      total_inprogress
      total_to_be_attempt
      total_not_attempt
      total_pass
      total_fail
    }
    results {
      ...LmsTrainingReplicaFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}
${LmsTrainingReplicaFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingReplicaListGQL extends Apollo.Query<LmsGetTrainingReplicaListQuery, LmsGetTrainingReplicaListQueryVariables> {
    override document = LmsGetTrainingReplicaListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingReplicaByIdDocument = gql`
    query LmsGetTrainingReplicaById($id: ID!) {
  getQuizTrainingReplicaById(id: $id) {
    ...LmsTrainingReplicaFields
  }
}
    ${LmsTrainingReplicaFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingReplicaByIdGQL extends Apollo.Query<LmsGetTrainingReplicaByIdQuery, LmsGetTrainingReplicaByIdQueryVariables> {
    override document = LmsGetTrainingReplicaByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateTrainingReplicaDocument = gql`
    mutation LmsUpdateTrainingReplica($id: ID!, $input: updateTraininReplicagInput!) {
  updateQuizTrainingReplica(id: $id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateTrainingReplicaGQL extends Apollo.Mutation<LmsUpdateTrainingReplicaMutation, LmsUpdateTrainingReplicaMutationVariables> {
    override document = LmsUpdateTrainingReplicaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsFilterTrainingAssignmentsDocument = gql`
    query LmsFilterTrainingAssignments($trainingReplicaId: ID!, $input: QuizTrainingAssignmentFilterInput) {
  filterQuizTrainingAssignement(
    trainingReplicaId: $trainingReplicaId
    input: $input
  ) {
    _id
    full_name
    email
    status
    start_time
    end_time
    training_start_time
    training_end_time
    attachments {
      _id
      file
      file_name
      language
      size
      type
      is_completed
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsFilterTrainingAssignmentsGQL extends Apollo.Query<LmsFilterTrainingAssignmentsQuery, LmsFilterTrainingAssignmentsQueryVariables> {
    override document = LmsFilterTrainingAssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingAssignmentsDocument = gql`
    query LmsGetTrainingAssignments($input: QuizTraningAssignementUserListInput) {
  getQuizTrainingAssignmentListWIthSearch(input: $input) {
    config {
      ...LmsConfigFields
    }
    results {
      _id
      title
      description
      status
      start_time
      end_time
      training_start_time
      training_end_time
      content
      languages
      matrix_section
      invalidated_at
      invalidation_reason
      is_invalidated
      User {
        ...LmsUserFields
      }
      Quiz {
        id
        title
        status
      }
      QuizTrainingReplica {
        ...LmsTrainingReplicaFields
      }
      QuizTrainingCategory {
        id
        name
      }
      QuizTrainingSubCategory {
        id
        name
      }
      attachments {
        _id
        file
        file_name
        language
        size
        type
        is_completed
      }
      links {
        _id
        url
        language
        is_completed
      }
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}
${LmsUserFieldsFragmentDoc}
${LmsTrainingReplicaFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingAssignmentsGQL extends Apollo.Query<LmsGetTrainingAssignmentsQuery, LmsGetTrainingAssignmentsQueryVariables> {
    override document = LmsGetTrainingAssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingAssignmentByIdDocument = gql`
    query LmsGetTrainingAssignmentById($id: ID!) {
  getQuizTrainingAssignementById(id: $id) {
    _id
    title
    description
    status
    start_time
    end_time
    training_start_time
    training_end_time
    content
    languages
    User {
      ...LmsUserFields
    }
    Quiz {
      id
      title
      status
    }
    QuizTrainingReplica {
      ...LmsTrainingReplicaFields
    }
    QuizTrainingCategory {
      id
      name
    }
    QuizTrainingSubCategory {
      id
      name
    }
    attachments {
      _id
      file
      file_name
      language
      size
      type
      is_completed
    }
    links {
      _id
      url
      language
      is_completed
    }
  }
}
    ${LmsUserFieldsFragmentDoc}
${LmsTrainingReplicaFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingAssignmentByIdGQL extends Apollo.Query<LmsGetTrainingAssignmentByIdQuery, LmsGetTrainingAssignmentByIdQueryVariables> {
    override document = LmsGetTrainingAssignmentByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateTrainingAssignmentStatusDocument = gql`
    mutation LmsUpdateTrainingAssignmentStatus($input: UpdateQuizTrainingAssignmentStatusInput!) {
  updateQuizTrainingAssignmentStatus(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateTrainingAssignmentStatusGQL extends Apollo.Mutation<LmsUpdateTrainingAssignmentStatusMutation, LmsUpdateTrainingAssignmentStatusMutationVariables> {
    override document = LmsUpdateTrainingAssignmentStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateUserAttachmentStatusDocument = gql`
    mutation LmsUpdateUserAttachmentStatus($trainingId: ID!, $input: updateTrainingAttachementStatus!) {
  updateUserAttachmentStatus(trainingId: $trainingId, input: $input) {
    id
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateUserAttachmentStatusGQL extends Apollo.Mutation<LmsUpdateUserAttachmentStatusMutation, LmsUpdateUserAttachmentStatusMutationVariables> {
    override document = LmsUpdateUserAttachmentStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateTrainingAssigneeAttachmentStatusDocument = gql`
    mutation LmsUpdateTrainingAssigneeAttachmentStatus($trainingAssignmentId: ID!, $input: updateTrainingAttachementStatus!) {
  updateTrainingAssigneeAttachmentStatus(
    trainingAssignmentId: $trainingAssignmentId
    input: $input
  ) {
    _id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateTrainingAssigneeAttachmentStatusGQL extends Apollo.Mutation<LmsUpdateTrainingAssigneeAttachmentStatusMutation, LmsUpdateTrainingAssigneeAttachmentStatusMutationVariables> {
    override document = LmsUpdateTrainingAssigneeAttachmentStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateTrainingAssigneeLinkStatusDocument = gql`
    mutation LmsUpdateTrainingAssigneeLinkStatus($trainingAssignmentId: ID!, $input: updateTrainingLinkStatus!) {
  updateTrainingAssigneeLinkStatus(
    trainingAssignmentId: $trainingAssignmentId
    input: $input
  ) {
    _id
    status
    title
    links {
      _id
      url
      language
      is_completed
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateTrainingAssigneeLinkStatusGQL extends Apollo.Mutation<LmsUpdateTrainingAssigneeLinkStatusMutation, LmsUpdateTrainingAssigneeLinkStatusMutationVariables> {
    override document = LmsUpdateTrainingAssigneeLinkStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateTraineeStatusDocument = gql`
    mutation LmsUpdateTraineeStatus($id: ID!, $input: quizTrainingUpdateStatus!) {
  updateTraineStatus(id: $id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateTraineeStatusGQL extends Apollo.Mutation<LmsUpdateTraineeStatusMutation, LmsUpdateTraineeStatusMutationVariables> {
    override document = LmsUpdateTraineeStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsAssigneeFilterByStatusDocument = gql`
    mutation LmsAssigneeFilterByStatus($id: ID!, $status: TrainingAssignStatus, $name: String) {
  assigneeFilterByStatus(id: $id, status: $status, name: $name) {
    title
    type
    start_time
    end_time
    user {
      full_name
      email
      status
      completed_date
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsAssigneeFilterByStatusGQL extends Apollo.Mutation<LmsAssigneeFilterByStatusMutation, LmsAssigneeFilterByStatusMutationVariables> {
    override document = LmsAssigneeFilterByStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingSettingsDocument = gql`
    query LmsGetTrainingSettings {
  getTrainingSettings {
    _id
    min_passing_score
    failure_escalation_threshold
    reminder_frequency_days
    mandatory_min_passing_score
    mandatory_failure_escalation_threshold
    mandatory_reminder_frequency_days
    departmental_min_passing_score
    departmental_failure_escalation_threshold
    departmental_reminder_frequency_days
    onboarding_min_passing_score
    onboarding_failure_escalation_threshold
    onboarding_reminder_frequency_days
    created_at
    updated_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingSettingsGQL extends Apollo.Query<LmsGetTrainingSettingsQuery, LmsGetTrainingSettingsQueryVariables> {
    override document = LmsGetTrainingSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsCreateTrainingSettingsDocument = gql`
    mutation LmsCreateTrainingSettings {
  createTrainingSettings {
    _id
    min_passing_score
    failure_escalation_threshold
    reminder_frequency_days
    mandatory_min_passing_score
    mandatory_failure_escalation_threshold
    mandatory_reminder_frequency_days
    departmental_min_passing_score
    departmental_failure_escalation_threshold
    departmental_reminder_frequency_days
    onboarding_min_passing_score
    onboarding_failure_escalation_threshold
    onboarding_reminder_frequency_days
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsCreateTrainingSettingsGQL extends Apollo.Mutation<LmsCreateTrainingSettingsMutation, LmsCreateTrainingSettingsMutationVariables> {
    override document = LmsCreateTrainingSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateTrainingSettingsDocument = gql`
    mutation LmsUpdateTrainingSettings($input: TrainingSettingsUpdateInput!) {
  updateTrainingSettings(input: $input) {
    _id
    min_passing_score
    failure_escalation_threshold
    reminder_frequency_days
    mandatory_min_passing_score
    mandatory_failure_escalation_threshold
    mandatory_reminder_frequency_days
    departmental_min_passing_score
    departmental_failure_escalation_threshold
    departmental_reminder_frequency_days
    onboarding_min_passing_score
    onboarding_failure_escalation_threshold
    onboarding_reminder_frequency_days
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateTrainingSettingsGQL extends Apollo.Mutation<LmsUpdateTrainingSettingsMutation, LmsUpdateTrainingSettingsMutationVariables> {
    override document = LmsUpdateTrainingSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetAllExternalVendorTrainingsDocument = gql`
    query LmsGetAllExternalVendorTrainings($input: ExternalVendorTrainingListInput) {
  getAllExternalVendorTrainings(input: $input) {
    results {
      _id
      training_name
      provider
      comments
      completion_date
      User {
        _id
        full_name
        first_name
        last_name
      }
      created_by {
        _id
        full_name
      }
    }
    config {
      ...LmsConfigFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetAllExternalVendorTrainingsGQL extends Apollo.Query<LmsGetAllExternalVendorTrainingsQuery, LmsGetAllExternalVendorTrainingsQueryVariables> {
    override document = LmsGetAllExternalVendorTrainingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetExternalVendorTrainingsByIdDocument = gql`
    query LmsGetExternalVendorTrainingsById($id: ID!) {
  getExternalVendorTrainingsById(id: $id) {
    _id
    training_name
    provider
    completion_date
    comments
    User {
      _id
      full_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetExternalVendorTrainingsByIdGQL extends Apollo.Query<LmsGetExternalVendorTrainingsByIdQuery, LmsGetExternalVendorTrainingsByIdQueryVariables> {
    override document = LmsGetExternalVendorTrainingsByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsCreateExternalVendorTrainingDocument = gql`
    mutation LmsCreateExternalVendorTraining($input: CreateExternalVendorTrainingInput!) {
  createExternalVendorTraining(input: $input) {
    _id
    training_name
    provider
    completion_date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsCreateExternalVendorTrainingGQL extends Apollo.Mutation<LmsCreateExternalVendorTrainingMutation, LmsCreateExternalVendorTrainingMutationVariables> {
    override document = LmsCreateExternalVendorTrainingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateExternalVendorTrainingDocument = gql`
    mutation LmsUpdateExternalVendorTraining($id: ID!, $input: UpdateExternalVendorTrainingInput!) {
  updateExternalVendorTraining(id: $id, input: $input) {
    _id
    training_name
    provider
    completion_date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateExternalVendorTrainingGQL extends Apollo.Mutation<LmsUpdateExternalVendorTrainingMutation, LmsUpdateExternalVendorTrainingMutationVariables> {
    override document = LmsUpdateExternalVendorTrainingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsDeleteExternalVendorTrainingDocument = gql`
    mutation LmsDeleteExternalVendorTraining($id: ID!) {
  deleteExternalVendorTraining(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsDeleteExternalVendorTrainingGQL extends Apollo.Mutation<LmsDeleteExternalVendorTrainingMutation, LmsDeleteExternalVendorTrainingMutationVariables> {
    override document = LmsDeleteExternalVendorTrainingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetAllOrientationTrackingDocument = gql`
    query LmsGetAllOrientationTracking($input: OrientationTrackingListInput) {
  getAllOrientationTracking(input: $input) {
    results {
      _id
      delivery_method
      orientation_date
      acknowledged_at
      status
      created_at
      updated_at
      User {
        _id
        full_name
        first_name
        last_name
        employee_id
        email
      }
    }
    config {
      ...LmsConfigFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetAllOrientationTrackingGQL extends Apollo.Query<LmsGetAllOrientationTrackingQuery, LmsGetAllOrientationTrackingQueryVariables> {
    override document = LmsGetAllOrientationTrackingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetOrientationTrackingByIdDocument = gql`
    query LmsGetOrientationTrackingById($id: ID!) {
  getOrientationTrackingById(_id: $id) {
    _id
    delivery_method
    orientation_date
    acknowledged_at
    status
    created_at
    updated_at
    User {
      _id
      full_name
      first_name
      last_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetOrientationTrackingByIdGQL extends Apollo.Query<LmsGetOrientationTrackingByIdQuery, LmsGetOrientationTrackingByIdQueryVariables> {
    override document = LmsGetOrientationTrackingByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetMyOrientationTrackingDocument = gql`
    query LmsGetMyOrientationTracking {
  getMyOrientationTracking {
    _id
    delivery_method
    orientation_date
    acknowledged_at
    status
    created_at
    updated_at
    User {
      _id
      full_name
      first_name
      last_name
      employee_id
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetMyOrientationTrackingGQL extends Apollo.Query<LmsGetMyOrientationTrackingQuery, LmsGetMyOrientationTrackingQueryVariables> {
    override document = LmsGetMyOrientationTrackingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateOrientationDetailsDocument = gql`
    mutation LmsUpdateOrientationDetails($input: UpdateOrientationDetailsInput!) {
  updateOrientationDetails(input: $input) {
    _id
    delivery_method
    orientation_date
    acknowledged_at
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateOrientationDetailsGQL extends Apollo.Mutation<LmsUpdateOrientationDetailsMutation, LmsUpdateOrientationDetailsMutationVariables> {
    override document = LmsUpdateOrientationDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsAcknowledgeOrientationDocument = gql`
    mutation LmsAcknowledgeOrientation {
  acknowledgeOrientation {
    _id
    delivery_method
    orientation_date
    acknowledged_at
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsAcknowledgeOrientationGQL extends Apollo.Mutation<LmsAcknowledgeOrientationMutation, LmsAcknowledgeOrientationMutationVariables> {
    override document = LmsAcknowledgeOrientationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingCyclesDocument = gql`
    query LmsGetTrainingCycles($input: TrainingCycleListInput) {
  getTrainingCycles(input: $input) {
    results {
      _id
      name
      matrix_section
      status
      type
      start_date
      end_date
      is_active
      created_at
      updated_at
      assignTo {
        _id
        id
        full_name
        first_name
        last_name
        email
      }
      targetDepartments {
        _id
        department_name
      }
    }
    config {
      ...LmsConfigFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingCyclesGQL extends Apollo.Query<LmsGetTrainingCyclesQuery, LmsGetTrainingCyclesQueryVariables> {
    override document = LmsGetTrainingCyclesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsCreateRefresherCycleDocument = gql`
    mutation LmsCreateRefresherCycle($input: CreateRefresherCycleInput) {
  createRefresherCycle(input: $input) {
    _id
    name
    matrix_section
    status
    type
    start_date
    end_date
    is_active
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsCreateRefresherCycleGQL extends Apollo.Mutation<LmsCreateRefresherCycleMutation, LmsCreateRefresherCycleMutationVariables> {
    override document = LmsCreateRefresherCycleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsDeleteRefresherCycleDocument = gql`
    mutation LmsDeleteRefresherCycle($id: ID!) {
  deleteRefresherCycle(id: $id) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsDeleteRefresherCycleGQL extends Apollo.Mutation<LmsDeleteRefresherCycleMutation, LmsDeleteRefresherCycleMutationVariables> {
    override document = LmsDeleteRefresherCycleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetAllMilestoneTrackingDocument = gql`
    query LmsGetAllMilestoneTracking($input: MilestoneTrackingListInput) {
  getAllMilestoneTracking(input: $input) {
    results {
      _id
      milestone_type
      admin_mode
      score_percentage
      evidence_doc
      meeting_date
      outcome_notes
      completion_date
      deadline_date
      status
      created_at
      updated_at
      User {
        _id
        first_name
        last_name
        full_name
      }
    }
    config {
      ...LmsConfigFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetAllMilestoneTrackingGQL extends Apollo.Query<LmsGetAllMilestoneTrackingQuery, LmsGetAllMilestoneTrackingQueryVariables> {
    override document = LmsGetAllMilestoneTrackingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetMilestoneTrackingByIdDocument = gql`
    query LmsGetMilestoneTrackingById($id: ID!) {
  getMilestoneTrackingById(_id: $id) {
    _id
    milestone_type
    admin_mode
    score_percentage
    evidence_doc
    meeting_date
    outcome_notes
    completion_date
    deadline_date
    status
    User {
      _id
      first_name
      last_name
      full_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetMilestoneTrackingByIdGQL extends Apollo.Query<LmsGetMilestoneTrackingByIdQuery, LmsGetMilestoneTrackingByIdQueryVariables> {
    override document = LmsGetMilestoneTrackingByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsRecordExternalAssessmentDocument = gql`
    mutation LmsRecordExternalAssessment($input: RecordExternalAssessmentInput!) {
  recordExternalAssessment(input: $input) {
    _id
    milestone_type
    score_percentage
    evidence_doc
    completion_date
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsRecordExternalAssessmentGQL extends Apollo.Mutation<LmsRecordExternalAssessmentMutation, LmsRecordExternalAssessmentMutationVariables> {
    override document = LmsRecordExternalAssessmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsRecordPerformanceMeetingDocument = gql`
    mutation LmsRecordPerformanceMeeting($input: RecordPerformanceMeetingInput!) {
  recordPerformanceMeeting(input: $input) {
    _id
    milestone_type
    meeting_date
    outcome_notes
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsRecordPerformanceMeetingGQL extends Apollo.Mutation<LmsRecordPerformanceMeetingMutation, LmsRecordPerformanceMeetingMutationVariables> {
    override document = LmsRecordPerformanceMeetingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingMatrixListDocument = gql`
    query LmsGetTrainingMatrixList($input: TrainingMatrixFilter) {
  getTrainingMatrixList(input: $input) {
    results {
      _id
      section
      milestone_type
      admin_mode
      deadline_days
      is_active
      created_at
      updated_at
      Department {
        _id
        department_name
      }
      Designation {
        _id
        designation_name
      }
      QuizTraining {
        training {
          _id
          title
        }
        is_required
      }
      evaluate_by {
        id
        full_name
        email
      }
    }
    config {
      ...LmsConfigFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingMatrixListGQL extends Apollo.Query<LmsGetTrainingMatrixListQuery, LmsGetTrainingMatrixListQueryVariables> {
    override document = LmsGetTrainingMatrixListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingMatrixByIdDocument = gql`
    query LmsGetTrainingMatrixById($id: ID!) {
  getTrainingMatrixById(id: $id) {
    _id
    section
    milestone_type
    admin_mode
    deadline_days
    is_active
    Department {
      _id
      department_name
    }
    Designation {
      _id
      designation_name
    }
    QuizTraining {
      training {
        _id
        title
      }
      is_required
    }
    evaluate_by {
      id
      _id
      full_name
      email
      first_name
      last_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingMatrixByIdGQL extends Apollo.Query<LmsGetTrainingMatrixByIdQuery, LmsGetTrainingMatrixByIdQueryVariables> {
    override document = LmsGetTrainingMatrixByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsCreateTrainingMatrixDocument = gql`
    mutation LmsCreateTrainingMatrix($input: TrainingMatrixInput!) {
  createTrainingMatrix(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsCreateTrainingMatrixGQL extends Apollo.Mutation<LmsCreateTrainingMatrixMutation, LmsCreateTrainingMatrixMutationVariables> {
    override document = LmsCreateTrainingMatrixDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateTrainingMatrixDocument = gql`
    mutation LmsUpdateTrainingMatrix($id: ID!, $input: TrainingMatrixUpdateInput!) {
  updateTrainingMatrix(id: $id, input: $input) {
    _id
    deadline_days
    is_active
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateTrainingMatrixGQL extends Apollo.Mutation<LmsUpdateTrainingMatrixMutation, LmsUpdateTrainingMatrixMutationVariables> {
    override document = LmsUpdateTrainingMatrixDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsDeleteTrainingMatrixByIdDocument = gql`
    mutation LmsDeleteTrainingMatrixById($id: ID!) {
  deleteTrainingMatrixById(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsDeleteTrainingMatrixByIdGQL extends Apollo.Mutation<LmsDeleteTrainingMatrixByIdMutation, LmsDeleteTrainingMatrixByIdMutationVariables> {
    override document = LmsDeleteTrainingMatrixByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetComplianceDashboardDocument = gql`
    query LmsGetComplianceDashboard($input: ComplianceDashboardInput) {
  getComplianceDashboard(input: $input) {
    totalCount
    headerStats {
      total_employees_pending
      total_trainings_outstanding
      overdue_count
      on_track_count
      not_yet_emailed_count
      employees_at_failure_threshold
    }
    employees {
      employee_id
      full_name
      first_name
      last_name
      outstanding_count
      overdue_count
      at_failure_threshold
      last_email_sent_at
      last_reminder_sent_at
      department {
        _id
        department_name
      }
      designation {
        _id
        designation_name
      }
    }
    departmentBreakdown {
      completion_percentage
      department_id
      department_name
      total_employees
      employees_completed_all_trainings
      employees_with_pending_trainings
      overdue_trainings_count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetComplianceDashboardGQL extends Apollo.Query<LmsGetComplianceDashboardQuery, LmsGetComplianceDashboardQueryVariables> {
    override document = LmsGetComplianceDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetComplianceDashboardDataTableDocument = gql`
    query LmsGetComplianceDashboardDataTable($input: ComplianceDashboardListInput) {
  getComplianceDashboardDataTable(input: $input) {
    results {
      employee_id
      full_name
      first_name
      last_name
      outstanding_count
      overdue_count
      at_failure_threshold
      last_email_sent_at
      last_reminder_sent_at
      department {
        _id
        department_name
      }
      designation {
        _id
        designation_name
      }
    }
    config {
      ...LmsConfigFields
    }
    headerStats {
      total_employees_pending
      total_trainings_outstanding
      overdue_count
      on_track_count
      not_yet_emailed_count
      employees_at_failure_threshold
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetComplianceDashboardDataTableGQL extends Apollo.Query<LmsGetComplianceDashboardDataTableQuery, LmsGetComplianceDashboardDataTableQueryVariables> {
    override document = LmsGetComplianceDashboardDataTableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetComplianceDashboardStatsDocument = gql`
    query LmsGetComplianceDashboardStats {
  getComplianceDashboardStats {
    total_employees_pending
    total_trainings_outstanding
    overdue_count
    on_track_count
    not_yet_emailed_count
    employees_at_failure_threshold
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetComplianceDashboardStatsGQL extends Apollo.Query<LmsGetComplianceDashboardStatsQuery, LmsGetComplianceDashboardStatsQueryVariables> {
    override document = LmsGetComplianceDashboardStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetDepartmentComplianceSummaryDocument = gql`
    query LmsGetDepartmentComplianceSummary {
  getDepartmentComplianceSummary {
    completion_percentage
    department_id
    department_name
    total_employees
    employees_completed_all_trainings
    employees_with_pending_trainings
    overdue_trainings_count
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetDepartmentComplianceSummaryGQL extends Apollo.Query<LmsGetDepartmentComplianceSummaryQuery, LmsGetDepartmentComplianceSummaryQueryVariables> {
    override document = LmsGetDepartmentComplianceSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetEmployeeTrainingProfileDocument = gql`
    query LmsGetEmployeeTrainingProfile($employeeId: ID!) {
  getEmployeeTrainingProfile(employeeId: $employeeId) {
    employee {
      full_name
      employee_id
      first_name
      last_name
      department {
        department_name
      }
      designation {
        designation_name
      }
    }
    orientation {
      _id
      status
      orientation_date
      acknowledged_at
      delivery_method
    }
    milestone {
      _id
      status
      milestone_type
      admin_mode
      deadline_date
      completion_date
      urgency_status
    }
    trainings {
      title
      matrix_section
      status
      score_percentage
      attempt_count
      due_date
      urgency_status
      failure_counter
      completion_date
      cycle_id
      assignment_id
      escalation_triggered
      attempts {
        attempt_number
        score
        is_passed
      }
    }
    external_trainings {
      _id
      training_name
      completion_date
      created_at
      provider
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetEmployeeTrainingProfileGQL extends Apollo.Query<LmsGetEmployeeTrainingProfileQuery, LmsGetEmployeeTrainingProfileQueryVariables> {
    override document = LmsGetEmployeeTrainingProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetEmployeeTrainingStatsDocument = gql`
    query LmsGetEmployeeTrainingStats($employeeId: ID!) {
  getEmployeeTrainingStats(employeeId: $employeeId) {
    total
    completed
    outstanding
    overdue
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetEmployeeTrainingStatsGQL extends Apollo.Query<LmsGetEmployeeTrainingStatsQuery, LmsGetEmployeeTrainingStatsQueryVariables> {
    override document = LmsGetEmployeeTrainingStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetEmployeeTrainingProfileAssignmentsDocument = gql`
    query LmsGetEmployeeTrainingProfileAssignments($input: EmployeeTrainingProfileListInput) {
  getEmployeeTrainingAssignments(input: $input) {
    results {
      _id
      title
      matrix_section
      status
      compliance_status
      quiz_score_percentage
      training_start_time
      training_end_time
      failure_counter
      escalation_triggered
      cycle_id {
        _id
        name
      }
      is_reattempt
      urgency_status
      completion_date
      counter_reset_active
      was_counter_reset
    }
    config {
      ...LmsConfigFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetEmployeeTrainingProfileAssignmentsGQL extends Apollo.Query<LmsGetEmployeeTrainingProfileAssignmentsQuery, LmsGetEmployeeTrainingProfileAssignmentsQueryVariables> {
    override document = LmsGetEmployeeTrainingProfileAssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingAttemptHistoryDocument = gql`
    query LmsGetTrainingAttemptHistory($input: TrainingAttemptHistoryListInput) {
  getTrainingAttemptHistory(input: $input) {
    results {
      _id
      title
      attempt_number
      percentage
      is_passed
      created_at
      end_time
      total_score
      user_score
    }
    config {
      ...LmsConfigFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingAttemptHistoryGQL extends Apollo.Query<LmsGetTrainingAttemptHistoryQuery, LmsGetTrainingAttemptHistoryQueryVariables> {
    override document = LmsGetTrainingAttemptHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingFailureResetLogsDocument = gql`
    query LmsGetTrainingFailureResetLogs($input: TrainingFailureResetLogListInput) {
  getTrainingFailureResetLogs(input: $input) {
    results {
      _id
      note
      previous_failure_count
      created_at
      User {
        _id
        id
        first_name
        last_name
        full_name
      }
      reset_by {
        _id
        id
        first_name
        last_name
        full_name
      }
      QuizTrainingAssignment {
        _id
        title
        status
        matrix_section
      }
    }
    config {
      ...LmsLegacyDataTableConfigFields
    }
  }
}
    ${LmsLegacyDataTableConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingFailureResetLogsGQL extends Apollo.Query<LmsGetTrainingFailureResetLogsQuery, LmsGetTrainingFailureResetLogsQueryVariables> {
    override document = LmsGetTrainingFailureResetLogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsResetEmployeeFailureCounterDocument = gql`
    mutation LmsResetEmployeeFailureCounter($input: ResetFailureCounterInput!) {
  resetEmployeeFailureCounter(input: $input) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsResetEmployeeFailureCounterGQL extends Apollo.Mutation<LmsResetEmployeeFailureCounterMutation, LmsResetEmployeeFailureCounterMutationVariables> {
    override document = LmsResetEmployeeFailureCounterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsTriggerComplianceSummaryEmailDocument = gql`
    mutation LmsTriggerComplianceSummaryEmail($input: ComplianceSummaryEmailInput) {
  triggerComplianceSummaryEmail(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsTriggerComplianceSummaryEmailGQL extends Apollo.Mutation<LmsTriggerComplianceSummaryEmailMutation, LmsTriggerComplianceSummaryEmailMutationVariables> {
    override document = LmsTriggerComplianceSummaryEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsSendManualReminderDocument = gql`
    mutation LmsSendManualReminder($input: SendManualReminderInput!) {
  sendManualReminder(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsSendManualReminderGQL extends Apollo.Mutation<LmsSendManualReminderMutation, LmsSendManualReminderMutationVariables> {
    override document = LmsSendManualReminderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsSendTrainingAssignmentEmailDocument = gql`
    mutation LmsSendTrainingAssignmentEmail($input: SendTrainingAssignmentEmailInput!) {
  sendTrainingAssignmentEmail(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsSendTrainingAssignmentEmailGQL extends Apollo.Mutation<LmsSendTrainingAssignmentEmailMutation, LmsSendTrainingAssignmentEmailMutationVariables> {
    override document = LmsSendTrainingAssignmentEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingCategoryListDocument = gql`
    query LmsGetTrainingCategoryList($input: quizCategoryListInput) {
  getQuizTrainingCategoryListWIthSearch(input: $input) {
    config {
      ...LmsConfigFields
    }
    results {
      ...LmsTrainingCategoryListFields
    }
  }
}
    ${LmsConfigFieldsFragmentDoc}
${LmsTrainingCategoryListFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingCategoryListGQL extends Apollo.Query<LmsGetTrainingCategoryListQuery, LmsGetTrainingCategoryListQueryVariables> {
    override document = LmsGetTrainingCategoryListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetTrainingCategoryByIdDocument = gql`
    query LmsGetTrainingCategoryById($id: ID!) {
  getQuizTrainingCategoryById(id: $id) {
    ...LmsTrainingCategoryFields
  }
}
    ${LmsTrainingCategoryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetTrainingCategoryByIdGQL extends Apollo.Query<LmsGetTrainingCategoryByIdQuery, LmsGetTrainingCategoryByIdQueryVariables> {
    override document = LmsGetTrainingCategoryByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsCreateTrainingCategoryDocument = gql`
    mutation LmsCreateTrainingCategory($input: trainingCategoriesInput!) {
  createQuizTarainingCategories(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsCreateTrainingCategoryGQL extends Apollo.Mutation<LmsCreateTrainingCategoryMutation, LmsCreateTrainingCategoryMutationVariables> {
    override document = LmsCreateTrainingCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsUpdateTrainingCategoryDocument = gql`
    mutation LmsUpdateTrainingCategory($id: ID!, $input: updateTrainingCategoriesInput!) {
  updateQuizTrainingCategories(id: $id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsUpdateTrainingCategoryGQL extends Apollo.Mutation<LmsUpdateTrainingCategoryMutation, LmsUpdateTrainingCategoryMutationVariables> {
    override document = LmsUpdateTrainingCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsArchiveTrainingCategoryDocument = gql`
    mutation LmsArchiveTrainingCategory($id: ID!, $archive: Boolean!) {
  archiveUnarchiveQuizTrainingCategory(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsArchiveTrainingCategoryGQL extends Apollo.Mutation<LmsArchiveTrainingCategoryMutation, LmsArchiveTrainingCategoryMutationVariables> {
    override document = LmsArchiveTrainingCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsArchiveTrainingSubCategoryDocument = gql`
    mutation LmsArchiveTrainingSubCategory($input: deleteSubCategoryInput) {
  archiveUnarchiveQuizTrainingSubCategory(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsArchiveTrainingSubCategoryGQL extends Apollo.Mutation<LmsArchiveTrainingSubCategoryMutation, LmsArchiveTrainingSubCategoryMutationVariables> {
    override document = LmsArchiveTrainingSubCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetSubCategoriesByCategoryDocument = gql`
    query LmsGetSubCategoriesByCategory($categoryId: ID!) {
  getSubCategoriesByCategory(categoryId: $categoryId) {
    _id
    name
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetSubCategoriesByCategoryGQL extends Apollo.Query<LmsGetSubCategoriesByCategoryQuery, LmsGetSubCategoriesByCategoryQueryVariables> {
    override document = LmsGetSubCategoriesByCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsGetSectionsByCategoryDocument = gql`
    query LmsGetSectionsByCategory($id: ID!) {
  getSectionsByCategory(id: $id) {
    id
    name
    score
    question_count
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsGetSectionsByCategoryGQL extends Apollo.Query<LmsGetSectionsByCategoryQuery, LmsGetSectionsByCategoryQueryVariables> {
    override document = LmsGetSectionsByCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LmsFileUploadProgressDocument = gql`
    subscription LmsFileUploadProgress($userId: ID!) {
  fileUploadProgress(userId: $userId) {
    fileName
    module
    percentage
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LmsFileUploadProgressGQL extends Apollo.Subscription<LmsFileUploadProgressSubscription, LmsFileUploadProgressSubscriptionVariables> {
    override document = LmsFileUploadProgressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLoanWithFiltersDocument = gql`
    query GetLoanWithFilters($input: loanFilter) {
  getLoanWithFilters(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      _id
      loan_type
      loan_amount
      no_of_installment
      installment_amount
      loan_recovery_method
      loan_taken_date
      payment_start_date
      payment_received_date
      description
      status
      payment
      balance
      is_deleted
      is_fixed
      approval_status
      behalf_of {
        _id
        full_name
      }
      employee {
        id
        _id
        full_name
        first_name
        last_name
        joining_date
        last_working_date
        salary_type
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLoanWithFiltersGQL extends Apollo.Query<GetLoanWithFiltersQuery, GetLoanWithFiltersQueryVariables> {
    override document = GetLoanWithFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLoanByIdDocument = gql`
    query GetLoanById($id: ID!) {
  getLoanById(id: $id) {
    _id
    loan_type
    loan_amount
    no_of_installment
    installment_amount
    loan_recovery_method
    loan_taken_date
    payment_start_date
    payment_received_date
    description
    status
    payment
    balance
    is_deleted
    is_fixed
    employee {
      id
      full_name
      first_name
      last_name
      joining_date
      last_working_date
    }
    _id
    approval_description
    business_manager {
      _id
      full_name
      status
    }
    behalf_of {
      full_name
      _id
    }
    employee {
      first_name
      last_name
      full_name
    }
    work_flow {
      approval_description
      status
      approved_by {
        id
        full_name
        _id
      }
      employee {
        _id
        full_name
        id
      }
    }
    loan_type
    approval_status
    description
    no_of_installment
    loan_amount
    loan_taken_date
    loan_recovery_method
    payment_start_date
    installment_amount
    is_fixed
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLoanByIdGQL extends Apollo.Query<GetLoanByIdQuery, GetLoanByIdQueryVariables> {
    override document = GetLoanByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLoanTransactionsDocument = gql`
    query GetLoanTransactions($input: loanTransactionFilter) {
  getLoanTransactionsByLoanId(input: $input) {
    config {
      type
      page
      limit
      totalResults
      totalPages
      actions
      columns {
        field
        header
        is_visible
        is_search_able
        is_sortable
        is_amount
        type
        column_data
      }
    }
    employee {
      id
      full_name
      first_name
      last_name
    }
    results {
      _id
      transaction
      loan_amount
      loan_transaction_amount
      loan_transaction_date
      balance
      comment
      is_credit
      is_adjustable
      adjustment_amount
      adjustment_comment
      adjustment_date
      logs {
        adjustment_amount
        adjustment_comment
        adjustment_date
        balance
        is_credit
      }
      loan {
        _id
        loan_type
        loan_amount
        payment_start_date
        balance
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLoanTransactionsGQL extends Apollo.Query<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables> {
    override document = GetLoanTransactionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmployeeLoanAmountDocument = gql`
    query EmployeeLoanAmount($employee: ID!) {
  employeeLoanAmount(employee: $employee) {
    paidAmount
    remainingAmount
    totalAmount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EmployeeLoanAmountGQL extends Apollo.Query<EmployeeLoanAmountQuery, EmployeeLoanAmountQueryVariables> {
    override document = EmployeeLoanAmountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateLoanDocument = gql`
    mutation CreateUpdateLoan($input: InputLoan!) {
  createUpdateLoan(input: $input) {
    _id
    loan_type
    loan_amount
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateLoanGQL extends Apollo.Mutation<CreateUpdateLoanMutation, CreateUpdateLoanMutationVariables> {
    override document = CreateUpdateLoanDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveLoanDocument = gql`
    mutation ArchiveLoan($ids: [ID]!, $archive: Boolean!) {
  archiveLoan(ids: $ids, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveLoanGQL extends Apollo.Mutation<ArchiveLoanMutation, ArchiveLoanMutationVariables> {
    override document = ArchiveLoanDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveLoanTransactionDocument = gql`
    mutation ArchiveLoanTransaction($id: ID!, $archive: Boolean!) {
  archiveLoanTransaction(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveLoanTransactionGQL extends Apollo.Mutation<ArchiveLoanTransactionMutation, ArchiveLoanTransactionMutationVariables> {
    override document = ArchiveLoanTransactionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLoanTransactionDocument = gql`
    mutation CreateLoanTransaction($input: InputTransaction!) {
  createLoanTransaction(input: $input) {
    _id
    loan_transaction_amount
    balance
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLoanTransactionGQL extends Apollo.Mutation<CreateLoanTransactionMutation, CreateLoanTransactionMutationVariables> {
    override document = CreateLoanTransactionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLoanAdjustmentDocument = gql`
    mutation CreateLoanAdjustment($input: InputAdjustment!) {
  createLoanAdjustment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLoanAdjustmentGQL extends Apollo.Mutation<CreateLoanAdjustmentMutation, CreateLoanAdjustmentMutationVariables> {
    override document = CreateLoanAdjustmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPayrollDetailByUserIdDocument = gql`
    query GetPayrollDetailByUserID($user_id: ID) {
  getPayrollDetailByUserID(user_id: $user_id) {
    _id
    User {
      full_name
      salary_payment_method
      employee_type
    }
    Payroll {
      payroll_name
      pay_period
    }
    absents
    account_number
    gross_salary
    basic_salary
    end_date
    leaves
    net_salary
    no_of_days
    pay_date
    start_date
    status
    pto_wages
    back_pay_wages
    allowances {
      amount
      name
      percentage
    }
    contributions {
      amount
      name
      percentage
    }
    deductions {
      amount
      name
      percentage
    }
    loan_payments {
      amount
      name
      percentage
    }
    expenses {
      amount
      name
      percentage
    }
    commissions {
      name
      amount
      percentage
    }
    taxes {
      amount
      name
      percentage
    }
    medical_insurance {
      amount
      name
      percentage
    }
    sale_goals {
      amount
      name
      percentage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPayrollDetailByUserIdGQL extends Apollo.Query<GetPayrollDetailByUserIdQuery, GetPayrollDetailByUserIdQueryVariables> {
    override document = GetPayrollDetailByUserIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllPayrolleListDocument = gql`
    query GetAllPayrolleList($input: inputPayrollList) {
  getAllPayrolleList(input: $input) {
    results {
      _id
      payroll_name
      pay_period
      start_date
      end_date
      no_of_days
      total_amount
      payroll_run_date
      despersed_date
      status
      is_deleted
      is_dispersed
      Business {
        _id
        business_keeping_unit
        business_system_name
        business_legal_name
      }
      BusinessLocation {
        _id
        store_name
        email
        store_legal_name
      }
      payroll_detail {
        User {
          _id
          id
          full_name
          user_name
        }
        salary_type
        total_amount
        status
        is_manually_adjust
        total_adjusted_amount
      }
      no_of_employee
    }
    config {
      page
      limit
      totalPages
      totalResults
      no_of_records
      type
      actions {
        name
        is_visible
      }
      columns {
        _id
        field
        header
        type
        search
        is_search_able
        query {
          first_condition
          second_condition
          first_value
          second_value
          condition
        }
        is_visible
        is_editable
        is_unique
        width
        pinned
        is_groupable
        column_data
        filterValue
        column_dropdown_value {
          _id
          value
        }
        is_sortable
        is_amount
        validateFn
        is_required
        show_total
        sum
        average
        min_count
        max_count
        count
        count_empty
        distinct_count
      }
      filters {
        search
        field
        type
        _ids
        query {
          first_condition
          first_value
          condition
          second_condition
          second_value
        }
      }
      table_preset {
        name
        activeFilters
        columns {
          _id
          field
          header
          type
          search
          is_search_able
          query {
            first_condition
            second_condition
            first_value
            second_value
            condition
          }
          is_visible
          is_editable
          is_unique
          width
          pinned
          is_groupable
          column_data
          filterValue
          column_dropdown_value {
            _id
            value
          }
          is_sortable
          is_amount
          validateFn
          is_required
          show_total
          sum
          average
          min_count
          max_count
          count
          count_empty
          distinct_count
        }
        filters {
          search
          field
          type
          _ids
          query {
            first_condition
            first_value
            condition
            second_condition
            second_value
          }
        }
        config {
          fontFaimly
          bodyTextFontsSize
          headerTextFontsSize
          showVerticalBorder
          selectedTableLayout
          globalSearch
          rowShadingEnabled
          oddRowsBackgroundColor
        }
        id
        is_default
        is_temp
        loadingCall
        type
      }
      table_config {
        fontFaimly
        bodyTextFontsSize
        headerTextFontsSize
        showVerticalBorder
        selectedTableLayout
        globalSearch
        rowShadingEnabled
        oddRowsBackgroundColor
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllPayrolleListGQL extends Apollo.Query<GetAllPayrolleListQuery, GetAllPayrolleListQueryVariables> {
    override document = GetAllPayrolleListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPayrollByIdDocument = gql`
    query GetPayrollByID($id: ID!) {
  getPayrollByID(_id: $id) {
    _id
    payroll_run_date
    payroll_name
    status
    total_amount
    end_date
    no_of_days
    pay_period
    start_date
    payroll_detail {
      total_amount
      status
      salary_type
      User {
        id
        full_name
        employee_type
        account_status
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPayrollByIdGQL extends Apollo.Query<GetPayrollByIdQuery, GetPayrollByIdQueryVariables> {
    override document = GetPayrollByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPayrollDetailDocument = gql`
    query GetPayrollDetail($payrollId: ID!, $userId: ID!) {
  getPayrollDetail(payroll_id: $payrollId, user_id: $userId) {
    _id
    User {
      full_name
      salary_payment_method
      employee_type
    }
    Payroll {
      payroll_name
      pay_period
    }
    adjustment_detail {
      is_credit
      description
      adjusted_amount
      adjusted_at
      adjusted_by {
        id
        full_name
      }
    }
    absents
    gross_salary
    basic_salary
    end_date
    is_dispersed
    leaves
    net_salary
    no_of_days
    pay_date
    start_date
    status
    pto_wages
    back_pay_wages
    allowances {
      amount
      name
      percentage
    }
    contributions {
      amount
      name
      percentage
    }
    deductions {
      amount
      name
      percentage
    }
    loan_payments {
      amount
      name
      percentage
    }
    expenses {
      amount
      name
      percentage
    }
    commissions {
      name
      amount
      percentage
    }
    taxes {
      amount
      name
      percentage
    }
    medical_insurance {
      amount
      name
      percentage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPayrollDetailGQL extends Apollo.Query<GetPayrollDetailQuery, GetPayrollDetailQueryVariables> {
    override document = GetPayrollDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePayrollStatusDocument = gql`
    mutation UpdatePayrollStatus($input: updatePayrollStatusInput!) {
  updatePayrollStatus(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePayrollStatusGQL extends Apollo.Mutation<UpdatePayrollStatusMutation, UpdatePayrollStatusMutationVariables> {
    override document = UpdatePayrollStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PayrollDetailManuallyAdjustDocument = gql`
    mutation PayrollDetailManuallyAdjust($input: manuallyAdjustmentInput!) {
  payrollDetailManuallyAdjust(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PayrollDetailManuallyAdjustGQL extends Apollo.Mutation<PayrollDetailManuallyAdjustMutation, PayrollDetailManuallyAdjustMutationVariables> {
    override document = PayrollDetailManuallyAdjustDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SyncPayrollDocument = gql`
    mutation SyncPayroll($input: syncPayrollInput!) {
  syncPayroll(input: $input) {
    _id
    payroll_name
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SyncPayrollGQL extends Apollo.Mutation<SyncPayrollMutation, SyncPayrollMutationVariables> {
    override document = SyncPayrollDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdatePayrollScheduleDocument = gql`
    mutation CreateUpdatePayrollSchedule($input: PayrollScheduleInput) {
  createUpdatePayrollSchedule(input: $input) {
    _id
    schedule_name
    pay_period
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdatePayrollScheduleGQL extends Apollo.Mutation<CreateUpdatePayrollScheduleMutation, CreateUpdatePayrollScheduleMutationVariables> {
    override document = CreateUpdatePayrollScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchivePayrollScheduleDocument = gql`
    mutation ArchivePayrollSchedule($_id: ID, $archive: Boolean) {
  archivePayrollSchedule(_id: $_id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchivePayrollScheduleGQL extends Apollo.Mutation<ArchivePayrollScheduleMutation, ArchivePayrollScheduleMutationVariables> {
    override document = ArchivePayrollScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateAllowanceDocument = gql`
    mutation CreateUpdateAllowance($input: InputAllowances) {
  createUpdateAllowance(input: $input) {
    _id
    pay_slip_name
    allowance_type
    is_fixed
    amount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateAllowanceGQL extends Apollo.Mutation<CreateUpdateAllowanceMutation, CreateUpdateAllowanceMutationVariables> {
    override document = CreateUpdateAllowanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAllowanceDocument = gql`
    mutation ArchiveAllowance($id: ID, $archive: Boolean) {
  archiveAllowance(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAllowanceGQL extends Apollo.Mutation<ArchiveAllowanceMutation, ArchiveAllowanceMutationVariables> {
    override document = ArchiveAllowanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllowanceWithFiltersDocument = gql`
    query GetAllowanceWithFilters($input: allowanceFilter) {
  getAllowanceWithFilters(input: $input) {
    results {
      _id
      pay_slip_name
      allowance_type
      is_fixed
      amount
      is_deleted
      created_at
    }
    config {
      ...ConfigWithSummaryFields
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllowanceWithFiltersGQL extends Apollo.Query<GetAllowanceWithFiltersQuery, GetAllowanceWithFiltersQueryVariables> {
    override document = GetAllowanceWithFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSearchContributionDocument = gql`
    query GetSearchContribution($input: contributionListFilter) {
  getSearchContribution(input: $input) {
    results {
      _id
      name_pay_slip
      is_calculate_amount_fixed
      contribution_amount
      is_deleted
      created_at
    }
    config {
      ...ConfigWithSummaryFields
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSearchContributionGQL extends Apollo.Query<GetSearchContributionQuery, GetSearchContributionQueryVariables> {
    override document = GetSearchContributionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateContributionDocument = gql`
    mutation CreateUpdateContribution($input: ContributionInput) {
  createUpdateContribution(input: $input) {
    _id
    name_pay_slip
    is_calculate_amount_fixed
    contribution_amount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateContributionGQL extends Apollo.Mutation<CreateUpdateContributionMutation, CreateUpdateContributionMutationVariables> {
    override document = CreateUpdateContributionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteContributionDocument = gql`
    mutation DeleteContribution($_id: ID, $archive: Boolean) {
  deletecontribution(_id: $_id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteContributionGQL extends Apollo.Mutation<DeleteContributionMutation, DeleteContributionMutationVariables> {
    override document = DeleteContributionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSearchDeductionDocument = gql`
    query GetSearchDeduction($input: deductionListFilter) {
  getSearchDeduction(input: $input) {
    results {
      _id
      name_pay_slip
      is_calculate_amount_fixed
      deduction_amount
      is_deleted
      created_at
    }
    config {
      ...ConfigWithSummaryFields
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSearchDeductionGQL extends Apollo.Query<GetSearchDeductionQuery, GetSearchDeductionQueryVariables> {
    override document = GetSearchDeductionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDeductionDocument = gql`
    mutation CreateDeduction($input: DeductionInput) {
  createDeduction(input: $input) {
    _id
    name_pay_slip
    is_calculate_amount_fixed
    deduction_amount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDeductionGQL extends Apollo.Mutation<CreateDeductionMutation, CreateDeductionMutationVariables> {
    override document = CreateDeductionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDeductionDocument = gql`
    mutation DeleteDeduction($_id: ID, $archive: Boolean) {
  deletededuction(_id: $_id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDeductionGQL extends Apollo.Mutation<DeleteDeductionMutation, DeleteDeductionMutationVariables> {
    override document = DeleteDeductionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllPayrollStructureListWithSearchDocument = gql`
    query GetAllPayrollStructureListWithSearch($input: PayrollStructureListInput) {
  getAllPayrollStructureListWithSearch(input: $input) {
    results {
      _id
      structure_name
      is_deleted
      created_at
      allowances {
        amount
        is_percentage
        allowance {
          _id
          pay_slip_name
          allowance_type
        }
      }
      contributions {
        amount
        is_percentage
        contribution {
          _id
          name_pay_slip
        }
      }
      deductions {
        amount
        is_percentage
        deduction {
          _id
          name_pay_slip
        }
      }
    }
    config {
      ...ConfigWithoutSummaryFields
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllPayrollStructureListWithSearchGQL extends Apollo.Query<GetAllPayrollStructureListWithSearchQuery, GetAllPayrollStructureListWithSearchQueryVariables> {
    override document = GetAllPayrollStructureListWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPayrollStructureByIdDocument = gql`
    query GetPayrollStructureByID($_id: ID!) {
  getPayrollStructureByID(_id: $_id) {
    _id
    structure_name
    allowances {
      amount
      is_percentage
      allowance {
        _id
        pay_slip_name
        allowance_type
      }
    }
    contributions {
      amount
      is_percentage
      contribution {
        _id
        name_pay_slip
      }
    }
    deductions {
      amount
      is_percentage
      deduction {
        _id
        name_pay_slip
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPayrollStructureByIdGQL extends Apollo.Query<GetPayrollStructureByIdQuery, GetPayrollStructureByIdQueryVariables> {
    override document = GetPayrollStructureByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdatePayrollStructureDocument = gql`
    mutation CreateUpdatePayrollStructure($input: PayrollStructureInput) {
  createUpdatePayrollStructure(input: $input) {
    _id
    structure_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdatePayrollStructureGQL extends Apollo.Mutation<CreateUpdatePayrollStructureMutation, CreateUpdatePayrollStructureMutationVariables> {
    override document = CreateUpdatePayrollStructureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchivePayrollStructureDocument = gql`
    mutation ArchivePayrollStructure($_id: ID, $archive: Boolean) {
  archivePayrollStructure(_id: $_id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchivePayrollStructureGQL extends Apollo.Mutation<ArchivePayrollStructureMutation, ArchivePayrollStructureMutationVariables> {
    override document = ArchivePayrollStructureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRecruitmentEmployeeByConfigDocument = gql`
    query GetRecruitmentEmployeeByConfig($input: inputRecruitment) {
  getRecruitmentEmployeeByConfig(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      status
      personal_details {
        first_name
        middle_name
        last_name
        full_name
        gender
        marital_status
        birth_date
        home_no
        phone
        email
        is_email_verify
        is_phone_verify
        mobile_no_to_send_sms
        address_1
        address_2
        city {
          _id
          city_name
        }
        zipcode
        state {
          _id
          state_name
        }
        Country {
          _id
          name
        }
        nationality
      }
      term_and_salary {
        roles {
          _id
          roleName
        }
        salary_type
        Designation {
          _id
          designation_name
        }
        salary_offered
        joining_date
        employee_type
        probation_period
      }
      offer_letter {
        offer_letter_details
        offer_letter_description
        professional_tax
        offer_letter_footer
      }
      Business {
        _id
        business_legal_name
      }
      created_at
      created_by {
        id
        _id
        full_name
      }
      updated_at
      updated_by {
        id
        _id
        full_name
      }
      deleted_at
      deleted_by {
        id
        _id
        full_name
      }
      is_deleted
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRecruitmentEmployeeByConfigGQL extends Apollo.Query<GetRecruitmentEmployeeByConfigQuery, GetRecruitmentEmployeeByConfigQueryVariables> {
    override document = GetRecruitmentEmployeeByConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRecruitmentByIdDocument = gql`
    query GetRecruitmentById($id: ID!) {
  getRecruitmentById(id: $id) {
    _id
    status
    is_deleted
    personal_details {
      first_name
      middle_name
      last_name
      email
      gender
      marital_status
      birth_date
      phone
      home_no
      zipcode
      address_1
      is_phone_verify
      Country {
        _id
        name
      }
      state {
        _id
        state_name
      }
      city {
        _id
        city_name
      }
    }
    term_and_salary {
      salary_type
      salary_offered
      weekly_hourly_salary
      weekend_day_salary
      public_day_hourly_salary
      joining_date
      employee_type
      probation_period
      roles {
        _id
        roleName
      }
      Designation {
        _id
        designation_name
      }
    }
    offer_letter {
      offer_letter_description
      offer_letter_details
      offer_letter_footer
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRecruitmentByIdGQL extends Apollo.Query<GetRecruitmentByIdQuery, GetRecruitmentByIdQueryVariables> {
    override document = GetRecruitmentByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountriesDocument = gql`
    query GetCountries {
  countries {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountriesGQL extends Apollo.Query<GetCountriesQuery, GetCountriesQueryVariables> {
    override document = GetCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStateByCountryIdDocument = gql`
    query GetStateByCountryId($country_id: ID!) {
  getStateByCountryId(country_id: $country_id) {
    _id
    state_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStateByCountryIdGQL extends Apollo.Query<GetStateByCountryIdQuery, GetStateByCountryIdQueryVariables> {
    override document = GetStateByCountryIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCityByStateIdDocument = gql`
    query GetCityByStateId($state_id: ID!) {
  getCityByStateId(state_id: $state_id) {
    _id
    city_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCityByStateIdGQL extends Apollo.Query<GetCityByStateIdQuery, GetCityByStateIdQueryVariables> {
    override document = GetCityByStateIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRolesForRecruitmentDocument = gql`
    query GetRolesForRecruitment($roleFilter: roleFilter!) {
  getRoles(roleFilter: $roleFilter) {
    _id
    roleName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRolesForRecruitmentGQL extends Apollo.Query<GetRolesForRecruitmentQuery, GetRolesForRecruitmentQueryVariables> {
    override document = GetRolesForRecruitmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDesignationListForRecruitmentDocument = gql`
    query GetAllDesignationListForRecruitment($input: designationtListFilter) {
  getAllDesignationList(input: $input) {
    result {
      _id
      designation_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDesignationListForRecruitmentGQL extends Apollo.Query<GetAllDesignationListForRecruitmentQuery, GetAllDesignationListForRecruitmentQueryVariables> {
    override document = GetAllDesignationListForRecruitmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateRecruitmentEmployeeDocument = gql`
    mutation CreateUpdateRecruitmentEmployee($input: RecruitmentInput) {
  createUpdateRecruitmentEmployee(input: $input) {
    _id
    status
    personal_details {
      first_name
      last_name
      email
      full_name
    }
    term_and_salary {
      Designation {
        _id
        designation_name
      }
    }
    offer_letter {
      offer_letter_description
      offer_letter_details
      offer_letter_footer
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateRecruitmentEmployeeGQL extends Apollo.Mutation<CreateUpdateRecruitmentEmployeeMutation, CreateUpdateRecruitmentEmployeeMutationVariables> {
    override document = CreateUpdateRecruitmentEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeRecruitmentStatusDocument = gql`
    mutation ChangeRecruitmentStatus($id: ID, $status: recruitmentStatusEnum) {
  changeRecruitmentStatus(id: $id, status: $status) {
    _id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeRecruitmentStatusGQL extends Apollo.Mutation<ChangeRecruitmentStatusMutation, ChangeRecruitmentStatusMutationVariables> {
    override document = ChangeRecruitmentStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRecruitmentDocument = gql`
    mutation DeleteRecruitment($ids: [ID], $is_deleted: Boolean) {
  deleteRecruitment(ids: $ids, is_deleted: $is_deleted) {
    _id
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRecruitmentGQL extends Apollo.Mutation<DeleteRecruitmentMutation, DeleteRecruitmentMutationVariables> {
    override document = DeleteRecruitmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAttendanceRegulationWithSearchDocument = gql`
    query GetAttendanceRegulationWithSearch($input: attendanceFilter) {
  getAttendanceRegulationWithSearch(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      work_flow {
        approved_by {
          id
          full_name
        }
        approval_description
        status
        employee {
          _id
          full_name
          id
        }
      }
      _id
      is_deleted
      description
      behalf_of {
        full_name
        _id
      }
      employee {
        id
        full_name
      }
      reason_type
      attendance_date
      time_in
      time_out
      status
      created_at
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAttendanceRegulationWithSearchGQL extends Apollo.Query<GetAttendanceRegulationWithSearchQuery, GetAttendanceRegulationWithSearchQueryVariables> {
    override document = GetAttendanceRegulationWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAttendanceRegulationDocument = gql`
    mutation CreateAttendanceRegulation($input: InputCreateAttendance!) {
  createAttendanceRegulation(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAttendanceRegulationGQL extends Apollo.Mutation<CreateAttendanceRegulationMutation, CreateAttendanceRegulationMutationVariables> {
    override document = CreateAttendanceRegulationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAttendanceRegulationDocument = gql`
    mutation UpdateAttendanceRegulation($input: InputUpdateAttendance!) {
  updateAttendanceRegulation(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAttendanceRegulationGQL extends Apollo.Mutation<UpdateAttendanceRegulationMutation, UpdateAttendanceRegulationMutationVariables> {
    override document = UpdateAttendanceRegulationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAttendanceRegulationDocument = gql`
    mutation ArchiveAttendanceRegulation($_id: [ID!], $archive: Boolean!) {
  archiveAttendanceRegulation(_id: $_id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAttendanceRegulationGQL extends Apollo.Mutation<ArchiveAttendanceRegulationMutation, ArchiveAttendanceRegulationMutationVariables> {
    override document = ArchiveAttendanceRegulationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMasterDataValuesByDataValueNameDocument = gql`
    query GetMasterDataValuesByDataValueName($data_type_name: String!) {
  getMasterDataValuesByDataValueName(data_type_name: $data_type_name) {
    _id
    data_value_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMasterDataValuesByDataValueNameGQL extends Apollo.Query<GetMasterDataValuesByDataValueNameQuery, GetMasterDataValuesByDataValueNameQueryVariables> {
    override document = GetMasterDataValuesByDataValueNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExpenseRequestDocument = gql`
    mutation CreateExpenseRequest($input: InputCreateExpenseRequest!) {
  createExpenseRequest(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExpenseRequestGQL extends Apollo.Mutation<CreateExpenseRequestMutation, CreateExpenseRequestMutationVariables> {
    override document = CreateExpenseRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateExpenseRequestDocument = gql`
    mutation UpdateExpenseRequest($input: InputUpdateExpenseRequest!) {
  updateExpenseRequest(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExpenseRequestGQL extends Apollo.Mutation<UpdateExpenseRequestMutation, UpdateExpenseRequestMutationVariables> {
    override document = UpdateExpenseRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExpenseRequestWithFiltersDocument = gql`
    query GetExpenseRequestWithFilters($input: expenseFilter) {
  getExpenseRequestWithFilters(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      work_flow {
        approval_description
        employee {
          logo
          designation {
            _id
            designation_name
          }
          id
          full_name
          first_name
          last_name
        }
        status
      }
      _id
      status
      is_deleted
      document_url
      employee {
        full_name
        id
        middle_name
        last_name
        full_name
        email
      }
      _id
      expense_type
      expense_total_amount
      expense_date
      description
      status
      created_at
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExpenseRequestWithFiltersGQL extends Apollo.Query<GetExpenseRequestWithFiltersQuery, GetExpenseRequestWithFiltersQueryVariables> {
    override document = GetExpenseRequestWithFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTimeOffRequestListDocument = gql`
    query GetTimeOffRequestList($input: timeOffListFilter) {
  getTimeOffRequestList(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      is_short_leave
      leave_request_dates {
        from_date
        to_date
      }
      upload_document_info {
        size
        extension
        name
      }
      document_url
      work_flow {
        approval_description
        employee {
          logo
          designation {
            _id
            designation_name
          }
          id
          full_name
          first_name
          last_name
        }
        status
      }
      _id
      is_deleted
      status
      employee {
        full_name
        id
      }
      type_of_absence {
        _id
        name
        is_pto
      }
      reason_for_leave
      total_leaves
      created_at
      total_request_leaves
      total_unpaid_leaves
      remaining_unpaid_days
      request_id
      countIn
      no_request
      leave_request {
        end_time
        from_date
        leave_date
        leave_type
        start_time
        to_date
        no_of_days
        status
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTimeOffRequestListGQL extends Apollo.Query<GetTimeOffRequestListQuery, GetTimeOffRequestListQueryVariables> {
    override document = GetTimeOffRequestListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateTimeOffRequestDocument = gql`
    mutation CreateUpdateTimeOffRequest($input: createUpdateTimeOffRequestInput!) {
  createUpdateTimeOffRequest(input: $input) {
    _id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateTimeOffRequestGQL extends Apollo.Mutation<CreateUpdateTimeOffRequestMutation, CreateUpdateTimeOffRequestMutationVariables> {
    override document = CreateUpdateTimeOffRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRoasterMinutesDocument = gql`
    query GetRoasterMinutes($input: RoasterMinutesInput) {
  getRoasterMinutes(input: $input) {
    totalMinuts
    start_time
    end_time
    start_date
    end_date
    out_of_accural_leave_days
    out_of_accural_leave_hours
    alertData {
      date
      message
      isLeaveApplied
      schedule_not_found
    }
    weekEndDays {
      _id
      id
      name
      selected
    }
    sandwichDate {
      difference_in_days
      difference_in_hours
      deduction_type
      deduction_value
      date_of_sandwich {
        date
        day
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoasterMinutesGQL extends Apollo.Query<GetRoasterMinutesQuery, GetRoasterMinutesQueryVariables> {
    override document = GetRoasterMinutesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLeaveTypeEmployeeByIdDocument = gql`
    query GetLeaveTypeEmployeeById($id: ID!) {
  getLeaveTypeEmployeeById(id: $id) {
    leaveTypeEmployee {
      _id
      countIn
      time_off_days
      unpaid_count
      carry_forword
      working_days
      time_off_type {
        _id
        name
        is_pto
        pto_type
        half_leave_in_ful_leave
        type
        leave_duration
        maximum_duration
        minimum_duration
        per_day_hours
        consecutive_leaves
        count_after_days
        half_day_Consideration
        un_paid_days
        working_days
        un_paid
        pto_minimum_consumable_hours
        pto_advance_notice_days
        is_allow_partial_apply
        partial_apply_minimum
        blackOutWindow {
          date
          reason
        }
      }
    }
    ptoMinutes {
      pto_earned_minutes
      pto_availed_minutes
      carry_forword
    }
    working_days
    total_week_hours
    sandwich
    manual_deduction_value
    is_week_hour_limit
    is_manual_deduction
    is_hourly_employee_sandwich
    publicHolidaySandwich
    salary_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeaveTypeEmployeeByIdGQL extends Apollo.Query<GetLeaveTypeEmployeeByIdQuery, GetLeaveTypeEmployeeByIdQueryVariables> {
    override document = GetLeaveTypeEmployeeByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AdjustLeaveBalanceDocument = gql`
    mutation AdjustLeaveBalance($input: adjustLeaveBalanceInput!) {
  adjustLeaveBalance(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdjustLeaveBalanceGQL extends Apollo.Mutation<AdjustLeaveBalanceMutation, AdjustLeaveBalanceMutationVariables> {
    override document = AdjustLeaveBalanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPendingRequestCountDocument = gql`
    query GetPendingRequestCount($input: pendingRequestInput!) {
  getPendingRequestCount(input: $input) {
    pending_request_minutes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPendingRequestCountGQL extends Apollo.Query<GetPendingRequestCountQuery, GetPendingRequestCountQueryVariables> {
    override document = GetPendingRequestCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetPtoOpeningBalanceDocument = gql`
    mutation SetPtoOpeningBalance($input: PtoOpeningBalanceInput!) {
  setPtoOpeningBalance(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetPtoOpeningBalanceGQL extends Apollo.Mutation<SetPtoOpeningBalanceMutation, SetPtoOpeningBalanceMutationVariables> {
    override document = SetPtoOpeningBalanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLoanRequestDocument = gql`
    mutation CreateLoanRequest($input: InputLoanRequest!) {
  createLoanRequest(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLoanRequestGQL extends Apollo.Mutation<CreateLoanRequestMutation, CreateLoanRequestMutationVariables> {
    override document = CreateLoanRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLoanRequestWithFiltersDocument = gql`
    query GetLoanRequestWithFilters($input: loanFilter) {
  getLoanRequestWithFilters(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      _id
      loan_type
      loan_amount
      no_of_installment
      installment_amount
      loan_recovery_method
      loan_taken_date
      payment_start_date
      payment_received_date
      description
      status
      payment
      balance
      is_deleted
      is_fixed
      employee {
        id
        full_name
        first_name
        last_name
        joining_date
        last_working_date
        salary_type
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLoanRequestWithFiltersGQL extends Apollo.Query<GetLoanRequestWithFiltersQuery, GetLoanRequestWithFiltersQueryVariables> {
    override document = GetLoanRequestWithFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRolesWithFilterDocument = gql`
    query GetRolesWithFilter($input: roleListingFilter!) {
  getRolesWithFilter(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      roleName
      employeeCount
      is_deleted
      created_at
      assigned_users {
        _id
        full_name
      }
      parent {
        _id
        roleName
      }
      BusinessLocation {
        _id
      }
      permissions {
        feature
        module
        permission
        permission_at
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRolesWithFilterGQL extends Apollo.Query<GetRolesWithFilterQuery, GetRolesWithFilterQueryVariables> {
    override document = GetRolesWithFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetallActiveRolesDocument = gql`
    query GetallActiveRoles {
  getallActiveRoles {
    _id
    roleName
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetallActiveRolesGQL extends Apollo.Query<GetallActiveRolesQuery, GetallActiveRolesQueryVariables> {
    override document = GetallActiveRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRoleDetailDocument = gql`
    query GetRoleDetail($roleId: ID!, $getEmployeeByAssignRoleRole2: ID!, $search: String) {
  getRoleDetail(roleID: $roleId) {
    _id
    roleName
    parent {
      _id
    }
    BusinessLocation {
      _id
    }
    permissions {
      feature
      module
      permission
      permission_at
    }
  }
  getEmployeeByAssignRole(role: $getEmployeeByAssignRoleRole2, search: $search) {
    id
    first_name
    last_name
    full_name
    joining_date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoleDetailGQL extends Apollo.Query<GetRoleDetailQuery, GetRoleDetailQueryVariables> {
    override document = GetRoleDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetModulesFeaturesAndPermissionsDocument = gql`
    query GetModulesFeaturesAndPermissions {
  getModulesFeaturesAndPermissions {
    POSPermissionResult {
      module
      features {
        feature
        permissions {
          permission
        }
      }
    }
    adminPermissionResult {
      module
      features {
        feature
        permissions {
          permission
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetModulesFeaturesAndPermissionsGQL extends Apollo.Query<GetModulesFeaturesAndPermissionsQuery, GetModulesFeaturesAndPermissionsQueryVariables> {
    override document = GetModulesFeaturesAndPermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRoleDocument = gql`
    mutation UpdateRole($id: ID!, $input: roleInput) {
  updateRole(id: $id, input: $input) {
    _id
    roleName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRoleGQL extends Apollo.Mutation<UpdateRoleMutation, UpdateRoleMutationVariables> {
    override document = UpdateRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveRoleDocument = gql`
    mutation ArchiveRole($role: [ID!], $archive: Boolean) {
  archiveRole(role: $role, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveRoleGQL extends Apollo.Mutation<ArchiveRoleMutation, ArchiveRoleMutationVariables> {
    override document = ArchiveRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignRoleToEmployeeDocument = gql`
    mutation AssignRoleToEmployee($input: assignRoleInput) {
  assignRoleToEmployee(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignRoleToEmployeeGQL extends Apollo.Mutation<AssignRoleToEmployeeMutation, AssignRoleToEmployeeMutationVariables> {
    override document = AssignRoleToEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CloneRoleDocument = gql`
    mutation CloneRole($input: cloneRoleInput!) {
  cloneRole(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CloneRoleGQL extends Apollo.Mutation<CloneRoleMutation, CloneRoleMutationVariables> {
    override document = CloneRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddOrRemoveEmployeeInRoleDocument = gql`
    mutation AddOrRemoveEmployeeInRole($input: addEmployee!) {
  addOrRemoveEmployeeInRole(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddOrRemoveEmployeeInRoleGQL extends Apollo.Mutation<AddOrRemoveEmployeeInRoleMutation, AddOrRemoveEmployeeInRoleMutationVariables> {
    override document = AddOrRemoveEmployeeInRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopyRolePermissionsDocument = gql`
    mutation CopyRolePermissions($input: copyPermissionInput) {
  copyRolePermissions(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopyRolePermissionsGQL extends Apollo.Mutation<CopyRolePermissionsMutation, CopyRolePermissionsMutationVariables> {
    override document = CopyRolePermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRoleDocument = gql`
    mutation CreateRole($input: roleInput) {
  createRole(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRoleGQL extends Apollo.Mutation<CreateRoleMutation, CreateRoleMutationVariables> {
    override document = CreateRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllActiveEmployeesSchedulerDocument = gql`
    query GetAllActiveEmployeesScheduler($business_id: ID!) {
  getAllActiveEmployees(business_id: $business_id) {
    id
    full_name
    last_working_date
    employee_group {
      is_un_restricted
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllActiveEmployeesSchedulerGQL extends Apollo.Query<GetAllActiveEmployeesSchedulerQuery, GetAllActiveEmployeesSchedulerQueryVariables> {
    override document = GetAllActiveEmployeesSchedulerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScheduleWithSearchDocument = gql`
    query GetScheduleWithSearch($input: scheduleListFilter) {
  getScheduleWithSearch(input: $input) {
    limit
    page
    totalResults
    totalPages
    is_conflict_schedule
    RosterStore {
      backgroundLeave
      backgroundScheduler
      default_schedular_view
      overtimeColor
      paidTomeOffColor
      ptoColor
      sandwichLeaveColor
      unpaidTomeOffColor
      publicHolidayColor
      weekendColor
      shortLeaveUnpaid
      shortLeavePaid
    }
    result {
      _id
      total_schedules_hours
      total_schedules_minutes
      estimated_wage
      total_normal_time
      total_normal_time_wage
      total_over_time
      total_over_time_wage
      User {
        _id
        id
        employee_id
        first_name
        last_name
        full_name
        logo
        email
        phone
        last_working_date
        joining_date
        salary_type
        account_status
        final_settlement_completed
        is_clocked_in
        last_working_date
        last_day_worked
        employee_group {
          _id
          week_number
          is_un_restricted
          is_auto_clocked_in
          weekEndDays {
            id
            name
            selected
          }
        }
        department {
          _id
          department_name
        }
        designation {
          _id
          designation_name
        }
        roles {
          _id
          roleName
        }
        profile_pictures {
          dimension
          path
        }
      }
      schedules {
        _id
        is_payroll_processed
        schedule_date
        start_time
        end_time
        type
        is_pto
        is_sand_wich
        is_paid_leave
        is_clocked_in
        is_weekend
        is_weekend_off
        is_public_holiday
        is_public_holiday_off
        is_attendance_exist
        paid_leave_percentage
        total_hours
        total_minuts
        schedule_minuts
        overtime_minuts
        over_time_percentage
        normal_time_percentage
        short_leave_time_percentage
        short_break_count
        short_break_duration
        short_break_type
        is_taken_short_break
        PublicHoliday {
          _id
          name
        }
        TimeOff {
          countIn
          type_of_absence {
            name
          }
        }
        events {
          type
          hours
          end_time
          leave_type
          minutes
          star_time
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScheduleWithSearchGQL extends Apollo.Query<GetScheduleWithSearchQuery, GetScheduleWithSearchQueryVariables> {
    override document = GetScheduleWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeSchedulesDocument = gql`
    query GetEmployeeSchedules($input: getScheduleByEmployeeIdInput!) {
  getEmployeeSchedules(input: $input) {
    limit
    page
    totalResults
    totalPages
    RosterStore {
      backgroundLeave
      backgroundScheduler
      default_schedular_view
      overtimeColor
      paidTomeOffColor
      ptoColor
      sandwichLeaveColor
      unpaidTomeOffColor
      publicHolidayColor
      weekendColor
      shortLeaveUnpaid
      shortLeavePaid
    }
    result {
      _id
      total_schedules_hours
      total_schedules_minutes
      estimated_wage
      total_normal_time
      total_normal_time_wage
      total_over_time
      total_over_time_wage
      User {
        _id
        id
        employee_id
        first_name
        last_name
        full_name
        logo
        email
        phone
        last_working_date
        joining_date
        salary_type
        account_status
        final_settlement_completed
        is_clocked_in
        employee_group {
          _id
          week_number
          is_un_restricted
          is_auto_clocked_in
          weekEndDays {
            id
            name
            selected
          }
        }
        department {
          _id
          department_name
        }
        designation {
          _id
          designation_name
        }
        profile_pictures {
          dimension
          path
        }
      }
      schedules {
        _id
        is_payroll_processed
        schedule_date
        start_time
        end_time
        type
        is_pto
        is_sand_wich
        is_paid_leave
        is_clocked_in
        is_weekend
        is_weekend_off
        is_public_holiday
        is_public_holiday_off
        is_attendance_exist
        paid_leave_percentage
        total_hours
        total_minuts
        schedule_minuts
        overtime_minuts
        over_time_percentage
        normal_time_percentage
        short_leave_time_percentage
        TimeOff {
          type_of_absence {
            name
          }
        }
        events {
          type
          hours
          end_time
          leave_type
          minutes
          star_time
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeSchedulesGQL extends Apollo.Query<GetEmployeeSchedulesQuery, GetEmployeeSchedulesQueryVariables> {
    override document = GetEmployeeSchedulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateScheduleDocument = gql`
    mutation CreateSchedule($input: schduleInput!) {
  createSchedule(input: $input) {
    is_overlap
    is_conflict
    employee_id
    employee_name
    employee_action
    conflicted_schedule {
      _id
      schedule_date
      start_time
      end_time
      type
      is_pto
      is_sand_wich
      is_attendance_exist
    }
    new_schedule {
      _id
      schedule_date
      start_time
      end_time
      type
      is_pto
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateScheduleGQL extends Apollo.Mutation<CreateScheduleMutation, CreateScheduleMutationVariables> {
    override document = CreateScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteScheduleDocument = gql`
    mutation DeleteSchedule($ids: [ID!]!, $notifyByEmail: Boolean!) {
  deleteSchedule(ids: $ids, notify_by_email: $notifyByEmail)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteScheduleGQL extends Apollo.Mutation<DeleteScheduleMutation, DeleteScheduleMutationVariables> {
    override document = DeleteScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMultiScheduleDocument = gql`
    mutation DeleteMultiSchedule($input: multiScheduleDeleteInput) {
  deleteMultiSchedule(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMultiScheduleGQL extends Apollo.Mutation<DeleteMultiScheduleMutation, DeleteMultiScheduleMutationVariables> {
    override document = DeleteMultiScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateScheduleDocument = gql`
    mutation UpdateSchedule($input: updateSchduleInput!) {
  updateSchedule(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateScheduleGQL extends Apollo.Mutation<UpdateScheduleMutation, UpdateScheduleMutationVariables> {
    override document = UpdateScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopyScheduleByDateDocument = gql`
    mutation CopyScheduleByDate($input: copyScheduleByDateInput!) {
  copyScheduleByDate(input: $input) {
    is_overlap
    is_conflict
    is_leave
    is_salary_detail_not_exist
    employee_id
    employee_name
    employee_action
    conflicted_schedule {
      _id
      schedule_date
      start_time
      end_time
      is_attendance_exist
      type
    }
    new_schedule {
      _id
      schedule_date
      start_time
      end_time
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopyScheduleByDateGQL extends Apollo.Mutation<CopyScheduleByDateMutation, CopyScheduleByDateMutationVariables> {
    override document = CopyScheduleByDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopyScheduleDifferentDateDocument = gql`
    mutation CopyScheduleDifferentDate($input: copyScheduleDifferentDateInput!) {
  copyScheduleDifferentDate(input: $input) {
    is_overlap
    is_conflict
    is_leave
    is_salary_detail_not_exist
    employee_id
    employee_name
    employee_action
    conflicted_schedule {
      _id
      schedule_date
      start_time
      end_time
      is_attendance_exist
      is_pto
      type
    }
    new_schedule {
      _id
      schedule_date
      start_time
      end_time
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopyScheduleDifferentDateGQL extends Apollo.Mutation<CopyScheduleDifferentDateMutation, CopyScheduleDifferentDateMutationVariables> {
    override document = CopyScheduleDifferentDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopyScheduleEmployeeToEmployeesDocument = gql`
    mutation CopyScheduleEmployeeToEmployees($input: copyScheduleEmpInput!) {
  copyScheduleEmployeeToEmployees(input: $input) {
    is_overlap
    is_conflict
    is_leave
    is_salary_detail_not_exist
    employee_id
    employee_name
    employee_action
    conflicted_schedule {
      _id
      schedule_date
      start_time
      end_time
      is_attendance_exist
      is_pto
      type
    }
    new_schedule {
      _id
      schedule_date
      start_time
      end_time
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopyScheduleEmployeeToEmployeesGQL extends Apollo.Mutation<CopyScheduleEmployeeToEmployeesMutation, CopyScheduleEmployeeToEmployeesMutationVariables> {
    override document = CopyScheduleEmployeeToEmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendSchedulesByEmailDocument = gql`
    mutation SendSchedulesByEmail($input: EmailScheduleInput!) {
  sendSchedulesByEmail(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendSchedulesByEmailGQL extends Apollo.Mutation<SendSchedulesByEmailMutation, SendSchedulesByEmailMutationVariables> {
    override document = SendSchedulesByEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResolveConflictsDocument = gql`
    mutation ResolveConflicts($input: [resolveConflictsInput!]!) {
  resolveConflicts(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResolveConflictsGQL extends Apollo.Mutation<ResolveConflictsMutation, ResolveConflictsMutationVariables> {
    override document = ResolveConflictsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConflictScheduleDocument = gql`
    query GetConflictSchedule {
  getConflictSchedule {
    is_overlap
    is_conflict
    employee_id {
      _id
      full_name
    }
    employee_name
    employee_action
    created_at
    created_by {
      _id
      full_name
    }
    conflicted_schedule {
      _id
      schedule_date
      start_time
      end_time
      type
      is_pto
      is_sand_wich
      is_attendance_exist
    }
    new_schedule {
      _id
      schedule_date
      start_time
      end_time
      type
      is_pto
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConflictScheduleGQL extends Apollo.Query<GetConflictScheduleQuery, GetConflictScheduleQueryVariables> {
    override document = GetConflictScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelScheduleConflictsDocument = gql`
    mutation CancelScheduleConflicts {
  cancelScheduleConflicts
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelScheduleConflictsGQL extends Apollo.Mutation<CancelScheduleConflictsMutation, CancelScheduleConflictsMutationVariables> {
    override document = CancelScheduleConflictsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScheduleByIdDocument = gql`
    query GetScheduleById($id: ID!) {
  getScheduleById(_id: $id) {
    _id
    schedule_date
    start_time
    end_time
    type
    is_pto
    is_sand_wich
    is_paid_leave
    is_clocked_in
    is_attendance_exist
    total_hours
    total_minuts
    overtime_minuts
    over_time_percentage
    normal_time_percentage
    short_leave_time_percentage
    User {
      id
      full_name
      is_clocked_in
      department {
        _id
        department_name
      }
      designation {
        _id
        designation_name
      }
    }
    TimeOff {
      _id
      is_pto
      total_leaves
      type_of_absence {
        _id
        name
        type
        leave_duration
      }
    }
    events {
      type
      star_time
      end_time
      leave_type
      hours
      minutes
      TimeOff {
        _id
        type_of_absence {
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScheduleByIdGQL extends Apollo.Query<GetScheduleByIdQuery, GetScheduleByIdQueryVariables> {
    override document = GetScheduleByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScheduleTotalCountsDocument = gql`
    query GetScheduleTotalCounts($input: scheduleCountFilter) {
  getScheduleTotalCounts(input: $input) {
    estimateWage
    onleave
    overTimeCost
    overTimeHours
    ptoCost
    ptoHours
    scheduleHours
    scheduleShift
    shortleaves
    totalUserCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScheduleTotalCountsGQL extends Apollo.Query<GetScheduleTotalCountsQuery, GetScheduleTotalCountsQueryVariables> {
    override document = GetScheduleTotalCountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllDepartmentsSchedulerDocument = gql`
    query GetAllDepartmentsScheduler($businessId: ID!) {
  getAllDepartments(business_id: $businessId) {
    _id
    department_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDepartmentsSchedulerGQL extends Apollo.Query<GetAllDepartmentsSchedulerQuery, GetAllDepartmentsSchedulerQueryVariables> {
    override document = GetAllDepartmentsSchedulerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRolesByDepartmentIdDocument = gql`
    query GetRolesByDepartmentId($departmentId: ID) {
  getRolesByDepartmentId(department_id: $departmentId) {
    _id
    roleName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRolesByDepartmentIdGQL extends Apollo.Query<GetRolesByDepartmentIdQuery, GetRolesByDepartmentIdQueryVariables> {
    override document = GetRolesByDepartmentIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateSchedulerConfigDocument = gql`
    mutation CreateUpdateSchedulerConfig($input: schedulerConfigInput!) {
  createUpdateSchedulerConfig(input: $input) {
    business {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateSchedulerConfigGQL extends Apollo.Mutation<CreateUpdateSchedulerConfigMutation, CreateUpdateSchedulerConfigMutationVariables> {
    override document = CreateUpdateSchedulerConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSchedulerConfigDocument = gql`
    query GetSchedulerConfig($business: ID!) {
  getSchedulerConfig(business: $business) {
    business {
      _id
      business_system_name
      business_type
      number_of_stores
    }
    backgroundScheduler
    number_of_record_employees
    paidTomeOffColor
    unpaidTomeOffColor
    overtimeColor
    ptoColor
    sandwichLeaveColor
    publicHolidayColor
    shortLeavePaid
    shortLeaveUnpaid
    weekendColor
    is_include_unpaid_break
    short_breaks {
      short_break_name
      short_break_duration
      short_break_type
    }
    chunk_wise_short_break {
      short_break_name
      short_break_duration
      short_break_type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSchedulerConfigGQL extends Apollo.Query<GetSchedulerConfigQuery, GetSchedulerConfigQueryVariables> {
    override document = GetSchedulerConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeesByDepartmentsDocument = gql`
    query GetEmployeesByDepartments($input: employeeFilterInput) {
  getEmployeesByDepartments(input: $input) {
    id
    email
    employee_id
    salary_type
    first_name
    joining_date
    hire_date
    last_working_date
    final_settlement_completed
    last_day_worked
    account_status
    employee_group {
      before_early_clockin
      paunch_out_mnts
      is_un_restricted
      is_auto_clocked_in
    }
    middle_name
    last_name
    profile_pictures {
      dimension
      path
    }
    full_name
    employee_group {
      _id
      group_name
    }
    phone
    isOwner
    phone_country_code
    landline
    logo
    avatar_location
    status
    business_id {
      business_system_name
    }
    department {
      _id
      department_name
    }
    designation {
      _id
      designation_name
    }
    users_password_manager {
      publicKey
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeesByDepartmentsGQL extends Apollo.Query<GetEmployeesByDepartmentsQuery, GetEmployeesByDepartmentsQueryVariables> {
    override document = GetEmployeesByDepartmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetShifBreaksDocument = gql`
    query GetShifBreaks($businessId: ID!) {
  getShifBreaks(business_id: $businessId) {
    _id
    data_value_name
    data_value_type {
      _id
      data_value_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetShifBreaksGQL extends Apollo.Query<GetShifBreaksQuery, GetShifBreaksQueryVariables> {
    override document = GetShifBreaksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSchedulesBreaksByDateRangeDocument = gql`
    mutation UpdateSchedulesBreaksByDateRange($input: inputBreakUpdate) {
  updateSchedulesBreaksByDateRange(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSchedulesBreaksByDateRangeGQL extends Apollo.Mutation<UpdateSchedulesBreaksByDateRangeMutation, UpdateSchedulesBreaksByDateRangeMutationVariables> {
    override document = UpdateSchedulesBreaksByDateRangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportScheduleCsvDocument = gql`
    mutation ImportScheduleCsv($file: Upload!, $scheduleFrom: String!, $scheduleTo: String!, $minimum_break_percentage: Int) {
  importScheduleCsv(
    file: $file
    schedule_From: $scheduleFrom
    schedule_To: $scheduleTo
    minimum_break_percentage: $minimum_break_percentage
  ) {
    complectSechduals {
      conflicted_schedule {
        _id
        start_date
        schedule_date
        start_time
        end_time
        type
        is_pto
        is_sand_wich
        is_attendance_exist
      }
      new_schedule {
        _id
        end_time
        type
        is_pto
        schedule_date
        start_time
      }
      is_overlap
      is_conflict
      employee_id
      employee_name
      employee_action
    }
    InvalidRecord {
      employee_id
      employee_name
      DAY
      reason
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportScheduleCsvGQL extends Apollo.Mutation<ImportScheduleCsvMutation, ImportScheduleCsvMutationVariables> {
    override document = ImportScheduleCsvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScheduleCsvProgressDocument = gql`
    subscription scheduleCsvProgress($userId: ID!) {
  scheduleCsvProgress(userId: $userId) {
    totalEmployees
    doneEmployees
    currentEmployee
    message
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScheduleCsvProgressGQL extends Apollo.Subscription<ScheduleCsvProgressSubscription, ScheduleCsvProgressSubscriptionVariables> {
    override document = ScheduleCsvProgressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetNumberOfRecordDocument = gql`
    mutation SetNumberOfRecord($input: setNumberOfRecordInput!) {
  setNumberOfRecord(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetNumberOfRecordGQL extends Apollo.Mutation<SetNumberOfRecordMutation, SetNumberOfRecordMutationVariables> {
    override document = SetNumberOfRecordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScheduleAlertDataDocument = gql`
    query GetScheduleAlertData($input: RoasterMinutesInput) {
  getScheduleAlertData(input: $input) {
    date
    message
    schedule_not_found
    isLeaveApplied
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScheduleAlertDataGQL extends Apollo.Query<GetScheduleAlertDataQuery, GetScheduleAlertDataQueryVariables> {
    override document = GetScheduleAlertDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMultiSchedulesDocument = gql`
    mutation UpdateMultiSchedules($input: updateMultiSchduleInput!) {
  updateMultiSchedules(input: $input) {
    data
    errorMessage {
      date
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMultiSchedulesGQL extends Apollo.Mutation<UpdateMultiSchedulesMutation, UpdateMultiSchedulesMutationVariables> {
    override document = UpdateMultiSchedulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTimeOffDocument = gql`
    mutation CreateTimeOff($input: createTimeOffInput) {
  createTimeOff(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTimeOffGQL extends Apollo.Mutation<CreateTimeOffMutation, CreateTimeOffMutationVariables> {
    override document = CreateTimeOffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicHolidayDocument = gql`
    query PublicHoliday($input: PublicHolidayInput!) {
  publicHoliday(input: $input) {
    sandwichDate {
      date_of_sandwich {
        date
        day
      }
      difference_in_days
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicHolidayGQL extends Apollo.Query<PublicHolidayQuery, PublicHolidayQueryVariables> {
    override document = PublicHolidayDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VerifyEmployeeScheduleDocument = gql`
    query VerifyEmployeeSchedule($input: employeeScheduleInput!) {
  verifyEmployeeSchedule(input: $input) {
    id
    full_name
    employee_group {
      _id
      is_un_restricted
    }
    salary_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VerifyEmployeeScheduleGQL extends Apollo.Query<VerifyEmployeeScheduleQuery, VerifyEmployeeScheduleQueryVariables> {
    override document = VerifyEmployeeScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetApprovalWorkFlowWithSearchDocument = gql`
    query GetApprovalWorkFlowWithSearch($input: workFlowListFilter) {
  getApprovalWorkFlowWithSearch(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      work_flow_type
      total_level
      is_deleted
      created_at
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetApprovalWorkFlowWithSearchGQL extends Apollo.Query<GetApprovalWorkFlowWithSearchQuery, GetApprovalWorkFlowWithSearchQueryVariables> {
    override document = GetApprovalWorkFlowWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetApprovalWorkFlowByIdDocument = gql`
    query GetApprovalWorkFlowById($id: ID!) {
  getApprovalWorkFlowById(id: $id) {
    _id
    work_flow_type
    total_level
    overdue_days
    work_flow_levels {
      level
      approval_to
      approval_level
      reminder
      move_to_next
      role {
        _id
        roleName
      }
      employee {
        id
        full_name
      }
    }
    escalation_user {
      escalationRole {
        _id
        roleName
      }
      escalationEmployee {
        id
        full_name
      }
      escalationReminder
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetApprovalWorkFlowByIdGQL extends Apollo.Query<GetApprovalWorkFlowByIdQuery, GetApprovalWorkFlowByIdQueryVariables> {
    override document = GetApprovalWorkFlowByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateApprovalWorkFlowDocument = gql`
    mutation CreateApprovalWorkFlow($input: WorkFlowInput!) {
  createApprovalWorkFlow(input: $input) {
    _id
    work_flow_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateApprovalWorkFlowGQL extends Apollo.Mutation<CreateApprovalWorkFlowMutation, CreateApprovalWorkFlowMutationVariables> {
    override document = CreateApprovalWorkFlowDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateApprovalWorkFlowDocument = gql`
    mutation UpdateApprovalWorkFlow($input: UpdateWorkFlowInput!) {
  updateApprovalWorkFlow(input: $input) {
    _id
    work_flow_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateApprovalWorkFlowGQL extends Apollo.Mutation<UpdateApprovalWorkFlowMutation, UpdateApprovalWorkFlowMutationVariables> {
    override document = UpdateApprovalWorkFlowDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveApprovalWorkFlowDocument = gql`
    mutation ArchiveApprovalWorkFlow($id: ID!, $archive: Boolean!) {
  archiveApprovalWorkFlow(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveApprovalWorkFlowGQL extends Apollo.Mutation<ArchiveApprovalWorkFlowMutation, ArchiveApprovalWorkFlowMutationVariables> {
    override document = ArchiveApprovalWorkFlowDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAttendanceListDocument = gql`
    query GetAttendanceList($input: attendanceListFilter) {
  getAttendanceList(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    data {
      _id
      is_deleted
      Business {
        _id
      }
      pay_type {
        _id
        schedule_name
      }
      employeeIds
      group_name
      description
      department
      designation
      employee_type
      employesId {
        id
        final_settlement_completed
        is_deleted
        employee_id
        full_name
        roles {
          _id
          roleName
          is_deleted
        }
        department {
          _id
          department_name
          is_deleted
        }
      }
      detail {
        actions {
          name
          is_visible
        }
        columns {
          _id
          field
          header
          is_amount
        }
        result {
          final_settlement_completed
          is_deleted
          _id
          full_name
          employee_id
          roles {
            _id
            roleName
          }
          department {
            _id
            department_name
          }
          employee_group {
            _id
            group_name
          }
        }
      }
      attendance_rule
      is_un_restricted
      deduct_days
      attendance_after_days
      block_employee_account_after
      missing_attendance_message
      send_absent_email_to_line_manager
      penalize_deduct_leave
      early_clockin
      before_early_clockin
      default_message_early
      modify_message_early
      late_clockin
      grace_period
      late_clockin_deduction
      base
      plenty_base
      deduct_salary_for_every
      deduct_salary_for_every_per_minuts
      apply_penalty_employee_daily_salary
      maximum_no_days
      late_coming_incidents
      for_every_incidents_late_coming
      deduct_days_of_leave_incidents
      How_are_leaves_deducted
      maximum_late_time
      maximum_late_time_deduction_after_minutes
      block_employee_default_message
      maximum_late_modify_message
      deduct_leave
      deduct_annually_minuts
      employesCount
      earlyOut_deduct_salary_incidents
      earlyOut_maximum_early_time
      messge_earlyOut
      earlyOut_deduct_based_on
      hours_penalize_deduct_leave
      wagebased
      wagebased_on
      percentage_base_no_of_days
      percentage_base_percentage_of_hourse
      overtime
      overtime_by_employeeType
      breaks
      minuts_period_break_in_out
      deduction_based
      break_deduct_salary_for_every_minuts
      break_deduct_salary_for_every_per_minuts
      block_user_acount_number_breaks
      break_modify_message
      percentage_Base
      start_date
      status
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAttendanceListGQL extends Apollo.Query<GetAttendanceListQuery, GetAttendanceListQueryVariables> {
    override document = GetAttendanceListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAttandencePolicyDocument = gql`
    mutation ArchiveAttandencePolicy($id: ID!, $archive: Boolean!) {
  archiveAttandencePolicy(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAttandencePolicyGQL extends Apollo.Mutation<ArchiveAttandencePolicyMutation, ArchiveAttandencePolicyMutationVariables> {
    override document = ArchiveAttandencePolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAttendancePolicyDocument = gql`
    mutation CreateAttendancePolicy($input: hrPolicyInput) {
  attendancePolicy(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAttendancePolicyGQL extends Apollo.Mutation<CreateAttendancePolicyMutation, CreateAttendancePolicyMutationVariables> {
    override document = CreateAttendancePolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAttendancePolicyDocument = gql`
    mutation UpdateAttendancePolicy($input: attandencePolicyUpdate) {
  updateAttendancePolicy(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAttendancePolicyGQL extends Apollo.Mutation<UpdateAttendancePolicyMutation, UpdateAttendancePolicyMutationVariables> {
    override document = UpdateAttendancePolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeEmployeeAttendancePolicyDocument = gql`
    mutation ChangeEmployeeAttendancePolicy($input: changePolicyInput_!) {
  changeEmployeeAttendancePolicy(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeEmployeeAttendancePolicyGQL extends Apollo.Mutation<ChangeEmployeeAttendancePolicyMutation, ChangeEmployeeAttendancePolicyMutationVariables> {
    override document = ChangeEmployeeAttendancePolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckEmployeeIsClockedInDocument = gql`
    query CheckEmployeeIsClockedIn($employeeId: ID!) {
  checkEmployeeIsClockedIn(employee_id: $employeeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckEmployeeIsClockedInGQL extends Apollo.Query<CheckEmployeeIsClockedInQuery, CheckEmployeeIsClockedInQueryVariables> {
    override document = CheckEmployeeIsClockedInDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAttendancePolicyGroupsDocument = gql`
    query GetAttendancePolicyGroups($businessId: ID!, $policyStatus: policyStatusEnum) {
  getAttendancePolicyGroups(
    business_id: $businessId
    policy_status: $policyStatus
  ) {
    _id
    group_name
    description
    is_un_restricted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAttendancePolicyGroupsGQL extends Apollo.Query<GetAttendancePolicyGroupsQuery, GetAttendancePolicyGroupsQueryVariables> {
    override document = GetAttendancePolicyGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetattendancePolicyByIdDocument = gql`
    query GetattendancePolicyById($_id: ID!) {
  getattendancePolicyByID(_id: $_id) {
    _id
    group_name
    description
    is_un_restricted
    is_auto_clocked_in
    is_clocked_in_from_app
    attendance_rule
    block_employee_account_after
    block_employee_account_after_days
    deafult_missing_attendance_message
    missing_attendance_message
    send_absent_email_to_line_manager
    penalize_deduct_leave
    early_clockin
    before_early_clockin
    default_message_early
    modify_message_early
    late_clockin
    grace_period
    maximum_late_time
    maximum_late_time_deduction_after_minutes
    maximum_late_time_message
    maximum_late_modify_message
    maximum_emp_absent
    maximum_emp_time
    maximum_emp_message
    maximum_absent_modify_message
    is_email_to_employee
    earlyOut_deduct_salary_incidents
    clock_out_grace_period
    earlyOut_maximum_early_time
    lateOut_maximum_late_time
    paunch_out_mnts
    is_auto_miss_punch_writeup
    is_email_to_line_manager
    deafult_message_earlyOut
    messge_earlyOut
    lateOut_message
    lateOut_message_late_time
    is_exclude_grace_time_in_working_hours
    is_paid_for_extra_time
    over_time_hours
    over_time_rate
    is_weekend_mode
    is_paid_weekend
    working_days
    is_weekend_premium_before_limit
    is_weekend_premium_after_limit
    breaks
    minuts_period_break_in_out
    block_user_acount_number_breaks
    send_break_email_to_line_manager
    send_break_email_to_employee
    block_user
    break_modify_message
    weekEndDays {
      id
      name
      selected
    }
    pay_type {
      _id
      schedule_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetattendancePolicyByIdGQL extends Apollo.Query<GetattendancePolicyByIdQuery, GetattendancePolicyByIdQueryVariables> {
    override document = GetattendancePolicyByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDepartmentDocument = gql`
    mutation CreateDepartment($input: departmentInput!) {
  createDepartment(input: $input) {
    _id
    department_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDepartmentGQL extends Apollo.Mutation<CreateDepartmentMutation, CreateDepartmentMutationVariables> {
    override document = CreateDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDepartmentDocument = gql`
    mutation UpdateDepartment($_id: ID!, $input: departmentInput!) {
  updateDepartment(_id: $_id, input: $input) {
    _id
    department_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDepartmentGQL extends Apollo.Mutation<UpdateDepartmentMutation, UpdateDepartmentMutationVariables> {
    override document = UpdateDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDepartmentDocument = gql`
    mutation DeleteDepartment($id: ID!, $archive: Boolean!) {
  deleteDepartment(_id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDepartmentGQL extends Apollo.Mutation<DeleteDepartmentMutation, DeleteDepartmentMutationVariables> {
    override document = DeleteDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDepartmentByIdDocument = gql`
    query GetDepartmentById($_id: ID!) {
  getDepartmentById(_id: $_id) {
    _id
    department_name
    Business {
      _id
    }
    businessLocation {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDepartmentByIdGQL extends Apollo.Query<GetDepartmentByIdQuery, GetDepartmentByIdQueryVariables> {
    override document = GetDepartmentByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDepartmentsListDocument = gql`
    query GetDepartmentsList($input: departmentListFilter!) {
  getDepartmentsList(input: $input) {
    results {
      is_deleted
      _id
      department_name
      Business {
        _id
      }
      businessLocation {
        _id
      }
      employee_count
    }
    config {
      ...ConfigWithoutSummaryFields
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDepartmentsListGQL extends Apollo.Query<GetDepartmentsListQuery, GetDepartmentsListQueryVariables> {
    override document = GetDepartmentsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDesignationDocument = gql`
    mutation CreateDesignation($input: designationsInput!) {
  createDesignation(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDesignationGQL extends Apollo.Mutation<CreateDesignationMutation, CreateDesignationMutationVariables> {
    override document = CreateDesignationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDesignationDocument = gql`
    mutation UpdateDesignation($_id: ID!, $input: designationsInput!) {
  updateDesignation(_id: $_id, input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDesignationGQL extends Apollo.Mutation<UpdateDesignationMutation, UpdateDesignationMutationVariables> {
    override document = UpdateDesignationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDesignationDocument = gql`
    mutation DeleteDesignation($id: ID!, $archive: Boolean!) {
  deleteDesignation(_id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDesignationGQL extends Apollo.Mutation<DeleteDesignationMutation, DeleteDesignationMutationVariables> {
    override document = DeleteDesignationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDesignationByIdDocument = gql`
    query GetDesignationById($_id: ID!) {
  getDesignationById(_id: $_id) {
    _id
    designation_name
    business {
      _id
    }
    businessLocation {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDesignationByIdGQL extends Apollo.Query<GetDesignationByIdQuery, GetDesignationByIdQueryVariables> {
    override document = GetDesignationByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDesignationListDocument = gql`
    query GetDesignationList($input: designationtListFilter!) {
  getDesignationList(input: $input) {
    results {
      is_deleted
      _id
      designation_name
      business {
        _id
      }
      businessLocation {
        _id
      }
      employee_count
    }
    config {
      ...ConfigWithoutSummaryFields
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDesignationListGQL extends Apollo.Query<GetDesignationListQuery, GetDesignationListQueryVariables> {
    override document = GetDesignationListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeListForSeparationDocument = gql`
    query GetEmployeeListForSeparation($search: String) {
  getEmployeeListForSeparation(search: $search) {
    _id
    full_name
    first_name
    last_name
    employee_id
    is_deleted
    isOwner
    joining_date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeListForSeparationGQL extends Apollo.Query<GetEmployeeListForSeparationQuery, GetEmployeeListForSeparationQueryVariables> {
    override document = GetEmployeeListForSeparationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmployeeSeparationListDocument = gql`
    query EmployeeSeparationList($input: employeeSeparationFilter) {
  employeeSeparationList(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      resignation_date
      last_working_date
      settlement_completed
      is_deleted
      reason
      separation_type
      reason_description
      attrition
      payroll_hold
      is_notifiy
      created_at
      employee {
        _id
        full_name
        first_name
        last_name
        employee_id
      }
      business {
        _id
        business_legal_name
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EmployeeSeparationListGQL extends Apollo.Query<EmployeeSeparationListQuery, EmployeeSeparationListQueryVariables> {
    override document = EmployeeSeparationListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeSeparationByIdDocument = gql`
    query GetEmployeeSeparationById($_id: ID!) {
  getEmployeeSeparationById(_id: $_id) {
    _id
    resignation_date
    last_working_date
    reason
    reason_description
    separation_type
    attrition
    payroll_hold
    is_notifiy
    settlement_completed
    employee {
      _id
      full_name
      first_name
      last_name
      employee_id
    }
    to_employees {
      _id
      full_name
    }
    business {
      _id
      business_legal_name
    }
    documents {
      document_description
      document_file_path
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeSeparationByIdGQL extends Apollo.Query<GetEmployeeSeparationByIdQuery, GetEmployeeSeparationByIdQueryVariables> {
    override document = GetEmployeeSeparationByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeePendingRequestsDocument = gql`
    query GetEmployeePendingRequests($employeeID: ID!, $action_performed: Boolean) {
  getEmployeePendingRequests(
    employeeID: $employeeID
    action_performed: $action_performed
  ) {
    clockedHistory {
      _id
      attendanceDate
      attendanceStatus
      clock_in_time
      clock_out_time
      User {
        full_name
      }
    }
    pending_loan_requests {
      logs {
        changed_from
        changed_to
        date
        created_by {
          full_name
        }
      }
      _id
      loan_type
      loan_amount
      installment_amount
      balance
      status
    }
    pending_expenses_requests {
      logs {
        changed_from
        changed_to
        date
        created_by {
          full_name
        }
      }
      _id
      expense_type
      expense_total_amount
      status
    }
    pending_attendance_requests {
      logs {
        changed_from
        changed_to
        date
        created_by {
          full_name
        }
      }
      _id
      reason_type
      description
      status
      attendance_date
      time_in
      time_out
    }
    pending_leaves_requests {
      logs {
        changed_from
        changed_to
        date
        created_by {
          full_name
        }
      }
      _id
      reason_for_leave
      status
      total_leaves
      total_unpaid_leaves
      remaining_unpaid_days
      remaining_days
      type_of_absence {
        _id
        name
      }
      date_type_leave {
        leave_date
        leave_type
      }
    }
    pending_writeup_requests {
      logs {
        changed_from
        changed_to
        date
        created_by {
          full_name
        }
      }
      _id
      write_up_type
      status
      writeup_date
      accept_assign_schedule
      informed_hr
    }
    tasklisting {
      logs {
        changed_from
        changed_to
        date
        created_by {
          full_name
        }
      }
      assignee {
        _id
      }
      _id
      task_name
      status
      no_sub_task
      summary
    }
    documentListing {
      _id
      name
      activity_type
      message
      status
    }
    assetListing {
      logs {
        changedFrom
        changedTo
        date
        created_by {
          full_name
        }
      }
      assigned {
        _id
        full_name
      }
      _id
      id
      name
      quantity
      type
    }
    workFlowListing {
      _id
      work_flow_type
      total_level
      logs {
        updated_at
        updated_by {
          id
          full_name
        }
        previous_workflow_levels {
          level
          approval_to
          employee {
            _id
            full_name
          }
          role {
            _id
            roleName
          }
        }
        current_workflow_levels {
          level
          approval_to
          employee {
            _id
            full_name
          }
          role {
            _id
            roleName
          }
        }
      }
      work_flow_levels {
        level
        approval_to
        approval_level
        employee {
          _id
          full_name
        }
        role {
          _id
          roleName
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeePendingRequestsGQL extends Apollo.Query<GetEmployeePendingRequestsQuery, GetEmployeePendingRequestsQueryVariables> {
    override document = GetEmployeePendingRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeLastClockedInOrSeparationDocument = gql`
    query GetEmployeeLastClockedInOrSeparation($user_id: ID!, $clockedHistory: Boolean) {
  getEmployeeLastClockedInOrSeparation(
    user_id: $user_id
    clockedHistory: $clockedHistory
  ) {
    firstClockedInDate
    lastClockedInDate
    last_working_date
    resignation_date
    seprationDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeLastClockedInOrSeparationGQL extends Apollo.Query<GetEmployeeLastClockedInOrSeparationQuery, GetEmployeeLastClockedInOrSeparationQueryVariables> {
    override document = GetEmployeeLastClockedInOrSeparationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLeaveAfterLastWorkingDayDocument = gql`
    query GetLeaveAfterLastWorkingDay($input: getLeaveAfterLastWorkingDayInput) {
  getLeaveAfterLastWorkingDay(input: $input) {
    _id
    start_date
    end_date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeaveAfterLastWorkingDayGQL extends Apollo.Query<GetLeaveAfterLastWorkingDayQuery, GetLeaveAfterLastWorkingDayQueryVariables> {
    override document = GetLeaveAfterLastWorkingDayDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEmployeeSeparationDocument = gql`
    mutation CreateEmployeeSeparation($input: employeeSeparationInput) {
  createEmployeeSeparation(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEmployeeSeparationGQL extends Apollo.Mutation<CreateEmployeeSeparationMutation, CreateEmployeeSeparationMutationVariables> {
    override document = CreateEmployeeSeparationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEmployeeSeparationDocument = gql`
    mutation UpdateEmployeeSeparation($id: ID!, $input: employeeSeparationInput!) {
  updateEmployeeSeparation(id: $id, input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEmployeeSeparationGQL extends Apollo.Mutation<UpdateEmployeeSeparationMutation, UpdateEmployeeSeparationMutationVariables> {
    override document = UpdateEmployeeSeparationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEmployeeSeparationDocument = gql`
    mutation DeleteEmployeeSeparation($_id: ID!, $archive: Boolean!) {
  deleteEmployeeSeparation(_id: $_id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEmployeeSeparationGQL extends Apollo.Mutation<DeleteEmployeeSeparationMutation, DeleteEmployeeSeparationMutationVariables> {
    override document = DeleteEmployeeSeparationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeesForFinalSettlementDocument = gql`
    query GetEmployeesForFinalSettlement {
  getEmployeesForFinalSettlement {
    _id
    last_working_date
    employee {
      full_name
      id
      first_name
      last_name
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeesForFinalSettlementGQL extends Apollo.Query<GetEmployeesForFinalSettlementQuery, GetEmployeesForFinalSettlementQueryVariables> {
    override document = GetEmployeesForFinalSettlementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLoanDetailDocument = gql`
    query GetLoanDetail($employee: ID!) {
  getLoanDetail(employee: $employee) {
    total_loan
    balance
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLoanDetailGQL extends Apollo.Query<GetLoanDetailQuery, GetLoanDetailQueryVariables> {
    override document = GetLoanDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExpenseDetailDocument = gql`
    query GetExpenseDetail($employee: ID!) {
  getExpenseDetail(employee: $employee)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExpenseDetailGQL extends Apollo.Query<GetExpenseDetailQuery, GetExpenseDetailQueryVariables> {
    override document = GetExpenseDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFinalSettlementWithFiltersDocument = gql`
    query GetFinalSettlementWithFilters($input: finalSettlementFilter!) {
  getFinalSettlementWithFilters(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      is_deleted
      separation_type
      description
      settlement_completed
      last_working_date
      employee {
        id
        full_name
      }
      expense_amount
      created_by {
        id
        full_name
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFinalSettlementWithFiltersGQL extends Apollo.Query<GetFinalSettlementWithFiltersQuery, GetFinalSettlementWithFiltersQueryVariables> {
    override document = GetFinalSettlementWithFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFinalSettlementByUserIdDocument = gql`
    query GetFinalSettlementByUserId($userId: ID!) {
  getFinalSettlementByUserId(userId: $userId) {
    _id
    employee {
      id
      first_name
      last_name
      full_name
    }
    last_working_date
    description
    loan_amount
    leave_amount
    expense_amount
    created_at
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFinalSettlementByUserIdGQL extends Apollo.Query<GetFinalSettlementByUserIdQuery, GetFinalSettlementByUserIdQueryVariables> {
    override document = GetFinalSettlementByUserIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFinalSettlementByIdDocument = gql`
    query GetFinalSettlementById($id: ID!) {
  getFinalSettlementById(_id: $id) {
    _id
    employee {
      id
      first_name
      last_name
      full_name
    }
    last_working_date
    description
    loan_amount
    leave_amount
    expense_amount
    created_at
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFinalSettlementByIdGQL extends Apollo.Query<GetFinalSettlementByIdQuery, GetFinalSettlementByIdQueryVariables> {
    override document = GetFinalSettlementByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFinalSettlementDocument = gql`
    mutation CreateFinalSettlement($input: InputFinalSettlement!) {
  createFinalSettlement(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFinalSettlementGQL extends Apollo.Mutation<CreateFinalSettlementMutation, CreateFinalSettlementMutationVariables> {
    override document = CreateFinalSettlementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFinalSettlementDocument = gql`
    mutation UpdateFinalSettlement($id: ID!, $input: InputFinalSettlement!) {
  updateFinalSettlement(_id: $id, input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFinalSettlementGQL extends Apollo.Mutation<UpdateFinalSettlementMutation, UpdateFinalSettlementMutationVariables> {
    override document = UpdateFinalSettlementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveFinalSettlementDocument = gql`
    mutation ArchiveFinalSettlement($id: ID!, $archive: Boolean!) {
  archiveFinalSettlement(_id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveFinalSettlementGQL extends Apollo.Mutation<ArchiveFinalSettlementMutation, ArchiveFinalSettlementMutationVariables> {
    override document = ArchiveFinalSettlementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeGarnishmentListDocument = gql`
    query GetEmployeeGarnishmentList($input: InputemployeeGarnishmentList) {
  getEmployeeGarnishmentList(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      garnishment_type
      fix_amount
      garnishment_creator
      start_date
      is_deleted
      garnishment_account
      end_date
      document
      garnishment
      assignTo {
        _id
        full_name
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeGarnishmentListGQL extends Apollo.Query<GetEmployeeGarnishmentListQuery, GetEmployeeGarnishmentListQueryVariables> {
    override document = GetEmployeeGarnishmentListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeGarnishmentByIdDocument = gql`
    query GetEmployeeGarnishmentById($_id: ID!) {
  getEmployeeGarnishmentById(_id: $_id) {
    _id
    garnishment_type
    garnishment_creator
    fix_amount
    garnishment_account
    garnishment
    start_date
    end_date
    document
    assignTo {
      id
      full_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeGarnishmentByIdGQL extends Apollo.Query<GetEmployeeGarnishmentByIdQuery, GetEmployeeGarnishmentByIdQueryVariables> {
    override document = GetEmployeeGarnishmentByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEmployeeGarnishmentDocument = gql`
    mutation CreateEmployeeGarnishment($input: employeeGarnishmentInput!) {
  createEmployeeGarnishment(input: $input) {
    _id
    garnishment_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEmployeeGarnishmentGQL extends Apollo.Mutation<CreateEmployeeGarnishmentMutation, CreateEmployeeGarnishmentMutationVariables> {
    override document = CreateEmployeeGarnishmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEmployeeGarnishmentDocument = gql`
    mutation UpdateEmployeeGarnishment($input: employeeGarnishmentUpdate) {
  updateEmployeeGarnishment(input: $input) {
    _id
    garnishment_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEmployeeGarnishmentGQL extends Apollo.Mutation<UpdateEmployeeGarnishmentMutation, UpdateEmployeeGarnishmentMutationVariables> {
    override document = UpdateEmployeeGarnishmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveEmployeeGarnishmentDocument = gql`
    mutation ArchiveEmployeeGarnishment($_id: ID!, $archive: Boolean!) {
  archiveEmployeeGarnishment(_id: $_id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveEmployeeGarnishmentGQL extends Apollo.Mutation<ArchiveEmployeeGarnishmentMutation, ArchiveEmployeeGarnishmentMutationVariables> {
    override document = ArchiveEmployeeGarnishmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGratuityPolicyDocument = gql`
    query GetGratuityPolicy($business: ID!) {
  getGratuityPolicy(business: $business) {
    _id
    month_days
    total_working_days
    type
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGratuityPolicyGQL extends Apollo.Query<GetGratuityPolicyQuery, GetGratuityPolicyQueryVariables> {
    override document = GetGratuityPolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateGratuityDocument = gql`
    mutation CreateUpdateGratuity($input: GratuityInput) {
  createUpdateGratuity(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateGratuityGQL extends Apollo.Mutation<CreateUpdateGratuityMutation, CreateUpdateGratuityMutationVariables> {
    override document = CreateUpdateGratuityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateLeavePolicyDocument = gql`
    mutation CreateUpdateLeavePolicy($input: leavePolicyInput!) {
  createUpdateLeavePolicy(input: $input) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateLeavePolicyGQL extends Apollo.Mutation<CreateUpdateLeavePolicyMutation, CreateUpdateLeavePolicyMutationVariables> {
    override document = CreateUpdateLeavePolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveLeavePolicyByIdDocument = gql`
    mutation ArchiveLeavePolicyById($_id: ID!, $archive: Boolean!) {
  archiveLeavePolicyById(_id: $_id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveLeavePolicyByIdGQL extends Apollo.Mutation<ArchiveLeavePolicyByIdMutation, ArchiveLeavePolicyByIdMutationVariables> {
    override document = ArchiveLeavePolicyByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEmployeeFromLeavePolicyDocument = gql`
    mutation RemoveEmployeeFromLeavePolicy($id: ID!, $employeeId: ID!) {
  removeEmployeeFromLeavePolicy(_id: $id, employee_id: $employeeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEmployeeFromLeavePolicyGQL extends Apollo.Mutation<RemoveEmployeeFromLeavePolicyMutation, RemoveEmployeeFromLeavePolicyMutationVariables> {
    override document = RemoveEmployeeFromLeavePolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeEmployeeLeavePolicyDocument = gql`
    mutation ChangeEmployeeLeavePolicy($input: changePolicyInput!) {
  changeEmployeeLeavePolicy(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeEmployeeLeavePolicyGQL extends Apollo.Mutation<ChangeEmployeeLeavePolicyMutation, ChangeEmployeeLeavePolicyMutationVariables> {
    override document = ChangeEmployeeLeavePolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignLeavePolicyToEmployeeDocument = gql`
    mutation AssignLeavePolicyToEmployee($input: assignLeavePolicyInput!) {
  assignLeavePolicyToEmployee(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignLeavePolicyToEmployeeGQL extends Apollo.Mutation<AssignLeavePolicyToEmployeeMutation, AssignLeavePolicyToEmployeeMutationVariables> {
    override document = AssignLeavePolicyToEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLeavePolicyByIdDocument = gql`
    query GetLeavePolicyById($id: ID!, $employee: ID, $search: String) {
  getLeavePolicyById(_id: $id, employee: $employee, search: $search) {
    _id
    name
    is_deleted
    sandwich
    sandwich_on_public_holiday
    is_accrual
    accrual_type
    accrual_on_day
    accrual_on_month
    accrual_no_of_hours
    accrual_one_time_day
    is_reset
    reset_type
    reset_on_day
    reset_on_month
    reset_carry_forward_count
    reset_max_limit
    accrual_one_time_day
    is_manual_deduction
    is_week_hour_limit
    manual_deduction_value
    is_hourly_employee_sandwich
    leaves {
      count
      countIn
      policy_type
      carry_forward_limit
      leaveAssighment
      type {
        _id
        name
        is_pto
        un_paid_days
        pto_type
      }
    }
    assign_to {
      employee_id
      id
      first_name
      last_name
      full_name
      pto_minutes {
        pto_earned_minutes
        pto_availed_minutes
        pto_fixed_total_minutes
      }
      time_off {
        time_off_days
        time_off_total_days
        countIn
        time_off_type {
          _id
          name
          is_pto
          pto_type
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeavePolicyByIdGQL extends Apollo.Query<GetLeavePolicyByIdQuery, GetLeavePolicyByIdQueryVariables> {
    override document = GetLeavePolicyByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeesForLeavePolicyDocument = gql`
    query GetEmployeesForLeavePolicy($args: getLeavePolicyArguments) {
  getEmployeesForLeavePolicy(args: $args) {
    id
    first_name
    last_name
    full_name
    joining_date
    employee_group {
      is_un_restricted
    }
    time_off {
      time_off_days
      time_off_total_days
      time_off_type {
        _id
        name
        is_pto
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeesForLeavePolicyGQL extends Apollo.Query<GetEmployeesForLeavePolicyQuery, GetEmployeesForLeavePolicyQueryVariables> {
    override document = GetEmployeesForLeavePolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeEmployeeLeavePackageDocument = gql`
    mutation ChangeEmployeeLeavePackage($input: changeLeavePolicyInput!) {
  changeEmployeeLeavePackage(input: $input) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeEmployeeLeavePackageGQL extends Apollo.Mutation<ChangeEmployeeLeavePackageMutation, ChangeEmployeeLeavePackageMutationVariables> {
    override document = ChangeEmployeeLeavePackageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateLeaveTypeDocument = gql`
    mutation CreateUpdateLeaveType($id: ID, $input: InputLeaveType!) {
  createUpdateLeaveType(id: $id, input: $input) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateLeaveTypeGQL extends Apollo.Mutation<CreateUpdateLeaveTypeMutation, CreateUpdateLeaveTypeMutationVariables> {
    override document = CreateUpdateLeaveTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveLeaveTypeByIdDocument = gql`
    mutation ArchiveLeaveTypeById($id: ID!, $archive: Boolean!) {
  archiveLeaveTypeById(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveLeaveTypeByIdGQL extends Apollo.Mutation<ArchiveLeaveTypeByIdMutation, ArchiveLeaveTypeByIdMutationVariables> {
    override document = ArchiveLeaveTypeByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLeavesTypeWithSearchDocument = gql`
    query GetLeavesTypeWithSearch($input: leaveTypeListFilter) {
  getLeavesTypeWithSearch(input: $input) {
    results {
      _id
      name
      code
      type
      is_pto
      is_deleted
      description
    }
    config {
      ...ConfigWithoutSummaryFields
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeavesTypeWithSearchGQL extends Apollo.Query<GetLeavesTypeWithSearchQuery, GetLeavesTypeWithSearchQueryVariables> {
    override document = GetLeavesTypeWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLeaveTypeByIdDocument = gql`
    query GetLeaveTypeById($id: ID!) {
  getLeaveTypeById(id: $id) {
    _id
    name
    code
    type
    description
    leave_duration
    minimum_duration
    maximum_duration
    per_day_hours
    working_days
    un_paid
    un_paid_days
    half_leave_in_ful_leave
    half_day_Consideration
    consecutive_leaves
    is_pto
    pto_type
    assign_to
    pto_earning_threshold_hours
    pto_hours_against_threshold
    pto_minimum_consumable_hours
    pto_advance_notice_days
    is_pto_against_overtime
    is_pto_against_weekend
    is_pto_against_public_holiday
    fixed_pto_ratio
    pto_value_in
    blackOutWindow {
      date
      reason
    }
    ranges {
      start
      end
      value
    }
    is_allow_partial_apply
    partial_apply_minimum
    is_reset
    reset_carry_forward_count
    policy_type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeaveTypeByIdGQL extends Apollo.Query<GetLeaveTypeByIdQuery, GetLeaveTypeByIdQueryVariables> {
    override document = GetLeaveTypeByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMedicalInsurancePackageListDocument = gql`
    query GetMedicalInsurancePackageList($input: medicalInsuranceListFilter) {
  getMedicalInsurancePackageList(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    results {
      _id
      package_name
      company
      package_type
      package_price
      is_deleted
      enrollment_start_date
      enrollment_start_days
      enrollment_end_days
      enrollment_end_date
      monthly_cost_to_employe
      MasterDataValue {
        _id
        data_value_name
      }
      monthly_cost_to_employer
      notify_before_days
      assigned_to {
        _id
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMedicalInsurancePackageListGQL extends Apollo.Query<GetMedicalInsurancePackageListQuery, GetMedicalInsurancePackageListQueryVariables> {
    override document = GetMedicalInsurancePackageListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateMedicalInsurancePackageDocument = gql`
    mutation CreateUpdateMedicalInsurancePackage($input: medicalInsurancePackageInput) {
  createUpdateMedicalInsurancePackage(input: $input) {
    _id
    package_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateMedicalInsurancePackageGQL extends Apollo.Mutation<CreateUpdateMedicalInsurancePackageMutation, CreateUpdateMedicalInsurancePackageMutationVariables> {
    override document = CreateUpdateMedicalInsurancePackageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveMedicalInsurancePackageDocument = gql`
    mutation ArchiveMedicalInsurancePackage($input: archiveMedicalInsurancepackageInput) {
  archiveMedicalInsurancePackage(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveMedicalInsurancePackageGQL extends Apollo.Mutation<ArchiveMedicalInsurancePackageMutation, ArchiveMedicalInsurancePackageMutationVariables> {
    override document = ArchiveMedicalInsurancePackageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPublicHolidaysWithFiltersDocument = gql`
    query GetPublicHolidaysWithFilters($input: publicHolidaysFilter) {
  getPublicHolidaysWithFilters(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      name
      from_date
      to_date
      is_recursive
      is_deleted
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPublicHolidaysWithFiltersGQL extends Apollo.Query<GetPublicHolidaysWithFiltersQuery, GetPublicHolidaysWithFiltersQueryVariables> {
    override document = GetPublicHolidaysWithFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPublicHolidaysByIdDocument = gql`
    query GetPublicHolidaysById($id: ID) {
  getPublicHolidaysByID(id: $id) {
    _id
    name
    from_date
    to_date
    is_recursive
    Department {
      _id
      department_name
    }
    Role {
      _id
      roleName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPublicHolidaysByIdGQL extends Apollo.Query<GetPublicHolidaysByIdQuery, GetPublicHolidaysByIdQueryVariables> {
    override document = GetPublicHolidaysByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdatePublicHolidaysDocument = gql`
    mutation CreateUpdatePublicHolidays($input: InputPublicHolidays) {
  createUpdatePublicHolidays(input: $input) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdatePublicHolidaysGQL extends Apollo.Mutation<CreateUpdatePublicHolidaysMutation, CreateUpdatePublicHolidaysMutationVariables> {
    override document = CreateUpdatePublicHolidaysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchivePublicHolidaysDocument = gql`
    mutation ArchivePublicHolidays($id: ID, $archive: Boolean) {
  archivePublicHolidays(id: $id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchivePublicHolidaysGQL extends Apollo.Mutation<ArchivePublicHolidaysMutation, ArchivePublicHolidaysMutationVariables> {
    override document = ArchivePublicHolidaysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateShiftDocument = gql`
    mutation CreateUpdateShift($input: ShiftInput) {
  createUpdateShift(input: $input) {
    _id
    shift_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateShiftGQL extends Apollo.Mutation<CreateUpdateShiftMutation, CreateUpdateShiftMutationVariables> {
    override document = CreateUpdateShiftDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveShiftDocument = gql`
    mutation ArchiveShift($_id: ID, $archive: Boolean) {
  archiveShift(_id: $_id, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveShiftGQL extends Apollo.Mutation<ArchiveShiftMutation, ArchiveShiftMutationVariables> {
    override document = ArchiveShiftDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWriteupsDocument = gql`
    query GetWriteups($input: writeUpListFilter) {
  getWriteups(input: $input) {
    config {
      ...ConfigWithoutSummaryFields
    }
    results {
      _id
      write_up_type
      write_up_reason
      description
      approval_description
      approval_status
      status
      informed_hr
      email
      writeup_date
      writeup_message
      created_at
      is_deleted
      is_pending
      write_up_source
      attachments
      employee {
        _id
        first_name
        last_name
        full_name
      }
      business_manager {
        _id
        full_name
      }
      work_flow {
        approval_description
        status
        approved_by {
          _id
          full_name
        }
        employee {
          _id
          full_name
        }
      }
    }
  }
}
    ${ConfigWithoutSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWriteupsGQL extends Apollo.Query<GetWriteupsQuery, GetWriteupsQueryVariables> {
    override document = GetWriteupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWriteUpByIdDocument = gql`
    query GetWriteUpById($getWriteUpByIdId: ID!) {
  getWriteUpById(id: $getWriteUpByIdId) {
    _id
    write_up_type
    write_up_reason
    description
    approval_description
    approval_status
    status
    informed_hr
    email
    writeup_date
    writeup_message
    created_at
    is_deleted
    attachments
    employee {
      _id
      first_name
      last_name
      full_name
    }
    business_manager {
      _id
      full_name
    }
    work_flow {
      approval_description
      status
      approved_by {
        _id
        full_name
      }
      employee {
        _id
        full_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWriteUpByIdGQL extends Apollo.Query<GetWriteUpByIdQuery, GetWriteUpByIdQueryVariables> {
    override document = GetWriteUpByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteWriteUpDocument = gql`
    mutation DeleteWriteUp($ids: [ID!]!, $archive: Boolean!) {
  deleteWriteUp(ids: $ids, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteWriteUpGQL extends Apollo.Mutation<DeleteWriteUpMutation, DeleteWriteUpMutationVariables> {
    override document = DeleteWriteUpDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateWriteUpApprovalDocument = gql`
    mutation UpdateWriteUpApproval($input: InputUpdateWriteUpApproval!) {
  updateWriteUpApproval(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateWriteUpApprovalGQL extends Apollo.Mutation<UpdateWriteUpApprovalMutation, UpdateWriteUpApprovalMutationVariables> {
    override document = UpdateWriteUpApprovalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMasterDataTypeDocument = gql`
    mutation CreateMasterDataType($input: dataTypeInput!) {
  createMasterDataType(input: $input) {
    _id
    data_type_name
    created_at
    created_by {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMasterDataTypeGQL extends Apollo.Mutation<CreateMasterDataTypeMutation, CreateMasterDataTypeMutationVariables> {
    override document = CreateMasterDataTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMasterDataTypeValueDocument = gql`
    mutation CreateMasterDataTypeValue($input: dataTypeValueInput!) {
  createMasterDataTypeValue(input: $input) {
    _id
    data_value_name
    is_system_generated
    data_type {
      _id
      data_type_name
    }
    data_value_type {
      _id
      data_value_name
      data_type {
        _id
        data_type_name
      }
    }
    is_system_generated
    created_at
    created_by {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMasterDataTypeValueGQL extends Apollo.Mutation<CreateMasterDataTypeValueMutation, CreateMasterDataTypeValueMutationVariables> {
    override document = CreateMasterDataTypeValueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMasterDataTypeValueDocument = gql`
    mutation UpdateMasterDataTypeValue($input: updateDataTypeValueInput!) {
  updateMasterDataTypeValue(input: $input) {
    _id
    data_value_name
    is_system_generated
    data_type {
      _id
      data_type_name
    }
    data_value_type {
      _id
      data_value_name
      data_type {
        _id
        data_type_name
      }
    }
    is_system_generated
    created_at
    created_by {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMasterDataTypeValueGQL extends Apollo.Mutation<UpdateMasterDataTypeValueMutation, UpdateMasterDataTypeValueMutationVariables> {
    override document = UpdateMasterDataTypeValueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllMasterDataTypeValueByIdDocument = gql`
    query GetAllMasterDataTypeValueById($getAllMasterDataTypeValueByIdId: ID!) {
  getAllMasterDataTypeValueById(id: $getAllMasterDataTypeValueByIdId) {
    _id
    data_value_name
    is_system_generated
    data_type {
      _id
    }
    business {
      _id
    }
    data_value_type {
      _id
      data_value_name
      data_type {
        _id
        data_type_name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllMasterDataTypeValueByIdGQL extends Apollo.Query<GetAllMasterDataTypeValueByIdQuery, GetAllMasterDataTypeValueByIdQueryVariables> {
    override document = GetAllMasterDataTypeValueByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMasterDataTypeValueDocument = gql`
    mutation DeleteMasterDataTypeValue($id: ID!) {
  deleteMasterDataTypeValue(_id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMasterDataTypeValueGQL extends Apollo.Mutation<DeleteMasterDataTypeValueMutation, DeleteMasterDataTypeValueMutationVariables> {
    override document = DeleteMasterDataTypeValueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllMasterDataTypeWithSearchDocument = gql`
    query GetAllMasterDataTypeWithSearch($search: String) {
  getAllMasterDataTypeWithSearch(search: $search) {
    _id
    data_type_name
    created_at
    created_by {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllMasterDataTypeWithSearchGQL extends Apollo.Query<GetAllMasterDataTypeWithSearchQuery, GetAllMasterDataTypeWithSearchQueryVariables> {
    override document = GetAllMasterDataTypeWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllMasterDataTypeValueWithSearchDocument = gql`
    query GetAllMasterDataTypeValueWithSearch($input: searchDataTypeValueInput!) {
  getAllMasterDataTypeValueWithSearch(input: $input) {
    results {
      _id
      data_value_name
      is_system_generated
      data_type {
        _id
      }
      business {
        _id
      }
      data_value_type {
        _id
        data_value_name
        data_type {
          _id
          data_type_name
        }
      }
      is_system_generated
    }
    page
    limit
    totalPages
    totalResults
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllMasterDataTypeValueWithSearchGQL extends Apollo.Query<GetAllMasterDataTypeValueWithSearchQuery, GetAllMasterDataTypeValueWithSearchQueryVariables> {
    override document = GetAllMasterDataTypeValueWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllMasterDataTypeValueByTypeIdDocument = gql`
    query GetAllMasterDataTypeValueByTypeId($input: dataValueInput!) {
  getAllMasterDataTypeValueByTypeId(input: $input) {
    _id
    data_value_name
    data_type {
      _id
      data_type_name
    }
    data_value_type {
      _id
      data_value_name
      data_type {
        _id
        data_type_name
      }
      data_value_type {
        _id
        data_value_name
        data_type {
          _id
        }
      }
      is_system_generated
      created_at
      created_by {
        id
      }
      business {
        _id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllMasterDataTypeValueByTypeIdGQL extends Apollo.Query<GetAllMasterDataTypeValueByTypeIdQuery, GetAllMasterDataTypeValueByTypeIdQueryVariables> {
    override document = GetAllMasterDataTypeValueByTypeIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllNotificationsWithFiltersDocument = gql`
    query GetAllNotificationsWithFilters($input: notificationFilterInput) {
  getAllNotificationsWithFilters(input: $input) {
    page
    limit
    totalPages
    totalResults
    notificationCount
    results {
      is_reminder_sent
      has_action
      action_type
      defaultSystemNotification
      path {
        slug
        feature
        module
        navigationUrl
      }
      data_object
      _id
      title
      description
      is_read
      created_at
      user_id {
        full_name
        id
        profile_pictures {
          dimension
          path
        }
      }
      for_user {
        full_name
        id
        profile_pictures {
          dimension
          path
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllNotificationsWithFiltersGQL extends Apollo.Query<GetAllNotificationsWithFiltersQuery, GetAllNotificationsWithFiltersQueryVariables> {
    override document = GetAllNotificationsWithFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllPermissionOfNotificationsDocument = gql`
    query GetAllPermissionOfNotifications {
  getAllPermissionOfNotifications {
    _id
    feature
    is_checked
    is_default
    is_deleted
    is_enabled
    module
    permission_at
    slug
    role {
      roleName
    }
    sub_feature
    userID
    created_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllPermissionOfNotificationsGQL extends Apollo.Query<GetAllPermissionOfNotificationsQuery, GetAllPermissionOfNotificationsQueryVariables> {
    override document = GetAllPermissionOfNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkAllAsReadDocument = gql`
    mutation MarkAllAsRead($input: markAsReadInput) {
  markAllAsRead(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkAllAsReadGQL extends Apollo.Mutation<MarkAllAsReadMutation, MarkAllAsReadMutationVariables> {
    override document = MarkAllAsReadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNotificationPermissionsDocument = gql`
    mutation UpdateNotificationPermissions($input: updatePermissions) {
  updateNotificationPermissions(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNotificationPermissionsGQL extends Apollo.Mutation<UpdateNotificationPermissionsMutation, UpdateNotificationPermissionsMutationVariables> {
    override document = UpdateNotificationPermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkNotificationsAsClearedDocument = gql`
    mutation MarkNotificationsAsCleared($ids: [ID!]) {
  MarkNotificationsAsCleared(_ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkNotificationsAsClearedGQL extends Apollo.Mutation<MarkNotificationsAsClearedMutation, MarkNotificationsAsClearedMutationVariables> {
    override document = MarkNotificationsAsClearedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteNotificationDocument = gql`
    mutation DeleteNotification($ids: [ID!]) {
  deleteNotification(_ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteNotificationGQL extends Apollo.Mutation<DeleteNotificationMutation, DeleteNotificationMutationVariables> {
    override document = DeleteNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetDoNotDisturbInNotificationsDocument = gql`
    mutation SetDoNotDisturbInNotifications($doNotDisturb: Boolean) {
  setDoNotDisturbInNotifications(DoNotDisturb: $doNotDisturb)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDoNotDisturbInNotificationsGQL extends Apollo.Mutation<SetDoNotDisturbInNotificationsMutation, SetDoNotDisturbInNotificationsMutationVariables> {
    override document = SetDoNotDisturbInNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkAllViewedDocument = gql`
    mutation markAllViewed {
  markAllViewed
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkAllViewedGQL extends Apollo.Mutation<MarkAllViewedMutation, MarkAllViewedMutationVariables> {
    override document = MarkAllViewedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateReminderForNotificationDocument = gql`
    mutation CreateReminderForNotification($notificationId: ID!) {
  createReminderForNotification(notificationId: $notificationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateReminderForNotificationGQL extends Apollo.Mutation<CreateReminderForNotificationMutation, CreateReminderForNotificationMutationVariables> {
    override document = CreateReminderForNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GeneratedNotificationDocument = gql`
    subscription GeneratedNotification($userId: ID!) {
  generatedNotification(userId: $userId) {
    _id
    created_at
    data_object
    description
    for_user {
      id
      full_name
      profile_pictures {
        dimension
        path
      }
    }
    is_read
    path {
      feature
      module
      navigationUrl
    }
    title
    user_id {
      id
      full_name
      profile_pictures {
        dimension
        path
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GeneratedNotificationGQL extends Apollo.Subscription<GeneratedNotificationSubscription, GeneratedNotificationSubscriptionVariables> {
    override document = GeneratedNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendNotificationCountDocument = gql`
    subscription SendNotificationCount($userId: ID!) {
  sendNotificationCount(userId: $userId) {
    notificationCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendNotificationCountGQL extends Apollo.Subscription<SendNotificationCountSubscription, SendNotificationCountSubscriptionVariables> {
    override document = SendNotificationCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPinCodeVerifyDocument = gql`
    mutation UserPinCodeVerify($pincode: String!, $businessId: ID!, $clockedTime: String!, $timeZone: String!) {
  userPinCodeVerify(
    pincode: $pincode
    business_id: $businessId
    clockedTime: $clockedTime
    time_zone: $timeZone
  ) {
    clockedHistory {
      breaks {
        _id
        break_duration
        breakInstatus
        break_in_time
        break_out_time
        title
        message
        break_type {
          _id
          data_value_name
          is_system_generated
          data_value_type {
            _id
            data_value_name
          }
        }
      }
    }
    break_details {
      break_in_time
      breakID
      breakType
      breakTypeID
    }
    User {
      id
      email
      first_name
      last_name
      middle_name
      writeup_type
      writeup_date
      storeAccess {
        businessLocation {
          _id
          store_name
          store_nick_name
          location_keeping_unit
          logo
        }
      }
      employee_group {
        _id
        is_clocked_in_from_app
      }
    }
    oldClockHistoryId
    clocked_in_time
    status
    UserClockInPin
    tokens {
      access {
        token
        expires
      }
      refresh {
        token
        expires
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPinCodeVerifyGQL extends Apollo.Mutation<UserPinCodeVerifyMutation, UserPinCodeVerifyMutationVariables> {
    override document = UserPinCodeVerifyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserClockedInDocument = gql`
    mutation UserClockedIn($userId: ID!, $userClockInPin: ID!, $clockedTime: String!, $zoneName: String, $oldClockHistoryId: ID, $businessLocation: ID) {
  userClockedIn(
    userId: $userId
    userClockInPin: $userClockInPin
    clockedTime: $clockedTime
    zoneName: $zoneName
    oldClockHistoryId: $oldClockHistoryId
    businessLocation: $businessLocation
  ) {
    _id
    message
    clock_in_time
    breaks {
      _id
      break_duration
      breakInstatus
    }
    write_up_type
    attendanceStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserClockedInGQL extends Apollo.Mutation<UserClockedInMutation, UserClockedInMutationVariables> {
    override document = UserClockedInDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateConfigListingDocument = gql`
    mutation CreateUpdateConfigListing($input: ConfigListingInput) {
  createUpdateConfigListing(input: $input) {
    actions {
      name
      is_visible
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateConfigListingGQL extends Apollo.Mutation<CreateUpdateConfigListingMutation, CreateUpdateConfigListingMutationVariables> {
    override document = CreateUpdateConfigListingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaymentMethodDocument = gql`
    query GetPaymentMethod($id: ID!) {
  getPaymentMethod(_id: $id) {
    cards {
      id
      customer
      billing_details {
        email
        name
      }
      card {
        brand
        country
        exp_month
        exp_year
        last4
      }
    }
    default
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaymentMethodGQL extends Apollo.Query<GetPaymentMethodQuery, GetPaymentMethodQueryVariables> {
    override document = GetPaymentMethodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddNewPaymentMethodCustomerDocument = gql`
    mutation AddNewPaymentMethodCustomer($input: paymentMethod) {
  addNewPaymentMethodCustomer(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNewPaymentMethodCustomerGQL extends Apollo.Mutation<AddNewPaymentMethodCustomerMutation, AddNewPaymentMethodCustomerMutationVariables> {
    override document = AddNewPaymentMethodCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchivePaymentMethodDocument = gql`
    mutation ArchivePaymentMethod($cardId: ID!, $customerId: ID!) {
  archivePaymentMethod(card_id: $cardId, customer_id: $customerId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchivePaymentMethodGQL extends Apollo.Mutation<ArchivePaymentMethodMutation, ArchivePaymentMethodMutationVariables> {
    override document = ArchivePaymentMethodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllSubscriptionLogActivityDocument = gql`
    query GetAllSubscriptionLogActivity($input: logActivity) {
  getAllSubscriptionLogActivity(input: $input) {
    results {
      _id
      type
      title
      description
      activity_date
      file_name
      attachment
    }
    config {
      page
      limit
      totalPages
      totalResults
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllSubscriptionLogActivityGQL extends Apollo.Query<GetAllSubscriptionLogActivityQuery, GetAllSubscriptionLogActivityQueryVariables> {
    override document = GetAllSubscriptionLogActivityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSubscriptionLogActivityByIdDocument = gql`
    query GetSubscriptionLogActivityById($id: ID!) {
  getSubscriptionLogActivityById(id: $id) {
    _id
    type
    title
    description
    activity_date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSubscriptionLogActivityByIdGQL extends Apollo.Query<GetSubscriptionLogActivityByIdQuery, GetSubscriptionLogActivityByIdQueryVariables> {
    override document = GetSubscriptionLogActivityByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSubscriptionLogActivityDocument = gql`
    mutation CreateSubscriptionLogActivity($input: InputCreateLogActivity!) {
  createSubscriptionLogActivity(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSubscriptionLogActivityGQL extends Apollo.Mutation<CreateSubscriptionLogActivityMutation, CreateSubscriptionLogActivityMutationVariables> {
    override document = CreateSubscriptionLogActivityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSubscriptionLogActivityDocument = gql`
    mutation UpdateSubscriptionLogActivity($input: InputUpdateLogActivity!) {
  updateSubscriptionLogActivity(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSubscriptionLogActivityGQL extends Apollo.Mutation<UpdateSubscriptionLogActivityMutation, UpdateSubscriptionLogActivityMutationVariables> {
    override document = UpdateSubscriptionLogActivityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveSubscriptionLogActivityDocument = gql`
    mutation ArchiveSubscriptionLogActivity($id: ID!) {
  archiveSubscriptionLogActivity(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveSubscriptionLogActivityGQL extends Apollo.Mutation<ArchiveSubscriptionLogActivityMutation, ArchiveSubscriptionLogActivityMutationVariables> {
    override document = ArchiveSubscriptionLogActivityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSubscriptionByRequestedBusinessIdDocument = gql`
    query GetSubscriptionByRequestedBusinessId($business_id: ID) {
  getSubscriptionByRequestedBusinessId(business_id: $business_id) {
    _id
    show_paynow
    is_custom_package
    status
    created_at
    user_request_from {
      id
      first_name
      last_name
      full_name
      email
      phone
    }
    request_from {
      _id
      business_system_name
      Country {
        name
      }
      address
      zip_code
    }
    request_to {
      _id
      business_system_name
    }
    package {
      _id
      package_name
      package_price
      recurring
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSubscriptionByRequestedBusinessIdGQL extends Apollo.Query<GetSubscriptionByRequestedBusinessIdQuery, GetSubscriptionByRequestedBusinessIdQueryVariables> {
    override document = GetSubscriptionByRequestedBusinessIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSubscriptionByIdDocument = gql`
    query GetSubscriptionById($id: ID!) {
  getSubscriptionById(id: $id) {
    _id
    show_paynow
    is_custom_package
    status
    created_at
    user_request_from {
      id
      first_name
      last_name
      full_name
      email
      phone
    }
    request_from {
      _id
      business_system_name
      Country {
        name
      }
      address
      zip_code
    }
    request_to {
      _id
      business_system_name
    }
    package {
      _id
      package_name
      package_type
      package_price
      recurring
      is_pakage_free
      transcation_fee_calculation_type
      transcation_fee
      no_of_store
      no_of_employee
      number_of_cashregisters
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSubscriptionByIdGQL extends Apollo.Query<GetSubscriptionByIdQuery, GetSubscriptionByIdQueryVariables> {
    override document = GetSubscriptionByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPacakgesForCustomSubscriptionRequestDocument = gql`
    query GetPacakgesForCustomSubscriptionRequest($subscription: ID!) {
  getPacakgesForCustomSubscriptionRequest(subscription: $subscription) {
    _id
    package_name
    package_type
    package_price
    recurring
    is_pakage_free
    transcation_fee_calculation_type
    transcation_fee
    no_of_store
    no_of_employee
    number_of_cashregisters
    created_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPacakgesForCustomSubscriptionRequestGQL extends Apollo.Query<GetPacakgesForCustomSubscriptionRequestQuery, GetPacakgesForCustomSubscriptionRequestQueryVariables> {
    override document = GetPacakgesForCustomSubscriptionRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSubscriptionPaymentLogsDocument = gql`
    query GetSubscriptionPaymentLogs($subscription: ID!) {
  getSubscriptionPaymentLogs(subscription: $subscription) {
    remarks
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSubscriptionPaymentLogsGQL extends Apollo.Query<GetSubscriptionPaymentLogsQuery, GetSubscriptionPaymentLogsQueryVariables> {
    override document = GetSubscriptionPaymentLogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BusinessPackageByBusinessIdDocument = gql`
    query BusinessPackageByBusinessId($businessId: ID!) {
  businessPackageByBusinessId(businessId: $businessId) {
    _id
    package_name
    package_type
    package_price
    recurring
    is_pakage_free
    transcation_fee_calculation_type
    transcation_fee
    no_of_store
    no_of_employee
    number_of_cashregisters
    subscribe_at
    hr_module_only
    expires_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BusinessPackageByBusinessIdGQL extends Apollo.Query<BusinessPackageByBusinessIdQuery, BusinessPackageByBusinessIdQueryVariables> {
    override document = BusinessPackageByBusinessIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculateUpdatePackageFeeDocument = gql`
    query CalculateUpdatePackageFee($package: ID!, $subscription: ID!) {
  calculateUpdatePackageFee(package: $package, subscription: $subscription)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalculateUpdatePackageFeeGQL extends Apollo.Query<CalculateUpdatePackageFeeQuery, CalculateUpdatePackageFeeQueryVariables> {
    override document = CalculateUpdatePackageFeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFranchiseRequestsDocument = gql`
    query GetFranchiseRequests($business: ID!) {
  getFranchiseRequests(business: $business) {
    _id
    Franchise {
      _id
      store_nick_name
    }
    FranchiseeBusiness {
      _id
      business_system_name
    }
    FranchiserBusiness {
      _id
      business_system_name
    }
    franchise_fee
    payment_pending
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFranchiseRequestsGQL extends Apollo.Query<GetFranchiseRequestsQuery, GetFranchiseRequestsQueryVariables> {
    override document = GetFranchiseRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeSubsriptionStatusDocument = gql`
    mutation ChangeSubsriptionStatus($id: ID!, $status: AllowedSubscriptionStatus!) {
  changeSubsriptionStatus(id: $id, status: $status)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeSubsriptionStatusGQL extends Apollo.Mutation<ChangeSubsriptionStatusMutation, ChangeSubsriptionStatusMutationVariables> {
    override document = ChangeSubsriptionStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignPackageToSubscriptionDocument = gql`
    mutation AssignPackageToSubscription($subscription: ID!, $package: ID!) {
  assignPackageToSubscription(subscription: $subscription, package: $package)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignPackageToSubscriptionGQL extends Apollo.Mutation<AssignPackageToSubscriptionMutation, AssignPackageToSubscriptionMutationVariables> {
    override document = AssignPackageToSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PayForPackageSubsctipitonDocument = gql`
    mutation PayForPackageSubsctipiton($subscription: ID!) {
  payForPackageSubsctipiton(subscription: $subscription)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PayForPackageSubsctipitonGQL extends Apollo.Mutation<PayForPackageSubsctipitonMutation, PayForPackageSubsctipitonMutationVariables> {
    override document = PayForPackageSubsctipitonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBusinessPackageDocument = gql`
    mutation UpdateBusinessPackage($package: ID!, $subscription: ID!, $inActiveEmployees: [ID], $inActiveStore: [ID]) {
  updateBusinessPackage(
    package: $package
    subscription: $subscription
    inActiveEmployees: $inActiveEmployees
    inActiveStore: $inActiveStore
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBusinessPackageGQL extends Apollo.Mutation<UpdateBusinessPackageMutation, UpdateBusinessPackageMutationVariables> {
    override document = UpdateBusinessPackageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelBusinessPackageDocument = gql`
    mutation CancelBusinessPackage($business: ID!) {
  cancelBusinessPackage(business: $business)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelBusinessPackageGQL extends Apollo.Mutation<CancelBusinessPackageMutation, CancelBusinessPackageMutationVariables> {
    override document = CancelBusinessPackageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PayFranchiseSubscriptionDocument = gql`
    mutation PayFranchiseSubscription($requestId: ID!) {
  payFranchiseSubscription(requestID: $requestId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PayFranchiseSubscriptionGQL extends Apollo.Mutation<PayFranchiseSubscriptionMutation, PayFranchiseSubscriptionMutationVariables> {
    override document = PayFranchiseSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetDefaultCardDocument = gql`
    mutation SetDefaultCard($cardId: ID!, $customerId: ID!) {
  setDefaultCard(card_id: $cardId, customer_id: $customerId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultCardGQL extends Apollo.Mutation<SetDefaultCardMutation, SetDefaultCardMutationVariables> {
    override document = SetDefaultCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessSubscriptionsDocument = gql`
    query GetBusinessSubscriptions($input: subscriptionListFilter) {
  getBusinessSubscriptions(input: $input) {
    results {
      _id
      is_deleted
      email
      phone
      created_at
      status
      user_request_from {
        id
        full_name
        business_id {
          _id
          business_type
        }
      }
      package {
        _id
        package_name
      }
    }
    config {
      actions
      limit
      no_of_records
      page
      totalPages
      totalResults
      type
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessSubscriptionsGQL extends Apollo.Query<GetBusinessSubscriptionsQuery, GetBusinessSubscriptionsQueryVariables> {
    override document = GetBusinessSubscriptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSubscriptionRequestDocument = gql`
    mutation DeleteSubscriptionRequest($deleteSubscriptionRequestId: [ID]!, $archive: Boolean!) {
  deleteSubscriptionRequest(id: $deleteSubscriptionRequestId, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSubscriptionRequestGQL extends Apollo.Mutation<DeleteSubscriptionRequestMutation, DeleteSubscriptionRequestMutationVariables> {
    override document = DeleteSubscriptionRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllTasksWithSearchDocument = gql`
    query GetAllTasksWithSearch($input: allTasksInput!) {
  getAllTasksWithSearch(input: $input) {
    config {
      limit
      page
      totalPages
      totalResults
      no_of_records
      type
      actions
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      table_preset {
        ...TablePresetFields
      }
    }
    data {
      _id
      summary
      description
      editor_description
      attachments
      attachments_name
      formatted_time
      total_time_spent
      is_timing_active
      is_timing_ended
      created_at
      due_date
      completed_date
      task_name
      no_sub_task
      is_owner
      comment_count
      attachments_count
      priority
      status
      Department {
        _id
        department_name
      }
      assignee {
        full_name
        id
      }
      reporter {
        full_name
        id
      }
      comments {
        _id
        comment
        comment_by {
          id
          full_name
          first_name
          last_name
          logo
        }
        comment_date
        replies {
          _id
          reply
          reply_by {
            id
            full_name
            logo
          }
          reply_date
        }
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllTasksWithSearchGQL extends Apollo.Query<GetAllTasksWithSearchQuery, GetAllTasksWithSearchQueryVariables> {
    override document = GetAllTasksWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTasksCountDocument = gql`
    query GetTasksCount($input: taskCountInput) {
  getTasksCount(input: $input) {
    assign_by_me
    assign_to_me
    my_tasks
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTasksCountGQL extends Apollo.Query<GetTasksCountQuery, GetTasksCountQueryVariables> {
    override document = GetTasksCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTeamMembersDocument = gql`
    query GetTeamMembers($employeeId: ID, $businessLocaion: ID) {
  getTeamMembers(employee_id: $employeeId, businessLocaion: $businessLocaion) {
    id
    first_name
    last_name
    full_name
    logo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTeamMembersGQL extends Apollo.Query<GetTeamMembersQuery, GetTeamMembersQueryVariables> {
    override document = GetTeamMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveTaskDocument = gql`
    mutation ArchiveTask($ids: [ID]!, $archive: Boolean!) {
  archiveTask(ids: $ids, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveTaskGQL extends Apollo.Mutation<ArchiveTaskMutation, ArchiveTaskMutationVariables> {
    override document = ArchiveTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllMyTasksWithSearchDocument = gql`
    query GetAllMyTasksWithSearch($input: allMyTasksInput!) {
  getAllMyTasksWithSearch(input: $input) {
    config {
      limit
      page
      totalPages
      totalResults
      no_of_records
      type
      actions
      columns {
        ...ColumnDefinitionWithoutSummaryFields
      }
      filters {
        ...FilterFields
      }
      table_preset {
        ...TablePresetFields
      }
    }
    results {
      _id
      is_deleted
      editor_description
      summary
      description
      attachments
      attachments_name
      due_date
      formatted_time
      total_time_spent
      is_timing_active
      is_timing_ended
      created_at
      completed_date
      priority
      status
      task_name
      no_sub_task
      is_owner
      comment_count
      attachments_count
      Department {
        _id
        department_name
      }
      check_list {
        _id
        is_completed
        title
      }
      comments {
        _id
        comment
        comment_by {
          id
          full_name
          first_name
          last_name
          logo
        }
        comment_date
        replies {
          _id
          reply
          reply_by {
            id
            full_name
            logo
          }
          reply_date
        }
      }
      assignee {
        first_name
        full_name
        id
      }
      reporter {
        first_name
        full_name
        id
      }
    }
  }
}
    ${ColumnDefinitionWithoutSummaryFieldsFragmentDoc}
${FilterFieldsFragmentDoc}
${TablePresetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllMyTasksWithSearchGQL extends Apollo.Query<GetAllMyTasksWithSearchQuery, GetAllMyTasksWithSearchQueryVariables> {
    override document = GetAllMyTasksWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllAssigneeTasksWithSearchDocument = gql`
    query GetAllAssigneeTasksWithSearch($input: allAssigneeTasksInput!) {
  getAllAssigneeTasksWithSearch(input: $input) {
    _id
    summary
    description
    attachments
    due_date
    is_deleted
    priority
    status
    completed_date
    check_list {
      _id
      is_completed
      title
    }
    comments {
      comment
      comment_by {
        id
        full_name
        first_name
        last_name
        logo
      }
      comment_date
    }
    assignee {
      id
      first_name
      last_name
      full_name
      logo
    }
    reporter {
      id
      first_name
      last_name
      full_name
      logo
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAssigneeTasksWithSearchGQL extends Apollo.Query<GetAllAssigneeTasksWithSearchQuery, GetAllAssigneeTasksWithSearchQueryVariables> {
    override document = GetAllAssigneeTasksWithSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTaskCalenderDocument = gql`
    query GetTaskCalender($input: taskCalenderInput) {
  getTaskCalender(input: $input) {
    limit
    page
    totalPages
    totalResults
    employees {
      _id
      employee_id
      first_name
      last_name
      full_name
      birth_date
      email
      salary_type
      phone
      joining_date
      employee_type
      roles {
        _id
        roleName
      }
      profile_pictures {
        dimension
        path
      }
      designation {
        _id
        designation_name
      }
      department {
        _id
        department_name
      }
    }
    results {
      _id
      task_name
      summary
      description
      due_date
      start_date
      end_date
      status
      comment_count
      created_at
      updated_at
      reporter {
        _id
        full_name
      }
      assignee {
        _id
        employee_id
        full_name
        profile_pictures {
          dimension
          path
        }
        department {
          _id
          department_name
        }
        designation {
          _id
          designation_name
        }
      }
      sub_task {
        _id
        task_name
        summary
        description
        due_date
        start_date
        end_date
        priority
        status
        comment_count
        created_at
        updated_at
        no_sub_task
        assignee {
          _id
          full_name
          employee_id
        }
        ParentTask {
          _id
          task_name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTaskCalenderGQL extends Apollo.Query<GetTaskCalenderQuery, GetTaskCalenderQueryVariables> {
    override document = GetTaskCalenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMyTaskCalenderDocument = gql`
    query GetMyTaskCalender($input: taskCalenderInput) {
  getMyTaskCalender(input: $input) {
    limit
    page
    totalPages
    totalResults
    employees {
      _id
      full_name
      profile_pictures {
        dimension
        path
      }
      department {
        _id
        department_name
      }
      designation {
        _id
        designation_name
      }
    }
    results {
      _id
      task_name
      summary
      description
      due_date
      start_date
      end_date
      status
      comment_count
      created_at
      updated_at
      reporter {
        _id
        full_name
      }
      assignee {
        _id
        employee_id
        full_name
        profile_pictures {
          dimension
          path
        }
        department {
          _id
          department_name
        }
        designation {
          _id
          designation_name
        }
      }
      sub_task {
        _id
        task_name
        summary
        description
        due_date
        start_date
        end_date
        priority
        status
        comment_count
        created_at
        updated_at
        no_sub_task
        assignee {
          _id
          full_name
          employee_id
        }
        ParentTask {
          _id
          task_name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMyTaskCalenderGQL extends Apollo.Query<GetMyTaskCalenderQuery, GetMyTaskCalenderQueryVariables> {
    override document = GetMyTaskCalenderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatecommentOnTaskDocument = gql`
    mutation CreatecommentOnTask($input: createCommentInput!) {
  createcommentOnTask(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatecommentOnTaskGQL extends Apollo.Mutation<CreatecommentOnTaskMutation, CreatecommentOnTaskMutationVariables> {
    override document = CreatecommentOnTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommentInTaskDocument = gql`
    mutation UpdateCommentInTask($input: updateCommentInput!) {
  updateCommentInTask(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommentInTaskGQL extends Apollo.Mutation<UpdateCommentInTaskMutation, UpdateCommentInTaskMutationVariables> {
    override document = UpdateCommentInTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommentInTaskDocument = gql`
    mutation DeleteCommentInTask($taskId: ID!, $commentId: ID!) {
  deleteCommentInTask(task_id: $taskId, comment_id: $commentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommentInTaskGQL extends Apollo.Mutation<DeleteCommentInTaskMutation, DeleteCommentInTaskMutationVariables> {
    override document = DeleteCommentInTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRepliesinCommmentTaskDocument = gql`
    mutation CreateRepliesinCommmentTask($input: createRepliesCommentInput!) {
  createRepliesinCommmentTask(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRepliesinCommmentTaskGQL extends Apollo.Mutation<CreateRepliesinCommmentTaskMutation, CreateRepliesinCommmentTaskMutationVariables> {
    override document = CreateRepliesinCommmentTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRepliesinCommmentTaskDocument = gql`
    mutation DeleteRepliesinCommmentTask($taskId: ID!, $commentId: ID!, $replyId: ID!) {
  deleteRepliesinCommmentTask(
    task_id: $taskId
    comment_id: $commentId
    reply_id: $replyId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRepliesinCommmentTaskGQL extends Apollo.Mutation<DeleteRepliesinCommmentTaskMutation, DeleteRepliesinCommmentTaskMutationVariables> {
    override document = DeleteRepliesinCommmentTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRepliesinCommmentTaskDocument = gql`
    mutation UpdateRepliesinCommmentTask($input: updateRepliesCommentInput) {
  updateRepliesinCommmentTask(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRepliesinCommmentTaskGQL extends Apollo.Mutation<UpdateRepliesinCommmentTaskMutation, UpdateRepliesinCommmentTaskMutationVariables> {
    override document = UpdateRepliesinCommmentTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTaskByIdDocument = gql`
    query GetTaskById($getTaskByIdId: ID!) {
  getTaskById(id: $getTaskByIdId) {
    _id
    summary
    description
    editor_description
    is_timing_active
    is_timing_ended
    status
    total_time_spent
    priority
    due_date
    completed_date
    is_deleted
    attachments
    attachments_name
    time_logs {
      status
      timestamp
    }
    bread_cram {
      _id
      task_name
      assignee {
        full_name
        id
      }
      reporter {
        _id
        full_name
        logo
      }
    }
    Department {
      _id
      department_name
    }
    Role {
      _id
      roleName
    }
    assignee {
      id
      first_name
      last_name
      full_name
      logo
    }
    reporter {
      id
      first_name
      last_name
      full_name
      logo
    }
    check_list {
      _id
      is_completed
      title
    }
    comments {
      _id
      comment
      comment_by {
        id
        full_name
        first_name
        last_name
        logo
      }
      comment_date
      replies {
        _id
        reply
        reply_by {
          id
          full_name
          logo
        }
        reply_date
      }
    }
    sub_task {
      config {
        columns {
          _id
          field
          header
        }
      }
      results {
        _id
        task_name
        description
        summary
        status
        attachments_name
        assignee {
          id
          full_name
        }
        reporter {
          id
          first_name
          last_name
          full_name
          logo
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTaskByIdGQL extends Apollo.Query<GetTaskByIdQuery, GetTaskByIdQueryVariables> {
    override document = GetTaskByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLogsByTaskIdDocument = gql`
    query GetLogsByTaskId($id: ID!) {
  getLogsByTaskId(id: $id) {
    _id
    is_timing_active
    is_timing_ended
    formatted_time
    total_time_spent
    todo_formatted_time
    onhold_formatted_time
    time_logs {
      status
      timestamp
    }
    timeLogs {
      from
      to
      fromTime
      toTime
      duration
      status
      userName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLogsByTaskIdGQL extends Apollo.Query<GetLogsByTaskIdQuery, GetLogsByTaskIdQueryVariables> {
    override document = GetLogsByTaskIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeForMentionDocument = gql`
    query GetEmployeeForMention($getEmployeeForMentionId: ID!) {
  getEmployeeForMention(id: $getEmployeeForMentionId) {
    full_name
    id
    logo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeForMentionGQL extends Apollo.Query<GetEmployeeForMentionQuery, GetEmployeeForMentionQueryVariables> {
    override document = GetEmployeeForMentionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTaskDocument = gql`
    mutation CreateTask($input: createTaskInput!) {
  createTask(input: $input) {
    _id
    summary
    description
    attachments
    completed_date
    due_date
    is_deleted
    priority
    status
    check_list {
      _id
      is_completed
      title
    }
    comments {
      comment
      comment_by {
        id
        full_name
        first_name
        last_name
        logo
      }
      comment_date
    }
    assignee {
      id
      first_name
      last_name
      full_name
      logo
    }
    reporter {
      id
      first_name
      last_name
      full_name
      logo
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTaskGQL extends Apollo.Mutation<CreateTaskMutation, CreateTaskMutationVariables> {
    override document = CreateTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTaskDocument = gql`
    mutation UpdateTask($input: updateTaskInput!) {
  updateTask(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTaskGQL extends Apollo.Mutation<UpdateTaskMutation, UpdateTaskMutationVariables> {
    override document = UpdateTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTaskStatusDocument = gql`
    mutation UpdateTaskStatus($id: ID!, $status: taskStatusUpdateEmums!) {
  updateTaskStatus(_id: $id, status: $status) {
    BusinessLocation {
      business_keeping_unit
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTaskStatusGQL extends Apollo.Mutation<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables> {
    override document = UpdateTaskStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTaskAssignToDocument = gql`
    mutation UpdateTaskAssignTo($input: updateAssignToInput!) {
  updateTaskAssignTo(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTaskAssignToGQL extends Apollo.Mutation<UpdateTaskAssignToMutation, UpdateTaskAssignToMutationVariables> {
    override document = UpdateTaskAssignToDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTaskSectionWiseDocument = gql`
    mutation UpdateTaskSectionWise($input: updateTaskSectionWise!) {
  updateTaskSectionWise(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTaskSectionWiseGQL extends Apollo.Mutation<UpdateTaskSectionWiseMutation, UpdateTaskSectionWiseMutationVariables> {
    override document = UpdateTaskSectionWiseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTasksListenDocument = gql`
    subscription UpdateTasksListen {
  updateTasksListen {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTasksListenGQL extends Apollo.Subscription<UpdateTasksListenSubscription, UpdateTasksListenSubscriptionVariables> {
    override document = UpdateTasksListenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TaskStatusUpdatedDocument = gql`
    subscription TaskStatusUpdated {
  taskStatusUpdated {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TaskStatusUpdatedGQL extends Apollo.Subscription<TaskStatusUpdatedSubscription, TaskStatusUpdatedSubscriptionVariables> {
    override document = TaskStatusUpdatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssigneeDocument = gql`
    subscription UpdateAssignee {
  updateAssignee {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssigneeGQL extends Apollo.Subscription<UpdateAssigneeSubscription, UpdateAssigneeSubscriptionVariables> {
    override document = UpdateAssigneeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommentInTaskListenDocument = gql`
    subscription CommentInTaskListen {
  commentInTaskListen {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommentInTaskListenGQL extends Apollo.Subscription<CommentInTaskListenSubscription, CommentInTaskListenSubscriptionVariables> {
    override document = CommentInTaskListenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSubTaskListenDocument = gql`
    subscription CreateSubTaskListen {
  createSubTaskListen {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSubTaskListenGQL extends Apollo.Subscription<CreateSubTaskListenSubscription, CreateSubTaskListenSubscriptionVariables> {
    override document = CreateSubTaskListenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSavedFiltersDocument = gql`
    query GetSavedFilters($type: FilterTypeEnum!) {
  getSavedFilters(type: $type) {
    _id
    name
    filter
    type
    created_at
    updated_at
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSavedFiltersGQL extends Apollo.Query<GetSavedFiltersQuery, GetSavedFiltersQueryVariables> {
    override document = GetSavedFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentDayScheduleByEmployeeDocument = gql`
    query GetCurrentDayScheduleByEmployee($employeeId: ID!, $date: Date!) {
  getCurrentDayScheduleByEmployee(employeeId: $employeeId, date: $date) {
    total_hours
    total_minuts
    end_time
    start_date
    end_date
    start_time
    _id
    is_between_leave
    clockedHistory {
      attendance_log_detail {
        clock_in_time
        clock_out_time
        clockedInStatus
        clockedOutStatus
      }
      is_between_leave
      short_leave {
        duration
        star_time
        end_time
      }
    }
    schedule_minuts
    break_detail {
      break_duration
      minimum_break_percentage
      break_type {
        data_value_type {
          data_value_name
        }
        _id
        data_value_name
        data_type {
          _id
          data_type_name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentDayScheduleByEmployeeGQL extends Apollo.Query<GetCurrentDayScheduleByEmployeeQuery, GetCurrentDayScheduleByEmployeeQueryVariables> {
    override document = GetCurrentDayScheduleByEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFilterByIdDocument = gql`
    query GetFilterByID($getFilterByIdId: ID!) {
  getFilterByID(id: $getFilterByIdId) {
    _id
    name
    filter
    type
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFilterByIdGQL extends Apollo.Query<GetFilterByIdQuery, GetFilterByIdQueryVariables> {
    override document = GetFilterByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfigDocument = gql`
    query Config($input: inputEmployeeTimeSheet) {
  getTimeSheetAttendanceList(input: $input) {
    config {
      ...ConfigWithSummaryFields
    }
    type
    dailyClockHistoryList {
      BusinessLocation
      clock_out_time
      clock_in_time
      attendance_date
      clockedInStatus
      clockedOutStatus
      is_un_restricted
      Payroll {
        Business {
          Country {
            _id
          }
        }
        _id
        end_date
        is_deleted
        is_dispersed
        no_of_days
        no_of_employee
      }
      PreviousUserHistory {
        account_status
        action_type
        action_create_date
      }
      Schedule {
        _id
        created_date
        deleted_at
        end_date
        start_time
        end_time
        events {
          TimeOff {
            _id
          }
          end_time
          leave_type
          hours
          minutes
          star_time
          type
        }
      }
      User {
        _id
        full_name
        email
        employee_id
        salary_type
        final_settlement_completed
        department {
          _id
          department_name
        }
        designation {
          _id
          designation_name
        }
        roles {
          _id
          roleName
        }
        profile_pictures {
          dimension
          path
        }
      }
      UserAppDeviceLog {
        longitude
        latitude
        is_deleted
        device_id
        break_type {
          _id
          data_type {
            data_type_name
          }
          data_value_name
        }
        app_type
        action_date
        action
        _id
        UserAppDevice {
          _id
          app_type
          device_name
          device_model
          terminal_name
          device_manufacturer
        }
        User {
          _id
          full_name
        }
      }
      _id
      attendanceDate
      attendanceStatus
      attendance_adjusted_by {
        _id
      }
      attendance_date
      attendance_log_detail {
        is_un_restricted
        clock_in_time
        clock_out_time
        status
        logged_minutes
        logged_hours
        wages
      }
      breaks {
        User {
          _id
        }
        _id
        breakId
        breakInstatus
        break_in_time
        break_out_time
        breakType
        breakTypeId
        break_duration
        break_in_time
        break_out_time
        break_type {
          _id
          data_value_name
          data_value_type {
            data_value_name
          }
        }
        message
        minimum_break_percentage
        newWriteUp {
          writeup_message
          write_up_type
          writeup_date
          writeup_category
        }
        title
      }
      writup_id
      write_up_type
      weeklyTotalLogTime
      weekOverTime
      user_name
      total_working_minutes_logged
      total_working_hours_logged
      total_wages
      total_minutes_logged
      total_hours_logged
      status
      short_leave {
        is_paid
        leave_type
        minutes
        remarks
        short_leave_time_percentage
        star_time
        start_time
        type
        hours
        end_time
        duration
        TimeOff
      }
      short_breaks {
        short_break_duration
        short_break_name
      }
      short_break_type
      short_break_taken_minutes
      short_break_remaining_minutes
      short_break_exceeded_minutes
      short_break_duration
      short_break_detail {
        break_start_time
        break_end_time
        break_duration
        break_out_time
      }
      short_break_count
      salary_type
      remarks
      pending_writeups {
        email
        is_deleted
      }
      pay_period
      over_time_minutes_logged
      normal_time_minutes_logged
      newWriteUp {
        writeup_message
        write_up_type
        writeup_date
        writeup_category
      }
      message
      marked_at
      manually_logs {
        breaks {
          break_id {
            _id
          }
          break_in {
            time
            status
            previous_state
          }
          break_name
          break_out {
            time
            status
            previous_state
          }
        }
        clock_in {
          time
          status
          previous_state
        }
        clock_in_status {
          status
          previous_state
        }
        clock_out {
          time
          status
          previous_state
        }
        clock_out_status {
          status
          previous_state
        }
        history_times {
          previous_time
          updated_time
        }
        log_date
        remarks
        short_leave {
          duration
          start_time
          end_time
          previous_state
        }
        updated_by {
          full_name
          _id
        }
      }
      is_attendance_maually_adjusted
    }
    groupData {
      EarlyClockin
      OntimeOut
      absent
      block
      earlyClockedOut
      id
      lateOut
      lateness
      missPaunchOut
      onLeave
      onTIme
      totalScheduleHours
      totalLogedMinuts
      totalWorkingLogedMinuts
      totalWages
      publicHoliday
      shortLeave
      totalCount
      totalLogedMinuts
      totalScheduleHours
      totalWorkingLogedMinuts
      user {
        id
        full_name
        email
        profile_pictures {
          path
        }
      }
      weekend
      detail {
        columns {
          _id
          field
          header
          is_amount
          type
          is_visible
        }
        result {
          BusinessLocation
          Payroll {
            _id
          }
          PreviousUserHistory {
            account_status
          }
          Schedule {
            _id
            end_time
            end_date
            deleted_at
            created_date
            is_attendance_exist
            events {
              TimeOff {
                _id
                created_at
              }
              end_time
              hours
              leave_type
              minutes
              star_time
              type
            }
          }
          UserAppDeviceLog {
            longitude
            latitude
            is_deleted
            device_id
            break_type {
              _id
              data_type {
                data_type_name
              }
              data_value_name
            }
            app_type
            action_date
            action
            _id
            UserAppDevice {
              _id
              app_type
              device_name
              terminal_name
              device_model
              device_manufacturer
            }
            User {
              _id
              full_name
            }
          }
          User {
            _id
            full_name
            email
            profile_pictures {
              path
            }
          }
          _id
          attendanceDate
          attendanceStatus
          attendance_adjusted_by {
            _id
          }
          attendance_date
          attendance_log_detail {
            is_un_restricted
            clock_in_time
            clock_out_time
            status
            logged_minutes
            logged_hours
            wages
          }
          breaks {
            _id
            breakType
            breakInstatus
            breakId
            breakTypeId
            break_duration
            break_in_time
            break_out_time
            break_type {
              _id
              data_value_name
              data_value_type {
                data_value_name
              }
              data_type {
                _id
                data_type_name
              }
            }
            message
            title
          }
          writup_id
          write_up_type
          weeklyTotalLogTime
          weekOverTime
          user_name
          total_working_minutes_logged
          total_working_hours_logged
          total_wages
          total_minutes_logged
          total_hours_logged
          status
          short_leave {
            is_paid
            leave_type
            minutes
            remarks
            short_leave_time_percentage
            star_time
            start_time
            type
            hours
            end_time
            duration
            TimeOff
          }
          short_breaks {
            short_break_duration
            short_break_name
          }
          short_break_type
          short_break_taken_minutes
          short_break_remaining_minutes
          short_break_exceeded_minutes
          short_break_duration
          short_break_detail {
            break_start_time
            break_end_time
            break_duration
            break_out_time
          }
          short_break_count
          salary_type
          remarks
          pay_period
          over_time_minutes_logged
          normal_time_minutes_logged
          newWriteUp {
            writeup_category
            write_up_type
            writeup_date
            writeup_message
          }
          message
          marked_at
          manually_logs {
            clock_in {
              time
              status
              previous_state
            }
            breaks {
              break_in {
                time
                status
                previous_state
              }
              break_name
              break_out {
                time
                status
                previous_state
              }
            }
            clock_in_status {
              status
              previous_state
            }
            clock_out {
              time
              status
              previous_state
            }
            clock_out_status {
              status
              previous_state
            }
            history_times {
              previous_time
              updated_time
            }
            log_date
            remarks
            short_leave {
              duration
              start_time
              end_time
              previous_state
            }
            updated_by {
              _id
              full_name
            }
          }
          logs {
            total_minutes
            log_status
            log_date
          }
          logged_seconds
          is_weekend
          is_update_pending
          is_un_restricted
          is_public_holiday_off
          is_public_holiday
          is_payroll_processed
          is_paid_weekend
          is_paid_public_holiday
          is_over_time_weekend
          is_over_time_public_holiday
          is_back_pay
          is_attendance_maually_adjusted
          clockedOutStatus
          clockedInStatus
          clock_out_time
          clock_in_time
        }
      }
    }
  }
}
    ${ConfigWithSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfigGQL extends Apollo.Query<ConfigQuery, ConfigQueryVariables> {
    override document = ConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeTimeSheetListDocument = gql`
    query GetEmployeeTimeSheetList($input: employeeTimeSheetInput) {
  getEmployeeTimeSheetList(input: $input) {
    totalAbsent
    totalEarlyOut
    totalLateness
    totalLeave
    totalPresent
    dateList
    employeesTimeSheet {
      _id
      Absent
      EarlyOut
      Lateness
      Leave
      Present
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeTimeSheetListGQL extends Apollo.Query<GetEmployeeTimeSheetListQuery, GetEmployeeTimeSheetListQueryVariables> {
    override document = GetEmployeeTimeSheetListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTimeSheetAttendanceListByEmployeeDocument = gql`
    query GetTimeSheetAttendanceListByEmployee($input: inputTimeSheetEmployee) {
  getTimeSheetAttendanceListByEmployee(input: $input) {
    groupData {
      countStatus {
        EarlyClockin
        lateness
        earlyClockedOut
        lateOut
        onTIme
        OntimeOut
        totalScheduleHours
        totalLogedMinuts
      }
      ClockedHistory {
        total_hours_logged
        total_wages
        _id
        User {
          profile_pictures {
            dimension
            path
          }
          id
          is_breaked_in
          first_name
          last_name
          full_name
          logo
          email
          employee_id
          salary_type
          department {
            _id
            department_name
          }
        }
        clock_in_time
        clock_out_time
        attendance_date
        status
        attendanceStatus
        breaks {
          _id
          break_in_time
          break_out_time
          breakInstatus
          breakType
          title
          breakTypeId
          break_duration
          breakId
          break_type {
            data_value_name
            data_type {
              _id
              data_type_name
            }
          }
        }
        logs {
          log_status
          break_id {
            data_value_name
          }
          total_minutes
          log_date
        }
        Schedule {
          break_detail {
            break_type {
              data_value_name
              _id
              data_type {
                _id
                data_type_name
              }
            }
            break_duration
          }
        }
        write_up_type
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTimeSheetAttendanceListByEmployeeGQL extends Apollo.Query<GetTimeSheetAttendanceListByEmployeeQuery, GetTimeSheetAttendanceListByEmployeeQueryVariables> {
    override document = GetTimeSheetAttendanceListByEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMisPaunchOutEmployeeListDocument = gql`
    query GetMisPaunchOutEmployeeList($input: MissPaunchOut) {
  getMisPaunchOutEmployeeList(input: $input) {
    page
    limit
    totalResults
    totalPages
    results {
      _id
      logs {
        log_status
        log_date
      }
      User {
        id
        first_name
        last_name
        full_name
        logo
        profile_pictures {
          path
        }
      }
      clock_in_time
      clock_out_time
      attendance_date
      status
      breaks {
        breakInstatus
        breakType
        break_type {
          data_value_name
        }
        break_duration
      }
      attendanceStatus
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMisPaunchOutEmployeeListGQL extends Apollo.Query<GetMisPaunchOutEmployeeListQuery, GetMisPaunchOutEmployeeListQueryVariables> {
    override document = GetMisPaunchOutEmployeeListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentDayRosterByEmployeeDocument = gql`
    query GetCurrentDayRosterByEmployee($employeeId: ID!, $date: Date!) {
  getCurrentDayRosterByEmployee(employeeId: $employeeId, date: $date) {
    total_hours
    total_minuts
    end_time
    start_date
    end_date
    start_time
    _id
    schedule_minuts
    break_detail {
      break_duration
      break_type {
        data_value_type {
          data_value_name
        }
        _id
        data_value_name
        data_type {
          _id
          data_type_name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentDayRosterByEmployeeGQL extends Apollo.Query<GetCurrentDayRosterByEmployeeQuery, GetCurrentDayRosterByEmployeeQueryVariables> {
    override document = GetCurrentDayRosterByEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTimeSheetGrandTotalDocument = gql`
    query GetTimeSheetGrandTotal($input: inputGrandTotal!) {
  getTimeSheetGrandTotal(input: $input) {
    absent
    earlyIn
    earlyOut
    lateOut
    lateness
    missPunchOut
    onLeave
    onTimeIn
    onTimeOut
    present
    scheduleTime
    shortLeave
    wages
    workingTime
    block
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTimeSheetGrandTotalGQL extends Apollo.Query<GetTimeSheetGrandTotalQuery, GetTimeSheetGrandTotalQueryVariables> {
    override document = GetTimeSheetGrandTotalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTimeSheetAttendanceGrandTotalDocument = gql`
    query GetTimeSheetAttendanceGrandTotal($input: inputTimeSheet!) {
  getTimeSheetAttendanceGrandTotal(input: $input) {
    absent
    workingTime
    weekend
    wages
    unrestrictedWorkingTime
    unrestrected
    unpaidLeave
    totalCount
    shortLeave
    scheduleTime
    restrected
    publicHoliday
    present
    paidLeave
    onTimeOut
    onTimeIn
    onLeave
    missPunchOut
    lateness
    lateOut
    earlyOut
    earlyIn
    block
    departmentWiseOT {
      perDepartment {
        department {
          _id
          department_name
        }
        totalOvertimeMinutes
        totalOvertimeWages
      }
      totalSummary {
        totalOvertimeMinutes
        totalOvertimeWages
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTimeSheetAttendanceGrandTotalGQL extends Apollo.Query<GetTimeSheetAttendanceGrandTotalQuery, GetTimeSheetAttendanceGrandTotalQueryVariables> {
    override document = GetTimeSheetAttendanceGrandTotalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGroupedWagesDataForGraphDocument = gql`
    query GetGroupedWagesDataForGraph($input: inputTimeSheet!) {
  getGroupedWagesDataForGraph(input: $input) {
    grand_total
    wages_by_date {
      date
      total_wages
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGroupedWagesDataForGraphGQL extends Apollo.Query<GetGroupedWagesDataForGraphQuery, GetGroupedWagesDataForGraphQueryVariables> {
    override document = GetGroupedWagesDataForGraphDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserDashboardViewDocument = gql`
    query GetUserDashboardView {
  getUserDashboardView {
    id
    is_bold_emp_name
    card_size
    is_bold_status_time
    created_at
    card_width
    Business {
      _id
    }
    created_by
    deleted_at
    deleted_by
    is_default_screen
    is_deleted
    name_format
    options
    profile_picture_size
    status_display
    is_system_default_screen
    title
    updated_at
    updated_by
    view_type
    views {
      animation
      width
      animation_speed
      arrays
      columns
      configs {
        array_list
        classes
        options
      }
      options
      section_title
      sort_order
      text
      upcoming_clock_reminder_time
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserDashboardViewGQL extends Apollo.Query<GetUserDashboardViewQuery, GetUserDashboardViewQueryVariables> {
    override document = GetUserDashboardViewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRosterStoresDocument = gql`
    query GetRosterStores($businessId: ID!) {
  getRosterStores(businessId: $businessId) {
    _id
    time_zone
    business_location {
      _id
      store_name
      store_nick_name
      address_1
      address_2
    }
    business {
      _id
      business_keeping_unit
      business_system_name
      address
      business_legal_name
    }
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRosterStoresGQL extends Apollo.Query<GetRosterStoresQuery, GetRosterStoresQueryVariables> {
    override document = GetRosterStoresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAttendanceByIdDocument = gql`
    query GetAttendanceById($_id: ID!) {
  getAttendanceById(_id: $_id) {
    attendanceStatus
    attendance_date
    clockedOutStatus
    clockedInStatus
    clock_in_time
    clock_out_time
    remarks
    message
    writup_id
    status
    short_breaks {
      short_break_duration
      short_break_name
    }
    short_break_detail {
      break_duration
      break_end_time
      break_out_time
      break_start_time
    }
    breaks {
      _id
      breakId
      breakType
      break_duration
      break_in_time
      break_out_time
      minimum_break_percentage
      breakInstatus
      break_type {
        _id
        data_value_name
        data_value_type {
          data_value_name
        }
      }
    }
    User {
      id
      full_name
      first_name
      last_name
      joining_date
      is_deleted
      account_status
    }
    is_un_restricted
    is_between_leave
    short_leave {
      duration
      star_time
      end_time
    }
    attendance_log_detail {
      clock_in_time
      clock_out_time
      clockedInStatus
      clockedOutStatus
    }
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAttendanceByIdGQL extends Apollo.Query<GetAttendanceByIdQuery, GetAttendanceByIdQueryVariables> {
    override document = GetAttendanceByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeePaidUnpaidLeavesDocument = gql`
    query GetEmployeePaidUnpaidLeaves($employeeId: ID) {
  getEmployeePaidUnpaidLeaves(employeeId: $employeeId) {
    paidLeave
    unPaidLeave
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeePaidUnpaidLeavesGQL extends Apollo.Query<GetEmployeePaidUnpaidLeavesQuery, GetEmployeePaidUnpaidLeavesQueryVariables> {
    override document = GetEmployeePaidUnpaidLeavesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeesForBackPayDocument = gql`
    query GetEmployeesForBackPay($business_id: ID!) {
  getAllActiveEmployees(business_id: $business_id) {
    id
    full_name
    joining_date
    salary_type
    basic_salary
    weekly_hourly_salary
    public_day_hourly_salary
    weekend_day_salary
    employee_type
    pay_schedule {
      _id
      schedule_name
    }
    employee_group {
      _id
      group_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeesForBackPayGQL extends Apollo.Query<GetEmployeesForBackPayQuery, GetEmployeesForBackPayQueryVariables> {
    override document = GetEmployeesForBackPayDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFilterDocument = gql`
    mutation CreateFilter($input: saveFilterInput!) {
  createFilter(input: $input) {
    _id
    name
    filter
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFilterGQL extends Apollo.Mutation<CreateFilterMutation, CreateFilterMutationVariables> {
    override document = CreateFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFilterDocument = gql`
    mutation UpdateFilter($updateFilterId: ID!, $input: saveFilterInput!) {
  updateFilter(id: $updateFilterId, input: $input) {
    _id
    name
    filter
    type
    is_deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFilterGQL extends Apollo.Mutation<UpdateFilterMutation, UpdateFilterMutationVariables> {
    override document = UpdateFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveFilterDocument = gql`
    mutation ArchiveFilter($archiveFilterId: ID!) {
  archiveFilter(id: $archiveFilterId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveFilterGQL extends Apollo.Mutation<ArchiveFilterMutation, ArchiveFilterMutationVariables> {
    override document = ArchiveFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddManualShortBreaksDocument = gql`
    mutation AddManualShortBreaks($input: addManualShortBreaksInput!) {
  addManualShortBreaks(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddManualShortBreaksGQL extends Apollo.Mutation<AddManualShortBreaksMutation, AddManualShortBreaksMutationVariables> {
    override document = AddManualShortBreaksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEmployeeDashboardViewDocument = gql`
    mutation CreateEmployeeDashboardView($input: CreateEmployeeDashboardViewInput!) {
  createEmployeeDashboardView(input: $input) {
    is_bold_emp_name
    card_size
    is_bold_status_time
    created_at
    card_width
    Business {
      _id
    }
    created_by
    deleted_at
    deleted_by
    id
    is_default_screen
    is_deleted
    name_format
    options
    profile_picture_size
    status_display
    is_system_default_screen
    title
    updated_at
    updated_by
    view_type
    views {
      animation
      width
      animation_speed
      arrays
      columns
      configs {
        array_list
        classes
        options
      }
      options
      section_title
      sort_order
      text
      upcoming_clock_reminder_time
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEmployeeDashboardViewGQL extends Apollo.Mutation<CreateEmployeeDashboardViewMutation, CreateEmployeeDashboardViewMutationVariables> {
    override document = CreateEmployeeDashboardViewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEmployeeDashboardViewDocument = gql`
    mutation UpdateEmployeeDashboardView($input: CreateEmployeeDashboardViewInput!, $updateEmployeeDashboardViewId: ID!) {
  updateEmployeeDashboardView(input: $input, id: $updateEmployeeDashboardViewId) {
    is_bold_emp_name
    card_size
    is_bold_status_time
    created_at
    card_width
    Business {
      _id
    }
    created_by
    deleted_at
    deleted_by
    id
    is_default_screen
    is_deleted
    name_format
    options
    profile_picture_size
    status_display
    is_system_default_screen
    title
    updated_at
    updated_by
    view_type
    views {
      animation
      width
      animation_speed
      arrays
      columns
      configs {
        array_list
        classes
        options
      }
      options
      section_title
      sort_order
      text
      upcoming_clock_reminder_time
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEmployeeDashboardViewGQL extends Apollo.Mutation<UpdateEmployeeDashboardViewMutation, UpdateEmployeeDashboardViewMutationVariables> {
    override document = UpdateEmployeeDashboardViewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveEmployeeDashboardViewDocument = gql`
    mutation ArchiveEmployeeDashboardView($ids: [ID!], $archive: Boolean!) {
  archiveEmployeeDashboardView(ids: $ids, archive: $archive)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveEmployeeDashboardViewGQL extends Apollo.Mutation<ArchiveEmployeeDashboardViewMutation, ArchiveEmployeeDashboardViewMutationVariables> {
    override document = ArchiveEmployeeDashboardViewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MakeScreenAsDefaultDocument = gql`
    mutation MakeScreenAsDefault($makeScreenAsDefaultId: ID!) {
  makeScreenAsDefault(id: $makeScreenAsDefaultId) {
    id
    is_deleted
    views {
      animation
      animation_speed
      columns
      section_title
      text
    }
    title
    view_type
    is_default_screen
    created_at
    updated_at
    deleted_at
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MakeScreenAsDefaultGQL extends Apollo.Mutation<MakeScreenAsDefaultMutation, MakeScreenAsDefaultMutationVariables> {
    override document = MakeScreenAsDefaultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateShortLeaveDocument = gql`
    mutation CreateUpdateShortLeave($input: shortLeaveInput!) {
  createUpdateShortLeave(input: $input) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateShortLeaveGQL extends Apollo.Mutation<CreateUpdateShortLeaveMutation, CreateUpdateShortLeaveMutationVariables> {
    override document = CreateUpdateShortLeaveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUpdateAttendanceDocument = gql`
    mutation CreateUpdateAttendance($input: InputAttendance!) {
  createUpdateAttendance(input: $input) {
    _id
    clock_in_time
    clock_out_time
    status
    attendance_date
    attendanceStatus
    total_minutes_logged
    total_hours_logged
    remarks
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUpdateAttendanceGQL extends Apollo.Mutation<CreateUpdateAttendanceMutation, CreateUpdateAttendanceMutationVariables> {
    override document = CreateUpdateAttendanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BackPayToEmployeeDocument = gql`
    mutation BackPayToEmployee($input: backPayInput!) {
  backPayToEmployee(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BackPayToEmployeeGQL extends Apollo.Mutation<BackPayToEmployeeMutation, BackPayToEmployeeMutationVariables> {
    override document = BackPayToEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveAttendanceDocument = gql`
    mutation ArchiveAttendance($input: archiveInput!) {
  archiveAttendance(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveAttendanceGQL extends Apollo.Mutation<ArchiveAttendanceMutation, ArchiveAttendanceMutationVariables> {
    override document = ArchiveAttendanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClockedHistoryDocument = gql`
    subscription ClockedHistory($businessId: ID!) {
  ClockedHistory(businessId: $businessId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClockedHistoryGQL extends Apollo.Subscription<ClockedHistorySubscription, ClockedHistorySubscriptionVariables> {
    override document = ClockedHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmployeeDashBoardUpdateDocument = gql`
    subscription EmployeeDashBoardUpdate($businessId: ID!) {
  employeeDashBoardUpdate(businessId: $businessId) {
    is_updated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EmployeeDashBoardUpdateGQL extends Apollo.Subscription<EmployeeDashBoardUpdateSubscription, EmployeeDashBoardUpdateSubscriptionVariables> {
    override document = EmployeeDashBoardUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAttendanceDocument = gql`
    subscription UpdateAttendance($userId: ID!) {
  updateAttendance(userId: $userId) {
    clockedHistory {
      clockedInStatus
      clockedOutStatus
      is_un_restricted
      is_payroll_processed
      attendance_log_detail {
        clock_in_time
        clock_out_time
        is_un_restricted
        logged_hours
        logged_minutes
        status
        wages
      }
      short_break_count
      short_break_duration
      short_break_exceeded_minutes
      short_break_remaining_minutes
      short_break_type
      short_break_taken_minutes
      short_break_detail {
        break_duration
        break_end_time
        break_out_time
        break_start_time
      }
      total_hours_logged
      total_working_hours_logged
      is_attendance_maually_adjusted
      manually_logs {
        breaks {
          break_in {
            status
            previous_state
            time
          }
          break_name
          break_out {
            status
            previous_state
            time
          }
        }
        clock_in {
          time
          previous_state
          status
        }
        clock_out {
          status
          previous_state
          time
        }
        log_date
        remarks
        updated_by {
          full_name
        }
      }
      attendance_adjusted_by {
        first_name
        last_name
        full_name
      }
      total_wages
      attendance_date
      breaks {
        _id
        break_in_time
        break_out_time
        breakInstatus
        breakType
        break_type {
          data_value_name
        }
        title
        breakTypeId
        break_duration
        breakId
      }
      _id
      User {
        profile_pictures {
          dimension
          path
        }
        id
        _id
        is_breaked_in
        first_name
        last_name
        is_deleted
        final_settlement_completed
        full_name
        phone
        logo
        email
        employee_id
        salary_type
        department {
          _id
          department_name
        }
      }
      clock_in_time
      clock_out_time
      short_leave {
        duration
        TimeOff
        end_time
        hours
        leave_type
        minutes
        remarks
        short_leave_time_percentage
        star_time
        start_time
        type
      }
      attendance_date
      status
      attendanceStatus
      message
      BusinessLocation
      short_breaks {
        short_break_duration
        short_break_name
      }
      Schedule {
        _id
        start_time
        end_time
        total_minuts
        total_hours
        TimeOff {
          type_of_absence {
            name
            type
          }
        }
        break_detail {
          break_type {
            data_value_name
            _id
          }
          break_duration
        }
      }
      logs {
        log_status
        break_id {
          data_value_name
        }
        total_minutes
        log_date
      }
    }
    user {
      _id
      full_name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAttendanceGQL extends Apollo.Subscription<UpdateAttendanceSubscription, UpdateAttendanceSubscriptionVariables> {
    override document = UpdateAttendanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }